webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// models
__export(__webpack_require__(12));
// services
__export(__webpack_require__(223));
__export(__webpack_require__(224));
__export(__webpack_require__(225));
__export(__webpack_require__(227));
__export(__webpack_require__(228));
__export(__webpack_require__(229));
__export(__webpack_require__(560));
__export(__webpack_require__(230));
__export(__webpack_require__(231));
// ordered by dependency tree (can cause 'cannot resolve all parameters for' error otherwise)


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

module.exports = ".d-table {\n  display: table; }\n\n.d-table-cell {\n  display: table-cell; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: none; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 456px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-full {\n    vertical-align: top; }\n    .page-content .page-content-full p, .page-content .page-content-full li, .page-content .page-content-full div, .page-content .page-content-full label {\n      font-size: 18px;\n      line-height: 32px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n.team-section {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n  .team-section .pure-g .founder {\n    cursor: pointer;\n    width: 96%;\n    overflow: hidden; }\n  .team-section .pure-g .pure-u-1-2 .team-text, .team-section .pure-g .pure-u-1-4 .team-text {\n    padding: 0 10px 10px 10px; }\n  .team-section .pure-g .pure-u-1-2 h1, .team-section .pure-g .pure-u-1-2 h2, .team-section .pure-g .pure-u-1-2 h3, .team-section .pure-g .pure-u-1-2 h4, .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-2 h6, .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-2 label, .team-section .pure-g .pure-u-1-2 li, .team-section .pure-g .pure-u-1-4 h1, .team-section .pure-g .pure-u-1-4 h2, .team-section .pure-g .pure-u-1-4 h3, .team-section .pure-g .pure-u-1-4 h4, .team-section .pure-g .pure-u-1-4 h5, .team-section .pure-g .pure-u-1-4 h6, .team-section .pure-g .pure-u-1-4 p, .team-section .pure-g .pure-u-1-4 label, .team-section .pure-g .pure-u-1-4 li {\n    color: #ffffff; }\n  .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-4 h5 {\n    font-weight: bold;\n    line-height: 32px;\n    color: #ffffff;\n    font-size: 20px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0; }\n  .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-4 p {\n    line-height: 20px;\n    margin-bottom: 5px; }\n  .team-section .pure-g .pure-u-1-2 img, .team-section .pure-g .pure-u-1-4 img {\n    max-width: 100%;\n    width: 100%;\n    transition: all 0.3s;\n    transform: scale(1); }\n  .team-section .pure-g .pure-u-1-2 .founder img:hover, .team-section .pure-g .pure-u-1-4 .founder img:hover {\n    transform: scale(1.1);\n    padding-bottom: 15px; }\n  .team-section .pure-g .team-text.bio h5:hover {\n    color: #fc7d17;\n    cursor: pointer; }\n  .team-section .team-member {\n    margin: 10px;\n    background-color: #393939; }\n\n#who-we-are {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n\n.page-content .quote {\n  padding-top: 20px;\n  font-size: 16px;\n  color: #7a7a7a;\n  width: 80%;\n  margin: 0 auto;\n  font-style: italic; }\n\n.page-content .quote-by {\n  font-size: 16px;\n  text-align: right;\n  color: #7a7a7a; }\n\n/*** MODAL CSS ***/\n.modal {\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: black;\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */ }\n\n/* Modal Content/Box */\n.modal-content {\n  background-color: #fefefe;\n  margin: 15% auto;\n  /* 15% from the top and centered */\n  padding: 50px;\n  border: 1px solid #888;\n  width: 80%;\n  /* Could be more or less, depending on screen size */ }\n\n/* The Close Button */\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold; }\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer; }\n\n.get-started {\n  padding: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  border-top: 1px solid #e9e9e9; }\n  .get-started h2 {\n    color: #247cbd;\n    margin: 0; }\n  .get-started h6 {\n    color: #666;\n    margin: 0; }\n  .get-started .buttons-container {\n    margin-top: 17px; }\n    .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 479px) {\n  .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n\n@media only screen and (max-width: 1023px) {\n  .pure-u-1-4, .pure-u-6-24 {\n    width: 50%; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; }\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(50% - 20px); }\n  .team-section .col-holder.full-width-team {\n    display: none; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .page-banner .page-banner-inner {\n    padding: 15px; }\n  .pure-u-1-2, .pure-u-1-4 {\n    width: 100%; } }\n\n@media only screen and (max-width: 599px) {\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(100% - 20px); } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n\n/* TABLES */\ntable {\n  width: 100%;\n  border: 1px solid #227CBD;\n  margin: 10px 0; }\n  table th {\n    text-align: left;\n    background-color: #227CBD;\n    color: white;\n    padding: 5px; }\n  table th:first-child {\n    border-right: 1px solid white; }\n  table td {\n    border: 1px solid #227CBD;\n    padding: 5px; }\n"

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(783));


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(548));
__export(__webpack_require__(549));
__export(__webpack_require__(550));
__export(__webpack_require__(551));
__export(__webpack_require__(552));
__export(__webpack_require__(553));
__export(__webpack_require__(554));
__export(__webpack_require__(555));
__export(__webpack_require__(556));
__export(__webpack_require__(557));
__export(__webpack_require__(558));
__export(__webpack_require__(60));
__export(__webpack_require__(220));
__export(__webpack_require__(221));
__export(__webpack_require__(559));
__export(__webpack_require__(222));


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports = ".d-table {\n  display: table; }\n\n.d-table-cell {\n  display: table-cell; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 456px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-full {\n    vertical-align: top; }\n    .page-content .page-content-full p, .page-content .page-content-full li, .page-content .page-content-full div, .page-content .page-content-full label {\n      font-size: 18px;\n      line-height: 32px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n.team-section {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n  .team-section .pure-g .founder {\n    cursor: pointer;\n    width: 96%;\n    overflow: hidden; }\n  .team-section .pure-g .pure-u-1-2 .team-text, .team-section .pure-g .pure-u-1-4 .team-text {\n    padding: 0 10px 10px 10px; }\n  .team-section .pure-g .pure-u-1-2 h1, .team-section .pure-g .pure-u-1-2 h2, .team-section .pure-g .pure-u-1-2 h3, .team-section .pure-g .pure-u-1-2 h4, .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-2 h6, .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-2 label, .team-section .pure-g .pure-u-1-2 li, .team-section .pure-g .pure-u-1-4 h1, .team-section .pure-g .pure-u-1-4 h2, .team-section .pure-g .pure-u-1-4 h3, .team-section .pure-g .pure-u-1-4 h4, .team-section .pure-g .pure-u-1-4 h5, .team-section .pure-g .pure-u-1-4 h6, .team-section .pure-g .pure-u-1-4 p, .team-section .pure-g .pure-u-1-4 label, .team-section .pure-g .pure-u-1-4 li {\n    color: #ffffff; }\n  .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-4 h5 {\n    font-weight: bold;\n    line-height: 32px;\n    color: #ffffff;\n    font-size: 20px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0; }\n  .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-4 p {\n    line-height: 20px;\n    margin-bottom: 5px; }\n  .team-section .pure-g .pure-u-1-2 img, .team-section .pure-g .pure-u-1-4 img {\n    max-width: 100%;\n    width: 100%;\n    transition: all 0.3s;\n    transform: scale(1); }\n  .team-section .pure-g .pure-u-1-2 .founder img:hover, .team-section .pure-g .pure-u-1-4 .founder img:hover {\n    transform: scale(1.1);\n    padding-bottom: 15px; }\n  .team-section .pure-g .team-text.bio h5:hover {\n    color: #fc7d17;\n    cursor: pointer; }\n  .team-section .team-member {\n    margin: 10px;\n    background-color: #393939; }\n\n#who-we-are {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n\n.page-content .quote {\n  padding-top: 20px;\n  font-size: 16px;\n  color: #7a7a7a;\n  width: 80%;\n  margin: 0 auto;\n  font-style: italic; }\n\n.page-content .quote-by {\n  font-size: 16px;\n  text-align: right;\n  color: #7a7a7a; }\n\n/*** MODAL CSS ***/\n.modal {\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: black;\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */ }\n\n/* Modal Content/Box */\n.modal-content {\n  background-color: #fefefe;\n  margin: 15% auto;\n  /* 15% from the top and centered */\n  padding: 50px;\n  border: 1px solid #888;\n  width: 80%;\n  /* Could be more or less, depending on screen size */ }\n\n/* The Close Button */\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold; }\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer; }\n\n.get-started {\n  padding: 50px;\n  margin-top: 10px;\n  padding-bottom: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  border-top: 1px solid #e9e9e9; }\n  .get-started h2 {\n    color: #247cbd;\n    margin: 0; }\n  .get-started h6 {\n    color: #666;\n    margin: 0; }\n  .get-started .buttons-container {\n    margin-top: 17px; }\n    .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 479px) {\n  .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n\n@media only screen and (max-width: 1023px) {\n  .pure-u-1-4, .pure-u-6-24 {\n    width: 50%; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; }\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(50% - 20px); }\n  .team-section .col-holder.full-width-team {\n    display: none; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .page-banner .page-banner-inner {\n    padding: 15px; }\n  .pure-u-1-2, .pure-u-1-4 {\n    width: 100%; } }\n\n@media only screen and (max-width: 599px) {\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(100% - 20px); } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n\n/* TABLES */\ntable {\n  width: 100%;\n  border: 1px solid #227CBD;\n  margin: 10px 0; }\n  table th {\n    text-align: left;\n    background-color: #227CBD;\n    color: white;\n    padding: 5px; }\n  table th:first-child {\n    border-right: 1px solid white; }\n  table td {\n    border: 1px solid #227CBD;\n    padding: 5px; }\n"

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleMapsAPIWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__maps_api_loader_maps_api_loader__ = __webpack_require__(58);



/**
 * Wrapper class that handles the communication with the Google Maps Javascript
 * API v3
 */
var GoogleMapsAPIWrapper = /** @class */ (function () {
    function GoogleMapsAPIWrapper(_loader, _zone) {
        var _this = this;
        this._loader = _loader;
        this._zone = _zone;
        this._map =
            new Promise(function (resolve) { _this._mapResolver = resolve; });
    }
    GoogleMapsAPIWrapper.prototype.createMap = function (el, mapOptions) {
        var _this = this;
        return this._zone.runOutsideAngular(function () {
            return _this._loader.load().then(function () {
                var map = new google.maps.Map(el, mapOptions);
                _this._mapResolver(map);
                return;
            });
        });
    };
    GoogleMapsAPIWrapper.prototype.setMapOptions = function (options) {
        this._map.then(function (m) { m.setOptions(options); });
    };
    /**
     * Creates a google map marker with the map context
     */
    /**
       * Creates a google map marker with the map context
       */
    GoogleMapsAPIWrapper.prototype.createMarker = /**
       * Creates a google map marker with the map context
       */
    function (options, addToMap) {
        if (options === void 0) { options = {}; }
        if (addToMap === void 0) { addToMap = true; }
        return this._map.then(function (map) {
            if (addToMap) {
                options.map = map;
            }
            return new google.maps.Marker(options);
        });
    };
    GoogleMapsAPIWrapper.prototype.createInfoWindow = function (options) {
        return this._map.then(function () { return new google.maps.InfoWindow(options); });
    };
    /**
     * Creates a google.map.Circle for the current map.
     */
    /**
       * Creates a google.map.Circle for the current map.
       */
    GoogleMapsAPIWrapper.prototype.createCircle = /**
       * Creates a google.map.Circle for the current map.
       */
    function (options) {
        return this._map.then(function (map) {
            options.map = map;
            return new google.maps.Circle(options);
        });
    };
    GoogleMapsAPIWrapper.prototype.createPolyline = function (options) {
        return this.getNativeMap().then(function (map) {
            var line = new google.maps.Polyline(options);
            line.setMap(map);
            return line;
        });
    };
    GoogleMapsAPIWrapper.prototype.createPolygon = function (options) {
        return this.getNativeMap().then(function (map) {
            var polygon = new google.maps.Polygon(options);
            polygon.setMap(map);
            return polygon;
        });
    };
    /**
     * Creates a new google.map.Data layer for the current map
     */
    /**
       * Creates a new google.map.Data layer for the current map
       */
    GoogleMapsAPIWrapper.prototype.createDataLayer = /**
       * Creates a new google.map.Data layer for the current map
       */
    function (options) {
        return this._map.then(function (m) {
            var data = new google.maps.Data(options);
            data.setMap(m);
            return data;
        });
    };
    /**
     * Determines if given coordinates are insite a Polygon path.
     */
    /**
       * Determines if given coordinates are insite a Polygon path.
       */
    GoogleMapsAPIWrapper.prototype.containsLocation = /**
       * Determines if given coordinates are insite a Polygon path.
       */
    function (latLng, polygon) {
        return google.maps.geometry.poly.containsLocation(latLng, polygon);
    };
    GoogleMapsAPIWrapper.prototype.subscribeToMapEvent = function (eventName) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"](function (observer) {
            _this._map.then(function (m) {
                m.addListener(eventName, function (arg) { _this._zone.run(function () { return observer.next(arg); }); });
            });
        });
    };
    GoogleMapsAPIWrapper.prototype.clearInstanceListeners = function () {
        this._map.then(function (map) {
            google.maps.event.clearInstanceListeners(map);
        });
    };
    GoogleMapsAPIWrapper.prototype.setCenter = function (latLng) {
        return this._map.then(function (map) { return map.setCenter(latLng); });
    };
    GoogleMapsAPIWrapper.prototype.getZoom = function () { return this._map.then(function (map) { return map.getZoom(); }); };
    GoogleMapsAPIWrapper.prototype.getBounds = function () {
        return this._map.then(function (map) { return map.getBounds(); });
    };
    GoogleMapsAPIWrapper.prototype.getMapTypeId = function () {
        return this._map.then(function (map) { return map.getMapTypeId(); });
    };
    GoogleMapsAPIWrapper.prototype.setZoom = function (zoom) {
        return this._map.then(function (map) { return map.setZoom(zoom); });
    };
    GoogleMapsAPIWrapper.prototype.getCenter = function () {
        return this._map.then(function (map) { return map.getCenter(); });
    };
    GoogleMapsAPIWrapper.prototype.panTo = function (latLng) {
        return this._map.then(function (map) { return map.panTo(latLng); });
    };
    GoogleMapsAPIWrapper.prototype.panBy = function (x, y) {
        return this._map.then(function (map) { return map.panBy(x, y); });
    };
    GoogleMapsAPIWrapper.prototype.fitBounds = function (latLng) {
        return this._map.then(function (map) { return map.fitBounds(latLng); });
    };
    GoogleMapsAPIWrapper.prototype.panToBounds = function (latLng) {
        return this._map.then(function (map) { return map.panToBounds(latLng); });
    };
    /**
     * Returns the native Google Maps Map instance. Be careful when using this instance directly.
     */
    /**
       * Returns the native Google Maps Map instance. Be careful when using this instance directly.
       */
    GoogleMapsAPIWrapper.prototype.getNativeMap = /**
       * Returns the native Google Maps Map instance. Be careful when using this instance directly.
       */
    function () { return this._map; };
    /**
     * Triggers the given event name on the map instance.
     */
    /**
       * Triggers the given event name on the map instance.
       */
    GoogleMapsAPIWrapper.prototype.triggerMapEvent = /**
       * Triggers the given event name on the map instance.
       */
    function (eventName) {
        return this._map.then(function (m) { return google.maps.event.trigger(m, eventName); });
    };
    GoogleMapsAPIWrapper.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    GoogleMapsAPIWrapper.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__maps_api_loader_maps_api_loader__["a" /* MapsAPILoader */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    return GoogleMapsAPIWrapper;
}());

//# sourceMappingURL=google-maps-api-wrapper.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Statics
__webpack_require__(123);
// Operators
__webpack_require__(132);
__webpack_require__(155);
__webpack_require__(199);


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports) {

module.exports = ".page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"../../img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 457px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 60px 60px;\n  width: 100%;\n  padding-bottom: 200px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-full {\n    vertical-align: top; }\n    .page-content .page-content-full p, .page-content .page-content-full li, .page-content .page-content-full div, .page-content .page-content-full label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .featured-image {\n    max-width: 100%; }\n  .page-content img {\n    max-width: 100%; }\n  .page-content .author-sub-head {\n    color: #979797;\n    font-size: 18px;\n    margin-top: 0;\n    margin-bottom: 20px; }\n  .page-content .news-entry h6 {\n    margin-top: 0;\n    margin-bottom: 10px; }\n  .page-content .news-entry-sub-head {\n    color: #979797; }\n  .page-content .blog-entry-sub-head {\n    color: #979797; }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(745));


/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractControlDirective", function() { return AbstractControlDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractFormGroupDirective", function() { return AbstractFormGroupDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxControlValueAccessor", function() { return CheckboxControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlContainer", function() { return ControlContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_VALUE_ACCESSOR", function() { return NG_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPOSITION_BUFFER_MODE", function() { return COMPOSITION_BUFFER_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultValueAccessor", function() { return DefaultValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControl", function() { return NgControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControlStatus", function() { return NgControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControlStatusGroup", function() { return NgControlStatusGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgForm", function() { return NgForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModel", function() { return NgModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModelGroup", function() { return NgModelGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RadioControlValueAccessor", function() { return RadioControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControlDirective", function() { return FormControlDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControlName", function() { return FormControlName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroupDirective", function() { return FormGroupDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormArrayName", function() { return FormArrayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroupName", function() { return FormGroupName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSelectOption", function() { return NgSelectOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectControlValueAccessor", function() { return SelectControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectMultipleControlValueAccessor", function() { return SelectMultipleControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxRequiredValidator", function() { return CheckboxRequiredValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmailValidator", function() { return EmailValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaxLengthValidator", function() { return MaxLengthValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinLengthValidator", function() { return MinLengthValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PatternValidator", function() { return PatternValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequiredValidator", function() { return RequiredValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormBuilder", function() { return FormBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractControl", function() { return AbstractControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormArray", function() { return FormArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControl", function() { return FormControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return FormGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_ASYNC_VALIDATORS", function() { return NG_ASYNC_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_VALIDATORS", function() { return NG_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Validators", function() { return Validators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormsModule", function() { return FormsModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReactiveFormsModule", function() { return ReactiveFormsModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵba", function() { return InternalFormsSharedModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵz", function() { return REACTIVE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵx", function() { return SHARED_FORM_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵy", function() { return TEMPLATE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return CHECKBOX_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return DEFAULT_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function() { return AbstractControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function() { return ngControlStatusHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function() { return formDirectiveProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf", function() { return formControlBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵg", function() { return modelGroupProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbf", function() { return NgNoValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbb", function() { return NUMBER_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbc", function() { return NumberValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵh", function() { return RADIO_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi", function() { return RadioControlRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbd", function() { return RANGE_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbe", function() { return RangeValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵj", function() { return formControlBinding$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵk", function() { return controlNameBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵl", function() { return formDirectiveProvider$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵn", function() { return formArrayNameProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵm", function() { return formGroupNameProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵo", function() { return SELECT_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵq", function() { return NgSelectMultipleOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵp", function() { return SELECT_MULTIPLE_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵs", function() { return CHECKBOX_REQUIRED_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵt", function() { return EMAIL_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵv", function() { return MAX_LENGTH_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵu", function() { return MIN_LENGTH_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵw", function() { return PATTERN_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵr", function() { return REQUIRED_VALIDATOR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_forkJoin__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_forkJoin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_fromPromise__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__ = __webpack_require__(28);
/**
 * @license Angular v5.2.11
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */







/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Base class for control directives.
 *
 * Only used internally in the forms module.
 *
 * \@stable
 * @abstract
 */
var AbstractControlDirective = /** @class */ (function () {
    function AbstractControlDirective() {
    }
    Object.defineProperty(AbstractControlDirective.prototype, "value", {
        /** The value of the control. */
        get: /**
         * The value of the control.
         * @return {?}
         */
        function () { return this.control ? this.control.value : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
        /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         */
        get: /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         * @return {?}
         */
        function () { return this.control ? this.control.valid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
        /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         */
        get: /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         * @return {?}
         */
        function () { return this.control ? this.control.invalid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pending", {
        /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         */
        get: /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         * @return {?}
         */
        function () { return this.control ? this.control.pending : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
        /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         */
        get: /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         * @return {?}
         */
        function () { return this.control ? this.control.disabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
        /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         */
        get: /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         * @return {?}
         */
        function () { return this.control ? this.control.enabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
        /**
         * Returns any errors generated by failing validation. If there
         * are no errors, it will return null.
         */
        get: /**
         * Returns any errors generated by failing validation. If there
         * are no errors, it will return null.
         * @return {?}
         */
        function () { return this.control ? this.control.errors : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
        /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         */
        get: /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        function () { return this.control ? this.control.pristine : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
        /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         */
        get: /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        function () { return this.control ? this.control.dirty : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
        /**
         * A control is marked `touched` once the user has triggered
         * a `blur` event on it.
         */
        get: /**
         * A control is marked `touched` once the user has triggered
         * a `blur` event on it.
         * @return {?}
         */
        function () { return this.control ? this.control.touched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "status", {
        get: /**
         * @return {?}
         */
        function () { return this.control ? this.control.status : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
        /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         */
        get: /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         * @return {?}
         */
        function () { return this.control ? this.control.untouched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
        /**
         * Emits an event every time the validation status of the control
         * is re-calculated.
         */
        get: /**
         * Emits an event every time the validation status of the control
         * is re-calculated.
         * @return {?}
         */
        function () {
            return this.control ? this.control.statusChanges : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
        /**
         * Emits an event every time the value of the control changes, in
         * the UI or programmatically.
         */
        get: /**
         * Emits an event every time the value of the control changes, in
         * the UI or programmatically.
         * @return {?}
         */
        function () {
            return this.control ? this.control.valueChanges : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "path", {
        /**
         * Returns an array that represents the path from the top-level form
         * to this control. Each index is the string name of the control on
         * that level.
         */
        get: /**
         * Returns an array that represents the path from the top-level form
         * to this control. Each index is the string name of the control on
         * that level.
         * @return {?}
         */
        function () { return null; },
        enumerable: true,
        configurable: true
    });
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * For more information, see {@link AbstractControl}.
     */
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * For more information, see {\@link AbstractControl}.
     * @param {?=} value
     * @return {?}
     */
    AbstractControlDirective.prototype.reset = /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * For more information, see {\@link AbstractControl}.
     * @param {?=} value
     * @return {?}
     */
    function (value) {
        if (value === void 0) { value = undefined; }
        if (this.control)
            this.control.reset(value);
    };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     */
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.hasError = /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    function (errorCode, path) {
        return this.control ? this.control.hasError(errorCode, path) : false;
    };
    /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     */
    /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.getError = /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    function (errorCode, path) {
        return this.control ? this.control.getError(errorCode, path) : null;
    };
    return AbstractControlDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A directive that contains multiple {\@link NgControl}s.
 *
 * Only used by the forms module.
 *
 * \@stable
 * @abstract
 */
var ControlContainer = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ControlContainer, _super);
    function ControlContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ControlContainer.prototype, "formDirective", {
        /**
         * Get the form to which this container belongs.
         */
        get: /**
         * Get the form to which this container belongs.
         * @return {?}
         */
        function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlContainer.prototype, "path", {
        /**
         * Get the path to this container.
         */
        get: /**
         * Get the path to this container.
         * @return {?}
         */
        function () { return null; },
        enumerable: true,
        configurable: true
    });
    return ControlContainer;
}(AbstractControlDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} value
 * @return {?}
 */
function isEmptyInputValue(value) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}
/**
 * Providers for validators to be used for {\@link FormControl}s in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * ### Example
 *
 * ```typescript
 * \@Directive({
 *   selector: '[custom-validator]',
 *   providers: [{provide: NG_VALIDATORS, useExisting: CustomValidatorDirective, multi: true}]
 * })
 * class CustomValidatorDirective implements Validator {
 *   validate(control: AbstractControl): ValidationErrors | null {
 *     return {"custom": true};
 *   }
 * }
 * ```
 *
 * \@stable
 */
var NG_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgValidators');
/**
 * Providers for asynchronous validators to be used for {\@link FormControl}s
 * in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * See {\@link NG_VALIDATORS} for more details.
 *
 * \@stable
 */
var NG_ASYNC_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgAsyncValidators');
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
/**
 * Provides a set of validators used by form controls.
 *
 * A validator is a function that processes a {\@link FormControl} or collection of
 * controls and returns a map of errors. A null map means that validation has passed.
 *
 * ### Example
 *
 * ```typescript
 * var loginControl = new FormControl("", Validators.required)
 * ```
 *
 * \@stable
 */
var Validators = /** @class */ (function () {
    function Validators() {
    }
    /**
     * Validator that requires controls to have a value greater than a number.
     *`min()` exists only as a function, not as a directive. For example,
     * `control = new FormControl('', Validators.min(3));`.
     */
    /**
     * Validator that requires controls to have a value greater than a number.
     * `min()` exists only as a function, not as a directive. For example,
     * `control = new FormControl('', Validators.min(3));`.
     * @param {?} min
     * @return {?}
     */
    Validators.min = /**
     * Validator that requires controls to have a value greater than a number.
     * `min()` exists only as a function, not as a directive. For example,
     * `control = new FormControl('', Validators.min(3));`.
     * @param {?} min
     * @return {?}
     */
    function (min) {
        return function (control) {
            if (isEmptyInputValue(control.value) || isEmptyInputValue(min)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = parseFloat(control.value);
            // Controls with NaN values after parsing should be treated as not having a
            // minimum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-min
            return !isNaN(value) && value < min ? { 'min': { 'min': min, 'actual': control.value } } : null;
        };
    };
    /**
     * Validator that requires controls to have a value less than a number.
     * `max()` exists only as a function, not as a directive. For example,
     * `control = new FormControl('', Validators.max(15));`.
     */
    /**
     * Validator that requires controls to have a value less than a number.
     * `max()` exists only as a function, not as a directive. For example,
     * `control = new FormControl('', Validators.max(15));`.
     * @param {?} max
     * @return {?}
     */
    Validators.max = /**
     * Validator that requires controls to have a value less than a number.
     * `max()` exists only as a function, not as a directive. For example,
     * `control = new FormControl('', Validators.max(15));`.
     * @param {?} max
     * @return {?}
     */
    function (max) {
        return function (control) {
            if (isEmptyInputValue(control.value) || isEmptyInputValue(max)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = parseFloat(control.value);
            // Controls with NaN values after parsing should be treated as not having a
            // maximum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-max
            return !isNaN(value) && value > max ? { 'max': { 'max': max, 'actual': control.value } } : null;
        };
    };
    /**
     * Validator that requires controls to have a non-empty value.
     */
    /**
     * Validator that requires controls to have a non-empty value.
     * @param {?} control
     * @return {?}
     */
    Validators.required = /**
     * Validator that requires controls to have a non-empty value.
     * @param {?} control
     * @return {?}
     */
    function (control) {
        return isEmptyInputValue(control.value) ? { 'required': true } : null;
    };
    /**
     * Validator that requires control value to be true.
     */
    /**
     * Validator that requires control value to be true.
     * @param {?} control
     * @return {?}
     */
    Validators.requiredTrue = /**
     * Validator that requires control value to be true.
     * @param {?} control
     * @return {?}
     */
    function (control) {
        return control.value === true ? null : { 'required': true };
    };
    /**
     * Validator that performs email validation.
     */
    /**
     * Validator that performs email validation.
     * @param {?} control
     * @return {?}
     */
    Validators.email = /**
     * Validator that performs email validation.
     * @param {?} control
     * @return {?}
     */
    function (control) {
        return EMAIL_REGEXP.test(control.value) ? null : { 'email': true };
    };
    /**
     * Validator that requires controls to have a value of a minimum length.
     */
    /**
     * Validator that requires controls to have a value of a minimum length.
     * @param {?} minLength
     * @return {?}
     */
    Validators.minLength = /**
     * Validator that requires controls to have a value of a minimum length.
     * @param {?} minLength
     * @return {?}
     */
    function (minLength) {
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length < minLength ?
                { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires controls to have a value of a maximum length.
     */
    /**
     * Validator that requires controls to have a value of a maximum length.
     * @param {?} maxLength
     * @return {?}
     */
    Validators.maxLength = /**
     * Validator that requires controls to have a value of a maximum length.
     * @param {?} maxLength
     * @return {?}
     */
    function (maxLength) {
        return function (control) {
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length > maxLength ?
                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires a control to match a regex to its value.
     */
    /**
     * Validator that requires a control to match a regex to its value.
     * @param {?} pattern
     * @return {?}
     */
    Validators.pattern = /**
     * Validator that requires a control to match a regex to its value.
     * @param {?} pattern
     * @return {?}
     */
    function (pattern) {
        if (!pattern)
            return Validators.nullValidator;
        var /** @type {?} */ regex;
        var /** @type {?} */ regexStr;
        if (typeof pattern === 'string') {
            regexStr = '';
            if (pattern.charAt(0) !== '^')
                regexStr += '^';
            regexStr += pattern;
            if (pattern.charAt(pattern.length - 1) !== '$')
                regexStr += '$';
            regex = new RegExp(regexStr);
        }
        else {
            regexStr = pattern.toString();
            regex = pattern;
        }
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = control.value;
            return regex.test(value) ? null :
                { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
        };
    };
    /**
     * No-op validator.
     */
    /**
     * No-op validator.
     * @param {?} c
     * @return {?}
     */
    Validators.nullValidator = /**
     * No-op validator.
     * @param {?} c
     * @return {?}
     */
    function (c) { return null; };
    /**
     * @param {?} validators
     * @return {?}
     */
    Validators.compose = /**
     * @param {?} validators
     * @return {?}
     */
    function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = /** @type {?} */ (validators.filter(isPresent));
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            return _mergeErrors(_executeValidators(control, presentValidators));
        };
    };
    /**
     * @param {?} validators
     * @return {?}
     */
    Validators.composeAsync = /**
     * @param {?} validators
     * @return {?}
     */
    function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = /** @type {?} */ (validators.filter(isPresent));
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            var /** @type {?} */ observables = _executeAsyncValidators(control, presentValidators).map(toObservable);
            return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_forkJoin__["forkJoin"])(observables), _mergeErrors);
        };
    };
    return Validators;
}());
/**
 * @param {?} o
 * @return {?}
 */
function isPresent(o) {
    return o != null;
}
/**
 * @param {?} r
 * @return {?}
 */
function toObservable(r) {
    var /** @type {?} */ obs = Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵisPromise"])(r) ? Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_fromPromise__["fromPromise"])(r) : r;
    if (!(Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵisObservable"])(obs))) {
        throw new Error("Expected validator to return Promise or Observable.");
    }
    return obs;
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeAsyncValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} arrayOfErrors
 * @return {?}
 */
function _mergeErrors(arrayOfErrors) {
    var /** @type {?} */ res = arrayOfErrors.reduce(function (res, errors) {
        return errors != null ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, /** @type {?} */ ((res)), errors) : /** @type {?} */ ((res));
    }, {});
    return Object.keys(res).length === 0 ? null : res;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A `ControlValueAccessor` acts as a bridge between the Angular forms API and a
 * native element in the DOM.
 *
 * Implement this interface if you want to create a custom form control directive
 * that integrates with Angular forms.
 *
 * \@stable
 * @record
 */

/**
 * Used to provide a {\@link ControlValueAccessor} for form controls.
 *
 * See {\@link DefaultValueAccessor} for how to implement one.
 * \@stable
 */
var NG_VALUE_ACCESSOR = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgValueAccessor');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CHECKBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return CheckboxControlValueAccessor; }),
    multi: true,
};
/**
 * The accessor for writing a value and listening to changes on a checkbox input element.
 *
 *  ### Example
 *  ```
 *  <input type="checkbox" name="rememberLogin" ngModel>
 *  ```
 *
 *  \@stable
 */
var CheckboxControlValueAccessor = /** @class */ (function () {
    function CheckboxControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'checked', value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    CheckboxControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
                    host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
                    providers: [CHECKBOX_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    CheckboxControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    ]; };
    return CheckboxControlValueAccessor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DEFAULT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return DefaultValueAccessor; }),
    multi: true
};
/**
 * We must check whether the agent is Android because composition events
 * behave differently between iOS and Android.
 * @return {?}
 */
function _isAndroid() {
    var /** @type {?} */ userAgent = Object(__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["ɵgetDOM"])() ? Object(__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["ɵgetDOM"])().getUserAgent() : '';
    return /android (\d+)/.test(userAgent.toLowerCase());
}
/**
 * Turn this mode on if you want form directives to buffer IME input until compositionend
 * \@experimental
 */
var COMPOSITION_BUFFER_MODE = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('CompositionEventMode');
/**
 * The default accessor for writing a value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="text" name="searchQuery" ngModel>
 *  ```
 *
 *  \@stable
 */
var DefaultValueAccessor = /** @class */ (function () {
    function DefaultValueAccessor(_renderer, _elementRef, _compositionMode) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._compositionMode = _compositionMode;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        /**
         * Whether the user is creating a composition string (IME events).
         */
        this._composing = false;
        if (this._compositionMode == null) {
            this._compositionMode = !_isAndroid();
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    DefaultValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype._handleInput = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (!this._compositionMode || (this._compositionMode && !this._composing)) {
            this.onChange(value);
        }
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    DefaultValueAccessor.prototype._compositionStart = /**
     * \@internal
     * @return {?}
     */
    function () { this._composing = true; };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype._compositionEnd = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._composing = false;
        this._compositionMode && this.onChange(value);
    };
    DefaultValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
                    // TODO: vsavkin replace the above selector with the one below it once
                    // https://github.com/angular/angular/issues/3011 is implemented
                    // selector: '[ngModel],[formControl],[formControlName]',
                    host: {
                        '(input)': '$any(this)._handleInput($event.target.value)',
                        '(blur)': 'onTouched()',
                        '(compositionstart)': '$any(this)._compositionStart()',
                        '(compositionend)': '$any(this)._compositionEnd($event.target.value)'
                    },
                    providers: [DEFAULT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    DefaultValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [COMPOSITION_BUFFER_MODE,] },] },
    ]; };
    return DefaultValueAccessor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeValidator(validator) {
    if ((/** @type {?} */ (validator)).validate) {
        return function (c) { return (/** @type {?} */ (validator)).validate(c); };
    }
    else {
        return /** @type {?} */ (validator);
    }
}
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeAsyncValidator(validator) {
    if ((/** @type {?} */ (validator)).validate) {
        return function (c) { return (/** @type {?} */ (validator)).validate(c); };
    }
    else {
        return /** @type {?} */ (validator);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NUMBER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NumberValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a number value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="number" [(ngModel)]="age">
 *  ```
 */
var NumberValueAccessor = /** @class */ (function () {
    function NumberValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    NumberValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NumberValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    NumberValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
                    host: {
                        '(change)': 'onChange($event.target.value)',
                        '(input)': 'onChange($event.target.value)',
                        '(blur)': 'onTouched()'
                    },
                    providers: [NUMBER_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    NumberValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    ]; };
    return NumberValueAccessor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @return {?}
 */
function unimplemented() {
    throw new Error('unimplemented');
}
/**
 * A base class that all control directive extend.
 * It binds a {\@link FormControl} object to a DOM element.
 *
 * Used internally by Angular forms.
 *
 * \@stable
 * @abstract
 */
var NgControl = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(NgControl, _super);
    function NgControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * \@internal
         */
        _this._parent = null;
        _this.name = null;
        _this.valueAccessor = null;
        /**
         * \@internal
         */
        _this._rawValidators = [];
        /**
         * \@internal
         */
        _this._rawAsyncValidators = [];
        return _this;
    }
    Object.defineProperty(NgControl.prototype, "validator", {
        get: /**
         * @return {?}
         */
        function () { return /** @type {?} */ (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgControl.prototype, "asyncValidator", {
        get: /**
         * @return {?}
         */
        function () { return /** @type {?} */ (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    return NgControl;
}(AbstractControlDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RADIO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return RadioControlValueAccessor; }),
    multi: true
};
/**
 * Internal class used by Angular to uncheck radio buttons with the matching name.
 */
var RadioControlRegistry = /** @class */ (function () {
    function RadioControlRegistry() {
        this._accessors = [];
    }
    /**
     * @param {?} control
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.add = /**
     * @param {?} control
     * @param {?} accessor
     * @return {?}
     */
    function (control, accessor) {
        this._accessors.push([control, accessor]);
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.remove = /**
     * @param {?} accessor
     * @return {?}
     */
    function (accessor) {
        for (var /** @type {?} */ i = this._accessors.length - 1; i >= 0; --i) {
            if (this._accessors[i][1] === accessor) {
                this._accessors.splice(i, 1);
                return;
            }
        }
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.select = /**
     * @param {?} accessor
     * @return {?}
     */
    function (accessor) {
        var _this = this;
        this._accessors.forEach(function (c) {
            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].fireUncheck(accessor.value);
            }
        });
    };
    /**
     * @param {?} controlPair
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype._isSameGroup = /**
     * @param {?} controlPair
     * @param {?} accessor
     * @return {?}
     */
    function (controlPair, accessor) {
        if (!controlPair[0].control)
            return false;
        return controlPair[0]._parent === accessor._control._parent &&
            controlPair[1].name === accessor.name;
    };
    RadioControlRegistry.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    RadioControlRegistry.ctorParameters = function () { return []; };
    return RadioControlRegistry;
}());
/**
 * \@whatItDoes Writes radio control values and listens to radio control changes.
 *
 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
 * to keep the view synced with the {\@link FormControl} model.
 *
 * \@howToUse
 *
 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
 * value accessor will be active on any radio control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use radio buttons with form directives
 *
 * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
 * in the same group have the same `name` attribute.  Radio buttons with different `name`
 * attributes do not affect each other.
 *
 * {\@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
 *
 * When using radio buttons in a reactive form, radio buttons in the same group should have the
 * same `formControlName`. You can also add a `name` attribute, but it's optional.
 *
 * {\@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
 *
 *  * **npm package**: `\@angular/forms`
 *
 *  \@stable
 */
var RadioControlValueAccessor = /** @class */ (function () {
    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._registry = _registry;
        this._injector = _injector;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._control = this._injector.get(NgControl);
        this._checkName();
        this._registry.add(this._control, this);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () { this._registry.remove(this); };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._state = value === this.value;
        this._renderer.setProperty(this._elementRef.nativeElement, 'checked', this._state);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this._fn = fn;
        this.onChange = function () {
            fn(_this.value);
            _this._registry.select(_this);
        };
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.fireUncheck = /**
     * @param {?} value
     * @return {?}
     */
    function (value) { this.writeValue(value); };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RadioControlValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._checkName = /**
     * @return {?}
     */
    function () {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            this._throwNameError();
        }
        if (!this.name && this.formControlName)
            this.name = this.formControlName;
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._throwNameError = /**
     * @return {?}
     */
    function () {
        throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
    };
    RadioControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
                    host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
                    providers: [RADIO_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    RadioControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: RadioControlRegistry, },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injector"], },
    ]; };
    RadioControlValueAccessor.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "formControlName": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "value": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return RadioControlValueAccessor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RANGE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return RangeValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a range value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="range" [(ngModel)]="age" >
 *  ```
 */
var RangeValueAccessor = /** @class */ (function () {
    function RangeValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    RangeValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RangeValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    RangeValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
                    host: {
                        '(change)': 'onChange($event.target.value)',
                        '(input)': 'onChange($event.target.value)',
                        '(blur)': 'onTouched()'
                    },
                    providers: [RANGE_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    RangeValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    ]; };
    return RangeValueAccessor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELECT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return SelectControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString(id, value) {
    if (id == null)
        return "" + value;
    if (value && typeof value === 'object')
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/**
 * \@whatItDoes Writes values and listens to changes on a select element.
 *
 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
 * to keep the view synced with the {\@link FormControl} model.
 *
 * \@howToUse
 *
 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
 * value accessor will be active on any select control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use select controls with form directives
 *
 * To use a select in a template-driven form, simply add an `ngModel` and a `name`
 * attribute to the main `<select>` tag.
 *
 * If your option values are simple strings, you can bind to the normal `value` property
 * on the option.  If your option values happen to be objects (and you'd like to save the
 * selection in your form as an object), use `ngValue` instead:
 *
 * {\@example forms/ts/selectControl/select_control_example.ts region='Component'}
 *
 * In reactive forms, you'll also want to add your form directive (`formControlName` or
 * `formControl`) on the main `<select>` tag. Like in the former example, you have the
 * choice of binding to the  `value` or `ngValue` property on the select's options.
 *
 * {\@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
 *
 * ### Caveat: Option selection
 *
 * Angular uses object identity to select option. It's possible for the identities of items
 * to change while the data does not. This can happen, for example, if the items are produced
 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
 * second response will produce objects with different identities.
 *
 * To customize the default option comparison algorithm, `<select>` supports `compareWith` input.
 * `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
 * If `compareWith` is given, Angular selects option by the return value of the function.
 *
 * #### Syntax
 *
 * ```
 * <select [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
 *     <option *ngFor="let country of countries" [ngValue]="country">
 *         {{country.name}}
 *     </option>
 * </select>
 *
 * compareFn(c1: Country, c2: Country): boolean {
 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
 * }
 * ```
 *
 * Note: We listen to the 'change' event because 'input' events aren't fired
 * for selects in Firefox and IE:
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var SelectControlValueAccessor = /** @class */ (function () {
    function SelectControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /**
         * \@internal
         */
        this._optionMap = new Map();
        /**
         * \@internal
         */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._compareWith = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵlooseIdentical"];
    }
    Object.defineProperty(SelectControlValueAccessor.prototype, "compareWith", {
        set: /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
        var /** @type {?} */ id = this._getOptionId(value);
        if (id == null) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'selectedIndex', -1);
        }
        var /** @type {?} */ valueString = _buildValueString(id, value);
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', valueString);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.onChange = function (valueString) {
            _this.value = _this._getOptionValue(valueString);
            fn(_this.value);
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectControlValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    SelectControlValueAccessor.prototype._registerOption = /**
     * \@internal
     * @return {?}
     */
    function () { return (this._idCounter++).toString(); };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionId = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (this._compareWith(this._optionMap.get(id), value))
                return id;
        }
        return null;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionValue = /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    function (valueString) {
        var /** @type {?} */ id = _extractId(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
    };
    SelectControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
                    host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                    providers: [SELECT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    SelectControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    ]; };
    SelectControlValueAccessor.propDecorators = {
        "compareWith": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return SelectControlValueAccessor;
}());
/**
 * \@whatItDoes Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * \@howToUse
 *
 * See docs for {\@link SelectControlValueAccessor} for usage examples.
 *
 * \@stable
 */
var NgSelectOption = /** @class */ (function () {
    function NgSelectOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select)
            this.id = this._select._registerOption();
    }
    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this._select == null)
                return;
            this._select._optionMap.set(this.id, value);
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectOption.prototype, "value", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._setElementValue(value);
            if (this._select)
                this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSelectOption.prototype._setElementValue = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._renderer.setProperty(this._element.nativeElement, 'value', value);
    };
    /**
     * @return {?}
     */
    NgSelectOption.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectOption.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: 'option' },] },
    ];
    /** @nocollapse */
    NgSelectOption.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: SelectControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] },] },
    ]; };
    NgSelectOption.propDecorators = {
        "ngValue": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngValue',] },],
        "value": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['value',] },],
    };
    return NgSelectOption;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELECT_MULTIPLE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return SelectMultipleControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString$1(id, value) {
    if (id == null)
        return "" + value;
    if (typeof value === 'string')
        value = "'" + value + "'";
    if (value && typeof value === 'object')
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId$1(valueString) {
    return valueString.split(':')[0];
}
/**
 * The accessor for writing a value and listening to changes on a select element.
 *
 *  ### Caveat: Options selection
 *
 * Angular uses object identity to select options. It's possible for the identities of items
 * to change while the data does not. This can happen, for example, if the items are produced
 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
 * second response will produce objects with different identities.
 *
 * To customize the default option comparison algorithm, `<select multiple>` supports `compareWith`
 * input. `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
 * If `compareWith` is given, Angular selects options by the return value of the function.
 *
 * #### Syntax
 *
 * ```
 * <select multiple [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
 *     <option *ngFor="let country of countries" [ngValue]="country">
 *         {{country.name}}
 *     </option>
 * </select>
 *
 * compareFn(c1: Country, c2: Country): boolean {
 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
 * }
 * ```
 *
 * \@stable
 */
var SelectMultipleControlValueAccessor = /** @class */ (function () {
    function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /**
         * \@internal
         */
        this._optionMap = new Map();
        /**
         * \@internal
         */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._compareWith = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵlooseIdentical"];
    }
    Object.defineProperty(SelectMultipleControlValueAccessor.prototype, "compareWith", {
        set: /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        this.value = value;
        var /** @type {?} */ optionSelectedStateSetter;
        if (Array.isArray(value)) {
            // convert values to ids
            var /** @type {?} */ ids_1 = value.map(function (v) { return _this._getOptionId(v); });
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(ids_1.indexOf(o.toString()) > -1); };
        }
        else {
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(false); };
        }
        this._optionMap.forEach(optionSelectedStateSetter);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.onChange = function (_) {
            var /** @type {?} */ selected = [];
            if (_.hasOwnProperty('selectedOptions')) {
                var /** @type {?} */ options = _.selectedOptions;
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    var /** @type {?} */ val = _this._getOptionValue(opt.value);
                    selected.push(val);
                }
            }
            else {
                var /** @type {?} */ options = /** @type {?} */ (_.options);
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    if (opt.selected) {
                        var /** @type {?} */ val = _this._getOptionValue(opt.value);
                        selected.push(val);
                    }
                }
            }
            _this.value = selected;
            fn(selected);
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._registerOption = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var /** @type {?} */ id = (this._idCounter++).toString();
        this._optionMap.set(id, value);
        return id;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionId = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (this._compareWith(/** @type {?} */ ((this._optionMap.get(id)))._value, value))
                return id;
        }
        return null;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionValue = /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    function (valueString) {
        var /** @type {?} */ id = _extractId$1(valueString);
        return this._optionMap.has(id) ? /** @type {?} */ ((this._optionMap.get(id)))._value : valueString;
    };
    SelectMultipleControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
                    host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
                    providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    SelectMultipleControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    ]; };
    SelectMultipleControlValueAccessor.propDecorators = {
        "compareWith": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return SelectMultipleControlValueAccessor;
}());
/**
 * Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * ### Example
 *
 * ```
 * <select multiple name="city" ngModel>
 *   <option *ngFor="let c of cities" [value]="c"></option>
 * </select>
 * ```
 */
var NgSelectMultipleOption = /** @class */ (function () {
    function NgSelectMultipleOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select) {
            this.id = this._select._registerOption(this);
        }
    }
    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this._select == null)
                return;
            this._value = value;
            this._setElementValue(_buildValueString$1(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this._select) {
                this._value = value;
                this._setElementValue(_buildValueString$1(this.id, value));
                this._select.writeValue(this._select.value);
            }
            else {
                this._setElementValue(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setElementValue = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._renderer.setProperty(this._element.nativeElement, 'value', value);
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} selected
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setSelected = /**
     * \@internal
     * @param {?} selected
     * @return {?}
     */
    function (selected) {
        this._renderer.setProperty(this._element.nativeElement, 'selected', selected);
    };
    /**
     * @return {?}
     */
    NgSelectMultipleOption.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectMultipleOption.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: 'option' },] },
    ];
    /** @nocollapse */
    NgSelectMultipleOption.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
        { type: SelectMultipleControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] },] },
    ]; };
    NgSelectMultipleOption.propDecorators = {
        "ngValue": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngValue',] },],
        "value": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['value',] },],
    };
    return NgSelectMultipleOption;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} name
 * @param {?} parent
 * @return {?}
 */
function controlPath(name, parent) {
    return /** @type {?} */ ((parent.path)).concat([name]);
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpControl(control, dir) {
    if (!control)
        _throwError(dir, 'Cannot find control with');
    if (!dir.valueAccessor)
        _throwError(dir, 'No value accessor for form control with');
    control.validator = Validators.compose([/** @type {?} */ ((control.validator)), dir.validator]);
    control.asyncValidator = Validators.composeAsync([/** @type {?} */ ((control.asyncValidator)), dir.asyncValidator]); /** @type {?} */
    ((dir.valueAccessor)).writeValue(control.value);
    setUpViewChangePipeline(control, dir);
    setUpModelChangePipeline(control, dir);
    setUpBlurPipeline(control, dir);
    if (/** @type {?} */ ((dir.valueAccessor)).setDisabledState) {
        control.registerOnDisabledChange(function (isDisabled) { /** @type {?} */ ((/** @type {?} */ ((dir.valueAccessor)).setDisabledState))(isDisabled); });
    }
    // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
    dir._rawValidators.forEach(function (validator) {
        if ((/** @type {?} */ (validator)).registerOnValidatorChange)
            /** @type {?} */ (((/** @type {?} */ (validator)).registerOnValidatorChange))(function () { return control.updateValueAndValidity(); });
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if ((/** @type {?} */ (validator)).registerOnValidatorChange)
            /** @type {?} */ (((/** @type {?} */ (validator)).registerOnValidatorChange))(function () { return control.updateValueAndValidity(); });
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function cleanUpControl(control, dir) {
    /** @type {?} */ ((dir.valueAccessor)).registerOnChange(function () { return _noControlError(dir); }); /** @type {?} */
    ((dir.valueAccessor)).registerOnTouched(function () { return _noControlError(dir); });
    dir._rawValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    if (control)
        control._clearChangeFns();
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpViewChangePipeline(control, dir) {
    /** @type {?} */ ((dir.valueAccessor)).registerOnChange(function (newValue) {
        control._pendingValue = newValue;
        control._pendingChange = true;
        control._pendingDirty = true;
        if (control.updateOn === 'change')
            updateControl(control, dir);
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpBlurPipeline(control, dir) {
    /** @type {?} */ ((dir.valueAccessor)).registerOnTouched(function () {
        control._pendingTouched = true;
        if (control.updateOn === 'blur' && control._pendingChange)
            updateControl(control, dir);
        if (control.updateOn !== 'submit')
            control.markAsTouched();
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function updateControl(control, dir) {
    dir.viewToModelUpdate(control._pendingValue);
    if (control._pendingDirty)
        control.markAsDirty();
    control.setValue(control._pendingValue, { emitModelToViewChange: false });
    control._pendingChange = false;
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpModelChangePipeline(control, dir) {
    control.registerOnChange(function (newValue, emitModelEvent) {
        /** @type {?} */ ((
        // control -> view
        dir.valueAccessor)).writeValue(newValue);
        // control -> ngModel
        if (emitModelEvent)
            dir.viewToModelUpdate(newValue);
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpFormContainer(control, dir) {
    if (control == null)
        _throwError(dir, 'Cannot find control with');
    control.validator = Validators.compose([control.validator, dir.validator]);
    control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
}
/**
 * @param {?} dir
 * @return {?}
 */
function _noControlError(dir) {
    return _throwError(dir, 'There is no FormControl instance attached to form control element with');
}
/**
 * @param {?} dir
 * @param {?} message
 * @return {?}
 */
function _throwError(dir, message) {
    var /** @type {?} */ messageEnd;
    if (/** @type {?} */ ((dir.path)).length > 1) {
        messageEnd = "path: '" + (/** @type {?} */ ((dir.path))).join(' -> ') + "'";
    }
    else if (/** @type {?} */ ((dir.path))[0]) {
        messageEnd = "name: '" + dir.path + "'";
    }
    else {
        messageEnd = 'unspecified name attribute';
    }
    throw new Error(message + " " + messageEnd);
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeValidators(validators) {
    return validators != null ? Validators.compose(validators.map(normalizeValidator)) : null;
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeAsyncValidators(validators) {
    return validators != null ? Validators.composeAsync(validators.map(normalizeAsyncValidator)) :
        null;
}
/**
 * @param {?} changes
 * @param {?} viewModel
 * @return {?}
 */
function isPropertyUpdated(changes, viewModel) {
    if (!changes.hasOwnProperty('model'))
        return false;
    var /** @type {?} */ change = changes['model'];
    if (change.isFirstChange())
        return true;
    return !Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵlooseIdentical"])(viewModel, change.currentValue);
}
var BUILTIN_ACCESSORS = [
    CheckboxControlValueAccessor,
    RangeValueAccessor,
    NumberValueAccessor,
    SelectControlValueAccessor,
    SelectMultipleControlValueAccessor,
    RadioControlValueAccessor,
];
/**
 * @param {?} valueAccessor
 * @return {?}
 */
function isBuiltInAccessor(valueAccessor) {
    return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
}
/**
 * @param {?} form
 * @param {?} directives
 * @return {?}
 */
function syncPendingControls(form, directives) {
    form._syncPendingControls();
    directives.forEach(function (dir) {
        var /** @type {?} */ control = /** @type {?} */ (dir.control);
        if (control.updateOn === 'submit' && control._pendingChange) {
            dir.viewToModelUpdate(control._pendingValue);
            control._pendingChange = false;
        }
    });
}
/**
 * @param {?} dir
 * @param {?} valueAccessors
 * @return {?}
 */
function selectValueAccessor(dir, valueAccessors) {
    if (!valueAccessors)
        return null;
    if (!Array.isArray(valueAccessors))
        _throwError(dir, 'Value accessor was not provided as an array for form control with');
    var /** @type {?} */ defaultAccessor = undefined;
    var /** @type {?} */ builtinAccessor = undefined;
    var /** @type {?} */ customAccessor = undefined;
    valueAccessors.forEach(function (v) {
        if (v.constructor === DefaultValueAccessor) {
            defaultAccessor = v;
        }
        else if (isBuiltInAccessor(v)) {
            if (builtinAccessor)
                _throwError(dir, 'More than one built-in value accessor matches form control with');
            builtinAccessor = v;
        }
        else {
            if (customAccessor)
                _throwError(dir, 'More than one custom value accessor matches form control with');
            customAccessor = v;
        }
    });
    if (customAccessor)
        return customAccessor;
    if (builtinAccessor)
        return builtinAccessor;
    if (defaultAccessor)
        return defaultAccessor;
    _throwError(dir, 'No valid value accessor for form control with');
    return null;
}
/**
 * @template T
 * @param {?} list
 * @param {?} el
 * @return {?}
 */
function removeDir(list, el) {
    var /** @type {?} */ index = list.indexOf(el);
    if (index > -1)
        list.splice(index, 1);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This is a base class for code shared between {\@link NgModelGroup} and {\@link FormGroupName}.
 *
 * \@stable
 */
var AbstractFormGroupDirective = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(AbstractFormGroupDirective, _super);
    function AbstractFormGroupDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._checkParentType(); /** @type {?} */
        ((this.formDirective)).addFormGroup(this);
    };
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.formDirective) {
            this.formDirective.removeFormGroup(this);
        }
    };
    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
        /**
         * Get the {@link FormGroup} backing this binding.
         */
        get: /**
         * Get the {\@link FormGroup} backing this binding.
         * @return {?}
         */
        function () { return /** @type {?} */ ((this.formDirective)).getFormGroup(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
        /**
         * Get the path to this control group.
         */
        get: /**
         * Get the path to this control group.
         * @return {?}
         */
        function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
        /**
         * Get the {@link Form} to which this group belongs.
         */
        get: /**
         * Get the {\@link Form} to which this group belongs.
         * @return {?}
         */
        function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
        get: /**
         * @return {?}
         */
        function () { return composeValidators(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
        get: /**
         * @return {?}
         */
        function () {
            return composeAsyncValidators(this._asyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    AbstractFormGroupDirective.prototype._checkParentType = /**
     * \@internal
     * @return {?}
     */
    function () { };
    return AbstractFormGroupDirective;
}(ControlContainer));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AbstractControlStatus = /** @class */ (function () {
    function AbstractControlStatus(cd) {
        this._cd = cd;
    }
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.untouched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.touched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.pristine : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.dirty : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.valid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.invalid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
        get: /**
         * @return {?}
         */
        function () { return this._cd.control ? this._cd.control.pending : false; },
        enumerable: true,
        configurable: true
    });
    return AbstractControlStatus;
}());
var ngControlStatusHost = {
    '[class.ng-untouched]': 'ngClassUntouched',
    '[class.ng-touched]': 'ngClassTouched',
    '[class.ng-pristine]': 'ngClassPristine',
    '[class.ng-dirty]': 'ngClassDirty',
    '[class.ng-valid]': 'ngClassValid',
    '[class.ng-invalid]': 'ngClassInvalid',
    '[class.ng-pending]': 'ngClassPending',
};
/**
 * Directive automatically applied to Angular form controls that sets CSS classes
 * based on control status. The following classes are applied as the properties
 * become true:
 *
 * * ng-valid
 * * ng-invalid
 * * ng-pending
 * * ng-pristine
 * * ng-dirty
 * * ng-untouched
 * * ng-touched
 *
 * \@stable
 */
var NgControlStatus = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(NgControlStatus, _super);
    function NgControlStatus(cd) {
        return _super.call(this, cd) || this;
    }
    NgControlStatus.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
    ];
    /** @nocollapse */
    NgControlStatus.ctorParameters = function () { return [
        { type: NgControl, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] },] },
    ]; };
    return NgControlStatus;
}(AbstractControlStatus));
/**
 * Directive automatically applied to Angular form groups that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * \@stable
 */
var NgControlStatusGroup = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(NgControlStatusGroup, _super);
    function NgControlStatusGroup(cd) {
        return _super.call(this, cd) || this;
    }
    NgControlStatusGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
                    host: ngControlStatusHost
                },] },
    ];
    /** @nocollapse */
    NgControlStatusGroup.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] },] },
    ]; };
    return NgControlStatusGroup;
}(AbstractControlStatus));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
 */
var VALID = 'VALID';
/**
 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
 */
var INVALID = 'INVALID';
/**
 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
 * errors are not yet available for the input value.
 */
var PENDING = 'PENDING';
/**
 * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
 * calculations of validity or value.
 */
var DISABLED = 'DISABLED';
/**
 * @param {?} control
 * @param {?} path
 * @param {?} delimiter
 * @return {?}
 */
function _find(control, path, delimiter) {
    if (path == null)
        return null;
    if (!(path instanceof Array)) {
        path = (/** @type {?} */ (path)).split(delimiter);
    }
    if (path instanceof Array && (path.length === 0))
        return null;
    return (/** @type {?} */ (path)).reduce(function (v, name) {
        if (v instanceof FormGroup) {
            return v.controls[name] || null;
        }
        if (v instanceof FormArray) {
            return v.at(/** @type {?} */ (name)) || null;
        }
        return null;
    }, control);
}
/**
 * @param {?=} validatorOrOpts
 * @return {?}
 */
function coerceToValidator(validatorOrOpts) {
    var /** @type {?} */ validator = /** @type {?} */ ((isOptionsObj(validatorOrOpts) ? (/** @type {?} */ (validatorOrOpts)).validators :
        validatorOrOpts));
    return Array.isArray(validator) ? composeValidators(validator) : validator || null;
}
/**
 * @param {?=} asyncValidator
 * @param {?=} validatorOrOpts
 * @return {?}
 */
function coerceToAsyncValidator(asyncValidator, validatorOrOpts) {
    var /** @type {?} */ origAsyncValidator = /** @type {?} */ ((isOptionsObj(validatorOrOpts) ? (/** @type {?} */ (validatorOrOpts)).asyncValidators :
        asyncValidator));
    return Array.isArray(origAsyncValidator) ? composeAsyncValidators(origAsyncValidator) :
        origAsyncValidator || null;
}
/**
 * @record
 */

/**
 * @param {?=} validatorOrOpts
 * @return {?}
 */
function isOptionsObj(validatorOrOpts) {
    return validatorOrOpts != null && !Array.isArray(validatorOrOpts) &&
        typeof validatorOrOpts === 'object';
}
/**
 * \@whatItDoes This is the base class for {\@link FormControl}, {\@link FormGroup}, and
 * {\@link FormArray}.
 *
 * It provides some of the shared behavior that all controls and groups of controls have, like
 * running validators, calculating status, and resetting state. It also defines the properties
 * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
 * instantiated directly.
 *
 * \@stable
 * @abstract
 */
var AbstractControl = /** @class */ (function () {
    function AbstractControl(validator, asyncValidator) {
        this.validator = validator;
        this.asyncValidator = asyncValidator;
        /**
         * \@internal
         */
        this._onCollectionChange = function () { };
        /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         */
        this.pristine = true;
        /**
         * A control is marked `touched` once the user has triggered
         * a `blur` event on it.
         */
        this.touched = false;
        /**
         * \@internal
         */
        this._onDisabledChange = [];
    }
    Object.defineProperty(AbstractControl.prototype, "parent", {
        /**
         * The parent control.
         */
        get: /**
         * The parent control.
         * @return {?}
         */
        function () { return this._parent; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valid", {
        /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         */
        get: /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         * @return {?}
         */
        function () { return this.status === VALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "invalid", {
        /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         */
        get: /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         * @return {?}
         */
        function () { return this.status === INVALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pending", {
        /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         */
        get: /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         * @return {?}
         */
        function () { return this.status == PENDING; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "disabled", {
        /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         */
        get: /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         * @return {?}
         */
        function () { return this.status === DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "enabled", {
        /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         */
        get: /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         * @return {?}
         */
        function () { return this.status !== DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "dirty", {
        /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         */
        get: /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        function () { return !this.pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "untouched", {
        /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         */
        get: /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         * @return {?}
         */
        function () { return !this.touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "updateOn", {
        /**
         * Returns the update strategy of the `AbstractControl` (i.e.
         * the event on which the control will update itself).
         * Possible values: `'change'` (default) | `'blur'` | `'submit'`
         */
        get: /**
         * Returns the update strategy of the `AbstractControl` (i.e.
         * the event on which the control will update itself).
         * Possible values: `'change'` (default) | `'blur'` | `'submit'`
         * @return {?}
         */
        function () {
            return this._updateOn ? this._updateOn : (this.parent ? this.parent.updateOn : 'change');
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this will overwrite any existing sync validators.
     */
    /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this will overwrite any existing sync validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setValidators = /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this will overwrite any existing sync validators.
     * @param {?} newValidator
     * @return {?}
     */
    function (newValidator) {
        this.validator = coerceToValidator(newValidator);
    };
    /**
     * Sets the async validators that are active on this control. Calling this
     * will overwrite any existing async validators.
     */
    /**
     * Sets the async validators that are active on this control. Calling this
     * will overwrite any existing async validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setAsyncValidators = /**
     * Sets the async validators that are active on this control. Calling this
     * will overwrite any existing async validators.
     * @param {?} newValidator
     * @return {?}
     */
    function (newValidator) {
        this.asyncValidator = coerceToAsyncValidator(newValidator);
    };
    /**
     * Empties out the sync validator list.
     */
    /**
     * Empties out the sync validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearValidators = /**
     * Empties out the sync validator list.
     * @return {?}
     */
    function () { this.validator = null; };
    /**
     * Empties out the async validator list.
     */
    /**
     * Empties out the async validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearAsyncValidators = /**
     * Empties out the async validator list.
     * @return {?}
     */
    function () { this.asyncValidator = null; };
    /**
     * Marks the control as `touched`.
     *
     * This will also mark all direct ancestors as `touched` to maintain
     * the model.
     */
    /**
     * Marks the control as `touched`.
     *
     * This will also mark all direct ancestors as `touched` to maintain
     * the model.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsTouched = /**
     * Marks the control as `touched`.
     *
     * This will also mark all direct ancestors as `touched` to maintain
     * the model.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).touched = true;
        if (this._parent && !opts.onlySelf) {
            this._parent.markAsTouched(opts);
        }
    };
    /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, it will also mark all children as `untouched`
     * to maintain the model, and re-calculate the `touched` status of all parent
     * controls.
     */
    /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, it will also mark all children as `untouched`
     * to maintain the model, and re-calculate the `touched` status of all parent
     * controls.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsUntouched = /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, it will also mark all children as `untouched`
     * to maintain the model, and re-calculate the `touched` status of all parent
     * controls.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).touched = false;
        this._pendingTouched = false;
        this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
        if (this._parent && !opts.onlySelf) {
            this._parent._updateTouched(opts);
        }
    };
    /**
     * Marks the control as `dirty`.
     *
     * This will also mark all direct ancestors as `dirty` to maintain
     * the model.
     */
    /**
     * Marks the control as `dirty`.
     *
     * This will also mark all direct ancestors as `dirty` to maintain
     * the model.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsDirty = /**
     * Marks the control as `dirty`.
     *
     * This will also mark all direct ancestors as `dirty` to maintain
     * the model.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).pristine = false;
        if (this._parent && !opts.onlySelf) {
            this._parent.markAsDirty(opts);
        }
    };
    /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, it will also mark all children as `pristine`
     * to maintain the model, and re-calculate the `pristine` status of all parent
     * controls.
     */
    /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, it will also mark all children as `pristine`
     * to maintain the model, and re-calculate the `pristine` status of all parent
     * controls.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsPristine = /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, it will also mark all children as `pristine`
     * to maintain the model, and re-calculate the `pristine` status of all parent
     * controls.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).pristine = true;
        this._pendingDirty = false;
        this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
        if (this._parent && !opts.onlySelf) {
            this._parent._updatePristine(opts);
        }
    };
    /**
     * Marks the control as `pending`.
     */
    /**
     * Marks the control as `pending`.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.markAsPending = /**
     * Marks the control as `pending`.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).status = PENDING;
        if (this._parent && !opts.onlySelf) {
            this._parent.markAsPending(opts);
        }
    };
    /**
     * Disables the control. This means the control will be exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children will be disabled to maintain the model.
     */
    /**
     * Disables the control. This means the control will be exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children will be disabled to maintain the model.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.disable = /**
     * Disables the control. This means the control will be exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children will be disabled to maintain the model.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).status = DISABLED;
        (/** @type {?} */ (this)).errors = null;
        this._forEachChild(function (control) { control.disable(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, opts, { onlySelf: true })); });
        this._updateValue();
        if (opts.emitEvent !== false) {
            (/** @type {?} */ (this.valueChanges)).emit(this.value);
            (/** @type {?} */ (this.statusChanges)).emit(this.status);
        }
        this._updateAncestors(opts);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
    };
    /**
     * Enables the control. This means the control will be included in validation checks and
     * the aggregate value of its parent. Its status is re-calculated based on its value and
     * its validators.
     *
     * If the control has children, all children will be enabled.
     */
    /**
     * Enables the control. This means the control will be included in validation checks and
     * the aggregate value of its parent. Its status is re-calculated based on its value and
     * its validators.
     *
     * If the control has children, all children will be enabled.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.enable = /**
     * Enables the control. This means the control will be included in validation checks and
     * the aggregate value of its parent. Its status is re-calculated based on its value and
     * its validators.
     *
     * If the control has children, all children will be enabled.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).status = VALID;
        this._forEachChild(function (control) { control.enable(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, opts, { onlySelf: true })); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
        this._updateAncestors(opts);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
    };
    /**
     * @param {?} opts
     * @return {?}
     */
    AbstractControl.prototype._updateAncestors = /**
     * @param {?} opts
     * @return {?}
     */
    function (opts) {
        if (this._parent && !opts.onlySelf) {
            this._parent.updateValueAndValidity(opts);
            this._parent._updatePristine();
            this._parent._updateTouched();
        }
    };
    /**
     * @param {?} parent
     * @return {?}
     */
    AbstractControl.prototype.setParent = /**
     * @param {?} parent
     * @return {?}
     */
    function (parent) { this._parent = parent; };
    /**
     * Re-calculates the value and validation status of the control.
     *
     * By default, it will also update the value and validity of its ancestors.
     */
    /**
     * Re-calculates the value and validation status of the control.
     *
     * By default, it will also update the value and validity of its ancestors.
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.updateValueAndValidity = /**
     * Re-calculates the value and validation status of the control.
     *
     * By default, it will also update the value and validity of its ancestors.
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        this._setInitialStatus();
        this._updateValue();
        if (this.enabled) {
            this._cancelExistingSubscription();
            (/** @type {?} */ (this)).errors = this._runValidator();
            (/** @type {?} */ (this)).status = this._calculateStatus();
            if (this.status === VALID || this.status === PENDING) {
                this._runAsyncValidator(opts.emitEvent);
            }
        }
        if (opts.emitEvent !== false) {
            (/** @type {?} */ (this.valueChanges)).emit(this.value);
            (/** @type {?} */ (this.statusChanges)).emit(this.status);
        }
        if (this._parent && !opts.onlySelf) {
            this._parent.updateValueAndValidity(opts);
        }
    };
    /** @internal */
    /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype._updateTreeValidity = /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = { emitEvent: true }; }
        this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity(opts); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._setInitialStatus = /**
     * @return {?}
     */
    function () {
        (/** @type {?} */ (this)).status = this._allControlsDisabled() ? DISABLED : VALID;
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._runValidator = /**
     * @return {?}
     */
    function () {
        return this.validator ? this.validator(this) : null;
    };
    /**
     * @param {?=} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._runAsyncValidator = /**
     * @param {?=} emitEvent
     * @return {?}
     */
    function (emitEvent) {
        var _this = this;
        if (this.asyncValidator) {
            (/** @type {?} */ (this)).status = PENDING;
            var /** @type {?} */ obs = toObservable(this.asyncValidator(this));
            this._asyncValidationSubscription =
                obs.subscribe(function (errors) { return _this.setErrors(errors, { emitEvent: emitEvent }); });
        }
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._cancelExistingSubscription = /**
     * @return {?}
     */
    function () {
        if (this._asyncValidationSubscription) {
            this._asyncValidationSubscription.unsubscribe();
        }
    };
    /**
     * Sets errors on a form control.
     *
     * This is used when validations are run manually by the user, rather than automatically.
     *
     * Calling `setErrors` will also update the validity of the parent control.
     *
     * ### Example
     *
     * ```
     * const login = new FormControl("someLogin");
     * login.setErrors({
     *   "notUnique": true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({"notUnique": true});
     *
     * login.setValue("someOtherLogin");
     *
     * expect(login.valid).toEqual(true);
     * ```
     */
    /**
     * Sets errors on a form control.
     *
     * This is used when validations are run manually by the user, rather than automatically.
     *
     * Calling `setErrors` will also update the validity of the parent control.
     *
     * ### Example
     *
     * ```
     * const login = new FormControl("someLogin");
     * login.setErrors({
     *   "notUnique": true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({"notUnique": true});
     *
     * login.setValue("someOtherLogin");
     *
     * expect(login.valid).toEqual(true);
     * ```
     * @param {?} errors
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype.setErrors = /**
     * Sets errors on a form control.
     *
     * This is used when validations are run manually by the user, rather than automatically.
     *
     * Calling `setErrors` will also update the validity of the parent control.
     *
     * ### Example
     *
     * ```
     * const login = new FormControl("someLogin");
     * login.setErrors({
     *   "notUnique": true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({"notUnique": true});
     *
     * login.setValue("someOtherLogin");
     *
     * expect(login.valid).toEqual(true);
     * ```
     * @param {?} errors
     * @param {?=} opts
     * @return {?}
     */
    function (errors, opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).errors = errors;
        this._updateControlsErrors(opts.emitEvent !== false);
    };
    /**
     * Retrieves a child control given the control's name or path.
     *
     * Paths can be passed in as an array or a string delimited by a dot.
     *
     * To get a control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     */
    /**
     * Retrieves a child control given the control's name or path.
     *
     * Paths can be passed in as an array or a string delimited by a dot.
     *
     * To get a control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     * @param {?} path
     * @return {?}
     */
    AbstractControl.prototype.get = /**
     * Retrieves a child control given the control's name or path.
     *
     * Paths can be passed in as an array or a string delimited by a dot.
     *
     * To get a control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     * @param {?} path
     * @return {?}
     */
    function (path) { return _find(this, path, '.'); };
    /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     */
    /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.getError = /**
     * Returns error data if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    function (errorCode, path) {
        var /** @type {?} */ control = path ? this.get(path) : this;
        return control && control.errors ? control.errors[errorCode] : null;
    };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     */
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.hasError = /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    function (errorCode, path) { return !!this.getError(errorCode, path); };
    Object.defineProperty(AbstractControl.prototype, "root", {
        /**
         * Retrieves the top-level ancestor of this control.
         */
        get: /**
         * Retrieves the top-level ancestor of this control.
         * @return {?}
         */
        function () {
            var /** @type {?} */ x = this;
            while (x._parent) {
                x = x._parent;
            }
            return x;
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    /**
     * \@internal
     * @param {?} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._updateControlsErrors = /**
     * \@internal
     * @param {?} emitEvent
     * @return {?}
     */
    function (emitEvent) {
        (/** @type {?} */ (this)).status = this._calculateStatus();
        if (emitEvent) {
            (/** @type {?} */ (this.statusChanges)).emit(this.status);
        }
        if (this._parent) {
            this._parent._updateControlsErrors(emitEvent);
        }
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._initObservables = /**
     * \@internal
     * @return {?}
     */
    function () {
        (/** @type {?} */ (this)).valueChanges = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        (/** @type {?} */ (this)).statusChanges = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._calculateStatus = /**
     * @return {?}
     */
    function () {
        if (this._allControlsDisabled())
            return DISABLED;
        if (this.errors)
            return INVALID;
        if (this._anyControlsHaveStatus(PENDING))
            return PENDING;
        if (this._anyControlsHaveStatus(INVALID))
            return INVALID;
        return VALID;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} status
     * @return {?}
     */
    AbstractControl.prototype._anyControlsHaveStatus = /**
     * \@internal
     * @param {?} status
     * @return {?}
     */
    function (status) {
        return this._anyControls(function (control) { return control.status === status; });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._anyControlsDirty = /**
     * \@internal
     * @return {?}
     */
    function () {
        return this._anyControls(function (control) { return control.dirty; });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._anyControlsTouched = /**
     * \@internal
     * @return {?}
     */
    function () {
        return this._anyControls(function (control) { return control.touched; });
    };
    /** @internal */
    /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype._updatePristine = /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).pristine = !this._anyControlsDirty();
        if (this._parent && !opts.onlySelf) {
            this._parent._updatePristine(opts);
        }
    };
    /** @internal */
    /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype._updateTouched = /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (opts === void 0) { opts = {}; }
        (/** @type {?} */ (this)).touched = this._anyControlsTouched();
        if (this._parent && !opts.onlySelf) {
            this._parent._updateTouched(opts);
        }
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} formState
     * @return {?}
     */
    AbstractControl.prototype._isBoxedValue = /**
     * \@internal
     * @param {?} formState
     * @return {?}
     */
    function (formState) {
        return typeof formState === 'object' && formState !== null &&
            Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} fn
     * @return {?}
     */
    AbstractControl.prototype._registerOnCollectionChange = /**
     * \@internal
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onCollectionChange = fn; };
    /** @internal */
    /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    AbstractControl.prototype._setUpdateStrategy = /**
     * \@internal
     * @param {?=} opts
     * @return {?}
     */
    function (opts) {
        if (isOptionsObj(opts) && (/** @type {?} */ (opts)).updateOn != null) {
            this._updateOn = /** @type {?} */ (((/** @type {?} */ (opts)).updateOn));
        }
    };
    return AbstractControl;
}());
/**
 * \@whatItDoes Tracks the value and validation status of an individual form control.
 *
 * It is one of the three fundamental building blocks of Angular forms, along with
 * {\@link FormGroup} and {\@link FormArray}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormControl}, you can pass in an initial value as the
 * first argument. Example:
 *
 * ```ts
 * const ctrl = new FormControl('some value');
 * console.log(ctrl.value);     // 'some value'
 * ```
 *
 * You can also initialize the control with a form state object on instantiation,
 * which includes both the value and whether or not the control is disabled.
 * You can't use the value key without the disabled key; both are required
 * to use this way of initialization.
 *
 * ```ts
 * const ctrl = new FormControl({value: 'n/a', disabled: true});
 * console.log(ctrl.value);     // 'n/a'
 * console.log(ctrl.status);   // 'DISABLED'
 * ```
 *
 * The second {\@link FormControl} argument can accept one of three things:
 * * a sync validator function
 * * an array of sync validator functions
 * * an options object containing validator and/or async validator functions
 *
 * Example of a single sync validator function:
 *
 * ```ts
 * const ctrl = new FormControl('', Validators.required);
 * console.log(ctrl.value);     // ''
 * console.log(ctrl.status);   // 'INVALID'
 * ```
 *
 * Example using options object:
 *
 * ```ts
 * const ctrl = new FormControl('', {
 *    validators: Validators.required,
 *    asyncValidators: myAsyncValidator
 * });
 * ```
 *
 * The options object can also be used to define when the control should update.
 * By default, the value and validity of a control updates whenever the value
 * changes. You can configure it to update on the blur event instead by setting
 * the `updateOn` option to `'blur'`.
 *
 * ```ts
 * const c = new FormControl('', { updateOn: 'blur' });
 * ```
 *
 * You can also set `updateOn` to `'submit'`, which will delay value and validity
 * updates until the parent form of the control fires a submit event.
 *
 * See its superclass, {\@link AbstractControl}, for more properties and methods.
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormControl = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FormControl, _super);
    function FormControl(formState, validatorOrOpts, asyncValidator) {
        if (formState === void 0) { formState = null; }
        var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
        /**
         * \@internal
         */
        _this._onChange = [];
        _this._applyFormState(formState);
        _this._setUpdateStrategy(validatorOrOpts);
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        _this._initObservables();
        return _this;
    }
    /**
     * Set the value of the form control to `value`.
     *
     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
     * and not its parent component. This defaults to false.
     *
     * If `emitEvent` is `true`, this
     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
     * to true (as it falls through to `updateValueAndValidity`).
     *
     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
     * specified.
     *
     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     */
    /**
     * Set the value of the form control to `value`.
     *
     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
     * and not its parent component. This defaults to false.
     *
     * If `emitEvent` is `true`, this
     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
     * to true (as it falls through to `updateValueAndValidity`).
     *
     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
     * specified.
     *
     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.setValue = /**
     * Set the value of the form control to `value`.
     *
     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
     * and not its parent component. This defaults to false.
     *
     * If `emitEvent` is `true`, this
     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
     * to true (as it falls through to `updateValueAndValidity`).
     *
     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
     * specified.
     *
     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        (/** @type {?} */ (this)).value = this._pendingValue = value;
        if (this._onChange.length && options.emitModelToViewChange !== false) {
            this._onChange.forEach(function (changeFn) { return changeFn(_this.value, options.emitViewToModelChange !== false); });
        }
        this.updateValueAndValidity(options);
    };
    /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {@link FormControl#setValue setValue} at this level.
     * It exists for symmetry with {@link FormGroup#patchValue patchValue} on `FormGroups` and
     * `FormArrays`, where it does behave differently.
     */
    /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {\@link FormControl#setValue setValue} at this level.
     * It exists for symmetry with {\@link FormGroup#patchValue patchValue} on `FormGroups` and
     * `FormArrays`, where it does behave differently.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.patchValue = /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {\@link FormControl#setValue setValue} at this level.
     * It exists for symmetry with {\@link FormGroup#patchValue patchValue} on `FormGroups` and
     * `FormArrays`, where it does behave differently.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        if (options === void 0) { options = {}; }
        this.setValue(value, options);
    };
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * You can also reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * Ex:
     *
     * ```ts
     * this.control.reset('Nancy');
     *
     * console.log(this.control.value);  // 'Nancy'
     * ```
     *
     * OR
     *
     * ```
     * this.control.reset({value: 'Nancy', disabled: true});
     *
     * console.log(this.control.value);  // 'Nancy'
     * console.log(this.control.status);  // 'DISABLED'
     * ```
     */
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * You can also reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * Ex:
     *
     * ```ts
     * this.control.reset('Nancy');
     *
     * console.log(this.control.value);  // 'Nancy'
     * ```
     *
     * OR
     *
     * ```
     * this.control.reset({value: 'Nancy', disabled: true});
     *
     * console.log(this.control.value);  // 'Nancy'
     * console.log(this.control.status);  // 'DISABLED'
     * ```
     * @param {?=} formState
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.reset = /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * You can also reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * Ex:
     *
     * ```ts
     * this.control.reset('Nancy');
     *
     * console.log(this.control.value);  // 'Nancy'
     * ```
     *
     * OR
     *
     * ```
     * this.control.reset({value: 'Nancy', disabled: true});
     *
     * console.log(this.control.value);  // 'Nancy'
     * console.log(this.control.status);  // 'DISABLED'
     * ```
     * @param {?=} formState
     * @param {?=} options
     * @return {?}
     */
    function (formState, options) {
        if (formState === void 0) { formState = null; }
        if (options === void 0) { options = {}; }
        this._applyFormState(formState);
        this.markAsPristine(options);
        this.markAsUntouched(options);
        this.setValue(this.value, options);
        this._pendingChange = false;
    };
    /**
     * @internal
     */
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._updateValue = /**
     * \@internal
     * @return {?}
     */
    function () { };
    /**
     * @internal
     */
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormControl.prototype._anyControls = /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    function (condition) { return false; };
    /**
     * @internal
     */
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._allControlsDisabled = /**
     * \@internal
     * @return {?}
     */
    function () { return this.disabled; };
    /**
     * Register a listener for change events.
     */
    /**
     * Register a listener for change events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnChange = /**
     * Register a listener for change events.
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onChange.push(fn); };
    /**
     * @internal
     */
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._clearChangeFns = /**
     * \@internal
     * @return {?}
     */
    function () {
        this._onChange = [];
        this._onDisabledChange = [];
        this._onCollectionChange = function () { };
    };
    /**
     * Register a listener for disabled events.
     */
    /**
     * Register a listener for disabled events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnDisabledChange = /**
     * Register a listener for disabled events.
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this._onDisabledChange.push(fn);
    };
    /**
     * @internal
     */
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormControl.prototype._forEachChild = /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    function (cb) { };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._syncPendingControls = /**
     * \@internal
     * @return {?}
     */
    function () {
        if (this.updateOn === 'submit') {
            if (this._pendingDirty)
                this.markAsDirty();
            if (this._pendingTouched)
                this.markAsTouched();
            if (this._pendingChange) {
                this.setValue(this._pendingValue, { onlySelf: true, emitModelToViewChange: false });
                return true;
            }
        }
        return false;
    };
    /**
     * @param {?} formState
     * @return {?}
     */
    FormControl.prototype._applyFormState = /**
     * @param {?} formState
     * @return {?}
     */
    function (formState) {
        if (this._isBoxedValue(formState)) {
            (/** @type {?} */ (this)).value = this._pendingValue = formState.value;
            formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
                this.enable({ onlySelf: true, emitEvent: false });
        }
        else {
            (/** @type {?} */ (this)).value = this._pendingValue = formState;
        }
    };
    return FormControl;
}(AbstractControl));
/**
 * \@whatItDoes Tracks the value and validity state of a group of {\@link FormControl}
 * instances.
 *
 * A `FormGroup` aggregates the values of each child {\@link FormControl} into one object,
 * with each control name as the key.  It calculates its status by reducing the statuses
 * of its children. For example, if one of the controls in a group is invalid, the entire
 * group becomes invalid.
 *
 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {\@link FormControl} and {\@link FormArray}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormGroup}, pass in a collection of child controls as the first
 * argument. The key for each child will be the name under which it is registered.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   first: new FormControl('Nancy', Validators.minLength(2)),
 *   last: new FormControl('Drew'),
 * });
 *
 * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
 * console.log(form.status);  // 'VALID'
 * ```
 *
 * You can also include group-level validators as the second arg, or group-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   password: new FormControl('', Validators.minLength(2)),
 *   passwordConfirm: new FormControl('', Validators.minLength(2)),
 * }, passwordMatchValidator);
 *
 *
 * function passwordMatchValidator(g: FormGroup) {
 *    return g.get('password').value === g.get('passwordConfirm').value
 *       ? null : {'mismatch': true};
 * }
 * ```
 *
 * Like {\@link FormControl} instances, you can alternatively choose to pass in
 * validators and async validators as part of an options object.
 *
 * ```
 * const form = new FormGroup({
 *   password: new FormControl('')
 *   passwordConfirm: new FormControl('')
 * }, {validators: passwordMatchValidator, asyncValidators: otherValidator});
 * ```
 *
 * The options object can also be used to set a default value for each child
 * control's `updateOn` property. If you set `updateOn` to `'blur'` at the
 * group level, all child controls will default to 'blur', unless the child
 * has explicitly specified a different `updateOn` value.
 *
 * ```ts
 * const c = new FormGroup({
 *    one: new FormControl()
 * }, {updateOn: 'blur'});
 * ```
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormGroup = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FormGroup, _super);
    function FormGroup(controls, validatorOrOpts, asyncValidator) {
        var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
        _this.controls = controls;
        _this._initObservables();
        _this._setUpdateStrategy(validatorOrOpts);
        _this._setUpControls();
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return _this;
    }
    /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update the value or validity of the control, so for most cases you'll want
     * to use {@link FormGroup#addControl addControl} instead.
     */
    /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update the value or validity of the control, so for most cases you'll want
     * to use {\@link FormGroup#addControl addControl} instead.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.registerControl = /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update the value or validity of the control, so for most cases you'll want
     * to use {\@link FormGroup#addControl addControl} instead.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    function (name, control) {
        if (this.controls[name])
            return this.controls[name];
        this.controls[name] = control;
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
        return control;
    };
    /**
     * Add a control to this group.
     */
    /**
     * Add a control to this group.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.addControl = /**
     * Add a control to this group.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    function (name, control) {
        this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove a control from this group.
     */
    /**
     * Remove a control from this group.
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype.removeControl = /**
     * Remove a control from this group.
     * @param {?} name
     * @return {?}
     */
    function (name) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     */
    /**
     * Replace an existing control.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.setControl = /**
     * Replace an existing control.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    function (name, control) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        if (control)
            this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * It will return false for disabled controls. If you'd like to check for existence in the group
     * only, use {@link AbstractControl#get get} instead.
     */
    /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * It will return false for disabled controls. If you'd like to check for existence in the group
     * only, use {\@link AbstractControl#get get} instead.
     * @param {?} controlName
     * @return {?}
     */
    FormGroup.prototype.contains = /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * It will return false for disabled controls. If you'd like to check for existence in the group
     * only, use {\@link AbstractControl#get get} instead.
     * @param {?} controlName
     * @return {?}
     */
    function (controlName) {
        return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
    };
    /**
     *  Sets the value of the {@link FormGroup}. It accepts an object that matches
     *  the structure of the group, with control names as keys.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.setValue({first: 'Nancy', last: 'Drew'});
     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     *
     *  ```
     */
    /**
     *  Sets the value of the {\@link FormGroup}. It accepts an object that matches
     *  the structure of the group, with control names as keys.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.setValue({first: 'Nancy', last: 'Drew'});
     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     *
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormGroup.prototype.setValue = /**
     *  Sets the value of the {\@link FormGroup}. It accepts an object that matches
     *  the structure of the group, with control names as keys.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.setValue({first: 'Nancy', last: 'Drew'});
     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     *
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this._checkAllValuesPresent(value);
        Object.keys(value).forEach(function (name) {
            _this._throwIfControlMissing(name);
            _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
    };
    /**
     *  Patches the value of the {@link FormGroup}. It accepts an object with control
     *  names as keys, and will do its best to match the values to the correct controls
     *  in the group.
     *
     *  It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.patchValue({first: 'Nancy'});
     *  console.log(form.value);   // {first: 'Nancy', last: null}
     *
     *  ```
     */
    /**
     *  Patches the value of the {\@link FormGroup}. It accepts an object with control
     *  names as keys, and will do its best to match the values to the correct controls
     *  in the group.
     *
     *  It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.patchValue({first: 'Nancy'});
     *  console.log(form.value);   // {first: 'Nancy', last: null}
     *
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormGroup.prototype.patchValue = /**
     *  Patches the value of the {\@link FormGroup}. It accepts an object with control
     *  names as keys, and will do its best to match the values to the correct controls
     *  in the group.
     *
     *  It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.patchValue({first: 'Nancy'});
     *  console.log(form.value);   // {first: 'Nancy', last: null}
     *
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        Object.keys(value).forEach(function (name) {
            if (_this.controls[name]) {
                _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
            }
        });
        this.updateValueAndValidity(options);
    };
    /**
     * Resets the {@link FormGroup}. This means by default:
     *
     * * The group and all descendants are marked `pristine`
     * * The group and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * can be a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * ### Example
     *
     * ```ts
     * this.form.reset({first: 'name', last: 'last name'});
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * - OR -
     *
     * ```
     * this.form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     */
    /**
     * Resets the {\@link FormGroup}. This means by default:
     *
     * * The group and all descendants are marked `pristine`
     * * The group and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * can be a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * ### Example
     *
     * ```ts
     * this.form.reset({first: 'name', last: 'last name'});
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * - OR -
     *
     * ```
     * this.form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    FormGroup.prototype.reset = /**
     * Resets the {\@link FormGroup}. This means by default:
     *
     * * The group and all descendants are marked `pristine`
     * * The group and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * can be a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * ### Example
     *
     * ```ts
     * this.form.reset({first: 'name', last: 'last name'});
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * - OR -
     *
     * ```
     * this.form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        if (value === void 0) { value = {}; }
        if (options === void 0) { options = {}; }
        this._forEachChild(function (control, name) {
            control.reset(value[name], { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
        this._updatePristine(options);
        this._updateTouched(options);
    };
    /**
     * The aggregate value of the {@link FormGroup}, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the group.
     */
    /**
     * The aggregate value of the {\@link FormGroup}, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the group.
     * @return {?}
     */
    FormGroup.prototype.getRawValue = /**
     * The aggregate value of the {\@link FormGroup}, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the group.
     * @return {?}
     */
    function () {
        return this._reduceChildren({}, function (acc, control, name) {
            acc[name] = control instanceof FormControl ? control.value : (/** @type {?} */ (control)).getRawValue();
            return acc;
        });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._syncPendingControls = /**
     * \@internal
     * @return {?}
     */
    function () {
        var /** @type {?} */ subtreeUpdated = this._reduceChildren(false, function (updated, child) {
            return child._syncPendingControls() ? true : updated;
        });
        if (subtreeUpdated)
            this.updateValueAndValidity({ onlySelf: true });
        return subtreeUpdated;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype._throwIfControlMissing = /**
     * \@internal
     * @param {?} name
     * @return {?}
     */
    function (name) {
        if (!Object.keys(this.controls).length) {
            throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.controls[name]) {
            throw new Error("Cannot find form control with name: " + name + ".");
        }
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormGroup.prototype._forEachChild = /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    function (cb) {
        var _this = this;
        Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._setUpControls = /**
     * \@internal
     * @return {?}
     */
    function () {
        var _this = this;
        this._forEachChild(function (control) {
            control.setParent(_this);
            control._registerOnCollectionChange(_this._onCollectionChange);
        });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._updateValue = /**
     * \@internal
     * @return {?}
     */
    function () { (/** @type {?} */ (this)).value = this._reduceValue(); };
    /** @internal */
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormGroup.prototype._anyControls = /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    function (condition) {
        var _this = this;
        var /** @type {?} */ res = false;
        this._forEachChild(function (control, name) {
            res = res || (_this.contains(name) && condition(control));
        });
        return res;
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._reduceValue = /**
     * \@internal
     * @return {?}
     */
    function () {
        var _this = this;
        return this._reduceChildren({}, function (acc, control, name) {
            if (control.enabled || _this.disabled) {
                acc[name] = control.value;
            }
            return acc;
        });
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} initValue
     * @param {?} fn
     * @return {?}
     */
    FormGroup.prototype._reduceChildren = /**
     * \@internal
     * @param {?} initValue
     * @param {?} fn
     * @return {?}
     */
    function (initValue, fn) {
        var /** @type {?} */ res = initValue;
        this._forEachChild(function (control, name) { res = fn(res, control, name); });
        return res;
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._allControlsDisabled = /**
     * \@internal
     * @return {?}
     */
    function () {
        for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
            var controlName = _a[_i];
            if (this.controls[controlName].enabled) {
                return false;
            }
        }
        return Object.keys(this.controls).length > 0 || this.disabled;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    FormGroup.prototype._checkAllValuesPresent = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._forEachChild(function (control, name) {
            if (value[name] === undefined) {
                throw new Error("Must supply a value for form control with name: '" + name + "'.");
            }
        });
    };
    return FormGroup;
}(AbstractControl));
/**
 * \@whatItDoes Tracks the value and validity state of an array of {\@link FormControl},
 * {\@link FormGroup} or {\@link FormArray} instances.
 *
 * A `FormArray` aggregates the values of each child {\@link FormControl} into an array.
 * It calculates its status by reducing the statuses of its children. For example, if one of
 * the controls in a `FormArray` is invalid, the entire array becomes invalid.
 *
 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {\@link FormControl} and {\@link FormGroup}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormArray}, pass in an array of child controls as the first
 * argument.
 *
 * ### Example
 *
 * ```
 * const arr = new FormArray([
 *   new FormControl('Nancy', Validators.minLength(2)),
 *   new FormControl('Drew'),
 * ]);
 *
 * console.log(arr.value);   // ['Nancy', 'Drew']
 * console.log(arr.status);  // 'VALID'
 * ```
 *
 * You can also include array-level validators and async validators. These come in handy
 * when you want to perform validation that considers the value of more than one child
 * control.
 *
 * The two types of validators can be passed in separately as the second and third arg
 * respectively, or together as part of an options object.
 *
 * ```
 * const arr = new FormArray([
 *   new FormControl('Nancy'),
 *   new FormControl('Drew')
 * ], {validators: myValidator, asyncValidators: myAsyncValidator});
 * ```
 *
 * The options object can also be used to set a default value for each child
 * control's `updateOn` property. If you set `updateOn` to `'blur'` at the
 * array level, all child controls will default to 'blur', unless the child
 * has explicitly specified a different `updateOn` value.
 *
 * ```ts
 * const c = new FormArray([
 *    new FormControl()
 * ], {updateOn: 'blur'});
 * ```
 *
 * ### Adding or removing controls
 *
 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
 * the `FormArray` directly, as that will result in strange and unexpected behavior such
 * as broken change detection.
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormArray = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FormArray, _super);
    function FormArray(controls, validatorOrOpts, asyncValidator) {
        var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
        _this.controls = controls;
        _this._initObservables();
        _this._setUpdateStrategy(validatorOrOpts);
        _this._setUpControls();
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return _this;
    }
    /**
     * Get the {@link AbstractControl} at the given `index` in the array.
     */
    /**
     * Get the {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.at = /**
     * Get the {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    function (index) { return this.controls[index]; };
    /**
     * Insert a new {@link AbstractControl} at the end of the array.
     */
    /**
     * Insert a new {\@link AbstractControl} at the end of the array.
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.push = /**
     * Insert a new {\@link AbstractControl} at the end of the array.
     * @param {?} control
     * @return {?}
     */
    function (control) {
        this.controls.push(control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /** Insert a new {@link AbstractControl} at the given `index` in the array. */
    /**
     * Insert a new {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.insert = /**
     * Insert a new {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    function (index, control) {
        this.controls.splice(index, 0, control);
        this._registerControl(control);
        this.updateValueAndValidity();
    };
    /** Remove the control at the given `index` in the array. */
    /**
     * Remove the control at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.removeAt = /**
     * Remove the control at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    function (index) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        this.updateValueAndValidity();
    };
    /**
     * Replace an existing control.
     */
    /**
     * Replace an existing control.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.setControl = /**
     * Replace an existing control.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    function (index, control) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        if (control) {
            this.controls.splice(index, 0, control);
            this._registerControl(control);
        }
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    Object.defineProperty(FormArray.prototype, "length", {
        /**
         * Length of the control array.
         */
        get: /**
         * Length of the control array.
         * @return {?}
         */
        function () { return this.controls.length; },
        enumerable: true,
        configurable: true
    });
    /**
     *  Sets the value of the {@link FormArray}. It accepts an array that matches
     *  the structure of the control.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.setValue(['Nancy', 'Drew']);
     *  console.log(arr.value);   // ['Nancy', 'Drew']
     *  ```
     */
    /**
     *  Sets the value of the {\@link FormArray}. It accepts an array that matches
     *  the structure of the control.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.setValue(['Nancy', 'Drew']);
     *  console.log(arr.value);   // ['Nancy', 'Drew']
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormArray.prototype.setValue = /**
     *  Sets the value of the {\@link FormArray}. It accepts an array that matches
     *  the structure of the control.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.setValue(['Nancy', 'Drew']);
     *  console.log(arr.value);   // ['Nancy', 'Drew']
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this._checkAllValuesPresent(value);
        value.forEach(function (newValue, index) {
            _this._throwIfControlMissing(index);
            _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
    };
    /**
     *  Patches the value of the {@link FormArray}. It accepts an array that matches the
     *  structure of the control, and will do its best to match the values to the correct
     *  controls in the group.
     *
     *  It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.patchValue(['Nancy']);
     *  console.log(arr.value);   // ['Nancy', null]
     *  ```
     */
    /**
     *  Patches the value of the {\@link FormArray}. It accepts an array that matches the
     *  structure of the control, and will do its best to match the values to the correct
     *  controls in the group.
     *
     *  It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.patchValue(['Nancy']);
     *  console.log(arr.value);   // ['Nancy', null]
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormArray.prototype.patchValue = /**
     *  Patches the value of the {\@link FormArray}. It accepts an array that matches the
     *  structure of the control, and will do its best to match the values to the correct
     *  controls in the group.
     *
     *  It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.patchValue(['Nancy']);
     *  console.log(arr.value);   // ['Nancy', null]
     *  ```
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        value.forEach(function (newValue, index) {
            if (_this.at(index)) {
                _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
            }
        });
        this.updateValueAndValidity(options);
    };
    /**
     * Resets the {@link FormArray}. This means by default:
     *
     * * The array and all descendants are marked `pristine`
     * * The array and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state can be a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * ### Example
     *
     * ```ts
     * this.arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * - OR -
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     */
    /**
     * Resets the {\@link FormArray}. This means by default:
     *
     * * The array and all descendants are marked `pristine`
     * * The array and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state can be a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * ### Example
     *
     * ```ts
     * this.arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * - OR -
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    FormArray.prototype.reset = /**
     * Resets the {\@link FormArray}. This means by default:
     *
     * * The array and all descendants are marked `pristine`
     * * The array and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state can be a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * ### Example
     *
     * ```ts
     * this.arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * - OR -
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    function (value, options) {
        if (value === void 0) { value = []; }
        if (options === void 0) { options = {}; }
        this._forEachChild(function (control, index) {
            control.reset(value[index], { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
        this._updatePristine(options);
        this._updateTouched(options);
    };
    /**
     * The aggregate value of the array, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the array.
     */
    /**
     * The aggregate value of the array, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the array.
     * @return {?}
     */
    FormArray.prototype.getRawValue = /**
     * The aggregate value of the array, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the array.
     * @return {?}
     */
    function () {
        return this.controls.map(function (control) {
            return control instanceof FormControl ? control.value : (/** @type {?} */ (control)).getRawValue();
        });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._syncPendingControls = /**
     * \@internal
     * @return {?}
     */
    function () {
        var /** @type {?} */ subtreeUpdated = this.controls.reduce(function (updated, child) {
            return child._syncPendingControls() ? true : updated;
        }, false);
        if (subtreeUpdated)
            this.updateValueAndValidity({ onlySelf: true });
        return subtreeUpdated;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype._throwIfControlMissing = /**
     * \@internal
     * @param {?} index
     * @return {?}
     */
    function (index) {
        if (!this.controls.length) {
            throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.at(index)) {
            throw new Error("Cannot find form control at index " + index);
        }
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormArray.prototype._forEachChild = /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    function (cb) {
        this.controls.forEach(function (control, index) { cb(control, index); });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._updateValue = /**
     * \@internal
     * @return {?}
     */
    function () {
        var _this = this;
        (/** @type {?} */ (this)).value =
            this.controls.filter(function (control) { return control.enabled || _this.disabled; })
                .map(function (control) { return control.value; });
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormArray.prototype._anyControls = /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    function (condition) {
        return this.controls.some(function (control) { return control.enabled && condition(control); });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._setUpControls = /**
     * \@internal
     * @return {?}
     */
    function () {
        var _this = this;
        this._forEachChild(function (control) { return _this._registerControl(control); });
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    FormArray.prototype._checkAllValuesPresent = /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._forEachChild(function (control, i) {
            if (value[i] === undefined) {
                throw new Error("Must supply a value for form control at index: " + i + ".");
            }
        });
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._allControlsDisabled = /**
     * \@internal
     * @return {?}
     */
    function () {
        for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
            var control = _a[_i];
            if (control.enabled)
                return false;
        }
        return this.controls.length > 0 || this.disabled;
    };
    /**
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype._registerControl = /**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
    };
    return FormArray;
}(AbstractControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formDirectiveProvider = {
    provide: ControlContainer,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgForm; })
};
var resolvedPromise = Promise.resolve(null);
/**
 * \@whatItDoes Creates a top-level {\@link FormGroup} instance and binds it to a form
 * to track aggregate form value and validation status.
 *
 * \@howToUse
 *
 * As soon as you import the `FormsModule`, this directive becomes active by default on
 * all `<form>` tags.  You don't need to add a special selector.
 *
 * You can export the directive into a local template variable using `ngForm` as the key
 * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
 * {\@link FormGroup} instance are duplicated on the directive itself, so a reference to it
 * will give you access to the aggregate value and validity status of the form, as well as
 * user interaction properties like `dirty` and `touched`.
 *
 * To register child controls with the form, you'll want to use {\@link NgModel} with a
 * `name` attribute.  You can also use {\@link NgModelGroup} if you'd like to create
 * sub-groups within the form.
 *
 * You can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * In template driven forms, all `<form>` tags are automatically tagged as `NgForm`.
 * If you want to import the `FormsModule` but skip its usage in some forms,
 * for example, to use native HTML5 validation, you can add `ngNoForm` and the `<form>`
 * tags won't create an `NgForm` directive. In reactive forms, using `ngNoForm` is
 * unnecessary because the `<form>` tags are inert. In that case, you would
 * refrain from using the `formGroup` directive.
 *
 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 *  \@stable
 */
var NgForm = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(NgForm, _super);
    function NgForm(validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this.submitted = false;
        _this._directives = [];
        _this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this.form =
            new FormGroup({}, composeValidators(validators), composeAsyncValidators(asyncValidators));
        return _this;
    }
    /**
     * @return {?}
     */
    NgForm.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () { this._setUpdateStrategy(); };
    Object.defineProperty(NgForm.prototype, "formDirective", {
        get: /**
         * @return {?}
         */
        function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "control", {
        get: /**
         * @return {?}
         */
        function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "path", {
        get: /**
         * @return {?}
         */
        function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "controls", {
        get: /**
         * @return {?}
         */
        function () { return this.form.controls; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addControl = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            (/** @type {?} */ (dir)).control = /** @type {?} */ (container.registerControl(dir.name, dir.control));
            setUpControl(dir.control, dir);
            dir.control.updateValueAndValidity({ emitEvent: false });
            _this._directives.push(dir);
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getControl = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeControl = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
            removeDir(_this._directives, dir);
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addFormGroup = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            var /** @type {?} */ group = new FormGroup({});
            setUpFormContainer(group, dir);
            container.registerControl(dir.name, group);
            group.updateValueAndValidity({ emitEvent: false });
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeFormGroup = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getFormGroup = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.updateModel = /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    function (dir, value) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ ctrl = /** @type {?} */ (_this.form.get(/** @type {?} */ ((dir.path))));
            ctrl.setValue(value);
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.setValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) { this.control.setValue(value); };
    /**
     * @param {?} $event
     * @return {?}
     */
    NgForm.prototype.onSubmit = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        (/** @type {?} */ (this)).submitted = true;
        syncPendingControls(this.form, this._directives);
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    NgForm.prototype.onReset = /**
     * @return {?}
     */
    function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    NgForm.prototype.resetForm = /**
     * @param {?=} value
     * @return {?}
     */
    function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        (/** @type {?} */ (this)).submitted = false;
    };
    /**
     * @return {?}
     */
    NgForm.prototype._setUpdateStrategy = /**
     * @return {?}
     */
    function () {
        if (this.options && this.options.updateOn != null) {
            this.form._updateOn = this.options.updateOn;
        }
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} path
     * @return {?}
     */
    NgForm.prototype._findContainer = /**
     * \@internal
     * @param {?} path
     * @return {?}
     */
    function (path) {
        path.pop();
        return path.length ? /** @type {?} */ (this.form.get(path)) : this.form;
    };
    NgForm.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
                    providers: [formDirectiveProvider],
                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                    outputs: ['ngSubmit'],
                    exportAs: 'ngForm'
                },] },
    ];
    /** @nocollapse */
    NgForm.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    ]; };
    NgForm.propDecorators = {
        "options": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngFormOptions',] },],
    };
    return NgForm;
}(ControlContainer));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var FormErrorExamples = {
    formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
    formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
    formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; index as i\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
    ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
    ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var TemplateDrivenErrors = /** @class */ (function () {
    function TemplateDrivenErrors() {
    }
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelParentException = /**
     * @return {?}
     */
    function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + FormErrorExamples.formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + FormErrorExamples.ngModelWithFormGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.formGroupNameException = /**
     * @return {?}
     */
    function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.missingNameException = /**
     * @return {?}
     */
    function () {
        throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelGroupParentException = /**
     * @return {?}
     */
    function () {
        throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
    };
    return TemplateDrivenErrors;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var modelGroupProvider = {
    provide: ControlContainer,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgModelGroup; })
};
/**
 * \@whatItDoes Creates and binds a {\@link FormGroup} instance to a DOM element.
 *
 * \@howToUse
 *
 * This directive can only be used as a child of {\@link NgForm} (or in other words,
 * within `<form>` tags).
 *
 * Use this directive if you'd like to create a sub-group within a form. This can
 * come in handy if you want to validate a sub-group of your form separately from
 * the rest of your form, or if some values in your domain model make more sense to
 * consume together in a nested object.
 *
 * Pass in the name you'd like this sub-group to have and it will become the key
 * for the sub-group in the form's full value. You can also export the directive into
 * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
 *
 * {\@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 * \@stable
 */
var NgModelGroup = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(NgModelGroup, _super);
    function NgModelGroup(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    NgModelGroup.prototype._checkParentType = /**
     * \@internal
     * @return {?}
     */
    function () {
        if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
            TemplateDrivenErrors.modelGroupParentException();
        }
    };
    NgModelGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
    ];
    /** @nocollapse */
    NgModelGroup.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    ]; };
    NgModelGroup.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModelGroup',] },],
    };
    return NgModelGroup;
}(AbstractFormGroupDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formControlBinding = {
    provide: NgControl,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgModel; })
};
/**
 * `ngModel` forces an additional change detection run when its inputs change:
 * E.g.:
 * ```
 * <div>{{myModel.valid}}</div>
 * <input [(ngModel)]="myValue" #myModel="ngModel">
 * ```
 * I.e. `ngModel` can export itself on the element and then be used in the template.
 * Normally, this would result in expressions before the `input` that use the exported directive
 * to have and old value as they have been
 * dirty checked before. As this is a very common case for `ngModel`, we added this second change
 * detection run.
 *
 * Notes:
 * - this is just one extra run no matter how many `ngModel` have been changed.
 * - this is a general problem when using `exportAs` for directives!
 */
var resolvedPromise$1 = Promise.resolve(null);
/**
 * \@whatItDoes Creates a {\@link FormControl} instance from a domain model and binds it
 * to a form control element.
 *
 * The {\@link FormControl} instance will track the value, user interaction, and
 * validation status of the control and keep the view synced with the model. If used
 * within a parent form, the directive will also register itself with the form as a child
 * control.
 *
 * \@howToUse
 *
 * This directive can be used by itself or as part of a larger form. All you need is the
 * `ngModel` selector to activate it.
 *
 * It accepts a domain model as an optional {\@link Input}. If you have a one-way binding
 * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
 * class will set the value in the view. If you have a two-way binding with `[()]` syntax
 * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
 * the domain model in your class as well.
 *
 * If you wish to inspect the properties of the associated {\@link FormControl} (like
 * validity state), you can also export the directive into a local template variable using
 * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
 * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
 * will fall through to the control anyway, so you can access them directly. You can see a
 * full list of properties directly available in {\@link AbstractControlDirective}.
 *
 * The following is an example of a simple standalone control using `ngModel`:
 *
 * {\@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
 *
 * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
 * so that the control can be registered with the parent form under that name.
 *
 * It's worth noting that in the context of a parent form, you often can skip one-way or
 * two-way binding because the parent form will sync the value for you. You can access
 * its properties by exporting it into a local template variable using `ngForm` (ex:
 * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
 *
 * If you do need to populate initial values into your form, using a one-way binding for
 * `ngModel` tends to be sufficient as long as you use the exported form's value rather
 * than the domain model's value on submit.
 *
 * Take a look at an example of using `ngModel` within a form:
 *
 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * To see `ngModel` examples with different form control types, see:
 *
 * * Radio buttons: {\@link RadioControlValueAccessor}
 * * Selects: {\@link SelectControlValueAccessor}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: `FormsModule`
 *
 *  \@stable
 */
var NgModel = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(NgModel, _super);
    function NgModel(parent, validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this.control = new FormControl();
        /**
         * \@internal
         */
        _this._registered = false;
        _this.update = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this._parent = parent;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        this._checkForErrors();
        if (!this._registered)
            this._setUpControl();
        if ('isDisabled' in changes) {
            this._updateDisabled(changes);
        }
        if (isPropertyUpdated(changes, this.viewModel)) {
            this._updateValue(this.model);
            this.viewModel = this.model;
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () { this.formDirective && this.formDirective.removeControl(this); };
    Object.defineProperty(NgModel.prototype, "path", {
        get: /**
         * @return {?}
         */
        function () {
            return this._parent ? controlPath(this.name, this._parent) : [this.name];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "formDirective", {
        get: /**
         * @return {?}
         */
        function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "validator", {
        get: /**
         * @return {?}
         */
        function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "asyncValidator", {
        get: /**
         * @return {?}
         */
        function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    NgModel.prototype.viewToModelUpdate = /**
     * @param {?} newValue
     * @return {?}
     */
    function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpControl = /**
     * @return {?}
     */
    function () {
        this._setUpdateStrategy();
        this._isStandalone() ? this._setUpStandalone() :
            this.formDirective.addControl(this);
        this._registered = true;
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpdateStrategy = /**
     * @return {?}
     */
    function () {
        if (this.options && this.options.updateOn != null) {
            this.control._updateOn = this.options.updateOn;
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype._isStandalone = /**
     * @return {?}
     */
    function () {
        return !this._parent || !!(this.options && this.options.standalone);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpStandalone = /**
     * @return {?}
     */
    function () {
        setUpControl(this.control, this);
        this.control.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkForErrors = /**
     * @return {?}
     */
    function () {
        if (!this._isStandalone()) {
            this._checkParentType();
        }
        this._checkName();
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkParentType = /**
     * @return {?}
     */
    function () {
        if (!(this._parent instanceof NgModelGroup) &&
            this._parent instanceof AbstractFormGroupDirective) {
            TemplateDrivenErrors.formGroupNameException();
        }
        else if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
            TemplateDrivenErrors.modelParentException();
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkName = /**
     * @return {?}
     */
    function () {
        if (this.options && this.options.name)
            this.name = this.options.name;
        if (!this._isStandalone() && !this.name) {
            TemplateDrivenErrors.missingNameException();
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgModel.prototype._updateValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        resolvedPromise$1.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype._updateDisabled = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        var _this = this;
        var /** @type {?} */ disabledValue = changes['isDisabled'].currentValue;
        var /** @type {?} */ isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
        resolvedPromise$1.then(function () {
            if (isDisabled && !_this.control.disabled) {
                _this.control.disable();
            }
            else if (!isDisabled && _this.control.disabled) {
                _this.control.enable();
            }
        });
    };
    NgModel.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[ngModel]:not([formControlName]):not([formControl])',
                    providers: [formControlBinding],
                    exportAs: 'ngModel'
                },] },
    ];
    /** @nocollapse */
    NgModel.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
    ]; };
    NgModel.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
        "isDisabled": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['disabled',] },],
        "model": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModel',] },],
        "options": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModelOptions',] },],
        "update": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['ngModelChange',] },],
    };
    return NgModel;
}(NgControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ReactiveErrors = /** @class */ (function () {
    function ReactiveErrors() {
    }
    /**
     * @return {?}
     */
    ReactiveErrors.controlParentException = /**
     * @return {?}
     */
    function () {
        throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.ngModelGroupException = /**
     * @return {?}
     */
    function () {
        throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + FormErrorExamples.formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + FormErrorExamples.ngModelGroup);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.missingFormException = /**
     * @return {?}
     */
    function () {
        throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + FormErrorExamples.formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.groupParentException = /**
     * @return {?}
     */
    function () {
        throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formGroupName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.arrayParentException = /**
     * @return {?}
     */
    function () {
        throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + FormErrorExamples.formArrayName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.disabledAttrWarning = /**
     * @return {?}
     */
    function () {
        console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
    };
    return ReactiveErrors;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formControlBinding$1 = {
    provide: NgControl,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormControlDirective; })
};
/**
 * \@whatItDoes Syncs a standalone {\@link FormControl} instance to a form control element.
 *
 * In other words, this directive ensures that any values written to the {\@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {\@link FormControl} instance (view -> model).
 *
 * \@howToUse
 *
 * Use this directive if you'd like to create and manage a {\@link FormControl} instance directly.
 * Simply create a {\@link FormControl}, save it to your component class, and pass it into the
 * {\@link FormControlDirective}.
 *
 * This directive is designed to be used as a standalone control.  Unlike {\@link FormControlName},
 * it does not require that your {\@link FormControl} instance be part of any parent
 * {\@link FormGroup}, and it won't be registered to any {\@link FormGroupDirective} that
 * exists above it.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormControl} instance. See a full list of available properties in
 * {\@link AbstractControl}.
 *
 * **Set the value**: You can pass in an initial value when instantiating the {\@link FormControl},
 * or you can set it programmatically later using {\@link AbstractControl#setValue setValue} or
 * {\@link AbstractControl#patchValue patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {\@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
 * {\@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {\@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 *  \@stable
 */
var FormControlDirective = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FormControlDirective, _super);
    function FormControlDirective(validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this.update = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
        set: /**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (this._isControlChanged(changes)) {
            setUpControl(this.form, this);
            if (this.control.disabled && /** @type {?} */ ((this.valueAccessor)).setDisabledState) {
                /** @type {?} */ ((/** @type {?} */ ((this.valueAccessor)).setDisabledState))(true);
            }
            this.form.updateValueAndValidity({ emitEvent: false });
        }
        if (isPropertyUpdated(changes, this.viewModel)) {
            this.form.setValue(this.model);
            this.viewModel = this.model;
        }
    };
    Object.defineProperty(FormControlDirective.prototype, "path", {
        get: /**
         * @return {?}
         */
        function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "validator", {
        get: /**
         * @return {?}
         */
        function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
        get: /**
         * @return {?}
         */
        function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "control", {
        get: /**
         * @return {?}
         */
        function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlDirective.prototype.viewToModelUpdate = /**
     * @param {?} newValue
     * @return {?}
     */
    function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype._isControlChanged = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        return changes.hasOwnProperty('form');
    };
    FormControlDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formControl]', providers: [formControlBinding$1], exportAs: 'ngForm' },] },
    ];
    /** @nocollapse */
    FormControlDirective.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
    ]; };
    FormControlDirective.propDecorators = {
        "form": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formControl',] },],
        "model": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModel',] },],
        "update": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['ngModelChange',] },],
        "isDisabled": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['disabled',] },],
    };
    return FormControlDirective;
}(NgControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formDirectiveProvider$1 = {
    provide: ControlContainer,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormGroupDirective; })
};
/**
 * \@whatItDoes Binds an existing {\@link FormGroup} to a DOM element.
 *
 * \@howToUse
 *
 * This directive accepts an existing {\@link FormGroup} instance. It will then use this
 * {\@link FormGroup} instance to match any child {\@link FormControl}, {\@link FormGroup},
 * and {\@link FormArray} instances to child {\@link FormControlName}, {\@link FormGroupName},
 * and {\@link FormArrayName} directives.
 *
 * **Set value**: You can set the form's initial value when instantiating the
 * {\@link FormGroup}, or you can set it programmatically later using the {\@link FormGroup}'s
 * {\@link AbstractControl#setValue setValue} or {\@link AbstractControl#patchValue patchValue}
 * methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
 * to the {\@link FormGroup}'s {\@link AbstractControl#valueChanges valueChanges} event.  You can also
 * listen to its {\@link AbstractControl#statusChanges statusChanges} event to be notified when the
 * validation status is re-calculated.
 *
 * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: {\@link ReactiveFormsModule}
 *
 *  \@stable
 */
var FormGroupDirective = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FormGroupDirective, _super);
    function FormGroupDirective(_validators, _asyncValidators) {
        var _this = _super.call(this) || this;
        _this._validators = _validators;
        _this._asyncValidators = _asyncValidators;
        _this.submitted = false;
        _this.directives = [];
        _this.form = /** @type {?} */ ((null));
        _this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        return _this;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    FormGroupDirective.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        this._checkFormPresent();
        if (changes.hasOwnProperty('form')) {
            this._updateValidators();
            this._updateDomValue();
            this._updateRegistrations();
        }
    };
    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
        get: /**
         * @return {?}
         */
        function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "control", {
        get: /**
         * @return {?}
         */
        function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "path", {
        get: /**
         * @return {?}
         */
        function () { return []; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addControl = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpControl(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
        this.directives.push(dir);
        return ctrl;
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getControl = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeControl = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { removeDir(this.directives, dir); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormGroup = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpFormContainer(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormGroup = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormGroup = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormArray = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpFormContainer(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormArray = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormArray = /**
     * @param {?} dir
     * @return {?}
     */
    function (dir) { return /** @type {?} */ (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    FormGroupDirective.prototype.updateModel = /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    function (dir, value) {
        var /** @type {?} */ ctrl = /** @type {?} */ (this.form.get(dir.path));
        ctrl.setValue(value);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FormGroupDirective.prototype.onSubmit = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        (/** @type {?} */ (this)).submitted = true;
        syncPendingControls(this.form, this.directives);
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype.onReset = /**
     * @return {?}
     */
    function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    FormGroupDirective.prototype.resetForm = /**
     * @param {?=} value
     * @return {?}
     */
    function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        (/** @type {?} */ (this)).submitted = false;
    };
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroupDirective.prototype._updateDomValue = /**
     * \@internal
     * @return {?}
     */
    function () {
        var _this = this;
        this.directives.forEach(function (dir) {
            var /** @type {?} */ newCtrl = _this.form.get(dir.path);
            if (dir.control !== newCtrl) {
                cleanUpControl(dir.control, dir);
                if (newCtrl)
                    setUpControl(newCtrl, dir);
                (/** @type {?} */ (dir)).control = newCtrl;
            }
        });
        this.form._updateTreeValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateRegistrations = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
        if (this._oldForm)
            this._oldForm._registerOnCollectionChange(function () { });
        this._oldForm = this.form;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateValidators = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ sync = composeValidators(this._validators);
        this.form.validator = Validators.compose([/** @type {?} */ ((this.form.validator)), /** @type {?} */ ((sync))]);
        var /** @type {?} */ async = composeAsyncValidators(this._asyncValidators);
        this.form.asyncValidator = Validators.composeAsync([/** @type {?} */ ((this.form.asyncValidator)), /** @type {?} */ ((async))]);
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._checkFormPresent = /**
     * @return {?}
     */
    function () {
        if (!this.form) {
            ReactiveErrors.missingFormException();
        }
    };
    FormGroupDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[formGroup]',
                    providers: [formDirectiveProvider$1],
                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                    exportAs: 'ngForm'
                },] },
    ];
    /** @nocollapse */
    FormGroupDirective.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    ]; };
    FormGroupDirective.propDecorators = {
        "form": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formGroup',] },],
        "ngSubmit": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"] },],
    };
    return FormGroupDirective;
}(ControlContainer));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formGroupNameProvider = {
    provide: ControlContainer,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormGroupName; })
};
/**
 * \@whatItDoes Syncs a nested {\@link FormGroup} to a DOM element.
 *
 * \@howToUse
 *
 * This directive can only be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {\@link FormGroup} you want to link, and
 * will look for a {\@link FormGroup} registered with that name in the parent
 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
 *
 * Nested form groups can come in handy when you want to validate a sub-group of a
 * form separately from the rest or when you'd like to group the values of certain
 * controls into their own nested object.
 *
 * **Access the group**: You can access the associated {\@link FormGroup} using the
 * {\@link AbstractControl#get get} method. Ex: `this.form.get('name')`.
 *
 * You can also access individual controls within the group using dot syntax.
 * Ex: `this.form.get('name.first')`
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormGroup}. See a full list of available properties in {\@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {\@link FormGroup}, or you can set it programmatically later using
 * {\@link AbstractControl#setValue setValue} or {\@link AbstractControl#patchValue patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the group, you can
 * subscribe to the {\@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
 * {\@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {\@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * \@stable
 */
var FormGroupName = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FormGroupName, _super);
    function FormGroupName(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /** @internal */
    /**
     * \@internal
     * @return {?}
     */
    FormGroupName.prototype._checkParentType = /**
     * \@internal
     * @return {?}
     */
    function () {
        if (_hasInvalidParent(this._parent)) {
            ReactiveErrors.groupParentException();
        }
    };
    FormGroupName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
    ];
    /** @nocollapse */
    FormGroupName.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    ]; };
    FormGroupName.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formGroupName',] },],
    };
    return FormGroupName;
}(AbstractFormGroupDirective));
var formArrayNameProvider = {
    provide: ControlContainer,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormArrayName; })
};
/**
 * \@whatItDoes Syncs a nested {\@link FormArray} to a DOM element.
 *
 * \@howToUse
 *
 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {\@link FormArray} you want to link, and
 * will look for a {\@link FormArray} registered with that name in the parent
 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
 *
 * Nested form arrays can come in handy when you have a group of form controls but
 * you're not sure how many there will be. Form arrays allow you to create new
 * form controls dynamically.
 *
 * **Access the array**: You can access the associated {\@link FormArray} using the
 * {\@link AbstractControl#get get} method on the parent {\@link FormGroup}.
 * Ex: `this.form.get('cities')`.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormArray}. See a full list of available properties in {\@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {\@link FormArray}, or you can set the value programmatically later using the
 * {\@link FormArray}'s {\@link AbstractControl#setValue setValue} or
 * {\@link AbstractControl#patchValue patchValue} methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the array, you can
 * subscribe to the {\@link FormArray}'s {\@link AbstractControl#valueChanges valueChanges} event.
 * You can also listen to its {\@link AbstractControl#statusChanges statusChanges} event to be
 * notified when the validation status is re-calculated.
 *
 * **Add new controls**: You can add new controls to the {\@link FormArray} dynamically by calling
 * its {\@link FormArray#push push} method.
 * Ex: `this.form.get('cities').push(new FormControl());`
 *
 * ### Example
 *
 * {\@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * \@stable
 */
var FormArrayName = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FormArrayName, _super);
    function FormArrayName(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this._checkParentType(); /** @type {?} */
        ((this.formDirective)).addFormArray(this);
    };
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.formDirective) {
            this.formDirective.removeFormArray(this);
        }
    };
    Object.defineProperty(FormArrayName.prototype, "control", {
        get: /**
         * @return {?}
         */
        function () { return /** @type {?} */ ((this.formDirective)).getFormArray(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "formDirective", {
        get: /**
         * @return {?}
         */
        function () {
            return this._parent ? /** @type {?} */ (this._parent.formDirective) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "path", {
        get: /**
         * @return {?}
         */
        function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "validator", {
        get: /**
         * @return {?}
         */
        function () { return composeValidators(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
        get: /**
         * @return {?}
         */
        function () {
            return composeAsyncValidators(this._asyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormArrayName.prototype._checkParentType = /**
     * @return {?}
     */
    function () {
        if (_hasInvalidParent(this._parent)) {
            ReactiveErrors.arrayParentException();
        }
    };
    FormArrayName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
    ];
    /** @nocollapse */
    FormArrayName.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    ]; };
    FormArrayName.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formArrayName',] },],
    };
    return FormArrayName;
}(ControlContainer));
/**
 * @param {?} parent
 * @return {?}
 */
function _hasInvalidParent(parent) {
    return !(parent instanceof FormGroupName) && !(parent instanceof FormGroupDirective) &&
        !(parent instanceof FormArrayName);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var controlNameBinding = {
    provide: NgControl,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormControlName; })
};
/**
 * \@whatItDoes Syncs a {\@link FormControl} in an existing {\@link FormGroup} to a form control
 * element by name.
 *
 * In other words, this directive ensures that any values written to the {\@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {\@link FormControl} instance (view -> model).
 *
 * \@howToUse
 *
 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the {\@link FormControl} instance you want to
 * link, and will look for a {\@link FormControl} registered with that name in the
 * closest {\@link FormGroup} or {\@link FormArray} above it.
 *
 * **Access the control**: You can access the {\@link FormControl} associated with
 * this directive by using the {\@link AbstractControl#get get} method.
 * Ex: `this.form.get('first');`
 *
 * **Get value**: the `value` property is always synced and available on the {\@link FormControl}.
 * See a full list of available properties in {\@link AbstractControl}.
 *
 *  **Set value**: You can set an initial value for the control when instantiating the
 *  {\@link FormControl}, or you can set it programmatically later using
 *  {\@link AbstractControl#setValue setValue} or {\@link AbstractControl#patchValue patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {\@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
 * {\@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * To see `formControlName` examples with different form control types, see:
 *
 * * Radio buttons: {\@link RadioControlValueAccessor}
 * * Selects: {\@link SelectControlValueAccessor}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: {\@link ReactiveFormsModule}
 *
 *  \@stable
 */
var FormControlName = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FormControlName, _super);
    function FormControlName(parent, validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this._added = false;
        _this.update = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this._parent = parent;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    Object.defineProperty(FormControlName.prototype, "isDisabled", {
        set: /**
         * @param {?} isDisabled
         * @return {?}
         */
        function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlName.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (!this._added)
            this._setUpControl();
        if (isPropertyUpdated(changes, this.viewModel)) {
            this.viewModel = this.model;
            this.formDirective.updateModel(this, this.model);
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.formDirective) {
            this.formDirective.removeControl(this);
        }
    };
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlName.prototype.viewToModelUpdate = /**
     * @param {?} newValue
     * @return {?}
     */
    function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    Object.defineProperty(FormControlName.prototype, "path", {
        get: /**
         * @return {?}
         */
        function () { return controlPath(this.name, /** @type {?} */ ((this._parent))); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "formDirective", {
        get: /**
         * @return {?}
         */
        function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "validator", {
        get: /**
         * @return {?}
         */
        function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
        get: /**
         * @return {?}
         */
        function () {
            return /** @type {?} */ ((composeAsyncValidators(this._rawAsyncValidators)));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormControlName.prototype._checkParentType = /**
     * @return {?}
     */
    function () {
        if (!(this._parent instanceof FormGroupName) &&
            this._parent instanceof AbstractFormGroupDirective) {
            ReactiveErrors.ngModelGroupException();
        }
        else if (!(this._parent instanceof FormGroupName) && !(this._parent instanceof FormGroupDirective) &&
            !(this._parent instanceof FormArrayName)) {
            ReactiveErrors.controlParentException();
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype._setUpControl = /**
     * @return {?}
     */
    function () {
        this._checkParentType();
        (/** @type {?} */ (this)).control = this.formDirective.addControl(this);
        if (this.control.disabled && /** @type {?} */ ((this.valueAccessor)).setDisabledState) {
            /** @type {?} */ ((/** @type {?} */ ((this.valueAccessor)).setDisabledState))(true);
        }
        this._added = true;
    };
    FormControlName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
    ];
    /** @nocollapse */
    FormControlName.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
    ]; };
    FormControlName.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['formControlName',] },],
        "model": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['ngModel',] },],
        "update": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['ngModelChange',] },],
        "isDisabled": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['disabled',] },],
    };
    return FormControlName;
}(NgControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An interface that can be implemented by classes that can act as validators.
 *
 * ## Usage
 *
 * ```typescript
 * \@Directive({
 *   selector: '[custom-validator]',
 *   providers: [{provide: NG_VALIDATORS, useExisting: CustomValidatorDirective, multi: true}]
 * })
 * class CustomValidatorDirective implements Validator {
 *   validate(c: Control): {[key: string]: any} {
 *     return {"custom": true};
 *   }
 * }
 * ```
 *
 * \@stable
 * @record
 */

/**
 * \@experimental
 * @record
 */

var REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return RequiredValidator; }),
    multi: true
};
var CHECKBOX_REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return CheckboxRequiredValidator; }),
    multi: true
};
/**
 * A Directive that adds the `required` validator to any controls marked with the
 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input name="fullName" ngModel required>
 * ```
 *
 * \@stable
 */
var RequiredValidator = /** @class */ (function () {
    function RequiredValidator() {
    }
    Object.defineProperty(RequiredValidator.prototype, "required", {
        get: /**
         * @return {?}
         */
        function () { return this._required; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._required = value != null && value !== false && "" + value !== 'false';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} c
     * @return {?}
     */
    RequiredValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return this.required ? Validators.required(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RequiredValidator.prototype.registerOnValidatorChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onChange = fn; };
    RequiredValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: ':not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]',
                    providers: [REQUIRED_VALIDATOR],
                    host: { '[attr.required]': 'required ? "" : null' }
                },] },
    ];
    /** @nocollapse */
    RequiredValidator.ctorParameters = function () { return []; };
    RequiredValidator.propDecorators = {
        "required": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return RequiredValidator;
}());
/**
 * A Directive that adds the `required` validator to checkbox controls marked with the
 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input type="checkbox" name="active" ngModel required>
 * ```
 *
 * \@experimental
 */
var CheckboxRequiredValidator = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CheckboxRequiredValidator, _super);
    function CheckboxRequiredValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} c
     * @return {?}
     */
    CheckboxRequiredValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return this.required ? Validators.requiredTrue(c) : null;
    };
    CheckboxRequiredValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'input[type=checkbox][required][formControlName],input[type=checkbox][required][formControl],input[type=checkbox][required][ngModel]',
                    providers: [CHECKBOX_REQUIRED_VALIDATOR],
                    host: { '[attr.required]': 'required ? "" : null' }
                },] },
    ];
    /** @nocollapse */
    CheckboxRequiredValidator.ctorParameters = function () { return []; };
    return CheckboxRequiredValidator;
}(RequiredValidator));
/**
 * Provider which adds {\@link EmailValidator} to {\@link NG_VALIDATORS}.
 */
var EMAIL_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return EmailValidator; }),
    multi: true
};
/**
 * A Directive that adds the `email` validator to controls marked with the
 * `email` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input type="email" name="email" ngModel email>
 * <input type="email" name="email" ngModel email="true">
 * <input type="email" name="email" ngModel [email]="true">
 * ```
 *
 * \@experimental
 */
var EmailValidator = /** @class */ (function () {
    function EmailValidator() {
    }
    Object.defineProperty(EmailValidator.prototype, "email", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._enabled = value === '' || value === true || value === 'true';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} c
     * @return {?}
     */
    EmailValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return this._enabled ? Validators.email(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    EmailValidator.prototype.registerOnValidatorChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onChange = fn; };
    EmailValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[email][formControlName],[email][formControl],[email][ngModel]',
                    providers: [EMAIL_VALIDATOR]
                },] },
    ];
    /** @nocollapse */
    EmailValidator.ctorParameters = function () { return []; };
    EmailValidator.propDecorators = {
        "email": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return EmailValidator;
}());
/**
 * \@stable
 * @record
 */

/**
 * \@stable
 * @record
 */

/**
 * Provider which adds {\@link MinLengthValidator} to {\@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {\@example common/forms/ts/validators/validators.ts region='min'}
 */
var MIN_LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return MinLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {\@link MinLengthValidator} for any `formControlName`,
 * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
 *
 * \@stable
 */
var MinLengthValidator = /** @class */ (function () {
    function MinLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MinLengthValidator.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if ('minlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MinLengthValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return this.minlength == null ? null : this._validator(c);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MinLengthValidator.prototype.registerOnValidatorChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MinLengthValidator.prototype._createValidator = /**
     * @return {?}
     */
    function () {
        this._validator = Validators.minLength(parseInt(this.minlength, 10));
    };
    MinLengthValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
                    providers: [MIN_LENGTH_VALIDATOR],
                    host: { '[attr.minlength]': 'minlength ? minlength : null' }
                },] },
    ];
    /** @nocollapse */
    MinLengthValidator.ctorParameters = function () { return []; };
    MinLengthValidator.propDecorators = {
        "minlength": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return MinLengthValidator;
}());
/**
 * Provider which adds {\@link MaxLengthValidator} to {\@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {\@example common/forms/ts/validators/validators.ts region='max'}
 */
var MAX_LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return MaxLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {\@link MaxLengthValidator} for any `formControlName,
 * `formControl`,
 * or control with `ngModel` that also has a `maxlength` attribute.
 *
 * \@stable
 */
var MaxLengthValidator = /** @class */ (function () {
    function MaxLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MaxLengthValidator.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if ('maxlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MaxLengthValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) {
        return this.maxlength != null ? this._validator(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MaxLengthValidator.prototype.registerOnValidatorChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MaxLengthValidator.prototype._createValidator = /**
     * @return {?}
     */
    function () {
        this._validator = Validators.maxLength(parseInt(this.maxlength, 10));
    };
    MaxLengthValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
                    providers: [MAX_LENGTH_VALIDATOR],
                    host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
                },] },
    ];
    /** @nocollapse */
    MaxLengthValidator.ctorParameters = function () { return []; };
    MaxLengthValidator.propDecorators = {
        "maxlength": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return MaxLengthValidator;
}());
var PATTERN_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return PatternValidator; }),
    multi: true
};
/**
 * A Directive that adds the `pattern` validator to any controls marked with the
 * `pattern` attribute, via the {\@link NG_VALIDATORS} binding. Uses attribute value
 * as the regex to validate Control value against.  Follows pattern attribute
 * semantics; i.e. regex must match entire Control value.
 *
 * ### Example
 *
 * ```
 * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
 * ```
 * \@stable
 */
var PatternValidator = /** @class */ (function () {
    function PatternValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    PatternValidator.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if ('pattern' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    PatternValidator.prototype.validate = /**
     * @param {?} c
     * @return {?}
     */
    function (c) { return this._validator(c); };
    /**
     * @param {?} fn
     * @return {?}
     */
    PatternValidator.prototype.registerOnValidatorChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    PatternValidator.prototype._createValidator = /**
     * @return {?}
     */
    function () { this._validator = Validators.pattern(this.pattern); };
    PatternValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
                    providers: [PATTERN_VALIDATOR],
                    host: { '[attr.pattern]': 'pattern ? pattern : null' }
                },] },
    ];
    /** @nocollapse */
    PatternValidator.ctorParameters = function () { return []; };
    PatternValidator.propDecorators = {
        "pattern": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return PatternValidator;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Creates an {\@link AbstractControl} from a user-specified configuration.
 *
 * It is essentially syntactic sugar that shortens the `new FormGroup()`,
 * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
 * forms.
 *
 * \@howToUse
 *
 * To use, inject `FormBuilder` into your component class. You can then call its methods
 * directly.
 *
 * {\@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
 *
 *  * **npm package**: `\@angular/forms`
 *
 *  * **NgModule**: {\@link ReactiveFormsModule}
 *
 * \@stable
 */
var FormBuilder = /** @class */ (function () {
    function FormBuilder() {
    }
    /**
     * Construct a new {@link FormGroup} with the given map of configuration.
     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
     *
     * See the {@link FormGroup} constructor for more details.
     */
    /**
     * Construct a new {\@link FormGroup} with the given map of configuration.
     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
     *
     * See the {\@link FormGroup} constructor for more details.
     * @param {?} controlsConfig
     * @param {?=} extra
     * @return {?}
     */
    FormBuilder.prototype.group = /**
     * Construct a new {\@link FormGroup} with the given map of configuration.
     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
     *
     * See the {\@link FormGroup} constructor for more details.
     * @param {?} controlsConfig
     * @param {?=} extra
     * @return {?}
     */
    function (controlsConfig, extra) {
        if (extra === void 0) { extra = null; }
        var /** @type {?} */ controls = this._reduceControls(controlsConfig);
        var /** @type {?} */ validator = extra != null ? extra['validator'] : null;
        var /** @type {?} */ asyncValidator = extra != null ? extra['asyncValidator'] : null;
        return new FormGroup(controls, validator, asyncValidator);
    };
    /**
     * Construct a new {@link FormControl} with the given `formState`,`validator`, and
     * `asyncValidator`.
     *
     * `formState` can either be a standalone value for the form control or an object
     * that contains both a value and a disabled status.
     *
     */
    /**
     * Construct a new {\@link FormControl} with the given `formState`,`validator`, and
     * `asyncValidator`.
     *
     * `formState` can either be a standalone value for the form control or an object
     * that contains both a value and a disabled status.
     *
     * @param {?} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.control = /**
     * Construct a new {\@link FormControl} with the given `formState`,`validator`, and
     * `asyncValidator`.
     *
     * `formState` can either be a standalone value for the form control or an object
     * that contains both a value and a disabled status.
     *
     * @param {?} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    function (formState, validator, asyncValidator) {
        return new FormControl(formState, validator, asyncValidator);
    };
    /**
     * Construct a {@link FormArray} from the given `controlsConfig` array of
     * configuration, with the given optional `validator` and `asyncValidator`.
     */
    /**
     * Construct a {\@link FormArray} from the given `controlsConfig` array of
     * configuration, with the given optional `validator` and `asyncValidator`.
     * @param {?} controlsConfig
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.array = /**
     * Construct a {\@link FormArray} from the given `controlsConfig` array of
     * configuration, with the given optional `validator` and `asyncValidator`.
     * @param {?} controlsConfig
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    function (controlsConfig, validator, asyncValidator) {
        var _this = this;
        var /** @type {?} */ controls = controlsConfig.map(function (c) { return _this._createControl(c); });
        return new FormArray(controls, validator, asyncValidator);
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} controlsConfig
     * @return {?}
     */
    FormBuilder.prototype._reduceControls = /**
     * \@internal
     * @param {?} controlsConfig
     * @return {?}
     */
    function (controlsConfig) {
        var _this = this;
        var /** @type {?} */ controls = {};
        Object.keys(controlsConfig).forEach(function (controlName) {
            controls[controlName] = _this._createControl(controlsConfig[controlName]);
        });
        return controls;
    };
    /** @internal */
    /**
     * \@internal
     * @param {?} controlConfig
     * @return {?}
     */
    FormBuilder.prototype._createControl = /**
     * \@internal
     * @param {?} controlConfig
     * @return {?}
     */
    function (controlConfig) {
        if (controlConfig instanceof FormControl || controlConfig instanceof FormGroup ||
            controlConfig instanceof FormArray) {
            return controlConfig;
        }
        else if (Array.isArray(controlConfig)) {
            var /** @type {?} */ value = controlConfig[0];
            var /** @type {?} */ validator = controlConfig.length > 1 ? controlConfig[1] : null;
            var /** @type {?} */ asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
            return this.control(value, validator, asyncValidator);
        }
        else {
            return this.control(controlConfig);
        }
    };
    FormBuilder.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    FormBuilder.ctorParameters = function () { return []; };
    return FormBuilder;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@stable
 */
var VERSION = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Version"]('5.2.11');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Adds `novalidate` attribute to all forms by default.
 *
 * `novalidate` is used to disable browser's native form validation.
 *
 * If you want to use native validation with Angular forms, just add `ngNativeValidate` attribute:
 *
 * ```
 * <form ngNativeValidate></form>
 * ```
 *
 * \@experimental
 */
var NgNoValidate = /** @class */ (function () {
    function NgNoValidate() {
    }
    NgNoValidate.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: 'form:not([ngNoForm]):not([ngNativeValidate])',
                    host: { 'novalidate': '' },
                },] },
    ];
    /** @nocollapse */
    NgNoValidate.ctorParameters = function () { return []; };
    return NgNoValidate;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SHARED_FORM_DIRECTIVES = [
    NgNoValidate,
    NgSelectOption,
    NgSelectMultipleOption,
    DefaultValueAccessor,
    NumberValueAccessor,
    RangeValueAccessor,
    CheckboxControlValueAccessor,
    SelectControlValueAccessor,
    SelectMultipleControlValueAccessor,
    RadioControlValueAccessor,
    NgControlStatus,
    NgControlStatusGroup,
    RequiredValidator,
    MinLengthValidator,
    MaxLengthValidator,
    PatternValidator,
    CheckboxRequiredValidator,
    EmailValidator,
];
var TEMPLATE_DRIVEN_DIRECTIVES = [NgModel, NgModelGroup, NgForm];
var REACTIVE_DRIVEN_DIRECTIVES = [FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName];
/**
 * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
 */
var InternalFormsSharedModule = /** @class */ (function () {
    function InternalFormsSharedModule() {
    }
    InternalFormsSharedModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                    declarations: SHARED_FORM_DIRECTIVES,
                    exports: SHARED_FORM_DIRECTIVES,
                },] },
    ];
    /** @nocollapse */
    InternalFormsSharedModule.ctorParameters = function () { return []; };
    return InternalFormsSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The ng module for forms.
 * \@stable
 */
var FormsModule = /** @class */ (function () {
    function FormsModule() {
    }
    FormsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                    declarations: TEMPLATE_DRIVEN_DIRECTIVES,
                    providers: [RadioControlRegistry],
                    exports: [InternalFormsSharedModule, TEMPLATE_DRIVEN_DIRECTIVES]
                },] },
    ];
    /** @nocollapse */
    FormsModule.ctorParameters = function () { return []; };
    return FormsModule;
}());
/**
 * The ng module for reactive forms.
 * \@stable
 */
var ReactiveFormsModule = /** @class */ (function () {
    function ReactiveFormsModule() {
    }
    ReactiveFormsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                    declarations: [REACTIVE_DRIVEN_DIRECTIVES],
                    providers: [FormBuilder, RadioControlRegistry],
                    exports: [InternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES]
                },] },
    ];
    /** @nocollapse */
    ReactiveFormsModule.ctorParameters = function () { return []; };
    return ReactiveFormsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of this package.
 */

// This file only reexports content of the `src` folder. Keep it that way.

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */


//# sourceMappingURL=forms.js.map


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MapsAPILoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var MapsAPILoader = /** @class */ (function () {
    function MapsAPILoader() {
    }
    MapsAPILoader.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    return MapsAPILoader;
}());

//# sourceMappingURL=maps-api-loader.js.map

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarkerManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__ = __webpack_require__(22);



var MarkerManager = /** @class */ (function () {
    function MarkerManager(_mapsWrapper, _zone) {
        this._mapsWrapper = _mapsWrapper;
        this._zone = _zone;
        this._markers = new Map();
    }
    MarkerManager.prototype.deleteMarker = function (marker) {
        var _this = this;
        var m = this._markers.get(marker);
        if (m == null) {
            // marker already deleted
            return Promise.resolve();
        }
        return m.then(function (m) {
            return _this._zone.run(function () {
                m.setMap(null);
                _this._markers.delete(marker);
            });
        });
    };
    MarkerManager.prototype.updateMarkerPosition = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setPosition({ lat: marker.latitude, lng: marker.longitude }); });
    };
    MarkerManager.prototype.updateTitle = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setTitle(marker.title); });
    };
    MarkerManager.prototype.updateLabel = function (marker) {
        return this._markers.get(marker).then(function (m) { m.setLabel(marker.label); });
    };
    MarkerManager.prototype.updateDraggable = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setDraggable(marker.draggable); });
    };
    MarkerManager.prototype.updateIcon = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setIcon(marker.iconUrl); });
    };
    MarkerManager.prototype.updateOpacity = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setOpacity(marker.opacity); });
    };
    MarkerManager.prototype.updateVisible = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setVisible(marker.visible); });
    };
    MarkerManager.prototype.updateZIndex = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setZIndex(marker.zIndex); });
    };
    MarkerManager.prototype.updateClickable = function (marker) {
        return this._markers.get(marker).then(function (m) { return m.setClickable(marker.clickable); });
    };
    MarkerManager.prototype.updateAnimation = function (marker) {
        return this._markers.get(marker).then(function (m) {
            if (typeof marker.animation === 'string') {
                m.setAnimation(google.maps.Animation[marker.animation]);
            }
            else {
                m.setAnimation(marker.animation);
            }
        });
    };
    MarkerManager.prototype.addMarker = function (marker) {
        var markerPromise = this._mapsWrapper.createMarker({
            position: { lat: marker.latitude, lng: marker.longitude },
            label: marker.label,
            draggable: marker.draggable,
            icon: marker.iconUrl,
            opacity: marker.opacity,
            visible: marker.visible,
            zIndex: marker.zIndex,
            title: marker.title,
            clickable: marker.clickable,
            animation: (typeof marker.animation === 'string') ? google.maps.Animation[marker.animation] : marker.animation
        });
        this._markers.set(marker, markerPromise);
    };
    MarkerManager.prototype.getNativeMarker = function (marker) {
        return this._markers.get(marker);
    };
    MarkerManager.prototype.createEventObservable = function (eventName, marker) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"](function (observer) {
            _this._markers.get(marker).then(function (m) {
                m.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
            });
        });
    };
    MarkerManager.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    MarkerManager.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    return MarkerManager;
}());

//# sourceMappingURL=marker-manager.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(12);
var trip_1 = __webpack_require__(220);
var Trips = (function () {
    function Trips(json) {
        try {
            var summary = json.data.summary;
            var data = json.data;
            this.searchId = data.searchId;
            this.total = summary.count;
            this.maxDuration = summary.max_duration || 0;
            this.minDuration = summary.min_duration || 0;
            this.selectedMaxDuration = summary['selected_duration.lte'] || this.maxDuration;
            this.selectedMinDuration = summary['selected_duration.gte'] || this.minDuration;
            this.setMapBounds(summary);
            this.setItems(data.items);
            this.setDestinationPorts(summary);
            this.setOriginPorts(summary);
            this.setCarriers(summary);
            this.setTranshipments(summary);
        }
        catch (ex) {
            this.setDefaults();
        }
    }
    Trips.prototype.setDefaults = function () {
        this.searchId = '';
        this.total = 0;
        this.maxDuration = 0;
        this.minDuration = 0;
        this.selectedMaxDuration = 0;
        this.selectedMinDuration = 0;
        this.originBounds = {
            north: 45, east: 45, south: -45, west: -45
        };
        this.destinationBounds = {
            north: 45, east: 45, south: 45, west: 45
        };
        this.items = [];
        this.destinationPorts = [];
        this.selectedDestinationPorts = [];
        this.originPorts = [];
        this.selectedOriginPorts = [];
        this.carriers = [];
        this.selectedCarriers = [];
        this.excludedCarriers = [];
        this.transhipments = [];
        this.selectedTranshipments = [];
    };
    Trips.prototype.setMapBounds = function (summary) {
        try {
            this.originBounds = {
                north: summary.available_origin_ports[0].port.latlong[0] + 1,
                east: summary.available_origin_ports[0].port.latlong[1] + 1,
                south: summary.available_origin_ports[0].port.latlong[0] - 1,
                west: summary.available_origin_ports[0].port.latlong[1] - 1
            };
        }
        catch (ex) {
            this.originBounds = {
                north: 45, east: 45, south: -45, west: -45
            };
        }
        try {
            this.destinationBounds = {
                north: summary.available_destination_ports[0].port.latlong[0] + 1,
                east: summary.available_destination_ports[0].port.latlong[1] + 1,
                south: summary.available_destination_ports[0].port.latlong[0] - 1,
                west: summary.available_destination_ports[0].port.latlong[1] - 1
            };
        }
        catch (ex) {
            this.destinationBounds = {
                north: 45, east: 45, south: -45, west: -45
            };
        }
    };
    Trips.prototype.setItems = function (items) {
        this.items = [];
        try {
            for (var current = 0; current < items.length; current++) {
                this.items.push(new trip_1.Trip(items[current]));
            }
        }
        catch (ex) {
        }
    };
    Trips.prototype.setDestinationPorts = function (summary) {
        this.destinationPorts = [];
        this.selectedDestinationPorts = [];
        var available = summary.available_destination_ports;
        for (var current = 0; current < available.length; current++) {
            var port = new _1.Port(available[current].port);
            var count = available[current].count;
            this.destinationPorts.push({ count: count, selected: true, port: port });
            this.selectedDestinationPorts.push(port.id);
            var lat = port.latlong[0];
            var lng = port.latlong[1];
            if (port.latlong[0] !== null && port.latlong[1] !== null) {
                this.destinationBounds.north = Math.max(lat, this.destinationBounds.north);
                this.destinationBounds.east = Math.max(lng, this.destinationBounds.east);
                this.destinationBounds.south = Math.min(lat, this.destinationBounds.south);
                this.destinationBounds.west = Math.min(lng, this.destinationBounds.west);
            }
        }
    };
    Trips.prototype.setOriginPorts = function (summary) {
        this.originPorts = [];
        this.selectedOriginPorts = [];
        var available = summary.available_origin_ports;
        for (var current = 0; current < available.length; current++) {
            var port = new _1.Port(available[current].port);
            var count = available[current].count;
            this.originPorts.push({ count: count, selected: true, port: port });
            this.selectedOriginPorts.push(port.id);
            var lat = port.latlong[0];
            var lng = port.latlong[1];
            if (port.latlong[0] !== null && port.latlong[1] !== null) {
                this.originBounds.north = Math.max(lat, this.originBounds.north);
                this.originBounds.east = Math.max(lng, this.originBounds.east);
                this.originBounds.south = Math.min(lat, this.originBounds.south);
                this.originBounds.west = Math.min(lng, this.originBounds.west);
            }
        }
    };
    Trips.prototype.setCarriers = function (summary) {
        this.carriers = [];
        this.selectedCarriers = summary.selected_carriers;
        this.excludedCarriers = summary.excluded_carriers;
        var available = summary.available_carriers;
        var selected = summary.selected_carriers;
        var excluded = summary.excluded_carriers;
        for (var current = 0; current < available.length; current++) {
            var carrier = new _1.Carrier(available[current].carrier);
            carrier.setSummary(available[current], this.isCarrierSelected(carrier.id, selected, excluded));
            this.carriers.push(carrier);
        }
    };
    Trips.prototype.isCarrierSelected = function (carrierId, selected, excluded) {
        if (selected.length === 0 && excluded.length === 0) {
            return true;
        }
        // excluded
        if (excluded.indexOf(carrierId) > -1) {
            return false;
        }
        // selected and not excluded
        if (selected.indexOf(carrierId) > -1) {
            return true;
        }
        // not selected
        if (selected.length !== 0) {
            return false;
        }
        // not excluded
        return true;
    };
    Trips.prototype.setTranshipments = function (summary) {
        this.transhipments = [];
        this.selectedTranshipments = [];
        var available = summary.available_transhipments;
        var selected = summary.selected_transhipments;
        var allTranshipmentsSelected = selected.length === 0 ? true : false;
        for (var current = 0; current < available.length; current++) {
            var total = available[current] || 0; // number of transhipments
            var isSelected = selected.indexOf(total) > -1 || allTranshipmentsSelected;
            if (selected.indexOf(total) > -1 && !allTranshipmentsSelected) {
                this.selectedTranshipments.push(total);
            }
            this.transhipments.push({ amount: total, selected: isSelected });
        }
    };
    return Trips;
}());
exports.Trips = Trips;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(17);
var forms_1 = __webpack_require__(43);
var router_1 = __webpack_require__(3);
var favorite_directive_1 = __webpack_require__(94);
var blur_1 = __webpack_require__(669);
var business_validator_directive_1 = __webpack_require__(244);
var personal_information_1 = __webpack_require__(674);
var search_box_1 = __webpack_require__(679);
var email_box_1 = __webpack_require__(684);
var plans_side_bar_1 = __webpack_require__(689);
var carrier_performance_1 = __webpack_require__(694);
var voyage_partial_1 = __webpack_require__(700);
var SharedModule = (function () {
    function SharedModule() {
    }
    SharedModule = __decorate([
        core_1.NgModule({
            imports: [forms_1.FormsModule, common_1.CommonModule, forms_1.ReactiveFormsModule, router_1.RouterModule],
            declarations: [blur_1.BlurComponent, business_validator_directive_1.BusinessValidatorDirective, favorite_directive_1.FavoriteDirective, personal_information_1.PersonalInformationComponent, search_box_1.SearchBoxComponent, email_box_1.EmailBoxComponent, plans_side_bar_1.PlansSideBarComponent, carrier_performance_1.CarrierPerformanceComponent, voyage_partial_1.VoyagePartialComponent],
            exports: [forms_1.FormsModule, forms_1.ReactiveFormsModule, blur_1.BlurComponent, favorite_directive_1.FavoriteDirective, personal_information_1.PersonalInformationComponent, search_box_1.SearchBoxComponent, email_box_1.EmailBoxComponent, plans_side_bar_1.PlansSideBarComponent, carrier_performance_1.CarrierPerformanceComponent, voyage_partial_1.VoyagePartialComponent]
        })
    ], SharedModule);
    return SharedModule;
}());
exports.SharedModule = SharedModule;


/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CircleManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__ = __webpack_require__(22);



var CircleManager = /** @class */ (function () {
    function CircleManager(_apiWrapper, _zone) {
        this._apiWrapper = _apiWrapper;
        this._zone = _zone;
        this._circles = new Map();
    }
    CircleManager.prototype.addCircle = function (circle) {
        this._circles.set(circle, this._apiWrapper.createCircle({
            center: { lat: circle.latitude, lng: circle.longitude },
            clickable: circle.clickable,
            draggable: circle.draggable,
            editable: circle.editable,
            fillColor: circle.fillColor,
            fillOpacity: circle.fillOpacity,
            radius: circle.radius,
            strokeColor: circle.strokeColor,
            strokeOpacity: circle.strokeOpacity,
            strokePosition: circle.strokePosition,
            strokeWeight: circle.strokeWeight,
            visible: circle.visible,
            zIndex: circle.zIndex
        }));
    };
    /**
     * Removes the given circle from the map.
     */
    /**
       * Removes the given circle from the map.
       */
    CircleManager.prototype.removeCircle = /**
       * Removes the given circle from the map.
       */
    function (circle) {
        var _this = this;
        return this._circles.get(circle).then(function (c) {
            c.setMap(null);
            _this._circles.delete(circle);
        });
    };
    CircleManager.prototype.setOptions = function (circle, options) {
        return this._circles.get(circle).then(function (c) { return c.setOptions(options); });
    };
    CircleManager.prototype.getBounds = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.getBounds(); });
    };
    CircleManager.prototype.getCenter = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.getCenter(); });
    };
    CircleManager.prototype.getRadius = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.getRadius(); });
    };
    CircleManager.prototype.setCenter = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.setCenter({ lat: circle.latitude, lng: circle.longitude }); });
    };
    CircleManager.prototype.setEditable = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.setEditable(circle.editable); });
    };
    CircleManager.prototype.setDraggable = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.setDraggable(circle.draggable); });
    };
    CircleManager.prototype.setVisible = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.setVisible(circle.visible); });
    };
    CircleManager.prototype.setRadius = function (circle) {
        return this._circles.get(circle).then(function (c) { return c.setRadius(circle.radius); });
    };
    CircleManager.prototype.createEventObservable = function (eventName, circle) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"](function (observer) {
            var listener = null;
            _this._circles.get(circle).then(function (c) {
                listener = c.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
            });
            return function () {
                if (listener !== null) {
                    listener.remove();
                }
            };
        });
    };
    CircleManager.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    CircleManager.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    return CircleManager;
}());

//# sourceMappingURL=circle-manager.js.map

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoWindowManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marker_manager__ = __webpack_require__(59);




var InfoWindowManager = /** @class */ (function () {
    function InfoWindowManager(_mapsWrapper, _zone, _markerManager) {
        this._mapsWrapper = _mapsWrapper;
        this._zone = _zone;
        this._markerManager = _markerManager;
        this._infoWindows = new Map();
    }
    InfoWindowManager.prototype.deleteInfoWindow = function (infoWindow) {
        var _this = this;
        var iWindow = this._infoWindows.get(infoWindow);
        if (iWindow == null) {
            // info window already deleted
            return Promise.resolve();
        }
        return iWindow.then(function (i) {
            return _this._zone.run(function () {
                i.close();
                _this._infoWindows.delete(infoWindow);
            });
        });
    };
    InfoWindowManager.prototype.setPosition = function (infoWindow) {
        return this._infoWindows.get(infoWindow).then(function (i) {
            return i.setPosition({
                lat: infoWindow.latitude,
                lng: infoWindow.longitude
            });
        });
    };
    InfoWindowManager.prototype.setZIndex = function (infoWindow) {
        return this._infoWindows.get(infoWindow)
            .then(function (i) { return i.setZIndex(infoWindow.zIndex); });
    };
    InfoWindowManager.prototype.open = function (infoWindow) {
        var _this = this;
        return this._infoWindows.get(infoWindow).then(function (w) {
            if (infoWindow.hostMarker != null) {
                return _this._markerManager.getNativeMarker(infoWindow.hostMarker).then(function (marker) {
                    return _this._mapsWrapper.getNativeMap().then(function (map) { return w.open(map, marker); });
                });
            }
            return _this._mapsWrapper.getNativeMap().then(function (map) { return w.open(map); });
        });
    };
    InfoWindowManager.prototype.close = function (infoWindow) {
        return this._infoWindows.get(infoWindow).then(function (w) { return w.close(); });
    };
    InfoWindowManager.prototype.setOptions = function (infoWindow, options) {
        return this._infoWindows.get(infoWindow).then(function (i) { return i.setOptions(options); });
    };
    InfoWindowManager.prototype.addInfoWindow = function (infoWindow) {
        var options = {
            content: infoWindow.content,
            maxWidth: infoWindow.maxWidth,
            zIndex: infoWindow.zIndex,
            disableAutoPan: infoWindow.disableAutoPan
        };
        if (typeof infoWindow.latitude === 'number' && typeof infoWindow.longitude === 'number') {
            options.position = { lat: infoWindow.latitude, lng: infoWindow.longitude };
        }
        var infoWindowPromise = this._mapsWrapper.createInfoWindow(options);
        this._infoWindows.set(infoWindow, infoWindowPromise);
    };
    /**
     * Creates a Google Maps event listener for the given InfoWindow as an Observable
     */
    /**
        * Creates a Google Maps event listener for the given InfoWindow as an Observable
        */
    InfoWindowManager.prototype.createEventObservable = /**
        * Creates a Google Maps event listener for the given InfoWindow as an Observable
        */
    function (eventName, infoWindow) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"](function (observer) {
            _this._infoWindows.get(infoWindow).then(function (i) {
                i.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
            });
        });
    };
    InfoWindowManager.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    InfoWindowManager.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_3__marker_manager__["a" /* MarkerManager */], },
    ]; };
    return InfoWindowManager;
}());

//# sourceMappingURL=info-window-manager.js.map

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PolygonManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__ = __webpack_require__(22);



var PolygonManager = /** @class */ (function () {
    function PolygonManager(_mapsWrapper, _zone) {
        this._mapsWrapper = _mapsWrapper;
        this._zone = _zone;
        this._polygons = new Map();
    }
    PolygonManager.prototype.addPolygon = function (path) {
        var polygonPromise = this._mapsWrapper.createPolygon({
            clickable: path.clickable,
            draggable: path.draggable,
            editable: path.editable,
            fillColor: path.fillColor,
            fillOpacity: path.fillOpacity,
            geodesic: path.geodesic,
            paths: path.paths,
            strokeColor: path.strokeColor,
            strokeOpacity: path.strokeOpacity,
            strokeWeight: path.strokeWeight,
            visible: path.visible,
            zIndex: path.zIndex,
        });
        this._polygons.set(path, polygonPromise);
    };
    PolygonManager.prototype.updatePolygon = function (polygon) {
        var _this = this;
        var m = this._polygons.get(polygon);
        if (m == null) {
            return Promise.resolve();
        }
        return m.then(function (l) { return _this._zone.run(function () { l.setPaths(polygon.paths); }); });
    };
    PolygonManager.prototype.setPolygonOptions = function (path, options) {
        return this._polygons.get(path).then(function (l) { l.setOptions(options); });
    };
    PolygonManager.prototype.deletePolygon = function (paths) {
        var _this = this;
        var m = this._polygons.get(paths);
        if (m == null) {
            return Promise.resolve();
        }
        return m.then(function (l) {
            return _this._zone.run(function () {
                l.setMap(null);
                _this._polygons.delete(paths);
            });
        });
    };
    PolygonManager.prototype.createEventObservable = function (eventName, path) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"](function (observer) {
            _this._polygons.get(path).then(function (l) {
                l.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
            });
        });
    };
    PolygonManager.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    PolygonManager.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    return PolygonManager;
}());

//# sourceMappingURL=polygon-manager.js.map

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PolylineManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__ = __webpack_require__(22);



var PolylineManager = /** @class */ (function () {
    function PolylineManager(_mapsWrapper, _zone) {
        this._mapsWrapper = _mapsWrapper;
        this._zone = _zone;
        this._polylines = new Map();
    }
    PolylineManager._convertPoints = function (line) {
        var path = line._getPoints().map(function (point) {
            return { lat: point.latitude, lng: point.longitude };
        });
        return path;
    };
    PolylineManager.prototype.addPolyline = function (line) {
        var path = PolylineManager._convertPoints(line);
        var polylinePromise = this._mapsWrapper.createPolyline({
            clickable: line.clickable,
            draggable: line.draggable,
            editable: line.editable,
            geodesic: line.geodesic,
            strokeColor: line.strokeColor,
            strokeOpacity: line.strokeOpacity,
            strokeWeight: line.strokeWeight,
            visible: line.visible,
            zIndex: line.zIndex,
            path: path
        });
        this._polylines.set(line, polylinePromise);
    };
    PolylineManager.prototype.updatePolylinePoints = function (line) {
        var _this = this;
        var path = PolylineManager._convertPoints(line);
        var m = this._polylines.get(line);
        if (m == null) {
            return Promise.resolve();
        }
        return m.then(function (l) { return _this._zone.run(function () { l.setPath(path); }); });
    };
    PolylineManager.prototype.setPolylineOptions = function (line, options) {
        return this._polylines.get(line).then(function (l) { l.setOptions(options); });
    };
    PolylineManager.prototype.deletePolyline = function (line) {
        var _this = this;
        var m = this._polylines.get(line);
        if (m == null) {
            return Promise.resolve();
        }
        return m.then(function (l) {
            return _this._zone.run(function () {
                l.setMap(null);
                _this._polylines.delete(line);
            });
        });
    };
    PolylineManager.prototype.createEventObservable = function (eventName, line) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"](function (observer) {
            _this._polylines.get(line).then(function (l) {
                l.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
            });
        });
    };
    PolylineManager.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    PolylineManager.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    return PolylineManager;
}());

//# sourceMappingURL=polyline-manager.js.map

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KmlLayerManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__ = __webpack_require__(22);



/**
 * Manages all KML Layers for a Google Map instance.
 */
var KmlLayerManager = /** @class */ (function () {
    function KmlLayerManager(_wrapper, _zone) {
        this._wrapper = _wrapper;
        this._zone = _zone;
        this._layers = new Map();
    }
    /**
     * Adds a new KML Layer to the map.
     */
    /**
       * Adds a new KML Layer to the map.
       */
    KmlLayerManager.prototype.addKmlLayer = /**
       * Adds a new KML Layer to the map.
       */
    function (layer) {
        var newLayer = this._wrapper.getNativeMap().then(function (m) {
            return new google.maps.KmlLayer({
                clickable: layer.clickable,
                map: m,
                preserveViewport: layer.preserveViewport,
                screenOverlays: layer.screenOverlays,
                suppressInfoWindows: layer.suppressInfoWindows,
                url: layer.url,
                zIndex: layer.zIndex
            });
        });
        this._layers.set(layer, newLayer);
    };
    KmlLayerManager.prototype.setOptions = function (layer, options) {
        this._layers.get(layer).then(function (l) { return l.setOptions(options); });
    };
    KmlLayerManager.prototype.deleteKmlLayer = function (layer) {
        var _this = this;
        this._layers.get(layer).then(function (l) {
            l.setMap(null);
            _this._layers.delete(layer);
        });
    };
    /**
     * Creates a Google Maps event listener for the given KmlLayer as an Observable
     */
    /**
       * Creates a Google Maps event listener for the given KmlLayer as an Observable
       */
    KmlLayerManager.prototype.createEventObservable = /**
       * Creates a Google Maps event listener for the given KmlLayer as an Observable
       */
    function (eventName, layer) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"](function (observer) {
            _this._layers.get(layer).then(function (m) {
                m.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
            });
        });
    };
    KmlLayerManager.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    KmlLayerManager.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    return KmlLayerManager;
}());

//# sourceMappingURL=kml-layer-manager.js.map

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataLayerManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__ = __webpack_require__(22);



/**
 * Manages all Data Layers for a Google Map instance.
 */
var DataLayerManager = /** @class */ (function () {
    function DataLayerManager(_wrapper, _zone) {
        this._wrapper = _wrapper;
        this._zone = _zone;
        this._layers = new Map();
    }
    /**
     * Adds a new Data Layer to the map.
     */
    /**
       * Adds a new Data Layer to the map.
       */
    DataLayerManager.prototype.addDataLayer = /**
       * Adds a new Data Layer to the map.
       */
    function (layer) {
        var _this = this;
        var newLayer = this._wrapper.createDataLayer({
            style: layer.style
        })
            .then(function (d) {
            if (layer.geoJson) {
                _this.getDataFeatures(d, layer.geoJson).then(function (features) { return d.features = features; });
            }
            return d;
        });
        this._layers.set(layer, newLayer);
    };
    DataLayerManager.prototype.deleteDataLayer = function (layer) {
        var _this = this;
        this._layers.get(layer).then(function (l) {
            l.setMap(null);
            _this._layers.delete(layer);
        });
    };
    DataLayerManager.prototype.updateGeoJson = function (layer, geoJson) {
        var _this = this;
        this._layers.get(layer).then(function (l) {
            l.forEach(function (feature) {
                l.remove(feature);
                var index = l.features.indexOf(feature, 0);
                if (index > -1) {
                    l.features.splice(index, 1);
                }
            });
            _this.getDataFeatures(l, geoJson).then(function (features) { return l.features = features; });
        });
    };
    DataLayerManager.prototype.setDataOptions = function (layer, options) {
        this._layers.get(layer).then(function (l) {
            l.setControlPosition(options.controlPosition);
            l.setControls(options.controls);
            l.setDrawingMode(options.drawingMode);
            l.setStyle(options.style);
        });
    };
    /**
     * Creates a Google Maps event listener for the given DataLayer as an Observable
     */
    /**
       * Creates a Google Maps event listener for the given DataLayer as an Observable
       */
    DataLayerManager.prototype.createEventObservable = /**
       * Creates a Google Maps event listener for the given DataLayer as an Observable
       */
    function (eventName, layer) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"](function (observer) {
            _this._layers.get(layer).then(function (d) {
                d.addListener(eventName, function (e) { return _this._zone.run(function () { return observer.next(e); }); });
            });
        });
    };
    /**
     * Extract features from a geoJson using google.maps Data Class
     * @param d : google.maps.Data class instance
     * @param geoJson : url or geojson object
     */
    /**
       * Extract features from a geoJson using google.maps Data Class
       * @param d : google.maps.Data class instance
       * @param geoJson : url or geojson object
       */
    DataLayerManager.prototype.getDataFeatures = /**
       * Extract features from a geoJson using google.maps Data Class
       * @param d : google.maps.Data class instance
       * @param geoJson : url or geojson object
       */
    function (d, geoJson) {
        return new Promise(function (resolve, reject) {
            if (typeof geoJson === 'object') {
                try {
                    var features = d.addGeoJson(geoJson);
                    resolve(features);
                }
                catch (e) {
                    reject(e);
                }
            }
            else if (typeof geoJson === 'string') {
                d.loadGeoJson(geoJson, null, resolve);
            }
            else {
                reject("Impossible to extract features from geoJson: wrong argument type");
            }
        });
    };
    DataLayerManager.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    DataLayerManager.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    ]; };
    return DataLayerManager;
}());

//# sourceMappingURL=data-layer-manager.js.map

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgmInfoWindow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_managers_info_window_manager__ = __webpack_require__(86);


var infoWindowId = 0;
/**
 * AgmInfoWindow renders a info window inside a {@link AgmMarker} or standalone.
 *
 * ### Example
 * ```typescript
 * import { Component } from '@angular/core';
 *
 * @Component({
 *  selector: 'my-map-cmp',
 *  styles: [`
 *    .agm-map-container {
 *      height: 300px;
 *    }
 * `],
 *  template: `
 *    <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
 *      <agm-marker [latitude]="lat" [longitude]="lng" [label]="'M'">
 *        <agm-info-window [disableAutoPan]="true">
 *          Hi, this is the content of the <strong>info window</strong>
 *        </agm-info-window>
 *      </agm-marker>
 *    </agm-map>
 *  `
 * })
 * ```
 */
var AgmInfoWindow = /** @class */ (function () {
    function AgmInfoWindow(_infoWindowManager, _el) {
        this._infoWindowManager = _infoWindowManager;
        this._el = _el;
        /**
           * Sets the open state for the InfoWindow. You can also call the open() and close() methods.
           */
        this.isOpen = false;
        /**
           * Emits an event when the info window is closed.
           */
        this.infoWindowClose = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._infoWindowAddedToManager = false;
        this._id = (infoWindowId++).toString();
    }
    AgmInfoWindow.prototype.ngOnInit = function () {
        this.content = this._el.nativeElement.querySelector('.agm-info-window-content');
        this._infoWindowManager.addInfoWindow(this);
        this._infoWindowAddedToManager = true;
        this._updateOpenState();
        this._registerEventListeners();
    };
    /** @internal */
    /** @internal */
    AgmInfoWindow.prototype.ngOnChanges = /** @internal */
    function (changes) {
        if (!this._infoWindowAddedToManager) {
            return;
        }
        if ((changes['latitude'] || changes['longitude']) && typeof this.latitude === 'number' &&
            typeof this.longitude === 'number') {
            this._infoWindowManager.setPosition(this);
        }
        if (changes['zIndex']) {
            this._infoWindowManager.setZIndex(this);
        }
        if (changes['isOpen']) {
            this._updateOpenState();
        }
        this._setInfoWindowOptions(changes);
    };
    AgmInfoWindow.prototype._registerEventListeners = function () {
        var _this = this;
        this._infoWindowManager.createEventObservable('closeclick', this).subscribe(function () {
            _this.isOpen = false;
            _this.infoWindowClose.emit();
        });
    };
    AgmInfoWindow.prototype._updateOpenState = function () {
        this.isOpen ? this.open() : this.close();
    };
    AgmInfoWindow.prototype._setInfoWindowOptions = function (changes) {
        var options = {};
        var optionKeys = Object.keys(changes).filter(function (k) { return AgmInfoWindow._infoWindowOptionsInputs.indexOf(k) !== -1; });
        optionKeys.forEach(function (k) { options[k] = changes[k].currentValue; });
        this._infoWindowManager.setOptions(this, options);
    };
    /**
     * Opens the info window.
     */
    /**
       * Opens the info window.
       */
    AgmInfoWindow.prototype.open = /**
       * Opens the info window.
       */
    function () { return this._infoWindowManager.open(this); };
    /**
     * Closes the info window.
     */
    /**
       * Closes the info window.
       */
    AgmInfoWindow.prototype.close = /**
       * Closes the info window.
       */
    function () {
        var _this = this;
        return this._infoWindowManager.close(this).then(function () { _this.infoWindowClose.emit(); });
    };
    /** @internal */
    /** @internal */
    AgmInfoWindow.prototype.id = /** @internal */
    function () { return this._id; };
    /** @internal */
    /** @internal */
    AgmInfoWindow.prototype.toString = /** @internal */
    function () { return 'AgmInfoWindow-' + this._id.toString(); };
    /** @internal */
    /** @internal */
    AgmInfoWindow.prototype.ngOnDestroy = /** @internal */
    function () { this._infoWindowManager.deleteInfoWindow(this); };
    AgmInfoWindow._infoWindowOptionsInputs = ['disableAutoPan', 'maxWidth'];
    AgmInfoWindow.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'agm-info-window',
                    template: "<div class='agm-info-window-content'>\n      <ng-content></ng-content>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    AgmInfoWindow.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__services_managers_info_window_manager__["a" /* InfoWindowManager */], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    AgmInfoWindow.propDecorators = {
        "latitude": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "longitude": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "disableAutoPan": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "zIndex": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "maxWidth": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "isOpen": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "infoWindowClose": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return AgmInfoWindow;
}());

//# sourceMappingURL=info-window.js.map

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgmPolylinePoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

/**
 * AgmPolylinePoint represents one element of a polyline within a  {@link
 * SembGoogleMapPolyline}
 */
var AgmPolylinePoint = /** @class */ (function () {
    function AgmPolylinePoint() {
        /**
           * This event emitter gets emitted when the position of the point changed.
           */
        this.positionChanged = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    AgmPolylinePoint.prototype.ngOnChanges = function (changes) {
        if (changes['latitude'] || changes['longitude']) {
            var position = {
                lat: changes['latitude'].currentValue,
                lng: changes['longitude'].currentValue
            };
            this.positionChanged.emit(position);
        }
    };
    AgmPolylinePoint.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'agm-polyline-point' },] },
    ];
    /** @nocollapse */
    AgmPolylinePoint.ctorParameters = function () { return []; };
    AgmPolylinePoint.propDecorators = {
        "latitude": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "longitude": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "positionChanged": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return AgmPolylinePoint;
}());

//# sourceMappingURL=polyline-point.js.map

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleMapsScriptProtocol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LAZY_MAPS_API_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LazyMapsAPILoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_browser_globals__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__maps_api_loader__ = __webpack_require__(58);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var GoogleMapsScriptProtocol;
(function (GoogleMapsScriptProtocol) {
    GoogleMapsScriptProtocol[GoogleMapsScriptProtocol["HTTP"] = 1] = "HTTP";
    GoogleMapsScriptProtocol[GoogleMapsScriptProtocol["HTTPS"] = 2] = "HTTPS";
    GoogleMapsScriptProtocol[GoogleMapsScriptProtocol["AUTO"] = 3] = "AUTO";
})(GoogleMapsScriptProtocol || (GoogleMapsScriptProtocol = {}));
/**
 * Token for the config of the LazyMapsAPILoader. Please provide an object of type {@link
 * LazyMapsAPILoaderConfig}.
 */
var LAZY_MAPS_API_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('angular-google-maps LAZY_MAPS_API_CONFIG');
var LazyMapsAPILoader = /** @class */ (function (_super) {
    __extends(LazyMapsAPILoader, _super);
    function LazyMapsAPILoader(config, w, d) {
        if (config === void 0) { config = null; }
        var _this = _super.call(this) || this;
        _this._SCRIPT_ID = 'agmGoogleMapsApiScript';
        _this.callbackName = "agmLazyMapsAPILoader";
        _this._config = config || {};
        _this._windowRef = w;
        _this._documentRef = d;
        return _this;
    }
    LazyMapsAPILoader.prototype.load = function () {
        var window = this._windowRef.getNativeWindow();
        if (window.google && window.google.maps) {
            // Google maps already loaded on the page.
            return Promise.resolve();
        }
        if (this._scriptLoadingPromise) {
            return this._scriptLoadingPromise;
        }
        // this can happen in HMR situations or Stackblitz.io editors.
        var scriptOnPage = this._documentRef.getNativeDocument().getElementById(this._SCRIPT_ID);
        if (scriptOnPage) {
            this._assignScriptLoadingPromise(scriptOnPage);
            return this._scriptLoadingPromise;
        }
        var script = this._documentRef.getNativeDocument().createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.id = this._SCRIPT_ID;
        script.src = this._getScriptSrc(this.callbackName);
        this._assignScriptLoadingPromise(script);
        this._documentRef.getNativeDocument().body.appendChild(script);
        return this._scriptLoadingPromise;
    };
    LazyMapsAPILoader.prototype._assignScriptLoadingPromise = function (scriptElem) {
        var _this = this;
        this._scriptLoadingPromise = new Promise(function (resolve, reject) {
            _this._windowRef.getNativeWindow()[_this.callbackName] = function () {
                resolve();
            };
            scriptElem.onerror = function (error) {
                reject(error);
            };
        });
    };
    LazyMapsAPILoader.prototype._getScriptSrc = function (callbackName) {
        var protocolType = (this._config && this._config.protocol) || GoogleMapsScriptProtocol.HTTPS;
        var protocol;
        switch (protocolType) {
            case GoogleMapsScriptProtocol.AUTO:
                protocol = '';
                break;
            case GoogleMapsScriptProtocol.HTTP:
                protocol = 'http:';
                break;
            case GoogleMapsScriptProtocol.HTTPS:
                protocol = 'https:';
                break;
        }
        var hostAndPath = this._config.hostAndPath || 'maps.googleapis.com/maps/api/js';
        var queryParams = {
            v: this._config.apiVersion || '3',
            callback: callbackName,
            key: this._config.apiKey,
            client: this._config.clientId,
            channel: this._config.channel,
            libraries: this._config.libraries,
            region: this._config.region,
            language: this._config.language
        };
        var params = Object.keys(queryParams)
            .filter(function (k) { return queryParams[k] != null; })
            .filter(function (k) {
            // remove empty arrays
            return !Array.isArray(queryParams[k]) ||
                (Array.isArray(queryParams[k]) && queryParams[k].length > 0);
        })
            .map(function (k) {
            // join arrays as comma seperated strings
            var i = queryParams[k];
            if (Array.isArray(i)) {
                return { key: k, value: i.join(',') };
            }
            return { key: k, value: queryParams[k] };
        })
            .map(function (entry) {
            return entry.key + "=" + entry.value;
        })
            .join('&');
        return protocol + "//" + hostAndPath + "?" + params;
    };
    LazyMapsAPILoader.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    LazyMapsAPILoader.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [LAZY_MAPS_API_CONFIG,] },] },
        { type: __WEBPACK_IMPORTED_MODULE_1__utils_browser_globals__["c" /* WindowRef */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__utils_browser_globals__["b" /* DocumentRef */], },
    ]; };
    return LazyMapsAPILoader;
}(__WEBPACK_IMPORTED_MODULE_2__maps_api_loader__["a" /* MapsAPILoader */]));

//# sourceMappingURL=lazy-maps-api-loader.js.map

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var _1 = __webpack_require__(2);
var FavoriteDirective = (function () {
    function FavoriteDirective(el, renderer, logger, service) {
        this.renderer = renderer;
        this.logger = logger;
        this.service = service;
        this.el = el.nativeElement;
    }
    Object.defineProperty(FavoriteDirective.prototype, "favorite", {
        set: function (item) {
            this.item = item;
            try {
                if (this.item.userData.favorited) {
                    this.renderer.setElementProperty(this.el, 'src', '../img/star-filled.svg');
                    this.renderer.setElementProperty(this.el, 'title', 'Favorited');
                }
                else {
                    this.renderer.setElementProperty(this.el, 'src', '../img/star-empty.svg');
                    this.renderer.setElementProperty(this.el, 'title', 'Not Favorited');
                }
            }
            catch (ex) {
                this.renderer.setElementProperty(this.el, 'src', '../img/star-empty.svg');
                this.renderer.setElementProperty(this.el, 'title', 'Not Favorited');
            }
        },
        enumerable: true,
        configurable: true
    });
    FavoriteDirective.prototype.onMouseEnter = function () {
    };
    FavoriteDirective.prototype.onMouseLeave = function () {
        this.highlight(null);
    };
    FavoriteDirective.prototype.onClick = function () {
        try {
            if (!this.service.app.isLoggedIn) {
                this.service.showSignInError();
                return;
            }
            this.renderer.setElementClass(this.el, 'loading', true);
            if (this.item.userData.favorited) {
                this.callUnFavorite();
            }
            else {
                this.callFavorite();
            }
        }
        catch (ex) {
            this.service.showSignInError();
        }
    };
    FavoriteDirective.prototype.highlight = function (color) {
        this.el.style.backgroundColor = color;
    };
    FavoriteDirective.prototype.callFavorite = function () {
        var _this = this;
        this.logger.log('favorite.directive', 'callFavorite', this.item);
        this.service.favorite(this.inputType, this.item.id).then(function (result) {
            _this.setFavorite();
            _this.end();
        }).catch(function (err) {
            _this.end();
        });
    };
    FavoriteDirective.prototype.callUnFavorite = function () {
        var _this = this;
        this.logger.log('favorite.directive', 'callUnFavorite', this.item);
        this.service.unfavorite(this.inputType, this.item.id).then(function (result) {
            _this.setUnFavorite();
            _this.end();
        }).catch(function (err) {
            _this.end();
        });
    };
    FavoriteDirective.prototype.setFavorite = function () {
        this.item.userData.favorited = true;
        this.renderer.setElementProperty(this.el, 'src', '../img/star-filled.svg');
        this.renderer.setElementProperty(this.el, 'title', 'Favorited');
        if (this.inputType === 'port') {
            this.service.app.setPort(this.item);
        }
        else if (this.inputType === 'vessel') {
            this.service.app.setVessel(this.item);
        }
        else if (this.inputType === 'carrier') {
            this.service.app.setCarrier(this.item);
        }
    };
    FavoriteDirective.prototype.setUnFavorite = function () {
        this.item.userData.favorited = false;
        this.renderer.setElementProperty(this.el, 'src', '../img/star-empty.svg');
        this.renderer.setElementProperty(this.el, 'title', 'Not Favorited');
        // could probably set an array and then only use one loop
        try {
            if (this.inputType === 'port') {
                for (var current = 0; current < this.service.app.ports.length; current++) {
                    if (this.service.app.ports[current].id === this.item.id) {
                        this.service.app.ports.splice(current, 1);
                    }
                }
            }
            else if (this.inputType === 'vessel') {
                for (var current = 0; current < this.service.app.vessels.length; current++) {
                    if (this.service.app.vessels[current].id === this.item.id) {
                        this.service.app.vessels.splice(current, 1);
                    }
                }
            }
            else if (this.inputType === 'carrier') {
                for (var current = 0; current < this.service.app.carriers.length; current++) {
                    if (this.service.app.carriers[current].id === this.item.id) {
                        this.service.app.carriers.splice(current, 1);
                    }
                }
            }
        }
        catch (ex) {
            this.logger.log('favorite.directive', 'setUnFavorite', 'could not unfavorite');
        }
    };
    FavoriteDirective.prototype.end = function () {
        this.renderer.setElementClass(this.el, 'loading', false);
    };
    __decorate([
        core_1.Input('itemtype'),
        __metadata("design:type", String)
    ], FavoriteDirective.prototype, "inputType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FavoriteDirective.prototype, "favorite", null);
    __decorate([
        core_1.HostListener('mouseenter'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FavoriteDirective.prototype, "onMouseEnter", null);
    __decorate([
        core_1.HostListener('mouseleave'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FavoriteDirective.prototype, "onMouseLeave", null);
    __decorate([
        core_1.HostListener('click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FavoriteDirective.prototype, "onClick", null);
    FavoriteDirective = __decorate([
        core_1.Directive({
            selector: '[favorite]'
        }),
        __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer, _1.LogService, _1.FavoriteService])
    ], FavoriteDirective);
    return FavoriteDirective;
}());
exports.FavoriteDirective = FavoriteDirective;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Status;
(function (Status) {
    Status[Status["Loading"] = 0] = "Loading";
    Status[Status["Loaded"] = 1] = "Loaded";
    Status[Status["Sending"] = 2] = "Sending";
    Status[Status["Success"] = 3] = "Success";
    Status[Status["Error"] = 4] = "Error";
})(Status = exports.Status || (exports.Status = {}));


/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgmMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_google_maps_api_wrapper__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_managers_circle_manager__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_managers_info_window_manager__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_managers_marker_manager__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_managers_polygon_manager__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_managers_polyline_manager__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_managers_kml_layer_manager__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_managers_data_layer_manager__ = __webpack_require__(90);









/**
 * AgmMap renders a Google Map.
 * **Important note**: To be able see a map in the browser, you have to define a height for the
 * element `agm-map`.
 *
 * ### Example
 * ```typescript
 * import { Component } from '@angular/core';
 *
 * @Component({
 *  selector: 'my-map-cmp',
 *  styles: [`
 *    agm-map {
 *      height: 300px;
 *    }
 * `],
 *  template: `
 *    <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
 *    </agm-map>
 *  `
 * })
 * ```
 */
var AgmMap = /** @class */ (function () {
    function AgmMap(_elem, _mapsWrapper) {
        this._elem = _elem;
        this._mapsWrapper = _mapsWrapper;
        /**
           * The longitude that defines the center of the map.
           */
        this.longitude = 0;
        /**
           * The latitude that defines the center of the map.
           */
        this.latitude = 0;
        /**
           * The zoom level of the map. The default zoom level is 8.
           */
        this.zoom = 8;
        /**
           * Enables/disables if map is draggable.
           */
        // tslint:disable-next-line:no-input-rename
        this.draggable = true;
        /**
           * Enables/disables zoom and center on double click. Enabled by default.
           */
        this.disableDoubleClickZoom = false;
        /**
           * Enables/disables all default UI of the Google map. Please note: When the map is created, this
           * value cannot get updated.
           */
        this.disableDefaultUI = false;
        /**
           * If false, disables scrollwheel zooming on the map. The scrollwheel is enabled by default.
           */
        this.scrollwheel = true;
        /**
           * If false, prevents the map from being controlled by the keyboard. Keyboard shortcuts are
           * enabled by default.
           */
        this.keyboardShortcuts = true;
        /**
           * The enabled/disabled state of the Zoom control.
           */
        this.zoomControl = true;
        /**
           * Styles to apply to each of the default map types. Note that for Satellite/Hybrid and Terrain
           * modes, these styles will only apply to labels and geometry.
           */
        this.styles = [];
        /**
           * When true and the latitude and/or longitude values changes, the Google Maps panTo method is
           * used to
           * center the map. See: https://developers.google.com/maps/documentation/javascript/reference#Map
           */
        this.usePanning = false;
        /**
           * The initial enabled/disabled state of the Street View Pegman control.
           * This control is part of the default UI, and should be set to false when displaying a map type
           * on which the Street View road overlay should not appear (e.g. a non-Earth map type).
           */
        this.streetViewControl = true;
        /**
           * Sets the viewport to contain the given bounds.
           */
        this.fitBounds = null;
        /**
           * The initial enabled/disabled state of the Scale control. This is disabled by default.
           */
        this.scaleControl = false;
        /**
           * The initial enabled/disabled state of the Map type control.
           */
        this.mapTypeControl = false;
        /**
           * The initial enabled/disabled state of the Pan control.
           */
        this.panControl = false;
        /**
           * The initial enabled/disabled state of the Rotate control.
           */
        this.rotateControl = false;
        /**
           * The initial enabled/disabled state of the Fullscreen control.
           */
        this.fullscreenControl = false;
        /**
           * The map mapTypeId. Defaults to 'roadmap'.
           */
        this.mapTypeId = 'roadmap';
        /**
           * When false, map icons are not clickable. A map icon represents a point of interest,
           * also known as a POI. By default map icons are clickable.
           */
        this.clickableIcons = true;
        /**
           * This setting controls how gestures on the map are handled.
           * Allowed values:
           * - 'cooperative' (Two-finger touch gestures pan and zoom the map. One-finger touch gestures are not handled by the map.)
           * - 'greedy'      (All touch gestures pan or zoom the map.)
           * - 'none'        (The map cannot be panned or zoomed by user gestures.)
           * - 'auto'        [default] (Gesture handling is either cooperative or greedy, depending on whether the page is scrollable or not.
           */
        this.gestureHandling = 'auto';
        this._observableSubscriptions = [];
        /**
           * This event emitter gets emitted when the user clicks on the map (but not when they click on a
           * marker or infoWindow).
           */
        this.mapClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event emitter gets emitted when the user right-clicks on the map (but not when they click
           * on a marker or infoWindow).
           */
        this.mapRightClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event emitter gets emitted when the user double-clicks on the map (but not when they click
           * on a marker or infoWindow).
           */
        this.mapDblClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event emitter is fired when the map center changes.
           */
        this.centerChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the viewport bounds have changed.
           */
        this.boundsChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the mapTypeId property changes.
           */
        this.mapTypeIdChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the map becomes idle after panning or zooming.
           */
        this.idle = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the zoom level has changed.
           */
        this.zoomChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the google map is fully initialized.
           * You get the google.maps.Map instance as a result of this EventEmitter.
           */
        this.mapReady = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    /** @internal */
    /** @internal */
    AgmMap.prototype.ngOnInit = /** @internal */
    function () {
        // todo: this should be solved with a new component and a viewChild decorator
        var container = this._elem.nativeElement.querySelector('.agm-map-container-inner');
        this._initMapInstance(container);
    };
    AgmMap.prototype._initMapInstance = function (el) {
        var _this = this;
        this._mapsWrapper.createMap(el, {
            center: { lat: this.latitude || 0, lng: this.longitude || 0 },
            zoom: this.zoom,
            minZoom: this.minZoom,
            maxZoom: this.maxZoom,
            disableDefaultUI: this.disableDefaultUI,
            disableDoubleClickZoom: this.disableDoubleClickZoom,
            scrollwheel: this.scrollwheel,
            backgroundColor: this.backgroundColor,
            draggable: this.draggable,
            draggableCursor: this.draggableCursor,
            draggingCursor: this.draggingCursor,
            keyboardShortcuts: this.keyboardShortcuts,
            styles: this.styles,
            zoomControl: this.zoomControl,
            zoomControlOptions: this.zoomControlOptions,
            streetViewControl: this.streetViewControl,
            streetViewControlOptions: this.streetViewControlOptions,
            scaleControl: this.scaleControl,
            scaleControlOptions: this.scaleControlOptions,
            mapTypeControl: this.mapTypeControl,
            mapTypeControlOptions: this.mapTypeControlOptions,
            panControl: this.panControl,
            panControlOptions: this.panControlOptions,
            rotateControl: this.rotateControl,
            rotateControlOptions: this.rotateControlOptions,
            fullscreenControl: this.fullscreenControl,
            fullscreenControlOptions: this.fullscreenControlOptions,
            mapTypeId: this.mapTypeId,
            clickableIcons: this.clickableIcons,
            gestureHandling: this.gestureHandling
        })
            .then(function () { return _this._mapsWrapper.getNativeMap(); })
            .then(function (map) { return _this.mapReady.emit(map); });
        // register event listeners
        this._handleMapCenterChange();
        this._handleMapZoomChange();
        this._handleMapMouseEvents();
        this._handleBoundsChange();
        this._handleMapTypeIdChange();
        this._handleIdleEvent();
    };
    /** @internal */
    /** @internal */
    AgmMap.prototype.ngOnDestroy = /** @internal */
    function () {
        // unsubscribe all registered observable subscriptions
        this._observableSubscriptions.forEach(function (s) { return s.unsubscribe(); });
        // remove all listeners from the map instance
        this._mapsWrapper.clearInstanceListeners();
    };
    /* @internal */
    /* @internal */
    AgmMap.prototype.ngOnChanges = /* @internal */
    function (changes) {
        this._updateMapOptionsChanges(changes);
        this._updatePosition(changes);
    };
    AgmMap.prototype._updateMapOptionsChanges = function (changes) {
        var options = {};
        var optionKeys = Object.keys(changes).filter(function (k) { return AgmMap._mapOptionsAttributes.indexOf(k) !== -1; });
        optionKeys.forEach(function (k) { options[k] = changes[k].currentValue; });
        this._mapsWrapper.setMapOptions(options);
    };
    /**
     * Triggers a resize event on the google map instance.
     * When recenter is true, the of the google map gets called with the current lat/lng values or fitBounds value to recenter the map.
     * Returns a promise that gets resolved after the event was triggered.
     */
    /**
       * Triggers a resize event on the google map instance.
       * When recenter is true, the of the google map gets called with the current lat/lng values or fitBounds value to recenter the map.
       * Returns a promise that gets resolved after the event was triggered.
       */
    AgmMap.prototype.triggerResize = /**
       * Triggers a resize event on the google map instance.
       * When recenter is true, the of the google map gets called with the current lat/lng values or fitBounds value to recenter the map.
       * Returns a promise that gets resolved after the event was triggered.
       */
    function (recenter) {
        var _this = this;
        if (recenter === void 0) { recenter = true; }
        // Note: When we would trigger the resize event and show the map in the same turn (which is a
        // common case for triggering a resize event), then the resize event would not
        // work (to show the map), so we trigger the event in a timeout.
        return new Promise(function (resolve) {
            setTimeout(function () {
                return _this._mapsWrapper.triggerMapEvent('resize').then(function () {
                    if (recenter) {
                        _this.fitBounds != null ? _this._fitBounds() : _this._setCenter();
                    }
                    resolve();
                });
            });
        });
    };
    AgmMap.prototype._updatePosition = function (changes) {
        if (changes['latitude'] == null && changes['longitude'] == null &&
            changes['fitBounds'] == null) {
            // no position update needed
            return;
        }
        // we prefer fitBounds in changes
        if (changes['fitBounds'] && this.fitBounds != null) {
            this._fitBounds();
            return;
        }
        if (typeof this.latitude !== 'number' || typeof this.longitude !== 'number') {
            return;
        }
        this._setCenter();
    };
    AgmMap.prototype._setCenter = function () {
        var newCenter = {
            lat: this.latitude,
            lng: this.longitude,
        };
        if (this.usePanning) {
            this._mapsWrapper.panTo(newCenter);
        }
        else {
            this._mapsWrapper.setCenter(newCenter);
        }
    };
    AgmMap.prototype._fitBounds = function () {
        if (this.usePanning) {
            this._mapsWrapper.panToBounds(this.fitBounds);
            return;
        }
        this._mapsWrapper.fitBounds(this.fitBounds);
    };
    AgmMap.prototype._handleMapCenterChange = function () {
        var _this = this;
        var s = this._mapsWrapper.subscribeToMapEvent('center_changed').subscribe(function () {
            _this._mapsWrapper.getCenter().then(function (center) {
                _this.latitude = center.lat();
                _this.longitude = center.lng();
                _this.centerChange.emit({ lat: _this.latitude, lng: _this.longitude });
            });
        });
        this._observableSubscriptions.push(s);
    };
    AgmMap.prototype._handleBoundsChange = function () {
        var _this = this;
        var s = this._mapsWrapper.subscribeToMapEvent('bounds_changed').subscribe(function () {
            _this._mapsWrapper.getBounds().then(function (bounds) { _this.boundsChange.emit(bounds); });
        });
        this._observableSubscriptions.push(s);
    };
    AgmMap.prototype._handleMapTypeIdChange = function () {
        var _this = this;
        var s = this._mapsWrapper.subscribeToMapEvent('maptypeid_changed').subscribe(function () {
            _this._mapsWrapper.getMapTypeId().then(function (mapTypeId) { _this.mapTypeIdChange.emit(mapTypeId); });
        });
        this._observableSubscriptions.push(s);
    };
    AgmMap.prototype._handleMapZoomChange = function () {
        var _this = this;
        var s = this._mapsWrapper.subscribeToMapEvent('zoom_changed').subscribe(function () {
            _this._mapsWrapper.getZoom().then(function (z) {
                _this.zoom = z;
                _this.zoomChange.emit(z);
            });
        });
        this._observableSubscriptions.push(s);
    };
    AgmMap.prototype._handleIdleEvent = function () {
        var _this = this;
        var s = this._mapsWrapper.subscribeToMapEvent('idle').subscribe(function () { _this.idle.emit(void 0); });
        this._observableSubscriptions.push(s);
    };
    AgmMap.prototype._handleMapMouseEvents = function () {
        var _this = this;
        var events = [
            { name: 'click', emitter: this.mapClick },
            { name: 'rightclick', emitter: this.mapRightClick },
            { name: 'dblclick', emitter: this.mapDblClick },
        ];
        events.forEach(function (e) {
            var s = _this._mapsWrapper.subscribeToMapEvent(e.name).subscribe(function (event) {
                var value = { coords: { lat: event.latLng.lat(), lng: event.latLng.lng() } };
                e.emitter.emit(value);
            });
            _this._observableSubscriptions.push(s);
        });
    };
    /**
       * Map option attributes that can change over time
       */
    AgmMap._mapOptionsAttributes = [
        'disableDoubleClickZoom', 'scrollwheel', 'draggable', 'draggableCursor', 'draggingCursor',
        'keyboardShortcuts', 'zoomControl', 'zoomControlOptions', 'styles', 'streetViewControl',
        'streetViewControlOptions', 'zoom', 'mapTypeControl', 'mapTypeControlOptions', 'minZoom',
        'maxZoom', 'panControl', 'panControlOptions', 'rotateControl', 'rotateControlOptions',
        'fullscreenControl', 'fullscreenControlOptions', 'scaleControl', 'scaleControlOptions',
        'mapTypeId', 'clickableIcons', 'gestureHandling'
    ];
    AgmMap.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'agm-map',
                    providers: [
                        __WEBPACK_IMPORTED_MODULE_1__services_google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */], __WEBPACK_IMPORTED_MODULE_4__services_managers_marker_manager__["a" /* MarkerManager */], __WEBPACK_IMPORTED_MODULE_3__services_managers_info_window_manager__["a" /* InfoWindowManager */], __WEBPACK_IMPORTED_MODULE_2__services_managers_circle_manager__["a" /* CircleManager */], __WEBPACK_IMPORTED_MODULE_6__services_managers_polyline_manager__["a" /* PolylineManager */],
                        __WEBPACK_IMPORTED_MODULE_5__services_managers_polygon_manager__["a" /* PolygonManager */], __WEBPACK_IMPORTED_MODULE_7__services_managers_kml_layer_manager__["a" /* KmlLayerManager */], __WEBPACK_IMPORTED_MODULE_8__services_managers_data_layer_manager__["a" /* DataLayerManager */]
                    ],
                    host: {
                        // todo: deprecated - we will remove it with the next version
                        '[class.sebm-google-map-container]': 'true'
                    },
                    styles: ["\n    .agm-map-container-inner {\n      width: inherit;\n      height: inherit;\n    }\n    .agm-map-content {\n      display:none;\n    }\n  "],
                    template: "\n    <div class='agm-map-container-inner sebm-google-map-container-inner'></div>\n    <div class='agm-map-content'>\n      <ng-content></ng-content>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    AgmMap.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__services_google_maps_api_wrapper__["a" /* GoogleMapsAPIWrapper */], },
    ]; };
    AgmMap.propDecorators = {
        "longitude": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "latitude": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "zoom": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "minZoom": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "maxZoom": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "draggable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mapDraggable',] },],
        "disableDoubleClickZoom": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "disableDefaultUI": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "scrollwheel": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "backgroundColor": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "draggableCursor": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "draggingCursor": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "keyboardShortcuts": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "zoomControl": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "zoomControlOptions": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "styles": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "usePanning": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "streetViewControl": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "streetViewControlOptions": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "fitBounds": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "scaleControl": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "scaleControlOptions": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "mapTypeControl": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "mapTypeControlOptions": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "panControl": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "panControlOptions": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "rotateControl": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "rotateControlOptions": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "fullscreenControl": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "fullscreenControlOptions": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "mapTypeId": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "clickableIcons": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "gestureHandling": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "mapClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "mapRightClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "mapDblClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "centerChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "boundsChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "mapTypeIdChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "idle": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "zoomChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "mapReady": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return AgmMap;
}());

//# sourceMappingURL=map.js.map

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgmCircle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_managers_circle_manager__ = __webpack_require__(85);


var AgmCircle = /** @class */ (function () {
    function AgmCircle(_manager) {
        this._manager = _manager;
        /**
           * Indicates whether this Circle handles mouse events. Defaults to true.
           */
        this.clickable = true;
        /**
           * If set to true, the user can drag this circle over the map. Defaults to false.
           */
        // tslint:disable-next-line:no-input-rename
        this.draggable = false;
        /**
           * If set to true, the user can edit this circle by dragging the control points shown at
           * the center and around the circumference of the circle. Defaults to false.
           */
        this.editable = false;
        /**
           * The radius in meters on the Earth's surface.
           */
        this.radius = 0;
        /**
           * The stroke position. Defaults to CENTER.
           * This property is not supported on Internet Explorer 8 and earlier.
           */
        this.strokePosition = 'CENTER';
        /**
           * The stroke width in pixels.
           */
        this.strokeWeight = 0;
        /**
           * Whether this circle is visible on the map. Defaults to true.
           */
        this.visible = true;
        /**
           * This event is fired when the circle's center is changed.
           */
        this.centerChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event emitter gets emitted when the user clicks on the circle.
           */
        this.circleClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event emitter gets emitted when the user clicks on the circle.
           */
        this.circleDblClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is repeatedly fired while the user drags the circle.
           */
        this.drag = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the user stops dragging the circle.
           */
        this.dragEnd = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the user starts dragging the circle.
           */
        this.dragStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the DOM mousedown event is fired on the circle.
           */
        this.mouseDown = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the DOM mousemove event is fired on the circle.
           */
        this.mouseMove = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired on circle mouseout.
           */
        this.mouseOut = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired on circle mouseover.
           */
        this.mouseOver = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the DOM mouseup event is fired on the circle.
           */
        this.mouseUp = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the circle's radius is changed.
           */
        this.radiusChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the circle is right-clicked on.
           */
        this.rightClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._circleAddedToManager = false;
        this._eventSubscriptions = [];
    }
    /** @internal */
    /** @internal */
    AgmCircle.prototype.ngOnInit = /** @internal */
    function () {
        this._manager.addCircle(this);
        this._circleAddedToManager = true;
        this._registerEventListeners();
    };
    /** @internal */
    /** @internal */
    AgmCircle.prototype.ngOnChanges = /** @internal */
    function (changes) {
        if (!this._circleAddedToManager) {
            return;
        }
        if (changes['latitude'] || changes['longitude']) {
            this._manager.setCenter(this);
        }
        if (changes['editable']) {
            this._manager.setEditable(this);
        }
        if (changes['draggable']) {
            this._manager.setDraggable(this);
        }
        if (changes['visible']) {
            this._manager.setVisible(this);
        }
        if (changes['radius']) {
            this._manager.setRadius(this);
        }
        this._updateCircleOptionsChanges(changes);
    };
    AgmCircle.prototype._updateCircleOptionsChanges = function (changes) {
        var options = {};
        var optionKeys = Object.keys(changes).filter(function (k) { return AgmCircle._mapOptions.indexOf(k) !== -1; });
        optionKeys.forEach(function (k) { options[k] = changes[k].currentValue; });
        if (optionKeys.length > 0) {
            this._manager.setOptions(this, options);
        }
    };
    AgmCircle.prototype._registerEventListeners = function () {
        var _this = this;
        var events = new Map();
        events.set('center_changed', this.centerChange);
        events.set('click', this.circleClick);
        events.set('dblclick', this.circleDblClick);
        events.set('drag', this.drag);
        events.set('dragend', this.dragEnd);
        events.set('dragStart', this.dragStart);
        events.set('mousedown', this.mouseDown);
        events.set('mousemove', this.mouseMove);
        events.set('mouseout', this.mouseOut);
        events.set('mouseover', this.mouseOver);
        events.set('mouseup', this.mouseUp);
        events.set('radius_changed', this.radiusChange);
        events.set('rightclick', this.rightClick);
        events.forEach(function (eventEmitter, eventName) {
            _this._eventSubscriptions.push(_this._manager.createEventObservable(eventName, _this).subscribe(function (value) {
                switch (eventName) {
                    case 'radius_changed':
                        _this._manager.getRadius(_this).then(function (radius) { return eventEmitter.emit(radius); });
                        break;
                    case 'center_changed':
                        _this._manager.getCenter(_this).then(function (center) {
                            return eventEmitter.emit({ lat: center.lat(), lng: center.lng() });
                        });
                        break;
                    default:
                        eventEmitter.emit({ coords: { lat: value.latLng.lat(), lng: value.latLng.lng() } });
                }
            }));
        });
    };
    /** @internal */
    /** @internal */
    AgmCircle.prototype.ngOnDestroy = /** @internal */
    function () {
        this._eventSubscriptions.forEach(function (s) { s.unsubscribe(); });
        this._eventSubscriptions = null;
        this._manager.removeCircle(this);
    };
    /**
     * Gets the LatLngBounds of this Circle.
     */
    /**
       * Gets the LatLngBounds of this Circle.
       */
    AgmCircle.prototype.getBounds = /**
       * Gets the LatLngBounds of this Circle.
       */
    function () { return this._manager.getBounds(this); };
    AgmCircle.prototype.getCenter = function () { return this._manager.getCenter(this); };
    AgmCircle._mapOptions = [
        'fillColor', 'fillOpacity', 'strokeColor', 'strokeOpacity', 'strokePosition', 'strokeWeight',
        'visible', 'zIndex', 'clickable'
    ];
    AgmCircle.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'agm-circle'
                },] },
    ];
    /** @nocollapse */
    AgmCircle.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__services_managers_circle_manager__["a" /* CircleManager */], },
    ]; };
    AgmCircle.propDecorators = {
        "latitude": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "longitude": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "clickable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "draggable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['circleDraggable',] },],
        "editable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "fillColor": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "fillOpacity": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "radius": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "strokeColor": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "strokeOpacity": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "strokePosition": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "strokeWeight": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "visible": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "zIndex": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "centerChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "circleClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "circleDblClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "drag": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "dragEnd": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "dragStart": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "mouseDown": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "mouseMove": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "mouseOut": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "mouseOver": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "mouseUp": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "radiusChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "rightClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return AgmCircle;
}());

//# sourceMappingURL=circle.js.map

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgmKmlLayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_managers_kml_layer_manager__ = __webpack_require__(89);


var layerId = 0;
var AgmKmlLayer = /** @class */ (function () {
    function AgmKmlLayer(_manager) {
        this._manager = _manager;
        this._addedToManager = false;
        this._id = (layerId++).toString();
        this._subscriptions = [];
        /**
           * If true, the layer receives mouse events. Default value is true.
           */
        this.clickable = true;
        /**
           * By default, the input map is centered and zoomed to the bounding box of the contents of the
           * layer.
           * If this option is set to true, the viewport is left unchanged, unless the map's center and zoom
           * were never set.
           */
        this.preserveViewport = false;
        /**
           * Whether to render the screen overlays. Default true.
           */
        this.screenOverlays = true;
        /**
           * Suppress the rendering of info windows when layer features are clicked.
           */
        this.suppressInfoWindows = false;
        /**
           * The URL of the KML document to display.
           */
        this.url = null;
        /**
           * The z-index of the layer.
           */
        this.zIndex = null;
        /**
           * This event is fired when a feature in the layer is clicked.
           */
        this.layerClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the KML layers default viewport has changed.
           */
        this.defaultViewportChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the KML layer has finished loading.
           * At this point it is safe to read the status property to determine if the layer loaded
           * successfully.
           */
        this.statusChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    AgmKmlLayer.prototype.ngOnInit = function () {
        if (this._addedToManager) {
            return;
        }
        this._manager.addKmlLayer(this);
        this._addedToManager = true;
        this._addEventListeners();
    };
    AgmKmlLayer.prototype.ngOnChanges = function (changes) {
        if (!this._addedToManager) {
            return;
        }
        this._updatePolygonOptions(changes);
    };
    AgmKmlLayer.prototype._updatePolygonOptions = function (changes) {
        var options = Object.keys(changes)
            .filter(function (k) { return AgmKmlLayer._kmlLayerOptions.indexOf(k) !== -1; })
            .reduce(function (obj, k) {
            obj[k] = changes[k].currentValue;
            return obj;
        }, {});
        if (Object.keys(options).length > 0) {
            this._manager.setOptions(this, options);
        }
    };
    AgmKmlLayer.prototype._addEventListeners = function () {
        var _this = this;
        var listeners = [
            { name: 'click', handler: function (ev) { return _this.layerClick.emit(ev); } },
            { name: 'defaultviewport_changed', handler: function () { return _this.defaultViewportChange.emit(); } },
            { name: 'status_changed', handler: function () { return _this.statusChange.emit(); } },
        ];
        listeners.forEach(function (obj) {
            var os = _this._manager.createEventObservable(obj.name, _this).subscribe(obj.handler);
            _this._subscriptions.push(os);
        });
    };
    /** @internal */
    /** @internal */
    AgmKmlLayer.prototype.id = /** @internal */
    function () { return this._id; };
    /** @internal */
    /** @internal */
    AgmKmlLayer.prototype.toString = /** @internal */
    function () { return "AgmKmlLayer-" + this._id.toString(); };
    /** @internal */
    /** @internal */
    AgmKmlLayer.prototype.ngOnDestroy = /** @internal */
    function () {
        this._manager.deleteKmlLayer(this);
        // unsubscribe all registered observable subscriptions
        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    AgmKmlLayer._kmlLayerOptions = ['clickable', 'preserveViewport', 'screenOverlays', 'suppressInfoWindows', 'url', 'zIndex'];
    AgmKmlLayer.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'agm-kml-layer'
                },] },
    ];
    /** @nocollapse */
    AgmKmlLayer.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__services_managers_kml_layer_manager__["a" /* KmlLayerManager */], },
    ]; };
    AgmKmlLayer.propDecorators = {
        "clickable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "preserveViewport": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "screenOverlays": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "suppressInfoWindows": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "url": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "zIndex": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "layerClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "defaultViewportChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "statusChange": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return AgmKmlLayer;
}());

//# sourceMappingURL=kml-layer.js.map

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgmDataLayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_managers_data_layer_manager__ = __webpack_require__(90);


var layerId = 0;
/**
 * AgmDataLayer enables the user to add data layers to the map.
 *
 * ### Example
 * ```typescript
 * import { Component } from 'angular2/core';
 * import { AgmMap, AgmDataLayer } from
 * 'angular-google-maps/core';
 *
 * @Component({
 *  selector: 'my-map-cmp',
 *  directives: [AgmMap, AgmDataLayer],
 *  styles: [`
 *    .agm-container {
 *      height: 300px;
 *    }
 * `],
 *  template: `
 * <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
 * 	  <agm-data-layer [geoJson]="geoJsonObject" (layerClick)="clicked($event)" [style]="styleFunc">
 * 	  </agm-data-layer>
 * </agm-map>
 *  `
 * })
 * export class MyMapCmp {
 *   lat: number = -25.274449;
 *   lng: number = 133.775060;
 *   zoom: number = 5;
 *
 * clicked(clickEvent) {
 *    console.log(clickEvent);
 *  }
 *
 *  styleFunc(feature) {
 *    return ({
 *      clickable: false,
 *      fillColor: feature.getProperty('color'),
 *      strokeWeight: 1
 *    });
 *  }
 *
 *  geoJsonObject: Object = {
 *    "type": "FeatureCollection",
 *    "features": [
 *      {
 *        "type": "Feature",
 *        "properties": {
 *          "letter": "G",
 *          "color": "blue",
 *          "rank": "7",
 *          "ascii": "71"
 *        },
 *        "geometry": {
 *          "type": "Polygon",
 *          "coordinates": [
 *            [
 *              [123.61, -22.14], [122.38, -21.73], [121.06, -21.69], [119.66, -22.22], [119.00, -23.40],
 *              [118.65, -24.76], [118.43, -26.07], [118.78, -27.56], [119.22, -28.57], [120.23, -29.49],
 *              [121.77, -29.87], [123.57, -29.64], [124.45, -29.03], [124.71, -27.95], [124.80, -26.70],
 *              [124.80, -25.60], [123.61, -25.64], [122.56, -25.64], [121.72, -25.72], [121.81, -26.62],
 *              [121.86, -26.98], [122.60, -26.90], [123.57, -27.05], [123.57, -27.68], [123.35, -28.18],
 *              [122.51, -28.38], [121.77, -28.26], [121.02, -27.91], [120.49, -27.21], [120.14, -26.50],
 *              [120.10, -25.64], [120.27, -24.52], [120.67, -23.68], [121.72, -23.32], [122.43, -23.48],
 *              [123.04, -24.04], [124.54, -24.28], [124.58, -23.20], [123.61, -22.14]
 *            ]
 *          ]
 *        }
 *      },
 *      {
 *        "type": "Feature",
 *        "properties": {
 *          "letter": "o",
 *          "color": "red",
 *          "rank": "15",
 *          "ascii": "111"
 *        },
 *        "geometry": {
 *          "type": "Polygon",
 *          "coordinates": [
 *            [
 *              [128.84, -25.76], [128.18, -25.60], [127.96, -25.52], [127.88, -25.52], [127.70, -25.60],
 *              [127.26, -25.79], [126.60, -26.11], [126.16, -26.78], [126.12, -27.68], [126.21, -28.42],
 *              [126.69, -29.49], [127.74, -29.80], [128.80, -29.72], [129.41, -29.03], [129.72, -27.95],
 *              [129.68, -27.21], [129.33, -26.23], [128.84, -25.76]
 *            ],
 *            [
 *              [128.45, -27.44], [128.32, -26.94], [127.70, -26.82], [127.35, -27.05], [127.17, -27.80],
 *              [127.57, -28.22], [128.10, -28.42], [128.49, -27.80], [128.45, -27.44]
 *            ]
 *          ]
 *        }
 *      },
 *      {
 *        "type": "Feature",
 *        "properties": {
 *          "letter": "o",
 *          "color": "yellow",
 *          "rank": "15",
 *          "ascii": "111"
 *        },
 *        "geometry": {
 *          "type": "Polygon",
 *          "coordinates": [
 *            [
 *              [131.87, -25.76], [131.35, -26.07], [130.95, -26.78], [130.82, -27.64], [130.86, -28.53],
 *              [131.26, -29.22], [131.92, -29.76], [132.45, -29.87], [133.06, -29.76], [133.72, -29.34],
 *              [134.07, -28.80], [134.20, -27.91], [134.07, -27.21], [133.81, -26.31], [133.37, -25.83],
 *              [132.71, -25.64], [131.87, -25.76]
 *            ],
 *            [
 *              [133.15, -27.17], [132.71, -26.86], [132.09, -26.90], [131.74, -27.56], [131.79, -28.26],
 *              [132.36, -28.45], [132.93, -28.34], [133.15, -27.76], [133.15, -27.17]
 *            ]
 *          ]
 *        }
 *      },
 *      {
 *        "type": "Feature",
 *        "properties": {
 *          "letter": "g",
 *          "color": "blue",
 *          "rank": "7",
 *          "ascii": "103"
 *        },
 *        "geometry": {
 *          "type": "Polygon",
 *          "coordinates": [
 *            [
 *              [138.12, -25.04], [136.84, -25.16], [135.96, -25.36], [135.26, -25.99], [135, -26.90],
 *              [135.04, -27.91], [135.26, -28.88], [136.05, -29.45], [137.02, -29.49], [137.81, -29.49],
 *              [137.94, -29.99], [137.90, -31.20], [137.85, -32.24], [136.88, -32.69], [136.45, -32.36],
 *              [136.27, -31.80], [134.95, -31.84], [135.17, -32.99], [135.52, -33.43], [136.14, -33.76],
 *              [137.06, -33.83], [138.12, -33.65], [138.86, -33.21], [139.30, -32.28], [139.30, -31.24],
 *              [139.30, -30.14], [139.21, -28.96], [139.17, -28.22], [139.08, -27.41], [139.08, -26.47],
 *              [138.99, -25.40], [138.73, -25.00], [138.12, -25.04]
 *            ],
 *            [
 *              [137.50, -26.54], [136.97, -26.47], [136.49, -26.58], [136.31, -27.13], [136.31, -27.72],
 *              [136.58, -27.99], [137.50, -28.03], [137.68, -27.68], [137.59, -26.78], [137.50, -26.54]
 *            ]
 *          ]
 *        }
 *      },
 *      {
 *        "type": "Feature",
 *        "properties": {
 *          "letter": "l",
 *          "color": "green",
 *          "rank": "12",
 *          "ascii": "108"
 *        },
 *        "geometry": {
 *          "type": "Polygon",
 *          "coordinates": [
 *            [
 *              [140.14, -21.04], [140.31, -29.42], [141.67, -29.49], [141.59, -20.92], [140.14, -21.04]
 *            ]
 *          ]
 *        }
 *      },
 *      {
 *        "type": "Feature",
 *        "properties": {
 *          "letter": "e",
 *          "color": "red",
 *          "rank": "5",
 *          "ascii": "101"
 *        },
 *        "geometry": {
 *          "type": "Polygon",
 *          "coordinates": [
 *            [
 *              [144.14, -27.41], [145.67, -27.52], [146.86, -27.09], [146.82, -25.64], [146.25, -25.04],
 *              [145.45, -24.68], [144.66, -24.60], [144.09, -24.76], [143.43, -25.08], [142.99, -25.40],
 *              [142.64, -26.03], [142.64, -27.05], [142.64, -28.26], [143.30, -29.11], [144.18, -29.57],
 *              [145.41, -29.64], [146.46, -29.19], [146.64, -28.72], [146.82, -28.14], [144.84, -28.42],
 *              [144.31, -28.26], [144.14, -27.41]
 *            ],
 *            [
 *              [144.18, -26.39], [144.53, -26.58], [145.19, -26.62], [145.72, -26.35], [145.81, -25.91],
 *              [145.41, -25.68], [144.97, -25.68], [144.49, -25.64], [144, -25.99], [144.18, -26.39]
 *            ]
 *          ]
 *        }
 *      }
 *    ]
 *  };
 * }
 * ```
 */
var AgmDataLayer = /** @class */ (function () {
    function AgmDataLayer(_manager) {
        this._manager = _manager;
        this._addedToManager = false;
        this._id = (layerId++).toString();
        this._subscriptions = [];
        /**
           * This event is fired when a feature in the layer is clicked.
           */
        this.layerClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * The geoJson to be displayed
           */
        this.geoJson = null;
    }
    AgmDataLayer.prototype.ngOnInit = function () {
        if (this._addedToManager) {
            return;
        }
        this._manager.addDataLayer(this);
        this._addedToManager = true;
        this._addEventListeners();
    };
    AgmDataLayer.prototype._addEventListeners = function () {
        var _this = this;
        var listeners = [
            { name: 'click', handler: function (ev) { return _this.layerClick.emit(ev); } },
        ];
        listeners.forEach(function (obj) {
            var os = _this._manager.createEventObservable(obj.name, _this).subscribe(obj.handler);
            _this._subscriptions.push(os);
        });
    };
    /** @internal */
    /** @internal */
    AgmDataLayer.prototype.id = /** @internal */
    function () { return this._id; };
    /** @internal */
    /** @internal */
    AgmDataLayer.prototype.toString = /** @internal */
    function () { return "AgmDataLayer-" + this._id.toString(); };
    /** @internal */
    /** @internal */
    AgmDataLayer.prototype.ngOnDestroy = /** @internal */
    function () {
        this._manager.deleteDataLayer(this);
        // unsubscribe all registered observable subscriptions
        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    /** @internal */
    /** @internal */
    AgmDataLayer.prototype.ngOnChanges = /** @internal */
    function (changes) {
        var _this = this;
        if (!this._addedToManager) {
            return;
        }
        var geoJsonChange = changes['geoJson'];
        if (geoJsonChange) {
            this._manager.updateGeoJson(this, geoJsonChange.currentValue);
        }
        var dataOptions = {};
        AgmDataLayer._dataOptionsAttributes.forEach(function (k) { return dataOptions[k] = changes.hasOwnProperty(k) ? changes[k].currentValue : _this[k]; });
        this._manager.setDataOptions(this, dataOptions);
    };
    AgmDataLayer._dataOptionsAttributes = ['style'];
    AgmDataLayer.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'agm-data-layer'
                },] },
    ];
    /** @nocollapse */
    AgmDataLayer.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__services_managers_data_layer_manager__["a" /* DataLayerManager */], },
    ]; };
    AgmDataLayer.propDecorators = {
        "layerClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "geoJson": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "style": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return AgmDataLayer;
}());

//# sourceMappingURL=data-layer.js.map

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgmMarker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_managers_marker_manager__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__info_window__ = __webpack_require__(91);



var markerId = 0;
/**
 * AgmMarker renders a map marker inside a {@link AgmMap}.
 *
 * ### Example
 * ```typescript
 * import { Component } from '@angular/core';
 *
 * @Component({
 *  selector: 'my-map-cmp',
 *  styles: [`
 *    .agm-map-container {
 *      height: 300px;
 *    }
 * `],
 *  template: `
 *    <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
 *      <agm-marker [latitude]="lat" [longitude]="lng" [label]="'M'">
 *      </agm-marker>
 *    </agm-map>
 *  `
 * })
 * ```
 */
var AgmMarker = /** @class */ (function () {
    function AgmMarker(_markerManager) {
        this._markerManager = _markerManager;
        /**
           * If true, the marker can be dragged. Default value is false.
           */
        // tslint:disable-next-line:no-input-rename
        this.draggable = false;
        /**
           * If true, the marker is visible
           */
        this.visible = true;
        /**
           * Whether to automatically open the child info window when the marker is clicked.
           */
        this.openInfoWindow = true;
        /**
           * The marker's opacity between 0.0 and 1.0.
           */
        this.opacity = 1;
        /**
           * All markers are displayed on the map in order of their zIndex, with higher values displaying in
           * front of markers with lower values. By default, markers are displayed according to their
           * vertical position on screen, with lower markers appearing in front of markers further up the
           * screen.
           */
        this.zIndex = 1;
        /**
           * If true, the marker can be clicked. Default value is true.
           */
        // tslint:disable-next-line:no-input-rename
        this.clickable = true;
        /**
           * This event emitter gets emitted when the user clicks on the marker.
           */
        this.markerClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the user stops dragging the marker.
           */
        this.dragEnd = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the user mouses over the marker.
           */
        this.mouseOver = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the user mouses outside the marker.
           */
        this.mouseOut = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * @internal
           */
        this.infoWindow = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["QueryList"]();
        this._markerAddedToManger = false;
        this._observableSubscriptions = [];
        this._id = (markerId++).toString();
    }
    /* @internal */
    /* @internal */
    AgmMarker.prototype.ngAfterContentInit = /* @internal */
    function () {
        var _this = this;
        this.handleInfoWindowUpdate();
        this.infoWindow.changes.subscribe(function () { return _this.handleInfoWindowUpdate(); });
    };
    AgmMarker.prototype.handleInfoWindowUpdate = function () {
        var _this = this;
        if (this.infoWindow.length > 1) {
            throw new Error('Expected no more than one info window.');
        }
        this.infoWindow.forEach(function (marker) {
            marker.hostMarker = _this;
        });
    };
    /** @internal */
    /** @internal */
    AgmMarker.prototype.ngOnChanges = /** @internal */
    function (changes) {
        if (typeof this.latitude !== 'number' || typeof this.longitude !== 'number') {
            return;
        }
        if (!this._markerAddedToManger) {
            this._markerManager.addMarker(this);
            this._markerAddedToManger = true;
            this._addEventListeners();
            return;
        }
        if (changes['latitude'] || changes['longitude']) {
            this._markerManager.updateMarkerPosition(this);
        }
        if (changes['title']) {
            this._markerManager.updateTitle(this);
        }
        if (changes['label']) {
            this._markerManager.updateLabel(this);
        }
        if (changes['draggable']) {
            this._markerManager.updateDraggable(this);
        }
        if (changes['iconUrl']) {
            this._markerManager.updateIcon(this);
        }
        if (changes['opacity']) {
            this._markerManager.updateOpacity(this);
        }
        if (changes['visible']) {
            this._markerManager.updateVisible(this);
        }
        if (changes['zIndex']) {
            this._markerManager.updateZIndex(this);
        }
        if (changes['clickable']) {
            this._markerManager.updateClickable(this);
        }
        if (changes['animation']) {
            this._markerManager.updateAnimation(this);
        }
    };
    AgmMarker.prototype._addEventListeners = function () {
        var _this = this;
        var cs = this._markerManager.createEventObservable('click', this).subscribe(function () {
            if (_this.openInfoWindow) {
                _this.infoWindow.forEach(function (infoWindow) { return infoWindow.open(); });
            }
            _this.markerClick.emit(null);
        });
        this._observableSubscriptions.push(cs);
        var ds = this._markerManager.createEventObservable('dragend', this)
            .subscribe(function (e) {
            _this.dragEnd.emit({ coords: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
        });
        this._observableSubscriptions.push(ds);
        var mover = this._markerManager.createEventObservable('mouseover', this)
            .subscribe(function (e) {
            _this.mouseOver.emit({ coords: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
        });
        this._observableSubscriptions.push(mover);
        var mout = this._markerManager.createEventObservable('mouseout', this)
            .subscribe(function (e) {
            _this.mouseOut.emit({ coords: { lat: e.latLng.lat(), lng: e.latLng.lng() } });
        });
        this._observableSubscriptions.push(mout);
    };
    /** @internal */
    /** @internal */
    AgmMarker.prototype.id = /** @internal */
    function () { return this._id; };
    /** @internal */
    /** @internal */
    AgmMarker.prototype.toString = /** @internal */
    function () { return 'AgmMarker-' + this._id.toString(); };
    /** @internal */
    /** @internal */
    AgmMarker.prototype.ngOnDestroy = /** @internal */
    function () {
        this._markerManager.deleteMarker(this);
        // unsubscribe all registered observable subscriptions
        this._observableSubscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    AgmMarker.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'agm-marker',
                    inputs: [
                        'latitude', 'longitude', 'title', 'label', 'draggable: markerDraggable', 'iconUrl',
                        'openInfoWindow', 'opacity', 'visible', 'zIndex', 'animation'
                    ],
                    outputs: ['markerClick', 'dragEnd', 'mouseOver', 'mouseOut']
                },] },
    ];
    /** @nocollapse */
    AgmMarker.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__services_managers_marker_manager__["a" /* MarkerManager */], },
    ]; };
    AgmMarker.propDecorators = {
        "latitude": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "longitude": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "title": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "label": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "draggable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['markerDraggable',] },],
        "iconUrl": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "visible": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "openInfoWindow": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "opacity": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "zIndex": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "clickable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['markerClickable',] },],
        "markerClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "dragEnd": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "mouseOver": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "mouseOut": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "infoWindow": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_2__info_window__["a" /* AgmInfoWindow */],] },],
    };
    return AgmMarker;
}());

//# sourceMappingURL=marker.js.map

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgmPolygon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_managers_polygon_manager__ = __webpack_require__(87);


/**
 * AgmPolygon renders a polygon on a {@link AgmMap}
 *
 * ### Example
 * ```typescript
 * import { Component } from '@angular/core';
 *
 * @Component({
 *  selector: 'my-map-cmp',
 *  styles: [`
 *    agm-map {
 *      height: 300px;
 *    }
 * `],
 *  template: `
 *    <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
 *      <agm-polygon [paths]="paths">
 *      </agm-polygon>
 *    </agm-map>
 *  `
 * })
 * export class MyMapCmp {
 *   lat: number = 0;
 *   lng: number = 0;
 *   zoom: number = 10;
 *   paths: Array<LatLngLiteral> = [
 *     { lat: 0,  lng: 10 },
 *     { lat: 0,  lng: 20 },
 *     { lat: 10, lng: 20 },
 *     { lat: 10, lng: 10 },
 *     { lat: 0,  lng: 10 }
 *   ]
 *   // Nesting paths will create a hole where they overlap;
 *   nestedPaths: Array<Array<LatLngLiteral>> = [[
 *     { lat: 0,  lng: 10 },
 *     { lat: 0,  lng: 20 },
 *     { lat: 10, lng: 20 },
 *     { lat: 10, lng: 10 },
 *     { lat: 0,  lng: 10 }
 *   ], [
 *     { lat: 0, lng: 15 },
 *     { lat: 0, lng: 20 },
 *     { lat: 5, lng: 20 },
 *     { lat: 5, lng: 15 },
 *     { lat: 0, lng: 15 }
 *   ]]
 * }
 * ```
 */
var AgmPolygon = /** @class */ (function () {
    function AgmPolygon(_polygonManager) {
        this._polygonManager = _polygonManager;
        /**
           * Indicates whether this Polygon handles mouse events. Defaults to true.
           */
        this.clickable = true;
        /**
           * If set to true, the user can drag this shape over the map. The geodesic
           * property defines the mode of dragging. Defaults to false.
           */
        // tslint:disable-next-line:no-input-rename
        this.draggable = false;
        /**
           * If set to true, the user can edit this shape by dragging the control
           * points shown at the vertices and on each segment. Defaults to false.
           */
        this.editable = false;
        /**
           * When true, edges of the polygon are interpreted as geodesic and will
           * follow the curvature of the Earth. When false, edges of the polygon are
           * rendered as straight lines in screen space. Note that the shape of a
           * geodesic polygon may appear to change when dragged, as the dimensions
           * are maintained relative to the surface of the earth. Defaults to false.
           */
        this.geodesic = false;
        /**
           * The ordered sequence of coordinates that designates a closed loop.
           * Unlike polylines, a polygon may consist of one or more paths.
           *  As a result, the paths property may specify one or more arrays of
           * LatLng coordinates. Paths are closed automatically; do not repeat the
           * first vertex of the path as the last vertex. Simple polygons may be
           * defined using a single array of LatLngs. More complex polygons may
           * specify an array of arrays. Any simple arrays are converted into Arrays.
           * Inserting or removing LatLngs from the Array will automatically update
           * the polygon on the map.
           */
        this.paths = [];
        /**
           * This event is fired when the DOM click event is fired on the Polygon.
           */
        this.polyClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the DOM dblclick event is fired on the Polygon.
           */
        this.polyDblClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is repeatedly fired while the user drags the polygon.
           */
        this.polyDrag = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the user stops dragging the polygon.
           */
        this.polyDragEnd = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the user starts dragging the polygon.
           */
        this.polyDragStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the DOM mousedown event is fired on the Polygon.
           */
        this.polyMouseDown = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the DOM mousemove event is fired on the Polygon.
           */
        this.polyMouseMove = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired on Polygon mouseout.
           */
        this.polyMouseOut = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired on Polygon mouseover.
           */
        this.polyMouseOver = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired whe the DOM mouseup event is fired on the Polygon
           */
        this.polyMouseUp = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This even is fired when the Polygon is right-clicked on.
           */
        this.polyRightClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._polygonAddedToManager = false;
        this._subscriptions = [];
    }
    /** @internal */
    /** @internal */
    AgmPolygon.prototype.ngAfterContentInit = /** @internal */
    function () {
        if (!this._polygonAddedToManager) {
            this._init();
        }
    };
    AgmPolygon.prototype.ngOnChanges = function (changes) {
        if (!this._polygonAddedToManager) {
            this._init();
            return;
        }
        this._polygonManager.setPolygonOptions(this, this._updatePolygonOptions(changes));
    };
    AgmPolygon.prototype._init = function () {
        this._polygonManager.addPolygon(this);
        this._polygonAddedToManager = true;
        this._addEventListeners();
    };
    AgmPolygon.prototype._addEventListeners = function () {
        var _this = this;
        var handlers = [
            { name: 'click', handler: function (ev) { return _this.polyClick.emit(ev); } },
            { name: 'dbclick', handler: function (ev) { return _this.polyDblClick.emit(ev); } },
            { name: 'drag', handler: function (ev) { return _this.polyDrag.emit(ev); } },
            { name: 'dragend', handler: function (ev) { return _this.polyDragEnd.emit(ev); } },
            { name: 'dragstart', handler: function (ev) { return _this.polyDragStart.emit(ev); } },
            { name: 'mousedown', handler: function (ev) { return _this.polyMouseDown.emit(ev); } },
            { name: 'mousemove', handler: function (ev) { return _this.polyMouseMove.emit(ev); } },
            { name: 'mouseout', handler: function (ev) { return _this.polyMouseOut.emit(ev); } },
            { name: 'mouseover', handler: function (ev) { return _this.polyMouseOver.emit(ev); } },
            { name: 'mouseup', handler: function (ev) { return _this.polyMouseUp.emit(ev); } },
            { name: 'rightclick', handler: function (ev) { return _this.polyRightClick.emit(ev); } },
        ];
        handlers.forEach(function (obj) {
            var os = _this._polygonManager.createEventObservable(obj.name, _this).subscribe(obj.handler);
            _this._subscriptions.push(os);
        });
    };
    AgmPolygon.prototype._updatePolygonOptions = function (changes) {
        return Object.keys(changes)
            .filter(function (k) { return AgmPolygon._polygonOptionsAttributes.indexOf(k) !== -1; })
            .reduce(function (obj, k) {
            obj[k] = changes[k].currentValue;
            return obj;
        }, {});
    };
    /** @internal */
    /** @internal */
    AgmPolygon.prototype.id = /** @internal */
    function () { return this._id; };
    /** @internal */
    /** @internal */
    AgmPolygon.prototype.ngOnDestroy = /** @internal */
    function () {
        this._polygonManager.deletePolygon(this);
        // unsubscribe all registered observable subscriptions
        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    AgmPolygon._polygonOptionsAttributes = [
        'clickable', 'draggable', 'editable', 'fillColor', 'fillOpacity', 'geodesic', 'icon', 'map',
        'paths', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'visible', 'zIndex', 'draggable',
        'editable', 'visible'
    ];
    AgmPolygon.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'agm-polygon'
                },] },
    ];
    /** @nocollapse */
    AgmPolygon.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__services_managers_polygon_manager__["a" /* PolygonManager */], },
    ]; };
    AgmPolygon.propDecorators = {
        "clickable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "draggable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['polyDraggable',] },],
        "editable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "fillColor": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "fillOpacity": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "geodesic": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "paths": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "strokeColor": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "strokeOpacity": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "strokeWeight": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "visible": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "zIndex": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "polyClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "polyDblClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "polyDrag": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "polyDragEnd": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "polyDragStart": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "polyMouseDown": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "polyMouseMove": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "polyMouseOut": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "polyMouseOver": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "polyMouseUp": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "polyRightClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return AgmPolygon;
}());

//# sourceMappingURL=polygon.js.map

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgmPolyline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_managers_polyline_manager__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polyline_point__ = __webpack_require__(92);



var polylineId = 0;
/**
 * AgmPolyline renders a polyline on a {@link AgmMap}
 *
 * ### Example
 * ```typescript
 * import { Component } from '@angular/core';
 *
 * @Component({
 *  selector: 'my-map-cmp',
 *  styles: [`
 *    .agm-map-container {
 *      height: 300px;
 *    }
 * `],
 *  template: `
 *    <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
 *      <agm-polyline>
 *          <agm-polyline-point [latitude]="latA" [longitude]="lngA">
 *          </agm-polyline-point>
 *          <agm-polyline-point [latitude]="latB" [longitude]="lngB">
 *          </agm-polyline-point>
 *      </agm-polyline>
 *    </agm-map>
 *  `
 * })
 * ```
 */
var AgmPolyline = /** @class */ (function () {
    function AgmPolyline(_polylineManager) {
        this._polylineManager = _polylineManager;
        /**
           * Indicates whether this Polyline handles mouse events. Defaults to true.
           */
        this.clickable = true;
        /**
           * If set to true, the user can drag this shape over the map. The geodesic property defines the
           * mode of dragging. Defaults to false.
           */
        // tslint:disable-next-line:no-input-rename
        this.draggable = false;
        /**
           * If set to true, the user can edit this shape by dragging the control points shown at the
           * vertices and on each segment. Defaults to false.
           */
        this.editable = false;
        /**
           * When true, edges of the polygon are interpreted as geodesic and will follow the curvature of
           * the Earth. When false, edges of the polygon are rendered as straight lines in screen space.
           * Note that the shape of a geodesic polygon may appear to change when dragged, as the dimensions
           * are maintained relative to the surface of the earth. Defaults to false.
           */
        this.geodesic = false;
        /**
           * Whether this polyline is visible on the map. Defaults to true.
           */
        this.visible = true;
        /**
           * This event is fired when the DOM click event is fired on the Polyline.
           */
        this.lineClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the DOM dblclick event is fired on the Polyline.
           */
        this.lineDblClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is repeatedly fired while the user drags the polyline.
           */
        this.lineDrag = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the user stops dragging the polyline.
           */
        this.lineDragEnd = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the user starts dragging the polyline.
           */
        this.lineDragStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the DOM mousedown event is fired on the Polyline.
           */
        this.lineMouseDown = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired when the DOM mousemove event is fired on the Polyline.
           */
        this.lineMouseMove = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired on Polyline mouseout.
           */
        this.lineMouseOut = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired on Polyline mouseover.
           */
        this.lineMouseOver = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This event is fired whe the DOM mouseup event is fired on the Polyline
           */
        this.lineMouseUp = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
           * This even is fired when the Polyline is right-clicked on.
           */
        this.lineRightClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._polylineAddedToManager = false;
        this._subscriptions = [];
        this._id = (polylineId++).toString();
    }
    /** @internal */
    /** @internal */
    AgmPolyline.prototype.ngAfterContentInit = /** @internal */
    function () {
        var _this = this;
        if (this.points.length) {
            this.points.forEach(function (point) {
                var s = point.positionChanged.subscribe(function () { _this._polylineManager.updatePolylinePoints(_this); });
                _this._subscriptions.push(s);
            });
        }
        if (!this._polylineAddedToManager) {
            this._init();
        }
        var s = this.points.changes.subscribe(function () { return _this._polylineManager.updatePolylinePoints(_this); });
        this._subscriptions.push(s);
        this._polylineManager.updatePolylinePoints(this);
    };
    AgmPolyline.prototype.ngOnChanges = function (changes) {
        if (!this._polylineAddedToManager) {
            this._init();
            return;
        }
        var options = {};
        var optionKeys = Object.keys(changes).filter(function (k) { return AgmPolyline._polylineOptionsAttributes.indexOf(k) !== -1; });
        optionKeys.forEach(function (k) { return options[k] = changes[k].currentValue; });
        this._polylineManager.setPolylineOptions(this, options);
    };
    AgmPolyline.prototype._init = function () {
        this._polylineManager.addPolyline(this);
        this._polylineAddedToManager = true;
        this._addEventListeners();
    };
    AgmPolyline.prototype._addEventListeners = function () {
        var _this = this;
        var handlers = [
            { name: 'click', handler: function (ev) { return _this.lineClick.emit(ev); } },
            { name: 'dblclick', handler: function (ev) { return _this.lineDblClick.emit(ev); } },
            { name: 'drag', handler: function (ev) { return _this.lineDrag.emit(ev); } },
            { name: 'dragend', handler: function (ev) { return _this.lineDragEnd.emit(ev); } },
            { name: 'dragstart', handler: function (ev) { return _this.lineDragStart.emit(ev); } },
            { name: 'mousedown', handler: function (ev) { return _this.lineMouseDown.emit(ev); } },
            { name: 'mousemove', handler: function (ev) { return _this.lineMouseMove.emit(ev); } },
            { name: 'mouseout', handler: function (ev) { return _this.lineMouseOut.emit(ev); } },
            { name: 'mouseover', handler: function (ev) { return _this.lineMouseOver.emit(ev); } },
            { name: 'mouseup', handler: function (ev) { return _this.lineMouseUp.emit(ev); } },
            { name: 'rightclick', handler: function (ev) { return _this.lineRightClick.emit(ev); } },
        ];
        handlers.forEach(function (obj) {
            var os = _this._polylineManager.createEventObservable(obj.name, _this).subscribe(obj.handler);
            _this._subscriptions.push(os);
        });
    };
    /** @internal */
    /** @internal */
    AgmPolyline.prototype._getPoints = /** @internal */
    function () {
        if (this.points) {
            return this.points.toArray();
        }
        return [];
    };
    /** @internal */
    /** @internal */
    AgmPolyline.prototype.id = /** @internal */
    function () { return this._id; };
    /** @internal */
    /** @internal */
    AgmPolyline.prototype.ngOnDestroy = /** @internal */
    function () {
        this._polylineManager.deletePolyline(this);
        // unsubscribe all registered observable subscriptions
        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    AgmPolyline._polylineOptionsAttributes = [
        'draggable', 'editable', 'visible', 'geodesic', 'strokeColor', 'strokeOpacity', 'strokeWeight',
        'zIndex'
    ];
    AgmPolyline.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'agm-polyline'
                },] },
    ];
    /** @nocollapse */
    AgmPolyline.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__services_managers_polyline_manager__["a" /* PolylineManager */], },
    ]; };
    AgmPolyline.propDecorators = {
        "clickable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "draggable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['polylineDraggable',] },],
        "editable": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "geodesic": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "strokeColor": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "strokeOpacity": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "strokeWeight": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "visible": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "zIndex": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        "lineClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "lineDblClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "lineDrag": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "lineDragEnd": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "lineDragStart": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "lineMouseDown": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "lineMouseMove": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "lineMouseOut": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "lineMouseOver": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "lineMouseUp": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "lineRightClick": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        "points": [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__WEBPACK_IMPORTED_MODULE_2__polyline_point__["a" /* AgmPolylinePoint */],] },],
    };
    return AgmPolyline;
}());

//# sourceMappingURL=polyline.js.map

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WindowRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DocumentRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BROWSER_GLOBALS_PROVIDERS; });
var WindowRef = /** @class */ (function () {
    function WindowRef() {
    }
    WindowRef.prototype.getNativeWindow = function () { return window; };
    return WindowRef;
}());

var DocumentRef = /** @class */ (function () {
    function DocumentRef() {
    }
    DocumentRef.prototype.getNativeDocument = function () { return document; };
    return DocumentRef;
}());

var BROWSER_GLOBALS_PROVIDERS = [WindowRef, DocumentRef];
//# sourceMappingURL=browser-globals.js.map

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var StickyComponent = (function () {
    function StickyComponent(element) {
        this.element = element;
        this.zIndex = 10;
        this.width = 'auto';
        this.offsetTop = 0;
        this.offsetBottom = 0;
        this.start = 0;
        this.stickClass = 'sticky';
        this.endStickClass = 'sticky-end';
        this.mediaQuery = '';
        this.parentMode = true;
        this.orientation = 'none';
        this.activated = new core_1.EventEmitter();
        this.deactivated = new core_1.EventEmitter();
        this.reset = new core_1.EventEmitter();
        this.isStuck = false;
    }
    StickyComponent.prototype.ngOnInit = function () {
        this.elem = this.element.nativeElement;
    };
    StickyComponent.prototype.ngAfterViewInit = function () {
        // define scroll container as parent element
        this.container = this.elem.parentNode;
        this.defineOriginalDimensions();
        this.sticker();
    };
    StickyComponent.prototype.onChange = function () {
        this.sticker();
    };
    StickyComponent.prototype.defineOriginalDimensions = function () {
        this.originalCss = {
            zIndex: this.getCssValue(this.elem, 'zIndex'),
            position: this.getCssValue(this.elem, 'position'),
            top: this.getCssValue(this.elem, 'top'),
            right: this.getCssValue(this.elem, 'right'),
            left: this.getCssValue(this.elem, 'left'),
            bottom: this.getCssValue(this.elem, 'bottom'),
            width: this.getCssValue(this.elem, 'width'),
        };
        if (this.width == 'auto') {
            this.width = this.originalCss.width;
        }
    };
    StickyComponent.prototype.defineDimensions = function () {
        var containerTop = this.getBoundingClientRectValue(this.container, 'top');
        this.windowHeight = window.innerHeight;
        this.elemHeight = this.getCssNumber(this.elem, 'height');
        this.containerHeight = this.getCssNumber(this.container, 'height');
        this.containerStart = containerTop + this.scrollbarYPos() - this.offsetTop + this.start;
        if (this.parentMode) {
            this.scrollFinish = this.containerStart - this.start - this.offsetBottom + (this.containerHeight - this.elemHeight);
        }
        else {
            this.scrollFinish = document.body.offsetHeight;
        }
    };
    StickyComponent.prototype.resetElement = function () {
        this.elem.classList.remove(this.stickClass);
        Object.assign(this.elem.style, this.originalCss);
        this.reset.next(this.elem);
    };
    StickyComponent.prototype.stuckElement = function () {
        this.isStuck = true;
        this.elem.classList.remove(this.endStickClass);
        this.elem.classList.add(this.stickClass);
        Object.assign(this.elem.style, {
            zIndex: this.zIndex,
            position: 'fixed',
            top: this.offsetTop + 'px',
            right: 'auto',
            bottom: 'auto',
            left: this.getBoundingClientRectValue(this.elem, 'left') + 'px',
            width: this.width
        });
        this.activated.next(this.elem);
    };
    StickyComponent.prototype.unstuckElement = function () {
        this.isStuck = false;
        this.elem.classList.add(this.endStickClass);
        this.container.style.position = 'relative';
        Object.assign(this.elem.style, {
            position: 'absolute',
            top: 'auto',
            left: 'auto',
            right: this.getCssValue(this.elem, 'float') === 'right' || this.orientation === 'right' ? 0 : 'auto',
            bottom: this.offsetBottom + 'px',
            width: this.width
        });
        this.deactivated.next(this.elem);
    };
    StickyComponent.prototype.matchMediaQuery = function () {
        if (!this.mediaQuery)
            return true;
        return (window.matchMedia('(' + this.mediaQuery + ')').matches ||
            window.matchMedia(this.mediaQuery).matches);
    };
    StickyComponent.prototype.sticker = function () {
        // check media query
        if (this.isStuck && !this.matchMediaQuery()) {
            this.resetElement();
            return;
        }
        // detecting when a container's height changes
        var currentContainerHeight = this.getCssNumber(this.container, 'height');
        if (currentContainerHeight !== this.containerHeight) {
            this.defineDimensions();
        }
        // check if the sticky element is above the container
        if (this.elemHeight >= currentContainerHeight) {
            return;
        }
        var position = this.scrollbarYPos();
        // unstick
        if (this.isStuck && (position < this.containerStart || position > this.scrollFinish) || position > this.scrollFinish) {
            this.resetElement();
            if (position > this.scrollFinish)
                this.unstuckElement();
            this.isStuck = false;
        }
        else if (this.isStuck === false && position > this.containerStart && position < this.scrollFinish) {
            this.stuckElement();
        }
    };
    StickyComponent.prototype.scrollbarYPos = function () {
        return window.pageYOffset || document.documentElement.scrollTop;
    };
    StickyComponent.prototype.getBoundingClientRectValue = function (element, property) {
        var result = 0;
        if (element && element.getBoundingClientRect) {
            var rect = element.getBoundingClientRect();
            result = (typeof rect[property] !== 'undefined') ? rect[property] : 0;
        }
        return result;
    };
    StickyComponent.prototype.getCssValue = function (element, property) {
        var result = '';
        if (typeof window.getComputedStyle !== 'undefined') {
            result = window.getComputedStyle(element, '').getPropertyValue(property);
        }
        else if (typeof element.currentStyle !== 'undefined') {
            result = element.currentStyle[property];
        }
        return result;
    };
    StickyComponent.prototype.getCssNumber = function (element, property) {
        if (typeof element === 'undefined')
            return 0;
        return parseInt(this.getCssValue(element, property), 10) || 0;
    };
    __decorate([
        core_1.Input('sticky-zIndex'),
        __metadata("design:type", Number)
    ], StickyComponent.prototype, "zIndex", void 0);
    __decorate([
        core_1.Input('sticky-width'),
        __metadata("design:type", String)
    ], StickyComponent.prototype, "width", void 0);
    __decorate([
        core_1.Input('sticky-offset-top'),
        __metadata("design:type", Number)
    ], StickyComponent.prototype, "offsetTop", void 0);
    __decorate([
        core_1.Input('sticky-offset-bottom'),
        __metadata("design:type", Number)
    ], StickyComponent.prototype, "offsetBottom", void 0);
    __decorate([
        core_1.Input('sticky-start'),
        __metadata("design:type", Number)
    ], StickyComponent.prototype, "start", void 0);
    __decorate([
        core_1.Input('sticky-class'),
        __metadata("design:type", String)
    ], StickyComponent.prototype, "stickClass", void 0);
    __decorate([
        core_1.Input('sticky-end-class'),
        __metadata("design:type", String)
    ], StickyComponent.prototype, "endStickClass", void 0);
    __decorate([
        core_1.Input('sticky-media-query'),
        __metadata("design:type", String)
    ], StickyComponent.prototype, "mediaQuery", void 0);
    __decorate([
        core_1.Input('sticky-parent'),
        __metadata("design:type", Boolean)
    ], StickyComponent.prototype, "parentMode", void 0);
    __decorate([
        core_1.Input('sticky-orientation'),
        __metadata("design:type", String)
    ], StickyComponent.prototype, "orientation", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], StickyComponent.prototype, "activated", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], StickyComponent.prototype, "deactivated", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], StickyComponent.prototype, "reset", void 0);
    __decorate([
        core_1.HostListener('window:scroll', ['$event']),
        core_1.HostListener('window:resize', ['$event']),
        core_1.HostListener('window:orientationchange', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StickyComponent.prototype, "onChange", null);
    StickyComponent = __decorate([
        core_1.Component({
            selector: 'sticky',
            template: '<ng-content></ng-content>'
        }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], StickyComponent);
    return StickyComponent;
}());
exports.StickyComponent = StickyComponent;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(12);
var leg_1 = __webpack_require__(221);
var Trip = (function () {
    function Trip(json) {
        this.duration = json.duration || 0;
        this.carrier = new _1.Carrier(json.carrier);
        this.legs = [];
        for (var current = 0; current < json.legs.length; current++) {
            this.legs.push(new leg_1.Leg(json.legs[current]));
        }
        this.viewDetails = false;
        this.departureDate = this.legs[0].startDate;
        this.departurePort = this.legs[0].startPort;
        this.durationText = this.duration == 1 ? '1 day' : this.duration + " days";
        if (json.legs.length === 1) {
            this.transhipments = 'direct';
            this.arrivalDate = this.legs[0].endDate;
            this.arrivalPort = this.legs[0].endPort;
        }
        else {
            this.transhipments = (this.legs.length - 1).toString() + ' t/s';
            this.arrivalDate = this.legs[this.legs.length - 1].endDate;
            this.arrivalPort = this.legs[this.legs.length - 1].endPort;
        }
    }
    Trip.prototype.getPortStops = function () {
        if (this.portStops != null) {
            return this.portStops;
        }
        var map = new Map();
        for (var current = 0; current < this.legs.length; current++) {
            var startPort = this.legs[current].startPort;
            var startDate = this.legs[current].startDate;
            var endPort = this.legs[current].endPort;
            var endDate = this.legs[current].endDate;
            if (!map.has(startPort.id)) {
                map.set(startPort.id, new PortStop(startDate, startPort));
            }
            if (!map.has(endPort.id)) {
                map.set(endPort.id, new PortStop(endDate, endPort));
            }
        }
        this.portStops = Array.from(map.values());
        return this.portStops;
    };
    return Trip;
}());
exports.Trip = Trip;
var PortStop = (function () {
    function PortStop(date, port) {
        this.date = date;
        this.port = port;
        this.linkParameters = { date: this.date, scroll: true };
    }
    return PortStop;
}());


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(12);
var Leg = (function () {
    function Leg(json) {
        this.voyage = json.voyage || 0;
        this.scheduleId = json.schedule_id || 0;
        this.endDate = json.end.date || '-';
        this.endTime = json.end.time || '';
        this.endPort = new _1.Port(json.end.port);
        this.startDate = json.start.date || '-';
        this.startTime = json.start.time || '';
        this.startPort = new _1.Port(json.start.port);
        this.vessel = new _1.Vessel(json.vessel);
        this.route = new _1.Route(json.route);
        // this.setStartLink();
        // this.setEndLink();
    }
    return Leg;
}());
exports.Leg = Leg;
// might want to add a try catch


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(12);
var Voyage = (function () {
    function Voyage(json) {
        this.schedules = [];
        this.voyage = json.voyage || '';
        this.carrier = new _1.Carrier(json.carrier);
        this.route = new _1.Route(json.route);
        this.schedules.push(new _1.Schedule(json));
        this.viewDetails = false;
    }
    Voyage.prototype.addSchedule = function (schedule) {
        this.schedules.push(schedule);
    };
    return Voyage;
}());
exports.Voyage = Voyage;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var LogService = (function () {
    function LogService() {
    }
    LogService.prototype.log = function (file, label, toLog) {
        // console.log(file, label, toLog);
    };
    LogService = __decorate([
        core_1.Injectable()
    ], LogService);
    return LogService;
}());
exports.LogService = LogService;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var _1 = __webpack_require__(2);
var AppContext = (function () {
    function AppContext(router, logger) {
        this.router = router;
        this.logger = logger;
        this.login = false;
        this.isLoggedIn = false;
        this.viewMenu = false;
        this.viewSearch = true;
        this.searchType = '';
        this.message = false;
        this.messageTitle = 'Title';
        this.messageContent = 'Body';
        this.arrivalMessage = false;
        this.arrivalTitle = 'Welcome to the new Linescape';
        this.arrivalContent = 'Please contact us with your thoughts and feedback.';
        this.year = moment().format('YYYY');
        this.registerMessage = false;
        this.registerTitle = 'Register';
        this.registerContent = 'You must register to use that content';
        this.upgradeMessage = false;
        this.upgradeTitle = 'Upgrade Account';
        this.upgradeContent = 'You must upgrade your account to have access to that feature';
        this.showPersonalInformation = false;
        this.isSubEnterprise = false;
        this.signUpPlan = '';
        this.signUpPlanBilling = '';
        this.email = localStorage.getItem('email') || '';
        this.accountType = localStorage.getItem('accountType') || '';
        this.billingInterval = localStorage.getItem('billingInterval') || '';
        this.maxSchedules = +localStorage.getItem('maxSchedules') || 0;
        this.customer = JSON.parse(localStorage.getItem('customer')) || null;
        this.isCustomer = localStorage.getItem('isCustomer') === 'true' ? true : false || false; // localStorage holds strings
        this.routes = JSON.parse(localStorage.getItem('favoriteRoutes')) || new Array();
        this.ports = JSON.parse(localStorage.getItem('favoritePorts')) || new Array();
        this.carriers = JSON.parse(localStorage.getItem('favoriteCarriers')) || new Array();
        this.vessels = JSON.parse(localStorage.getItem('vessels')) || new Array();
        this.country = JSON.parse(localStorage.getItem('country')) || { name: '', id: '' };
        this.EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*|\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        this.logger.log('app.context', 'constructor', 'hello');
    }
    AppContext.prototype.toggleLogin = function () {
        this.login = !this.login;
    };
    AppContext.prototype.toggleSearch = function (searchType) {
        if (searchType === void 0) { searchType = 'schedule'; }
        if (this.viewSearch && this.searchType == searchType) {
            this.closeSearch();
        }
        else if (this.viewSearch && this.searchType != searchType) {
            this.searchType = searchType;
        }
        else {
            this.openSearch(searchType);
        }
    };
    AppContext.prototype.closeSearch = function () {
        this.viewSearch = false;
        this.searchType = '';
    };
    AppContext.prototype.openSearch = function (searchType) {
        this.viewSearch = true;
        this.searchType = searchType;
    };
    AppContext.prototype.toggleMenu = function () {
        this.viewMenu = !this.viewMenu;
    };
    AppContext.prototype.showMessage = function (title, body) {
        this.messageTitle = title;
        this.messageContent = body;
        this.message = true;
    };
    AppContext.prototype.hideMessage = function () {
        this.message = false;
    };
    AppContext.prototype.showRegister = function () {
        this.registerMessage = true;
    };
    AppContext.prototype.showSavedRoutesExplanation = function () {
        this.showMessage('Saved Routes', 'This button allows you to quickly access your most commonly searched routes.  Click the "Save Route" button at the bottom of the schedule search results to add a route to this list.');
    };
    AppContext.prototype.hideRegister = function () {
        this.registerMessage = false;
    };
    AppContext.prototype.openArrivalMessage = function () {
        this.arrivalMessage = true;
    };
    AppContext.prototype.hideArrivalMessage = function () {
        this.arrivalMessage = false;
    };
    AppContext.prototype.showUpgrade = function () {
        this.upgradeMessage = true;
    };
    AppContext.prototype.hideUpgrade = function () {
        this.upgradeMessage = false;
    };
    AppContext.prototype.setLogin = function (truth) {
        this.isLoggedIn = truth;
        if (!this.isLoggedIn) {
            this.logout();
        }
        else {
            this.login = false;
        }
    };
    AppContext.prototype.setEmail = function (email) {
        localStorage.setItem('email', email);
        this.email = email.toLowerCase();
    };
    AppContext.prototype.setAccountType = function (accountType) {
        if (accountType === void 0) { accountType = 'Basic'; }
        localStorage.setItem('accountType', accountType);
        this.accountType = accountType.indexOf('api') > -1 ? 'Professional' : accountType;
    };
    AppContext.prototype.setPersonalInformation = function (information) {
        this.personalInformation = information;
    };
    AppContext.prototype.setBillingInterval = function (billingInterval) {
        localStorage.setItem('billingInterval', billingInterval);
        this.billingInterval = billingInterval;
    };
    AppContext.prototype.setMaxSchedules = function (maxSchedules) {
        localStorage.setItem('maxSchedules', maxSchedules.toString());
        this.maxSchedules = maxSchedules;
    };
    AppContext.prototype.setPlan = function (plan) {
        this.plan = new _1.Plan(plan);
    };
    AppContext.prototype.setRoutes = function (routes) {
        if (routes !== null && routes !== undefined) {
            this.routes = routes;
            localStorage.setItem('favoriteRoutes', JSON.stringify(this.routes));
        }
    };
    AppContext.prototype.toSort = function (a, b) {
        var one = a.name.toUpperCase();
        var two = b.name.toUpperCase();
        return (one < two) ? -1 : (one > two) ? 1 : 0;
    };
    AppContext.prototype.setPort = function (port) {
        var isUnique = true;
        for (var current = 0; current < this.ports.length; current++) {
            if (port.id === this.ports[current].id) {
                isUnique = false;
            }
        }
        // generally awful solution to duplicate issue
        if (isUnique) {
            this.ports.push(port);
        }
        localStorage.setItem('port' + port.id, JSON.stringify(port));
        localStorage.setItem('favoritePorts', JSON.stringify(this.ports));
        try {
            this.ports.sort(this.toSort);
        }
        catch (ex) {
            this.logger.log('app.context', 'setPort error', ex);
        }
    };
    AppContext.prototype.setCarrier = function (carrier) {
        var isUnique = true;
        for (var current = 0; current < this.carriers.length; current++) {
            if (carrier.id === this.carriers[current].id) {
                isUnique = false;
            }
        }
        if (isUnique) {
            this.carriers.push(carrier);
        }
        localStorage.setItem('carrier' + carrier.id, JSON.stringify(carrier));
        localStorage.setItem('favoriteCarriers', JSON.stringify(this.carriers));
        try {
            this.carriers.sort(this.toSort);
        }
        catch (ex) {
            this.logger.log('app.context', 'setCarrier error', ex);
        }
    };
    AppContext.prototype.setVessel = function (vessel) {
        var isUnique = true;
        for (var current = 0; current < this.vessels.length; current++) {
            if (vessel.id === this.vessels[current].id) {
                isUnique = false;
            }
        }
        if (isUnique) {
            this.vessels.push(vessel);
        }
        localStorage.setItem('vessel' + vessel.id, JSON.stringify(vessel));
        localStorage.setItem('favoriteVessels', JSON.stringify(this.vessels));
        try {
            this.vessels.sort(this.toSort);
        }
        catch (ex) {
            this.logger.log('app.context', 'setVessel error', ex);
        }
    };
    AppContext.prototype.setCustomer = function (customer) {
        this.customer = customer;
        localStorage.setItem('customer', JSON.stringify(customer));
    };
    AppContext.prototype.setIsCustomer = function (stripeId) {
        this.isCustomer = (stripeId !== undefined && stripeId !== null && stripeId !== '');
        localStorage.setItem('isCustomer', this.isCustomer.toString());
    };
    AppContext.prototype.setCountry = function (country) {
        this.country = country;
        localStorage.setItem('country', JSON.stringify(country));
    };
    AppContext.prototype.getPlanSideBarType = function () {
        if (this.accountType === '') {
            return 'register';
        }
        else if (this.accountType === 'Premium') {
            return 'upgrade';
        }
        else {
            return 'upsell';
        }
    };
    AppContext.prototype.logout = function () {
        var _this = this;
        this.clear();
        var url = this.router.url;
        this.clearStorage();
        this.router.navigate(['/']).then(function (result) { return _this.router.navigateByUrl(url); });
    };
    AppContext.prototype.clear = function () {
        this.routes = new Array();
        this.ports = new Array();
        this.carriers = new Array();
        this.vessels = new Array();
        this.billingInterval = '';
        this.accountType = '';
        this.isCustomer = false;
        this.email = '';
        this.maxSchedules = 0;
        this.plan = new _1.Plan({});
    };
    AppContext.prototype.clearStorage = function () {
        // localStorage.removeItem('billingInterval');
        // localStorage.removeItem('accountType');
        // localStorage.removeItem('email');
        // localStorage.removeItem('maxSchedules');
        // localStorage.removeItem('customer');
        // localStorage.removeItem('billingInterval');
        // localStorage.removeItem('favoriteCarriers');
        // localStorage.removeItem('favoritePorts');
        // localStorage.removeItem('favoriteRoutes');
        // localStorage.removeItem('favoriteVessels');
        localStorage.clear();
    };
    AppContext = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [router_1.Router, _1.LogService])
    ], AppContext);
    return AppContext;
}());
exports.AppContext = AppContext;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(28);
var environment_prod_1 = __webpack_require__(226);
var _1 = __webpack_require__(2);
var ApiService = (function () {
    function ApiService(titleService, logger, app) {
        this.titleService = titleService;
        this.logger = logger;
        this.app = app;
        this.client = null;
        this.userPool = null;
        this.poolData = {
            UserPoolId: environment_prod_1.environment.userPoolId,
            ClientId: environment_prod_1.environment.clientId,
            Paranoia: 7
        };
        this.cognitoParams = {
            IdentityPoolId: environment_prod_1.environment.identityPoolId
        };
        this.count = 0;
        this.logger.log('api.service', 'constructor', environment_prod_1.environment);
    }
    ApiService.prototype.initUserPool = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                AWS.config.region = environment_prod_1.environment.region;
                AWS.config.credentials = new AWS.CognitoIdentityCredentials(_this.cognitoParams);
                AWSCognito.config.region = environment_prod_1.environment.region;
                _this.userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(_this.poolData);
                var cognitoUser = _this.userPool.getCurrentUser();
                if (cognitoUser !== null) {
                    cognitoUser.getSession(function (err, session) {
                        if (session) {
                            var loginToken = "";
                            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                                IdentityId: AWS.config.credentials.identityId,
                                IdentityPoolId: environment_prod_1.environment.identityPoolId,
                                Logins: (_a = {},
                                    _a["cognito-idp." + environment_prod_1.environment.region + ".amazonaws.com/" + environment_prod_1.environment.userPoolId] = session.getIdToken().getJwtToken(),
                                    _a)
                            });
                            AWSCognito.config.credentials = new AWS.CognitoIdentityCredentials({
                                IdentityId: session.identityId,
                                IdentityPoolId: environment_prod_1.environment.identityPoolId,
                                Logins: (_b = {},
                                    _b["cognito-idp." + environment_prod_1.environment.region + ".amazonaws.com/" + environment_prod_1.environment.userPoolId] = session.getIdToken().getJwtToken(),
                                    _b)
                            });
                            _this.app.setLogin(true);
                            resolve();
                        }
                        var _a, _b;
                    });
                }
                else {
                    AWSCognito.config.credentials = new AWS.CognitoIdentityCredentials(_this.cognitoParams);
                    AWSCognito.config.update({ accessKeyId: 'anything', secretAccessKey: 'anything' });
                    resolve();
                }
            }
            catch (ex) {
                reject();
            }
        });
    };
    ApiService.prototype.getCognitoId = function () {
        var cognitoidentity = new AWS.CognitoIdentity();
        return cognitoidentity.config.credentials.identityId;
    };
    ApiService.prototype.getApiClient = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // this.logger.log('api.service', 'getApiClient', 'in return promise of getApiClient');
            if (_this.client !== null) {
                resolve(_this.client);
            }
            else {
                _this.generateApiClient().then(function () {
                    // this.logger.log('api.service', 'getApiClient', this.client);
                    resolve(_this.client);
                });
            }
        });
    };
    ApiService.prototype.generateApiClient = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.userPool === null) {
                _this.initUserPool().then(function () {
                    _this.initClient().then(function (client) {
                        resolve(client);
                    });
                });
            }
            else {
                _this.initClient().then(function (client) {
                    resolve(client);
                });
            }
        });
    };
    ApiService.prototype.initClient = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.initUser().then(function () {
                _this.client = apigClientFactory.newClient({
                    accessKey: AWS.config.credentials.accessKeyId,
                    secretKey: AWS.config.credentials.secretAccessKey,
                    sessionToken: AWS.config.credentials.sessionToken,
                    region: environment_prod_1.environment.region
                });
                resolve(_this.client);
            });
        });
    };
    ApiService.prototype.initUser = function () {
        return new Promise(function (resolve, reject) {
            AWS.config.credentials.get(function () {
                resolve();
            });
        });
    };
    ApiService.prototype.handleError = function (err) {
        // Do not bind this. Unless they have the logger and context injected
        this.logger.log('api.service', 'handleError', err);
        try {
            if (err.status === 429) {
                if (this.app.accountType === '') {
                    this.app.showMessage(err.data.message, 'Sorry, you have exceeded your search limit. Please try again later or register for free.');
                }
                else {
                    this.app.showMessage(err.data.message, 'Sorry, you have exceeded your search limit. Please try again later or upgrade your plan.');
                }
            }
            if (err.status === 504) {
                var message = err.statusText || err.message;
                this.app.showMessage(message, 'An unexpected error has occurred. Please try again');
            }
            if (err.status === 0) {
                // Really status code 403
                // this.signOut();
                this.client = null;
                this.userPool = null;
                return 403;
            }
            return null;
        }
        catch (ex) {
            this.logger.log('api.service', 'handleError catch', 'err created an exception');
            return null;
        }
    };
    ApiService.prototype.destroy = function () {
        var _this = this;
        localStorage.clear();
        var cognitoUser = this.userPool.getCurrentUser();
        if (cognitoUser !== null && cognitoUser !== undefined) {
            cognitoUser.signOut();
            cognitoUser.globalSignOut();
        }
        AWS.config.credentials.clearCachedId();
        this.client = null;
        this.userPool = null;
        var credentials = new AWS.CognitoIdentityCredentials(this.cognitoParams);
        AWS.config.credentials = credentials;
        AWS.config.credentials.get(function () {
            // check for credentials
        });
        AWS.config.credentials.refresh(function (error) {
            _this.getApiClient().then(function (client) {
                // console.log('destroy complete');
            });
        });
    };
    ApiService.prototype.signOut = function () {
        var _this = this;
        this.client = null;
        localStorage.removeItem('password'); // just in case it is set
        var cognitoUser = this.userPool.getCurrentUser();
        if (cognitoUser !== null && cognitoUser !== undefined) {
            cognitoUser.signOut();
            AWS.config.credentials.clearCachedId();
            var credentials = new AWS.CognitoIdentityCredentials(this.cognitoParams);
            AWS.config.credentials = credentials;
            AWS.config.credentials.get(function () {
                // check for credentials
            });
            this.client = null;
            this.userPool = null;
            AWS.config.credentials.refresh(function (error) {
                _this.getApiClient().then(function (client) {
                    _this.app.setLogin(false);
                });
            });
        }
        else {
            // should never be reached
            this.client = null;
            this.userPool = null;
            this.getApiClient().then(function (client) {
                AWS.config.credentials.refresh(function (error) {
                    setTimeout(function () {
                        _this.app.setLogin(false);
                    }, 500);
                });
            });
        }
    };
    ApiService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [platform_browser_1.Title, _1.LogService, _1.AppContext])
    ], ApiService);
    return ApiService;
}());
exports.ApiService = ApiService;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.environment = {
    production: true,
    region: 'us-east-1',
    identityPoolId: 'us-east-1:c22279ad-f7e3-4fa9-93d4-098afd6f34fd',
    userPoolId: 'us-east-1_W3suNlI8o',
    clientId: '2qkbbhteitdh8e8s6vh90btk12'
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var _1 = __webpack_require__(2);
var _2 = __webpack_require__(2);
var UserService = (function () {
    function UserService(api, app, logger) {
        this.api = api;
        this.app = app;
        this.logger = logger;
        this.apiService = null;
        this.apiService = api;
    }
    UserService.prototype.createUser = function (model) {
        var _this = this;
        var body = {
            email: model.email.toLowerCase(),
            token: model.token,
            coupon: model.coupon,
            planId: model.planId,
            firstName: model.firstName,
            lastName: model.lastName
        };
        return this.api.getApiClient().then(function (client) { return _this.callCreateUser(client, body); });
    };
    UserService.prototype.callCreateUser = function (apigClient, body) {
        return new Promise(function (resolve, reject) {
            var params = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' }
            };
            try {
                apigClient.userRegisterPost(params, body, additionalParams)
                    .then(function (result) {
                    resolve(result.data);
                })
                    .catch(function (err) {
                    return reject(err);
                });
            }
            catch (ex) {
                return reject(ex);
            }
        });
    };
    UserService.prototype.addPersonalInformation = function (model) {
        var _this = this;
        var body = {
            firstName: model.firstName,
            lastName: model.lastName,
            business: model.business,
            company: model.company,
            position: model.position,
            country: model.country,
            city: model.city,
            subscribe: model.subscribe
        };
        return this.api.getApiClient().then(function (client) { return _this.callAddPersonalInformation(client, body); });
    };
    UserService.prototype.callAddPersonalInformation = function (apigClient, body) {
        return new Promise(function (resolve, reject) {
            var params = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' }
            };
            try {
                apigClient.userInformationPost(params, body, additionalParams)
                    .then(function (result) {
                    resolve(result);
                }).catch(function (err) {
                    return reject(err);
                });
            }
            catch (ex) {
                return reject(ex);
            }
        });
    };
    UserService.prototype.confirmUser = function (email) {
        var _this = this;
        return this.api.getApiClient().then(function (client) { return _this.callConfirmUser(client, email); });
    };
    UserService.prototype.callConfirmUser = function (apigClient, email) {
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {
                email: email.toLowerCase()
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' }
            };
            try {
                apigClient.userConfirmPost(params, body, additionalParams)
                    .then(function (result) {
                    resolve(result);
                }).catch(function (err) {
                    return reject(err);
                });
            }
            catch (ex) {
                return reject(ex);
            }
        });
    };
    UserService.prototype.init = function () {
        var cognitoUser = this.api.userPool.getCurrentUser();
        if (cognitoUser !== null) {
            this.getProfile();
        }
    };
    UserService.prototype.checkIfUser = function (email) {
        var _this = this;
        return this.api.getApiClient().then(function (client) { return _this.callCheckIfUser(client, email); });
    };
    UserService.prototype.callCheckIfUser = function (apigClient, email) {
        return new Promise(function (resolve, reject) {
            var params = {
                email: email.toLowerCase()
            };
            var body = {
                email: email.toLowerCase()
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {
                    email: email.toLowerCase()
                }
            };
            try {
                apigClient.userConfirmGet(params, body, additionalParams)
                    .then(function (result) {
                    resolve(result);
                }).catch(function (err) {
                    return reject(err);
                });
            }
            catch (ex) {
                return reject(ex);
            }
        });
    };
    UserService.prototype.getProfile = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.api.getApiClient().then(function (client) { return _this.callGetProfile(client); })
                .then(function (result) {
                _this.logger.log('user.service', 'getProfile result', result);
                _this.setProfile(result.data);
                resolve(result.data);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    UserService.prototype.callGetProfile = function (apigClient) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' }
            };
            var cognitoIdentityId = _this.apiService.getCognitoId();
            var checkAccountStatusPostBody = {
                cognitoId: cognitoIdentityId
            };
            try {
                apigClient.v2CheckAccountStatusPost(params, checkAccountStatusPostBody, additionalParams)
                    .then(function (resultUserProfile) {
                    apigClient.userProfileGet(params, body, additionalParams)
                        .then(function (result) {
                        resolve(result);
                    }).catch(function (err) { return _this.api.handleError(err); });
                }).catch(function (e) { });
            }
            catch (ex) {
                return reject(ex);
            }
        });
    };
    UserService.prototype.setProfile = function (data) {
        try {
            this.app.setEmail(data.email);
            // **** 
            //this.app.setAccountType(data.account.type);
            this.app.setIsCustomer(data.account.stripeId);
            if (data.limits !== undefined && data.limits !== null) {
                this.app.setMaxSchedules(data.limits.maxSchedules);
            }
            if (data.plan !== undefined && data.plan !== null) {
                this.app.setPlan(data.plan);
                this.app.setBillingInterval(data.plan.interval);
            }
            // TODO: This is a temporary fix due to we can't change linescape-api now, it should be change when the linescape-api is able to be change
            // if (this.app.plan.name === 'Monthly Enterprise 2-6' || this.app.plan.name === 'Monthly Enterprise 7-12' || this.app.plan.name === 'Monthly Enterprise 13-18' ||
            //     this.app.plan.name === 'Yearly Enterprise 2-6' || this.app.plan.name === 'Yearly Enterprise 7-12' || this.app.plan.name === 'Yearly Enterprise 13-18') {
            //   data.account.type = 'Professional';
            // }
            if (this.app.plan.name.includes('Enterprise')) {
                data.account.type = 'Professional';
            }
            if (data.account.coveredByEnterprise == true) {
                data.account.type = 'Professional';
                this.app.isSubEnterprise = true;
            }
            else {
                this.app.isSubEnterprise = false;
            }
            this.app.setAccountType(data.account.type);
            // ****
        }
        catch (err) {
            this.logger.log('user.service', 'setProfile', err);
        }
        try {
            if (data !== null && data.favorites !== null) {
                this.setFavorites(data.favorites);
            }
        }
        catch (err) {
            this.logger.log('user.service', 'setProfile setFavorites', err);
        }
        try {
            var information = new _2.PersonalInformation(data.personalInformation);
            this.app.setPersonalInformation(information);
            if (data.personalInformation == undefined || data.personalInformation.business == undefined) {
                this.app.showPersonalInformation = true;
            }
        }
        catch (err) {
            // show personal information popup
            this.app.showPersonalInformation = true;
        }
    };
    UserService.prototype.setFavorites = function (favorites) {
        if (favorites.routes !== undefined) {
            this.app.routes = [];
            this.app.setRoutes(favorites.routes);
        }
        if (favorites.ports !== undefined) {
            this.app.ports = [];
            this.getPorts(favorites.ports.values);
        }
        if (favorites.carriers !== undefined) {
            this.app.carriers = [];
            this.getCarriers(favorites.carriers.values);
        }
        if (favorites.vessels !== undefined) {
            this.app.vessels = [];
            this.getVessels(favorites.vessels.values);
        }
        // not sure if the best practice is to check for undefined or use try-catch
    };
    UserService.prototype.getVessels = function (vessels) {
        var _this = this;
        this.logger.log('user.service', 'getVessels', vessels);
        try {
            var _loop_1 = function (current) {
                var local = localStorage.getItem('vessel' + vessels[current]);
                if (local === undefined || local === null) {
                    this_1.api.getApiClient().then(function (client) { return _this.callGetVessel(client, vessels[current]); })
                        .then(function (result) {
                        _this.app.setVessel(result);
                    }).catch(function (err) {
                        _this.logger.log('user.service', 'getVessels catch', "vessel: " + vessels[current] + " and error: " + err);
                    });
                }
                else {
                    this_1.app.setVessel(JSON.parse(local));
                }
            };
            var this_1 = this;
            for (var current = 0; current < vessels.length; current++) {
                _loop_1(current);
            }
        }
        catch (ex) {
            this.logger.log('user.service', 'getvessels', 'no vessels');
        }
    };
    UserService.prototype.callGetVessel = function (apigClient, vesselId) {
        var _this = this;
        this.logger.log('user.service', 'callGetVessel', vesselId);
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {
                    id: vesselId
                }
            };
            try {
                apigClient.vesselsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('user.service', 'vessel result', result);
                    try {
                        if (result.data.items[0] == null) {
                            throw 'no item returned';
                        }
                        var vessel = new _2.Vessel(result.data.items[0]);
                        resolve(vessel);
                    }
                    catch (ex) {
                        _this.logger.log('user.service', 'vessel null', ex);
                        reject(null);
                    }
                }).catch(function (err) { return _this.api.handleError(err); });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    UserService.prototype.getCarriers = function (carriers) {
        var _this = this;
        this.logger.log('user.service', 'getCarriers', carriers);
        try {
            var _loop_2 = function (current) {
                var local = localStorage.getItem('carrier' + carriers[current]);
                if (local === undefined || local === null) {
                    this_2.api.getApiClient().then(function (client) { return _this.callGetCarrier(client, carriers[current]); })
                        .then(function (result) {
                        _this.app.setCarrier(result);
                    }).catch(function (err) {
                        _this.logger.log('user.service', 'getCarriers catch', err);
                    });
                }
                else {
                    this_2.app.setCarrier(JSON.parse(local));
                }
            };
            var this_2 = this;
            for (var current = 0; current < carriers.length; current++) {
                _loop_2(current);
            }
        }
        catch (ex) {
            this.logger.log('user.service', 'getCarriers', 'no carriers');
        }
    };
    UserService.prototype.callGetCarrier = function (apigClient, carrierId) {
        var _this = this;
        this.logger.log('user.service', 'callGetCarrier', carrierId);
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {
                    id: carrierId
                }
            };
            try {
                apigClient.carriersGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('user.service', 'carrier result', result);
                    try {
                        if (result.data.items[0] == null) {
                            throw 'no item returned';
                        }
                        var carrier = new _2.Carrier(result.data.items[0]);
                        resolve(carrier);
                    }
                    catch (ex) {
                        _this.logger.log('user.service', 'carrier null', ex);
                        reject(null);
                    }
                }).catch(function (err) { return _this.api.handleError(err); });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    UserService.prototype.getPorts = function (ports) {
        var _this = this;
        this.logger.log('user.service', 'getPorts', ports);
        try {
            var _loop_3 = function (current) {
                var local = localStorage.getItem('port' + ports[current]);
                if (local === undefined || local === null) {
                    this_3.api.getApiClient().then(function (client) { return _this.callGetPort(client, ports[current]); })
                        .then(function (result) {
                        _this.app.setPort(result);
                    }).catch(function (err) {
                        _this.logger.log('user.service', 'getPorts catch', "port: " + ports[current] + " and error: " + err);
                    });
                }
                else {
                    this_3.app.setPort(JSON.parse(local));
                }
            };
            var this_3 = this;
            for (var current = 0; current < ports.length; current++) {
                _loop_3(current);
            }
        }
        catch (ex) {
            this.logger.log('user.service', 'getPorts', 'no ports');
        }
    };
    UserService.prototype.callGetPort = function (apigClient, portId) {
        var _this = this;
        this.logger.log('user.service', 'callGetPort', portId);
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {
                    id: portId
                }
            };
            try {
                apigClient.portsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('user.service', 'port result', result);
                    try {
                        if (result.data.items[0] == null) {
                            throw 'no item returned';
                        }
                        var port = new _2.Port(result.data.items[0]);
                        resolve(port);
                    }
                    catch (ex) {
                        _this.logger.log('user.service', 'port null', ex);
                        reject(null);
                    }
                }).catch(function (err) { return _this.api.handleError(err); });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    UserService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [_1.ApiService, _1.AppContext, _1.LogService])
    ], UserService);
    return UserService;
}());
exports.UserService = UserService;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var environment_prod_1 = __webpack_require__(226);
var shared_1 = __webpack_require__(2);
var AuthService = (function () {
    function AuthService(api, app, user) {
        this.api = api;
        this.app = app;
        this.user = user;
        this.loginUrl = '';
        this.registerUrl = '';
        this.cognitoUser = {};
        this.userPool = {};
    }
    AuthService.prototype.login = function (email, password) {
        var _this = this;
        localStorage.removeItem('password'); // just in case it is set
        var userData = {
            Username: email.toLowerCase(),
            Pool: this.api.userPool
        };
        this.cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
        var authenticationData = {
            Username: email.toLowerCase(),
            Password: password,
        };
        var authenticationDetails = new AWSCognito.CognitoIdentityServiceProvider.AuthenticationDetails(authenticationData);
        return new Promise(function (resolve, reject) {
            try {
                _this.cognitoUser.authenticateUser(authenticationDetails, {
                    onSuccess: function (result) {
                        if (result) {
                            // Add the User's Id Token to the Cognito credentials login map.
                            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                                IdentityId: AWS.config.credentials.identityId,
                                IdentityPoolId: environment_prod_1.environment.identityPoolId,
                                Logins: (_a = {},
                                    _a["cognito-idp." + environment_prod_1.environment.region + ".amazonaws.com/" + environment_prod_1.environment.userPoolId] = result.getIdToken().getJwtToken(),
                                    _a)
                            });
                            AWSCognito.config.credentials = new AWS.CognitoIdentityCredentials({
                                IdentityId: result.identityId,
                                IdentityPoolId: environment_prod_1.environment.identityPoolId,
                                Logins: (_b = {},
                                    _b["cognito-idp." + environment_prod_1.environment.region + ".amazonaws.com/" + environment_prod_1.environment.userPoolId] = result.getIdToken().getJwtToken(),
                                    _b)
                            });
                            AWS.config.credentials.get(function () {
                                _this.api.client = apigClientFactory.newClient({
                                    accessKey: AWS.config.credentials.accessKeyId,
                                    secretKey: AWS.config.credentials.secretAccessKey,
                                    sessionToken: AWS.config.credentials.sessionToken,
                                    region: environment_prod_1.environment.region
                                });
                                _this.app.setLogin(true);
                                _this.completeLogin(email.toLowerCase());
                                resolve();
                            });
                        }
                        var _a, _b;
                    },
                    onFailure: function (err) {
                        // console.log('logging in did not work', err);
                        if (err == undefined || err.message == undefined) {
                            var error = {
                                message: 'Password attempts exceeded'
                            };
                            return reject(error);
                        }
                        return reject(err);
                    },
                    mfaRequired: function (codeDeliveryDetails) {
                        var verificationCode = prompt('Please input verification code', '');
                        this.cognitoUser.sendMFACode(verificationCode, this);
                    }
                });
            }
            catch (ex) {
                return reject(ex);
            }
        });
    };
    AuthService.prototype.completeLogin = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.user.checkIfUser(email).then(function (result) {
                // is a user, get profile
                _this.user.getProfile();
                resolve();
            }).catch(function (ex) {
                // not a user, confirm account
                _this.user.confirmUser(email).then(function (result) {
                    _this.user.getProfile();
                    resolve();
                }).catch(function (confirmEx) {
                    reject(confirmEx);
                });
            });
        });
    };
    AuthService.prototype.getCurrentUser = function () {
        return this.api.userPool.getCurrentUser();
    };
    AuthService.prototype.getCognitoUserAttributeList = function (model) {
        var attributeList = [];
        var dataEmail = {
            Name: 'email',
            Value: model.email.toLowerCase()
        };
        var attributeEmail = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataEmail);
        attributeList.push(attributeEmail);
        var dataFirstName = {
            Name: 'given_name',
            value: model.firstName
        };
        var attributeFirstName = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataFirstName);
        attributeList.push(attributeFirstName);
        var dataLastName = {
            Name: 'family_name',
            value: model.lastName
        };
        var attributeLastName = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataLastName);
        attributeList.push(attributeLastName);
        return attributeList;
    };
    AuthService.prototype.register = function (model) {
        var attributeList = this.getCognitoUserAttributeList(model);
        var userPool = this.api.userPool;
        return new Promise(function (resolve, reject) {
            try {
                userPool.signUp(model.email.toLowerCase(), model.password, attributeList, null, function (err, result) {
                    if (err !== null) {
                        return reject(err);
                    }
                    resolve(result);
                });
            }
            catch (ex) {
                return reject(ex);
            }
        });
    };
    AuthService.prototype.confirmEmail = function (verificationCode, email) {
        var _this = this;
        var userPool = this.api.userPool;
        return new Promise(function (resolve, reject) {
            try {
                var userData = {
                    Username: email.toLowerCase(),
                    Pool: userPool
                };
                _this.cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
                _this.cognitoUser.confirmRegistration(verificationCode, true, function (err, result) {
                    if (err) {
                        reject(err);
                    }
                    resolve(result);
                });
            }
            catch (ex) {
                return reject(ex);
            }
        });
    };
    AuthService.prototype.resendVerificationEmail = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var userData = {
                    Username: email.toLowerCase(),
                    Pool: _this.api.userPool
                };
                _this.cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
                _this.cognitoUser.resendConfirmationCode(function (err, result) {
                    err ? reject(err) : resolve(result);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    AuthService.prototype.changePassword = function (oldPassword, newPassword) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                // user needs to be authenticated
                _this.login(_this.app.email, oldPassword).then(function (result) {
                    _this.cognitoUser.changePassword(oldPassword, newPassword, function (err, changeResult) {
                        err ? reject(err) : resolve(changeResult);
                    });
                }).catch(function (err) {
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    AuthService.prototype.forgotPassword = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var userData = {
                    Username: email.toLowerCase(),
                    Pool: _this.api.userPool
                };
                _this.cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
                // console.log('AuthService forgotPassword');
                _this.cognitoUser.forgotPassword({
                    onSuccess: function (result) {
                        // console.log('forgotPassword result', result);
                        resolve(true);
                    },
                    onFailure: function (err) {
                        // console.log('forgotPassword err', err);
                        reject(err);
                    },
                    inputVerificationCode: function (data) {
                        // onSuccess is not firing
                        // console.log('callback that should not do anything data', data);
                        resolve(true);
                    }
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    AuthService.prototype.confirmPassword = function (email, verificationCode, newPassword) {
        var _this = this;
        // console.log('confirmPassword', email, verificationCode, newPassword);
        return new Promise(function (resolve, reject) {
            try {
                var userData = {
                    Username: email.toLowerCase(),
                    Pool: _this.api.userPool
                };
                _this.cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
                _this.cognitoUser.confirmPassword(verificationCode, newPassword, {
                    onSuccess: function (result) {
                        // console.log('confirmPassword result', result);
                        resolve(true);
                    },
                    onFailure: function (err) {
                        // console.log('confirmPassword err', err);
                        reject(err);
                    },
                    inputVerificationCode: function (data) {
                        // needs to be defined, but does not have to do anything
                        // console.log('callback that should not do anything data', data);
                    }
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    AuthService.prototype.handleError = function (error) {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    };
    AuthService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AppContext, shared_1.UserService])
    ], AuthService);
    return AuthService;
}());
exports.AuthService = AuthService;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
__webpack_require__(23);
var _1 = __webpack_require__(2);
var CacheService = (function () {
    function CacheService(logger) {
        this.logger = logger;
        this.logger.log('cache.service', 'constructor', 'hello');
    }
    CacheService.prototype.get = function (key) {
        var promise = this.getFromCache(key);
        var cache = Observable_1.Observable.fromPromise(promise);
        var subscription = cache.subscribe(function (x) { }, function (e) { console.log('e', e); }, function () { console.log('complete'); });
        return cache;
    };
    CacheService.prototype.getFromCache = function (key) {
        this.logger.log('cache.service', 'getFromCache', key);
        return new Promise(function (resolve, reject) {
            var value = localStorage[key] || null; // || reject('not in cache');
            resolve(JSON.parse(value));
        });
    };
    CacheService.prototype.updateCache = function (key, source) {
        var subscription = source.subscribe(function (x) {
            if (x !== null) {
                localStorage[key] = JSON.stringify(x);
            }
        }, function (e) { }, function () { });
    };
    CacheService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [_1.LogService])
    ], CacheService);
    return CacheService;
}());
exports.CacheService = CacheService;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var _1 = __webpack_require__(2);
var FavoriteService = (function () {
    function FavoriteService(logger, api, app) {
        this.logger = logger;
        this.api = api;
        this.app = app;
        this.apiService = null;
        this.apiService = api;
    }
    FavoriteService.prototype.showSignInError = function () {
        // this.app.showMessage('Sign in Required', 'You must sign in to use this feature');
        this.app.showRegister();
    };
    FavoriteService.prototype.favorite = function (type, id) {
        var _this = this;
        if (!this.app.isLoggedIn) {
            this.showSignInError();
            return;
        }
        else if (type === 'port') {
            return this.api.generateApiClient().then(function (client) { return _this.callFavoritePort(client, id); });
        }
        else if (type === 'vessel') {
            return this.api.generateApiClient().then(function (client) { return _this.callFavoriteVessel(client, id); });
        }
        else if (type === 'carrier') {
            return this.api.generateApiClient().then(function (client) { return _this.callFavoriteCarrier(client, id); });
        }
        else {
            return;
        }
    };
    FavoriteService.prototype.unfavorite = function (type, id) {
        var _this = this;
        if (!this.app.isLoggedIn) {
            this.showSignInError();
            return;
        }
        else if (type === 'port') {
            return this.api.generateApiClient().then(function (client) { return _this.callUnFavoritePort(client, id); });
        }
        else if (type === 'vessel') {
            return this.api.generateApiClient().then(function (client) { return _this.callUnFavoriteVessel(client, id); });
        }
        else if (type === 'carrier') {
            return this.api.generateApiClient().then(function (client) { return _this.callUnFavoriteCarrier(client, id); });
        }
        else {
            return;
        }
    };
    FavoriteService.prototype.unfavoriteRoute = function (originId, destinationId) {
        var _this = this;
        return this.api.generateApiClient().then(function (client) { return _this.callUnFavoriteRoute(client, originId, destinationId); });
    };
    FavoriteService.prototype.callUnFavoriteRoute = function (apigClient, originId, destinationId) {
        var _this = this;
        this.logger.log('favorite.service', 'callUnFavoriteRoute', originId + " + " + destinationId);
        var cognitoIdentityId = this.apiService.getCognitoId();
        return new Promise(function (resolve, reject) {
            var params = {
                originId: originId,
                destinationId: destinationId
            };
            var body = {
                cognitoId: cognitoIdentityId,
                originId: originId,
                destinationId: destinationId
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.v2RoutesFavoriteDelete(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('favorite.service', 'callUnFavoritePort result', result);
                    resolve(result);
                }).catch(function (err) {
                    _this.api.handleError(err);
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    FavoriteService.prototype.callFavoritePort = function (apigClient, id) {
        var _this = this;
        this.logger.log('favorite.service', 'callFavoritePort', id);
        return new Promise(function (resolve, reject) {
            var params = {
                portId: id
            };
            var body = {
                portId: id
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.portsPortIdFavoritePost(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('favorite.service', 'callFavoritePort result', result);
                    resolve(result);
                }).catch(function (err) {
                    _this.api.handleError(err);
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    FavoriteService.prototype.callUnFavoritePort = function (apigClient, id) {
        var _this = this;
        this.logger.log('favorite.service', 'callUnFavoritePort', id);
        return new Promise(function (resolve, reject) {
            var params = {
                portId: id
            };
            var body = {
                portId: id
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.portsPortIdFavoriteDelete(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('favorite.service', 'callUnFavoritePort result', result);
                    resolve(result);
                }).catch(function (err) {
                    _this.api.handleError(err);
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    FavoriteService.prototype.callFavoriteVessel = function (apigClient, id) {
        var _this = this;
        this.logger.log('favorite.service', 'callFavoriteVessel', id);
        return new Promise(function (resolve, reject) {
            var params = {
                vesselId: id
            };
            var body = {
                vesselId: id
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.vesselsVesselIdFavoritePost(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('favorite.service', 'callFavoriteVessel result', result);
                    resolve(result);
                }).catch(function (err) {
                    _this.api.handleError(err);
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    FavoriteService.prototype.callUnFavoriteVessel = function (apigClient, id) {
        var _this = this;
        this.logger.log('favorite.service', 'callUnFavoriteVessel', id);
        return new Promise(function (resolve, reject) {
            var params = {
                vesselId: id
            };
            var body = {
                vesselId: id
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.vesselsVesselIdFavoriteDelete(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('favorite.service', 'callUnFavoriteVessel result', result);
                    resolve(result);
                }).catch(function (err) {
                    _this.api.handleError(err);
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    FavoriteService.prototype.callFavoriteCarrier = function (apigClient, id) {
        var _this = this;
        this.logger.log('favorite.service', 'callFavoriteCarrier', id);
        return new Promise(function (resolve, reject) {
            var params = {
                carrierId: id
            };
            var body = {
                carrierId: id
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.carriersCarrierIdFavoritePost(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('favorite.service', 'callFavoriteCarrier result', result);
                    resolve(result);
                }).catch(function (err) {
                    _this.api.handleError(err);
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    FavoriteService.prototype.callUnFavoriteCarrier = function (apigClient, id) {
        var _this = this;
        this.logger.log('favorite.service', 'callUnFavoriteCarrier', id);
        return new Promise(function (resolve, reject) {
            var params = {
                carrierId: id
            };
            var body = {
                carrierId: id
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.carriersCarrierIdFavoriteDelete(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('favorite.service', 'callUnFavoriteCarrier result', result);
                    resolve(result);
                }).catch(function (err) {
                    _this.api.handleError(err);
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    FavoriteService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [_1.LogService, _1.ApiService, _1.AppContext])
    ], FavoriteService);
    return FavoriteService;
}());
exports.FavoriteService = FavoriteService;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(28);
var _1 = __webpack_require__(2);
var SeoService = (function () {
    function SeoService(logger, titleService, metaService) {
        this.logger = logger;
        this.titleService = titleService;
        this.metaService = metaService;
    }
    // https://github.com/angular/angular/blob/4.0.0-beta.6/modules/%40angular/platform-browser/src/browser/meta.ts
    // for examples
    // https://github.com/angular/angular/commit/72361fb68f79fbddac96cc4c005eac85f071692a
    SeoService.prototype.setPort = function (port) {
        var title = port.name + " Port Vessel Schedule - Linescape";
        this.titleService.setTitle(title);
        var description = "View cargo vessel arrivals and departures for the port of " + port.display + ". Filter schedule data by date and carrier, or search nearby port schedules.";
        this.metaService.updateTag({ name: 'description', content: description }, 'description');
    };
    SeoService.prototype.setVessel = function (vessel) {
        var title = vessel.name + " Vessel Sailing Schedule - Linescape";
        this.titleService.setTitle(title);
        var description = "View " + vessel.name + " IMO: " + vessel.imo + " container ship sailing schedules, along with vessel capacity, propulsion, and construction data.";
        this.metaService.updateTag({ name: 'description', content: description }, 'description');
    };
    SeoService.prototype.setCarrier = function (carrier) {
        var title = carrier.name + " Schedule - " + carrier.name + " Vessels - Linescape";
        this.titleService.setTitle(title);
        var description = "View sailing schedules and vessels data for carrier " + carrier.name + " - " + carrier.description + " and access " + carrier.name + " local office contact information by country.";
        this.metaService.updateTag({ name: 'description', content: description }, 'description');
    };
    SeoService.prototype.setTrips = function (trips) {
        // let origin = trips.originPorts[0].port.name; // not precise
        // let destination = trips.destinationPorts[0].port.name; // not precise
        var title = 'Schedules - Linescape';
        this.titleService.setTitle(title);
    };
    SeoService.prototype.set = function (title, description) {
        this.titleService.setTitle(title);
        this.metaService.updateTag({ name: 'description', content: description }, 'description');
    };
    SeoService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [_1.LogService, platform_browser_1.Title, platform_browser_1.Meta])
    ], SeoService);
    return SeoService;
}());
exports.SeoService = SeoService;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var tippy_js_1 = __webpack_require__(565);
var HomeComponent = (function () {
    function HomeComponent(route, seo, app) {
        this.route = route;
        this.seo = seo;
        this.app = app;
        this.title = 'Linescape - Ocean Container Shipping Schedules';
        this.description = 'Linescape is the first independent liner shipping search engine for ocean container sailing schedules with searches filtered by port, vessel or carrier.';
        // Do stuff
    }
    HomeComponent.prototype.ngOnInit = function () {
        this.seo.set(this.title, this.description);
        tippy_js_1.default('.tippy-hover', {
            arrow: true,
            size: 'small'
            // content: 'Tooltip',
        });
    };
    HomeComponent.prototype.ngAfterViewInit = function () {
        window.scrollTo(0, 0);
    };
    HomeComponent = __decorate([
        core_1.Component({
            selector: 'my-home',
            template: __webpack_require__(567),
            styles: [__webpack_require__(568)],
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService, shared_1.AppContext])
    ], HomeComponent);
    return HomeComponent;
}());
exports.HomeComponent = HomeComponent;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(569));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(572));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var trips_1 = __webpack_require__(60);
var schedules_service_1 = __webpack_require__(575);
var SchedulesComponent = (function () {
    function SchedulesComponent(logger, service, route, router, zone) {
        this.logger = logger;
        this.service = service;
        this.route = route;
        this.router = router;
        this.zone = zone;
        this.originPorts = new Array();
        this.showAllOriginPorts = false;
        this.destinationPorts = new Array();
        this.showAllDestinationPorts = false;
        this.portShowLimit = 10;
        this.originId = '';
        this.destinationId = '';
        this.departureSet = false;
        this.departureRange = 'any';
        this.destinationSearch = '';
        this.originSearch = '';
        this.destinationType = 'port';
        this.originType = 'port';
        this.arrivalSet = false;
        this.arrivalRange = 'any';
        this.nearbyOriginPorts = false;
        this.nearbyDestinationPorts = false;
        this.sort = 'duration';
        this.offset = 0;
        this.limit = 25;
        this.minDuration = 0;
        this.maxDuration = 0;
        this.pages = [];
        this.pageNumber = 1;
        this.paginationContext = '';
        this.resultsNumber = '';
        this.showShare = false;
        this.showSave = false;
        this.showContact = false;
        this.showTransSales = false;
        this.displayType = 'trips';
        this.mapsHiddenVar = false;
        this.showRoutes = false;
        this.showDepartureRange = false;
        this.showArrivalRange = false;
        this.sidebarActive = false;
        // Do stuff
    }
    SchedulesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.logger.log('schedules.component', 'ngOnInit params', this.route.snapshot.params);
        this.schedules = new trips_1.Trips(null);
        this.sub = this.route.params.subscribe(function (params) {
            if (params['search_id'] != null) {
                _this.setupSharedSearch(params['search_id']);
            }
            else {
                _this.setupPage(params);
            }
        });
        if (localStorage.getItem('mapsHidden') === 'true') {
            this.mapsHiddenVar = true;
        }
    };
    SchedulesComponent.prototype.ngOnDestroy = function () {
        this.sub.unsubscribe();
    };
    SchedulesComponent.prototype.onResize = function () {
        this.service.resizeSidebar();
    };
    SchedulesComponent.prototype.ngAfterViewInit = function () {
        this.service.resizeSidebar();
    };
    SchedulesComponent.prototype.setupSharedSearch = function (searchId) {
        var _this = this;
        this.service.getParametersFromSearchId(searchId).then(function (result) {
            _this.searchIdUpdate(result);
        }).catch(function (err) {
            _this.logger.log('schedules.component', 'setupSharedSearch catch', err);
        });
    };
    // must use != null as !== null does not work for route parameter checks
    SchedulesComponent.prototype.setupPage = function (params) {
        this.schedules = new trips_1.Trips(null);
        this.setupOrigin(params);
        this.setupDestination(params);
        this.setupFilters(params);
        this.setupDates(params);
        // if (params['limit'] != null || params['offset'] != null) {
        //   let old = JSON.parse(localStorage.getItem('saved-schedules' + this.originId + this.destinationId));
        //   if (old !== null && old !== undefined) {
        //     old.items = [];
        //     this.schedules = old;
        //     this.service.resizeSidebar();
        //   }
        // }
        if ((this.originType === 'port' || this.originType === 'share') && (this.destinationType === 'port' || this.destinationType === 'share')) {
            this.getSchedules();
        }
    };
    SchedulesComponent.prototype.setupOrigin = function (params) {
        var _this = this;
        if (params['selected_origin_ids'] != null) {
            this.schedules.selectedOriginPorts = params['selected_origin_ids'].split(',').map(Number);
        }
        else {
            this.schedules.selectedOriginPorts = [];
        }
        if (params['origin_search'] != null) {
            this.originSearch = params['origin_search'];
        }
        else {
            this.originSearch = 'Origin';
        }
        // origin id will always be a single id (be it port or region/country)
        if (params['origin_id'] != null) {
            this.originId = params['origin_id'];
        }
        if (params['origin_type'] != null) {
            this.originType = params['origin_type'];
        }
        if (params['with_nearby_origins'] === 'true') {
            // this.nearbyOriginPorts = Boolean(params['with_nearby_origins']);
            if (this.service.app.accountType === '' || this.service.app.accountType === 'Basic') {
                this.nearbyOriginPorts = false;
            }
            else {
                this.nearbyOriginPorts = true;
            }
        }
        if (this.originType === 'share') {
            // shared search with multiple ports
        }
        else if (this.originType !== 'port') {
            this.service.getPortsForLocation(this.originType, this.originId).then(function (ports) {
                _this.logger.log('schedules.component', 'setupOrigin ports', ports);
                _this.originPorts = ports;
                var selectAll = _this.schedules.selectedOriginPorts.length === 0;
                for (var current = 0; current < _this.originPorts.length; current++) {
                    var origin = _this.originPorts[current];
                    origin.selected = selectAll || (_this.schedules.selectedOriginPorts.indexOf(origin.port.id) > -1);
                    if (selectAll) {
                        _this.schedules.selectedOriginPorts.push(origin.port.id);
                    }
                }
                if (_this.destinationPorts.length !== 0 || _this.destinationType === 'port') {
                    // single port information is returned by the schedule call for speed
                    _this.getSchedules();
                }
            }).catch(function (err) {
                _this.originPorts = [];
                // ask user to re-search
            });
        }
        else {
            this.schedules.selectedOriginPorts = [+this.originId];
        }
    };
    SchedulesComponent.prototype.setupDestination = function (params) {
        var _this = this;
        if (params['selected_destination_ids'] != null) {
            this.schedules.selectedDestinationPorts = params['selected_destination_ids'].split(',').map(Number);
        }
        else {
            this.schedules.selectedDestinationPorts = [];
        }
        if (params['destination_search'] != null) {
            this.destinationSearch = params['destination_search'];
        }
        else {
            this.destinationSearch = 'Destination';
        }
        // destination id will always be a single id (be it port or region/country)
        if (params['destination_id'] != null) {
            this.destinationId = params['destination_id'];
        }
        if (params['destination_type'] != null) {
            this.destinationType = params['destination_type'];
        }
        if (params['with_nearby_destinations'] === 'true') {
            // this.nearbyDestinationPorts = Boolean(params['with_nearby_destinations']);
            if (this.service.app.accountType === '' || this.service.app.accountType === 'Basic') {
                this.nearbyDestinationPorts = false;
            }
            else {
                this.nearbyDestinationPorts = true;
            }
        }
        if (this.destinationType === 'share') {
            // shared search with multiple ports
        }
        else if (this.destinationType !== 'port') {
            this.service.getPortsForLocation(this.destinationType, this.destinationId).then(function (ports) {
                _this.logger.log('schedules.component', 'setupDestination ports', ports);
                _this.destinationPorts = ports;
                var selectAll = _this.schedules.selectedDestinationPorts.length === 0;
                for (var current = 0; current < _this.destinationPorts.length; current++) {
                    var destination = _this.destinationPorts[current];
                    destination.selected = selectAll || (_this.schedules.selectedDestinationPorts.indexOf(destination.port.id) > -1);
                    if (selectAll) {
                        _this.schedules.selectedDestinationPorts.push(destination.port.id);
                    }
                }
                if (_this.originPorts.length !== 0 || _this.originType === 'port') {
                    // single port information is returned by the schedule call for speed
                    _this.getSchedules();
                }
            }).catch(function (err) {
                _this.destinationPorts = [];
                // ask user to re-search
            });
        }
        else {
            this.schedules.selectedDestinationPorts = [+this.destinationId];
        }
    };
    SchedulesComponent.prototype.setupFilters = function (params) {
        if (params['carriers'] != null) {
            this.schedules.selectedCarriers = params['carriers'].split(',').map(Number);
        }
        else {
            this.schedules.selectedCarriers = [];
        }
        if (params['excluded_carriers'] != null) {
            this.schedules.excludedCarriers = params['excluded_carriers'].split(',').map(Number);
        }
        else {
            this.schedules.excludedCarriers = [];
        }
        if (params['transhipment_counts'] != null) {
            this.schedules.selectedTranshipments = params['transhipment_counts'].split(',').map(Number);
        }
        if (params['scroll'] != null && params['scroll'] == 'true') {
            window.scrollTo(0, 0);
        }
        this.sort = params['sort'] || 'duration';
        this.limit = +params['limit'] || 25;
        this.offset = +params['offset'] || 0;
        this.minDuration = +params['duration_gte'] || 0;
        this.maxDuration = +params['duration_lte'] || 0;
    };
    SchedulesComponent.prototype.setupDates = function (params) {
        if (moment(decodeURIComponent(params['start_date_gte'])).format('YYYY-MM-DD') != 'Invalid date') {
            this.departureSet = true;
            var gte = decodeURIComponent(params['start_date_gte']);
            var lte = decodeURIComponent(params['start_date_lte']);
            this.departureDateGreater = moment(gte).format('YYYY-MM-DD');
            this.departureDateLess = moment(lte).format('YYYY-MM-DD');
            this.departureRange = moment(this.departureDateGreater).format('YYYY-MM-DD') + ' to ' + moment(this.departureDateLess).format('YYYY-MM-DD');
        }
        if (moment(decodeURIComponent(params['end_date_gte'])).format('YYYY-MM-DD') != 'Invalid date') {
            this.arrivalSet = true;
            var gte = decodeURIComponent(params['end_date_gte']);
            var lte = decodeURIComponent(params['end_date_lte']);
            this.arrivalDateGreater = moment(gte).format('YYYY-MM-DD');
            this.arrivalDateLess = moment(lte).format('YYYY-MM-DD');
            this.arrivalRange = moment(this.arrivalDateGreater).format('YYYY-MM-DD') + ' to ' + moment(this.arrivalDateLess).format('YYYY-MM-DD');
        }
    };
    SchedulesComponent.prototype.setupPagination = function () {
        this.pageNumber = Math.floor(this.offset / this.limit) + 1;
        var pageTotal = Math.ceil(this.schedules.total / this.limit);
        var newPages = [];
        if (this.pages === null) {
            this.pages = [];
        }
        else if (pageTotal <= 9) {
            var count = 0;
            for (var current = 1; current <= pageTotal; current++) {
                newPages[count] = current;
                count = count + 1;
            }
            this.pages = newPages;
        }
        else if (this.pageNumber <= 5) {
            this.pages = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        }
        else if ((this.pageNumber > 5) && (this.pageNumber > pageTotal - 4)) {
            var count = 0;
            for (var current = pageTotal - 9; current <= pageTotal; current++) {
                newPages[count] = current;
                count = count + 1;
            }
            this.pages = newPages;
        }
        else {
            var count = 0;
            for (var current = this.pageNumber - 5; (current < this.pageNumber + 4) && (current < pageTotal); current++) {
                newPages[count] = current;
                count = count + 1;
            }
            this.pages = newPages;
        }
        if (this.pageNumber === pageTotal) {
            this.paginationContext = (this.limit * (this.pageNumber - 1) + 1) + ' - ' + (this.schedules.total) + ' of ' + this.schedules.total;
        }
        else {
            this.paginationContext = (this.limit * (this.pageNumber - 1) + 1) + ' - ' + (this.limit * this.pageNumber) + ' of ' + this.schedules.total;
        }
        this.resultsNumber = this.schedules.total.toString();
    };
    SchedulesComponent.prototype.toPage = function (page) {
        if (page == this.pageNumber) {
            // dont call update
            return;
        }
        this.offset = (page - 1) * this.limit;
        this.hideMaps();
        this.update();
    };
    SchedulesComponent.prototype.changeDisplay = function (type) {
        this.displayType = type;
    };
    SchedulesComponent.prototype.selectCarrier = function (carrier) {
        if (this.schedules.selectedCarriers.length === 1 && carrier.id === this.schedules.selectedCarriers[0]) {
            return;
        }
        carrier.selected = !carrier.selected;
        var excludedIndex = this.schedules.excludedCarriers.indexOf(carrier.id);
        var selectedIndex = this.schedules.selectedCarriers.indexOf(carrier.id);
        if (carrier.selected) {
            // select
            if (excludedIndex > -1) {
                this.schedules.excludedCarriers.splice(excludedIndex, 1);
            }
            if (this.schedules.selectedCarriers.length !== 0) {
                if (selectedIndex === -1) {
                    this.schedules.selectedCarriers.push(carrier.id);
                }
            }
        }
        else {
            // de-select
            if (excludedIndex === -1) {
                this.schedules.excludedCarriers.push(carrier.id);
            }
            if (this.schedules.selectedCarriers.length !== 0) {
                if (selectedIndex > -1) {
                    this.schedules.selectedCarriers.splice(selectedIndex, 1);
                }
            }
        }
        this.hideMaps();
        this.update();
    };
    SchedulesComponent.prototype.selectDestinationPort = function (destination) {
        if (this.schedules.selectedDestinationPorts.length === 1 && destination.port.id === this.schedules.selectedDestinationPorts[0]) {
            return;
        }
        destination.selected = !destination.selected;
        var index = this.schedules.selectedDestinationPorts.indexOf(destination.port.id);
        if (index > -1) {
            this.schedules.selectedDestinationPorts.splice(index, 1);
            destination.port.iconUrl = '../img/port-unselected.png';
        }
        else {
            this.schedules.selectedDestinationPorts.push(destination.port.id);
            destination.port.iconUrl = '../img/port-selected.png';
        }
        // this.update();
        this.getSchedules();
    };
    SchedulesComponent.prototype.selectOriginPort = function (origin) {
        if (this.schedules.selectedOriginPorts.length === 1 && origin.port.id === this.schedules.selectedOriginPorts[0]) {
            return;
        }
        origin.selected = !origin.selected;
        var index = this.schedules.selectedOriginPorts.indexOf(origin.port.id);
        if (index > -1) {
            this.schedules.selectedOriginPorts.splice(index, 1);
            origin.port.iconUrl = '../img/port-unselected.png';
        }
        else {
            this.schedules.selectedOriginPorts.push(origin.port.id);
            origin.port.iconUrl = '../img/port-selected.png';
        }
        // this.update();
        this.getSchedules();
    };
    SchedulesComponent.prototype.deselectTransShipments = function () {
        if (this.schedules.transhipments.length > 1) {
            this.showTransSales = true;
        }
    };
    SchedulesComponent.prototype.selectTranshipment = function (transhipment, only) {
        if (only === void 0) { only = false; }
        if (this.schedules.selectedTranshipments.length === 1 && transhipment.amount === this.schedules.selectedTranshipments[0]) {
            return; // do not let user de-select all transhipments
        }
        transhipment.selected = only ? true : !transhipment.selected;
        if (only) {
            this.schedules.selectedTranshipments = [transhipment.amount];
        }
        else {
            this.schedules.selectedTranshipments = [];
            for (var index = 0; index < this.schedules.transhipments.length; index++) {
                var transhipment_1 = this.schedules.transhipments[index];
                if (transhipment_1.selected) {
                    this.schedules.selectedTranshipments.push(transhipment_1.amount);
                }
            }
        }
        this.hideMaps();
        this.update();
    };
    SchedulesComponent.prototype.portsAll = function () {
        this.schedules.selectedOriginPorts = [];
        this.schedules.selectedDestinationPorts = [];
        for (var current = 0; current < this.originPorts.length; current++) {
            var origin = this.originPorts[current];
            origin.selected = true;
            this.schedules.selectedOriginPorts.push(origin.port.id);
        }
        for (var current = 0; current < this.destinationPorts.length; current++) {
            var destination = this.destinationPorts[current];
            destination.selected = true;
            this.schedules.selectedDestinationPorts.push(destination.port.id);
        }
        this.hideMaps();
        this.update();
    };
    SchedulesComponent.prototype.carriersAll = function () {
        this.schedules.selectedCarriers = [];
        this.schedules.excludedCarriers = [];
        for (var current = 0; current < this.schedules.carriers.length; current++) {
            this.schedules.carriers[current].selected = true;
        }
        this.hideMaps();
        this.update();
    };
    SchedulesComponent.prototype.clearAll = function () {
        this.schedules.selectedCarriers = [];
        this.schedules.excludedCarriers = [];
        for (var current = 0; current < this.schedules.carriers.length; current++) {
            this.schedules.carriers[current].selected = false;
            this.schedules.excludedCarriers.push(this.schedules.carriers[current].id);
        }
        this.hideMaps();
        this.update();
    };
    SchedulesComponent.prototype.allSelected = function () {
        var allSelected = true;
        for (var current = 0; current < this.schedules.carriers.length; current++) {
            if (this.schedules.carriers[current].selected == false) {
                allSelected = false;
            }
        }
        return allSelected;
    };
    SchedulesComponent.prototype.allCleared = function () {
        var allCleared = true;
        for (var current = 0; current < this.schedules.carriers.length; current++) {
            if (this.schedules.carriers[current].selected == true) {
                allCleared = false;
            }
        }
        return allCleared;
    };
    SchedulesComponent.prototype.portsFavorites = function () {
        if (this.service.app.ports.length === 0) {
            return;
        }
        try {
            var selectedOriginPorts = [];
            var selectedDestinationPorts = [];
            for (var current = 0; current < this.originPorts.length; current++) {
                var origin = this.originPorts[current];
                if (origin.port.userData.favorited) {
                    selectedOriginPorts.push(origin.port.id);
                    origin.selected = true;
                }
                else {
                    origin.selected = false;
                }
            }
            for (var current = 0; current < this.destinationPorts.length; current++) {
                var destination = this.destinationPorts[current];
                if (destination.port.userData.favorited) {
                    selectedDestinationPorts.push(destination.port.id);
                    destination.selected = true;
                }
                else {
                    destination.selected = false;
                }
            }
            this.schedules.selectedOriginPorts = selectedOriginPorts.length == 0 ? this.schedules.selectedOriginPorts : selectedOriginPorts;
            this.schedules.selectedDestinationPorts = selectedDestinationPorts.length == 0 ? this.schedules.selectedDestinationPorts : selectedDestinationPorts;
            this.hideMaps();
            this.update();
        }
        catch (ex) {
            // not logged in
        }
    };
    SchedulesComponent.prototype.carriersFavorites = function () {
        if (this.service.app.carriers.length === 0) {
            return;
        }
        try {
            this.schedules.selectedCarriers = [];
            this.schedules.excludedCarriers = [];
            for (var current = 0; current < this.schedules.carriers.length; current++) {
                if (this.schedules.carriers[current].userData.favorited) {
                    this.schedules.carriers[current].selected = true;
                }
            }
            for (var current = 0; current < this.service.app.carriers.length; current++) {
                this.schedules.selectedCarriers.push(this.service.app.carriers[current].id);
            }
            this.hideMaps();
            this.update();
        }
        catch (ex) {
            // not logged in
        }
    };
    SchedulesComponent.prototype.rangeChange = function (target) {
        this.logger.log('schedules.component', 'rangeChange startValue', +target.value);
        this.logger.log('schedules.component', 'rangeChange endValue', +target.highValue);
        this.minDuration = +target.value;
        this.maxDuration = +target.highValue;
        this.hideMaps();
        this.update();
    };
    SchedulesComponent.prototype.update = function () {
        var params = {
            origin_id: this.originId,
            origin_type: this.originType,
            origin_search: this.originSearch.trim(),
            destination_id: this.destinationId,
            destination_type: this.destinationType,
            destination_search: this.destinationSearch.trim(),
            selected_origin_ids: this.schedules.selectedOriginPorts,
            selected_destination_ids: this.schedules.selectedDestinationPorts,
            sort: this.sort,
            limit: this.limit,
            offset: this.offset
        };
        this.setRouteFilterParams(params);
        this.setRouteDates(params);
        localStorage.setItem('saved-schedules' + this.originId + this.destinationId, JSON.stringify(this.schedules));
        this.router.navigate(['/schedules', params]);
    };
    SchedulesComponent.prototype.setRouteDates = function (params) {
        if (this.departureSet) {
            if (moment(this.departureDateLess, 'YYYY-MM-DD').isBefore(this.departureDateGreater)) {
                params['start_date_gte'] = encodeURIComponent(this.departureDateLess);
                params['start_date_lte'] = encodeURIComponent(this.departureDateGreater);
            }
            else {
                params['start_date_gte'] = encodeURIComponent(this.departureDateGreater);
                params['start_date_lte'] = encodeURIComponent(this.departureDateLess);
            }
            // changing the date string creates an Angular exception because you change the value after it has checked the value
        }
        if (this.arrivalSet) {
            if (moment(this.arrivalDateLess, 'YYYY-MM-DD').isBefore(this.arrivalDateGreater)) {
                params['end_date_gte'] = encodeURIComponent(this.arrivalDateLess);
                params['end_date_lte'] = encodeURIComponent(this.arrivalDateGreater);
            }
            else {
                params['end_date_gte'] = encodeURIComponent(this.arrivalDateGreater);
                params['end_date_lte'] = encodeURIComponent(this.arrivalDateLess);
            }
            // changing the date string creates an Angular exception because you change the value after it has checked the value
        }
        if (this.minDuration !== 0 || this.maxDuration !== 0) {
            params['duration_gte'] = this.minDuration.toString();
            params['duration_lte'] = this.maxDuration.toString();
        }
    };
    SchedulesComponent.prototype.searchIdUpdate = function (result) {
        var data = result.data.details;
        var params = {};
        this.setSavedPortParams(params, data);
        this.setSavedFilterParams(params, data);
        this.setSavedDateParams(params, data);
        this.router.navigate(['/schedules', params]);
    };
    SchedulesComponent.prototype.setSavedPortParams = function (params, data) {
        if (data['origin_search'] != null) {
            params['origin_search'] = data['origin_search'];
        }
        if (data['origin_ids'] != null) {
            var origins = data['origin_ids'].split(',').map(Number);
            if (origins.length === 1) {
                //port
                params['origin_id'] = origins;
            }
            else {
                params['selected_origin_ids'] = origins;
                params['origin_type'] = 'share';
            }
        }
        if (data['destination_ids'] != null) {
            var destinations = data['destination_ids'].split(',').map(Number);
            if (destinations.length === 1) {
                params['destination_id'] = destinations;
            }
            else {
                params['selected_destination_ids'] = destinations;
                params['destination_type'] = 'share';
            }
        }
        if (data['destination_search'] != null) {
            params['destination_search'] = data['destination_search'];
        }
    };
    SchedulesComponent.prototype.setSavedFilterParams = function (params, data) {
        params.sort = data.sort || 'duration';
        params.limit = +data.limit || 25;
        params.offset = +data.offset || 0;
        if (data['transhipment_counts'] != null) {
            params['transhipment_counts'] = data['transhipment_counts'];
        }
        if (data['carriers'] != null) {
            params['carriers'] = data['carriers'];
        }
        if (data['carriers.ne'] != null) {
            params['excluded_carriers'] = data['carriers.ne'];
        }
    };
    SchedulesComponent.prototype.setSavedDateParams = function (params, data) {
        if (data['start_date.gte'] != null && data['start_date.lte'] != null) {
            params['start_date_gte'] = data['start_date.gte'];
            params['start_date_lte'] = data['start_date.lte'];
        }
        if (data['end_date.gte'] != null && data['end_date.lte'] != null) {
            params['end_date_gte'] = data['end_date.gte'];
            params['end_date_lte'] = data['end_date.lte'];
        }
        if (data['duration.gte'] != null) {
            params['duration_gte'] = data['duration.gte'];
        }
        if (data['duration.lte'] != null) {
            params['duration_lte'] = data['duration.lte'];
        }
    };
    SchedulesComponent.prototype.getSchedules = function (retry) {
        if (retry === void 0) { retry = true; }
        var params = this.getParams();
        this.callGetSchedules(params, retry);
    };
    SchedulesComponent.prototype.getParams = function () {
        var params = {
            origin_search: this.originSearch.trim(),
            origin_ids: this.schedules.selectedOriginPorts,
            destination_search: this.destinationSearch.trim(),
            destination_ids: this.schedules.selectedDestinationPorts,
            with_nearby_origins: +this.nearbyOriginPorts,
            with_nearby_destinations: +this.nearbyDestinationPorts,
            sort: this.sort,
            limit: this.limit,
            offset: this.offset,
        };
        this.setFilterParams(params);
        this.setDateParams(params);
        return params;
    };
    SchedulesComponent.prototype.callGetSchedules = function (params, retry) {
        var _this = this;
        this.logger.log('schedules.component', 'callGetSchedules params', params);
        if (params.destination_ids.length == 0 || params.origin_ids.length == 0) {
            this.formatSchedules(null);
            this.service.loaderOff = true;
            this.service.noResult = true;
        }
        else {
            this.service.getSchedules(params).then(function (schedules) {
                _this.formatSchedules(schedules);
            }).catch(function (ex) {
                if (ex === 403 && retry) {
                    _this.getSchedules(false);
                }
            });
        }
    };
    SchedulesComponent.prototype.setRouteFilterParams = function (params) {
        if (this.schedules.selectedTranshipments.length !== 0) {
            params['transhipment_counts'] = this.schedules.selectedTranshipments;
        }
        if (this.schedules.selectedCarriers.length !== 0) {
            params['carriers'] = this.schedules.selectedCarriers;
        }
        if (this.schedules.excludedCarriers.length !== 0) {
            params['excluded_carriers'] = this.schedules.excludedCarriers;
        }
    };
    SchedulesComponent.prototype.setFilterParams = function (params) {
        if (this.schedules.selectedTranshipments.length !== 0) {
            params['transhipment_counts'] = this.schedules.selectedTranshipments;
        }
        if (this.schedules.selectedCarriers.length !== 0) {
            params['carriers'] = this.schedules.selectedCarriers;
        }
        if (this.schedules.excludedCarriers.length !== 0) {
            params['carriers.ne'] = this.schedules.excludedCarriers;
        }
    };
    SchedulesComponent.prototype.setDateParams = function (params) {
        var start_gte = this.departureDateGreater !== undefined ? this.departureDateGreater : '';
        var start_lte = this.departureDateLess !== undefined ? this.departureDateLess : '';
        if (start_gte !== '') {
            params['start_date.gte'] = start_gte;
        }
        if (start_lte !== '') {
            params['start_date.lte'] = start_lte;
        }
        var end_gte = this.arrivalDateGreater !== undefined ? this.arrivalDateGreater : '';
        var end_lte = this.arrivalDateLess !== undefined ? this.arrivalDateLess : '';
        if (end_gte !== '') {
            params['end_date.gte'] = end_gte;
        }
        if (end_gte !== '') {
            params['end_date.lte'] = end_lte;
        }
        var duration_gte = this.minDuration === 0 ? '' : this.minDuration;
        var duration_lte = this.maxDuration === 0 ? '' : this.maxDuration;
        if (duration_gte !== '') {
            params['duration.gte'] = duration_gte;
        }
        if (duration_lte !== '') {
            params['duration.lte'] = duration_lte;
        }
    };
    SchedulesComponent.prototype.formatSchedules = function (schedules) {
        this.logger.log('schedules.component', 'formatSchedules', schedules);
        if (schedules !== null) {
            this.schedules = schedules;
            this.formatOrigin();
            this.formatDestination();
            this.formatMessage();
            this.formatSubject();
        }
        else {
            var old = JSON.parse(localStorage.getItem('saved-schedules' + this.originId + this.destinationId));
            if (old !== null && old !== undefined) {
                old.items = [];
                this.schedules = old;
                this.formatOrigin();
                this.formatDestination();
            }
        }
        this.setupPagination();
    };
    SchedulesComponent.prototype.formatOrigin = function () {
        this.nearbyOriginPorts = false;
        if (this.originType === 'port' || this.originType === 'share') {
            this.originPorts = this.schedules.originPorts;
        }
        else {
            for (var current = 0; current < this.originPorts.length; current++) {
                var item = this.originPorts[current];
                if (this.schedules.selectedOriginPorts.indexOf(item.port.id) > -1) {
                    for (var index = 0; index < this.schedules.originPorts.length; index++) {
                        if (item.port.id === this.schedules.originPorts[index].port.id) {
                            item.selected = this.schedules.originPorts[index].selected;
                            item.count = this.schedules.originPorts[index].count;
                            item.iconUrl = this.schedules.originPorts[index].port.iconUrl;
                        }
                    }
                }
            }
        }
    };
    SchedulesComponent.prototype.formatDestination = function () {
        this.nearbyDestinationPorts = false;
        if (this.destinationType === 'port' || this.destinationType === 'share') {
            this.destinationPorts = this.schedules.destinationPorts;
        }
        else {
            for (var current = 0; current < this.destinationPorts.length; current++) {
                var item = this.destinationPorts[current];
                if (this.schedules.selectedDestinationPorts.indexOf(item.port.id) >= 0) {
                    for (var index = 0; index < this.schedules.destinationPorts.length; index++) {
                        if (item.port.id === this.schedules.destinationPorts[index].port.id) {
                            item.selected = this.schedules.destinationPorts[index].selected;
                            item.count = this.schedules.destinationPorts[index].count;
                            item.iconUrl = this.schedules.destinationPorts[index].port.iconUrl;
                        }
                    }
                }
            }
        }
    };
    SchedulesComponent.prototype.formatMessage = function () {
        // ex. '153 Schedule Search Results. Origin: Shanghai; Destination: Yokohame; Departure: 16-10-5 to 16-10-12; Duration: 5 to 30 days; Carriers: Maersk, MSC, Evergreen'
        var carriers = '';
        try {
            if (this.schedules.selectedCarriers.length !== 0 && (this.schedules.selectedCarriers.length !== this.schedules.carriers.length)) {
                carriers = 'Carriers: ';
                for (var current = 0; current < this.schedules.carriers.length; current++) {
                    carriers += this.schedules.carriers[current].selected ? this.schedules.carriers[current].name + ', ' : '';
                }
                carriers = carriers.slice(0, -2);
            }
            var origin = '';
            var destination = '';
            this.schedules.message =
                this.schedules.total.toString() +
                    this.formatMessagePorts() +
                    this.formatMessageDates() +
                    carriers;
        }
        catch (ex) {
            this.schedules.message = '';
        }
    };
    SchedulesComponent.prototype.formatMessagePorts = function () {
        var origin = this.originSearch === 'Origin' ? this.schedules.originPorts[0].port.name : this.originSearch;
        var destination = this.destinationSearch === 'Destination' ? this.schedules.destinationPorts[0].port.name : this.destinationSearch;
        return ' Schedule Search Results. Origin: ' + origin + '; Destination: ' + destination;
    };
    SchedulesComponent.prototype.formatMessageDates = function () {
        var range = '';
        var duration = '';
        if (this.departureSet) {
            var beginning = encodeURIComponent(moment(this.departureDateGreater).format('YYYY-MM-DD'));
            var end = encodeURIComponent(moment(this.departureDateLess).format('YYYY-MM-DD'));
            range = '; Departure: ' + beginning + ' to ' + end + '; ';
        }
        else {
            var beginning = encodeURIComponent(moment(this.arrivalDateGreater).format('YYYY-MM-DD'));
            var end = encodeURIComponent(moment(this.arrivalDateLess).format('YYYY-MM-DD'));
            range = '; Arrival: ' + beginning + ' to ' + end + '; ';
        }
        if (this.minDuration !== 0 || this.maxDuration !== 0) {
            var beginning = this.minDuration.toString();
            var end = this.maxDuration.toString();
            duration = beginning + ' to ' + end + ' days; ';
        }
        return range + duration;
    };
    SchedulesComponent.prototype.formatSubject = function () {
        try {
            var sharedBy = this.service.app.email === '' ? 'someone' : this.service.app.email;
            this.schedules.subject = this.schedules.total + ' Linescape Schedules Search Results shared by ' + sharedBy;
        }
        catch (ex) {
            this.schedules.subject = 'Linescape Schedule Search Results shared by someone';
        }
    };
    SchedulesComponent.prototype.contact = function (schedule) {
        if (this.service.app.accountType === '') {
            this.service.app.showRegister();
        }
        else {
            this.contactSchedule = schedule;
            this.showContact = !this.showContact;
        }
    };
    SchedulesComponent.prototype.closeContact = function () {
        this.showContact = false;
    };
    SchedulesComponent.prototype.book = function (schedule) {
    };
    SchedulesComponent.prototype.bookmark = function (schedule) {
    };
    SchedulesComponent.prototype.viewDetails = function (item) {
        if (item.viewDetials = false) {
            try {
                // ga('send', 'event', 'Port Pair Results', 'Viewed Details');
            }
            catch (ex) {
            }
        }
        item.viewDetails = !item.viewDetails;
    };
    SchedulesComponent.prototype.toggleDepartureRange = function () {
        this.showDepartureRange = !this.showDepartureRange;
        if (!this.showDepartureRange) {
            this.hideMaps();
            this.update();
        }
    };
    SchedulesComponent.prototype.toggleArrivalRange = function () {
        this.showArrivalRange = !this.showArrivalRange;
        if (!this.showArrivalRange) {
            this.hideMaps();
            this.update();
        }
        // changed from (ngModelChange)=update() so it only updates when you close the departure range again
    };
    SchedulesComponent.prototype.hideMaps = function () {
        this.mapsHiddenVar = true;
    };
    SchedulesComponent.prototype.toggleSave = function () {
        this.showSave = !this.showSave;
    };
    SchedulesComponent.prototype.closeSave = function () {
        this.showSave = false;
    };
    SchedulesComponent.prototype.toggleShare = function () {
        this.showShare = !this.showShare;
    };
    SchedulesComponent.prototype.closeShare = function () {
        this.showShare = false;
    };
    // searchesSearchIdDownloadGet
    SchedulesComponent.prototype.destinationMarkerClicked = function (item) {
        this.selectDestinationPort(item);
    };
    SchedulesComponent.prototype.originMarkerClicked = function (item) {
        this.selectOriginPort(item);
    };
    SchedulesComponent.prototype.setSort = function (header) {
        this.sort = header;
        this.update();
    };
    SchedulesComponent.prototype.toggleActions = function (schedule) {
        schedule.viewActions = !schedule.viewActions;
    };
    SchedulesComponent.prototype.slideOutIn = function () {
        this.sidebarActive = !this.sidebarActive;
    };
    SchedulesComponent.prototype.download = function () {
        if (this.service.app.accountType === '') {
            this.service.app.showRegister();
        }
        else {
            this.service.getDownload(this.schedules.searchId);
        }
    };
    SchedulesComponent.prototype.toggleMaps = function (schedule) {
        if (localStorage.getItem('mapsHidden') === 'true' || this.mapsHiddenVar) {
            localStorage.setItem('mapsHidden', 'false');
            this.mapsHiddenVar = false;
        }
        else {
            localStorage.setItem('mapsHidden', 'true');
            this.mapsHiddenVar = true;
        }
    };
    SchedulesComponent.prototype.expandOrigins = function () {
        this.showAllOriginPorts = true;
        this.service.resizeSidebar();
    };
    SchedulesComponent.prototype.expandDestinations = function () {
        this.showAllDestinationPorts = true;
        this.service.resizeSidebar();
    };
    SchedulesComponent.prototype.registerMessage = function () {
        this.service.app.showRegister();
    };
    __decorate([
        core_1.HostListener('window:resize', ['$event.target']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SchedulesComponent.prototype, "onResize", null);
    SchedulesComponent = __decorate([
        core_1.Component({
            selector: 'schedules',
            template: __webpack_require__(576),
            styles: [__webpack_require__(577)],
            providers: [schedules_service_1.SchedulesService]
        }),
        __metadata("design:paramtypes", [shared_1.LogService, schedules_service_1.SchedulesService, router_1.ActivatedRoute, router_1.Router, core_1.NgZone])
    ], SchedulesComponent);
    return SchedulesComponent;
}());
exports.SchedulesComponent = SchedulesComponent;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var ports_service_1 = __webpack_require__(578);
var _1 = __webpack_require__(2);
var PortsComponent = (function () {
    function PortsComponent(service, logger, route, router) {
        this.service = service;
        this.logger = logger;
        this.route = route;
        this.router = router;
        this.schedules = {
            scheduleId: 0,
            total: 0,
            carriers: new Array(),
            selectedCarriers: new Array(),
            excludedCarriers: new Array(),
            items: new Array()
        };
        this.port = {
            display: '',
            userData: {
                favorited: false,
                note: ''
            }
        };
        this.limit = 20;
        this.pages = [];
        this.pageNumber = 1;
        this.paginationContext = '';
        this.sidebarActive = false;
        // Do stuff
    }
    PortsComponent.prototype.ngOnInit = function () {
        this.logger.log('ports.component', 'ngOnInit', this.route.snapshot.params);
        this.sub = this.route.params.subscribe(this.setupPage.bind(this));
    };
    PortsComponent.prototype.ngOnDestroy = function () {
        this.sub.unsubscribe();
    };
    PortsComponent.prototype.ngAfterViewInit = function () {
        this.service.resizeSidebar();
    };
    PortsComponent.prototype.onResize = function () {
        this.service.resizeSidebar();
    };
    PortsComponent.prototype.setupPage = function (params) {
        this.portId = +params['id'];
        if (moment(decodeURIComponent(params['date']), 'YYYY-MM-DD').format('YYYY-MM-DD') != 'Invalid date') {
            var date = decodeURIComponent(params['date']);
            this.date = moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD');
        }
        else {
            this.date = moment().format('YYYY-MM-DD');
        }
        if ((params['selected_carriers'] != null) && (params['selected_carriers'] !== 0)) {
            this.schedules.selectedCarriers = params['selected_carriers'].split(',').map(Number);
        }
        else {
            this.schedules.selectedCarriers = [];
        }
        if ((params['excluded_carriers'] != null) && (params['excluded_carriers'] !== 0)) {
            this.schedules.excludedCarriers = params['excluded_carriers'].split(',').map(Number);
        }
        else {
            this.schedules.excludedCarriers = [];
        }
        this.limit = +params['limit'] || 20;
        this.offset = +params['offset'] || 0;
        if (params['scroll'] != null && params['scroll'] === 'true') {
            window.scrollTo(0, 0);
        }
        this.getPortSchedules();
        this.getPort();
    };
    PortsComponent.prototype.setupPagination = function () {
        this.pageNumber = Math.floor(this.offset / this.limit) + 1;
        var pageTotal = Math.ceil(this.schedules.total / this.limit);
        var newPages = [];
        if (this.pages === null) {
            this.pages = [];
        }
        else if (pageTotal <= 9) {
            var count = 0;
            for (var current = 1; current <= pageTotal; current++) {
                newPages[count] = current;
                count = count + 1;
            }
            this.pages = newPages;
        }
        else if (this.pageNumber <= 5) {
            this.pages = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        }
        else if ((this.pageNumber > 5) && (this.pageNumber > pageTotal - 4)) {
            var count = 0;
            for (var current = pageTotal - 9; current <= pageTotal; current++) {
                newPages[count] = current;
                count = count + 1;
            }
            this.pages = newPages;
        }
        else {
            var count = 0;
            for (var current = this.pageNumber - 5; (current < this.pageNumber + 4) && (current < pageTotal); current++) {
                newPages[count] = current;
                count = count + 1;
            }
            this.pages = newPages;
        }
        if (this.pageNumber === pageTotal) {
            this.paginationContext = (this.limit * (this.pageNumber - 1) + 1) + ' - ' + (this.schedules.total) + ' of ' + this.schedules.total;
        }
        else {
            this.paginationContext = (this.limit * (this.pageNumber - 1) + 1) + ' - ' + (this.limit * this.pageNumber) + ' of ' + this.schedules.total;
        }
    };
    PortsComponent.prototype.toPage = function (page) {
        if (page == this.pageNumber) {
            // dont call update
            return;
        }
        this.service.loaderOff = false;
        this.offset = (page - 1) * this.limit;
        this.update();
    };
    PortsComponent.prototype.selectCarrier = function (carrier) {
        carrier.selected = !carrier.selected;
        var excludedIndex = this.schedules.excludedCarriers.indexOf(carrier.carrier.id);
        var selectedIndex = this.schedules.selectedCarriers.indexOf(carrier.carrier.id);
        if (carrier.selected) {
            // select
            if (excludedIndex > -1) {
                this.schedules.excludedCarriers.splice(excludedIndex, 1);
            }
            if (this.schedules.selectedCarriers.length !== 0) {
                if (selectedIndex === -1) {
                    this.schedules.selectedCarriers.push(carrier.carrier.id);
                }
            }
        }
        else {
            // de-select
            if (excludedIndex === -1) {
                this.schedules.excludedCarriers.push(carrier.carrier.id);
            }
            if (this.schedules.selectedCarriers.length !== 0) {
                if (selectedIndex > -1) {
                    this.schedules.selectedCarriers.splice(selectedIndex, 1);
                }
            }
            ;
        }
        // // standard operating procedure
        // let index = this.schedules.excludedCarriers.indexOf(carrier.carrier.id);
        // if (index > -1) {
        //   this.schedules.excludedCarriers.splice(index, 1);
        // }
        // else {
        //   this.schedules.excludedCarriers.push(carrier.carrier.id);
        // }
        this.update();
    };
    PortsComponent.prototype.selectAll = function () {
        this.schedules.selectedCarriers = [];
        this.schedules.excludedCarriers = [];
        for (var current = 0; current < this.schedules.carriers.length; current++) {
            this.schedules.carriers[current].selected = true;
            // this.schedules.selectedCarriers.push(this.schedules.carriers[current].id);
        }
        this.update();
    };
    PortsComponent.prototype.clearAll = function () {
        for (var current = 0; current < this.schedules.carriers.length; current++) {
            if (this.schedules.carriers[current].selected == true) {
                var excludedIndex = this.schedules.excludedCarriers.indexOf(this.schedules.carriers[current].carrier.id);
                var selectedIndex = this.schedules.selectedCarriers.indexOf(this.schedules.carriers[current].carrier.id);
                if (excludedIndex === -1) {
                    this.schedules.excludedCarriers.push(this.schedules.carriers[current].carrier.id);
                }
                if (this.schedules.selectedCarriers.length !== 0) {
                    if (selectedIndex > -1) {
                        this.schedules.selectedCarriers.splice(selectedIndex, 1);
                    }
                }
                ;
            }
        }
        this.update();
    };
    PortsComponent.prototype.allSelected = function () {
        var allSelected = true;
        for (var current = 0; current < this.schedules.carriers.length; current++) {
            if (this.schedules.carriers[current].selected == false) {
                allSelected = false;
            }
        }
        return allSelected;
    };
    PortsComponent.prototype.allCleared = function () {
        var allCleared = true;
        for (var current = 0; current < this.schedules.carriers.length; current++) {
            if (this.schedules.carriers[current].selected == true) {
                allCleared = false;
            }
        }
        return allCleared;
    };
    PortsComponent.prototype.favoritesOnly = function () {
        if (this.service.app.carriers.length === 0) {
            return;
        }
        try {
            this.schedules.selectedCarriers = [];
            this.schedules.excludedCarriers = [];
            for (var current = 0; current < this.schedules.carriers.length; current++) {
                if (this.schedules.carriers[current].carrier.userData.favorited) {
                    this.schedules.carriers[current].selected = true;
                }
            }
            for (var current = 0; current < this.service.app.carriers.length; current++) {
                this.schedules.selectedCarriers.push(this.service.app.carriers[current].id);
            }
            this.update();
        }
        catch (ex) {
            // not logged in
            this.logger.log('ports.components', 'favoritesOnly catch', ex);
        }
    };
    PortsComponent.prototype.changeDate = function () {
        if (this.port !== null) {
            this.update();
        }
    };
    PortsComponent.prototype.nextDay = function () {
        var date = moment(this.date, 'YYYY-MM-DD').add(1, 'days');
        var ninetydays = moment().add(89, 'days');
        var minusthirtydays = moment().subtract(29, 'days');
        if (date.isAfter(ninetydays) || date.isBefore(minusthirtydays)) {
            this.service.app.showMessage('Date', 'Data limited to 90 days in the future');
            return;
        }
        if (this.port !== null) {
            this.update(date.format('YYYY-MM-DD'));
        }
    };
    PortsComponent.prototype.previousDay = function () {
        var date = moment(this.date).subtract(1, 'days');
        var ninetydays = moment().add(89, 'days');
        var minusthirtydays = moment().subtract(29, 'days');
        if (date.isAfter(ninetydays) || date.isBefore(minusthirtydays)) {
            this.service.app.showMessage('Date', 'Data limited prior to 30 days in the past');
            return;
        }
        if (this.port !== null) {
            this.update(date.format('YYYY-MM-DD')); // changing date creates angular change detection error
        }
    };
    PortsComponent.prototype.update = function (date) {
        if (date === void 0) { date = ''; }
        var params = {
            date: date === '' ? this.date : date
        };
        if (this.schedules.selectedCarriers.length !== 0 && (this.schedules.selectedCarriers.length !== this.schedules.carriers.length) && (this.schedules.selectedCarriers.length !== 1 && this.schedules.selectedCarriers[0] !== 0)) {
            params['selected_carriers'] = this.schedules.selectedCarriers;
        }
        if (this.schedules.excludedCarriers.length !== 0) {
            params['excluded_carriers'] = this.schedules.excludedCarriers;
        }
        if (this.limit !== 20) {
            params['limit'] = this.limit;
        }
        if (this.offset !== 0) {
            params['offset'] = this.offset;
        }
        this.router.navigate(['/ports', this.portId, params]);
    };
    PortsComponent.prototype.getPortSchedules = function (retry) {
        var _this = this;
        if (retry === void 0) { retry = true; }
        this.logger.log('ports.component', 'getPortSchedules', this.schedules.selectedCarriers);
        var params = {
            'eta.lte': this.date,
            'etd.gte': this.date
        };
        this.service.loaderOff = false;
        if (this.schedules.selectedCarriers.length !== 0) {
            params['carriers'] = this.schedules.selectedCarriers;
        }
        if (this.schedules.excludedCarriers.length !== 0) {
            params['carriers.ne'] = this.schedules.excludedCarriers;
        }
        if (this.limit !== 20) {
            params['limit'] = this.limit;
        }
        if (this.offset !== 0) {
            params['offset'] = this.offset;
        }
        this.service.getPortSchedules(this.portId, params).then(function (schedules) {
            if (schedules !== null) {
                _this.schedules = schedules;
            }
            _this.setupPagination();
        }).catch(function (ex) {
            if (ex === 403 && retry) {
                _this.getPortSchedules(false);
            }
        });
    };
    PortsComponent.prototype.getPort = function (retry) {
        var _this = this;
        if (retry === void 0) { retry = true; }
        this.service.getPort(this.portId).then(function (port) {
            if (port !== null) {
                _this.port = port;
            }
        }).catch(function (ex) {
            if (ex === 403 && retry) {
                _this.getPort(false);
            }
        });
    };
    PortsComponent.prototype.slideOutIn = function () {
        this.sidebarActive = !this.sidebarActive;
    };
    PortsComponent.prototype.registerMessage = function () {
        this.service.app.showRegister();
    };
    __decorate([
        core_1.HostListener('window:resize', ['$event.target']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PortsComponent.prototype, "onResize", null);
    PortsComponent = __decorate([
        core_1.Component({
            selector: 'ports',
            template: __webpack_require__(579),
            styles: [__webpack_require__(580)],
            providers: [ports_service_1.PortsService]
        }),
        __metadata("design:paramtypes", [ports_service_1.PortsService, _1.LogService, router_1.ActivatedRoute, router_1.Router])
    ], PortsComponent);
    return PortsComponent;
}());
exports.PortsComponent = PortsComponent;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var carriers_service_1 = __webpack_require__(581);
var favorite_directive_1 = __webpack_require__(94);
var contacts_1 = __webpack_require__(238);
var models_1 = __webpack_require__(12);
var results_1 = __webpack_require__(239);
var CarriersComponent = (function () {
    function CarriersComponent(service, route, router, zone) {
        this.service = service;
        this.route = route;
        this.router = router;
        this.zone = zone;
        this.vessels = new results_1.VesselResults(null);
        this.carrier = new models_1.Carrier(null);
        this.contacts = new contacts_1.Contacts(null);
        this.country = { name: 'Select Country', id: '' };
        this.countries = [{ count: 0, country: this.country }];
        this.pages = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        this.pageNumber = 1;
        this.paginationContext = '';
        this.offset = 0;
        this.limit = 20;
        this.sidebarActive = false;
        // Do stuff
    }
    CarriersComponent.prototype.onResize = function () {
        this.service.resizeSidebar();
    };
    CarriersComponent.prototype.ngOnInit = function () {
        this.sub = this.route.params.subscribe(this.setupPage.bind(this));
    };
    CarriersComponent.prototype.ngOnDestroy = function () {
        this.sub.unsubscribe();
    };
    CarriersComponent.prototype.ngAfterViewInit = function () {
        this.service.resizeSidebar();
        this.carrierNotice = document.getElementById('carrier-notice');
        this.noticeLabel = document.getElementById('notice-label');
        this.noticeData = document.getElementById('notice-data');
    };
    CarriersComponent.prototype.setupPage = function (params) {
        this.carrierId = +params['id'];
        this.limit = +params['limit'] || 20;
        this.offset = +params['offset'] || 0;
        this.getVessels();
        this.getCarrier();
        this.getContacts();
        if (params['scroll'] != null && params['scroll'] === 'true') {
            window.scrollTo(0, 0);
        }
    };
    CarriersComponent.prototype.setupPagination = function () {
        this.pageNumber = Math.floor(this.offset / this.limit) + 1;
        var pageTotal = Math.ceil(this.vessels.total / this.limit);
        var newPages = [];
        if (this.pages === null) {
            this.pages = [];
        }
        else if (pageTotal <= 9) {
            var count = 0;
            for (var current = 1; current <= pageTotal; current++) {
                newPages[count] = current;
                count = count + 1;
            }
            this.pages = newPages;
        }
        else if (this.pageNumber <= 5) {
            this.pages = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        }
        else if ((this.pageNumber > 5) && (this.pageNumber > pageTotal - 4)) {
            var count = 0;
            for (var current = pageTotal - 9; current <= pageTotal; current++) {
                newPages[count] = current;
                count = count + 1;
            }
            this.pages = newPages;
        }
        else {
            var count = 0;
            for (var current = this.pageNumber - 5; (current < this.pageNumber + 4) && (current < pageTotal); current++) {
                newPages[count] = current;
                count = count + 1;
            }
            this.pages = newPages;
        }
        if (this.pageNumber === pageTotal) {
            this.paginationContext = (this.limit * (this.pageNumber - 1) + 1) + ' - ' + (this.vessels.total) + ' of ' + this.vessels.total;
        }
        else {
            this.paginationContext = (this.limit * (this.pageNumber - 1) + 1) +
                ' - ' + (this.limit * this.pageNumber) +
                ' of ' + this.vessels.total;
        }
    };
    CarriersComponent.prototype.toPage = function (page) {
        if (page == this.pageNumber) {
            // dont call update
            return;
        }
        this.service.loaderOff = false;
        this.offset = (page - 1) * this.limit;
        this.update();
    };
    CarriersComponent.prototype.update = function () {
        this.router.navigate(['/carriers', this.carrierId, { limit: this.limit, offset: this.offset }]);
    };
    CarriersComponent.prototype.getVessels = function (retry) {
        var _this = this;
        if (retry === void 0) { retry = true; }
        this.service.loaderOff = false;
        var params = {
            limit: this.limit,
            offset: this.offset,
            carrier_id: this.carrierId
        };
        this.service.getVessels(params).then(this.formatVessels.bind(this)).catch(function (ex) {
            if (ex === 403 && retry) {
                _this.getVessels(false);
            }
        });
    };
    CarriersComponent.prototype.formatVessels = function (results) {
        if (results !== null) {
            this.vessels = results;
        }
        this.setupPagination();
    };
    CarriersComponent.prototype.getCarrier = function (retry) {
        var _this = this;
        if (retry === void 0) { retry = true; }
        this.service.getCarrier(this.carrierId).then(this.formatCarrier.bind(this)).catch(function (ex) {
            if (ex === 403 && retry) {
                _this.getCarrier(false);
            }
        });
    };
    CarriersComponent.prototype.formatCarrier = function (carrier) {
        if (carrier !== null) {
            this.carrier = carrier;
            var noticeType = carrier.notice.split(' ')[0];
            if (noticeType == 'Acquired' || noticeType == 'Merged') {
                this.carrierNotice.setAttribute('style', 'color: yellow;');
                this.noticeLabel.setAttribute('style', '');
                this.noticeData.setAttribute('style', '');
            }
            else if (carrier.notice.split(' ')[0] == 'Closed') {
                this.carrierNotice.setAttribute('style', 'color: red;');
                this.noticeLabel.setAttribute('style', '');
                this.noticeData.setAttribute('style', '');
            }
        }
    };
    CarriersComponent.prototype.getContacts = function (retry) {
        var _this = this;
        if (retry === void 0) { retry = true; }
        this.service.localContactsLoader = true;
        var params = {
            limit: 50,
            offset: 0,
            carrier_id: this.carrierId
        };
        if (this.service.app.country !== null) {
            params['country_id'] = this.service.app.country.id;
        }
        this.service.getLocalContacts(this.carrierId, params).then(this.formatLocalContacts.bind(this)).catch(function (ex) {
            if (ex === 403 && retry) {
                _this.getContacts(false);
            }
        });
    };
    CarriersComponent.prototype.formatLocalContacts = function (localContacts) {
        try {
            this.setContacts(localContacts);
        }
        catch (ex) {
            this.contacts = new contacts_1.Contacts(null);
            var country = { name: 'Select Country', id: '' };
            this.countries = [{ count: 0, country: country }];
            this.service.localContactsLoader = false;
        }
    };
    CarriersComponent.prototype.setContacts = function (localContacts) {
        if (localContacts !== null && this.service.app.country.id !== '') {
            this.contacts = localContacts;
        }
        // Keep the default 'Select Country' in there
        var dataHasFavoritedCountry = false;
        for (var current = 0; current < this.contacts.countries.length; current++) {
            if (this.service.app.country.id === this.contacts.countries[current].country.id) {
                this.countries = this.contacts.countries;
                this.country = this.countries[current].country;
                dataHasFavoritedCountry = true;
            }
        }
        if (!dataHasFavoritedCountry) {
            this.countries = this.countries.concat(localContacts.countries);
        }
        this.service.localContactsLoader = false;
        this.service.resizeSidebar();
    };
    CarriersComponent.prototype.updateCountry = function () {
        if (this.country.id !== this.service.app.country.id && this.country.id !== '') {
            this.service.app.setCountry(this.country);
            this.getContacts();
        }
        this.service.resizeSidebar();
    };
    CarriersComponent.prototype.slideOutIn = function () {
        this.sidebarActive = !this.sidebarActive;
    };
    CarriersComponent.prototype.registerMessage = function () {
        this.service.app.showRegister();
    };
    CarriersComponent.prototype.expand = function (e) {
        e.showFull = !e.showFull;
        this.service.resizeSidebar();
    };
    __decorate([
        core_1.HostListener('window:resize', ['$event.target']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CarriersComponent.prototype, "onResize", null);
    CarriersComponent = __decorate([
        core_1.Component({
            selector: 'my-carriers',
            template: __webpack_require__(584),
            styles: [__webpack_require__(585)],
            providers: [carriers_service_1.CarriersService, favorite_directive_1.FavoriteDirective],
        }),
        __metadata("design:paramtypes", [carriers_service_1.CarriersService, router_1.ActivatedRoute, router_1.Router, core_1.NgZone])
    ], CarriersComponent);
    return CarriersComponent;
}());
exports.CarriersComponent = CarriersComponent;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var office_1 = __webpack_require__(582);
var Contacts = (function () {
    function Contacts(json, accountType) {
        if (accountType === void 0) { accountType = ''; }
        this.setOffices(json, accountType);
        try {
            this.countries = json.data.summary.available_countries;
            this.countries.sort(function (a, b) {
                var one = a.country.name.toUpperCase();
                var two = b.country.name.toUpperCase();
                return (one < two) ? -1 : (one > two) ? 1 : 0;
            });
        }
        catch (ex) {
            this.countries = [];
        }
    }
    Contacts.prototype.setOffices = function (json, accountType) {
        try {
            this.offices = [];
            for (var current = 0; current < json.data.items.length; current++) {
                var office = new office_1.Office(json.data.items[current], accountType);
                this.offices.push(office);
            }
        }
        catch (ex) {
            this.offices = [];
        }
    };
    return Contacts;
}());
exports.Contacts = Contacts;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(12);
var BaseResults = (function () {
    function BaseResults(json, accountType) {
        if (accountType === void 0) { accountType = ''; }
        try {
            var data = json.data;
            var summary = data.summary;
            this.searchId = data.searchId;
            this.total = summary.count;
        }
        catch (ex) {
            this.setDefaults();
        }
    }
    BaseResults.prototype.setDefaults = function () {
        this.searchId = '';
        this.total = 0;
        this.items = [];
    };
    return BaseResults;
}());
exports.BaseResults = BaseResults;
var VesselResults = (function (_super) {
    __extends(VesselResults, _super);
    function VesselResults(json, accountType) {
        if (accountType === void 0) { accountType = ''; }
        var _this = _super.call(this, json) || this;
        try {
            _this.setItems(json.data.items, accountType);
        }
        catch (ex) {
            _this.items = [];
        }
        return _this;
    }
    VesselResults.prototype.setItems = function (items, accountType) {
        this.items = [];
        try {
            for (var current = 0; current < items.length; current++) {
                this.items.push(new _1.Vessel(items[current], accountType));
            }
            this.items.sort(function (a, b) {
                var one = a.name.toUpperCase();
                var two = b.name.toUpperCase();
                return (one < two) ? -1 : (one > two) ? 1 : 0;
            });
        }
        catch (ex) {
        }
    };
    return VesselResults;
}(BaseResults));
exports.VesselResults = VesselResults;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var vessels_service_1 = __webpack_require__(586);
var favorite_directive_1 = __webpack_require__(94);
var _1 = __webpack_require__(2);
var models_1 = __webpack_require__(12);
var VesselsComponent = (function () {
    function VesselsComponent(logger, service, route, router) {
        this.logger = logger;
        this.service = service;
        this.route = route;
        this.router = router;
        this.voyages = new models_1.Voyages(null);
        this.vessel = new models_1.Vessel(null);
        this.limit = 75;
        this.pages = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        this.pageNumber = 1;
        this.paginationContext = '';
        this.sidebarActive = false;
        // Do stuff
    }
    VesselsComponent.prototype.onResize = function () {
        this.service.resizeSidebar();
    };
    VesselsComponent.prototype.ngOnInit = function () {
        this.logger.log('vessels.component', 'ngOnInit', this.route.snapshot.params);
        this.sub = this.route.params.subscribe(this.setupPage.bind(this));
    };
    VesselsComponent.prototype.ngOnDestroy = function () {
        this.sub.unsubscribe();
    };
    VesselsComponent.prototype.ngAfterViewInit = function () {
        this.service.resizeSidebar();
        // ADDED BY RM
        this.thumbnailDiv = document.getElementById('vessel-thumbnail');
        this.thumbnailLargeDiv = document.getElementById('vessel-large-image');
    };
    VesselsComponent.prototype.setupPage = function (params) {
        this.vesselId = +params['id'];
        this.limit = +params['limit'] || 75;
        this.offset = +params['offset'] || 0;
        this.getVoyages();
        this.getVessel();
        if (params['scroll'] != null && params['scroll'] === 'true') {
            window.scrollTo(0, 0);
        }
    };
    VesselsComponent.prototype.setupPagination = function () {
        this.pageNumber = Math.floor(this.offset / this.limit) + 1;
        var pageTotal = Math.ceil(this.voyages.total / this.limit);
        var newPages = [];
        if (this.pages === null) {
            this.pages = [];
        }
        else if (pageTotal <= 9) {
            var count = 0;
            for (var current = 1; current <= pageTotal; current++) {
                newPages[count] = current;
                count = count + 1;
            }
            this.pages = newPages;
        }
        else if (this.pageNumber <= 5) {
            this.pages = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        }
        else if ((this.pageNumber > 5) && (this.pageNumber > pageTotal - 4)) {
            var count = 0;
            for (var current = pageTotal - 9; current <= pageTotal; current++) {
                newPages[count] = current;
                count = count + 1;
            }
            this.pages = newPages;
        }
        else {
            var count = 0;
            for (var current = this.pageNumber - 5; (current < this.pageNumber + 4) && (current < pageTotal); current++) {
                newPages[count] = current;
                count = count + 1;
            }
            this.pages = newPages;
        }
        if (this.pageNumber === pageTotal) {
            this.paginationContext = (this.limit * (this.pageNumber - 1) + 1)
                + ' - ' + (this.voyages.total) + ' of ' + this.voyages.total;
        }
        else {
            this.paginationContext = (this.limit * (this.pageNumber - 1) + 1)
                + ' - ' + (this.limit * this.pageNumber) + ' of ' + this.voyages.total;
        }
    };
    VesselsComponent.prototype.toPage = function (page) {
        if (page == this.pageNumber) {
            // dont call update
            return;
        }
        this.service.loaderOff = false;
        this.offset = (page - 1) * this.limit;
        this.update();
    };
    VesselsComponent.prototype.update = function () {
        this.router.navigate(['/vessels', this.vesselId, { limit: this.limit, offset: this.offset }]);
    };
    VesselsComponent.prototype.getVoyages = function (retry) {
        var _this = this;
        if (retry === void 0) { retry = true; }
        this.service.loaderOff = false;
        var params = {
            limit: this.limit,
            offset: this.offset
        };
        this.service.getVoyages(this.vesselId, params).then(function (voyages) {
            _this.formatVoyages(voyages);
        }).catch(function (ex) {
            if (ex === 403 && retry) {
                _this.getVoyages(false);
            }
        });
    };
    VesselsComponent.prototype.formatVoyages = function (voyages) {
        this.logger.log('vessels.component', 'formatVoyages', voyages);
        if (voyages != null) {
            voyages.accountTypeStr = this.service.app.accountType;
            this.voyages = voyages;
        }
        this.voyages.items.sort(function (v1, v2) {
            if (v1.schedules[0].etd > v2.schedules[0].etd) {
                return 1;
            }
            else if (v1.schedules[0].etd < v2.schedules[0].etd) {
                return -1;
            }
            else {
                return 0;
            }
        });
        this.setupPagination();
    };
    VesselsComponent.prototype.getVessel = function (retry) {
        var _this = this;
        if (retry === void 0) { retry = true; }
        this.service.getVessel(this.vesselId).then(function (vessel) {
            _this.logger.log('vessels.component', 'vessel subscribe', vessel);
            if (vessel != null) {
                _this.vessel = vessel;
                if (vessel.thumbnailUrl !== "" && _this.isValidHttpUrl(vessel.thumbnailUrl)) {
                    var modalElement = document.getElementById("thumbnailModal");
                    var closeButton = document.getElementsByClassName("close")[0];
                    closeButton.onclick = function () {
                        modalElement.style.display = "none";
                    };
                    // When the user clicks anywhere outside of the modal, close it
                    window.onclick = function (event) {
                        if (event.target == modalElement) {
                            modalElement.style.display = "none";
                        }
                    };
                    _this.thumbnailDiv.src = vessel.thumbnailUrl;
                    _this.thumbnailLargeDiv.src = vessel.thumbnailUrl.replace('Small', 'Large');
                    _this.thumbnailLargeDiv.onclick = function () {
                        //window.location.href = vessel.thumbnailUrl.replace('Small', 'Large');
                        window.open('https://www.fleetmon.com/', '_blank');
                    };
                    _this.thumbnailDiv.onclick = function () {
                        //window.location.href = vessel.thumbnailUrl.replace('Small', 'Large');
                        modalElement.style.display = "block";
                    };
                }
                else {
                    _this.thumbnailDiv.setAttribute('style', 'display: none;');
                }
            }
        }).catch(function (ex) {
            if (ex === 403 && retry) {
                _this.getVessel(false);
            }
        });
    };
    VesselsComponent.prototype.isValidHttpUrl = function (string) {
        var url;
        try {
            url = new URL(string);
        }
        catch (_) {
            return false;
        }
        return url.protocol === "http:" || url.protocol === "https:";
    };
    VesselsComponent.prototype.slideOutIn = function () {
        this.sidebarActive = !this.sidebarActive;
    };
    VesselsComponent.prototype.registerMessage = function () {
        this.service.app.showRegister();
    };
    VesselsComponent.prototype.expand = function (item) {
        item.viewDetails = !item.viewDetails;
        this.service.resizeSidebar();
    };
    __decorate([
        core_1.HostListener('window:resize', ['$event.target']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VesselsComponent.prototype, "onResize", null);
    VesselsComponent = __decorate([
        core_1.Component({
            selector: 'vessels',
            template: __webpack_require__(587),
            styles: [__webpack_require__(588)],
            providers: [vessels_service_1.VesselsService, favorite_directive_1.FavoriteDirective]
        }),
        __metadata("design:paramtypes", [_1.LogService, vessels_service_1.VesselsService, router_1.ActivatedRoute, router_1.Router])
    ], VesselsComponent);
    return VesselsComponent;
}());
exports.VesselsComponent = VesselsComponent;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var web_search_service_1 = __webpack_require__(589);
var shared_1 = __webpack_require__(2);
var WebSearchComponent = (function () {
    function WebSearchComponent(service, route, router, app, seo) {
        this.service = service;
        this.route = route;
        this.router = router;
        this.app = app;
        this.seo = seo;
        this.title = 'Ocean Container Shipping Schedule Plans - Linescape';
        this.description = 'Linescape offers various subscription plans to access liner shipping schedules, routes, ports, vessels or carrier data.';
        this.enterprisePlanLevel = '6';
    }
    WebSearchComponent.prototype.ngOnInit = function () {
        this.seo.set(this.title, this.description);
        window.scrollTo(0, 0);
        this.getPlans();
    };
    WebSearchComponent.prototype.ngAfterViewInit = function () {
        window.scrollTo(0, 0);
    };
    WebSearchComponent.prototype.getPlans = function () {
        this.plans = this.service.getPlans();
    };
    WebSearchComponent.prototype.monthly = function () {
        this.service.yearlyBilling = false;
    };
    WebSearchComponent.prototype.yearly = function () {
        this.service.yearlyBilling = true;
    };
    WebSearchComponent.prototype.openRegister = function (planType) {
        if (!this.service.app.isLoggedIn) {
            if (planType === 'Premium') {
                this.app.signUpPlan = 'Premium';
            }
            else if (planType === 'Professional') {
                this.app.signUpPlan = 'Professional';
            }
            else if (planType === 'Enterprise') {
                if (this.enterprisePlanLevel == '6') {
                    this.app.signUpPlan = 'Enterprise6';
                }
                else if (this.enterprisePlanLevel == '12') {
                    this.app.signUpPlan = 'Enterprise12';
                }
                else if (this.enterprisePlanLevel == '18') {
                    this.app.signUpPlan = 'Enterprise18';
                }
                else {
                    this.app.signUpPlan = 'Enterprise6';
                }
            }
            else {
                this.app.signUpPlan = 'Basic';
            }
            if (this.service.yearlyBilling) {
                this.app.signUpPlanBilling = 'yearly';
            }
            else {
                this.app.signUpPlanBilling = 'monthly';
            }
            this.router.navigate(['/register']);
        }
    };
    WebSearchComponent = __decorate([
        core_1.Component({
            selector: 'web-search',
            template: __webpack_require__(590),
            styles: [__webpack_require__(591)],
            providers: [web_search_service_1.WebSearchService],
        }),
        __metadata("design:paramtypes", [web_search_service_1.WebSearchService, router_1.ActivatedRoute, router_1.Router, shared_1.AppContext, shared_1.SeoService])
    ], WebSearchComponent);
    return WebSearchComponent;
}());
exports.WebSearchComponent = WebSearchComponent;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var plans_service_1 = __webpack_require__(592);
var shared_1 = __webpack_require__(2);
var PlansComponent = (function () {
    function PlansComponent(service, route, router, app, seo) {
        this.service = service;
        this.route = route;
        this.router = router;
        this.app = app;
        this.seo = seo;
        this.title = 'Ocean Container Shipping Schedule Plans - Linescape';
        this.description = 'Linescape offers various subscription plans to access liner shipping schedules, routes, ports, vessels or carrier data.';
    }
    PlansComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.seo.set(this.title, this.description);
        window.scrollTo(0, 0);
        this.getPlans();
        // no longer necessary
        // keep in case legacy links are used
        this.sub = this.route.params.subscribe(function (params) {
            if (params['register'] !== null && params['register'] === 'true') {
                _this.openRegister('Basic');
            }
            if (params['code'] !== null && params['code'] !== undefined) {
                _this.service.code = params['code'];
                _this.openConfirm();
            }
        });
    };
    PlansComponent.prototype.ngAfterViewInit = function () {
        window.scrollTo(0, 0);
    };
    PlansComponent.prototype.getPlans = function () {
        this.plans = this.service.getPlans();
    };
    PlansComponent.prototype.monthly = function () {
        this.service.yearlyBilling = false;
    };
    PlansComponent.prototype.yearly = function () {
        this.service.yearlyBilling = true;
    };
    PlansComponent.prototype.openRegister = function (planType) {
        if (!this.service.app.isLoggedIn) {
            if (planType === 'Premium') {
                this.app.signUpPlan = 'Premium';
            }
            else if (planType === 'Professional') {
                this.app.signUpPlan = 'Professional';
            }
            else if (planType === 'Enterprise') {
                this.app.signUpPlan = 'Enterprise-6';
            }
            else {
                this.app.signUpPlan = 'Basic';
            }
            if (this.service.yearlyBilling) {
                this.app.signUpPlanBilling = 'yearly';
            }
            else {
                this.app.signUpPlanBilling = 'monthly';
            }
            this.router.navigate(['/register']);
        }
    };
    PlansComponent.prototype.openConfirm = function () {
        if (!this.service.app.isLoggedIn) {
            this.router.navigate(['/confirm', { code: this.service.code }]);
        }
    };
    PlansComponent = __decorate([
        core_1.Component({
            selector: 'plans',
            template: __webpack_require__(593),
            styles: [__webpack_require__(594)],
            providers: [plans_service_1.PlansService],
        }),
        __metadata("design:paramtypes", [plans_service_1.PlansService, router_1.ActivatedRoute, router_1.Router, shared_1.AppContext, shared_1.SeoService])
    ], PlansComponent);
    return PlansComponent;
}());
exports.PlansComponent = PlansComponent;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(595));
__export(__webpack_require__(599));
__export(__webpack_require__(603));
__export(__webpack_require__(607));
__export(__webpack_require__(611));
__export(__webpack_require__(615));
__export(__webpack_require__(619));
__export(__webpack_require__(623));
__export(__webpack_require__(627));
__export(__webpack_require__(631));
__export(__webpack_require__(635));
__export(__webpack_require__(639));
__export(__webpack_require__(643));
__export(__webpack_require__(647));
__export(__webpack_require__(653));
__export(__webpack_require__(657));
__export(__webpack_require__(661));
__export(__webpack_require__(665));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(43);
var BusinessValidatorDirective = (function () {
    function BusinessValidatorDirective() {
    }
    BusinessValidatorDirective_1 = BusinessValidatorDirective;
    BusinessValidatorDirective.prototype.validate = function (control) {
        return businessValidator(control);
    };
    BusinessValidatorDirective = BusinessValidatorDirective_1 = __decorate([
        core_1.Directive({
            selector: '[businessValidator]',
            providers: [{ provide: forms_1.NG_VALIDATORS, useExisting: BusinessValidatorDirective_1, multi: true }]
        })
    ], BusinessValidatorDirective);
    return BusinessValidatorDirective;
    var BusinessValidatorDirective_1;
}());
exports.BusinessValidatorDirective = BusinessValidatorDirective;
function businessValidator(control) {
    var choice = control.get('businessChoice').value;
    var other = control.get('other').value;
    if (choice == 'Select a Business') {
        return { 'required': true };
    }
    else if (choice == 'Other' && other == '') {
        return { 'otherRequired': true };
    }
    else {
        return null;
    }
}
exports.businessValidator = businessValidator;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(17);
var _1 = __webpack_require__(246);
var update_card_component_1 = __webpack_require__(725);
var update_plan_component_1 = __webpack_require__(729);
var profile_component_1 = __webpack_require__(247);
var email_delivery_1 = __webpack_require__(733);
var shared_1 = __webpack_require__(2);
var shared_module_1 = __webpack_require__(61);
var account_routing_module_1 = __webpack_require__(742);
var AccountModule = (function () {
    function AccountModule() {
    }
    AccountModule = __decorate([
        core_1.NgModule({
            imports: [common_1.CommonModule, shared_module_1.SharedModule, account_routing_module_1.AccountRoutingModule],
            declarations: [_1.AccountComponent, _1.MyFavoritesComponent, _1.AccountInformationComponent, _1.InvoicesComponent, update_card_component_1.UpdateCardComponent, update_plan_component_1.UpdatePlanComponent, profile_component_1.ProfileComponent, email_delivery_1.EmailDeliveryComponent, email_delivery_1.EmailScheduleComponent, email_delivery_1.EmailSettingsComponent],
            schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA],
            providers: [shared_1.AppContext, shared_1.LogService, shared_1.AuthService, shared_1.ApiService, shared_1.UserService, shared_1.FavoriteService, shared_1.BillingService]
        })
    ], AccountModule);
    return AccountModule;
}());
exports.AccountModule = AccountModule;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(705));
__export(__webpack_require__(708));
__export(__webpack_require__(712));
__export(__webpack_require__(716));
__export(__webpack_require__(247));
__export(__webpack_require__(248));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ProfileComponent = (function () {
    function ProfileComponent() {
    }
    ProfileComponent.prototype.doNothing = function () {
    };
    ProfileComponent = __decorate([
        core_1.Component({
            selector: 'profile',
            template: __webpack_require__(720),
            styles: [__webpack_require__(721)],
        }),
        __metadata("design:paramtypes", [])
    ], ProfileComponent);
    return ProfileComponent;
}());
exports.ProfileComponent = ProfileComponent;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var email_delivery_service_1 = __webpack_require__(722);
var EmailDeliveryComponent = (function () {
    function EmailDeliveryComponent(service, renderer, route) {
        this.service = service;
        this.renderer = renderer;
        this.route = route;
        // Do stuff
    }
    EmailDeliveryComponent.prototype.delete = function ($event, schedule) {
        this.service.delete($event.target, schedule.id);
    };
    EmailDeliveryComponent.prototype.setClass = function (target, state) {
        this.renderer.setElementClass(target, 'saving', false);
        this.renderer.setElementClass(target, 'saved', false);
        this.renderer.setElementClass(target, 'error', false);
        this.renderer.setElementClass(target, state, true);
    };
    EmailDeliveryComponent.prototype.setSchedule = function (old, $event) {
        this.service.update(old, $event);
    };
    EmailDeliveryComponent = __decorate([
        core_1.Component({
            selector: 'email-delivery',
            template: __webpack_require__(723),
            styles: [__webpack_require__(724)],
            providers: [email_delivery_service_1.EmailDeliveryService]
        }),
        __metadata("design:paramtypes", [email_delivery_service_1.EmailDeliveryService, core_1.Renderer, router_1.ActivatedRoute])
    ], EmailDeliveryComponent);
    return EmailDeliveryComponent;
}());
exports.EmailDeliveryComponent = EmailDeliveryComponent;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(17);
var _1 = __webpack_require__(250);
var shared_1 = __webpack_require__(2);
var shared_module_1 = __webpack_require__(61);
var blog_routing_module_1 = __webpack_require__(776);
var BlogModule = (function () {
    function BlogModule() {
    }
    BlogModule = __decorate([
        core_1.NgModule({
            imports: [common_1.CommonModule, blog_routing_module_1.BlogRoutingModule, shared_module_1.SharedModule],
            declarations: [_1.BlogRollComponent, _1.FiveReasonsToComponent, _1.SuperSizedShippingComponent, _1.FiveTrendsShapingComponent, _1.GlassHalfFullComponent, _1.WalmartAmazonTakeComponent, _1.AnalyticsAnswerYourBusinessQuestions, _1.SampleNewsComponent],
            exports: [_1.BlogRollComponent, _1.FiveReasonsToComponent, _1.FiveTrendsShapingComponent, _1.SuperSizedShippingComponent, _1.GlassHalfFullComponent, _1.WalmartAmazonTakeComponent, _1.AnalyticsAnswerYourBusinessQuestions, _1.SampleNewsComponent],
            providers: [shared_1.AppContext, shared_1.SeoService]
        })
    ], BlogModule);
    return BlogModule;
}());
exports.BlogModule = BlogModule;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(743));
__export(__webpack_require__(748));
__export(__webpack_require__(752));
__export(__webpack_require__(756));
__export(__webpack_require__(760));
__export(__webpack_require__(764));
__export(__webpack_require__(768));
__export(__webpack_require__(772));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(17);
var _1 = __webpack_require__(252);
var shared_1 = __webpack_require__(2);
var shared_module_1 = __webpack_require__(61);
var press_routing_module_1 = __webpack_require__(898);
var PressModule = (function () {
    function PressModule() {
    }
    PressModule = __decorate([
        core_1.NgModule({
            imports: [common_1.CommonModule, press_routing_module_1.PressRoutingModule, shared_module_1.SharedModule],
            declarations: [
                _1.Ef3IntegratesLinescapeDataComponent,
                _1.DbhIntegratesLinescapeComponent,
                _1.Linescape4AniversaryTranshipmentVoyageComponent,
                _1.XenetaAddsLinescapeComponent,
                _1.HavenOceanFreightMarketplaceLinescapeComponent,
                _1.TechStackAnniversaryComponent,
                _1.LinescapeUpgradesSearchEngineComponent,
                _1.LinescapeExhibitIntermodalEuropeComponent,
                _1.LinescapeMoreDataAnniversaryComponent,
                _1.DakosyToDistributeLinescapeComponent,
                _1.LinescapeCIAwardFinalistComponent,
                _1.DachserSelectsLinescapeSchedulesComponent,
                _1.LinescapeVesselInformationAnniversaryComponent,
                _1.LinescapeExhibitIntermodalEuropeAmsterdamComponent,
                _1.TransworldExpeditionShipTruckComponent,
                _1.LinescapeCarrierProfilesAnniversaryComponent,
                _1.LinescapeLaunchesOceanContainerSearchComponent,
                _1.LinescapeLaunchesSailingScheduleComponent,
                _1.CogoportAddsLinescapeSchedulesComponent,
                _1.LinescapeCelebrates10thAnniversaryComponent,
                _1.LinescapeWebsiteNewLookComponent,
                _1.SuzhouYunLogisticsTechnologySelectsLinescape,
                _1.LinescapeJournalOfCommerceComponent,
                _1.LinescapeCeoToSpeakAtGlobalLinerShippingConference,
                _1.LinescapeEnhancesSailingScheduleswithActualTrackingData,
                _1.LogitOneChoosesLinescapeAsSaillingScheduleProvider,
                _1.KotachiSelectsLinescapeSailingSchedulesApi,
                _1.JfHillebrandToIntegrateLinescapeIntoTms,
                _1.MercurygateAddsLinescapeToTme,
                _1.PressRollComponent
            ],
            exports: [
                _1.Ef3IntegratesLinescapeDataComponent,
                _1.DbhIntegratesLinescapeComponent,
                _1.Linescape4AniversaryTranshipmentVoyageComponent,
                _1.XenetaAddsLinescapeComponent,
                _1.HavenOceanFreightMarketplaceLinescapeComponent,
                _1.TechStackAnniversaryComponent,
                _1.LinescapeUpgradesSearchEngineComponent,
                _1.LinescapeExhibitIntermodalEuropeComponent,
                _1.LinescapeMoreDataAnniversaryComponent,
                _1.DakosyToDistributeLinescapeComponent,
                _1.LinescapeCIAwardFinalistComponent,
                _1.DachserSelectsLinescapeSchedulesComponent,
                _1.LinescapeVesselInformationAnniversaryComponent,
                _1.LinescapeExhibitIntermodalEuropeAmsterdamComponent,
                _1.TransworldExpeditionShipTruckComponent,
                _1.LinescapeCarrierProfilesAnniversaryComponent,
                _1.LinescapeLaunchesOceanContainerSearchComponent,
                _1.LinescapeLaunchesSailingScheduleComponent,
                _1.CogoportAddsLinescapeSchedulesComponent,
                _1.LinescapeCelebrates10thAnniversaryComponent,
                _1.LinescapeWebsiteNewLookComponent,
                _1.SuzhouYunLogisticsTechnologySelectsLinescape,
                _1.LinescapeJournalOfCommerceComponent,
                _1.LinescapeCeoToSpeakAtGlobalLinerShippingConference,
                _1.LinescapeEnhancesSailingScheduleswithActualTrackingData,
                _1.LogitOneChoosesLinescapeAsSaillingScheduleProvider,
                _1.KotachiSelectsLinescapeSailingSchedulesApi,
                _1.JfHillebrandToIntegrateLinescapeIntoTms,
                _1.MercurygateAddsLinescapeToTme,
                _1.PressRollComponent
            ],
            providers: [shared_1.AppContext, shared_1.SeoService]
        })
    ], PressModule);
    return PressModule;
}());
exports.PressModule = PressModule;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(777));
__export(__webpack_require__(781));
__export(__webpack_require__(786));
__export(__webpack_require__(790));
__export(__webpack_require__(794));
__export(__webpack_require__(798));
__export(__webpack_require__(802));
__export(__webpack_require__(806));
__export(__webpack_require__(810));
__export(__webpack_require__(814));
__export(__webpack_require__(818));
__export(__webpack_require__(822));
__export(__webpack_require__(826));
__export(__webpack_require__(830));
__export(__webpack_require__(834));
__export(__webpack_require__(838));
__export(__webpack_require__(842));
__export(__webpack_require__(846));
__export(__webpack_require__(850));
__export(__webpack_require__(854));
__export(__webpack_require__(858));
__export(__webpack_require__(862));
__export(__webpack_require__(866));
__export(__webpack_require__(870));
__export(__webpack_require__(874));
__export(__webpack_require__(878));
__export(__webpack_require__(882));
__export(__webpack_require__(886));
__export(__webpack_require__(890));
__export(__webpack_require__(894));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var register_service_1 = __webpack_require__(899);
var RegisterComponent = (function () {
    function RegisterComponent(authService, userService, service, app) {
        this.authService = authService;
        this.userService = userService;
        this.service = service;
        this.app = app;
        this.model = new shared_1.Register();
        this.premiumPlan = 'Premium';
        this.professionalPlan = 'Professional';
        this.basicPlan = 'Basic';
        this.api500Plan = 'API500';
        this.api1000Plan = 'API1000';
        this.api1500Plan = 'API1500';
        this.api4000Plan = 'API4000';
        this.api15000Plan = 'API15000';
        this.api50000Plan = 'API50000';
        this.api150000Plan = 'API150000';
        this.enterprise6Plan = 'Enterprise6';
        this.enterprise12Plan = 'Enterprise12';
        this.enterprise18Plan = 'Enterprise18';
        this.yearlyPlan = 'Yearly';
        this.monthlyPlan = 'Monthly';
        this.displayVerificationInput = false;
        this.thanksAmount = -1;
        this.thanksDate = '';
        this.frontError = false;
        this.submitted = false;
    }
    RegisterComponent.prototype.ngOnInit = function () {
        if (this.app.signUpPlan === 'Professional') {
            this.service.accountType = 'Professional';
        }
        else if (this.app.signUpPlan === 'Premium') {
            this.service.accountType = 'Premium';
        }
        else if (this.app.signUpPlan === 'Enterprise6') {
            this.service.accountType = 'Enterprise6';
        }
        else if (this.app.signUpPlan === 'Enterprise12') {
            this.service.accountType = 'Enterprise12';
        }
        else if (this.app.signUpPlan === 'Enterprise18') {
            this.service.accountType = 'Enterprise18';
        }
        if (this.app.signUpPlanBilling === 'yearly') {
            this.service.billingPeriod = 'Yearly';
        }
        else {
            this.service.billingPeriod = 'Monthly';
        }
        this.service.updateCost();
    };
    RegisterComponent.prototype.ngAfterViewInit = function () {
        this.service.updateCost();
    };
    RegisterComponent.prototype.validateFirstName = function () {
        var firstName = this.model.firstName.trim();
        if (firstName.length > 0) {
            this.firstNameError = '';
        }
        else {
            this.frontError = true;
            this.firstNameError = 'First Name Required';
        }
    };
    RegisterComponent.prototype.validateLastName = function () {
        var lastName = this.model.lastName.trim();
        if (lastName.length > 0) {
            this.lastNameError = '';
        }
        else {
            this.frontError = true;
            this.lastNameError = 'Last Name Required';
        }
    };
    RegisterComponent.prototype.validateEmail = function () {
        //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*|\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        var EMAIL_REGEXP = this.app.EMAIL_REGEXP;
        if (EMAIL_REGEXP.test(this.model.email)) {
            this.emailError = '';
        }
        else {
            this.frontError = true;
            this.emailError = 'Invalid Email';
        }
    };
    RegisterComponent.prototype.validateConfirmEmail = function () {
        if (this.model.email !== this.model.confirmEmail) {
            this.frontError = true;
            this.confirmEmailError = 'Email must match';
        }
        else {
            this.confirmEmailError = '';
        }
    };
    RegisterComponent.prototype.validatePassword = function () {
        var PASSWORD_REGEXP = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).*$/;
        if (PASSWORD_REGEXP.test(this.model.password) && this.model.password.length >= 8) {
            this.passwordError = '';
        }
        else if (!PASSWORD_REGEXP.test(this.model.password) && this.model.password.length >= 8) {
            this.frontError = true;
            this.passwordError = 'Invalid Password';
        }
        else if (PASSWORD_REGEXP.test(this.model.password) && this.model.password.length < 8) {
            this.frontError = true;
            this.passwordError = 'Invalid Password';
        }
        else {
            this.frontError = true;
            this.passwordError = 'Invalid Password';
        }
    };
    RegisterComponent.prototype.validateConfirmPassword = function () {
        if (this.model.password !== this.model.confirmPassword) {
            this.frontError = true;
            this.confirmPasswordError = 'Passwords must match';
        }
        else {
            this.confirmPasswordError = '';
        }
    };
    RegisterComponent.prototype.validateCC = function () {
        if (this.service.accountType !== 'Basic') {
            if (this.service.card.length !== 13 && this.service.card.length !== 14 && this.service.card.length !== 15 && this.service.card.length !== 16 && this.service.card.length !== 17 && this.service.card.length !== 18 && this.service.card.length !== 19) {
                this.frontError = true;
                this.service.errors.card = 'Card Length Invalid';
            }
            else {
                this.service.errors.card = '';
            }
        }
    };
    RegisterComponent.prototype.validateExp = function () {
        var exp = this.service.expiration.split('/');
        this.expMonth = +exp[0];
        this.expYear = +exp[1];
        if (this.service.accountType !== 'Basic') {
            if (this.expMonth <= 0 || this.expMonth >= 13) {
                this.service.errors.expiration = 'Date Invalid';
                this.frontError = true;
            }
            else if (this.expYear <= 0 || this.expYear >= 100) {
                this.frontError = true;
                this.service.errors.expiration = 'Date Invalid';
            }
            else {
                this.service.errors.expiration = '';
            }
        }
    };
    RegisterComponent.prototype.validateCVC = function () {
        if (this.service.accountType !== 'Basic') {
            if (this.service.cvc.length !== 3 && this.service.cvc.length !== 4) {
                this.service.errors.cvc = 'CVC Invalid';
                this.frontError = true;
            }
            else {
                this.service.errors.cvc = '';
            }
        }
    };
    RegisterComponent.prototype.validateToken = function () {
        if (this.service.stripeResponse !== null && this.service.stripeStatus !== 200) {
            this.frontError = true;
            this.service.errors.register = 'Credit card verification failed. Please update your card details.';
        }
    };
    RegisterComponent.prototype.clearErrors = function () {
        this.frontError = false;
        this.firstNameError = '';
        this.lastNameError = '';
        this.emailError = '';
        this.passwordError = '';
        this.confirmPasswordError = '';
        this.service.errors.card = '';
        this.service.errors.expiration = '';
        this.service.errors.cvc = '';
    };
    RegisterComponent.prototype.validatePersonalInformation = function () {
        this.validateFirstName();
        this.validateLastName();
        this.validateEmail();
        this.validateConfirmEmail();
        this.validatePassword();
        this.validateConfirmPassword();
    };
    RegisterComponent.prototype.register = function () {
        this.clearErrors();
        this.validatePersonalInformation();
        if (!this.service.freeAccount) {
            this.validateCC();
            this.validateExp();
            this.validateCVC();
            this.validateToken();
            this.service.validateHolderName();
            this.service.validatePostalCode();
        }
        if (!this.frontError) {
            if (this.service.accountType === 'Basic' || this.service.freeAccount) {
                this.service.registerWithCognito(this.model);
            }
            else {
                this.service.registerProcess(this.model);
            }
        }
    };
    RegisterComponent = __decorate([
        core_1.Component({
            selector: 'register',
            template: __webpack_require__(900),
            styles: [__webpack_require__(901), __webpack_require__(16)],
            providers: [register_service_1.RegisterService]
        }),
        __metadata("design:paramtypes", [shared_1.AuthService, shared_1.UserService, register_service_1.RegisterService, shared_1.AppContext])
    ], RegisterComponent);
    return RegisterComponent;
}());
exports.RegisterComponent = RegisterComponent;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var PageNotFoundComponent = (function () {
    function PageNotFoundComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = '404 - Page Not Found';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';
    }
    PageNotFoundComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    PageNotFoundComponent = __decorate([
        core_1.Component({
            selector: 'app-page-not-found',
            template: __webpack_require__(950),
            styles: [__webpack_require__(951)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], PageNotFoundComponent);
    return PageNotFoundComponent;
}());
exports.PageNotFoundComponent = PageNotFoundComponent;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var confirm_service_1 = __webpack_require__(967);
var models_1 = __webpack_require__(12);
var ConfirmComponent = (function () {
    function ConfirmComponent(service, route, router) {
        this.service = service;
        this.route = route;
        this.router = router;
        this.code = '';
    }
    ConfirmComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sub = this.route.params.subscribe(function (params) {
            if (params['code'] !== null && params['code'] !== undefined) {
                _this.code = params['code'];
            }
            if (_this.service.type !== 'no-email') {
                _this.service.checkIfUser(_this.service.app.email);
            }
        });
    };
    ConfirmComponent.prototype.confirmEmail = function () {
        this.service.frontError = false;
        this.service.validateEmail();
        if (!this.service.frontError) {
            var model = new models_1.Confirm(this.service.email, this.code);
            this.service.confirm(model);
        }
    };
    ConfirmComponent.prototype.reset = function () {
        this.service.frontError = false;
        this.service.validatePassword();
        if (!this.service.frontError) {
            this.service.reset(this.service.email, this.code, this.service.password);
        }
    };
    ConfirmComponent.prototype.login = function () {
        this.close();
        this.service.app.toggleLogin();
    };
    ConfirmComponent.prototype.close = function () {
        this.router.navigate(['/']);
    };
    ConfirmComponent = __decorate([
        core_1.Component({
            selector: 'confirm',
            template: __webpack_require__(968),
            styles: [__webpack_require__(969)],
            providers: [confirm_service_1.ConfirmService]
        }),
        __metadata("design:paramtypes", [confirm_service_1.ConfirmService, router_1.ActivatedRoute, router_1.Router])
    ], ConfirmComponent);
    return ConfirmComponent;
}());
exports.ConfirmComponent = ConfirmComponent;


/***/ }),
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var platform_browser_dynamic_1 = __webpack_require__(107);
var app_module_1 = __webpack_require__(539);
// depending on the env mode, enable prod mode or add debugging modules
if (true) {
    core_1.enableProdMode();
}
function main() {
    return platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule).then(function (MODULE_REF) {
        if (false) {
            module["hot"]["accept"]();
            if (MODULE_REF.instance["hmrOnInit"]) {
                MODULE_REF.instance["hmrOnInit"](module["hot"]["data"]);
            }
            if (MODULE_REF.instance["hmrOnStatus"]) {
                module["hot"]["apply"](function (status) {
                    MODULE_REF.instance["hmrOnStatus"](status);
                });
            }
            if (MODULE_REF.instance["hmrOnCheck"]) {
                module["hot"]["check"](function (err, outdatedModules) {
                    MODULE_REF.instance["hmrOnCheck"](err, outdatedModules);
                });
            }
            if (MODULE_REF.instance["hmrOnDecline"]) {
                module["hot"]["decline"](function (dependencies) {
                    MODULE_REF.instance["hmrOnDecline"](dependencies);
                });
            }
            module["hot"]["dispose"](function (store) {
                MODULE_REF.instance["hmrOnDestroy"] && MODULE_REF.instance["hmrOnDestroy"](store);
                MODULE_REF.destroy();
                MODULE_REF.instance["hmrAfterDestroy"] && MODULE_REF.instance["hmrAfterDestroy"](store);
            });
        }
        return MODULE_REF;
    });
}
exports.main = main;
if (document.readyState === 'complete') {
    main();
}
else {
    document.addEventListener('DOMContentLoaded', main);
}


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(28);
var router_1 = __webpack_require__(3);
var http_1 = __webpack_require__(540);
var core_2 = __webpack_require__(541);
var ng2_sticky_kit_1 = __webpack_require__(546);
var app_component_1 = __webpack_require__(547);
// components
var home_component_1 = __webpack_require__(232);
var api_docs_1 = __webpack_require__(233);
var test_connection_1 = __webpack_require__(234);
var schedules_component_1 = __webpack_require__(235);
var ports_component_1 = __webpack_require__(236);
var carriers_component_1 = __webpack_require__(237);
var vessels_component_1 = __webpack_require__(240);
var web_search_component_1 = __webpack_require__(241);
var plans_component_1 = __webpack_require__(242);
var static_1 = __webpack_require__(243);
var shared_module_1 = __webpack_require__(61);
var account_module_1 = __webpack_require__(245);
var blog_module_1 = __webpack_require__(249);
var press_module_1 = __webpack_require__(251);
var register_component_1 = __webpack_require__(253);
var login_component_1 = __webpack_require__(902);
var _1 = __webpack_require__(906);
var save_route_component_1 = __webpack_require__(926);
var carriers_search_component_1 = __webpack_require__(930);
var ports_search_component_1 = __webpack_require__(934);
var schedules_search_component_1 = __webpack_require__(938);
var vessels_search_component_1 = __webpack_require__(942);
var share_results_component_1 = __webpack_require__(946);
var page_not_found_component_1 = __webpack_require__(254);
// Directives
var contact_carrier_component_1 = __webpack_require__(952);
var contact_form_component_1 = __webpack_require__(956);
var appt_form_component_1 = __webpack_require__(960);
var date_picker_component_1 = __webpack_require__(964);
var confirm_component_1 = __webpack_require__(255);
var ng5_slider_1 = __webpack_require__(970);
// services
var api_service_1 = __webpack_require__(225);
var app_context_1 = __webpack_require__(224);
var auth_service_1 = __webpack_require__(228);
var cache_service_1 = __webpack_require__(229);
var favorite_service_1 = __webpack_require__(230);
var logging_service_1 = __webpack_require__(223);
var user_service_1 = __webpack_require__(227);
var seo_service_1 = __webpack_require__(231);
var app_routing_module_1 = __webpack_require__(971);
var hmr_1 = __webpack_require__(981);
var AppModule = (function () {
    function AppModule(appRef) {
        this.appRef = appRef;
    }
    AppModule.prototype.hmrOnInit = function (store) {
    };
    AppModule.prototype.hmrOnDestroy = function (store) {
        var cmpLocation = this.appRef.components.map(function (cmp) { return cmp.location.nativeElement; });
        // recreate elements
        store.disposeOldHosts = hmr_1.createNewHosts(cmpLocation);
        // remove styles
        hmr_1.removeNgStyles();
    };
    AppModule.prototype.hmrAfterDestroy = function (store) {
        // display new elements
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    };
    AppModule = __decorate([
        core_1.NgModule({
            imports: [
                platform_browser_1.BrowserModule,
                http_1.HttpClientModule,
                router_1.RouterModule,
                app_routing_module_1.AppRoutingModule,
                shared_module_1.SharedModule,
                account_module_1.AccountModule,
                blog_module_1.BlogModule,
                press_module_1.PressModule,
                ng2_sticky_kit_1.StickyModule,
                ng5_slider_1.Ng5SliderModule,
                core_2.AgmCoreModule.forRoot({
                    apiKey: 'AIzaSyBEGhrviWvyFDAjzRfnJvXKg__LroVbjLk' // old key:'AIzaSyDUFqOKzVgnxyCsH_GR0yyjTFcLtSoCThc'
                }),
            ],
            schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA],
            declarations: [
                app_component_1.AppComponent,
                home_component_1.HomeComponent,
                api_docs_1.ApiDocsComponent,
                test_connection_1.TestConnectionComponent,
                schedules_component_1.SchedulesComponent,
                ports_component_1.PortsComponent,
                carriers_component_1.CarriersComponent,
                vessels_component_1.VesselsComponent,
                web_search_component_1.WebSearchComponent,
                plans_component_1.PlansComponent,
                static_1.DataFeedsComponent,
                static_1.AboutComponent,
                static_1.ApiComponent,
                static_1.AnalyticsComponent,
                share_results_component_1.ShareResultsComponent,
                contact_carrier_component_1.ContactCarrierComponent,
                static_1.ContactComponent,
                static_1.PrivacyPolicyComponent,
                static_1.TermsOfUseComponent,
                register_component_1.RegisterComponent,
                login_component_1.LoginComponent,
                _1.MessageComponent,
                _1.RegisterMessageComponent,
                _1.ArrivalMessageComponent,
                _1.UpgradeMessageComponent,
                _1.ProfilePopupComponent,
                save_route_component_1.SaveRouteComponent,
                carriers_search_component_1.CarriersSearchComponent,
                ports_search_component_1.PortsSearchComponent,
                schedules_search_component_1.SchedulesSearchComponent,
                vessels_search_component_1.VesselsSearchComponent,
                date_picker_component_1.DatePicker,
                contact_form_component_1.ContactFormComponent,
                appt_form_component_1.ApptFormComponent,
                confirm_component_1.ConfirmComponent,
                static_1.HelpComponent,
                static_1.SolutionsComponent,
                static_1.ApplicationComponent,
                static_1.WhatWeDoComponent,
                static_1.OnlineSearchComponent,
                static_1.ApiOverviewComponent,
                static_1.CarrierNetworkComponent,
                static_1.DataConsolidationComponent,
                static_1.DataFormatsComponent,
                static_1.AboutLandingComponent,
                static_1.UpcomingEventsComponent,
                page_not_found_component_1.PageNotFoundComponent
            ],
            providers: [
                platform_browser_1.Title,
                api_service_1.ApiService,
                app_context_1.AppContext,
                auth_service_1.AuthService,
                cache_service_1.CacheService,
                favorite_service_1.FavoriteService,
                logging_service_1.LogService,
                user_service_1.UserService,
                seo_service_1.SeoService
            ],
            bootstrap: [app_component_1.AppComponent]
        }),
        __metadata("design:paramtypes", [core_1.ApplicationRef])
    ], AppModule);
    return AppModule;
}());
exports.AppModule = AppModule;


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpBackend", function() { return HttpBackend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpHandler", function() { return HttpHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClient", function() { return HttpClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpHeaders", function() { return HttpHeaders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HTTP_INTERCEPTORS", function() { return HTTP_INTERCEPTORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonpClientBackend", function() { return JsonpClientBackend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonpInterceptor", function() { return JsonpInterceptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClientJsonpModule", function() { return HttpClientJsonpModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClientModule", function() { return HttpClientModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpClientXsrfModule", function() { return HttpClientXsrfModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinterceptingHandler", function() { return interceptingHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpParams", function() { return HttpParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpUrlEncodingCodec", function() { return HttpUrlEncodingCodec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpRequest", function() { return HttpRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpErrorResponse", function() { return HttpErrorResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpEventType", function() { return HttpEventType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpHeaderResponse", function() { return HttpHeaderResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpResponse", function() { return HttpResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpResponseBase", function() { return HttpResponseBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpXhrBackend", function() { return HttpXhrBackend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XhrFactory", function() { return XhrFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpXsrfTokenExtractor", function() { return HttpXsrfTokenExtractor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return NoopInterceptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return JsonpCallbackContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function() { return HttpInterceptingHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function() { return jsonpCallbackContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function() { return BrowserXhr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵh", function() { return HttpXsrfCookieExtractor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi", function() { return HttpXsrfInterceptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf", function() { return XSRF_COOKIE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵg", function() { return XSRF_HEADER_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_concatMap__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_concatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_concatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tslib__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_common__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_Observable__);
/**
 * @license Angular v5.2.11
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */









/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Transforms an `HttpRequest` into a stream of `HttpEvent`s, one of which will likely be a
 * `HttpResponse`.
 *
 * `HttpHandler` is injectable. When injected, the handler instance dispatches requests to the
 * first interceptor in the chain, which dispatches to the second, etc, eventually reaching the
 * `HttpBackend`.
 *
 * In an `HttpInterceptor`, the `HttpHandler` parameter is the next interceptor in the chain.
 *
 * \@stable
 * @abstract
 */
var HttpHandler = /** @class */ (function () {
    function HttpHandler() {
    }
    return HttpHandler;
}());
/**
 * A final `HttpHandler` which will dispatch the request via browser HTTP APIs to a backend.
 *
 * Interceptors sit between the `HttpClient` interface and the `HttpBackend`.
 *
 * When injected, `HttpBackend` dispatches requests directly to the backend, without going
 * through the interceptor chain.
 *
 * \@stable
 * @abstract
 */
var HttpBackend = /** @class */ (function () {
    function HttpBackend() {
    }
    return HttpBackend;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @record
 */
/**
 * Immutable set of Http headers, with lazy parsing.
 * \@stable
 */
var HttpHeaders = /** @class */ (function () {
    function HttpHeaders(headers) {
        var _this = this;
        /**
         * Internal map of lowercased header names to the normalized
         * form of the name (the form seen first).
         */
        this.normalizedNames = new Map();
        /**
         * Queued updates to be materialized the next initialization.
         */
        this.lazyUpdate = null;
        if (!headers) {
            this.headers = new Map();
        }
        else if (typeof headers === 'string') {
            this.lazyInit = function () {
                _this.headers = new Map();
                headers.split('\n').forEach(function (line) {
                    var /** @type {?} */ index = line.indexOf(':');
                    if (index > 0) {
                        var /** @type {?} */ name_1 = line.slice(0, index);
                        var /** @type {?} */ key = name_1.toLowerCase();
                        var /** @type {?} */ value = line.slice(index + 1).trim();
                        _this.maybeSetNormalizedName(name_1, key);
                        if (_this.headers.has(key)) {
                            /** @type {?} */ ((_this.headers.get(key))).push(value);
                        }
                        else {
                            _this.headers.set(key, [value]);
                        }
                    }
                });
            };
        }
        else {
            this.lazyInit = function () {
                _this.headers = new Map();
                Object.keys(headers).forEach(function (name) {
                    var /** @type {?} */ values = headers[name];
                    var /** @type {?} */ key = name.toLowerCase();
                    if (typeof values === 'string') {
                        values = [values];
                    }
                    if (values.length > 0) {
                        _this.headers.set(key, values);
                        _this.maybeSetNormalizedName(name, key);
                    }
                });
            };
        }
    }
    /**
     * Checks for existence of header by given name.
     */
    /**
     * Checks for existence of header by given name.
     * @param {?} name
     * @return {?}
     */
    HttpHeaders.prototype.has = /**
     * Checks for existence of header by given name.
     * @param {?} name
     * @return {?}
     */
    function (name) {
        this.init();
        return this.headers.has(name.toLowerCase());
    };
    /**
     * Returns first header that matches given name.
     */
    /**
     * Returns first header that matches given name.
     * @param {?} name
     * @return {?}
     */
    HttpHeaders.prototype.get = /**
     * Returns first header that matches given name.
     * @param {?} name
     * @return {?}
     */
    function (name) {
        this.init();
        var /** @type {?} */ values = this.headers.get(name.toLowerCase());
        return values && values.length > 0 ? values[0] : null;
    };
    /**
     * Returns the names of the headers
     */
    /**
     * Returns the names of the headers
     * @return {?}
     */
    HttpHeaders.prototype.keys = /**
     * Returns the names of the headers
     * @return {?}
     */
    function () {
        this.init();
        return Array.from(this.normalizedNames.values());
    };
    /**
     * Returns list of header values for a given name.
     */
    /**
     * Returns list of header values for a given name.
     * @param {?} name
     * @return {?}
     */
    HttpHeaders.prototype.getAll = /**
     * Returns list of header values for a given name.
     * @param {?} name
     * @return {?}
     */
    function (name) {
        this.init();
        return this.headers.get(name.toLowerCase()) || null;
    };
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    HttpHeaders.prototype.append = /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (name, value) {
        return this.clone({ name: name, value: value, op: 'a' });
    };
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    HttpHeaders.prototype.set = /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    function (name, value) {
        return this.clone({ name: name, value: value, op: 's' });
    };
    /**
     * @param {?} name
     * @param {?=} value
     * @return {?}
     */
    HttpHeaders.prototype.delete = /**
     * @param {?} name
     * @param {?=} value
     * @return {?}
     */
    function (name, value) {
        return this.clone({ name: name, value: value, op: 'd' });
    };
    /**
     * @param {?} name
     * @param {?} lcName
     * @return {?}
     */
    HttpHeaders.prototype.maybeSetNormalizedName = /**
     * @param {?} name
     * @param {?} lcName
     * @return {?}
     */
    function (name, lcName) {
        if (!this.normalizedNames.has(lcName)) {
            this.normalizedNames.set(lcName, name);
        }
    };
    /**
     * @return {?}
     */
    HttpHeaders.prototype.init = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!!this.lazyInit) {
            if (this.lazyInit instanceof HttpHeaders) {
                this.copyFrom(this.lazyInit);
            }
            else {
                this.lazyInit();
            }
            this.lazyInit = null;
            if (!!this.lazyUpdate) {
                this.lazyUpdate.forEach(function (update) { return _this.applyUpdate(update); });
                this.lazyUpdate = null;
            }
        }
    };
    /**
     * @param {?} other
     * @return {?}
     */
    HttpHeaders.prototype.copyFrom = /**
     * @param {?} other
     * @return {?}
     */
    function (other) {
        var _this = this;
        other.init();
        Array.from(other.headers.keys()).forEach(function (key) {
            _this.headers.set(key, /** @type {?} */ ((other.headers.get(key))));
            _this.normalizedNames.set(key, /** @type {?} */ ((other.normalizedNames.get(key))));
        });
    };
    /**
     * @param {?} update
     * @return {?}
     */
    HttpHeaders.prototype.clone = /**
     * @param {?} update
     * @return {?}
     */
    function (update) {
        var /** @type {?} */ clone = new HttpHeaders();
        clone.lazyInit =
            (!!this.lazyInit && this.lazyInit instanceof HttpHeaders) ? this.lazyInit : this;
        clone.lazyUpdate = (this.lazyUpdate || []).concat([update]);
        return clone;
    };
    /**
     * @param {?} update
     * @return {?}
     */
    HttpHeaders.prototype.applyUpdate = /**
     * @param {?} update
     * @return {?}
     */
    function (update) {
        var /** @type {?} */ key = update.name.toLowerCase();
        switch (update.op) {
            case 'a':
            case 's':
                var /** @type {?} */ value = /** @type {?} */ ((update.value));
                if (typeof value === 'string') {
                    value = [value];
                }
                if (value.length === 0) {
                    return;
                }
                this.maybeSetNormalizedName(update.name, key);
                var /** @type {?} */ base = (update.op === 'a' ? this.headers.get(key) : undefined) || [];
                base.push.apply(base, value);
                this.headers.set(key, base);
                break;
            case 'd':
                var /** @type {?} */ toDelete_1 = /** @type {?} */ (update.value);
                if (!toDelete_1) {
                    this.headers.delete(key);
                    this.normalizedNames.delete(key);
                }
                else {
                    var /** @type {?} */ existing = this.headers.get(key);
                    if (!existing) {
                        return;
                    }
                    existing = existing.filter(function (value) { return toDelete_1.indexOf(value) === -1; });
                    if (existing.length === 0) {
                        this.headers.delete(key);
                        this.normalizedNames.delete(key);
                    }
                    else {
                        this.headers.set(key, existing);
                    }
                }
                break;
        }
    };
    /**
     * @internal
     */
    /**
     * \@internal
     * @param {?} fn
     * @return {?}
     */
    HttpHeaders.prototype.forEach = /**
     * \@internal
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.init();
        Array.from(this.normalizedNames.keys())
            .forEach(function (key) { return fn(/** @type {?} */ ((_this.normalizedNames.get(key))), /** @type {?} */ ((_this.headers.get(key)))); });
    };
    return HttpHeaders;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A codec for encoding and decoding parameters in URLs.
 *
 * Used by `HttpParams`.
 *
 * \@stable
 *
 * @record
 */

/**
 * A `HttpParameterCodec` that uses `encodeURIComponent` and `decodeURIComponent` to
 * serialize and parse URL parameter keys and values.
 *
 * \@stable
 */
var HttpUrlEncodingCodec = /** @class */ (function () {
    function HttpUrlEncodingCodec() {
    }
    /**
     * @param {?} k
     * @return {?}
     */
    HttpUrlEncodingCodec.prototype.encodeKey = /**
     * @param {?} k
     * @return {?}
     */
    function (k) { return standardEncoding(k); };
    /**
     * @param {?} v
     * @return {?}
     */
    HttpUrlEncodingCodec.prototype.encodeValue = /**
     * @param {?} v
     * @return {?}
     */
    function (v) { return standardEncoding(v); };
    /**
     * @param {?} k
     * @return {?}
     */
    HttpUrlEncodingCodec.prototype.decodeKey = /**
     * @param {?} k
     * @return {?}
     */
    function (k) { return decodeURIComponent(k); };
    /**
     * @param {?} v
     * @return {?}
     */
    HttpUrlEncodingCodec.prototype.decodeValue = /**
     * @param {?} v
     * @return {?}
     */
    function (v) { return decodeURIComponent(v); };
    return HttpUrlEncodingCodec;
}());
/**
 * @param {?} rawParams
 * @param {?} codec
 * @return {?}
 */
function paramParser(rawParams, codec) {
    var /** @type {?} */ map$$1 = new Map();
    if (rawParams.length > 0) {
        var /** @type {?} */ params = rawParams.split('&');
        params.forEach(function (param) {
            var /** @type {?} */ eqIdx = param.indexOf('=');
            var _a = eqIdx == -1 ?
                [codec.decodeKey(param), ''] :
                [codec.decodeKey(param.slice(0, eqIdx)), codec.decodeValue(param.slice(eqIdx + 1))], key = _a[0], val = _a[1];
            var /** @type {?} */ list = map$$1.get(key) || [];
            list.push(val);
            map$$1.set(key, list);
        });
    }
    return map$$1;
}
/**
 * @param {?} v
 * @return {?}
 */
function standardEncoding(v) {
    return encodeURIComponent(v)
        .replace(/%40/gi, '@')
        .replace(/%3A/gi, ':')
        .replace(/%24/gi, '$')
        .replace(/%2C/gi, ',')
        .replace(/%3B/gi, ';')
        .replace(/%2B/gi, '+')
        .replace(/%3D/gi, '=')
        .replace(/%3F/gi, '?')
        .replace(/%2F/gi, '/');
}
/**
 * An HTTP request/response body that represents serialized parameters,
 * per the MIME type `application/x-www-form-urlencoded`.
 *
 * This class is immutable - all mutation operations return a new instance.
 *
 * \@stable
 */
var HttpParams = /** @class */ (function () {
    function HttpParams(options) {
        if (options === void 0) { options = /** @type {?} */ ({}); }
        var _this = this;
        this.updates = null;
        this.cloneFrom = null;
        this.encoder = options.encoder || new HttpUrlEncodingCodec();
        if (!!options.fromString) {
            if (!!options.fromObject) {
                throw new Error("Cannot specify both fromString and fromObject.");
            }
            this.map = paramParser(options.fromString, this.encoder);
        }
        else if (!!options.fromObject) {
            this.map = new Map();
            Object.keys(options.fromObject).forEach(function (key) {
                var /** @type {?} */ value = (/** @type {?} */ (options.fromObject))[key]; /** @type {?} */
                ((_this.map)).set(key, Array.isArray(value) ? value : [value]);
            });
        }
        else {
            this.map = null;
        }
    }
    /**
     * Check whether the body has one or more values for the given parameter name.
     */
    /**
     * Check whether the body has one or more values for the given parameter name.
     * @param {?} param
     * @return {?}
     */
    HttpParams.prototype.has = /**
     * Check whether the body has one or more values for the given parameter name.
     * @param {?} param
     * @return {?}
     */
    function (param) {
        this.init();
        return /** @type {?} */ ((this.map)).has(param);
    };
    /**
     * Get the first value for the given parameter name, or `null` if it's not present.
     */
    /**
     * Get the first value for the given parameter name, or `null` if it's not present.
     * @param {?} param
     * @return {?}
     */
    HttpParams.prototype.get = /**
     * Get the first value for the given parameter name, or `null` if it's not present.
     * @param {?} param
     * @return {?}
     */
    function (param) {
        this.init();
        var /** @type {?} */ res = /** @type {?} */ ((this.map)).get(param);
        return !!res ? res[0] : null;
    };
    /**
     * Get all values for the given parameter name, or `null` if it's not present.
     */
    /**
     * Get all values for the given parameter name, or `null` if it's not present.
     * @param {?} param
     * @return {?}
     */
    HttpParams.prototype.getAll = /**
     * Get all values for the given parameter name, or `null` if it's not present.
     * @param {?} param
     * @return {?}
     */
    function (param) {
        this.init();
        return /** @type {?} */ ((this.map)).get(param) || null;
    };
    /**
     * Get all the parameter names for this body.
     */
    /**
     * Get all the parameter names for this body.
     * @return {?}
     */
    HttpParams.prototype.keys = /**
     * Get all the parameter names for this body.
     * @return {?}
     */
    function () {
        this.init();
        return Array.from(/** @type {?} */ ((this.map)).keys());
    };
    /**
     * Construct a new body with an appended value for the given parameter name.
     */
    /**
     * Construct a new body with an appended value for the given parameter name.
     * @param {?} param
     * @param {?} value
     * @return {?}
     */
    HttpParams.prototype.append = /**
     * Construct a new body with an appended value for the given parameter name.
     * @param {?} param
     * @param {?} value
     * @return {?}
     */
    function (param, value) { return this.clone({ param: param, value: value, op: 'a' }); };
    /**
     * Construct a new body with a new value for the given parameter name.
     */
    /**
     * Construct a new body with a new value for the given parameter name.
     * @param {?} param
     * @param {?} value
     * @return {?}
     */
    HttpParams.prototype.set = /**
     * Construct a new body with a new value for the given parameter name.
     * @param {?} param
     * @param {?} value
     * @return {?}
     */
    function (param, value) { return this.clone({ param: param, value: value, op: 's' }); };
    /**
     * Construct a new body with either the given value for the given parameter
     * removed, if a value is given, or all values for the given parameter removed
     * if not.
     */
    /**
     * Construct a new body with either the given value for the given parameter
     * removed, if a value is given, or all values for the given parameter removed
     * if not.
     * @param {?} param
     * @param {?=} value
     * @return {?}
     */
    HttpParams.prototype.delete = /**
     * Construct a new body with either the given value for the given parameter
     * removed, if a value is given, or all values for the given parameter removed
     * if not.
     * @param {?} param
     * @param {?=} value
     * @return {?}
     */
    function (param, value) { return this.clone({ param: param, value: value, op: 'd' }); };
    /**
     * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
     * separated by `&`s.
     */
    /**
     * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
     * separated by `&`s.
     * @return {?}
     */
    HttpParams.prototype.toString = /**
     * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
     * separated by `&`s.
     * @return {?}
     */
    function () {
        var _this = this;
        this.init();
        return this.keys()
            .map(function (key) {
            var /** @type {?} */ eKey = _this.encoder.encodeKey(key);
            return /** @type {?} */ ((/** @type {?} */ ((_this.map)).get(key))).map(function (value) { return eKey + '=' + _this.encoder.encodeValue(value); }).join('&');
        })
            .join('&');
    };
    /**
     * @param {?} update
     * @return {?}
     */
    HttpParams.prototype.clone = /**
     * @param {?} update
     * @return {?}
     */
    function (update) {
        var /** @type {?} */ clone = new HttpParams({ encoder: this.encoder });
        clone.cloneFrom = this.cloneFrom || this;
        clone.updates = (this.updates || []).concat([update]);
        return clone;
    };
    /**
     * @return {?}
     */
    HttpParams.prototype.init = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.map === null) {
            this.map = new Map();
        }
        if (this.cloneFrom !== null) {
            this.cloneFrom.init();
            this.cloneFrom.keys().forEach(function (key) { return ((_this.map)).set(key, /** @type {?} */ ((/** @type {?} */ ((/** @type {?} */ ((_this.cloneFrom)).map)).get(key)))); }); /** @type {?} */
            ((this.updates)).forEach(function (update) {
                switch (update.op) {
                    case 'a':
                    case 's':
                        var /** @type {?} */ base = (update.op === 'a' ? /** @type {?} */ ((_this.map)).get(update.param) : undefined) || [];
                        base.push(/** @type {?} */ ((update.value))); /** @type {?} */
                        ((_this.map)).set(update.param, base);
                        break;
                    case 'd':
                        if (update.value !== undefined) {
                            var /** @type {?} */ base_1 = /** @type {?} */ ((_this.map)).get(update.param) || [];
                            var /** @type {?} */ idx = base_1.indexOf(update.value);
                            if (idx !== -1) {
                                base_1.splice(idx, 1);
                            }
                            if (base_1.length > 0) {
                                /** @type {?} */ ((_this.map)).set(update.param, base_1);
                            }
                            else {
                                /** @type {?} */ ((_this.map)).delete(update.param);
                            }
                        }
                        else {
                            /** @type {?} */ ((_this.map)).delete(update.param);
                            break;
                        }
                }
            });
            this.cloneFrom = null;
        }
    };
    return HttpParams;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Determine whether the given HTTP method may include a body.
 * @param {?} method
 * @return {?}
 */
function mightHaveBody(method) {
    switch (method) {
        case 'DELETE':
        case 'GET':
        case 'HEAD':
        case 'OPTIONS':
        case 'JSONP':
            return false;
        default:
            return true;
    }
}
/**
 * Safely assert whether the given value is an ArrayBuffer.
 *
 * In some execution environments ArrayBuffer is not defined.
 * @param {?} value
 * @return {?}
 */
function isArrayBuffer(value) {
    return typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer;
}
/**
 * Safely assert whether the given value is a Blob.
 *
 * In some execution environments Blob is not defined.
 * @param {?} value
 * @return {?}
 */
function isBlob(value) {
    return typeof Blob !== 'undefined' && value instanceof Blob;
}
/**
 * Safely assert whether the given value is a FormData instance.
 *
 * In some execution environments FormData is not defined.
 * @param {?} value
 * @return {?}
 */
function isFormData(value) {
    return typeof FormData !== 'undefined' && value instanceof FormData;
}
/**
 * An outgoing HTTP request with an optional typed body.
 *
 * `HttpRequest` represents an outgoing request, including URL, method,
 * headers, body, and other request configuration options. Instances should be
 * assumed to be immutable. To modify a `HttpRequest`, the `clone`
 * method should be used.
 *
 * \@stable
 * @template T
 */
var HttpRequest = /** @class */ (function () {
    function HttpRequest(method, url, third, fourth) {
        this.url = url;
        /**
         * The request body, or `null` if one isn't set.
         *
         * Bodies are not enforced to be immutable, as they can include a reference to any
         * user-defined data type. However, interceptors should take care to preserve
         * idempotence by treating them as such.
         */
        this.body = null;
        /**
         * Whether this request should be made in a way that exposes progress events.
         *
         * Progress events are expensive (change detection runs on each event) and so
         * they should only be requested if the consumer intends to monitor them.
         */
        this.reportProgress = false;
        /**
         * Whether this request should be sent with outgoing credentials (cookies).
         */
        this.withCredentials = false;
        /**
         * The expected response type of the server.
         *
         * This is used to parse the response appropriately before returning it to
         * the requestee.
         */
        this.responseType = 'json';
        this.method = method.toUpperCase();
        // Next, need to figure out which argument holds the HttpRequestInit
        // options, if any.
        var /** @type {?} */ options;
        // Check whether a body argument is expected. The only valid way to omit
        // the body argument is to use a known no-body method like GET.
        if (mightHaveBody(this.method) || !!fourth) {
            // Body is the third argument, options are the fourth.
            this.body = (third !== undefined) ? /** @type {?} */ (third) : null;
            options = fourth;
        }
        else {
            // No body required, options are the third argument. The body stays null.
            options = /** @type {?} */ (third);
        }
        // If options have been passed, interpret them.
        if (options) {
            // Normalize reportProgress and withCredentials.
            this.reportProgress = !!options.reportProgress;
            this.withCredentials = !!options.withCredentials;
            // Override default response type of 'json' if one is provided.
            if (!!options.responseType) {
                this.responseType = options.responseType;
            }
            // Override headers if they're provided.
            if (!!options.headers) {
                this.headers = options.headers;
            }
            if (!!options.params) {
                this.params = options.params;
            }
        }
        // If no headers have been passed in, construct a new HttpHeaders instance.
        if (!this.headers) {
            this.headers = new HttpHeaders();
        }
        // If no parameters have been passed in, construct a new HttpUrlEncodedParams instance.
        if (!this.params) {
            this.params = new HttpParams();
            this.urlWithParams = url;
        }
        else {
            // Encode the parameters to a string in preparation for inclusion in the URL.
            var /** @type {?} */ params = this.params.toString();
            if (params.length === 0) {
                // No parameters, the visible URL is just the URL given at creation time.
                this.urlWithParams = url;
            }
            else {
                // Does the URL already have query parameters? Look for '?'.
                var /** @type {?} */ qIdx = url.indexOf('?');
                // There are 3 cases to handle:
                // 1) No existing parameters -> append '?' followed by params.
                // 2) '?' exists and is followed by existing query string ->
                //    append '&' followed by params.
                // 3) '?' exists at the end of the url -> append params directly.
                // This basically amounts to determining the character, if any, with
                // which to join the URL and parameters.
                var /** @type {?} */ sep = qIdx === -1 ? '?' : (qIdx < url.length - 1 ? '&' : '');
                this.urlWithParams = url + sep + params;
            }
        }
    }
    /**
     * Transform the free-form body into a serialized format suitable for
     * transmission to the server.
     */
    /**
     * Transform the free-form body into a serialized format suitable for
     * transmission to the server.
     * @return {?}
     */
    HttpRequest.prototype.serializeBody = /**
     * Transform the free-form body into a serialized format suitable for
     * transmission to the server.
     * @return {?}
     */
    function () {
        // If no body is present, no need to serialize it.
        if (this.body === null) {
            return null;
        }
        // Check whether the body is already in a serialized form. If so,
        // it can just be returned directly.
        if (isArrayBuffer(this.body) || isBlob(this.body) || isFormData(this.body) ||
            typeof this.body === 'string') {
            return this.body;
        }
        // Check whether the body is an instance of HttpUrlEncodedParams.
        if (this.body instanceof HttpParams) {
            return this.body.toString();
        }
        // Check whether the body is an object or array, and serialize with JSON if so.
        if (typeof this.body === 'object' || typeof this.body === 'boolean' ||
            Array.isArray(this.body)) {
            return JSON.stringify(this.body);
        }
        // Fall back on toString() for everything else.
        return (/** @type {?} */ (this.body)).toString();
    };
    /**
     * Examine the body and attempt to infer an appropriate MIME type
     * for it.
     *
     * If no such type can be inferred, this method will return `null`.
     */
    /**
     * Examine the body and attempt to infer an appropriate MIME type
     * for it.
     *
     * If no such type can be inferred, this method will return `null`.
     * @return {?}
     */
    HttpRequest.prototype.detectContentTypeHeader = /**
     * Examine the body and attempt to infer an appropriate MIME type
     * for it.
     *
     * If no such type can be inferred, this method will return `null`.
     * @return {?}
     */
    function () {
        // An empty body has no content type.
        if (this.body === null) {
            return null;
        }
        // FormData bodies rely on the browser's content type assignment.
        if (isFormData(this.body)) {
            return null;
        }
        // Blobs usually have their own content type. If it doesn't, then
        // no type can be inferred.
        if (isBlob(this.body)) {
            return this.body.type || null;
        }
        // Array buffers have unknown contents and thus no type can be inferred.
        if (isArrayBuffer(this.body)) {
            return null;
        }
        // Technically, strings could be a form of JSON data, but it's safe enough
        // to assume they're plain strings.
        if (typeof this.body === 'string') {
            return 'text/plain';
        }
        // `HttpUrlEncodedParams` has its own content-type.
        if (this.body instanceof HttpParams) {
            return 'application/x-www-form-urlencoded;charset=UTF-8';
        }
        // Arrays, objects, and numbers will be encoded as JSON.
        if (typeof this.body === 'object' || typeof this.body === 'number' ||
            Array.isArray(this.body)) {
            return 'application/json';
        }
        // No type could be inferred.
        return null;
    };
    /**
     * @param {?=} update
     * @return {?}
     */
    HttpRequest.prototype.clone = /**
     * @param {?=} update
     * @return {?}
     */
    function (update) {
        if (update === void 0) { update = {}; }
        // For method, url, and responseType, take the current value unless
        // it is overridden in the update hash.
        var /** @type {?} */ method = update.method || this.method;
        var /** @type {?} */ url = update.url || this.url;
        var /** @type {?} */ responseType = update.responseType || this.responseType;
        // The body is somewhat special - a `null` value in update.body means
        // whatever current body is present is being overridden with an empty
        // body, whereas an `undefined` value in update.body implies no
        // override.
        var /** @type {?} */ body = (update.body !== undefined) ? update.body : this.body;
        // Carefully handle the boolean options to differentiate between
        // `false` and `undefined` in the update args.
        var /** @type {?} */ withCredentials = (update.withCredentials !== undefined) ? update.withCredentials : this.withCredentials;
        var /** @type {?} */ reportProgress = (update.reportProgress !== undefined) ? update.reportProgress : this.reportProgress;
        // Headers and params may be appended to if `setHeaders` or
        // `setParams` are used.
        var /** @type {?} */ headers = update.headers || this.headers;
        var /** @type {?} */ params = update.params || this.params;
        // Check whether the caller has asked to add headers.
        if (update.setHeaders !== undefined) {
            // Set every requested header.
            headers =
                Object.keys(update.setHeaders)
                    .reduce(function (headers, name) { return headers.set(name, /** @type {?} */ ((update.setHeaders))[name]); }, headers);
        }
        // Check whether the caller has asked to set params.
        if (update.setParams) {
            // Set every requested param.
            params = Object.keys(update.setParams)
                .reduce(function (params, param) { return params.set(param, /** @type {?} */ ((update.setParams))[param]); }, params);
        }
        // Finally, construct the new HttpRequest using the pieces from above.
        return new HttpRequest(method, url, body, {
            params: params, headers: headers, reportProgress: reportProgress, responseType: responseType, withCredentials: withCredentials,
        });
    };
    return HttpRequest;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** @enum {number} */
var HttpEventType = {
    /**
       * The request was sent out over the wire.
       */
    Sent: 0,
    /**
       * An upload progress event was received.
       */
    UploadProgress: 1,
    /**
       * The response status code and headers were received.
       */
    ResponseHeader: 2,
    /**
       * A download progress event was received.
       */
    DownloadProgress: 3,
    /**
       * The full response including the body was received.
       */
    Response: 4,
    /**
       * A custom event from an interceptor or a backend.
       */
    User: 5,
};
HttpEventType[HttpEventType.Sent] = "Sent";
HttpEventType[HttpEventType.UploadProgress] = "UploadProgress";
HttpEventType[HttpEventType.ResponseHeader] = "ResponseHeader";
HttpEventType[HttpEventType.DownloadProgress] = "DownloadProgress";
HttpEventType[HttpEventType.Response] = "Response";
HttpEventType[HttpEventType.User] = "User";
/**
 * Base interface for progress events.
 *
 * \@stable
 * @record
 */

/**
 * A download progress event.
 *
 * \@stable
 * @record
 */

/**
 * An upload progress event.
 *
 * \@stable
 * @record
 */

/**
 * An event indicating that the request was sent to the server. Useful
 * when a request may be retried multiple times, to distinguish between
 * retries on the final event stream.
 *
 * \@stable
 * @record
 */

/**
 * A user-defined event.
 *
 * Grouping all custom events under this type ensures they will be handled
 * and forwarded by all implementations of interceptors.
 *
 * \@stable
 * @record
 * @template T
 */

/**
 * An error that represents a failed attempt to JSON.parse text coming back
 * from the server.
 *
 * It bundles the Error object with the actual response body that failed to parse.
 *
 * \@stable
 * @record
 */

/**
 * Base class for both `HttpResponse` and `HttpHeaderResponse`.
 *
 * \@stable
 * @abstract
 */
var HttpResponseBase = /** @class */ (function () {
    /**
     * Super-constructor for all responses.
     *
     * The single parameter accepted is an initialization hash. Any properties
     * of the response passed there will override the default values.
     */
    function HttpResponseBase(init, defaultStatus, defaultStatusText) {
        if (defaultStatus === void 0) { defaultStatus = 200; }
        if (defaultStatusText === void 0) { defaultStatusText = 'OK'; }
        // If the hash has values passed, use them to initialize the response.
        // Otherwise use the default values.
        this.headers = init.headers || new HttpHeaders();
        this.status = init.status !== undefined ? init.status : defaultStatus;
        this.statusText = init.statusText || defaultStatusText;
        this.url = init.url || null;
        // Cache the ok value to avoid defining a getter.
        this.ok = this.status >= 200 && this.status < 300;
    }
    return HttpResponseBase;
}());
/**
 * A partial HTTP response which only includes the status and header data,
 * but no response body.
 *
 * `HttpHeaderResponse` is a `HttpEvent` available on the response
 * event stream, only when progress events are requested.
 *
 * \@stable
 */
var HttpHeaderResponse = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_5_tslib__["b" /* __extends */])(HttpHeaderResponse, _super);
    /**
     * Create a new `HttpHeaderResponse` with the given parameters.
     */
    function HttpHeaderResponse(init) {
        if (init === void 0) { init = {}; }
        var _this = _super.call(this, init) || this;
        _this.type = HttpEventType.ResponseHeader;
        return _this;
    }
    /**
     * Copy this `HttpHeaderResponse`, overriding its contents with the
     * given parameter hash.
     */
    /**
     * Copy this `HttpHeaderResponse`, overriding its contents with the
     * given parameter hash.
     * @param {?=} update
     * @return {?}
     */
    HttpHeaderResponse.prototype.clone = /**
     * Copy this `HttpHeaderResponse`, overriding its contents with the
     * given parameter hash.
     * @param {?=} update
     * @return {?}
     */
    function (update) {
        if (update === void 0) { update = {}; }
        // Perform a straightforward initialization of the new HttpHeaderResponse,
        // overriding the current parameters with new ones if given.
        return new HttpHeaderResponse({
            headers: update.headers || this.headers,
            status: update.status !== undefined ? update.status : this.status,
            statusText: update.statusText || this.statusText,
            url: update.url || this.url || undefined,
        });
    };
    return HttpHeaderResponse;
}(HttpResponseBase));
/**
 * A full HTTP response, including a typed response body (which may be `null`
 * if one was not returned).
 *
 * `HttpResponse` is a `HttpEvent` available on the response event
 * stream.
 *
 * \@stable
 * @template T
 */
var HttpResponse = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_5_tslib__["b" /* __extends */])(HttpResponse, _super);
    /**
     * Construct a new `HttpResponse`.
     */
    function HttpResponse(init) {
        if (init === void 0) { init = {}; }
        var _this = _super.call(this, init) || this;
        _this.type = HttpEventType.Response;
        _this.body = init.body !== undefined ? init.body : null;
        return _this;
    }
    /**
     * @param {?=} update
     * @return {?}
     */
    HttpResponse.prototype.clone = /**
     * @param {?=} update
     * @return {?}
     */
    function (update) {
        if (update === void 0) { update = {}; }
        return new HttpResponse({
            body: (update.body !== undefined) ? update.body : this.body,
            headers: update.headers || this.headers,
            status: (update.status !== undefined) ? update.status : this.status,
            statusText: update.statusText || this.statusText,
            url: update.url || this.url || undefined,
        });
    };
    return HttpResponse;
}(HttpResponseBase));
/**
 * A response that represents an error or failure, either from a
 * non-successful HTTP status, an error while executing the request,
 * or some other failure which occurred during the parsing of the response.
 *
 * Any error returned on the `Observable` response stream will be
 * wrapped in an `HttpErrorResponse` to provide additional context about
 * the state of the HTTP layer when the error occurred. The error property
 * will contain either a wrapped Error object or the error response returned
 * from the server.
 *
 * \@stable
 */
var HttpErrorResponse = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_5_tslib__["b" /* __extends */])(HttpErrorResponse, _super);
    function HttpErrorResponse(init) {
        var _this = 
        // Initialize with a default status of 0 / Unknown Error.
        _super.call(this, init, 0, 'Unknown Error') || this;
        _this.name = 'HttpErrorResponse';
        /**
         * Errors are never okay, even when the status code is in the 2xx success range.
         */
        _this.ok = false;
        // If the response was successful, then this was a parse error. Otherwise, it was
        // a protocol-level failure of some sort. Either the request failed in transit
        // or the server returned an unsuccessful status code.
        if (_this.status >= 200 && _this.status < 300) {
            _this.message = "Http failure during parsing for " + (init.url || '(unknown url)');
        }
        else {
            _this.message =
                "Http failure response for " + (init.url || '(unknown url)') + ": " + init.status + " " + init.statusText;
        }
        _this.error = init.error || null;
        return _this;
    }
    return HttpErrorResponse;
}(HttpResponseBase));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Construct an instance of `HttpRequestOptions<T>` from a source `HttpMethodOptions` and
 * the given `body`. Basically, this clones the object and adds the body.
 * @template T
 * @param {?} options
 * @param {?} body
 * @return {?}
 */
function addBody(options, body) {
    return {
        body: body,
        headers: options.headers,
        observe: options.observe,
        params: options.params,
        reportProgress: options.reportProgress,
        responseType: options.responseType,
        withCredentials: options.withCredentials,
    };
}
/**
 * Perform HTTP requests.
 *
 * `HttpClient` is available as an injectable class, with methods to perform HTTP requests.
 * Each request method has multiple signatures, and the return type varies according to which
 * signature is called (mainly the values of `observe` and `responseType`).
 *
 * \@stable
 */
var HttpClient = /** @class */ (function () {
    function HttpClient(handler) {
        this.handler = handler;
    }
    /**
     * Constructs an `Observable` for a particular HTTP request that, when subscribed,
     * fires the request through the chain of registered interceptors and on to the
     * server.
     *
     * This method can be called in one of two ways. Either an `HttpRequest`
     * instance can be passed directly as the only parameter, or a method can be
     * passed as the first parameter, a string URL as the second, and an
     * options hash as the third.
     *
     * If a `HttpRequest` object is passed directly, an `Observable` of the
     * raw `HttpEvent` stream will be returned.
     *
     * If a request is instead built by providing a URL, the options object
     * determines the return type of `request()`. In addition to configuring
     * request parameters such as the outgoing headers and/or the body, the options
     * hash specifies two key pieces of information about the request: the
     * `responseType` and what to `observe`.
     *
     * The `responseType` value determines how a successful response body will be
     * parsed. If `responseType` is the default `json`, a type interface for the
     * resulting object may be passed as a type parameter to `request()`.
     *
     * The `observe` value determines the return type of `request()`, based on what
     * the consumer is interested in observing. A value of `events` will return an
     * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
     * including progress events by default. A value of `response` will return an
     * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
     * depends on the `responseType` and any optionally provided type parameter.
     * A value of `body` will return an `Observable<T>` with the same `T` body type.
     */
    /**
     * Constructs an `Observable` for a particular HTTP request that, when subscribed,
     * fires the request through the chain of registered interceptors and on to the
     * server.
     *
     * This method can be called in one of two ways. Either an `HttpRequest`
     * instance can be passed directly as the only parameter, or a method can be
     * passed as the first parameter, a string URL as the second, and an
     * options hash as the third.
     *
     * If a `HttpRequest` object is passed directly, an `Observable` of the
     * raw `HttpEvent` stream will be returned.
     *
     * If a request is instead built by providing a URL, the options object
     * determines the return type of `request()`. In addition to configuring
     * request parameters such as the outgoing headers and/or the body, the options
     * hash specifies two key pieces of information about the request: the
     * `responseType` and what to `observe`.
     *
     * The `responseType` value determines how a successful response body will be
     * parsed. If `responseType` is the default `json`, a type interface for the
     * resulting object may be passed as a type parameter to `request()`.
     *
     * The `observe` value determines the return type of `request()`, based on what
     * the consumer is interested in observing. A value of `events` will return an
     * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
     * including progress events by default. A value of `response` will return an
     * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
     * depends on the `responseType` and any optionally provided type parameter.
     * A value of `body` will return an `Observable<T>` with the same `T` body type.
     * @param {?} first
     * @param {?=} url
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.request = /**
     * Constructs an `Observable` for a particular HTTP request that, when subscribed,
     * fires the request through the chain of registered interceptors and on to the
     * server.
     *
     * This method can be called in one of two ways. Either an `HttpRequest`
     * instance can be passed directly as the only parameter, or a method can be
     * passed as the first parameter, a string URL as the second, and an
     * options hash as the third.
     *
     * If a `HttpRequest` object is passed directly, an `Observable` of the
     * raw `HttpEvent` stream will be returned.
     *
     * If a request is instead built by providing a URL, the options object
     * determines the return type of `request()`. In addition to configuring
     * request parameters such as the outgoing headers and/or the body, the options
     * hash specifies two key pieces of information about the request: the
     * `responseType` and what to `observe`.
     *
     * The `responseType` value determines how a successful response body will be
     * parsed. If `responseType` is the default `json`, a type interface for the
     * resulting object may be passed as a type parameter to `request()`.
     *
     * The `observe` value determines the return type of `request()`, based on what
     * the consumer is interested in observing. A value of `events` will return an
     * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
     * including progress events by default. A value of `response` will return an
     * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
     * depends on the `responseType` and any optionally provided type parameter.
     * A value of `body` will return an `Observable<T>` with the same `T` body type.
     * @param {?} first
     * @param {?=} url
     * @param {?=} options
     * @return {?}
     */
    function (first, url, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var /** @type {?} */ req;
        // Firstly, check whether the primary argument is an instance of `HttpRequest`.
        if (first instanceof HttpRequest) {
            // It is. The other arguments must be undefined (per the signatures) and can be
            // ignored.
            req = /** @type {?} */ (first);
        }
        else {
            // It's a string, so it represents a URL. Construct a request based on it,
            // and incorporate the remaining arguments (assuming GET unless a method is
            // provided.
            // Figure out the headers.
            var /** @type {?} */ headers = undefined;
            if (options.headers instanceof HttpHeaders) {
                headers = options.headers;
            }
            else {
                headers = new HttpHeaders(options.headers);
            }
            // Sort out parameters.
            var /** @type {?} */ params = undefined;
            if (!!options.params) {
                if (options.params instanceof HttpParams) {
                    params = options.params;
                }
                else {
                    params = new HttpParams({ fromObject: options.params });
                }
            }
            // Construct the request.
            req = new HttpRequest(first, /** @type {?} */ ((url)), (options.body !== undefined ? options.body : null), {
                headers: headers,
                params: params,
                reportProgress: options.reportProgress,
                // By default, JSON is assumed to be returned for all calls.
                responseType: options.responseType || 'json',
                withCredentials: options.withCredentials,
            });
        }
        // Start with an Observable.of() the initial request, and run the handler (which
        // includes all interceptors) inside a concatMap(). This way, the handler runs
        // inside an Observable chain, which causes interceptors to be re-run on every
        // subscription (this also makes retries re-run the handler, including interceptors).
        var /** @type {?} */ events$ = __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_concatMap__["concatMap"].call(Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["of"])(req), function (req) { return _this.handler.handle(req); });
        // If coming via the API signature which accepts a previously constructed HttpRequest,
        // the only option is to get the event stream. Otherwise, return the event stream if
        // that is what was requested.
        if (first instanceof HttpRequest || options.observe === 'events') {
            return events$;
        }
        // The requested stream contains either the full response or the body. In either
        // case, the first step is to filter the event stream to extract a stream of
        // responses(s).
        var /** @type {?} */ res$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__["filter"].call(events$, function (event) { return event instanceof HttpResponse; });
        // Decide which stream to return.
        switch (options.observe || 'body') {
            case 'body':
                // The requested stream is the body. Map the response stream to the response
                // body. This could be done more simply, but a misbehaving interceptor might
                // transform the response body into a different format and ignore the requested
                // responseType. Guard against this by validating that the response is of the
                // requested type.
                switch (req.responseType) {
                    case 'arraybuffer':
                        return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(res$, function (res) {
                            // Validate that the body is an ArrayBuffer.
                            if (res.body !== null && !(res.body instanceof ArrayBuffer)) {
                                throw new Error('Response is not an ArrayBuffer.');
                            }
                            return res.body;
                        });
                    case 'blob':
                        return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(res$, function (res) {
                            // Validate that the body is a Blob.
                            if (res.body !== null && !(res.body instanceof Blob)) {
                                throw new Error('Response is not a Blob.');
                            }
                            return res.body;
                        });
                    case 'text':
                        return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(res$, function (res) {
                            // Validate that the body is a string.
                            if (res.body !== null && typeof res.body !== 'string') {
                                throw new Error('Response is not a string.');
                            }
                            return res.body;
                        });
                    case 'json':
                    default:
                        // No validation needed for JSON responses, as they can be of any type.
                        return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(res$, function (res) { return res.body; });
                }
            case 'response':
                // The response stream was requested directly, so return it.
                return res$;
            default:
                // Guard against new future observe types being added.
                throw new Error("Unreachable: unhandled observe type " + options.observe + "}");
        }
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * DELETE request to be executed on the server. See the individual overloads for
     * details of `delete()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * DELETE request to be executed on the server. See the individual overloads for
     * details of `delete()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.delete = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * DELETE request to be executed on the server. See the individual overloads for
     * details of `delete()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    function (url, options) {
        if (options === void 0) { options = {}; }
        return this.request('DELETE', url, /** @type {?} */ (options));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * GET request to be executed on the server. See the individual overloads for
     * details of `get()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * GET request to be executed on the server. See the individual overloads for
     * details of `get()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.get = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * GET request to be executed on the server. See the individual overloads for
     * details of `get()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    function (url, options) {
        if (options === void 0) { options = {}; }
        return this.request('GET', url, /** @type {?} */ (options));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * HEAD request to be executed on the server. See the individual overloads for
     * details of `head()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * HEAD request to be executed on the server. See the individual overloads for
     * details of `head()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.head = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * HEAD request to be executed on the server. See the individual overloads for
     * details of `head()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    function (url, options) {
        if (options === void 0) { options = {}; }
        return this.request('HEAD', url, /** @type {?} */ (options));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause a request
     * with the special method `JSONP` to be dispatched via the interceptor pipeline.
     *
     * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
     * If no such interceptor is reached, then the `JSONP` request will likely be
     * rejected by the configured backend.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause a request
     * with the special method `JSONP` to be dispatched via the interceptor pipeline.
     *
     * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
     * If no such interceptor is reached, then the `JSONP` request will likely be
     * rejected by the configured backend.
     * @template T
     * @param {?} url
     * @param {?} callbackParam
     * @return {?}
     */
    HttpClient.prototype.jsonp = /**
     * Constructs an `Observable` which, when subscribed, will cause a request
     * with the special method `JSONP` to be dispatched via the interceptor pipeline.
     *
     * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
     * If no such interceptor is reached, then the `JSONP` request will likely be
     * rejected by the configured backend.
     * @template T
     * @param {?} url
     * @param {?} callbackParam
     * @return {?}
     */
    function (url, callbackParam) {
        return this.request('JSONP', url, {
            params: new HttpParams().append(callbackParam, 'JSONP_CALLBACK'),
            observe: 'body',
            responseType: 'json',
        });
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * OPTIONS request to be executed on the server. See the individual overloads for
     * details of `options()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * OPTIONS request to be executed on the server. See the individual overloads for
     * details of `options()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.options = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * OPTIONS request to be executed on the server. See the individual overloads for
     * details of `options()`'s return type based on the provided options.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    function (url, options) {
        if (options === void 0) { options = {}; }
        return this.request('OPTIONS', url, /** @type {?} */ (options));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * PATCH request to be executed on the server. See the individual overloads for
     * details of `patch()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * PATCH request to be executed on the server. See the individual overloads for
     * details of `patch()`'s return type based on the provided options.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.patch = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * PATCH request to be executed on the server. See the individual overloads for
     * details of `patch()`'s return type based on the provided options.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    function (url, body, options) {
        if (options === void 0) { options = {}; }
        return this.request('PATCH', url, addBody(options, body));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.post = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    function (url, body, options) {
        if (options === void 0) { options = {}; }
        return this.request('POST', url, addBody(options, body));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     */
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    HttpClient.prototype.put = /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    function (url, body, options) {
        if (options === void 0) { options = {}; }
        return this.request('PUT', url, addBody(options, body));
    };
    HttpClient.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HttpClient.ctorParameters = function () { return [
        { type: HttpHandler, },
    ]; };
    return HttpClient;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Intercepts `HttpRequest` and handles them.
 *
 * Most interceptors will transform the outgoing request before passing it to the
 * next interceptor in the chain, by calling `next.handle(transformedReq)`.
 *
 * In rare cases, interceptors may wish to completely handle a request themselves,
 * and not delegate to the remainder of the chain. This behavior is allowed.
 *
 * \@stable
 * @record
 */

/**
 * `HttpHandler` which applies an `HttpInterceptor` to an `HttpRequest`.
 *
 * \@stable
 */
var HttpInterceptorHandler = /** @class */ (function () {
    function HttpInterceptorHandler(next, interceptor) {
        this.next = next;
        this.interceptor = interceptor;
    }
    /**
     * @param {?} req
     * @return {?}
     */
    HttpInterceptorHandler.prototype.handle = /**
     * @param {?} req
     * @return {?}
     */
    function (req) {
        return this.interceptor.intercept(req, this.next);
    };
    return HttpInterceptorHandler;
}());
/**
 * A multi-provider token which represents the array of `HttpInterceptor`s that
 * are registered.
 *
 * \@stable
 */
var HTTP_INTERCEPTORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('HTTP_INTERCEPTORS');
var NoopInterceptor = /** @class */ (function () {
    function NoopInterceptor() {
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    NoopInterceptor.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        return next.handle(req);
    };
    NoopInterceptor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    NoopInterceptor.ctorParameters = function () { return []; };
    return NoopInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Every request made through JSONP needs a callback name that's unique across the
// whole page. Each request is assigned an id and the callback name is constructed
// from that. The next id to be assigned is tracked in a global variable here that
// is shared among all applications on the page.
var nextRequestId = 0;
// Error text given when a JSONP script is injected, but doesn't invoke the callback
// passed in its URL.
var JSONP_ERR_NO_CALLBACK = 'JSONP injected script did not invoke callback.';
// Error text given when a request is passed to the JsonpClientBackend that doesn't
// have a request method JSONP.
var JSONP_ERR_WRONG_METHOD = 'JSONP requests must use JSONP request method.';
var JSONP_ERR_WRONG_RESPONSE_TYPE = 'JSONP requests must use Json response type.';
/**
 * DI token/abstract type representing a map of JSONP callbacks.
 *
 * In the browser, this should always be the `window` object.
 *
 * \@stable
 * @abstract
 */
var JsonpCallbackContext = /** @class */ (function () {
    function JsonpCallbackContext() {
    }
    return JsonpCallbackContext;
}());
/**
 * `HttpBackend` that only processes `HttpRequest` with the JSONP method,
 * by performing JSONP style requests.
 *
 * \@stable
 */
var JsonpClientBackend = /** @class */ (function () {
    function JsonpClientBackend(callbackMap, document) {
        this.callbackMap = callbackMap;
        this.document = document;
    }
    /**
     * Get the name of the next callback method, by incrementing the global `nextRequestId`.
     * @return {?}
     */
    JsonpClientBackend.prototype.nextCallback = /**
     * Get the name of the next callback method, by incrementing the global `nextRequestId`.
     * @return {?}
     */
    function () { return "ng_jsonp_callback_" + nextRequestId++; };
    /**
     * Process a JSONP request and return an event stream of the results.
     */
    /**
     * Process a JSONP request and return an event stream of the results.
     * @param {?} req
     * @return {?}
     */
    JsonpClientBackend.prototype.handle = /**
     * Process a JSONP request and return an event stream of the results.
     * @param {?} req
     * @return {?}
     */
    function (req) {
        var _this = this;
        // Firstly, check both the method and response type. If either doesn't match
        // then the request was improperly routed here and cannot be handled.
        if (req.method !== 'JSONP') {
            throw new Error(JSONP_ERR_WRONG_METHOD);
        }
        else if (req.responseType !== 'json') {
            throw new Error(JSONP_ERR_WRONG_RESPONSE_TYPE);
        }
        // Everything else happens inside the Observable boundary.
        return new __WEBPACK_IMPORTED_MODULE_7_rxjs_Observable__["Observable"](function (observer) {
            // The first step to make a request is to generate the callback name, and replace the
            // callback placeholder in the URL with the name. Care has to be taken here to ensure
            // a trailing &, if matched, gets inserted back into the URL in the correct place.
            var /** @type {?} */ callback = _this.nextCallback();
            var /** @type {?} */ url = req.urlWithParams.replace(/=JSONP_CALLBACK(&|$)/, "=" + callback + "$1");
            // Construct the <script> tag and point it at the URL.
            var /** @type {?} */ node = _this.document.createElement('script');
            node.src = url;
            // A JSONP request requires waiting for multiple callbacks. These variables
            // are closed over and track state across those callbacks.
            // The response object, if one has been received, or null otherwise.
            var /** @type {?} */ body = null;
            // Whether the response callback has been called.
            var /** @type {?} */ finished = false;
            // Whether the request has been cancelled (and thus any other callbacks)
            // should be ignored.
            var /** @type {?} */ cancelled = false;
            // Set the response callback in this.callbackMap (which will be the window
            // object in the browser. The script being loaded via the <script> tag will
            // eventually call this callback.
            // Set the response callback in this.callbackMap (which will be the window
            // object in the browser. The script being loaded via the <script> tag will
            // eventually call this callback.
            _this.callbackMap[callback] = function (data) {
                // Data has been received from the JSONP script. Firstly, delete this callback.
                delete _this.callbackMap[callback];
                // Next, make sure the request wasn't cancelled in the meantime.
                if (cancelled) {
                    return;
                }
                // Set state to indicate data was received.
                body = data;
                finished = true;
            };
            // cleanup() is a utility closure that removes the <script> from the page and
            // the response callback from the window. This logic is used in both the
            // success, error, and cancellation paths, so it's extracted out for convenience.
            var /** @type {?} */ cleanup = function () {
                // Remove the <script> tag if it's still on the page.
                if (node.parentNode) {
                    node.parentNode.removeChild(node);
                }
                // Remove the response callback from the callbackMap (window object in the
                // browser).
                delete _this.callbackMap[callback];
            };
            // onLoad() is the success callback which runs after the response callback
            // if the JSONP script loads successfully. The event itself is unimportant.
            // If something went wrong, onLoad() may run without the response callback
            // having been invoked.
            var /** @type {?} */ onLoad = function (event) {
                // Do nothing if the request has been cancelled.
                if (cancelled) {
                    return;
                }
                // Cleanup the page.
                cleanup();
                // Check whether the response callback has run.
                if (!finished) {
                    // It hasn't, something went wrong with the request. Return an error via
                    // the Observable error path. All JSONP errors have status 0.
                    observer.error(new HttpErrorResponse({
                        url: url,
                        status: 0,
                        statusText: 'JSONP Error',
                        error: new Error(JSONP_ERR_NO_CALLBACK),
                    }));
                    return;
                }
                // Success. body either contains the response body or null if none was
                // returned.
                observer.next(new HttpResponse({
                    body: body,
                    status: 200,
                    statusText: 'OK', url: url,
                }));
                // Complete the stream, the response is over.
                observer.complete();
            };
            // onError() is the error callback, which runs if the script returned generates
            // a Javascript error. It emits the error via the Observable error channel as
            // a HttpErrorResponse.
            var /** @type {?} */ onError = function (error) {
                // If the request was already cancelled, no need to emit anything.
                if (cancelled) {
                    return;
                }
                cleanup();
                // Wrap the error in a HttpErrorResponse.
                observer.error(new HttpErrorResponse({
                    error: error,
                    status: 0,
                    statusText: 'JSONP Error', url: url,
                }));
            };
            // Subscribe to both the success (load) and error events on the <script> tag,
            // and add it to the page.
            node.addEventListener('load', onLoad);
            node.addEventListener('error', onError);
            _this.document.body.appendChild(node);
            // The request has now been successfully sent.
            observer.next({ type: HttpEventType.Sent });
            // Cancellation handler.
            return function () {
                // Track the cancellation so event listeners won't do anything even if already scheduled.
                cancelled = true;
                // Remove the event listeners so they won't run if the events later fire.
                node.removeEventListener('load', onLoad);
                node.removeEventListener('error', onError);
                // And finally, clean up the page.
                cleanup();
            };
        });
    };
    JsonpClientBackend.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    JsonpClientBackend.ctorParameters = function () { return [
        { type: JsonpCallbackContext, },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_6__angular_common__["DOCUMENT"],] },] },
    ]; };
    return JsonpClientBackend;
}());
/**
 * An `HttpInterceptor` which identifies requests with the method JSONP and
 * shifts them to the `JsonpClientBackend`.
 *
 * \@stable
 */
var JsonpInterceptor = /** @class */ (function () {
    function JsonpInterceptor(jsonp) {
        this.jsonp = jsonp;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    JsonpInterceptor.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        if (req.method === 'JSONP') {
            return this.jsonp.handle(/** @type {?} */ (req));
        }
        // Fall through for normal HTTP requests.
        return next.handle(req);
    };
    JsonpInterceptor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    JsonpInterceptor.ctorParameters = function () { return [
        { type: JsonpClientBackend, },
    ]; };
    return JsonpInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var XSSI_PREFIX = /^\)\]\}',?\n/;
/**
 * Determine an appropriate URL for the response, by checking either
 * XMLHttpRequest.responseURL or the X-Request-URL header.
 * @param {?} xhr
 * @return {?}
 */
function getResponseUrl(xhr) {
    if ('responseURL' in xhr && xhr.responseURL) {
        return xhr.responseURL;
    }
    if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
        return xhr.getResponseHeader('X-Request-URL');
    }
    return null;
}
/**
 * A wrapper around the `XMLHttpRequest` constructor.
 *
 * \@stable
 * @abstract
 */
var XhrFactory = /** @class */ (function () {
    function XhrFactory() {
    }
    return XhrFactory;
}());
/**
 * A factory for \@{link HttpXhrBackend} that uses the `XMLHttpRequest` browser API.
 *
 * \@stable
 */
var BrowserXhr = /** @class */ (function () {
    function BrowserXhr() {
    }
    /**
     * @return {?}
     */
    BrowserXhr.prototype.build = /**
     * @return {?}
     */
    function () { return /** @type {?} */ ((new XMLHttpRequest())); };
    BrowserXhr.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    BrowserXhr.ctorParameters = function () { return []; };
    return BrowserXhr;
}());
/**
 * An `HttpBackend` which uses the XMLHttpRequest API to send
 * requests to a backend server.
 *
 * \@stable
 */
var HttpXhrBackend = /** @class */ (function () {
    function HttpXhrBackend(xhrFactory) {
        this.xhrFactory = xhrFactory;
    }
    /**
     * Process a request and return a stream of response events.
     */
    /**
     * Process a request and return a stream of response events.
     * @param {?} req
     * @return {?}
     */
    HttpXhrBackend.prototype.handle = /**
     * Process a request and return a stream of response events.
     * @param {?} req
     * @return {?}
     */
    function (req) {
        var _this = this;
        // Quick check to give a better error message when a user attempts to use
        // HttpClient.jsonp() without installing the JsonpClientModule
        if (req.method === 'JSONP') {
            throw new Error("Attempted to construct Jsonp request without JsonpClientModule installed.");
        }
        // Everything happens on Observable subscription.
        return new __WEBPACK_IMPORTED_MODULE_7_rxjs_Observable__["Observable"](function (observer) {
            // Start by setting up the XHR object with request method, URL, and withCredentials flag.
            var /** @type {?} */ xhr = _this.xhrFactory.build();
            xhr.open(req.method, req.urlWithParams);
            if (!!req.withCredentials) {
                xhr.withCredentials = true;
            }
            // Add all the requested headers.
            req.headers.forEach(function (name, values) { return xhr.setRequestHeader(name, values.join(',')); });
            // Add an Accept header if one isn't present already.
            if (!req.headers.has('Accept')) {
                xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
            }
            // Auto-detect the Content-Type header if one isn't present already.
            if (!req.headers.has('Content-Type')) {
                var /** @type {?} */ detectedType = req.detectContentTypeHeader();
                // Sometimes Content-Type detection fails.
                if (detectedType !== null) {
                    xhr.setRequestHeader('Content-Type', detectedType);
                }
            }
            // Set the responseType if one was requested.
            if (req.responseType) {
                var /** @type {?} */ responseType = req.responseType.toLowerCase();
                // JSON responses need to be processed as text. This is because if the server
                // returns an XSSI-prefixed JSON response, the browser will fail to parse it,
                // xhr.response will be null, and xhr.responseText cannot be accessed to
                // retrieve the prefixed JSON data in order to strip the prefix. Thus, all JSON
                // is parsed by first requesting text and then applying JSON.parse.
                xhr.responseType = /** @type {?} */ (((responseType !== 'json') ? responseType : 'text'));
            }
            // Serialize the request body if one is present. If not, this will be set to null.
            var /** @type {?} */ reqBody = req.serializeBody();
            // If progress events are enabled, response headers will be delivered
            // in two events - the HttpHeaderResponse event and the full HttpResponse
            // event. However, since response headers don't change in between these
            // two events, it doesn't make sense to parse them twice. So headerResponse
            // caches the data extracted from the response whenever it's first parsed,
            // to ensure parsing isn't duplicated.
            var /** @type {?} */ headerResponse = null;
            // partialFromXhr extracts the HttpHeaderResponse from the current XMLHttpRequest
            // state, and memoizes it into headerResponse.
            var /** @type {?} */ partialFromXhr = function () {
                if (headerResponse !== null) {
                    return headerResponse;
                }
                // Read status and normalize an IE9 bug (http://bugs.jquery.com/ticket/1450).
                var /** @type {?} */ status = xhr.status === 1223 ? 204 : xhr.status;
                var /** @type {?} */ statusText = xhr.statusText || 'OK';
                // Parse headers from XMLHttpRequest - this step is lazy.
                var /** @type {?} */ headers = new HttpHeaders(xhr.getAllResponseHeaders());
                // Read the response URL from the XMLHttpResponse instance and fall back on the
                // request URL.
                var /** @type {?} */ url = getResponseUrl(xhr) || req.url;
                // Construct the HttpHeaderResponse and memoize it.
                headerResponse = new HttpHeaderResponse({ headers: headers, status: status, statusText: statusText, url: url });
                return headerResponse;
            };
            // Next, a few closures are defined for the various events which XMLHttpRequest can
            // emit. This allows them to be unregistered as event listeners later.
            // First up is the load event, which represents a response being fully available.
            var /** @type {?} */ onLoad = function () {
                // Read response state from the memoized partial data.
                var _a = partialFromXhr(), headers = _a.headers, status = _a.status, statusText = _a.statusText, url = _a.url;
                // The body will be read out if present.
                var /** @type {?} */ body = null;
                if (status !== 204) {
                    // Use XMLHttpRequest.response if set, responseText otherwise.
                    body = (typeof xhr.response === 'undefined') ? xhr.responseText : xhr.response;
                }
                // Normalize another potential bug (this one comes from CORS).
                if (status === 0) {
                    status = !!body ? 200 : 0;
                }
                // ok determines whether the response will be transmitted on the event or
                // error channel. Unsuccessful status codes (not 2xx) will always be errors,
                // but a successful status code can still result in an error if the user
                // asked for JSON data and the body cannot be parsed as such.
                var /** @type {?} */ ok = status >= 200 && status < 300;
                // Check whether the body needs to be parsed as JSON (in many cases the browser
                // will have done that already).
                if (req.responseType === 'json' && typeof body === 'string') {
                    // Save the original body, before attempting XSSI prefix stripping.
                    var /** @type {?} */ originalBody = body;
                    body = body.replace(XSSI_PREFIX, '');
                    try {
                        // Attempt the parse. If it fails, a parse error should be delivered to the user.
                        body = body !== '' ? JSON.parse(body) : null;
                    }
                    catch (/** @type {?} */ error) {
                        // Since the JSON.parse failed, it's reasonable to assume this might not have been a
                        // JSON response. Restore the original body (including any XSSI prefix) to deliver
                        // a better error response.
                        body = originalBody;
                        // If this was an error request to begin with, leave it as a string, it probably
                        // just isn't JSON. Otherwise, deliver the parsing error to the user.
                        if (ok) {
                            // Even though the response status was 2xx, this is still an error.
                            ok = false;
                            // The parse error contains the text of the body that failed to parse.
                            body = /** @type {?} */ ({ error: error, text: body });
                        }
                    }
                }
                if (ok) {
                    // A successful response is delivered on the event stream.
                    observer.next(new HttpResponse({
                        body: body,
                        headers: headers,
                        status: status,
                        statusText: statusText,
                        url: url || undefined,
                    }));
                    // The full body has been received and delivered, no further events
                    // are possible. This request is complete.
                    observer.complete();
                }
                else {
                    // An unsuccessful request is delivered on the error channel.
                    observer.error(new HttpErrorResponse({
                        // The error in this case is the response body (error from the server).
                        error: body,
                        headers: headers,
                        status: status,
                        statusText: statusText,
                        url: url || undefined,
                    }));
                }
            };
            // The onError callback is called when something goes wrong at the network level.
            // Connection timeout, DNS error, offline, etc. These are actual errors, and are
            // transmitted on the error channel.
            var /** @type {?} */ onError = function (error) {
                var /** @type {?} */ res = new HttpErrorResponse({
                    error: error,
                    status: xhr.status || 0,
                    statusText: xhr.statusText || 'Unknown Error',
                });
                observer.error(res);
            };
            // The sentHeaders flag tracks whether the HttpResponseHeaders event
            // has been sent on the stream. This is necessary to track if progress
            // is enabled since the event will be sent on only the first download
            // progerss event.
            var /** @type {?} */ sentHeaders = false;
            // The download progress event handler, which is only registered if
            // progress events are enabled.
            var /** @type {?} */ onDownProgress = function (event) {
                // Send the HttpResponseHeaders event if it hasn't been sent already.
                if (!sentHeaders) {
                    observer.next(partialFromXhr());
                    sentHeaders = true;
                }
                // Start building the download progress event to deliver on the response
                // event stream.
                var /** @type {?} */ progressEvent = {
                    type: HttpEventType.DownloadProgress,
                    loaded: event.loaded,
                };
                // Set the total number of bytes in the event if it's available.
                if (event.lengthComputable) {
                    progressEvent.total = event.total;
                }
                // If the request was for text content and a partial response is
                // available on XMLHttpRequest, include it in the progress event
                // to allow for streaming reads.
                if (req.responseType === 'text' && !!xhr.responseText) {
                    progressEvent.partialText = xhr.responseText;
                }
                // Finally, fire the event.
                observer.next(progressEvent);
            };
            // The upload progress event handler, which is only registered if
            // progress events are enabled.
            var /** @type {?} */ onUpProgress = function (event) {
                // Upload progress events are simpler. Begin building the progress
                // event.
                var /** @type {?} */ progress = {
                    type: HttpEventType.UploadProgress,
                    loaded: event.loaded,
                };
                // If the total number of bytes being uploaded is available, include
                // it.
                if (event.lengthComputable) {
                    progress.total = event.total;
                }
                // Send the event.
                observer.next(progress);
            };
            // By default, register for load and error events.
            xhr.addEventListener('load', onLoad);
            xhr.addEventListener('error', onError);
            // Progress events are only enabled if requested.
            if (req.reportProgress) {
                // Download progress is always enabled if requested.
                xhr.addEventListener('progress', onDownProgress);
                // Upload progress depends on whether there is a body to upload.
                if (reqBody !== null && xhr.upload) {
                    xhr.upload.addEventListener('progress', onUpProgress);
                }
            }
            // Fire the request, and notify the event stream that it was fired.
            xhr.send(reqBody);
            observer.next({ type: HttpEventType.Sent });
            // This is the return from the Observable function, which is the
            // request cancellation handler.
            return function () {
                // On a cancellation, remove all registered event listeners.
                xhr.removeEventListener('error', onError);
                xhr.removeEventListener('load', onLoad);
                if (req.reportProgress) {
                    xhr.removeEventListener('progress', onDownProgress);
                    if (reqBody !== null && xhr.upload) {
                        xhr.upload.removeEventListener('progress', onUpProgress);
                    }
                }
                // Finally, abort the in-flight request.
                xhr.abort();
            };
        });
    };
    HttpXhrBackend.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HttpXhrBackend.ctorParameters = function () { return [
        { type: XhrFactory, },
    ]; };
    return HttpXhrBackend;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var XSRF_COOKIE_NAME = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('XSRF_COOKIE_NAME');
var XSRF_HEADER_NAME = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('XSRF_HEADER_NAME');
/**
 * Retrieves the current XSRF token to use with the next outgoing request.
 *
 * \@stable
 * @abstract
 */
var HttpXsrfTokenExtractor = /** @class */ (function () {
    function HttpXsrfTokenExtractor() {
    }
    return HttpXsrfTokenExtractor;
}());
/**
 * `HttpXsrfTokenExtractor` which retrieves the token from a cookie.
 */
var HttpXsrfCookieExtractor = /** @class */ (function () {
    function HttpXsrfCookieExtractor(doc, platform, cookieName) {
        this.doc = doc;
        this.platform = platform;
        this.cookieName = cookieName;
        this.lastCookieString = '';
        this.lastToken = null;
        /**
         * \@internal for testing
         */
        this.parseCount = 0;
    }
    /**
     * @return {?}
     */
    HttpXsrfCookieExtractor.prototype.getToken = /**
     * @return {?}
     */
    function () {
        if (this.platform === 'server') {
            return null;
        }
        var /** @type {?} */ cookieString = this.doc.cookie || '';
        if (cookieString !== this.lastCookieString) {
            this.parseCount++;
            this.lastToken = Object(__WEBPACK_IMPORTED_MODULE_6__angular_common__["ɵparseCookieValue"])(cookieString, this.cookieName);
            this.lastCookieString = cookieString;
        }
        return this.lastToken;
    };
    HttpXsrfCookieExtractor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HttpXsrfCookieExtractor.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_6__angular_common__["DOCUMENT"],] },] },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["PLATFORM_ID"],] },] },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [XSRF_COOKIE_NAME,] },] },
    ]; };
    return HttpXsrfCookieExtractor;
}());
/**
 * `HttpInterceptor` which adds an XSRF token to eligible outgoing requests.
 */
var HttpXsrfInterceptor = /** @class */ (function () {
    function HttpXsrfInterceptor(tokenService, headerName) {
        this.tokenService = tokenService;
        this.headerName = headerName;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    HttpXsrfInterceptor.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        var /** @type {?} */ lcUrl = req.url.toLowerCase();
        // Skip both non-mutating requests and absolute URLs.
        // Non-mutating requests don't require a token, and absolute URLs require special handling
        // anyway as the cookie set
        // on our origin is not the same as the token expected by another origin.
        if (req.method === 'GET' || req.method === 'HEAD' || lcUrl.startsWith('http://') ||
            lcUrl.startsWith('https://')) {
            return next.handle(req);
        }
        var /** @type {?} */ token = this.tokenService.getToken();
        // Be careful not to overwrite an existing header of the same name.
        if (token !== null && !req.headers.has(this.headerName)) {
            req = req.clone({ headers: req.headers.set(this.headerName, token) });
        }
        return next.handle(req);
    };
    HttpXsrfInterceptor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HttpXsrfInterceptor.ctorParameters = function () { return [
        { type: HttpXsrfTokenExtractor, },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [XSRF_HEADER_NAME,] },] },
    ]; };
    return HttpXsrfInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An `HttpHandler` that applies a bunch of `HttpInterceptor`s
 * to a request before passing it to the given `HttpBackend`.
 *
 * The interceptors are loaded lazily from the injector, to allow
 * interceptors to themselves inject classes depending indirectly
 * on `HttpInterceptingHandler` itself.
 */
var HttpInterceptingHandler = /** @class */ (function () {
    function HttpInterceptingHandler(backend, injector) {
        this.backend = backend;
        this.injector = injector;
        this.chain = null;
    }
    /**
     * @param {?} req
     * @return {?}
     */
    HttpInterceptingHandler.prototype.handle = /**
     * @param {?} req
     * @return {?}
     */
    function (req) {
        if (this.chain === null) {
            var /** @type {?} */ interceptors = this.injector.get(HTTP_INTERCEPTORS, []);
            this.chain = interceptors.reduceRight(function (next, interceptor) { return new HttpInterceptorHandler(next, interceptor); }, this.backend);
        }
        return this.chain.handle(req);
    };
    HttpInterceptingHandler.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    HttpInterceptingHandler.ctorParameters = function () { return [
        { type: HttpBackend, },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
    ]; };
    return HttpInterceptingHandler;
}());
/**
 * Constructs an `HttpHandler` that applies a bunch of `HttpInterceptor`s
 * to a request before passing it to the given `HttpBackend`.
 *
 * Meant to be used as a factory function within `HttpClientModule`.
 *
 * \@stable
 * @param {?} backend
 * @param {?=} interceptors
 * @return {?}
 */
function interceptingHandler(backend, interceptors) {
    if (interceptors === void 0) { interceptors = []; }
    if (!interceptors) {
        return backend;
    }
    return interceptors.reduceRight(function (next, interceptor) { return new HttpInterceptorHandler(next, interceptor); }, backend);
}
/**
 * Factory function that determines where to store JSONP callbacks.
 *
 * Ordinarily JSONP callbacks are stored on the `window` object, but this may not exist
 * in test environments. In that case, callbacks are stored on an anonymous object instead.
 *
 * \@stable
 * @return {?}
 */
function jsonpCallbackContext() {
    if (typeof window === 'object') {
        return window;
    }
    return {};
}
/**
 * `NgModule` which adds XSRF protection support to outgoing requests.
 *
 * Provided the server supports a cookie-based XSRF protection system, this
 * module can be used directly to configure XSRF protection with the correct
 * cookie and header names.
 *
 * If no such names are provided, the default is to use `X-XSRF-TOKEN` for
 * the header name and `XSRF-TOKEN` for the cookie name.
 *
 * \@stable
 */
var HttpClientXsrfModule = /** @class */ (function () {
    function HttpClientXsrfModule() {
    }
    /**
     * Disable the default XSRF protection.
     */
    /**
     * Disable the default XSRF protection.
     * @return {?}
     */
    HttpClientXsrfModule.disable = /**
     * Disable the default XSRF protection.
     * @return {?}
     */
    function () {
        return {
            ngModule: HttpClientXsrfModule,
            providers: [
                { provide: HttpXsrfInterceptor, useClass: NoopInterceptor },
            ],
        };
    };
    /**
     * Configure XSRF protection to use the given cookie name or header name,
     * or the default names (as described above) if not provided.
     */
    /**
     * Configure XSRF protection to use the given cookie name or header name,
     * or the default names (as described above) if not provided.
     * @param {?=} options
     * @return {?}
     */
    HttpClientXsrfModule.withOptions = /**
     * Configure XSRF protection to use the given cookie name or header name,
     * or the default names (as described above) if not provided.
     * @param {?=} options
     * @return {?}
     */
    function (options) {
        if (options === void 0) { options = {}; }
        return {
            ngModule: HttpClientXsrfModule,
            providers: [
                options.cookieName ? { provide: XSRF_COOKIE_NAME, useValue: options.cookieName } : [],
                options.headerName ? { provide: XSRF_HEADER_NAME, useValue: options.headerName } : [],
            ],
        };
    };
    HttpClientXsrfModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    providers: [
                        HttpXsrfInterceptor,
                        { provide: HTTP_INTERCEPTORS, useExisting: HttpXsrfInterceptor, multi: true },
                        { provide: HttpXsrfTokenExtractor, useClass: HttpXsrfCookieExtractor },
                        { provide: XSRF_COOKIE_NAME, useValue: 'XSRF-TOKEN' },
                        { provide: XSRF_HEADER_NAME, useValue: 'X-XSRF-TOKEN' },
                    ],
                },] },
    ];
    /** @nocollapse */
    HttpClientXsrfModule.ctorParameters = function () { return []; };
    return HttpClientXsrfModule;
}());
/**
 * `NgModule` which provides the `HttpClient` and associated services.
 *
 * Interceptors can be added to the chain behind `HttpClient` by binding them
 * to the multiprovider for `HTTP_INTERCEPTORS`.
 *
 * \@stable
 */
var HttpClientModule = /** @class */ (function () {
    function HttpClientModule() {
    }
    HttpClientModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    imports: [
                        HttpClientXsrfModule.withOptions({
                            cookieName: 'XSRF-TOKEN',
                            headerName: 'X-XSRF-TOKEN',
                        }),
                    ],
                    providers: [
                        HttpClient,
                        { provide: HttpHandler, useClass: HttpInterceptingHandler },
                        HttpXhrBackend,
                        { provide: HttpBackend, useExisting: HttpXhrBackend },
                        BrowserXhr,
                        { provide: XhrFactory, useExisting: BrowserXhr },
                    ],
                },] },
    ];
    /** @nocollapse */
    HttpClientModule.ctorParameters = function () { return []; };
    return HttpClientModule;
}());
/**
 * `NgModule` which enables JSONP support in `HttpClient`.
 *
 * Without this module, Jsonp requests will reach the backend
 * with method JSONP, where they'll be rejected.
 *
 * \@stable
 */
var HttpClientJsonpModule = /** @class */ (function () {
    function HttpClientJsonpModule() {
    }
    HttpClientJsonpModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    providers: [
                        JsonpClientBackend,
                        { provide: JsonpCallbackContext, useFactory: jsonpCallbackContext },
                        { provide: HTTP_INTERCEPTORS, useClass: JsonpInterceptor, multi: true },
                    ],
                },] },
    ];
    /** @nocollapse */
    HttpClientJsonpModule.ctorParameters = function () { return []; };
    return HttpClientJsonpModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */


//# sourceMappingURL=http.js.map


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives__ = __webpack_require__(542);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AgmMap", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AgmCircle", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AgmInfoWindow", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AgmKmlLayer", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AgmDataLayer", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AgmMarker", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AgmPolygon", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AgmPolyline", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AgmPolylinePoint", function() { return __WEBPACK_IMPORTED_MODULE_0__directives__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(543);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "GoogleMapsAPIWrapper", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CircleManager", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "InfoWindowManager", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MarkerManager", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PolygonManager", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PolylineManager", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "KmlLayerManager", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DataLayerManager", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "GoogleMapsScriptProtocol", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "LAZY_MAPS_API_CONFIG", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "LazyMapsAPILoader", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MapsAPILoader", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "NoOpMapsAPILoader", function() { return __WEBPACK_IMPORTED_MODULE_1__services__["k"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_module__ = __webpack_require__(545);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AgmCoreModule", function() { return __WEBPACK_IMPORTED_MODULE_2__core_module__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_map__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__directives_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_circle__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__directives_circle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_info_window__ = __webpack_require__(91);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__directives_info_window__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_kml_layer__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__directives_kml_layer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_data_layer__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__directives_data_layer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_marker__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__directives_marker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_polygon__ = __webpack_require__(216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__directives_polygon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_polyline__ = __webpack_require__(217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__directives_polyline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_polyline_point__ = __webpack_require__(92);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__directives_polyline_point__["a"]; });









//# sourceMappingURL=directives.js.map

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_google_maps_api_wrapper__ = __webpack_require__(22);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__services_google_maps_api_wrapper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_managers_circle_manager__ = __webpack_require__(85);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__services_managers_circle_manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_managers_info_window_manager__ = __webpack_require__(86);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__services_managers_info_window_manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_managers_marker_manager__ = __webpack_require__(59);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__services_managers_marker_manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_managers_polygon_manager__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_4__services_managers_polygon_manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_managers_polyline_manager__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__services_managers_polyline_manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_managers_kml_layer_manager__ = __webpack_require__(89);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__services_managers_kml_layer_manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_managers_data_layer_manager__ = __webpack_require__(90);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__services_managers_data_layer_manager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_maps_api_loader_lazy_maps_api_loader__ = __webpack_require__(93);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__services_maps_api_loader_lazy_maps_api_loader__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__services_maps_api_loader_lazy_maps_api_loader__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__services_maps_api_loader_lazy_maps_api_loader__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_maps_api_loader_maps_api_loader__ = __webpack_require__(58);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__services_maps_api_loader_maps_api_loader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_maps_api_loader_noop_maps_api_loader__ = __webpack_require__(544);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__services_maps_api_loader_noop_maps_api_loader__["a"]; });











//# sourceMappingURL=services.js.map

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoOpMapsAPILoader; });
/**
 * When using the NoOpMapsAPILoader, the Google Maps API must be added to the page via a `<script>`
 * Tag.
 * It's important that the Google Maps API script gets loaded first on the page.
 */
var /**
 * When using the NoOpMapsAPILoader, the Google Maps API must be added to the page via a `<script>`
 * Tag.
 * It's important that the Google Maps API script gets loaded first on the page.
 */
NoOpMapsAPILoader = /** @class */ (function () {
    function NoOpMapsAPILoader() {
    }
    NoOpMapsAPILoader.prototype.load = function () {
        if (!window.google || !window.google.maps) {
            throw new Error('Google Maps API not loaded on page. Make sure window.google.maps is available!');
        }
        return Promise.resolve();
    };
    return NoOpMapsAPILoader;
}());
/**
 * When using the NoOpMapsAPILoader, the Google Maps API must be added to the page via a `<script>`
 * Tag.
 * It's important that the Google Maps API script gets loaded first on the page.
 */

//# sourceMappingURL=noop-maps-api-loader.js.map

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export coreDirectives */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgmCoreModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_map__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_circle__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_info_window__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_marker__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_polygon__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_polyline__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_polyline_point__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_kml_layer__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_data_layer__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_maps_api_loader_lazy_maps_api_loader__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_maps_api_loader_maps_api_loader__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_browser_globals__ = __webpack_require__(218);














/**
 * @internal
 */
function coreDirectives() {
    return [
        __WEBPACK_IMPORTED_MODULE_1__directives_map__["a" /* AgmMap */], __WEBPACK_IMPORTED_MODULE_4__directives_marker__["a" /* AgmMarker */], __WEBPACK_IMPORTED_MODULE_3__directives_info_window__["a" /* AgmInfoWindow */], __WEBPACK_IMPORTED_MODULE_2__directives_circle__["a" /* AgmCircle */],
        __WEBPACK_IMPORTED_MODULE_5__directives_polygon__["a" /* AgmPolygon */], __WEBPACK_IMPORTED_MODULE_6__directives_polyline__["a" /* AgmPolyline */], __WEBPACK_IMPORTED_MODULE_7__directives_polyline_point__["a" /* AgmPolylinePoint */], __WEBPACK_IMPORTED_MODULE_8__directives_kml_layer__["a" /* AgmKmlLayer */],
        __WEBPACK_IMPORTED_MODULE_9__directives_data_layer__["a" /* AgmDataLayer */]
    ];
}
/**
 * The angular-google-maps core module. Contains all Directives/Services/Pipes
 * of the core module. Please use `AgmCoreModule.forRoot()` in your app module.
 */
var AgmCoreModule = /** @class */ (function () {
    function AgmCoreModule() {
    }
    /**
     * Please use this method when you register the module at the root level.
     */
    /**
       * Please use this method when you register the module at the root level.
       */
    AgmCoreModule.forRoot = /**
       * Please use this method when you register the module at the root level.
       */
    function (lazyMapsAPILoaderConfig) {
        return {
            ngModule: AgmCoreModule,
            providers: __WEBPACK_IMPORTED_MODULE_12__utils_browser_globals__["a" /* BROWSER_GLOBALS_PROVIDERS */].concat([
                { provide: __WEBPACK_IMPORTED_MODULE_11__services_maps_api_loader_maps_api_loader__["a" /* MapsAPILoader */], useClass: __WEBPACK_IMPORTED_MODULE_10__services_maps_api_loader_lazy_maps_api_loader__["c" /* LazyMapsAPILoader */] },
                { provide: __WEBPACK_IMPORTED_MODULE_10__services_maps_api_loader_lazy_maps_api_loader__["b" /* LAZY_MAPS_API_CONFIG */], useValue: lazyMapsAPILoaderConfig }
            ]),
        };
    };
    AgmCoreModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{ declarations: coreDirectives(), exports: coreDirectives() },] },
    ];
    return AgmCoreModule;
}());

//# sourceMappingURL=core.module.js.map

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(17);
var ng2_sticky_1 = __webpack_require__(219);
__export(__webpack_require__(219));
exports.default = {
    directives: [ng2_sticky_1.StickyComponent]
};
var StickyModule = (function () {
    function StickyModule() {
    }
    StickyModule = __decorate([
        core_1.NgModule({
            imports: [common_1.CommonModule],
            declarations: [ng2_sticky_1.StickyComponent],
            exports: [ng2_sticky_1.StickyComponent]
        })
    ], StickyModule);
    return StickyModule;
}());
exports.StickyModule = StickyModule;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
__webpack_require__(562);
var AppComponent = (function () {
    function AppComponent(log, app, api, cache, auth, user, billing, route, router) {
        //this.checkCache();
        var _this = this;
        this.log = log;
        this.app = app;
        this.api = api;
        this.cache = cache;
        this.auth = auth;
        this.user = user;
        this.billing = billing;
        this.route = route;
        this.router = router;
        this.url = 'linescape.com';
        this.versionNumber = '1.2';
        this.api.getApiClient().then(function (client) {
            _this.user.init();
        });
    }
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (window.location.pathname + window.location.search === '/') {
            this.app.searchType = 'schedule';
        }
        this.router.events.subscribe(function (event) {
            if (event instanceof router_1.NavigationEnd) {
                _this.router.url == '/' ? _this.app.openSearch('schedule') : _this.app.closeSearch();
            }
        });
    };
    AppComponent.prototype.checkCache = function () {
        var version = localStorage.getItem('version');
        // check the length because a cognito id is saved on your first visit
        if (version !== this.versionNumber && localStorage.length > 1) {
            console.log('CLEARING CACHE', localStorage);
            localStorage.clear();
            localStorage.setItem('version', this.versionNumber);
        }
    };
    AppComponent.prototype.toggleMenu = function () {
        this.app.toggleMenu();
    };
    AppComponent.prototype.toggleSearch = function () {
        this.app.searchType ? this.app.closeSearch() : this.app.openSearch('schedule');
    };
    AppComponent.prototype.toggle = function (type) {
        this.app.toggleSearch(type);
    };
    AppComponent.prototype.scrollTop = function () {
        var scrollToTop = window.setInterval(function () {
            var pos = window.pageYOffset;
            if (pos > 0) {
                window.scrollTo(0, pos - 20);
            }
            else {
                window.clearInterval(scrollToTop);
            }
        }, 4);
    };
    AppComponent.prototype.logout = function () {
        this.app.closeSearch();
        sessionStorage.setItem('need-update-search-setting', 'true');
        this.api.signOut();
        //this.app.openSearch('schedule');
    };
    AppComponent = __decorate([
        core_1.Component({
            selector: 'linescape-app',
            providers: [shared_1.LogService, shared_1.AppContext, shared_1.ApiService, shared_1.CacheService, shared_1.AuthService, shared_1.UserService, shared_1.FavoriteService, shared_1.BillingService],
            template: __webpack_require__(563),
            styles: [__webpack_require__(564)],
        }),
        __metadata("design:paramtypes", [shared_1.LogService, shared_1.AppContext, shared_1.ApiService, shared_1.CacheService,
            shared_1.AuthService, shared_1.UserService, shared_1.BillingService,
            router_1.ActivatedRoute, router_1.Router])
    ], AppComponent);
    return AppComponent;
}());
exports.AppComponent = AppComponent;
// https://github.com/angular/angular/pull/10595/commits/f54f9efc0e70eb1c71ac8eb6a8ed690f1e7f09f9 


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Card = (function () {
    function Card() {
    }
    return Card;
}());
exports.Card = Card;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Register = (function () {
    function Register(email, confirmEmail, password, confirmPassword, firstName, lastName, token, coupon, planId) {
        if (email === void 0) { email = ''; }
        if (confirmEmail === void 0) { confirmEmail = ''; }
        if (password === void 0) { password = ''; }
        if (confirmPassword === void 0) { confirmPassword = ''; }
        if (firstName === void 0) { firstName = ''; }
        if (lastName === void 0) { lastName = ''; }
        if (token === void 0) { token = ''; }
        if (coupon === void 0) { coupon = ''; }
        if (planId === void 0) { planId = ''; }
        this.email = email;
        this.confirmEmail = confirmEmail;
        this.password = password;
        this.confirmPassword = confirmPassword;
        this.firstName = firstName;
        this.lastName = lastName;
        this.token = token;
        this.coupon = coupon;
        this.planId = planId;
    }
    return Register;
}());
exports.Register = Register;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Confirm = (function () {
    function Confirm(email, code) {
        if (email === void 0) { email = ''; }
        if (code === void 0) { code = ''; }
        this.email = email;
        this.code = code;
    }
    return Confirm;
}());
exports.Confirm = Confirm;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PersonalInformation = (function () {
    function PersonalInformation(json) {
        this.firstName = json.firstName || '';
        this.lastName = json.lastName || '';
        this.business = json.business || '';
        this.company = json.company || '';
        this.position = json.position || '';
        this.country = json.country || '';
        this.city = json.city || '';
        this.subscribe = json.subscribe || false;
    }
    return PersonalInformation;
}());
exports.PersonalInformation = PersonalInformation;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Plan = (function () {
    function Plan(json) {
        // data saved in dynamo
        this.amount = json.amount || 0;
        this.id = json.id || '';
        this.interval = json.interval || 0;
        this.name = json.name || '';
        this.trialPeriodDays = json.trial_period_days || 0;
        // data from stripe
        try {
            this.created = new Date(json.created);
            this.currency = json.currency;
            this.intervalCount = json.interval_count;
            this.livemode = json.livemode;
            this.metadata = json.metadata;
            this.statementDescriptor = json.statement_descriptor;
        }
        catch (ex) {
            this.created = null;
            this.currency = '';
            this.intervalCount = 0;
            this.livemode = false;
            this.metadata = {};
            this.statementDescriptor = '';
        }
    }
    return Plan;
}());
exports.Plan = Plan;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Coupon = (function () {
    function Coupon(json) {
        try {
            this.id = json.id;
            // this.amountOff = json.amount_off;
            // this.created = new Date(json.created);
            this.percentOff = json.percent_off;
            this.valid = json.valid;
        }
        catch (ex) {
            this.id = '';
            this.percentOff = 0;
            this.valid = false;
        }
    }
    return Coupon;
}());
exports.Coupon = Coupon;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Carrier = (function () {
    function Carrier(json, accountType) {
        if (accountType === void 0) { accountType = ''; }
        try {
            this.id = json.id || 0;
            this.imo = json.imo || '';
            this.name = json.name || '';
            this.description = json.description || '';
            this.userData = json.userData || {
                favorited: false,
                note: ''
            };
            this.iconUrl = '../img/carriers/' + this.id + '.gif';
        }
        catch (ex) {
            this.setDefaults();
        }
        this.setSummaryDefaults();
        this.setProfile(json, accountType);
        this.setHeadquarters(json, accountType);
        //Title Case for Category ("kind")
        if (this.kind === "deepsea") {
            this.kind = "Deep Sea";
        }
        if (this.kind === "shortsea") {
            this.kind = "Short Sea";
        }
        if (this.kind === "feeder") {
            this.kind = "Feeder";
        }
        if (this.kind === "roro") {
            this.kind = "Ro-Ro";
        }
        if (this.kind === "nvocc") {
            this.kind = "NVOCC";
        }
        if (this.kind === "unknown") {
            this.kind = "Unknown";
        }
    }
    Carrier.prototype.setDefaults = function () {
        this.id = 0;
        this.imo = '';
        this.name = '';
        this.description = '';
        this.userData = {
            favorited: false,
            note: ''
        };
        this.iconUrl = '../img/carriers/0.gif';
    };
    Carrier.prototype.setSummary = function (json, isSelected) {
        try {
            this.viewDetails = false;
            this.selected = isSelected;
            this.count = json.count;
            this.minDuration = json.min_duration;
            this.minTranshipments = json.min_duration_ts_count;
            this.minDurationTranshipments = json.min_duration_ts_count == 0 ? 'direct' : (json.min_duration_ts_count).toString() + ' t/s';
            this.maxDuration = json.max_duration;
            this.reliability = 'blurred text';
        }
        catch (ex) {
            this.setSummaryDefaults();
        }
    };
    Carrier.prototype.setSummaryDefaults = function () {
        this.viewDetails = false;
        this.selected = true;
        this.count = 0;
        this.minDuration = 0;
        this.maxDuration = 0;
        this.reliability = 'blurred text';
    };
    Carrier.prototype.setProfile = function (json, accountType) {
        var show = true;
        try {
            this.established = json.established;
            this.year_est = json.year_est;
            this.carrier_group = json.carrier_group;
            this.max_ships = json.max_ships + ' ships';
            this.max_teu = json.max_teu + ' TEU';
            this.kind = json.kind;
            this.regions = json.regions;
            this.scac = json.scac;
            this.smdg = json.smdg;
            this.bic = json.bic;
            this.notice = json.notice;
        }
        catch (ex) {
            this.setProfileDefaults();
        }
    };
    Carrier.prototype.setProfileDefaults = function () {
        this.established = '';
        this.year_est = '';
        this.carrier_group = '';
        this.max_ships = '';
        this.max_teu = '';
        this.kind = '';
        this.regions = '';
        this.scac = '';
        this.smdg = '';
        this.bic = '';
        this.notice = '';
    };
    Carrier.prototype.setHeadquarters = function (json, accountType) {
        var show = true;
        try {
            this.company = json.company;
            this.address = json.address;
            this.city = json.city;
            if (json.country !== undefined) {
                this.countryId = json.country.id;
                this.countryName = json.country.name;
            }
            else {
                this.countryId = '';
                this.countryName = '';
            }
            this.postcode = json.postcode;
            this.website = json.website;
            this.email = json.email;
        }
        catch (ex) {
            this.setHeadquartersDefaults();
        }
    };
    Carrier.prototype.setHeadquartersDefaults = function () {
        this.company = '';
        this.address = '';
        this.city = '';
        this.countryId = '';
        this.countryName = '';
        this.postcode = '';
        this.website = '';
        this.email = '';
    };
    Carrier.prototype.setTrips = function (trips) {
        this.trips = trips;
    };
    return Carrier;
}());
exports.Carrier = Carrier;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Port = (function () {
    function Port(json) {
        this.id = json.id || 0;
        this.code = json.code || '';
        this.name = json.name || '';
        this.setRegion(json);
        this.setCountry(json);
        this.setCoordinates(json);
        this.userData = json.userData || {
            favorited: false,
            note: ''
        };
        this.iconUrl = '../img/port-selected.png';
        this.latlong = json.latlong || [null, null];
        this.setLocation();
        this.setDisplay();
        this.setTitle();
    }
    Port.prototype.setRegion = function (json) {
        try {
            this.regionId = json.region.id || 0;
            this.regionName = json.region.name || '';
        }
        catch (ex) {
            this.regionId = 0;
            this.regionName = '';
        }
    };
    Port.prototype.setCountry = function (json) {
        try {
            this.countryId = json.country.id || 0;
            this.countryName = json.country.name || '';
        }
        catch (ex) {
            this.countryId = 0;
            this.countryName = '';
        }
    };
    Port.prototype.setCoordinates = function (json) {
        try {
            this.latitude = json.latlong[0] || null;
            this.longitude = json.latlong[1] || null;
            this.coordinates = this.latitude.toFixed(4) + ", " + this.longitude.toFixed(4);
        }
        catch (ex) {
            this.latitude = null;
            this.longitude = null;
            this.coordinates = '0.0000, 0.0000';
        }
    };
    Port.prototype.setLocation = function () {
        if (this.regionName === '' || this.regionId === 0) {
            this.location = this.countryName;
        }
        else if (this.regionName !== '' && this.countryName === '') {
            this.location = this.regionName;
        }
        else {
            this.location = '';
        }
    };
    Port.prototype.setDisplay = function () {
        if (this.name === 'blurred text' && this.id === 0) {
            this.display = 'blurred text';
        }
        else if (this.regionName !== '' && this.countryName !== '') {
            this.display = this.name + ' [' + this.code + '], ' + this.regionName + ', ' + this.countryName;
        }
        else if (this.regionName === '' && this.countryName !== null) {
            this.display = this.name + ' [' + this.code + '], ' + this.countryName;
        }
        else {
            this.display = this.name + ' [' + this.code + ']';
        }
    };
    Port.prototype.setTitle = function () {
        if (this.name === 'blurred text' && this.id === 0) {
            this.title = 'blurred text';
        }
        else {
            this.title = this.name + ' [' + this.code + ']';
        }
    };
    return Port;
}());
exports.Port = Port;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Route = (function () {
    function Route(json) {
        try {
            this.id = json.id;
            this.code = json.code;
            this.name = json.name;
        }
        catch (ex) {
            this.id = 0;
            this.code = '';
            this.name = '';
        }
    }
    return Route;
}());
exports.Route = Route;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(12);
var Vessel = (function () {
    function Vessel(json, accountType) {
        if (accountType === void 0) { accountType = ''; }
        try {
            this.id = json.id || 0;
            this.imo = json.imo || '';
            this.name = json.name || '';
            this.thumbnailUrl = json.thumbnailUrl || '';
            this.userData = json.userData || {
                favorited: false,
                note: ''
            };
        }
        catch (ex) {
            this.setDefaults();
        }
        this.setRegister(json, accountType);
        this.setManagement(json, accountType);
        this.setCapacity(json, accountType);
        this.setConstruction(json, accountType);
        this.setPropulsion(json, accountType);
    }
    Vessel.prototype.setDefaults = function () {
        this.id = 0;
        this.imo = '';
        this.name = '';
        this.thumbnailUrl = '';
        this.userData = {
            favorited: false,
            note: ''
        };
    };
    Vessel.prototype.setRegister = function (json, accountType) {
        var show = true;
        try {
            if (json.country !== undefined) {
                this.countryId = show ? json.country.id : 'blurred text';
                this.countryName = show ? json.country.name : 'blurred text';
            }
            else {
                this.countryId = show ? '' : 'blurred text';
                this.countryName = show ? '' : 'blurred text';
            }
            this.callSign = show ? json.call_sign : 'blurred text';
            this.mmsi = show ? json.mmsi : 'blurred text';
        }
        catch (ex) {
            this.countryId = '';
            this.countryName = '';
            this.callSign = '';
            this.mmsi = '';
        }
    };
    Vessel.prototype.setManagement = function (json, accountType) {
        var show = accountType !== '' && accountType !== 'Basic';
        try {
            this.carrier = new _1.Carrier(json.carrier);
            if (!show) {
                this.carrier.name = 'blurred text';
            }
        }
        catch (ex) {
            this.carrier = new _1.Carrier(null);
        }
        try {
            if (json.owner !== undefined) {
                this.ownerId = show ? json.owner.id : 'blurred text';
                this.ownerName = show ? json.owner.name : 'blurred text';
            }
            else {
                this.ownerId = show ? '' : 'blurred text';
                this.ownerName = show ? '' : 'blurred text';
            }
            this.previousNames = show ? json.previous_names : ['blurred text', 'blurred text', 'blurred text'];
        }
        catch (ex) {
            this.ownerId = '';
            this.ownerName = '';
            this.previousNames = [];
        }
    };
    Vessel.prototype.setCapacity = function (json, accountType) {
        var show = accountType !== '' && accountType !== 'Basic';
        try {
            this.grossTonnage = show ? json.gross_tonnage : 'blurred text';
            this.netTonnage = show ? json.net_tonnage : 'blurred text';
            this.dwt = show ? json.dwt : 'blurred text';
            this.avgTEU = show ? json.avg_teu : 'blurred text';
            this.maxTEU = show ? json.max_teu : 'blurred text';
            this.reeferTEU = show ? json.reefer_teu : 'blurred text';
        }
        catch (ex) {
            this.grossTonnage = '';
            this.netTonnage = '';
            this.dwt = '';
            this.avgTEU = '';
            this.maxTEU = '';
            this.reeferTEU = '';
        }
    };
    Vessel.prototype.setConstruction = function (json, accountType) {
        var show = accountType === 'Professional' || accountType === 'Enterprise';
        try {
            this.shipType = show ? json.ship_type : 'blurred text';
            this.portRegister = show ? json.port_registry : 'blurred text';
            this.yearBuilt = show ? json.year_built : 'blurred text';
            this.shipBuilder = show ? json.ship_builder : 'blurred text';
            this.yardHull = show ? json.yard_hull : 'blurred text';
            this.handlingGear = show ? json.handling_gear : 'blurred text';
            this.length = show ? json.length : 'blurred text';
            this.beam = show ? json.beam : 'blurred text';
            this.draught = show ? json.draught : 'blurred text';
        }
        catch (ex) {
            this.shipType = '';
            this.portRegister = '';
            this.yearBuilt = '';
            this.shipBuilder = '';
            this.yardHull = '';
            this.handlingGear = '';
            this.length = '';
            this.beam = '';
            this.draught = '';
        }
    };
    Vessel.prototype.setPropulsion = function (json, accountType) {
        var show = accountType === 'Professional' || accountType === 'Enterprise';
        try {
            this.engineDesign = show ? json.engine_design : 'blurred text';
            this.engineType = show ? json.engine_type : 'blurred text';
            this.power = show ? json.power + ' KW' : 'blurred text';
            this.speed = show ? json.speed + ' Kn' : 'blurred text';
            this.sfc = show ? json.sfc : 'blurred text';
            this.co2 = show ? json.co2 : 'blurred text';
        }
        catch (ex) {
            this.engineDesign = '';
            this.engineType = '';
            this.power = '';
            this.speed = '';
            this.sfc = '';
            this.co2 = '';
        }
    };
    return Vessel;
}());
exports.Vessel = Vessel;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(12);
var Schedule = (function () {
    function Schedule(json) {
        this.scheduleId = json.schedule_id || 0;
        this.scheduleIndex = json.schedul_index || 0;
        this.voyage = json.voyage || '';
        this.eta = json.eta;
        this.etaTime = this.eta == ' - ' ? '' : (json.eta_time || '');
        this.etd = json.etd;
        this.etdTime = this.etd == ' - ' ? '' : (json.etd_time || '');
        this.carrier = new _1.Carrier(json.carrier);
        this.port = new _1.Port(json.port);
        this.route = new _1.Route(json.route);
        this.vessel = new _1.Vessel(json.vessel);
        this.portLinkParameters = { date: this.eta, scroll: true };
    }
    return Schedule;
}());
exports.Schedule = Schedule;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(12);
var voyage_1 = __webpack_require__(222);
var index_1 = __webpack_require__(2);
var Voyages = (function () {
    function Voyages(json, accountType) {
        if (accountType === void 0) { accountType = ''; }
        this.accountTypeStr = '';
        try {
            var summary = json.data.summary;
            var data = json.data;
            this.searchId = data.searchId;
            this.total = summary.count;
            this.accountTypeStr = accountType;
            this.setItems(data.items, accountType);
            this.setCarriers(summary);
        }
        catch (ex) {
            this.setDefaults();
        }
    }
    Voyages.prototype.setDefaults = function () {
        this.searchId = '';
        this.total = 0;
        this.items = [];
        this.selectedCarriers = [];
        this.excludedCarriers = [];
    };
    Voyages.prototype.setItems = function (items, accountType) {
        var show = this.accountTypeStr !== '' && this.accountTypeStr !== 'Basic';
        this.items = [];
        var voyages = new Array();
        for (var current = 0; current < items.length; current++) {
            try {
                var item = items[current];
                var index = voyages.indexOf(item.schedule_id);
                if (index < 0) {
                    // ****
                    if (item.route === undefined) {
                        item.route = new _1.Route(null);
                    }
                    if (item.route.name === undefined) {
                        item.route.name = 'Undefined route name';
                    }
                    item.route.name = show ? item.route.name : 'blurred text';
                    // ****
                    this.items.push(new voyage_1.Voyage(item));
                    voyages.push(item.schedule_id);
                }
                else {
                    this.items[index].addSchedule(new index_1.Schedule(item));
                }
            }
            catch (ex) {
                // console.log('exception in voyages setItems', ex);
            }
        }
    };
    Voyages.prototype.setCarriers = function (summary) {
        this.carriers = [];
        this.selectedCarriers = summary.selected_carriers;
        this.excludedCarriers = summary.excluded_carriers;
        var available = summary.available_carriers;
        var selected = summary.selected_carriers;
        var excluded = summary.excluded_carriers;
        for (var current = 0; current < available.length; current++) {
            var carrier = new _1.Carrier(available[current].carrier);
            var count = available[current].count;
            var min = available[current].min_duration;
            var max = available[current].max_duration;
            var isSelected = this.isCarrierSelected(carrier.id, selected, excluded);
            this.carriers.push({ count: count, minDuration: min, maxDuration: max, selected: isSelected, carrier: carrier });
        }
    };
    Voyages.prototype.isCarrierSelected = function (carrierId, selected, excluded) {
        if (selected.length === 0 && excluded.length === 0) {
            return true;
        }
        // excluded
        if (excluded.indexOf(carrierId) > -1) {
            return false;
        }
        // selected and not excluded
        if (selected.indexOf(carrierId) > -1) {
            return true;
        }
        // not selected
        if (selected.length !== 0) {
            return false;
        }
        // not excluded
        return true;
    };
    return Voyages;
}());
exports.Voyages = Voyages;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var customer_1 = __webpack_require__(561);
var BillingService = (function () {
    function BillingService(api, logger, app) {
        this.api = api;
        this.logger = logger;
        this.app = app;
    }
    BillingService.prototype.createToken = function (card) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                Stripe.card.createToken(card, function (status, response) {
                    _this.logger.log('billing.service', 'stripeResponse', response);
                    if (status === 200) {
                        resolve(response);
                    }
                    else {
                        reject(response);
                    }
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    BillingService.prototype.checkCoupon = function (coupon) {
        var _this = this;
        return this.api.getApiClient().then(function (client) { return _this.callCheckCoupon(client, coupon); });
    };
    BillingService.prototype.callCheckCoupon = function (apigClient, coupon) {
        var _this = this;
        this.logger.log('billing.service', 'callCheckCoupon', 'before promise');
        return new Promise(function (resolve, reject) {
            var params = {
                coupon: coupon
            };
            var body = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {
                    coupon: coupon
                }
            };
            try {
                apigClient.billingCouponGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('billing.service', 'callCheckCoupon result', result);
                    var model = new shared_1.Coupon(result.data);
                    resolve(model);
                })
                    .catch(function (err) {
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    BillingService.prototype.getPlans = function () {
        var _this = this;
        return this.api.getApiClient().then(function (client) { return _this.callGetPlans(client); });
    };
    BillingService.prototype.callGetPlans = function (apigClient) {
        var _this = this;
        this.logger.log('billing.service', 'callGetPlans', 'before promise');
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.billingPlansGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('billing.service', 'callGetPlans result', result);
                    var planArray = new Array();
                    for (var current = 0; current < result.data.data.length; current++) {
                        var plan = new shared_1.Plan(result.data.data[current]);
                        planArray.push(plan);
                    }
                    resolve(planArray);
                })
                    .catch(function (err) {
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    BillingService.prototype.createCustomer = function (email, token) {
        var _this = this;
        return this.api.getApiClient().then(function (client) { return _this.callCreateCustomer(client, email, token); });
    };
    BillingService.prototype.callCreateCustomer = function (apigClient, email, token) {
        var _this = this;
        this.logger.log('billing.service', 'callCreateCustomer', 'before promise');
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {
                email: email.toLowerCase(),
                source: token
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.billingCustomerPost(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('billing.service', 'callCreateCustomer result', result);
                    _this.clearCustomer();
                    resolve(result.data);
                }).catch(function (err) {
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    BillingService.prototype.updateCustomer = function (token) {
        var _this = this;
        return this.api.getApiClient().then(function (client) { return _this.callUpdateCustomer(client, token); });
    };
    BillingService.prototype.callUpdateCustomer = function (apigClient, token) {
        var _this = this;
        this.logger.log('billing.service', 'callUpdateCustomer', 'before promise');
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {
                source: token
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.billingCustomerPut(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('billing.service', 'callUpdateCustomer result', result);
                    _this.clearCustomer();
                    resolve(result.data);
                }).catch(function (err) {
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    BillingService.prototype.subscribe = function (plan, coupon) {
        var _this = this;
        var body = {
            plan: plan,
            coupon: coupon
        };
        return this.api.getApiClient().then(function (client) { return _this.callSubscribe(client, body); });
    };
    BillingService.prototype.callSubscribe = function (apigClient, body) {
        var _this = this;
        this.logger.log('billing.service', 'callSubscribe', 'before promise');
        return new Promise(function (resolve, reject) {
            var params = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.billingSubscribePost(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('billing.service', 'callSubscribe result', result);
                    if (result.data.errorMessage !== undefined && result.data.errorMessage === '{}') {
                        reject('you must provide your credit card details first');
                    }
                    _this.clearCustomer();
                    resolve(result);
                }).catch(function (err) {
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    BillingService.prototype.cancel = function () {
        var _this = this;
        return this.api.getApiClient().then(function (client) { return _this.callCancel(client); });
    };
    BillingService.prototype.callCancel = function (apigClient) {
        var _this = this;
        this.logger.log('billing.service', 'callCancel', 'before promise');
        return new Promise(function (resolve, reject) {
            var params = {
                '': ''
            };
            var body = {
                '': ''
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.billingSubscribeDelete(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('billing.service', 'callCancel result', result);
                    _this.clearCustomer();
                    resolve(result);
                }).catch(function (err) {
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    BillingService.prototype.getInvoices = function () {
        var _this = this;
        return this.api.getApiClient().then(function (client) { return _this.callGetInvoices(client); });
    };
    BillingService.prototype.callGetInvoices = function (apigClient) {
        var _this = this;
        this.logger.log('billing.service', 'callGetInvoices', 'before promise');
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.billingCustomerInvoicesGet(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('billing.service', 'callGetInvoices result', result);
                    var formatted = _this.formatInvoices(result.data);
                    resolve(formatted);
                }).catch(function (err) {
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    BillingService.prototype.formatInvoices = function (invoices) {
        try {
            var formatted = new Array();
            var count = 0;
            for (var current = 0; current < invoices.length; current++) {
                if (invoices[current].status !== "draft") {
                    var line = invoices[current].lines.data[0];
                    var item = {
                        id: invoices[current].id,
                        date: moment.unix(invoices[current].date).format('YYYY-MM-DD'),
                        amount: '$' + (invoices[current].amount_due / 100).toFixed(2),
                        //description: line.plan.statement_descriptor
                        description: line.plan ? line.plan.statement_descriptor : ''
                    };
                    formatted[count] = item;
                    count++;
                }
            }
            return formatted;
        }
        catch (err) {
            return null;
        }
    };
    BillingService.prototype.clearCustomer = function () {
        this.app.setCustomer(null);
    };
    BillingService.prototype.getCustomer = function () {
        var _this = this;
        return this.api.getApiClient().then(function (client) { return _this.callGetCustomer(client); });
    };
    BillingService.prototype.callGetCustomer = function (apigClient) {
        var _this = this;
        this.logger.log('billing.service', 'callGetCustomer', 'before promise');
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.billingCustomerGet(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('billing.service', 'callGetCustomer result', result);
                    var customer = new customer_1.Customer(result.data);
                    _this.app.setCustomer(customer);
                    resolve(customer);
                }).catch(function (err) {
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    BillingService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.LogService, shared_1.AppContext])
    ], BillingService);
    return BillingService;
}());
exports.BillingService = BillingService;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(12);
var Customer = (function () {
    function Customer(json) {
        // data from stripe
        try {
            this.setStripeData(json);
        }
        catch (ex) {
            this.setDefaults();
        }
    }
    Customer.prototype.setStripeData = function (json) {
        this.id = json.id || '';
        this.balance = json.account_balance || 0;
        this.created = new Date(json.created);
        this.currency = json.currency;
        this.defaultSource = json.default_source || '';
        this.delinquent = json.delinquent || false;
        this.description = json.description || '';
        this.discount = ''; // json.discount
        this.email = json.email || '';
        this.invoicePrefix = json.invoice_prefix || '';
        this.livemode = json.livemode;
        this.metadata = json.metadata;
        this.setSources(json.sources.data);
        this.setSubscriptions(json.subscriptions.data);
    };
    Customer.prototype.setSources = function (sources) {
        this.sources = [];
        try {
            for (var current = 0; current < sources.length; current++) {
                this.sources.push(new Source(sources[current]));
            }
        }
        catch (ex) {
        }
    };
    Customer.prototype.setSubscriptions = function (subscriptions) {
        this.subscriptions = [];
        try {
            for (var current = 0; current < subscriptions.length; current++) {
                this.subscriptions.push(new Subscription(subscriptions[current]));
            }
        }
        catch (ex) {
        }
    };
    Customer.prototype.setDefaults = function () {
        this.id = '';
        this.balance = 0;
        this.created = null;
        this.currency = '';
        this.defaultSource = '';
        this.delinquent = false;
        this.description = '';
        this.email = '';
        this.invoicePrefix = '';
        this.livemode = false;
        this.metadata = {};
        this.sources = [];
        this.subscriptions = [];
    };
    return Customer;
}());
exports.Customer = Customer;
var Source = (function () {
    function Source(json) {
        try {
            this.setStripeData(json);
        }
        catch (ex) {
            this.setDefaults();
        }
    }
    Source.prototype.setStripeData = function (json) {
        this.addressCity = json.address_city || '';
        this.addressCountry = json.address_country || '';
        this.addressLineOne = json.address_line1 || '';
        this.addressLineTwo = json.address_line2 || '';
        this.addressZip = json.address_zip || '';
        this.brand = json.brand || '';
        this.country = json.country || '';
        this.customer = json.customer || '';
        this.cvcCheck = json.cvc_check || '';
        this.expMonth = json.exp_month || '';
        this.expYear = json.exp_year || '';
        this.funding = json.funding || '';
        this.id = json.id || '';
        this.lastFour = json.last4 || '';
        this.metadata = json.metadata || {};
        this.name = json.name || '';
    };
    Source.prototype.setDefaults = function () {
        this.addressCity = '';
        this.addressCountry = '';
        this.addressLineOne = '';
        this.addressLineTwo = '';
        this.addressZip = '';
        this.brand = '';
        this.country = '';
        this.customer = '';
        this.cvcCheck = '';
        this.expMonth = '';
        this.expYear = '';
        this.funding = '';
        this.id = '';
        this.lastFour = '';
        this.metadata = {};
        this.name = '';
    };
    return Source;
}());
exports.Source = Source;
var Subscription = (function () {
    function Subscription(json) {
        try {
            this.setStripeData(json);
        }
        catch (ex) {
            this.setDefaults();
        }
    }
    Subscription.prototype.setStripeData = function (json) {
        this.billing = json.billing || '';
        this.cancelAtPeriodEnd = json.cancel_at_period_end || false;
        this.canceledAt = json.canceled_at || null;
        this.created = json.created || null;
        this.currentPeriodEnd = json.current_period_end || null;
        this.currentPeriodStart = json.current_period_start || null;
        this.customer = json.customer || '';
        this.discount = json.discount || '';
        this.id = json.id || '';
        this.items = json.items || {};
        this.livemode = json.livemode || false;
        this.metadata = json.metadata || {};
        this.plan = new _1.Plan(json.plan);
        this.start = json.start || null;
        this.status = json.status || '';
        this.trialEnd = json.trial_end || null;
        this.trialStart = json.trial_start || null;
    };
    Subscription.prototype.setDefaults = function () {
        this.billing = '';
        this.cancelAtPeriodEnd = false;
        this.canceledAt = null;
        this.created = null;
        this.currentPeriodEnd = null;
        this.currentPeriodStart = null;
        this.customer = '';
        this.discount = '';
        this.id = '';
        this.items = {};
        this.livemode = false;
        this.metadata = {};
        this.plan = new _1.Plan(null);
        this.start = null;
        this.status = '';
        this.trialEnd = null;
        this.trialStart = null;
    };
    return Subscription;
}());
exports.Subscription = Subscription;


/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports = "<div class=\"header-content-wrapper\">\r\n  <header>\r\n    <div class=\"wrapper\">\r\n      <div class=\"left-side\">\r\n        <a class=\"header-logo\" [routerLink]=\"['']\" (click)=\"toggle('schedule')\">\r\n          <!-- Just saying footer, because it leaves it open -->\r\n          <img src=\"../img/logos/svg/linescape-logo-gradient.svg\"\r\n            onerror=\"this.onerror=null; this.src='../img/logos/png/linescape-logo-gradient.png'\" />\r\n        </a>\r\n        <div class=\"search-container\">\r\n          <a href=\"javascript:;\" class=\"search-button\" (click)=\"toggleSearch()\" [class.open]=\"app.viewSearch\"><img\r\n              src=\"../img/icons/svg/search-tool-white.svg\"\r\n              onerror=\"this.onerror=null; this.src='../img/icons/png/search-tool-white.png'\" /></a>\r\n          <ul class=\"search-buttons\" [class.open]=\"app.viewSearch\">\r\n            <li [class.active]=\"app.searchType == 'schedule'\" (click)=\"toggle('schedule')\">\r\n              Schedules\r\n            </li>\r\n            <li [class.active]=\"app.searchType == 'vessels'\" (click)=\"toggle('vessels')\">\r\n              Vessels\r\n            </li>\r\n            <li [class.active]=\"app.searchType == 'ports'\" (click)=\"toggle('ports')\">\r\n              Ports\r\n            </li>\r\n            <li [class.active]=\"app.searchType == 'carriers'\" (click)=\"toggle('carriers')\">\r\n              Carriers\r\n            </li>\r\n          </ul>\r\n\r\n          <div class=\"search-bottom\" [ngSwitch]=\"app.searchType\" [class.open]=\"app.viewSearch\"\r\n            [hidden]=\"!app.viewSearch\">\r\n            <ng-template [ngSwitchCase]=\"'carriers'\">\r\n              <carriers-search (close)=\"toggle($event.searchType)\">loading...</carriers-search>\r\n            </ng-template>\r\n            <ng-template [ngSwitchCase]=\"'vessels'\">\r\n              <vessels-search (close)=\"toggle($event.searchType)\">loading...</vessels-search>\r\n            </ng-template>\r\n            <ng-template [ngSwitchCase]=\"'ports'\">\r\n              <ports-search (close)=\"toggle($event.searchType)\"> loading...</ports-search>\r\n            </ng-template>\r\n            <ng-template [ngSwitchCase]=\"'schedule'\">\r\n              <schedules-search (close)=\"toggle($event.searchType)\">loading...</schedules-search>\r\n            </ng-template>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"right-side\">\r\n        <nav class=\"nav-account\">\r\n          <a [routerLink]=\"['subscribe']\" [routerLinkActive]=\"'current-page'\">Subscribe</a>\r\n          <a *ngIf=\"!app.isLoggedIn\" class=\"login-link\" (click)=\"app.toggleLogin()\">Login</a>\r\n          <a *ngIf=\"app.isLoggedIn\" [routerLink]=\"['account']\" [routerLinkActive]=\"'current-page'\">My Account</a>\r\n          <a *ngIf=\"app.isLoggedIn\" class=\"login-link\" (click)=\"logout()\">Logout</a>\r\n        </nav>\r\n        <nav class=\"nav-main\" [class.open]=\"app.viewMenu\">\r\n          <a (click)=\"toggleMenu()\" [routerLink]=\"['solutions']\" [routerLinkActive]=\"'current-page'\"\r\n            class=\"has-dropdown\">Solutions</a>\r\n          <ul class=\"nav-dropdown solutions-dropdown\">\r\n            <li>\r\n              <a [routerLink]=\"['online-search']\">Online Search</a>\r\n            </li>\r\n            <span class=\"triangle\">▲</span>\r\n            <div class=\"shadow-blocker\"></div>\r\n            <li>\r\n              <a [routerLink]=\"['api-data-on-demand']\">API Data-on-Demand</a>\r\n            </li>\r\n            <li>\r\n              <a [routerLink]=\"['bulk-data-feeds']\">Bulk Data Feeds</a>\r\n            </li>\r\n            <li>\r\n              <a [routerLink]=\"['analytics-reporting']\">Analytics & Reporting</a>\r\n            </li>\r\n          </ul>\r\n          <a (click)=\"toggleMenu()\" [routerLink]=\"['application']\" [routerLinkActive]=\"'current-page'\"\r\n            class=\"has-dropdown\">Application</a>\r\n          <ul class=\"nav-dropdown application-dropdown\">\r\n            <li>\r\n              <a [routerLink]=\"['api-overview']\">API Overview</a>\r\n            </li>\r\n            <span class=\"triangle\">▲</span>\r\n            <div class=\"shadow-blocker\"></div>\r\n            <li>\r\n              <a [routerLink]=\"['bulk-data-formats']\">Bulk Data Formats</a>\r\n            </li>\r\n            <li>\r\n              <a [routerLink]=\"['carrier-list']\">Carrier List</a>\r\n            </li>\r\n            <li>\r\n              <a [routerLink]=\"['data-consolidation']\">Data Consolidation</a>\r\n            </li>\r\n          </ul>\r\n          <a (click)=\"toggleMenu()\" [routerLink]=\"['about']\" [routerLinkActive]=\"'current-page'\"\r\n            class=\"has-dropdown\">About</a>\r\n          <ul class=\"nav-dropdown about-dropdown\">\r\n            <li>\r\n              <a [routerLink]=\"['what-we-do']\">What We Do</a>\r\n            </li>\r\n            <span class=\"triangle\">▲</span>\r\n            <div class=\"shadow-blocker\"></div>\r\n            <li>\r\n              <a [routerLink]=\"['/who-we-are']\">Who We Are</a>\r\n            </li>\r\n            <li>\r\n              <a [routerLink]=\"['/upcoming-events']\">Upcoming Events</a>\r\n            </li>\r\n            <li>\r\n              <a [routerLink]=\"['/press']\">Press</a>\r\n            </li>\r\n          </ul>\r\n          <a (click)=\"toggleMenu()\" [routerLink]=\"['contact']\" [routerLinkActive]=\"'current-page'\"\r\n            class=\"has-dropdown\">Contact</a>\r\n          <ul class=\"nav-dropdown contact-dropdown\">\r\n            <li>\r\n              <a [routerLink]=\"['contact']\">Contact Us</a>\r\n            </li>\r\n            <span class=\"triangle\">▲</span>\r\n            <div class=\"shadow-blocker\"></div>\r\n            <li>\r\n              <a href=\"https://docs.linescape.com/\" target=\"_blank\">FAQs</a>\r\n            </li>\r\n          </ul>\r\n          <a class=\"mobile-link\" (click)=\"toggleMenu()\" [routerLink]=\"['subscribe']\"\r\n            [routerLinkActive]=\"'current-page'\">Subscribe</a>\r\n          <a (click)=\"toggleMenu()\" *ngIf=\"!app.isLoggedIn\" class=\"login-link mobile-link\"\r\n            (click)=\"app.toggleLogin()\">Login</a>\r\n          <a class=\"mobile-link\" (click)=\"toggleMenu()\" *ngIf=\"app.isLoggedIn\" [routerLink]=\"['account']\"\r\n            [routerLinkActive]=\"'current-page'\">My Account</a>\r\n          <a (click)=\"toggleMenu()\" *ngIf=\"app.isLoggedIn\" class=\"login-link mobile-link\"\r\n            (click)=\"api.signOut()\">Logout</a>\r\n        </nav>\r\n        <div (click)=\"toggleMenu()\" [class.open]=\"app.viewMenu\" class=\"hamburger-holder\">\r\n          <span></span>\r\n          <span></span>\r\n          <span></span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </header>\r\n  <main>\r\n    <arrival-message *ngIf=\"app.arrivalMessage\">loading...</arrival-message>\r\n    <message *ngIf=\"app.message\" [title]=\"app.messageTitle\" [content]=\"app.messageContent\">loading...</message>\r\n    <register-message *ngIf=\"app.registerMessage\" [title]=\"app.registerTitle\" [content]=\"app.registerContent\">loading...\r\n    </register-message>\r\n    <upgrade-message *ngIf=\"app.upgradeMessage\" [title]=\"app.upgradeTitle\" [content]=\"app.upgradeContent\">loading...\r\n    </upgrade-message>\r\n    <profile-popup *ngIf=\"app.showPersonalInformation\">loading...</profile-popup>\r\n    <div class=\"loading\" *ngIf=\"app.login\">\r\n      <div class=\"login-behind\">\r\n        <login>loading...</login>\r\n      </div>\r\n    </div>\r\n    <router-outlet></router-outlet>\r\n\r\n  </main>\r\n</div>\r\n<footer>\r\n  <div class=\"wrapper full-nav\">\r\n    <div class=\"under-logo\">\r\n      <a class=\"footer-logo\" [routerLink]=\"['']\" (click)=\"scrollTop()\">\r\n        <img src=\"../img/logos/svg/linescape-logo-white.svg\"\r\n          onerror=\"this.onerror=null; this.src='../img/logos/png/linescape-logo-white.png'\" />\r\n      </a>\r\n      <div class=\"footer-social-links\">\r\n        <ul>\r\n          <li><a href=\"http://www.facebook.com/pages/Linescape/127633963941865\" target=\"_blank\"><img\r\n                src=\"../img/fb-icon.png\"></a></li>\r\n          <li><a href=\"http://www.linkedin.com/company/linescape\" target=\"_blank\"><img\r\n                src=\"../img/linkedin-icon.png\"></a></li>\r\n          <li><a href=\"http://twitter.com/Linescape\" target=\"_blank\"><img src=\"../img/twitter.png\"></a></li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n    <div>\r\n      <ul>\r\n        <li><a (click)=\"toggle('schedule')\" (click)=\"scrollTop()\">SEARCH BY</a></li>\r\n        <li><a (click)=\"toggle('schedule')\" (click)=\"scrollTop()\">Schedules</a></li>\r\n        <li><a (click)=\"toggle('vessels')\" (click)=\"scrollTop()\">Vessels</a></li>\r\n        <li><a (click)=\"toggle('ports')\" (click)=\"scrollTop()\">Ports</a></li>\r\n        <li><a (click)=\"toggle('carriers')\" (click)=\"scrollTop()\">Carriers</a></li>\r\n      </ul>\r\n    </div>\r\n\r\n    <div>\r\n      <ul>\r\n        <li>\r\n          <a [routerLink]=\"['solutions']\" (click)=\"scrollTop()\">SOLUTIONS</a>\r\n        <li>\r\n          <a [routerLink]=\"['online-search']\" (click)=\"scrollTop()\">Online Search</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['api-data-on-demand']\" (click)=\"scrollTop()\">API\r\n            Data-on-Demand</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['bulk-data-feeds']\" (click)=\"scrollTop()\">Bulk Data Feeds</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['analytics-reporting']\" (click)=\"scrollTop()\">Analytics &\r\n            Reporting</a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n\r\n    <div>\r\n      <ul>\r\n        <li>\r\n          <a [routerLink]=\"['application']\" (click)=\"scrollTop()\">APPLICATION</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['api-overview']\" (click)=\"scrollTop()\">API Overview</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['bulk-data-formats']\" (click)=\"scrollTop()\">Bulk Data\r\n            Formats</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['carrier-list']\" (click)=\"scrollTop()\">Carrier List</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['data-consolidation']\" (click)=\"scrollTop()\">Data\r\n            Consolidation</a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n\r\n    <div>\r\n      <ul>\r\n        <li>\r\n          <a [routerLink]=\"['/about']\" (click)=\"scrollTop()\">ABOUT</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['/who-we-are']\" (click)=\"scrollTop()\">Who We Are</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['/what-we-do']\" (click)=\"scrollTop()\">What We Do</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['/upcoming-events']\" (click)=\"scrollTop()\">Upcoming Events</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['/press']\" (click)=\"scrollTop()\">Press</a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n\r\n    <div>\r\n      <ul>\r\n        <li *ngIf=\"!app.isLoggedIn\">\r\n          <a class=\"\" (click)=\"app.toggleLogin()\">Login</a>\r\n        </li>\r\n        <li *ngIf=\"app.isLoggedIn\">\r\n          <a [routerLink]=\"['/account']\" (click)=\"scrollTop()\">My Account</a>\r\n        </li>\r\n        <li *ngIf=\"app.isLoggedIn\">\r\n          <a class=\"\" (click)=\"api.signOut()\">Logout</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['/subscribe']\" (click)=\"scrollTop()\">Subscribe</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['/contact']\" (click)=\"scrollTop()\">Contact</a>\r\n        </li>\r\n        <li>\r\n          <a href=\"https://docs.linescape.com/\" target=\"_blank\">FAQs</a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <!--- MOBILE FOOTER NAV-->\r\n\r\n  <div class=\"wrapper mobile-nav\">\r\n    <div class=\"under-logo\">\r\n      <a class=\"footer-logo\" [routerLink]=\"['']\" (click)=\"scrollTop()\">\r\n        <img src=\"../img/logos/svg/linescape-logo-white.svg\"\r\n          onerror=\"this.onerror=null; this.src='../img/logos/png/linescape-logo-white.png'\" />\r\n      </a>\r\n      <div class=\"footer-social-links\">\r\n        <ul>\r\n          <li><a href=\"http://www.facebook.com/pages/Linescape/127633963941865\" target=\"_blank\"><img\r\n                src=\"../img/fb-icon.png\"></a></li>\r\n          <li><a href=\"http://www.linkedin.com/company/linescape\" target=\"_blank\"><img\r\n                src=\"../img/linkedin-icon.png\"></a></li>\r\n          <li><a href=\"http://twitter.com/Linescape\" target=\"_blank\"><img src=\"../img/twitter.png\"></a></li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"pure-menu pure-menu-horizontal\">\r\n      <ul class=\"pure-menu-list\">\r\n        <li *ngIf=\"!app.isLoggedIn\">\r\n          <a class=\"\" (click)=\"app.toggleLogin()\">Login</a>\r\n        </li>\r\n        <li *ngIf=\"app.isLoggedIn\">\r\n          <a [routerLink]=\"['account']\" (click)=\"scrollTop()\">My Account</a>\r\n        </li>\r\n        <li *ngIf=\"app.isLoggedIn\">\r\n          <a class=\"\" (click)=\"api.signOut()\">Logout</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['subscribe']\" (click)=\"scrollTop()\">Subscribe</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['contact']\" (click)=\"scrollTop()\">Contact</a>\r\n        </li>\r\n        <li>\r\n          <a href=\"https://docs.linescape.com/\" target=\"_blank\">FAQs</a>\r\n        </li>\r\n        <li class=\"pure-menu-item pure-menu-has-children pure-menu-allow-hover\">\r\n          <a class=\"pure-menu-link\">SEARCH BY</a>\r\n          <ul class=\"pure-menu-children\">\r\n            <li class=\"pure-menu-item\"><a (click)=\"toggle('schedule')\" (click)=\"scrollTop()\"\r\n                class=\"pure-menu-link\">Schedules</a></li>\r\n            <li class=\"pure-menu-item\"><a (click)=\"toggle('vessels')\" (click)=\"scrollTop()\"\r\n                class=\"pure-menu-link\">Vessels</a></li>\r\n            <li class=\"pure-menu-item\"><a (click)=\"toggle('ports')\" (click)=\"scrollTop()\"\r\n                class=\"pure-menu-link\">Ports</a></li>\r\n            <li class=\"pure-menu-item\"><a (click)=\"toggle('carriers')\" (click)=\"scrollTop()\"\r\n                class=\"pure-menu-link\">Carriers</a></li>\r\n          </ul>\r\n        </li>\r\n        <li class=\"pure-menu-item pure-menu-has-children pure-menu-allow-hover\">\r\n          <a class=\"pure-menu-link\">SOLUTIONS</a>\r\n          <ul class=\"pure-menu-children\">\r\n            <li class=\"pure-menu-item\">\r\n              <a class=\"pure-menu-link\" [routerLink]=\"['/online-search']\" (click)=\"scrollTop()\">Online Search</a>\r\n            </li>\r\n            <li class=\"pure-menu-item\">\r\n              <a class=\"pure-menu-link\" [routerLink]=\"['/api']\" (click)=\"scrollTop()\">API\r\n                Data-on-Demand</a>\r\n            </li>\r\n            <li class=\"pure-menu-item\">\r\n              <a class=\"pure-menu-link\" [routerLink]=\"['/data-feeds']\" (click)=\"scrollTop()\">Bulk Data Feeds</a>\r\n            </li>\r\n            <li class=\"pure-menu-item\">\r\n              <a class=\"pure-menu-link\" [routerLink]=\"['/analytics']\" (click)=\"scrollTop()\">Analytics & Reporting</a>\r\n            </li>\r\n          </ul>\r\n        </li>\r\n\r\n        <li class=\"pure-menu-item pure-menu-has-children pure-menu-allow-hover\">\r\n          <a class=\"pure-menu-link\">APPLICATION</a>\r\n          <ul class=\"pure-menu-children\">\r\n            <li class=\"pure-menu-item\">\r\n              <a class=\"pure-menu-link\" [routerLink]=\"['/api-overview']\" (click)=\"scrollTop()\">API Overview</a>\r\n            </li>\r\n            <li class=\"pure-menu-item\">\r\n              <a class=\"pure-menu-link\" [routerLink]=\"['/data-formats']\" (click)=\"scrollTop()\">Bulk Data Formats</a>\r\n            </li>\r\n            <li class=\"pure-menu-item\">\r\n              <a class=\"pure-menu-link\" [routerLink]=\"['/carrier-list']\" (click)=\"scrollTop()\">Carrier List</a>\r\n            </li>\r\n            <li class=\"pure-menu-item\">\r\n              <a class=\"pure-menu-link\" [routerLink]=\"['/data-consolidation']\" (click)=\"scrollTop()\">Data\r\n                Consolidation</a>\r\n            </li>\r\n          </ul>\r\n        </li>\r\n\r\n        <li class=\"pure-menu-item pure-menu-has-children pure-menu-allow-hover\">\r\n          <a class=\"pure-menu-link\">ABOUT</a>\r\n          <ul class=\"pure-menu-children\">\r\n            <li class=\"pure-menu-item\">\r\n              <a class=\"pure-menu-link\" [routerLink]=\"['/who-we-are']\" (click)=\"scrollTop()\">Who We Are</a>\r\n            </li>\r\n            <li class=\"pure-menu-item\">\r\n              <a class=\"pure-menu-link\" [routerLink]=\"['/what-we-do']\" (click)=\"scrollTop()\">What We Do</a>\r\n            </li>\r\n            <li class=\"pure-menu-item\">\r\n              <a class=\"pure-menu-link\" [routerLink]=\"['/upcoming-events']\" (click)=\"scrollTop()\">Upcoming Events</a>\r\n            </li>\r\n            <li class=\"pure-menu-item\">\r\n              <a class=\"pure-menu-link\" [routerLink]=\"['/press']\" (click)=\"scrollTop()\">Press</a>\r\n            </li>\r\n          </ul>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"pure-g wrapper-footer\">\r\n    <div class=\"pure-u-1-3\">\r\n      <p>Copyright © 2020 Linescape. All rights reserved.</p>\r\n    </div>\r\n\r\n    <div class=\"pure-u-1-3 inline-links\">\r\n      <a [routerLink]=\"['/terms-of-use']\" (click)=\"scrollTop()\">Terms</a> |\r\n      <a [routerLink]=\"['/privacy-policy']\" (click)=\"scrollTop()\">Privacy</a>\r\n    </div>\r\n    <div class=\"pure-u-1-3\">\r\n      <a href=\"http://tecture.com/\" target=\"_blank\" class=\"logo tecture-logo\" title=\"Web Development Chicago\"\r\n        alt=\"Web Development Company Chicago\"><span class=\"tecture\"></span></a>\r\n    </div>\r\n  </div>\r\n  <!--<div class=\"wrapper wrapper-2 text-right\">\r\n    <a\r\n      href=\"http://tecture.com/\"\r\n      target=\"_blank\"\r\n      class=\"logo tecture-logo\"\r\n      title=\"Web Development Chicago\"\r\n      alt=\"Web Development Company Chicago\"\r\n      ><span class=\"tecture\"></span\r\n    ></a>\r\n  </div>-->\r\n</footer>"

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = ":host {\n  display: block; }\n\nsmall {\n  font-size: 0.8em;\n  line-height: 1em; }\n\n.alert-banner {\n  background: #FF663B;\n  background: #2798d8;\n  padding-top: 3px;\n  padding-bottom: 3px;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 29; }\n  .alert-banner p {\n    color: #ffffff;\n    text-align: center; }\n  .alert-banner .btn-white-blue {\n    margin-left: 8px; }\n\n@media only screen and (max-width: 899px) {\n  .alert-banner p {\n    font-size: 17px; } }\n\n@media only screen and (max-width: 799px) {\n  .alert-banner {\n    position: relative; } }\n\n.login-behind {\n  position: fixed;\n  z-index: 100;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh; }\n\n.search-holder {\n  animation: slideDownHome 1s 1;\n  overflow: hidden; }\n\n.search-holder {\n  animation: slideDownInner 1s 1;\n  overflow: hidden; }\n\n@keyframes slideDownHome {\n  0% {\n    max-height: 133px; }\n  100% {\n    max-height: 1000px; } }\n\n@keyframes slideDownInner {\n  0% {\n    max-height: 0px; }\n  100% {\n    max-height: 1000px; } }\n\n#loader-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1000;\n  background: rgba(255, 255, 255, 0.5); }\n\n#loader {\n  display: block;\n  position: relative;\n  left: 50%;\n  top: 50%;\n  width: 80px;\n  height: 80px;\n  margin: -40px 0 0 -40px;\n  border-radius: 50%;\n  border: 5px solid #3498db;\n  z-index: 1500;\n  border: 3px solid transparent;\n  border-top-color: #333333;\n  border-left-color: #333333;\n  animation: spin 1s linear infinite; }\n\n@keyframes spin {\n  0% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: rotate(0deg);\n    /* Firefox 16+, IE 10+, Opera */ }\n  100% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: rotate(360deg);\n    /* Firefox 16+, IE 10+, Opera */ } }\n\n/***********************************************\r\nHEADER\r\n***********************************************/\n.header-content-wrapper {\n  min-height: calc(100vh - 121px); }\n\nheader {\n  background: #fff;\n  padding-top: 20px;\n  padding-bottom: 20px; }\n  header .header-logo img {\n    height: 60px;\n    width: 205px; }\n  header .search-container {\n    font-size: 0;\n    line-height: 0;\n    position: relative; }\n  header .search-button {\n    background: #345a78;\n    display: inline-block;\n    padding: 7px;\n    height: 35px;\n    width: 40px; }\n    header .search-button img {\n      width: 100%;\n      height: 100%; }\n  header .search-buttons {\n    display: inline-block;\n    vertical-align: top;\n    margin: 0;\n    font-size: 0;\n    line-height: 0; }\n    header .search-buttons li {\n      list-style: none;\n      display: inline-block;\n      margin-left: 0;\n      background: #fff;\n      color: #0882c5;\n      border: 1px solid #0882c5;\n      border-right: 0;\n      cursor: pointer;\n      font-size: 16px;\n      padding: 0 28px;\n      height: 35px; }\n      header .search-buttons li:last-of-type {\n        border-right: 1px solid #0882c5; }\n      header .search-buttons li.active {\n        background: #0882c5;\n        color: #fff;\n        cursor: default; }\n      header .search-buttons li:hover {\n        background: #0882c5;\n        color: #fff; }\n  header .search-bottom {\n    position: absolute;\n    background: #fff;\n    z-index: 30;\n    left: 40px;\n    top: 35px;\n    width: 450px; }\n  @media (max-width: 979px) {\n    header .search-container {\n      position: absolute;\n      top: 27px;\n      right: 80px; } }\n  header .left-side {\n    display: inline-block; }\n  header .right-side {\n    float: right; }\n    header .right-side nav {\n      display: block;\n      text-align: right;\n      padding-top: 15px; }\n      header .right-side nav a {\n        display: inline-block;\n        line-height: 30px;\n        padding-left: 12px;\n        padding-right: 12px;\n        margin-left: 5px;\n        font-size: 16px;\n        position: relative;\n        color: #ffffff; }\n        header .right-side nav a:hover {\n          color: #FF663B; }\n        header .right-side nav a.current-page {\n          text-decoration: underline; }\n      header .right-side nav .login-link {\n        border: 1px solid #ffffff;\n        cursor: pointer;\n        padding-left: 15px;\n        padding-right: 15px;\n        border-radius: 3px;\n        margin-left: 5px; }\n        header .right-side nav .login-link:hover {\n          border: 1px solid #FF663B; }\n    header .right-side .nav-account a {\n      color: #0882c5; }\n    header .right-side .nav-account .login-link {\n      text-decoration: none;\n      border-color: #0882c5; }\n    header .right-side .nav-main a {\n      color: #000; }\n    header .right-side .nav-main .nav-dropdown a {\n      color: #0882c5; }\n    header .right-side .nav-main .nav-dropdown svg {\n      display: inline-block;\n      margin-right: 10px;\n      max-width: 26px;\n      max-height: 26px;\n      vertical-align: top;\n      margin-top: 13px; }\n      header .right-side .nav-main .nav-dropdown svg * {\n        fill: #0882c5; }\n    header .right-side .nav-main .mobile-link {\n      display: none; }\n    @media (max-width: 979px) {\n      header .right-side .nav-account {\n        display: none; } }\n  header .has-dropdown {\n    padding-bottom: 20px !important; }\n  @media only screen and (max-width: 979px) {\n    header .has-dropdown {\n      padding-bottom: 5px !important; } }\n  header .has-dropdown:hover {\n    color: #888 !important; }\n  header .has-dropdown:hover + .nav-dropdown {\n    visibility: visible;\n    opacity: 1; }\n  header .nav-dropdown:hover {\n    visibility: visible;\n    opacity: 1; }\n  header .nav-main {\n    position: relative;\n    padding-top: 5px !important; }\n    header .nav-main > a {\n      padding: 10px 12px; }\n  header .nav-dropdown {\n    border-radius: 10px;\n    background: #fff;\n    position: absolute;\n    z-index: 1;\n    top: 65px;\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 300ms linear;\n    margin: 0; }\n    header .nav-dropdown .triangle {\n      position: absolute;\n      top: -16px;\n      left: 92px;\n      color: #fff;\n      font-size: 24px;\n      transform: scaleX(2);\n      line-height: 1em;\n      text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\n      cursor: default; }\n    header .nav-dropdown .shadow-blocker {\n      position: absolute;\n      background: #fff;\n      width: 40px;\n      height: 15px;\n      top: 0;\n      left: 83px; }\n    header .nav-dropdown li {\n      list-style: none;\n      margin-left: 0; }\n    header .nav-dropdown a {\n      display: block !important;\n      padding: 10px;\n      text-align: left !important;\n      margin-left: 0 !important;\n      min-width: 210px; }\n      header .nav-dropdown a:hover {\n        background: #0882c5;\n        color: #fff !important; }\n    header .nav-dropdown li:first-of-type a {\n      border-radius: 10px 10px 0 0; }\n    header .nav-dropdown li:last-of-type a {\n      border-radius: 0 0 10px 10px; }\n    header .nav-dropdown li:first-of-type:hover ~ .triangle {\n      color: #0882c5; }\n    header .nav-dropdown li:first-of-type:hover ~ .shadow-blocker {\n      background: #0882c5; }\n    header .nav-dropdown.solutions-dropdown {\n      left: -53px; }\n    header .nav-dropdown.application-dropdown {\n      left: 49px; }\n    header .nav-dropdown.about-dropdown {\n      left: 161px; }\n      header .nav-dropdown.about-dropdown a {\n        min-width: 180px; }\n      header .nav-dropdown.about-dropdown .triangle {\n        left: 77px; }\n      header .nav-dropdown.about-dropdown .shadow-blocker {\n        left: 69px; }\n    header .nav-dropdown.contact-dropdown {\n      left: 230px; }\n  @media (max-width: 979px) {\n    header .has-dropdown:hover + .nav-dropdown {\n      visibility: hidden;\n      opacity: 0; }\n    header .nav-dropdown:hover {\n      visibility: hidden;\n      opacity: 0; }\n    header .has-dropdown:hover {\n      color: #FF663B !important; } }\n\n/*----------------------------\r\n\tHamburger Menu\r\n----------------------------*/\n.hamburger-holder {\n  position: absolute;\n  top: 50px;\n  right: 30px;\n  width: 30px;\n  height: 20px;\n  cursor: pointer;\n  z-index: 25;\n  display: none; }\n  .hamburger-holder span {\n    display: block;\n    position: absolute;\n    height: 3px;\n    background: #247cbd;\n    width: 100%;\n    border-radius: 3px;\n    transform: rotate(0deg);\n    transition: .25s ease-in-out; }\n    .hamburger-holder span:nth-child(1) {\n      top: -3px; }\n    .hamburger-holder span:nth-child(2) {\n      top: 5px; }\n    .hamburger-holder span:nth-child(3) {\n      top: 13px; }\n  .hamburger-holder.open span:nth-child(1) {\n    top: 5px;\n    transform: rotate(135deg); }\n  .hamburger-holder.open span:nth-child(2) {\n    opacity: 0;\n    /*-webkit-transform: translateX(-60px);\r\n            -moz-transform: translateX(-60px);\r\n            -o-transform: translateX(-60px);\r\n            transform: translateX(-60px);*/ }\n  .hamburger-holder.open :nth-child(3) {\n    top: 5px;\n    transform: rotate(-135deg); }\n\n@media only screen and (max-width: 979px) {\n  header .right-side .nav-main {\n    display: none;\n    position: absolute;\n    background: white;\n    width: 200px;\n    z-index: 300;\n    right: 0;\n    box-sizing: border-box;\n    transition: all .5s ease;\n    overflow-x: hidden;\n    padding-top: 0;\n    top: 89px;\n    max-height: 0;\n    overflow-y: hidden;\n    padding-bottom: 7px;\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2); }\n    header .right-side .nav-main a {\n      width: 100%;\n      text-align: center;\n      box-sizing: border-box;\n      color: #0882c5;\n      padding: 5px 0;\n      margin-left: 0; }\n    header .right-side .nav-main .mobile-link {\n      display: inline-block; }\n    header .right-side .nav-main span {\n      display: none; }\n    header .right-side .nav-main .login-link {\n      border: none; }\n      header .right-side .nav-main .login-link:hover {\n        border: none; }\n    header .right-side .nav-main.open {\n      display: block;\n      max-height: 288px; }\n  header .wrapper {\n    position: relative; }\n  .hamburger-holder {\n    display: block;\n    top: 37px; }\n  header .search-buttons {\n    position: absolute;\n    top: 35px;\n    right: 0;\n    width: 450px;\n    text-align: right;\n    transition: all .5s ease;\n    max-height: 0;\n    overflow: hidden;\n    z-index: 29; }\n    header .search-buttons.open {\n      max-height: 100px; }\n  header .search-bottom {\n    top: 70px;\n    left: unset;\n    right: 0;\n    transition: all .5s ease;\n    max-height: 0;\n    padding: 0 20px;\n    overflow: scroll; }\n    header .search-bottom.open {\n      max-height: 1000px;\n      box-shadow: 0px 9px 20px -10px rgba(0, 0, 0, 0.75); } }\n\n@media only screen and (max-width: 599px) {\n  header {\n    padding-top: 26px;\n    padding-bottom: 26px; }\n    header .header-logo img {\n      height: 60px;\n      margin-top: 5px; }\n    header .search-buttons {\n      width: 350px; }\n      header .search-buttons li {\n        padding: 0 15px; }\n    header .search-bottom {\n      width: 343px; } }\n\n@media only screen and (max-width: 599px) {\n  header {\n    padding-top: 26px;\n    padding-bottom: 26px; }\n    header .header-logo img {\n      height: 60px;\n      margin-top: 5px; }\n    header .search-buttons {\n      width: 350px; }\n      header .search-buttons li {\n        padding: 0 15px; }\n    header .search-bottom {\n      width: 343px; } }\n\n@media only screen and (max-width: 479px) {\n  header .search-buttons {\n    right: 0; }\n  header .search-bottom {\n    right: 0; } }\n\n@media only screen and (max-width: 375px) {\n  header .search-buttons {\n    right: -75px; }\n  header .search-bottom {\n    right: -75px; } }\n\n/***********************************************\r\nFooter\r\n***********************************************/\nfooter {\n  left: 0;\n  right: 0;\n  bottom: 0;\n  color: #ffffff;\n  background: #247cbd;\n  position: relative;\n  z-index: 1;\n  box-shadow: 0px -5px 5px rgba(0, 0, 0, 0.2);\n  /*\r\n    span {\r\n        color: #fff;\r\n        font-size: 18px;\r\n    }\r\n    .footer-menu {\r\n      font-size: 0;\r\n      max-width: 1023px;\r\n      margin: auto;\r\n      margin-bottom: 10px;\r\n      text-align: center;\r\n      a {\r\n        display: inline-block;\r\n        font-size: 18px;\r\n        text-align: center;\r\n        padding: 0 15px;\r\n      }\r\n    }\r\n    */ }\n  footer .wrapper {\n    padding: 40px 20px; }\n  footer .footer-logo img {\n    height: 60px;\n    width: 205px; }\n  footer a {\n    color: #ffffff; }\n    footer a:hover {\n      color: #285e85; }\n  footer .wrapper {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap; }\n  footer .wrapper-2 {\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n    padding-bottom: 40px; }\n  footer ul {\n    margin: 0; }\n  footer li {\n    list-style: none;\n    margin-left: 0; }\n  footer .login-link {\n    border: 1px solid #ffffff;\n    cursor: pointer;\n    padding: 2px 10px;\n    border-radius: 3px; }\n    footer .login-link:hover {\n      border: 1px solid #FF663B; }\n  footer .wrapper-footer {\n    max-width: 1180px;\n    margin: 0 auto;\n    border-top: 1px solid #79aed4;\n    padding: 15px; }\n  footer .inline-links {\n    text-align: center; }\n  footer .pure-menu-has-children {\n    transition: transform .2s; }\n    footer .pure-menu-has-children:hover {\n      background-color: #79aed4; }\n  footer .pure-menu-children {\n    left: 100%;\n    top: 0;\n    background-color: #79aed4;\n    position: initial; }\n  footer .pure-menu-link:hover {\n    background-color: transparent; }\n  footer .copyright {\n    text-align: center; }\n  footer .footer-social-links {\n    position: absolute;\n    bottom: 95px; }\n    footer .footer-social-links ul {\n      list-style-type: none; }\n      footer .footer-social-links ul li {\n        list-style-type: none;\n        display: inline-block;\n        margin-right: 9px; }\n        footer .footer-social-links ul li img {\n          max-width: 25px; }\n  footer .mobile-nav .pure-menu {\n    padding-top: 15px; }\n  footer .mobile-nav .footer-social-links {\n    border-bottom: 1px solid #79aed4;\n    position: inherit;\n    bottom: 0;\n    padding-bottom: 15px; }\n  footer .under-logo {\n    display: -ms-grid;\n    display: grid; }\n  footer .tecture-logo .tecture {\n    display: inline-block;\n    float: right;\n    height: 24px;\n    width: 131px;\n    background: url(../img/tecture-white-orange.png) bottom left;\n    overflow: hidden;\n    text-indent: -3000px;\n    margin-top: 5px;\n    margin-right: 20px; }\n  footer .tecture-logo:hover .tecture {\n    background: url(../img/tecture-white-orange.png) top left; }\n  @media (max-width: 1023px) {\n    footer .wrapper {\n      -ms-flex-pack: start;\n          justify-content: start;\n      padding: 20px; }\n    footer .wrapper > div {\n      margin-right: 40px;\n      margin-bottom: 30px; }\n    footer .wrapper > div:first-of-type {\n      width: 100%; } }\n\n.pure-menu-horizontal {\n  width: auto; }\n\n.pure-menu-list {\n  float: left; }\n\nfooter .wrapper.mobile-nav {\n  display: none; }\n\n@media (max-width: 1023px) {\n  .pure-menu-horizontal .pure-menu-list {\n    display: -ms-grid;\n    display: grid; }\n  footer .wrapper {\n    text-align: center; }\n  footer .wrapper > div {\n    margin: 0 auto; }\n  footer .wrapper-footer {\n    text-align: center; }\n  footer .pure-u-1-3 {\n    width: 100%; }\n  footer .inline-links {\n    text-align: center; }\n  footer .tecture-logo .tecture {\n    float: none; }\n  footer .wrapper.full-nav .footer-social-links {\n    position: inherit;\n    bottom: 0;\n    padding-bottom: 15px; } }\n\n@media (max-width: 800px) {\n  footer .wrapper.full-nav {\n    display: none; }\n  footer .wrapper.mobile-nav {\n    display: -ms-flexbox;\n    display: flex; } }\n\n/*\r\nfooter {\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    color: #ffffff;\r\n    background: #247cbd;\r\n    position: relative;\r\n    z-index: 1;\r\n    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2);\r\n    .wrapper {\r\n        padding: 20px 0;\r\n    }\r\n    a {\r\n        color: #ffffff;\r\n        &:hover {\r\n            color: $orange;\r\n        }    \r\n    }\r\n    span {\r\n        color: #fff;\r\n        font-size: 18px;\r\n    }\r\n    .footer-menu {\r\n      font-size: 0;\r\n      max-width: 1023px;\r\n      margin: auto;\r\n      margin-bottom: 10px;\r\n      text-align: center;\r\n      a {\r\n        display: inline-block;\r\n        font-size: 18px;\r\n        text-align: center;\r\n        padding: 0 15px;\r\n      }\r\n    }\r\n    .copyright {\r\n        text-align: center;\r\n    }\r\n    .footer-social-links {\r\n        text-align: center;\r\n        ul {\r\n            list-style-type: none;\r\n            li {\r\n                list-style-type: none;\r\n                display: inline-block;\r\n                margin-left: 9px;\r\n                margin-right: 9px;\r\n            }\r\n        }\r\n    }\r\n    .tecture-logo {\r\n        .tecture {\r\n            display: inline-block;\r\n            float: right;\r\n            height: 24px;\r\n            width: 131px;\r\n            background: url(../img/tecture-white-orange.png) bottom left;\r\n            overflow: hidden;\r\n            text-indent: -3000px;\r\n            margin-top: 5px;\r\n            margin-right: 20px;\r\n        }\r\n        &:hover {\r\n            .tecture {\r\n                background: url(../img/tecture-white-orange.png) top left;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 1000px) {\r\n    footer span {\r\n        display: none;\r\n    }\r\n}\r\n@media only screen and (min-width: 768px) {\r\n    footer { \r\n        .tecture-logo {\r\n            width: 1px;\r\n\t        float: right;\r\n\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@media only screen and (max-width: 1023px) {\r\n    \r\n}\r\n\r\n@media only screen and (max-width: 979px) { \r\n    footer {\r\n      .footer-menu {\r\n        a {\r\n          width: 28.56%;\r\n        }\r\n      }\r\n    }\r\n}\r\n\r\n\r\n@media only screen and (max-width: 767px) {\r\n    footer { \r\n        .tecture-logo {\r\n            display: block;\r\n            text-align: center;\r\n            margin-top: 20px;\r\n            .tecture {\r\n                float: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 599px) {\r\n    footer {\r\n      .footer-menu {\r\n        a {\r\n          width: 50%;\r\n        }\r\n      }\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 499px) {\r\n\r\n}\r\n\r\n@media only screen and (max-width: 399px) {\r\n\r\n}\r\n*/\n/***********************************************\r\nEmail Delivery\r\n***********************************************/\n.email-delivery-section.saved .message {\n  position: absolute;\n  top: -2px;\n  right: 15px;\n  background: #575757;\n  padding: 3px 20px;\n  color: #ffffff;\n  border-radius: 3px;\n  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.43);\n  line-height: 23px; }\n"

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(566);
/**!
* tippy.js v4.3.0
* (c) 2017-2019 atomiks
* MIT License
*/


var css = ".tippy-iOS{cursor:pointer!important;-webkit-tap-highlight-color:transparent}.tippy-popper{transition-timing-function:cubic-bezier(.165,.84,.44,1);max-width:calc(100% - 8px);pointer-events:none;outline:0}.tippy-popper[x-placement^=top] .tippy-backdrop{border-radius:40% 40% 0 0}.tippy-popper[x-placement^=top] .tippy-roundarrow{bottom:-7px;bottom:-6.5px;-webkit-transform-origin:50% 0;transform-origin:50% 0;margin:0 3px}.tippy-popper[x-placement^=top] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.tippy-popper[x-placement^=top] .tippy-arrow{border-top:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;bottom:-7px;margin:0 3px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-backdrop{-webkit-transform-origin:0 25%;transform-origin:0 25%}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-55%);transform:scale(1) translate(-50%,-55%)}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%,-45%);transform:scale(.2) translate(-50%,-45%);opacity:0}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(-20px);transform:translateY(-20px)}.tippy-popper[x-placement^=top] [data-animation=perspective]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateY(-10px) rotateX(0);transform:perspective(700px) translateY(-10px) rotateX(0)}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) translateY(0) rotateX(60deg);transform:perspective(700px) translateY(0) rotateX(60deg)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=top] [data-animation=scale]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(-10px) scale(1);transform:translateY(-10px) scale(1)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px) scale(.5);transform:translateY(-10px) scale(.5)}.tippy-popper[x-placement^=bottom] .tippy-backdrop{border-radius:0 0 30% 30%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow{top:-7px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%;margin:0 3px}.tippy-popper[x-placement^=bottom] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(0);transform:rotate(0)}.tippy-popper[x-placement^=bottom] .tippy-arrow{border-bottom:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;top:-7px;margin:0 3px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-backdrop{-webkit-transform-origin:0 -50%;transform-origin:0 -50%}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-45%);transform:scale(1) translate(-50%,-45%)}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%);transform:scale(.2) translate(-50%);opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateY(10px) rotateX(0);transform:perspective(700px) translateY(10px) rotateX(0)}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) translateY(0) rotateX(-60deg);transform:perspective(700px) translateY(0) rotateX(-60deg)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=bottom] [data-animation=scale]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(10px) scale(1);transform:translateY(10px) scale(1)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px) scale(.5);transform:translateY(10px) scale(.5)}.tippy-popper[x-placement^=left] .tippy-backdrop{border-radius:50% 0 0 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow{right:-12px;-webkit-transform-origin:33.33333333% 50%;transform-origin:33.33333333% 50%;margin:3px 0}.tippy-popper[x-placement^=left] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.tippy-popper[x-placement^=left] .tippy-arrow{border-left:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;right:-7px;margin:3px 0;-webkit-transform-origin:0 50%;transform-origin:0 50%}.tippy-popper[x-placement^=left] .tippy-backdrop{-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-75%,-50%);transform:scale(.2) translate(-75%,-50%);opacity:0}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(-20px);transform:translateX(-20px)}.tippy-popper[x-placement^=left] [data-animation=perspective]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateX(-10px) rotateY(0);transform:perspective(700px) translateX(-10px) rotateY(0)}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) translateX(0) rotateY(-60deg);transform:perspective(700px) translateX(0) rotateY(-60deg)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=left] [data-animation=scale]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(-10px) scale(1);transform:translateX(-10px) scale(1)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px) scale(.5);transform:translateX(-10px) scale(.5)}.tippy-popper[x-placement^=right] .tippy-backdrop{border-radius:0 50% 50% 0}.tippy-popper[x-placement^=right] .tippy-roundarrow{left:-12px;-webkit-transform-origin:66.66666666% 50%;transform-origin:66.66666666% 50%;margin:3px 0}.tippy-popper[x-placement^=right] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.tippy-popper[x-placement^=right] .tippy-arrow{border-right:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;left:-7px;margin:3px 0;-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.tippy-popper[x-placement^=right] .tippy-backdrop{-webkit-transform-origin:-50% 0;transform-origin:-50% 0}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-25%,-50%);transform:scale(.2) translate(-25%,-50%);opacity:0}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(20px);transform:translateX(20px)}.tippy-popper[x-placement^=right] [data-animation=perspective]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateX(10px) rotateY(0);transform:perspective(700px) translateX(10px) rotateY(0)}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) translateX(0) rotateY(60deg);transform:perspective(700px) translateX(0) rotateY(60deg)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=right] [data-animation=scale]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(10px) scale(1);transform:translateX(10px) scale(1)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px) scale(.5);transform:translateX(10px) scale(.5)}.tippy-tooltip{position:relative;color:#fff;border-radius:.25rem;font-size:.875rem;padding:.3125rem .5625rem;line-height:1.4;text-align:center;background-color:#333}.tippy-tooltip[data-size=small]{padding:.1875rem .375rem;font-size:.75rem}.tippy-tooltip[data-size=large]{padding:.375rem .75rem;font-size:1rem}.tippy-tooltip[data-animatefill]{overflow:hidden;background-color:transparent}.tippy-tooltip[data-interactive],.tippy-tooltip[data-interactive] path{pointer-events:auto}.tippy-tooltip[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-tooltip[data-inertia][data-state=hidden]{transition-timing-function:ease}.tippy-arrow,.tippy-roundarrow{position:absolute;width:0;height:0}.tippy-roundarrow{width:18px;height:7px;fill:#333;pointer-events:none}.tippy-backdrop{position:absolute;background-color:#333;border-radius:50%;width:calc(110% + 2rem);left:50%;top:50%;z-index:-1;transition:all cubic-bezier(.46,.1,.52,.98);-webkit-backface-visibility:hidden;backface-visibility:hidden}.tippy-backdrop:after{content:\"\";float:left;padding-top:100%}.tippy-backdrop+.tippy-content{transition-property:opacity;will-change:opacity}.tippy-backdrop+.tippy-content[data-state=visible]{opacity:1}.tippy-backdrop+.tippy-content[data-state=hidden]{opacity:0}";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var version = "4.3.0";

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var ua = isBrowser ? navigator.userAgent : '';
var isIE = /MSIE |Trident\//.test(ua);
var isUCBrowser = /UCBrowser\//.test(ua);
var isIOS = isBrowser && /iPhone|iPad|iPod/.test(navigator.platform) && !window.MSStream;

var defaultProps = {
  a11y: true,
  allowHTML: true,
  animateFill: true,
  animation: 'shift-away',
  appendTo: function appendTo() {
    return document.body;
  },
  aria: 'describedby',
  arrow: false,
  arrowType: 'sharp',
  boundary: 'scrollParent',
  content: '',
  delay: 0,
  distance: 10,
  duration: [325, 275],
  flip: true,
  flipBehavior: 'flip',
  flipOnUpdate: false,
  followCursor: false,
  hideOnClick: true,
  ignoreAttributes: false,
  inertia: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  lazy: true,
  maxWidth: 350,
  multiple: false,
  offset: 0,
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  placement: 'top',
  popperOptions: {},
  role: 'tooltip',
  showOnInit: false,
  size: 'regular',
  sticky: false,
  target: '',
  theme: 'dark',
  touch: true,
  touchHold: false,
  trigger: 'mouseenter focus',
  triggerTarget: null,
  updateDuration: 0,
  wait: null,
  zIndex: 9999
  /**
   * If the set() method encounters one of these, the popperInstance must be
   * recreated
   */

};
var POPPER_INSTANCE_DEPENDENCIES = ['arrow', 'arrowType', 'boundary', 'distance', 'flip', 'flipBehavior', 'flipOnUpdate', 'offset', 'placement', 'popperOptions'];

var elementProto = isBrowser ? Element.prototype : {};
var matches = elementProto.matches || elementProto.matchesSelector || elementProto.webkitMatchesSelector || elementProto.mozMatchesSelector || elementProto.msMatchesSelector;
/**
 * Ponyfill for Array.from - converts iterable values to an array
 */

function arrayFrom(value) {
  return [].slice.call(value);
}
/**
 * Ponyfill for Element.prototype.closest
 */

function closest(element, selector) {
  return closestCallback(element, function (el) {
    return matches.call(el, selector);
  });
}
/**
 * Works like Element.prototype.closest, but uses a callback instead
 */

function closestCallback(element, callback) {
  while (element) {
    if (callback(element)) {
      return element;
    }

    element = element.parentElement;
  }

  return null;
}

// Passive event listener config
var PASSIVE = {
  passive: true // Popper `preventOverflow` padding

};
var PADDING = 4; // Popper attributes
// In Popper v2 these will be `data-*` instead of `x-*` to adhere to HTML5 spec

var PLACEMENT_ATTRIBUTE = 'x-placement';
var OUT_OF_BOUNDARIES_ATTRIBUTE = 'x-out-of-boundaries'; // Classes

var IOS_CLASS = 'tippy-iOS';
var ACTIVE_CLASS = 'tippy-active'; // Selectors

var POPPER_SELECTOR = '.tippy-popper';
var TOOLTIP_SELECTOR = '.tippy-tooltip';
var CONTENT_SELECTOR = '.tippy-content';
var BACKDROP_SELECTOR = '.tippy-backdrop';
var ARROW_SELECTOR = '.tippy-arrow';
var ROUND_ARROW_SELECTOR = '.tippy-roundarrow';

var keys = Object.keys(defaultProps);
/**
 * Returns an object of optional props from data-tippy-* attributes
 */

function getDataAttributeOptions(reference) {
  return keys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-".concat(key)) || '').trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
}
/**
 * Polyfills the virtual reference (plain object) with Element.prototype props
 * Mutating because DOM elements are mutated, adds `_tippy` property
 */

function polyfillElementPrototypeProperties(virtualReference) {
  var polyfills = {
    isVirtual: true,
    attributes: virtualReference.attributes || {},
    setAttribute: function setAttribute(key, value) {
      virtualReference.attributes[key] = value;
    },
    getAttribute: function getAttribute(key) {
      return virtualReference.attributes[key];
    },
    removeAttribute: function removeAttribute(key) {
      delete virtualReference.attributes[key];
    },
    hasAttribute: function hasAttribute(key) {
      return key in virtualReference.attributes;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    classList: {
      classNames: {},
      add: function add(key) {
        virtualReference.classList.classNames[key] = true;
      },
      remove: function remove(key) {
        delete virtualReference.classList.classNames[key];
      },
      contains: function contains(key) {
        return key in virtualReference.classList.classNames;
      }
    }
  };

  for (var key in polyfills) {
    virtualReference[key] = polyfills[key];
  }
}

/**
 * Determines if a value is a "bare" virtual element (before mutations done
 * by `polyfillElementPrototypeProperties()`). JSDOM elements show up as
 * [object Object], we can check if the value is "element-like" if it has
 * `addEventListener`
 */

function isBareVirtualElement(value) {
  return {}.toString.call(value) === '[object Object]' && !value.addEventListener;
}
/**
 * Determines if the value is a reference element
 */

function isReferenceElement(value) {
  return !!value._tippy && !matches.call(value, POPPER_SELECTOR);
}
/**
 * Safe .hasOwnProperty check, for prototype-less objects
 */

function hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
/**
 * Returns an array of elements based on the value
 */

function getArrayOfElements(value) {
  if (isSingular(value)) {
    // TODO: VirtualReference is not compatible to type Element
    return [value];
  }

  if (value instanceof NodeList) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  try {
    return arrayFrom(document.querySelectorAll(value));
  } catch (e) {
    return [];
  }
}
/**
 * Returns a value at a given index depending on if it's an array or number
 */

function getValue(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? defaultValue : v;
  }

  return value;
}
/**
 * Debounce utility
 */

function debounce(fn, ms) {
  var timeoutId;
  return function () {
    var _this = this,
        _arguments = arguments;

    clearTimeout(timeoutId); // @ts-ignore

    timeoutId = setTimeout(function () {
      return fn.apply(_this, _arguments);
    }, ms);
  };
}
/**
 * Prevents errors from being thrown while accessing nested modifier objects
 * in `popperOptions`
 */

function getModifier(obj, key) {
  return obj && obj.modifiers && obj.modifiers[key];
}
/**
 * Determines if an array or string includes a value
 */

function includes(a, b) {
  return a.indexOf(b) > -1;
}
/**
 * Determines if the value is a real element
 */

function isRealElement(value) {
  return value instanceof Element;
}
/**
 * Determines if the value is singular-like
 */

function isSingular(value) {
  return !!(value && hasOwnProperty(value, 'isVirtual')) || isRealElement(value);
}
/**
 * Firefox extensions don't allow setting .innerHTML directly, this will trick it
 */

function innerHTML() {
  return 'innerHTML';
}
/**
 * Evaluates a function if one, or returns the value
 */

function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(null, args) : value;
}
/**
 * Sets a popperInstance `flip` modifier's enabled state
 */

function setFlipModifierEnabled(modifiers, value) {
  modifiers.filter(function (m) {
    return m.name === 'flip';
  })[0].enabled = value;
}
/**
 * Determines if an element can receive focus
 * Always returns true for virtual objects
 */

function canReceiveFocus(element) {
  return element instanceof Element ? matches.call(element, 'a[href],area[href],button,details,input,textarea,select,iframe,[tabindex]') && !element.hasAttribute('disabled') : true;
}
/**
 * Returns a new `div` element
 */

function div() {
  return document.createElement('div');
}
/**
 * Applies a transition duration to a list of elements
 */

function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = "".concat(value, "ms");
    }
  });
}
/**
 * Sets the visibility state to elements so they can begin to transition
 */

function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
/**
 * Evaluates the props object by merging data attributes and
 * disabling conflicting options where necessary
 */

function evaluateProps(reference, props) {
  var out = _extends({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeOptions(reference));

  if (out.arrow || isUCBrowser) {
    out.animateFill = false;
  }

  return out;
}
/**
 * Validates an object of options with the valid default props object
 */

function validateOptions(options, defaultProps) {
  Object.keys(options).forEach(function (option) {
    if (!hasOwnProperty(defaultProps, option)) {
      throw new Error("[tippy]: `".concat(option, "` is not a valid option"));
    }
  });
}

/**
 * Sets the innerHTML of an element
 */

function setInnerHTML(element, html) {
  element[innerHTML()] = html instanceof Element ? html[innerHTML()] : html;
}
/**
 * Sets the content of a tooltip
 */

function setContent(contentEl, props) {
  if (props.content instanceof Element) {
    setInnerHTML(contentEl, '');
    contentEl.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    var key = props.allowHTML ? 'innerHTML' : 'textContent';
    contentEl[key] = props.content;
  }
}
/**
 * Returns the child elements of a popper element
 */

function getChildren(popper) {
  return {
    tooltip: popper.querySelector(TOOLTIP_SELECTOR),
    backdrop: popper.querySelector(BACKDROP_SELECTOR),
    content: popper.querySelector(CONTENT_SELECTOR),
    arrow: popper.querySelector(ARROW_SELECTOR) || popper.querySelector(ROUND_ARROW_SELECTOR)
  };
}
/**
 * Adds `data-inertia` attribute
 */

function addInertia(tooltip) {
  tooltip.setAttribute('data-inertia', '');
}
/**
 * Removes `data-inertia` attribute
 */

function removeInertia(tooltip) {
  tooltip.removeAttribute('data-inertia');
}
/**
 * Creates an arrow element and returns it
 */

function createArrowElement(arrowType) {
  var arrow = div();

  if (arrowType === 'round') {
    arrow.className = 'tippy-roundarrow';
    setInnerHTML(arrow, '<svg viewBox="0 0 18 7" xmlns="http://www.w3.org/2000/svg"><path d="M0 7s2.021-.015 5.253-4.218C6.584 1.051 7.797.007 9 0c1.203-.007 2.416 1.035 3.761 2.782C16.012 7.005 18 7 18 7H0z"/></svg>');
  } else {
    arrow.className = 'tippy-arrow';
  }

  return arrow;
}
/**
 * Creates a backdrop element and returns it
 */

function createBackdropElement() {
  var backdrop = div();
  backdrop.className = 'tippy-backdrop';
  backdrop.setAttribute('data-state', 'hidden');
  return backdrop;
}
/**
 * Adds interactive-related attributes
 */

function addInteractive(popper, tooltip) {
  popper.setAttribute('tabindex', '-1');
  tooltip.setAttribute('data-interactive', '');
}
/**
 * Removes interactive-related attributes
 */

function removeInteractive(popper, tooltip) {
  popper.removeAttribute('tabindex');
  tooltip.removeAttribute('data-interactive');
}
/**
 * Add/remove transitionend listener from tooltip
 */

function updateTransitionEndListener(tooltip, action, listener) {
  // UC Browser hasn't adopted the `transitionend` event despite supporting
  // unprefixed transitions...
  var eventName = isUCBrowser && document.body.style.webkitTransition !== undefined ? 'webkitTransitionEnd' : 'transitionend';
  tooltip[action + 'EventListener'](eventName, listener);
}
/**
 * Returns the popper's placement, ignoring shifting (top-start, etc)
 */

function getBasicPlacement(popper) {
  var fullPlacement = popper.getAttribute(PLACEMENT_ATTRIBUTE);
  return fullPlacement ? fullPlacement.split('-')[0] : '';
}
/**
 * Triggers reflow
 */

function reflow(popper) {
  void popper.offsetHeight;
}
/**
 * Adds/removes theme from tooltip's classList
 */

function updateTheme(tooltip, action, theme) {
  theme.split(' ').forEach(function (themeName) {
    tooltip.classList[action](themeName + '-theme');
  });
}
/**
 * Constructs the popper element and returns it
 */

function createPopperElement(id, props) {
  var popper = div();
  popper.className = 'tippy-popper';
  popper.id = "tippy-".concat(id);
  popper.style.zIndex = '' + props.zIndex;

  if (props.role) {
    popper.setAttribute('role', props.role);
  }

  var tooltip = div();
  tooltip.className = 'tippy-tooltip';
  tooltip.style.maxWidth = props.maxWidth + (typeof props.maxWidth === 'number' ? 'px' : '');
  tooltip.setAttribute('data-size', props.size);
  tooltip.setAttribute('data-animation', props.animation);
  tooltip.setAttribute('data-state', 'hidden');
  updateTheme(tooltip, 'add', props.theme);
  var content = div();
  content.className = 'tippy-content';
  content.setAttribute('data-state', 'hidden');

  if (props.interactive) {
    addInteractive(popper, tooltip);
  }

  if (props.arrow) {
    tooltip.appendChild(createArrowElement(props.arrowType));
  }

  if (props.animateFill) {
    tooltip.appendChild(createBackdropElement());
    tooltip.setAttribute('data-animatefill', '');
  }

  if (props.inertia) {
    addInertia(tooltip);
  }

  setContent(content, props);
  tooltip.appendChild(content);
  popper.appendChild(tooltip);
  return popper;
}
/**
 * Updates the popper element based on the new props
 */

function updatePopperElement(popper, prevProps, nextProps) {
  var _getChildren = getChildren(popper),
      tooltip = _getChildren.tooltip,
      content = _getChildren.content,
      backdrop = _getChildren.backdrop,
      arrow = _getChildren.arrow;

  popper.style.zIndex = '' + nextProps.zIndex;
  tooltip.setAttribute('data-size', nextProps.size);
  tooltip.setAttribute('data-animation', nextProps.animation);
  tooltip.style.maxWidth = nextProps.maxWidth + (typeof nextProps.maxWidth === 'number' ? 'px' : '');

  if (nextProps.role) {
    popper.setAttribute('role', nextProps.role);
  } else {
    popper.removeAttribute('role');
  }

  if (prevProps.content !== nextProps.content) {
    setContent(content, nextProps);
  } // animateFill


  if (!prevProps.animateFill && nextProps.animateFill) {
    tooltip.appendChild(createBackdropElement());
    tooltip.setAttribute('data-animatefill', '');
  } else if (prevProps.animateFill && !nextProps.animateFill) {
    tooltip.removeChild(backdrop);
    tooltip.removeAttribute('data-animatefill');
  } // arrow


  if (!prevProps.arrow && nextProps.arrow) {
    tooltip.appendChild(createArrowElement(nextProps.arrowType));
  } else if (prevProps.arrow && !nextProps.arrow) {
    tooltip.removeChild(arrow);
  } // arrowType


  if (prevProps.arrow && nextProps.arrow && prevProps.arrowType !== nextProps.arrowType) {
    tooltip.replaceChild(createArrowElement(nextProps.arrowType), arrow);
  } // interactive


  if (!prevProps.interactive && nextProps.interactive) {
    addInteractive(popper, tooltip);
  } else if (prevProps.interactive && !nextProps.interactive) {
    removeInteractive(popper, tooltip);
  } // inertia


  if (!prevProps.inertia && nextProps.inertia) {
    addInertia(tooltip);
  } else if (prevProps.inertia && !nextProps.inertia) {
    removeInertia(tooltip);
  } // theme


  if (prevProps.theme !== nextProps.theme) {
    updateTheme(tooltip, 'remove', prevProps.theme);
    updateTheme(tooltip, 'add', nextProps.theme);
  }
}
/**
 * Hides all visible poppers on the document
 */

function hideAll() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      checkHideOnClick = _ref.checkHideOnClick,
      excludedReferenceOrInstance = _ref.exclude,
      duration = _ref.duration;

  arrayFrom(document.querySelectorAll(POPPER_SELECTOR)).forEach(function (popper) {
    var instance = popper._tippy;

    if (instance) {
      var shouldHideDueToHideOnClickOption = checkHideOnClick ? instance.props.hideOnClick === true : true;
      var isExcluded = false;

      if (excludedReferenceOrInstance) {
        isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : popper === excludedReferenceOrInstance.popper;
      }

      if (shouldHideDueToHideOnClickOption && !isExcluded) {
        instance.hide(duration);
      }
    }
  });
}
/**
 * Determines if the mouse cursor is outside of the popper's interactive border
 * region
 */

function isCursorOutsideInteractiveBorder(popperPlacement, popperRect, event, props) {
  if (!popperPlacement) {
    return true;
  }

  var x = event.clientX,
      y = event.clientY;
  var interactiveBorder = props.interactiveBorder,
      distance = props.distance;
  var exceedsTop = popperRect.top - y > (popperPlacement === 'top' ? interactiveBorder + distance : interactiveBorder);
  var exceedsBottom = y - popperRect.bottom > (popperPlacement === 'bottom' ? interactiveBorder + distance : interactiveBorder);
  var exceedsLeft = popperRect.left - x > (popperPlacement === 'left' ? interactiveBorder + distance : interactiveBorder);
  var exceedsRight = x - popperRect.right > (popperPlacement === 'right' ? interactiveBorder + distance : interactiveBorder);
  return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
}
/**
 * Returns the distance offset, taking into account the default offset due to
 * the transform: translate() rule (10px) in CSS
 */

function getOffsetDistanceInPx(distance) {
  return -(distance - 10) + 'px';
}

var isUsingTouch = false;
function onDocumentTouch() {
  if (isUsingTouch) {
    return;
  }

  isUsingTouch = true;

  if (isIOS) {
    document.body.classList.add(IOS_CLASS);
  }

  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
var lastMouseMoveTime = 0;
function onDocumentMouseMove() {
  var now = performance.now(); // Chrome 60+ is 1 mousemove per animation frame, use 20ms time difference

  if (now - lastMouseMoveTime < 20) {
    isUsingTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);

    if (!isIOS) {
      document.body.classList.remove(IOS_CLASS);
    }
  }

  lastMouseMoveTime = now;
}
function onDocumentClick(event) {
  // Simulated events dispatched on the document
  if (!(event.target instanceof Element)) {
    return hideAll();
  } // Clicked on an interactive popper


  var popper = closest(event.target, POPPER_SELECTOR);

  if (popper && popper._tippy && popper._tippy.props.interactive) {
    return;
  } // Clicked on a reference


  var reference = closestCallback(event.target, function (el) {
    return el._tippy && el._tippy.reference === el;
  });

  if (reference) {
    var instance = reference._tippy;

    if (instance) {
      var isClickTrigger = includes(instance.props.trigger || '', 'click');

      if (isUsingTouch || isClickTrigger) {
        return hideAll({
          exclude: reference,
          checkHideOnClick: true
        });
      }

      if (instance.props.hideOnClick !== true || isClickTrigger) {
        return;
      }

      instance.clearDelayTimeouts();
    }
  }

  hideAll({
    checkHideOnClick: true
  });
}
function onWindowBlur() {
  var _document = document,
      activeElement = _document.activeElement;

  if (activeElement && activeElement.blur && activeElement._tippy) {
    activeElement.blur();
  }
}
/**
 * Adds the needed global event listeners
 */

function bindGlobalEventListeners() {
  document.addEventListener('click', onDocumentClick, true);
  document.addEventListener('touchstart', onDocumentTouch, PASSIVE);
  window.addEventListener('blur', onWindowBlur);
}

var idCounter = 1;
/**
 * Creates and returns a Tippy object. We're using a closure pattern instead of
 * a class so that the exposed object API is clean without private members
 * prefixed with `_`.
 */

function createTippy(reference, collectionProps) {
  var props = evaluateProps(reference, collectionProps); // If the reference shouldn't have multiple tippys, return null early

  if (!props.multiple && reference._tippy) {
    return null;
  }
  /* ======================= 🔒 Private members 🔒 ======================= */


  var lastTriggerEventType;
  var lastMouseMoveEvent;
  var showTimeoutId;
  var hideTimeoutId;
  var animationFrameId;
  var isScheduledToShow = false;
  var currentParentNode;
  var previousPlacement;
  var wasVisibleDuringPreviousUpdate = false;
  var hasMountCallbackRun = false;
  var currentMountCallback;
  var currentTransitionEndListener;
  var listeners = [];
  var currentComputedPadding;
  var debouncedOnMouseMove = props.interactiveDebounce > 0 ? debounce(onMouseMove, props.interactiveDebounce) : onMouseMove;
  /* ======================= 🔑 Public members 🔑 ======================= */

  var id = idCounter++;
  var popper = createPopperElement(id, props);
  var popperChildren = getChildren(popper);
  var popperInstance = null;
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: popper,
    popperChildren: popperChildren,
    popperInstance: popperInstance,
    props: props,
    state: state,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    set: set,
    setContent: setContent,
    show: show,
    hide: hide,
    enable: enable,
    disable: disable,
    destroy: destroy
    /* ==================== Initial instance mutations =================== */

  };
  reference._tippy = instance;
  popper._tippy = instance;
  getEventListenersTarget()._tippy = instance;
  addTriggersToReference();

  if (!props.lazy) {
    createPopperInstance();
  }

  if (props.showOnInit) {
    scheduleShow();
  } // Ensure the reference element can receive focus (and is not a delegate)


  if (props.a11y && !props.target && !canReceiveFocus(reference)) {
    getEventListenersTarget().setAttribute('tabindex', '0');
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding


  popper.addEventListener('mouseenter', function (event) {
    if (instance.props.interactive && instance.state.isVisible && lastTriggerEventType === 'mouseenter') {
      // We don't want props.onTrigger() to be called here, since the `event`
      // object is not related to the reference element
      scheduleShow(event, true);
    }
  });
  popper.addEventListener('mouseleave', function () {
    if (instance.props.interactive && lastTriggerEventType === 'mouseenter') {
      document.addEventListener('mousemove', debouncedOnMouseMove);
    }
  });
  return instance;
  /* ======================= 🔒 Private methods 🔒 ======================= */

  /**
   * Removes the follow cursor listener
   */

  function removeFollowCursorListener() {
    document.removeEventListener('mousemove', positionVirtualReferenceNearCursor);
  }
  /**
   * Cleans up old listeners
   */


  function cleanupOldMouseListeners() {
    document.body.removeEventListener('mouseleave', scheduleHide);
    document.removeEventListener('mousemove', debouncedOnMouseMove);
  }
  /**
   * Returns correct target used for event listeners
   */


  function getEventListenersTarget() {
    return instance.props.triggerTarget || reference;
  }
  /**
   * Returns transitionable inner elements used in show/hide methods
   */


  function getTransitionableElements() {
    return [instance.popperChildren.tooltip, instance.popperChildren.backdrop, instance.popperChildren.content];
  }
  /**
   * Determines if the instance is in `followCursor` mode
   */


  function hasFollowCursorBehavior() {
    return instance.props.followCursor && !isUsingTouch && lastTriggerEventType !== 'focus';
  }
  /**
   * Updates the tooltip's position on each animation frame
   */


  function makeSticky() {
    setTransitionDuration([popper], isIE ? 0 : instance.props.updateDuration);

    function updatePosition() {
      instance.popperInstance.scheduleUpdate();

      if (instance.state.isMounted) {
        requestAnimationFrame(updatePosition);
      } else {
        setTransitionDuration([popper], 0);
      }
    }

    updatePosition();
  }
  /**
   * Invokes a callback once the tooltip has fully transitioned out
   */


  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && currentParentNode && currentParentNode.contains(popper)) {
        callback();
      }
    });
  }
  /**
   * Invokes a callback once the tooltip has fully transitioned in
   */


  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }
  /**
   * Invokes a callback once the tooltip's CSS transition ends
   */


  function onTransitionEnd(duration, callback) {
    var tooltip = instance.popperChildren.tooltip;
    /**
     * Listener added as the `transitionend` handler
     */

    function listener(event) {
      if (event.target === tooltip) {
        updateTransitionEndListener(tooltip, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise


    if (duration === 0) {
      return callback();
    }

    updateTransitionEndListener(tooltip, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(tooltip, 'add', listener);
    currentTransitionEndListener = listener;
  }
  /**
   * Adds an event listener to the reference and stores it in `listeners`
   */


  function on(eventType, handler) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    getEventListenersTarget().addEventListener(eventType, handler, options);
    listeners.push({
      eventType: eventType,
      handler: handler,
      options: options
    });
  }
  /**
   * Adds event listeners to the reference based on the `trigger` prop
   */


  function addTriggersToReference() {
    if (instance.props.touchHold && !instance.props.target) {
      on('touchstart', onTrigger, PASSIVE);
      on('touchend', onMouseLeave, PASSIVE);
    }

    instance.props.trigger.trim().split(' ').forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      } // Non-delegates


      if (!instance.props.target) {
        on(eventType, onTrigger);

        switch (eventType) {
          case 'mouseenter':
            on('mouseleave', onMouseLeave);
            break;

          case 'focus':
            on(isIE ? 'focusout' : 'blur', onBlur);
            break;
        }
      } else {
        // Delegates
        switch (eventType) {
          case 'mouseenter':
            on('mouseover', onDelegateShow);
            on('mouseout', onDelegateHide);
            break;

          case 'focus':
            on('focusin', onDelegateShow);
            on('focusout', onDelegateHide);
            break;

          case 'click':
            on(eventType, onDelegateShow);
            break;
        }
      }
    });
  }
  /**
   * Removes event listeners from the reference
   */


  function removeTriggersFromReference() {
    listeners.forEach(function (_ref) {
      var eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      getEventListenersTarget().removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }
  /**
   * Returns corrected preventOverflow padding if the instance has an arrow
   */


  function getCorrectedPadding(placement) {
    return instance.props.arrow ? currentComputedPadding[placement] + (instance.props.arrowType === 'round' ? 18 : 16) : currentComputedPadding[placement];
  }
  /**
   * Positions the virtual reference near the cursor
   */


  function positionVirtualReferenceNearCursor(event) {
    var _lastMouseMoveEvent = lastMouseMoveEvent = event,
        clientX = _lastMouseMoveEvent.clientX,
        clientY = _lastMouseMoveEvent.clientY; // Gets set once popperInstance `onCreate` has been called


    if (!currentComputedPadding) {
      return;
    }

    var rect = reference.getBoundingClientRect();
    var followCursor = instance.props.followCursor;
    var isHorizontal = followCursor === 'horizontal';
    var isVertical = followCursor === 'vertical'; // Ensure virtual reference is padded to prevent tooltip from overflowing.
    // Seems to be a Popper.js issue

    var placement = getBasicPlacement(popper);
    var isVerticalPlacement = includes(['top', 'bottom'], placement);
    var isHorizontalPlacement = includes(['left', 'right'], placement);

    var padding = _extends({}, currentComputedPadding);

    if (isVerticalPlacement) {
      padding.left = getCorrectedPadding('left');
      padding.right = getCorrectedPadding('right');
    }

    if (isHorizontalPlacement) {
      padding.top = getCorrectedPadding('top');
      padding.bottom = getCorrectedPadding('bottom');
    } // TODO: Remove the following later if Popper.js changes/fixes the
    // behavior
    // Top / left boundary


    var x = isVerticalPlacement ? Math.max(padding.left, clientX) : clientX;
    var y = isHorizontalPlacement ? Math.max(padding.top, clientY) : clientY; // Bottom / right boundary

    if (isVerticalPlacement && x > padding.right) {
      x = Math.min(clientX, window.innerWidth - padding.right);
    }

    if (isHorizontalPlacement && y > padding.bottom) {
      y = Math.min(clientY, window.innerHeight - padding.bottom);
    } // If the instance is interactive, avoid updating the position unless it's
    // over the reference element


    var isCursorOverReference = closestCallback(event.target, function (el) {
      return el === reference;
    });

    if (isCursorOverReference || !instance.props.interactive) {
      instance.popperInstance.reference = _extends({}, instance.popperInstance.reference, {
        getBoundingClientRect: function getBoundingClientRect() {
          return {
            width: 0,
            height: 0,
            top: isHorizontal ? rect.top : y,
            bottom: isHorizontal ? rect.bottom : y,
            left: isVertical ? rect.left : x,
            right: isVertical ? rect.right : x
          };
        },
        clientWidth: 0,
        clientHeight: 0
      });
      instance.popperInstance.scheduleUpdate();
    }

    if (followCursor === 'initial' && instance.state.isVisible) {
      removeFollowCursorListener();
    }
  }
  /**
   * Creates the tippy instance for a delegate when it's been triggered
   */


  function createDelegateChildTippy(event) {
    if (event) {
      var targetEl = closest(event.target, instance.props.target);

      if (targetEl && !targetEl._tippy) {
        createTippy(targetEl, _extends({}, instance.props, {
          content: invokeWithArgsOrReturn(collectionProps.content, [targetEl]),
          appendTo: collectionProps.appendTo,
          target: '',
          showOnInit: true
        }));
      }
    }
  }
  /**
   * Event listener invoked upon trigger
   */


  function onTrigger(event) {
    if (!instance.state.isEnabled || isEventListenerStopped(event)) {
      return;
    }

    if (!instance.state.isVisible) {
      lastTriggerEventType = event.type;

      if (event instanceof MouseEvent) {
        lastMouseMoveEvent = event;
      }
    } // Toggle show/hide when clicking click-triggered tooltips


    if (event.type === 'click' && instance.props.hideOnClick !== false && instance.state.isVisible) {
      scheduleHide();
    } else {
      scheduleShow(event);
    }
  }
  /**
   * Event listener used for interactive tooltips to detect when they should
   * hide
   */


  function onMouseMove(event) {
    var referenceTheCursorIsOver = closestCallback(event.target, function (el) {
      return el._tippy;
    });
    var isCursorOverPopper = closest(event.target, POPPER_SELECTOR) === popper;
    var isCursorOverReference = referenceTheCursorIsOver === reference;

    if (isCursorOverPopper || isCursorOverReference) {
      return;
    }

    if (isCursorOutsideInteractiveBorder(getBasicPlacement(popper), popper.getBoundingClientRect(), event, instance.props)) {
      cleanupOldMouseListeners();
      scheduleHide();
    }
  }
  /**
   * Event listener invoked upon mouseleave
   */


  function onMouseLeave(event) {
    if (isEventListenerStopped(event)) {
      return;
    }

    if (instance.props.interactive) {
      document.body.addEventListener('mouseleave', scheduleHide);
      document.addEventListener('mousemove', debouncedOnMouseMove);
      return;
    }

    scheduleHide();
  }
  /**
   * Event listener invoked upon blur
   */


  function onBlur(event) {
    if (event.target !== getEventListenersTarget()) {
      return;
    }

    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide();
  }
  /**
   * Event listener invoked when a child target is triggered
   */


  function onDelegateShow(event) {
    if (closest(event.target, instance.props.target)) {
      scheduleShow(event);
    }
  }
  /**
   * Event listener invoked when a child target should hide
   */


  function onDelegateHide(event) {
    if (closest(event.target, instance.props.target)) {
      scheduleHide();
    }
  }
  /**
   * Determines if an event listener should stop further execution due to the
   * `touchHold` option
   */


  function isEventListenerStopped(event) {
    var supportsTouch = 'ontouchstart' in window;
    var isTouchEvent = includes(event.type, 'touch');
    var touchHold = instance.props.touchHold;
    return supportsTouch && isUsingTouch && touchHold && !isTouchEvent || isUsingTouch && !touchHold && isTouchEvent;
  }
  /**
   * Runs the mount callback
   */


  function runMountCallback() {
    if (!hasMountCallbackRun && currentMountCallback) {
      hasMountCallbackRun = true;
      reflow(popper);
      currentMountCallback();
    }
  }
  /**
   * Creates the popper instance for the instance
   */


  function createPopperInstance() {
    var popperOptions = instance.props.popperOptions;
    var _instance$popperChild = instance.popperChildren,
        tooltip = _instance$popperChild.tooltip,
        arrow = _instance$popperChild.arrow;
    var preventOverflowModifier = getModifier(popperOptions, 'preventOverflow');

    function applyMutations(data) {
      if (instance.props.flip && !instance.props.flipOnUpdate) {
        if (data.flipped) {
          instance.popperInstance.options.placement = data.placement;
        }

        setFlipModifierEnabled(instance.popperInstance.modifiers, false);
      } // Apply all of the popper's attributes to the tootip node as well.
      // Allows users to avoid using the .tippy-popper selector for themes.


      tooltip.setAttribute(PLACEMENT_ATTRIBUTE, data.placement);

      if (data.attributes[OUT_OF_BOUNDARIES_ATTRIBUTE] !== false) {
        tooltip.setAttribute(OUT_OF_BOUNDARIES_ATTRIBUTE, '');
      } else {
        tooltip.removeAttribute(OUT_OF_BOUNDARIES_ATTRIBUTE);
      } // Prevents a transition when changing placements (while tippy is visible)
      // for scroll/resize updates


      if (previousPlacement && previousPlacement !== data.placement && wasVisibleDuringPreviousUpdate) {
        tooltip.style.transition = 'none';
        requestAnimationFrame(function () {
          tooltip.style.transition = '';
        });
      }

      previousPlacement = data.placement;
      wasVisibleDuringPreviousUpdate = instance.state.isVisible;
      var basicPlacement = getBasicPlacement(popper);
      var styles = tooltip.style; // Account for the `distance` offset

      styles.top = styles.bottom = styles.left = styles.right = '';
      styles[basicPlacement] = getOffsetDistanceInPx(instance.props.distance);
      var padding = preventOverflowModifier && preventOverflowModifier.padding !== undefined ? preventOverflowModifier.padding : PADDING;
      var isPaddingNumber = typeof padding === 'number';

      var computedPadding = _extends({
        top: isPaddingNumber ? padding : padding.top,
        bottom: isPaddingNumber ? padding : padding.bottom,
        left: isPaddingNumber ? padding : padding.left,
        right: isPaddingNumber ? padding : padding.right
      }, !isPaddingNumber && padding);

      computedPadding[basicPlacement] = isPaddingNumber ? padding + instance.props.distance : (padding[basicPlacement] || 0) + instance.props.distance;
      instance.popperInstance.modifiers.filter(function (m) {
        return m.name === 'preventOverflow';
      })[0].padding = computedPadding;
      currentComputedPadding = computedPadding;
    }

    var config = _extends({
      eventsEnabled: false,
      placement: instance.props.placement
    }, popperOptions, {
      modifiers: _extends({}, popperOptions ? popperOptions.modifiers : {}, {
        preventOverflow: _extends({
          boundariesElement: instance.props.boundary,
          padding: PADDING
        }, preventOverflowModifier),
        arrow: _extends({
          element: arrow,
          enabled: !!arrow
        }, getModifier(popperOptions, 'arrow')),
        flip: _extends({
          enabled: instance.props.flip,
          // The tooltip is offset by 10px from the popper in CSS,
          // we need to account for its distance
          padding: instance.props.distance + PADDING,
          behavior: instance.props.flipBehavior
        }, getModifier(popperOptions, 'flip')),
        offset: _extends({
          offset: instance.props.offset
        }, getModifier(popperOptions, 'offset'))
      }),
      onCreate: function onCreate(data) {
        runMountCallback();
        applyMutations(data);

        if (popperOptions && popperOptions.onCreate) {
          popperOptions.onCreate(data);
        }
      },
      onUpdate: function onUpdate(data) {
        runMountCallback();
        applyMutations(data);

        if (popperOptions && popperOptions.onUpdate) {
          popperOptions.onUpdate(data);
        }
      }
    });

    instance.popperInstance = new __WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */](reference, popper, config);
  }
  /**
   * Mounts the tooltip to the DOM
   */


  function mount() {
    hasMountCallbackRun = false;
    var shouldEnableListeners = !hasFollowCursorBehavior() && !(instance.props.followCursor === 'initial' && isUsingTouch);

    if (!instance.popperInstance) {
      createPopperInstance();

      if (shouldEnableListeners) {
        instance.popperInstance.enableEventListeners();
      }
    } else {
      if (!hasFollowCursorBehavior()) {
        instance.popperInstance.scheduleUpdate();

        if (shouldEnableListeners) {
          instance.popperInstance.enableEventListeners();
        }
      }

      setFlipModifierEnabled(instance.popperInstance.modifiers, instance.props.flip);
    } // If the instance previously had followCursor behavior, it will be
    // positioned incorrectly if triggered by `focus` afterwards.
    // Update the reference back to the real DOM element


    instance.popperInstance.reference = reference;
    var arrow = instance.popperChildren.arrow;

    if (hasFollowCursorBehavior()) {
      if (arrow) {
        arrow.style.margin = '0';
      }

      if (lastMouseMoveEvent) {
        positionVirtualReferenceNearCursor(lastMouseMoveEvent);
      }
    } else if (arrow) {
      arrow.style.margin = '';
    } // Allow followCursor: 'initial' on touch devices


    if (isUsingTouch && lastMouseMoveEvent && instance.props.followCursor === 'initial') {
      positionVirtualReferenceNearCursor(lastMouseMoveEvent);

      if (arrow) {
        arrow.style.margin = '0';
      }
    }

    var appendTo = instance.props.appendTo;
    currentParentNode = appendTo === 'parent' ? reference.parentNode : invokeWithArgsOrReturn(appendTo, [reference]);

    if (!currentParentNode.contains(popper)) {
      currentParentNode.appendChild(popper);
      instance.props.onMount(instance);
      instance.state.isMounted = true;
    }
  }
  /**
   * Setup before show() is invoked (delays, etc.)
   */


  function scheduleShow(event, shouldAvoidCallingOnTrigger) {
    clearDelayTimeouts();

    if (instance.state.isVisible) {
      return;
    } // Is a delegate, create an instance for the child target


    if (instance.props.target) {
      return createDelegateChildTippy(event);
    }

    isScheduledToShow = true;

    if (event && !shouldAvoidCallingOnTrigger) {
      instance.props.onTrigger(instance, event);
    }

    if (instance.props.wait) {
      return instance.props.wait(instance, event);
    } // If the tooltip has a delay, we need to be listening to the mousemove as
    // soon as the trigger event is fired, so that it's in the correct position
    // upon mount.
    // Edge case: if the tooltip is still mounted, but then scheduleShow() is
    // called, it causes a jump.


    if (hasFollowCursorBehavior() && !instance.state.isMounted) {
      if (!instance.popperInstance) {
        createPopperInstance();
      }

      document.addEventListener('mousemove', positionVirtualReferenceNearCursor);
    }

    var delay = getValue(instance.props.delay, 0, defaultProps.delay);

    if (delay) {
      showTimeoutId = setTimeout(function () {
        show();
      }, delay);
    } else {
      show();
    }
  }
  /**
   * Setup before hide() is invoked (delays, etc.)
   */


  function scheduleHide() {
    clearDelayTimeouts();

    if (!instance.state.isVisible) {
      return removeFollowCursorListener();
    }

    isScheduledToShow = false;
    var delay = getValue(instance.props.delay, 1, defaultProps.delay);

    if (delay) {
      hideTimeoutId = setTimeout(function () {
        if (instance.state.isVisible) {
          hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      animationFrameId = requestAnimationFrame(function () {
        hide();
      });
    }
  }
  /* ======================= 🔑 Public methods 🔑 ======================= */

  /**
   * Enables the instance to allow it to show or hide
   */


  function enable() {
    instance.state.isEnabled = true;
  }
  /**
   * Disables the instance to disallow it to show or hide
   */


  function disable() {
    instance.state.isEnabled = false;
  }
  /**
   * Clears pending timeouts related to the `delay` prop if any
   */


  function clearDelayTimeouts() {
    clearTimeout(showTimeoutId);
    clearTimeout(hideTimeoutId);
    cancelAnimationFrame(animationFrameId);
  }
  /**
   * Sets new props for the instance and redraws the tooltip
   */


  function set(options) {
    // Backwards-compatible after TypeScript change
    options = options || {};
    validateOptions(options, defaultProps);
    removeTriggersFromReference();

    if (instance.props.triggerTarget) {
      delete instance.props.triggerTarget._tippy;
    }

    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, _extends({}, instance.props, options, {
      ignoreAttributes: true
    }));
    nextProps.ignoreAttributes = hasOwnProperty(options, 'ignoreAttributes') ? options.ignoreAttributes || false : prevProps.ignoreAttributes;
    instance.props = nextProps;
    getEventListenersTarget()._tippy = instance;
    addTriggersToReference();
    cleanupOldMouseListeners();
    debouncedOnMouseMove = debounce(onMouseMove, options.interactiveDebounce || 0);
    updatePopperElement(popper, prevProps, nextProps);
    instance.popperChildren = getChildren(popper);

    if (instance.popperInstance) {
      instance.popperInstance.update();

      if (POPPER_INSTANCE_DEPENDENCIES.some(function (prop) {
        return hasOwnProperty(options, prop) && options[prop] !== prevProps[prop];
      })) {
        instance.popperInstance.destroy();
        createPopperInstance();

        if (instance.state.isVisible) {
          instance.popperInstance.enableEventListeners();
        }

        if (instance.props.followCursor && lastMouseMoveEvent) {
          positionVirtualReferenceNearCursor(lastMouseMoveEvent);
        }
      }
    }
  }
  /**
   * Shortcut for .set({ content: newContent })
   */


  function setContent(content) {
    set({
      content: content
    });
  }
  /**
   * Shows the tooltip
   */


  function show() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getValue(instance.props.duration, 0, defaultProps.duration[1]);

    if (instance.state.isDestroyed || !instance.state.isEnabled || isUsingTouch && !instance.props.touch) {
      return;
    } // Standardize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.


    if (getEventListenersTarget().hasAttribute('disabled')) {
      return;
    }

    if (instance.props.onShow(instance) === false) {
      return;
    }

    popper.style.visibility = 'visible';
    instance.state.isVisible = true;

    if (instance.props.interactive) {
      getEventListenersTarget().classList.add(ACTIVE_CLASS);
    } // Prevent a transition if the popper is at the opposite placement


    var transitionableElements = getTransitionableElements();
    setTransitionDuration(transitionableElements.concat(popper), 0);

    currentMountCallback = function currentMountCallback() {
      if (!instance.state.isVisible) {
        return;
      } // Double update will apply correct mutations


      if (!hasFollowCursorBehavior()) {
        instance.popperInstance.update();
      }

      if (instance.popperChildren.backdrop) {
        instance.popperChildren.content.style.transitionDelay = Math.round(duration / 12) + 'ms';
      }

      if (instance.props.sticky) {
        makeSticky();
      }

      setTransitionDuration([popper], instance.props.updateDuration);
      setTransitionDuration(transitionableElements, duration);
      setVisibilityState(transitionableElements, 'visible');
      onTransitionedIn(duration, function () {
        if (instance.props.aria) {
          getEventListenersTarget().setAttribute("aria-".concat(instance.props.aria), popper.id);
        }

        instance.props.onShown(instance);
        instance.state.isShown = true;
      });
    };

    mount();
  }
  /**
   * Hides the tooltip
   */


  function hide() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getValue(instance.props.duration, 1, defaultProps.duration[1]);

    if (instance.state.isDestroyed || !instance.state.isEnabled) {
      return;
    }

    if (instance.props.onHide(instance) === false) {
      return;
    }

    popper.style.visibility = 'hidden';
    instance.state.isVisible = false;
    instance.state.isShown = false;
    wasVisibleDuringPreviousUpdate = false;

    if (instance.props.interactive) {
      getEventListenersTarget().classList.remove(ACTIVE_CLASS);
    }

    var transitionableElements = getTransitionableElements();
    setTransitionDuration(transitionableElements, duration);
    setVisibilityState(transitionableElements, 'hidden');
    onTransitionedOut(duration, function () {
      if (!isScheduledToShow) {
        removeFollowCursorListener();
      }

      if (instance.props.aria) {
        getEventListenersTarget().removeAttribute("aria-".concat(instance.props.aria));
      }

      instance.popperInstance.disableEventListeners();
      instance.popperInstance.options.placement = instance.props.placement;
      currentParentNode.removeChild(popper);
      instance.props.onHidden(instance);
      instance.state.isMounted = false;
    });
  }
  /**
   * Destroys the tooltip
   */


  function destroy(destroyTargetInstances) {
    if (instance.state.isDestroyed) {
      return;
    } // If the popper is currently mounted to the DOM, we want to ensure it gets
    // hidden and unmounted instantly upon destruction


    if (instance.state.isMounted) {
      hide(0);
    }

    removeTriggersFromReference();
    delete reference._tippy;
    delete getEventListenersTarget()._tippy;
    var target = instance.props.target;

    if (target && destroyTargetInstances && isRealElement(reference)) {
      arrayFrom(reference.querySelectorAll(target)).forEach(function (child) {
        if (child._tippy) {
          child._tippy.destroy();
        }
      });
    }

    if (instance.popperInstance) {
      instance.popperInstance.destroy();
    }

    instance.state.isDestroyed = true;
  }
}

/**
 * Groups an array of instances by taking control of their props during
 * certain lifecycles.
 */
function group(instances) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? instances[0].props.delay : _ref$delay,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 0 : _ref$duration;

  var isAnyTippyOpen = false;
  instances.forEach(function (instance) {
    if (instance._originalProps) {
      instance.set(instance._originalProps);
    } else {
      instance._originalProps = _extends({}, instance.props);
    }
  });

  function setIsAnyTippyOpen(value) {
    isAnyTippyOpen = value;
    updateInstances();
  }

  function onShow(instance) {
    instance._originalProps.onShow(instance);

    instances.forEach(function (instance) {
      instance.set({
        duration: duration
      });
      instance.hide();
    });
    setIsAnyTippyOpen(true);
  }

  function onHide(instance) {
    instance._originalProps.onHide(instance);

    setIsAnyTippyOpen(false);
  }

  function onShown(instance) {
    instance._originalProps.onShown(instance);

    instance.set({
      duration: instance._originalProps.duration
    });
  }

  function updateInstances() {
    instances.forEach(function (instance) {
      instance.set({
        onShow: onShow,
        onShown: onShown,
        onHide: onHide,
        delay: isAnyTippyOpen ? [0, Array.isArray(delay) ? delay[1] : delay] : delay,
        duration: isAnyTippyOpen ? duration : instance._originalProps.duration
      });
    });
  }

  updateInstances();
}

var globalEventListenersBound = false;
/**
 * Exported module
 */

function tippy(targets, options) {
  validateOptions(options || {}, defaultProps);

  if (!globalEventListenersBound) {
    bindGlobalEventListeners();
    globalEventListenersBound = true;
  }

  var props = _extends({}, defaultProps, options); // If they are specifying a virtual positioning reference, we need to polyfill
  // some native DOM props


  if (isBareVirtualElement(targets)) {
    polyfillElementPrototypeProperties(targets);
  }

  var instances = getArrayOfElements(targets).reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, props);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return isSingular(targets) ? instances[0] : instances;
}
/**
 * Static props
 */


tippy.version = version;
tippy.defaults = defaultProps;
/**
 * Static methods
 */

tippy.setDefaults = function (partialDefaults) {
  Object.keys(partialDefaults).forEach(function (key) {
    // @ts-ignore
    defaultProps[key] = partialDefaults[key];
  });
};

tippy.hideAll = hideAll;
tippy.group = group;
/**
 * Auto-init tooltips for elements with a `data-tippy="..."` attribute
 */

function autoInit() {
  arrayFrom(document.querySelectorAll('[data-tippy]')).forEach(function (el) {
    var content = el.getAttribute('data-tippy');

    if (content) {
      tippy(el, {
        content: content
      });
    }
  });
}

if (isBrowser) {
  setTimeout(autoInit);
}

/**
 * Injects a string of CSS styles to a style node in <head>
 */

function injectCSS(css) {
  if (isBrowser) {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.textContent = css;
    var head = document.head;
    var firstChild = head.firstChild;

    if (firstChild) {
      head.insertBefore(style, firstChild);
    } else {
      head.appendChild(style);
    }
  }
}

injectCSS(css);

/* harmony default export */ __webpack_exports__["default"] = (tippy);
//# sourceMappingURL=index.all.js.map


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24)))

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports = "<div class=\"new-home\">\r\n  <div class=\"home-hero\">\r\n    <div class=\"wrapper\">\r\n      <div class=\"hero-text\">\r\n        <h1>The Leading Provider of Sailing Schedule Data Solutions</h1>\r\n        <p>\r\n          Whether you're planning container bookings or analyzing vessel\r\n          movements, Linescape has the most comprehensive sailing schedule\r\n          database. Complete, accurate and updated continuously, our schedule\r\n          data is available to logistics professionals - anytime, anywhere.\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"features\">\r\n    <div class=\"wrapper\">\r\n      <div class=\"feature\">\r\n        <img src=\"../img/icons/svg/carriers.svg\" onerror=\"this.onerror=null; this.src='../img/icons/carriers.png'\">\r\n        <div>\r\n          <span>CARRIERS</span>\r\n          <strong>120+</strong>\r\n        </div>\r\n      </div>\r\n      <div class=\"feature\">\r\n        <img src=\"../img/icons/svg/sea-ports.svg\" onerror=\"this.onerror=null; this.src='../img/icons/sea-ports.png'\">\r\n        <div>\r\n          <span>SEA PORTS</span>\r\n          <strong>900+</strong>\r\n        </div>\r\n      </div>\r\n      <div class=\"feature\">\r\n        <img src=\"../img/icons/svg/services.svg\" onerror=\"this.onerror=null; this.src='../img/icons/services.png'\">\r\n        <div>\r\n          <span>SERVICES</span>\r\n          <strong>3,000+</strong>\r\n        </div>\r\n      </div>\r\n      <div class=\"feature\">\r\n        <img src=\"../img/icons/svg/vessels.svg\" onerror=\"this.onerror=null; this.src='../img/icons/vessels.png'\">\r\n        <div>\r\n          <span>VESSELS</span>\r\n          <strong>4,000+</strong>\r\n        </div>\r\n      </div>\r\n      <div class=\"feature\">\r\n        <img src=\"../img/icons/svg/voyages.svg\" onerror=\"this.onerror=null; this.src='../img/icons/voyages.png'\">\r\n        <div>\r\n          <span>VOYAGES*</span>\r\n          <strong>65,000+</strong>\r\n        </div>\r\n      </div>\r\n      <div class=\"feature\">\r\n        <img src=\"../img/icons/svg/port-pairs.svg\" onerror=\"this.onerror=null; this.src='../img/icons/port-pairs.png'\">\r\n        <div>\r\n          <span>PORT PAIRS</span>\r\n          <strong>270,000+</strong>\r\n        </div>\r\n      </div>\r\n      <div class=\"feature\">\r\n        <img src=\"../img/icons/svg/schedules.svg\" onerror=\"this.onerror=null; this.src='../img/icons/schedules.png'\">\r\n        <div>\r\n          <span>SCHEDULES*</span>\r\n          <strong>8,000,000+</strong>\r\n        </div>\r\n      </div>\r\n      \r\n    </div>\r\n    <div class=\"wrapper wrapper-2\"><div class=\"subtext\"><em>* within a 3 month horizon</em></div></div>\r\n  </div>\r\n  <div class=\"home-main\">\r\n    <div class=\"wrapper\">\r\n      <div class=\"solutions-application\">\r\n        <div class=\"solutions\">\r\n          <h1><img src=\"../img/icons/SVG/solutions.svg\" onerror=\"this.onerror=null; this.src='../img/icons/png/solutions.png'\"><span>SOLUTIONS</span></h1>\r\n          <ul>\r\n            <li>\r\n              <strong>Online Search:</strong>\r\n              <span>Plans & Pricing to fit your needs and budget</span>\r\n            </li>\r\n            <li>\r\n              <strong>API Data-on-Demand:</strong>\r\n              <span>Only the data you need, when you need it</span>\r\n            </li>\r\n            <li>\r\n              <strong>Bulk Data Feeds:</strong>\r\n              <span\r\n                >Integrate schedule and vessel data into your IT system</span\r\n              >\r\n            </li>\r\n            <li>\r\n              <strong>Analytics & Reporting:</strong>\r\n              <span\r\n                >Informed business decisions start with data-driven\r\n                insights</span\r\n              >\r\n            </li>\r\n          </ul>\r\n          <div class=\"text-center\">\r\n            <a class=\"btn\" [routerLink]=\"['/solutions', { scroll: true }]\"\r\n              >LEARN MORE</a\r\n            >\r\n          </div>\r\n        </div>\r\n        <div class=\"application\">\r\n          <h1><img src=\"../img/icons/svg/data.svg\" onerror=\"this.onerror=null; this.src='../img/icons/png/data.png'\"><span>APPLICATION</span></h1>\r\n          <ul>\r\n            <li>\r\n              <strong>API Documentation:</strong>\r\n              <span>Easy requests via REST web service with JSON response</span>\r\n            </li>\r\n            <li>\r\n              <strong>Bulk Data Formats:</strong>\r\n              <span>Direct FTP downloads of CSV schedule and vessel data</span>\r\n            </li>\r\n            <li>\r\n              <strong>Carrier List:</strong>\r\n              <span\r\n                >Explore 120+ carriers (deep-sea, short-sea and feeders)</span\r\n              >\r\n            </li>\r\n            <li>\r\n              <strong>Data Consolidation:</strong>\r\n              <span>See how we import, process, validate, and export data</span>\r\n            </li>\r\n          </ul>\r\n          <div class=\"text-center\">\r\n          <a class=\"btn\" [routerLink]=\"['/application', { scroll: true }]\"\r\n            >LEARN MORE</a\r\n          >\r\n        </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"testimonials\">\r\n        <!-- There are no testimonials yet -->\r\n      </div>\r\n      <div class=\"carrier-network text-center\">\r\n        <h2>Carrier List</h2>\r\n\r\n        <!-- The order for these is this: (from here: https://3.basecamp.com/3138460/buckets/3005000/messages/1652305779#__recording_1761485588)\r\n        ID\tCarrier\r\n        1\tMaersk\r\n        2\tMSC\r\n        3\tCMA-CGM\r\n        4\tEvergreen\r\n        5\tHapag-Lloyd\r\n        6\tCOSCO\r\n        8\tAPL\r\n        12\tOOCL\r\n        14\tZim\r\n        16\tYang Ming\r\n\r\n        We might want to number the file names if we add more.\r\n        -->\r\n\r\n        <div class=\"carrier-icons-container\">\r\n          <div style=\"width: 100px; -webkit-transform: scaleX(-1); transform: scaleX(-1);\">\r\n              <a [routerLink]=\"['carrier-list', { scroll: true }]\" class=\"tippy-hover\" data-tippy-content=\"More carriers\"><img src=\"../img/arrow.svg\" alt=\"More Carriers\"></a>\r\n          </div>\r\n          <div>\r\n            <img src=\"../img/carrier-icons/maersk-250.png\" alt=\"Maersk\">\r\n          </div>\r\n          <div>\r\n            <img src=\"../img/carrier-icons/msc-250.png\" alt=\"MSC\">\r\n          </div>\r\n          <div>\r\n            <img src=\"../img/carrier-icons/cma-cgm-250.png\" alt=\"CMA-CGM\">\r\n          </div>\r\n          <div>\r\n            <img src=\"../img/carrier-icons/evergreen-250.png\" alt=\"Evergreen\">\r\n          </div>\r\n          <div>\r\n            <img src=\"../img/carrier-icons/hapag-lloyd-250.png\" alt=\"Hapag-Lloyd\">\r\n          </div>\r\n          <div class=\"hide-mobile\">\r\n            <img src=\"../img/carrier-icons/cosco-250.png\" alt=\"COSCO\">\r\n          </div>\r\n          <div class=\"hide-mobile\">\r\n            <img src=\"../img/carrier-icons/APL-250.png\" alt=\"APL\">\r\n          </div>\r\n          <div class=\"hide-mobile\">\r\n            <img src=\"../img/carrier-icons/OOCL_250.png\" alt=\"OOCL\">\r\n          </div>\r\n          <div class=\"hide-mobile\">\r\n            <img src=\"../img/carrier-icons/zim-250.png\" alt=\"Zim\">\r\n          </div>\r\n          <div class=\"hide-mobile\">\r\n            <img src=\"../img/carrier-icons/yang-ming-250.png\" alt=\"Yang Ming\">\r\n          </div>\r\n          <div style=\"width:100px;\">\r\n            <a [routerLink]=\"['carrier-list', { scroll: true }]\" class=\"tippy-hover\" data-tippy-content=\"More carriers\"><img src=\"../img/arrow.svg\" alt=\"More Carriers\"></a>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n      <div class=\"get-started\">\r\n        <div>\r\n          <h2>Get Started Today</h2>\r\n          <h6>Contact us or create a Linescape account.</h6>\r\n        </div>\r\n        <div class=\"buttons-container\">\r\n          <a class=\"btn btn-lg\" [routerLink]=\"['/register', { scroll: true }]\"\r\n            >CREATE ACCOUNT</a\r\n          >\r\n          <a class=\"btn-outline btn-lg\" [routerLink]=\"['/contact', { scroll: true }]\"\r\n            ><div class=\"text-container\">CONTACT US</div></a\r\n          >\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports = "@charset \"UTF-8\";\n.new-home .home-hero {\n  background: #5d92c0;\n  background: url(\"/img/line-bg-test.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: center;\n  height: 570px; }\n  @media (max-width: 990px) {\n    .new-home .home-hero {\n      background: url(\"img/line-bg-side.jpg\");\n      background-size: 100%; } }\n  .new-home .home-hero .wrapper {\n    position: relative;\n    height: 100%; }\n  .new-home .home-hero .hero-text {\n    background: rgba(4, 51, 86, 0.85);\n    padding: 20px;\n    position: absolute;\n    right: 35px;\n    top: 50px;\n    width: 500px;\n    color: #fff; }\n    .new-home .home-hero .hero-text h1 {\n      font-size: 26px;\n      font-weight: bold;\n      width: 100%;\n      margin-bottom: 1em;\n      line-height: 1.2em;\n      text-align: left; }\n    .new-home .home-hero .hero-text p {\n      text-align: left; }\n  @media (max-width: 1099px) {\n    .new-home .home-hero .hero-text {\n      width: calc(100% - 590px); } }\n  @media (max-width: 979px) {\n    .new-home .home-hero .hero-text {\n      width: calc(100% - 70px); } }\n\n.new-home .features {\n  position: relative;\n  z-index: 1;\n  background-image: url(\"/img/background-features.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center 60%;\n  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2);\n  padding: 30px 0 40px; }\n  .new-home .features .wrapper {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -ms-flex-pack: center;\n        justify-content: center; }\n  .new-home .features .wrapper-2 {\n    -ms-flex-pack: end;\n        justify-content: flex-end; }\n  .new-home .features .feature {\n    display: table;\n    margin: 25px 30px; }\n    .new-home .features .feature img {\n      display: table-cell;\n      width: 88px;\n      height: 88px; }\n    .new-home .features .feature div {\n      display: table-cell;\n      padding-left: 15px;\n      vertical-align: middle; }\n      .new-home .features .feature div span {\n        text-decoration: underline; }\n      .new-home .features .feature div strong {\n        font-weight: bold;\n        font-size: 28px;\n        display: block; }\n    @media (max-width: 599px) {\n      .new-home .features .feature {\n        margin: 10px 15px; }\n        .new-home .features .feature img {\n          width: 50px;\n          height: 50px; }\n        .new-home .features .feature div {\n          display: table-cell;\n          padding-left: 10px;\n          vertical-align: middle; }\n          .new-home .features .feature div span {\n            font-size: 14px; }\n          .new-home .features .feature div strong {\n            font-size: 18px;\n            margin-top: -12px; } }\n  .new-home .features .subtext {\n    margin-right: 50px; }\n    .new-home .features .subtext em {\n      font-size: 16px;\n      font-weight: 300; }\n\n.new-home .home-main .wrapper {\n  background: #fff; }\n\n.new-home .home-main .solutions-application {\n  padding: 50px;\n  display: -ms-flexbox;\n  display: flex; }\n  .new-home .home-main .solutions-application img {\n    max-width: 50px;\n    max-height: 50px; }\n  .new-home .home-main .solutions-application h1 span {\n    display: inline-block;\n    vertical-align: top;\n    margin-top: 2px;\n    margin-left: 15px;\n    color: #247cbd;\n    font-weight: bold; }\n  .new-home .home-main .solutions-application li span {\n    display: block;\n    margin-top: -7px;\n    margin-bottom: 7px; }\n  @media (max-width: 979px) {\n    .new-home .home-main .solutions-application li span {\n      line-height: initial; } }\n  .new-home .home-main .solutions-application .solutions {\n    padding-right: 40px;\n    border-right: 3px solid #247cbd; }\n  .new-home .home-main .solutions-application .application {\n    padding-left: 40px; }\n\n@media (max-width: 1023px) {\n  .new-home .home-main .solutions-application {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 50px 0;\n    text-align: center; }\n    .new-home .home-main .solutions-application .solutions {\n      padding-right: 0;\n      padding-bottom: 40px;\n      border-right: 0;\n      border-bottom: 3px solid #247cbd; }\n    .new-home .home-main .solutions-application .application {\n      padding-left: 0;\n      padding-top: 40px; }\n    .new-home .home-main .solutions-application li {\n      margin-left: 0;\n      list-style: none; } }\n\n@media (max-width: 479px) {\n  .new-home .home-main .solutions-application h1 {\n    font-size: 38px;\n    line-height: 38px; } }\n\n.new-home .home-main .testimonials {\n  background-image: url(\"/img/background-testimonials.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 300px;\n  position: relative;\n  z-index: 1;\n  box-shadow: 0px -5px 5px rgba(0, 0, 0, 0.2); }\n\n.new-home .home-main .carrier-network {\n  position: relative;\n  z-index: 1;\n  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2);\n  padding: 30px 20px; }\n  .new-home .home-main .carrier-network h2 {\n    color: #247cbd; }\n  .new-home .home-main .carrier-network .swiper-slide {\n    height: auto !important;\n    margin-left: 20px; }\n  .new-home .home-main .carrier-network .carrier-icons-container {\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    width: 100%; }\n    .new-home .home-main .carrier-network .carrier-icons-container div {\n      margin: 0 auto;\n      padding: 25px; }\n    .new-home .home-main .carrier-network .carrier-icons-container img {\n      max-width: 40px;\n      max-height: 40px;\n      vertical-align: middle; }\n  @media (max-width: 1117px) {\n    .new-home .home-main .carrier-network .carrier-icons-container div {\n      padding: 10px 5px; }\n    .new-home .home-main .carrier-network .carrier-icons-container .hide-mobile {\n      display: none; } }\n\n.new-home .home-main .get-started {\n  padding: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  .new-home .home-main .get-started h2 {\n    color: #247cbd; }\n  .new-home .home-main .get-started h6 {\n    color: #666; }\n  .new-home .home-main .get-started .buttons-container {\n    margin-top: 17px; }\n    .new-home .home-main .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .new-home .home-main .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 479px) {\n  .new-home .home-main .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n\n/* Old Home\r\n.home-background {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: url(../../img/shipping-schedules-background.jpg);\r\n  background-size: cover;\r\n  background-position: 50% 50%;\r\n  z-index: -1;\r\n}\r\n.home-hero {\r\n  padding-top: 134px;\r\n  color: #ffffff;\r\n  padding-bottom: 250px;\r\n  h1 {\r\n    text-align: center;\r\n    margin-bottom: 16px;\r\n    font-weight: 300;\r\n    width: 65%;\r\n    margin: auto;\r\n    margin-bottom: 65px;\r\n  }\r\n  ul {\r\n    font-size: 0;\r\n    height: 42px;\r\n    width: calc(100% + 2px);\r\n    margin: 0;\r\n    li {\r\n      background-image: linear-gradient(to top, #212121, #212121);\r\n      cursor: pointer;\r\n      display: inline-block;\r\n      width: calc(25% - 2px);\r\n      text-align: center;\r\n      margin-right: 2px;\r\n      margin-left: 0;\r\n      margin-bottom: 0;\r\n      padding-top: 8px;\r\n\t    padding-bottom: 8px;\r\n    \tfont-weight: 300;\r\n      transition: all .5s ease;\r\n      &:hover {\r\n        background: linear-gradient(to right, #664587, #212121);\r\n      }\r\n      &.active {\r\n        background: linear-gradient(to right, #3a7bb3, #664587);\r\n      }\r\n    }\r\n  }\r\n  .search-bottom {\r\n    background: rgba(0,0,0,0.5);\r\n    padding: 20px;\r\n    min-height: 205px;\r\n    .data-question {\r\n      margin-top: 30px;\r\n    }\r\n    .data-question.schedules-on {\r\n      margin-top: 0;\r\n      line-height: 28px;\r\n      padding-bottom: 2px;\r\n    }\r\n  }\r\n}\r\n\r\n.main-content {\r\n  margin-top: -200px;\r\n}\r\n\r\n.home-mid-section {\r\n  .col1of2 {\r\n    background: rgba(0, 0, 0, 0.5);\r\n    color: #fff;\r\n    padding: 20px;\r\n    width: calc(50% - 30px);\r\n    margin-right: 30px;\r\n    &:nth-child(2) {\r\n      margin-left: 30px;\r\n      margin-right: 0;\r\n    }\r\n  }\r\n  li {\r\n    margin-bottom: 0;\r\n    margin-left: 0;\r\n    list-style: none;\r\n    &::before {\r\n      content: \"• \";\r\n      color: #03A9F4;\r\n      margin-right: 5px;\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 1200px) {\r\n  .home-mid-section {\r\n    .col1of2 {\r\n      width: calc(50% - 45px);\r\n      margin-left: 15px;\r\n      &:nth-child(2) {\r\n        margin-left: 30px;\r\n        margin-right: 15px;\r\n      }\r\n    }\r\n  }\r\n}\r\n@media only screen and (max-width: 767px) {\r\n  .home-mid-section {\r\n    .col1of2 {\r\n      width: calc(100% - 30px);\r\n      padding: 20px !important; // not sure why this is necessary\r\n      margin: 0 15px;\r\n      &:nth-child(2) {\r\n        margin-left: 15px;\r\n        margin-top: 30px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.home-feature {\r\n  margin: 50px 0;\r\n  padding: 50px;\r\n  h3 {\r\n    font-weight: 300;\r\n  }\r\n  .content-container {\r\n    text-align: center;\r\n    li {\r\n      list-style: none;\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  // feature specific styles\r\n  &.feature-1 {\r\n    background:\r\n    url(img/home-features/home-feature-1-bg.png) top right no-repeat,\r\n    #fff;\r\n    .content-container {\r\n      max-width: 500px;\r\n      margin-left: 3%;\r\n    }\r\n  }\r\n  &.feature-2 {\r\n    background: \r\n  url(img/home-features/home-feature-2-bg1.png) bottom -2px left no-repeat,\r\n  url(img/home-features/home-feature-2-bg2.png) top right no-repeat,\r\n    #fff;\r\n    .content-container {\r\n      max-width: 500px;\r\n      margin: 0 auto;\r\n    }\r\n  }\r\n  &.feature-3 {\r\n    background: \r\n  url(img/home-features/home-feature-3-bg1.png) top left no-repeat,\r\n  url(img/home-features/home-feature-3-bg2.png) bottom right no-repeat,\r\n    #fff;\r\n    .content-container {\r\n      max-width: 600px;\r\n      margin-left: 13%;\r\n    }\r\n  }\r\n  \r\n}\r\n\r\n@media only screen and (max-width: 1200px) {\r\n  .home-feature {\r\n    margin-left: 15px;\r\n    margin-right: 15px;\r\n    &.feature-1 {\r\n      background-position: top right -300px;\r\n      .content-container {\r\n      }\r\n    }\r\n    &.feature-2 {\r\n      background-position:\r\n        bottom -2px left -135px, top right -125px;\r\n      .content-container {\r\n      }\r\n    }\r\n    &.feature-3 {\r\n      background-position: top left, bottom right -235px;\r\n      .content-container {\r\n        margin: auto;\r\n      }\r\n    }\r\n  }\r\n}\r\n@media only screen and (max-width: 767px) {\r\n  .home-feature {\r\n    &.feature-1 {\r\n      background-position: top right -450px;\r\n      .content-container {\r\n        width: 100%;\r\n        margin: auto;\r\n      }\r\n    }\r\n    &.feature-2 {\r\n      background-position:\r\n        bottom -2px left -225px, top right -185px;\r\n      .content-container {\r\n        width: 100%;\r\n      }\r\n    }\r\n    &.feature-3 {\r\n      background-position: top left, bottom right -235px;\r\n      .content-container {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n@media only screen and (max-width: 599px) {\r\n  .home-feature {\r\n    \r\n    &.feature-1 {\r\n      background: #fff;\r\n    }\r\n    &.feature-2 {\r\n      background: #fff;\r\n    }\r\n    &.feature-3 {\r\n      background: #fff;\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 599px) {\r\n  .home-hero { \r\n    padding-top: 140px;\r\n    h1 {\r\n      width: 100%;\r\n      margin-left: 0;\r\n      font-size: 36px;\r\n      line-height: 40px;\r\n    }\r\n    ul {\r\n      li {\r\n        h5 {\r\n          font-size: 20px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 499px) {\r\n  .home-hero { \r\n    h1 {\r\n      margin-bottom: 30px;\r\n    }\r\n    ul {\r\n      height: inherit;\r\n      li {\r\n        width: 100%;\r\n        h5 {\r\n          font-size: 22px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n@media only screen and (max-width: 399px) {\r\n  .home-hero { \r\n    h1 {\r\n      \tfont-size: 26px;\r\n\t      line-height: 32px;\r\n    }\r\n  }\r\n  .main-wrapper {\r\n    padding-left: 0;\r\n    padding-right: 0;\r\n  }\r\n}\r\n*/\n"

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ApiDocsComponent = (function () {
    function ApiDocsComponent() {
    }
    ApiDocsComponent.prototype.ngOnInit = function () {
        window.location.href = 'https://linescape-downloads.s3.amazonaws.com/schedule-api/latest/index.html';
    };
    ApiDocsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(570),
            styles: [__webpack_require__(571)]
        })
    ], ApiDocsComponent);
    return ApiDocsComponent;
}());
exports.ApiDocsComponent = ApiDocsComponent;


/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = "<h1>Api Docs</h1>"

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var TestConnectionComponent = (function () {
    function TestConnectionComponent() {
    }
    TestConnectionComponent.prototype.ngOnInit = function () {
        var _this = this;
        document.getElementById('test-button').onclick = function () { return _this.testConnection(); };
    };
    TestConnectionComponent.prototype.testConnection = function () {
        var items = __assign({}, localStorage);
        var ul = document.getElementById('response-list');
        ul.innerHTML = '';
        var startTime, endTime, timeDiff, time;
        startTime = new Date();
        fetch('https://v2gcar23gi.execute-api.us-east-1.amazonaws.com/beta/v2/test-access', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(items)
        })
            .then(function (response) {
            var status = document.createElement('li');
            status.innerText = 'Status Code: ' + response.status.toString();
            ul.appendChild(status);
            endTime = new Date();
            timeDiff = endTime - startTime;
            timeDiff /= 1000;
            time = document.createElement('li');
            time.innerText = 'Time Elapsed: ' + timeDiff + ' ' + 'seconds';
            ul.appendChild(time);
            return response.json();
        })
            .then(function (jsonData) {
            var data = document.createElement('li');
            data.innerText = 'Response: ' + jsonData.body;
            ul.appendChild(data);
            for (var item in items) {
                var li = document.createElement('li');
                li.innerText = item + ': ' + items[item];
                ul.appendChild(li);
            }
        })
            .catch(function (err) {
            var error = document.createElement('li');
            error.innerText = err;
            ul.appendChild(error);
            endTime = new Date();
            timeDiff = endTime - startTime;
            timeDiff /= 1000;
            time = document.createElement('li');
            time.innerText = 'Time Elapsed: ' + timeDiff + ' ' + 'seconds';
            ul.appendChild(time);
            for (var item in items) {
                var li = document.createElement('li');
                li.innerText = item + ': ' + items[item];
                ul.appendChild(li);
            }
        });
    };
    TestConnectionComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(573),
            styles: [__webpack_require__(574)]
        })
    ], TestConnectionComponent);
    return TestConnectionComponent;
}());
exports.TestConnectionComponent = TestConnectionComponent;


/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = "<h1>Test Connection</h1>\r\n\r\n<button id=\"test-button\">Test Connection</button>\r\n\r\n<ul id=\"response-list\"></ul>"

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = "li {\n  padding: 10px; }\n"

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var trips_1 = __webpack_require__(60);
var models_1 = __webpack_require__(12);
var SchedulesService = (function () {
    function SchedulesService(api, cache, logger, favorite, seo, app, el, renderer) {
        this.api = api;
        this.cache = cache;
        this.logger = logger;
        this.favorite = favorite;
        this.seo = seo;
        this.app = app;
        this.renderer = renderer;
        this.queryString = '';
        this.loaderOff = false;
        this.noResult = false;
        this.downloadLoaderOff = false;
    }
    SchedulesService.prototype.getSchedules = function (params) {
        var _this = this;
        this.loaderOff = false;
        this.noResult = false;
        this.logger.log('schedules.service', 'getSchedules', params);
        // let cache = this.cache.get('ports' + this.queryString);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetSchedules(client, params); });
        // let server = Observable.fromPromise(promise);
        // this.schedules = Observable.concat(cache, server);
        // this.schedules = server;
        // this.cache.updateCache('ports' + this.queryString, this.schedules);
        return promise;
    };
    SchedulesService.prototype.getPerformanceSchedules = function (params) {
        var _this = this;
        return this.api.getApiClient().then(function (client) { return _this.callGetSchedules(client, params); });
    };
    SchedulesService.prototype.callGetSchedules = function (apigClient, query) {
        this.logger.log('schedules.service', 'callGetPortSchedules', query);
        var params = {};
        var additionalParams = {
            headers: { 'Content-Type': 'application/json' },
            queryParams: query
        };
        return apigClient.tripsGet(params, '', additionalParams)
            .then(this.handleSchedulesResolve.bind(this)).catch(this.handleSchedulesError.bind(this));
    };
    SchedulesService.prototype.handleSchedulesResolve = function (result) {
        this.logger.log('schedules.service', 'result', result);
        if (!this.formatUI(result)) {
            return null;
        }
        var trips = new trips_1.Trips(result);
        this.seo.setTrips(trips);
        return trips;
    };
    SchedulesService.prototype.handleSchedulesError = function (error) {
        this.resizeSidebar();
        this.loaderOff = true;
        this.noResult = true;
        throw (this.api.handleError(error));
    };
    SchedulesService.prototype.formatUI = function (result) {
        if (result.data === null) {
            this.resizeSidebar();
            this.loaderOff = true;
            this.noResult = true;
            return false;
        }
        else if (result.data.hasOwnProperty('errorMessage')) {
            var response = JSON.parse(result.data.errorMessage);
            this.resizeSidebar();
            this.loaderOff = true;
            this.noResult = true;
            this.api.handleError(response);
            return false;
        }
        else if (result.data.items === undefined || result.data.items.length === 0 || result.data.summary.count === 0) {
            this.resizeSidebar();
            this.loaderOff = true;
            this.noResult = true;
            return false;
        }
        else {
            this.resizeSidebar();
            this.loaderOff = true;
            return true;
        }
    };
    SchedulesService.prototype.getParametersFromSearchId = function (searchId) {
        var _this = this;
        return this.api.generateApiClient().then(function (client) { return _this.callGetParameters(client, searchId); });
    };
    SchedulesService.prototype.callGetParameters = function (apigClient, searchId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var params = {
                searchId: searchId
            };
            var body = {
                searchId: searchId
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.searchesSearchIdGet(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('schedule.service', 'callGetParameters result', result);
                    resolve(result);
                }).catch(function (err) {
                    _this.resizeSidebar();
                    _this.loaderOff = true;
                    _this.noResult = true;
                    reject(_this.api.handleError(err));
                });
            }
            catch (ex) {
                _this.resizeSidebar();
                _this.loaderOff = true;
                _this.noResult = true;
                reject(null);
            }
        });
    };
    SchedulesService.prototype.resizeSidebar = function () {
        var _this = this;
        setTimeout(function () {
            try {
                _this.el = document.getElementById('refine-sidebar-inner');
                _this.content = document.getElementById('results-content');
                _this.container = document.getElementById('content-sidebar-wrapper');
                _this.renderer.setElementProperty(_this.container, 'style', false);
                if (_this.el.scrollHeight > _this.content.scrollHeight) {
                    var heightNum = (_this.el.scrollHeight + 200);
                    _this.renderer.setElementStyle(_this.container, 'height', heightNum + 'px');
                }
                else {
                    _this.logger.log('schedules.service', 'resizeSidebar', 'NOT SETTING HEIGHTS');
                }
            }
            catch (ex) {
            }
        }, 10);
    };
    SchedulesService.prototype.getPortsForLocation = function (type, id) {
        var _this = this;
        var params = {
            limit: 200
        };
        var idParam = type === 'country' ? 'country_id' : 'region_id';
        params[idParam] = id;
        var local = localStorage.getItem(JSON.stringify(params));
        // if (local === undefined || local === null) {
        return this.api.getApiClient().then(function (client) { return _this.callGetPortsForLocation(client, params); });
        // } else {
        //  return this.getPortsForLocationFromStorage(local);
        // }
    };
    SchedulesService.prototype.getPortsForLocationFromStorage = function (local) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var formatted = JSON.parse(local);
                resolve(formatted);
            }
            catch (ex) {
                _this.logger.log('schedules.service', 'getPortsForLocationFromStorage catch', ex);
                resolve(null);
            }
        });
    };
    SchedulesService.prototype.callGetPortsForLocation = function (apigClient, query) {
        var _this = this;
        this.logger.log('schedules.service', 'callGetPortsForLocation', query);
        return new Promise(function (resolve, reject) {
            var params = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: query
            };
            try {
                apigClient.portsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('schedules.service', 'callGetPortsForLocation resolve', result);
                    if (result.data === null || result.data.items.length === 0) {
                        resolve([]);
                    }
                    else {
                        var formatted = [];
                        for (var current = 0; current < result.data.items.length; current++) {
                            var port = new models_1.Port(result.data.items[current]);
                            formatted.push({
                                count: 0,
                                iconUrl: '../img/port-selected.png',
                                selected: true,
                                port: port
                            });
                        }
                        formatted.sort(function (a, b) {
                            var one = a.port.name.toUpperCase();
                            var two = b.port.name.toUpperCase();
                            return (one < two) ? -1 : (one > two) ? 1 : 0;
                        });
                        localStorage.setItem(JSON.stringify(query), JSON.stringify(formatted));
                        resolve(formatted);
                    }
                }).catch(function (err) {
                    _this.loaderOff = true;
                    _this.noResult = true;
                    reject(_this.api.handleError(err));
                });
            }
            catch (ex) {
                _this.logger.log('schedules.service', 'catch', ex);
                reject(null);
            }
        });
    };
    SchedulesService.prototype.getDownload = function (searchId) {
        var _this = this;
        // return 'https://v2gcar23gi.execute-api.us-east-1.amazonaws.com/beta/searches/' + searchId + '/download';
        this.downloadLoaderOff = true;
        this.api.getApiClient().then(function (client) { return _this.callGetDownload(client, searchId); }).then(function () {
        });
    };
    SchedulesService.prototype.callGetDownload = function (apigClient, searchId) {
        var _this = this;
        this.logger.log('schedules.service', 'callGetDownload', searchId);
        new Promise(function (resolve, reject) {
            var params = {
                searchId: searchId
            };
            var body = {
                searchId: searchId
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.searchesSearchIdDownloadGet(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('schedules.service', 'callGetDownload result', result);
                    _this.transformDownload(result.data);
                    resolve(null);
                }).catch(function (err) {
                    reject(_this.api.handleError(err));
                });
            }
            catch (ex) {
                _this.logger.log('schedules.service', 'callGetDownload catch', ex);
            }
        });
    };
    SchedulesService.prototype.transformDownload = function (data) {
        var sliceSize = 512;
        var byteCharacters = atob(data);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var index = 0; index < slice.length; index++) {
                byteNumbers[index] = slice.charCodeAt(index);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, { type: 'text/csv' });
        var blobUrl = URL.createObjectURL(blob);
        if (window.navigator.msSaveBlob !== undefined) {
            window.navigator.msSaveBlob(blob, 'test.csv');
            this.downloadLoaderOff = false;
        }
        else {
            this.saveDownload(blobUrl, 'LinescapeDownload' + moment().format('YYYYMMDDHHmmss') + '.csv');
        }
    };
    SchedulesService.prototype.saveDownload = function (url, fileName) {
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style.setProperty('display', 'none');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
        this.downloadLoaderOff = false;
    };
    SchedulesService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.CacheService, shared_1.LogService,
            shared_1.FavoriteService, shared_1.SeoService, shared_1.AppContext, core_1.ElementRef, core_1.Renderer])
    ], SchedulesService);
    return SchedulesService;
}());
exports.SchedulesService = SchedulesService;


/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = "<div class=\"schedule-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"schedule-banner-inner\">\r\n      <h2><img src=\"../img/schedule-01.svg\" onerror=\"this.onerror=null; this.src='../img/schedule-01.png'\">{{originSearch}} &#8594; {{destinationSearch}}</h2>\r\n      <div class=\"clear\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"results-header\">\r\n      <div class=\"col-holder\">\r\n        <div class=\"results-header-col-1\">\r\n          <h5>Refine Results</h5>\r\n        </div>\r\n        <div class=\"results-header-col-2\">\r\n          <h5>\r\n            Schedules\r\n          </h5>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-holder content-sidebar-wrapper\" id=\"content-sidebar-wrapper\">\r\n      <div *ngIf=\"service.noResult\" class=\"no-results-wrapper\">\r\n        <h4>No Results Found</h4>\r\n        <p>Try searching again above</p>\r\n      </div>\r\n      <div [class.active]=\"sidebarActive\" class=\"refine-sidebar\">\r\n        <div id=\"refine-sidebar-inner\">\r\n          <div class=\"sidebar-header\">\r\n            <p>Ports<span style=\"float: right; font-weight: 300;\"></span></p>\r\n          </div>\r\n          <div class=\"sidebar-section\">\r\n            <a class=\"btn-light-blue\" (click)=\"portsAll()\">Select All</a>\r\n            <a *ngIf=\"service.app.accountType !== ''\" class=\"btn-light-blue schedule-refine-select-all\" style=\"float:right\" (click)=\"portsFavorites()\">Favorites Only</a>\r\n            <a *ngIf=\"service.app.accountType === ''\" class=\"btn-light-blue schedule-refine-favorites-only\" style=\"float:right\" (click)=\"registerMessage()\">Favorites Only</a>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Origin Port <span style=\"float: right; font-weight: 300;\"></span></p>\r\n          </div>\r\n          <div class=\"sidebar-section sidebar-section-port sidebar-carrier-list\" *ngFor=\"let origin of originPorts; let i = index\">\r\n            <div *ngIf=\"i < portShowLimit || showAllOriginPorts\">\r\n              <div (click)=selectOriginPort(origin) [class.selected]=\"origin.selected\" class=\"schedule-refine-port-refine select-box-div\">\r\n                <span>&#x2714;</span>\r\n              </div>\r\n              <img (click)=selectOriginPort(origin) class=\"company-logo pointer schedule-refine-port-refine\" src=\"../img/flags/{{ origin.port.countryId }}.svg\">\r\n              <div class=\"sidebar-section-right\">\r\n                <p><span class=\"pointer schedule-refine-port-refine\" (click)=selectOriginPort(origin)><b>{{ origin.port.title }}</b></span><span class=\"favorite-star\"><img class=\"ga-favorite-port\" [favorite]=\"origin.port\" [itemtype]=\"'port'\"></span><br/>\r\n                <span class=\"pointer schedule-refine-port-refine\" (click)=selectOriginPort(origin)>{{ origin.port.location }}</span></p>\r\n                <p><span class=\"pointer schedule-refine-port-refine\" (click)=selectOriginPort(origin)>({{ origin.count }})</span></p>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div *ngIf=\"originPorts.length > portShowLimit && !showAllOriginPorts\" (click)=\"expandOrigins()\" class=\"sidebar-section expand-button\">\r\n            <p class=\"text-center\"><img src=\"../img/bluearrowdown.png\">Show all Origin Ports</p>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Destination Port <span style=\"float: right; font-weight: 300;\"></span></p>\r\n          </div>\r\n          <div class=\"sidebar-section sidebar-section-port sidebar-carrier-list\" *ngFor=\"let destination of destinationPorts; let i = index\">\r\n            <div *ngIf=\"i < portShowLimit || showAllDestinationPorts\">\r\n              <div (click)=selectDestinationPort(destination) [class.selected]=\"destination.selected\" class=\"schedule-refine-port-refine select-box-div\">\r\n                <span>&#x2714;</span>\r\n              </div>\r\n              <img (click)=selectDestinationPort(destination) class=\"company-logo pointer schedule-refine-port-refine\" src=\"../img/flags/{{ destination.port.countryId }}.svg\">\r\n              <div class=\"sidebar-section-right\">\r\n                <p><span class=\"pointer schedule-refine-port-refine\" (click)=selectDestinationPort(destination)><b>{{ destination.port.title }}</b></span><span class=\"favorite-star\"><img class=\"ga-favorite-port\" [favorite]=\"destination.port\" [itemtype]=\"'port'\"></span><br/>\r\n                <span class=\"pointer schedule-refine-port-refine\" (click)=selectDestinationPort(destination)>{{ destination.port.location }}</span></p>\r\n                <p><span class=\"pointer schedule-refine-port-refine\" (click)=selectDestinationPort(destination)>({{ destination.count }})</span></p>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div *ngIf=\"destinationPorts.length > portShowLimit && !showAllDestinationPorts\" (click)=\"expandDestinations()\" class=\"sidebar-section expand-button\">\r\n            <p class=\"text-center\"><img src=\"../img/bluearrowdown.png\">Show all Destination Ports</p>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Departure Date Range</p>\r\n          </div>\r\n          <div class=\"sidebar-section\">\r\n            <p>{{ departureRange }} <a class=\"btn-light-blue date-change-btn schedule-refine-departure-date\" (click)=\"toggleDepartureRange()\">Change</a></p>\r\n            <div class=\"clear\"></div>\r\n            <div *ngIf=\"showDepartureRange\">\r\n              <datepicker [(ngModel)]=\"departureDateGreater\" view-format=\"YYYY-MM-DD\" init-date=\"{{departureDateGreater}}\"></datepicker>\r\n              <datepicker [(ngModel)]=\"departureDateLess\" view-format=\"YYYY-MM-DD\" init-date=\"{{departureDateLess}}\"></datepicker>\r\n            </div>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Arrival Date Range</p>\r\n          </div>\r\n          <div class=\"sidebar-section\">\r\n            <p>{{ arrivalRange }} <a class=\"btn-light-blue date-change-btn schedule-refine-arrival-date\" (click)=\"toggleArrivalRange()\">Change</a></p>\r\n            <div *ngIf=\"showArrivalRange\">\r\n              <datepicker [(ngModel)]=\"arrivalDateGreater\" view-format=\"YYYY-MM-DD\" init-date=\"{{arrivalDateGreater}}\"></datepicker>\r\n              <datepicker [(ngModel)]=\"arrivalDateLess\" view-format=\"YYYY-MM-DD\" init-date=\"{{arrivalDateLess}}\"></datepicker>\r\n            </div>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Transit Duration</p>\r\n          </div>\r\n          <div *ngIf=\"schedules.maxDuration > 0\" class=\"sidebar-section sidebar-slider-section\">\r\n            <ng5-slider [(value)]=\"schedules.selectedMinDuration\" [(highValue)]=\"schedules.selectedMaxDuration\" [options]=\"{floor: schedules.minDuration, ceil: schedules.maxDuration}\" (userChangeEnd)=\"rangeChange($event)\"></ng5-slider>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Carriers <span style=\"float: right; font-weight: 300;\"></span></p>\r\n          </div>\r\n          <div class=\"sidebar-section\">\r\n            <a class=\"btn-light-blue\" [class.disabled]=\"allSelected()\" [class.deactivated-btn]=\"allSelected()\" (click)=\"carriersAll()\" style=\"padding-left: 14px; padding-right: 14px;\">Select All</a>\r\n            <a class=\"btn-light-blue\" [class.disabled]=\"allCleared()\" [class.deactivated-btn]=\"allCleared()\" (click)=\"clearAll()\" style=\"padding-left: 14px; padding-right: 14px;\">Clear All</a>\r\n            <a *ngIf=\"service.app.accountType !== ''\" class=\"btn-light-blue schedule-refine-select-all\" style=\"float:right\" (click)=\"carriersFavorites()\">Favorites</a>\r\n            <a *ngIf=\"service.app.accountType === ''\" class=\"btn-light-blue schedule-refine-favorites-only\" style=\"float:right\" (click)=\"registerMessage()\">Favorites</a>\r\n          </div>\r\n          <div class=\"sidebar-section\">\r\n            <div class=\"sidebar-carrier-list\" *ngFor=\"let carrier of schedules.carriers\">\r\n              <div>\r\n                <div class=\"pointer\" (click)=\"selectCarrier(carrier)\" [class.schedule-refine-individual-carrier-deselect]=\"carrier.selected\" [class.schedule-refine-individual-carrier-select]=\"!carrier.selected\" [class.selected]=\"carrier.selected\" class=\"select-box-div\">\r\n                  <span>&#x2714;</span>\r\n                </div>\r\n                <div class=\"sidebar-section-right carrier-sidebar-section-right\">\r\n                  <p><span class=\"pointer\" [class.schedule-refine-individual-carrier-deselect]=\"carrier.selected\" [class.schedule-refine-individual-carrier-select]=\"!carrier.selected\" (click)=\"selectCarrier(carrier)\">{{ carrier.name }}</span><span class=\"favorite-star\"><img class=\"ga-favorite-carrier\" [favorite]=\"carrier\" [itemtype]=\"'carrier'\"></span><span class=\"pointer\" [class.schedule-refine-individual-carrier-deselect]=\"carrier.selected\" [class.schedule-refine-individual-carrier-select]=\"!carrier.selected\" (click)=\"selectCarrier(carrier)\">({{ carrier.count }})</span><span style=\"float: right;\">{{ carrier.minDuration }} <span *ngIf=\"carrier.minDuration !== carrier.maxDuration\">- {{ carrier.maxDuration }}</span> days</span></p>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Transhipments</p>\r\n          </div>\r\n          <div class=\"sidebar-section sidebar-transhipments\">\r\n            <div *ngFor=\"let trans of schedules.transhipments\">\r\n              <div (click)=\"selectTranshipment(trans)\" [class.schedule-refine-trans-deselect]=\"trans.selected\" [class.schedule-refine-trans-select]=\"!trans.selected\" [class.selected]=\"trans.selected\" class=\"select-box-div pointer\">\r\n                <span>&#x2714;</span>\r\n              </div>\r\n              <span *ngIf=\"trans.amount === 0\">\r\n                <div class=\"sidebar-section-right\">\r\n                  <a [class.schedule-refine-trans-deselect]=\"trans.selected\" [class.schedule-refine-trans-select]=\"!trans.selected\" (click)=\"selectTranshipment(trans)\">0 Direct</a> <span>(<a (click)=\"selectTranshipment(trans, true)\" style=\"color: #03A9F4;\">only</a>)</span>\r\n                </div>\r\n              </span>\r\n              <div *ngIf=\"trans.amount === 1\" class=\"sidebar-section-right\">\r\n                <a [class.schedule-refine-trans-deselect]=\"trans.selected\" [class.schedule-refine-trans-select]=\"!trans.selected\" (click)=\"selectTranshipment(trans)\">{{ trans.amount }} Tranship</a>\r\n              </div>\r\n              <div *ngIf=\"trans.amount > 1\" class=\"sidebar-section-right\">\r\n                <a [class.schedule-refine-trans-deselect]=\"trans.selected\" [class.schedule-refine-trans-select]=\"!trans.selected\" (click)=\"selectTranshipment(trans)\">{{ trans.amount }} Tranships</a>\r\n              </div>\r\n            </div>\r\n            <div *ngIf=\"showTransSales\" class=\"trans-sales-message\">\r\n              <p *ngIf=\"service.app.accountType === ''\"><b>Note:</b><i> You are viewing only direct routes, to access schedule data for routes which include transhipments please <a [routerLink]=\"['/register']\">register</a> for a premium or professional account.</i></p>\r\n              <p *ngIf=\"service.app.accountType === 'Basic'\"><b>Note:</b><i> You are viewing only direct routes, to access schedule data for routes which include transhipments please <a [routerLink]=\"['../account/information']\">upgrade</a> your account.</i></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      <div class=\"refine-sidebar-after\">\r\n        <div (click)=\"slideOutIn()\" class=\"refine-sidebar-after-inner\">\r\n          <p><span class=\"text\">Refine</span><span class=\"arrow\">&rsaquo;</span><span class=\"arrow2\">&lsaquo;</span></p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div [ngSwitch]=\"displayType\" class=\"results-content\" id=\"results-content\">\r\n      <div class=\"compare-by-container\">\r\n          <span>Compare by:</span>\r\n          <a (click)=\"changeDisplay('trips')\" class=\"btn-refine compare-by-tab\" [class.active]=\"displayType == 'trips'\">Sailings</a>\r\n          <a *ngIf=\"service.app.accountType !== 'Professional' && service.app.accountType !== 'Enterprise'\" class=\"btn-refine compare-by-tab\" (click)=\"service.app.showUpgrade()\">Carriers</a>\r\n          <a *ngIf=\"service.app.accountType === 'Professional' || service.app.accountType === 'Enterprise'\" class=\"btn-refine compare-by-tab\" (click)=\"changeDisplay('performance')\" [class.active]=\"displayType == 'performance'\">Carriers</a>\r\n      </div>\r\n      <ng-template [ngSwitchCase]=\"'performance'\">\r\n        <!-- PERFORMANCE -->\r\n        <div *ngIf=\"!service.loaderOff\" id=\"loader-wrapper\">\r\n          <sticky sticky-offset-top=\"220\" sticky-class=\"sticky-loader\" sticky-offset-bottom=\"50\" sticky-zIndex=\"2999\">\r\n            <div id=\"loader\"></div>\r\n          </sticky>\r\n        </div>\r\n        <div *ngIf=\"schedules.searchId !== 0\">\r\n          <carrier-performance [items]=\"schedules.carriers\" [parameters]=\"getParams()\" (onShare)=\"toggleShare()\" (onContact)=\"contact($event)\"></carrier-performance>\r\n        </div>\r\n        <!-- END OF PERFORMANCE -->\r\n      </ng-template>\r\n      <ng-template [ngSwitchCase]=\"'trips'\">\r\n          <div *ngIf=\"!service.loaderOff\" id=\"loader-wrapper\"><!-- *ngIf=\"!service.loaderOff\" -->\r\n            <sticky sticky-offset-top=\"220\" sticky-class=\"sticky-loader\" sticky-offset-bottom=\"50\" sticky-zIndex=\"2999\">\r\n              <div id=\"loader\"></div>\r\n            </sticky>\r\n          </div>\r\n          <div *ngIf=\"schedules.searchId !== 0\">\r\n            <div *ngIf=\"!mapsHiddenVar\" class=\"col-holder\">\r\n                <div class=\"col1of2 map-col\">\r\n                  <h5 class=\"map-header\">Origin Port</h5>\r\n                  <agm-map\r\n                    [fitBounds]=\"schedules.originBounds\"\r\n                    [gestureHandling]=\"cooperative\"\r\n                    [scrollwheel]=\"false\"\r\n                    [streetViewControl]= \"false\"\r\n                  >\r\n                    <agm-marker\r\n                      *ngFor=\"let item of originPorts; let i = index\"\r\n                      [latitude]=\"item.port.latlong[0]\"\r\n                      [longitude]=\"item.port.latlong[1]\"\r\n                      [iconUrl]=\"item.port.iconUrl\"\r\n                      (markerClick)=\"originMarkerClicked(item)\"\r\n                    >\r\n                    </agm-marker>\r\n                  </agm-map>\r\n                </div>\r\n                <div class=\"col1of2 map-col\">\r\n                  <h5 class=\"map-header\">Destination Port</h5>\r\n                  <agm-map\r\n                    [fitBounds]=\"schedules.destinationBounds\"\r\n                    [gestureHandling]=\"cooperative\"\r\n                    [scrollwheel]=\"false\"\r\n                    [streetViewControl]= \"false\"\r\n                  >\r\n                    <agm-marker\r\n                      *ngFor=\"let item of destinationPorts; let i = index\"\r\n                      [latitude]=\"item.port.latlong[0]\"\r\n                      [longitude]=\"item.port.latlong[1]\"\r\n                      [iconUrl]=\"item.port.iconUrl\"\r\n                      (markerClick)=\"destinationMarkerClicked(item)\"\r\n                    >\r\n                    </agm-marker>\r\n                  </agm-map>\r\n                </div>\r\n              </div>\r\n              <p class=\"text-right small-text\"><a on-touch=\"toggleMaps()\" (click)=\"toggleMaps()\"><span *ngIf=\"mapsHiddenVar\">Show</span><span *ngIf=\"!mapsHiddenVar\">Hide</span> Maps<span *ngIf=\"mapsHiddenVar\">&#9660;</span><span *ngIf=\"!mapsHiddenVar\">&#9650;</span></a></p>\r\n            </div>\r\n            <div class=\"col-holder\">\r\n              <div class=\"col1of2 mt15\">\r\n                <p>{{ paginationContext }}\r\n                <select [(ngModel)]=\"limit\" (ngModelChange)=\"update()\">\r\n                  <option value=\"25\">25</option>\r\n                  <option value=\"50\">50</option>\r\n                  <option value=\"100\">100</option>\r\n                  <option value=\"200\">200</option>\r\n                </select>\r\n                per page</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <div class=\"pagination-holder\">\r\n                  <ul [class.selected]=\"page == pageNumber\" class=\"pagination\" *ngFor=\"let page of pages\">\r\n                    <li (click)=\"toPage(page)\">{{ page }}</li>\r\n                  </ul>\r\n                </div>\r\n              </div>\r\n           </div>\r\n          <div class=\"schedule-results-table\">\r\n            <div class=\"header-col\">\r\n              <div class=\"col1\" [class.selected]=\"sort === 'duration'\" (click)=\"setSort('duration')\">Transit<span class=\"sort-span\">&#9660;</span></div>\r\n              <div class=\"col2\" [class.selected]=\"sort === 'carrier'\" (click)=\"setSort('carrier')\">Carrier<span class=\"sort-span\">&#9660;</span></div>\r\n              <div class=\"col3\" [class.selected]=\"sort === 'start_date'\" (click)=\"setSort('start_date')\">Departure<span class=\"sort-span\">&#9660;</span></div>\r\n              <div class=\"col4\" [class.selected]=\"sort === 'end_date'\" (click)=\"setSort('end_date')\">Arrival<span class=\"sort-span\">&#9660;</span></div>\r\n            </div>\r\n            <div class=\"results-row\" *ngFor=\"let schedule of schedules.items\">\r\n              <div class=\"results-row-padding\">\r\n                <div class=\"col6\"><a [class.open]=\"schedule.viewDetails\" class=\"expand-button more-icon\" title=\"View More Details\" (click)=\"toggleActions(schedule)\" (click)=\"viewDetails(schedule)\"><img src=\"../img/blackarrow-01.svg\" onerror=\"this.onerror=null; this.src='../img/blackarrow.png'\"></a></div>\r\n                <div class=\"col1\"><p class=\"table-rep-header\"><b>Transit</b></p><b>{{ schedule.duration }} days</b><br> {{ schedule.transhipments}}</div>\r\n                <div class=\"col2\">\r\n                  <p class=\"table-rep-header\"><b>Carrier</b></p>\r\n                  <span class=\"carrier-logo-wrapper\">\r\n                    <img [routerLink]=\"['/carriers', schedule.carrier.id, {scroll: true}]\" class=\"company-logo pointer\" src=\"../img/carriers/{{ schedule.carrier.id }}.gif\" onerror=\"src='../img/carriers/0.gif'\">\r\n                  </span>\r\n                  <b class=\"hover-link\" [routerLink]=\"['/carriers', schedule.carrier.id, {scroll: true}]\">{{ schedule.carrier.name }}</b>\r\n                  <span class=\"favorite-star\">\r\n                    <img class=\"ga-favorite-carrier\" [favorite]=\"schedule.carrier\" [itemtype]=\"'carrier'\">\r\n                  </span>\r\n                </div>\r\n                <div class=\"col3\"><p class=\"table-rep-header\"><b>Departure</b></p><b>{{ schedule.departurePort.title }}</b><br>{{ schedule.departureDate }}</div>\r\n                <div class=\"col4\"><p class=\"table-rep-header\"><b>Arrival</b></p><b>{{ schedule.arrivalPort.name }} [{{ schedule.arrivalPort.code }}]</b><br>{{ schedule.arrivalDate }}</div>\r\n                <div class=\"col5\">\r\n                  <a title=\"Email this Schedule\" class=\"actions-icon open-share-result-event\" (click)=\"toggleShare()\"><img class=\"main-img\" src=\"../img/litepurple-email.svg\" onerror=\"this.onerror=null; this.src='../img/litepurple-email.png'\"><img class=\"hover-img\" src=\"../img/email-purple.svg\" onerror=\"this.onerror=null; this.src='../img/email-purple.png'\"></a>\r\n                  <a title=\"Contact this Carrier\" class=\"actions-icon contact-carrier-event phone-icon\" (click)=\"toggleActions(schedule)\" (click)=\"contact(schedule)\"><img class=\"main-img\" src=\"../img/contact-icon-lite.svg\" onerror=\"this.onerror=null; this.src='../img/contact-lite-icon-01.png'\"><img class=\"hover-img\" src=\"../img/contact-icon.svg\" onerror=\"this.onerror=null; this.src='../img/contact-icon-01.png'\"></a>\r\n                </div>\r\n            </div>\r\n              <div class=\"results-row-bottom\" *ngIf=\"schedule.viewDetails\">\r\n                <div class=\"inner-results-row\" *ngFor=\"let leg of schedule.legs\">\r\n                  <div class=\"col1\"><em><u>Vessel</u></em><br><blur [item]=\"leg.vessel\" [itemtype]=\"'vessel'\"></blur></div>\r\n                  <div class=\"col2\"><em><u>Voyage</u></em><br><blur [item]=\"leg.voyage\" [itemtype]=\"'small-number-dark'\"></blur></div>\r\n                  <div class=\"col3\"><em><u>Service</u></em><br><blur [item]=\"leg.route.name\" [itemtype]=\"'large-text-dark'\"></blur></div>\r\n                  <div class=\"col4 etaDateTime\"><em><u>Departure</u></em><br><blur [item]=\"leg.startPort\" [itemtype]=\"'port'\"></blur>\r\n                    <br><blur [item]=\"leg.startDate\" [itemtype]=\"'large-text-dark'\"></blur>\r\n                    <blur [item]=\"leg.startTime\" [itemtype]=\"'small-text'\" class=\"small-gray-text\"></blur>\r\n                  </div>\r\n                  <div class=\"col5 etaDateTime\"><em><u>Arrival</u></em><br><blur [item]=\"leg.endPort\" [itemtype]=\"'port'\"></blur>\r\n                    <br><blur [item]=\"leg.endDate\" [itemtype]=\"'large-text-dark'\"></blur>\r\n                    <blur [item]=\"leg.endTime\" [itemtype]=\"'small-text'\" class=\"small-gray-text\"></blur>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-holder\">\r\n            <div class=\"col1of2 mt15\">\r\n              <p>{{ paginationContext }}\r\n              <select class=\"mt0\" [(ngModel)]=\"limit\" (ngModelChange)=\"update()\">\r\n                <option value=\"25\">25</option>\r\n                <option value=\"50\">50</option>\r\n                <option value=\"100\">100</option>\r\n                <option value=\"200\">200</option>\r\n              </select>\r\n              per page</p>\r\n            </div>\r\n            <div class=\"col1of2 mt5\">\r\n              <div class=\"pagination-holder\">\r\n                <ul [class.selected]=\"page == pageNumber\" class=\"pagination\" *ngFor=\"let page of pages\">\r\n                  <li (click)=\"toPage(page)\">{{ page }}</li>\r\n                </ul>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"save-email-bar\" *ngIf=\"schedules.searchId !== 0\">\r\n            <div class=\"col1of3 text-center\">\r\n              <a *ngIf=\"service.app.accountType !== ''\" (click)=\"toggleSave()\" class=\"btn-no-fill\"><img src=\"../img/white-save.svg\" onerror=\"this.onerror=null; this.src='../img/white-safe.png'\">Save Route</a>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"registerMessage()\" class=\"btn-no-fill\"><img src=\"../img/white-save.svg\" onerror=\"this.onerror=null; this.src='../img/white-safe.png'\">Save Route</a>\r\n            </div>\r\n            <div [class.loading]=\"service.downloadLoaderOff\" class=\"col1of3 text-center download-btn\">\r\n              <a (click)=\"download()\" class=\"btn-no-fill\">\r\n                <svg id=\"Layer_1\" xmlns:x=\"&ns_extend;\" xmlns:i=\"&ns_ai;\" xmlns:graph=\"&ns_graphs;\"\r\n                    xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"15.4px\" height=\"15px\"\r\n                    viewBox=\"0 0 15.4 15\" style=\"enable-background:new 0 0 15.4 15;\" xml:space=\"preserve\">\r\n                    <g i:extraneous=\"self\">\r\n                      <title>download-white</title>\r\n                      <path id=\"arrow\" style=\"fill:#FFFFFF;\" d=\"M11.7,7.8c0.2-0.2,0.2-0.4,0-0.6c0,0,0,0,0,0c-0.2-0.2-0.4-0.2-0.6,0c0,0,0,0,0,0l-3,3V0.4\r\n                        C8.1,0.2,7.9,0,7.7,0C7.5,0,7.3,0.2,7.3,0.4c0,0,0,0,0,0v9.8l-3-3c-0.2-0.2-0.4-0.2-0.6,0c-0.2,0.2-0.2,0.4,0,0.6l3.7,3.7\r\n                        c0.2,0.2,0.4,0.2,0.6,0L11.7,7.8z\"/>\r\n                      <path style=\"fill:#FFFFFF;\" d=\"M14.6,10.5c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0c0.2,0,0.4,0.2,0.4,0.4c0,0,0,0,0,0v4\r\n                        c0,0.2-0.1,0.4-0.4,0.5c0,0,0,0-0.1,0H0.4C0.2,15,0,14.8,0,14.6c0,0,0,0,0,0v-4c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v3.6h13.8\r\n                        L14.6,10.5L14.6,10.5z\"/>\r\n                    </g>\r\n                  </svg> Download Results</a>\r\n            </div>\r\n            <div class=\"col1of3 text-center\">\r\n              <a (click)=\"toggleShare()\" class=\"btn-no-fill\"><img src=\"../img/white-email.svg\" onerror=\"this.onerror=null; this.src='../img/white-email.png'\">Email Results</a>\r\n            </div>\r\n          </div>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n</div>\r\n<share-results [display]=\"showShare\" [id]=\"schedules.searchId\" [schedules]=\"schedules\" (onClose)=\"closeShare()\"></share-results>\r\n<save-route [display]=\"showSave\" [origins]=\"schedules.originPorts\" [destinations]=\"schedules.destinationPorts\" (onClose)=\"closeSave()\"></save-route>\r\n<contact-carrier [display]=\"showContact\" [schedule]=\"contactSchedule\" (onClose)=\"closeContact()\"></contact-carrier>\r\n"

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = ".schedule-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 58%; }\n  .schedule-banner .schedule-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .schedule-banner .schedule-banner-inner .btn-no-fill {\n      float: right;\n      margin-top: 15px; }\n    .schedule-banner .schedule-banner-inner .btn {\n      color: #000; }\n    .schedule-banner .schedule-banner-inner h3 {\n      display: inline-block; }\n    .schedule-banner .schedule-banner-inner.search-on {\n      padding: 60px 20px 90px 20px; }\n    .schedule-banner .schedule-banner-inner h3 {\n      font-size: 27px; }\n    .schedule-banner .schedule-banner-inner h2 {\n      display: inline-block;\n      height: 38px;\n      font-weight: 300;\n      margin-bottom: 10px;\n      width: 100%; }\n      .schedule-banner .schedule-banner-inner h2 img {\n        height: 42px;\n        width: 42px;\n        cursor: default;\n        margin-right: 10px; }\n\n.results-header {\n  background: #282828;\n  height: 50px;\n  color: #ffffff;\n  /*\r\n  .btn-refine:not(.btn-light-blue) { \r\n    background: #686868;\r\n    border: none;\r\n    color: #ffffff;\r\n    font-size: 18px;\r\n    padding: 8px 20px;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n    line-height: 15px;\r\n    transition: background ease .5s;\r\n    display: inline-block;\r\n    border-radius: 3px;\r\n  }\r\n  .btn-light-blue {\r\n    &:hover {\r\n      background: #217ebf;\r\n    }\r\n  }\r\n  */ }\n  .results-header h5 {\n    line-height: 50px;\n    font-weight: 300; }\n  .results-header .results-header-col-1 {\n    display: inline-block;\n    width: 320px;\n    padding-left: 10px; }\n  .results-header .results-header-col-2 {\n    display: inline-block;\n    width: calc(100% - 320px);\n    padding-left: 20px; }\n\n.compare-by-container {\n  border-bottom: 1px solid #c5c5c5;\n  margin-left: -20px;\n  margin-right: -20px;\n  margin-bottom: 20px; }\n  .compare-by-container span {\n    color: #9f9591;\n    margin-left: 20px;\n    margin-right: 20px;\n    display: inline-block;\n    vertical-align: top;\n    margin-top: 3px;\n    font-size: 16px; }\n  .compare-by-container .compare-by-tab {\n    background: #f5f5f5;\n    padding: 10px 20px;\n    border: 1px solid #c5c5c5;\n    font-size: 16px;\n    line-height: 1em;\n    display: inline-block;\n    margin-bottom: -1px; }\n    .compare-by-container .compare-by-tab.active {\n      background: #fff;\n      border-bottom-color: #fff;\n      border-top: 2px solid #217ebf;\n      padding-top: 9px;\n      color: #353535;\n      display: inline-block;\n      margin-bottom: -1px; }\n\n.sidebar-carrier-list .sidebar-section-right {\n  display: inline-block;\n  width: calc(100% - 85px);\n  vertical-align: top; }\n  .sidebar-carrier-list .sidebar-section-right p {\n    line-height: 26px; }\n\n.sidebar-carrier-list .carrier-sidebar-section-right {\n  width: calc(100% - 26px); }\n\n.sidebar-carrier-list .select-box-div {\n  width: 14px;\n  height: 14px;\n  border: 1px solid #217ebf;\n  border-radius: 3px;\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 5px;\n  margin-top: 7px;\n  cursor: pointer; }\n  .sidebar-carrier-list .select-box-div span {\n    color: #ffffff;\n    visibility: hidden;\n    line-height: 16px;\n    vertical-align: top;\n    font-size: 12px;\n    position: relative;\n    top: -2px;\n    left: 1px;\n    transition: all 1s ease; }\n  .sidebar-carrier-list .select-box-div.selected {\n    background: #217ebf; }\n    .sidebar-carrier-list .select-box-div.selected span {\n      visibility: visible; }\n  .sidebar-carrier-list .select-box-div > div {\n    cursor: pointer; }\n\n.sidebar-carrier-list .company-logo {\n  width: 40px;\n  vertical-align: top;\n  margin-top: 6px;\n  margin-left: 5px;\n  margin-right: 10px; }\n\n.sidebar-transhipments .sidebar-section-right {\n  display: inline-block;\n  width: calc(100% - 85px);\n  vertical-align: top; }\n  .sidebar-transhipments .sidebar-section-right p {\n    line-height: 26px; }\n  .sidebar-transhipments .sidebar-section-right a {\n    color: #ffffff; }\n    .sidebar-transhipments .sidebar-section-right a:hover {\n      color: #e6e6e6; }\n\n.sidebar-transhipments .select-box-div {\n  width: 14px;\n  height: 14px;\n  border: 1px solid #217ebf;\n  border-radius: 3px;\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 5px;\n  margin-top: 10px; }\n  .sidebar-transhipments .select-box-div span {\n    color: #ffffff;\n    visibility: hidden;\n    line-height: 16px;\n    vertical-align: top;\n    font-size: 12px;\n    position: relative;\n    top: -2px;\n    left: 1px;\n    transition: all 1s ease; }\n  .sidebar-transhipments .select-box-div.selected {\n    background: #217ebf; }\n    .sidebar-transhipments .select-box-div.selected span {\n      visibility: visible; }\n  .sidebar-transhipments .select-box-div > div {\n    cursor: pointer; }\n\n.date-change-btn {\n  padding: 7px;\n  float: right; }\n\n.content-sidebar-wrapper {\n  position: relative;\n  /*min-height: 457px;*/\n  /*min-height: 100%;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.refine-sidebar {\n  z-index: 26;\n  position: absolute;\n  min-height: 100%;\n  display: inline-block;\n  background: #393939;\n  color: #ffffff;\n  width: 350px;\n  border-top: 1px solid #393939;\n  transition: all 1s ease; }\n  .refine-sidebar .sidebar-header {\n    background: #282828;\n    padding: 5px 10px; }\n    .refine-sidebar .sidebar-header p {\n      font-size: 20px; }\n  .refine-sidebar .sidebar-section {\n    padding: 10px 10px; }\n    .refine-sidebar .sidebar-section:nth-of-type(even) {\n      background: #464646; }\n    .refine-sidebar .sidebar-section .date {\n      width: 100%; }\n  .refine-sidebar .sidebar-section-port {\n    padding: 0; }\n    .refine-sidebar .sidebar-section-port > div {\n      padding: 10px; }\n  .refine-sidebar .expand-button {\n    cursor: pointer; }\n    .refine-sidebar .expand-button img {\n      height: 20px;\n      position: relative;\n      top: 3px;\n      margin-right: 5px;\n      transition: transform .5s linear; }\n    .refine-sidebar .expand-button.open img {\n      transform: rotate(180deg); }\n  .refine-sidebar .sidebar-slider-section {\n    padding-left: 30px;\n    padding-right: 30px; }\n  .refine-sidebar .refine-sidebar-after {\n    display: none;\n    position: absolute;\n    height: 40px;\n    border-radius: 0px 3px 3px 0;\n    top: 20px;\n    left: 100%;\n    cursor: pointer;\n    box-shadow: inset 7px 0 9px -7px rgba(0, 0, 0, 0.7);\n    overflow: hidden; }\n    .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner {\n      background: #393939;\n      border-radius: 0px 3px 3px 0;\n      margin-left: -40px;\n      transition: all .5s ease;\n      padding-left: 2px;\n      padding-right: 2px; }\n      .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p {\n        white-space: nowrap;\n        font-size: 14px;\n        line-height: 38px;\n        padding-left: 2px; }\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p span.arrow2,\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p span.arrow {\n          display: inline;\n          /* text-align: center; */\n          line-height: 31px;\n          font-size: 40px;\n          vertical-align: top; }\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p span.arrow2 {\n          display: none; }\n      .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner:hover {\n        margin-left: 0; }\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner:hover p span.text {\n          display: inline;\n          color: #ffffff; }\n  .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner {\n    margin-left: 0px;\n    transition: all .01s ease; }\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner p span.text,\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner p span.arrow {\n      display: none; }\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner p span.arrow2 {\n      display: inline; }\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner:hover {\n      margin-left: 0px; }\n      .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner:hover p span.text {\n        display: none; }\n\n.trans-sales-message {\n  background: #2798d8;\n  margin-bottom: 25px;\n  margin-top: 15px;\n  padding: 10px 25px;\n  border-radius: 5px;\n  color: #fff; }\n  .trans-sales-message p {\n    line-height: 28px; }\n  .trans-sales-message h6 {\n    color: #ffffff;\n    line-height: 36px; }\n  .trans-sales-message a {\n    color: #ffffff;\n    text-decoration: underline; }\n\n.results-content {\n  margin-left: 350px;\n  vertical-align: top;\n  display: inline-block;\n  width: calc(100% - 350px);\n  padding: 20px;\n  padding-bottom: 200px; }\n\n.header-col {\n  width: calc(100% + 40px);\n  margin-left: -20px;\n  background: #f0f0f0;\n  margin-bottom: 25px;\n  margin-top: 25px;\n  padding: 10px 30px; }\n  .header-col div {\n    vertical-align: top;\n    font-weight: bold;\n    font-size: 20px;\n    cursor: pointer; }\n    .header-col div .sort-span {\n      display: none;\n      font-size: 16px;\n      position: relative;\n      top: -3px;\n      white-space: nowrap; }\n    .header-col div:hover .sort-span {\n      display: inline; }\n    .header-col div.selected .sort-span {\n      display: inline; }\n  .header-col .col1 {\n    margin-left: 22px;\n    min-width: 85px; }\n  .header-col .col2 {\n    padding-left: 32px !important; }\n  .header-col .col5 {\n    width: 20px; }\n\n.schedule-results-table {\n  font-size: 0; }\n  .schedule-results-table .results-row {\n    border: 1px solid #c1c1c1;\n    margin-bottom: 20px;\n    font-size: 0; }\n    .schedule-results-table .results-row .company-logo {\n      vertical-align: middle;\n      max-width: 100%;\n      max-height: 40px; }\n    .schedule-results-table .results-row .carrier-logo-wrapper {\n      width: 36px;\n      text-align: center;\n      display: inline-block; }\n    .schedule-results-table .results-row .results-row-padding {\n      padding: 10px;\n      font-size: 0; }\n    .schedule-results-table .results-row .inner-results-row:nth-of-type(odd) {\n      background: #efecf3; }\n    .schedule-results-table .results-row:nth-of-type(2n) {\n      background: #efecf3; }\n      .schedule-results-table .results-row:nth-of-type(2n) .inner-results-row:nth-of-type(odd) {\n        background: #ffffff; }\n    .schedule-results-table .results-row div {\n      vertical-align: top;\n      font-size: 16px; }\n    .schedule-results-table .results-row .notes-div {\n      background: #c1c1c1;\n      padding-left: 10px; }\n      .schedule-results-table .results-row .notes-div p {\n        line-height: 26px; }\n    .schedule-results-table .results-row .table-rep-header {\n      display: none; }\n  .schedule-results-table .col1, .schedule-results-table .col2, .schedule-results-table .col3, .schedule-results-table .col4, .schedule-results-table .col5, .schedule-results-table .col6 {\n    display: inline-block;\n    padding-left: 3px;\n    padding-right: 3px;\n    word-break: break-word;\n    overflow-wrap: break-word; }\n  .schedule-results-table .col1 {\n    width: 10%; }\n  .schedule-results-table .col2 {\n    width: 22.5%; }\n  .schedule-results-table .col3 {\n    width: 22.5%; }\n  .schedule-results-table .col4 {\n    width: 22.5%; }\n  .schedule-results-table .col5 {\n    width: calc(22.5% - 30px); }\n  .schedule-results-table .col6 {\n    width: 24px; }\n    .schedule-results-table .col6 a {\n      padding: 6px 10px;\n      margin-left: -10px;\n      height: 42px;\n      line-height: 42px;\n      margin-top: 0px; }\n      .schedule-results-table .col6 a img {\n        transition: transform .2s ease-in-out;\n        height: 20px; }\n      .schedule-results-table .col6 a.open img {\n        transform: rotate(90deg); }\n  .schedule-results-table .results-row-padding .col5 {\n    text-align: right; }\n  .schedule-results-table .inner-results-row {\n    padding: 10px;\n    font-size: 0 !important; }\n    .schedule-results-table .inner-results-row .col1 {\n      width: 20%; }\n    .schedule-results-table .inner-results-row .col2 {\n      width: 10%; }\n    .schedule-results-table .inner-results-row .col3 {\n      width: 30%; }\n    .schedule-results-table .inner-results-row .col4 {\n      width: 20%; }\n    .schedule-results-table .inner-results-row .col5 {\n      width: 20%; }\n  .schedule-results-table .results-row-bottom input[type=\"text\"] {\n    width: calc(100% - 190px); }\n  .schedule-results-table .results-row-bottom .btn {\n    position: relative;\n    top: 2px;\n    line-height: 18px;\n    margin-left: 10px;\n    background: #664587; }\n    .schedule-results-table .results-row-bottom .btn:hover {\n      background: #4d3465; }\n  .schedule-results-table .results-row-bottom .results-row-bottom-notes {\n    padding: 10px; }\n\n.details-button {\n  margin-top: 5px;\n  display: inline-block;\n  background: #664587;\n  padding: 2px 15px;\n  color: #ffffff;\n  font-weight: 400;\n  white-space: nowrap;\n  width: 140px; }\n  .details-button:hover {\n    background: #4d3465; }\n  .details-button .x-holder {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    border: 1px solid #ffffff;\n    border-radius: 50%;\n    position: relative;\n    vertical-align: sub !important;\n    transition: transform .5s ease;\n    margin-top: 5px;\n    float: right; }\n    .details-button .x-holder .x-two,\n    .details-button .x-holder .x-one {\n      width: 12px;\n      height: 2px;\n      background: #ffffff;\n      display: inline-block;\n      position: absolute;\n      top: calc(50% - 1px);\n      left: calc(50% - 6px); }\n    .details-button .x-holder .x-two {\n      width: 2px;\n      height: 12px;\n      left: calc(50% - 1px);\n      top: calc(50% - 6px); }\n  .details-button.open .x-holder {\n    transform: rotate(45deg); }\n\n.save-email-bar {\n  background: #664587;\n  padding: 10px;\n  margin-top: 15px;\n  font-size: 0; }\n  .save-email-bar .btn-no-fill {\n    padding: 10px 20px 10px 10px; }\n    .save-email-bar .btn-no-fill:hover {\n      color: #ffffff; }\n  .save-email-bar img {\n    height: 18px;\n    margin-right: 5px; }\n\n.actions-dropdown {\n  display: none;\n  position: absolute;\n  z-index: 2; }\n  .actions-dropdown .actions-button {\n    display: inline-block;\n    background: #4d3668;\n    padding: 0 15px;\n    color: #ffffff;\n    font-weight: 400;\n    white-space: nowrap;\n    width: 140px; }\n    .actions-dropdown .actions-button:hover {\n      background: #342546; }\n    .actions-dropdown .actions-button:nth-of-type(even) {\n      background: #543a71; }\n      .actions-dropdown .actions-button:nth-of-type(even):hover {\n        background: #3b294f; }\n\n.actions-dropdown.active {\n  display: block; }\n\n.map-col .map-header {\n  display: none;\n  margin-bottom: 15px; }\n\n.map-col:first-of-type {\n  padding-right: 10px; }\n\n.map-col:last-of-type {\n  padding-left: 10px; }\n\nagm-map {\n  height: 300px;\n  width: 100%; }\n\n.no-results-wrapper {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: #fff;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  padding-left: 350px;\n  padding-top: 35px;\n  padding-right: 20px;\n  padding-bottom: 35px; }\n\n#loader-wrapper {\n  position: absolute;\n  top: 0;\n  left: 320px;\n  width: calc(100% - 320px);\n  height: 100%;\n  z-index: 25;\n  background: rgba(255, 255, 255, 0.5); }\n\n#loader {\n  display: block;\n  position: relative;\n  left: 50%;\n  top: 220px;\n  width: 80px;\n  height: 80px;\n  margin: -40px 0 0 -40px;\n  border-radius: 50%;\n  border: 5px solid #3498db;\n  z-index: 1500;\n  border: 3px solid transparent;\n  border-top-color: #333333;\n  border-left-color: #333333;\n  animation: spin 1s linear infinite; }\n\n.sticky-loader {\n  left: calc(50% + 150px) !important; }\n\n@keyframes spin {\n  0% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: rotate(0deg);\n    /* Firefox 16+, IE 10+, Opera */ }\n  100% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: rotate(360deg);\n    /* Firefox 16+, IE 10+, Opera */ } }\n\n.save-email-bar .download-btn a {\n  padding-top: 13px; }\n\n.download-btn #Layer_1 {\n  width: 18px;\n  margin-right: 5px; }\n\n.download-btn.loading #Layer_1 #arrow {\n  animation: down 1.5s linear infinite; }\n\n@keyframes down {\n  0% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: translateY(0px);\n    /* Firefox 16+, IE 10+, Opera */ }\n  50% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: translateY(18px);\n    /* Firefox 16+, IE 10+, Opera */ }\n  51% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: translateY(-18px);\n    /* Firefox 16+, IE 10+, Opera */ }\n  100% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: translateY(0px);\n    /* Firefox 16+, IE 10+, Opera */ } }\n\n@media only screen and (max-width: 1023px) {\n  .refine-sidebar {\n    margin-left: -315px;\n    transition: all 1s ease;\n    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.5); }\n    .refine-sidebar.active {\n      margin-left: 0; }\n    .refine-sidebar .refine-sidebar-after {\n      display: block; }\n  .results-content {\n    width: 100%;\n    margin-left: 0; }\n  .results-header .results-header-col-1 {\n    display: none; }\n  .no-results-wrapper {\n    padding-left: 64px; }\n  #loader-wrapper {\n    left: 0;\n    width: 100%; }\n  .sticky-loader {\n    left: 50% !important; } }\n\n@media only screen and (max-width: 980px) {\n  .save-email-bar .col1of3 {\n    width: 33%; } }\n\n@media only screen and (max-width: 767px) {\n  .map-col .map-header {\n    display: block; }\n  .map-col:first-of-type {\n    margin-bottom: 25px;\n    padding-right: 0; }\n  .map-col:last-of-type {\n    padding-left: 0; } }\n\n@media only screen and (max-width: 699px) {\n  .schedule-banner .schedule-banner-inner {\n    padding: 15px 15px 15px 15px; }\n    .schedule-banner .schedule-banner-inner.search-on {\n      padding: 15px 15px 15px 15px; }\n  .schedule-results-table {\n    margin-top: 35px; }\n    .schedule-results-table .results-row .table-rep-header {\n      display: block;\n      text-decoration: underline; }\n    .schedule-results-table .results-row-padding .col5 {\n      text-align: center; }\n    .schedule-results-table .col1, .schedule-results-table .col2, .schedule-results-table .col3, .schedule-results-table .col4, .schedule-results-table .col5 {\n      width: 100%;\n      margin-bottom: 10px;\n      line-height: 18px;\n      text-align: center; }\n    .schedule-results-table .col1 {\n      width: calc(100% - 48px); }\n    .schedule-results-table .inner-results-row .col1, .schedule-results-table .inner-results-row .col2, .schedule-results-table .inner-results-row .col3, .schedule-results-table .inner-results-row .col4, .schedule-results-table .inner-results-row .col5 {\n      width: 100%;\n      margin-bottom: 10px;\n      line-height: 18px;\n      text-align: center; }\n    .schedule-results-table .results-row-bottom input[type=\"text\"] {\n      width: 100%; }\n    .schedule-results-table .results-row-bottom .btn {\n      margin-left: 0;\n      float: right;\n      margin-right: 1px; }\n  .header-col {\n    display: none; }\n  .details-button {\n    padding: 7px 15px;\n    line-height: 28px; }\n  .actions-dropdown {\n    width: 140px;\n    left: calc(50% - 70px); }\n  .save-email-bar .col1of3 {\n    width: 100%;\n    margin-top: 15px; }\n  .actions-icon img {\n    margin-left: 5px;\n    margin-right: 5px; }\n  #loader {\n    left: calc(50vw - 20px); }\n  .sticky-loader {\n    left: 20px !important; }\n    .sticky-loader #loader {\n      left: calc(50vw - 20px); } }\n\n@media only screen and (max-width: 399px) {\n  .refine-sidebar {\n    width: 300px;\n    margin-left: -295px; }\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; }\n  .refine-sidebar .sidebar-slider-section {\n    padding-left: 20px;\n    padding-right: 20px; } }\n\n.ng5-slider .ng5-slider-pointer {\n  background-color: red; }\n\n.deactivated-btn {\n  background-color: gray; }\n"

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var models_1 = __webpack_require__(12);
var PortsService = (function () {
    function PortsService(api, cache, logger, favorite, seo, app, el, renderer) {
        this.api = api;
        this.cache = cache;
        this.logger = logger;
        this.favorite = favorite;
        this.seo = seo;
        this.app = app;
        this.renderer = renderer;
        this.queryString = '';
        this.loaderOff = false;
        this.noResult = false;
    }
    PortsService.prototype.getPortSchedules = function (portId, params) {
        var _this = this;
        this.logger.log('ports.service', 'getPortSchedules', portId);
        this.noResult = false;
        // let cache = this.cache.get('ports' + this.queryString);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetPortSchedules(client, portId, params); });
        // let server = Observable.fromPromise(promise);
        // this.schedules = Observable.concat(cache, server);
        // this.schedules = server;
        // this.cache.updateCache('ports' + this.queryString, this.schedules);
        return promise;
    };
    PortsService.prototype.callGetPortSchedules = function (apigClient, portId, query) {
        var _this = this;
        this.logger.log('ports.service', 'callGetPortSchedules', portId);
        return new Promise(function (resolve, reject) {
            var params = {
                portId: portId
            };
            var body = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: query
            };
            try {
                apigClient.portsPortIdSchedulesGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('ports.service', 'result', result);
                    if (result.data === null) {
                        _this.resizeSidebar();
                        _this.loaderOff = true;
                        _this.noResult = true;
                    }
                    else if (result.data.items.length === 0 || result.data.summary.count === 0) {
                        _this.resizeSidebar();
                        _this.loaderOff = true;
                        _this.noResult = true;
                    }
                    else {
                        _this.resizeSidebar();
                        _this.loaderOff = true;
                    }
                    var formatted = {
                        searchId: result.data.searchId,
                        total: result.data.summary.count,
                        carriers: Array(),
                        selectedCarriers: result.data.summary.selected_carriers,
                        excludedCarriers: result.data.summary.excluded_carriers,
                        items: Array()
                    };
                    for (var current = 0; current < result.data.items.length; current++) {
                        formatted.items[current] = new shared_1.Schedule(result.data.items[current]);
                    }
                    var selected = result.data.summary.selected_carriers;
                    var available = result.data.summary.available_carriers;
                    var excluded = result.data.summary.excluded_carriers;
                    for (var current = 0; current < available.length; current++) {
                        formatted.carriers[current] = available[current];
                        formatted.carriers[current].carrier = new shared_1.Carrier(formatted.carriers[current].carrier);
                        formatted.carriers[current].selected = _this.isCarrierSelected(available[current].carrier.id, selected, excluded);
                        formatted.carriers[current].iconUrl = '../img/carriers/' + formatted.carriers[current].carrier.id + '.gif';
                    }
                    _this.logger.log('ports.service', 'formatted', formatted);
                    resolve(formatted);
                }).catch(function (err) {
                    _this.resizeSidebar();
                    _this.loaderOff = true;
                    _this.noResult = true;
                    reject(_this.api.handleError(err));
                });
            }
            catch (ex) {
                reject(null);
            }
        });
    };
    PortsService.prototype.isCarrierSelected = function (carrierId, selected, excluded) {
        if (selected.length === 0 && excluded.length === 0) {
            return true;
        }
        // excluded
        if (excluded.indexOf(carrierId) > -1) {
            return false;
        }
        // selected and not excluded
        if (selected.indexOf(carrierId) > -1) {
            return true;
        }
        // not selected
        if (selected.length !== 0) {
            return false;
        }
        // not excluded
        return true;
    };
    PortsService.prototype.formatResult = function (result) {
        var formatted;
        formatted.items = Array();
        for (var current = 0; current < result.data.items.length; current++) {
            formatted.items[current] = new shared_1.Schedule(result.data.items[current]);
        }
        return formatted.items;
    };
    PortsService.prototype.getPort = function (portId) {
        var _this = this;
        this.logger.log('ports.service', 'getPort', portId);
        // let cache = this.cache.get('ports' + portId);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetPort(client, portId); });
        // let server = Observable.fromPromise(promise);
        // this.port = server;
        // this.port = Observable.concat(cache, server);
        // this.port = this.cache.updateCache('ports' + this.queryString, this.port);
        return promise;
    };
    PortsService.prototype.callGetPort = function (apigClient, portId) {
        var _this = this;
        this.logger.log('ports.service', 'callGetPort', portId);
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {
                    id: portId
                }
            };
            try {
                apigClient.portsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('ports.service', 'port result', result);
                    var port = new models_1.Port(result.data.items[0]);
                    _this.seo.setPort(port);
                    resolve(port);
                }).catch(function (err) { return reject(_this.api.handleError(err)); });
            }
            catch (ex) {
                reject(null);
            }
        });
    };
    PortsService.prototype.resizeSidebar = function () {
        var _this = this;
        setTimeout(function () {
            try {
                _this.el = document.getElementById('refine-sidebar-inner');
                _this.content = document.getElementById('results-content');
                _this.container = document.getElementById('content-sidebar-wrapper');
                _this.renderer.setElementProperty(_this.container, 'style', false);
                if (_this.el.scrollHeight > _this.content.scrollHeight) {
                    var heightNum = (_this.el.scrollHeight + 200);
                    _this.renderer.setElementStyle(_this.container, 'height', heightNum + 'px');
                }
            }
            catch (ex) {
            }
        }, 10);
    };
    PortsService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.CacheService, shared_1.LogService, shared_1.FavoriteService, shared_1.SeoService, shared_1.AppContext, core_1.ElementRef, core_1.Renderer])
    ], PortsService);
    return PortsService;
}());
exports.PortsService = PortsService;


/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ports-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"ports-banner-inner\">\r\n      <h2><img class=\"type-icon\" src=\"../img/crane-01.svg\"\r\n          onerror=\"this.onerror=null; this.src='../img/crane-01.png'\">{{ port.title }}\r\n        <span [class.hide]=\"port.display === ''\" class=\"favorite-star-big\"><img class=\"ga-favorite-port\"\r\n            [favorite]=\"port\" [itemtype]=\"'port'\"></span>\r\n      </h2>\r\n      <div class=\"clear\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"results-header\">\r\n      <div class=\"col-holder\">\r\n        <div class=\"results-header-col-1\">\r\n          <h5>Refine Results</h5>\r\n        </div>\r\n        <div class=\"results-header-col-2\">\r\n          <h5>Vessels</h5>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-holder content-sidebar-wrapper\" id=\"content-sidebar-wrapper\">\r\n      <div *ngIf=\"service.noResult\" class=\"no-results-wrapper\">\r\n        <h4>No Results Found</h4>\r\n      </div>\r\n      <div [class.active]=\"sidebarActive\" class=\"refine-sidebar\">\r\n        <div id=\"refine-sidebar-inner\">\r\n          <div class=\"sidebar-section\">\r\n            <div class=\"col-holder\">\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Port:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <p>{{ port.name }}</p>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Region:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <p>{{ port.regionName }}</p>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Country:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <p>{{ port.countryName }}</p>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Locode:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <p>[{{ port.code }}]</p>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Lat/Lon:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <p>{{ port.coordinates }}</p>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Date</p>\r\n          </div>\r\n          <div class=\"sidebar-section\">\r\n            <div class=\"date-row\">\r\n              <div class=\"prev-next-holder date-col\">\r\n                <a class=\"btn-blue ga-event-port-date-change\" (click)=\"previousDay()\"><</a> \r\n              </div> \r\n              <div class=\"datepicker-holder date-col\">\r\n                <datepicker class=\"ga-event-port-date-change\" [(ngModel)]=\"date\" view-format=\"YYYY-MM-DD\"\r\n                      init-date=\"{{date}}\" (ngModelChange)=\"changeDate()\"></datepicker>\r\n              </div>\r\n             <div class=\"prev-next-holder date-col\">\r\n                <a style=\"float: right;\" class=\"btn-blue ga-event-port-date-change\" (click)=\"nextDay()\">></a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Carriers</p>\r\n          </div>\r\n          <div class=\"sidebar-section\">\r\n            <a id=\"select-all-btn\" class=\"btn-light-blue\" [class.disabled]=\"allSelected()\" [class.deactivated-btn]=\"allSelected()\" (click)=\"selectAll()\" style=\"padding-left: 14px; padding-right: 14px;\">Select All</a>\r\n            <a id=\"clear-all-btn\" class=\"btn-light-blue\" [class.disabled]=\"allCleared()\" [class.deactivated-btn]=\"allCleared()\" (click)=\"clearAll()\" style=\"padding-left: 14px; padding-right: 14px;\">Clear All</a>\r\n            <a *ngIf=\"service.app.accountType !== ''\" class=\"btn-light-blue\" style=\"float:right\"\r\n              (click)=\"favoritesOnly()\">Favorites</a>\r\n            <a *ngIf=\"service.app.accountType === ''\" class=\"btn-light-blue\" style=\"float:right\"\r\n              (click)=\"registerMessage()\">Favorites</a>\r\n          </div>\r\n          <div class=\"sidebar-section sidebar-carrier-list\" *ngFor=\"let carrier of schedules.carriers\">\r\n            <div>\r\n              <div (click)=selectCarrier(carrier) [class.port-refine-trans-deselect]=\"carrier.selected\"\r\n                [class.port-refine-trans-select]=\"!carrier.selected\" [class.selected]=\"carrier.selected\"\r\n                class=\"select-box-div pointer\">\r\n                <span>&#x2714;</span>\r\n              </div>\r\n              <!--<img class=\"company-logo\" src=\"{{ carrier.iconUrl }}\">-->\r\n              <div class=\"sidebar-section-right\">\r\n                <p><span class=\"pointer\" [class.port-refine-trans-deselect]=\"carrier.selected\"\r\n                    [class.port-refine-trans-select]=\"!carrier.selected\"\r\n                    (click)=selectCarrier(carrier)>{{ carrier.carrier.name }}</span><span class=\"favorite-star\"><img\r\n                      class=\"ga-favorite-carrier\" [favorite]=\"carrier.carrier\"\r\n                      [itemtype]=\"'carrier'\"></span>({{ carrier.count }})</p>\r\n                <!-- I figured there would be a favorited attribute we could change these to later-->\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"refine-sidebar-after\">\r\n          <div (click)=\"slideOutIn()\" class=\"refine-sidebar-after-inner\">\r\n            <p><span class=\"text\">Refine</span><span class=\"arrow\">&rsaquo;</span><span class=\"arrow2\">&lsaquo;</span>\r\n            </p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"results-content\" id=\"results-content\">\r\n        <div *ngIf=\"!service.loaderOff\" id=\"loader-wrapper\">\r\n          <sticky sticky-offset-top=\"220\" sticky-class=\"sticky-loader\" sticky-offset-bottom=\"50\" sticky-zIndex=\"2999\">\r\n            <div id=\"loader\"></div>\r\n          </sticky>\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"col1of2 mt15\">\r\n            <p>{{ paginationContext }}\r\n              <select [(ngModel)]=\"limit\" (ngModelChange)=\"update()\">\r\n                <option value=\"10\">10</option>\r\n                <option value=\"15\">15</option>\r\n                <option value=\"20\">20</option>\r\n                <option value=\"25\">25</option>\r\n              </select>\r\n              per page</p>\r\n          </div>\r\n          <div class=\"col1of2\">\r\n            <div class=\"pagination-holder\">\r\n              <ul [class.selected]=\"page == pageNumber\" class=\"pagination\" *ngFor=\"let page of pages\">\r\n                <li (click)=\"toPage(page)\">{{ page }}</li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"ports-results-table\">\r\n          <div class=\"header-col\">\r\n            <div class=\"col1\">Carrier</div>\r\n            <div class=\"col2\">Vessel/Voyage</div>\r\n            <div class=\"col3\">ETA</div>\r\n            <div class=\"col4\">ETD</div>\r\n          </div>\r\n          <div class=\"results-row\" *ngFor=\"let schedule of schedules.items\">\r\n            <div class=\"col1\">\r\n              <p class=\"table-rep-header\"><b>Carrier</b></p>\r\n              <span class=\"carrier-logo-wrapper\">\r\n                <img [routerLink]=\"['/carriers', schedule.carrier.id, {scroll:true}]\" class=\"company-logo pointer\"\r\n                  src=\"../img/carriers/{{ schedule.carrier.id }}.gif\" onerror=\"src='../img/carriers/0.gif'\">\r\n              </span>\r\n              <span class=\"hover-link\"\r\n                [routerLink]=\"['/carriers', schedule.carrier.id, {scroll:true}]\">{{ schedule.carrier.name }}</span><span\r\n                class=\"favorite-star\"><img class=\"ga-favorite-carrier\" [favorite]=\"schedule.carrier\"\r\n                  [itemtype]=\"'carrier'\"></span>\r\n            </div>\r\n            <div class=\"col2\">\r\n              <div>\r\n                <p class=\"table-rep-header\"><b>Vessel/Voyage</b></p><span class=\"hover-link\"\r\n                  [routerLink]=\"['/vessels', schedule.vessel.id, {scroll:true}]\">{{ schedule.vessel.name }}</span><span\r\n                  class=\"favorite-star\"><img class=\"ga-favorite-vessel\" [favorite]=\"schedule.vessel\"\r\n                    [itemtype]=\"'vessel'\"></span><b>{{ schedule.voyage }}</b>\r\n              </div>\r\n            </div>\r\n            <div class=\"col3 etaDateTime\">\r\n              <p class=\"table-rep-header\"><b>ETA</b></p>\r\n              <blur [item]=\"schedule.eta\" [itemtype]=\"'large-text-dark'\"></blur>\r\n              <blur [item]=\"schedule.etaTime\" [itemtype]=\"'small-text'\" class=\"small-gray-text\"></blur>\r\n            </div>\r\n            <div class=\"col4 etaDateTime\">\r\n              <p class=\"table-rep-header\"><b>ETD</b></p>\r\n              <blur [item]=\"schedule.etd\" [itemtype]=\"'large-text-dark'\"></blur>\r\n              <blur [item]=\"schedule.etdTime\" [itemtype]=\"'small-text'\" class=\"small-gray-text\"></blur>\r\n            </div>\r\n            <!--<div class=\"notes-div\"><p><b>Notes:</b> Put notes here</p></div>-->\r\n          </div>\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"col1of2 mt15\">\r\n            <p>{{ paginationContext }}\r\n              <select [(ngModel)]=\"limit\" (ngModelChange)=\"update()\">\r\n                <option value=\"10\">10</option>\r\n                <option value=\"15\">15</option>\r\n                <option value=\"20\">20</option>\r\n                <option value=\"25\">25</option>\r\n              </select>\r\n              per page</p>\r\n          </div>\r\n          <div class=\"col1of2\">\r\n            <div class=\"pagination-holder\">\r\n              <ul [class.selected]=\"page == pageNumber\" class=\"pagination\" *ngFor=\"let page of pages\">\r\n                <li (click)=\"toPage(page)\">{{ page }}</li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>"

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = ".ports-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"../../img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .ports-banner .ports-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .ports-banner .ports-banner-inner h2 {\n      line-height: 40px;\n      text-transform: capitalize; }\n    @media only screen and (min-width: 800px) {\n      .ports-banner .ports-banner-inner .btn-no-fill {\n        position: relative;\n        float: right;\n        top: -54px; } }\n    .ports-banner .ports-banner-inner .hide {\n      display: none; }\n    .ports-banner .ports-banner-inner img {\n      width: 27px;\n      cursor: pointer; }\n    .ports-banner .ports-banner-inner h3 {\n      font-size: 27px; }\n    .ports-banner .ports-banner-inner h2 {\n      font-weight: 300;\n      margin-bottom: 10px; }\n      .ports-banner .ports-banner-inner h2 img {\n        height: 30px;\n        width: 30px; }\n        .ports-banner .ports-banner-inner h2 img.type-icon {\n          height: 42px;\n          width: 42px;\n          cursor: default;\n          margin-right: 10px; }\n\n.results-header {\n  background: #282828;\n  height: 50px;\n  color: #ffffff; }\n  .results-header h5 {\n    line-height: 50px;\n    font-weight: 300; }\n  .results-header .results-header-col-1 {\n    display: inline-block;\n    width: 320px;\n    padding-left: 10px; }\n  .results-header .results-header-col-2 {\n    display: inline-block;\n    width: calc(100% - 320px);\n    padding-left: 20px; }\n\n.sidebar-carrier-list {\n  padding: 7px 10px 3px 10px !important; }\n  .sidebar-carrier-list .select-box-div {\n    width: 14px;\n    height: 14px;\n    border: 1px solid #217ebf;\n    border-radius: 3px;\n    display: inline-block;\n    vertical-align: top;\n    margin-right: 5px;\n    margin-top: 7px; }\n    .sidebar-carrier-list .select-box-div span {\n      color: #ffffff;\n      visibility: hidden;\n      line-height: 16px;\n      vertical-align: top;\n      font-size: 12px;\n      position: relative;\n      top: -2px;\n      left: 1px;\n      transition: all 1s ease; }\n    .sidebar-carrier-list .select-box-div.selected {\n      background: #217ebf; }\n      .sidebar-carrier-list .select-box-div.selected span {\n        visibility: visible; }\n    .sidebar-carrier-list .select-box-div > div {\n      cursor: pointer; }\n  .sidebar-carrier-list .sidebar-section-right {\n    display: inline-block;\n    width: calc(100% - 85px);\n    vertical-align: top; }\n    .sidebar-carrier-list .sidebar-section-right p {\n      line-height: 26px; }\n  .sidebar-carrier-list .company-logo {\n    width: 40px;\n    vertical-align: top;\n    margin-top: 6px;\n    margin-left: 5px;\n    margin-right: 10px;\n    max-height: 40px; }\n\n.content-sidebar-wrapper {\n  position: relative;\n  /*min-height: 457px;*/\n  min-height: 100%;\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.refine-sidebar {\n  z-index: 26;\n  position: absolute;\n  min-height: 100%;\n  display: inline-block;\n  background: #393939;\n  color: #ffffff;\n  width: 350px;\n  border-top: 1px solid #393939;\n  transition: all 1s ease; }\n  .refine-sidebar #refine-sidebar-inner {\n    padding-bottom: 100px; }\n  .refine-sidebar .sidebar-header {\n    background: #282828;\n    padding: 5px 10px; }\n  .refine-sidebar .sidebar-section {\n    padding: 5px 10px; }\n    .refine-sidebar .sidebar-section:nth-of-type(even) {\n      background: #464646; }\n    .refine-sidebar .sidebar-section .date {\n      width: 100%; }\n    .refine-sidebar .sidebar-section .col1of2 {\n      width: 62%; }\n      .refine-sidebar .sidebar-section .col1of2.text-right {\n        width: 38%; }\n  .refine-sidebar .refine-sidebar-after {\n    display: none;\n    position: absolute;\n    height: 40px;\n    border-radius: 0px 3px 3px 0;\n    top: 20px;\n    left: 100%;\n    cursor: pointer;\n    box-shadow: inset 7px 0 9px -7px rgba(0, 0, 0, 0.7);\n    overflow: hidden; }\n    .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner {\n      background: #393939;\n      border-radius: 0px 3px 3px 0;\n      margin-left: -40px;\n      transition: all .5s ease;\n      padding-left: 2px;\n      padding-right: 2px; }\n      .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p {\n        white-space: nowrap;\n        font-size: 14px;\n        line-height: 38px;\n        padding-left: 2px; }\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p span.arrow2,\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p span.arrow {\n          display: inline;\n          /* text-align: center; */\n          line-height: 31px;\n          font-size: 40px;\n          vertical-align: top; }\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p span.arrow2 {\n          display: none; }\n      .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner:hover {\n        margin-left: 0; }\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner:hover p span.text {\n          display: inline;\n          color: #ffffff; }\n  .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner {\n    margin-left: 0px;\n    transition: all .01s ease; }\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner p span.text,\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner p span.arrow {\n      display: none; }\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner p span.arrow2 {\n      display: inline; }\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner:hover {\n      margin-left: 0px; }\n      .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner:hover p span.text {\n        display: none; }\n\n.results-content {\n  margin-left: 350px;\n  vertical-align: top;\n  display: inline-block;\n  width: calc(100% - 350px);\n  padding: 20px;\n  padding-bottom: 200px; }\n\n.header-col {\n  width: calc(100% + 40px);\n  margin-left: -20px;\n  background: #f0f0f0;\n  margin-bottom: 25px;\n  margin-top: 25px;\n  padding: 10px 30px; }\n  .header-col div {\n    vertical-align: top;\n    font-weight: bold;\n    font-size: 20px; }\n\n.ports-results-table {\n  font-size: 0; }\n  .ports-results-table .results-row {\n    border: 1px solid #c1c1c1;\n    padding: 10px;\n    margin-bottom: 20px; }\n    .ports-results-table .results-row:nth-of-type(2n) {\n      background: #efefef; }\n    .ports-results-table .results-row div {\n      vertical-align: top;\n      font-size: 16px; }\n    .ports-results-table .results-row .carrier-logo-wrapper {\n      width: 36px;\n      text-align: center;\n      display: inline-block; }\n    .ports-results-table .results-row .notes-div {\n      background: #c1c1c1;\n      width: calc(100% + 20px);\n      margin-bottom: -10px;\n      margin-left: -10px;\n      padding-left: 10px;\n      margin-top: 10px; }\n      .ports-results-table .results-row .notes-div p {\n        line-height: 26px; }\n    .ports-results-table .results-row .table-rep-header {\n      display: none; }\n    .ports-results-table .results-row .company-logo {\n      vertical-align: middle;\n      max-width: 100%;\n      max-height: 40px; }\n  .ports-results-table .col1, .ports-results-table .col2, .ports-results-table .col3, .ports-results-table .col4, .ports-results-table .col5 {\n    display: inline-block;\n    padding-left: 3px;\n    padding-right: 3px;\n    word-break: break-word;\n    overflow-wrap: break-word; }\n  .ports-results-table .col1 {\n    width: 24%; }\n  .ports-results-table .col2 {\n    line-height: 22px;\n    width: 39%; }\n  .ports-results-table .col3 {\n    width: 16%; }\n  .ports-results-table .col4 {\n    width: 16%; }\n\n.no-results-wrapper {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: #fff;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  margin-left: 350px;\n  padding-left: 20px;\n  padding-top: 35px;\n  padding-right: 20px;\n  padding-bottom: 35px; }\n\n#loader-wrapper {\n  position: absolute;\n  top: 0;\n  left: 320px;\n  width: calc(100% - 320px);\n  height: 100%;\n  z-index: 25;\n  background: rgba(255, 255, 255, 0.5); }\n\n#loader {\n  display: block;\n  position: relative;\n  left: 50%;\n  top: 220px;\n  width: 80px;\n  height: 80px;\n  margin: -40px 0 0 -40px;\n  border-radius: 50%;\n  border: 5px solid #3498db;\n  z-index: 1500;\n  border: 3px solid transparent;\n  border-top-color: #333333;\n  border-left-color: #333333;\n  animation: spin 1s linear infinite; }\n\n.sticky-loader {\n  left: calc(50% + 150px) !important; }\n\n.date-row {\n  display: table; }\n\n.date-col {\n  display: table-cell; }\n\n@keyframes spin {\n  0% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: rotate(0deg);\n    /* Firefox 16+, IE 10+, Opera */ }\n  100% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: rotate(360deg);\n    /* Firefox 16+, IE 10+, Opera */ } }\n\n@media only screen and (max-width: 1150px) {\n  .ports-results-table .results-row {\n    padding-left: 5px;\n    padding-right: 5px; }\n    .ports-results-table .results-row .col4 {\n      font-size: 15px; }\n    .ports-results-table .results-row .col5 {\n      font-size: 15px; } }\n\n@media only screen and (max-width: 1023px) {\n  .refine-sidebar {\n    margin-left: -315px;\n    transition: all 1s ease;\n    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.5); }\n    .refine-sidebar.active {\n      margin-left: 0; }\n    .refine-sidebar .refine-sidebar-after {\n      display: block; }\n  .results-content {\n    width: 100%;\n    margin-left: 0; }\n  .results-header .results-header-col-1 {\n    display: none; }\n  .ports-results-table .results-row {\n    padding-left: 10px;\n    padding-right: 10px; }\n    .ports-results-table .results-row .col4 {\n      font-size: 16px; }\n  .ports-results-table .col2 {\n    width: 38%; }\n  .ports-results-table .col3 {\n    width: 16.5%; }\n  .ports-results-table .col4 {\n    width: 16.5%;\n    font-size: 15px; }\n  .no-results-wrapper {\n    margin-left: 0;\n    padding-left: 64px; }\n  #loader-wrapper {\n    left: 0;\n    width: 100%; }\n  .sticky-loader {\n    left: calc(50% - 20px) !important; } }\n\n@media only screen and (max-width: 699px) {\n  .ports-banner .ports-banner-inner {\n    padding: 15px 15px 15px 15px; }\n  .ports-results-table {\n    margin-top: 35px; }\n    .ports-results-table .results-row .table-rep-header {\n      display: block; }\n    .ports-results-table .col1, .ports-results-table .col2, .ports-results-table .col3, .ports-results-table .col4, .ports-results-table .col5 {\n      width: 100%;\n      margin-bottom: 10px;\n      line-height: 18px;\n      text-align: center; }\n  .header-col {\n    display: none; } }\n\n@media only screen and (max-width: 399px) {\n  .refine-sidebar {\n    width: 300px;\n    margin-left: -295px; }\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n\n.deactivated-btn {\n  background-color: gray; }\n"

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var contacts_1 = __webpack_require__(238);
var models_1 = __webpack_require__(12);
var results_1 = __webpack_require__(239);
var CarriersService = (function () {
    function CarriersService(api, cache, logger, seo, app, el, renderer) {
        this.api = api;
        this.cache = cache;
        this.logger = logger;
        this.seo = seo;
        this.app = app;
        this.renderer = renderer;
        this.queryString = '';
        this.loaderOff = false;
        this.noCarrier = false;
        this.noVessels = false;
        this.localContactsLoader = false;
    }
    CarriersService.prototype.getVessels = function (params) {
        var _this = this;
        this.logger.log('carriers.service', 'getVessels', params);
        // let cache = this.cache.get('vessels' + this.queryString);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetVessels(client, params); });
        // let server = Observable.fromPromise(promise);
        // this.vessels = server;
        // this.vessels = Observable.concat(cache, server);
        // this.cache.updateCache('vessels' + this.queryString, this.vessels);
        return promise;
    };
    CarriersService.prototype.callGetVessels = function (apigClient, query) {
        var _this = this;
        this.logger.log('carriers.service', 'callGetVessels', query);
        return new Promise(function (resolve, reject) {
            var params = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: query
            };
            try {
                apigClient.vesselsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('carriers.service', 'vessels result', result);
                    if (result.data === null) {
                        _this.resizeSidebar();
                        _this.loaderOff = true;
                        _this.noVessels = true;
                    }
                    else if (result.data.items.length === 0 || result.data.summary.count === 0) {
                        _this.resizeSidebar();
                        _this.loaderOff = true;
                        _this.noVessels = true;
                    }
                    else {
                        _this.resizeSidebar();
                        _this.loaderOff = true;
                    }
                    var formatted = new results_1.VesselResults(result, _this.app.accountType);
                    resolve(formatted);
                }).catch(function (err) {
                    _this.resizeSidebar();
                    _this.loaderOff = true;
                    _this.noVessels = true;
                    reject(_this.api.handleError(err));
                });
            }
            catch (ex) {
                reject(null);
            }
        });
    };
    CarriersService.prototype.getCarrier = function (carrierId) {
        var _this = this;
        this.logger.log('carriers.service', 'getCarriers', carrierId);
        // let cache = this.cache.get('carriers' + carrierId);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetCarrier(client, carrierId); });
        // let server = Observable.fromPromise(promise);
        // this.carrier = server;
        // this.carrier = Observable.concat(cache, server);
        // this.cache.updateCache('carriers' + this.queryString, this.carrier);
        return promise;
    };
    CarriersService.prototype.callGetCarrier = function (apigClient, carrierId) {
        var _this = this;
        this.logger.log('carriers.service', 'callGetCarrier', carrierId);
        return new Promise(function (resolve, reject) {
            var params = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {
                    id: carrierId
                }
            };
            try {
                apigClient.carriersGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('carriers.service', 'carrier result', result);
                    var carrier = new models_1.Carrier(result.data.items[0], _this.app.accountType);
                    _this.seo.setCarrier(carrier);
                    if (carrier.id == 0) {
                        _this.noCarrier = true;
                    }
                    resolve(carrier);
                }).catch(function (err) {
                    reject(_this.api.handleError(err));
                });
            }
            catch (ex) {
                reject(null);
            }
        });
    };
    CarriersService.prototype.resizeSidebar = function () {
        var _this = this;
        setTimeout(function () {
            try {
                _this.el = document.getElementById('refine-sidebar-inner');
                _this.content = document.getElementById('results-content');
                _this.container = document.getElementById('content-sidebar-wrapper');
                _this.renderer.setElementProperty(_this.container, 'style', false);
                if (_this.el.scrollHeight > _this.content.scrollHeight) {
                    var heightNum = (_this.el.scrollHeight + 200);
                    _this.renderer.setElementStyle(_this.container, 'height', heightNum + 'px');
                }
            }
            catch (ex) {
            }
        }, 50);
    };
    CarriersService.prototype.getLocalContacts = function (carrierId, params) {
        var _this = this;
        this.logger.log('carriers.service', 'getCarriers', carrierId);
        // let cache = this.cache.get('carriers' + carrierId);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetLocalContacts(client, carrierId, params); });
        // let server = Observable.fromPromise(promise);
        // this.carrier = server;
        // this.carrier = Observable.concat(cache, server);
        // this.cache.updateCache('carriers' + this.queryString, this.carrier);
        return promise;
    };
    CarriersService.prototype.callGetLocalContacts = function (apigClient, carrierId, paramsToSend) {
        var _this = this;
        this.logger.log('carriers.service', 'callGetLocalContacts', carrierId);
        return new Promise(function (resolve, reject) {
            var params = {
                carrierId: carrierId
            };
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: paramsToSend
            };
            try {
                apigClient.carriersCarrierIdContactsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('carriers.service', 'contacts result', result);
                    var contacts = new contacts_1.Contacts(result, _this.app.accountType);
                    resolve(contacts);
                }).catch(function (err) {
                    reject(_this.api.handleError(err));
                });
            }
            catch (ex) {
                reject(null);
            }
        });
    };
    CarriersService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.CacheService, shared_1.LogService,
            shared_1.SeoService, shared_1.AppContext, core_1.ElementRef, core_1.Renderer])
    ], CarriersService);
    return CarriersService;
}());
exports.CarriersService = CarriersService;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var contact_1 = __webpack_require__(583);
var Office = (function () {
    function Office(json, accountType) {
        if (accountType === void 0) { accountType = ''; }
        this.setContactDetails(json, accountType);
        this.setContacts(json, accountType);
        this.setLocation(json);
        this.showFull = false;
    }
    Office.prototype.setContactDetails = function (json, accountType) {
        var show = accountType !== '' && accountType !== 'Basic';
        try {
            this.id = json.id || 0;
            this.name = json.name || '';
            this.comment = json.comment || '';
            this.comments = json.comments || [];
            this.isAgent = json.is_agent || false;
            this.urls = json.urls || [];
            var site = this.urls.length > 0 ? this.urls[0] : '';
            this.website = show ? site : 'blurred text';
        }
        catch (ex) {
            this.id = 0;
            this.name = '';
            this.comment = '';
            this.comments = [];
            this.isAgent = false;
            this.website = show ? '' : 'blurred text';
            this.urls = [];
        }
    };
    Office.prototype.setContacts = function (json, accountType) {
        try {
            this.contacts = [];
            for (var current = 0; current < json.contacts.length; current++) {
                var contact = new contact_1.Contact(json.contacts[current], accountType);
                this.contacts.push(contact);
            }
            this.contacts.sort(function (a, b) {
                var one = a.desc.toUpperCase();
                var two = b.desc.toUpperCase();
                return (one < two) ? -1 : (one > two) ? 1 : 0;
            });
        }
        catch (ex) {
            this.contacts = [];
        }
    };
    Office.prototype.setLocation = function (json) {
        try {
            this.address = json.address || '';
            this.postcode = json.postcode || '';
            this.city = json.city || '';
            if (json.region !== undefined) {
                this.regionId = json.region.id || '';
                this.regionName = json.region.name || '';
            }
            else {
                this.regionId = '';
                this.regionName = '';
            }
            if (json.country !== undefined) {
                this.countryId = json.country.id || '';
                this.countryName = json.country.name || '';
            }
            else {
                this.countryId = '';
                this.countryName = '';
            }
        }
        catch (ex) {
            this.address = '';
            this.postcode = '';
            this.city = '';
            this.regionId = '';
            this.regionName = '';
            this.countryId = '';
            this.countryName = '';
        }
    };
    return Office;
}());
exports.Office = Office;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Contact = (function () {
    function Contact(json, accountType) {
        if (accountType === void 0) { accountType = ''; }
        var show = accountType !== '' && accountType !== 'Basic';
        try {
            this.desc = json.desc || '';
            this.type = json.type || '';
            this.value = show ? json.value : 'blurred text';
        }
        catch (ex) {
            this.desc = '';
            this.type = '';
            this.value = show ? '' : 'blurred text';
        }
    }
    return Contact;
}());
exports.Contact = Contact;


/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = "<div class=\"carrier-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"carrier-banner-inner\">\r\n      <h2><img class=\"type-icon\" src=\"../img/office-01.svg\"\r\n          onerror=\"this.onerror=null; this.src='../img/office-01.png'\">{{ carrier.name }}\r\n        <span [class.hide]=\"carrier.name === ''\" class=\"favorite-star-big\"><img class=\"ga-favorite-carrier\"\r\n            [favorite]=\"carrier\" [itemtype]=\"'carrier'\"></span>\r\n      </h2>\r\n      <p>{{ carrier.description }}</p>\r\n      <div class=\"clear\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content carriers-main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"results-header\">\r\n      <div class=\"col-holder\">\r\n        <div class=\"results-header-col-1\">\r\n          <h5>Profile:</h5>\r\n        </div>\r\n        <div class=\"results-header-col-2\">\r\n          <h5>Fleet:</h5>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-holder content-sidebar-wrapper\" id=\"content-sidebar-wrapper\">\r\n      <div *ngIf=\"service.noCarrier\" class=\"no-results-wrapper\">\r\n        <h4>No Results Found</h4>\r\n      </div>\r\n      <div *ngIf=\"!service.noCarrier\" [class.active]=\"sidebarActive\" id=\"refine-sidebar\" class=\"refine-sidebar\">\r\n        <div id=\"refine-sidebar-inner\">\r\n          <div class=\"sidebar-section col-holder mb15\">\r\n            <div class=\"left-col\">\r\n              <p>Name:</p>\r\n            </div>\r\n            <div class=\"right-col\">\r\n              <p>{{ carrier.description }}</p>\r\n            </div>\r\n            <div class=\"left-col\">\r\n              <p>{{ carrier.established }} {{ carrier.year_est }}:</p>\r\n            </div>\r\n            <div class=\"right-col\">\r\n              <p>{{ carrier.carrier_group }}</p>\r\n            </div>\r\n            <div class=\"left-col\">\r\n              <p>Operates:</p>\r\n            </div>\r\n            <div class=\"right-col\">\r\n              <blur [item]=\"carrier.max_ships\" [itemtype]=\"'small-number'\"></blur>\r\n            </div>\r\n            <div class=\"left-col\">\r\n              <p>Capacity:</p>\r\n            </div>\r\n            <div class=\"right-col\">\r\n              <blur [item]=\"carrier.max_teu\" [itemtype]=\"'medium-number'\"></blur>\r\n            </div>\r\n            <div class=\"left-col\">\r\n              <p>Category:</p>\r\n            </div>\r\n            <div class=\"right-col\">\r\n              <blur [item]=\"carrier.kind\" [itemtype]=\"'large-text'\"></blur>\r\n            </div>\r\n            <div class=\"left-col\">\r\n              <p>Service:</p>\r\n            </div>\r\n            <div class=\"right-col\">\r\n              <blur [item]=\"carrier.regions\" [itemtype]=\"'large-text'\"></blur>\r\n            </div>\r\n            <div class=\"left-col\">\r\n              <p>SCAC:</p>\r\n            </div>\r\n            <div class=\"right-col\">\r\n              <p>{{ carrier.scac }}</p>\r\n            </div>\r\n            <div class=\"left-col\">\r\n              <p>SMDG:</p>\r\n            </div>\r\n            <div class=\"right-col\">\r\n              <p>{{ carrier.smdg }}</p>\r\n            </div>\r\n            <div class=\"left-col\">\r\n              <p>BIC:</p>\r\n            </div>\r\n            <div class=\"right-col\">\r\n              <p>{{ carrier.bic }}</p>\r\n            </div>\r\n            <div class=\"left-col\" id=\"notice-label\" style=\"display: none;\">\r\n              <p>Notice:</p>\r\n            </div>\r\n            <div class=\"right-col\" id=\"notice-data\" style=\"display: none;\">\r\n              <p id='carrier-notice'>{{ carrier.notice }}</p>\r\n            </div>\r\n            \r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Headquarters:</p>\r\n          </div>\r\n          <div class=\"sidebar-section carrier-address-section\">\r\n            <p>{{ carrier.company }}</p>\r\n            <p>\r\n              <blur [item]=\"carrier.address\" [itemtype]=\"'medium-text'\"></blur>\r\n            </p>\r\n            <p>\r\n              <blur [item]=\"carrier.city\" [itemtype]=\"'medium-text'\"></blur>, <blur [item]=\"carrier.postcode\"\r\n                [itemtype]=\"'medium-number'\"></blur>\r\n            </p>\r\n            <p>{{ carrier.countryName }}</p>\r\n            <p><a href=\"http://{{ carrier.website }}\" target=\"_blank\">{{ carrier.website }}</a></p>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Contacts:</p>\r\n          </div>\r\n          <div class=\"sidebar-section local-contacts\">\r\n            <select [(ngModel)]=\"country\" (ngModelChange)=\"updateCountry()\">\r\n              <option *ngFor=\"let item of countries\" [ngValue]=\"item.country\">\r\n                {{ item.country.name }} {{ item.count == 0 ? '' : '(' + item.count + ')' }}\r\n              </option>\r\n            </select>\r\n            <span *ngIf=\"service.localContactsLoader\" class=\"contacts-loader\"></span>\r\n            <div class=\"local-contact\" *ngFor=\"let item of contacts.offices\">\r\n              <div (click)=\"expand(item)\" class=\"col-holder\">\r\n                <div class=\"local-col-1\">\r\n                  <a [class.open]=\"item.showFull\" class=\"expand-button\"><img src=\"../img/bluearrow-01.svg\"\r\n                      onerror=\"this.onerror=null; this.src='../img/bluearrow.png'\"></a>\r\n                </div>\r\n                <div class=\"local-col-2\">\r\n                  <h5 class=\"mb10 pointer\">{{ item.name }}</h5>\r\n                </div>\r\n              </div>\r\n              <div *ngIf=\"item.showFull\" class=\"local-contact-expand\">\r\n                <h6 class=\"mt25\"><b>Address:</b></h6>\r\n                <p>{{ item.address }}</p>\r\n                <p>{{ item.city }}, {{ item.regionName }}</p>\r\n                <p>{{ item.postcode }}</p>\r\n                <h6 class=\"mt25\"><b>Contact Info:</b></h6>\r\n                <div *ngFor=\"let contact of item.contacts\">\r\n                  <p><b>{{ contact.desc }}:</b></p>\r\n                  <p class=\"mb10\">\r\n                    <blur [item]=\"contact.value\" [itemtype]=\"contact.type\"></blur>\r\n                  </p>\r\n                </div>\r\n                <div *ngIf=\"item.comment !== ''\">\r\n                  <h6 class=\"mt25\"><b>Notes:</b></h6>\r\n                  <p>{{ item.comment }}</p>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"refine-sidebar-after\">\r\n          <div (click)=\"slideOutIn()\" class=\"refine-sidebar-after-inner\">\r\n            <p><span class=\"text\">Carrier Info</span><span class=\"arrow\">&rsaquo;</span><span\r\n                class=\"arrow2\">&lsaquo;</span></p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"service.noVessels\" class=\"no-results-wrapper\">\r\n        <h4>No Results Found</h4>\r\n      </div>\r\n      <div class=\"results-content\" id=\"results-content\">\r\n        <div *ngIf=\"!service.loaderOff && !service.noVessels\" id=\"loader-wrapper\">\r\n          <sticky sticky-offset-top=\"220\" sticky-class=\"sticky-loader\" sticky-offset-bottom=\"50\" sticky-zIndex=\"2999\">\r\n            <div id=\"loader\"></div>\r\n          </sticky>\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"col1of2 mt15\">\r\n            <p>{{ paginationContext }}\r\n              <select [(ngModel)]=\"limit\" (ngModelChange)=\"update()\">\r\n                <option value=\"10\">10</option>\r\n                <option value=\"15\">15</option>\r\n                <option value=\"20\">20</option>\r\n                <option value=\"25\">25</option>\r\n              </select>\r\n              per page</p>\r\n          </div>\r\n          <div class=\"col1of2\">\r\n            <div class=\"pagination-holder\">\r\n              <ul [class.selected]=\"page == pageNumber\" class=\"pagination\" *ngFor=\"let page of pages\">\r\n                <li (click)=\"toPage(page)\">{{ page }}</li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"carrier-results-table\">\r\n          <div class=\"header-col\">\r\n            <div class=\"col1\">Vessel</div>\r\n            <div class=\"col2\">TEU</div>\r\n            <div class=\"col3\">Flag</div>\r\n            <div class=\"col4\">Year</div>\r\n            <div class=\"col5\">Type</div>\r\n          </div>\r\n          <div class=\"results-row\" *ngFor=\"let vessel of vessels.items\">\r\n            <div class=\"col1\">\r\n              <p class=\"table-rep-header\"><b>Vessel</b></p>\r\n              <span *ngIf=\"service.app.accountType !== 'Basic' && service.app.accountType !== ''\"\r\n                class=\"carrier-logo-wrapper\">\r\n                <img [routerLink]=\"['/carriers', carrier.id, {scroll: true}]\" class=\"company-logo pointer\"\r\n                  src=\"../img/carriers/{{ carrier.id }}.gif\" onerror=\"src='../img/carriers/0.gif'\">\r\n              </span>\r\n              <span class=\"hover-link\" [routerLink]=\"['/vessels', vessel.id, {scroll: true}]\">{{ vessel.name }}</span>\r\n              <span [class.hide]=\"vessel.name === ''\" class=\"favorite-star\"><img class=\"ga-favorite-vessel\"\r\n                  [favorite]=\"vessel\" [itemtype]=\"'vessel'\"></span>\r\n            </div>\r\n            <div class=\"col2\">\r\n              <p class=\"table-rep-header\"><b>TEU</b></p>\r\n              <blur [item]=\"vessel.maxTEU\" [itemtype]=\"'medium-number-dark'\"></blur>\r\n            </div>\r\n            <div class=\"col3\">\r\n              <p class=\"table-rep-header\"><b>Flag</b></p>{{ vessel.countryName }}\r\n            </div>\r\n            <div class=\"col4\">\r\n              <p class=\"table-rep-header\"><b>Year</b></p>\r\n              <blur [item]=\"vessel.yearBuilt\" [itemtype]=\"'large-number-dark'\"></blur>\r\n            </div>\r\n            <div class=\"col5\">\r\n              <p class=\"table-rep-header\"><b>Type</b></p>\r\n              <blur [item]=\"vessel.shipType\" [itemtype]=\"'medium-text-dark'\"></blur>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"col1of2 mt15\">\r\n            <p>{{ paginationContext }}\r\n              <select [(ngModel)]=\"limit\" (ngModelChange)=\"update()\">\r\n                <option value=\"10\">10</option>\r\n                <option value=\"15\">15</option>\r\n                <option value=\"20\">20</option>\r\n                <option value=\"25\">25</option>\r\n              </select>\r\n              per page</p>\r\n          </div>\r\n          <div class=\"col1of2\">\r\n            <div class=\"pagination-holder\">\r\n              <ul [class.selected]=\"page == pageNumber\" class=\"pagination\" *ngFor=\"let page of pages\">\r\n                <li (click)=\"toPage(page)\">{{ page }}</li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = ".carrier-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"../../img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .carrier-banner .carrier-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .carrier-banner .carrier-banner-inner h2 {\n      line-height: 40px;\n      text-transform: capitalize; }\n    @media only screen and (min-width: 800px) {\n      .carrier-banner .carrier-banner-inner .btn-no-fill {\n        position: relative;\n        float: right;\n        top: -54px; } }\n    .carrier-banner .carrier-banner-inner .hide {\n      display: none; }\n    .carrier-banner .carrier-banner-inner img {\n      width: 27px; }\n    .carrier-banner .carrier-banner-inner h3 {\n      font-size: 27px; }\n    .carrier-banner .carrier-banner-inner h2 {\n      font-weight: 300;\n      margin-bottom: 10px; }\n      .carrier-banner .carrier-banner-inner h2 img {\n        height: 30px;\n        width: 30px; }\n        .carrier-banner .carrier-banner-inner h2 img.type-icon {\n          height: 42px;\n          width: 42px;\n          cursor: default;\n          margin-right: 10px; }\n\n.results-header {\n  background: #282828;\n  height: 50px;\n  color: #ffffff; }\n  .results-header h5 {\n    line-height: 50px;\n    font-weight: 300; }\n  .results-header .results-header-col-1 {\n    display: inline-block;\n    width: 320px;\n    padding-left: 10px; }\n  .results-header .results-header-col-2 {\n    display: inline-block;\n    width: calc(100% - 320px);\n    padding-left: 20px; }\n\n.content-sidebar-wrapper {\n  position: relative;\n  /*min-height: 457px;*/\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.refine-sidebar {\n  z-index: 26;\n  position: absolute;\n  min-height: 100%;\n  display: inline-block;\n  background: #393939;\n  color: #ffffff;\n  width: 350px;\n  border-top: 1px solid #393939;\n  transition: all 1s ease; }\n  .refine-sidebar .sidebar-header {\n    background: #282828;\n    padding: 5px 10px; }\n    .refine-sidebar .sidebar-header h5 {\n      line-height: 40px; }\n  .refine-sidebar .sidebar-section {\n    padding: 5px 10px 5px 20px; }\n    .refine-sidebar .sidebar-section:nth-of-type(even) {\n      background: #464646; }\n    .refine-sidebar .sidebar-section .date {\n      width: 100%; }\n    .refine-sidebar .sidebar-section p {\n      font-size: 16px; }\n    .refine-sidebar .sidebar-section h6 {\n      font-size: 18px; }\n    .refine-sidebar .sidebar-section .left-col,\n    .refine-sidebar .sidebar-section .right-col {\n      display: inline-block;\n      width: 50%;\n      vertical-align: top; }\n    .refine-sidebar .sidebar-section .left-col {\n      width: 90px; }\n    .refine-sidebar .sidebar-section .right-col {\n      width: calc(100% - 90px); }\n    .refine-sidebar .sidebar-section.local-contacts h5 {\n      font-size: 20px;\n      line-height: 28px; }\n  .refine-sidebar .refine-sidebar-after {\n    display: none;\n    position: absolute;\n    height: 40px;\n    border-radius: 0px 3px 3px 0;\n    top: 20px;\n    left: 100%;\n    cursor: pointer;\n    box-shadow: inset 7px 0 9px -7px rgba(0, 0, 0, 0.7);\n    overflow: hidden; }\n    .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner {\n      background: #393939;\n      border-radius: 0px 3px 3px 0;\n      margin-left: -66px;\n      transition: all .5s ease;\n      padding-left: 2px;\n      padding-right: 2px; }\n      .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p {\n        white-space: nowrap;\n        font-size: 14px;\n        line-height: 38px;\n        padding-left: 2px; }\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p span.arrow2,\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p span.arrow {\n          display: inline;\n          /* text-align: center; */\n          line-height: 31px;\n          font-size: 40px;\n          vertical-align: top; }\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p span.arrow2 {\n          display: none; }\n      .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner:hover {\n        margin-left: 0; }\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner:hover p span.text {\n          display: inline;\n          color: #ffffff; }\n  .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner {\n    margin-left: 0px;\n    transition: all .01s ease; }\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner p span.text,\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner p span.arrow {\n      display: none; }\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner p span.arrow2 {\n      display: inline; }\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner:hover {\n      margin-left: 0px; }\n      .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner:hover p span.text {\n        display: none; }\n\n.results-content {\n  margin-left: 350px;\n  vertical-align: top;\n  display: inline-block;\n  width: calc(100% - 350px);\n  padding: 20px;\n  padding-bottom: 200px; }\n\n.carrier-info-table {\n  margin-bottom: 40px;\n  border: 1px solid #c1c1c1; }\n  .carrier-info-table .info-row {\n    padding: 10px;\n    margin-bottom: 0;\n    font-size: 0; }\n    .carrier-info-table .info-row:nth-of-type(2n) {\n      background: #efefef; }\n    .carrier-info-table .info-row div {\n      vertical-align: top;\n      font-size: 16px; }\n    .carrier-info-table .info-row .col1of2:first-of-type p {\n      font-weight: bold; }\n  .carrier-info-table .notes-div {\n    background: #c1c1c1;\n    padding-left: 10px;\n    margin-top: 10px; }\n    .carrier-info-table .notes-div p {\n      line-height: 26px; }\n\n.header-col {\n  width: calc(100% + 40px);\n  margin-left: -20px;\n  background: #f0f0f0;\n  margin-bottom: 25px;\n  margin-top: 25px;\n  padding: 10px 30px;\n  font-size: 0; }\n  .header-col div {\n    vertical-align: top;\n    font-weight: bold;\n    font-size: 20px; }\n  .header-col .col1 {\n    width: 20%; }\n  .header-col .col2 {\n    width: 20%;\n    font-weight: bold; }\n  .header-col .col3 {\n    width: 20%; }\n  .header-col .col4 {\n    width: 20%;\n    font-weight: bold; }\n  .header-col .col5 {\n    width: 20%; }\n\n.carrier-results-table {\n  font-size: 0; }\n  .carrier-results-table .results-row {\n    border: 1px solid #c1c1c1;\n    padding: 10px;\n    margin-bottom: 20px;\n    font-size: 0; }\n    .carrier-results-table .results-row:nth-of-type(2n) {\n      background: #efefef; }\n    .carrier-results-table .results-row .company-logo {\n      vertical-align: middle;\n      max-width: 100%;\n      max-height: 40px; }\n    .carrier-results-table .results-row .carrier-logo-wrapper {\n      width: 36px;\n      text-align: center;\n      display: inline-block; }\n    .carrier-results-table .results-row div {\n      vertical-align: top;\n      font-size: 16px; }\n    .carrier-results-table .results-row .notes-div {\n      background: #c1c1c1;\n      width: calc(100% + 20px);\n      margin-bottom: -10px;\n      margin-left: -10px;\n      padding-left: 10px;\n      margin-top: 10px; }\n      .carrier-results-table .results-row .notes-div p {\n        line-height: 26px; }\n    .carrier-results-table .results-row .table-rep-header {\n      display: none; }\n  .carrier-results-table .col1, .carrier-results-table .col2, .carrier-results-table .col3, .carrier-results-table .col4, .carrier-results-table .col5 {\n    display: inline-block;\n    padding-left: 3px;\n    padding-right: 3px;\n    word-break: break-word;\n    overflow-wrap: break-word; }\n  .carrier-results-table .col1 {\n    width: 32%;\n    white-space: nowrap; }\n  .carrier-results-table .col2 {\n    width: 10%;\n    font-weight: bold; }\n  .carrier-results-table .col3 {\n    width: 24%; }\n  .carrier-results-table .col4 {\n    width: 10%;\n    font-weight: bold; }\n  .carrier-results-table .col5 {\n    width: 24%; }\n\n.refine-sidebar .local-contacts {\n  padding: 5px 10px; }\n  .refine-sidebar .local-contacts .local-contact {\n    margin-top: 35px;\n    border-bottom: 1px solid #777;\n    padding-bottom: 10px; }\n    .refine-sidebar .local-contacts .local-contact .local-col-1 {\n      display: inline-block;\n      width: 36px;\n      vertical-align: top;\n      text-align: center;\n      margin-top: -10px; }\n    .refine-sidebar .local-contacts .local-contact .local-col-2 {\n      display: inline-block;\n      width: calc(100% - 36px); }\n    .refine-sidebar .local-contacts .local-contact .expand-button {\n      display: inline-block;\n      transition: transform .3s ease-in-out;\n      line-height: 26px;\n      height: 26px;\n      vertical-align: -webkit-baseline-middle; }\n      .refine-sidebar .local-contacts .local-contact .expand-button.open {\n        transform: rotate(90deg); }\n    .refine-sidebar .local-contacts .local-contact p {\n      line-height: 24px; }\n    .refine-sidebar .local-contacts .local-contact h6 {\n      border-bottom: 1px solid #777;\n      padding-bottom: 5px;\n      margin-bottom: 5px;\n      margin-top: 25px; }\n\n.blurry-text {\n  vertical-align: bottom; }\n\n.no-results-wrapper {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: #fff;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  padding-left: 350px;\n  padding-top: 35px;\n  padding-right: 35px;\n  padding-bottom: 35px; }\n\n#loader-wrapper {\n  position: absolute;\n  top: 0;\n  left: 320px;\n  width: calc(100% - 320px);\n  height: 100%;\n  z-index: 25;\n  background: rgba(255, 255, 255, 0.5); }\n\n#loader {\n  display: block;\n  position: relative;\n  left: 50%;\n  top: 220px;\n  width: 80px;\n  height: 80px;\n  margin: -40px 0 0 -40px;\n  border-radius: 50%;\n  border: 5px solid #3498db;\n  z-index: 1500;\n  border: 3px solid transparent;\n  border-top-color: #333333;\n  border-left-color: #333333;\n  animation: spin 1s linear infinite; }\n\n.sticky-loader {\n  left: calc(50% + 150px) !important; }\n\n.contacts-loader {\n  display: inline-block;\n  width: 23px;\n  height: 23px;\n  margin: 0px;\n  margin-left: 4px;\n  border-radius: 50%;\n  border: 3px solid transparent;\n  border-top-color: #7f56db;\n  border-left-color: #7f56db;\n  vertical-align: middle;\n  animation: spin 1s linear infinite; }\n  .contacts-loader.white {\n    border-top-color: #ffffff;\n    border-left-color: #ffffff; }\n  .contacts-loader.visible {\n    display: block; }\n\n@keyframes spin {\n  0% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: rotate(0deg);\n    /* Firefox 16+, IE 10+, Opera */ }\n  100% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: rotate(360deg);\n    /* Firefox 16+, IE 10+, Opera */ } }\n\n@media only screen and (max-width: 1023px) {\n  .refine-sidebar {\n    margin-left: -315px;\n    transition: all 1s ease;\n    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.5); }\n    .refine-sidebar.active {\n      margin-left: 0; }\n    .refine-sidebar .refine-sidebar-after {\n      display: block; }\n  .results-content {\n    width: 100%;\n    margin-left: 0; }\n  .results-header .results-header-col-1 {\n    display: none; }\n  .results-header .results-header-col-2 {\n    width: 100%; }\n  .no-results-wrapper {\n    padding-left: 64px; }\n  #loader-wrapper {\n    left: 0;\n    width: 100%; }\n  .sticky-loader {\n    left: calc(50% - 20px) !important; } }\n\n@media only screen and (max-width: 767px) {\n  .info-row {\n    text-align: center; } }\n\n@media only screen and (max-width: 699px) {\n  .carrier-banner .carrier-banner-inner {\n    padding: 15px 15px 15px 15px; }\n  .carrier-results-table {\n    margin-top: 35px; }\n    .carrier-results-table .results-row .table-rep-header {\n      display: block; }\n    .carrier-results-table .col1, .carrier-results-table .col2, .carrier-results-table .col3, .carrier-results-table .col4, .carrier-results-table .col5 {\n      width: 100%;\n      margin-bottom: 10px;\n      line-height: 18px;\n      text-align: center; }\n  .header-col {\n    display: none; } }\n\n@media only screen and (max-width: 399px) {\n  .refine-sidebar {\n    width: 300px;\n    margin-left: -295px; }\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var models_1 = __webpack_require__(12);
var VesselsService = (function () {
    function VesselsService(api, app, cache, logger, seo, el, renderer) {
        this.api = api;
        this.app = app;
        this.cache = cache;
        this.logger = logger;
        this.seo = seo;
        this.renderer = renderer;
        this.loaderOff = false;
        this.noResult = false;
        this.noVesselData = false;
    }
    VesselsService.prototype.getVoyages = function (vesselId, params) {
        var _this = this;
        this.logger.log('vessels.service', 'getVoyages', vesselId);
        // let cache = this.cache.get('vessels' + this.queryString);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetVoyages(client, vesselId, params); });
        // let server = Observable.fromPromise(promise);
        // this.voyages = server;
        // this.voyages = Observable.concat(cache, server);
        // this.cache.updateCache('vessels' + this.queryString, this.voyages);
        return promise;
    };
    VesselsService.prototype.callGetVoyages = function (apigClient, vesselId, paramsToSend) {
        var _this = this;
        this.logger.log('vessels.service', 'callGetVoyages', vesselId);
        return new Promise(function (resolve, reject) {
            var params = {
                vesselId: vesselId
            };
            var body = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: paramsToSend
            };
            try {
                apigClient.vesselsVesselIdSchedulesGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('vessels.service', 'voyages result', result);
                    if (!_this.formatUI(result)) {
                        resolve(null);
                    }
                    var voyages = new models_1.Voyages(result, _this.app.accountType);
                    resolve(voyages);
                }).catch(function (err) {
                    _this.resizeSidebar();
                    _this.loaderOff = true;
                    _this.noResult = true;
                    reject(_this.api.handleError(err));
                });
            }
            catch (ex) {
                reject(null);
            }
        });
    };
    VesselsService.prototype.formatUI = function (result) {
        if (result.data === null) {
            this.resizeSidebar();
            this.loaderOff = true;
            this.noResult = true;
            return false;
        }
        else if (result.data.hasOwnProperty('errorMessage')) {
            var response = JSON.parse(result.data.errorMessage);
            this.resizeSidebar();
            this.loaderOff = true;
            this.noResult = true;
            this.api.handleError(response);
            return false;
        }
        else if (result.data.items === undefined || result.data.items.length === 0 || result.data.summary.count === 0) {
            this.resizeSidebar();
            this.loaderOff = true;
            this.noResult = true;
            return false;
        }
        else {
            this.resizeSidebar();
            this.loaderOff = true;
            return true;
        }
    };
    VesselsService.prototype.getVessel = function (vesselId) {
        var _this = this;
        this.logger.log('vessels.service', 'getVessel', vesselId);
        // let cache = this.cache.get('vessels' + vesselId);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetVessel(client, vesselId); });
        // let server = Observable.fromPromise(promise);
        // this.vessel = server;
        // this.vessel = Observable.concat(cache, server);
        // this.cache.updateCache('vessels' + vesselId, this.vessel);
        return promise;
    };
    VesselsService.prototype.callGetVessel = function (apigClient, vesselId) {
        var _this = this;
        this.logger.log('vessels.service', 'callGetVessel', vesselId);
        return new Promise(function (resolve, reject) {
            var params = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {
                    id: vesselId
                }
            };
            try {
                apigClient.vesselsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('vessels.service', 'vessel result', result);
                    if (result.data === null) {
                        _this.noVesselData = true;
                    }
                    else if (result.data.items !== undefined) {
                        if (result.data.items.length === 0 || result.data.summary.count === 0) {
                            _this.noVesselData = true;
                        }
                        else {
                            _this.noVesselData = false;
                        }
                    }
                    else {
                        _this.noVesselData = true;
                    }
                    var vessel = new models_1.Vessel(result.data.items[0], _this.app.accountType);
                    _this.seo.setVessel(vessel);
                    resolve(vessel);
                }).catch(function (err) {
                    _this.noVesselData = true;
                    reject(_this.api.handleError(err));
                });
            }
            catch (ex) {
                reject(null);
            }
        });
    };
    VesselsService.prototype.resizeSidebar = function () {
        var _this = this;
        setTimeout(function () {
            try {
                _this.el = document.getElementById('refine-sidebar-inner');
                _this.content = document.getElementById('results-content');
                _this.container = document.getElementById('content-sidebar-wrapper');
                _this.renderer.setElementProperty(_this.container, 'style', false);
                if (_this.el.scrollHeight > _this.content.scrollHeight) {
                    var heightNum = (_this.el.scrollHeight + 200);
                    _this.renderer.setElementStyle(_this.container, 'height', heightNum + 'px');
                }
            }
            catch (ex) {
            }
        }, 50);
    };
    VesselsService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AppContext, shared_1.CacheService, shared_1.LogService, shared_1.SeoService, core_1.ElementRef, core_1.Renderer])
    ], VesselsService);
    return VesselsService;
}());
exports.VesselsService = VesselsService;


/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = "<div class=\"vessel-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div [class.search-on]=\"service.newSearch\" class=\"vessel-banner-inner\">\r\n      <h2><img class=\"type-icon\" src=\"../img/container-01.svg\"\r\n          onerror=\"this.onerror=null; this.src='../img/container-01.png'\">{{ vessel.name }}&nbsp;\r\n        <span [class.hide]=\"vessel.name === ''\" class=\"favorite-star-big\"><img *ngIf=\"vessel.name !== ''\"\r\n            class=\"ga-favorite-vessel\" [favorite]=\"vessel\" [itemtype]=\"'vessel'\"></span></h2>\r\n      <!--<p>IMO No: <blur [item]=\"vessel.imo\" [itemtype]=\"'large-number'\"></blur>\r\n      </p>-->\r\n      <div class=\"clear\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content vessels-main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"results-header\">\r\n      <div class=\"col-holder\">\r\n        <div class=\"results-header-col-1\">\r\n          <h5>Vessel Info</h5>\r\n        </div>\r\n        <div *ngIf=\"!service.noResult\" class=\"results-header-col-2\">\r\n          <h5>Vessel Schedule</h5>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-holder content-sidebar-wrapper\" id=\"content-sidebar-wrapper\">\r\n      <div [class.sidebar-present]=\"!service.noVesselData\" *ngIf=\"service.noResult\" class=\"no-results-wrapper\">\r\n        <h4 *ngIf=\"service.noResult && service.noVesselData\">No Results Found</h4>\r\n        <h4 *ngIf=\"service.noResult && !service.noVesselData\">No Voyages Found</h4>\r\n      </div>\r\n      <div *ngIf=\"!service.noVesselData\" [class.active]=\"sidebarActive\" class=\"refine-sidebar\" id=\"refine-sidebar\">\r\n        <div id=\"refine-sidebar-inner\">\r\n          <div class=\"vessel-thumbnail\">\r\n            <img src=\"\" id=\"vessel-thumbnail\">\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Register</p>\r\n          </div>\r\n          <div class=\"sidebar-section\">\r\n            <div class=\"col-holder\">\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Name:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <p>{{ vessel.name }}</p>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>IMO:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.imo\" [itemtype]=\"'large-number'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Flag:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.countryId\" [itemtype]=\"'small-text'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Call Sign:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.callSign\" [itemtype]=\"'small-text'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>MMSI:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.mmsi\" [itemtype]=\"'large-number'\"></blur>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Management</p>\r\n          </div>\r\n          <div class=\"sidebar-section\">\r\n            <div class=\"col-holder\">\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Owner:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.ownerName\" [itemtype]=\"'large-text'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p class=\"small-text\">Operator:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.carrier\" [itemtype]=\"'carrier'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Old Names:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <div *ngFor=\"let name of vessel.previousNames\">\r\n                  <blur [item]=\"name\" [itemtype]=\"text\"></blur><br>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Capacity</p>\r\n          </div>\r\n          <div class=\"sidebar-section\">\r\n            <div class=\"col-holder\">\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Gross Tons:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.grossTonnage\" [itemtype]=\"'medium-number'\"></blur><span\r\n                  *ngIf=\"vessel.grossTonnage !== null\"><span *ngIf=\"vessel.grossTonnage !== ''\"><span\r\n                      *ngIf=\"vessel.grossTonnage !== 'blurred text'\">t</span></span></span>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Net Tons:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.netTonnage\" [itemtype]=\"'medium-number'\"></blur><span\r\n                  *ngIf=\"vessel.netTonnage !== null\"><span *ngIf=\"vessel.netTonnage !== ''\"><span\r\n                      *ngIf=\"vessel.netTonnage !== 'blurred text'\">t</span></span></span>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>DWT:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.dwt\" [itemtype]=\"'medium-number'\"></blur><span *ngIf=\"vessel.dwt !== null\"><span\r\n                    *ngIf=\"vessel.dwt !== ''\"><span *ngIf=\"vessel.dwt !== 'blurred text'\">t</span></span></span>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>TEU <span class=\"small-text\">Nominal</span>:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.avgTEU\" [itemtype]=\"'medium-number'\"></blur><span\r\n                  *ngIf=\"vessel.avgTEU !== null\"><span *ngIf=\"vessel.avgTEU !== ''\"><span\r\n                      *ngIf=\"vessel.avgTEU !== 'blurred text'\">teu</span></span></span>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>TEU @ 14mt:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.maxTEU\" [itemtype]=\"'medium-number'\"></blur><span\r\n                  *ngIf=\"vessel.maxTEU !== null\"><span *ngIf=\"vessel.maxTEU !== ''\"><span\r\n                      *ngIf=\"vessel.maxTEU !== 'blurred text'\">teu</span></span></span>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>TEU Reefer:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.reeferTEU\" [itemtype]=\"'medium-number'\"></blur><span\r\n                  *ngIf=\"vessel.reeferTEU !== null\"><span *ngIf=\"vessel.reeferTEU !== ''\"><span\r\n                      *ngIf=\"vessel.reeferTEU !== 'blurred text'\">teu</span></span></span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Construction</p>\r\n          </div>\r\n          <div class=\"sidebar-section\">\r\n            <div class=\"col-holder\">\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Type:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.shipType\" [itemtype]=\"'large-text'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Registered:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.portRegister\" [itemtype]=\"'large-text'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Year:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.yearBuilt\" [itemtype]=\"'large-number'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Shipyard:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.shipBuilder\" [itemtype]=\"'large-text'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Hull:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.yardHull\" [itemtype]=\"'medium-number'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Gear:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.handlingGear\" [itemtype]=\"'large-text'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Length:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.length\" [itemtype]=\"'medium-number'\"></blur><span\r\n                  *ngIf=\"vessel.length !== null\"><span *ngIf=\"vessel.length !== ''\"><span\r\n                      *ngIf=\"vessel.length !== 'blurred text'\">m</span></span></span>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Beam:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.beam\" [itemtype]=\"'small-number'\"></blur><span *ngIf=\"vessel.beam !== null\"><span\r\n                    *ngIf=\"vessel.beam !== ''\"><span *ngIf=\"vessel.beam !== 'blurred text'\">m</span></span></span>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Draught:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.draught\" [itemtype]=\"'small-number'\"></blur><span\r\n                  *ngIf=\"vessel.draught !== null\"><span *ngIf=\"vessel.draught !== ''\"><span\r\n                      *ngIf=\"vessel.draught !== 'blurred text'\">m</span></span></span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"sidebar-header\">\r\n            <p>Propulsion</p>\r\n          </div>\r\n          <div class=\"sidebar-section\">\r\n            <div class=\"col-holder\">\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Engine:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.engineDesign\" [itemtype]=\"'large-text'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Type:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.engineType\" [itemtype]=\"'large-text'\"></blur>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Power:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <span *ngIf=\"vessel.power !== 'null KW'\">\r\n                  <blur [item]=\"vessel.power\" [itemtype]=\"'medium-number'\"></blur>\r\n                </span>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>Speed:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <span *ngIf=\"vessel.speed !== 'null Kn'\">\r\n                  <blur [item]=\"vessel.speed\" [itemtype]=\"'small-number'\"></blur>\r\n                </span>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>SFC:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.sfc\" [itemtype]=\"'medium-number'\"></blur><span *ngIf=\"vessel.sfc !== null\"><span\r\n                    *ngIf=\"vessel.sfc !== ''\"><span *ngIf=\"vessel.sfc !== 'blurred text'\">g/kW-h</span></span></span>\r\n              </div>\r\n              <div class=\"col1of2 text-right\">\r\n                <p>CO2:&nbsp;</p>\r\n              </div>\r\n              <div class=\"col1of2\">\r\n                <blur [item]=\"vessel.co2\" [itemtype]=\"'medium-number'\"></blur><span *ngIf=\"vessel.co2 !== null\"><span\r\n                    *ngIf=\"vessel.co2 !== ''\"><span *ngIf=\"vessel.co2 !== 'blurred text'\">g/TEU-NM</span></span></span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"refine-sidebar-after\">\r\n          <div (click)=\"slideOutIn()\" class=\"refine-sidebar-after-inner\">\r\n            <p><span class=\"text\">Vessel Info</span><span class=\"arrow\">&rsaquo;</span><span\r\n                class=\"arrow2\">&lsaquo;</span></p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"results-content\" id=\"results-content\">\r\n        <div *ngIf=\"!service.loaderOff\" id=\"loader-wrapper\">\r\n          <!-- *ngIf=\"!service.loaderOff\" -->\r\n          <sticky sticky-offset-top=\"220\" sticky-class=\"sticky-loader\" sticky-offset-bottom=\"50\" sticky-zIndex=\"2999\">\r\n            <div id=\"loader\"></div>\r\n          </sticky>\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"col1of2 mt5\">\r\n            <p>{{ paginationContext }}\r\n              <select [(ngModel)]=\"limit\" (ngModelChange)=\"update()\">\r\n                <option value=\"50\">50</option>\r\n                <option value=\"75\">75</option>\r\n                <option value=\"100\">100</option>\r\n              </select>\r\n              per page</p>\r\n          </div>\r\n          <div class=\"col1of2\">\r\n            <div class=\"pagination-holder\">\r\n              <ul [class.selected]=\"page == pageNumber\" class=\"pagination\" *ngFor=\"let page of pages\">\r\n                <li (click)=\"toPage(page)\">{{ page }}</li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"vessel-results-table\">\r\n          <div class=\"header-col col-holder\">\r\n            <div class=\"col1\">Carrier</div>\r\n            <div class=\"col2\">Vessel / Voyage / Service</div>\r\n            <div class=\"col3\">First ETD</div>\r\n          </div>\r\n          <div *ngFor=\"let item of voyages.items; let i=index\" class=\"carrier-results-row\">\r\n            <div class=\"results-header-col col-holder\">\r\n              <div class=\"col3\"><a [class.open]=\"item.viewDetails\" class=\"expand-button\" (click)=\"expand(item)\"><img\r\n                    src=\"../img/blackarrow-01.svg\" onerror=\"this.onerror=null; this.src='../img/blackarrow.png'\"></a>\r\n              </div>\r\n              <div class=\"col1\">\r\n                <img [routerLink]=\"['/carriers', item.carrier.id, {scroll:true}]\" class=\"company-logo pointer\"\r\n                  src=\"../img/carriers/{{ item.carrier.id }}.gif\" onerror=\"src='../img/carriers/0.gif'\">\r\n                <b><span class=\"hover-link\" [routerLink]=\"['/carriers', item.carrier.id, {scroll:true}]\">{{ item.carrier.name }}</span></b>\r\n                <span class=\"favorite-star\"><img class=\"ga-favorite-carrier\" [favorite]=\"item.carrier\" [itemtype]=\"'carrier'\"></span>\r\n              </div>\r\n              <div class=\"col2\">\r\n                <div>\r\n                  {{ vessel.name }}&nbsp;\r\n                  <b><span [class.hide]=\"vessel.name === ''\" class=\"favorite-star\"><img *ngIf=\"vessel.name !== ''\" class=\"ga-favorite-vessel\" [favorite]=\"vessel\" [itemtype]=\"'vessel'\"></span></b>\r\n                  <b>{{ item.voyage }}</b>\r\n                  <b style=\"position: absolute; right: 50px\">{{ item.schedules[0].etd }}</b>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"results-header-col col-holder\" style=\"margin-top: -25px;\">\r\n              <div class=\"col3\"></div>\r\n              <div class=\"col1\"></div>\r\n              <div class=\"col2\">\r\n                <blur [item]=\"item.route.name\" [itemtype]=\"'text-dark'\"></blur>\r\n              </div>\r\n            </div>\r\n            <div *ngIf=\"item.viewDetails\" class=\"results-expand col-holder\">\r\n              <div class=\"small-header col-holder\">\r\n                <div class=\"column1\"><b>Port</b></div>\r\n                <div class=\"column2\"><b>ETA</b></div>\r\n                <div class=\"column3\"><b>ETD</b></div>\r\n              </div>\r\n              <div *ngFor=\"let voyage of item.schedules\" class=\"col-holder service-ports\">\r\n                <div class=\"column1\">\r\n                  <p class=\"table-rep-header\"><b>Port</b></p>\r\n                  <a class=\"hover-link\" [routerLink]=\"['/ports', voyage.port.id, voyage.portLinkParameters]\">\r\n                    {{ voyage.port.name }}\r\n                  </a>\r\n                  <span [class.hide]=\"voyage.port.name === ''\" class=\"favorite-star\"><img class=\"ga-favorite-port\"\r\n                      [favorite]=\"voyage.port\" [itemtype]=\"'port'\"></span>\r\n                </div>\r\n                <div class=\"column2 etaDateTime\">\r\n                  <p class=\"table-rep-header\"><b>ETA</b></p>\r\n                  <blur [item]=\"voyage.eta\" [itemtype]=\"'large-text-dark'\"></blur>\r\n                  <blur [item]=\"voyage.etaTime\" [itemtype]=\"'small-text'\" class=\"small-gray-text\"></blur>\r\n                </div>\r\n                <div class=\"column3 etaDateTime\">\r\n                  <p class=\"table-rep-header\"><b>ETD</b></p>\r\n                  <blur [item]=\"voyage.etd\" [itemtype]=\"'large-text-dark'\"></blur>\r\n                  <blur [item]=\"voyage.etdTime\" [itemtype]=\"'small-text'\" class=\"small-gray-text\"></blur>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"col1of2 mt15\">\r\n            <p>{{ paginationContext }}\r\n              <select [(ngModel)]=\"limit\" (ngModelChange)=\"update()\">\r\n                <option value=\"50\">50</option>\r\n                <option value=\"75\">75</option>\r\n                <option value=\"100\">100</option>\r\n              </select>\r\n              per page</p>\r\n          </div>\r\n          <div class=\"col1of2\">\r\n            <div class=\"pagination-holder\">\r\n              <ul [class.selected]=\"page == pageNumber\" class=\"pagination\" *ngFor=\"let page of pages\">\r\n                <li (click)=\"toPage(page)\">{{ page }}</li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- The Modal -->\r\n  <div id=\"thumbnailModal\" class=\"modal\">\r\n\r\n    <!-- Modal content -->\r\n    <div class=\"modal-content\">\r\n      <span class=\"close\">&times;</span>\r\n      <img src=\"\" id=\"vessel-large-image\">\r\n    </div>\r\n\r\n  </div>"

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = "#vessel-thumbnail {\n  width: 100%;\n  cursor: zoom-in; }\n\n#vessel-large-image {\n  height: 95%;\n  width: 100%;\n  cursor: pointer;\n  object-fit: contain;\n  display: block;\n  padding: auto;\n  margin: auto; }\n\n/* The Modal (background) */\n.modal {\n  display: none;\n  /* Hidden by default */\n  position: fixed;\n  /* Stay in place */\n  z-index: 30;\n  /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: black;\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */\n  /* Safari, Chrome and Opera > 12.1 */\n  /* Firefox < 16 */\n  /* Internet Explorer */\n  /* Opera < 12.1 */\n  animation: fadein 1s; }\n\n/* Modal Content/Box */\n.modal-content {\n  background-color: #fefefe;\n  margin: 2% auto;\n  /* 15% from the top and centered */\n  padding: 20px;\n  border: 1px solid #888;\n  width: 80%;\n  height: 90vh;\n  /* Could be more or less, depending on screen size */ }\n\n/* The Close Button */\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold; }\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer; }\n\n@keyframes fadein {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n/* Firefox < 16 */\n\n/* Safari, Chrome and Opera > 12.1 */\n\n/* Internet Explorer */\n\n/* Opera < 12.1 */\n\n.vessel-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"../../img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .vessel-banner .vessel-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .vessel-banner .vessel-banner-inner h2 {\n      line-height: 40px;\n      text-transform: capitalize; }\n    @media only screen and (min-width: 800px) {\n      .vessel-banner .vessel-banner-inner .btn-no-fill {\n        position: relative;\n        float: right;\n        top: -54px; } }\n    .vessel-banner .vessel-banner-inner .hide {\n      display: none; }\n    .vessel-banner .vessel-banner-inner img {\n      width: 27px; }\n    .vessel-banner .vessel-banner-inner h3 {\n      font-size: 27px; }\n      .vessel-banner .vessel-banner-inner h3 img {\n        cursor: pointer; }\n    .vessel-banner .vessel-banner-inner p img {\n      width: 102px;\n      vertical-align: middle; }\n    .vessel-banner .vessel-banner-inner h2 {\n      font-weight: 300;\n      margin-bottom: 10px; }\n      .vessel-banner .vessel-banner-inner h2 img {\n        height: 30px;\n        width: 30px; }\n        .vessel-banner .vessel-banner-inner h2 img.type-icon {\n          height: 42px;\n          width: 42px;\n          cursor: default;\n          margin-right: 10px; }\n\n.results-header {\n  background: #282828;\n  height: 50px;\n  color: #ffffff; }\n  .results-header h5 {\n    line-height: 50px;\n    font-weight: 300; }\n  .results-header .results-header-col-1 {\n    display: inline-block;\n    width: 320px;\n    padding-left: 10px; }\n  .results-header .results-header-col-2 {\n    display: inline-block;\n    width: calc(100% - 320px);\n    padding-left: 20px; }\n\n.content-sidebar-wrapper {\n  position: relative;\n  min-height: 100%;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.refine-sidebar {\n  z-index: 26;\n  position: absolute;\n  min-height: 100%;\n  display: inline-block;\n  background: #393939;\n  color: #ffffff;\n  width: 350px;\n  border-top: 1px solid #393939;\n  transition: all 1s ease; }\n  .refine-sidebar .sidebar-header {\n    background: #282828;\n    padding: 5px 10px; }\n  .refine-sidebar .sidebar-section {\n    padding: 5px 10px; }\n    .refine-sidebar .sidebar-section:nth-of-type(even) {\n      background: #464646; }\n    .refine-sidebar .sidebar-section .date {\n      width: 100%; }\n    .refine-sidebar .sidebar-section .col1of2 {\n      width: 62%; }\n      .refine-sidebar .sidebar-section .col1of2.text-right {\n        width: 38%; }\n  .refine-sidebar .refine-sidebar-after {\n    display: none;\n    position: absolute;\n    height: 40px;\n    border-radius: 0px 3px 3px 0;\n    top: 20px;\n    left: 100%;\n    cursor: pointer;\n    box-shadow: inset 7px 0 9px -7px rgba(0, 0, 0, 0.7);\n    overflow: hidden; }\n    .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner {\n      background: #393939;\n      border-radius: 0px 3px 3px 0;\n      margin-left: -66px;\n      transition: all .5s ease;\n      padding-left: 2px;\n      padding-right: 2px; }\n      .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p {\n        white-space: nowrap;\n        font-size: 14px;\n        line-height: 38px;\n        padding-left: 2px; }\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p span.arrow2,\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p span.arrow {\n          display: inline;\n          /* text-align: center; */\n          line-height: 31px;\n          font-size: 40px;\n          vertical-align: top; }\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner p span.arrow2 {\n          display: none; }\n      .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner:hover {\n        margin-left: 0; }\n        .refine-sidebar .refine-sidebar-after .refine-sidebar-after-inner:hover p span.text {\n          display: inline;\n          color: #ffffff; }\n  .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner {\n    margin-left: 0px;\n    transition: all .01s ease; }\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner p span.text,\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner p span.arrow {\n      display: none; }\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner p span.arrow2 {\n      display: inline; }\n    .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner:hover {\n      margin-left: 0px; }\n      .refine-sidebar.active .refine-sidebar-after .refine-sidebar-after-inner:hover p span.text {\n        display: none; }\n\n.results-content {\n  margin-left: 350px;\n  vertical-align: top;\n  display: inline-block;\n  width: calc(100% - 350px);\n  padding: 20px;\n  padding-bottom: 200px; }\n\n.vessel-info-table {\n  margin-bottom: 40px; }\n  .vessel-info-table .info-row {\n    padding: 10px;\n    margin-bottom: 0;\n    font-size: 0; }\n    .vessel-info-table .info-row:nth-of-type(2n) {\n      background: #464646; }\n    .vessel-info-table .info-row div {\n      vertical-align: top;\n      font-size: 16px; }\n    .vessel-info-table .info-row .col1of2:first-of-type p {\n      font-weight: bold; }\n  .vessel-info-table .notes-div {\n    background: #464646;\n    padding-left: 10px;\n    margin-top: 10px; }\n    .vessel-info-table .notes-div p {\n      line-height: 26px; }\n\n.header-col {\n  width: calc(100% + 40px);\n  margin-left: -20px;\n  background: #f0f0f0;\n  margin-bottom: 25px;\n  margin-top: 0;\n  padding: 10px 20px;\n  font-size: 0; }\n  .header-col h3 {\n    color: #fff;\n    font-weight: bold;\n    border-bottom: 1px solid #bbb;\n    margin-bottom: 5px;\n    padding-bottom: 5px; }\n  .header-col div {\n    vertical-align: top;\n    font-weight: bold;\n    font-size: 20px; }\n\n.vessel-results-table {\n  font-size: 0; }\n  .vessel-results-table .header-col .col1 {\n    padding-left: 30px;\n    width: calc(32% + 18px); }\n  .vessel-results-table .header-col .col2 {\n    width: calc(68% - 18px); }\n  .vessel-results-table .header-col .col3 {\n    position: absolute;\n    right: 60px; }\n  .vessel-results-table .carrier-results-row {\n    border: 2px solid #c1c1c1;\n    padding: 10px;\n    padding-bottom: 0;\n    padding-top: 0;\n    margin-bottom: 20px;\n    margin-top: 10px;\n    font-size: 0; }\n    .vessel-results-table .carrier-results-row .results-header-col {\n      background: #f0f0f0;\n      margin-left: -10px;\n      width: calc(100% + 20px);\n      padding: 20px 10px 16px;\n      line-height: 18px; }\n      .vessel-results-table .carrier-results-row .results-header-col .company-logo {\n        vertical-align: middle;\n        margin-top: -2px;\n        max-width: 100%;\n        max-height: 40px; }\n      .vessel-results-table .carrier-results-row .results-header-col .expand-button {\n        color: #353535;\n        display: inline-block;\n        transition: transform .2s ease-in-out;\n        height: 24px;\n        line-height: 24px;\n        margin-top: -2px; }\n        .vessel-results-table .carrier-results-row .results-header-col .expand-button.open {\n          transform: rotate(90deg); }\n        .vessel-results-table .carrier-results-row .results-header-col .expand-button img {\n          height: 20px;\n          margin-top: -4px;\n          vertical-align: text-bottom; }\n      .vessel-results-table .carrier-results-row .results-header-col .col2 {\n        width: calc(60% - 18px); }\n      .vessel-results-table .carrier-results-row .results-header-col .col3 {\n        width: 10px;\n        margin-top: -2px; }\n  .vessel-results-table .results-row {\n    border: 1px solid #c1c1c1;\n    padding: 20px;\n    margin-bottom: 20px;\n    font-size: 0; }\n    .vessel-results-table .results-row:nth-of-type(2n) {\n      background: #efefef; }\n    .vessel-results-table .results-row div {\n      vertical-align: top;\n      font-size: 16px; }\n    .vessel-results-table .results-row .notes-div {\n      background: #c1c1c1;\n      width: calc(100% + 20px);\n      margin-bottom: -10px;\n      margin-left: -10px;\n      padding-left: 10px;\n      margin-top: 10px; }\n      .vessel-results-table .results-row .notes-div p {\n        line-height: 26px; }\n    .vessel-results-table .results-row .table-rep-header {\n      display: none; }\n    .vessel-results-table .results-row .service-box {\n      border-top: 1px solid #ccc;\n      padding-top: 5px;\n      margin-top: 5px; }\n  .vessel-results-table .col1, .vessel-results-table .col2, .vessel-results-table .col3, .vessel-results-table .col4, .vessel-results-table .col5 {\n    display: inline-block;\n    padding-left: 3px;\n    padding-right: 3px;\n    word-break: break-word;\n    overflow-wrap: break-word; }\n  .vessel-results-table .col1 {\n    vertical-align: top;\n    width: 32%; }\n  .vessel-results-table .col2 {\n    vertical-align: top;\n    width: 68%; }\n  .vessel-results-table .results-expand {\n    padding-top: 15px;\n    padding-bottom: 15px; }\n  .vessel-results-table .column1 {\n    width: 50%;\n    display: inline-block;\n    border-bottom: 1px solid #f0f0f0; }\n  .vessel-results-table .column2 {\n    width: 25%;\n    display: inline-block;\n    border-bottom: 1px solid #f0f0f0; }\n  .vessel-results-table .column3 {\n    width: 25%;\n    display: inline-block;\n    border-bottom: 1px solid #f0f0f0; }\n  .vessel-results-table .small-header .column1, .vessel-results-table .small-header .column2, .vessel-results-table .small-header .column3 {\n    border-bottom: 1px solid #ccc; }\n  .vessel-results-table .service-ports .table-rep-header {\n    display: none; }\n\n.no-results-wrapper {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: #fff;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  padding-left: 35px;\n  padding-top: 35px;\n  padding-right: 35px;\n  padding-bottom: 35px; }\n  .no-results-wrapper.sidebar-present {\n    padding-left: 350px; }\n\n#loader-wrapper {\n  position: absolute;\n  top: 0;\n  left: 320px;\n  width: calc(100% - 320px);\n  height: 100%;\n  z-index: 25;\n  background: rgba(255, 255, 255, 0.5); }\n\n#loader {\n  display: block;\n  position: relative;\n  left: 50%;\n  top: 220px;\n  width: 80px;\n  height: 80px;\n  margin: -40px 0 0 -40px;\n  border-radius: 50%;\n  border: 5px solid #3498db;\n  z-index: 1500;\n  border: 3px solid transparent;\n  border-top-color: #333333;\n  border-left-color: #333333;\n  animation: spin 1s linear infinite; }\n\n.sticky-loader {\n  left: calc(50% + 150px) !important; }\n\n@keyframes spin {\n  0% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: rotate(0deg);\n    /* Firefox 16+, IE 10+, Opera */ }\n  100% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: rotate(360deg);\n    /* Firefox 16+, IE 10+, Opera */ } }\n\n@media only screen and (max-width: 1023px) {\n  .refine-sidebar {\n    margin-left: -315px;\n    transition: all 1s ease;\n    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.5); }\n    .refine-sidebar.active {\n      margin-left: 0; }\n    .refine-sidebar .refine-sidebar-after {\n      display: block; }\n  .results-content {\n    width: 100%;\n    margin-left: 0; }\n  .results-header .results-header-col-1 {\n    display: none; }\n  .no-results-wrapper {\n    padding-left: 64px; }\n    .no-results-wrapper.sidebar-present {\n      padding-left: 35px; }\n  #loader-wrapper {\n    left: 0;\n    width: 100%; }\n  .sticky-loader {\n    left: calc(50% - 20px) !important; } }\n\n@media only screen and (max-width: 767px) {\n  .info-row {\n    text-align: center; }\n  .sidebar-section .col1of2 {\n    width: 50%; } }\n\n@media only screen and (max-width: 699px) {\n  .vessel-results-table {\n    margin-top: 35px;\n    /*.col1,.col2,.col3,.col4,.col5 {\r\n      width: 100%;\r\n      margin-bottom: 10px;\r\n\t    line-height: 18px;\r\n\t    text-align: center;\r\n    }*/ }\n    .vessel-results-table .results-row .table-rep-header {\n      display: block; }\n    .vessel-results-table .results-row .service-box {\n      border-top: none;\n      padding-top: 0;\n      margin-top: 0; }\n    .vessel-results-table .carrier-results-row .results-expand .col1, .vessel-results-table .carrier-results-row .results-expand .col2 {\n      text-align: center;\n      width: 100%; }\n  .header-col h3 {\n    margin-bottom: 0;\n    padding-bottom: 0;\n    border: none; }\n  .service-box {\n    text-align: center;\n    border-top: none;\n    padding-top: 0;\n    margin-top: 0; }\n    .service-box b {\n      display: block; }\n      .service-box b span {\n        display: none; }\n  .vessel-banner .vessel-banner-inner {\n    padding: 15px 15px 15px 15px; } }\n\n@media only screen and (max-width: 599px) {\n  .small-header {\n    display: none; }\n  .vessel-results-table .service-ports {\n    border-bottom: 2px solid #ccc; }\n    .vessel-results-table .service-ports .table-rep-header {\n      display: block; }\n  .vessel-results-table .column1, .vessel-results-table .column2, .vessel-results-table .column3 {\n    width: 100%;\n    border: none; } }\n\n@media only screen and (max-width: 499px) {\n  .vessel-results-table .col2 {\n    padding-left: 30px;\n    width: 100%;\n    font-size: 18px;\n    font-weight: 500; }\n  .vessel-results-table .carrier-results-row .results-header-col .col2 {\n    display: block;\n    width: 100%;\n    padding-left: 23px; }\n  .vessel-results-table .carrier-results-row .results-header-col .col1 {\n    width: calc(100% - 18px); } }\n\n@media only screen and (max-width: 399px) {\n  .refine-sidebar {\n    width: 300px;\n    margin-left: -295px; }\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n\n.btn-deactive {\n  background-color: gray; }\n"

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
__webpack_require__(23);
var shared_1 = __webpack_require__(2);
var WebSearchService = (function () {
    // subscription: Subject<string>;
    function WebSearchService(api, cache, app) {
        this.api = api;
        this.cache = cache;
        this.app = app;
        this.code = '';
        // Variable being used as place holder untill we can check the billing interval through appContext
        this.monthlyAccount = true;
        this.yearlyBilling = false;
        this.managementShowFull = false;
        this.capacityShowFull = false;
        this.constructionShowFull = false;
        this.propulsionShowFull = false;
    }
    // End - Variable being used as place holder untill we can check the billing interval through appContext
    WebSearchService.prototype.getPlans = function () {
        var _this = this;
        var cache = this.cache.get('plans');
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetPlans(client); });
        var server = Observable_1.Observable.fromPromise(promise);
        this.plans = Observable_1.Observable.concat(cache, server);
        this.cache.updateCache('plans', this.plans);
        return this.plans;
    };
    WebSearchService.prototype.callGetPlans = function (apigClient) {
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {};
            var additionalParams = {
                // If there are any unmodeled query parameters or headers that must be 
                // sent with the request, add them here.
                headers: {
                    'Content-Type': 'application/json'
                },
                queryParams: {}
            };
            try {
                apigClient.billingPlansGet(params, '', additionalParams)
                    .then(function (result) {
                    var planArray = new Array();
                    for (var current = 0; current < result.data.data.length; current++) {
                        var plan = new shared_1.Plan(result.data.data[current]);
                        planArray.push(plan);
                    }
                    resolve(planArray);
                })
                    .catch(function (err) {
                    return reject(err);
                });
            }
            catch (ex) {
                return reject(ex);
            }
        });
    };
    WebSearchService.prototype.expandManagement = function () {
        this.managementShowFull = !this.managementShowFull;
    };
    WebSearchService.prototype.expandCapacity = function () {
        this.capacityShowFull = !this.capacityShowFull;
    };
    WebSearchService.prototype.expandConstruction = function () {
        this.constructionShowFull = !this.constructionShowFull;
    };
    WebSearchService.prototype.expandPropulsion = function () {
        this.propulsionShowFull = !this.propulsionShowFull;
    };
    WebSearchService.prototype.isEnterprise = function () {
        if (this.app.accountType == 'Professional') {
            if (this.app.plan.name == 'Professional' || this.app.plan.name == 'Monthly API 500' || this.app.plan.name == 'Monthly API 1000' || this.app.plan.name == 'Monthly API 4000' || this.app.plan.name == 'Monthly API 15000') {
                return false;
            }
            else if (this.app.plan.name == 'Monthly Enterprise 2-6' || this.app.plan.name == 'Monthly Enterprise 7-12' || this.app.plan.name == 'Monthly Enterprise 13-18' || this.app.plan.name == 'Yearly Enterprise 2-6' || this.app.plan.name == 'Yearly Enterprise 7-12' || this.app.plan.name == 'Yearly Enterprise 13-18') {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    WebSearchService.prototype.isMontylyEnterprise = function () {
        if (this.app.plan.name == 'Monthly Enterprise 2-6' || this.app.plan.name == 'Monthly Enterprise 7-12' || this.app.plan.name == 'Monthly Enterprise 13-18') {
            return true;
        }
        else {
            return false;
        }
    };
    WebSearchService.prototype.isYearlyEnterprise = function () {
        if (this.app.plan.name == 'Yearly Enterprise 2-6' || this.app.plan.name == 'Yearly Enterprise 7-12' || this.app.plan.name == 'Yearly Enterprise 13-18') {
            return true;
        }
        else {
            return false;
        }
    };
    WebSearchService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.CacheService, shared_1.AppContext])
    ], WebSearchService);
    return WebSearchService;
}());
exports.WebSearchService = WebSearchService;


/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = "<div class=\"plans-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"plans-banner-inner\">\r\n      <h2>Subscribe</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <!--<div class=\"results-header\">\r\n      <h5><span class=\"hide\">Select </span>Billing<span class=\"hide\"> Period</span>:\r\n      <a (click)=\"monthly()\" [class.selected]=\"!service.yearlyBilling\" class=\"btn-no-fill\">Monthly</a>\r\n      <a (click)=\"yearly()\" [class.selected]=\"service.yearlyBilling\" class=\"btn-no-fill\">Yearly</a></h5>\r\n    </div>-->\r\n    <div class=\"col-holder plans-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"page-top-content\">\r\n          <h3 class=\"blue mb15 mt15\">Plans &amp; Pricing</h3>\r\n          <p>Choose any plan which suits your needs and budget. You may upgrade or downgrade any plan at any time. When upgrading plans you'll receive a partial-month refund. When downgrading plans you'll maintain your current plan until the end of the billing period, and begin the downgraded plan at the start of the next billing period.</p>\r\n        </div>\r\n    </div>\r\n      <div class=\"plans-content col-holder\">\r\n        <div class=\"upper-right-header\">\r\n          <!--<h1>Select the Perfect Plan for You</h1>-->\r\n          <h4 class=\"blue\">Choose a Plan</h4>\r\n          <h6 class=\"mt10 mb15\">Select Billing Period\r\n            <br />\r\n            <a (click)=\"monthly()\" [class.btn-deactive]=\"!service.yearlyBilling\" [class.selected]=\"!service.yearlyBilling\" class=\"mt10 btn\">Monthly</a>\r\n            <a (click)=\"yearly()\" [class.btn-deactive]=\"service.yearlyBilling\" [class.selected]=\"service.yearlyBilling\" class=\"btn\">Yearly</a>\r\n          </h6>\r\n        </div>\r\n        <div class=\"plans-header\">\r\n          <div class=\"col-holder\">\r\n            <div [class.current]=\"service.app.accountType === 'Basic'\" class=\"col1of4\">\r\n              <p><b>Basic</b></p>\r\n              <p class=\"small-text\">Registered</p>\r\n              <p style=\"padding: 6px;\">one user</p>\r\n              <h1 *ngIf=\"!service.yearlyBilling\">FREE<span></span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">Free<span></span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling\" class=\"small-text\">&nbsp;</p>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Basic')\" class=\"btn-blue\">Register Now</a>\r\n              <a *ngIf=\"service.app.accountType === 'Basic'\" [routerLink]=\"['../account/information']\" class=\"btn\">Current Plan</a>\r\n              <a *ngIf=\"service.app.accountType !== 'Basic' && service.app.accountType !== ''\" [routerLink]=\"['../account/information']\" class=\"btn-blue btn-gray\">Included</a>\r\n            </div>\r\n            <div [class.current]=\"service.app.accountType === 'Premium'\" class=\"col1of4\">\r\n              <p><b>Premium</b></p>\r\n              <p class=\"small-text\">Subscription</p>\r\n              <p style=\"padding: 6px;\">one user</p>\r\n              <h1 *ngIf=\"!service.yearlyBilling\">$49<span>/mo</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">$488<span>/year</span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month' && service.app.accountType !== 'Professional'\" class=\"small-text\">Save $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">&nbsp;</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">&nbsp;</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Premium'\" class=\"small-text\">Saving $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Basic'\" class=\"small-text\">Save $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.accountType === ''\" class=\"small-text\">Save $100</p>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Premium')\" class=\"btn\">Try Now</a>\r\n              <a *ngIf=\"service.app.accountType === 'Basic'\" [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.app.accountType === 'Premium'\" [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month'\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n              <a *ngIf=\"service.app.accountType === 'Professional'\" [routerLink]=\"['../account/information']\" class=\"btn btn-gray\">Included</a>\r\n            </div>\r\n            <div [class.current]=\"service.app.accountType === 'Professional' && !service.isEnterprise()\" class=\"col1of4\">\r\n              <p><b>Professional</b></p>\r\n              <p class=\"small-text\">Subscription</p>\r\n              <p style=\"padding: 6px;\">one user</p>\r\n              <h1 *ngIf=\"!service.yearlyBilling\">$99<span>/mo</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">$988<span>/year</span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\" class=\"small-text\">Save $200</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType !== 'Professional'\" class=\"small-text\">Save $200</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">Saving $200</p>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Professional')\" class=\"btn\">Try Now</a>\r\n              <a *ngIf=\"service.app.accountType !== '' && service.app.accountType !== 'Professional'\"  [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.app.accountType === 'Professional' && !service.isEnterprise()\"  [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month'\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n              <a *ngIf=\"service.app.accountType === 'Professional' && service.isEnterprise()\" [routerLink]=\"['../account/information']\" class=\"btn btn-gray\">Included</a>\r\n            </div>\r\n            <!-- <div [class.current]=\"service.app.accountType === 'Enterprise'\" class=\"col1of4\">\r\n              <p><b>Enterprise</b></p>\r\n              <p class=\"small-text\">Account</p>\r\n              <h1>Per User<span></span></h1>\r\n              <a *ngIf=\"service.app.accountType === ''\" [routerLink]=\"['../contact']\" class=\"btn\">Contact Us</a>\r\n              <a *ngIf=\"service.app.accountType !== '' && service.app.accountType !== 'Enterprise'\"  [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.app.accountType === 'Enterprise'\"  [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month'\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n            </div> -->\r\n            <div [class.current]=\"service.app.accountType === 'Professional' && service.isEnterprise()\" class=\"col1of4\">\r\n              <p><b>Enterprise</b></p>\r\n              <p class=\"small-text\">Subscription</p>\r\n              <select [(ngModel)]=\"enterprisePlanLevel\">\r\n                <option value=\"6\">2-6 users</option>\r\n                <option value=\"12\">7-12 users</option>\r\n                <option value=\"18\">13-18 users</option>\r\n              </select>\r\n              <h1 *ngIf=\"!service.yearlyBilling && enterprisePlanLevel == '6'\">$149<span>/mo</span></h1>\r\n              <h1 *ngIf=\"!service.yearlyBilling && enterprisePlanLevel == '12'\">$199<span>/mo</span></h1>\r\n              <h1 *ngIf=\"!service.yearlyBilling && enterprisePlanLevel == '18'\">$249<span>/mo</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling && enterprisePlanLevel == '6'\">$1488<span>/year</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling && enterprisePlanLevel == '12'\">$1988<span>/year</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling && enterprisePlanLevel == '18'\">$2488<span>/year</span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && enterprisePlanLevel == '6'\" class=\"small-text\">Save $300</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && enterprisePlanLevel == '12'\" class=\"small-text\">Save $400</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && enterprisePlanLevel == '18'\" class=\"small-text\">Save $500</p>\r\n              <!-- <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType !== 'Professional'\" class=\"small-text\">Save $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">Saving $200</p> -->\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Enterprise')\" class=\"btn\">Try Now</a>\r\n              <a *ngIf=\"service.app.accountType !== '' && !service.isEnterprise()\"  [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.isEnterprise()\"  [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.isMontylyEnterprise()\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.isYearlyEnterprise()\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"plans-section\">\r\n          <h5>MAIN FEATURES</h5>\r\n          <div class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Save Routes and Favorites</p>\r\n              <p>Download Schedules</p>\r\n              <p>Email Schedules</p>\r\n              <p>View Transhipments</p>\r\n              <p>Include Nearby Ports</p>\r\n              <p>Unlimited Searches</p>\r\n              <p>Compare Carrier Schedules</p>\r\n              <p>Multiple Users</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Save Routes and Favorites<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Download Schedules<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Email Schedules<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">View Transhipments<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Include Nearby Ports<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Unlimited Searches<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Compare Carrier Performance<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Multiple Users<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Save Routes and Favorites<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Download Schedules<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Email Schedules<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">View Transhipments<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Include Nearby Ports<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Unlimited Searches<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Compare Carrier Performance<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Multiple Users<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Save Routes and Favorites<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Download Schedules<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Email Schedules<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">View Transhipments<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Include Nearby Ports<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Unlimited Searches<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Compare Carrier Performance<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Multiple Users<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Enterprise</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Save Routes and Favorites<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Download Schedules<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Email Schedules<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">View Transhipments<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Include Nearby Ports<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Unlimited Searches<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Compare Carrier Performance<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Multiple Users<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"plans-section\">\r\n          <h5>SCHEDULE DATA</h5>\r\n          <div class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Carrier Name &amp; SCAC</p>\r\n              <p>Port Names &amp; UN Locodes</p>\r\n              <p>ETD &amp; ETA Dates</p>\r\n              <p>Vessel Name &amp; Voyage Number</p>\r\n              <p>Service Name &amp; Code</p>\r\n              <p>Get Data by Email Attachment</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name &amp; SCAC<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Port Names &amp; UN Locodes<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">ETD &amp; ETA Dates<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Vessel Name &amp; Voyage Number<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Service Name &amp; Code<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Get Data by Email Attachment<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name &amp; SCAC<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Port Names &amp; UN Locodes<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">ETD &amp; ETA Dates<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Vessel Name &amp; Voyage Number<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Service Name &amp; Code<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Get Data by Email Attachment<br></span>3 files / day</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name &amp; SCAC<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Port Names &amp; UN Locodes<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">ETD &amp; ETA Dates<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Vessel Name &amp; Voyage Number<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Service Name &amp; Code<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Get Data by Email Attachment<br></span>10 files / day</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Enterprise</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name &amp; SCAC<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Port Names &amp; UN Locodes<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">ETD &amp; ETA Dates<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Vessel Name &amp; Voyage Number<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Service Name &amp; Code<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Get Data by Email Attachment<br></span>10 files / day / user</p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"plans-section\">\r\n          <h5>CARRIER DATA</h5>\r\n          <div class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Carrier Profile</p>\r\n              <p>Fleet (Vessels &amp; TEU)</p>\r\n              <p>Company Address &amp; Website</p>\r\n              <p>Local Carrier Contacts</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Address, Website, Parent<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Fleet (Ships, TEU, Trades)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Local Carrier Contacts<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Address, Website, Parent<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Fleet (Ships, TEU, Trades)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Local Carrier Contacts<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Address, Website, Parent<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Fleet (Ships, TEU, Trades)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Local Carrier Contacts<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Enterprise</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Address, Website, Parent<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Fleet (Ships, TEU, Trades)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Local Carrier Contacts<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"plans-section\">\r\n          <h5>VESSEL DATA</h5>\r\n          <div class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Vessel Name, IMO Number</p>\r\n              <p>Flag, Call Sign, MMSI</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Vessel Name, IMO Number<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Flag, Call Sign, MMSI<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Vessel Name, IMO Number<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Flag, Call Sign, MMSI<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Vessel Name, IMO Number<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Flag, Call Sign, MMSI<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Enterprise</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Vessel Name, IMO Number<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Flag, Call Sign, MMSI<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div [class.open]=\"service.managementShowFull\" class=\"plans-section plans-section-expandable\">\r\n          <div *ngIf=\"!service.managementShowFull\" class=\"col-holder plans-section-closed-checks\">\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n          <h5 [class.open]=\"service.managementShowFull\" (click)=\"service.expandManagement()\" class=\"sub-header pointer\"><a [class.open]=\"service.managementShowFull\" class=\"expand-button\"><img src=\"../img/blackarrow-01.svg\" onerror=\"this.onerror=null; this.src='../img/blackarrow.png'\"></a>VESSEL MANAGEMENT</h5>\r\n          <div *ngIf=\"service.managementShowFull\" class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Owner, Operator</p>\r\n              <p>Previous Names</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Owner, Operator<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>  \r\n              <p><span class=\"rep-header\">Previous Names<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Owner, Operator<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>  \r\n              <p><span class=\"rep-header\">Previous Names<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Owner, Operator<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>  \r\n              <p><span class=\"rep-header\">Previous Names<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p> \r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Enterprise</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Owner, Operator<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>  \r\n              <p><span class=\"rep-header\">Previous Names<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p> \r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div [class.open]=\"service.capacityShowFull\" class=\"plans-section plans-section-expandable\">\r\n          <div *ngIf=\"!service.capacityShowFull\" class=\"col-holder plans-section-closed-checks\">\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n          <h5 [class.open]=\"service.capacityShowFull\" (click)=\"service.expandCapacity()\" class=\"sub-header pointer\"><a [class.open]=\"service.capacityShowFull\" class=\"expand-button\"><img src=\"../img/blackarrow-01.svg\" onerror=\"this.onerror=null; this.src='../img/blackarrow.png'\"></a>VESSEL CAPACITY</h5>\r\n          <div *ngIf=\"service.capacityShowFull\" class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Gross &amp; Net Tonnage</p>\r\n              <p>DWT (Dead Weight Tons)</p>\r\n              <p>Nominal TEU</p>\r\n              <p>14mt TEU &amp; Reefer TEU</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Gross &amp; Net Tonnage<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">DWT (Dead Weight Tons)<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Nominal TEU<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">14mt TEU &amp; Reefer TEU<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Gross &amp; Net Tonnage<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">DWT (Dead Weight Tons)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Nominal TEU<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">14mt TEU &amp; Reefer TEU<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Gross &amp; Net Tonnage<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">DWT (Dead Weight Tons)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Nominal TEU<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">14mt TEU &amp; Reefer TEU<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Enterprise</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Gross &amp; Net Tonnage<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">DWT (Dead Weight Tons)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Nominal TEU<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">14mt TEU &amp; Reefer TEU<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div [class.open]=\"service.constructionShowFull\" class=\"plans-section plans-section-expandable\">\r\n          <div *ngIf=\"!service.constructionShowFull\" class=\"col-holder plans-section-closed-checks\">\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n          <h5 [class.open]=\"service.constructionShowFull\" (click)=\"service.expandConstruction()\" class=\"sub-header pointer\"><a [class.open]=\"service.constructionShowFull\" class=\"expand-button\"><img src=\"../img/blackarrow-01.svg\" onerror=\"this.onerror=null; this.src='../img/blackarrow.png'\"></a>VESSEL CONSTRUCTION</h5>\r\n          <div *ngIf=\"service.constructionShowFull\" class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Ship Type, Year Built</p>\r\n              <p>Port Registry, Ship Builder</p>\r\n              <p>Yard, Hull, Handling Gear</p>\r\n              <p>Length, Beam, Draught</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Ship Type, Year Built<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Port Registry, Ship Builder<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Yard, Hull, Handling Gear<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Length, Beam, Draught<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Ship Type, Year Built<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Port Registry, Ship Builder<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Yard, Hull, Handling Gear<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Length, Beam, Draught<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Ship Type, Year Built<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Port Registry, Ship Builder<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Yard, Hull, Handling Gear<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Length, Beam, Draught<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Enterprise</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Ship Type, Year Built<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Port Registry, Ship Builder<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Yard, Hull, Handling Gear<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Length, Beam, Draught<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div [class.open]=\"service.propulsionShowFull\" class=\"plans-section plans-section-expandable\">\r\n          <div *ngIf=\"!service.propulsionShowFull\" class=\"col-holder plans-section-closed-checks\">\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n          <h5 [class.open]=\"service.propulsionShowFull\" (click)=\"service.expandPropulsion()\" class=\"sub-header pointer\"><a [class.open]=\"service.propulsionShowFull\" class=\"expand-button\"><img src=\"../img/blackarrow-01.svg\" onerror=\"this.onerror=null; this.src='../img/blackarrow.png'\"></a>VESSEL PROPULSION</h5>\r\n          <div *ngIf=\"service.propulsionShowFull\" class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Engine Design, Type</p>\r\n              <p>Power (KW), Speed(Kn)</p>\r\n              <p>Fuel Consumption</p>\r\n              <p>CO2 Emissions</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Engine Design, Type<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Power (KW), Speed(Kn)<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Fuel Consumption<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">CO2 Emissions<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Engine Design, Type<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Power (KW), Speed(Kn)<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Fuel Consumption<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">CO2 Emissions<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Engine Design, Type<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Power (KW), Speed(Kn)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Fuel Consumption<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">CO2 Emissions<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Enterprise</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Engine Design, Type<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Power (KW), Speed(Kn)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Fuel Consumption<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">CO2 Emissions<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"plans-header bottom\">\r\n           <div class=\"col-holder\">\r\n            <div [class.current]=\"service.app.accountType === 'Basic'\" class=\"col1of4\">\r\n              <p><b>Basic</b></p>\r\n              <p class=\"small-text\">Registered</p>\r\n              <p style=\"padding: 6px;\">one user</p>\r\n              <h1 *ngIf=\"!service.yearlyBilling\">FREE<span></span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">Free<span></span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling\" class=\"small-text\">&nbsp;</p>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Basic')\" class=\"btn-blue\">Register Now</a>\r\n              <a *ngIf=\"service.app.accountType === 'Basic'\" [routerLink]=\"['../account/information']\" class=\"btn\">Current Plan</a>\r\n              <a *ngIf=\"service.app.accountType !== 'Basic' && service.app.accountType !== ''\" [routerLink]=\"['../account/information']\" class=\"btn-blue btn-gray\">Included</a>\r\n            </div>\r\n            <div [class.current]=\"service.app.accountType === 'Premium'\" class=\"col1of4\">\r\n              <p><b>Premium</b></p>\r\n              <p class=\"small-text\">Subscription</p>\r\n              <p style=\"padding: 6px;\">one user</p>\r\n              <h1 *ngIf=\"!service.yearlyBilling\">$49<span>/mo</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">$488<span>/year</span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month' && service.app.accountType !== 'Professional'\" class=\"small-text\">Save $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">&nbsp;</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">&nbsp;</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Premium'\" class=\"small-text\">Saving $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Basic'\" class=\"small-text\">Save $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.accountType === ''\" class=\"small-text\">Save $100</p>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Premium')\" class=\"btn\">Try Now</a>\r\n              <a *ngIf=\"service.app.accountType === 'Basic'\" [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.app.accountType === 'Premium'\" [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month'\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n              <a *ngIf=\"service.app.accountType === 'Professional'\" [routerLink]=\"['../account/information']\" class=\"btn btn-gray\">Included</a>\r\n            </div>\r\n            <div [class.current]=\"service.app.accountType === 'Professional' && !service.isEnterprise()\" class=\"col1of4\">\r\n              <p><b>Professional</b></p>\r\n              <p class=\"small-text\">Subscription</p>\r\n              <p style=\"padding: 6px;\">one user</p>\r\n              <h1 *ngIf=\"!service.yearlyBilling\">$99<span>/mo</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">$988<span>/year</span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\" class=\"small-text\">Save $200</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType !== 'Professional'\" class=\"small-text\">Save $200</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">Saving $200</p>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Professional')\" class=\"btn\">Try Now</a>\r\n              <a *ngIf=\"service.app.accountType !== '' && service.app.accountType !== 'Professional'\"  [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.app.accountType === 'Professional' && !service.isEnterprise()\"  [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month'\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n              <a *ngIf=\"service.app.accountType === 'Professional' && service.isEnterprise()\" [routerLink]=\"['../account/information']\" class=\"btn btn-gray\">Included</a>\r\n            </div>\r\n            <!-- <div [class.current]=\"service.app.accountType === 'Enterprise'\" class=\"col1of4\">\r\n              <p><b>Enterprise</b></p>\r\n              <p class=\"small-text\">Account</p>\r\n              <h1>Per User<span></span></h1>\r\n              <a *ngIf=\"service.app.accountType === ''\" [routerLink]=\"['../contact']\" class=\"btn\">Contact Us</a>\r\n              <a *ngIf=\"service.app.accountType !== '' && service.app.accountType !== 'Enterprise'\"  [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.app.accountType === 'Enterprise'\"  [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month'\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n            </div> -->\r\n            <div [class.current]=\"service.app.accountType === 'Professional' && service.isEnterprise()\" class=\"col1of4\">\r\n              <p><b>Enterprise</b></p>\r\n              <p class=\"small-text\">Subscription</p>\r\n              <select [(ngModel)]=\"enterprisePlanLevel\">\r\n                <option value=\"6\">2-6 users</option>\r\n                <option value=\"12\">7-12 users</option>\r\n                <option value=\"18\">13-18 users</option>\r\n              </select>\r\n              <h1 *ngIf=\"!service.yearlyBilling && enterprisePlanLevel == '6'\">$149<span>/mo</span></h1>\r\n              <h1 *ngIf=\"!service.yearlyBilling && enterprisePlanLevel == '12'\">$199<span>/mo</span></h1>\r\n              <h1 *ngIf=\"!service.yearlyBilling && enterprisePlanLevel == '18'\">$249<span>/mo</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling && enterprisePlanLevel == '6'\">$1488<span>/year</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling && enterprisePlanLevel == '12'\">$1988<span>/year</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling && enterprisePlanLevel == '18'\">$2488<span>/year</span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && enterprisePlanLevel == '6'\" class=\"small-text\">Save $300</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && enterprisePlanLevel == '12'\" class=\"small-text\">Save $400</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && enterprisePlanLevel == '18'\" class=\"small-text\">Save $500</p>\r\n              <!-- <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType !== 'Professional'\" class=\"small-text\">Save $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">Saving $200</p> -->\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Enterprise')\" class=\"btn\">Try Now</a>\r\n              <a *ngIf=\"service.app.accountType !== '' && !service.isEnterprise()\"  [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.isEnterprise()\"  [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.isMontylyEnterprise()\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.isYearlyEnterprise()\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <h5 class=\"mt30 mb15 blue\">Payments</h5>\r\n        <p>We accept most major credit cards, including: Visa, MasterCard, American Express, Discover, Diners Club and JCB. Our payments are processed through our partner Stripe Checkout, and you will receive a full invoice for every order.</p>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = ".results-header {\n  padding-left: 28%;\n  background: #282828;\n  height: 50px;\n  color: #ffffff; }\n  .results-header h5 {\n    line-height: 50px; }\n    .results-header h5 .btn-no-fill {\n      margin-left: 5px;\n      margin-right: 5px; }\n      .results-header h5 .btn-no-fill:hover {\n        background: #ffffff;\n        border-color: #ffffff;\n        color: #282828; }\n      .results-header h5 .btn-no-fill.selected {\n        background: #ffffff;\n        border-color: #ffffff;\n        color: #282828; }\n\n.page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n  color: #7f56db; }\n\n.blue {\n  color: #7f56db; }\n\n.plans-content-wrapper {\n  position: relative;\n  /*min-height: 457px;*/\n  min-height: 2000px;\n  background: #ffffff;\n  /*overflow-x: hidden*/ }\n\n.upper-right-header .btn-no-fill {\n  color: #7f56db;\n  border-color: #7f56db;\n  background: transparent;\n  transition: background ease .5s, color ease .5s; }\n  .upper-right-header .btn-no-fill:hover {\n    background: #7f56db;\n    border-color: #7f56db;\n    color: #ffffff; }\n  .upper-right-header .btn-no-fill.selected {\n    background: #7f56db;\n    border-color: #7f56db;\n    color: #ffffff; }\n\nplans-side-bar {\n  display: inline-block; }\n\n.plans-sidebar {\n  margin-left: 0;\n  margin-top: 0; }\n\n.plans-sidebar-2 {\n  display: none; }\n\n.plans-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px 20px 60px;\n  width: 100%;\n  padding-bottom: 200px; }\n  .plans-content .upper-right-header {\n    width: 30%;\n    display: inline-block;\n    vertical-align: top; }\n    .plans-content .upper-right-header h1 {\n      font-weight: 300;\n      line-height: 54px;\n      margin-top: 10px; }\n  .plans-content .plans-header {\n    vertical-align: top;\n    display: inline-block;\n    text-align: center;\n    width: 70%;\n    margin-bottom: 40px; }\n    .plans-content .plans-header .col1of4,\n    .plans-content .plans-header .col1of3 {\n      width: calc(33% - 4px);\n      border: 1px solid #c1c1c1;\n      padding: 25px 5px;\n      margin-left: 2px;\n      margin-right: 2px;\n      border-radius: 3px; }\n      .plans-content .plans-header .col1of4 p,\n      .plans-content .plans-header .col1of3 p {\n        font-weight: 400; }\n      .plans-content .plans-header .col1of4 h1,\n      .plans-content .plans-header .col1of3 h1 {\n        font-weight: 300;\n        font-size: 33px; }\n        .plans-content .plans-header .col1of4 h1 span,\n        .plans-content .plans-header .col1of3 h1 span {\n          font-size: 14px;\n          font-weight: 400; }\n      .plans-content .plans-header .col1of4 .btn-blue,\n      .plans-content .plans-header .col1of4 .btn,\n      .plans-content .plans-header .col1of3 .btn-blue,\n      .plans-content .plans-header .col1of3 .btn {\n        padding: 8px 10px;\n        width: calc(100% - 20px);\n        font-size: 16px; }\n      .plans-content .plans-header .col1of4 .btn-gray,\n      .plans-content .plans-header .col1of3 .btn-gray {\n        background: #484848;\n        color: #686868; }\n      .plans-content .plans-header .col1of4.current,\n      .plans-content .plans-header .col1of3.current {\n        background: #2798d8; }\n        .plans-content .plans-header .col1of4.current p,\n        .plans-content .plans-header .col1of3.current p {\n          color: #ffffff; }\n        .plans-content .plans-header .col1of4.current h1,\n        .plans-content .plans-header .col1of3.current h1 {\n          color: #ffffff; }\n    .plans-content .plans-header .col1of4 {\n      width: calc(25% - 4px); }\n    .plans-content .plans-header.bottom {\n      margin-left: 30%; }\n  .plans-content .plans-section {\n    margin-bottom: 40px; }\n    .plans-content .plans-section h5 {\n      padding-left: 15px;\n      font-weight: bold;\n      line-height: 40px;\n      background: linear-gradient(to right, #851746, #2798d8);\n      color: white; }\n      .plans-content .plans-section h5.sub-header {\n        color: #353535;\n        background: none;\n        font-size: 18px;\n        border-bottom: 2px solid #c1c1c1;\n        position: relative;\n        top: -42px; }\n        .plans-content .plans-section h5.sub-header.open {\n          border-bottom: none;\n          position: initial;\n          top: 0; }\n    .plans-content .plans-section.plans-section-expandable {\n      margin-bottom: 0; }\n    .plans-content .plans-section.open {\n      margin-bottom: 40px; }\n    .plans-content .plans-section .plans-section-col-big {\n      vertical-align: top;\n      display: inline-block;\n      width: 30%;\n      border-top: 2px solid #c1c1c1; }\n      .plans-content .plans-section .plans-section-col-big p {\n        line-height: 40px;\n        padding-left: 15px;\n        font-size: 17px; }\n    .plans-content .plans-section .plans-section-col-small {\n      text-align: center;\n      vertical-align: top;\n      display: inline-block;\n      width: 17.5%;\n      border-top: 2px solid #c1c1c1;\n      border-bottom: 2px solid #c1c1c1;\n      border-left: 2px solid #c1c1c1; }\n      .plans-content .plans-section .plans-section-col-small img {\n        height: 18px;\n        width: 25px; }\n      .plans-content .plans-section .plans-section-col-small .image-span {\n        height: 40px; }\n      .plans-content .plans-section .plans-section-col-small .dash-image {\n        display: none; }\n      .plans-content .plans-section .plans-section-col-small p {\n        line-height: 40px;\n        font-size: 16px; }\n      .plans-content .plans-section .plans-section-col-small p:nth-of-type(even) {\n        background: #efefef; }\n      .plans-content .plans-section .plans-section-col-small:last-of-type {\n        border-right: 2px solid #c1c1c1; }\n    .plans-content .plans-section:first-of-type {\n      margin-top: -26px; }\n    .plans-content .plans-section .rep-header {\n      display: none;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 20px;\n      color: #999999; }\n    .plans-content .plans-section .rep-plan-header {\n      display: none;\n      border-bottom: 2px solid #c1c1c1;\n      padding-top: 5px;\n      padding-bottom: 5px; }\n      .plans-content .plans-section .rep-plan-header p {\n        background: #ffffff !important;\n        line-height: 26px; }\n      .plans-content .plans-section .rep-plan-header p:nth-of-type(2) {\n        font-size: 16px; }\n    .plans-content .plans-section .expand-button {\n      display: inline-block;\n      transition: transform .3s ease-in-out;\n      margin-right: 8px; }\n      .plans-content .plans-section .expand-button.open {\n        transform: rotate(90deg); }\n      .plans-content .plans-section .expand-button img {\n        height: 18px;\n        margin-bottom: -1px; }\n  .plans-content .local-contact-section h5 {\n    padding-left: 15px;\n    font-weight: bold;\n    line-height: 40px;\n    background: #fff;\n    color: #353535;\n    font-size: 20px; }\n\n.header-col {\n  width: calc(100% + 40px);\n  margin-left: -20px;\n  background: #f0f0f0;\n  margin-bottom: 25px;\n  margin-top: 25px;\n  padding: 10px 30px; }\n  .header-col div {\n    vertical-align: top;\n    font-weight: bold;\n    font-size: 20px; }\n\n.plans-content .plans-section-closed-checks {\n  margin-left: 30%; }\n  .plans-content .plans-section-closed-checks .plans-section-col-small {\n    width: 25%;\n    border-bottom: none; }\n\n.page-content {\n  padding: 20px 60px;\n  width: 100%; }\n  .page-content .page-top-content {\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 0; }\n    .page-content .page-top-content h1 {\n      font-weight: 300;\n      line-height: 54px;\n      margin-top: 10px; }\n\n.mobile-screenshot {\n  display: none; }\n\n.full-width-screenshot {\n  max-width: 950px;\n  margin: auto; }\n\n@media screen and (min-width: 767px) and (max-height: 800px) {\n  .remove800h {\n    display: none; }\n  .plans-sidebar .plans-sidebar-section {\n    margin-bottom: 10px;\n    padding-bottom: 10px; } }\n\n@media only screen and (max-width: 1200px) {\n  .plans-content {\n    width: 100%; }\n    .plans-content .plans-header .col1of3 .btn-blue,\n    .plans-content .plans-header .col1of3 .btn {\n      font-size: 16px; }\n    .plans-content .plans-section .plans-section-col-big p {\n      font-size: 16px; }\n  .sidebar-section:first-of-type {\n    display: none !important; }\n  .plans-content .plans-sidebar-2 {\n    display: block !important;\n    margin-bottom: 45px; }\n  plans-side-bar {\n    width: 100%; }\n  .plans-sidebar {\n    width: 100%;\n    font-size: 0;\n    margin-left: 0;\n    margin-top: 0;\n    padding: 30px 20px; }\n    .plans-sidebar .plans-sidebar-section {\n      padding-left: 10px;\n      padding-right: 10px;\n      width: calc(33% - 1px);\n      display: inline-block;\n      vertical-align: top;\n      border-bottom: 0; }\n      .plans-sidebar .plans-sidebar-section:nth-of-type(3) {\n        width: calc(33% + 2px);\n        border-left: 1px dashed #ffffff;\n        border-right: 1px dashed #ffffff; }\n    .plans-sidebar .btn {\n      display: block; }\n    .plans-sidebar img {\n      height: 60px; }\n  sticky {\n    display: none; } }\n\n@media only screen and (max-width: 1100px) {\n  .plans-content .plans-header .col1of3 .btn-blue,\n  .plans-content .plans-header .col1of3 .btn {\n    font-size: 15px; }\n  .plans-content .plans-section h5 {\n    padding-left: 5px; }\n    .plans-content .plans-section h5.sub-header {\n      top: 0; }\n  .plans-content .plans-section .plans-section-col-big p {\n    font-size: 15px;\n    padding-left: 5px; }\n  .plans-content .plans-section.plans-section-expandable {\n    margin-bottom: 40px; }\n  .plans-content .plans-section-closed-checks {\n    display: none; } }\n\n@media only screen and (max-width: 1023px) {\n  .plans-content .plans-header .col1of3 .btn-blue,\n  .plans-content .plans-header .col1of3 .btn {\n    font-size: 14px; }\n  .plans-content .plans-section .plans-section-col-big p {\n    font-size: 14px; }\n  .plans-content .plans-sidebar-2 {\n    display: none !important; } }\n\n@media only screen and (max-width: 980px) {\n  .plans-content .plans-sidebar-2 {\n    display: block !important; }\n  .plans-sidebar {\n    width: 100%;\n    font-size: 0;\n    padding: 30px 20px; }\n    .plans-sidebar .plans-sidebar-section {\n      padding-left: 10px;\n      padding-right: 10px;\n      width: calc(33% - 1px);\n      display: inline-block;\n      vertical-align: top;\n      border-bottom: 0; }\n      .plans-sidebar .plans-sidebar-section:nth-of-type(3) {\n        width: calc(33% + 2px);\n        border-left: 1px dashed #ffffff;\n        border-right: 1px dashed #ffffff; }\n    .plans-sidebar .btn {\n      display: block; }\n    .plans-sidebar img {\n      height: 60px; }\n  .plans-content .upper-right-header {\n    width: 100%; }\n    .plans-content .upper-right-header h1 {\n      margin-bottom: 20px; }\n  .plans-content .page-content .page-top-content h1 {\n    margin-bottom: 20px; }\n  .plans-content .plans-header {\n    width: 100%;\n    margin-left: 0; }\n    .plans-content .plans-header.bottom {\n      margin-left: 0; }\n  .plans-content .plans-section {\n    margin-top: 20px; }\n    .plans-content .plans-section:first-of-type {\n      margin-top: 20px; }\n    .plans-content .plans-section .rep-header {\n      display: block; }\n    .plans-content .plans-section .plans-section-col-big {\n      display: none; }\n    .plans-content .plans-section .plans-section-col-small {\n      width: 25%; }\n      .plans-content .plans-section .plans-section-col-small p {\n        padding-top: 5px;\n        padding-bottom: 5px; }\n      .plans-content .plans-section .plans-section-col-small .rep-plan-header p {\n        padding-top: 0;\n        padding-bottom: 0; }\n      .plans-content .plans-section .plans-section-col-small .image-span {\n        display: none; }\n      .plans-content .plans-section .plans-section-col-small .dash-image {\n        display: inline; }\n  .results-header {\n    padding-left: 0;\n    text-align: center; } }\n\n@media only screen and (max-width: 860px) {\n  .full-width-screenshot {\n    display: none; }\n  .mobile-screenshot {\n    display: block; } }\n\n@media only screen and (max-width: 767px) {\n  .page-content {\n    padding-right: 20px; }\n  .plans-sidebar-1 {\n    display: none; }\n  .plans-content .plans-sidebar-2 {\n    display: none; }\n  .plans-sidebar {\n    width: 100%;\n    font-size: 0;\n    padding: 30px 20px; }\n    .plans-sidebar .plans-sidebar-section {\n      padding-left: 10px;\n      padding-right: 10px;\n      width: calc(33% - 1px);\n      display: inline-block;\n      vertical-align: top;\n      border-bottom: 0; }\n      .plans-sidebar .plans-sidebar-section:nth-of-type(3) {\n        width: calc(33% + 2px);\n        border-left: 1px dashed #ffffff;\n        border-right: 1px dashed #ffffff; }\n    .plans-sidebar .btn {\n      display: block; }\n    .plans-sidebar img {\n      height: 60px; }\n  .plans-content {\n    width: 100%; }\n    .plans-content .plans-header .col1of4 {\n      width: calc(50% - 20px);\n      max-width: 220px;\n      margin-bottom: 20px;\n      margin-left: 10px;\n      margin-right: 10px; }\n    .plans-content .plans-section h5 {\n      margin-bottom: 20px; }\n    .plans-content .plans-section .col-holder {\n      text-align: center; }\n    .plans-content .plans-section .plans-section-col-small {\n      width: calc(50% - 20px);\n      max-width: calc(50% - 20px);\n      margin-bottom: 20px;\n      margin-left: 10px;\n      margin-right: 10px;\n      border: 2px solid #c1c1c1; }\n      .plans-content .plans-section .plans-section-col-small .rep-plan-header {\n        display: block; }\n  .plans-content .plans-section h5.sub-header.open {\n    border-bottom: 2px solid #c1c1c1; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 20px; }\n  .plans-banner .plans-banner-inner {\n    padding: 15px; }\n  .plans-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .header-col {\n    display: none; }\n  .plans-sidebar {\n    width: 100%;\n    font-size: 0;\n    padding: 15px 5px; }\n    .plans-sidebar .btn {\n      width: 200px;\n      margin: auto; } }\n\n@media only screen and (max-width: 499px) {\n  .plans-sidebar {\n    width: 100%;\n    font-size: 0;\n    padding: 15px; }\n    .plans-sidebar .plans-sidebar-section {\n      width: 100%;\n      display: inline-block;\n      vertical-align: top;\n      border-bottom: 0;\n      border-bottom: 1px dashed #ffffff; }\n      .plans-sidebar .plans-sidebar-section:nth-of-type(3) {\n        width: 100%;\n        border-left: none;\n        border-right: none; }\n      .plans-sidebar .plans-sidebar-section.show499 {\n        display: block; }\n      .plans-sidebar .plans-sidebar-section.hide499 {\n        display: none; }\n    .plans-sidebar .btn {\n      display: block; }\n    .plans-sidebar img {\n      height: 60px; }\n  .plans-content .plans-header .col1of4,\n  .plans-content .plans-header .col1of3 {\n    width: 100%;\n    max-width: 220px;\n    margin-bottom: 20px;\n    margin-left: 10px;\n    margin-right: 10px; }\n  .plans-content .plans-section .col-holder {\n    text-align: center; }\n  .plans-content .plans-section .plans-section-col-small {\n    width: 100%;\n    max-width: calc(100% - 20px);\n    margin-bottom: 20px;\n    margin-left: 10px;\n    margin-right: 10px;\n    border: 2px solid #c1c1c1; }\n  .results-header .hide {\n    display: none; } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; }\n  .results-header h5 {\n    font-size: 20px; }\n    .results-header h5 .btn-no-fill {\n      padding: 8px 16px; }\n  .plans-content .plans-section .plans-section-col-small {\n    width: 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n    margin-left: 0;\n    margin-right: 0;\n    border: 2px solid #c1c1c1; } }\n\n.plans-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .plans-banner .plans-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .plans-banner .plans-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.btn-deactive {\n  background: linear-gradient(to left, #777777, #777777);\n  border: none;\n  color: #ffffff;\n  font-size: 18px;\n  padding: 8px 20px;\n  cursor: pointer;\n  white-space: nowrap;\n  line-height: 15px;\n  transition: background ease .5s;\n  display: inline-block;\n  border-radius: 3px;\n  box-shadow: inset 0px -1px 2px rgba(0, 0, 0, 0.5); }\n"

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
__webpack_require__(23);
var shared_1 = __webpack_require__(2);
var PlansService = (function () {
    function PlansService(api, cache, app) {
        this.api = api;
        this.cache = cache;
        this.app = app;
        this.code = '';
        // subscription: Subject<string>;
        // Variable being used as place holder untill we can check the billing interval through appContext
        this.monthlyAccount = true;
        // End - Variable being used as place holder untill we can check the billing interval through appContext
        this.propulsionShowFull = false;
        this.constructionShowFull = false;
        this.capacityShowFull = false;
        this.yearlyBilling = false;
        this.managementShowFull = false;
    }
    PlansService.prototype.expandManagement = function () {
        this.managementShowFull = !this.managementShowFull;
    };
    PlansService.prototype.expandCapacity = function () {
        this.capacityShowFull = !this.capacityShowFull;
    };
    PlansService.prototype.expandConstruction = function () {
        this.constructionShowFull = !this.constructionShowFull;
    };
    PlansService.prototype.expandPropulsion = function () {
        this.propulsionShowFull = !this.propulsionShowFull;
    };
    PlansService.prototype.getPlans = function () {
        var _this = this;
        var cache = this.cache.get('plans');
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetPlans(client); });
        var server = Observable_1.Observable.fromPromise(promise);
        this.plans = Observable_1.Observable.concat(cache, server);
        this.cache.updateCache('plans', this.plans);
        return this.plans;
    };
    PlansService.prototype.callGetPlans = function (apigClient) {
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {};
            var additionalParams = {
                // If there are any unmodeled query parameters or headers that must be 
                // sent with the request, add them here.
                headers: {
                    'Content-Type': 'application/json'
                },
                queryParams: {}
            };
            try {
                apigClient.billingPlansGet(params, '', additionalParams)
                    .then(function (result) {
                    var planArray = new Array();
                    for (var current = 0; current < result.data.data.length; current++) {
                        var plan = new shared_1.Plan(result.data.data[current]);
                        planArray.push(plan);
                    }
                    resolve(planArray);
                })
                    .catch(function (err) {
                    return reject(err);
                });
            }
            catch (ex) {
                return reject(ex);
            }
        });
    };
    PlansService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.CacheService, shared_1.AppContext])
    ], PlansService);
    return PlansService;
}());
exports.PlansService = PlansService;


/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = "<div class=\"plans-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"plans-banner-inner\">\r\n      <h2>Web Search</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <!--<div class=\"results-header\">\r\n      <h5><span class=\"hide\">Select </span>Billing<span class=\"hide\"> Period</span>:\r\n      <a (click)=\"monthly()\" [class.selected]=\"!service.yearlyBilling\" class=\"btn-no-fill\">Monthly</a>\r\n      <a (click)=\"yearly()\" [class.selected]=\"service.yearlyBilling\" class=\"btn-no-fill\">Yearly</a></h5>\r\n    </div>-->\r\n    <div class=\"col-holder plans-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"page-top-content\">\r\n          <h3 class=\"blue mb15 mt15\">Plans &amp; Pricing</h3>\r\n          <p>Choose any plan which suits your needs and budget. You may upgrade or downgrade any plan at any time. When upgrading plans you'll receive a partial-month refund. When downgrading plans you'll maintain your current plan until the end of the billing period, and begin the downgraded plan at the start of the next billing period.</p>\r\n        </div>\r\n    </div>\r\n      <div class=\"plans-content col-holder\">\r\n        <div class=\"upper-right-header\">\r\n          <!--<h1>Select the Perfect Plan for You</h1>-->\r\n          <h4 class=\"blue\">Choose a Plan</h4>\r\n          <h6 class=\"mt10 mb15\">Select Billing Period<br><a (click)=\"monthly()\" [class.selected]=\"!service.yearlyBilling\" class=\"btn-no-fill mt10 btn\">Monthly</a>\r\n          <a (click)=\"yearly()\" [class.selected]=\"service.yearlyBilling\" class=\"btn-no-fill btn\">Yearly</a></h6>\r\n        </div>\r\n        <div class=\"plans-header\">\r\n          <div class=\"col-holder\">\r\n            <div [class.current]=\"service.app.accountType === 'Basic'\" class=\"col1of4\">\r\n              <p><b>Basic</b></p>\r\n              <p class=\"small-text\">Registered</p>\r\n              <h1 *ngIf=\"!service.yearlyBilling\">FREE<span></span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">FREE<span></span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling\" class=\"small-text\">&nbsp;</p>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Basic')\" class=\"btn-blue\">Register Now</a>\r\n              <a *ngIf=\"service.app.accountType === 'Basic'\" [routerLink]=\"['../account/information']\" class=\"btn\">Current Plan</a>\r\n              <a *ngIf=\"service.app.accountType !== 'Basic' && service.app.accountType !== ''\" [routerLink]=\"['../account/information']\" class=\"btn-blue btn-gray\">Included</a>\r\n            </div>\r\n            <div [class.current]=\"service.app.accountType === 'Premium'\" class=\"col1of4\">\r\n              <p><b>Premium</b></p>\r\n              <p class=\"small-text\">Subscription</p>\r\n              <h1 *ngIf=\"!service.yearlyBilling\">$49<span>/mo</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">$488<span>/year</span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month' && service.app.accountType !== 'Professional'\" class=\"small-text\">Save $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">&nbsp;</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">&nbsp;</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Premium'\" class=\"small-text\">Saving $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Basic'\" class=\"small-text\">Save $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.accountType === ''\" class=\"small-text\">Save $100</p>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Premium')\" class=\"btn\">Try Now</a>\r\n              <a *ngIf=\"service.app.accountType === 'Basic'\" [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.app.accountType === 'Premium'\" [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month'\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n              <a *ngIf=\"service.app.accountType === 'Professional'\" [routerLink]=\"['../account/information']\" class=\"btn btn-gray\">Included</a>\r\n            </div>\r\n            <div [class.current]=\"service.app.accountType === 'Professional'\" class=\"col1of4\">\r\n              <p><b>Professional</b></p>\r\n              <p class=\"small-text\">Subscription</p>\r\n              <h1 *ngIf=\"!service.yearlyBilling\">$99<span>/mo</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">$988<span>/year</span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\" class=\"small-text\">Save $200</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType !== 'Professional'\" class=\"small-text\">Save $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">Saving $200</p>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Professional')\" class=\"btn\">Try Now</a>\r\n              <a *ngIf=\"service.app.accountType !== '' && service.app.accountType !== 'Professional'\"  [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.app.accountType === 'Professional'\"  [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month'\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n            </div>\r\n            <div [class.current]=\"service.app.accountType === 'Enterprise'\" class=\"col1of4\">\r\n              <p><b>Enterprise</b></p>\r\n              <p class=\"small-text\">Subscription</p>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">PER USER<span></span></h1>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Enterprise')\" class=\"btn\">Try Now</a>\r\n              <a *ngIf=\"service.app.accountType !== '' && service.app.accountType !== 'Enterprise'\"  [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.app.accountType === 'Enterprise'\"  [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month'\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"plans-section\">\r\n          <h5>MAIN FEATURES</h5>\r\n          <div class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Transhipments</p>\r\n              <p>Save Favorites</p>\r\n              <p>Download Results</p>\r\n              <p>Email Results</p>\r\n              <p>Data by Email (see below)</p>\r\n              <p>Multiple Users</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Transhipments<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Save Favorites<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Download Results<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Email Results<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Data by Email (see below)<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Multiple Users<br></span>1</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Transhipments<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Save Favorites<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Download Results<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Email Results<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Data by Email (see below)<br></span>3 Searches</p>\r\n              <p><span class=\"rep-header\">Multiple Users<br></span>2</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Transhipments<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Save Favorites<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Download Results<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Email Results<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Data by Email (see below)<br></span>10 Searches</p>\r\n              <p><span class=\"rep-header\">Multiple Users<br></span>10</p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!-- Commenting this out per copy deck - https://docs.google.com/document/d/1GTjO2Kx17G66I1x-9sXA5smhVi065ippj9wnelu1Rlc/edit#\r\n        <div class=\"plans-section local-contact-section\">\r\n          <h5>LOCAL CARRIER CONTACTS</h5>\r\n          <div class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Email, Phone, Fax, Website</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Email, Phone, Fax, Website<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Email, Phone, Fax, Website<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Email, Phone, Fax, Website<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      -->\r\n        <div class=\"plans-section\">\r\n          <h5>SCHEDULE DATA</h5>\r\n          <div class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Carrier Name &amp; SCAC</p>\r\n              <p>Vessel Name &amp; Voyage Number</p>\r\n              <p>Port Names &amp; UN Locode</p>\r\n              <p>ETD &amp; ETA Dates</p>\r\n              <p>Service Name &amp; Code</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name &amp; SCAC<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Vessel Name &amp; Voyage Number<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Port Names &amp; UN Locode<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">ETD &amp; ETA Dates<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Service Name &amp; Code<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name &amp; SCAC<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Vessel Name &amp; Voyage Number<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Port Names &amp; UN Locode<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">ETD &amp; ETA Dates<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Service Name &amp; Code<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name &amp; SCAC<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Vessel Name &amp; Voyage Number<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Port Names &amp; UN Locode<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">ETD &amp; ETA Dates<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Service Name &amp; Code<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"plans-section\">\r\n          <h5>CARRIER DATA</h5>\r\n          <div class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Carrier Profile</p>\r\n              <p>Fleet(Vessels &amp; TEU)</p>\r\n              <p>Company Address &amp; Website</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Address, Website, Parent<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Fleet (Ships, TEU, Trades)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Address, Website, Parent<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Fleet (Ships, TEU, Trades)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Carrier Name<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Address, Website, Parent<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Fleet (Ships, TEU, Trades)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"plans-section\">\r\n          <h5>VESSEL DATA</h5>\r\n          <div class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Vessel Name, IMO Number</p>\r\n              <p>Flag, Call Sign, MMSI</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Vessel Name, IMO Number<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Flag, Call Sign, MMSI<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Vessel Name, IMO Number<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Flag, Call Sign, MMSI<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Vessel Name, IMO Number<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Flag, Call Sign, MMSI<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div [class.open]=\"service.managementShowFull\" class=\"plans-section plans-section-expandable\">\r\n          <div *ngIf=\"!service.managementShowFull\" class=\"col-holder plans-section-closed-checks\">\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n          <h5 [class.open]=\"service.managementShowFull\" (click)=\"service.expandManagement()\" class=\"sub-header pointer\"><a [class.open]=\"service.managementShowFull\" class=\"expand-button\"><img src=\"../img/blackarrow-01.svg\" onerror=\"this.onerror=null; this.src='../img/blackarrow.png'\"></a>VESSEL MANAGEMENT</h5>\r\n          <div *ngIf=\"service.managementShowFull\" class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Owner, Operator</p>\r\n              <p>Previous Names</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Owner, Operator<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>  \r\n              <p><span class=\"rep-header\">Previous Names<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Owner, Operator<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>  \r\n              <p><span class=\"rep-header\">Previous Names<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Owner, Operator<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>  \r\n              <p><span class=\"rep-header\">Previous Names<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p> \r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"plans-sidebar plans-sidebar-2\">\r\n          <div class=\"plans-sidebar-section show499\">\r\n            <img src=\"../img/datafeed.svg\" onerror=\"this.onerror=null; this.src='../img/datafeed.png'\">\r\n            <h5>Data Feeds</h5>\r\n            <p class=\"small-text\">Integrate schedule data directly into your system.</p>\r\n            <p>Reduce Errors</p>\r\n            <p>Save time</p>\r\n            <p>Cut Costs</p>\r\n            <p class=\"small-text\">Choose either API or FTP delivery.</p>\r\n          </div>\r\n          <div class=\"plans-sidebar-section\">\r\n            <img class=\"small-image\" src=\"../img/api.svg\" onerror=\"this.onerror=null; this.src='../img/api.png'\">\r\n            <h6>Live Data by API</h6>\r\n            <p>Real Time Data</p>\r\n            <p>No Hosting</p>\r\n            <p>On Demand</p>\r\n          </div>\r\n          <div class=\"plans-sidebar-section hide499\">\r\n            <img src=\"../img/datafeed.svg\" onerror=\"this.onerror=null; this.src='../img/datafeed.png'\">\r\n            <h6>Data Feeds</h6>\r\n            <p class=\"small-text\">Integrate schedule data directly into your system.</p>\r\n            <p>Reduce Errors</p>\r\n            <p>Save time</p>\r\n            <p>Cut Costs</p>\r\n            <p class=\"small-text\">Choose either API or FTP delivery.</p>\r\n          </div>\r\n          <div class=\"plans-sidebar-section\">\r\n            <img class=\"small-image\" src=\"../img/ftp.svg\" onerror=\"this.onerror=null; this.src='../img/ftp.png'\">\r\n            <h6>Bulk Data by FTP</h6>\r\n            <p>Regular Updates</p>\r\n            <p>Hosted Locally</p>\r\n            <p>Tailor-Made</p>\r\n          </div>\r\n          <div class=\"mt10\">\r\n            <a class=\"btn\">Get a Quote</a>\r\n            <a [routerLink]=\"['/bulk-data-feeds', {scroll:true}]\" class=\"link\">Learn More</a>\r\n          </div>\r\n        </div>\r\n        <div [class.open]=\"service.capacityShowFull\" class=\"plans-section plans-section-expandable\">\r\n          <div *ngIf=\"!service.capacityShowFull\" class=\"col-holder plans-section-closed-checks\">\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n          <h5 [class.open]=\"service.capacityShowFull\" (click)=\"service.expandCapacity()\" class=\"sub-header pointer\"><a [class.open]=\"service.capacityShowFull\" class=\"expand-button\"><img src=\"../img/blackarrow-01.svg\" onerror=\"this.onerror=null; this.src='../img/blackarrow.png'\"></a>VESSEL CAPACITY</h5>\r\n          <div *ngIf=\"service.capacityShowFull\" class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Gross &amp; Net Tonnage</p>\r\n              <p>DWT (Dead Weight Tons)</p>\r\n              <p>Nominal TEU</p>\r\n              <p>14mt TEU &amp; Reefer TEU</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Gross &amp; Net Tonnage<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">DWT (Dead Weight Tons)<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Nominal TEU<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">14mt TEU &amp; Reefer TEU<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Gross &amp; Net Tonnage<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">DWT (Dead Weight Tons)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Nominal TEU<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">14mt TEU &amp; Reefer TEU<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Gross &amp; Net Tonnage<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">DWT (Dead Weight Tons)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Nominal TEU<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">14mt TEU &amp; Reefer TEU<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div [class.open]=\"service.constructionShowFull\" class=\"plans-section plans-section-expandable\">\r\n          <div *ngIf=\"!service.constructionShowFull\" class=\"col-holder plans-section-closed-checks\">\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n          <h5 [class.open]=\"service.constructionShowFull\" (click)=\"service.expandConstruction()\" class=\"sub-header pointer\"><a [class.open]=\"service.constructionShowFull\" class=\"expand-button\"><img src=\"../img/blackarrow-01.svg\" onerror=\"this.onerror=null; this.src='../img/blackarrow.png'\"></a>VESSEL CONSTRUCTION</h5>\r\n          <div *ngIf=\"service.constructionShowFull\" class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Ship Type, Year Built</p>\r\n              <p>Port Registry, Ship Builder</p>\r\n              <p>Yard, Hull, Handling Gear</p>\r\n              <p>Length, Beam, Draught</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Ship Type, Year Built<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Port Registry, Ship Builder<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Yard, Hull, Handling Gear<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Length, Beam, Draught<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Ship Type, Year Built<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Port Registry, Ship Builder<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Yard, Hull, Handling Gear<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Length, Beam, Draught<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Ship Type, Year Built<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Port Registry, Ship Builder<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Yard, Hull, Handling Gear<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Length, Beam, Draught<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div [class.open]=\"service.propulsionShowFull\" class=\"plans-section plans-section-expandable\">\r\n          <div *ngIf=\"!service.propulsionShowFull\" class=\"col-holder plans-section-closed-checks\">\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <p><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n          <h5 [class.open]=\"service.propulsionShowFull\" (click)=\"service.expandPropulsion()\" class=\"sub-header pointer\"><a [class.open]=\"service.propulsionShowFull\" class=\"expand-button\"><img src=\"../img/blackarrow-01.svg\" onerror=\"this.onerror=null; this.src='../img/blackarrow.png'\"></a>VESSEL PROPULSION</h5>\r\n          <div *ngIf=\"service.propulsionShowFull\" class=\"col-holder\">\r\n            <div class=\"plans-section-col-big\">\r\n              <p>Engine Design, Type</p>\r\n              <p>Power (KW), Speed(Kn)</p>\r\n              <p>Fuel Consumption</p>\r\n              <p>CO2 Emissions</p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-1\">\r\n                <p><b>Basic</b></p>\r\n                <p>FREE</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Engine Design, Type<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Power (KW), Speed(Kn)<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Fuel Consumption<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">CO2 Emissions<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-2\">\r\n                <p><b>Premium</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Engine Design, Type<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Power (KW), Speed(Kn)<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">Fuel Consumption<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n              <p><span class=\"rep-header\">CO2 Emissions<br></span><img class=\"dash-image\" src=\"../img/gray-dash.svg\" onerror=\"this.onerror=null; this.src='../img/gray-dash-01.png'\"><span class=\"image-span\">&nbsp;</span></p>\r\n            </div>\r\n            <div class=\"plans-section-col-small\">\r\n              <div class=\"rep-plan-header rep-plan-header-3\">\r\n                <p><b>Professional</b></p>\r\n                <p>Subscription</p>\r\n              </div>\r\n              <p><span class=\"rep-header\">Engine Design, Type<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Power (KW), Speed(Kn)<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">Fuel Consumption<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n              <p><span class=\"rep-header\">CO2 Emissions<br></span><img src=\"../img/greencheck.svg\" onerror=\"this.onerror=null; this.src='../img/greencheck.png'\"></p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"plans-header bottom\">\r\n           <div class=\"col-holder\">\r\n            <div [class.current]=\"service.app.accountType === 'Basic'\" class=\"col1of3\">\r\n              <p><b>Basic</b></p>\r\n              <p class=\"small-text\">Registered</p>\r\n              <h1 *ngIf=\"!service.yearlyBilling\">FREE<span></span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">FREE<span></span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling\" class=\"small-text\">&nbsp;</p>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Basic')\" class=\"btn-blue\">Register Now</a>\r\n              <a *ngIf=\"service.app.accountType === 'Basic'\" [routerLink]=\"['../account/information']\" class=\"btn\">Current Plan</a>\r\n              <a *ngIf=\"service.app.accountType !== 'Basic' && service.app.accountType !== ''\" [routerLink]=\"['../account/information']\" class=\"btn-blue btn-gray\">Included</a>\r\n            </div>\r\n            <div [class.current]=\"service.app.accountType === 'Premium'\" class=\"col1of3\">\r\n              <p><b>Premium</b></p>\r\n              <p class=\"small-text\">Subscription</p>\r\n              <h1 *ngIf=\"!service.yearlyBilling\">$49<span>/mo</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">$488<span>/year</span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month' && service.app.accountType !== 'Professional'\" class=\"small-text\">Save $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">&nbsp;</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">&nbsp;</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Premium'\" class=\"small-text\">Saving $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Basic'\" class=\"small-text\">Save $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.accountType === ''\" class=\"small-text\">Save $100</p>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Premium')\" class=\"btn\">Try Now</a>\r\n              <a *ngIf=\"service.app.accountType === 'Basic'\" [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.app.accountType === 'Premium'\" [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month'\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n              <a *ngIf=\"service.app.accountType === 'Professional'\" [routerLink]=\"['../account/information']\" class=\"btn btn-gray\">Included</a>\r\n            </div>\r\n            <div [class.current]=\"service.app.accountType === 'Professional'\" class=\"col1of3\">\r\n              <p><b>Professional</b></p>\r\n              <p class=\"small-text\">Subscription</p>\r\n              <h1 *ngIf=\"!service.yearlyBilling\">$99<span>/mo</span></h1>\r\n              <h1 style=\"font-size: 40px;\" *ngIf=\"service.yearlyBilling\">$988<span>/year</span></h1>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\" class=\"small-text\">Save $200</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType !== 'Professional'\" class=\"small-text\">Save $100</p>\r\n              <p style=\"margin-top: -10px;\" *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month' && service.app.accountType === 'Professional'\" class=\"small-text\">Saving $200</p>\r\n              <a *ngIf=\"service.app.accountType === ''\" (click)=\"openRegister('Professional')\" class=\"btn\">Try Now</a>\r\n              <a *ngIf=\"service.app.accountType !== '' && service.app.accountType !== 'Professional'\"  [routerLink]=\"['../account/information']\" class=\"btn\">Upgrade</a>\r\n              <a *ngIf=\"service.app.accountType === 'Professional'\"  [routerLink]=\"['../account/information']\" class=\"btn\">\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval === 'month'\">Save Now</span>\r\n                <span *ngIf=\"service.yearlyBilling && service.app.billingInterval !== 'month'\">Current Plan</span>\r\n                <span *ngIf=\"!service.yearlyBilling\">Current Plan</span>\r\n              </a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <h5 class=\"mt30 mb15 blue\">Payments</h5>\r\n        <p>We accept most major credit cards, including: Visa, MasterCard, American Express, Discover, Diners Club and JCB. Our payments are processed through our partner Stripe Checkout, and you will receive a full invoice for every order.</p>\r\n        \r\n        <h3 class=\"mt30 mb15 blue\">Data by Email</h3>\r\n        \r\n        <p>Data by Email is an easy to use “mini data feed” of sailing schedules designed for users who do not require vast amounts of data, or do not wish to implement a full-scale data feed integration. Data by Email is available for both Premium and Professional subscribers, and allows you to choose and receive data as CSV file delivered daily by email attachment.</p>\r\n\r\n        <p class=\"mt15\">Subscribers can choose from 3 types of formats:</p>\r\n\r\n        <ul>\r\n          <li>Schedules by origin and destination</li>\r\n          <li>Schedules by vessel name or IMO</li>\r\n          <li>Schedules by port arrivals or departures</li>\r\n        </ul>\r\n\r\n        <p>Data by Email will be sent as CSV files attachments to the email address you specify and on the day and time of your choosing. Premium subscribers may choose up to 3 data feeds, whereas Professional subscribers may choose up to 10 data feeds.</p>\r\n        <a class=\"btn mt30 mb30\" *ngIf=\"app.accountType === ''\" [routerLink]=\"['/register']\">REGISTER NOW</a> \r\n        <a class=\"btn mt30 mb30\" *ngIf=\"app.accountType !== '' && app.accountType !== 'Basic'\" [routerLink]=\"['/account/data-by-email']\">VIEW MY ACCOUNT</a> \r\n\r\n        <div class=\"full-width-screenshot\">\r\n          <img style=\"width: 100%;\" src=\"../img/linescape-directions-2.png\">\r\n        </div>\r\n        <div class=\"mobile-screenshot\">\r\n          <img style=\"width: 100%;\" src=\"../img/email-directions-step1-2.jpg\">\r\n          <img style=\"width: 100%;\" src=\"../img/email-directions-step2.jpg\">\r\n        </div>\r\n\r\n\r\n        <!--<a [routerLink]=\"['../data-feeds']\" class=\"mt15 btn-blue\">See Our Data Feeds</a>\r\n        <ul>\r\n          <li *ngFor=\"let plan of plans | async\">{{ plan.name }} at cost {{ plan.amount }}</li>\r\n        </ul>-->\r\n    </div>\r\n    <sticky sticky-offset-top=\"20\" sticky-offset-bottom=\"30\" sticky-zIndex=\"999\">\r\n      <div class=\"page-content-sidebar-right\">\r\n        <plans-side-bar [type]=\"upsell\">loading...</plans-side-bar>\r\n      </div>\r\n    </sticky>\r\n  </div>\r\n</div>"

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = ".plans-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"../../img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .plans-banner .plans-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .plans-banner .plans-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.blue {\n  color: #7f56db; }\n\n.results-header {\n  padding-left: 28%;\n  background: #282828;\n  height: 50px;\n  color: #ffffff; }\n  .results-header h5 {\n    line-height: 50px; }\n    .results-header h5 .btn-no-fill {\n      margin-left: 5px;\n      margin-right: 5px; }\n      .results-header h5 .btn-no-fill:hover {\n        background: #ffffff;\n        border-color: #ffffff;\n        color: #282828; }\n      .results-header h5 .btn-no-fill.selected {\n        background: #ffffff;\n        border-color: #ffffff;\n        color: #282828; }\n\n.plans-content-wrapper {\n  position: relative;\n  /*min-height: 457px;*/\n  min-height: 2000px;\n  background: #ffffff;\n  /*overflow-x: hidden*/ }\n\n.upper-right-header .btn-no-fill {\n  color: #7f56db;\n  border-color: #7f56db;\n  background: transparent;\n  transition: background ease .5s, color ease .5s; }\n  .upper-right-header .btn-no-fill:hover {\n    background: #7f56db;\n    border-color: #7f56db;\n    color: #ffffff; }\n  .upper-right-header .btn-no-fill.selected {\n    background: #7f56db;\n    border-color: #7f56db;\n    color: #ffffff; }\n\n.plans-sidebar {\n  border-radius: 3px;\n  padding: 20px;\n  margin-right: 60px;\n  margin-top: 20px;\n  vertical-align: top;\n  display: inline-block;\n  width: 172px;\n  background: #2798d8;\n  color: #ffffff;\n  text-align: center; }\n  .plans-sidebar .plans-sidebar-section {\n    border-bottom: 1px dashed #ffffff;\n    margin-bottom: 20px;\n    padding-bottom: 20px; }\n    .plans-sidebar .plans-sidebar-section.show499 {\n      display: none; }\n  .plans-sidebar img {\n    width: 50%; }\n  .plans-sidebar .small-image {\n    width: 40%;\n    height: 40%; }\n  .plans-sidebar h5 {\n    font-weight: 600; }\n  .plans-sidebar h6 {\n    font-weight: 600;\n    font-size: 17px;\n    margin-bottom: 5px; }\n  .plans-sidebar .small-text {\n    line-height: 20px;\n    font-size: 13px;\n    margin-bottom: 5px;\n    margin-top: 5px; }\n  .plans-sidebar p {\n    line-height: 20px;\n    font-size: 15px; }\n  .plans-sidebar .btn {\n    margin-top: 20px; }\n  .plans-sidebar .link {\n    color: #18569d;\n    cursor: pointer;\n    font-size: 15px; }\n\n.plans-sidebar-2 {\n  display: none; }\n\n.plans-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 20px 20px 60px;\n  width: calc(100% - 233px);\n  padding-bottom: 200px; }\n  .plans-content .upper-right-header {\n    width: 33%;\n    display: inline-block;\n    vertical-align: top; }\n    .plans-content .upper-right-header h1 {\n      font-weight: 300;\n      line-height: 54px;\n      margin-top: 10px; }\n  .plans-content .plans-header {\n    vertical-align: top;\n    display: inline-block;\n    text-align: center;\n    width: 67%;\n    margin-bottom: 40px; }\n    .plans-content .plans-header .col1of3,\n    .plans-content .plans-header .col1of4 {\n      width: calc(33% - 4px);\n      border: 1px solid #c1c1c1;\n      padding: 25px 5px;\n      margin-left: 2px;\n      margin-right: 2px;\n      border-radius: 3px; }\n      .plans-content .plans-header .col1of3 p,\n      .plans-content .plans-header .col1of4 p {\n        font-weight: 400; }\n      .plans-content .plans-header .col1of3 h1,\n      .plans-content .plans-header .col1of4 h1 {\n        font-weight: 300; }\n        .plans-content .plans-header .col1of3 h1 span,\n        .plans-content .plans-header .col1of4 h1 span {\n          font-size: 14px;\n          font-weight: 400; }\n      .plans-content .plans-header .col1of3 .btn-blue,\n      .plans-content .plans-header .col1of3 .btn,\n      .plans-content .plans-header .col1of4 .btn-blue,\n      .plans-content .plans-header .col1of4 .btn {\n        padding: 8px 10px;\n        width: calc(100% - 20px); }\n      .plans-content .plans-header .col1of3 .btn-gray,\n      .plans-content .plans-header .col1of4 .btn-gray {\n        background: #484848;\n        color: #686868; }\n      .plans-content .plans-header .col1of3.current,\n      .plans-content .plans-header .col1of4.current {\n        background: #2798d8; }\n        .plans-content .plans-header .col1of3.current p,\n        .plans-content .plans-header .col1of4.current p {\n          color: #ffffff; }\n        .plans-content .plans-header .col1of3.current h1,\n        .plans-content .plans-header .col1of4.current h1 {\n          color: #ffffff; }\n    .plans-content .plans-header .col1of3 {\n      width: calc(25% - 4px); }\n    .plans-content .plans-header.bottom {\n      margin-left: 33%; }\n  .plans-content .plans-section {\n    margin-bottom: 40px; }\n    .plans-content .plans-section h5 {\n      padding-left: 15px;\n      font-weight: bold;\n      line-height: 40px;\n      background: linear-gradient(to right, #851746, #2798d8);\n      color: white; }\n      .plans-content .plans-section h5.sub-header {\n        color: #353535;\n        background: none;\n        font-size: 20px;\n        border-bottom: 2px solid #c1c1c1;\n        position: relative;\n        top: -42px; }\n        .plans-content .plans-section h5.sub-header.open {\n          border-bottom: none;\n          position: initial;\n          top: 0; }\n    .plans-content .plans-section.plans-section-expandable {\n      margin-bottom: 0; }\n    .plans-content .plans-section.open {\n      margin-bottom: 40px; }\n    .plans-content .plans-section .plans-section-col-big {\n      vertical-align: top;\n      display: inline-block;\n      width: 33%;\n      border-top: 2px solid #c1c1c1; }\n      .plans-content .plans-section .plans-section-col-big p {\n        line-height: 40px;\n        padding-left: 15px; }\n    .plans-content .plans-section .plans-section-col-small {\n      text-align: center;\n      vertical-align: top;\n      display: inline-block;\n      width: 22.3%;\n      border-top: 2px solid #c1c1c1;\n      border-bottom: 2px solid #c1c1c1;\n      border-left: 2px solid #c1c1c1; }\n      .plans-content .plans-section .plans-section-col-small img {\n        height: 18px;\n        width: 25px; }\n      .plans-content .plans-section .plans-section-col-small .image-span {\n        height: 40px; }\n      .plans-content .plans-section .plans-section-col-small .dash-image {\n        display: none; }\n      .plans-content .plans-section .plans-section-col-small p {\n        line-height: 40px; }\n      .plans-content .plans-section .plans-section-col-small p:nth-of-type(even) {\n        background: #efefef; }\n      .plans-content .plans-section .plans-section-col-small:last-of-type {\n        border-right: 2px solid #c1c1c1; }\n    .plans-content .plans-section:first-of-type {\n      margin-top: -26px; }\n    .plans-content .plans-section .rep-header {\n      display: none;\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 20px;\n      color: #999999; }\n    .plans-content .plans-section .rep-plan-header {\n      display: none;\n      border-bottom: 2px solid #c1c1c1;\n      padding-top: 5px;\n      padding-bottom: 5px; }\n      .plans-content .plans-section .rep-plan-header p {\n        background: #ffffff !important;\n        line-height: 26px; }\n      .plans-content .plans-section .rep-plan-header p:nth-of-type(2) {\n        font-size: 16px; }\n    .plans-content .plans-section .expand-button {\n      display: inline-block;\n      transition: transform .3s ease-in-out;\n      margin-right: 8px; }\n      .plans-content .plans-section .expand-button.open {\n        transform: rotate(90deg); }\n      .plans-content .plans-section .expand-button img {\n        height: 18px;\n        margin-bottom: -1px; }\n  .plans-content .local-contact-section h5 {\n    padding-left: 15px;\n    font-weight: bold;\n    line-height: 40px;\n    background: #fff;\n    color: #353535;\n    font-size: 20px; }\n\n.header-col {\n  width: calc(100% + 40px);\n  margin-left: -20px;\n  background: #f0f0f0;\n  margin-bottom: 25px;\n  margin-top: 25px;\n  padding: 10px 30px; }\n  .header-col div {\n    vertical-align: top;\n    font-weight: bold;\n    font-size: 20px; }\n\n.plans-content .plans-section-closed-checks {\n  margin-left: 33.33%; }\n  .plans-content .plans-section-closed-checks .plans-section-col-small {\n    width: 33.33%;\n    border-bottom: none; }\n\n.page-content {\n  padding: 20px 60px;\n  width: 100%; }\n  .page-content .page-top-content {\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 0; }\n    .page-content .page-top-content h1 {\n      font-weight: 300;\n      line-height: 54px;\n      margin-top: 10px; }\n\n.mobile-screenshot {\n  display: none; }\n\n.full-width-screenshot {\n  max-width: 950px;\n  margin: auto; }\n\n@media screen and (min-width: 767px) and (max-height: 800px) {\n  .remove800h {\n    display: none; }\n  .plans-sidebar .plans-sidebar-section {\n    margin-bottom: 10px;\n    padding-bottom: 10px; } }\n\n@media only screen and (max-width: 1200px) {\n  .plans-content .plans-header .col1of3 .btn-blue,\n  .plans-content .plans-header .col1of3 .btn {\n    font-size: 16px; }\n  .plans-content .plans-section .plans-section-col-big p {\n    font-size: 16px; } }\n\n@media only screen and (max-width: 1100px) {\n  .plans-content .plans-header .col1of3 .btn-blue,\n  .plans-content .plans-header .col1of3 .btn {\n    font-size: 15px; }\n  .plans-content .plans-section h5 {\n    padding-left: 5px; }\n    .plans-content .plans-section h5.sub-header {\n      top: 0; }\n  .plans-content .plans-section .plans-section-col-big p {\n    font-size: 15px;\n    padding-left: 5px; }\n  .plans-content .plans-section.plans-section-expandable {\n    margin-bottom: 40px; }\n  .plans-content .plans-section-closed-checks {\n    display: none; } }\n\n@media only screen and (max-width: 1023px) {\n  .plans-content .plans-header .col1of3 .btn-blue,\n  .plans-content .plans-header .col1of3 .btn {\n    font-size: 14px; }\n  .plans-content .plans-section .plans-section-col-big p {\n    font-size: 14px; } }\n\n@media only screen and (max-width: 980px) {\n  .plans-content .upper-right-header {\n    width: 100%; }\n    .plans-content .upper-right-header h1 {\n      margin-bottom: 20px; }\n  .plans-content .page-content .page-top-content h1 {\n    margin-bottom: 20px; }\n  .plans-content .plans-header {\n    width: 100%;\n    margin-left: 0; }\n    .plans-content .plans-header.bottom {\n      margin-left: 0; }\n  .plans-content .plans-section {\n    margin-top: 20px; }\n    .plans-content .plans-section:first-of-type {\n      margin-top: 20px; }\n    .plans-content .plans-section .rep-header {\n      display: block; }\n    .plans-content .plans-section .plans-section-col-big {\n      display: none; }\n    .plans-content .plans-section .plans-section-col-small {\n      width: 33.3%; }\n      .plans-content .plans-section .plans-section-col-small p {\n        padding-top: 5px;\n        padding-bottom: 5px; }\n      .plans-content .plans-section .plans-section-col-small .rep-plan-header p {\n        padding-top: 0;\n        padding-bottom: 0; }\n      .plans-content .plans-section .plans-section-col-small .image-span {\n        display: none; }\n      .plans-content .plans-section .plans-section-col-small .dash-image {\n        display: inline; }\n  .results-header {\n    padding-left: 0;\n    text-align: center; } }\n\n@media only screen and (max-width: 860px) {\n  .full-width-screenshot {\n    display: none; }\n  .mobile-screenshot {\n    display: block; } }\n\n@media only screen and (max-width: 767px) {\n  .page-content {\n    padding-right: 20px; }\n  .plans-sidebar-1 {\n    display: none; }\n  .plans-sidebar-2 {\n    display: block; }\n  .plans-sidebar {\n    width: 100%;\n    font-size: 0;\n    padding: 30px 20px; }\n    .plans-sidebar .plans-sidebar-section {\n      padding-left: 10px;\n      padding-right: 10px;\n      width: calc(33% - 1px);\n      display: inline-block;\n      vertical-align: top;\n      border-bottom: 0; }\n      .plans-sidebar .plans-sidebar-section:nth-of-type(3) {\n        width: calc(33% + 2px);\n        border-left: 1px dashed #ffffff;\n        border-right: 1px dashed #ffffff; }\n    .plans-sidebar .btn {\n      display: block; }\n    .plans-sidebar img {\n      height: 60px; }\n  .plans-content {\n    width: 100%; }\n    .plans-content .plans-header .col1of4 {\n      width: calc(50% - 20px);\n      max-width: 220px;\n      margin-bottom: 20px;\n      margin-left: 10px;\n      margin-right: 10px; }\n    .plans-content .plans-section h5 {\n      margin-bottom: 20px; }\n    .plans-content .plans-section .col-holder {\n      text-align: center; }\n    .plans-content .plans-section .plans-section-col-small {\n      width: calc(50% - 20px);\n      max-width: calc(50% - 20px);\n      margin-bottom: 20px;\n      margin-left: 10px;\n      margin-right: 10px;\n      border: 2px solid #c1c1c1; }\n      .plans-content .plans-section .plans-section-col-small .rep-plan-header {\n        display: block; }\n  .plans-content .plans-section h5.sub-header.open {\n    border-bottom: 2px solid #c1c1c1; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 20px; }\n  .plans-banner .plans-banner-inner {\n    padding: 15px 15px 15px 15px; }\n  .plans-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .header-col {\n    display: none; }\n  .plans-sidebar {\n    width: 100%;\n    font-size: 0;\n    padding: 15px 5px; }\n    .plans-sidebar .btn {\n      width: 200px;\n      margin: auto; } }\n\n@media only screen and (max-width: 499px) {\n  .plans-sidebar {\n    width: 100%;\n    font-size: 0;\n    padding: 15px; }\n    .plans-sidebar .plans-sidebar-section {\n      width: 100%;\n      display: inline-block;\n      vertical-align: top;\n      border-bottom: 0;\n      border-bottom: 1px dashed #ffffff; }\n      .plans-sidebar .plans-sidebar-section:nth-of-type(3) {\n        width: 100%;\n        border-left: none;\n        border-right: none; }\n      .plans-sidebar .plans-sidebar-section.show499 {\n        display: block; }\n      .plans-sidebar .plans-sidebar-section.hide499 {\n        display: none; }\n    .plans-sidebar .btn {\n      display: block; }\n    .plans-sidebar img {\n      height: 60px; }\n  .plans-content .plans-header .col1of3 {\n    width: 100%;\n    max-width: 220px;\n    margin-bottom: 20px;\n    margin-left: 10px;\n    margin-right: 10px; }\n  .plans-content .plans-section .col-holder {\n    text-align: center; }\n  .plans-content .plans-section .plans-section-col-small {\n    width: 100%;\n    max-width: calc(100% - 20px);\n    margin-bottom: 20px;\n    margin-left: 10px;\n    margin-right: 10px;\n    border: 2px solid #c1c1c1; }\n  .results-header .hide {\n    display: none; } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; }\n  .results-header h5 {\n    font-size: 20px; }\n    .results-header h5 .btn-no-fill {\n      padding: 8px 16px; }\n  .plans-content .plans-section .plans-section-col-small {\n    width: 100%;\n    max-width: 100%;\n    margin-bottom: 20px;\n    margin-left: 0;\n    margin-right: 0;\n    border: 2px solid #c1c1c1; } }\n"

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(596));


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var AboutComponent = (function () {
    function AboutComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'About Us - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';
        this.modal = { isVisible: false, title: '', body: '' };
        // Do stuff
    }
    AboutComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    AboutComponent.prototype.openDavidModal = function () {
        this.modal.title = "David Tarizzo";
        this.modal.body = "David Tarizzo is co-Founder, and President and CEO of Linescape. David\u2019s extensive business development expertise and proven track record of turning opportunities and ideas into successful global business endeavors led to the inception of Linescape. Prior to co-founding Linescape, David held leadership positions in organizations across Europe and the USA. David also founded an international business that focused on shipping containers for specialty chemical products. David has a degree in chemistry from the University of Illinois and an MBA from the University of Michigan. David has lived in France and England, and currently resides near Chicago, Illinois. In his free time David likes to bike, sail, ski and play tennis.";
        this.modal.isVisible = true;
    };
    AboutComponent.prototype.openDimitriosModal = function () {
        this.modal.title = "Dimitrios Sogas";
        this.modal.body = "Dimitrios Sogas is co-Founder of Linescape and serves as the company\u2019s Vice President and Managing Director. With more than 25 years of executive-level experience in the aerospace and commercial semiconductor industries, Dimitrios\u2019 technological expertise combined with his keen business acumen shaped the architecture and design of Linescape\u2019s unique platform. His big picture outlook and strategic approach to business solutions have been utilized by high-profile organizations around the world, and now at Linescape. Dimitrios holds a degree in electrical engineering from the University of Missouri and an MBA from Santa Clara University. Dimitrios lives in sunny Burlingame, California and enjoys skiing, cycling, cooking, travelling, and collecting and tasting good wine.";
        this.modal.isVisible = true;
    };
    AboutComponent.prototype.closeModal = function () {
        this.modal.isVisible = false;
    };
    AboutComponent = __decorate([
        core_1.Component({
            selector: 'what-we-do',
            template: __webpack_require__(597),
            styles: [__webpack_require__(598)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], AboutComponent);
    return AboutComponent;
}());
exports.AboutComponent = AboutComponent;


/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Who We Are</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-full\">\r\n            <div id=\"who-we-are\">\r\n              <p>Founded in 2008 by industry experts, David Tarizzo and Dimitrios Sogas, Linescape is the only\r\n                independent online solution that presents a comprehensive and impartial overview of the routes and\r\n                schedules of all the world's containership lines, thus giving shippers and forwarders the freedom and\r\n                ease to choose the carrier and vessel best suited to any particular shipment.</p>\r\n\r\n              <p>We believe that the process of finding a carrier should be a simple one. Our aim is to help achieve\r\n                this by presenting routing and scheduling information in a clear and easy to understand format.</p>\r\n\r\n              <div class=\"quote\">\r\n                <p>“Linescape was founded on the premise that there had to be a more efficient way to plan\r\n                  transportation of cargo. As the backbone of data for the logistics industry, we saw an opportunity to\r\n                  help move the industry toward an automated model and reduce the ocean of paperwork and manual tasks.\r\n                  Our focus is and continues to be on providing a reliable and flexible resource for our customers.”</p>\r\n                <p class=\"quote-by\">-- David Tarizzo & Dimitrios Sogas<br>Linescape Founders</p>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!--<div class=\"page-content-sidebar-right\">\r\n            <div class=\"sidebar-section\">\r\n              <h6>Data Feeds?</h6>\r\n              <p>If you are interested in Data Feeds of container sailing schedules, vessel register details, carrier profiles and local contacts information, please contact us at Linescape Marketing.</p>\r\n            </div>\r\n            <div class=\"sidebar-section\">\r\n              <h6>Attention VOCC Carriers!</h6>\r\n              <p>Linescape is pleased to host schedules for all vessel-operating container lines:</p>\r\n              <ul>\r\n                <li>Ocean Carriers</li>\r\n                <li>Short Sea Operators</li>\r\n                <li>Feeder Lines</li>\r\n              </ul>\r\n              <p>Let us know...</p>\r\n              <p>If your schedules are not displayed or not properly displayed, please tell us by contacting <a>Linescape Marketing.</a></p>\r\n            </div>\r\n            <div class=\"sidebar-section\">\r\n              <h6>Browsers</h6>\r\n              <p>Linescape is best viewed using browsers Firefox 3.5 or Internet Explorer 8.0 or Chrome 5.0, and we provide limited support for Firefox 3.0, Internet Explorer 7.0, Chrome 4.x, Safari 3.x and Opera 9.x, but previous browsers are no longer supported.</p>\r\n            </div>\r\n          </div>-->\r\n        </div>\r\n        <div id=\"team\" class=\"team-section\">\r\n          <h3 class=\"mt0\">The Team</h3>\r\n          <p>Headquartered in Burlingame, California, Linescape is a young startup that embraces flexible working and\r\n            personal development. Our culture is driven by respect, transparency, collaboration, open discussion and\r\n            direct feedback. If you would like to explore opportunities with Linescape, feel free to <a\r\n              [routerLink]=\"['/contact']\">contact us</a>.</p><br>\r\n\r\n\r\n          <div class=\"pure-g\">\r\n            <div class=\"pure-u-1-2\" (click)=\"openDavidModal()\">\r\n              <div class=\"team-member founder\" data-toggle=\"modal\" data-target=\"#DavidModal\">\r\n                <img src=\"../../img/bio_dtarizzo.jpg\">\r\n                <div class=\"team-text bio\">\r\n                  <h5>David Tarizzo</h5>\r\n                  <p><i>Founder, President</i></p>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"pure-u-1-2\" (click)=\"openDimitriosModal()\">\r\n              <div class=\"team-member founder\">\r\n                <img src=\"../../img/bio_dimitri.jpg\">\r\n                <div class=\"team-text bio\">\r\n                  <h5>Dimitrios Sogas</h5>\r\n                  <p><i>Founder, VP Sales</i></p>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- The Modal -->\r\n          <div *ngIf=\"modal.isVisible\" id=\"myModal\" class=\"modal\" (click)=\"closeModal()\">\r\n\r\n            <!-- Modal content -->\r\n            <div class=\"modal-content\">\r\n              <span class=\"close\" (click)=\"closeModal()\">&times;</span>\r\n              <h5>{{modal.title}}</h5>\r\n              <p>{{modal.body}}</p>\r\n            </div>\r\n\r\n          </div>\r\n\r\n          <div class=\"pure-g\">\r\n            <div class=\"pure-u-1-4\">\r\n              <div class=\"team-member\">\r\n                <img src=\"../../img/bio_mporter.jpg\">\r\n                <div class=\"team-text\">\r\n                  <h5>Michael Porter</h5>\r\n                  <p><i>Senior Developer</i></p>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"pure-u-1-4\">\r\n              <div class=\"team-member\">\r\n                <img src=\"../../img/bio_cristen-full.jpg\">\r\n                <div class=\"team-text\">\r\n                  <h5>Cristen Bolan</h5>\r\n                  <p><i>Marketing, Social Media</i></p>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"pure-u-1-4\">\r\n              <div class=\"team-member\">\r\n                <img src=\"../../img/bio_tpersino.jpg\">\r\n                <div class=\"team-text\">\r\n                  <h5>Terri Persino</h5>\r\n                  <p><i>Customer Success</i></p>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"pure-u-1-4\">\r\n              <div class=\"team-member\">\r\n                <img src=\"../../img/bio_jfuller.png\">\r\n                <div class=\"team-text\">\r\n                  <h5>Jessica Fuller</h5>\r\n                  <p><i>Data Quality</i></p>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n      <div class=\"get-started\">\r\n        <div>\r\n          <h2>Get Started Today</h2>\r\n          <h6>Contact us or create a Linescape account.</h6>\r\n        </div>\r\n        <div class=\"buttons-container\">\r\n          <a class=\"btn btn-lg\" [routerLink]=\"['/register', { scroll: true }]\">CREATE ACCOUNT</a>\r\n          <a class=\"btn-outline btn-lg\" [routerLink]=\"['/contact', { scroll: true }]\">\r\n            <div class=\"text-container\">CONTACT US</div>\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = ".d-table {\n  display: table; }\n\n.d-table-cell {\n  display: table-cell; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 457px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 50px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-full {\n    vertical-align: top; }\n    .page-content .page-content-full p, .page-content .page-content-full li, .page-content .page-content-full div, .page-content .page-content-full label {\n      font-size: 18px;\n      line-height: 32px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n.team-section {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n  .team-section .pure-g .founder {\n    cursor: pointer;\n    width: 96%;\n    overflow: hidden; }\n  .team-section .pure-g .pure-u-1-2 .team-text, .team-section .pure-g .pure-u-1-4 .team-text {\n    padding: 0 10px 10px 10px; }\n  .team-section .pure-g .pure-u-1-2 h1, .team-section .pure-g .pure-u-1-2 h2, .team-section .pure-g .pure-u-1-2 h3, .team-section .pure-g .pure-u-1-2 h4, .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-2 h6, .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-2 label, .team-section .pure-g .pure-u-1-2 li, .team-section .pure-g .pure-u-1-4 h1, .team-section .pure-g .pure-u-1-4 h2, .team-section .pure-g .pure-u-1-4 h3, .team-section .pure-g .pure-u-1-4 h4, .team-section .pure-g .pure-u-1-4 h5, .team-section .pure-g .pure-u-1-4 h6, .team-section .pure-g .pure-u-1-4 p, .team-section .pure-g .pure-u-1-4 label, .team-section .pure-g .pure-u-1-4 li {\n    color: #ffffff; }\n  .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-4 h5 {\n    font-weight: bold;\n    line-height: 32px;\n    color: #ffffff;\n    font-size: 20px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0; }\n  .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-4 p {\n    line-height: 20px;\n    margin-bottom: 5px; }\n  .team-section .pure-g .pure-u-1-2 img, .team-section .pure-g .pure-u-1-4 img {\n    max-width: 100%;\n    width: 100%;\n    transition: all 0.3s;\n    transform: scale(1); }\n  .team-section .pure-g .pure-u-1-2 .founder img:hover, .team-section .pure-g .pure-u-1-4 .founder img:hover {\n    transform: scale(1.1);\n    padding-bottom: 15px; }\n  .team-section .pure-g .team-text.bio h5:hover {\n    color: #fc7d17;\n    cursor: pointer; }\n  .team-section .team-member {\n    margin: 10px;\n    background-color: #393939; }\n\n.page-content .quote {\n  padding-top: 20px;\n  font-size: 16px;\n  color: #7a7a7a;\n  width: 80%;\n  margin: 0 auto;\n  font-style: italic; }\n\n.page-content .quote-by {\n  font-size: 16px;\n  text-align: right;\n  color: #7a7a7a; }\n\n.upcoming-events {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n  .upcoming-events ul li {\n    list-style-type: none;\n    margin-left: 0; }\n\n/*** MODAL CSS ***/\n.modal {\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: black;\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */ }\n\n/* Modal Content/Box */\n.modal-content {\n  background-color: #fefefe;\n  margin: 15% auto;\n  /* 15% from the top and centered */\n  padding: 50px;\n  border: 1px solid #888;\n  width: 80%;\n  /* Could be more or less, depending on screen size */ }\n\n/* The Close Button */\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold; }\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer; }\n\n.get-started {\n  padding: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  border-top: 1px solid #e9e9e9; }\n  .get-started h2 {\n    color: #247cbd; }\n  .get-started h6 {\n    color: #666; }\n  .get-started .buttons-container {\n    margin-top: 17px; }\n    .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 479px) {\n  .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n\n@media only screen and (max-width: 1023px) {\n  .pure-u-1-4, .pure-u-6-24 {\n    width: 50%; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; }\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(50% - 20px); }\n  .team-section .col-holder.full-width-team {\n    display: none; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; }\n  .pure-u-1-2, .pure-u-1-4 {\n    width: 100%; } }\n\n@media only screen and (max-width: 599px) {\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(100% - 20px); } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(600));


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var ContactComponent = (function () {
    function ContactComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'Contact Us - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessels or carrier.';
    }
    ContactComponent.prototype.ngOnInit = function () {
        this.seo.set(this.title, this.description);
    };
    ContactComponent.prototype.ngAfterViewInit = function () {
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    ContactComponent = __decorate([
        core_1.Component({
            selector: 'contact',
            template: __webpack_require__(601),
            styles: [__webpack_require__(602), __webpack_require__(16)],
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], ContactComponent);
    return ContactComponent;
}());
exports.ContactComponent = ContactComponent;


/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Contact</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"page-top-content\">\r\n          <p>Feel free to contact us with your general enquiries or feedback about this website by using the following form. We strive to respond as quickly as possible to legitimate requests.</p>\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <contact-form [type]=\"Contact\"></contact-form>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <div class=\"sidebar-section\">\r\n              <h6>Contact us on Social Media</h6>\r\n              <div class=\"social-links\">\r\n                  <ul>\r\n                      <li><a href=\"http://www.facebook.com/pages/Linescape/127633963941865\"><img src=\"../img/facebook-logotype-button.png\"></a></li>\r\n                      <li><a href=\"http://www.linkedin.com/company/linescape\"><img src=\"../img/linkedin-logotype-button.png\"></a></li>\r\n                      <li><a href=\"http://twitter.com/Linescape\"><img src=\"../img/twitter-logo.png\"></a></li>\r\n                  </ul>\r\n              </div>\r\n              <h6>Your Opinions are Important</h6>\r\n              <p>Starting with the contact form, all of our communication is handled by email, rather than by telephone. We have found that this allows us to better serve our users in a quick and efficient manner.</p>\r\n              <p>Alternatively, you may write to us at the following address.</p>\r\n              <p>Linescape<br>1290 Howard Ave., Suite 323<br>Burlingame, CA 94010<br>U.S.A.</p>\r\n            </div>\r\n          </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n</div>\r\n"

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = ".error {\n  padding-left: 0;\n  margin-top: -5px; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 200px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n.social-links ul {\n  list-style-type: none;\n  font-size: 0; }\n  .social-links ul li {\n    display: inline-block;\n    margin-left: 5px; }\n\n.sending-loader .ellipse-1 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseOne 2s linear infinite;\n  -webkit-animation: ellipseOne 2s linear infinite; }\n\n.sending-loader .ellipse-2 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseTwo 2s linear infinite;\n  -webkit-animation: ellipseTwo 2s linear infinite; }\n\n.sending-loader .ellipse-3 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseThree 2s linear infinite;\n  -webkit-animation: ellipseThree 2s linear infinite; }\n\n@keyframes ellipseOne {\n  0% {\n    opacity: 0; }\n  24% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseTwo {\n  0% {\n    opacity: 0; }\n  49% {\n    opacity: 0; }\n  50% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseThree {\n  0% {\n    opacity: 0; }\n  74% {\n    opacity: 0; }\n  75% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%;\n    border-top: 1px solid #e3e3e3;\n    margin-top: 25px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n    .page-content .page-top-content {\n      padding-top: 0; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(604));


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var PrivacyPolicyComponent = (function () {
    function PrivacyPolicyComponent(route, seo, app) {
        this.route = route;
        this.seo = seo;
        this.app = app;
        this.title = 'Linescape Privacy Policy';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessels or carrier.';
        // Do stuff
    }
    PrivacyPolicyComponent.prototype.ngOnInit = function () {
        this.seo.set(this.title, this.description);
    };
    PrivacyPolicyComponent.prototype.loginToggle = function () {
        this.app.toggleLogin();
    };
    PrivacyPolicyComponent.prototype.ngAfterViewInit = function () {
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    PrivacyPolicyComponent = __decorate([
        core_1.Component({
            selector: 'privacy-policy',
            template: __webpack_require__(605),
            styles: [__webpack_require__(606), __webpack_require__(16)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService, shared_1.AppContext])
    ], PrivacyPolicyComponent);
    return PrivacyPolicyComponent;
}());
exports.PrivacyPolicyComponent = PrivacyPolicyComponent;


/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Privacy Policy</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n\r\n        <div class=\"page-top-content\">\r\n          <p>Linescape is a search engine that saves you time and money. We search the industry for the routes and schedules; you find what you.re looking for and then you go directly to a forwarder or carrier to make your booking. So, this means we do not take your credit card information and we do not take your money. Registration on Linescape is strictly voluntary, and this allows you to get more information and access to certain great features if you register.</p>\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6>Personal Information</h6>\r\n            <p>Linescape collects personally identifiable information that you provide to us, including. (at your discretion) your name, an email address, and a password. Our software uses your information to personalize and manage the Linescape website for you. For example, our site stores your favorite schedules, carriers and forwarders. If you decide to give us this information, you are telling us that this information is both true and accurate. You are also are telling us that you have the authorization to provide us with that information.</p>\r\n            <h6>Non-Personal Information</h6>\r\n            <p>In order to make our site more efficient, we may also collect certain non-personal information (such as destination or site usage behavior) based on your use of Linescape. We may use this information to display advertising that may be relevant to your business and suppress advertising that may not interest you. For example, we might show you offers from your port of departure or destination, but not those from other ports.</p>\r\n            <h6>Technical Information</h6>\r\n            <p>To help us to refine occasionally our software, we may collect some technical information from your browser software (such as Firefox or Internet Explorer), screen resolution and the website that referred you to us.</p>\r\n            <h6>Registration</h6>\r\n            <p>When you choose to register with us, Linescape logs you in automatically using your email address. This makes it easier for you as you don't have to create and remember a login identifier. The use of your email address for login also allows Linescape the chance to email you a new password in case you forget or lost your old one. This happens quite often, particularly to those who are incredibly busy. If you register with us, Linescape will save your information and recognise you regardless of from where you login. So if you are travelling or in another office and using another computer, we'll know it's you and display your searches and preferences when you login.</p>\r\n            <h6>Mail</h6>\r\n            <p>Linescape gives you the option of receiving emails from us. We think they are useful, but you may not and can opt out any time. Our emails are sent from a Linescape address and are sent to your real email address. Every email that we send has an opt-out URL, so you can be unsubscribed when you want. We dislike spam at Linescape and expect that you do too.</p>\r\n            <h6>Who knows?</h6>\r\n            <p>All of the information that you chose to share with us stays with us. We do not sell your information to anyone. The only exception might be if Linescape itself were to be sold. In such a case, the buyers would acquire your information so that they can continue to provide the same great Linescape service.</p>\r\n            <p>Linescape will occasionally share aggregated usage information with others. This type of information does not contain your identity or anything personally identifiable to you.</p>\r\n            <p>Linescape may disclose to authorized law enforcement personnel the personal data from anyone who poses a threat to our interests, or otherwise make such disclosures that Linescape is required to (or where Linescape believes it should do so) by law. This might include those that are attempting to commit fraud or those who conduct activities that could bring harm to others.</p>\r\n            <h6>Safe and Secure</h6>\r\n            <p>All users of Linescape have control over the use of their personal data. You can always change your account settings in the \"My Profile\" page on Linescape.</p>\r\n            <p>Linescape has a sophisticated security program intended to keep the information stored in our systems protected from unauthorized access. We store your information in secure data centers located in the United States. Our systems are configured with data encryption, or scrambling technologies and firewalls constructed to the highest industry standards. We also use Secure Socket Layer (SSL) technology that protects the data you send over the Internet. Third party security firms review our internal security policies and documentation regularly.</p>\r\n            <h6>Cookies</h6>\r\n            <p>When you visit Linescape we may store information about your web session and assign you one or more 'cookies'. Your browser will store these cookies on you computer in a small text file. For example, when you decide to login as a Linescape member, we store encrypted information in your browser so you don't have to login on every page.</p>\r\n            <p>Permanent cookie files remain on your computer's hard drive until you delete them manually using your browser or operating system software. You can enable your browser to refuse cookies, but doing so may disable access to some services and tools that we offer.</p>\r\n            <p>Linescape does make money by selling advertising as well as referrals from searches on our site. Our third party advertising partners often use a cookie or third party web beacon (a single pixel GIF image) to track when a click becomes a sale, but no personally identifiable information is ever sent to these advertising partners.</p>\r\n            <h6>Third Parties</h6>\r\n            <p>We use Stripe as our payment processor. By registering and submitting your payment information, you acknowledge that your payment information will be transferred to Stripe for processing in accordance with their <a href=\"https://stripe.com/us/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://stripe.com/us/terms\" target=\"_blank\">Terms</a></p>\r\n            <p>We use MailChimp as our marketing automation platform. By opting into our mailing list, you acknowledge that the information you provide will be transferred to MailChimp for processing in accordance with their <a href=\"https://mailchimp.com/legal/privacy\" target=\"_blank\">Privacy Policy</a> and <a href=\"https://mailchimp.com/legal/terms\" target=\"_blank\">Terms</a></p>\r\n            <p>We use third-party advertising companies to serve ads when you visit our web site. These companies may use general information (not including your name, address, email address or telephone number) about your visits to this and other web sites in order to provide advertisements about goods and services which may be of interest to you.</p>\r\n            <p>Although we work with responsible third parties, their business policies may include different privacy policies and practices than we have. So when you click through to third party websites, our privacy policies no longer apply. We encourage you to read the privacy policies of these partner websites.</p>\r\n            <p>Linescape does not knowingly collect personally identifiable information from people under the age of 18. If we become aware of the fact that a minor is attempting to submit this information, we will inform the minor that he or she is ineligible to do so. We will then remove this information from our records.</p>\r\n            <p>Linescape reserves the right to modify this privacy statement at any time. If there are material changes to this statement on how Linescape will use your information, we will prominently post these changes prior to implementing them. If you use our website after we post these changes, this indicates your acceptance of them. Regardless of later updates, we will follow the privacy practices described in this privacy statement at the time you provided us with your information. If you have questions about our privacy policies, please send feedback.</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <div class=\"sidebar-section\">\r\n              <h6>What is linescape ?</h6>\r\n              <p>Linescape is a free online comparison website which helps forwarders and shippers to quickly and easily find routes or schedules from many vessel-operating container lines, all at once.</p>\r\n              <p>Users now have everything they need at their fingertips to research and plan the best geographic routes and to select the best sailing schedules for shipping goods anywhere by ocean container.</p>\r\n              <a [routerLink]=\"['/register']\" class=\"btn mt15 mb15\">Register</a>\r\n              <p>or if you are an existing member <a (click)=\"loginToggle()\">Login</a></p>\r\n            </div>\r\n          </div>\r\n      </div>\r\n\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n</div>\r\n"

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = ".page-content-wrapper {\n  position: relative;\n  min-height: 457px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 200px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%;\n    border-top: 1px solid #e3e3e3;\n    margin-top: 25px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n    .page-content .page-top-content {\n      padding-top: 0; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(608));


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var TermsOfUseComponent = (function () {
    function TermsOfUseComponent(app, route, seo) {
        this.app = app;
        this.route = route;
        this.seo = seo;
        this.title = 'Terms of Use - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessels or carrier.';
        // Do stuff
    }
    TermsOfUseComponent.prototype.ngOnInit = function () {
        this.seo.set(this.title, this.description);
    };
    TermsOfUseComponent.prototype.loginToggle = function () {
        this.app.toggleLogin();
    };
    TermsOfUseComponent.prototype.ngAfterViewInit = function () {
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    TermsOfUseComponent = __decorate([
        core_1.Component({
            selector: 'terms-of-use',
            template: __webpack_require__(609),
            styles: [__webpack_require__(610), __webpack_require__(16)],
        }),
        __metadata("design:paramtypes", [shared_1.AppContext, router_1.ActivatedRoute, shared_1.SeoService])
    ], TermsOfUseComponent);
    return TermsOfUseComponent;
}());
exports.TermsOfUseComponent = TermsOfUseComponent;


/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Terms, Conditions & Notices</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n\r\n        <div class=\"page-top-content\">\r\n          <h5 class=\"mt0\">Agreement between our Users and Linescape</h5>\r\n          <p>Welcome to the Linescape website (the \"Website\"). This Website is provided solely to assist users in gathering shipping information, determining the availability of shipping-related services, and using this information to request quotations or make bookings with legitimate shipping suppliers, and for no other purposes. The terms \"we\", \"us\", \"our\" and \"Linescape\" refer to Linescape. The term \"you\" refers to the user visiting the Website and/or gathering information from our Website.</p>\r\n          <p>This Website is offered to you conditioned upon your acceptance without modification of all the terms, conditions, and notices set forth below (collectively, the \"Agreement\"). By accessing or using this Website in any manner, you agree to be bound by the Agreement. Please read the Agreement carefully. If you do not accept all of these terms and conditions, please do not use this Website. Be sure to return to this page periodically to review the most current version of the Agreement. We reserve the right at any time, at our sole discretion, to change or otherwise modify the Agreement without prior notice, and your continued access or use of this Website signifies your acceptance of the updated or modified Agreement.</p>\r\n        </div>\r\n\r\n\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6>Use of the Website</h6>\r\n            <p>As a condition of your use of this Website, you warrant that (i) you are at least 18 years of age, (ii) you possess the legal authority to create a binding legal obligation, (iii) you will use this Website in accordance with this Agreement, (iv) you will only use this Website to gather shipping information for you or for another person for whom you are legally authorized to act, (v) all information supplied by you on this Website is true, accurate, current and complete, and (vi) if you have an account with Linescape, you will safeguard your account information and will supervise and be completely responsible for any use of your account by anyone other than you. We retain the right at our sole discretion to deny access to anyone to this Website and the services we offer, at any time and for any reason, including, but not limited to, for violation of this Agreement.</p>\r\n            <h6>Prohibited Activities</h6>\r\n            <p>The content and information on this Website, as well as the infrastructure used to provide such content and information, is proprietary to us or our suppliers and providers. While you may make limited copies of your shipping itinerary (and related documents) you agree not to otherwise modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer, or sell or re-sell any information, software, products, or services obtained from or through this Website. Additionally, you agree not to: (i) use this Website or its contents for any commercial purpose which is not expressly authorized by Linescape; (ii) use this Website or its contents to make any speculative, false, or fraudulent bookings with any third parties; (iii) access, monitor or copy any content or information of this Website using any robot, spider, scraper or other automated means or any manual process for any purpose without our express written permission; (iv) violate the restrictions in any robot exclusion headers on this Website or bypass or circumvent other measures employed to prevent or limit access to this Website; (v) take any action that imposes, or may impose, in our discretion, an unreasonable or disproportionately large load on our infrastructure; (vi) deep-link to any portion of this Website for any purpose without our express written permission; or (vii) \"frame\", \"mirror\" or otherwise incorporate any part of this Website into any other website without our prior written authorization.</p>\r\n            <h6>Submissions of Information</h6>\r\n            <p>We appreciate hearing from you. Please be aware that by submitting content to this Website by electronic mail, postings on this Website or otherwise, including any questions, comments, suggestions, ideas or the like contained in any submissions (collectively, .Submissions.), you grant Linescape and its Affiliates a nonexclusive, royalty-free, perpetual, transferable, irrevocable and fully sub-licensable right to (a) use, reproduce, modify, adapt, translate, distribute, publish, create derivative works from and publicly display and perform such Submissions throughout the world in any media, now known or hereafter devised; and (b) use the name that you submit in connection with such Submission. You acknowledge that Linescape may choose to provide attribution of your comments at our discretion, and that such Submissions may be shared with our supplier partners. You further grant Linescape the right to pursue at law any person or entity that violates your or Linescape.s rights in the Submissions by a breach of this Agreement. You acknowledge and agree that Submissions are non-confidential and non-proprietary. We take no responsibility and assume no liability for any Submissions posted or submitted by you. We have no obligation to post your comments; we reserve the right in our absolute discretion to determine which comments are published on our Website If you do not agree to these terms and conditions, please do not provide us with any Submissions.</p>\r\n            <p>You are fully responsible for the content of your Submissions. You are prohibited from posting or transmitting to or from this Website: (i) any unlawful, threatening, libelous, defamatory, obscene, pornographic, or other material or content that would violate rights of publicity and/or privacy or that would violate any law; (ii) any commercial material or content (including, but not limited to, solicitation of funds, advertising, or marketing of any good or services); and (iii) any material or content that infringes, misappropriates or violates any copyright, trademark, patent right or other proprietary right of any third party. You shall be solely liable for any damages resulting from any violation of the foregoing restrictions, or any other harm resulting from your posting of content to this Website. You acknowledge that Linescape may exercise its rights to use, publish or delete any content you submit without notice to you.</p>\r\n            <h6>Liability Disclaimer</h6>\r\n            <p>The information, software, products, and services published on this Website may include inaccuracies or errors. In particular, Linescape and affiliated, co-branded and/or linked website partners through whom we provide service (.Affiliates.) do not guarantee the accuracy of, and disclaim all liability for any errors or other inaccuracies relating to the information and descriptions on this Website, much of which is provided by the respective suppliers. In addition, Linescape expressly reserves the right to correct any errors on this Website.</p>\r\n            <p>Linescape and its respective suppliers make no representations about the suitability of the information, software, products, and services contained on this Website for any purpose, and the inclusion or offering of any products or services on this Website does not constitute any endorsement or recommendation of such products or services by Linescape. All such information, software, products, and services are provided \"as is\" without warranty of any kind. Linescape, its Affiliates, and/or their respective suppliers disclaim all warranties and conditions that this Website, its servers or any email sent from Linescape, its Affiliates, and/or their respective suppliers are free of viruses or other harmful components. Linescape, its Affiliates, and/or their respective suppliers hereby disclaim all warranties and conditions with regard to this information, software, products, and services, including all implied warranties and conditions of merchantability, fitness for a particular purpose, title, and non-infringement.</p>\r\n            <p>The carriers and other suppliers providing shipping information or other services on this Website are independent contractors and not agents or employees of Linescape or its Affiliates. Linescape and its Affiliates are not liable for the acts, errors, omissions, representations, warranties, breaches or negligence of any such suppliers or for any personal injuries, death, property damage, or other damages or expenses resulting therefrom.</p>\r\n            <p>In no event shall Linescape, its Affiliates, and/or their respective suppliers be liable for any direct, indirect, punitive, incidental, special, or consequential damages arising out of, or in any way connected with, your access to, display of or use of this Website or with the delay or inability to access, display or use this Website (including, but not limited to, your reliance upon opinions appearing on this web site; any computer viruses, information, software, linked sites, products, and services obtained through this Website; or otherwise arising out of the access to, display of or use of this Website) whether based on a theory of negligence, contract, tort, strict liability, or otherwise, and even if the Linescape, its Affiliates and/or their respective suppliers have been advised of the possibility of such damages.</p>\r\n            <h6>Indemnification</h6>\r\n            <p>You agree to defend and indemnify Linescape, its Affiliates, and/or their respective suppliers and any of their officers, directors, employees and agents from and against any claims, causes of action, demands, recoveries, losses, damages, fines, penalties or other costs or expenses of any kind or nature including but not limited to reasonable legal and accounting fees, brought by third parties as a result of: (a) your breach of this Agreement or the documents referenced herein; (b) your violation of any law or the rights of a third party; or (c) your use of this Website.</p>\r\n            <p>Links to Third-Party Sites</p>\r\n            <p>This Website may contain hyperlinks to websites operated by parties other than Linescape. Such hyperlinks are provided for your reference only. We do not control such websites and are not responsible for their contents or the privacy or other practices of such websites. Furthermore, it is up to you to take precautions to ensure that whatever links you select or software you download (whether from this Website or other websites) is free of such items as viruses, worms, trojan horses, defects and other items of a destructive nature. Our inclusion of hyperlinks to such websites does not imply any endorsement of the material on such websites or any association with their operators.</p>\r\n            <h6>Software Available on this Website</h6>\r\n            <p>Any software that is made available to download from this Website is the copyrighted work of Linescape, its Affiliates, and/or our respective suppliers. Your use of such software is governed by the terms of the end user license agreement, if any, which accompanies, or is included with, the software. You may not install or use any software that is accompanied by or includes a license agreement unless you first agree to the license agreement terms. For any software made available for download on this Website not accompanied by a license agreement, we hereby grant to you, the user, a limited, personal, non-transferable license to use the software for viewing and otherwise using this Website in accordance with these terms and conditions and for no other purpose.</p>\r\n            <p>Please note that all software, including, without limitation, all HTML code and Active X controls contained on this Website, is owned by Linescape, its Affiliates, and/or our respective suppliers, and is protected by copyright laws and international treaty provisions. Any reproduction or redistribution of the software is expressly prohibited, and may result in severe civil and criminal penalties. Violators will be prosecuted to the maximum extent possible.</p>\r\n            <p>Without limiting the foregoing, copying or reproduction of the software to any other server or location for further reproduction or redistribution is expressly prohibited. The software is warranted, if at all, only according to the terms of the license agreement.</p>\r\n            <h6>Copyright and Trademark Notices</h6>\r\n            <p>All contents of this Website are: © 2008 Linescape. All rights reserved. Linescape is not responsible for content on websites operated by parties other than Linescape. Linescape and its logo are either registered trademarks or trademarks of Linescape in the U.S. and/or other countries. Other logos and product and company names mentioned herein may be the trademarks of their respective owners. If you are aware of an infringement of our brand, please let us know by contacting us through our contact form.</p>\r\n            <h6>Claims of Copyright Infringement</h6>\r\n            <p>If you believe in good faith that materials hosted by us may infringe your copyright, please let us know by contacting us through our contact form.</p>\r\n            <h6>General</h6>\r\n            <p>This Website is operated by a U.S. entity and this Agreement is governed by the laws of the State of Delaware, USA. You hereby consent to the exclusive jurisdiction and venue of courts in Delaware, USA, in all disputes arising out of or relating to the use of this Website. Use of this Website is unauthorized in any jurisdiction that does not give effect to all provisions of these terms and conditions, including, without limitation, this paragraph.</p>\r\n            <p>You agree that no joint venture, partnership, or employment relationship exists between you and Linescape as a result of this Agreement or use of this Website.</p>\r\n            <p>Our performance of this Agreement is subject to existing laws and legal process, and nothing contained in this Agreement limits our right to comply with law enforcement or other governmental or legal requests or requirements relating to your use of this Website or information provided to or gathered by us with respect to such use. To the extent allowed by applicable law, you agree that you will bring any claim or cause of action arising from or relating to your access or use of this Website within one (1) year from the date on which such claim or action arose or accrued or such claim or cause of action will be irrevocably waived.</p>\r\n            <p>If any part of this Agreement is determined to be invalid or unenforceable pursuant to applicable law including, but not limited to, the warranty disclaimers and liability limitations set forth above, then the invalid or unenforceable provision will be deemed superseded by a valid, enforceable provision that most closely matches the intent of the original provision and agreement shall continue in effect.</p>\r\n            <p>This Agreement (and any other terms and conditions referenced herein) constitutes the entire agreement between you and Linescape with respect to this Website and it supersedes all prior or contemporaneous communications and proposals, whether electronic, oral, or written, between the user and Linescape with respect to this Website. A printed version of this Agreement and of any notice given in electronic form shall be admissible in judicial or administrative proceedings based upon or relating to this Agreement to the same extent and subject to the same conditions as other business documents and records originally generated and maintained in printed form.</p>\r\n            <p>Fictitious names of companies, products, people, characters, and/or data mentioned on this Website are not intended to represent any real individual, company, product, or event.</p>\r\n            <p>Any rights not expressly granted herein are reserved.</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <div class=\"sidebar-section\">\r\n              <h6>What is linescape ?</h6>\r\n              <p>Linescape is a free online comparison website which helps forwarders and shippers to quickly and easily find routes or schedules from many vessel-operating container lines, all at once.</p>\r\n              <p>Users now have everything they need at their fingertips to research and plan the best geographic routes and to select the best sailing schedules for shipping goods anywhere by ocean container.</p>\r\n              <a [routerLink]=\"['/register']\" class=\"btn mt15 mb15\">Register</a>\r\n              <p>or if you are an existing member <a (click)=\"loginToggle()\">Login</a></p>\r\n            </div>\r\n          </div>\r\n      </div>\r\n\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n</div>"

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = ".page-content-wrapper {\n  position: relative;\n  min-height: 457px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 200px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%;\n    border-top: 1px solid #e3e3e3;\n    margin-top: 25px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n    .page-content .page-top-content {\n      padding-top: 0; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(612));


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var HelpComponent = (function () {
    function HelpComponent() {
        // Do stuff
    }
    HelpComponent = __decorate([
        core_1.Component({
            selector: 'help',
            template: __webpack_require__(613),
            styles: [__webpack_require__(614)]
        }),
        __metadata("design:paramtypes", [])
    ], HelpComponent);
    return HelpComponent;
}());
exports.HelpComponent = HelpComponent;


/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Help</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"page-top-content\">\r\n          <h5>Help</h5>\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <p>Help</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <div class=\"sidebar-section\">\r\n              <h6>Help</h6>\r\n            </div>\r\n          </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n</div>\r\n"

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports = ".page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"../../img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 457px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 200px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%;\n    border-top: 1px solid #e3e3e3;\n    margin-top: 25px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n    .page-content .page-top-content {\n      padding-top: 0; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(616));


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var DataFeedsComponent = (function () {
    function DataFeedsComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'Sailing Schedules, Vessel and Carrier Data Feeds - Linescape';
        this.description = 'Liner shipping schedules, routes and vessel data filtered by port, vessel or carrier integrate with your IT system, by API or FTP.';
    }
    DataFeedsComponent.prototype.ngOnInit = function () {
        this.seo.set(this.title, this.description);
    };
    DataFeedsComponent.prototype.ngAfterViewInit = function () {
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    DataFeedsComponent = __decorate([
        core_1.Component({
            selector: 'bulk-data-feeds',
            template: __webpack_require__(617),
            styles: [__webpack_require__(618), __webpack_require__(16)],
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], DataFeedsComponent);
    return DataFeedsComponent;
}());
exports.DataFeedsComponent = DataFeedsComponent;


/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Bulk Data Feeds</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"page-top-content\">\r\n          <h5>Integrate Schedules and Vessel Data into your IT System</h5>\r\n          <p>Receiving sailing schedules and vessel information directly into your system allows you to eliminate the tedious and costly manual process of gathering such data. The benefits of a bulk data feed are immediate and significant:</p>\r\n          <ul>\r\n            <li>Reduce cost and time of manual data gathering</li>\r\n            <li>Increase efficiencies of employee’s workflow</li>\r\n            <li>Eliminate errors caused by manual intervention</li>\r\n            <li>Enhance visibility over the complete supply chain</li>\r\n          </ul>\r\n          <h5>Choose the data structure and file format to meet your needs</h5>\r\n\r\n          <p>Data feeds are delivered as CSV files by FTP download and are tailor-made to your needs and budget. From a low-cost 5-field simple schedule data feed to a premium multi-file data feed with over 50 unique data fields... or something in between, we have a solution made just for you.</p>\r\n\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-full\">\r\n            <h6>Contact us for a quotation and a free sample file.</h6>\r\n            <p>Simply fill out and submit the following form and we will provide you with a proposal.</p>\r\n            <contact-form type=\"Data\"></contact-form>\r\n          </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n</div>\r\n"

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(620));


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var AnalyticsComponent = (function () {
    function AnalyticsComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'Analytics - Linescape';
        this.description = 'Global sailing schedules can provide a wealth of analytical data to give you deeper insights into the trends affecting your business, for better decision making';
        // Do stuff
    }
    AnalyticsComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    AnalyticsComponent = __decorate([
        core_1.Component({
            selector: 'analytics-reporting',
            template: __webpack_require__(621),
            styles: [__webpack_require__(622), __webpack_require__(16)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], AnalyticsComponent);
    return AnalyticsComponent;
}());
exports.AnalyticsComponent = AnalyticsComponent;


/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Analytics & Reporting</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"page-top-content\">\r\n            <h6>Acquire More Strategic Market Intelligence</h6>\r\n            <p>Global sailing schedules can provide a wealth of analytical data to give you deeper insights into the trends affecting your business, for better decision making. Schedule analytics bring you the following benefits:</p>\r\n            <ul>\r\n                <li>Analyze On-Time Arrival Accuracy</li>\r\n                <li>Benchmark Competitive Transit Times</li>\r\n                <li>Compare Route Reliability Options</li>\r\n                <li>Get Event Notifications &amp; Alerts</li>\r\n            </ul>\r\n        </div>\r\n        <div class=\"page-top-content pt0\">\r\n            <h6>On-Time Arrival Accuracy</h6>\r\n            <p>On-Time Arrival Accuracy compares the estimated time of arrivals (from schedules) with the actual time of arrivals (from AIS) and can be analyzed by carrier, by service, and by port pair.</p>\r\n            \r\n            <h6>Benchmark Transit Times</h6>\r\n            <p>Transit Time Benchmarking compares the transit times between carriers by port pair to create benchmarks.</p>\r\n\r\n            <h6>Route Reliability Options</h6>\r\n            <p>Route Reliability compares port pair transit times across carriers and services to identify the most reliable routes.</p>\r\n\r\n            <h6>Event Notifications &amp; Alerts</h6>\r\n            <p>Notifications and Alerts are available for any schedule change events.</p>\r\n\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-full\">\r\n            <h6>Contact us for a quotation.</h6>\r\n            <p>Simply fill out and submit the following form and we will provide you with a proposal.</p>\r\n            <contact-form type=\"Data\"></contact-form>\r\n          </div>\r\n      </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(624));


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var ApiComponent = (function () {
    function ApiComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'API - Linescape';
        this.description = 'Data feeds by API save you the trouble of hosting data on your system and allow you to get any data in real-time, whenever you need it, one search at a time.';
        // Do stuff
    }
    ApiComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    ApiComponent = __decorate([
        core_1.Component({
            selector: 'api-data-on-demand',
            template: __webpack_require__(625),
            styles: [__webpack_require__(626), __webpack_require__(16)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], ApiComponent);
    return ApiComponent;
}());
exports.ApiComponent = ApiComponent;


/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>API Data-on-Demand</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"page-top-content\">\r\n            <h5>Query Schedule Data in Real-Time</h5>\r\n            <p>Data feeds by API save you the trouble of hosting data on your system and allow you to get any data in real-time, whenever you need it, one search at a time.</p>\r\n            <ul>\r\n                <li>Pay as you go - pay only for the amount of data you query</li>\r\n                <li>Get the latest updated results at the time of each query</li>\r\n                <li>Query any data from any perspective at any time</li>\r\n                <li>Receive content tailor-made to your exact requirements</li>\r\n            </ul>\r\n            <p>The API provides access via a standard REST web service that can be used with any programming language and on any platform. Data is accessed by making a \"Request\" to the API that specifies the type of data that is being searched and any criteria to narrow the search. The API then replies with a \"Response\" that includes a list of any items that satisfy the request. </p>\r\n            <br>\r\n            <p>To view our API Documentation, <a target=\"_blank\" href=\"./api-docs\">CLICK HERE</a></p>\r\n\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-full\">\r\n                <h5>Contact us for a quotation and a free two-week trial</h5>\r\n\r\n                <p>Simply fill out and submit the following form and we will provide you with a proposal and a test key.</p>\r\n                <contact-form type=\"Data\"></contact-form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(628));


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var ApplicationComponent = (function () {
    function ApplicationComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'Application - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';
        // Do stuff
    }
    ApplicationComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    ApplicationComponent = __decorate([
        core_1.Component({
            selector: 'application',
            template: __webpack_require__(629),
            styles: [__webpack_require__(630)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], ApplicationComponent);
    return ApplicationComponent;
}());
exports.ApplicationComponent = ApplicationComponent;


/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-banner-inner\">\r\n        <h2>Application</h2>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"main-content\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n            <p>Linescape’s variety of Applications lets logistics professionals search for and display schedules from any view: by port pairs, by vessel name, by port calls or by carrier.</p>\r\n          <div class=\"col-holder feature-box\">\r\n            <div class=\"col3of4\">\r\n              <h1>API Overview</h1>\r\n              <div style=\"text-align: center; margin-top: -15px; margin-bottom: 15px;\"><em>Easy requests via REST web service with JSON response</em></div>\r\n              <p>The API provides access via a standard REST web service that can be used with any programming language and on any platform. Data is accessed by making a \"Request\" to the API that specifies the type of data that is being searched and any criteria to narrow the search. The API then replies with a \"Response\" that includes a list of any items that satisfy the request.</p>\r\n              <div class=\"text-center\"><a [routerLink]=\"['/api-overview', { scroll: true }]\" class=\"btn btn-lg\">LEARN MORE</a></div>\r\n            </div>\r\n            <div class=\"col1of4 no-gutter\">\r\n              <div class=\"d-table\">\r\n                <div class=\"d-table-cell\">\r\n                  <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 300 300\" style=\"enable-background:new 0 0 300 300;\" xml:space=\"preserve\"> <style type=\"text/css\"> .st0{fill:#FFFFFF;}</style> <path class=\"st0\" d=\"M131.5,138.5l-13.6,13.6l14.3,14.3c2.6,2.6,2.6,7.1,0,9.7c-1.3,1.3-3,2-4.8,2c-1.8,0-3.6-0.7-4.8-2L103.5,157 c-1.3-1.3-2-3-2-4.8s0.7-3.6,2-4.8l18.4-18.4c2.6-2.6,7.1-2.6,9.7,0C134.2,131.4,134.2,135.7,131.5,138.5z M169,176.6L169,176.6 c1.3,1.3,3,2,4.8,2c1.8,0,3.6-0.7,4.8-2l18.4-18.4c1.3-1.3,2-3,2-4.8s-0.7-3.6-2-4.8l-19.1-19.1c-1.3-1.3-3-2-4.8-2s-3.6,0.7-4.8,2 c-1.3,1.3-2,3-2,4.8s0.7,3.6,2,4.8l14.3,14.3L169,167C166.4,169.5,166.4,173.8,169,176.6z M137.8,191.4c0.7,0.2,1.4,0.4,2.2,0.4 c3,0,5.6-1.9,6.5-4.8l20.7-63.8c1.2-3.6-0.8-7.5-4.4-8.7c-1.8-0.6-3.6-0.4-5.3,0.4c-1.7,0.8-2.9,2.3-3.4,4l-20.7,63.9 C132.1,186.3,134,190.2,137.8,191.4z M151.2,59.8C101.5,59.8,61,100.3,61,150c0,36.4,21.6,69,55.2,83.2c3.5,1.4,7.6-0.1,9-3.6 c1.4-3.5-0.1-7.6-3.6-9c-28.4-12-46.7-39.7-46.7-70.5c0-42.2,34.4-76.6,76.6-76.6s76.6,34.4,76.6,76.6s-34.4,76.6-76.6,76.6 c-3.5,0-7.1-0.2-10.5-0.7c-1.8-0.2-3.6,0.2-5,1.3c-1.4,1.1-2.4,2.8-2.6,4.6c-0.5,3.7,2.2,7.2,5.9,7.7c4.1,0.6,8.2,0.8,12.4,0.8 c49.8,0,90.3-40.5,90.3-90.3C241.5,100.3,201,59.8,151.2,59.8z M300.4,140.2v19.7c0,7.2-5.4,13.1-12.5,13.7l-15.5,1.4 c-1.2,5.9-2.9,11.8-4.9,17.5l12.5,9.3c5.8,4.3,7.2,12.1,3.5,18.3l-10.3,16.8c-3.7,6.1-11.4,8.3-17.9,5.2l-13.9-7 c-2.9,3.1-5.9,6-9.1,8.8l6.4,14.2c3,6.5,0.5,14.2-5.8,17.7l-17.2,9.7c-6.2,3.5-14.1,1.8-18.1-4.2l-8.9-12.7 c-4.3,1.4-8.9,2.6-13.3,3.5l-1.4,15.5c-0.6,7.1-6.5,12.5-13.7,12.5h-19.7c-7.2,0-13.1-5.4-13.7-12.5l-1.4-15.5 c-5.9-1.2-11.8-2.9-17.5-4.9l-9.1,12.6c-4.3,5.8-12.1,7.2-18.3,3.5l-16.8-10.3c-6.1-3.7-8.3-11.4-5.2-17.9l7-13.9 c-3.1-2.9-6-5.9-8.8-9.1l-14.2,6.4c-6.5,3-14.2,0.5-17.7-5.8l-9.7-17.2c-3.5-6.2-1.8-14.1,4.2-18.1l12.7-8.9 c-1.4-4.3-2.6-8.9-3.5-13.3l-15.5-1.4c-7.1-0.6-12.5-6.5-12.5-13.7V140c0-7.2,5.4-13.1,12.5-13.7l15.5-1.4 c1.2-5.9,2.9-11.8,4.9-17.5l-12.5-9.3c-5.8-4.3-7.2-12.1-3.5-18.3L27.6,63c3.7-6.1,11.4-8.3,17.9-5.2l13.9,7c2.9-3.1,5.9-6,9.1-8.8 L61.9,42c-3-6.5-0.5-14.2,5.8-17.7l17.2-9.7c6.2-3.5,14.1-1.8,18.1,4.2l8.9,12.7c4.3-1.4,8.9-2.6,13.3-3.5l1.4-15.5 c0.6-7.2,6.5-12.6,13.7-12.6h19.7c7.2,0,13.1,5.4,13.7,12.5l1.4,15.5c5.9,1.2,11.8,2.9,17.5,4.9l9.3-12.5c4.3-5.8,12.1-7.2,18.3-3.5 l16.8,10.3c6.1,3.7,8.3,11.4,5.2,17.9l-7,13.9c3.1,2.9,6,5.9,8.8,9.1l14.2-6.4c6.5-3,14.2-0.5,17.7,5.8l9.7,17.2 c3.5,6.2,1.8,14.1-4.2,18.1l-12.7,8.8c1.4,4.3,2.6,8.9,3.5,13.3l15.5,1.4C294.9,127.1,300.4,133,300.4,140.2z M265.9,161.8l20.8-1.9 v-19.7l-20.8-1.9c-3.1-0.2-5.6-2.6-6.1-5.8c-1.2-7.2-3-14.3-5.5-21.2c-1.1-3,0-6.2,2.5-8.1l17.1-11.8l-9.7-17.2l-19,8.5 c-2.9,1.3-6.2,0.5-8.2-1.9c-4.3-5.4-9.1-10.5-14.4-14.9c-2.4-2-3.1-5.4-1.7-8.3l9.3-18.6l-16.8-10.3l-12.6,16.6 c-1.9,2.5-5.3,3.5-8.2,2.3c-7.9-3.2-16.2-5.6-24.8-7c-3.1-0.5-5.5-3-5.8-6.1L160,13.9h-19.8l-1.9,20.8c-0.2,3.1-2.6,5.6-5.8,6.1 c-7.2,1.2-14.3,3-21.2,5.5c-3,1.1-6.2,0-8.1-2.5L91.5,26.7l-17.1,9.5l8.7,19c1.3,2.9,0.5,6.2-1.9,8.2c-5.4,4.3-10.5,9.3-14.9,14.4 c-2,2.4-5.4,3.1-8.3,1.7l-18.6-9.3L29,87.1l16.5,12.6c2.5,1.9,3.5,5.3,2.3,8.2c-3.2,7.9-5.6,16.2-7,24.8c-0.5,3.1-3,5.5-6.1,5.8 L14,140.3v19.8l20.8,1.9c3.1,0.2,5.6,2.6,6.1,5.8c1.2,7.2,3,14.3,5.5,21.2c1.1,3,0,6.2-2.5,8.1l-17.1,11.8l9.7,17.2l19-8.5 c2.9-1.3,6.2-0.5,8.2,1.9c4.3,5.4,9.3,10.5,14.4,14.9c2.4,2,3.1,5.4,1.7,8.3l-9.3,18.6l16.8,10.3l12.5-16.7c1.3-1.7,3.4-2.8,5.5-2.8 c1,0,1.8,0.1,2.6,0.5c7.9,3.2,16.2,5.6,24.8,7c3.1,0.5,5.5,3,5.8,6.1l1.9,20.7h19.8l1.9-20.8c0.2-3.1,2.6-5.6,5.8-6.1 c7.2-1.2,14.3-3,21.2-5.5c3-1.1,6.2,0,8.1,2.5l11.8,17.1l17.2-9.7l-8.5-19c-1.3-2.9-0.5-6.2,1.9-8.2c5.4-4.3,10.5-9.1,14.9-14.4 c2-2.4,5.4-3.1,8.3-1.7l18.6,9.3l10.3-16.8l-16.7-12.5c-2.5-1.9-3.5-5.3-2.3-8.2c3.2-7.9,5.6-16.2,7-24.8 C260.2,164.4,262.7,162,265.9,161.8z M177.8,84.8c-8.8-3.7-18-5.5-27.6-5.5c-39.1,0-70.9,31.8-70.9,70.9s31.8,70.9,70.9,70.9 s70.9-31.8,70.9-70.9c0-19.9-8.4-39.1-23.2-52.4c-1.3-1.2-3.1-1.9-4.9-1.8s-3.5,0.8-4.8,2.3c-1.2,1.3-1.9,3.1-1.8,4.9 s0.8,3.5,2.3,4.8c11.9,10.8,18.6,26.2,18.6,42.3c0,31.5-25.6,57.1-57.1,57.1s-57.1-25.6-57.1-57.1s25.6-57.1,57.1-57.1 c7.7,0,15.1,1.6,22.2,4.4c1.7,0.7,3.6,0.7,5.3,0s3-2,3.7-3.7s0.7-3.6,0-5.3C180.8,86.8,179.5,85.5,177.8,84.8z\"/> </svg>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-holder feature-box\">\r\n            <div class=\"col1of4 no-gutter\">\r\n              <div class=\"d-table\">\r\n                <div class=\"d-table-cell\">\r\n                  <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 300 300\" style=\"enable-background:new 0 0 300 300;\" xml:space=\"preserve\"> <style type=\"text/css\"> .st0{fill:#FFFFFF;}</style> <g> <path class=\"st0\" d=\"M53.3,34.1c-12.9,0-23.5,10.5-23.5,23.5s10.5,23.5,23.5,23.5s23.5-10.5,23.5-23.5S66.2,34.1,53.3,34.1z M64.5,57.6c0,6.2-5,11.2-11.2,11.2S42,63.8,42,57.6s5-11.2,11.2-11.2S64.5,51.4,64.5,57.6z\"/> <path class=\"st0\" d=\"M255.3,50.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1 C252.6,56.2,255.3,53.5,255.3,50.1z\"/> <path class=\"st0\" d=\"M235.5,50.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1 C232.8,56.2,235.5,53.5,235.5,50.1z\"/> <path class=\"st0\" d=\"M259.2,58.9c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1 C265.3,61.6,262.5,58.9,259.2,58.9z\"/> <path class=\"st0\" d=\"M239.3,58.9c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1 C245.4,61.6,242.7,58.9,239.3,58.9z\"/> <path class=\"st0\" d=\"M215.7,50.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1 C212.9,56.2,215.7,53.5,215.7,50.1z\"/> <path class=\"st0\" d=\"M219.5,58.9c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1 C225.6,61.6,222.8,58.9,219.5,58.9z\"/> <path class=\"st0\" d=\"M195.8,50.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1 C193.1,56.2,195.8,53.5,195.8,50.1z\"/> <path class=\"st0\" d=\"M199.6,58.9c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1 C205.7,61.6,203,58.9,199.6,58.9z\"/> <path class=\"st0\" d=\"M176,50.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1C173.2,56.2,176,53.5,176,50.1z \"/> <path class=\"st0\" d=\"M179.8,58.9c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1 C185.9,61.6,183.1,58.9,179.8,58.9z\"/> <path class=\"st0\" d=\"M300,86.8V28.3c0-13.2-10.8-24-24-24H24c-13.2,0-24,10.8-24,24v58.5c0,6.9,3,13.3,8.2,17.9 C3,109.3,0,115.7,0,122.6v58.5c0,13.2,10.8,24,24,24h121.2c-0.8,1-1.3,2.4-1.3,3.8v5c0,3.4,2.7,6.1,6.1,6.1s6.1-2.7,6.1-6.1v-5 c0-1.4-0.5-2.8-1.3-3.8H276c13.2,0,24-10.8,24-24v-58.5c0-6.9-3-13.3-8.2-17.9C297,100.1,300,93.7,300,86.8z M276,98.6H23.7 c-6.3-0.2-11.4-5.4-11.4-11.8V28.3c0-6.5,5.3-11.8,11.8-11.8h252c6.5,0,11.8,5.3,11.8,11.8v58.5C287.8,93.3,282.5,98.6,276,98.6z M12.2,122.6c0-6.5,5.3-11.8,11.8-11.8h252c6.5,0,11.8,5.3,11.8,11.8v58.5c0,6.5-5.3,11.8-11.8,11.8H24c0,0,0,0,0,0 c-3.1,0-6.1-1.2-8.3-3.5c-2.2-2.2-3.5-5.2-3.5-8.3V122.6z\"/> <path class=\"st0\" d=\"M53.3,175.3c12.9,0,23.5-10.5,23.5-23.5s-10.5-23.5-23.5-23.5s-23.5,10.5-23.5,23.5S40.3,175.3,53.3,175.3z M42,151.8c0-6.2,5-11.2,11.2-11.2s11.2,5,11.2,11.2c0,6.2-5,11.2-11.2,11.2S42,158,42,151.8z\"/> <path class=\"st0\" d=\"M154.4,248.1c-1.7,2.9-0.6,6.7,2.3,8.3l0,0c1,0.6,2,1.3,2.9,2.2c1.2,1.1,2.7,1.7,4.3,1.7 c1.7,0,3.2-0.7,4.4-1.8c2.4-2.4,2.3-6.3-0.1-8.7c-1.6-1.6-3.4-2.9-5.4-4.1C159.8,244.2,156.1,245.2,154.4,248.1z\"/> <path class=\"st0\" d=\"M156.9,280.3L156.9,280.3c-1,0.6-2.1,1.1-3.3,1.4c-3.3,0.9-5.2,4.2-4.3,7.5c0.7,2.7,3.2,4.5,5.9,4.5 c0.5,0,1.1-0.1,1.6-0.2c2.2-0.6,4.3-1.5,6.3-2.6c2.9-1.7,3.9-5.5,2.2-8.4C163.6,279.6,159.8,278.6,156.9,280.3z\"/> <path class=\"st0\" d=\"M169.8,262.2c-3.4,0-6.1,2.8-6.1,6.2c0,1.2-0.2,2.4-0.5,3.5c-0.4,1.6-0.2,3.2,0.6,4.6c0.8,1.4,2.1,2.4,3.7,2.8 c0.5,0.1,1,0.2,1.6,0.2c2.8,0,5.2-1.9,5.9-4.5c0.6-2.2,0.9-4.4,0.9-6.7v-0.2C176,264.8,173.3,262.2,169.8,262.2z\"/> <path class=\"st0\" d=\"M143.2,280.3L143.2,280.3c-1-0.6-2-1.3-2.8-2.2c-2.4-2.4-6.3-2.4-8.7,0c-1.2,1.2-1.8,2.7-1.8,4.3 c0,1.6,0.6,3.2,1.8,4.3c1.6,1.6,3.4,3,5.4,4.1c0.9,0.5,2,0.8,3,0.8c2.2,0,4.2-1.2,5.3-3.1C147.1,285.8,146.1,282,143.2,280.3z\"/> <path class=\"st0\" d=\"M150.6,247.7c-0.9-3.2-4.3-5.2-7.5-4.3l0,0c-2.2,0.6-4.3,1.5-6.2,2.6c-1.4,0.8-2.4,2.2-2.8,3.7 c-0.4,1.6-0.2,3.2,0.7,4.6c1.1,1.9,3.1,3,5.3,3c1.1,0,2.2-0.3,3.1-0.8c1-0.6,2.1-1.1,3.3-1.4c1.6-0.4,2.9-1.5,3.7-2.9 C150.8,250.9,151,249.3,150.6,247.7z\"/> <path class=\"st0\" d=\"M130.2,274.6c1.6,0,3.1-0.6,4.3-1.8c1.2-1.2,1.8-2.7,1.8-4.4c0-1.2,0.1-2.3,0.4-3.5c0.8-3.3-1.1-6.6-4.4-7.5 c-3.3-0.8-6.6,1.1-7.5,4.4c-0.5,1.8-0.7,3.6-0.8,5.5l0,2.3h0.1C124.7,272.5,127.2,274.6,130.2,274.6 C130.2,274.6,130.2,274.6,130.2,274.6z\"/> <path class=\"st0\" d=\"M249.2,150.5c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1 C243.1,147.8,245.9,150.5,249.2,150.5z\"/> <path class=\"st0\" d=\"M229.4,150.5c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1 C223.3,147.8,226,150.5,229.4,150.5z\"/> <circle class=\"st0\" cx=\"259.2\" cy=\"159.3\" r=\"6.1\"/> <circle class=\"st0\" cx=\"239.3\" cy=\"159.3\" r=\"6.1\"/> <circle class=\"st0\" cx=\"209.5\" cy=\"144.4\" r=\"6.1\"/> <path class=\"st0\" d=\"M213.3,159.3c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1 C216.1,153.2,213.3,155.9,213.3,159.3z\"/> <circle class=\"st0\" cx=\"189.7\" cy=\"144.4\" r=\"6.1\"/> <path class=\"st0\" d=\"M193.5,159.3c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1 C196.2,153.2,193.5,155.9,193.5,159.3z\"/> <circle class=\"st0\" cx=\"169.8\" cy=\"144.4\" r=\"6.1\"/> <path class=\"st0\" d=\"M173.6,159.3c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1 C176.4,153.2,173.6,155.9,173.6,159.3z\"/> <path class=\"st0\" d=\"M110.3,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S113.7,262.3,110.3,262.3z\"/> <path class=\"st0\" d=\"M70.6,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S74,262.3,70.6,262.3z\"/> <path class=\"st0\" d=\"M90.5,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S93.8,262.3,90.5,262.3z\"/> <path class=\"st0\" d=\"M11.1,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S14.5,262.3,11.1,262.3z\"/> <path class=\"st0\" d=\"M30.9,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S34.3,262.3,30.9,262.3z\"/> <path class=\"st0\" d=\"M50.8,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S54.1,262.3,50.8,262.3z\"/> <path class=\"st0\" d=\"M194.7,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S198,262.3,194.7,262.3z\"/> <path class=\"st0\" d=\"M234.3,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S237.7,262.3,234.3,262.3z\"/> <path class=\"st0\" d=\"M214.5,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S217.9,262.3,214.5,262.3z\"/> <path class=\"st0\" d=\"M293.9,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S297.3,262.3,293.9,262.3z\"/> <path class=\"st0\" d=\"M254.2,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S257.6,262.3,254.2,262.3z\"/> <path class=\"st0\" d=\"M274,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S277.4,262.3,274,262.3z\"/> <path class=\"st0\" d=\"M150,222.6c-3.4,0-6.1,2.7-6.1,6.1v5c0,3.4,2.7,6.1,6.1,6.1s6.1-2.7,6.1-6.1v-5 C156.1,225.4,153.4,222.6,150,222.6z\"/> </g> </svg>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col3of4\">\r\n              <h1>Bulk Data Formats</h1>\r\n              <div style=\"text-align: center; margin-top: -15px; margin-bottom: 15px;\"><em>Direct FTP downloads of CSV schedule and vessel data</em></div>\r\n              <p>Data feeds are delivered as CSV files by FTP download and are tailor-made to your needs and budget. From a low-cost 5-field simple schedule data feed to a premium multi-file data feed with over 50 unique data fields... or something in between, we have a solution made just for you.</p>\r\n              <div class=\"text-center\"><a [routerLink]=\"['/bulk-data-formats', { scroll: true }]\" class=\"btn btn-lg\" (click)=\"toggle('', 'footer')\" (click)=\"scrollTop()\">LEARN MORE</a></div>\r\n              \r\n            </div>\r\n          </div>\r\n          <div class=\"col-holder feature-box\">\r\n            <div class=\"col3of4\">\r\n              <h1>Carrier List</h1>\r\n              <div style=\"text-align: center; margin-top: -15px; margin-bottom: 15px;\"><em>Explore 120+ carriers (deep-sea, short-sea and feeders)</em></div>\r\n              <p>We believe that the process of finding a carrier should be a simple one Linescape data comprises routes and schedules from over 120 carriers (deep-sea, short-sea and feeders), all of which is regularly updated, allowing shippers and forwarders to quickly and easily find alternatives.</p>\r\n              <div class=\"text-center\"><a [routerLink]=\"['/carrier-list', { scroll: true }]\" class=\"btn btn-lg\">LEARN MORE</a></div>\r\n            </div>\r\n            <div class=\"col1of4 no-gutter\">\r\n                <div class=\"d-table\">\r\n                    <div class=\"d-table-cell\">\r\n                        <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n                        viewBox=\"0 0 100 100\" style=\"enable-background:new 0 0 100 100;\" xml:space=\"preserve\"><style type=\"text/css\">.st0{fill:#ffffff;}</style><path class=\"st0\" d=\"M72.5,53h-3.9v-3.2h3.9V53z M72.5,55.6h-3.9v3.2h3.9V55.6z M66.5,74.1h3.3v-3.3h-3.3V74.1z M58.3,74.1h3.3v-3.3\r\n                       h-3.3V74.1z M50,74.1h3.3v-3.3H50V74.1z M41.7,74.1H45v-3.3h-3.3V74.1z M33.4,74.1h3.3v-3.3h-3.3V74.1z M22,71h3.3v-3.3H22V71z\r\n                        M13.7,71H17v-3.3h-3.3V71z M81.8,83.7c1.3,1.5,1.7,3.5,1.8,4.9L81,88.8c-0.1-1.6-0.5-2.7-1.1-3.4c-0.5-0.6-1.6-1-2.2-0.5\r\n                       c-0.4,0.3-0.7,0.9-1,1.4c-0.6,1.1-1.3,2.5-2.9,2.7c-1.4,0.2-2.7-0.5-3.7-2c-0.1-0.2-0.3-0.4-0.4-0.7c-0.4-0.6-0.7-1.1-1.1-1.4\r\n                       c-0.3-0.2-0.6-0.2-1-0.1s-0.7,0.3-0.8,0.6c-0.1,0.2-0.2,0.5-0.3,0.8c-0.3,0.7-0.6,1.6-1.5,2.2c-0.6,0.4-1.4,0.6-2.1,0.4\r\n                       c-1.6-0.3-2.7-1.9-3.2-2.5c-1.2-1.8-1.7-1.8-1.8-1.7c-0.4,0.1-0.7,0.9-1,1.6c-0.5,1.2-1.3,2.9-3.2,2.9c0,0,0,0-0.1,0\r\n                       c-2.1,0-3.1-2.3-3.4-3.1c-0.4-1.1-0.9-1.4-1-1.4c-0.2,0-0.6,0.8-0.8,1.3c-0.5,1.1-1.3,2.6-3,2.7c-1.7-0.1-2.5-1.2-3.1-2.2\r\n                       c-0.3-0.4-0.7-1.1-0.9-1.1s-0.7,0.6-1,1c-0.6,0.8-1.4,1.7-2.6,2c-2.2,0.5-3.7-1.5-4.5-2.6c-0.6-0.8-1.4-1.2-1.6-1.1\r\n                       c-0.1,0.1-0.3,0.5-0.4,0.8c-0.2,0.4-0.3,0.8-0.6,1.3c-1,1.4-3.1,1.9-4.6,1c-0.8-0.5-1.3-1.1-1.7-1.7c-0.1-0.2-0.3-0.4-0.4-0.5\r\n                       c-0.3-0.4-0.7-0.6-0.7-0.5c-0.1,0.1-0.3,0.6-0.5,0.9c-0.3,0.8-0.8,1.9-2,2.3C19.5,88.7,18,88,17,86.3l-0.3-0.5\r\n                       c-0.3-0.5-0.6-1-0.9-1.2c-0.1,0-0.2-0.1-0.4,0c-0.5,0.2-1,0.8-1.2,1.4c-0.2,0.5-0.3,1-0.8,1.4c-0.5,0.5-1.1,0.8-1.9,0.7\r\n                       C10.6,88,9.6,87.4,9,86.6c-0.2-0.3-0.4-0.7-0.6-1c-0.2-0.4-0.5-0.8-0.7-1c-0.4-0.3-1.2-0.1-1.7,0.2c-1.5,0.8-1.6,2.4-2.2,3.3\r\n                       l-2.3,0.1c0.7-2.2,0.9-4,3-5.6C6,81.5,8,81.5,9.3,82.5c0.7,0.5,1.1,1.2,1.4,1.9c0.1,0.3,0.3,0.5,0.4,0.7c0.1,0.2,0.3,0.3,0.5,0.4\r\n                       c0-0.1,0-0.2,0-0.2c0.4-1.1,1-2,1.8-2.6l-9-19.9H17V51.4h45.2v-6.5l6.8-0.1v-9h-4v-2.6h11v2.6h-4.4v8.9l6.6-0.1l0.1,20.6h1.4\r\n                       l0.2,1.4c0.2,1.2,1,7.3-0.3,10.1c-1,2.2-3.5,4.1-4.8,5v2.8c0.3-0.6,0.7-1.2,1.3-1.7C77.9,81.4,80.5,82.2,81.8,83.7z M65.4,53v1.6\r\n                       v10.7H75V48l-9.5,0.1L65.4,53L65.4,53z M45,60.3v-5.6h-2.5v10.7h19.7V54.6H60v5.6h-3.2v-5.6h-2.7v5.6h-3.2v-5.6h-2.7v5.6H45V60.3z\r\n                        M20.2,54.6V63h11.6v2.3h7.4V54.6H20.2z M71.5,84.5V80l0.8-0.5c0.9-0.6,3.6-2.4,4.3-4.1c0.5-1.2,0.5-4.3,0.2-6.9H75l0,0H28.6V66H9.5\r\n                       L17,82.2l0,0c1.1,0.5,1.6,1.5,2.1,2.3l0.2,0.4c0.3,0.5,0.6,0.7,0.7,0.7c0.1-0.1,0.3-0.6,0.4-0.9c0.3-0.8,0.7-1.8,1.8-2.3\r\n                       c1.2-0.5,2.7,0,3.8,1.3c0.2,0.2,0.3,0.4,0.5,0.7c0.3,0.4,0.6,0.8,0.9,1c0.4,0.2,0.9,0.1,1.2-0.3c0.1-0.2,0.2-0.4,0.4-0.7\r\n                       c0.3-0.6,0.6-1.4,1.4-2c1.5-1,3.6-0.3,5.1,1.7c0.4,0.5,1.3,1.8,1.8,1.6c0.3-0.1,0.8-0.6,1.1-1.1c0.7-0.9,1.7-2.1,3.3-1.9\r\n                       c1.4,0.2,2.2,1.4,2.8,2.2c0.2,0.3,0.6,1,0.8,1c0.2-0.1,0.6-0.8,0.8-1.2c0.5-1.1,1.2-2.5,2.8-2.7c0.9-0.1,2.5,0.1,3.7,2.9\r\n                       c0.6,1.5,1,1.5,1,1.5c0.2,0,0.6-0.9,0.9-1.4c0.5-1.1,1.1-2.5,2.6-3c2.5-0.8,4.2,1.9,4.8,2.8c0.5,0.8,1.2,1.3,1.5,1.4\r\n                       c0.3-0.1,0.5-0.6,0.6-1c0.2-0.4,0.3-0.9,0.6-1.3c0.5-0.9,1.4-1.5,2.5-1.8c1-0.2,2.1-0.1,3,0.5C70.7,83.3,71.2,83.9,71.5,84.5z\r\n                        M89.4,84.8V88h8.8v-3.2H89.4z M92.2,29.9H56.4V6.7h39v9.1l0,0v63.7h-3.2C92.2,79.5,92.2,29.9,92.2,29.9z M92.2,9.9H59.6v16.7h32.5\r\n                       L92.2,9.9L92.2,9.9z\"/>\r\n                     </svg>\r\n                </div></div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-holder feature-box\">\r\n              <div class=\"col1of4 no-gutter\">\r\n                  <div class=\"d-table\">\r\n                      <div class=\"d-table-cell\">\r\n                <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 300 300\" style=\"enable-background:new 0 0 300 300;\" xml:space=\"preserve\"> <style type=\"text/css\"> .st0{fill:#FFFFFF;}</style> <g> <path class=\"st0\" d=\"M293.7,287.5h-6.2V106.3c0-3.5-2.8-6.3-6.3-6.3h-37.5c-3.4,0-6.3,2.8-6.3,6.3v181.2h-25V181.3 c0-3.5-2.8-6.3-6.3-6.3h-37.5c-3.4,0-6.3,2.8-6.3,6.3v106.2h-25V156.3c0-3.4-2.8-6.3-6.3-6.3H93.7c-3.4,0-6.3,2.8-6.3,6.3v131.2 h-25v-68.8c0-3.4-2.8-6.2-6.3-6.2H18.8c-3.4,0-6.3,2.8-6.3,6.3v68.7H6.3c-3.4,0-6.3,2.8-6.3,6.2c0,3.5,2.8,6.3,6.3,6.3h12.5h37.5 h37.5c0,0,0,0,0,0h37.5c0,0,0,0,0,0h37.5c0,0,0,0,0,0h37.5c0,0,0,0,0,0h37.5c0,0,0,0,0,0h37.5c0,0,0,0,0,0h12.5 c3.5,0,6.3-2.8,6.3-6.3C300,290.3,297.2,287.5,293.7,287.5z M250,112.5h25v175h-25V112.5z M175,187.5h25v100h-25V187.5z M100,162.5 h25v125h-25V162.5z M50,287.5H25V225h25L50,287.5L50,287.5z\"/> <path class=\"st0\" d=\"M37.5,162.5c13.8,0,25-11.2,25-25c0-4.4-1.1-8.5-3.1-12.1L97.5,95c4.2,3.1,9.4,5,15,5c9.2,0,17.2-5,21.5-12.4 l28.8,8.2c-0.2,1.3-0.4,2.7-0.4,4.1c0,13.8,11.2,25,25,25s25-11.2,25-25c0-4.6-1.3-9-3.5-12.7l40.8-40.8c3.7,2.2,8,3.5,12.7,3.5 c13.8,0,25-11.2,25-25s-11.2-25-25-25c-13.8,0-25,11.2-25,25c0,4.6,1.3,9,3.5,12.7l-40.8,40.8c-3.7-2.2-8-3.5-12.7-3.5 c-7.9,0-14.9,3.7-19.5,9.3l-30.6-8.7c0-0.2,0-0.4,0-0.6c0-13.8-11.2-25-25-25s-25,11.2-25,25c0,3.6,0.8,7.1,2.2,10.2l-39,31.1 c-3.8-2.4-8.3-3.8-13.2-3.8c-13.8,0-25,11.2-25,25S23.7,162.5,37.5,162.5z M262.5,12.5c6.9,0,12.5,5.6,12.5,12.5 c0,6.9-5.6,12.5-12.5,12.5c-3.4,0-6.5-1.4-8.8-3.6c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c-2.2-2.3-3.6-5.4-3.6-8.8 C250,18.1,255.6,12.5,262.5,12.5z M187.5,87.5c6.9,0,12.5,5.6,12.5,12.5c0,6.9-5.6,12.5-12.5,12.5S175,106.9,175,100 C175,93.1,180.6,87.5,187.5,87.5z M112.5,62.5c6.9,0,12.5,5.6,12.5,12.5c0,6.9-5.6,12.5-12.5,12.5c-3.9,0-7.4-1.8-9.7-4.6 c0,0,0-0.1-0.1-0.1c0,0,0,0,0-0.1c-1.7-2.1-2.7-4.8-2.7-7.7C100,68.1,105.6,62.5,112.5,62.5z M37.5,125c6.9,0,12.5,5.6,12.5,12.5 c0,6.9-5.6,12.5-12.5,12.5S25,144.4,25,137.5C25,130.6,30.6,125,37.5,125z\"/> </g> </svg>\r\n                </div></div>\r\n              </div>\r\n            <div class=\"col3of4\">\r\n              <h1>Data Consolidation</h1>\r\n              <div style=\"text-align: center; margin-top: -15px; margin-bottom: 15px;\"><em>See how we import, process, validate and export data</em></div>\r\n              <p>Linescape combines schedule data with a variety of other data sources. All data is compiled, processed, checked and validated using cutting edge information technology. The resulting live database can be accessed by API or packaged for delivery as a tailor-made bulk data feed.</p>\r\n              <div class=\"text-center\">\r\n                <a [routerLink]=\"['/data-consolidation', { scroll: true }]\" class=\"btn btn-lg\">LEARN MORE</a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"get-started\">\r\n            <div>\r\n              <h2>Get Started Today</h2>\r\n              <h6>Contact us or create a Linescape account.</h6>\r\n            </div>\r\n            <div class=\"buttons-container\">\r\n              <a class=\"btn btn-lg\" [routerLink]=\"['/register', { scroll: true }]\"\r\n                >CREATE ACCOUNT</a\r\n              >\r\n              <a class=\"btn-outline btn-lg\" [routerLink]=\"['/contact', { scroll: true }]\"\r\n                ><div class=\"text-container\">CONTACT US</div></a\r\n              >\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  \r\n"

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = ".d-table {\n  display: table; }\n\n.d-table-cell {\n  display: table-cell; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 457px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 30px 60px;\n  width: 100%; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1, .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3, .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n\n.col-holder {\n  width: calc(100% + 20px);\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: -10px !important; }\n  .col-holder .col1of4, .col-holder .col2of4, .col-holder .col3of4, .col-holder .col4of4 {\n    margin: 0 10px; }\n    .col-holder .col1of4.no-gutter, .col-holder .col2of4.no-gutter, .col-holder .col3of4.no-gutter, .col-holder .col4of4.no-gutter {\n      margin: 0; }\n  .col-holder .col1of4 {\n    -ms-flex: 1 0 calc(25% - 20px);\n        flex: 1 0 calc(25% - 20px); }\n  .col-holder .col3of4 {\n    -ms-flex: 1 0 calc(75% - 20px);\n        flex: 1 0 calc(75% - 20px); }\n\n.feature-box {\n  border: 1px solid #d7d7d7;\n  margin: 30px 0;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3); }\n  .feature-box .col3of4 {\n    padding: 20px; }\n  .feature-box h1 {\n    margin-top: 0;\n    text-align: center;\n    color: #247cbd;\n    font-weight: bold; }\n  .feature-box .btn, .feature-box .btn-outline {\n    margin-top: 20px; }\n  .feature-box .d-table {\n    width: 100%;\n    height: 100%;\n    padding: 20%; }\n  .feature-box .d-table-cell {\n    vertical-align: middle; }\n  .feature-box .text-center .btn, .feature-box .text-center .btn-outline {\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-bottom: 5px; }\n  .feature-box .col1of4 {\n    background-repeat: no-repeat;\n    background-size: cover; }\n  .feature-box:nth-of-type(1) .col1of4 {\n    background-image: url(/img/solutions-background-1.png); }\n  .feature-box:nth-of-type(2) .col1of4 {\n    background-image: url(/img/solutions-background-2.png); }\n  .feature-box:nth-of-type(3) .col1of4 {\n    background-image: url(/img/solutions-background-3.png); }\n  .feature-box:nth-of-type(4) .col1of4 {\n    background-image: url(/img/solutions-background-4.png); }\n\n@media (max-width: 767px) {\n  .feature-box {\n    -ms-flex-direction: column;\n        flex-direction: column; }\n    .feature-box .col1of4 {\n      background: none !important;\n      -ms-flex-order: 0;\n          order: 0; }\n    .feature-box .col3of4 {\n      -ms-flex-order: 1;\n          order: 1; }\n    .feature-box .d-table {\n      padding: 0;\n      padding-top: 30px; }\n    .feature-box .d-table-cell {\n      text-align: center; }\n    .feature-box svg {\n      max-width: 100px;\n      max-height: 100px; }\n      .feature-box svg * {\n        fill: #92ACCA; } }\n\n.get-started {\n  margin: 50px 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  .get-started h2 {\n    color: #247cbd;\n    margin-top: 0;\n    margin-bottom: 5px; }\n  .get-started h6 {\n    color: #666;\n    margin-top: 0; }\n  .get-started .buttons-container {\n    margin-top: 17px; }\n    .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 599px) {\n  .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n"

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(632));


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var SolutionsComponent = (function () {
    function SolutionsComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'Solutions - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';
        // Do stuff
    }
    SolutionsComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    SolutionsComponent = __decorate([
        core_1.Component({
            selector: 'solutions',
            template: __webpack_require__(633),
            styles: [__webpack_require__(634)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], SolutionsComponent);
    return SolutionsComponent;
}());
exports.SolutionsComponent = SolutionsComponent;


/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Solutions</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n          <p>Our customizable Solutions provide access to the most comprehensive selection of global sailing schedules, ships register details and carrier profile information. Our data comprises routes and schedules from over 120 carriers, all of which is regularly updated, allowing shippers and forwarders to quickly and easily find alternatives.</p>\r\n        <div class=\"col-holder feature-box\">\r\n          <div class=\"col3of4\">\r\n            <h1>Online Search</h1>\r\n            <div style=\"text-align: center; margin-top: -15px; margin-bottom: 15px;\"><em>Plans & Pricing to fit your needs and budget</em></div>\r\n            <p>Linescape’s subscription-based Online Search plans put you in control. All packages include items from our Main Features plus Schedule, Carrier and Vessel data. You may upgrade or downgrade any plan at any time, allowing you to choose the plan that’s right, now.</p>\r\n            <div class=\"text-center\"><a [routerLink]=\"['../online-search', { scroll: true }]\" class=\"btn btn-lg\">LEARN MORE</a></div>\r\n          </div>\r\n          <div class=\"col1of4 no-gutter\">\r\n            <div class=\"d-table\">\r\n              <div class=\"d-table-cell\">\r\n                <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 300 300\" style=\"enable-background:new 0 0 300 300;\" xml:space=\"preserve\"> <style type=\"text/css\"> .st0{fill:#FFFFFF;}</style> <g> <circle class=\"st0\" cx=\"181.4\" cy=\"117.4\" r=\"7\"/> <path class=\"st0\" d=\"M292.8,258.3L292.8,258.3l-76.9-76.9c12.4-19,19-41.1,19-63.9C234.9,52.7,182.2,0,117.4,0S0,52.7,0,117.4 s52.7,117.4,117.4,117.4c22.8,0,44.9-6.6,63.9-19l76.9,76.9c4.6,4.6,10.7,7.2,17.3,7.2c6.5,0,12.7-2.5,17.3-7.2 c4.6-4.6,7.2-10.7,7.2-17.3C300,269.1,297.5,262.9,292.8,258.3z M283,283L283,283c-2,2-4.6,3.1-7.4,3.1s-5.4-1.1-7.4-3.1 l-50.7-50.7c5.2-4.6,10.2-9.5,14.8-14.8l50.7,50.7c2,2,3.1,4.6,3.1,7.4C286,278.4,285,281,283,283z M178.1,201.2L178.1,201.2 c-17.7,12.9-38.7,19.7-60.7,19.7C60.4,220.9,14,174.5,14,117.4S60.4,14,117.4,14s103.5,46.4,103.5,103.5c0,21.9-6.8,42.9-19.7,60.7 C194.8,187,187,194.8,178.1,201.2z M178.8,202.2L178.8,202.2L178.8,202.2L178.8,202.2z M222.4,207.6c-4.5,5.3-9.5,10.3-14.8,14.8 l-14.8-14.8c5.4-4.5,10.3-9.4,14.8-14.8L222.4,207.6z\"/> <path class=\"st0\" d=\"M117.4,23.3c-51.9,0-94.2,42.3-94.2,94.2s42.3,94.2,94.2,94.2s94.2-42.3,94.2-94.2S169.4,23.3,117.4,23.3z M117.4,197.7c-44.2,0-80.2-36-80.2-80.2s36-80.2,80.2-80.2s80.2,36,80.2,80.2S161.7,197.7,117.4,197.7z\"/> <path class=\"st0\" d=\"M179.7,101.1c3.6-1.4,5.4-5.4,4-9v0c-5.1-13.2-14-24.6-25.6-32.8c-12-8.4-26-12.8-40.6-12.8c-3.8,0-7,3.1-7,7 s3.1,7,7,7c23.4,0,44.8,14.7,53.2,36.6c1,2.7,3.6,4.5,6.5,4.5C178,101.5,178.9,101.4,179.7,101.1z\"/> </g> </svg>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-holder feature-box\">\r\n          <div class=\"col1of4 no-gutter\">\r\n            <div class=\"d-table\">\r\n              <div class=\"d-table-cell\">\r\n                <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 300 300\" style=\"enable-background:new 0 0 300 300;\" xml:space=\"preserve\"> <style type=\"text/css\"> .st0{fill:#FFFFFF;}</style> <path class=\"st0\" d=\"M131.5,138.5l-13.6,13.6l14.3,14.3c2.6,2.6,2.6,7.1,0,9.7c-1.3,1.3-3,2-4.8,2c-1.8,0-3.6-0.7-4.8-2L103.5,157 c-1.3-1.3-2-3-2-4.8s0.7-3.6,2-4.8l18.4-18.4c2.6-2.6,7.1-2.6,9.7,0C134.2,131.4,134.2,135.7,131.5,138.5z M169,176.6L169,176.6 c1.3,1.3,3,2,4.8,2c1.8,0,3.6-0.7,4.8-2l18.4-18.4c1.3-1.3,2-3,2-4.8s-0.7-3.6-2-4.8l-19.1-19.1c-1.3-1.3-3-2-4.8-2s-3.6,0.7-4.8,2 c-1.3,1.3-2,3-2,4.8s0.7,3.6,2,4.8l14.3,14.3L169,167C166.4,169.5,166.4,173.8,169,176.6z M137.8,191.4c0.7,0.2,1.4,0.4,2.2,0.4 c3,0,5.6-1.9,6.5-4.8l20.7-63.8c1.2-3.6-0.8-7.5-4.4-8.7c-1.8-0.6-3.6-0.4-5.3,0.4c-1.7,0.8-2.9,2.3-3.4,4l-20.7,63.9 C132.1,186.3,134,190.2,137.8,191.4z M151.2,59.8C101.5,59.8,61,100.3,61,150c0,36.4,21.6,69,55.2,83.2c3.5,1.4,7.6-0.1,9-3.6 c1.4-3.5-0.1-7.6-3.6-9c-28.4-12-46.7-39.7-46.7-70.5c0-42.2,34.4-76.6,76.6-76.6s76.6,34.4,76.6,76.6s-34.4,76.6-76.6,76.6 c-3.5,0-7.1-0.2-10.5-0.7c-1.8-0.2-3.6,0.2-5,1.3c-1.4,1.1-2.4,2.8-2.6,4.6c-0.5,3.7,2.2,7.2,5.9,7.7c4.1,0.6,8.2,0.8,12.4,0.8 c49.8,0,90.3-40.5,90.3-90.3C241.5,100.3,201,59.8,151.2,59.8z M300.4,140.2v19.7c0,7.2-5.4,13.1-12.5,13.7l-15.5,1.4 c-1.2,5.9-2.9,11.8-4.9,17.5l12.5,9.3c5.8,4.3,7.2,12.1,3.5,18.3l-10.3,16.8c-3.7,6.1-11.4,8.3-17.9,5.2l-13.9-7 c-2.9,3.1-5.9,6-9.1,8.8l6.4,14.2c3,6.5,0.5,14.2-5.8,17.7l-17.2,9.7c-6.2,3.5-14.1,1.8-18.1-4.2l-8.9-12.7 c-4.3,1.4-8.9,2.6-13.3,3.5l-1.4,15.5c-0.6,7.1-6.5,12.5-13.7,12.5h-19.7c-7.2,0-13.1-5.4-13.7-12.5l-1.4-15.5 c-5.9-1.2-11.8-2.9-17.5-4.9l-9.1,12.6c-4.3,5.8-12.1,7.2-18.3,3.5l-16.8-10.3c-6.1-3.7-8.3-11.4-5.2-17.9l7-13.9 c-3.1-2.9-6-5.9-8.8-9.1l-14.2,6.4c-6.5,3-14.2,0.5-17.7-5.8l-9.7-17.2c-3.5-6.2-1.8-14.1,4.2-18.1l12.7-8.9 c-1.4-4.3-2.6-8.9-3.5-13.3l-15.5-1.4c-7.1-0.6-12.5-6.5-12.5-13.7V140c0-7.2,5.4-13.1,12.5-13.7l15.5-1.4 c1.2-5.9,2.9-11.8,4.9-17.5l-12.5-9.3c-5.8-4.3-7.2-12.1-3.5-18.3L27.6,63c3.7-6.1,11.4-8.3,17.9-5.2l13.9,7c2.9-3.1,5.9-6,9.1-8.8 L61.9,42c-3-6.5-0.5-14.2,5.8-17.7l17.2-9.7c6.2-3.5,14.1-1.8,18.1,4.2l8.9,12.7c4.3-1.4,8.9-2.6,13.3-3.5l1.4-15.5 c0.6-7.2,6.5-12.6,13.7-12.6h19.7c7.2,0,13.1,5.4,13.7,12.5l1.4,15.5c5.9,1.2,11.8,2.9,17.5,4.9l9.3-12.5c4.3-5.8,12.1-7.2,18.3-3.5 l16.8,10.3c6.1,3.7,8.3,11.4,5.2,17.9l-7,13.9c3.1,2.9,6,5.9,8.8,9.1l14.2-6.4c6.5-3,14.2-0.5,17.7,5.8l9.7,17.2 c3.5,6.2,1.8,14.1-4.2,18.1l-12.7,8.8c1.4,4.3,2.6,8.9,3.5,13.3l15.5,1.4C294.9,127.1,300.4,133,300.4,140.2z M265.9,161.8l20.8-1.9 v-19.7l-20.8-1.9c-3.1-0.2-5.6-2.6-6.1-5.8c-1.2-7.2-3-14.3-5.5-21.2c-1.1-3,0-6.2,2.5-8.1l17.1-11.8l-9.7-17.2l-19,8.5 c-2.9,1.3-6.2,0.5-8.2-1.9c-4.3-5.4-9.1-10.5-14.4-14.9c-2.4-2-3.1-5.4-1.7-8.3l9.3-18.6l-16.8-10.3l-12.6,16.6 c-1.9,2.5-5.3,3.5-8.2,2.3c-7.9-3.2-16.2-5.6-24.8-7c-3.1-0.5-5.5-3-5.8-6.1L160,13.9h-19.8l-1.9,20.8c-0.2,3.1-2.6,5.6-5.8,6.1 c-7.2,1.2-14.3,3-21.2,5.5c-3,1.1-6.2,0-8.1-2.5L91.5,26.7l-17.1,9.5l8.7,19c1.3,2.9,0.5,6.2-1.9,8.2c-5.4,4.3-10.5,9.3-14.9,14.4 c-2,2.4-5.4,3.1-8.3,1.7l-18.6-9.3L29,87.1l16.5,12.6c2.5,1.9,3.5,5.3,2.3,8.2c-3.2,7.9-5.6,16.2-7,24.8c-0.5,3.1-3,5.5-6.1,5.8 L14,140.3v19.8l20.8,1.9c3.1,0.2,5.6,2.6,6.1,5.8c1.2,7.2,3,14.3,5.5,21.2c1.1,3,0,6.2-2.5,8.1l-17.1,11.8l9.7,17.2l19-8.5 c2.9-1.3,6.2-0.5,8.2,1.9c4.3,5.4,9.3,10.5,14.4,14.9c2.4,2,3.1,5.4,1.7,8.3l-9.3,18.6l16.8,10.3l12.5-16.7c1.3-1.7,3.4-2.8,5.5-2.8 c1,0,1.8,0.1,2.6,0.5c7.9,3.2,16.2,5.6,24.8,7c3.1,0.5,5.5,3,5.8,6.1l1.9,20.7h19.8l1.9-20.8c0.2-3.1,2.6-5.6,5.8-6.1 c7.2-1.2,14.3-3,21.2-5.5c3-1.1,6.2,0,8.1,2.5l11.8,17.1l17.2-9.7l-8.5-19c-1.3-2.9-0.5-6.2,1.9-8.2c5.4-4.3,10.5-9.1,14.9-14.4 c2-2.4,5.4-3.1,8.3-1.7l18.6,9.3l10.3-16.8l-16.7-12.5c-2.5-1.9-3.5-5.3-2.3-8.2c3.2-7.9,5.6-16.2,7-24.8 C260.2,164.4,262.7,162,265.9,161.8z M177.8,84.8c-8.8-3.7-18-5.5-27.6-5.5c-39.1,0-70.9,31.8-70.9,70.9s31.8,70.9,70.9,70.9 s70.9-31.8,70.9-70.9c0-19.9-8.4-39.1-23.2-52.4c-1.3-1.2-3.1-1.9-4.9-1.8s-3.5,0.8-4.8,2.3c-1.2,1.3-1.9,3.1-1.8,4.9 s0.8,3.5,2.3,4.8c11.9,10.8,18.6,26.2,18.6,42.3c0,31.5-25.6,57.1-57.1,57.1s-57.1-25.6-57.1-57.1s25.6-57.1,57.1-57.1 c7.7,0,15.1,1.6,22.2,4.4c1.7,0.7,3.6,0.7,5.3,0s3-2,3.7-3.7s0.7-3.6,0-5.3C180.8,86.8,179.5,85.5,177.8,84.8z\"/> </svg>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col3of4\">\r\n            <h1>API Data-on-Demand</h1>\r\n            <div style=\"text-align: center; margin-top: -15px; margin-bottom: 15px;\"><em>Only the data you need, when you need it</em></div>\r\n            <p>API Data-on-Demand takes the hassle out of hosting data on your system so you can focus on what you do best – running your business. Data is easily accessible via a highly compatible web service, and provides content that’s tailor-made to your exact requirements, whenever you need it, one search at a time.</p>\r\n            <div class=\"text-center\"><a [routerLink]=\"['../api-data-on-demand', { scroll: true }]\" class=\"btn btn-lg\">LEARN MORE</a></div>\r\n            \r\n          </div>\r\n        </div>\r\n        <div class=\"col-holder feature-box\">\r\n          <div class=\"col3of4\">\r\n            <h1>Bulk Data Feeds</h1>\r\n            <div style=\"text-align: center; margin-top: -15px; margin-bottom: 15px;\"><em>Integrate schedule and vessel data into your IT system</em></div>\r\n            <p>Today's fast-paced business environment requires a data mining solution that’s designed for the 21st century. Linescape’s Bulk Data Feeds quickly and efficiently aggregate data directly into your system, in the format that you prefer, saving you time – and money. </p>\r\n            <div class=\"text-center\"><a [routerLink]=\"['../bulk-data-feeds', { scroll: true }]\" class=\"btn btn-lg\">LEARN MORE</a></div>\r\n          </div>\r\n          <div class=\"col1of4 no-gutter\">\r\n              <div class=\"d-table\">\r\n                  <div class=\"d-table-cell\">\r\n              <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 300 300\" style=\"enable-background:new 0 0 300 300;\" xml:space=\"preserve\"> <style type=\"text/css\"> .st0{fill:#FFFFFF;}</style> <g> <path class=\"st0\" d=\"M53.3,34.1c-12.9,0-23.5,10.5-23.5,23.5s10.5,23.5,23.5,23.5s23.5-10.5,23.5-23.5S66.2,34.1,53.3,34.1z M64.5,57.6c0,6.2-5,11.2-11.2,11.2S42,63.8,42,57.6s5-11.2,11.2-11.2S64.5,51.4,64.5,57.6z\"/> <path class=\"st0\" d=\"M255.3,50.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1 C252.6,56.2,255.3,53.5,255.3,50.1z\"/> <path class=\"st0\" d=\"M235.5,50.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1 C232.8,56.2,235.5,53.5,235.5,50.1z\"/> <path class=\"st0\" d=\"M259.2,58.9c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1 C265.3,61.6,262.5,58.9,259.2,58.9z\"/> <path class=\"st0\" d=\"M239.3,58.9c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1 C245.4,61.6,242.7,58.9,239.3,58.9z\"/> <path class=\"st0\" d=\"M215.7,50.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1 C212.9,56.2,215.7,53.5,215.7,50.1z\"/> <path class=\"st0\" d=\"M219.5,58.9c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1 C225.6,61.6,222.8,58.9,219.5,58.9z\"/> <path class=\"st0\" d=\"M195.8,50.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1 C193.1,56.2,195.8,53.5,195.8,50.1z\"/> <path class=\"st0\" d=\"M199.6,58.9c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1 C205.7,61.6,203,58.9,199.6,58.9z\"/> <path class=\"st0\" d=\"M176,50.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1C173.2,56.2,176,53.5,176,50.1z \"/> <path class=\"st0\" d=\"M179.8,58.9c-3.4,0-6.1,2.7-6.1,6.1c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1 C185.9,61.6,183.1,58.9,179.8,58.9z\"/> <path class=\"st0\" d=\"M300,86.8V28.3c0-13.2-10.8-24-24-24H24c-13.2,0-24,10.8-24,24v58.5c0,6.9,3,13.3,8.2,17.9 C3,109.3,0,115.7,0,122.6v58.5c0,13.2,10.8,24,24,24h121.2c-0.8,1-1.3,2.4-1.3,3.8v5c0,3.4,2.7,6.1,6.1,6.1s6.1-2.7,6.1-6.1v-5 c0-1.4-0.5-2.8-1.3-3.8H276c13.2,0,24-10.8,24-24v-58.5c0-6.9-3-13.3-8.2-17.9C297,100.1,300,93.7,300,86.8z M276,98.6H23.7 c-6.3-0.2-11.4-5.4-11.4-11.8V28.3c0-6.5,5.3-11.8,11.8-11.8h252c6.5,0,11.8,5.3,11.8,11.8v58.5C287.8,93.3,282.5,98.6,276,98.6z M12.2,122.6c0-6.5,5.3-11.8,11.8-11.8h252c6.5,0,11.8,5.3,11.8,11.8v58.5c0,6.5-5.3,11.8-11.8,11.8H24c0,0,0,0,0,0 c-3.1,0-6.1-1.2-8.3-3.5c-2.2-2.2-3.5-5.2-3.5-8.3V122.6z\"/> <path class=\"st0\" d=\"M53.3,175.3c12.9,0,23.5-10.5,23.5-23.5s-10.5-23.5-23.5-23.5s-23.5,10.5-23.5,23.5S40.3,175.3,53.3,175.3z M42,151.8c0-6.2,5-11.2,11.2-11.2s11.2,5,11.2,11.2c0,6.2-5,11.2-11.2,11.2S42,158,42,151.8z\"/> <path class=\"st0\" d=\"M154.4,248.1c-1.7,2.9-0.6,6.7,2.3,8.3l0,0c1,0.6,2,1.3,2.9,2.2c1.2,1.1,2.7,1.7,4.3,1.7 c1.7,0,3.2-0.7,4.4-1.8c2.4-2.4,2.3-6.3-0.1-8.7c-1.6-1.6-3.4-2.9-5.4-4.1C159.8,244.2,156.1,245.2,154.4,248.1z\"/> <path class=\"st0\" d=\"M156.9,280.3L156.9,280.3c-1,0.6-2.1,1.1-3.3,1.4c-3.3,0.9-5.2,4.2-4.3,7.5c0.7,2.7,3.2,4.5,5.9,4.5 c0.5,0,1.1-0.1,1.6-0.2c2.2-0.6,4.3-1.5,6.3-2.6c2.9-1.7,3.9-5.5,2.2-8.4C163.6,279.6,159.8,278.6,156.9,280.3z\"/> <path class=\"st0\" d=\"M169.8,262.2c-3.4,0-6.1,2.8-6.1,6.2c0,1.2-0.2,2.4-0.5,3.5c-0.4,1.6-0.2,3.2,0.6,4.6c0.8,1.4,2.1,2.4,3.7,2.8 c0.5,0.1,1,0.2,1.6,0.2c2.8,0,5.2-1.9,5.9-4.5c0.6-2.2,0.9-4.4,0.9-6.7v-0.2C176,264.8,173.3,262.2,169.8,262.2z\"/> <path class=\"st0\" d=\"M143.2,280.3L143.2,280.3c-1-0.6-2-1.3-2.8-2.2c-2.4-2.4-6.3-2.4-8.7,0c-1.2,1.2-1.8,2.7-1.8,4.3 c0,1.6,0.6,3.2,1.8,4.3c1.6,1.6,3.4,3,5.4,4.1c0.9,0.5,2,0.8,3,0.8c2.2,0,4.2-1.2,5.3-3.1C147.1,285.8,146.1,282,143.2,280.3z\"/> <path class=\"st0\" d=\"M150.6,247.7c-0.9-3.2-4.3-5.2-7.5-4.3l0,0c-2.2,0.6-4.3,1.5-6.2,2.6c-1.4,0.8-2.4,2.2-2.8,3.7 c-0.4,1.6-0.2,3.2,0.7,4.6c1.1,1.9,3.1,3,5.3,3c1.1,0,2.2-0.3,3.1-0.8c1-0.6,2.1-1.1,3.3-1.4c1.6-0.4,2.9-1.5,3.7-2.9 C150.8,250.9,151,249.3,150.6,247.7z\"/> <path class=\"st0\" d=\"M130.2,274.6c1.6,0,3.1-0.6,4.3-1.8c1.2-1.2,1.8-2.7,1.8-4.4c0-1.2,0.1-2.3,0.4-3.5c0.8-3.3-1.1-6.6-4.4-7.5 c-3.3-0.8-6.6,1.1-7.5,4.4c-0.5,1.8-0.7,3.6-0.8,5.5l0,2.3h0.1C124.7,272.5,127.2,274.6,130.2,274.6 C130.2,274.6,130.2,274.6,130.2,274.6z\"/> <path class=\"st0\" d=\"M249.2,150.5c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1 C243.1,147.8,245.9,150.5,249.2,150.5z\"/> <path class=\"st0\" d=\"M229.4,150.5c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1c-3.4,0-6.1,2.7-6.1,6.1 C223.3,147.8,226,150.5,229.4,150.5z\"/> <circle class=\"st0\" cx=\"259.2\" cy=\"159.3\" r=\"6.1\"/> <circle class=\"st0\" cx=\"239.3\" cy=\"159.3\" r=\"6.1\"/> <circle class=\"st0\" cx=\"209.5\" cy=\"144.4\" r=\"6.1\"/> <path class=\"st0\" d=\"M213.3,159.3c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1 C216.1,153.2,213.3,155.9,213.3,159.3z\"/> <circle class=\"st0\" cx=\"189.7\" cy=\"144.4\" r=\"6.1\"/> <path class=\"st0\" d=\"M193.5,159.3c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1 C196.2,153.2,193.5,155.9,193.5,159.3z\"/> <circle class=\"st0\" cx=\"169.8\" cy=\"144.4\" r=\"6.1\"/> <path class=\"st0\" d=\"M173.6,159.3c0,3.4,2.7,6.1,6.1,6.1c3.4,0,6.1-2.7,6.1-6.1c0-3.4-2.7-6.1-6.1-6.1 C176.4,153.2,173.6,155.9,173.6,159.3z\"/> <path class=\"st0\" d=\"M110.3,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S113.7,262.3,110.3,262.3z\"/> <path class=\"st0\" d=\"M70.6,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S74,262.3,70.6,262.3z\"/> <path class=\"st0\" d=\"M90.5,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S93.8,262.3,90.5,262.3z\"/> <path class=\"st0\" d=\"M11.1,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S14.5,262.3,11.1,262.3z\"/> <path class=\"st0\" d=\"M30.9,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S34.3,262.3,30.9,262.3z\"/> <path class=\"st0\" d=\"M50.8,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S54.1,262.3,50.8,262.3z\"/> <path class=\"st0\" d=\"M194.7,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S198,262.3,194.7,262.3z\"/> <path class=\"st0\" d=\"M234.3,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S237.7,262.3,234.3,262.3z\"/> <path class=\"st0\" d=\"M214.5,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S217.9,262.3,214.5,262.3z\"/> <path class=\"st0\" d=\"M293.9,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S297.3,262.3,293.9,262.3z\"/> <path class=\"st0\" d=\"M254.2,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S257.6,262.3,254.2,262.3z\"/> <path class=\"st0\" d=\"M274,262.3h-5c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1h5c3.4,0,6.1-2.7,6.1-6.1S277.4,262.3,274,262.3z\"/> <path class=\"st0\" d=\"M150,222.6c-3.4,0-6.1,2.7-6.1,6.1v5c0,3.4,2.7,6.1,6.1,6.1s6.1-2.7,6.1-6.1v-5 C156.1,225.4,153.4,222.6,150,222.6z\"/> </g> </svg>\r\n              </div></div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-holder feature-box\">\r\n            <div class=\"col1of4 no-gutter\">\r\n                <div class=\"d-table\">\r\n                    <div class=\"d-table-cell\">\r\n              <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 300 300\" style=\"enable-background:new 0 0 300 300;\" xml:space=\"preserve\"> <style type=\"text/css\"> .st0{fill:#FFFFFF;}</style> <g> <path class=\"st0\" d=\"M293.7,287.5h-6.2V106.3c0-3.5-2.8-6.3-6.3-6.3h-37.5c-3.4,0-6.3,2.8-6.3,6.3v181.2h-25V181.3 c0-3.5-2.8-6.3-6.3-6.3h-37.5c-3.4,0-6.3,2.8-6.3,6.3v106.2h-25V156.3c0-3.4-2.8-6.3-6.3-6.3H93.7c-3.4,0-6.3,2.8-6.3,6.3v131.2 h-25v-68.8c0-3.4-2.8-6.2-6.3-6.2H18.8c-3.4,0-6.3,2.8-6.3,6.3v68.7H6.3c-3.4,0-6.3,2.8-6.3,6.2c0,3.5,2.8,6.3,6.3,6.3h12.5h37.5 h37.5c0,0,0,0,0,0h37.5c0,0,0,0,0,0h37.5c0,0,0,0,0,0h37.5c0,0,0,0,0,0h37.5c0,0,0,0,0,0h37.5c0,0,0,0,0,0h12.5 c3.5,0,6.3-2.8,6.3-6.3C300,290.3,297.2,287.5,293.7,287.5z M250,112.5h25v175h-25V112.5z M175,187.5h25v100h-25V187.5z M100,162.5 h25v125h-25V162.5z M50,287.5H25V225h25L50,287.5L50,287.5z\"/> <path class=\"st0\" d=\"M37.5,162.5c13.8,0,25-11.2,25-25c0-4.4-1.1-8.5-3.1-12.1L97.5,95c4.2,3.1,9.4,5,15,5c9.2,0,17.2-5,21.5-12.4 l28.8,8.2c-0.2,1.3-0.4,2.7-0.4,4.1c0,13.8,11.2,25,25,25s25-11.2,25-25c0-4.6-1.3-9-3.5-12.7l40.8-40.8c3.7,2.2,8,3.5,12.7,3.5 c13.8,0,25-11.2,25-25s-11.2-25-25-25c-13.8,0-25,11.2-25,25c0,4.6,1.3,9,3.5,12.7l-40.8,40.8c-3.7-2.2-8-3.5-12.7-3.5 c-7.9,0-14.9,3.7-19.5,9.3l-30.6-8.7c0-0.2,0-0.4,0-0.6c0-13.8-11.2-25-25-25s-25,11.2-25,25c0,3.6,0.8,7.1,2.2,10.2l-39,31.1 c-3.8-2.4-8.3-3.8-13.2-3.8c-13.8,0-25,11.2-25,25S23.7,162.5,37.5,162.5z M262.5,12.5c6.9,0,12.5,5.6,12.5,12.5 c0,6.9-5.6,12.5-12.5,12.5c-3.4,0-6.5-1.4-8.8-3.6c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c-2.2-2.3-3.6-5.4-3.6-8.8 C250,18.1,255.6,12.5,262.5,12.5z M187.5,87.5c6.9,0,12.5,5.6,12.5,12.5c0,6.9-5.6,12.5-12.5,12.5S175,106.9,175,100 C175,93.1,180.6,87.5,187.5,87.5z M112.5,62.5c6.9,0,12.5,5.6,12.5,12.5c0,6.9-5.6,12.5-12.5,12.5c-3.9,0-7.4-1.8-9.7-4.6 c0,0,0-0.1-0.1-0.1c0,0,0,0,0-0.1c-1.7-2.1-2.7-4.8-2.7-7.7C100,68.1,105.6,62.5,112.5,62.5z M37.5,125c6.9,0,12.5,5.6,12.5,12.5 c0,6.9-5.6,12.5-12.5,12.5S25,144.4,25,137.5C25,130.6,30.6,125,37.5,125z\"/> </g> </svg>\r\n              </div></div>\r\n            </div>\r\n          <div class=\"col3of4\">\r\n            <h1>Analytics & Reporting</h1>\r\n            <div style=\"text-align: center; margin-top: -15px; margin-bottom: 15px;\"><em>Informed business decisions start with data-driven insights</em></div>\r\n            <p>The best business decisions start with data-driven insights. Linescape's analytics combine up-to-date schedule data with cutting-edge technology that helps our members make the most informed decisions possible – for today or for future planning.</p>\r\n            <div class=\"text-center\">\r\n              <a [routerLink]=\"['../analytics-reporting', { scroll: true }]\" class=\"btn btn-lg\">LEARN MORE</a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"get-started\">\r\n          <div>\r\n            <h2>Get Started Today</h2>\r\n            <h6>Contact us or create a Linescape account.</h6>\r\n          </div>\r\n          <div class=\"buttons-container\">\r\n            <a class=\"btn btn-lg\" [routerLink]=\"['/register', { scroll: true }]\"\r\n              >CREATE ACCOUNT</a\r\n            >\r\n            <a class=\"btn-outline btn-lg\" [routerLink]=\"['/contact', { scroll: true }]\"\r\n              ><div class=\"text-container\">CONTACT US</div></a\r\n            >\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = ".d-table {\n  display: table; }\n\n.d-table-cell {\n  display: table-cell; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 457px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 30px 60px;\n  width: 100%; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1, .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3, .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n\n.col-holder {\n  width: calc(100% + 20px);\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: -10px !important; }\n  .col-holder .col1of4, .col-holder .col2of4, .col-holder .col3of4, .col-holder .col4of4 {\n    margin: 0 10px; }\n    .col-holder .col1of4.no-gutter, .col-holder .col2of4.no-gutter, .col-holder .col3of4.no-gutter, .col-holder .col4of4.no-gutter {\n      margin: 0; }\n  .col-holder .col1of4 {\n    -ms-flex: 1 0 calc(25% - 20px);\n        flex: 1 0 calc(25% - 20px); }\n  .col-holder .col3of4 {\n    -ms-flex: 1 0 calc(75% - 20px);\n        flex: 1 0 calc(75% - 20px); }\n\n.feature-box {\n  border: 1px solid #d7d7d7;\n  margin: 30px 0;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3); }\n  .feature-box .col3of4 {\n    padding: 20px; }\n  .feature-box h1 {\n    margin-top: 0;\n    text-align: center;\n    color: #247cbd;\n    font-weight: bold; }\n  .feature-box .btn, .feature-box .btn-outline {\n    margin-top: 20px; }\n  .feature-box .d-table {\n    width: 100%;\n    height: 100%;\n    padding: 20%; }\n  .feature-box .d-table-cell {\n    vertical-align: middle; }\n  .feature-box .text-center .btn, .feature-box .text-center .btn-outline {\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-bottom: 5px; }\n  .feature-box .col1of4 {\n    background-repeat: no-repeat;\n    background-size: cover; }\n  .feature-box:nth-of-type(1) .col1of4 {\n    background-image: url(/img/solutions-background-1.png); }\n  .feature-box:nth-of-type(2) .col1of4 {\n    background-image: url(/img/solutions-background-2.png); }\n  .feature-box:nth-of-type(3) .col1of4 {\n    background-image: url(/img/solutions-background-3.png); }\n  .feature-box:nth-of-type(4) .col1of4 {\n    background-image: url(/img/solutions-background-4.png); }\n\n@media (max-width: 767px) {\n  .feature-box {\n    -ms-flex-direction: column;\n        flex-direction: column; }\n    .feature-box .col1of4 {\n      background: none !important;\n      -ms-flex-order: 0;\n          order: 0; }\n    .feature-box .col3of4 {\n      -ms-flex-order: 1;\n          order: 1; }\n    .feature-box .d-table {\n      padding: 0;\n      padding-top: 30px; }\n    .feature-box .d-table-cell {\n      text-align: center; }\n    .feature-box svg {\n      max-width: 100px;\n      max-height: 100px; }\n      .feature-box svg * {\n        fill: #92ACCA; } }\n\n.get-started {\n  margin: 50px 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  .get-started h2 {\n    color: #247cbd;\n    margin-top: 0;\n    margin-bottom: 5px; }\n  .get-started h6 {\n    color: #666;\n    margin-top: 0; }\n  .get-started .buttons-container {\n    margin-top: 17px; }\n    .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 599px) {\n  .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n"

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(636));


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var WhatWeDoComponent = (function () {
    function WhatWeDoComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'What We Do - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';
        // Do stuff
    }
    WhatWeDoComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    WhatWeDoComponent = __decorate([
        core_1.Component({
            selector: 'what-we-do',
            template: __webpack_require__(637),
            styles: [__webpack_require__(638)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], WhatWeDoComponent);
    return WhatWeDoComponent;
}());
exports.WhatWeDoComponent = WhatWeDoComponent;


/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>What We Do</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-full\">\r\n            <div id=\"what-we-do\">\r\n              <p>Linescape is the leading independent resource for searching and finding ocean container shipping routes\r\n                and schedules. Shippers and forwarders now have everything they need for researching the best route for\r\n                shipping their goods with the shipping line of their choice, at their fingertips.</p>\r\n\r\n              <p>The best business decisions start with data-driven insights. Linescape combines up-to-date schedule\r\n                data with cutting-edge technology that helps our members make the most informed decisions possible – for\r\n                today or for future planning.</p>\r\n              <ul>\r\n                <li>Our customizable <a [routerLink]=\"['/solutions', { scroll: true }]\">Solutions</a> provide access to\r\n                  the most\r\n                  comprehensive selection of global sailing schedules, ships register details and carrier profile\r\n                  information, plus tools to assist with cargo movement priority setting. </li>\r\n\r\n                <li>Linescape’s variety of <a [routerLink]=\"['/application', { scroll: true }]\">Applications</a> lets\r\n                  logistics\r\n                  professionals search schedules from any view: by port pairs, by vessel name, by port of call or by\r\n                  carrier. </li>\r\n\r\n                <li>Our data comprises routes and schedules from over 120 carriers, all of which is regularly updated,\r\n                  allowing shippers and forwarders to quickly and easily find alternatives.</li>\r\n              </ul>\r\n\r\n              <p>Whether you’re planning container bookings or analyzing vessel movements, Linescape has the most\r\n                comprehensive sailing schedule database. Complete, accurate and updated continuously, our schedule data\r\n                is available to logistics professionals – anytime, anywhere.</p><br>\r\n              <div class=\"text-center\"><a [routerLink]=\"['/subscribe', { scroll: true }]\" class=\"btn btn-lg\">Get Started\r\n                  Today</a></div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"get-started\">\r\n        <div>\r\n          <h2>Get Started Today</h2>\r\n          <h6>Contact us or create a Linescape account.</h6>\r\n        </div>\r\n        <div class=\"buttons-container\">\r\n          <a class=\"btn btn-lg\" [routerLink]=\"['/register', { scroll: true }]\">CREATE\r\n            ACCOUNT</a>\r\n          <a class=\"btn-outline btn-lg\" [routerLink]=\"['/contact', { scroll: true }]\">\r\n            <div class=\"text-container\">CONTACT US</div>\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = ".d-table {\n  display: table; }\n\n.d-table-cell {\n  display: table-cell; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 456px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 50px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-full {\n    vertical-align: top; }\n    .page-content .page-content-full p, .page-content .page-content-full li, .page-content .page-content-full div, .page-content .page-content-full label {\n      font-size: 18px;\n      line-height: 32px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n.team-section {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n  .team-section .pure-g .founder {\n    cursor: pointer;\n    width: 96%;\n    overflow: hidden; }\n  .team-section .pure-g .pure-u-1-2 .team-text, .team-section .pure-g .pure-u-1-4 .team-text {\n    padding: 0 10px 10px 10px; }\n  .team-section .pure-g .pure-u-1-2 h1, .team-section .pure-g .pure-u-1-2 h2, .team-section .pure-g .pure-u-1-2 h3, .team-section .pure-g .pure-u-1-2 h4, .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-2 h6, .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-2 label, .team-section .pure-g .pure-u-1-2 li, .team-section .pure-g .pure-u-1-4 h1, .team-section .pure-g .pure-u-1-4 h2, .team-section .pure-g .pure-u-1-4 h3, .team-section .pure-g .pure-u-1-4 h4, .team-section .pure-g .pure-u-1-4 h5, .team-section .pure-g .pure-u-1-4 h6, .team-section .pure-g .pure-u-1-4 p, .team-section .pure-g .pure-u-1-4 label, .team-section .pure-g .pure-u-1-4 li {\n    color: #ffffff; }\n  .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-4 h5 {\n    font-weight: bold;\n    line-height: 32px;\n    color: #ffffff;\n    font-size: 20px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0; }\n  .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-4 p {\n    line-height: 20px;\n    margin-bottom: 5px; }\n  .team-section .pure-g .pure-u-1-2 img, .team-section .pure-g .pure-u-1-4 img {\n    max-width: 100%;\n    width: 100%;\n    transition: all 0.3s;\n    transform: scale(1); }\n  .team-section .pure-g .pure-u-1-2 .founder img:hover, .team-section .pure-g .pure-u-1-4 .founder img:hover {\n    transform: scale(1.1);\n    padding-bottom: 15px; }\n  .team-section .pure-g .team-text.bio h5:hover {\n    color: #fc7d17;\n    cursor: pointer; }\n  .team-section .team-member {\n    margin: 10px;\n    background-color: #393939; }\n\n#who-we-are {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n\n.page-content .quote {\n  padding-top: 20px;\n  font-size: 16px;\n  color: #7a7a7a;\n  width: 80%;\n  margin: 0 auto;\n  font-style: italic; }\n\n.page-content .quote-by {\n  font-size: 16px;\n  text-align: right;\n  color: #7a7a7a; }\n\n/*** MODAL CSS ***/\n.modal {\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: black;\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */ }\n\n/* Modal Content/Box */\n.modal-content {\n  background-color: #fefefe;\n  margin: 15% auto;\n  /* 15% from the top and centered */\n  padding: 50px;\n  border: 1px solid #888;\n  width: 80%;\n  /* Could be more or less, depending on screen size */ }\n\n/* The Close Button */\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold; }\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer; }\n\n.get-started {\n  padding: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  border-top: 1px solid #e9e9e9; }\n  .get-started h2 {\n    color: #247cbd; }\n  .get-started h6 {\n    color: #666; }\n  .get-started .buttons-container {\n    margin-top: 17px; }\n    .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 479px) {\n  .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n\n@media only screen and (max-width: 1023px) {\n  .pure-u-1-4, .pure-u-6-24 {\n    width: 50%; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; }\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(50% - 20px); }\n  .team-section .col-holder.full-width-team {\n    display: none; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; }\n  .pure-u-1-2, .pure-u-1-4 {\n    width: 100%; } }\n\n@media only screen and (max-width: 599px) {\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(100% - 20px); } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(640));


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var OnlineSearchComponent = (function () {
    function OnlineSearchComponent(route, seo, app) {
        this.route = route;
        this.seo = seo;
        this.app = app;
        this.title = 'Online Search - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';
        // Do stuff
    }
    OnlineSearchComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    OnlineSearchComponent = __decorate([
        core_1.Component({
            selector: 'online-search',
            styles: [__webpack_require__(641), __webpack_require__(16)],
            template: __webpack_require__(642)
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService, shared_1.AppContext])
    ], OnlineSearchComponent);
    return OnlineSearchComponent;
}());
exports.OnlineSearchComponent = OnlineSearchComponent;


/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = ".d-table {\n  display: table; }\n\n.d-table-cell {\n  display: table-cell; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 456px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 50px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-full {\n    vertical-align: top; }\n    .page-content .page-content-full p, .page-content .page-content-full li, .page-content .page-content-full div, .page-content .page-content-full label {\n      font-size: 18px;\n      line-height: 32px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n.team-section {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n  .team-section .pure-g .founder {\n    cursor: pointer;\n    width: 96%;\n    overflow: hidden; }\n  .team-section .pure-g .pure-u-1-2 .team-text, .team-section .pure-g .pure-u-1-4 .team-text {\n    padding: 0 10px 10px 10px; }\n  .team-section .pure-g .pure-u-1-2 h1, .team-section .pure-g .pure-u-1-2 h2, .team-section .pure-g .pure-u-1-2 h3, .team-section .pure-g .pure-u-1-2 h4, .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-2 h6, .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-2 label, .team-section .pure-g .pure-u-1-2 li, .team-section .pure-g .pure-u-1-4 h1, .team-section .pure-g .pure-u-1-4 h2, .team-section .pure-g .pure-u-1-4 h3, .team-section .pure-g .pure-u-1-4 h4, .team-section .pure-g .pure-u-1-4 h5, .team-section .pure-g .pure-u-1-4 h6, .team-section .pure-g .pure-u-1-4 p, .team-section .pure-g .pure-u-1-4 label, .team-section .pure-g .pure-u-1-4 li {\n    color: #ffffff; }\n  .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-4 h5 {\n    font-weight: bold;\n    line-height: 32px;\n    color: #ffffff;\n    font-size: 20px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0; }\n  .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-4 p {\n    line-height: 20px;\n    margin-bottom: 5px; }\n  .team-section .pure-g .pure-u-1-2 img, .team-section .pure-g .pure-u-1-4 img {\n    max-width: 100%;\n    width: 100%;\n    transition: all 0.3s;\n    transform: scale(1); }\n  .team-section .pure-g .pure-u-1-2 .founder img:hover, .team-section .pure-g .pure-u-1-4 .founder img:hover {\n    transform: scale(1.1);\n    padding-bottom: 15px; }\n  .team-section .pure-g .team-text.bio h5:hover {\n    color: #fc7d17;\n    cursor: pointer; }\n  .team-section .team-member {\n    margin: 10px;\n    background-color: #393939; }\n\n#who-we-are {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n\n.page-content .quote {\n  padding-top: 20px;\n  font-size: 16px;\n  color: #7a7a7a;\n  width: 80%;\n  margin: 0 auto;\n  font-style: italic; }\n\n.page-content .quote-by {\n  font-size: 16px;\n  text-align: right;\n  color: #7a7a7a; }\n\n/*** MODAL CSS ***/\n.modal {\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: black;\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */ }\n\n/* Modal Content/Box */\n.modal-content {\n  background-color: #fefefe;\n  margin: 15% auto;\n  /* 15% from the top and centered */\n  padding: 50px;\n  border: 1px solid #888;\n  width: 80%;\n  /* Could be more or less, depending on screen size */ }\n\n/* The Close Button */\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold; }\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer; }\n\n.get-started {\n  padding: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  border-top: 1px solid #e9e9e9; }\n  .get-started h2 {\n    color: #247cbd; }\n  .get-started h6 {\n    color: #666; }\n  .get-started .buttons-container {\n    margin-top: 17px; }\n    .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 479px) {\n  .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n\n@media only screen and (max-width: 1023px) {\n  .pure-u-1-4, .pure-u-6-24 {\n    width: 50%; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; }\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(50% - 20px); }\n  .team-section .col-holder.full-width-team {\n    display: none; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; }\n  .pure-u-1-2, .pure-u-1-4 {\n    width: 100%; } }\n\n@media only screen and (max-width: 599px) {\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(100% - 20px); } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n\n.schedule-image {\n  padding: 15px;\n  padding-top: 30px; }\n  .schedule-image img {\n    width: 100%; }\n\nhr {\n  margin-top: 30px; }\n"

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = "  <div class=\"page-banner\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-banner-inner\">\r\n        <h2>Online Search</h2>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"main-content\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n            <h6>Plans & Pricing to fit your needs and budget</h6>\r\n              <p>Linescape’s subscription-based Online Search plans put you in control. All packages include items from our Main Features plus Schedule, Carrier and Vessel data. You may upgrade or downgrade any plan at any time, allowing you to choose the plan that’s right, now.</p>\r\n              \r\n              <div class=\"schedule-image\"><img src=\"../img/schedules-v2.png\" alt=\"schedule example\"></div>\r\n              <h6>Get Search Results Data by Email</h6>\r\n\r\n              <p>Data by Email is an easy to use “mini data feed” of sailing schedules designed for users who do not require vast amounts of data, or do not wish to implement a full-scale data feed integration. Data by Email is available for both Premium and Professional subscribers, and allows you to choose and receive data as CSV file delivered daily by email attachment.</p>\r\n\r\n              <p class=\"mt15\">Subscribers can choose from 3 types of formats:</p>\r\n\r\n              <ul>\r\n                <li>Schedules by origin and destination</li>\r\n                <li>Schedules by vessel name or IMO</li>\r\n                <li>Schedules by port arrivals or departures</li>\r\n              </ul>\r\n\r\n              <p>Data by Email will be sent as CSV files attachments to the email address you specify and on the day and time of your choosing. Premium subscribers may choose up to 3 data feeds, whereas Professional subscribers may choose up to 10 data feeds.</p>\r\n              <a class=\"btn mt30 mb30\" *ngIf=\"app.accountType === ''\" [routerLink]=\"['/register']\">REGISTER NOW</a> \r\n              <a class=\"btn mt30 mb30\" *ngIf=\"app.accountType !== '' && app.accountType !== 'Basic'\" [routerLink]=\"['/account/data-by-email']\">VIEW MY ACCOUNT</a> \r\n              <div class=\"full-width-screenshot\">\r\n                <img style=\"width: 100%;\" src=\"../img/linescape-directions-2.png\">\r\n              </div>\r\n          \r\n              <div class=\"get-started\">\r\n                <div>\r\n                  <h2>Check Out Our Plans</h2>\r\n                  <h6>Learn more about our premium features.</h6>\r\n                </div>\r\n                <div class=\"buttons-container\">\r\n                  <a class=\"btn btn-lg\" [routerLink]=\"['/subscribe', { scroll: true }]\"\r\n                    >PLANS & PRICING</a\r\n                  >\r\n                  <a class=\"btn-outline btn-lg\" [routerLink]=\"['/contact', { scroll: true }]\"\r\n                    ><div class=\"text-container\">CONTACT US</div></a\r\n                  >\r\n                </div>\r\n              </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  \r\n"

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(644));


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var ApiOverviewComponent = (function () {
    function ApiOverviewComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'API Overview - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';
        // Do stuff
    }
    ApiOverviewComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    ApiOverviewComponent = __decorate([
        core_1.Component({
            selector: 'api-overview',
            template: __webpack_require__(645),
            styles: [__webpack_require__(646), __webpack_require__(16)],
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], ApiOverviewComponent);
    return ApiOverviewComponent;
}());
exports.ApiOverviewComponent = ApiOverviewComponent;


/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-banner-inner\">\r\n        <h2>API Overview</h2>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"main-content\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n            <p>The API provides a mechanism for Linescape customers to access the Linescape schedule data. Customers can use the API to make use of the schedule data within their own software applications. The API provides access via a standard REST web service that can be used with any programming language and on any platform. </p>\r\n            <p>Data is accessed by making a Request to the API that specifies the type of data that is being searched for and any criteria to narrow the search. The API then replies with a Response that includes a list of any items that satisfy the request. So, for example, a request for vessels could specify a particular carrier and the API would send back a response which includes a list containing information on each of the vessels operated by the specified carrier.</p>\r\n            <p>The table below summarises the different types of data available from the API and gives an example of a request that could be made to retrieve data of that type.</p>\r\n\r\n            <table>\r\n                <tr>\r\n                  <th>Call</th>\r\n                  <th>Description</th>\r\n                  <th>Example Request</th>\r\n                </tr>\r\n                  <tr>\r\n                    <td>Carriers</td>\r\n                    <td>The company operating a vessel</td>\r\n                    <td>Get details on a carrier with a specific SCAC code</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>Contacts</td>\r\n                    <td>Contact details for a carrier</td>\r\n                    <td>Get the contact details for all offices of a carrier in a specified country</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>Vessels</td>\r\n                    <td>A shipping vessel</td>\r\n                    <td>Get details on all vessels operated by a specified carrier</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>Ports</td>\r\n                    <td>A shipping port</td>\r\n                    <td>Get details of all the ports in a specified country</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>Locations</td>\r\n                    <td>A region or country in which ports are located</td>\r\n                    <td>Get details of all regions or countries whose name begins with a specific word</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>Schedules</td>\r\n                    <td>Information on a particular vessel voyage from an origin port on a particular date to a destination port at a later date</td>\r\n                    <td>Get information on all voyages made by a specified vessel after a specified date</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>Calls</td>\r\n                    <td>A call at a port by a particular vessel</td>\r\n                    <td>Get the names of all vessels that call at a port within a specified date range</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>Trips</td>\r\n                    <td>A journey between an origin and destination port. This can be a direct voyage or a multi-legged journey involving one or two transhipments</td>\r\n                    <td>Get a list of possible trips between a specified origin anddestination that starts after a specified date</td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>Usage</td>\r\n                    <td>The number of API requests made per calendar month</td>\r\n                    <td>Get the number of remaining quota of API calls available</td>\r\n                </tr>\r\n              </table>\r\n\r\n\r\n            <p>Each request to the API is made by specifying a particular Endpoint to call. These endpoints are simply URLs that the code that calls the API uses to indicate which type of data it is interested in. There is one endpoint for each of the items in the table above. So, for example, there is an endpoint named /carriers which is used to return information on carriers and an endpoint named /vessels to return vessel information.</p>\r\n\r\n            <p>Each endpoint also supports a number of different parameters that specify criteria to use to filter the results. So, for example, the /carriers endpoint can be called with a scac parameter. This would indicate that only details for the carrier with a SCAC code that matches that specified by the parameter should be returned.</p>\r\n                \r\n            <p>These parameters vary according to the endpoint and the exact details can be found in the API reference guide, which will be sent to you along with an API test key.</p>\r\n                \r\n            <p>The response data returned by the API also varies according to each endpoint. Generally the responses consist of a list of items that match the request and some aggregate information. The aggregate information contains data such as the total number of results or the number of results that relate to a particular carrier for example.</p>\r\n                \r\n            <p>If there are a lot of results available for a particular API call, the response will just include a subset of them and an indication of how many are available. Further API calls can be made to retrieve the rest of the results in batches. In these cases, special limit and offset parameters are used to specify which subset of the results should be returned on each call.</p>\r\n\r\n            <p>Sometimes requests to a number of different API endpoints will be required to get all the information needed. For example, if a request had been made to the /schedules endpoint to find information about the voyages of a particular vessel, the response will include the origin and destination ports but not any intermediate ports. To obtain these, a further call to the /calls endpoint could be made specifying the schedule ID that was included in the /schedules response.</p>\r\n\r\n            <br>\r\n            \r\n            <p>To view our API Documentation, <a target=\"_blank\" href=\"./api-docs\">CLICK HERE</a></p>\r\n                \r\n            <br>\r\n            <hr>\r\n            <h6>Contact us for a quotation and a free two-week trial.</h6>\r\n                \r\n            <p>Simply fill out and submit the following form and we will provide you with a proposal and a test key.</p>\r\n            <contact-form [type]=\"Contact\"></contact-form>\r\n\r\n          <div class=\"get-started\">\r\n            <div>\r\n              <h2>Get Started Today</h2>\r\n              <h6>Contact us or create a Linescape account.</h6>\r\n            </div>\r\n            <div class=\"buttons-container\">\r\n              <a class=\"btn btn-lg\" [routerLink]=\"['/register', { scroll: true }]\">CREATE ACCOUNT</a>\r\n              <a class=\"btn-outline btn-lg\" [routerLink]=\"['/contact', { scroll: true }]\"><div class=\"text-container\">CONTACT US</div></a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  \r\n"

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(648));


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var carrier_network_service_1 = __webpack_require__(649);
var CarrierNetworkComponent = (function () {
    function CarrierNetworkComponent(route, seo, service) {
        this.route = route;
        this.seo = seo;
        this.service = service;
        this.title = 'Carrier List - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';
        this.loader = false;
        this.carriers = new Array();
        // Do stuff
    }
    CarrierNetworkComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
        this.loader = true;
        this.service.getCarriers().then(function (result) {
            _this.loader = false;
            _this.carriers = result;
        }).catch(function (error) {
            _this.loader = false;
        });
    };
    CarrierNetworkComponent = __decorate([
        core_1.Component({
            selector: 'carrier-network',
            styles: [__webpack_require__(651), __webpack_require__(16)],
            template: __webpack_require__(652),
            providers: [carrier_network_service_1.CarrierNetworkService]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService, carrier_network_service_1.CarrierNetworkService])
    ], CarrierNetworkComponent);
    return CarrierNetworkComponent;
}());
exports.CarrierNetworkComponent = CarrierNetworkComponent;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var models_1 = __webpack_require__(12);
var data = __webpack_require__(650);
var CarrierNetworkService = (function () {
    function CarrierNetworkService(api, cache, logger, seo, app, el, renderer) {
        this.api = api;
        this.cache = cache;
        this.logger = logger;
        this.seo = seo;
        this.app = app;
        this.renderer = renderer;
        this.queryString = '';
        this.loaderOff = false;
        this.noResult = false;
        this.newSearch = false;
        this.localContactsLoader = false;
    }
    CarrierNetworkService.prototype.getCarriers = function () {
        this.logger.log('carrier-network.service', 'getCarriers', null);
        // let cache = this.cache.get('carriers' + carrierId);
        var promise = this.callGetCarriers();
        // let server = Observable.fromPromise(promise);
        // this.carrier = server;
        // this.carrier = Observable.concat(cache, server);
        // this.cache.updateCache('carriers' + this.queryString, this.carrier);
        return promise;
    };
    CarrierNetworkService.prototype.callGetCarriers = function () {
        var _this = this;
        this.logger.log('carriers.service', 'callGetCarriers', data);
        return new Promise(function (resolve, reject) {
            try {
                var result = data;
                var carriers = _this.formatCarriers(result);
                resolve(carriers);
            }
            catch (ex) {
                reject(null);
            }
        });
    };
    CarrierNetworkService.prototype.formatCarriers = function (result) {
        var carriers = Array();
        for (var current = 0; current < result.length; current++) {
            var carrier = new models_1.Carrier(result[current].carrier);
            carriers.push(carrier);
        }
        return carriers;
    };
    CarrierNetworkService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.CacheService, shared_1.LogService,
            shared_1.SeoService, shared_1.AppContext, core_1.ElementRef, core_1.Renderer])
    ], CarrierNetworkService);
    return CarrierNetworkService;
}());
exports.CarrierNetworkService = CarrierNetworkService;


/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = [{"count":6006,"carrier":{"scac":"MAEU","id":1,"name":"Maersk"}},{"count":14948,"carrier":{"scac":"MSCU","id":2,"name":"MSC"}},{"count":50283,"carrier":{"scac":"CMDU","id":3,"name":"CMA-CGM"}},{"count":22143,"carrier":{"scac":"EGLV","id":4,"name":"Evergreen"}},{"count":17193,"carrier":{"scac":"HLCU","id":5,"name":"Hapag-Lloyd"}},{"count":17915,"carrier":{"scac":"COSU","id":6,"name":"COSCO"}},{"count":22562,"carrier":{"scac":"APLU","id":8,"name":"APL"}},{"count":9335,"carrier":{"scac":"OOLU","id":12,"name":"OOCL"}},{"count":9827,"carrier":{"scac":"ZIMU","id":14,"name":"Zim"}},{"count":19807,"carrier":{"scac":"SUDU","id":15,"name":"Hamburg Sud"}},{"count":19280,"carrier":{"scac":"YMLU","id":16,"name":"Yang Ming"}},{"count":5709,"carrier":{"scac":"HDMU","id":18,"name":"Hyundai"}},{"count":1984,"carrier":{"scac":"PILN","id":19,"name":"PIL"}},{"count":8615,"carrier":{"scac":"WHLC","id":20,"name":"Wan Hai"}},{"count":21807,"carrier":{"scac":"ONEY","id":21,"name":"ONE Line"}},{"count":1067,"carrier":{"scac":"SMLM","id":23,"name":"SM Line"}},{"count":393,"carrier":{"scac":"REGU","id":25,"name":"RCL"}},{"count":1565,"carrier":{"scac":"GRIU","id":26,"name":"Grimaldi"}},{"count":1088,"carrier":{"scac":"XCLX","id":30,"name":"X-Press"}},{"count":4063,"carrier":{"scac":"TSQD","id":33,"name":"TS Lines"}},{"count":368,"carrier":{"scac":"CHVW ","id":34,"name":"Swire"}},{"count":120,"carrier":{"scac":"BTLX","id":36,"name":"BTL"}},{"count":1258,"carrier":{"scac":"KMTU","id":37,"name":"KMTC"}},{"count":1026,"carrier":{"scac":"MATS","id":38,"name":"Matson"}},{"count":1309,"carrier":{"scac":"EPIR","id":39,"name":"Emirates"}},{"count":1556,"carrier":{"scac":"SMLU","id":40,"name":"Seaboard"}},{"count":27,"carrier":{"scac":"OELX","id":42,"name":"Transworld"}},{"count":532,"carrier":{"scac":"UFEE","id":43,"name":"Unifeeder"}},{"count":837,"carrier":{"scac":"SITU","id":44,"name":"SITC"}},{"count":938,"carrier":{"scac":"SIKU","id":45,"name":"Samudera"}},{"count":5694,"carrier":{"scac":"GSLU","id":47,"name":"Gold Star"}},{"count":1453,"carrier":{"scac":"MCCQ","id":49,"name":"Sealand Asia"}},{"count":505,"carrier":{"scac":"HALU","id":52,"name":"Heung-A"}},{"count":213,"carrier":{"scac":"LMCU","id":53,"name":"Messina"}},{"count":1070,"carrier":{"scac":"ARKU","id":55,"name":"Arkas Line"}},{"count":198,"carrier":{"scac":"SKLU","id":56,"name":"Sinokor"}},{"count":103,"carrier":{"scac":"CHPU","id":58,"name":"Chipolbrok"}},{"count":1324,"carrier":{"scac":"FESO","id":59,"name":"FESCO"}},{"count":290,"carrier":{"scac":"EIMU","id":60,"name":"Eimskip"}},{"count":3,"carrier":{"scac":"CAMN","id":61,"name":"Crowley"}},{"count":1503,"carrier":{"scac":"SEJJ","id":62,"name":"Sealand Europe"}},{"count":139,"carrier":{"scac":"MOCU","id":65,"name":"MACS"}},{"count":126,"carrier":{"scac":"GFSX","id":66,"name":"GFS"}},{"count":169,"carrier":{"scac":"WWSU","id":67,"name":"Westwood"}},{"count":49,"carrier":{"scac":"UFSX","id":68,"name":"Unimed"}},{"count":18,"carrier":{"scac":"SKII","id":69,"name":"Samskip"}},{"count":735,"carrier":{"scac":"TRKU","id":70,"name":"Turkon"}},{"count":434,"carrier":{"scac":"BORU","id":71,"name":"Borchard"}},{"count":216,"carrier":{"scac":"DOLQ","id":72,"name":"Dole"}},{"count":3452,"carrier":{"scac":"NSSU","id":73,"name":"Namsung"}},{"count":20,"carrier":{"scac":"NPFU","id":74,"name":"Boluda"}},{"count":7406,"carrier":{"scac":"CNCU","id":76,"name":"CNC Line"}},{"count":276,"carrier":{"scac":"ACLZ","id":80,"name":"ACL USA"}},{"count":3265,"carrier":{"scac":"ANLC","id":81,"name":"ANL"}},{"count":2001,"carrier":{"scac":"SEAU","id":82,"name":"Sealand Americas"}},{"count":58,"carrier":{"scac":"AALU","id":83,"name":"AAL"}},{"count":569,"carrier":{"scac":"MRTU","id":85,"name":"Meratus"}},{"count":53,"carrier":{"scac":"TEMX","id":86,"name":"Temas"}},{"count":919,"carrier":{"scac":"MFUS","id":87,"name":"Marfret"}},{"count":67,"carrier":{"scac":"UALX","id":89,"name":"UAL"}},{"count":191,"carrier":{"scac":"TNTX","id":92,"name":"Tanto"}},{"count":33,"carrier":{"scac":"SLPX","id":93,"name":"SPIL"}},{"count":128,"carrier":{"scac":"NSAU","id":94,"name":"Bahri"}},{"count":389,"carrier":{"scac":"LGIX","id":96,"name":"Log-In"}},{"count":90,"carrier":{"scac":"TSCW","id":98,"name":"Tropical"}},{"count":369,"carrier":{"scac":"GETU","id":103,"name":"Tarros"}},{"count":152,"carrier":{"scac":"BGFU","id":104,"name":"BGFL"}},{"count":43,"carrier":{"scac":"UBCU","id":105,"name":"GWF"}},{"count":1,"carrier":{"scac":"METX","id":107,"name":"Metz"}},{"count":123,"carrier":{"scac":"CFSX","id":108,"name":"CFS"}},{"count":112,"carrier":{"scac":"ICLN","id":110,"name":"ICL"}},{"count":198,"carrier":{"scac":"KMBU","id":111,"name":"Kambara"}},{"count":204,"carrier":{"scac":"JINX","id":112,"name":"Jin Jiang"}},{"count":101,"carrier":{"scac":"HAHU","id":116,"name":"HASCO"}},{"count":268,"carrier":{"scac":"MELX","id":119,"name":"MELL"}},{"count":361,"carrier":{"scac":"WECU","id":124,"name":"WEC Lines"}},{"count":257,"carrier":{"scac":"CKYX","id":126,"name":"CK Line"}},{"count":219,"carrier":{"scac":"SDGR","id":128,"name":"Seatrade"}},{"count":219,"carrier":{"scac":"PSHI","id":132,"name":"Pasha Hawaii"}},{"count":219,"carrier":{"scac":"CSFU","id":134,"name":"Containerships"}},{"count":10,"carrier":{"scac":"MNNX","id":137,"name":"Mann Lines"}},{"count":93,"carrier":{"scac":"RALU","id":140,"name":"RAL"}},{"count":88,"carrier":{"scac":"GNSU","id":144,"name":"Geest"}},{"count":69,"carrier":{"scac":"ECVX","id":145,"name":"ECL Vertraco"}},{"count":23,"carrier":{"scac":"AMLU","id":147,"name":"Antillean"}},{"count":127,"carrier":{"scac":"PCLW","id":148,"name":"PACC"}},{"count":88,"carrier":{"scac":"PPSU","id":149,"name":"GBH"}},{"count":154,"carrier":{"scac":"NGPX","id":150,"name":"NGPL"}},{"count":60,"carrier":{"scac":"PLLU","id":151,"name":"Polynesia"}},{"count":15,"carrier":{"scac":"BCLU","id":152,"name":"BCL Bermuda"}},{"count":12,"carrier":{"scac":"TRCU","id":157,"name":"Wallenius SOL"}},{"count":124,"carrier":{"scac":"SSGX","id":158,"name":"Streamline"}},{"count":24,"carrier":{"scac":"NPLX","id":165,"name":"NPDL"}},{"count":16,"carrier":{"scac":"KCNX","id":166,"name":"Kalypso"}},{"count":104,"carrier":{"scac":"NCLX","id":173,"name":"NCL"}},{"count":250,"carrier":{"scac":"KOSU","id":177,"name":"KOS"}},{"count":20,"carrier":{"scac":"SSLH","id":179,"name":"Tote Maritime"}},{"count":45,"carrier":{"scac":"NIRU","id":180,"name":"Nirint Lines"}},{"count":33,"carrier":{"scac":"OVPX","id":181,"name":"OVP"}},{"count":234,"carrier":{"scac":"MERX","id":182,"name":"Mercosul"}},{"count":18,"carrier":{"scac":"ARRJ","id":185,"name":"ARRC"}},{"count":21,"carrier":{"scac":"PSLX","id":190,"name":"PSL"}},{"count":9,"carrier":{"scac":"UWLX","id":194,"name":"UWL"}},{"count":171,"carrier":{"scac":"FDTX","id":200,"name":"Feedertech"}},{"count":58,"carrier":{"scac":"PSPX","id":205,"name":"PacShip"}},{"count":19,"carrier":{"scac":"UAFX","id":207,"name":"UAFL"}},{"count":50,"carrier":{"scac":"TCGX","id":208,"name":"TCLC"}},{"count":14,"carrier":{"scac":"NSHA","id":217,"name":"NSA"}},{"count":105,"carrier":{"scac":"GMDU","id":218,"name":"Gemadept"}},{"count":36,"carrier":{"scac":"LPUS","id":223,"name":"Peninsular"}},{"count":70,"carrier":{"scac":"CZTU","id":225,"name":"Centrans"}},{"count":39,"carrier":{"scac":"AFEX","id":228,"name":"AEL"}},{"count":68,"carrier":{"scac":"TRBR","id":234,"name":"Trailer Bridge"}},{"count":271,"carrier":{"scac":"MGSU","id":235,"name":"Marguisa"}},{"count":135,"carrier":{"scac":"LNLU","id":237,"name":"Laurel"}},{"count":13,"carrier":{"scac":"NSCU","id":241,"name":"NSC"}},{"count":6,"carrier":{"scac":"MDEX","id":246,"name":"Medex"}},{"count":325,"carrier":{"scac":"MBFU","id":247,"name":"Carpenters"}},{"count":76,"carrier":{"scac":"TRSX ","id":251,"name":"Transit"}},{"count":11,"carrier":{"scac":"MTTX","id":254,"name":"MTT"}},{"count":158,"carrier":{"scac":"CULU","id":259,"name":"CU Lines"}},{"count":19,"carrier":{"scac":"ADMU","id":264,"name":"Admiral"}},{"count":1,"carrier":{"scac":"OCXI","id":265,"name":"Oceanex"}},{"count":4,"carrier":{"scac":"LKAX","id":269,"name":"LKA"}},{"count":98,"carrier":{"scac":"DJLE","id":273,"name":"DongJin"}},{"count":18,"carrier":{"scac":"TREX","id":277,"name":"TMS Lines"}},{"count":19,"carrier":{"scac":"SAFX","id":279,"name":"Safetrans"}},{"count":67,"carrier":{"scac":"MKLU","id":282,"name":"Medkon"}},{"count":166,"carrier":{"scac":"SOMX","id":283,"name":"Star Ocean"}},{"count":12,"carrier":{"scac":"BTGX","id":284,"name":"Bintang Mas"}},{"count":91,"carrier":{"scac":"LLYU","id":285,"name":"Lily Line"}},{"count":33,"carrier":{"scac":"ELLX","id":286,"name":"Ellerman"}},{"count":47,"carrier":{"scac":"IAAU","id":288,"name":"Interasia"}},{"count":13,"carrier":{"scac":"PFLU","id":289,"name":"PFL"}},{"count":19,"carrier":{"scac":"SMLX","id":292,"name":"Sallaum"}},{"count":47,"carrier":{"scac":"AKKX","id":294,"name":"Akkon Lines"}},{"count":39,"carrier":{"scac":"HRLX","id":295,"name":"HR Lines"}},{"count":66,"carrier":{"scac":"BCSX","id":296,"name":"BOCS"}},{"count":5,"carrier":{"scac":"OCLX","id":298,"name":"Oceanus Line"}}]

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = ".d-table {\n  display: table; }\n\n.d-table-cell {\n  display: table-cell; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 456px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 50px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-full {\n    vertical-align: top; }\n    .page-content .page-content-full p, .page-content .page-content-full li, .page-content .page-content-full div, .page-content .page-content-full label {\n      font-size: 18px;\n      line-height: 32px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n.team-section {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n  .team-section .pure-g .founder {\n    cursor: pointer;\n    width: 96%;\n    overflow: hidden; }\n  .team-section .pure-g .pure-u-1-2 .team-text, .team-section .pure-g .pure-u-1-4 .team-text {\n    padding: 0 10px 10px 10px; }\n  .team-section .pure-g .pure-u-1-2 h1, .team-section .pure-g .pure-u-1-2 h2, .team-section .pure-g .pure-u-1-2 h3, .team-section .pure-g .pure-u-1-2 h4, .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-2 h6, .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-2 label, .team-section .pure-g .pure-u-1-2 li, .team-section .pure-g .pure-u-1-4 h1, .team-section .pure-g .pure-u-1-4 h2, .team-section .pure-g .pure-u-1-4 h3, .team-section .pure-g .pure-u-1-4 h4, .team-section .pure-g .pure-u-1-4 h5, .team-section .pure-g .pure-u-1-4 h6, .team-section .pure-g .pure-u-1-4 p, .team-section .pure-g .pure-u-1-4 label, .team-section .pure-g .pure-u-1-4 li {\n    color: #ffffff; }\n  .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-4 h5 {\n    font-weight: bold;\n    line-height: 32px;\n    color: #ffffff;\n    font-size: 20px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0; }\n  .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-4 p {\n    line-height: 20px;\n    margin-bottom: 5px; }\n  .team-section .pure-g .pure-u-1-2 img, .team-section .pure-g .pure-u-1-4 img {\n    max-width: 100%;\n    width: 100%;\n    transition: all 0.3s;\n    transform: scale(1); }\n  .team-section .pure-g .pure-u-1-2 .founder img:hover, .team-section .pure-g .pure-u-1-4 .founder img:hover {\n    transform: scale(1.1);\n    padding-bottom: 15px; }\n  .team-section .pure-g .team-text.bio h5:hover {\n    color: #fc7d17;\n    cursor: pointer; }\n  .team-section .team-member {\n    margin: 10px;\n    background-color: #393939; }\n\n#who-we-are {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n\n.page-content .quote {\n  padding-top: 20px;\n  font-size: 16px;\n  color: #7a7a7a;\n  width: 80%;\n  margin: 0 auto;\n  font-style: italic; }\n\n.page-content .quote-by {\n  font-size: 16px;\n  text-align: right;\n  color: #7a7a7a; }\n\n/*** MODAL CSS ***/\n.modal {\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: black;\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */ }\n\n/* Modal Content/Box */\n.modal-content {\n  background-color: #fefefe;\n  margin: 15% auto;\n  /* 15% from the top and centered */\n  padding: 50px;\n  border: 1px solid #888;\n  width: 80%;\n  /* Could be more or less, depending on screen size */ }\n\n/* The Close Button */\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold; }\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer; }\n\n.get-started {\n  padding: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  border-top: 1px solid #e9e9e9; }\n  .get-started h2 {\n    color: #247cbd; }\n  .get-started h6 {\n    color: #666; }\n  .get-started .buttons-container {\n    margin-top: 17px; }\n    .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 479px) {\n  .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n\n@media only screen and (max-width: 1023px) {\n  .pure-u-1-4, .pure-u-6-24 {\n    width: 50%; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; }\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(50% - 20px); }\n  .team-section .col-holder.full-width-team {\n    display: none; } }\n\n.carriers-all {\n  margin: 0 auto; }\n\n.carrier-style {\n  width: 100px;\n  padding: 15px;\n  text-align: center;\n  line-height: 1.25; }\n  .carrier-style .hover-link {\n    font-size: 16px;\n    font-weight: 500; }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; }\n  .pure-u-1-2, .pure-u-1-4 {\n    width: 100%; } }\n\n@media only screen and (max-width: 599px) {\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(100% - 20px); } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Carrier List</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <p>Linescape has the industry’s largest carrier coverage of deep-sea, short-sea and feeder carriers, which\r\n          altogether comprise about 90% of global container capacity. We maintain relationships with all carriers to\r\n          ensure for them the greatest possible reach and to monitor their schedule quality.</p>\r\n        <p>Schedule data is provided by carriers in one of several formats, including EDI IFTSAI, EDI ANSI 323, XML, CSV\r\n          and other formats. Within each format the data structure or message can vary considerably from one carrier to\r\n          another, resulting in each carrier requiring a tailor-made solution for importing and processing each\r\n          carrier’s data. Linescape’s proprietary technology can automatically process and update all carrier schedules\r\n          seamlessly and as frequently as delivered to provide customers with the most up-to-date consolidated sailing\r\n          schedules.</p>\r\n\r\n        <div class=\"carriers-all\">\r\n          \r\n          <div class=\"carrier-style\" *ngFor=\"let carrier of carriers\" style=\"display: inline-grid\">\r\n            <span class=\"carrier-logo-wrapper\">\r\n              <img [routerLink]=\"['/carriers', carrier.id, {scroll: true}]\" class=\"company-logo pointer\"\r\n                src=\"../img/carriers/{{ carrier.id }}.gif\" onerror=\"src='../img/carriers/0.gif'\">\r\n            </span>\r\n            <b class=\"hover-link\" [routerLink]=\"['/carriers', carrier.id, {scroll: true}]\">{{ carrier.name }}</b>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"get-started\">\r\n          <div>\r\n            <h2>Get Started Today</h2>\r\n            <h6>Contact us or create a Linescape account.</h6>\r\n          </div>\r\n          <div class=\"buttons-container\">\r\n            <a class=\"btn btn-lg\" [routerLink]=\"['/register', { scroll: true }]\">CREATE ACCOUNT</a>\r\n            <a class=\"btn-outline btn-lg\" [routerLink]=\"['/contact', { scroll: true }]\">\r\n              <div class=\"text-container\">CONTACT US</div>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(654));


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var DataConsolidationComponent = (function () {
    function DataConsolidationComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'Data Consolidation - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';
        // Do stuff
    }
    DataConsolidationComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    DataConsolidationComponent = __decorate([
        core_1.Component({
            selector: 'data-consolidation',
            styles: [__webpack_require__(655), __webpack_require__(16)],
            template: __webpack_require__(656)
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], DataConsolidationComponent);
    return DataConsolidationComponent;
}());
exports.DataConsolidationComponent = DataConsolidationComponent;


/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = ".d-table {\n  display: table; }\n\n.d-table-cell {\n  display: table-cell; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 456px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 50px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-full {\n    vertical-align: top; }\n    .page-content .page-content-full p, .page-content .page-content-full li, .page-content .page-content-full div, .page-content .page-content-full label {\n      font-size: 18px;\n      line-height: 32px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n.team-section {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n  .team-section .pure-g .founder {\n    cursor: pointer;\n    width: 96%;\n    overflow: hidden; }\n  .team-section .pure-g .pure-u-1-2 .team-text, .team-section .pure-g .pure-u-1-4 .team-text {\n    padding: 0 10px 10px 10px; }\n  .team-section .pure-g .pure-u-1-2 h1, .team-section .pure-g .pure-u-1-2 h2, .team-section .pure-g .pure-u-1-2 h3, .team-section .pure-g .pure-u-1-2 h4, .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-2 h6, .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-2 label, .team-section .pure-g .pure-u-1-2 li, .team-section .pure-g .pure-u-1-4 h1, .team-section .pure-g .pure-u-1-4 h2, .team-section .pure-g .pure-u-1-4 h3, .team-section .pure-g .pure-u-1-4 h4, .team-section .pure-g .pure-u-1-4 h5, .team-section .pure-g .pure-u-1-4 h6, .team-section .pure-g .pure-u-1-4 p, .team-section .pure-g .pure-u-1-4 label, .team-section .pure-g .pure-u-1-4 li {\n    color: #ffffff; }\n  .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-4 h5 {\n    font-weight: bold;\n    line-height: 32px;\n    color: #ffffff;\n    font-size: 20px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0; }\n  .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-4 p {\n    line-height: 20px;\n    margin-bottom: 5px; }\n  .team-section .pure-g .pure-u-1-2 img, .team-section .pure-g .pure-u-1-4 img {\n    max-width: 100%;\n    width: 100%;\n    transition: all 0.3s;\n    transform: scale(1); }\n  .team-section .pure-g .pure-u-1-2 .founder img:hover, .team-section .pure-g .pure-u-1-4 .founder img:hover {\n    transform: scale(1.1);\n    padding-bottom: 15px; }\n  .team-section .pure-g .team-text.bio h5:hover {\n    color: #fc7d17;\n    cursor: pointer; }\n  .team-section .team-member {\n    margin: 10px;\n    background-color: #393939; }\n\n#who-we-are {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n\n.page-content .quote {\n  padding-top: 20px;\n  font-size: 16px;\n  color: #7a7a7a;\n  width: 80%;\n  margin: 0 auto;\n  font-style: italic; }\n\n.page-content .quote-by {\n  font-size: 16px;\n  text-align: right;\n  color: #7a7a7a; }\n\n.last-paragraph {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n\n/*** MODAL CSS ***/\n.modal {\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: black;\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */ }\n\n/* Modal Content/Box */\n.modal-content {\n  background-color: #fefefe;\n  margin: 15% auto;\n  /* 15% from the top and centered */\n  padding: 50px;\n  border: 1px solid #888;\n  width: 80%;\n  /* Could be more or less, depending on screen size */ }\n\n/* The Close Button */\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold; }\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer; }\n\n.get-started {\n  padding: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  border-top: 1px solid #e9e9e9; }\n  .get-started h2 {\n    color: #247cbd; }\n  .get-started h6 {\n    color: #666; }\n  .get-started .buttons-container {\n    margin-top: 17px; }\n    .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 479px) {\n  .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n\n@media only screen and (max-width: 1023px) {\n  .pure-u-1-4, .pure-u-6-24 {\n    width: 50%; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; }\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(50% - 20px); }\n  .team-section .col-holder.full-width-team {\n    display: none; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; }\n  .pure-u-1-2, .pure-u-1-4 {\n    width: 100%; } }\n\n@media only screen and (max-width: 599px) {\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(100% - 20px); } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n\n.infographic img {\n  max-width: 100%;\n  padding: 15px;\n  padding-top: 30px; }\n"

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-banner-inner\">\r\n        <h2>Data Consolidation</h2>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"main-content\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n            <p>Linescape processes much more than just sailing schedules. Although carrier schedules form the foundation of our database, they must be enhanced and validated with other sources of data. Carrier services (or routes) are analyzed in order to correctly attribute vessel schedules to a particular service. Sea port data is gathered to avoid confusing similar port names, mapping vessel port calls to the correct ports. Terminal data is imported to determine the identity of the terminal where a vessel will berth. Vessel register data is used to provide current vessel identifiers, such as IMO, MMSI, Call Sign, Flag, Operator, Ship Type, TEU, etc… Finally, we receive AIS data to track the ETA and ETD of vessels at each port worldwide. This data allows us to check and validate the accuracy of vessel schedules as well as to calculate on-time reliability.</p>\r\n\r\n            <div class=\"infographic\">\r\n              <h3>Our Process</h3>\r\n              <img src=\"../img/infographic.png\" alt=\"linescape infographic\">\r\n            </div>\r\n\r\n            <p class=\"last-paragraph\">All data is imported and processed on secure bare-metal servers under our complete control and with a redundancy of backups. Several times each day, the most recent portion of the validated database is pushed to the cloud where it can be accessed either by the Linescape website or the API for customer access which is flexible and scalable. Data feeds are likewise generated and pushed to a secure FTP server where customers can pull their data feeds daily. Furthermore, we maintain all historical data which can be made available to certain customers for analysis or used for data mining.</p>\r\n\r\n            <p>Linescape’s proprietary platform functions seamlessly, automatically and securely with near 100% uptime, providing customers with a totally reliable source of sailing schedule data.</p>\r\n          <div class=\"get-started\">\r\n            <div>\r\n              <h2>Get Started Today</h2>\r\n              <h6>Contact us or create a Linescape account.</h6>\r\n            </div>\r\n            <div class=\"buttons-container\">\r\n              <a class=\"btn btn-lg\" [routerLink]=\"['/register', { scroll: true }]\"\r\n                >CREATE ACCOUNT</a\r\n              >\r\n              <a class=\"btn-outline btn-lg\" [routerLink]=\"['/contact', { scroll: true }]\"\r\n                ><div class=\"text-container\">CONTACT US</div></a\r\n              >\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  \r\n"

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(658));


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var DataFormatsComponent = (function () {
    function DataFormatsComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'Bulk Data Formats - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';
        // Do stuff
    }
    DataFormatsComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    DataFormatsComponent = __decorate([
        core_1.Component({
            selector: 'bulk-data-formats',
            styles: [__webpack_require__(659), __webpack_require__(16)],
            template: __webpack_require__(660)
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], DataFormatsComponent);
    return DataFormatsComponent;
}());
exports.DataFormatsComponent = DataFormatsComponent;


/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = ".d-table {\n  display: table; }\n\n.d-table-cell {\n  display: table-cell; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 456px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 50px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-full {\n    vertical-align: top; }\n    .page-content .page-content-full p, .page-content .page-content-full li, .page-content .page-content-full div, .page-content .page-content-full label {\n      font-size: 18px;\n      line-height: 32px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n.team-section {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n  .team-section .pure-g .founder {\n    cursor: pointer;\n    width: 96%;\n    overflow: hidden; }\n  .team-section .pure-g .pure-u-1-2 .team-text, .team-section .pure-g .pure-u-1-4 .team-text {\n    padding: 0 10px 10px 10px; }\n  .team-section .pure-g .pure-u-1-2 h1, .team-section .pure-g .pure-u-1-2 h2, .team-section .pure-g .pure-u-1-2 h3, .team-section .pure-g .pure-u-1-2 h4, .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-2 h6, .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-2 label, .team-section .pure-g .pure-u-1-2 li, .team-section .pure-g .pure-u-1-4 h1, .team-section .pure-g .pure-u-1-4 h2, .team-section .pure-g .pure-u-1-4 h3, .team-section .pure-g .pure-u-1-4 h4, .team-section .pure-g .pure-u-1-4 h5, .team-section .pure-g .pure-u-1-4 h6, .team-section .pure-g .pure-u-1-4 p, .team-section .pure-g .pure-u-1-4 label, .team-section .pure-g .pure-u-1-4 li {\n    color: #ffffff; }\n  .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-4 h5 {\n    font-weight: bold;\n    line-height: 32px;\n    color: #ffffff;\n    font-size: 20px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0; }\n  .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-4 p {\n    line-height: 20px;\n    margin-bottom: 5px; }\n  .team-section .pure-g .pure-u-1-2 img, .team-section .pure-g .pure-u-1-4 img {\n    max-width: 100%;\n    width: 100%;\n    transition: all 0.3s;\n    transform: scale(1); }\n  .team-section .pure-g .pure-u-1-2 .founder img:hover, .team-section .pure-g .pure-u-1-4 .founder img:hover {\n    transform: scale(1.1);\n    padding-bottom: 15px; }\n  .team-section .pure-g .team-text.bio h5:hover {\n    color: #fc7d17;\n    cursor: pointer; }\n  .team-section .team-member {\n    margin: 10px;\n    background-color: #393939; }\n\n#who-we-are {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n\n.page-content .quote {\n  padding-top: 20px;\n  font-size: 16px;\n  color: #7a7a7a;\n  width: 80%;\n  margin: 0 auto;\n  font-style: italic; }\n\n.page-content .quote-by {\n  font-size: 16px;\n  text-align: right;\n  color: #7a7a7a; }\n\n/*** MODAL CSS ***/\n.modal {\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: black;\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */ }\n\n/* Modal Content/Box */\n.modal-content {\n  background-color: #fefefe;\n  margin: 15% auto;\n  /* 15% from the top and centered */\n  padding: 50px;\n  border: 1px solid #888;\n  width: 80%;\n  /* Could be more or less, depending on screen size */ }\n\n/* The Close Button */\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold; }\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer; }\n\n.get-started {\n  padding: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  border-top: 1px solid #e9e9e9; }\n  .get-started h2 {\n    color: #247cbd; }\n  .get-started h6 {\n    color: #666; }\n  .get-started .buttons-container {\n    margin-top: 17px; }\n    .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 479px) {\n  .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n\n@media only screen and (max-width: 1023px) {\n  .pure-u-1-4, .pure-u-6-24 {\n    width: 50%; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; }\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(50% - 20px); }\n  .team-section .col-holder.full-width-team {\n    display: none; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; }\n  .pure-u-1-2, .pure-u-1-4 {\n    width: 100%; } }\n\n@media only screen and (max-width: 599px) {\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(100% - 20px); } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n\nh3 {\n  padding-top: 30px;\n  margin-top: 30px; }\n"

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-banner-inner\">\r\n        <h2>Bulk Data Formats</h2>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"main-content\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n            <p>Bulk data is delivered as CSV files which Linescape customers pull from our FTP server. Customers then integrate the bulk data into their TMS or other IT system so that the schedule data displays directly in the company system, alleviating the need to search elsewhere for data.</p>\r\n            <p>Data is available in a variety of formats, each providing a specific view for a particular use case.</p>\r\n\r\n            <h3 class=\"mt0\">Port Rotation Schedules</h3>\r\n            <p>Schedule data in the port rotation format consists of the following data fields:</p>\r\n            <table>\r\n              <tr>\r\n                <th>Data Field</th>\r\n                <th>Description</th>\r\n              </tr>\r\n              <tr>\r\n              <td>carrier_code</td>\r\n              <td>Carrier SCAC Code</td>\r\n              </tr>\r\n              <tr>\r\n                <td>carrier_name</td>\r\n                <td>Carrier Name</td>\r\n              </tr>\r\n              <tr>\r\n                <td>service_code</td>\r\n                <td>Service/Route Code</td>\r\n              </tr>\r\n              <tr>\r\n                <td>service_name</td>\r\n                <td>Service/Route Name</td>\r\n              </tr>\r\n              <tr>\r\n                <td>vessel_imo</td>\r\n                <td>Vessel IMO Number</td>\r\n              </tr>\r\n              <tr>\r\n                <td>vessel_name</td>\r\n                <td>Vessel Name</td>\r\n              </tr>\r\n              <tr>\r\n                <td>vessel_voyage</td>\r\n                <td>Vessel Voyage Number</td>\r\n              </tr>\r\n              <tr>\r\n                <td>port_code</td>\r\n                <td>Port UN Locode</td>\r\n              </tr>\r\n              <tr>\r\n                <td>port_name</td>\r\n                <td>Port Name</td>\r\n              </tr>\r\n              <tr>\r\n                <td>port_eta</td>\r\n                <td>Port ETA Date</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>port_etd</td>\r\n                  <td>Port ETD Date</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>portcalls_sequence</td>\r\n                  <td>Sequence of Port Calls</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>portcalls_total</td>\r\n                  <td>Total Number of Port Calls</td>\r\n              </tr>\r\n            </table>\r\n            <p>It is organized as one port call per record. For example, a vessel voyage which comprises 8 ports of call will be displayed in 8 records, with the portcalls_sequence indicating the chronological order of calls, from 1 to 8. To search for a particular schedule, customers search on the unique combination of Carrier-Service-Vessel-Voyage, which would return all 8 records of the schedule.</p>\r\n            <p>Each schedule has two timestamps. One is the date/time that each schedule was last updated. The other is the date/time that the carrier last sent a complete set of updated schedules. If the former timestamp becomes much older than the latter, then that schedule becomes a cancelled schedule and is filtered out of the data feed.</p>\r\n\r\n            <h3 class=\"mt0\">Transhipment Schedules</h3>\r\n            <p>Schedule data in the transhipment format consists of the following data fields:</p>\r\n            <table>\r\n              <tr>\r\n                <th>Data Field</th>\r\n                <th>Description</th>\r\n              </tr>\r\n              <tr>\r\n                  <td>c1scac</td>\r\n                  <td>Carrier #1 SCAC</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>r1name</td>\r\n                  <td>Route #1 Name</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>v1name</td>\r\n                  <td>Vessel #1 Name</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>s1voy</td>\r\n                  <td>Voyage #1 Label</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>oport</td>\r\n                  <td>Origin Port Locode</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>oetd</td>\r\n                  <td>Origin Port ETD</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>ts1port</td>\r\n                  <td>Tranship Port #1 Locode</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>ts1eta</td>\r\n                  <td>Tranship Port #1 ETA</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>omode</td>\r\n                  <td>Origin Mode (S=\"Ship\", T=\"Tranship\")</td>\r\n              </tr>\r\n              <tr>\r\n                  <td></td>\r\n                  <td></td>\r\n              </tr>\r\n              <tr>\r\n                  <td>c2scac</td>\r\n                  <td>Carrier #2 SCAC</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>r2name</td>\r\n                  <td>Route #2 Name</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>v2name</td>\r\n                  <td>Vessel #2 Name</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>s2voy</td>\r\n                  <td>Voyage #2 Label</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>ts1etd</td>\r\n                  <td>Tranship Port #1 ETD</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>ts2port</td>\r\n                  <td>Tranship Port #2 Locode</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>ts2eta</td>\r\n                  <td>Tranship Port #2 ETA</td>\r\n              </tr>\r\n              <tr>\r\n                  <td></td>\r\n                  <td></td>\r\n              </tr>\r\n              <tr>\r\n                  <td>c3scac</td>\r\n                  <td>Carrier #3 SCAC</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>r3name</td>\r\n                  <td>Route #3 Name</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>v3name</td>\r\n                  <td>Vessel #3 Name</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>s3voy</td>\r\n                  <td>Voyage #3 Label</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>ts2etd</td>\r\n                  <td>Tranship Port #2 ETD</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>dport</td>\r\n                  <td>Destination Port Locode</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>deta</td>\r\n                  <td>Destination Port ETA</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>dmode</td>\r\n                  <td>Destination Mode (S=\"Ship\", T=\"Tranship\")</td>\r\n              </tr>\r\n              <tr>\r\n                  <td></td>\r\n                  <td></td>\r\n              </tr>\r\n              <tr>\r\n                  <td>cscac</td>\r\n                  <td>Booking Carrier</td>\r\n              </tr>\r\n              <tr>\r\n                  <td>dur</td>\r\n                  <td>Duration (days)</td>\r\n              </tr>\r\n            </table>\r\n            <p>It is organized as one origin-destination per record. Each record may comprise either a single direct vessel voyage, or two vessel voyages with one transhipment, or three vessel voyages with two transhipments. Each of the three possible vessels may be deep-sea vessels or the first and/or last vessels may be feeder vessels.</p>\r\n\r\n            <h3 class=\"mt0\">Vessel Data</h3>\r\n            <p>Vessel data can be delivered and associated with either of the schedule data feeds. The most commonly requested information consists of the following data fields:</p>\r\n            <table>\r\n                <tr>\r\n                  <th>Data Field</th>\r\n                  <th>Description</th>\r\n                </tr>\r\n                <tr>\r\n                    <td>imo</td>\r\n                    <td>Vessel IMO Number</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>name</td>\r\n                    <td>Vessel Name</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>flag</td>\r\n                    <td>Flag Country</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>call_sign</td>\r\n                    <td>Call Sign</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>mmsi</td>\r\n                    <td>MMSI Number</td>\r\n                </tr>\r\n                <tr>\r\n                    <td></td>\r\n                    <td></td>\r\n                </tr>\r\n                <tr>\r\n                    <td>owner</td>\r\n                    <td>Vessel Owner</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>operator</td>\r\n                    <td>Vessel Operator</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>old_names</td>\r\n                    <td>Previous Names</td>\r\n                </tr>\r\n                <tr>\r\n                    <td></td>\r\n                    <td></td>\r\n                </tr>\r\n                <tr>\r\n                    <td>gross_tonnage</td>\r\n                    <td>Gross Tonnage</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>net_tonnage</td>\r\n                    <td>Net Tonnage</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>dwt</td>\r\n                    <td>Deadweight Tons</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>max_teu</td>\r\n                    <td>Nominal Container Capacity</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>avg_teu</td>\r\n                    <td>14mt Container Capacity</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>reefer_teu</td>\r\n                    <td>Reefer Container Capacity</td>\r\n                </tr>\r\n                <tr>\r\n                    <td></td>\r\n                    <td></td>\r\n                </tr>\r\n                <tr>\r\n                    <td>ship_type</td>\r\n                    <td>Ship Type</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>port_of</td>\r\n                    <td>Port of Registry</td>\r\n                </tr>\r\n                <tr>\r\n                    <td>year</td>\r\n                    <td>Year Built</td>\r\n                </tr>\r\n              </table>\r\n            <br>\r\n            <hr>\r\n            <h6>Contact us for a quotation and a free sample file.</h6>\r\n            <p>Simply fill out and submit the following form and we will provide you with a proposal.</p>\r\n            <contact-form [type]=\"Contact\"></contact-form>\r\n          <div class=\"get-started\">\r\n            <div>\r\n              <h2>Get Started Today</h2>\r\n              <h6>Contact us or create a Linescape account.</h6> \r\n            </div>\r\n            <div class=\"buttons-container\">\r\n              <a class=\"btn btn-lg\" [routerLink]=\"['/register', { scroll: true }]\"\r\n                >CREATE ACCOUNT</a\r\n              >\r\n              <a class=\"btn-outline btn-lg\" [routerLink]=\"['/contact', { scroll: true }]\"\r\n                ><div class=\"text-container\">CONTACT US</div></a\r\n              >\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  \r\n"

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(662));


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var AboutLandingComponent = (function () {
    function AboutLandingComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'About Us - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';
        this.modal = { isVisible: false, title: '', body: '' };
        // Do stuff
    }
    AboutLandingComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    AboutLandingComponent.prototype.openDavidModal = function () {
        this.modal.title = "David Tarizzo";
        this.modal.body = "David Tarizzo is co-Founder, and President and CEO of Linescape. David\u2019s extensive business development expertise and proven track record of turning opportunities and ideas into successful global business endeavors led to the inception of Linescape. Prior to co-founding Linescape, David held leadership positions in organizations across Europe and the USA. David also founded an international business that focused on shipping containers for specialty chemical products. David has a degree in chemistry from the University of Illinois and an MBA from the University of Michigan. David has lived in France and England, and currently resides near Chicago, Illinois. In his free time David likes to bike, sail, ski and play tennis.";
        this.modal.isVisible = true;
    };
    AboutLandingComponent.prototype.openDimitriosModal = function () {
        this.modal.title = "Dimitrios Sogas";
        this.modal.body = "Dimitrios Sogas is co-Founder of Linescape and serves as the company\u2019s Vice President and Managing Director. With more than 25 years of executive-level experience in the aerospace and commercial semiconductor industries, Dimitrios\u2019 technological expertise combined with his keen business acumen shaped the architecture and design of Linescape\u2019s unique platform. His big picture outlook and strategic approach to business solutions have been utilized by high-profile organizations around the world, and now at Linescape. Dimitrios holds a degree in electrical engineering from the University of Missouri and an MBA from Santa Clara University. Dimitrios lives in sunny Burlingame, California and enjoys skiing, cycling, cooking, travelling, and collecting and tasting good wine.";
        this.modal.isVisible = true;
    };
    AboutLandingComponent.prototype.closeModal = function () {
        this.modal.isVisible = false;
    };
    AboutLandingComponent = __decorate([
        core_1.Component({
            selector: 'about-landing',
            template: __webpack_require__(663),
            styles: [__webpack_require__(664)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], AboutLandingComponent);
    return AboutLandingComponent;
}());
exports.AboutLandingComponent = AboutLandingComponent;


/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-banner-inner\">\r\n        <h2>About Us</h2>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"main-content\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n          <div class=\"col-holder feature-box\">\r\n            <div class=\"col3of4\">\r\n              <h1>What We Do</h1>\r\n              <p>Linescape is the leading independent resource for searching and finding ocean container shipping routes and schedules. Shippers and forwarders now have everything they need for researching the best route for shipping their goods with the shipping line of their choice, at their fingertips.</p>\r\n              <div class=\"text-center\"><a [routerLink]=\"['/what-we-do', { scroll: true }]\" class=\"btn btn-lg\">LEARN MORE</a></div>\r\n            </div>\r\n            <div class=\"col1of4 no-gutter\">\r\n              <div class=\"d-table\">\r\n                <div class=\"d-table-cell\">\r\n                  <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 300 300\" style=\"enable-background:new 0 0 300 300;\" xml:space=\"preserve\"> <style type=\"text/css\"> .st0{fill:#FFFFFF;}</style> <path class=\"st0\" d=\"M131.5,138.5l-13.6,13.6l14.3,14.3c2.6,2.6,2.6,7.1,0,9.7c-1.3,1.3-3,2-4.8,2c-1.8,0-3.6-0.7-4.8-2L103.5,157 c-1.3-1.3-2-3-2-4.8s0.7-3.6,2-4.8l18.4-18.4c2.6-2.6,7.1-2.6,9.7,0C134.2,131.4,134.2,135.7,131.5,138.5z M169,176.6L169,176.6 c1.3,1.3,3,2,4.8,2c1.8,0,3.6-0.7,4.8-2l18.4-18.4c1.3-1.3,2-3,2-4.8s-0.7-3.6-2-4.8l-19.1-19.1c-1.3-1.3-3-2-4.8-2s-3.6,0.7-4.8,2 c-1.3,1.3-2,3-2,4.8s0.7,3.6,2,4.8l14.3,14.3L169,167C166.4,169.5,166.4,173.8,169,176.6z M137.8,191.4c0.7,0.2,1.4,0.4,2.2,0.4 c3,0,5.6-1.9,6.5-4.8l20.7-63.8c1.2-3.6-0.8-7.5-4.4-8.7c-1.8-0.6-3.6-0.4-5.3,0.4c-1.7,0.8-2.9,2.3-3.4,4l-20.7,63.9 C132.1,186.3,134,190.2,137.8,191.4z M151.2,59.8C101.5,59.8,61,100.3,61,150c0,36.4,21.6,69,55.2,83.2c3.5,1.4,7.6-0.1,9-3.6 c1.4-3.5-0.1-7.6-3.6-9c-28.4-12-46.7-39.7-46.7-70.5c0-42.2,34.4-76.6,76.6-76.6s76.6,34.4,76.6,76.6s-34.4,76.6-76.6,76.6 c-3.5,0-7.1-0.2-10.5-0.7c-1.8-0.2-3.6,0.2-5,1.3c-1.4,1.1-2.4,2.8-2.6,4.6c-0.5,3.7,2.2,7.2,5.9,7.7c4.1,0.6,8.2,0.8,12.4,0.8 c49.8,0,90.3-40.5,90.3-90.3C241.5,100.3,201,59.8,151.2,59.8z M300.4,140.2v19.7c0,7.2-5.4,13.1-12.5,13.7l-15.5,1.4 c-1.2,5.9-2.9,11.8-4.9,17.5l12.5,9.3c5.8,4.3,7.2,12.1,3.5,18.3l-10.3,16.8c-3.7,6.1-11.4,8.3-17.9,5.2l-13.9-7 c-2.9,3.1-5.9,6-9.1,8.8l6.4,14.2c3,6.5,0.5,14.2-5.8,17.7l-17.2,9.7c-6.2,3.5-14.1,1.8-18.1-4.2l-8.9-12.7 c-4.3,1.4-8.9,2.6-13.3,3.5l-1.4,15.5c-0.6,7.1-6.5,12.5-13.7,12.5h-19.7c-7.2,0-13.1-5.4-13.7-12.5l-1.4-15.5 c-5.9-1.2-11.8-2.9-17.5-4.9l-9.1,12.6c-4.3,5.8-12.1,7.2-18.3,3.5l-16.8-10.3c-6.1-3.7-8.3-11.4-5.2-17.9l7-13.9 c-3.1-2.9-6-5.9-8.8-9.1l-14.2,6.4c-6.5,3-14.2,0.5-17.7-5.8l-9.7-17.2c-3.5-6.2-1.8-14.1,4.2-18.1l12.7-8.9 c-1.4-4.3-2.6-8.9-3.5-13.3l-15.5-1.4c-7.1-0.6-12.5-6.5-12.5-13.7V140c0-7.2,5.4-13.1,12.5-13.7l15.5-1.4 c1.2-5.9,2.9-11.8,4.9-17.5l-12.5-9.3c-5.8-4.3-7.2-12.1-3.5-18.3L27.6,63c3.7-6.1,11.4-8.3,17.9-5.2l13.9,7c2.9-3.1,5.9-6,9.1-8.8 L61.9,42c-3-6.5-0.5-14.2,5.8-17.7l17.2-9.7c6.2-3.5,14.1-1.8,18.1,4.2l8.9,12.7c4.3-1.4,8.9-2.6,13.3-3.5l1.4-15.5 c0.6-7.2,6.5-12.6,13.7-12.6h19.7c7.2,0,13.1,5.4,13.7,12.5l1.4,15.5c5.9,1.2,11.8,2.9,17.5,4.9l9.3-12.5c4.3-5.8,12.1-7.2,18.3-3.5 l16.8,10.3c6.1,3.7,8.3,11.4,5.2,17.9l-7,13.9c3.1,2.9,6,5.9,8.8,9.1l14.2-6.4c6.5-3,14.2-0.5,17.7,5.8l9.7,17.2 c3.5,6.2,1.8,14.1-4.2,18.1l-12.7,8.8c1.4,4.3,2.6,8.9,3.5,13.3l15.5,1.4C294.9,127.1,300.4,133,300.4,140.2z M265.9,161.8l20.8-1.9 v-19.7l-20.8-1.9c-3.1-0.2-5.6-2.6-6.1-5.8c-1.2-7.2-3-14.3-5.5-21.2c-1.1-3,0-6.2,2.5-8.1l17.1-11.8l-9.7-17.2l-19,8.5 c-2.9,1.3-6.2,0.5-8.2-1.9c-4.3-5.4-9.1-10.5-14.4-14.9c-2.4-2-3.1-5.4-1.7-8.3l9.3-18.6l-16.8-10.3l-12.6,16.6 c-1.9,2.5-5.3,3.5-8.2,2.3c-7.9-3.2-16.2-5.6-24.8-7c-3.1-0.5-5.5-3-5.8-6.1L160,13.9h-19.8l-1.9,20.8c-0.2,3.1-2.6,5.6-5.8,6.1 c-7.2,1.2-14.3,3-21.2,5.5c-3,1.1-6.2,0-8.1-2.5L91.5,26.7l-17.1,9.5l8.7,19c1.3,2.9,0.5,6.2-1.9,8.2c-5.4,4.3-10.5,9.3-14.9,14.4 c-2,2.4-5.4,3.1-8.3,1.7l-18.6-9.3L29,87.1l16.5,12.6c2.5,1.9,3.5,5.3,2.3,8.2c-3.2,7.9-5.6,16.2-7,24.8c-0.5,3.1-3,5.5-6.1,5.8 L14,140.3v19.8l20.8,1.9c3.1,0.2,5.6,2.6,6.1,5.8c1.2,7.2,3,14.3,5.5,21.2c1.1,3,0,6.2-2.5,8.1l-17.1,11.8l9.7,17.2l19-8.5 c2.9-1.3,6.2-0.5,8.2,1.9c4.3,5.4,9.3,10.5,14.4,14.9c2.4,2,3.1,5.4,1.7,8.3l-9.3,18.6l16.8,10.3l12.5-16.7c1.3-1.7,3.4-2.8,5.5-2.8 c1,0,1.8,0.1,2.6,0.5c7.9,3.2,16.2,5.6,24.8,7c3.1,0.5,5.5,3,5.8,6.1l1.9,20.7h19.8l1.9-20.8c0.2-3.1,2.6-5.6,5.8-6.1 c7.2-1.2,14.3-3,21.2-5.5c3-1.1,6.2,0,8.1,2.5l11.8,17.1l17.2-9.7l-8.5-19c-1.3-2.9-0.5-6.2,1.9-8.2c5.4-4.3,10.5-9.1,14.9-14.4 c2-2.4,5.4-3.1,8.3-1.7l18.6,9.3l10.3-16.8l-16.7-12.5c-2.5-1.9-3.5-5.3-2.3-8.2c3.2-7.9,5.6-16.2,7-24.8 C260.2,164.4,262.7,162,265.9,161.8z M177.8,84.8c-8.8-3.7-18-5.5-27.6-5.5c-39.1,0-70.9,31.8-70.9,70.9s31.8,70.9,70.9,70.9 s70.9-31.8,70.9-70.9c0-19.9-8.4-39.1-23.2-52.4c-1.3-1.2-3.1-1.9-4.9-1.8s-3.5,0.8-4.8,2.3c-1.2,1.3-1.9,3.1-1.8,4.9 s0.8,3.5,2.3,4.8c11.9,10.8,18.6,26.2,18.6,42.3c0,31.5-25.6,57.1-57.1,57.1s-57.1-25.6-57.1-57.1s25.6-57.1,57.1-57.1 c7.7,0,15.1,1.6,22.2,4.4c1.7,0.7,3.6,0.7,5.3,0s3-2,3.7-3.7s0.7-3.6,0-5.3C180.8,86.8,179.5,85.5,177.8,84.8z\"/> </svg>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-holder feature-box\">\r\n            <div class=\"col1of4 no-gutter\">\r\n              <div class=\"d-table\">\r\n                <div class=\"d-table-cell\">\r\n                    <svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n                    viewBox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\">\r\n                 <style type=\"text/css\">\r\n                   .st0{fill:#FFFFFF;}\r\n                 </style>\r\n                 <g>\r\n                   <g>\r\n                     <path class=\"st0\" d=\"M451.7,237.3c-17.4-8.7-50.1-8.8-51.5-8.8c-4.1,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5c8.4,0,32.9,1.3,44.8,7.2\r\n                       c1.1,0.5,2.2,0.8,3.3,0.8c2.8,0,5.4-1.5,6.7-4.1C456.9,243.6,455.4,239.1,451.7,237.3z\"/>\r\n                   </g>\r\n                 </g>\r\n                 <g>\r\n                   <g>\r\n                     <path class=\"st0\" d=\"M489.1,344l-31-8.9c-1.3-0.4-2.3-1.6-2.3-3v-10.3c2.5-1.7,4.9-3.7,7.2-5.9c10.9-10.6,16.9-24.7,16.9-39.9\r\n                       v-14.3l3-6c3.3-6.6,5-13.9,5-21.3v-38.6c0-4.1-3.4-7.5-7.5-7.5h-72.2c-26.2,0-47.6,21.4-47.6,47.6v0.4c0,6.1,1.4,12.2,4.2,17.7\r\n                       l3.8,7.7V274c0,19.4,9.6,36.8,24.1,47.3l0,10.8c0,1.7,0,2.4-6.2,4.1l-15.1,4.3l-43.7-15.9c0.2-2.1-0.5-4.2-2-5.7l-14-14.7v-24.6\r\n                       c1.5-1.2,2.9-2.5,4.3-3.8c17.6-16.5,27.7-39.8,27.7-64v-19.7c5.3-11.6,8-23.8,8-36.5V75.6c0-4.1-3.4-7.5-7.5-7.5H232\r\n                       c-39.5,0-71.7,32.1-71.7,71.7v16c0,12.6,2.7,24.9,8,36.5v16.9c0,28,12.5,53.3,32.1,69.9v25.2l-14,14.7c-1.5,1.6-2.2,3.7-2,5.7\r\n                       l-46.1,16.8c-3.3,1.2-6.5,2.9-9.3,4.9l-7.2-3.6c21.6-9.4,28.4-22.6,28.7-23.2c1.1-2.1,1.1-4.6,0-6.7c-5.4-10.8-6.1-30.6-6.6-46.6\r\n                       c-0.2-5.3-0.3-10.3-0.7-14.8c-2.6-36-29.9-63.1-63.6-63.1s-61.1,27.1-63.6,63.1c-0.3,4.5-0.5,9.5-0.7,14.8\r\n                       c-0.5,15.9-1.2,35.7-6.6,46.6c-1.1,2.1-1.1,4.6,0,6.7c0.3,0.7,7.1,13.8,28.8,23.2l-20.1,10.1C6.7,358.2,0,369,0,381v55.4\r\n                       c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5V381c0-6.3,3.5-12,9.2-14.8l25.1-12.5l8.7,8.3c6.1,5.8,13.9,8.7,21.7,8.7\r\n                       c7.8,0,15.6-2.9,21.7-8.7l8.7-8.3l8.2,4.1c-3.8,6.2-6,13.4-6,20.9v57.7c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-57.7\r\n                       c0-10.3,6.5-19.6,16.2-23.1l48.7-17.7l20.3,30.4c2.6,3.9,6.7,6.4,11.4,6.8c0.5,0.1,1,0.1,1.5,0.1c4.1,0,8-1.6,11-4.5l12.4-12.4\r\n                       v78.1c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-78.1l12.4,12.4c2.9,2.9,6.9,4.5,11,4.5c0.5,0,1,0,1.5-0.1c4.6-0.5,8.8-3,11.4-6.8\r\n                       l20.3-30.4l48.7,17.7c9.7,3.5,16.2,12.8,16.2,23.1v57.7c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-57.7c0-10.4-4.1-20.2-11.1-27.4\r\n                       l1.9-0.5c1.9-0.5,4.4-1.3,7-2.5l19.1,19.1v69.1c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-69.1l19-19c1,0.5,2.1,0.9,3.2,1.3l31,8.9\r\n                       c7.1,2,12,8.6,12,15.9v62c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-62C512,360.4,502.6,347.9,489.1,344z M48.1,330.8\r\n                       c-14-5-21.1-11.8-24.1-15.5c2-5.4,3.4-11.5,4.3-18c4.1,9.9,11.1,18.4,19.8,24.4V330.8z M91.1,351.1c-6.4,6.1-16.4,6.1-22.8,0\r\n                       l-7-6.6c1.2-2.2,1.8-4.7,1.8-7.3v-8c5.2,1.6,10.8,2.5,16.6,2.5c5.8,0,11.3-0.9,16.6-2.5l0,8c0,2.6,0.6,5.1,1.8,7.3L91.1,351.1z\r\n                        M79.7,316.7c-22.4,0-40.6-18.2-40.6-40.6c0-4.1-3.4-7.5-7.5-7.5c-0.4,0-0.8,0-1.2,0.1c0-0.6,0-1.3,0.1-1.9\r\n                       c0.2-5.2,0.3-10,0.6-14.2c1-13.5,6.3-25.9,15.2-35c8.9-9.2,20.8-14.2,33.5-14.2s24.6,5,33.5,14.2c8.8,9.1,14.2,21.5,15.2,35\r\n                       c0.3,4.2,0.5,9,0.6,14.2c0,0.4,0,0.9,0,1.3c-8.2-12.6-20.8-21.8-37-27.1c-15-4.8-28-4.5-28.5-4.5c-2,0.1-3.8,0.9-5.2,2.3l-13.5,14\r\n                       c-2.9,3-2.8,7.7,0.2,10.6s7.7,2.8,10.6-0.2l11.3-11.7c9.7,0.5,40.9,4.1,53,30.8C116.7,302,99.8,316.7,79.7,316.7z M111.2,330.8\r\n                       l0-8.9c8.7-6,15.7-14.5,19.8-24.4c0.9,6.5,2.2,12.6,4.3,17.9C132.3,319,125.2,325.8,111.2,330.8z M183.4,209.1v-18.6\r\n                       c0-1.1-0.3-2.2-0.7-3.3c-4.8-10-7.3-20.6-7.3-31.5v-16c0-31.2,25.4-56.7,56.7-56.7h104.8v72.7c0,10.9-2.4,21.5-7.3,31.5\r\n                       c-0.5,1-0.7,2.1-0.7,3.3v21.4c0,20.3-8.2,39.1-23,53c-1.9,1.7-3.8,3.4-5.8,4.9c0,0-0.1,0.1-0.1,0.1\r\n                       c-13.9,10.5-30.9,15.7-48.7,14.5C213.2,282,183.4,248.9,183.4,209.1z M225.6,360.1c-0.1,0.1-0.2,0.2-0.4,0.1\r\n                       c-0.2,0-0.3-0.2-0.4-0.2l-23.3-35l7.5-7.9l35.4,24.2L225.6,360.1z M256.1,331.1l-40.6-27.8v-14c10.5,5.7,22.3,9.2,34.8,10\r\n                       c2,0.1,3.9,0.2,5.9,0.2c14.3,0,28.1-3.4,40.5-9.9v13.7L256.1,331.1z M287.4,360c0,0.1-0.1,0.2-0.4,0.2c-0.2,0-0.4-0.1-0.4-0.1\r\n                       l-18.8-18.8l35.4-24.2l7.5,7.9L287.4,360z M424.3,353.6l-17-17c0.3-1.3,0.5-2.8,0.5-4.5l0-3.2c4.7,1.5,9.7,2.5,14.9,2.6\r\n                       c0.6,0,1.2,0,1.7,0c5.7,0,11.2-0.9,16.5-2.5v3c0,1.5,0.2,3,0.5,4.4L424.3,353.6z M452.6,305.2c-7.9,7.7-18.5,11.8-29.5,11.4\r\n                       c-21.7-0.7-39.4-19.8-39.4-42.6v-14c0-1.2-0.3-2.3-0.8-3.4l-4.6-9.3c-1.7-3.4-2.6-7.2-2.6-11V236c0-18,14.6-32.6,32.6-32.6h64.7\r\n                       v31.1c0,5-1.2,10.1-3.4,14.6l-3.8,7.6c-0.5,1-0.8,2.2-0.8,3.4v16C464.9,287.1,460.5,297.5,452.6,305.2z\"/>\r\n                   </g>\r\n                 </g>\r\n                 <g>\r\n                   <g>\r\n                     <path class=\"st0\" d=\"M472.4,380.8c-4.1,0-7.5,3.4-7.5,7.5v48.1c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-48.1\r\n                       C479.9,384.2,476.6,380.8,472.4,380.8z\"/>\r\n                   </g>\r\n                 </g>\r\n                 <g>\r\n                   <g>\r\n                     <path class=\"st0\" d=\"M39.6,390.7c-4.1,0-7.5,3.4-7.5,7.5v38.2c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-38.2\r\n                       C47.1,394.1,43.7,390.7,39.6,390.7z\"/>\r\n                   </g>\r\n                 </g>\r\n                 <g>\r\n                   <g>\r\n                     <path class=\"st0\" d=\"M317.5,158.5c-28.4-28.4-87.7-22.9-111.9-19.3c-7.6,1.1-13.2,7.6-13.2,15.3v17.3c0,4.1,3.4,7.5,7.5,7.5\r\n                       s7.5-3.4,7.5-7.5v-17.3c0-0.3,0.2-0.5,0.4-0.5c9.7-1.5,28.9-3.7,48.7-2.4c23.4,1.6,40.3,7.4,50.3,17.4c2.9,2.9,7.7,2.9,10.6,0\r\n                       C320.5,166.2,320.5,161.4,317.5,158.5z\"/>\r\n                   </g>\r\n                 </g>\r\n                 <g>\r\n                   <g>\r\n                     <path class=\"st0\" d=\"M167.9,396.9c-4.1,0-7.5,3.4-7.5,7.5v32.1c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-32.1\r\n                       C175.4,400.2,172,396.9,167.9,396.9z\"/>\r\n                   </g>\r\n                 </g>\r\n                 <g>\r\n                   <g>\r\n                     <path class=\"st0\" d=\"M344.3,396.9c-4.1,0-7.5,3.4-7.5,7.5v32.1c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5v-32.1\r\n                       C351.8,400.2,348.4,396.9,344.3,396.9z\"/>\r\n                   </g>\r\n                 </g>\r\n                 </svg>\r\n                 \r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col3of4\">\r\n              <h1>Who We Are</h1>\r\n              <p>We believe that the process of finding a carrier should be a simple one. Our aim is to help achieve this by presenting routing and scheduling information in a clear and easy to understand format.</p>\r\n              <div class=\"text-center\"><a [routerLink]=\"['/who-we-are', { scroll: true }]\" class=\"btn btn-lg\">LEARN MORE</a></div>\r\n              \r\n            </div>\r\n          </div>\r\n          <div class=\"col-holder feature-box\">\r\n            <div class=\"col3of4\">\r\n              <h1>Upcoming Events</h1>\r\n              <p>The team at Linescape regularly attends major industry events, and would be happy to meet you there. To arrange a meeting, <a [routerLink]=\"['contact']\">contact us</a>, indicating which event you plan to attend and one of our team will contact you to schedule an appointment.</p>\r\n              <div class=\"text-center\"><a [routerLink]=\"['/upcoming-events', { scroll: true }]\" class=\"btn btn-lg\">LEARN MORE</a></div>\r\n            </div>\r\n            <div class=\"col1of4 no-gutter\">\r\n                <div class=\"d-table\">\r\n                    <div class=\"d-table-cell\">\r\n                        <svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n                        viewBox=\"0 0 433.6 433.6\" style=\"enable-background:new 0 0 433.6 433.6;\" xml:space=\"preserve\">\r\n                        <style type=\"text/css\">\r\n                       .st0{fill:#FFFFFF;}\r\n                        </style>\r\n                          <g>\r\n                            <g>\r\n                              <g>\r\n                                <path class=\"st0\" d=\"M388.7,47c-0.9,0-1.8,0-2.7,0h-33.4V18.3c0-11.5-11-18.3-22.5-18.3h-30.8c-11.5,0-19.9,6.8-19.9,18.3V47\r\n                                  H154.1V18.3c0-11.5-8.4-18.3-19.9-18.3h-30.8C92,0,81,6.8,81,18.3V47H47.5C26.2,46.4,8.4,63.2,7.8,84.6c0,0.9,0,1.8,0,2.7v302\r\n                                  c0,23,16.7,44.4,39.7,44.4h338.5c23,0,39.7-21.4,39.7-44.4v-302C426.7,65.9,410.1,47.9,388.7,47z M299.4,20.9h32.4v57.5h-32.4\r\n                                  V20.9z M103.4,20.9h29.8v57.5h-29.8C103.4,78.4,103.4,20.9,103.4,20.9z M404.9,389.2c0,11.5-7.3,23.5-18.8,23.5H47.5\r\n                                  c-11.5,0-18.8-12-18.8-23.5v-222h376.2L404.9,389.2L404.9,389.2z M404.9,87.2v59H28.7v-59c-0.9-9.8,6.3-18.4,16.1-19.3\r\n                                  c0.9-0.1,1.8-0.1,2.7,0H81v11.5c0,11.5,11,19.9,22.5,19.9h30.8c10.7,0.3,19.6-8.1,19.9-18.8c0-0.4,0-0.7,0-1.1V67.9h125.4v11.5\r\n                                  c-0.3,10.7,8.1,19.6,18.8,19.9c0.4,0,0.7,0,1.1,0h30.8c11.5,0,22.5-8.4,22.5-19.9V67.9h33.4c9.8-0.6,18.2,6.8,18.8,16.6\r\n                                  C405,85.4,405,86.3,404.9,87.2z\"/>\r\n                                <path class=\"st0\" d=\"M158.8,309.8l-9.4,52.2c-0.4,2.2,0,4.5,1,6.6c2.7,5.1,9,7.1,14.1,4.4l47-24.6l47,24.6l4.7,1\r\n                                  c2.3,0,4.5-0.7,6.3-2.1c3.1-2.3,4.7-6.1,4.2-9.9l-9.4-52.2l38.1-36.6c2.7-2.9,3.7-7.1,2.6-11c-1.4-3.6-4.6-6.1-8.4-6.8l-52.2-7.8\r\n                                  L221,200.1c-1-2.1-2.7-3.8-4.8-4.8c-5.2-2.5-11.4-0.3-14,4.8l-23.5,47.5l-52.2,7.8c-3.8,0.6-7,3.2-8.4,6.8c-1.1,3.9-0.1,8,2.6,11\r\n                                  L158.8,309.8z M187.6,267.5c3.3-0.5,6.1-2.7,7.3-5.7l16.7-33.4l16.7,33.4c1.3,3.1,4,5.3,7.3,5.7l37.1,5.2l-26.6,25.6\r\n                                  c-2.5,2.5-3.6,5.9-3.1,9.4l6.3,37.1l-32.9-17.8l-4.7-1l-4.7,1L174,344.8l6.3-37.1c0.5-3.5-0.7-6.9-3.1-9.4l-26.6-25.6\r\n                                  L187.6,267.5z\"/>\r\n                              </g>\r\n                            </g>\r\n                          </g>\r\n                        </svg>\r\n                </div></div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-holder feature-box\">\r\n              <div class=\"col1of4 no-gutter\">\r\n                  <div class=\"d-table\">\r\n                      <div class=\"d-table-cell\">\r\n                          <svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t                        viewBox=\"0 0 189.2 189.2\" style=\"enable-background:new 0 0 189.2 189.2;\" xml:space=\"preserve\">\r\n                          <style type=\"text/css\">\r\n                            .st0{fill:#FFFFFF;}\r\n                          </style>\r\n                          <g>\r\n                            <path class=\"st0\" d=\"M87.5,145H57.2c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5h30.4c2.5,0,4.5-2,4.5-4.5S90,145,87.5,145z\"/>\r\n                            <path class=\"st0\" d=\"M100,72.7h46.9c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5H100c-2.5,0-4.5,2-4.5,4.5S97.5,72.7,100,72.7z\"/>\r\n                            <path class=\"st0\" d=\"M44.9,94.1H16.2c-2.5,0-4.5,2-4.5,4.5v50.9c0,2.5,2,4.5,4.5,4.5h28.8c2.5,0,4.5-2,4.5-4.5V98.6\r\n                              C49.4,96.1,47.4,94.1,44.9,94.1z M20.7,145v-41.9h19.8V145H20.7z\"/>\r\n                            <path class=\"st0\" d=\"M146.1,80.9c0-2.5-2-4.5-4.5-4.5H100c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5h41.6\r\n                              C144.1,85.4,146.1,83.4,146.1,80.9z\"/>\r\n                            <path class=\"st0\" d=\"M129.3,94.3c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5h19.7c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5H129.3z\"/>\r\n                            <path class=\"st0\" d=\"M129.3,107c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5h13c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5H129.3z\"/>\r\n                            <path class=\"st0\" d=\"M57.2,141.3h21.3c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5H57.2c-2.5,0-4.5,2-4.5,4.5S54.7,141.3,57.2,141.3z\"/>\r\n                            <path class=\"st0\" d=\"M100,47.2h35.4c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5H100c-2.5,0-4.5,2-4.5,4.5S97.5,47.2,100,47.2z\"/>\r\n                            <path class=\"st0\" d=\"M100,60h41.6c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5H100c-2.5,0-4.5,2-4.5,4.5S97.5,60,100,60z\"/>\r\n                            <path class=\"st0\" d=\"M100,34.5h46.9c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5H100c-2.5,0-4.5,2-4.5,4.5S97.5,34.5,100,34.5z\"/>\r\n                            <path class=\"st0\" d=\"M99.3,116h13c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5h-13c-2.5,0-4.5,2-4.5,4.5S96.8,116,99.3,116z\"/>\r\n                            <path class=\"st0\" d=\"M118.9,94.3H99.3c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5h19.7c2.5,0,4.5-2,4.5-4.5S121.4,94.3,118.9,94.3z\"/>\r\n                            <path class=\"st0\" d=\"M117.8,119.7H99.3c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5h18.6c2.5,0,4.5-2,4.5-4.5S120.3,119.7,117.8,119.7z\"/>\r\n                            <path class=\"st0\" d=\"M150.9,119.8h-21.6c-2.5,0-4.5,2-4.5,4.5v25.2c0,2.5,2,4.5,4.5,4.5h21.6c2.5,0,4.5-2,4.5-4.5v-25.2\r\n                              C155.4,121.8,153.4,119.8,150.9,119.8z M146.4,128.8V145h-12.6v-16.2H146.4z\"/>\r\n                            <path class=\"st0\" d=\"M184.2,33.6h-18.6V15.1c0-2.5-2-4.5-4.5-4.5H2.5c-2.5,0-4.5,2-4.5,4.5v143.2c0,11.2,9.1,20.3,20.3,20.3h153.1\r\n                              c0.3,0,0.6,0,0.8-0.1c0.6,0.1,1.1,0.1,1.7,0.1c9.5,0,17.3-7.7,17.3-17.3V40.6C191.2,36.7,188.1,33.6,184.2,33.6z M182.2,42.6v118.8\r\n                              c0,4.6-3.7,8.3-8.3,8.3s-8.3-3.7-8.3-8.3l0-118.8L182.2,42.6z M158.8,169.6H18.3c-6.3,0-11.3-5.1-11.3-11.3V19.6h149.7v141.7\r\n                              C156.7,164.3,157.4,167.1,158.8,169.6z\"/>\r\n                            <path class=\"st0\" d=\"M89,25.5H16.2c-2.5,0-4.5,2-4.5,4.5v50.9c0,2.5,2,4.5,4.5,4.5H89c2.5,0,4.5-2,4.5-4.5V30\r\n                              C93.5,27.5,91.5,25.5,89,25.5z M84.5,34.5v41.9H20.7V34.5H84.5z\"/>\r\n                            <path class=\"st0\" d=\"M57.2,115.8h21.3c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5H57.2c-2.5,0-4.5,2-4.5,4.5S54.7,115.8,57.2,115.8z\"/>\r\n                            <path class=\"st0\" d=\"M99.3,141.5h13c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5h-13c-2.5,0-4.5,2-4.5,4.5S96.8,141.5,99.3,141.5z\"/>\r\n                            <path class=\"st0\" d=\"M57.2,103.1H87c2.5,0,4.5-2,4.5-4.5s-2-4.5-4.5-4.5H57.2c-2.5,0-4.5,2-4.5,4.5S54.7,103.1,57.2,103.1z\"/>\r\n                            <path class=\"st0\" d=\"M87.5,119.6H57.2c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5h30.4c2.5,0,4.5-2,4.5-4.5S90,119.6,87.5,119.6z\"/>\r\n                            <path class=\"st0\" d=\"M117.8,145.2H99.3c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5h18.6c2.5,0,4.5-2,4.5-4.5S120.3,145.2,117.8,145.2z\"/>\r\n                          </g>\r\n                          </svg>\r\n                </div></div>\r\n              </div>\r\n            <div class=\"col3of4\">\r\n              <h1>Press</h1>\r\n              <p>Read about the most recent Linescape announcements, press releases and success stories, as well as historical milestones and achievements.</p>\r\n              <div class=\"text-center\">\r\n                <a [routerLink]=\"['/press', { scroll: true }]\" class=\"btn btn-lg\">LEARN MORE</a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"get-started\">\r\n            <div>\r\n              <h2>Get Started Today</h2>\r\n              <h6>Contact us or create a Linescape account.</h6>\r\n            </div>\r\n            <div class=\"buttons-container\">\r\n              <a class=\"btn btn-lg\" [routerLink]=\"['/register', { scroll: true }]\"\r\n                >CREATE ACCOUNT</a\r\n              >\r\n              <a class=\"btn-outline btn-lg\" [routerLink]=\"['/contact', { scroll: true }]\"\r\n                ><div class=\"text-container\">CONTACT US</div></a\r\n              >\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  \r\n"

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = ".d-table {\n  display: table; }\n\n.d-table-cell {\n  display: table-cell; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 457px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 30px 60px;\n  width: 100%; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1, .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3, .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n\n.col-holder {\n  width: calc(100% + 20px);\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: -10px !important; }\n  .col-holder .col1of4, .col-holder .col2of4, .col-holder .col3of4, .col-holder .col4of4 {\n    margin: 0 10px; }\n    .col-holder .col1of4.no-gutter, .col-holder .col2of4.no-gutter, .col-holder .col3of4.no-gutter, .col-holder .col4of4.no-gutter {\n      margin: 0; }\n  .col-holder .col1of4 {\n    -ms-flex: 1 0 calc(25% - 20px);\n        flex: 1 0 calc(25% - 20px); }\n  .col-holder .col3of4 {\n    -ms-flex: 1 0 calc(75% - 20px);\n        flex: 1 0 calc(75% - 20px); }\n\n.feature-box {\n  border: 1px solid #d7d7d7;\n  margin: 30px 0;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3); }\n  .feature-box .col3of4 {\n    padding: 20px; }\n  .feature-box h1 {\n    margin-top: 0;\n    text-align: center;\n    color: #247cbd;\n    font-weight: bold; }\n  .feature-box .btn, .feature-box .btn-outline {\n    margin-top: 20px; }\n  .feature-box .d-table {\n    width: 100%;\n    height: 100%;\n    padding: 20%; }\n  .feature-box .d-table-cell {\n    vertical-align: middle; }\n  .feature-box .text-center .btn, .feature-box .text-center .btn-outline {\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-bottom: 5px; }\n  .feature-box .col1of4 {\n    background-repeat: no-repeat;\n    background-size: cover; }\n  .feature-box:nth-of-type(1) .col1of4 {\n    background-image: url(/img/solutions-background-1.png); }\n  .feature-box:nth-of-type(2) .col1of4 {\n    background-image: url(/img/solutions-background-2.png); }\n  .feature-box:nth-of-type(3) .col1of4 {\n    background-image: url(/img/solutions-background-3.png); }\n  .feature-box:nth-of-type(4) .col1of4 {\n    background-image: url(/img/solutions-background-4.png); }\n\n@media (max-width: 767px) {\n  .feature-box {\n    -ms-flex-direction: column;\n        flex-direction: column; }\n    .feature-box .col1of4 {\n      background: none !important;\n      -ms-flex-order: 0;\n          order: 0; }\n    .feature-box .col3of4 {\n      -ms-flex-order: 1;\n          order: 1; }\n    .feature-box .d-table {\n      padding: 0;\n      padding-top: 30px; }\n    .feature-box .d-table-cell {\n      text-align: center; }\n    .feature-box svg {\n      max-width: 100px;\n      max-height: 100px; }\n      .feature-box svg * {\n        fill: #92ACCA; } }\n\n.get-started {\n  margin: 50px 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  .get-started h2 {\n    color: #247cbd;\n    margin-top: 0;\n    margin-bottom: 5px; }\n  .get-started h6 {\n    color: #666;\n    margin-top: 0; }\n  .get-started .buttons-container {\n    margin-top: 17px; }\n    .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 599px) {\n  .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n"

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(666));


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var UpcomingEventsComponent = (function () {
    function UpcomingEventsComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'Upcoming Events - Linescape';
        this.description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';
        // Do stuff
    }
    UpcomingEventsComponent.prototype.ngAfterViewInit = function () {
        this.seo.set(this.title, this.description);
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    UpcomingEventsComponent = __decorate([
        core_1.Component({
            selector: 'upcoming-events',
            template: __webpack_require__(667),
            styles: [__webpack_require__(668)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], UpcomingEventsComponent);
    return UpcomingEventsComponent;
}());
exports.UpcomingEventsComponent = UpcomingEventsComponent;


/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Upcoming Events</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"page-top-content\">\r\n          <p>The team at Linescape regularly attends major industry events, and would be happy to meet you there. To\r\n            arrange a meeting, fill out the form below indicating which\r\n            event you plan to attend and one of our team will contact you to schedule an appointment.</p>\r\n          <ul>\r\n            <li><b>Manifest 2023</b>: <a href=\"https://manife.st/\" target=\"_blank\">Manifest - The Future of Logistics</a>, Jan. 31 - Feb. 2, 2023, Las Vegas, NV</li>\r\n            <li><b>TPM Tech 2023</b>: <a href=\"https://events.joc.com/tpmtech/index.html\" target=\"_blank\">JOC Logistics Technology Conference</a>, Feb. 23-24, 2023, Long Beach, CA</li>\r\n            <li><b>Transport Logistic 2023</b>: <a href=\"https://transportlogistic.de/en/\" target=\"_blank\">International Exhibition for Logistics</a>, May 9-12, 2023, Munich, Germany</li>\r\n          </ul>\r\n          <p style=\"margin-top: 30px;\">Previous Events:</p>\r\n          <ul>\r\n            <li><b>TPM'2022</b>: <a href=\"https://events.joc.com/tpm/program/agenda.html\" target=\"_blank\">Trans-Pacific Maritime Conference</a>, Feb. 27 - Mar. 2, 2022, Long Beach, CA (JOC)</li>\r\n            <li><b>TPM Tech</b>: <a href=\"https://events.joc.com/tpm/tpmtech/tpmtech-agenda.html\" target=\"_blank\">Logistics Technology Conference</a>, Feb. 24-25, 2022, Long Beach, CA (JOC)</li>\r\n            <li><b>GLS'20</b>: <a href=\"https://informaconnect.com/global-liner-shipping/\" target=\"_blank\">Global Liner Shipping - Virtual</a>, Nov. 3-4, 2020, Online Event (Informa) </li>\r\n            <li><b>TPM'2020</b>: <a href=\"https://events.joc.com/tpm/index.html\" target=\"_blank\">Trans-Pacific Maritime Conference</a>, March 1-4, 2020, Long Beach, CA (JOC) </li>\r\n            <li><b>GLS-Asia'19</b>: <a href=\"https://informaconnect.com/global-liner-shipping/\" target=\"_blank\">Global Liner Shipping Asia Conference</a>, Sept. 17-19, 2019, Singapore, SG (Informa) </li>\r\n            <li><b>LogTech'19</b>: <a href=\"https://www.joc-logtech.com/\" target=\"_blank\">Logistics Technology Conference</a>, Sept. 8-10, 2019, Las Vegas, NV (JOC) </li>\r\n            <li><b>GLS'19</b>: <a href=\"https://informaconnect.com/global-liner-shipping/\" target=\"_blank\">Global Liner Shipping Europe</a>, May 13-15, 2019, Hamburg, DE (KNect365) </li>\r\n            <li><b>TPM'2019</b>: <a href=\"https://events.joc.com/tpm/index.html\" target=\"_blank\">Trans-Pacific Maritime Conference</a>, March 3-6, 2019, Long Beach, CA (JOC) </li>\r\n            <li><b>LogTech'18</b>: <a href=\"https://www.joc-logtech.com/\" target=\"_blank\">Logistics Technology Conference</a>, Oct. 29-30, 2018, Las Vegas, NV (JOC) </li>\r\n          </ul>\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <h6>Make an Appointment</h6>\r\n          <p>Meet with the Linescape team at the next event.</p>\r\n          <div class=\"page-content-left\">\r\n            <appt-form [type]=\"appointment\"></appt-form>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <div class=\"sidebar-section\">\r\n              <h6>Setup a Meeting</h6>\r\n              <p>Complete this form to book a meeting to:</p>\r\n              <ul>\r\n                <li>See a live demo of Linescape's sailing schedules</li>\r\n                <li>Get advice and tips on using Linescape's API</li>\r\n                <li>Understand data feed formats and structures</li>\r\n                <li>Explore partnership and integration opportunities</li>\r\n                <li>See what’s coming up next at Linescape</li>\r\n              </ul>\r\n              <h6>Follow us on Social Media</h6>\r\n              <div class=\"social-links\">\r\n                  <ul>\r\n                      <li><a href=\"http://www.facebook.com/pages/Linescape/127633963941865\"><img src=\"../img/facebook-logotype-button.png\"></a></li>\r\n                      <li><a href=\"http://www.linkedin.com/company/linescape\"><img src=\"../img/linkedin-logotype-button.png\"></a></li>\r\n                      <li><a href=\"http://twitter.com/Linescape\"><img src=\"../img/twitter-logo.png\"></a></li>\r\n                  </ul>\r\n              </div>\r\n            </div>\r\n          </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n</div>\r\n"

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = ".d-table {\n  display: table; }\n\n.d-table-cell {\n  display: table-cell; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 456px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 50px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-full {\n    vertical-align: top; }\n    .page-content .page-content-full p, .page-content .page-content-full li, .page-content .page-content-full div, .page-content .page-content-full label {\n      font-size: 18px;\n      line-height: 32px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n.team-section {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n  .team-section .pure-g .founder {\n    cursor: pointer;\n    width: 96%;\n    overflow: hidden; }\n  .team-section .pure-g .pure-u-1-2 .team-text, .team-section .pure-g .pure-u-1-4 .team-text {\n    padding: 0 10px 10px 10px; }\n  .team-section .pure-g .pure-u-1-2 h1, .team-section .pure-g .pure-u-1-2 h2, .team-section .pure-g .pure-u-1-2 h3, .team-section .pure-g .pure-u-1-2 h4, .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-2 h6, .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-2 label, .team-section .pure-g .pure-u-1-2 li, .team-section .pure-g .pure-u-1-4 h1, .team-section .pure-g .pure-u-1-4 h2, .team-section .pure-g .pure-u-1-4 h3, .team-section .pure-g .pure-u-1-4 h4, .team-section .pure-g .pure-u-1-4 h5, .team-section .pure-g .pure-u-1-4 h6, .team-section .pure-g .pure-u-1-4 p, .team-section .pure-g .pure-u-1-4 label, .team-section .pure-g .pure-u-1-4 li {\n    color: #ffffff; }\n  .team-section .pure-g .pure-u-1-2 h5, .team-section .pure-g .pure-u-1-4 h5 {\n    font-weight: bold;\n    line-height: 32px;\n    color: #ffffff;\n    font-size: 20px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0; }\n  .team-section .pure-g .pure-u-1-2 p, .team-section .pure-g .pure-u-1-4 p {\n    line-height: 20px;\n    margin-bottom: 5px; }\n  .team-section .pure-g .pure-u-1-2 img, .team-section .pure-g .pure-u-1-4 img {\n    max-width: 100%;\n    width: 100%;\n    transition: all 0.3s;\n    transform: scale(1); }\n  .team-section .pure-g .pure-u-1-2 .founder img:hover, .team-section .pure-g .pure-u-1-4 .founder img:hover {\n    transform: scale(1.1);\n    padding-bottom: 15px; }\n  .team-section .pure-g .team-text.bio h5:hover {\n    color: #fc7d17;\n    cursor: pointer; }\n  .team-section .team-member {\n    margin: 10px;\n    background-color: #393939; }\n\n#who-we-are {\n  padding-top: 30px;\n  margin-top: 30px;\n  border-top: 1px solid #e9e9e9; }\n\n.page-content .quote {\n  padding-top: 20px;\n  font-size: 16px;\n  color: #7a7a7a;\n  width: 80%;\n  margin: 0 auto;\n  font-style: italic; }\n\n.page-content .quote-by {\n  font-size: 16px;\n  text-align: right;\n  color: #7a7a7a; }\n\n/*** MODAL CSS ***/\n.modal {\n  position: fixed;\n  /* Stay in place */\n  z-index: 1;\n  /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: auto;\n  /* Enable scroll if needed */\n  background-color: black;\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */ }\n\n/* Modal Content/Box */\n.modal-content {\n  background-color: #fefefe;\n  margin: 15% auto;\n  /* 15% from the top and centered */\n  padding: 50px;\n  border: 1px solid #888;\n  width: 80%;\n  /* Could be more or less, depending on screen size */ }\n\n/* The Close Button */\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold; }\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer; }\n\n.get-started {\n  padding: 50px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  border-top: 1px solid #e9e9e9; }\n  .get-started h2 {\n    color: #247cbd; }\n  .get-started h6 {\n    color: #666; }\n  .get-started .buttons-container {\n    margin-top: 17px; }\n    .get-started .buttons-container .btn-outline {\n      margin-left: 10px; }\n\n@media (max-width: 979px) {\n  .get-started {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 30px 0; } }\n\n@media (max-width: 479px) {\n  .get-started .btn-outline {\n    margin-left: 0 !important;\n    margin-top: 15px; } }\n\n@media only screen and (max-width: 1023px) {\n  .pure-u-1-4, .pure-u-6-24 {\n    width: 50%; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; }\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(50% - 20px); }\n  .team-section .col-holder.full-width-team {\n    display: none; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; }\n  .pure-u-1-2, .pure-u-1-4 {\n    width: 100%; } }\n\n@media only screen and (max-width: 599px) {\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(100% - 20px); } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(670));


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var blur_service_1 = __webpack_require__(671);
var shared_1 = __webpack_require__(2);
var BlurComponent = (function () {
    function BlurComponent(logger, service) {
        this.logger = logger;
        this.service = service;
        // Do stuff
    }
    Object.defineProperty(BlurComponent.prototype, "itemtype", {
        set: function (type) {
            this.service.setType(type);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlurComponent.prototype, "item", {
        set: function (item) {
            this.service.setItem(item);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], BlurComponent.prototype, "itemtype", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], BlurComponent.prototype, "item", null);
    BlurComponent = __decorate([
        core_1.Component({
            selector: 'blur',
            template: __webpack_require__(672),
            styles: [__webpack_require__(673)],
            providers: [blur_service_1.BlurService]
        }),
        __metadata("design:paramtypes", [shared_1.LogService, blur_service_1.BlurService])
    ], BlurComponent);
    return BlurComponent;
}());
exports.BlurComponent = BlurComponent;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var BlurService = (function () {
    function BlurService(logger, app) {
        this.logger = logger;
        this.app = app;
        this.type = 'date'; // default
        this.item = null;
        this.text = '';
        this.showText = false;
        this.url = '';
        // arrays of image urls
        this.dates = ['../img/blurredtext-dark.png'];
        this.largeText = ['../img/blurredtext-large.png'];
        this.mediumText = ['../img/blurredtext-medium.png'];
        this.smallText = ['../img/blurredtext-small.png'];
        this.largeNumber = ['../img/4numbers.png', '../img/4numbersv2.png',
            '../img/4numbersv3.png', '../img/4numbersv4.png',
            '../img/5numbers.png', '../img/5numbersv2.png',
            '../img/5numbersv3.png', '../img/5numbersv4.png'];
        this.mediumNumber = ['../img/3numbers.png', '../img/3numbersv2.png',
            '../img/3numbersv3.png', '../img/3numbersv4.png'];
        this.smallNumber = ['../img/2numbers.png', '../img/2numbersv2.png',
            '../img/2numbersv3.png', '../img/2numbersv4.png'];
        this.darkText = ['../img/blurredtext-dark.png'];
        this.largeTextDark = ['../img/blurredtext-large-dark.png'];
        this.mediumTextDark = ['../img/blurredtext-medium-dark.png'];
        this.smallTextDark = ['../img/blurredtext-small-dark.png'];
        this.largeNumberDark = ['../img/4numbers-dark.png', '../img/4numbersv2-dark.png',
            '../img/4numbersv3-dark.png', '../img/4numbersv4-dark.png',
            '../img/5numbers-dark.png', '../img/5numbersv2-dark.png',
            '../img/5numbersv3-dark.png', '../img/5numbersv4-dark.png'];
        this.mediumNumberDark = ['../img/3numbers-dark.png', '../img/3numbersv2-dark.png',
            '../img/3numbersv3-dark.png', '../img/3numbersv4-dark.png'];
        this.smallNumberDark = ['../img/2numbers-dark.png', '../img/2numbersv2-dark.png',
            '../img/2numbersv3-dark.png', '../img/2numbersv4-dark.png'];
        // this.logger.log('search-box.service', 'constructor', this.app);
    }
    BlurService.prototype.upsell = function () {
        if (!this.app.isLoggedIn) {
            this.app.showRegister();
        }
        else if (this.app.accountType === 'Premium') {
            this.app.showUpgrade();
        }
    };
    BlurService.prototype.setType = function (type) {
        this.type = type;
        switch (this.type) {
            case 'date':
                this.setUrl(this.dates);
                break;
            case 'carrier':
                this.setUrl(this.largeText);
                break;
            case 'port':
                this.setUrl(this.largeTextDark);
                break;
            case 'vessel':
                this.setUrl(this.largeTextDark.concat(this.mediumTextDark));
                break;
            case 'phone':
                this.setUrl(this.largeNumber);
                break;
            case 'website':
                this.setUrl(this.largeText);
                break;
            case 'text':
                this.setUrl(this.largeText.concat(this.mediumText, this.smallText));
                break;
            case 'text-dark':
                this.setUrl(this.largeTextDark.concat(this.mediumTextDark, this.smallTextDark));
                break;
            case 'large-text':
                this.setUrl(this.largeText);
                break;
            case 'large-number':
                this.setUrl(this.largeNumber);
                break;
            case 'medium-number':
                this.setUrl(this.mediumNumber);
                break;
            case 'medium-text':
                this.setUrl(this.mediumText);
                break;
            case 'small-text':
                this.setUrl(this.smallText);
                break;
            case 'small-number':
                this.setUrl(this.smallNumber);
                break;
            case 'dark-text':
                this.setUrl(this.darkText);
                break;
            case 'large-text-dark':
                this.setUrl(this.largeTextDark);
                break;
            case 'medium-text-dark':
                this.setUrl(this.mediumTextDark);
                break;
            case 'small-text-dark':
                this.setUrl(this.smallTextDark);
                break;
            case 'large-number-dark':
                this.setUrl(this.largeNumberDark);
                break;
            case 'medium-number-dark':
                this.setUrl(this.mediumNumberDark);
                break;
            case 'small-number-dark':
                this.setUrl(this.smallNumberDark);
                break;
            default:
                this.setUrl(this.largeText.concat(this.mediumText, this.smallText));
                break;
        }
    };
    BlurService.prototype.setItem = function (item) {
        try {
            this.item = item;
            if (this.type === 'carrier') {
                this.text = this.item.name;
            }
            else if (this.type === 'port') {
                this.text = this.item.title;
            }
            else if (this.type === 'vessel') {
                this.text = this.item.name;
            }
            else if (this.type === 'website') {
                this.text = this.item.url;
            }
            else {
                this.text = +item === NaN ? item : item.toString(); // check if number
            }
            this.showText = this.text.toLowerCase() !== 'blurred text';
        }
        catch (ex) {
            this.text = '';
            this.showText = true;
        }
    };
    BlurService.prototype.setUrl = function (urls) {
        var index = Math.floor(Math.random() * (urls.length - 1));
        this.url = urls[index];
    };
    BlurService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.LogService, shared_1.AppContext])
    ], BlurService);
    return BlurService;
}());
exports.BlurService = BlurService;


/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"service.showText\">\r\n  <div [ngSwitch]=\"service.type\">\r\n    <ng-template [ngSwitchCase]=\"'carrier'\">\r\n      <span class=\"hover-link\" [routerLink]=\"['/carriers', service.item.id, {scroll:true}]\">\r\n        {{ service.text }}\r\n      </span>\r\n      <span class=\"favorite-star\">\r\n        <img class=\"ga-favorite-carrier\" [favorite]=\"service.item\" [itemtype]=\"'carrier'\">\r\n      </span>\r\n    </ng-template>\r\n    <ng-template [ngSwitchCase]=\"'port'\">\r\n      <span class=\"hover-link\" [routerLink]=\"['/ports', service.item.id, {scroll:true}]\">\r\n        {{ service.text }}\r\n      </span>\r\n    </ng-template>\r\n    <ng-template [ngSwitchCase]=\"'vessel'\">\r\n      <span class=\"hover-link\" [routerLink]=\"['/vessels', service.item.id, {scroll:true}]\">\r\n        {{ service.text }}\r\n      </span>\r\n    </ng-template>\r\n    <ng-template [ngSwitchCase]=\"'phone'\">\r\n      <a href=\"tel:{{ service.text }}\">{{ service.text }}</a>\r\n    </ng-template>\r\n    <ng-template [ngSwitchCase]=\"'email'\">\r\n      <a href=\"mailto:{{ service.text }}\">{{ service.text }}</a>\r\n    </ng-template>\r\n    <ng-template [ngSwitchCase]=\"'website'\">\r\n      <a href=\"{{ service.item.url }}\" target=\"_blank\" >{{ service.item.display }}</a>\r\n    </ng-template>\r\n    <ng-template ngSwitchDefault>\r\n      <span>\r\n        {{ service.text }}\r\n      </span>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n<img *ngIf=\"!service.showText\" (click)=\"service.upsell()\" class=\"pointer ga-blur-clicked\" src=\"{{ service.url }}\">"

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = "img {\n  vertical-align: baseline; }\n\ndiv {\n  display: inline;\n  font-size: 16px; }\n"

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(675));


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(43);
var router_1 = __webpack_require__(3);
var personal_information_service_1 = __webpack_require__(676);
var _1 = __webpack_require__(2);
var business_validator_directive_1 = __webpack_require__(244);
var status_1 = __webpack_require__(95);
var PersonalInformationComponent = (function () {
    function PersonalInformationComponent(fb, service, route, router) {
        this.fb = fb;
        this.service = service;
        this.route = route;
        this.router = router;
        this.onSave = new core_1.EventEmitter();
        this.Status = status_1.Status;
    }
    Object.defineProperty(PersonalInformationComponent.prototype, "firstName", {
        get: function () { return this.infoForm.get('firstName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PersonalInformationComponent.prototype, "lastName", {
        get: function () { return this.infoForm.get('lastName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PersonalInformationComponent.prototype, "company", {
        get: function () { return this.infoForm.get('company'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PersonalInformationComponent.prototype, "position", {
        get: function () { return this.infoForm.get('position'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PersonalInformationComponent.prototype, "business", {
        get: function () { return this.infoForm.get('business'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PersonalInformationComponent.prototype, "businessChoice", {
        get: function () { return this.infoForm.get('business.businessChoice'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PersonalInformationComponent.prototype, "other", {
        get: function () { return this.infoForm.get('business.other'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PersonalInformationComponent.prototype, "city", {
        get: function () { return this.infoForm.get('city'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PersonalInformationComponent.prototype, "country", {
        get: function () { return this.infoForm.get('country'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PersonalInformationComponent.prototype, "subscribe", {
        get: function () { return this.infoForm.get('subscribe'); },
        enumerable: true,
        configurable: true
    });
    ;
    PersonalInformationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.createForm();
        this.status = status_1.Status.Loading;
        this.service.getPersonalInformation()
            .then(this.setInformation.bind(this))
            .catch(function (err) {
            _this.status = status_1.Status.Error;
        });
    };
    PersonalInformationComponent.prototype.setInformation = function (info) {
        if (info !== null && info !== undefined) {
            var index = this.service.businessChoices.indexOf(info.business);
            var businessChoice = info.business;
            var other = '';
            if (index > -1) {
                this.service.businessChoice = this.service.businessChoices[index];
            }
            else {
                businessChoice = 'Other';
                other = info.business;
            }
            this.infoForm.patchValue({
                firstName: info.firstName,
                lastName: info.lastName,
                company: info.company,
                position: info.position,
                business: {
                    businessChoice: businessChoice,
                    other: other
                },
                city: info.city,
                country: info.country
            });
        }
        this.status = status_1.Status.Loaded;
    };
    PersonalInformationComponent.prototype.createForm = function () {
        this.infoForm = this.fb.group({
            firstName: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(128)]],
            lastName: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(128)]],
            company: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(128)]],
            position: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(128)]],
            business: this.fb.group({
                businessChoice: 'Select a Business',
                other: ''
            }, { validator: business_validator_directive_1.businessValidator }),
            city: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(128)]],
            country: ['', [forms_1.Validators.required, forms_1.Validators.maxLength(128)]],
            subscribe: ['', forms_1.Validators.required]
        });
        // switch businessChoice to an enum when typescript version is updated past 2.4
    };
    PersonalInformationComponent.prototype.save = function () {
        var _this = this;
        this.touchAllFormElements();
        if (this.infoForm.invalid || this.status === status_1.Status.Loading || this.status === status_1.Status.Sending) {
            return;
        }
        this.status = status_1.Status.Sending;
        var model = this.preparePersonalInformationModel();
        this.service.save(model).then(function (response) {
            _this.status = status_1.Status.Success;
            _this.onSave.emit();
        }).catch(function (err) {
            _this.status = status_1.Status.Error;
        });
    };
    PersonalInformationComponent.prototype.touchAllFormElements = function () {
        for (var control in this.infoForm.controls) {
            this.infoForm.controls[control].markAsTouched();
        }
    };
    PersonalInformationComponent.prototype.preparePersonalInformationModel = function () {
        var form = this.infoForm.value;
        var business = form.business.businessChoice === 'Other' ? form.business.other : form.business.businessChoice;
        var information = {
            firstName: form.firstName,
            lastName: form.lastName,
            business: business,
            company: form.company,
            position: form.position,
            country: form.country,
            city: form.city,
            subscribe: form.subscribe,
        };
        return new _1.PersonalInformation(information);
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], PersonalInformationComponent.prototype, "onSave", void 0);
    PersonalInformationComponent = __decorate([
        core_1.Component({
            selector: 'personal-information',
            template: __webpack_require__(677),
            styles: [__webpack_require__(678)],
            providers: [personal_information_service_1.PersonalInformationService]
        }),
        __metadata("design:paramtypes", [forms_1.FormBuilder, personal_information_service_1.PersonalInformationService, router_1.ActivatedRoute, router_1.Router])
    ], PersonalInformationComponent);
    return PersonalInformationComponent;
}());
exports.PersonalInformationComponent = PersonalInformationComponent;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var _1 = __webpack_require__(2);
var PersonalInformationService = (function () {
    function PersonalInformationService(api, logger, user, app) {
        this.api = api;
        this.logger = logger;
        this.user = user;
        this.app = app;
        this.firstName = '';
        this.firstNameError = '';
        this.lastName = '';
        this.lastNameError = '';
        this.company = '';
        this.companyError = '';
        this.position = '';
        this.positionError = '';
        this.business = '';
        this.businessError = '';
        this.businessChoices = [
            'Select a Business',
            'Freight Forwarder',
            'Network or Association of Freight Forwarders',
            'Non-Vessel Operating Common Carrier (NVOCC)',
            'Vessel Operating Common Carrier (VOCC)',
            'Customs Agent, Liner Agent, Broker',
            'Port Authority, Terminal Operator, Inland Depot Agent',
            'Intermodal Operator, Trucking Company, Railroad',
            'Container Manufacture, Repair, Handling, Leasing',
            'Insurance, Banking, Accounting, Consulting, Government',
            'Shipper, Consignee, Importer, Exporter',
            'Other'
        ];
        this.businessChoice = this.businessChoices[0];
        this.city = '';
        this.cityError = '';
        this.country = '';
        this.countryError = '';
        this.frontError = false;
        this.status = '';
        this.message = '';
        this.init();
    }
    PersonalInformationService.prototype.init = function () {
        var _this = this;
        if (this.app.personalInformation == null) {
            this.user.getProfile().then(function () {
                _this.populateFromUserProfile();
            });
        }
        else {
            this.populateFromUserProfile();
        }
    };
    PersonalInformationService.prototype.getPersonalInformation = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.user.getProfile().then(function () {
                resolve(_this.app.personalInformation);
            }).catch(function (err) {
                reject(err);
            });
        });
    };
    PersonalInformationService.prototype.populateFromUserProfile = function () {
        if (this.app.personalInformation != null) {
            this.firstName = this.app.personalInformation.firstName;
            this.lastName = this.app.personalInformation.lastName;
            this.company = this.app.personalInformation.company || '';
            this.position = this.app.personalInformation.position || '';
            this.business = this.app.personalInformation.business || '';
            var index = this.businessChoices.indexOf(this.business);
            if (this.business == '') {
                this.businessChoice = this.businessChoices[0];
            }
            else if (index > -1) {
                this.businessChoice = this.businessChoices[index];
            }
            else {
                this.businessChoice = 'Other';
            }
            this.city = this.app.personalInformation.city || '';
            this.country = this.app.personalInformation.country || '';
        }
    };
    PersonalInformationService.prototype.save = function (model) {
        var _this = this;
        this.logger.log('personal-information.service', 'save model', model);
        if (this.status !== 'saving') {
            this.status = 'saving';
            return new Promise(function (resolve, reject) {
                _this.user.addPersonalInformation(model).then(function (result) {
                    _this.logger.log('personal-information.service', 'add personal information result', result);
                    _this.status = 'saved';
                    _this.app.setPersonalInformation(model);
                    resolve(result);
                }).catch(function (err) {
                    _this.logger.log('personal-information.service', 'save error', err);
                    _this.status = 'error';
                    _this.message = err.message;
                    reject(err);
                });
            });
        }
    };
    PersonalInformationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [_1.ApiService, _1.LogService, _1.UserService, _1.AppContext])
    ], PersonalInformationService);
    return PersonalInformationService;
}());
exports.PersonalInformationService = PersonalInformationService;


/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"status != Status.Success\">\r\n  <p>Tell us about yourself! <span *ngIf=\"status == Status.Loading\" class=\"mini-loader\"></span></p>\r\n  <form [formGroup]=\"infoForm\" (ngSubmit)=\"save()\">\r\n    <div class=\"form-group\">\r\n      <input class=\"form-control type-text\" formControlName=\"firstName\" placeholder=\"First Name\">\r\n\r\n      <div *ngIf=\"firstName.invalid && (firstName.dirty || firstName.touched)\" class=\"alert alert-danger\">\r\n        <div class=\"error\" *ngIf=\"firstName.errors.required\">\r\n          First Name is required.\r\n        </div>\r\n        <div class=\"error\" *ngIf=\"firstName.errors.maxLength\">\r\n          First Name cannot be more than 128 characters.\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <input class=\"form-control type-text\" formControlName=\"lastName\" placeholder=\"Last Name\">\r\n\r\n      <div *ngIf=\"lastName.invalid && (lastName.dirty || lastName.touched)\" class=\"alert alert-danger\">\r\n        <div class=\"error\" *ngIf=\"lastName.errors.required\">\r\n          Last Name is required.\r\n        </div>\r\n        <div class=\"error\" *ngIf=\"lastName.errors.maxLength\">\r\n          Last Name cannot be more than 128 characters.\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <input class=\"form-control type-text\" formControlName=\"company\" placeholder=\"Company\">\r\n\r\n      <div *ngIf=\"company.invalid && (company.dirty || company.touched)\" class=\"alert alert-danger\">\r\n        <div class=\"error\" *ngIf=\"company.errors.required\">\r\n          Company is required.\r\n        </div>\r\n        <div class=\"error\" *ngIf=\"company.errors.maxLength\">\r\n          Company cannot be more than 128 characters.\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <input class=\"form-control type-text\" formControlName=\"position\" placeholder=\"Position\">\r\n\r\n      <div *ngIf=\"position.invalid && (position.dirty || position.touched)\" class=\"alert alert-danger\">\r\n        <div class=\"error\" *ngIf=\"position.errors.required\">\r\n          Position is required.\r\n        </div>\r\n        <div class=\"error\" *ngIf=\"position.errors.maxLength\">\r\n          Position cannot be more than 128 characters.\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  <div formGroupName=\"business\">\r\n    <div class=\"form-group\">\r\n      <select class=\"form-control\" formControlName=\"businessChoice\">\r\n        <option *ngFor=\"let choice of service.businessChoices\" [value]=\"choice\">{{choice}}</option>\r\n      </select>\r\n    </div>\r\n\r\n    <div *ngIf=\"businessChoice.value == 'Other'\" class=\"form-group\">\r\n      <input class=\"form-control type-text\" formControlName=\"other\" placeholder=\"Business\">\r\n    </div>\r\n\r\n    <div *ngIf=\"business.invalid && (business.dirty || business.touched)\" class=\"alert alert-danger\">\r\n      <div class=\"error\" *ngIf=\"business.hasError('required')\">\r\n        Business is required.\r\n      </div>\r\n      <div class=\"error\" *ngIf=\"business.hasError('otherRequired')\">\r\n        Business must be specified.\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n    <div class=\"form-group\">\r\n      <input class=\"form-control type-text\" formControlName=\"city\" placeholder=\"City\">\r\n\r\n      <div *ngIf=\"city.invalid && (city.dirty || city.touched)\" class=\"alert alert-danger\">\r\n        <div class=\"error\" *ngIf=\"city.errors.required\">\r\n          City is required.\r\n        </div>\r\n        <div class=\"error\" *ngIf=\"city.errors.maxLength\">\r\n          City cannot be more than 128 characters.\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <input class=\"form-control type-text\" formControlName=\"country\" placeholder=\"Country\">\r\n\r\n      <div *ngIf=\"country.invalid && (country.dirty || country.touched)\" class=\"alert alert-danger\">\r\n        <div class=\"error\" *ngIf=\"country.errors.required\">\r\n          Country is required.\r\n        </div>\r\n        <div class=\"error\" *ngIf=\"country.errors.maxLength\">\r\n          Country cannot be more than 128 characters.\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group radio\">\r\n      <p id=\"contact-agreement\">I agree to receive periodic updates, information, and offers by email from Linescape in accordance with our <a [routerLink]=\"['/privacy-policy', {scroll: true}]\">Privacy Policy</a></p>\r\n      <div class=\"col-holder\">\r\n          <div class=\"col1of2\">\r\n              <label><input type=\"radio\" formControlName=\"subscribe\" value=\"true\">Yes</label>\r\n          </div>\r\n          <div class=\"col1of2\">\r\n              <label><input type=\"radio\" formControlName=\"subscribe\" value=\"false\">No</label>\r\n          </div>\r\n      </div>\r\n\r\n      <div *ngIf=\"subscribe.invalid && (subscribe.dirty || subscribe.touched)\" class=\"alert error alert-danger\">\r\n        Please decide if you would like to receive news emails.\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"popup-line-grey\"></div>\r\n    <button [disabled]=\"infoForm.pristine\" [class.btn-gray]=\"infoForm.invalid\" class=\"btn text-center mt10\">Save</button>\r\n  </form>\r\n</div>\r\n<div *ngIf=\"status == Status.Success\">\r\n  <p>Thank you! This information helps us to develop new features for our users.</p>\r\n</div>\r\n<div *ngIf=\"status == Status.Sending\">\r\n  <p class=\"loader\">Saving<span class=\"ellipse-1\"> .</span><span class=\"ellipse-2\"> .</span><span class=\"ellipse-3\"> .</span></p>\r\n</div>\r\n<div *ngIf=\"status == Status.Error\">\r\n  <div class=\"popup-line-div\"></div>\r\n  <span class=\"error\">There was an error saving your information. Please try again or contact support.</span>\r\n</div>"

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = "input, select,\n.btn {\n  width: 100%; }\n\n.btn-gray {\n  background: #686868;\n  color: #484848;\n  cursor: not-allowed; }\n\n.type-text {\n  border: 1px solid #c4c4c4;\n  padding: 8px;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  max-width: 100%;\n  min-width: 250px;\n  border-radius: 3px;\n  font-size: 16px; }\n\n#contact-agreement {\n  font-size: 16px;\n  line-height: 20px;\n  text-align: left; }\n\ninput[type=\"radio\"] {\n  display: inline-block;\n  width: 16px; }\n\n.error {\n  font-size: 16px; }\n"

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(680));


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var Subject_1 = __webpack_require__(10);
var search_box_service_1 = __webpack_require__(681);
var shared_1 = __webpack_require__(2);
var SearchBoxComponent = (function () {
    function SearchBoxComponent(logger, router, service) {
        var _this = this;
        this.logger = logger;
        this.router = router;
        this.service = service;
        this.searchTermStream = new Subject_1.Subject();
        this.searchTerm = '';
        this.item = null;
        this.items = this.searchTermStream
            .debounceTime(100)
            .distinctUntilChanged()
            .switchMap(function (term) { return _this.service.search(term); });
        this.select = new core_1.EventEmitter();
        // Do stuff
    }
    Object.defineProperty(SearchBoxComponent.prototype, "type", {
        set: function (type) {
            this.service.setType(type);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchBoxComponent.prototype, "display", {
        set: function (display) {
            this.searchTerm = display;
        },
        enumerable: true,
        configurable: true
    });
    SearchBoxComponent.prototype.onClick = function ($event) {
        if ($event.target.id === this.id.toString() && !this.service.autoOn) {
            this.service.autoOn = true;
        }
        else if ($event.target.id !== this.id.toString() && this.service.autoOn) {
            this.service.autoOn = false;
        }
    };
    SearchBoxComponent.prototype.set = function (item) {
        this.service.autoOn = false;
        this.logger.log('search-box.component', 'set', item);
        this.searchTerm = item.name;
        this.item = item;
        this.select.emit(this.item);
    };
    SearchBoxComponent.prototype.auto = function () {
        if (this.searchTerm.length < 3) {
            if (this.service.favorites.length === 0) {
                this.service.autoOn = false;
            }
            else {
                this.service.autoOn = true;
            }
        }
        else {
            if (this.service.autoOn === false) {
                this.service.startSearch();
            }
            this.searchTermStream.next(this.searchTerm);
            this.logger.log('search-box.component', 'auto else', this.service.autoOn);
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SearchBoxComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SearchBoxComponent.prototype, "type", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SearchBoxComponent.prototype, "display", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SearchBoxComponent.prototype, "select", void 0);
    SearchBoxComponent = __decorate([
        core_1.Component({
            selector: 'search-box',
            template: __webpack_require__(682),
            styles: [__webpack_require__(683)],
            providers: [search_box_service_1.SearchBoxService],
            host: {
                '(document:click)': 'onClick($event)'
            }
        }),
        __metadata("design:paramtypes", [shared_1.LogService, router_1.Router, search_box_service_1.SearchBoxService])
    ], SearchBoxComponent);
    return SearchBoxComponent;
}());
exports.SearchBoxComponent = SearchBoxComponent;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
__webpack_require__(23);
var shared_1 = __webpack_require__(2);
var SearchBoxService = (function () {
    function SearchBoxService(logger, api, cache, app) {
        this.logger = logger;
        this.api = api;
        this.cache = cache;
        this.app = app;
        this.favorites = new Array();
        this.type = 'port'; // default
        this.autoOn = false;
        this.loaderOn = false;
        this.noResult = false;
        // this.logger.log('search-box.service', 'constructor', this.app);
    }
    SearchBoxService.prototype.setType = function (type) {
        this.type = type;
        if (this.type === 'port') {
            this.favorites = this.app.ports;
        }
        else if (this.type === 'carrier') {
            this.favorites = this.app.carriers;
        }
        else if (this.type === 'vessel') {
            this.favorites = this.app.vessels;
            for (var current = 0; current < this.favorites.length; current++) {
                this.favorites[current].display = this.favorites[current].name;
            }
        }
        else {
            this.logger.log('search-box.service', 'setType', 'type is not recognized: ' + this.type);
        }
    };
    SearchBoxService.prototype.search = function (term) {
        if (this.type === 'port') {
            return this.getPorts(term);
        }
        else if (this.type === 'carrier') {
            //
        }
        else if (this.type === 'vessel') {
            return this.getVessels(term);
        }
        else {
            this.logger.log('search-box.service', 'search', 'type is not recognized: ' + this.type);
        }
    };
    SearchBoxService.prototype.startSearch = function () {
        this.autoOn = true;
        this.loaderOn = true;
        this.noResult = false;
    };
    SearchBoxService.prototype.getPorts = function (term) {
        var _this = this;
        this.startSearch();
        // let cache = this.cache.get('ports' + term);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetPorts(client, term); });
        var server = Observable_1.Observable.fromPromise(promise);
        this.items = server;
        // this.ports = Observable.concat(cache, server);
        // this.cache.updateCache('ports' + term, this.ports);
        return this.items;
    };
    SearchBoxService.prototype.callGetPorts = function (apigClient, term) {
        var _this = this;
        this.logger.log('search-box.service', 'callGetPorts', term);
        return new Promise(function (resolve, reject) {
            var params = {};
            var additionalParams = {
                // If there are any unmodeled query parameters or headers that must be
                // sent with the request, add them here.
                headers: {
                    'Content-Type': 'application/json'
                },
                queryParams: {
                    search: term
                }
            };
            try {
                apigClient.portsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('search-box.service', 'resolve', result);
                    var formatted = _this.endSearch(result.data);
                    if (formatted !== null) {
                        for (var current = 0; current < formatted.length; current++) {
                            var item = formatted[current];
                            _this.formatPort(item);
                        }
                    }
                    resolve(formatted);
                }).catch(function (err) {
                    _this.endSearch(null);
                    _this.api.handleError(err);
                });
            }
            catch (ex) {
                _this.logger.log('search-box.service', 'catch', ex);
                return reject(ex);
            }
        });
    };
    SearchBoxService.prototype.formatPort = function (item) {
        if (item.country !== null && item.country.id === 'US') {
            try {
                item.display = item.name + ' [' + item.code + '], ' + item.region.name + ', ' + item.country.name;
            }
            catch (ex) {
                if (item.region === null && item.country !== null) {
                    item.display = item.name + ' [' + item.code + '], ' + item.country.name;
                }
                else {
                    item.display = item.name + ' [' + item.code + ']';
                }
            }
        }
        else {
            try {
                item.display = item.name + ' [' + item.code + '], ' + item.country.name;
            }
            catch (ex) {
                item.display = item.name + ' [' + item.code + ']';
            }
        }
    };
    SearchBoxService.prototype.getVessels = function (term) {
        var _this = this;
        this.startSearch();
        // let cache = this.cache.get('vessels' + term);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetVessels(client, term); });
        var server = Observable_1.Observable.fromPromise(promise);
        this.items = server;
        // this.vessels = Observable.concat(cache, server);
        // this.cache.updateCache('vessels' + term, this.vessels);
        return this.items;
    };
    SearchBoxService.prototype.callGetVessels = function (apigClient, term) {
        var _this = this;
        this.logger.log('vessels-search.service', 'callGetVessels', term);
        return new Promise(function (resolve, reject) {
            var params = {};
            var additionalParams = {
                headers: {
                    'Content-Type': 'application/json'
                },
                queryParams: {
                    search: term
                }
            };
            try {
                apigClient.vesselsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('vessels-search.service', 'resolve', result);
                    var formatted = _this.endSearch(result.data);
                    if (formatted !== null) {
                        for (var current = 0; current < formatted.length; current++) {
                            formatted[current].display = formatted[current].name;
                        }
                    }
                    resolve(formatted);
                }).catch(function (err) {
                    _this.endSearch(null);
                    _this.autoOn = false;
                    _this.api.handleError(err);
                });
            }
            catch (ex) {
                _this.logger.log('vessels-search.service', 'catch', ex);
                return reject(ex);
            }
        });
    };
    SearchBoxService.prototype.endSearch = function (data) {
        if (data === null || data.items === null || data.items === undefined || data.items.length === 0) {
            this.noResult = true;
            this.loaderOn = false;
            return null;
        }
        else {
            this.noResult = false;
            this.loaderOn = false;
            return data.items;
        }
    };
    SearchBoxService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.LogService, shared_1.ApiService, shared_1.CacheService, shared_1.AppContext])
    ], SearchBoxService);
    return SearchBoxService;
}());
exports.SearchBoxService = SearchBoxService;


/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = "<input id='{{id}}' class=\"text\" [(ngModel)]=\"searchTerm\" (keyup)=\"auto()\" (click)=\"auto()\">\r\n<div *ngIf=\"service.autoOn\" class=\"auto-complete\">\r\n  <div [class.visible]=\"service.loaderOn\" style=\"float: right;\" class=\"little-loader\"></div>\r\n  <ul *ngIf=\"searchTerm === ''\">\r\n    <li *ngFor=\"let item of service.favorites\" (click)=\"set(item)\">\r\n      <span class=\"favorite-star\"><img *ngIf=\"item.userData.favorites\" src=\"../img/star-filled.svg\"></span>\r\n      {{ item.display }}\r\n    </li>\r\n  </ul>\r\n  <ul *ngIf=\"searchTerm !== ''\">\r\n    <ul *ngIf=\"service.noResult\"><li>No Results</li></ul>\r\n    <li *ngFor=\"let item of items | async\" (click)=\"set(item)\">\r\n      {{ item.display }}\r\n    </li>\r\n  </ul>\r\n</div>"

/***/ }),
/* 683 */
/***/ (function(module, exports) {

module.exports = ".btn {\n  float: right; }\n\n.little-loader {\n  float: right; }\n\ninput.text {\n  max-width: calc(100% - 10px);\n  min-width: calc(100% - 10px); }\n\n@media only screen and (max-width: 599px) {\n  .btn {\n    float: none;\n    margin-top: 10px; } }\n"

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(685));


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var email_box_service_1 = __webpack_require__(686);
var shared_1 = __webpack_require__(2);
var EmailBoxComponent = (function () {
    function EmailBoxComponent(logger, service) {
        this.logger = logger;
        this.service = service;
        this.emailsUpdated = new core_1.EventEmitter();
    }
    Object.defineProperty(EmailBoxComponent.prototype, "initial", {
        set: function (emails) {
            this.service.email = (emails === undefined || emails === null) ? '' : emails;
            this.add();
        },
        enumerable: true,
        configurable: true
    });
    EmailBoxComponent.prototype.add = function () {
        this.service.emailError = '';
        this.service.add();
        this.emailsUpdated.emit(this.service.items);
    };
    EmailBoxComponent.prototype.remove = function (index) {
        this.service.emailError = '';
        this.service.remove(index);
        this.emailsUpdated.emit(this.service.items);
        // could use toString, but join seems safer as you set the ',' yourself
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], EmailBoxComponent.prototype, "initial", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], EmailBoxComponent.prototype, "emailsUpdated", void 0);
    EmailBoxComponent = __decorate([
        core_1.Component({
            selector: 'email-box',
            template: __webpack_require__(687),
            styles: [__webpack_require__(688)],
            providers: [email_box_service_1.EmailBoxService]
        }),
        __metadata("design:paramtypes", [shared_1.LogService, email_box_service_1.EmailBoxService])
    ], EmailBoxComponent);
    return EmailBoxComponent;
}());
exports.EmailBoxComponent = EmailBoxComponent;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
__webpack_require__(23);
var shared_1 = __webpack_require__(2);
var EmailBoxService = (function () {
    function EmailBoxService(logger, api, cache, app) {
        this.logger = logger;
        this.api = api;
        this.cache = cache;
        this.app = app;
        this.email = '';
        this.emailError = '';
        this.items = [];
    }
    EmailBoxService.prototype.add = function () {
        this.email = this.parse(this.email);
        if (this.email !== '') {
            this.emailError = 'Invalid Email';
        }
    };
    EmailBoxService.prototype.parse = function (emails) {
        try {
            if (emails === null || emails === undefined || emails === '') {
                return '';
            }
            if (this.isEmail(emails)) {
                this.items.push(emails);
                return '';
            }
            var indexOfSpace = emails.indexOf(' ');
            var indexOfComma = emails.indexOf(',');
            var index = Math.min(indexOfSpace, indexOfComma) === -1 ? Math.max(indexOfSpace, indexOfComma) : Math.min(indexOfSpace, indexOfComma);
            if (index === -1) {
                return emails;
            }
            else if (index === 0) {
                return this.parse(emails.slice(1));
            }
            var mightBeEmail = emails.substr(0, index);
            if (this.isEmail(mightBeEmail)) {
                this.items.push(mightBeEmail);
                return this.parse(emails.substr(index));
            }
            else {
                return emails;
            }
        }
        catch (ex) {
            return '';
        }
    };
    EmailBoxService.prototype.isEmail = function (email) {
        return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test(email);
    };
    EmailBoxService.prototype.remove = function (index) {
        // remove from list
        this.items.splice(+index, 1);
    };
    EmailBoxService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.LogService, shared_1.ApiService, shared_1.CacheService, shared_1.AppContext])
    ], EmailBoxService);
    return EmailBoxService;
}());
exports.EmailBoxService = EmailBoxService;


/***/ }),
/* 687 */
/***/ (function(module, exports) {

module.exports = "<input placeholder=\"email\" [(ngModel)]=\"service.email\" (keyup.enter)=\"add()\" (paste)=\"add()\" type=\"email\">\r\n<a (click)=\"add()\" class=\"add-email mt15\" placeholder=\"Email Addresses\">+</a>\r\n<span *ngIf=\"service.emailError\" class=\"error\">{{ service.emailError }}</span>\r\n<div>\r\n  <ul>\r\n    <li *ngFor=\"let item of service.items; let index = index\">\r\n      <p>{{ item }} <a class='delete-email' (click)=\"remove(index)\">&times;</a></p>\r\n    </li>\r\n  </ul>\r\n</div>"

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports = ".btn {\n  float: right; }\n\n.little-loader {\n  float: right; }\n\ninput.text {\n  max-width: calc(100% - 10px);\n  min-width: calc(100% - 10px); }\n\n.remove {\n  position: absolute;\n  right: 10px;\n  top: 5px;\n  line-height: 7px;\n  font-size: 24px;\n  color: #ffffff;\n  cursor: pointer; }\n  .remove:hover {\n    color: #e6e6e6; }\n\n.add-email {\n  background: linear-gradient(to left, #ffa000, #FF663B);\n  color: white;\n  font-size: 26px;\n  vertical-align: middle;\n  font-weight: 400;\n  padding: 0 7px;\n  box-shadow: inset 0px -1px 2px rgba(0, 0, 0, 0.5); }\n\n.add-email:hover {\n  color: #ffffff;\n  background: linear-gradient(to left, #E68700, #E64D22); }\n\n.delete-email {\n  display: inline-block;\n  background: #f0f0f0;\n  width: 18px;\n  height: 18px;\n  line-height: 15px;\n  text-align: center;\n  border-radius: 50%;\n  color: #353535; }\n\nli {\n  list-style-type: none;\n  background-image: url(../../img/email-353535.png);\n  background-repeat: no-repeat;\n  margin-left: 0;\n  padding-left: 30px;\n  background-size: 27px;\n  background-position: 0 64%; }\n\n@media only screen and (max-width: 599px) {\n  .btn {\n    float: none;\n    margin-top: 10px; } }\n\n@media only screen and (max-width: 399px) {\n  input[type=\"email\"] {\n    width: 236px;\n    max-width: 236px;\n    min-width: 236px; }\n  .btn {\n    float: none;\n    margin-top: 10px; } }\n"

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(690));


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var side_bar_type_1 = __webpack_require__(691);
var PlansSideBarComponent = (function () {
    function PlansSideBarComponent() {
        this.SideBarType = side_bar_type_1.SideBarType;
    }
    Object.defineProperty(PlansSideBarComponent.prototype, "type", {
        set: function (typeToDisplay) {
            if (typeToDisplay == 'register') {
                this.displayType = side_bar_type_1.SideBarType.Register;
            }
            else if (typeToDisplay == 'upgrade') {
                this.displayType = side_bar_type_1.SideBarType.Upgrade;
            }
            else {
                this.displayType = side_bar_type_1.SideBarType.Upsell;
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], PlansSideBarComponent.prototype, "type", null);
    PlansSideBarComponent = __decorate([
        core_1.Component({
            selector: 'plans-side-bar',
            template: __webpack_require__(692),
            styles: [__webpack_require__(693)],
        }),
        __metadata("design:paramtypes", [])
    ], PlansSideBarComponent);
    return PlansSideBarComponent;
}());
exports.PlansSideBarComponent = PlansSideBarComponent;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SideBarType;
(function (SideBarType) {
    SideBarType[SideBarType["Register"] = 0] = "Register";
    SideBarType[SideBarType["Upgrade"] = 1] = "Upgrade";
    SideBarType[SideBarType["Upsell"] = 2] = "Upsell";
})(SideBarType = exports.SideBarType || (exports.SideBarType = {}));


/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"displayType == SideBarType.Register\">\r\n  <div class=\"sidebar-section\">\r\n      <h6>Connect with Us</h6>\r\n      <div class=\"social-links\">\r\n          <ul>\r\n              <li><a href=\"http://www.facebook.com/pages/Linescape/127633963941865\" target=\"_blank\"><img src=\"../img/facebook-logotype-button.png\"></a></li>\r\n              <li><a href=\"http://www.linkedin.com/company/linescape\" target=\"_blank\"><img src=\"../img/linkedin-logotype-button.png\"></a></li>\r\n              <li><a href=\"http://twitter.com/Linescape\" target=\"_blank\"><img src=\"../img/twitter-logo.png\"></a></li>\r\n          </ul>\r\n      </div>\r\n  </div>\r\n  <div class=\"sidebar-section\">\r\n      <h6>Register for Extra Features</h6>\r\n      <p>Registering is quick and easy, in order to take advantage of these useful features:</p>\r\n      <ul>\r\n          <li>Save routes for easy searching again.</li>\r\n          <li>Email schedules for immediate action.</li>\r\n          <li>Print schedules for your files.</li>\r\n          <li>Save carrier info for quick access.</li>\r\n      </ul>\r\n      <p class=\"text-center\"><a [routerLink]=\"['/register']\" class=\"btn text-center\">Try Now</a></p>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"displayType == SideBarType.Upgrade\">\r\n  <div class=\"sidebar-section\">\r\n      <h6>Connect with Us</h6>\r\n      <div class=\"social-links\">\r\n          <ul>\r\n              <li><a href=\"http://www.facebook.com/pages/Linescape/127633963941865\" target=\"_blank\"><img src=\"../img/facebook-logotype-button.png\"></a></li>\r\n              <li><a href=\"http://www.linkedin.com/company/linescape\" target=\"_blank\"><img src=\"../img/linkedin-logotype-button.png\"></a></li>\r\n              <li><a href=\"http://twitter.com/Linescape\" target=\"_blank\"><img src=\"../img/twitter-logo.png\"></a></li>\r\n          </ul>\r\n      </div>\r\n  </div>\r\n  <div class=\"sidebar-section\">\r\n      <h6>Upgrade for Extra Features</h6>\r\n      <p>Upgrade in order to take advantage of these useful features:</p>\r\n      <ul>\r\n          <li>Local carrier contact information.</li>\r\n          <li>Information on trip transhipments</li>\r\n          <li>Vessel Management Data</li>\r\n      </ul>\r\n      <p class=\"text-center\"><a  [routerLink]=\"['../../account/information']\" class=\"btn text-center\">Try Now</a></p>\r\n  </div>\r\n</div>\r\n\r\n<!--\r\nAPI\r\nQuery Any Data\r\nOn Demand From\r\nYour IT System\r\n\r\nData Feeds\r\nIntegrate Bulk \r\nData Into Your\r\nIT System\r\n\r\nAnalytics \r\nMeasure Your\r\nCarriers On Time\r\nPerformance\r\n-->\r\n\r\n<div *ngIf=\"displayType == SideBarType.Upsell\" class=\"sidebar-section\">\r\n  <div [routerLink]=\"['/bulk-data-feeds']\" class=\"plans-sidebar plans-sidebar-1 pointer\">\r\n    <div class=\"plans-sidebar-section\">\r\n        <!-- was too faint\r\n        <img class=\"small-image\" src=\"../img/home-features/home-feature-1-icon.svg\" onerror=\"this.onerror=null; this.src='../img/api.png'\">\r\n        -->\r\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"103\" height=\"103\" viewBox=\"0 0 103 103\" class=\"small-image\">\r\n            <image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" class=\"cls-1\" width=\"103\" height=\"103\" xlink:href=\"data:img/png;base64,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\"/>\r\n        </svg>\r\n        <h5>API</h5>\r\n        <p>Query Any Data</p>\r\n        <p>On Demand From</p>\r\n        <p>Your IT System</p>\r\n    </div>\r\n    <div class=\"plans-sidebar-section\">\r\n        <!-- was too faint\r\n        <img src=\"../img/home-features/home-feature-2-icon.svg\" onerror=\"this.onerror=null; this.src='../img/datafeed.png'\">\r\n        -->\r\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" class=\"small-image\">\r\n            <image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" class=\"cls-1\" width=\"100\" height=\"100\" xlink:href=\"data:img/png;base64,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\"/>\r\n        </svg>\r\n        <h5>Data Feeds</h5>\r\n        <p>Integrate Bulk</p>\r\n        <p>Data Into Your</p>\r\n        <p>IT System</p>\r\n        <p class=\"small-text\">Choose either API or FTP delivery.</p>\r\n    </div>\r\n    <div class=\"plans-sidebar-section\">\r\n        <!-- was too faint\r\n        <img class=\"small-image\" src=\"../img/home-features/home-feature-3-icon.svg\" onerror=\"this.onerror=null; this.src='../img/ftp.png'\">\r\n        -->\r\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"107\" height=\"107\" viewBox=\"0 0 107 107\" class=\"small-image\">\r\n            <image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" class=\"cls-1\" width=\"107\" height=\"107\" xlink:href=\"data:img/png;base64,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\"/>\r\n        </svg>\r\n        <h5>Analytics</h5>\r\n        <p>Measure Your</p>\r\n        <p>Carriers On Time</p>\r\n        <p>Performance</p>\r\n    </div>\r\n    <div>\r\n        <a class=\"btn\">Get a Quote</a><br class=\"hide1200\">\r\n        <a class=\"link\">Learn More</a>\r\n    </div>\r\n  </div>\r\n  <div [routerLink]=\"['/bulk-data-feeds']\" class=\"plans-sidebar pointer plans-sidebar-2\">\r\n    <div class=\"plans-sidebar-section\">\r\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"103\" height=\"103\" viewBox=\"0 0 103 103\" class=\"small-image\">\r\n            <image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" class=\"cls-1\" width=\"103\" height=\"103\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGcAAABnCAYAAAAdQVz5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gIGCBUc5VT3dgAAH/VJREFUeNrVnfebFFXa9z93EwYQhgEkK5JF1DWsaV91dXcfFyTDDJN7eiK4BoKuuM9f8BgeGaIK05MzMCNJBH3fNaysuO7KuioYSIJklWFAQMLU+8Op6j7V06Fm6Ea9r4uLmupTp6rO95z73LmEXyC5E5fFI3KbAQMAFyK+3wztGJEW4IgB22vqH2n+qZ+7rSSX38WVJXfisu7AOEQ6G763CAmOOgfnEdlSUzf79E/9/G0h10/9AO2gm4HObbyms3ndL4o6/tQP0A7qpx1vB/aEaTscuC3Idb8I+knAyZ6y6GqEgYDLQI4hHC5fO9fp5V2040NVax47H6phRsorh/CD04VfGF1RcLKnFMajBmuQdnoscNgzbfG75WvntoS73p24LA47Kz4b4Zb676701BVxNXWzf3T6vKmZ3sEGMgLohnAK5Mv6ytzjV2q8rgg4OZML44CbDBhFcCFkIPBr4MMIXcVpxy1Vax67EK5xdf0jFzJSXmnBD2gc4Aic1AzvzcBN2qlewJAUd8k+Q9i+qiL3XKzHLabg5Exa6EIYDdxI6038W+AS0N/8e6Rn2pJvytfOORymy67asdPBOQd0066PKFKnZngHYwdGp6HAoOSsko9Bdq+qyDEi9ddeipm0ljtp4dXABBQb04H5AdgKvAm8DTRpv93tmb4kLky3+r4RiaUFaxdx30nNKOoG3KOdaga2ASe0c52BO4GHkj2lvWI1hjEBJ3fSiwnA74Ee2ukLwMfAxrL18/aXrZtH2bp5LcD7gLXXdAXuCOwva8ZS3DOWxaOUTouc7h36CuufnrqiR6iGqelFLuBe/JPpEvBefVXeXmAL8JH5Hhb1AcbN9JTeOtNTFnWdMVZs7Uagg3lsALuBT8rWz2/FisrXzW3yTFv8CXCLeWpI1vQlB4GjiAwCBgN9ac0Wna4c/Z4jgBHpaSvOGchx4AjwTW3tLKvNr4Crtfb/rK/KOwlQX5lnAF+kuEv2A7cDQ8w2AtyAmugfRXMQYwVOb+34g9IN8/dGaL8TJcH1Nf++m8irusnhswRr1wW41vx3R1p60THgO0MNskX76qryW+lQ9ZW5Z4GtyVkle1CrvLv50+iZ2WWfrS7LdiwNRqJY7TkXteOukRqXr51roPi6dV2w5zJQA70X+AD4yuGzfGW232teH7iBC0ooGaudayaC5LiqIvcwsAk4r/XTM5qDGKuVcxBIMI9H50wu/Lx0w/ywOkz52rmnPdOWfATcpZ0+bfZ1GDhe2fD4RdpI1fWPGCgrwh6A9NQVHVErdCBwDXBVwCWXgK111flO7tUN6KT9fcHBNY4pVuB8hZ8PdwWuQ83csFS+ds5uz/QlF1GCxKGKxie+j/aD1dTNvogC+zDwUVrayt7AMPMZOwEf1lXnNzns7kb8etsp7BLdZVPMrNK5kxbebcBwdQdpAl4v3TA/Vre7bEpLLxIDXHU1BZectE/OKukBMhFBFJ+UD1aXZ+9xcq1TiqUS+jnK8AiKxQ1ASUc/S6qtKTBQLM0p6avmNA44Q1spZkpoycYnT6JYh0U3tLevnxslZ5VchbIUWLRzdXl21C0FsfbnfK4dD8ieUpgQ4/tdKRqLf9WcIbzbot3UJraWP/75OER6Ks8iTcWbng7ZNnfSQpdhn12gNOqmWI3YlaAUd0lXw8+uAT5bXZ7T0u4Ow5AjcPLHPy8oG9loNOkkb8ILO0D2Fm/6s21J5056sQNwP0pctegUSiyOOmXOfKmT+S4dDRU3cBG4WL3qT23ZQ5xSAnaOM3imp3Tv6vKcqN/LkbSWP/75W7H2DBGlxfmulNPATkPYU/Lan1tyJ77YAeEBkP7+dnIMeK90w/zL0p7dics6oFZfP0QSDIgHeiDiG6yAGILzQLMBzYicAI7U1M2+rECPFHeJyxAeBPqDgIABR0HeWV2e3QqgpJyKrsAohMEGdETke+CzhmJ302WDkz/+uV4g43xtRc4b0AmxrjWDKIQzIJ8BgxEGgQ/EAyB/j6SEhqKsGUs7ANcYyDCEflg2O2uSmMchwFHn7G3OIRwwkL21tbO+a88zJWeVuID/A3KtCQ4ghxHeXV2W3aJAKe8JjAEZCrh87dRzXAL+2lDs/rbd4BSMe04M4SGQPuap04hsMpRn8EZgqHU3Q7TuzGMDvkZ4v3TDk22WZLKmL+mGyA0oBbGTYc5SfeCDgNNiaKsoBDjmbBdQZpovENlTW1PQpsmTnFUiIL9BuM6wOhX2AvtAxhhisXTR7ml7jlMgmxqKM0PeNxI4Iw3hTq3Z297NC3zicd6EF3qA3AgMNUQbPQXOAQO2lm5sGzCe6Uu6GCpSZriNXfm7vwQcQ+RbA04CpxA5A1yoWv2oAZCR/HIHoBMiPYAeBiQg0h/LpOQHxwLxDLDDgF11St9xCFCpINxrwLXYJo+Yk9U3GGcRvjTgLCJ3a4htbyjO/DxU/yHBKRj3XBdgoiF0Npvt925esDVY27wJ/3uVIYwFGY5awkdB3i7Z+KTj2eiZtlhARiH8yrDsVf5ZdsFADiDsQ9nY2sUi01NXxKHY7jAD8Ufj+FfYCYQP66oLHLO7ZE+py4DfgfQLAk4TyOfA12tKs1oAEvMq7wRGmu3OG8LGRm9m0L04HDi/Qa0IQC4Ar3k3LwjrQ8md+GJXIAHhaMnGp9oCTDfgXpCr/Twca0bvBHZXND4RVWkoLW1ld5SQ41uhmgCzA/hPXXW+o1U001MaB/IQYjkX5Ygh7ASOrCn12Nom5lV2ASYBnUwQv2z0Zv7LMTgF457tC/Jf4NtLPvJuXvBFNAfHIs/UxYMR7gFzhSpwLgD/QWRXReMTIUHOTFruAuIR6YoSpTsZIhdQovRZRE5V1z8SFtS0tJVdEbkVGKqBA3AcYWtdVb4jp95MT1kXhMHAd6vLspvCtU3MqxwL3GKCYwCbGr2ZraTIUODcCzLEBOcEyBbv5gVRN09kT100xkBu09kBwtcGfFTx6pxWXlNTlB4EDECkn6Gs1xJBWjtlKK/qUeBgTd3soGClpRf1M+AuNft9e+dZA3mnviovqtbmxLxKFzAJ5CqT/R1q9Ga+4xSc8SC9THC2eTc/E3WjXvbURbcAY+0bvfyzfO2cVqaQrBlLexrIGIRr0fajdojSF4ADCB/X1M5uBX5qelFHlAA01BodQ7H0t+qr8toldoeixLzKISD3aoLDm43eDJtoHcq2dkY7Hps//vmoeviypyz6FXbP41ngjUBgsmYsjc+asfR+VBTPcOyOLYtaUCLx98Ax8/9m/EEjOnUy+7k92HPV1RRcrKsueB/4F/6trxPwuxR3cR+iS/tR4WEWDQxsEMp8sxsVWAFKCx+XP/75f3o3L7hsA1/2lMJRKHO7Rc3AW+Vr5/omRNb0JS5U3JjlsNPpAnAI5X44Dpy2RGidMpJfFpR/vy/KDT0YP7hhPZZ11flfpmZ4zwG/Me/fCXggxV3yRn1lbrQyFVzYXRStFko4ae1m4Cabcgn7EPnQ+/rTbXYXA2RPKewL/AHEsi+cNpA3ytfN9YmSnulLuhsqPKm3jV0hJxF2AAcqGx5vs+SWnrqiAwqgOIS9NbWzI75Daqb3GgO5Dyx7iJwEttRX5l6W5JiYV5kA/AYkQWNrbzd6M2wBlZGU0MGGcA+IPyxJpNmArcWvP93UlgfKmVwYZwgPA13Njf8c8GbZunm+meiZtqQvwm8NKwxKgXMG2G4g+ysbH7+cMQlJaelFvYAhBnxTV2PXcVIyi0egBAVruHbXV+b+oz33ScytEETGoEKwXJo+dNgEx9Y+rD+naMszB4HXsfPGeOCPeRNeGNrGZ7sLfySOAfzNDsziQcDvsMen7QZeq2h8ImbAmPQgag/8Q2pGUX/9h/qqvN2ArkaMSM4qubatN0jKregO/AG4Ffu47wLeDQQGnFulXSi0b9Cs0i3AmuJNT0dc4jmTCwcDv9WW8Pay9fN8ZgvPtMV9UVp2B1PPaQG2Vbw65+toIhCM0tJWCiLTgC7me10CebuuOv+Y1SYls9iFsjH2BjCEs8BrqypyHUXbJOVUjEC43bRKW6fPgnzQUJwZMjbckSfUu3lBi3fzgn8DO7TTFwguEdkoZ/LCDqgMAouOo3lIPVMXdwd+iz9C9ALw9pUABqC2dpaBit22JlkH4P7UDK8vZKq+Kq8F+Dv2sGFHmXJJORVDUVxDF772A6+HAwba7qbWxcmvizc97UQxHYk/NswAPixbPw+A7KmLAmOTW4C/Vbw652i7R7sdVFtTcAx4Bz9AnYH7UzO9vvGpr8w7hX1yjkrOKu3moPvu2nEL8H5DsXtrQ7E7om/LMTj545/vgj11L6JimjNpoQt7YMdXZevnn9T+vgl76O628isMjEW1NQVHAX2j74Vd5AcFjiXyu4AxDro+pB27AMfv15aVcw3+PeqH4k1POwn4G4ZfCGhBm3nZUxfFYwdud/na6LGyjOSX4zJSXokYCqxTXU3BPtQGbdHYlMzieOsPU4TWTfwjkz2l4VJWWFOa9T0qdMqiQTiktoCjp1984/AaPRBiT9n6+boR8Rbt/meIYoR+RvLLfYBpwNSMlFeuaePl/8a+OgL3ll34Mxc64M82CEd67MRgB+19N3dKfbXjw5Ea505a2AN7OoVvRmZPWdQTtRIt2l6+dm67FNsQNNJ8N8E+qSJSXXXBBRRAFg1JySxOsP4wV88+7ffhDrrVx6tvYl6lo2dxBE7++Od74M8KM1ASVyS6Tjs+Wbphvm7Z1Xn1SZT0EhXKSH7ZhR349iTY7seenjgq4Hd9v+0901PaPUJ/x/Hb6jqjdMWIFNS2VjDu2TiQOKCrIXTBn7cJcLLYmflGv8a3l2RPKeyAyouxaEcb0tydUD/s0t+htnZQV51vpGZ4d6LyhACuS3EXf1RfmXcJYFVFblNyVkkz/kHuj31fsdGa0qyLSbkVJ/FnXtyQmFd5BOScqTP9GMwb2hFg1kP/0x2Rmw31Yl0Iv6Ii+jbMuDWdpekSyiDsBsgDkfrLmrHUZSC3IvQCPq5seDxc1IoO/OHq+kcuAKSnruiL2h/219TNdrKa9qP0s47m8w7Evtce0cAZgLJmhKMT+MEZTgA7nJFf3WKatI4Z8MmrRRmnXbMe+p94YBwqOrMbkVndMSJTH62fC4Bur9L3gEPl6+aGtTBkzVjqAu4DrkdNnltDtc2c+ZJgZ2nfAKSnvOICHkAFRf4+PW1FxE3ZzM/RN/LAvUufcFdH6s/BuLlQ4z8UGDd9Vk28i9bZzha1oKSW71CsYTfKz+HE8abz1BOlG+bryqquK4XNOtCA0QezKcwlV2PfG7/Rji3t3gXcl5a20onUpD9f/4DfdFWi20xPWacIfe01x2+3OZ7fm+MbzMrSGbitI/YZsd288GzRlmcuJ0tLB+eUdZA9pdCFPcM6JHsxfTqBwBwkvMiti7VHq+sfOQ9QU/+IkZ664h2UYbUTfoDeq62dFS5EWH++HinuEld9ZW4LwKqK3DPJWaUX8e/b3QnD8teUZBnAl8F+m5Ff1QmlDw7CXw5mgAs7G9tT9MZfmou2/OVy0+d0s8Yp7TgevyLbQohNNAww74UKi8qc+RLYWZptL6upm/0d8BZ+R5uTFXQa/8wWWktZ+rtFkthCUqM380KjN6MZe7aCK1YpILrWrEshusZ+umzdvFa2OU87gDGpD/ZJ0UpRDglQelFQgOqq8g3sEyiwyIReFCkSW2szxQocXUS/EOJ8K3HcMy0MMI0RAwltuk31qj8FLb/SVoACnjMQgAthfrtsihU4er+6NKa/QDBd6SaCABMudk0jfb8Jq9TW1AYHKDW9qH+Q5k7BiXoK55WoVKjfI9LLBPLtI06AyZz5UkLAtRFtf2aGwfsBzzk6SNNQXAAiT7aoDVw0SX+JDtqx/gLBwPkE+x7166wZS0cRmfRV8131qj+diXRBWtrKOPwlXSwKJtqHY8Uxq0EAsQNHH2B9k9at0t2zpy6yucnL1845Bfw14Po7HADUSvEMR+lpK+JQ/nw9Hm9HXU2BrSpIaqbXCq8K9vxg1w9jsnJ0tjG84I/PxheMe/ZyNzd95urgNOM3ALoIIn6WvzqniSAAuWcsCwpQZtLyeOyDHHa/MTMNWgFTW1PwcZDm3fFPYIPWtdp0ne0U7aQZ+VWdZuRXx2M36bR0RC1lywF0m/mPgnHPtQCmYU7OoXwYTYh85X09ontaf9AE66Bs/fyW7CmFp/DrC32DvVTFq3OasqYv+SuqLJgllt/hTlxGZcPjgTVv9FXTVL3qTyENkG0Exno+3ztZCihAclZJN+wsL2ywYVJuhRgwCpEElEjeBcQyLAfjYEdcKKtAsCKmlq2nD0qCGoEyBA4jMumacq+cyYU6+9JtTCF9LRWhVlDishEBTfX9JqQRNSQwtbNCARP4fIG2Md29fmZ1eXakPWeYOX4jzPG09LJgwJwHtrtWvvnfzahCb/sIbevRyUkJ4BPYY431an76pjvIM3Vxh1CdVDQ+0URrgH7tTlzmAshMWn5VQN/hLNx30gZgUjO8VkZDsOcGu60tbG6nw3GzbJn7gC2vrkxv7giw8s3/Po0mVip/DnEojb4LagZZ/DBi2cSSjU9dzJ208Dv81toB+A2Fh1CSTSfz37XYPYs2qmh8oilrxlKdxf2IH3jdPdBctfrRk4QmfRJEWjFW37prI9AvpK8qJ2Vj9HHbjbJqnwPLn5MR3J8TSEVb/vKjOQjNAPnjnz+BH5yeeQ+/0NGBw+0IfnCGYAZ3lK2ffyl7yqIDWn9jPdMW7wvncKtofKLJPWPZ6+aAHKlseDwYOJGktA9RbocTNbWz94VrmJrhBXsWxAHL0QaQnFWSgN3OFjaiJimnoiP2VbuzodgdUYBwqtU2o/hgZ5QBsC+R4wi+xl9htlfO5MKepRt8YVF60aKemE6wcJ1VNj5+Fs1d4U5a3tWw+1HCOu1q6mafQe2vTmhIwGAGJtXq++73q8tzImUe9MVv8D3nBBhwHvEJdvP5wEjXlGx8shm778UnCpetn3cS+0y/zTNtcVvNH7qU9kPV6kejUpstNaOoI36zPcA3Vp1PgBR3SQfsZWOcpMXo4+U4pqEtSmh7wnt0sXdY9pRC3Vr9MX7ho1vAgDghXcyN6OpuA92GXzdrMZ9Tp5H4rdOXcBacok8kx2XN2gKOviF2z5vwQm8H1+zFL2l1RIugLFs3rxmVKe17ac+0Jdc56NMii61eJLL/3hGlphddhy8NHYCd9VV5PsXTXDV65NCuVeU5YcNqk3IqemMPR3Ya89cmcPpjF7MjRi6WbnwyMEJyVPaUQl2r/hS7u/cez/Ql/SP1C1C55rG9wDpgXdXqRy/7w0VpyiKtF/v+3nw+ncZiX1WfO+ha35+ONRS7HZfZjwhO/vjn4vLHP38v/hQ8i5ym332B3yblAu7InrIIwCr6vRW/EuwC7s9yCFDVmsfOhPsKiFMygblfe7/zwNa6qnzfZExxF/fALsF9taoiJ6yBNSmnXLDH77Up6TcsOAXjnhsIPIxdC78I/KN409P7nNygdMOTl7D7/QegCQfl6+aeBt7F7/fpBDyYNb1NLK7dlJa28jpU8pSl01wC3q2rzvdNvpTMYrMQkW+8zqIs6E7GV7dTjk3Mq7zVTHWPSKFS3V0gvwZGBuSEHkdkm/f1p9uctJozufBBrVhPC8IbZevm+cw8KrNN7kPooKWw7wK2VzQ+EXWLb1raSksqG6mlxF9CeK+uusCmcKZkFt+OcL1WIeu9VRW5joSQpJyKYcCdvvdS9/oW2NpQ7A678lqBU/DHZ0F4EGSg+SBqMNVM2dneYhE5kwu7mjmhcWZO6FlgS9m6eT4z/JXICU1PXQHCEAPxS2XqPucNeLeupsAm6kYjJzQppyLBLGAUr2W2nQfZ1lCcGTL6Jxg4A01wMMFpAnnfu3lB0+UOTPaUwoHAA1o29UkD+X9XMJv6WmAsQs+AqlHfA1trawpsHCGa2dRJuRUdDbgTMQtQmMNvCJ82ejODsshg4NyCqgAFcNQQ3vZufiZqNSyzpxReD3K7dWcDaUJ4q3ztXJ8U46tDoOqtmUWDfJU+lJ1L5Ihh1SFY81jwOgQi3YG+hirH4g8D9pf0agF2IvJpYL211AzvEITfGJhlxYQfQS67DkFiXuVw1DcQOmjZ1O82eluvoGDg3Ixwk/nTt4bwpnfzM9HCxgRokTkBfIN+GninfO1cm0icNWNpPMqVfE2YYngtiJzGrOtpiHRE6VTd7dWgWhXD+wb4uLZ2VisxPDXDOxq4XRX0NsuyCG/VV0anxEpiXmVP4D6QeBOcg43ezHedgHO1mTkMgCFs9W5+JmopGj6Api66HbheG/SLINvK185ptdHGoPbN5zW1s1tZsK9w7ZthIPeY4Jxo9GZujggOQMG4Zx8AGaRelh9ANno3L4h6ed7sqYvGGsgtAVWj9ppVo1rpL0GqRsU7AKfZUJUNjwCHfiZVowQYB9LLBGd/ozezVaHBUMbG7ShjnaBMD2OwZxK3otyJ/5tg1gI9WPLaU4604LJ183Z4pi4+hdLMrWcZBgzKmr7kE7Pemm+BmILAAfOfv96a8jtZqRr+emvQXF3/SNhJpddbC/jpOLC1virP6UeU2kKjsft3gsZQh6t9cwcwSqtUuNG7eYFt0PMmvADIAOAGQxhgdncK4c2SjU85LlPsmbY4HlULpndApcLTKPvbHoeBhY4pypUKXSD9EZpWl2WHBTMxr7IrMBF/pcJ9jd7M94O1DWem/wRleuisOuJmzA/+5D38ggvhOtSKSgi4rgdwX+6khW85rfFZvnZus2fa4jdQ5hH9k2LdUe7locD/vVxA7DU+g7qNTwD/rKvOd+J2Bnw1Ph/EtD3OzC7bA7JjdZnnhxCX3I7fanCeMD6mSIWJxhjCbWYzA/gAka4GjEasoHSf4IDGq7mM6rhdDVXKZRji20AMA6mvbHzc1ldm0nKrUuG5qtWP+vaon0F1XMNQxWI/W1Pq8TnWEnMrBiLyoHbjDxuKM3eF6j8SOC5DmADityS3rsgOcNgQPjelnGFRqivd3ayw1B/YVdH4hK3GqDtp+SjD+jKiXwi4ZIj4YwWufF1p3w0M361lH/AZwhkDJpi6F8B3IG82FGeGHJuIhYnyxz93NcjvCayErgoT7QP5vHjTn08C5E580QX8Vn13OjoV2UORO2n5fYYVQ/DzqMh+COEgcCNIt4C60gbCBQM6WzXSgS0Nxe6wUqDTqlEJ6qb0RuSiAQcRvire9HSrzS/EtwyOAm9HEyB30vI+hsp2vtLfMogzhPuAflo1X9+3DGZml7lAhhvCDUD3EBXZdzYUu/8d6V6OwGkrqWxquc+AQZrB8O3SDfMjFpdoD2XOfCkOJdx0MEQuEaOvgKS4S7oA/2X460eDcNiAvwV+BcT05QwDGQv0MMExEPkS2N5Q7I7I6mMCDkDupIUjlaEPTKv2+tIN82OhM1wxSnGXjADu0ljWXoR/rArz/ZyknAqAXgidDDjZUJLlWMWIyTfbcie96MJecWnPLx0YkwL3qH2rInzYaE1pFrTzK4ixSgEZjt/XbgCfxeg+V5TqK3ObsEfPOCnp1W6KOji5E18UAj4jXLphfsRkpl8Q6RFDA5M9pVGtua1TLFbOMPx5N21aNZ5pS1ye6Utitg9GiY5gD5aM2eqJ6kDkTnwRYJJl2TVgb+nGJ7c5udYzbfEwkLtMfeBrYG/Fq3Oi/oXdQEpLW9nbdMSdrlXF8CJSclbJMOAeU1prMWD96vKcqO+p0RYIeuHP9nK8ajzTFiegbGguVCbBaGB01oylP6CC8A4byPHKxrZ/mzqQ0lNXdEToa6gYicFo2XWp6UUd6moKnAQofo1yAnY1n3kU8J8oj2XUwQlMYI2413imLu6IihkIlqdzFSoz4HrAcCcuO4mSfI4hsrcyiHs6kDJSXhFD2en6oSZPT0JzjNtTM4qO1lUXhHVFr6rIbUnOKvkSf8LvYGIATrT3nJPYi75NyJm8MFLQ+53Y0yl2oFIqAgdeUIbLYSjLgJMsa8x2d5vXJRAcGEsc7gjck5rhdcLudTYWE5Ukqp2WvPbUj7kTX/wSNdNBsYwHcyYX7gc+CtR1sqcuGh7woded5a/O+Rgga/qSLqgA8AGooPXA0iYJDh8rWLvzKGfaQVQMeH9URCvmvW4ghHMxxV3SxRBuRqUPWhSTvTEWiG9HzcQx+GfpEGBg9pTCT4Avy9bPN7KnLuqJZVVW9C0aazA/brTL/Id7xrIe5qBZg9IFZ6TX29mDEoWba2tn6W32meVVrMjWm1MzvIfqqvObrAYp7mIXyBiUz0ln35eIkR4XS/NNL9N808fu8+EEyBdm9E28GeBxHnhd/0xLMHInLrsOFRYLIt9VrnnsjUjPkZHyyh8N6GMaHP9eUzc7aHnktPSiOAMeVn4qAWhC2GIo09MQhFtBrtLeA5BTCNtWlec4ds61hWL5VfcTwJso76kerNELFTOg7zPbIgFjku4md1ozumuI621UW1PwI/CBdioB5eF8CCWwXKX9ZnkwN8UKGIjRRmaR6QXdlTO58BtUXPLQIM0+LV871+k3q/U9yylb6xLi+lZUV1NwODWjaBf+HJ3AbAcDlRD26aqK3Mv6lLMTiik4FpVumH8OeD97SuEulA7TAyVm7y5f5xgYsKe8uzKTlneqWvNYyPz/jJRXrKqEwa4PRf9CrZJAKfMQsL2+Mveyc4Gc0s/dVNKK3InLUgCX6ZF9rWrNYyEHKyPllXhgounkaqmpm13v5B5mNvVAhH7mnnO4viovZuwrFF2RlRNlOoff4j0oM2n5uZBuanv2neOMsrrqfFBpjTFxDjqlXyI4x/DvXb5aPQ6v+0XRlSiGF236hOC1esLReZxlov2s6Be35wC4E5fFI3KboawHrjDRNy3AEQO219Q/csU28mjR/wd5M8CQz9GQZgAAAABJRU5ErkJggg==\"/>\r\n        </svg>\r\n        <h5>API</h5>\r\n        <p>Query Any Data</p>\r\n        <p>On Demand From</p>\r\n        <p>Your IT System</p>\r\n    </div>\r\n    <div class=\"plans-sidebar-section hide980\">\r\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" class=\"small-image\">\r\n            <image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" class=\"cls-1\" width=\"100\" height=\"100\" xlink:href=\"data:img/png;base64,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\"/>\r\n        </svg>\r\n        <h5>Data Feeds</h5>\r\n        <p>Integrate Bulk</p>\r\n        <p>Data Into Your</p>\r\n        <p>IT System</p>\r\n        <p class=\"small-text\">Choose either API or FTP delivery.</p>\r\n    </div>\r\n    <div class=\"plans-sidebar-section\">\r\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"107\" height=\"107\" viewBox=\"0 0 107 107\" class=\"small-image\">\r\n            <image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" class=\"cls-1\" width=\"107\" height=\"107\" xlink:href=\"data:img/png;base64,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\"/>\r\n        </svg>\r\n        <h5>Analytics</h5>\r\n        <p>Measure Your</p>\r\n        <p>Carriers On Time</p>\r\n        <p>Performance</p>\r\n    </div>\r\n    <div class=\"mt10\">\r\n        <a class=\"btn\">Get a Quote</a>\r\n        <a class=\"link\">Learn More</a>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n"

/***/ }),
/* 693 */
/***/ (function(module, exports) {

module.exports = ".sidebar-section {\n  margin-top: 30px; }\n\n.sidebar-section:first-of-type {\n  margin-top: 0; }\n\n@media only screen and (max-width: 1200px) {\n  .plans-sidebar {\n    width: 100%;\n    font-size: 0;\n    margin-left: 0;\n    margin-top: 0;\n    padding: 30px 20px; }\n    .plans-sidebar .plans-sidebar-section {\n      padding-left: 10px;\n      padding-right: 10px;\n      width: calc(33% - 1px);\n      display: inline-block;\n      vertical-align: top;\n      border-bottom: 0; }\n      .plans-sidebar .plans-sidebar-section:nth-of-type(3) {\n        width: calc(33% + 2px); }\n    .plans-sidebar .btn {\n      display: block; }\n    .plans-sidebar img {\n      height: 60px; } }\n\n@media only screen and (max-width: 499px) {\n  .plans-sidebar .plans-sidebar-section:nth-of-type(3),\n  .plans-sidebar .plans-sidebar-section {\n    border: none;\n    width: 100%; } }\n"

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(695));


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var carrier_performance_service_1 = __webpack_require__(696);
var status_1 = __webpack_require__(95);
var sort_1 = __webpack_require__(697);
var CarrierPerformanceComponent = (function () {
    function CarrierPerformanceComponent(service) {
        this.service = service;
        this.Status = status_1.Status;
        this.Sort = sort_1.CarrierPerformanceSort;
        this.sortOrder = sort_1.CarrierPerformanceSort.Time;
        this.descending = true;
        this.showTrip = false;
        this.onShare = new core_1.EventEmitter();
        this.onContact = new core_1.EventEmitter();
    }
    Object.defineProperty(CarrierPerformanceComponent.prototype, "items", {
        set: function (carriers) {
            var selected = new Array();
            for (var index = 0; index < carriers.length; index++) {
                if (carriers[index].selected) {
                    selected.push(carriers[index]);
                }
            }
            selected.sort(this.sortItems.bind(this));
            this.carriers = selected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CarrierPerformanceComponent.prototype, "parameters", {
        set: function (params) {
            this.params = params;
        },
        enumerable: true,
        configurable: true
    });
    CarrierPerformanceComponent.prototype.share = function () {
        this.onShare.emit();
    };
    CarrierPerformanceComponent.prototype.contact = function (trip) {
        this.onContact.emit(trip);
    };
    CarrierPerformanceComponent.prototype.setSort = function (orderToSet) {
        if (orderToSet !== this.sortOrder) {
            this.descending = true;
        }
        else {
            this.descending = !this.descending;
        }
        this.sortOrder = orderToSet;
        this.carriers.sort(this.sortItems.bind(this));
    };
    CarrierPerformanceComponent.prototype.sortItems = function (a, b) {
        switch (this.sortOrder) {
            case sort_1.CarrierPerformanceSort.Carrier:
                return this.sortByCarrier(a, b);
            case sort_1.CarrierPerformanceSort.Count:
                return this.sortByCount(a, b);
            case sort_1.CarrierPerformanceSort.Time:
                return this.sortByTime(a, b);
            case sort_1.CarrierPerformanceSort.Tranships:
                return this.sortByTranships(a, b);
            default:
                return this.sortByTranships(a, b);
        }
    };
    CarrierPerformanceComponent.prototype.sortByTranships = function (a, b) {
        var one = a.minTranshipments;
        var two = b.minTranshipments;
        var sorted = (one < two) ? -1 : (one > two) ? 1 : 0;
        if (sorted === 0) {
            sorted = (a.minDuration < b.minDuration) ? -1 : (a.minDuration > b.minDuration) ? 1 : 0;
        }
        return this.descending ? sorted : -1 * sorted;
    };
    CarrierPerformanceComponent.prototype.sortByCarrier = function (a, b) {
        var one = a.name.toUpperCase();
        var two = b.name.toUpperCase();
        var sorted = (one < two) ? -1 : (one > two) ? 1 : 0;
        return this.descending ? sorted : -1 * sorted;
    };
    CarrierPerformanceComponent.prototype.sortByTime = function (a, b) {
        var one = a.minDuration;
        var two = b.minDuration;
        var sorted = (one < two) ? -1 : (one > two) ? 1 : 0;
        if (sorted === 0) {
            sorted = (a.minTranshipments < b.minTranshipments) ? -1 : (a.minTranshipments > b.minTranshipments) ? 1 : 0;
        }
        return this.descending ? sorted : -1 * sorted;
    };
    CarrierPerformanceComponent.prototype.sortByCount = function (a, b) {
        var one = a.count;
        var two = b.count;
        var sorted = (one < two) ? -1 : (one > two) ? 1 : 0;
        if (sorted === 0) {
            sorted = (a.minDuration < b.minDuration) ? -1 : (a.minDuration > b.minDuration) ? 1 : 0;
        }
        return this.descending ? sorted : -1 * sorted;
    };
    CarrierPerformanceComponent.prototype.viewDetails = function (carrier) {
        if (carrier.trips == null) {
            carrier.status = status_1.Status.Loading;
            this.service.getSchedules(carrier, this.params).then(function (schedules) {
                carrier.setTrips(schedules.items);
                carrier.status = status_1.Status.Loaded;
            }).catch(function (err) {
                carrier.status = status_1.Status.Error;
            });
        }
        carrier.viewDetails = !carrier.viewDetails;
    };
    CarrierPerformanceComponent.prototype.displayTrip = function (trip) {
        this.tripToDisplay = trip;
        this.showTrip = true;
    };
    CarrierPerformanceComponent.prototype.closeTrip = function () {
        this.showTrip = false;
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], CarrierPerformanceComponent.prototype, "onShare", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], CarrierPerformanceComponent.prototype, "onContact", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], CarrierPerformanceComponent.prototype, "items", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], CarrierPerformanceComponent.prototype, "parameters", null);
    CarrierPerformanceComponent = __decorate([
        core_1.Component({
            selector: 'carrier-performance',
            template: __webpack_require__(698),
            styles: [__webpack_require__(699)],
            providers: [carrier_performance_service_1.CarrierPerformanceService]
        }),
        __metadata("design:paramtypes", [carrier_performance_service_1.CarrierPerformanceService])
    ], CarrierPerformanceComponent);
    return CarrierPerformanceComponent;
}());
exports.CarrierPerformanceComponent = CarrierPerformanceComponent;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var CarrierPerformanceService = (function () {
    function CarrierPerformanceService(api, app) {
        this.api = api;
        this.app = app;
    }
    CarrierPerformanceService.prototype.getSchedules = function (carrier, params) {
        var _this = this;
        params['carriers'] = [carrier.id];
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetSchedules(client, params); });
        return promise;
    };
    CarrierPerformanceService.prototype.callGetSchedules = function (apigClient, query) {
        var params = {};
        var additionalParams = {
            headers: { 'Content-Type': 'application/json' },
            queryParams: query
        };
        return apigClient.tripsGet(params, '', additionalParams)
            .then(this.handleSchedulesResolve.bind(this)).catch(this.handleSchedulesError.bind(this));
    };
    CarrierPerformanceService.prototype.handleSchedulesResolve = function (result) {
        var trips = new shared_1.Trips(result);
        trips.items.sort(function (a, b) {
            var one = new Date(a.departureDate);
            var two = new Date(b.departureDate);
            return (one < two) ? -1 : (one > two) ? 1 : 0;
        });
        return trips;
    };
    CarrierPerformanceService.prototype.handleSchedulesError = function (error) {
        return this.api.handleError(error);
    };
    CarrierPerformanceService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AppContext])
    ], CarrierPerformanceService);
    return CarrierPerformanceService;
}());
exports.CarrierPerformanceService = CarrierPerformanceService;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CarrierPerformanceSort;
(function (CarrierPerformanceSort) {
    CarrierPerformanceSort[CarrierPerformanceSort["Carrier"] = 0] = "Carrier";
    CarrierPerformanceSort[CarrierPerformanceSort["Tranships"] = 1] = "Tranships";
    CarrierPerformanceSort[CarrierPerformanceSort["Time"] = 2] = "Time";
    CarrierPerformanceSort[CarrierPerformanceSort["Count"] = 3] = "Count";
    CarrierPerformanceSort[CarrierPerformanceSort["Reliability"] = 4] = "Reliability";
})(CarrierPerformanceSort = exports.CarrierPerformanceSort || (exports.CarrierPerformanceSort = {}));


/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = "<div class=\"schedule-results-table\">\r\n    <div class=\"header-col\">\r\n        <div class=\"col1\" [class.selected]=\"sortOrder === Sort.Carrier\" (click)=\"setSort(Sort.Carrier)\">\r\n            Carrier\r\n            <span class=\"sort-span\" [class.upside-down]=\"!descending && sortOrder === Sort.Carrier\">&#9660;</span>\r\n        </div>\r\n        <div class=\"col2\" [class.selected]=\"sortOrder === Sort.Tranships\" (click)=\"setSort(Sort.Tranships)\">\r\n            Minimum<br>Tranships\r\n            <span class=\"sort-span\" [class.upside-down]=\"!descending && sortOrder === Sort.Tranships\">&#9660;</span>\r\n        </div>\r\n        <div class=\"col3\" [class.selected]=\"sortOrder === Sort.Time\" (click)=\"setSort(Sort.Time)\">\r\n            Fastest<br>Transit Time\r\n            <span class=\"sort-span\" [class.upside-down]=\"!descending && sortOrder === Sort.Time\">&#9660;</span>\r\n        </div>\r\n        <div class=\"col4\" [class.selected]=\"sortOrder === Sort.Count\" (click)=\"setSort(Sort.Count)\">\r\n            Number of<br>Sailings\r\n            <span class=\"sort-span\" [class.upside-down]=\"!descending && sortOrder === Sort.Count\">&#9660;</span>\r\n        </div>\r\n        <!--<div class=\"col5\">\r\n            On-Time Arrival<br>Reliability\r\n        </div>-->\r\n    </div>\r\n    <div class=\"results-row\" *ngFor=\"let carrier of carriers\">\r\n        <div class=\"results-row-padding\">\r\n            <div class=\"col6\"><a [class.open]=\"carrier.viewDetails\" (click)=\"viewDetails(carrier)\" title=\"View More Details\"\r\n                    class=\"expand-button more-icon\"><img src=\"../img/blackarrow-01.svg\" onerror=\"this.onerror=null; this.src='../img/blackarrow.png'\"></a></div>\r\n            <div class=\"col1\">\r\n                <p class=\"table-rep-header\"><b>Carrier</b></p>\r\n                <span class=\"carrier-logo-wrapper\">\r\n                    <img [routerLink]=\"['/carriers', carrier.id, {scroll: true}]\" class=\"company-logo pointer\" src=\"../img/carriers/{{ carrier.id }}.gif\"\r\n                        onerror=\"src='../img/carriers/0.gif'\">\r\n                </span>\r\n                <b class=\"hover-link\" [routerLink]=\"['/carriers', carrier.id, {scroll: true}]\">{{ carrier.name }}</b>\r\n                <span class=\"favorite-star\">\r\n                    <img class=\"ga-favorite-carrier\" [favorite]=\"carrier\" [itemtype]=\"'carrier'\">\r\n                </span>\r\n            </div>\r\n            <div class=\"col2\">\r\n                <p class=\"table-rep-header\"><b>Minimum Tranships</b></p><b>{{ carrier.minDurationTranshipments }}</b></div>\r\n            <div class=\"col3\">\r\n                <p class=\"table-rep-header\"><b>Fastest Transit Time</b></p><b>{{ carrier.minDuration }} days</b></div>\r\n            <div class=\"col4\">\r\n                <p class=\"table-rep-header\"><b>Number of Sailings</b></p><b>{{ carrier.count }}</b></div>\r\n            <!--<div class=\"col5\">\r\n                <p class=\"table-rep-header\"><b>On-Time Arrival Reliability</b></p><em>coming soon</em></div>-->\r\n                <!-- <blur [item]=\"carrier.reliability\" [itemtype]=\"'small-number-dark'\"></blur> -->\r\n        </div>\r\n        <div *ngIf=\"carrier.viewDetails\" class=\"results-row-bottom\">\r\n            <span *ngIf=\"carrier.status == Status.Loading\" class=\"mini-loader\"></span>\r\n            <span *ngIf=\"carrier.status == Status.Error\" class=\"error\"><em>there was an error, please try again.</em></span>\r\n            <div *ngIf=\"carrier.status == Status.Loaded\">\r\n                <div class=\"inner-results-row\">\r\n                    <div class=\"col1\"><em><u>Tranships</u></em></div>\r\n                    <div class=\"col2\"><em><u>Transit</u></em></div>\r\n                    <div class=\"col3\"><em><u>Ports</u></em></div>\r\n                    <div class=\"col4\"><em><u>Departure</u></em></div>\r\n                    <div class=\"col5\"><em><u>Arrival</u></em></div>\r\n                </div>\r\n                <div class=\"inner-results-row\" *ngFor=\"let trip of carrier.trips\">\r\n                    <div class=\"col1\"><blur [item]=\"trip.transhipments\" [itemtype]=\"small-number-dark\"></blur></div>\r\n                    <div class=\"col2\"><p><blur [item]=\"trip.durationText\" [itemtype]=\"small-text\"></blur></p></div>\r\n                    <div class=\"col3\">\r\n                        <span *ngFor=\"let stop of trip.getPortStops()\" class=\"greater-than-list hover-link\" (click)=\"displayTrip(trip)\">\r\n                            <span>\r\n                                <blur [item]=\"stop.port.code\" [itemtype]=\"'medium-text-dark'\"></blur>\r\n                            </span>\r\n                        </span>\r\n                    </div>\r\n                    <div class=\"col4 etaDateTime\">\r\n                        <blur [item]=\"trip.departureDate\" [itemtype]=\"'large-text-dark'\"></blur>\r\n                            <!-- <blur [item]=\"trip.departureDate\" [itemtype]=\"'large-text-dark'\"></blur> -->\r\n                        <!-- <blur [item]=\"trip.departureTime\" [itemtype]=\"'small-text'\" class=\"small-gray-text\"></blur> -->\r\n                    </div>\r\n                    <div class=\"col5 etaDateTime\">\r\n                        <blur [item]=\"trip.arrivalDate\" [itemtype]=\"'large-text-dark'\"></blur>\r\n                        <!-- <blur [item]=\"leg.endTime\" [itemtype]=\"'small-text'\" class=\"small-gray-text\"></blur> -->\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div *ngIf=\"this.showTrip\">\r\n    <div class=\"popup-container\">\r\n        <div class=\"popup-wrapper\" (click)=\"closeTrip()\"></div>\r\n        <div class=\"popup\">\r\n            <a class=\"close\" (click)=\"closeTrip()\">&times;</a>\r\n            <voyage-partial [item]=\"tripToDisplay\" (onShare)=\"share()\" (onContact)=\"contact($event)\"></voyage-partial>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 699 */
/***/ (function(module, exports) {

module.exports = ".main-content {\n  margin-top: -50px; }\n\n.results-header {\n  background: #282828;\n  height: 50px;\n  color: #ffffff; }\n  .results-header h5 {\n    line-height: 50px;\n    font-weight: 300; }\n  .results-header .results-header-col-1 {\n    display: inline-block;\n    width: 320px;\n    padding-left: 10px; }\n  .results-header .results-header-col-2 {\n    display: inline-block;\n    width: calc(100% - 320px);\n    padding-left: 20px; }\n\n.results-content {\n  margin-left: 320px;\n  vertical-align: top;\n  display: inline-block;\n  width: calc(100% - 320px);\n  padding: 20px;\n  padding-bottom: 200px; }\n\n.header-col {\n  width: calc(100% + 40px);\n  margin-left: -20px;\n  background: #f0f0f0;\n  margin-bottom: 25px;\n  margin-top: 25px;\n  padding: 10px 30px; }\n  .header-col div {\n    vertical-align: top;\n    font-weight: bold;\n    font-size: 15px;\n    line-height: 18px; }\n    .header-col div .sort-span {\n      display: none;\n      font-size: 16px;\n      position: relative;\n      top: -3px;\n      white-space: nowrap; }\n    .header-col div:hover .sort-span {\n      display: inline-block; }\n    .header-col div.selected .sort-span {\n      display: inline-block; }\n  .header-col .col1 {\n    margin-left: 22px; }\n\n.schedule-results-table {\n  font-size: 0; }\n  .schedule-results-table .results-row {\n    border: 1px solid #c1c1c1;\n    margin-bottom: 20px;\n    font-size: 0; }\n    .schedule-results-table .results-row .company-logo {\n      vertical-align: middle;\n      max-width: 100%;\n      max-height: 40px; }\n    .schedule-results-table .results-row .carrier-logo-wrapper {\n      width: 36px;\n      text-align: center;\n      display: inline-block; }\n    .schedule-results-table .results-row .results-row-padding {\n      padding: 10px;\n      font-size: 0;\n      background: #efecf3; }\n    .schedule-results-table .results-row div {\n      vertical-align: top;\n      font-size: 16px; }\n    .schedule-results-table .results-row .notes-div {\n      background: #c1c1c1;\n      padding-left: 10px; }\n      .schedule-results-table .results-row .notes-div p {\n        line-height: 26px; }\n    .schedule-results-table .results-row .table-rep-header {\n      display: none; }\n  .schedule-results-table .col1, .schedule-results-table .col2, .schedule-results-table .col3, .schedule-results-table .col4, .schedule-results-table .col5, .schedule-results-table .col6 {\n    display: inline-block;\n    padding-left: 3px;\n    padding-right: 3px;\n    word-break: break-word;\n    overflow-wrap: break-word; }\n  .schedule-results-table .col1 {\n    width: calc(28.5% - 22px);\n    white-space: nowrap; }\n  .schedule-results-table .col2 {\n    width: 22%; }\n  .schedule-results-table .col3 {\n    width: 26.5%; }\n  .schedule-results-table .col4 {\n    width: 19.5%; }\n  .schedule-results-table .col5 {\n    width: calc(21.5% - 30px); }\n  .schedule-results-table .col6 {\n    width: 24px; }\n    .schedule-results-table .col6 a {\n      padding: 6px 10px;\n      margin-left: -10px;\n      height: 42px;\n      line-height: 42px;\n      margin-top: 0px; }\n      .schedule-results-table .col6 a img {\n        transition: transform .2s ease-in-out;\n        height: 20px; }\n      .schedule-results-table .col6 a.open img {\n        transform: rotate(90deg); }\n  .schedule-results-table .results-row-padding .col6 {\n    text-align: right; }\n  .schedule-results-table .inner-results-row {\n    font-size: 0 !important; }\n    .schedule-results-table .inner-results-row .col1 {\n      width: 15%;\n      margin-left: 10px; }\n    .schedule-results-table .inner-results-row .col2 {\n      width: 10%; }\n    .schedule-results-table .inner-results-row .col3 {\n      width: 40%; }\n    .schedule-results-table .inner-results-row .col4 {\n      width: 15%; }\n    .schedule-results-table .inner-results-row .col5 {\n      width: 15%; }\n  .schedule-results-table .results-row-bottom input[type=\"text\"] {\n    width: calc(100% - 190px); }\n  .schedule-results-table .results-row-bottom .btn {\n    position: relative;\n    top: 2px;\n    line-height: 18px;\n    margin-left: 10px;\n    background: #664587; }\n    .schedule-results-table .results-row-bottom .btn:hover {\n      background: #4d3465; }\n  .schedule-results-table .results-row-bottom .results-row-bottom-notes {\n    padding: 10px; }\n\n.no-results-wrapper {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  background: #fff;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  padding-left: 350px;\n  padding-top: 35px;\n  padding-right: 20px;\n  padding-bottom: 35px; }\n\n#loader-wrapper {\n  position: absolute;\n  top: 0;\n  left: 320px;\n  width: calc(100% - 320px);\n  height: 100%;\n  z-index: 25;\n  background: rgba(255, 255, 255, 0.5); }\n\n#loader {\n  display: block;\n  position: relative;\n  left: 50%;\n  top: 220px;\n  width: 80px;\n  height: 80px;\n  margin: -40px 0 0 -40px;\n  border-radius: 50%;\n  border: 5px solid #3498db;\n  z-index: 1500;\n  border: 3px solid transparent;\n  border-top-color: #333333;\n  border-left-color: #333333;\n  animation: spin 1s linear infinite; }\n\n.sticky-loader {\n  left: calc(50% + 150px) !important; }\n\n@keyframes spin {\n  0% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: rotate(0deg);\n    /* Firefox 16+, IE 10+, Opera */ }\n  100% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: rotate(360deg);\n    /* Firefox 16+, IE 10+, Opera */ } }\n\n@keyframes down {\n  0% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: translateY(0px);\n    /* Firefox 16+, IE 10+, Opera */ }\n  50% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: translateY(18px);\n    /* Firefox 16+, IE 10+, Opera */ }\n  51% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: translateY(-18px);\n    /* Firefox 16+, IE 10+, Opera */ }\n  100% {\n    /* Chrome, Opera 15+, Safari 3.1+ */\n    /* IE 9 */\n    transform: translateY(0px);\n    /* Firefox 16+, IE 10+, Opera */ } }\n\n@media only screen and (max-width: 1023px) {\n  .results-content {\n    width: 100%;\n    margin-left: 0; }\n  .results-header .results-header-col-1 {\n    display: none; }\n  .no-results-wrapper {\n    padding-left: 64px; }\n  #loader-wrapper {\n    left: 0;\n    width: 100%; }\n  .sticky-loader {\n    left: 50% !important; } }\n\n@media only screen and (max-width: 699px) {\n  .schedule-results-table {\n    margin-top: 35px; }\n    .schedule-results-table .results-row .table-rep-header {\n      display: block;\n      text-decoration: underline; }\n    .schedule-results-table .results-row-padding .col5 {\n      text-align: center; }\n    .schedule-results-table .col1, .schedule-results-table .col2, .schedule-results-table .col3, .schedule-results-table .col4, .schedule-results-table .col5 {\n      width: 100%;\n      margin-bottom: 10px;\n      line-height: 18px;\n      text-align: center; }\n    .schedule-results-table .inner-results-row .col1, .schedule-results-table .inner-results-row .col2, .schedule-results-table .inner-results-row .col3, .schedule-results-table .inner-results-row .col4, .schedule-results-table .inner-results-row .col5 {\n      width: 100%;\n      margin-bottom: 10px;\n      line-height: 18px;\n      text-align: center; }\n    .schedule-results-table .results-row-bottom input[type=\"text\"] {\n      width: 100%; }\n    .schedule-results-table .results-row-bottom .btn {\n      margin-left: 0;\n      float: right;\n      margin-right: 1px; }\n  .header-col {\n    display: none; }\n  .details-button {\n    padding: 7px 15px;\n    line-height: 28px; }\n  #loader {\n    left: calc(50vw - 20px); }\n  .sticky-loader {\n    left: 20px !important; }\n    .sticky-loader #loader {\n      left: calc(50vw - 20px); } }\n\n.popup-container .popup {\n  padding: 25px;\n  width: 860px;\n  max-width: 100%; }\n"

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(701));


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var voyage_partial_service_1 = __webpack_require__(702);
var models_1 = __webpack_require__(12);
var VoyagePartialComponent = (function () {
    function VoyagePartialComponent(service) {
        this.service = service;
        this.onShare = new core_1.EventEmitter();
        this.onContact = new core_1.EventEmitter();
    }
    Object.defineProperty(VoyagePartialComponent.prototype, "item", {
        set: function (trip) {
            this.trip = trip;
        },
        enumerable: true,
        configurable: true
    });
    VoyagePartialComponent.prototype.share = function () {
        this.onShare.emit();
    };
    VoyagePartialComponent.prototype.contact = function () {
        this.onContact.emit(this.trip);
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], VoyagePartialComponent.prototype, "onShare", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], VoyagePartialComponent.prototype, "onContact", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", models_1.Trip),
        __metadata("design:paramtypes", [models_1.Trip])
    ], VoyagePartialComponent.prototype, "item", null);
    VoyagePartialComponent = __decorate([
        core_1.Component({
            selector: 'voyage-partial',
            template: __webpack_require__(703),
            styles: [__webpack_require__(704)],
            providers: [voyage_partial_service_1.VoyagePartialService]
        }),
        __metadata("design:paramtypes", [voyage_partial_service_1.VoyagePartialService])
    ], VoyagePartialComponent);
    return VoyagePartialComponent;
}());
exports.VoyagePartialComponent = VoyagePartialComponent;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var VoyagePartialService = (function () {
    function VoyagePartialService(api, app) {
        this.api = api;
        this.app = app;
    }
    VoyagePartialService.prototype.getSchedules = function (carrier, params) {
        var _this = this;
        params['carriers'] = [carrier.id];
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetSchedules(client, params); });
        return promise;
    };
    VoyagePartialService.prototype.callGetSchedules = function (apigClient, query) {
        var params = {};
        var additionalParams = {
            headers: { 'Content-Type': 'application/json' },
            queryParams: query
        };
        return apigClient.tripsGet(params, '', additionalParams)
            .then(this.handleSchedulesResolve.bind(this)).catch(this.handleSchedulesError.bind(this));
    };
    VoyagePartialService.prototype.handleSchedulesResolve = function (result) {
        var trips = new shared_1.Trips(result);
        trips.items.sort(function (a, b) {
            var one = new Date(a.arrivalDate);
            var two = new Date(b.arrivalDate);
            return (one < two) ? -1 : (one > two) ? 1 : 0;
        });
        return trips;
    };
    VoyagePartialService.prototype.handleSchedulesError = function (error) {
        return this.api.handleError(error);
    };
    VoyagePartialService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AppContext])
    ], VoyagePartialService);
    return VoyagePartialService;
}());
exports.VoyagePartialService = VoyagePartialService;


/***/ }),
/* 703 */
/***/ (function(module, exports) {

module.exports = "<div class=\"results-row\">\r\n    <div class=\"results-row-padding\">\r\n        <div class=\"col1\"><p class=\"table-rep-header\"><b>Transit</b></p><b>{{ trip.duration }} days</b><br> {{ trip.transhipments}}</div>\r\n        <div class=\"col2\">\r\n            <p class=\"table-rep-header\"><b>Carrier</b></p>\r\n            <span class=\"carrier-logo-wrapper\">\r\n            <img [routerLink]=\"['/carriers', trip.carrier.id, {scroll: true}]\" class=\"company-logo pointer\" src=\"../img/carriers/{{ trip.carrier.id }}.gif\" onerror=\"src='../img/carriers/0.gif'\">\r\n            </span>\r\n            <b class=\"hover-link\" [routerLink]=\"['/carriers', trip.carrier.id, {scroll: true}]\">{{ trip.carrier.name }}</b>\r\n            <span class=\"favorite-star\">\r\n            <img class=\"ga-favorite-carrier\" [favorite]=\"trip.carrier\" [itemtype]=\"'carrier'\">\r\n            </span>\r\n        </div>\r\n        <div class=\"col3\"><p class=\"table-rep-header\"><b>Departure</b></p><b>{{ trip.departurePort.title }}</b><br>{{ trip.departureDate }}</div>\r\n        <div class=\"col4\"><p class=\"table-rep-header\"><b>Arrival</b></p><b>{{ trip.arrivalPort.name }} [{{ trip.arrivalPort.code }}]</b><br>{{ trip.arrivalDate }}</div>\r\n        <div class=\"col5\">\r\n            <a title=\"Email this Schedule\" class=\"actions-icon open-share-result-event\" (click)=\"share()\"><img class=\"main-img\" src=\"../img/litepurple-email.svg\" onerror=\"this.onerror=null; this.src='../img/litepurple-email.png'\"><img class=\"hover-img\" src=\"../img/email-purple.svg\" onerror=\"this.onerror=null; this.src='../img/email-purple.png'\"></a>\r\n            <a title=\"Contact this Carrier\" class=\"actions-icon contact-carrier-event phone-icon\" (click)=\"contact(schedule)\"><img class=\"main-img\" src=\"../img/contact-icon-lite.svg\" onerror=\"this.onerror=null; this.src='../img/contact-lite-icon-01.png'\"><img class=\"hover-img\" src=\"../img/contact-icon.svg\" onerror=\"this.onerror=null; this.src='../img/contact-icon-01.png'\"></a>\r\n          </div>\r\n    </div>\r\n    <div class=\"inner-results-row\" *ngFor=\"let leg of trip.legs\">\r\n        <div class=\"col1\"><em><u>Vessel</u></em><br><blur [item]=\"leg.vessel\" [itemtype]=\"'vessel'\"></blur></div>\r\n        <div class=\"col2\"><em><u>Voyage</u></em><br><blur [item]=\"leg.voyage\" [itemtype]=\"'small-number-dark'\"></blur></div>\r\n        <div class=\"col3\"><em><u>Service</u></em><br><blur [item]=\"leg.route.name\" [itemtype]=\"'large-text-dark'\"></blur></div>\r\n        <div class=\"col4 etaDateTime\"><em><u>Departure</u></em><br><blur [item]=\"leg.startPort\" [itemtype]=\"'port'\"></blur>\r\n            <br><blur [item]=\"leg.startDate\" [itemtype]=\"'large-text-dark'\"></blur>\r\n            <blur [item]=\"leg.startTime\" [itemtype]=\"'small-text'\" class=\"small-gray-text\"></blur>\r\n        </div>\r\n        <div class=\"col5 etaDateTime\"><em><u>Arrival</u></em><br><blur [item]=\"leg.endPort\" [itemtype]=\"'port'\"></blur>\r\n            <br><blur [item]=\"leg.endDate\" [itemtype]=\"'large-text-dark'\"></blur>\r\n            <blur [item]=\"leg.endTime\" [itemtype]=\"'small-text'\" class=\"small-gray-text\"></blur>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = ".results-row-padding {\n  background: #efecf3; }\n\n.inner-results-row:nth-of-type(odd) {\n  background: #efecf3; }\n\n.results-row {\n  border: 1px solid #c1c1c1;\n  font-size: 0;\n  width: calc(100%); }\n  .results-row .company-logo {\n    vertical-align: middle;\n    max-width: 100%;\n    max-height: 40px; }\n  .results-row .carrier-logo-wrapper {\n    width: 36px;\n    text-align: center;\n    display: inline-block; }\n  .results-row .results-row-padding {\n    padding: 10px;\n    font-size: 0; }\n  .results-row .inner-results-row:nth-of-type(odd) {\n    background: #efecf3; }\n  .results-row:nth-of-type(2n) {\n    background: #efecf3; }\n    .results-row:nth-of-type(2n) .inner-results-row:nth-of-type(odd) {\n      background: #ffffff; }\n  .results-row div {\n    vertical-align: top;\n    font-size: 16px !important; }\n  .results-row span {\n    font-size: 16px !important; }\n  .results-row .notes-div {\n    background: #c1c1c1;\n    padding-left: 10px; }\n    .results-row .notes-div p {\n      line-height: 26px; }\n  .results-row .table-rep-header {\n    display: none; }\n  .results-row .col1, .results-row .col2, .results-row .col3, .results-row .col4, .results-row .col5, .results-row .col6 {\n    display: inline-block;\n    padding-left: 3px;\n    padding-right: 3px;\n    word-break: break-word;\n    overflow-wrap: break-word; }\n    .results-row .col1 div, .results-row .col2 div, .results-row .col3 div, .results-row .col4 div, .results-row .col5 div, .results-row .col6 div {\n      font-size: 16px !important; }\n  .results-row .col1 {\n    width: 10%; }\n  .results-row .col2 {\n    width: 22.5%; }\n  .results-row .col3 {\n    width: 22.5%; }\n  .results-row .col4 {\n    width: 22.5%; }\n  .results-row .col5 {\n    width: calc(22.5% - 30px); }\n  .results-row .col6 {\n    width: 24px; }\n    .results-row .col6 a {\n      padding: 6px 10px;\n      margin-left: -10px;\n      height: 42px;\n      line-height: 42px;\n      margin-top: 0px; }\n      .results-row .col6 a img {\n        transition: transform .2s ease-in-out;\n        height: 20px; }\n      .results-row .col6 a.open img {\n        transform: rotate(90deg); }\n  .results-row .results-row-padding .col5 {\n    text-align: right; }\n  .results-row .inner-results-row {\n    padding: 10px;\n    font-size: 0 !important; }\n    .results-row .inner-results-row .col1 {\n      width: 20%; }\n    .results-row .inner-results-row .col2 {\n      width: 10%; }\n    .results-row .inner-results-row .col3 {\n      width: 30%; }\n    .results-row .inner-results-row .col4 {\n      width: 20%; }\n    .results-row .inner-results-row .col5 {\n      width: 20%; }\n  .results-row .results-row-bottom input[type=\"text\"] {\n    width: calc(100% - 190px); }\n  .results-row .results-row-bottom .btn {\n    position: relative;\n    top: 2px;\n    line-height: 18px;\n    margin-left: 10px;\n    background: #664587; }\n    .results-row .results-row-bottom .btn:hover {\n      background: #4d3465; }\n  .results-row .results-row-bottom .results-row-bottom-notes {\n    padding: 10px; }\n"

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var AccountComponent = (function () {
    function AccountComponent(router, app, billing, seo) {
        this.router = router;
        this.app = app;
        this.billing = billing;
        this.seo = seo;
        this.trialEnd = '';
        this.trialLeft = 0;
        this.paidStart = '';
        this.showTrialBanner = false;
        this.title = 'My Account';
        this.description = 'My Linescape Account';
    }
    AccountComponent.prototype.ngOnInit = function () {
        this.seo.set(this.title, this.description);
        if (!this.app.isLoggedIn) {
            this.router.navigate(['']);
        }
        this.trialEnd = '';
        this.trialLeft = 0;
        this.paidStart = '';
        this.showTrialBanner = false;
        this.update();
    };
    AccountComponent.prototype.update = function () {
        var _this = this;
        this.billing.getCustomer().then(function (customer) {
            try {
                if (customer.subscriptions[0].status === 'trialing') {
                    _this.trialEnd = moment.unix(customer.subscriptions[0].trialEnd).format('YYYY-MM-DD');
                    _this.paidStart = moment.unix(customer.subscriptions[0].trialEnd).add(1, 'day').format('YYYY-MM-DD');
                    _this.showTrialBanner = true;
                    _this.trialLeft = moment.unix(customer.subscriptions[0].trialEnd).add(1, 'day').diff(moment(), 'days');
                    if (_this.trialLeft < 0) {
                        _this.showTrialBanner = false;
                    }
                }
            }
            catch (ex) {
                _this.showTrialBanner = false;
            }
        });
    };
    AccountComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(706),
            styles: [__webpack_require__(707)],
        }),
        __metadata("design:paramtypes", [router_1.Router, shared_1.AppContext, shared_1.BillingService, shared_1.SeoService])
    ], AccountComponent);
    return AccountComponent;
}());
exports.AccountComponent = AccountComponent;


/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>My Account</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"trial-banner\" *ngIf=\"showTrialBanner\">\r\n          <h6 class=\"mt0 mb0\"><b>Linescape {{this.app.accountType}} Trial</b> | Days Remaining in Trial: {{trialLeft}}</h6>\r\n          <p>Thank you for signing up for a Linescape 14-day free trial! Your free trial ends {{ trialEnd }}, and your paid account will begin on {{paidStart}}. If you have any questions about our service, please email <a href=\"mailto:contacts@linescape.com\">contacts@linescape.com</a>.</p>\r\n        </div>\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-sidebar-left\">\r\n            <div class=\"mt15 sidebar-section\">\r\n              <p [routerLinkActive]=\"'current-page'\" class=\"favorites-sidebar-link\" [routerLink]=\"['favorites']\">Favorites</p>\r\n              <p [routerLinkActive]=\"'current-page'\" class=\"data-by-email-sidebar-link\" [routerLink]=\"['data-by-email']\">Data by Email</p>\r\n              <p [routerLinkActive]=\"'current-page'\" class=\"billing-sidebar-link\" [routerLink]=\"['invoices']\">Billing History</p>\r\n              <p [routerLinkActive]=\"'current-page'\" class=\"account-sidebar-link\" [routerLink]=\"['information']\">Account Information</p>\r\n              <p [routerLinkActive]=\"'current-page'\" class=\"profile-sidebar-link\" [routerLink]=\"['profile']\">Personal Profile</p>\r\n            </div>\r\n          </div>\r\n          <div class=\"page-content-right\">\r\n            <router-outlet></router-outlet>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 707 */
/***/ (function(module, exports) {

module.exports = ".page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 457px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 40px 60px;\n  width: 100%;\n  padding-bottom: 200px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-full {\n    vertical-align: top; }\n    .page-content .page-content-full p, .page-content .page-content-full li, .page-content .page-content-full div, .page-content .page-content-full label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-right {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-left: 50px;\n    vertical-align: top;\n    border-left: 1px solid #e3e3e3; }\n    .page-content .page-content-right p, .page-content .page-content-right li, .page-content .page-content-right div, .page-content .page-content-right label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n  .page-content .page-content-sidebar-left {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-left p, .page-content .page-content-sidebar-left li, .page-content .page-content-sidebar-left div, .page-content .page-content-sidebar-left .btn, .page-content .page-content-sidebar-left label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-left .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-left .sidebar-section:first-of-type {\n      margin-top: 0; }\n  .page-content .account-sidebar-link {\n    background-image: url(../../img/account-avatar.svg);\n    background-image: url(../../img/account-avatar.png);\n    background-repeat: no-repeat;\n    background-position: 0 50%;\n    background-size: auto 24px;\n    padding-left: 30px;\n    cursor: pointer; }\n    .page-content .account-sidebar-link.current-page {\n      text-decoration: underline; }\n  .page-content .billing-sidebar-link {\n    background-image: url(../../img/billing-history.svg);\n    background-image: url(../../img/billing-history.png);\n    background-repeat: no-repeat;\n    background-position: 0 50%;\n    background-size: auto 24px;\n    padding-left: 30px;\n    cursor: pointer; }\n    .page-content .billing-sidebar-link.current-page {\n      text-decoration: underline; }\n  .page-content .favorites-sidebar-link {\n    background-image: url(../../img/star-dark.svg);\n    background-image: url(../../img/star-dark.png);\n    background-repeat: no-repeat;\n    background-position: 0 50%;\n    background-size: auto 24px;\n    padding-left: 30px;\n    cursor: pointer; }\n    .page-content .favorites-sidebar-link.current-page {\n      text-decoration: underline; }\n  .page-content .data-by-email-sidebar-link {\n    background-image: url(../../img/databyemail.svg);\n    background-image: url(../../img/databyemail.png);\n    background-repeat: no-repeat;\n    background-position: 0 50%;\n    background-size: auto 13px;\n    padding-left: 30px;\n    cursor: pointer; }\n    .page-content .data-by-email-sidebar-link.current-page {\n      text-decoration: underline; }\n  .page-content .profile-sidebar-link {\n    background-image: url(../../img/account-profile.svg);\n    background-image: url(../../img/account-profile.png);\n    background-repeat: no-repeat;\n    background-position: 0 50%;\n    background-size: auto 24px;\n    padding-left: 30px;\n    cursor: pointer; }\n    .page-content .profile-sidebar-link.current-page {\n      text-decoration: underline; }\n\n.trial-banner {\n  background: #2798d8;\n  margin-bottom: 25px;\n  padding: 10px 25px;\n  border-radius: 5px;\n  color: #fff; }\n  .trial-banner p {\n    line-height: 28px; }\n  .trial-banner h6 {\n    color: #ffffff;\n    line-height: 36px; }\n  .trial-banner a {\n    color: #ffffff; }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-right {\n    display: inline-block;\n    width: 100%;\n    padding-left: 0;\n    border-left: none; }\n  .page-content .page-content-sidebar-right {\n    width: 100%;\n    border-top: 1px solid #e3e3e3;\n    margin-top: 25px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; }\n  .page-content .page-content-sidebar-left {\n    width: 100%;\n    border-bottom: 1px solid #e3e3e3;\n    margin-bottom: 25px;\n    padding-bottom: 25px; }\n    .page-content .page-content-sidebar-left .sidebar-section {\n      margin-top: 0; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n    .page-content .page-top-content {\n      padding-top: 0; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var my_favorites_service_1 = __webpack_require__(709);
var MyFavoritesComponent = (function () {
    function MyFavoritesComponent(service) {
        this.service = service;
        this.vessels = new Array();
        this.ports = new Array();
        this.carriers = new Array();
        this.routes = new Array();
        this.startDate = '';
        this.endDate = '';
    }
    MyFavoritesComponent.prototype.ngOnInit = function () {
        this.startDate = this.service.getStartDate();
        this.endDate = this.service.getEndDate();
        this.carriers = this.service.getCarriers();
        this.ports = this.service.getPorts();
        this.vessels = this.service.getVessels();
        this.routes = this.service.getRoutes();
    };
    MyFavoritesComponent.prototype.hasFavorites = function () {
        return this.carriers.length > 0 || this.ports.length > 0 || this.vessels.length > 0 || this.routes.length > 0;
    };
    MyFavoritesComponent.prototype.unfavoriteRoute = function (originId, destinationId) {
        var _this = this;
        this.service.callUnFavoriteRoute(originId, destinationId).then(function (result) {
            _this.removeRoute(originId, destinationId);
        });
    };
    MyFavoritesComponent.prototype.removeRoute = function (originId, destinationId) {
        for (var current = 0; current < this.routes.length; current++) {
            if (this.routes[current].originId === originId && this.routes[current].destinationId === destinationId) {
                this.routes.splice(current, 1);
            }
        }
        this.service.app.routes = this.routes;
        localStorage.setItem('favoriteRoutes', JSON.stringify(this.routes));
    };
    MyFavoritesComponent = __decorate([
        core_1.Component({
            selector: 'my-favorites',
            template: __webpack_require__(710),
            styles: [__webpack_require__(711)],
            providers: [my_favorites_service_1.MyFavoritesService]
        }),
        __metadata("design:paramtypes", [my_favorites_service_1.MyFavoritesService])
    ], MyFavoritesComponent);
    return MyFavoritesComponent;
}());
exports.MyFavoritesComponent = MyFavoritesComponent;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var MyFavoritesService = (function () {
    function MyFavoritesService(favoriteService, app) {
        this.favoriteService = favoriteService;
        this.app = app;
    }
    MyFavoritesService.prototype.getStartDate = function () {
        var now = moment();
        return encodeURIComponent(now.format('YYYY-MM-DD'));
    };
    MyFavoritesService.prototype.getEndDate = function () {
        var now = moment();
        return encodeURIComponent(now.add(1, 'week').format('YYYY-MM-DD'));
    };
    MyFavoritesService.prototype.getCarriers = function () {
        var carriers = new Array();
        try {
            return this.app.carriers;
        }
        catch (ex) {
            return carriers;
        }
    };
    MyFavoritesService.prototype.getPorts = function () {
        var ports = new Array();
        try {
            return this.app.ports;
        }
        catch (ex) {
            return ports;
        }
    };
    MyFavoritesService.prototype.getVessels = function () {
        var vessels = new Array();
        try {
            return this.app.vessels;
        }
        catch (ex) {
            return vessels;
        }
    };
    MyFavoritesService.prototype.getRoutes = function () {
        var routes = new Array();
        try {
            return this.app.routes;
        }
        catch (ex) {
            return routes;
        }
    };
    MyFavoritesService.prototype.callUnFavoriteRoute = function (originId, destinationId) {
        return this.favoriteService.unfavoriteRoute(originId, destinationId);
    };
    MyFavoritesService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.FavoriteService, shared_1.AppContext])
    ], MyFavoritesService);
    return MyFavoritesService;
}());
exports.MyFavoritesService = MyFavoritesService;


/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = "<h2 class=\"mb15\">Favorites</h2>\r\n<p *ngIf=\"!hasFavorites()\">You don't currently have any favorites.  Favorite some of your most searched routes, vessels, ports, or carriers to easily access them here.</p>\r\n<p *ngIf=\"routes.length !== 0\"><b>Routes</b></p>\r\n<ul *ngFor=\"let route of routes\">\r\n  <div style=\"line-height: 24px; margin-bottom: 15px;\">\r\n    <span class=\"route-img\"><img src=\"../../img/routesave-01.png\"></span>\r\n    <a [routerLink]=\"['/schedules', { origin_search: route.originName, origin_id: route.originId, destination_search: route.destinationName, destination_id: route.destinationId, start_date_gte: startDate, start_date_lte: endDate }]\">{{ route.originName }} &#8594; {{ route.destinationName }}</a>\r\n    <a class=\"delete-close\" onclick=\"favoriteRouteDeletingSpinningAnimationStart(this);\" (click)=\"unfavoriteRoute(route.originId, route.destinationId)\"> x </a>\r\n  </div>\r\n</ul>\r\n<p *ngIf=\"vessels.length !== 0\"><b>Vessels</b></p>\r\n<ul *ngFor=\"let vessel of vessels\">\r\n  <div>\r\n    <span class=\"favorite-star\"><img [favorite]=\"vessel\" [itemtype]=\"'vessel'\"></span>\r\n    <a [routerLink]=\"['/vessels', vessel.id, {scroll:true}]\">{{ vessel.name }}</a>\r\n  </div>\r\n</ul>\r\n<p *ngIf=\"ports.length !== 0\"><b>Ports</b></p>\r\n<ul *ngFor=\"let port of ports\">\r\n  <div>\r\n    <span class=\"favorite-star\"><img [favorite]=\"port\" [itemtype]=\"'port'\"></span>\r\n    <a [routerLink]=\"['/ports', port.id, {scroll:true}]\">{{ port.display }}</a>\r\n  </div>\r\n</ul>\r\n<p *ngIf=\"carriers.length !== 0\"><b>Carriers</b></p>\r\n<ul *ngFor=\"let carrier of carriers\">\r\n  <div>\r\n    <span class=\"favorite-star\"><img [favorite]=\"carrier\" [itemtype]=\"'carrier'\"></span>\r\n    <a [routerLink]=\"['/carriers', carrier.id, {scroll:true}]\">{{ carrier.name }}</a>\r\n  </div>\r\n</ul>"

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = ".route-img img {\n  height: 24px;\n  vertical-align: sub;\n  margin-right: 5px; }\n\nul {\n  margin-top: 5px;\n  margin-bottom: 5px; }\n\n.saved-routes-line {\n  display: block;\n  height: 1px;\n  width: 80%;\n  margin: auto;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  background: #d4d4d4; }\n\n.delete-close {\n  position: absolute;\n  display: inline-block;\n  background: #f0f0f0;\n  width: 22px;\n  height: 22px;\n  line-height: 20px;\n  text-align: center;\n  border-radius: 50%;\n  color: #353535;\n  margin-left: 20px; }\n"

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var account_information_service_1 = __webpack_require__(713);
var status_1 = __webpack_require__(95);
var AccountInformationComponent = (function () {
    function AccountInformationComponent(service) {
        this.service = service;
        this.showUpdateCard = false;
        this.showUpdatePlan = false;
        this.Status = status_1.Status;
    }
    AccountInformationComponent.prototype.ngOnInit = function () {
        this.getCustomerInfo();
    };
    AccountInformationComponent.prototype.getCustomerInfo = function () {
        var _this = this;
        this.status = status_1.Status.Loading;
        this.service.getCustomer()
            .then(this.displayCustomerInfo.bind(this))
            .catch(function (err) {
            _this.status = status_1.Status.Error;
        });
    };
    AccountInformationComponent.prototype.displayCustomerInfo = function (customer) {
        this.status = status_1.Status.Loaded;
    };
    AccountInformationComponent.prototype.openUpdateCard = function () {
        this.showUpdateCard = true;
    };
    AccountInformationComponent.prototype.closeUpdateCard = function () {
        this.showUpdateCard = false;
        this.getCustomerInfo();
    };
    AccountInformationComponent.prototype.openUpdatePlan = function () {
        this.showUpdatePlan = true;
    };
    AccountInformationComponent.prototype.closeUpdatePlan = function () {
        this.showUpdatePlan = false;
        this.getCustomerInfo();
    };
    AccountInformationComponent.prototype.closeCancelPopup = function () {
        this.service.showCancel = false;
        this.service.cancelSuccess = false;
        this.service.status = '';
        this.ngOnInit();
    };
    AccountInformationComponent = __decorate([
        core_1.Component({
            selector: 'account-information',
            template: __webpack_require__(714),
            styles: [__webpack_require__(715)],
            providers: [account_information_service_1.AccountInformationService]
        }),
        __metadata("design:paramtypes", [account_information_service_1.AccountInformationService])
    ], AccountInformationComponent);
    return AccountInformationComponent;
}());
exports.AccountInformationComponent = AccountInformationComponent;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var AccountInformationService = (function () {
    function AccountInformationService(api, auth, app, logger, billing, user) {
        this.api = api;
        this.auth = auth;
        this.app = app;
        this.logger = logger;
        this.billing = billing;
        this.user = user;
        this.oldPassword = '';
        this.newPassword = '';
        this.confirmNewPassword = '';
        this.confirmError = '';
        this.newPasswordErrorLength = '';
        this.newPasswordErrorReg = '';
        this.newPasswordError = '';
        this.showChangePassword = false;
        this.showCardDetails = false;
        this.showPlanDetails = false;
        this.showTrialDetails = false;
        this.submitted = false;
        this.showCancel = false;
        this.status = '';
        this.cancelSuccess = false;
        this.errors = {
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            update: '',
            updateErrors: '',
            oldPasswordErrors: ''
        };
        this.planName = '';
        this.billingPeriod = '';
        this.lastFour = '';
        // charge: string = '';
        this.trialEnd = '';
        this.passwordOkay = false;
    }
    AccountInformationService.prototype.getCustomer = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.billing.getCustomer().then(function (customer) {
                if (customer.sources.length > 0) {
                    _this.lastFour = customer.sources[0].lastFour;
                    _this.showCardDetails = true;
                }
                else {
                    _this.showCardDetails = false;
                }
                if (customer.subscriptions.length > 0) {
                    _this.planName = customer.subscriptions[0].plan.name;
                    _this.billingPeriod = customer.subscriptions[0].plan.interval == 'month' ? 'Monthly' : 'Yearly';
                    _this.showPlanDetails = true;
                    if (customer.subscriptions[0].status == 'trialing') {
                        _this.trialEnd = moment.unix(customer.subscriptions[0].trialEnd).format('YYYY-MM-DD');
                        _this.showTrialDetails = true;
                    }
                    else {
                        _this.showTrialDetails = false;
                    }
                }
                else {
                    _this.showPlanDetails = false;
                    _this.showTrialDetails = false;
                }
                resolve(customer);
            }).catch(function (err) {
                reject(err);
            });
        });
    };
    AccountInformationService.prototype.toggleChangePassword = function () {
        this.showChangePassword = !this.showChangePassword;
    };
    AccountInformationService.prototype.changePassword = function () {
        var _this = this;
        this.submitted = true;
        this.errors.update = '';
        this.errors.updateErrors = '';
        this.errors.oldPasswordErrors = '';
        if (this.passwordOkay) {
            this.logger.log('account-information.service', 'changePassword', 'before promise');
            this.auth.changePassword(this.oldPassword, this.newPassword).then(function (result) {
                _this.logger.log('account-information.service', 'changePassword result', result);
                _this.errors.update = 'Password Changed';
                _this.showChangePassword = false;
            }).catch(function (err) {
                _this.logger.log('account-information.service', 'changePassword err', err);
                if (err = 'Error: Incorrect username or password.') {
                    _this.errors.oldPasswordErrors = 'Password Incorrect';
                }
                else {
                    _this.errors.updateErrors = 'something went wrong. please try again';
                }
            });
        }
    };
    AccountInformationService.prototype.validateOldPassword = function () {
    };
    AccountInformationService.prototype.validateNewPassword = function () {
        var PASSWORD_REGEXP = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^$*.\[\]{}()?-“!@#%&\/,><‘:;|_~`]).*$/;
        this.passwordOkay = true;
        this.newPasswordErrorLength = '';
        this.newPasswordErrorReg = '';
        this.newPasswordError = '';
        if (!PASSWORD_REGEXP.test(this.newPassword)) {
            this.passwordOkay = false;
            // this.newPasswordErrorReg = 'Passwords must be at least 8 characters and contain one uppercase letter,
            // one lowercase letter, one numeral, and one special character';
            this.newPasswordError = 'Invalid Password';
        }
        if (this.newPassword.length < 8) {
            this.passwordOkay = false;
            // this.newPasswordErrorLength = 'Password must be at least 8 characters';
            this.newPasswordError = 'Invalid Password';
        }
        if (this.newPassword.length > 99) {
            this.passwordOkay = false;
            // this.newPasswordErrorLength = 'Password is too long';
            this.newPasswordError = 'Invalid Password';
        }
    };
    AccountInformationService.prototype.validateConfirmPassword = function () {
        this.passwordOkay = true;
        this.confirmError = '';
        if (this.newPassword !== this.confirmNewPassword) {
            this.passwordOkay = false;
            this.confirmError = 'Passwords must match';
        }
    };
    AccountInformationService.prototype.toggleCancel = function () {
        this.showCancel = !this.showCancel;
    };
    // close() {
    //   this.showCancel = false;
    //   this.cancelSuccess = false;
    //   this.status = '';
    //   this.service.close();
    //   this.onClose.emit(true);
    // }
    AccountInformationService.prototype.cancelPlan = function () {
        var _this = this;
        if (this.status === 'sending...') {
            return;
        }
        this.status = 'sending...';
        this.cancelSuccess = false;
        this.billing.cancel()
            .then(function (result) {
            _this.logger.log('update-plan.service', 'cancelPlan success', result);
            _this.user.getProfile();
            _this.app.setAccountType('Basic');
            _this.app.plan.interval = '';
            _this.cancelSuccess = true;
            _this.status = 'success';
        }).catch(function (err) {
            _this.logger.log('update-plan.service', 'cancelPlan error', err);
            _this.status = 'error';
            _this.cancelSuccess = false;
        });
    };
    AccountInformationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AuthService, shared_1.AppContext,
            shared_1.LogService, shared_1.BillingService, shared_1.UserService])
    ], AccountInformationService);
    return AccountInformationService;
}());
exports.AccountInformationService = AccountInformationService;


/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = "<h2 class=\"mb15\">Account Information</h2>\r\n<h4 class=\"mb10\">\r\n  Plan Information<span *ngIf=\"status == Status.Loading\" class=\"mini-loader\"></span>\r\n</h4>\r\n<div *ngIf=\"status == Status.Loaded\">\r\n  <div *ngIf=\"service.showTrialDetails\">\r\n    <p><b>Trial Ends:</b> {{ service.trialEnd }}</p>\r\n  </div>\r\n  <p><b>Account Type:</b> {{ service.app.accountType }}</p>\r\n  <div *ngIf=\"service.showPlanDetails\">\r\n    <p><b>Plan Name:</b> {{ service.planName }}\r\n    <p><b>Billing Period:</b> {{ service.billingPeriod }}</p>\r\n  </div>\r\n  <div *ngIf=\"service.app.isSubEnterprise == true\">\r\n    <p><b>Plan Name:</b> Sub-Enterprise</p>\r\n  </div>\r\n  <div *ngIf=\"service.showCardDetails\">\r\n    <p><b>Last 4 Card Digits:</b> {{ service.lastFour }}</p>\r\n  </div>\r\n  <p *ngIf=\"!service.app.isCustomer\"><i>To upgrade your account, please add a credit card.</i></p>\r\n  <button (click)=\"openUpdateCard()\" class=\"btn btn-blue mb10 center\"><span *ngIf=\"!service.app.isCustomer\">Add Credit Card</span><span *ngIf=\"service.app.isCustomer\">Change your credit card</span></button><br>\r\n  <button (click)=\"openUpdatePlan()\" class=\"btn mb10 center\"><span *ngIf=\"!service.app.isCustomer\">Subscribe to a Plan</span><span *ngIf=\"service.app.isCustomer\">Change your plan</span></button><br>\r\n  <button (click)=\"service.toggleCancel()\" *ngIf=\"service.app.isCustomer && service.app.accountType !== 'Basic'\" class=\"btn center\" style=\"background: gray;\"><span>Cancel your subscription</span></button>\r\n</div>\r\n\r\n<div class=\"confirm-popup\" *ngIf=\"service.showCancel\">\r\n  <a class=\"close\" (click)=\"closeCancelPopup()\">&times;</a>\r\n  <div *ngIf=\"!service.cancelSuccess\">\r\n      <h6 class=\"text-center mt10 mb15\">Are you sure you want to cancel your subscription?</h6>\r\n      <p>If you cancel, your paid subscription to Linescape will be terminated and your account will revert to a free 'Basic' plan. Your card will no longer be charged.</p>\r\n      <br />\r\n      <a (click)=\"service.cancelPlan()\" class=\"btn btn-wide mb5\">Yes, cancel my subscription</a>\r\n      <a (click)=\"service.toggleCancel()\" class=\"btn-wide btn-blue\">No, do not cancel my subscription</a>\r\n      <br />\r\n      <p><span *ngIf=\"service.status === 'error'\">Something went wrong. Please contact Linescape for support.</span></p>\r\n  </div>\r\n  <div *ngIf=\"service.cancelSuccess\">\r\n    <p class=\"mt15\">We are sorry to see you go!</p>\r\n    <br />\r\n    <p>Please contact <a href=\"mailto:marketing@linescape.com\">marketing@linescape.com</a> with any suggestions you may have for improving our service.<p>\r\n  </div>\r\n  <p *ngIf=\"service.status === 'sending...'\">Canceling Plan<span class=\"sending-loader\"><span class=\"ellipse-1\">. </span><span class=\"ellipse-2\">. </span><span class=\"ellipse-3\"> .</span></span></p>\r\n</div>\r\n\r\n<h4 class=\"mb15 mt15\">Login Information</h4>\r\n<div class=\"mb60\">\r\n  <p><b>Email Address</b></p>\r\n  <p class=\"mb15\">{{ service.app.email }}</p>\r\n  <p><b>Password</b> <span (click)=\"service.toggleChangePassword()\" class=\"underline pointer\">edit</span></p>\r\n  <div *ngIf=\"service.showChangePassword\">\r\n    <input [class.error-input]=\"service.errors.oldPasswordErrors && service.submitted\" [(ngModel)]=\"service.oldPassword\" (ngModelChange)=\"service.validateOldPassword()\" placeholder=\"Old Password\" type=\"password\"/><span class=\"error-2\" *ngIf=\"service.errors.oldPasswordErrors\">{{ service.errors.oldPasswordErrors }}</span><br>\r\n    <input [class.error-input]=\"service.newPasswordError && service.submitted\" title='Passwords must be at least 8 characters and contain one uppercase letter, one lowercase letter, one numeral, and one special character' [(ngModel)]=\"service.newPassword\" (ngModelChange)=\"service.validateNewPassword()\" placeholder=\"New Password\" type=\"password\"/>\r\n    <span class=\"error-2\" *ngIf=\"service.newPasswordError && service.submitted\">{{ service.newPasswordError }}<img class=\"info-icon\" title='Passwords must be at least 8 characters and contain one uppercase letter, one lowercase letter, one numeral, and one special character' src=\"../img/information.svg\" onerror=\"this.onerror=null; this.src='../img/information.png'\"></span><br>\r\n    <input [class.error-input]=\"service.confirmError && service.submitted\" title='Passwords must be at least 8 characters and contain one uppercase letter, one lowercase letter, one numeral, and one special character' [(ngModel)]=\"service.confirmNewPassword\" (ngModelChange)=\"service.validateConfirmPassword()\" placeholder=\"Confirm Password\" type=\"password\"/>\r\n    <span class=\"error-2\" *ngIf=\"service.confirmError && service.submitted\">{{ service.confirmError }}</span><br>\r\n    <button class=\"change-password-button\" (click)=\"service.changePassword()\" class=\"btn mb10 center\">Change your password</button>\r\n    <p *ngIf=\"service.errors.updateErrors\" class=\"error\">{{ service.errors.updateErrors }}</p>\r\n  </div>\r\n  <p *ngIf=\"!service.showChangePassword\" class=\"mb15\">********</p>\r\n  <p class=\"success\" *ngIf=\"service.errors.update\"><img class=\"success-check\" src=\"../img/check-sign.svg\" onerror=\"this.onerror=null; this.src='../img/check-sign.png'\">{{ service.errors.update }}</p>\r\n\r\n  <p class=\"mt60\"><i>If you would like to close your account and have your account information permanently deleted, please <a [routerLink]=\"['/contact', {scroll: true}]\">Contact Us</a> to request an account deletion.</i></p>\r\n</div>\r\n\r\n<update-card [display]=\"showUpdateCard\" (onClose)=\"closeUpdateCard()\">loading...</update-card>\r\n<update-plan [display]=\"showUpdatePlan\" (onClose)=\"closeUpdatePlan()\">loading...</update-plan>"

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports = ".underline {\n  text-decoration: underline; }\n\n.btn {\n  width: 250px; }\n\n.btn-wide {\n  width: 300px; }\n\n.btn-gray {\n  background: #686868;\n  color: #484848; }\n\n.error {\n  color: #353535;\n  margin-bottom: 5px;\n  border: 1px solid #dd0000;\n  background: #ffaaaa;\n  width: 250px; }\n\n.error-input {\n  outline: 1px solid red; }\n\n.error-2 {\n  color: red;\n  white-space: nowrap;\n  display: inline-block;\n  padding-left: 5px; }\n\n.close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  line-height: 7px;\n  font-size: 24px;\n  color: #353535;\n  cursor: pointer; }\n  .close:hover {\n    color: #1c1c1c; }\n\n.confirm-popup {\n  background-color: #fafafa;\n  position: fixed;\n  left: calc(50% - 200px);\n  width: 500px;\n  padding: 20px;\n  text-align: center;\n  z-index: 40;\n  border-radius: 3px;\n  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.43);\n  top: 194px;\n  max-height: calc(100vh - 120px);\n  overflow-y: auto;\n  visibility: visible;\n  border: 1px solid #c4c4c4; }\n  .confirm-popup .close {\n    right: 7px;\n    top: 7px; }\n\n/*.success {\r\n    margin-bottom: 5px;\r\n    animation: savedAnimation 1.75s linear forwards 1;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    width: 229px; \r\n    text-align: center;\r\n    border-radius: 3px;\r\n}*/\n\n@keyframes savedAnimation {\n  from {\n    background: forestgreen;\n    border-color: #117310;\n    color: #353535;\n    visibility: visible; }\n  to {\n    background: transparent;\n    border-color: transparent;\n    color: transparent;\n    visibility: transparent; } }\n"

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var invoices_service_1 = __webpack_require__(717);
var InvoicesComponent = (function () {
    function InvoicesComponent(service) {
        this.service = service;
    }
    InvoicesComponent.prototype.ngOnInit = function () {
        this.service.loaderOn = true;
    };
    InvoicesComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(718),
            styles: [__webpack_require__(719)],
            providers: [invoices_service_1.InvoicesService]
        }),
        __metadata("design:paramtypes", [invoices_service_1.InvoicesService])
    ], InvoicesComponent);
    return InvoicesComponent;
}());
exports.InvoicesComponent = InvoicesComponent;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var InvoicesService = (function () {
    function InvoicesService(api, app, billing) {
        this.api = api;
        this.app = app;
        this.billing = billing;
        this.invoices = new Array();
        this.loaderOn = true;
        this.getInvoices();
    }
    InvoicesService.prototype.getInvoices = function () {
        var _this = this;
        this.billing.getInvoices().then(function (result) {
            _this.invoices = result;
            _this.loaderOn = false;
        }).catch(function (err) {
            _this.api.handleError(err);
            _this.loaderOn = false;
        });
    };
    InvoicesService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AppContext, shared_1.BillingService])
    ], InvoicesService);
    return InvoicesService;
}());
exports.InvoicesService = InvoicesService;


/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = "<h2 class=\"mb15\">Billing History<span *ngIf=\"service.loaderOn\" class=\"mini-loader\"></span></h2>\r\n\r\n<div *ngIf=\"!service.loaderOn\" class=\"invoice-table\">\r\n  <div class=\"header-col\">\r\n    <div class=\"col1\">Date</div>\r\n    <div class=\"col2\">Amount</div>\r\n    <div class=\"col3\">Description</div>\r\n    <div class=\"col4\">Invoice Id</div>\r\n  </div>\r\n  <div *ngIf=\"service.invoices.length !== 0\" >\r\n    <div class=\"results-row\" *ngFor=\"let item of service.invoices\">\r\n      <div class=\"col1\"><p class=\"table-rep-header\"><b>Date</b></p>{{ item.date }}</div>\r\n      <div class=\"col2\"><p class=\"table-rep-header\"><b>Amount</b></p>{{ item.amount }}</div>\r\n      <div class=\"col3\"><p class=\"table-rep-header\"><b>Description</b></p>{{ item.description }}</div>\r\n      <div class=\"col4\"><p class=\"table-rep-header\"><b>Invoice Id</b></p>{{ item.id }}</div>\r\n    </div>\r\n  </div>\r\n  <div style=\"background: #ffffff;\" *ngIf=\"service.invoices.length === 0\" class=\"results-row\">\r\n    <p>No billing history found</p>\r\n  </div>\r\n</div>"

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = ".invoice-table {\n  margin-bottom: 20px;\n  border: 1px solid #a5a5a5; }\n  .invoice-table .header-col {\n    width: 100%;\n    background: #f0f0f0;\n    margin-bottom: 0;\n    padding: 10px 10px;\n    font-size: 0;\n    border-bottom: 1px solid #a5a5a5; }\n    .invoice-table .header-col div {\n      vertical-align: top;\n      font-weight: bold;\n      font-size: 16px; }\n  .invoice-table .results-row {\n    padding: 10px;\n    font-size: 0;\n    background: #ffffff; }\n    .invoice-table .results-row:nth-of-type(2n) {\n      background: #f0f0f0; }\n    .invoice-table .results-row div {\n      vertical-align: top;\n      font-size: 16px; }\n    .invoice-table .results-row .table-rep-header {\n      display: none; }\n  .invoice-table .col1, .invoice-table .col2, .invoice-table .col3, .invoice-table .col4, .invoice-table .col5 {\n    display: inline-block;\n    padding-left: 3px;\n    padding-right: 3px;\n    text-align: center;\n    word-break: break-word;\n    overflow-wrap: break-word; }\n  .invoice-table .col1 {\n    width: 15%; }\n  .invoice-table .col2 {\n    width: 10%; }\n  .invoice-table .col3 {\n    width: 25%; }\n  .invoice-table .col4 {\n    width: 50%; }\n\n@media only screen and (max-width: 699px) {\n  .invoice-table .results-row {\n    border-bottom: 1px solid #a5a5a5; }\n    .invoice-table .results-row:nth-last-of-type() {\n      border-bottom: none; }\n    .invoice-table .results-row .table-rep-header {\n      display: block; }\n  .invoice-table .col1, .invoice-table .col2, .invoice-table .col3, .invoice-table .col4, .invoice-table .col5 {\n    width: 100%;\n    margin-bottom: 10px;\n    line-height: 18px;\n    text-align: center; }\n  .invoice-table .header-col {\n    display: none; } }\n"

/***/ }),
/* 720 */
/***/ (function(module, exports) {

module.exports = "<h2 class=\"mb15\">Personal Profile</h2>\r\n<personal-information (onSave)=\"doNothing()\">loading...</personal-information>"

/***/ }),
/* 721 */
/***/ (function(module, exports) {

module.exports = ".error {\n  margin-top: -4px; }\n\np {\n  text-align: left; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\n.line-div {\n  display: block;\n  height: 1px;\n  width: 80%;\n  margin: auto;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  background: #d4d4d4; }\n\ninput,\n.btn {\n  width: 100%; }\n\nselect {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  line-height: 24px;\n  text-align: left;\n  margin-top: 5px; }\n\n.underline {\n  text-decoration: underline; }\n"

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var EmailDeliveryService = (function () {
    function EmailDeliveryService(api, logger, app, renderer) {
        this.api = api;
        this.logger = logger;
        this.app = app;
        this.renderer = renderer;
        this.emailSchedules = new Array();
        this.loaderOn = false;
        this.getEmailSchedules();
    }
    EmailDeliveryService.prototype.update = function (oldSchedule, newSchedule) {
        try {
            for (var current = 0; current < this.emailSchedules.length; current++) {
                if (this.emailSchedules[current].id === oldSchedule.id) {
                    this.emailSchedules[current] = newSchedule;
                }
            }
        }
        catch (ex) {
            this.logger.log('email-delivery.service', 'update catch', ex);
        }
    };
    EmailDeliveryService.prototype.add = function () {
        if (this.emailSchedules.length < this.app.maxSchedules) {
            this.emailSchedules.push({
                id: this.emailSchedules.length,
                type: 'portPair',
                originPort: {
                    id: 0,
                    name: ''
                },
                destinationPort: {
                    id: 0,
                    name: ''
                }
            });
        }
    };
    EmailDeliveryService.prototype.getEmailSchedules = function () {
        var _this = this;
        this.loaderOn = true;
        this.api.getApiClient().then(function (client) { return _this.callGetEmailSchedules(client); });
    };
    EmailDeliveryService.prototype.callGetEmailSchedules = function (apigClient) {
        var _this = this;
        this.logger.log('email-delivery.service', 'callGetEmailSchedules', 'hello');
        var params = {};
        var body = {};
        var additionalParams = { headers: { 'Content-Type': 'application/json' } };
        try {
            apigClient.userEmailDeliverySchedulesGet(params, body, additionalParams)
                .then(function (result) {
                _this.logger.log('email-delivery.service', 'result', result);
                _this.loaderOn = false;
                if (result !== null && result.data !== null) {
                    _this.emailSchedules = result.data;
                }
            }).catch(function (err) {
                _this.api.handleError(err);
                _this.loaderOn = false;
                _this.app.showMessage('Network Error', 'Please refresh the page to try again. If this issue persists, please contact our support');
            });
        }
        catch (ex) {
            this.loaderOn = false;
            this.app.showMessage('Network Error', 'Please refresh the page to try again. If this issue persists, please contact our support');
        }
    };
    EmailDeliveryService.prototype.delete = function (el, scheduleId) {
        var _this = this;
        this.renderer.setElementClass(el, 'loading', true);
        this.api.getApiClient().then(function (client) { return _this.callDelete(client, scheduleId); })
            .then(function (result) {
            _this.logger.log('email-delivery.service', 'delete successful', result);
            _this.renderer.setElementClass(el, 'loading', false);
            for (var current = 0; current < _this.emailSchedules.length; current++) {
                if (_this.emailSchedules[current].id === scheduleId) {
                    _this.emailSchedules.splice(current, 1);
                }
            }
        })
            .catch(function (err) {
            _this.renderer.setElementClass(el, 'loading', false);
        });
    };
    EmailDeliveryService.prototype.callDelete = function (apigClient, scheduleId) {
        var _this = this;
        this.logger.log('email-schedule.service', 'callDelete', scheduleId);
        return new Promise(function (resolve, reject) {
            var params = {
                scheduleId: scheduleId
            };
            var body = {
                scheduleId: scheduleId
            };
            var additionalParams = { headers: { 'Content-Type': 'application/json' } };
            try {
                apigClient.userEmailDeliverySchedulesScheduleIdDelete(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('email-schedule.service', 'delete result', result);
                    resolve(result);
                }).catch(function (err) {
                    _this.api.handleError(err);
                    reject(err);
                });
            }
            catch (ex) {
                reject(ex);
            }
        });
    };
    EmailDeliveryService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.LogService, shared_1.AppContext, core_1.Renderer])
    ], EmailDeliveryService);
    return EmailDeliveryService;
}());
exports.EmailDeliveryService = EmailDeliveryService;


/***/ }),
/* 723 */
/***/ (function(module, exports) {

module.exports = "\r\n<div *ngIf=\"service.app.accountType !== '' && service.app.accountType !== 'Basic'\">\r\n  <div class=\"col-holder\">\r\n    <div class=\"page-content-left\">\r\n      <h3 class=\"mt0 mb0\">Schedules<span *ngIf=\"service.loaderOn\" class=\"schedules-loader\"></span></h3>\r\n      <div class=\"line-row\">\r\n        <div class=\"line-col\" *ngIf=\"service.emailSchedules.length === 0\">You have enabled {{ service.emailSchedules.length }}/{{ service.app.maxSchedules }} schedules. </div>\r\n        <div class=\"line-col\" style=\"padding-left: 20px;\">\r\n          <a *ngIf=\"service.emailSchedules.length === 0\" (click)=\"service.add()\" class=\"btn mt15\">Add a Schedule</a>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"service.emailSchedules.length !== 0\">\r\n        <div #scheduleContainer class=\"email-delivery-section\" *ngFor=\"let schedule of service.emailSchedules\">\r\n            <email-schedule [delivery]=\"schedule\" (status)=\"setClass(scheduleContainer, $event)\" (scheduleChange)=\"setSchedule(schedule, $event)\">loading...</email-schedule>\r\n            <a (click)=\"delete($event, schedule)\" class=\"email-delivery-close\">&times;</a>\r\n        </div>\r\n        <div style=\"padding: 15px;\" class=\"email-delivery-section\">\r\n          <a *ngIf=\"service.emailSchedules.length !== service.app.maxSchedules\" (click)=\"service.add()\" class=\"btn mt15\">Add a Schedule</a>\r\n          <p class=\"mt15\">You have enabled {{ service.emailSchedules.length }}/{{ service.app.maxSchedules }} schedules. </p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"page-content-sidebar-right\">\r\n      <div class=\"sidebar-section\">\r\n        <h3 class=\"mt15 mb0\">Delivery</h3>\r\n        <email-settings>loading...</email-settings>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"service.app.accountType === 'Basic'\">\r\n  <div>\r\n    <p>Data by Email is an easy to use “mini data feed” of sailing schedules designed for users who do not require vast amounts of data, or do not wish to implement a full-scale data feed integration. Data by Email is available for both Premium and Professional subscribers, and allows you to choose and receive data as a CSV file delivered daily by email attachment.</p>\r\n    <p>Subscribers can choose from 3 types of formats:</p>\r\n    <ul>\r\n      <li>Schedules by origin and destination</li>\r\n      <li>Schedules by vessel name or IMO</li>\r\n      <li>Schedules by port arrivals or departures</li>\r\n    </ul>\r\n    <p>Data by Email will be sent as a CSV file attachment to the email address you specify and on the day and time of your choosing. Premium subscribers may choose up to 3 data feeds, whereas Professional subscribers may choose up to 10 data feeds.</p>\r\n    <a class=\"btn mt10\" [routerLink]=\"['/subscribe']\">UPGRADE NOW</a>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 724 */
/***/ (function(module, exports) {

module.exports = ".page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"../../img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 457px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 200px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\n.email-delivery-section {\n  border: 1px solid #c1c1c1;\n  border-bottom: none;\n  padding-right: 25px;\n  position: relative; }\n  .email-delivery-section .email-delivery-close {\n    position: absolute;\n    right: 15px;\n    top: 40%;\n    display: inline-block;\n    background: #f0f0f0;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n    text-align: center;\n    border-radius: 50%;\n    color: #353535; }\n    .email-delivery-section .email-delivery-close.loading {\n      animation: spin-little 1s linear forwards 1; }\n  .email-delivery-section.saved {\n    animation: savedAnimation 1.5s linear 1;\n    border-style: solid;\n    border-width: 1px;\n    border-color: rgba(193, 193, 193, 0.99);\n    border-right-color: rgba(193, 193, 193, 0.99);\n    border-bottom-color: transparent; }\n  .email-delivery-section.error {\n    border-color: rgba(255, 0, 0, 0.99);\n    border-width: 1px;\n    border-style: solid;\n    box-shadow: inset 0 0 6px 1px rgba(255, 0, 0, 0.7);\n    color: #353535; }\n  .email-delivery-section.saving {\n    animation: loadingAnimation 1.5s linear infinite;\n    border-style: solid;\n    border-width: 1px;\n    border-color: rgba(127, 86, 219, 0.99);\n    box-shadow: inset 0 0 6px 1px rgba(127, 86, 219, 0.7); }\n\n@keyframes savedAnimation {\n  0% {\n    border-color: rgba(34, 139, 34, 0.99);\n    box-shadow: inset 0 0 6px 1px rgba(34, 139, 34, 0.7);\n    border-width: 1px; }\n  100% {\n    border-color: rgba(193, 193, 193, 0.99);\n    box-shadow: inset 0 0 6px 1px transparent;\n    border-bottom-color: transparent;\n    border-width: 1px; } }\n\n@keyframes loadingAnimation {\n  0% {\n    border-color: rgba(127, 86, 219, 0.99);\n    box-shadow: inset 0 0 6px 1px rgba(127, 86, 219, 0.7);\n    border-width: 1px; }\n  50% {\n    border-color: #c1c1c1;\n    box-shadow: inset 0 0 6px 1px transparent;\n    border-bottom-color: transparent; }\n  0% {\n    border-color: rgba(127, 86, 219, 0.99);\n    box-shadow: inset 0 0 6px 1px rgba(127, 86, 219, 0.7);\n    border-width: 1px; } }\n\n.line-row {\n  display: table; }\n\n.line-col {\n  display: table-cell; }\n\n.email-delivery-section:first-of-type {\n  border-radius: 3px 3px 0 0; }\n\n.email-delivery-section:last-of-type {\n  border-bottom: 1px solid #c1c1c1;\n  border-radius: 0 0 3px 3px; }\n\n.schedules-loader {\n  display: inline-block;\n  width: 23px;\n  height: 23px;\n  margin: 0px;\n  margin-left: 4px;\n  border-radius: 50%;\n  border: 3px solid transparent;\n  border-top-color: #7f56db;\n  border-left-color: #7f56db;\n  animation: spin-little 1s linear infinite; }\n  .schedules-loader.white {\n    border-top-color: #ffffff;\n    border-left-color: #ffffff; }\n  .schedules-loader.visible {\n    display: block; }\n\n.mobile-screenshot {\n  display: none; }\n\n.full-width-screenshot {\n  max-width: 950px;\n  margin: auto; }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; } }\n\n@media only screen and (max-width: 860px) {\n  .full-width-screenshot {\n    display: none; }\n  .mobile-screenshot {\n    display: block; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; } }\n\n@media only screen and (max-width: 499px) {\n  .email-delivery-section {\n    padding-right: 0;\n    border-top-width: 3px; }\n  .email-delivery-section .email-delivery-close {\n    top: 15px; } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var update_card_service_1 = __webpack_require__(726);
var UpdateCardComponent = (function () {
    function UpdateCardComponent(service) {
        this.service = service;
        this.onClose = new core_1.EventEmitter();
    }
    Object.defineProperty(UpdateCardComponent.prototype, "display", {
        set: function (toDisplay) {
            this.service.show = toDisplay;
        },
        enumerable: true,
        configurable: true
    });
    UpdateCardComponent.prototype.close = function () {
        this.onClose.emit(true);
    };
    UpdateCardComponent.prototype.ngOnInit = function () {
        this.service.errors.update = '';
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], UpdateCardComponent.prototype, "display", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], UpdateCardComponent.prototype, "onClose", void 0);
    UpdateCardComponent = __decorate([
        core_1.Component({
            selector: 'update-card',
            template: __webpack_require__(727),
            styles: [__webpack_require__(728)],
            providers: [update_card_service_1.UpdateCardService]
        }),
        __metadata("design:paramtypes", [update_card_service_1.UpdateCardService])
    ], UpdateCardComponent);
    return UpdateCardComponent;
}());
exports.UpdateCardComponent = UpdateCardComponent;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var UpdateCardService = (function () {
    function UpdateCardService(api, app, logger, billing) {
        this.api = api;
        this.app = app;
        this.logger = logger;
        this.billing = billing;
        this.show = false;
        this.lastFour = '';
        this.exp = '';
        this.showEditCard = false;
        this.card = '';
        this.name = '';
        this.expiration = '';
        this.month = -1;
        this.year = -1;
        this.cvc = '';
        this.postalCode = '';
        this.loaderOn = false;
        this.stripeStatus = 0;
        this.stripeResponse = null;
        this.errors = {
            name: '',
            card: '',
            expiration: '',
            cvc: '',
            postalCode: '',
            update: ''
        };
        this.updateCardAttempted = false;
        this.cardOkay = false;
        this.init();
    }
    UpdateCardService.prototype.init = function () {
        this.getCustomer();
        this.updateCardAttempted = false;
    };
    UpdateCardService.prototype.toggleEditCard = function () {
        this.errors.update = '';
        this.showEditCard = !this.showEditCard;
    };
    UpdateCardService.prototype.getCustomer = function () {
        var _this = this;
        this.billing.getCustomer().then(function (customer) {
            _this.logger.log('update-card.service', 'getCustomer customer', customer);
            try {
                _this.lastFour = customer.sources[0].lastFour;
                _this.exp = customer.sources[0].expMonth + "/" + customer.sources[0].expYear;
            }
            catch (ex) {
                _this.lastFour = '';
                _this.exp = '';
            }
        }).catch(function (err) {
            _this.logger.log('update-card.service', 'getCustomer error', err);
        });
    };
    UpdateCardService.prototype.validateName = function () {
        var name = this.name.trim();
        if (name.length === 0 || name.length > 256) {
            return false;
        }
        this.errors.name = '';
        return true;
    };
    UpdateCardService.prototype.validateNameError = function () {
        var name = this.name.trim();
        if (name.length === 0 || name.length > 256) {
            this.errors.name = 'Card Holder\'s Name Invalid';
        }
    };
    UpdateCardService.prototype.validatePostalCode = function () {
        var code = this.postalCode.trim();
        if (code.length === 0 || code.length > 256) {
            return false;
        }
        this.errors.postalCode = '';
        return true;
    };
    UpdateCardService.prototype.validatePostalCodeError = function () {
        var code = this.postalCode.trim();
        if (code.length === 0 || code.length > 256) {
            this.errors.postalCode = 'Postal Code Invalid';
        }
    };
    UpdateCardService.prototype.validateCard = function () {
        this.stripeStatus = 0;
        if (this.card.length !== 13 && this.card.length !== 14 && this.card.length !== 15
            && this.card.length !== 16 && this.card.length !== 17 && this.card.length !== 18
            && this.card.length !== 19) {
            return false;
        }
        this.errors.card = '';
        return true;
    };
    UpdateCardService.prototype.validateCardError = function () {
        if (this.card.length !== 13 && this.card.length !== 14 && this.card.length !== 15
            && this.card.length !== 16 && this.card.length !== 17 && this.card.length !== 18
            && this.card.length !== 19) {
            this.errors.card = 'Credit Card Number Invalid';
        }
    };
    UpdateCardService.prototype.validateExpiration = function () {
        this.stripeStatus = 0;
        try {
            var exp = this.expiration.split('/');
            this.month = +exp[0];
            this.year = +exp[1];
            if (this.month <= 0 || this.month >= 13) {
                return false;
            }
            if (this.year <= 0 || this.year >= 100) {
                return false;
            }
        }
        catch (ex) {
            return false;
        }
        this.errors.expiration = '';
        return true;
    };
    UpdateCardService.prototype.validateExpirationError = function () {
        try {
            var exp = this.expiration.split('/');
            this.month = +exp[0];
            this.year = +exp[1];
            if (this.month <= 0 || this.month >= 13) {
                this.errors.expiration = 'Date Invalid';
                return false;
            }
            if (this.year <= 0 || this.year >= 100) {
                this.errors.expiration = 'Date Invalid';
                return false;
            }
        }
        catch (ex) {
            this.errors.expiration = 'Date Invalid';
            return false;
        }
        this.errors.expiration = '';
        return true;
    };
    UpdateCardService.prototype.validateCVC = function () {
        this.stripeStatus = 0;
        if (this.cvc.length !== 3 && this.cvc.length !== 4) {
            return false;
        }
        this.errors.cvc = '';
        return true;
    };
    UpdateCardService.prototype.validateCVCError = function () {
        if (this.cvc.length !== 3 && this.cvc.length !== 4) {
            this.errors.cvc = 'CVC Invalid';
        }
    };
    UpdateCardService.prototype.getToken = function () {
        var model = {
            name: this.name.trim(),
            number: +this.card,
            exp_month: this.month,
            exp_year: this.year,
            cvc: +this.cvc,
            address_zip: this.postalCode.trim()
        };
        return this.billing.createToken(model);
    };
    UpdateCardService.prototype.tokenResponse = function (status, response) {
        this.stripeStatus = status;
        this.stripeResponse = response;
        if (this.stripeStatus === 200) {
            this.cardOkay = true;
        }
        else {
            this.stripeError(response.error);
            this.cardOkay = false;
        }
    };
    UpdateCardService.prototype.stripeError = function (error) {
        try {
            if (error.param === 'number') {
                this.errors.card = error.message;
            }
            else if (error.param === 'exp_year' || error.param === 'exp_month') {
                this.errors.expiration = error.message;
            }
            else if (error.param === 'name') {
                this.errors.name = error.message;
            }
            else if (error.param === 'address_zip') {
                this.errors.name = error.message;
            }
        }
        catch (ex) {
            this.errors.update = 'Card Invalid';
        }
    };
    UpdateCardService.prototype.updateCard = function () {
        var _this = this;
        this.expirationMasking();
        this.errors.update = '';
        this.loaderOn = true;
        if (this.validateName() && this.validateCard() && this.validateExpiration() && this.validateCVC() && this.validatePostalCode()) {
            this.logger.log('update-card.service', 'getToken', 'before call');
            this.getToken().then(function (response) {
                _this.tokenResponse(200, response);
                _this.callUpdateCard();
            }).catch(function (err) {
                _this.loaderOn = false;
                _this.tokenResponse(400, err);
                _this.errors.update = err.message;
            });
            this.updateCardAttempted = true;
        }
        else {
            // card is not validated, do not create token
            this.cardOkay = false;
            this.loaderOn = false;
            this.errors.update = "Invalid card";
            this.updateCardAttempted = true;
            return;
        }
    };
    UpdateCardService.prototype.callUpdateCard = function () {
        var _this = this;
        if (!this.app.isCustomer) {
            this.billing.createCustomer(this.app.email, this.stripeResponse.id)
                .then(function (customer) {
                _this.cardUpdateSuccess(customer);
                _this.loaderOn = false;
            }).catch(function (err) {
                _this.cardUpdateFailure(err);
                _this.loaderOn = false;
            });
        }
        else {
            this.billing.updateCustomer(this.stripeResponse.id)
                .then(function (customer) {
                _this.cardUpdateSuccess(customer);
                _this.loaderOn = false;
            }).catch(function (err) {
                _this.cardUpdateFailure(err);
                _this.loaderOn = false;
            });
        }
    };
    UpdateCardService.prototype.cardUpdateSuccess = function (customer) {
        this.app.setIsCustomer('stripeId'); // just to set it to true
        this.app.setCustomer(customer);
        this.getCustomer();
        this.errors.update = 'Success';
        this.showEditCard = false;
    };
    UpdateCardService.prototype.cardUpdateFailure = function (error) {
        this.logger.log('update-card.service', 'cardUpdateFailure', error);
        try {
            this.errors.update = error.data.details.message;
        }
        catch (ex) {
            this.errors.update = 'Something went wrong';
        }
    };
    UpdateCardService.prototype.validateFrontEnd = function () {
        this.expirationMasking();
        this.errors.update = '';
        if (this.validateName() && this.validateCard() && this.validateExpiration() && this.validateCVC() && this.validatePostalCode()) {
            this.logger.log('update-card.service', 'getToken', 'before call');
            this.cardOkay = true;
        }
        else {
            this.cardOkay = false;
        }
    };
    UpdateCardService.prototype.expirationMasking = function () {
        if (this.expiration.match(/^\d{2}$/) !== null) {
            this.expiration = this.expiration + '/';
        }
    };
    UpdateCardService.prototype.numeralInputMasking = function (event) {
        var e = event || window.event;
        var key = event.keyCode || e.which;
        if ((key < 48 || key > 57) && key !== 37 && key !== 38
            && key !== 39 && key !== 40 && key !== 46
            && key !== 8 && key !== 35) {
            e.preventDefault();
        }
    };
    UpdateCardService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AppContext, shared_1.LogService, shared_1.BillingService])
    ], UpdateCardService);
    return UpdateCardService;
}());
exports.UpdateCardService = UpdateCardService;


/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"service.show\" class=\"popup-container\">\r\n    <div class=\"popup-wrapper\"></div>\r\n    <div class=\"popup\">\r\n        <a class=\"close\" (click)=\"close()\">&times;</a>\r\n        <h5>Change Your Card</h5>\r\n        <div class=\"popup-line-div\"></div>\r\n        <p><b>Credit Card Information</b>  <a (click)=\"service.toggleEditCard()\" class=\"underline\">edit</a></p>\r\n        <p>Last 4 Digits: {{ service.lastFour }}<br>\r\n        Expiration Date: {{ service.exp }}</p>\r\n        <p>{{ service.cost }}</p>\r\n        <div *ngIf=\"service.showEditCard\">\r\n            <div class=\"popup-line-div\"></div>\r\n            <input [class.error-input]=\"service.errors.name\" [(ngModel)]=\"service.name\" (ngModelChange)=\"service.validateFrontEnd()\" (blur)=\"service.validateNameError()\" id=\"name\" #name=\"ngModel\" placeholder=\"Card Holder's Name\" type=\"text\"/>\r\n            <div *ngIf=\"service.errors.name\" class=\"alert alert-danger\">\r\n                <span class=\"error\">{{ service.errors.name }}</span>\r\n            </div>\r\n            <input [class.error-input]=\"service.errors.card\" [(ngModel)]=\"service.card\" (ngModelChange)=\"service.validateFrontEnd()\" (blur)=\"service.validateCardError()\" (keypress)=\"service.numeralInputMasking($event)\" id=\"card\" #card=\"ngModel\" class=\"form-control\" placeholder=\"Credit Card Number\" type=\"text\" required pattern=\"[0-9]\"/>\r\n            <div *ngIf=\"service.errors.card\" class=\"alert alert-danger\">\r\n                <span class=\"error\">{{ service.errors.card }}</span>\r\n            </div>\r\n            <div class=\"col-holder\">\r\n                <input [class.error-input]=\"service.errors.expiration\" (blur)=\"service.validateExpirationError()\" class=\"small-input\" style=\"margin-right: 5px;\" [(ngModel)]=\"service.expiration\" (ngModelChange)=\"service.validateFrontEnd()\" (keypress)=\"service.numeralInputMasking($event)\" placeholder=\"Exp Date (MM/YY)\" type=\"text\" pattern=\"(0[1-9]|1[0-2])\\/\\d{2}\" minlength=\"4\" maxlength=\"5\"/>\r\n                <input [class.error-input]=\"service.errors.cvc\" (ngModelChange)=\"service.validateFrontEnd()\" (blur)=\"service.validateCVCError()\" class=\"small-input\" style=\"margin-left: 5px;\" [(ngModel)]=\"service.cvc\" (keypress)=\"service.numeralInputMasking($event)\" placeholder=\"CVC\" type=\"text\" pattern=\"[0-9]{3,4}\" minlength=\"3\" maxlength=\"4\"/>\r\n            </div>\r\n            <div class=\"col-holder\">\r\n                <div *ngIf=\"service.errors.expiration\" style=\"margin-right: 5px; width: calc(50% - 5px); float: left;\" class=\"alert alert-danger\">\r\n                    <span class=\"error\">{{ service.errors.expiration }}</span>\r\n                </div>\r\n                <div *ngIf=\"service.errors.cvc\" style=\"margin-left: 5px; width: calc(50% - 5px); float: right;\" class=\"alert alert-danger\">\r\n                    <span class=\"error\">{{ service.errors.cvc }}</span>\r\n                </div>\r\n                <div class=\"clear\"></div>\r\n            </div>\r\n            <input [class.error-input]=\"service.errors.postalCode\" [(ngModel)]=\"service.postalCode\" (ngModelChange)=\"service.validateFrontEnd()\" (blur)=\"service.validatePostalCodeError()\" id=\"postalCode\" #name=\"ngModel\" placeholder=\"Postal Code\" type=\"text\"/>\r\n            <div *ngIf=\"service.errors.postalCode\" class=\"alert alert-danger\">\r\n                <span class=\"error\">{{ service.errors.postalCode }}</span>\r\n            </div>\r\n            <button (click)=\"service.updateCard()\" class=\"btn center\" [disabled]=\"!service.cardOkay\" [class.btn-gray]=\"!service.cardOkay\">Update Card</button>\r\n            <p *ngIf=\"service.loaderOn\">Updating <span class=\"sending-loader\"><span class=\"ellipse-1\">. </span><span class=\"ellipse-2\">. </span><span class=\"ellipse-3\"> .</span></span></p>\r\n        </div>\r\n        <p *ngIf=\"service.errors.update !== 'Success'\" class=\"error\">{{ service.errors.update }}</p>\r\n        <p class=\"mt15 mb15\" *ngIf=\"service.errors.update === 'Success'\" ><img class=\"success-check\" src=\"../img/check-sign.svg\" onerror=\"this.onerror=null; this.src='../img/check-sign.png'\">Your credit card has been changed.</p>\r\n        <a *ngIf=\"service.errors.update === 'Success'\" class=\"btn\" (click)=\"close()\">Done</a>\r\n    </div>\r\n</div>"

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = ".popup {\n  width: 400px;\n  max-width: 100%; }\n\n.error {\n  margin-top: -4px; }\n\np {\n  text-align: left; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput,\n.btn {\n  width: 100%; }\n\ninput.small-input {\n  width: calc(50% - 5px);\n  min-width: 0; }\n\ninput.stripe-passed {\n  background-image: url(../../img/greencheck.png);\n  background-repeat: no-repeat;\n  background-size: 20px;\n  background-position: 98% 50%; }\n\n.btn-gray {\n  background: #686868;\n  color: #484848;\n  cursor: not-allowed; }\n\nselect {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  line-height: 24px;\n  text-align: left;\n  margin-top: 5px; }\n\n.close {\n  position: absolute;\n  right: 10px;\n  top: 5px;\n  line-height: 7px;\n  font-size: 24px;\n  color: #353535;\n  cursor: pointer; }\n  .close:hover {\n    color: #1c1c1c; }\n\n.underline {\n  text-decoration: underline; }\n\n.sending-loader .ellipse-1 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseOne 2s linear infinite;\n  -webkit-animation: ellipseOne 2s linear infinite; }\n\n.sending-loader .ellipse-2 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseTwo 2s linear infinite;\n  -webkit-animation: ellipseTwo 2s linear infinite; }\n\n.sending-loader .ellipse-3 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseThree 2s linear infinite;\n  -webkit-animation: ellipseThree 2s linear infinite; }\n\n@keyframes ellipseOne {\n  0% {\n    opacity: 0; }\n  24% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseTwo {\n  0% {\n    opacity: 0; }\n  49% {\n    opacity: 0; }\n  50% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseThree {\n  0% {\n    opacity: 0; }\n  74% {\n    opacity: 0; }\n  75% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@media only screen and (max-width: 499px) {\n  .update-billing-popup {\n    left: calc(50% - 160px);\n    width: 320px; } }\n\n@media only screen and (max-width: 399px) {\n  .update-billing-popup {\n    width: calc(100% - 10px);\n    height: 100%;\n    left: 5px;\n    top: 10px;\n    padding-bottom: 400px;\n    overflow-y: scroll; } }\n"

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var update_plan_service_1 = __webpack_require__(730);
var UpdatePlanComponent = (function () {
    function UpdatePlanComponent(service) {
        this.service = service;
        this.onClose = new core_1.EventEmitter();
    }
    Object.defineProperty(UpdatePlanComponent.prototype, "display", {
        set: function (toDisplay) {
            this.service.open(toDisplay);
        },
        enumerable: true,
        configurable: true
    });
    UpdatePlanComponent.prototype.close = function () {
        this.service.close();
        this.onClose.emit(true);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], UpdatePlanComponent.prototype, "display", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], UpdatePlanComponent.prototype, "onClose", void 0);
    UpdatePlanComponent = __decorate([
        core_1.Component({
            selector: 'update-plan',
            template: __webpack_require__(731),
            styles: [__webpack_require__(732)],
            providers: [update_plan_service_1.UpdatePlanService]
        }),
        __metadata("design:paramtypes", [update_plan_service_1.UpdatePlanService])
    ], UpdatePlanComponent);
    return UpdatePlanComponent;
}());
exports.UpdatePlanComponent = UpdatePlanComponent;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var UpdatePlanService = (function () {
    function UpdatePlanService(api, app, logger, billing, user) {
        this.api = api;
        this.app = app;
        this.logger = logger;
        this.billing = billing;
        this.user = user;
        this.title = 'Change Your Plan';
        this.show = false;
        this.accountType = '';
        this.billingPeriod = '';
        this.cost = '';
        this.plan = 'Basic';
        this.showCancel = false;
        this.status = '';
        this.cancelSuccess = false;
        this.showSubscribe = false;
        this.subscribeSuccess = false;
        this.coupon = '';
        this.freeAccount = false;
        this.costMultiplier = 1;
        this.couponValid = false;
        this.couponError = '';
        this.buttonEnabled = false;
        this.newPlan = 'Basic';
        this.hasCard = false;
        this.init();
    }
    UpdatePlanService.prototype.init = function () {
        var _this = this;
        this.billing.getCustomer().then(function (customer) {
            try {
                if (_this.app.accountType == 'Basic') {
                    _this.accountType = 'Professional';
                    _this.billingPeriod = 'Monthly';
                }
                else if (_this.app.plan.id.indexOf('api') > -1) {
                    var planArray = _this.app.plan.id.split('-');
                    if (planArray[1] == '500') {
                        _this.accountType = 'Professional + API(500)';
                    }
                    else if (planArray[1] == '1000') {
                        _this.accountType = 'Professional + API(1000)';
                    }
                    else if (planArray[1] == '1500') {
                        _this.accountType = 'Professional + API(1500)';
                    }
                    else if (planArray[1] == '4000') {
                        _this.accountType = 'Professional + API(4000)';
                    }
                    else if (planArray[1] == '15000') {
                        _this.accountType = 'Professional + API(15000)';
                    }
                    else if (planArray[1] == '50000') {
                        _this.accountType = 'Professional + API(50000)';
                    }
                    else if (planArray[1] == '150000') {
                        _this.accountType = 'Professional + API(150000)';
                    }
                    else {
                        _this.accountType = 'Professional';
                    }
                }
                else {
                    _this.accountType = _this.app.accountType;
                    _this.billingPeriod = _this.app.billingInterval == 'month' ? 'Monthly' : 'Yearly';
                }
                _this.hasCard = customer.sources.length > 0;
            }
            catch (ex) {
                _this.hasCard = false;
            }
            _this.updateView();
        }).catch(function (err) {
            _this.hasCard = false;
            _this.updateView();
        });
    };
    UpdatePlanService.prototype.open = function (toDisplay) {
        this.show = toDisplay;
        this.init();
    };
    UpdatePlanService.prototype.close = function () {
        this.coupon = '';
        this.costMultiplier = 1;
        this.couponValid = false;
        this.couponError = '';
        this.freeAccount = false;
        this.hasCard = false;
        this.couponError = '';
        this.showCancel = false;
        this.cancelSuccess = false;
        this.showSubscribe = false;
        this.subscribeSuccess = false;
        this.status = '';
        this.cost = '';
    };
    UpdatePlanService.prototype.updateView = function () {
        this.validate();
        this.updateCost();
    };
    UpdatePlanService.prototype.updateCost = function () {
        var cost = '';
        if (this.accountType === 'Premium') {
            if (this.billingPeriod === 'Monthly') {
                cost = "You will be charged $" + (49 * this.costMultiplier).toFixed(2) + " in 14 days";
                this.plan = 'monthly-premium';
            }
            else {
                cost = "You will be charged $" + (488 * this.costMultiplier).toFixed(2) + " in 14 days";
                this.plan = 'yearly-premium';
            }
        }
        else if (this.accountType === 'Professional') {
            if (this.billingPeriod === 'Monthly') {
                cost = "You will be charged $" + (99 * this.costMultiplier).toFixed(2) + " in 14 days";
                this.plan = 'monthly-professional';
            }
            else {
                cost = "You will be charged $" + (988 * this.costMultiplier).toFixed(2) + " in 14 days";
                this.plan = 'yearly-professional';
            }
        }
        else if (this.accountType === 'Enterprise 2-6 users') {
            if (this.billingPeriod === 'Monthly') {
                cost = "You will be charged $" + (149 * this.costMultiplier).toFixed(2);
                this.plan = 'price_1HUDlXBI16lWsbHUpazF2axJ';
            }
            else {
                cost = "You will be charged $" + (1488 * this.costMultiplier).toFixed(2);
                this.plan = 'price_1HrW7lBI16lWsbHUsNT327Sp';
            }
        }
        else if (this.accountType === 'Enterprise 7-12 users') {
            if (this.billingPeriod === 'Monthly') {
                cost = "You will be charged $" + (199 * this.costMultiplier).toFixed(2);
                this.plan = 'price_1HUDrpBI16lWsbHUEcy8QqRp';
            }
            else {
                cost = "You will be charged $" + (1988 * this.costMultiplier).toFixed(2);
                this.plan = 'price_1HtzNJBI16lWsbHUF6DRNf0X';
            }
        }
        else if (this.accountType === 'Enterprise 13-18 users') {
            if (this.billingPeriod === 'Monthly') {
                cost = "You will be charged $" + (249 * this.costMultiplier).toFixed(2);
                this.plan = 'price_1HUDwiBI16lWsbHUJUXFNMp2';
            }
            else {
                cost = "You will be charged $" + (2488 * this.costMultiplier).toFixed(2);
                this.plan = 'price_1HtzKUBI16lWsbHU4gyZlwmJ';
            }
        }
        else if (this.accountType === 'API-500 + Enterprise') {
            this.billingPeriod = 'Monthly';
            cost = "You will be charged $" + (330 * this.costMultiplier).toFixed(2);
            this.plan = 'price_1KDzaGCAIBqfWZikF50UOobO';
        }
        else if (this.accountType === 'API-1500 + Enterprise') {
            this.billingPeriod = 'Monthly';
            cost = "You will be charged $" + (550 * this.costMultiplier).toFixed(2);
            this.plan = 'price_1KDzdlCAIBqfWZikTr54Oj54';
        }
        else if (this.accountType === 'API-4000 + Enterprise') {
            this.billingPeriod = 'Monthly';
            cost = "You will be charged $" + (1000 * this.costMultiplier).toFixed(2);
            this.plan = 'price_1KDzh3CAIBqfWZikkmKsljAm';
        }
        else if (this.accountType === 'API-15000 + Enterprise') {
            this.billingPeriod = 'Monthly';
            cost = "You will be charged $" + (1990 * this.costMultiplier).toFixed(2);
            this.plan = 'price_1KDzicCAIBqfWZikm7knIDYs';
        }
        else if (this.accountType === 'API-50000 + Enterprise') {
            this.billingPeriod = 'Monthly';
            cost = "You will be charged $" + (3600 * this.costMultiplier).toFixed(2);
            this.plan = 'price_1KDzlWCAIBqfWZikOzC01OKm';
        }
        else if (this.accountType === 'API-150000 + Enterprise') {
            this.billingPeriod = 'Monthly';
            cost = "You will be charged $" + (4900 * this.costMultiplier).toFixed(2);
            this.plan = 'price_1KDzoOCAIBqfWZik4wgvO1ZZ';
        }
        if (!this.hasCard && !this.freeAccount && this.couponValid) {
            // has no card and is using a non-free-account coupon
            this.cost = 'Please add a credit card before subscribing with that coupon.';
        }
        else {
            this.cost = this.freeAccount ? 'FREE ACCOUNT' : cost;
        }
    };
    UpdatePlanService.prototype.checkCoupon = function () {
        this.couponValid = false;
        this.couponError = '';
        if (this.validateCoupon()) {
            this.logger.log('update-plan.service', 'checkCoupon', 'before call');
            this.callCheckCoupon();
        }
    };
    UpdatePlanService.prototype.validateCoupon = function () {
        if (this.coupon.length === 0 || this.coupon.length > 256) {
            return false;
        }
        return true;
    };
    UpdatePlanService.prototype.callCheckCoupon = function () {
        var _this = this;
        this.billing.checkCoupon(this.coupon).then(function (coupon) {
            if (coupon.percentOff == 100) {
                // free account
                _this.freeAccount = true;
                _this.couponValid = true;
            }
            else if (coupon.percentOff !== 0 && coupon.percentOff) {
                _this.costMultiplier = 1 - (coupon.percentOff / 100);
                _this.couponValid = true;
            }
            else {
                _this.couponError = 'Invalid Coupon';
                _this.couponValid = false;
            }
            _this.updateView();
        }).catch(function (err) {
            _this.couponError = 'Invalid Coupon';
            _this.couponValid = false;
        });
    };
    UpdatePlanService.prototype.validate = function () {
        // is a change
        // has card or is free
        var intervalChange = false;
        if (this.billingPeriod === 'Yearly' && this.app.billingInterval !== 'year') {
            intervalChange = true;
        }
        if (this.billingPeriod === 'Monthly' && this.app.billingInterval !== 'month') {
            intervalChange = true;
        }
        else if (this.billingPeriod === 'Monthly' && this.app.billingInterval === 'month') {
            intervalChange = false;
        }
        try {
            this.buttonEnabled = ((intervalChange || this.isTypeChange()) && (this.hasCard || this.freeAccount)) || this.couponValid;
        }
        catch (ex) {
            this.buttonEnabled = false;
        }
    };
    UpdatePlanService.prototype.isTypeChange = function () {
        var currentAccountType = this.app.accountType;
        var currentPlan = this.app.plan.id;
        if (this.app.plan.id.indexOf('api') > -1) {
            var planArray = this.app.plan.id.split('-');
            if (planArray[1] == '500') {
                currentAccountType = 'Professional + API(500)';
            }
            else if (planArray[1] == '1000') {
                currentAccountType = 'Professional + API(1000)';
            }
            else if (planArray[1] == '1500') {
                currentAccountType = 'Professional + API(1500)';
            }
            else if (planArray[1] == '4000') {
                currentAccountType = 'Professional + API(4000)';
            }
            else if (planArray[1] == '15000') {
                currentAccountType = 'Professional + API(15000)';
            }
            else if (planArray[1] == '50000') {
                currentAccountType = 'Professional + API(50000)';
            }
            else if (planArray[1] == '150000') {
                currentAccountType = 'Professional + API(150000)';
            }
        }
        return currentAccountType != this.accountType;
    };
    UpdatePlanService.prototype.toggleSubscribe = function () {
        this.showSubscribe = !this.showSubscribe;
    };
    UpdatePlanService.prototype.subscribe = function () {
        var _this = this;
        this.validate();
        if (this.status === 'sending...' || !this.buttonEnabled) {
            return;
        }
        this.status = 'sending...';
        this.subscribeSuccess = false;
        var coupon = '';
        if (this.couponValid) {
            coupon = this.coupon;
        }
        this.billing.subscribe(this.plan, coupon)
            .then(function (subscription) {
            _this.app.setAccountType(_this.accountType);
            if (_this.billingPeriod === 'Monthly') {
                _this.app.plan.interval = 'month';
            }
            if (_this.billingPeriod === 'Yearly') {
                _this.app.plan.interval = 'year';
            }
            _this.user.getProfile();
            _this.subscribeSuccess = true;
            _this.status = 'success';
        }).catch(function (err) {
            _this.logger.log('update-plan.service', 'changePlan error', err);
            if (typeof err == 'string') {
                _this.status = err;
            }
            else {
                _this.status = 'something went wrong';
            }
            _this.subscribeSuccess = false;
        });
    };
    UpdatePlanService.prototype.toggleCancel = function () {
        this.showCancel = !this.showCancel;
    };
    UpdatePlanService.prototype.cancelPlan = function () {
        var _this = this;
        if (this.status === 'sending...') {
            return;
        }
        this.status = 'sending...';
        this.cancelSuccess = false;
        this.billing.cancel()
            .then(function (result) {
            _this.logger.log('update-plan.service', 'cancelPlan success', result);
            _this.user.getProfile();
            _this.app.setAccountType('Basic');
            _this.app.plan.interval = '';
            _this.cancelSuccess = true;
            _this.status = 'success';
        }).catch(function (err) {
            _this.logger.log('update-plan.service', 'cancelPlan error', err);
            _this.status = 'error';
            _this.cancelSuccess = false;
        });
    };
    UpdatePlanService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AppContext, shared_1.LogService,
            shared_1.BillingService, shared_1.UserService])
    ], UpdatePlanService);
    return UpdatePlanService;
}());
exports.UpdatePlanService = UpdatePlanService;


/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"service.show\" class=\"update-plan-popup-wrapper\"></div>\r\n<div [class.hide]=\"service.showCancel || service.showSubscribe\" *ngIf=\"service.show\" class=\"update-plan-popup\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5>{{ service.title }}</h5>\r\n    <div class=\"popup-line-div\"></div>\r\n    <div *ngIf=\"!service.hasCard && !service.buttonEnabled\" class=\"error\">Please update your credit card info</div>\r\n    <p>Plan Type</p>\r\n    <select [(ngModel)]=\"service.accountType\" (ngModelChange)=\"service.updateView()\">\r\n        <option value=\"Premium\">\r\n            Premium\r\n        </option>\r\n        <option value=\"Professional\">\r\n            Professional\r\n        </option>\r\n        <option value=\"Enterprise 2-6 users\">\r\n            Enterprise 2-6 users\r\n        </option>\r\n        <option value=\"Enterprise 7-12 users\">\r\n            Enterprise 7-12 users\r\n        </option>\r\n        <option value=\"Enterprise 13-18 users\">\r\n            Enterprise 13-18 users\r\n        </option>\r\n    </select>\r\n    <p>Billing Period</p>\r\n    <select [(ngModel)]=\"service.billingPeriod\" (ngModelChange)=\"service.updateView()\">\r\n        <option value=\"Monthly\">Monthly</option>\r\n        <option *ngIf=\"service.accountType != 'API-500 + Enterprise' && service.accountType != 'API-1500 + Enterprise' && service.accountType != 'API-4000 + Enterprise' && service.accountType != 'API-15000 + Enterprise' && service.accountType != 'API-50000 + Enterprise' && service.accountType != 'API-150000 + Enterprise'\" value=\"Yearly\">Yearly</option>\r\n    </select>\r\n    <div class=\"popup-line-div\"></div>\r\n    <div class=\"col-holder\">\r\n        <input class=\"coupon-input\" (blur)=\"service.checkCoupon()\" [class.passed]=\"service.couponValid\" [(ngModel)]=\"service.coupon\" placeholder=\"Coupon Code\" type=\"text\" />\r\n        <div class=\"coupon-plus-holder\"><a class=\"coupon-plus\" (click)=\"service.checkCoupon()\">+</a></div>\r\n        <span *ngIf=\"couponError !== ''\" style=\"font-size: 18px;\" class=\"error\">{{ service.couponError }}</span>\r\n    </div>\r\n    <div class=\"popup-line-div\"></div>\r\n    <button (click)=\"service.toggleSubscribe()\" class=\"btn center\" [disabled]=\"!service.buttonEnabled\" [class.btn-gray]=\"!service.buttonEnabled\">{{ service.title }}</button>\r\n    <p *ngIf=\"service.cost\">{{ service.cost }}</p>\r\n    <p *ngIf=\"service.app.accountType !== 'Basic'\" (click)=\"service.toggleCancel()\" class=\"text-right pointer mt10 small-text underline\">Cancel Your Plan</p>\r\n</div>\r\n\r\n<div class=\"confirm-popup\" *ngIf=\"service.showCancel\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <div *ngIf=\"!service.cancelSuccess\">\r\n        <h6 class=\"text-center mt10 mb15\">Are you sure you want to cancel your plan?</h6>\r\n        <a (click)=\"service.cancelPlan()\" class=\"btn mb5\">Yes, cancel my plan</a>\r\n        <a (click)=\"service.toggleCancel()\" class=\"btn btn-blue\">No, do not cancel my plan</a>\r\n        <span *ngIf=\"service.status === 'error'\">Something went wrong. Please contact Linescape for support.</span>\r\n    </div>\r\n    <div *ngIf=\"service.cancelSuccess\">\r\n        <p class=\"mt15\">We are sorry to see you go!</p>\r\n        <br />\r\n        <p>Please contact <a href=\"mailto:marketing@linescape.com\">marketing@linescape.com</a> with any suggestions you may have for improving our service.<p>\r\n    </div>\r\n    <p *ngIf=\"service.status === 'sending...'\">Canceling Plan<span class=\"sending-loader\"><span class=\"ellipse-1\">. </span><span class=\"ellipse-2\">. </span><span class=\"ellipse-3\"> .</span></span></p>\r\n</div>\r\n\r\n<div class=\"confirm-popup\" *ngIf=\"service.showSubscribe\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <div *ngIf=\"!service.subscribeSuccess\">\r\n        <h6 class=\"text-center mt10 mb15\">Are you sure you want to subscribe?</h6>\r\n        <a (click)=\"service.subscribe()\" class=\"btn mb5\">Yes</a>\r\n        <a (click)=\"service.toggleSubscribe()\" class=\"btn btn-blue\">No</a>\r\n        <span *ngIf=\"service.status === 'error'\">Something went wrong. Please contact Linescape for support.</span>\r\n    </div>\r\n    <div *ngIf=\"service.subscribeSuccess\">\r\n        <h6 class=\"text-center mt15\">Thank you for subscribing!</h6>\r\n    </div>\r\n    <p *ngIf=\"service.status === 'sending...'\">Changing Plan<span class=\"sending-loader\"><span class=\"ellipse-1\">. </span><span class=\"ellipse-2\">. </span><span class=\"ellipse-3\"> .</span></span></p>\r\n</div>"

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = ".update-plan-popup-wrapper {\n  position: fixed;\n  z-index: 30;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.3); }\n\n.update-plan-popup {\n  background-color: #fafafa;\n  position: fixed;\n  left: calc(50% - 200px);\n  width: 400px;\n  padding: 20px;\n  text-align: center;\n  z-index: 40;\n  border-radius: 3px;\n  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.43);\n  top: 100px;\n  max-height: calc(100vh - 120px);\n  overflow-y: auto; }\n  .update-plan-popup.hide {\n    visibility: hidden; }\n\np {\n  text-align: left; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\n.popup-line-div {\n  display: block;\n  height: 1px;\n  width: 50%;\n  margin: auto;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  background: #d4d4d4; }\n\ninput,\n.btn {\n  width: 100%; }\n\n.btn-gray {\n  background: #686868;\n  color: #484848;\n  cursor: not-allowed; }\n\nselect {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  line-height: 24px;\n  text-align: left;\n  margin-top: 5px; }\n\n.close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  line-height: 7px;\n  font-size: 24px;\n  color: #353535;\n  cursor: pointer; }\n  .close:hover {\n    color: #1c1c1c; }\n\n.coupon-input.passed,\n.stripe-passed input {\n  background-image: url(../../img/greencheck.png);\n  background-repeat: no-repeat;\n  background-size: 20px;\n  background-position: 98% 50%; }\n\n.coupon-input {\n  width: calc(100% - 40px);\n  min-width: 160px; }\n\n.coupon-plus-holder {\n  vertical-align: top;\n  display: inline-block;\n  width: 40px;\n  margin-top: 5px;\n  height: 37px; }\n  .coupon-plus-holder .coupon-plus {\n    font-size: 30px; }\n\n.underline {\n  text-decoration: underline; }\n\n.confirm-popup {\n  background-color: #fafafa;\n  position: fixed;\n  left: calc(50% - 200px);\n  width: 400px;\n  padding: 20px;\n  text-align: center;\n  z-index: 40;\n  border-radius: 3px;\n  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.43);\n  top: 194px;\n  max-height: calc(100vh - 120px);\n  overflow-y: auto;\n  visibility: visible;\n  border: 1px solid #c4c4c4; }\n  .confirm-popup .close {\n    right: 7px;\n    top: 7px; }\n\n.sending-loader .ellipse-1 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseOne 2s linear infinite;\n  -webkit-animation: ellipseOne 2s linear infinite; }\n\n.sending-loader .ellipse-2 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseTwo 2s linear infinite;\n  -webkit-animation: ellipseTwo 2s linear infinite; }\n\n.sending-loader .ellipse-3 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseThree 2s linear infinite;\n  -webkit-animation: ellipseThree 2s linear infinite; }\n\n@keyframes ellipseOne {\n  0% {\n    opacity: 0; }\n  24% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseTwo {\n  0% {\n    opacity: 0; }\n  49% {\n    opacity: 0; }\n  50% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseThree {\n  0% {\n    opacity: 0; }\n  74% {\n    opacity: 0; }\n  75% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@media only screen and (max-width: 499px) {\n  .update-billing-popup {\n    left: calc(50% - 160px);\n    width: 320px; } }\n\n@media only screen and (max-width: 399px) {\n  .update-billing-popup {\n    width: calc(100% - 10px);\n    height: 100%;\n    left: 5px;\n    top: 10px;\n    padding-bottom: 400px;\n    overflow-y: scroll; } }\n"

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(248));
__export(__webpack_require__(734));
__export(__webpack_require__(738));


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var email_settings_service_1 = __webpack_require__(735);
var EmailSettingsComponent = (function () {
    function EmailSettingsComponent(service) {
        this.service = service;
    }
    EmailSettingsComponent = __decorate([
        core_1.Component({
            selector: 'email-settings',
            template: __webpack_require__(736),
            styles: [__webpack_require__(737)],
            providers: [email_settings_service_1.EmailSettingsService],
        }),
        __metadata("design:paramtypes", [email_settings_service_1.EmailSettingsService])
    ], EmailSettingsComponent);
    return EmailSettingsComponent;
}());
exports.EmailSettingsComponent = EmailSettingsComponent;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var EmailSettingsService = (function () {
    function EmailSettingsService(api, logger, app) {
        this.api = api;
        this.logger = logger;
        this.app = app;
        this.timezones = [];
        this.userTimeZone = '';
        this.hourOfDay = 9;
        this.mondayVar = false;
        this.tuesdayVar = false;
        this.wednesdayVar = false;
        this.thursdayVar = false;
        this.fridayVar = false;
        this.daysOfWeek = [];
        this.emailYourself = false;
        this.emailOthers = false;
        this.email = '';
        this.otherEmails = new Array();
        this.loading = false;
        this.message = '';
        this.errorPresent = false;
        this.emailError = '';
        this.init();
    }
    EmailSettingsService.prototype.init = function () {
        var _this = this;
        try {
            this.userTimeZone = moment.tz.guess();
        }
        catch (ex) {
            this.userTimeZone = '';
        }
        this.api.getApiClient().then(function (client) { return _this.callGetEmailDeliverySettings(client); });
        this.api.getApiClient().then(function (client) { return _this.callGetTimezones(client); });
    };
    EmailSettingsService.prototype.callGetEmailDeliverySettings = function (apigClient) {
        var _this = this;
        this.logger.log('email-settings.service', 'callGetEmailDeliverySettings', 'hello');
        var params = {};
        var body = {};
        var additionalParams = { headers: { 'Content-Type': 'application/json' } };
        try {
            apigClient.userEmailDeliverySettingsGet(params, body, additionalParams)
                .then(function (result) {
                _this.logger.log('email-settings.service', 'callGetEmailDeliverySettings result', result);
                _this.formatSettings(result.data);
            }).catch(function (err) {
                _this.api.handleError(err);
                _this.app.showMessage('Network Error', 'Please refresh the page to try again. If this issue persists, please contact our support');
            });
        }
        catch (ex) {
            this.app.showMessage('Network Error', 'Please refresh the page to try again. If this issue persists, please contact our support');
        }
    };
    EmailSettingsService.prototype.formatSettings = function (data) {
        try {
            this.userTimeZone = data.userTimeZone.replace(/_/g, ' ');
            this.hourOfDay = data.hourOfDay;
            this.daysOfWeek = data.daysOfWeek instanceof Array ? data.daysOfWeek : data.daysOfWeek.values;
            this.mondayVar = this.daysOfWeek.indexOf(1) > -1 ? true : false;
            this.tuesdayVar = this.daysOfWeek.indexOf(2) > -1 ? true : false;
            this.wednesdayVar = this.daysOfWeek.indexOf(3) > -1 ? true : false;
            this.thursdayVar = this.daysOfWeek.indexOf(4) > -1 ? true : false;
            this.fridayVar = this.daysOfWeek.indexOf(5) > -1 ? true : false;
            this.emailYourself = data.emailSelf || false;
            if (data.otherEmails.length !== 0) {
                this.otherEmails = data.otherEmails;
                this.email = this.otherEmails.join(',');
                this.emailOthers = this.otherEmails.length !== 0;
            }
        }
        catch (ex) {
            this.logger.log('email-settings.service', 'formatSettings', 'no settings');
        }
    };
    EmailSettingsService.prototype.callGetTimezones = function (apigClient) {
        var _this = this;
        this.logger.log('email-settings.service', 'callGetTimezones', 'hello');
        var params = {};
        var body = {};
        var additionalParams = { headers: { 'Content-Type': 'application/json' } };
        try {
            apigClient.timezonesGet(params, body, additionalParams)
                .then(function (result) {
                _this.logger.log('email-settings.service', 'timezones result', result);
                _this.timezones = result.data;
            }).catch(function (err) { return _this.api.handleError(err); });
        }
        catch (ex) {
        }
    };
    EmailSettingsService.prototype.save = function () {
        var _this = this;
        this.errorPresent = false;
        this.emailError = '';
        this.message = '';
        if (!this.errorPresent) {
            var post_1;
            this.loading = true;
            post_1 = {
                daysOfWeek: this.daysOfWeek,
                emailSelf: this.emailYourself,
                otherEmails: this.otherEmails,
                htmlEmails: true,
                emailFormat: 'html',
                hourOfDay: +this.hourOfDay,
                userTimeZone: this.userTimeZone
            };
            this.api.getApiClient().then(function (client) { return _this.callUpdateDeliverySettings(client, post_1); });
        }
    };
    EmailSettingsService.prototype.callUpdateDeliverySettings = function (apigClient, post) {
        var _this = this;
        var params = {};
        var body = post;
        var additionalParams = { headers: { 'Content-Type': 'application/json' } };
        try {
            apigClient.userEmailDeliverySettingsPost(params, body, additionalParams)
                .then(function (result) {
                _this.logger.log('email-settings.service', 'callGetEmailDeliverySettings result', result);
                _this.loading = false;
                _this.message = 'Settings Saved';
            }).catch(function (err) {
                _this.api.handleError(err);
                _this.loading = false;
                _this.message = 'An error has occurred. Please try again later.';
                _this.logger.log('email-settings.service', 'callUpdateDeliverySettings error', err);
                _this.logger.log('email-settings.service', 'callUpdateDeliverySettings message', _this.message);
            });
        }
        catch (ex) {
            this.loading = false;
            this.message = 'An error has occurred. Please try again later.';
        }
    };
    EmailSettingsService.prototype.toggleEmailYourself = function () {
        this.emailYourself = !this.emailYourself;
    };
    EmailSettingsService.prototype.toggleEmailOthers = function () {
        this.emailOthers = !this.emailOthers;
    };
    EmailSettingsService.prototype.monday = function () {
        if (this.mondayVar) {
            var index = this.daysOfWeek.indexOf(1);
            this.daysOfWeek.splice(index, 1);
        }
        else {
            this.daysOfWeek.push(1);
        }
        this.mondayVar = !this.mondayVar;
    };
    EmailSettingsService.prototype.tuesday = function () {
        if (this.tuesdayVar) {
            var index = this.daysOfWeek.indexOf(2);
            this.daysOfWeek.splice(index, 1);
        }
        else {
            this.daysOfWeek.push(2);
        }
        this.tuesdayVar = !this.tuesdayVar;
    };
    EmailSettingsService.prototype.wednesday = function () {
        if (this.wednesdayVar) {
            var index = this.daysOfWeek.indexOf(3);
            this.daysOfWeek.splice(index, 1);
        }
        else {
            this.daysOfWeek.push(3);
        }
        this.wednesdayVar = !this.wednesdayVar;
    };
    EmailSettingsService.prototype.thursday = function () {
        if (this.thursdayVar) {
            var index = this.daysOfWeek.indexOf(4);
            this.daysOfWeek.splice(index, 1);
        }
        else {
            this.daysOfWeek.push(4);
        }
        this.thursdayVar = !this.thursdayVar;
    };
    EmailSettingsService.prototype.friday = function () {
        if (this.fridayVar) {
            var index = this.daysOfWeek.indexOf(5);
            this.daysOfWeek.splice(index, 1);
        }
        else {
            this.daysOfWeek.push(5);
        }
        this.fridayVar = !this.fridayVar;
    };
    EmailSettingsService.prototype.updateEmails = function (emails) {
        this.otherEmails = emails;
    };
    EmailSettingsService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.LogService, shared_1.AppContext])
    ], EmailSettingsService);
    return EmailSettingsService;
}());
exports.EmailSettingsService = EmailSettingsService;


/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = "<div class=\"mb30\">\r\n  <p>Email delivery days</p>\r\n  <div class=\"pointer\" (click)=\"service.monday()\"><!-- Put click event for selecting days on this div> -->\r\n    <div class=\"pointer\" [class.selected]=\"service.mondayVar\" class=\"check-box-div\"><span>&#x2714;</span></div><label class=\"pointer\">Monday</label>\r\n  </div>\r\n  <div class=\"pointer\" (click)=\"service.tuesday()\"><!-- Put click event for selecting days on this div> -->\r\n    <div class=\"pointer\" [class.selected]=\"service.tuesdayVar\" class=\"check-box-div\"><span>&#x2714;</span></div><label class=\"pointer\">Tuesday</label>\r\n  </div>\r\n  <div class=\"pointer\" (click)=\"service.wednesday()\"><!-- Put click event for selecting days on this div> -->\r\n    <div class=\"pointer\" [class.selected]=\"service.wednesdayVar\" class=\"check-box-div\"><span>&#x2714;</span></div><label class=\"pointer\">Wednesday</label>\r\n  </div>\r\n  <div class=\"pointer\" (click)=\"service.thursday()\"><!-- Put click event for selecting days on this div> -->\r\n    <div class=\"pointer\" [class.selected]=\"service.thursdayVar\" class=\"check-box-div\"><span>&#x2714;</span></div><label class=\"pointer\">Thursday</label>\r\n  </div>\r\n  <div class=\"pointer\" (click)=\"service.friday()\"><!-- Put click event for selecting days on this div> -->\r\n    <div class=\"pointer\" [class.selected]=\"service.fridayVar\" class=\"check-box-div\"><span>&#x2714;</span></div><label class=\"pointer\">Friday</label>\r\n  </div>\r\n</div>\r\n<div class=\"mb30\">\r\n  <p>Time zone</p>\r\n  <select [(ngModel)]=\"service.userTimeZone\">\r\n    <option *ngFor=\"let zone of service.timezones\" value=\"{{ zone }}\">\r\n      {{ zone }}\r\n    </option>\r\n  </select>\r\n  <p>Time of day</p>\r\n  <select [(ngModel)]=\"service.hourOfDay\">\r\n    <option value=\"0\">12:00 AM</option>\r\n    <option value=\"1\">1:00 AM</option>\r\n    <option value=\"2\">2:00 AM</option>\r\n    <option value=\"3\">3:00 AM</option>\r\n    <option value=\"4\">4:00 AM</option>\r\n    <option value=\"5\">5:00 AM</option>\r\n    <option value=\"6\">6:00 AM</option>\r\n    <option value=\"7\">7:00 AM</option>\r\n    <option value=\"8\">8:00 AM</option>\r\n    <option value=\"9\">9:00 AM</option>\r\n    <option value=\"10\">10:00 AM</option>\r\n    <option value=\"11\">11:00 AM</option>\r\n    <option value=\"12\">12:00 PM</option>\r\n    <option value=\"13\">1:00 PM</option>\r\n    <option value=\"14\">2:00 PM</option>\r\n    <option value=\"15\">3:00 PM</option>\r\n    <option value=\"16\">4:00 PM</option>\r\n    <option value=\"17\">5:00 PM</option>\r\n    <option value=\"18\">6:00 PM</option>\r\n    <option value=\"19\">7:00 PM</option>\r\n    <option value=\"20\">8:00 PM</option>\r\n    <option value=\"21\">9:00 PM</option>\r\n    <option value=\"22\">10:00 PM</option>\r\n    <option value=\"23\">11:00 PM</option>\r\n  </select>\r\n</div>\r\n<div>\r\n  <p>Email Options</p>\r\n  <div (click)=\"service.toggleEmailYourself()\">\r\n    <div class=\"pointer\" [class.selected]=\"service.emailYourself\" class=\"check-box-div\"><span>&#x2714;</span></div><label class=\"pointer\">Email Yourself</label>\r\n  </div>\r\n  <div (click)=\"service.toggleEmailOthers()\">\r\n    <div class=\"pointer\" [class.selected]=\"service.emailOthers\" class=\"check-box-div\"><span>&#x2714;</span></div><label class=\"pointer\">Enter Email Addresses</label>\r\n  </div>\r\n  <div *ngIf=\"service.emailOthers\">\r\n    <p>Email Address</p>\r\n    <div class=\"popup-line-div\"></div>\r\n    <email-box [initial]=\"service.email\" (emailsUpdated)=\"service.updateEmails($event)\"></email-box>\r\n  </div>\r\n</div>\r\n<a class=\"btn mt15 mb10\" (click)=\"service.save()\">Save<span *ngIf=\"service.loading\" class=\"saving-loader\"><span class=\"ellipse-1\">.</span><span class=\"ellipse-2\">.</span><span class=\"ellipse-3\">.</span></span></a>\r\n<br>\r\n<p [class.saved]=\"service.message === 'Settings Saved'\" class=\"success\" *ngIf=\"service.message\">\r\n  <img *ngIf=\"service.message === 'Settings Saved'\" class=\"success-check\" src=\"../img/check-sign.svg\" onerror=\"this.onerror=null; this.src='../img/check-sign.png'\">\r\n  {{ service.message }}\r\n</p>"

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = "select {\n  width: 100%; }\n\n/*.error {\r\n  \tcolor: #353535;\r\n\t  margin-top: 10px;\r\n    border: 1px solid #dd0000;\r\n    background: #ffaaaa;\r\n    width: 250px;\r\n}*/\n/*.message {\r\n  color: #ffffff;\r\n\tbackground: #999999;\r\n\tpadding-top: 0px;\r\n\tpadding-bottom: 0px;\r\n\twidth: 100%;\r\n\tdisplay: block;\r\n\tborder-radius: 3px;\r\n\tborder: 1px solid #000000;\r\n\ttext-align: left;\r\n\tpadding: 4px 8px;\r\n\tline-height: 22px;\r\n\tmargin-top: 5px;\r\n  &.saved {\r\n    animation: savedAnimation 3s linear forwards 1;\r\n  }\r\n}*/\n.check-box-div {\n  border: 1px solid #c4c4c4;\n  width: 16px;\n  height: 16px;\n  margin-right: 5px; }\n  .check-box-div span {\n    top: 0px;\n    left: 0px; }\n\n.saving-loader .ellipse-1 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseOne 2s linear infinite;\n  -webkit-animation: ellipseOne 2s linear infinite; }\n\n.saving-loader .ellipse-2 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseTwo 2s linear infinite;\n  -webkit-animation: ellipseTwo 2s linear infinite; }\n\n.saving-loader .ellipse-3 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseThree 2s linear infinite;\n  -webkit-animation: ellipseThree 2s linear infinite; }\n\n@keyframes savedAnimation {\n  from {\n    border-color: #000000;\n    background: #999999; }\n  to {\n    border-color: transparent;\n    background: transparent; } }\n\n@keyframes ellipseOne {\n  0% {\n    opacity: 0; }\n  1% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  76% {\n    opacity: 0; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseTwo {\n  0% {\n    opacity: 0; }\n  24% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  76% {\n    opacity: 0; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseThree {\n  0% {\n    opacity: 0; }\n  49% {\n    opacity: 0; }\n  50% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  76% {\n    opacity: 0; }\n  100% {\n    opacity: 0; } }\n"

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var email_schedule_service_1 = __webpack_require__(739);
var EmailScheduleComponent = (function () {
    function EmailScheduleComponent(service) {
        this.service = service;
        this.scheduleId = '';
        this.savedScheduleType = 'portPair';
        this.scheduleType = 'portPair';
        this.message = '';
        this.showRoutes = false;
        this.inputOne = '';
        this.inputTwo = '';
        this.originName = '';
        this.originId = 0;
        this.destinationName = '';
        this.destinationId = 0;
        this.status = new core_1.EventEmitter();
        this.scheduleChange = new core_1.EventEmitter();
        // Do stuff
    }
    Object.defineProperty(EmailScheduleComponent.prototype, "delivery", {
        set: function (schedule) {
            this.savedEmailSchedule = schedule;
            this.scheduleId = this.savedEmailSchedule.id;
            this.savedScheduleType = this.savedEmailSchedule.type;
            this.scheduleType = this.savedScheduleType;
            if (this.scheduleType === 'portPair') {
                this.inputOne = this.savedEmailSchedule.originPort.name;
                this.originId = this.savedEmailSchedule.originPort.id;
                this.originName = this.savedEmailSchedule.originPort.name;
                this.inputTwo = this.savedEmailSchedule.destinationPort.name;
                this.destinationId = this.savedEmailSchedule.destinationPort.id;
                this.destinationName = this.savedEmailSchedule.destinationPort.name;
            }
            else if (this.scheduleType === 'port') {
                this.inputOne = this.savedEmailSchedule.port.name;
            }
            else if (this.scheduleType === 'vessel') {
                this.inputOne = this.savedEmailSchedule.vessel.name;
            }
        },
        enumerable: true,
        configurable: true
    });
    EmailScheduleComponent.prototype.onStatusChange = function (state) {
        this.message = state;
        this.status.emit(state);
    };
    EmailScheduleComponent.prototype.onScheduleChange = function (schedule) {
        this.scheduleChange.emit(schedule);
    };
    EmailScheduleComponent.prototype.update = function (type, item) {
        if (type === 'origin') {
            this.originId = item.id;
            this.originName = item.name;
            this.populatePortPair();
        }
        else if (type === 'destination') {
            this.destinationId = item.id;
            this.destinationName = item.name;
            this.populatePortPair();
        }
        else if (type === 'port') {
            this.populatePort(item);
        }
        else if (type === 'vessel') {
            this.populateVessel(item);
        }
    };
    EmailScheduleComponent.prototype.toggleRoutes = function () {
        this.showRoutes = !this.showRoutes;
    };
    EmailScheduleComponent.prototype.onSaved = function (schedule) {
        this.onStatusChange('saved');
        this.scheduleId = schedule.id === null ? this.scheduleId : schedule.id;
        this.savedEmailSchedule = schedule;
        this.savedScheduleType = schedule.type;
        this.onScheduleChange(this.savedEmailSchedule);
    };
    EmailScheduleComponent.prototype.populatePortPair = function () {
        var _this = this;
        try {
            if (this.originName === null || this.originName === '' || this.originName === undefined || this.originId === 0) {
                return;
            }
            if (this.destinationName === null || this.destinationName === '' || this.destinationName === undefined || this.destinationId === 0) {
                return;
            }
            if (this.savedEmailSchedule.id === this.scheduleId && this.destinationId === this.savedEmailSchedule.destinationPortId && this.originId === this.savedEmailSchedule.originPortId) {
                return;
            }
        }
        catch (ex) {
            // saved is not a portPair
        }
        var params = {};
        if (!+this.scheduleId) {
            params = {
                scheduleId: this.scheduleId
            };
        }
        var body = {
            scheduleId: this.scheduleId,
            type: 'portPair',
            originPortId: this.originId,
            destinationPortId: this.destinationId
        };
        this.onStatusChange('saving');
        this.service.set(params, body).then(function (schedule) {
            schedule.originPort = {
                id: _this.originId,
                name: _this.originName
            };
            schedule.destinationPort = {
                id: _this.destinationId,
                name: _this.destinationName
            };
            _this.onSaved(schedule);
        }).catch(function (err) {
            _this.onStatusChange('error');
        });
    };
    EmailScheduleComponent.prototype.populatePort = function (port) {
        var _this = this;
        try {
            if (port === null || port === undefined || port.id === 0 || port.id === null || port.id === undefined) {
                return;
            }
            if (this.savedEmailSchedule.id === this.scheduleId && port.id === this.savedEmailSchedule.port.id) {
                return;
            }
        }
        catch (ex) {
        }
        var params = {};
        if (!+this.scheduleId) {
            params = {
                scheduleId: this.scheduleId
            };
        }
        var body = {
            scheduleId: this.scheduleId,
            type: 'port',
            portId: port.id
        };
        this.onStatusChange('saving');
        this.service.set(params, body).then(function (schedule) {
            schedule.port = port;
            _this.onSaved(schedule);
        }).catch(function (err) {
            _this.onStatusChange('error');
        });
    };
    EmailScheduleComponent.prototype.populateVessel = function (vessel) {
        var _this = this;
        try {
            if (vessel === null || vessel === undefined || vessel.id === 0 || vessel.id === null || vessel.id === undefined) {
                return;
            }
            if (this.savedEmailSchedule.id === this.scheduleId && vessel.id === this.savedEmailSchedule.vessel.id) {
                return;
            }
        }
        catch (ex) {
        }
        var params = {};
        if (!+this.scheduleId) {
            params = {
                scheduleId: this.scheduleId
            };
        }
        var body = {
            scheduleId: this.scheduleId,
            type: 'vessel',
            vesselId: vessel.id
        };
        this.onStatusChange('saving');
        this.service.set(params, body).then(function (schedule) {
            schedule.vessel = vessel;
            _this.onSaved(schedule);
        }).catch(function (err) {
            _this.onStatusChange('error');
        });
    };
    EmailScheduleComponent.prototype.populateRoute = function (route) {
        var _this = this;
        this.showRoutes = false;
        this.inputOne = route.originName;
        this.originId = route.originId;
        this.originName = route.originName;
        this.inputTwo = route.destinationName;
        this.destinationId = route.destinationId;
        this.destinationName = route.destinationName;
        var params = {};
        if (!+this.scheduleId) {
            params = {
                scheduleId: this.scheduleId
            };
        }
        var body = {
            scheduleId: this.scheduleId,
            type: 'portPair',
            originPortId: this.originId,
            destinationPortId: this.destinationId
        };
        this.onStatusChange('saving');
        this.service.set(params, body).then(function (schedule) {
            schedule.originPort = {
                id: _this.originId,
                name: _this.originName
            };
            schedule.destinationPort = {
                id: _this.destinationId,
                name: _this.destinationName
            };
            _this.onSaved(schedule);
        }).catch(function (err) {
            _this.onStatusChange('error');
        });
    };
    EmailScheduleComponent.prototype.clear = function () {
        this.inputOne = '';
        this.originId = 0;
        this.originName = '';
        this.inputTwo = '';
        this.destinationId = 0;
        this.destinationName = '';
    };
    EmailScheduleComponent.prototype.portPair = function () {
        this.message = '';
        if (this.scheduleType !== 'portPair') {
            this.clear();
        }
        if (this.savedScheduleType === 'portPair') {
            this.inputOne = this.savedEmailSchedule.originPort.name;
            this.originId = this.savedEmailSchedule.originPort.id;
            this.originName = this.savedEmailSchedule.originPort.name;
            this.inputTwo = this.savedEmailSchedule.destinationPort.name;
            this.destinationId = this.savedEmailSchedule.destinationPort.id;
            this.destinationName = this.savedEmailSchedule.destinationPort.name;
        }
        this.scheduleType = 'portPair';
    };
    EmailScheduleComponent.prototype.vessel = function () {
        this.message = '';
        if (this.scheduleId !== 'vessel') {
            this.clear();
        }
        if (this.savedScheduleType === 'vessel') {
            this.inputOne = this.savedEmailSchedule.vessel.name;
        }
        this.scheduleType = 'vessel';
    };
    EmailScheduleComponent.prototype.singlePort = function () {
        this.message = '';
        if (this.scheduleType !== 'port') {
            this.clear();
        }
        if (this.savedScheduleType === 'port') {
            this.inputOne = this.savedEmailSchedule.port.name;
        }
        this.scheduleType = 'port';
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], EmailScheduleComponent.prototype, "status", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], EmailScheduleComponent.prototype, "scheduleChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], EmailScheduleComponent.prototype, "delivery", null);
    EmailScheduleComponent = __decorate([
        core_1.Component({
            selector: 'email-schedule',
            template: __webpack_require__(740),
            styles: [__webpack_require__(741)],
            providers: [email_schedule_service_1.EmailScheduleService]
        }),
        __metadata("design:paramtypes", [email_schedule_service_1.EmailScheduleService])
    ], EmailScheduleComponent);
    return EmailScheduleComponent;
}());
exports.EmailScheduleComponent = EmailScheduleComponent;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var EmailScheduleService = (function () {
    function EmailScheduleService(api, logger, app) {
        this.api = api;
        this.logger = logger;
        this.app = app;
    }
    EmailScheduleService.prototype.set = function (params, body) {
        var _this = this;
        return this.api.getApiClient().then(function (client) { return _this.callSet(client, params, body); });
    };
    EmailScheduleService.prototype.callSet = function (apigClient, paramsToSend, bodyToSend) {
        var _this = this;
        this.logger.log('email-schedule.service', 'callSet', paramsToSend);
        this.logger.log('email-schedule.service', 'callSet', bodyToSend);
        return new Promise(function (resolve, reject) {
            var params = paramsToSend;
            var body = bodyToSend;
            var additionalParams = { headers: { 'Content-Type': 'application/json' } };
            try {
                apigClient.userEmailDeliverySchedulesPost(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('email-schedule.service', 'post result', result);
                    var schedule = result.data.emailSchedules[result.data.emailSchedules.length - 1];
                    resolve(schedule);
                }).catch(function (err) {
                    reject(err);
                    _this.api.handleError(err);
                });
            }
            catch (ex) {
                reject('error occurred');
            }
        });
    };
    EmailScheduleService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.LogService, shared_1.AppContext])
    ], EmailScheduleService);
    return EmailScheduleService;
}());
exports.EmailScheduleService = EmailScheduleService;


/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = "<div class=\"email-delivery-section-innner col-holder\">\r\n    <div class=\"col1of5\">\r\n        <div>\r\n            <input [checked]=\"scheduleType === 'portPair'\" (click)=\"portPair()\" class=\"radio-hide\" type=\"radio\" id=\"port-pair-{{scheduleId}}\" value=\"yourself\" name=\"email-delivery-one-{{scheduleId}}\"><label attr.for=\"port-pair-{{scheduleId}}\" class=\"radio-label\"><span></span></label><label attr.for=\"port-pair-{{scheduleId}}\">Port Pair</label>\r\n        </div>\r\n        <div>\r\n            <input [checked]=\"scheduleType === 'vessel'\" (click)=\"vessel()\" class=\"radio-hide\" type=\"radio\" id=\"vessel-{{scheduleId}}\" value=\"others\" name=\"email-delivery-one-{{scheduleId}}\"><label attr.for=\"vessel-{{scheduleId}}\" class=\"radio-label\"><span></span></label><label attr.for=\"vessel-{{scheduleId}}\">Vessel</label>\r\n        </div>\r\n        <div>\r\n            <input [checked]=\"scheduleType === 'port'\" (click)=\"singlePort()\" class=\"radio-hide\" type=\"radio\" id=\"single-port-{{scheduleId}}\" value=\"others\" name=\"email-delivery-one-{{scheduleId}}\"><label attr.for=\"single-port-{{scheduleId}}\" class=\"radio-label\"><span></span></label><label attr.for=\"single-port-{{scheduleId}}\">Single Port</label>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"scheduleType === 'portPair'\" class=\"col4of5 col-holder\">\r\n        <div class=\"col1of2\">\r\n            <h6>Origin</h6>\r\n            <search-box [id]=\"scheduleId + 'origin'\" [display]=\"inputOne\" [type]=\"'port'\" (select)=\"update('origin', $event)\" type=\"text\">loading...</search-box>\r\n        </div>\r\n        <div class=\"col1of2\">\r\n            <h6>Destination</h6>\r\n            <search-box [id]=\"scheduleId + 'destination'\" [display]=\"inputTwo\" [type]=\"'port'\" (select)=\"update('destination', $event)\" class=\"destination-input\" type=\"text\">loading...</search-box>\r\n        </div>\r\n        <a class=\"saved-schedule-btn\" (click)=\"toggleRoutes()\"><img title=\"Saved Routes\" src=\"../img/routesave-01.svg\" onerror=\"this.onerror=null; this.src='../img/routesave-01.png'\" /></a>\r\n        <div *ngIf=\"showRoutes\" class=\"auto-complete saved-schedule-autocomplete\">\r\n            <ul *ngFor=\"let route of service.app.routes; let last = last\">\r\n                <li (click)=\"populateRoute(route)\">\r\n                {{ route.originName }} &#8594; {{ route.destinationName }}\r\n                </li>\r\n                <div *ngIf=\"!last\" class=\"saved-routes-line\"></div>\r\n            </ul>\r\n        </div>\r\n        <p><i>Port Name or code</i></p>\r\n        <p *ngIf=\"message !== ''\" class=\"mt10 message\">{{ message }}</p>\r\n    </div>\r\n    <div *ngIf=\"scheduleType === 'vessel'\" class=\"col4of5 col-holder\">\r\n        <div>\r\n            <h6>Vessel</h6>\r\n            <search-box [id]=\"scheduleId\" [display]=\"inputOne\" [type]=\"'vessel'\" (select)=\"update('vessel', $event)\" class=\"vessel-name-input\" type=\"text\">loading...</search-box>\r\n        </div>\r\n        <p><i>Vessel Name or IMO number</i></p>\r\n        <p *ngIf=\"message !== ''\" class=\"mt10 message\">{{ message }}</p>\r\n    </div>\r\n    <div *ngIf=\"scheduleType === 'port'\" class=\"col4of5 col-holder\">\r\n        <div>\r\n            <h6>Port</h6>\r\n            <search-box [id]=\"scheduleId\" [display]=\"inputOne\" [type]=\"'port'\" (select)=\"update('port', $event)\" type=\"text\">loading...</search-box>\r\n        </div>\r\n        <p><i>Port Name or code</i></p>\r\n        <p *ngIf=\"message !== ''\" class=\"mt10 message\">{{ message }}</p>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = ".email-delivery-section-innner > .col1of5 {\n  padding: 15px; }\n\n.email-delivery-section-innner > .col4of5 {\n  padding: 15px;\n  border-left: 1px solid #c1c1c1; }\n  .email-delivery-section-innner > .col4of5 .col1of2 {\n    width: calc(50% - 30px); }\n\n.vessel-name-input {\n  width: calc(100% - 20px); }\n\n.saved-schedule-btn {\n  position: relative;\n  top: 29px;\n  left: -5px;\n  line-height: 28px;\n  font-size: 30px;\n  height: 34px;\n  width: 55px;\n  padding: 0;\n  text-align: center;\n  vertical-align: middle; }\n  .saved-schedule-btn img {\n    height: 34px; }\n  .saved-schedule-btn:hover {\n    border: none; }\n\n.saved-schedule-autocomplete {\n  top: 169px;\n  right: 50px; }\n\n.saved-routes-line {\n  display: block;\n  height: 1px;\n  width: 50%;\n  margin: auto;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  background: #d4d4d4; }\n\n.destination-input {\n  min-width: 220px;\n  width: 220px;\n  max-width: 220px;\n  margin-right: 5px; }\n\n@media only screen and (max-width: 1200px) {\n  .email-delivery-section-innner > .col1of5 {\n    width: 142px;\n    padding-left: 15px !important; }\n  .email-delivery-section-innner > .col4of5 {\n    width: calc(100% - 143px);\n    padding-left: 15px !important; }\n    .email-delivery-section-innner > .col4of5 .col1of2 {\n      width: 100%; }\n  .destination-input {\n    width: 250px;\n    min-width: 250px; }\n  .saved-schedule-btn {\n    top: 11px;\n    float: right;\n    left: initial;\n    margin-right: 10px; } }\n\n@media only screen and (max-width: 980px) {\n  .email-delivery-section-innner > .col4of5 .col1of2 {\n    width: 50%; }\n    .email-delivery-section-innner > .col4of5 .col1of2 input[type=\"text\"] {\n      max-width: 195px;\n      max-width: 195px;\n      min-width: 195px; }\n  .saved-schedule-btn {\n    top: 62px;\n    float: none;\n    left: initial;\n    margin-left: -10px; } }\n\n@media only screen and (max-width: 860px) {\n  .email-delivery-section-innner > .col4of5 .col1of2 {\n    width: 100%; }\n    .email-delivery-section-innner > .col4of5 .col1of2 input[type=\"text\"] {\n      max-width: 250px;\n      min-width: 250px; }\n  .saved-schedule-btn {\n    top: 11px;\n    float: right;\n    left: initial;\n    margin-right: 11px; }\n  .saved-schedule-autocomplete {\n    top: 133px; } }\n\n@media only screen and (max-width: 599px) {\n  .email-delivery-section-innner > .col4of5 .col1of2 input[type=\"text\"] {\n    max-width: calc(100% - 30px);\n    min-width: calc(100% - 30px); } }\n\n@media only screen and (max-width: 499px) {\n  .email-delivery-section-innner > .col1of5 {\n    width: 100%; }\n  .email-delivery-section-innner > .col4of5 {\n    border-left: none;\n    border-top: 1px solid #c1c1c1;\n    width: 100%; }\n  .saved-schedule-autocomplete {\n    top: 260px;\n    max-width: calc(100% - 27px); } }\n"

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var _1 = __webpack_require__(246);
var accountRoutes = [
    {
        path: '',
        component: _1.AccountComponent,
        children: [
            { path: '', component: _1.MyFavoritesComponent },
            { path: 'favorites', component: _1.MyFavoritesComponent },
            { path: 'information', component: _1.AccountInformationComponent },
            { path: 'invoices', component: _1.InvoicesComponent },
            { path: 'profile', component: _1.ProfileComponent },
            { path: 'data-by-email', component: _1.EmailDeliveryComponent }
        ]
    }
];
var AccountRoutingModule = (function () {
    function AccountRoutingModule() {
    }
    AccountRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(accountRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        })
    ], AccountRoutingModule);
    return AccountRoutingModule;
}());
exports.AccountRoutingModule = AccountRoutingModule;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(744));


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(30);
var FiveReasonsToComponent = (function (_super) {
    __extends(FiveReasonsToComponent, _super);
    function FiveReasonsToComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = '5 Reasons to Use Scheduling Data - Linescape';
        _this.description = 'With over 50,000 merchant ships transporting 90% of the world’s trade by sea, how do you plan to navigate around that traffic jam?';
        return _this;
    }
    FiveReasonsToComponent = __decorate([
        core_1.Component({
            selector: 'five-reasons-to',
            template: __webpack_require__(746),
            styles: [__webpack_require__(27), __webpack_require__(747)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], FiveReasonsToComponent);
    return FiveReasonsToComponent;
}(blog_page_1.BlogPage));
exports.FiveReasonsToComponent = FiveReasonsToComponent;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BlogPage = (function () {
    function BlogPage(route, app, seo) {
        this.route = route;
        this.app = app;
        this.seo = seo;
        this.title = 'Linescape Blog Page';
        this.description = "Linescape";
    }
    BlogPage.prototype.ngOnInit = function () {
        this.seo.set(this.title, this.description);
    };
    BlogPage.prototype.ngAfterViewInit = function () {
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    return BlogPage;
}());
exports.BlogPage = BlogPage;


/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>5 Reasons to Use Scheduling Data</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <img class=\"featured-image\" src=\"../../../img/five-reasons-image.png\">\r\n            <h6 class=\"author-sub-head\">Feb 6th, 2017</h6>\r\n            <p>With over 50,000 merchant ships transporting 90% of the world’s trade by sea, how do you plan to navigate around that traffic jam?</p>\r\n            <p>Since you’re not at the helm and, even if you were, you can’t exactly take a shortcut, the best thing you can do is plan well. Shipping analysts and experts say the future of logistics and transportation is in IT and data solutions. That’s why having more scheduling data at your fingertips would be a big help. Good thing <a [routerLink]=\"['']\">Linescape’s</a> search tool lets you filter by ports, vessels and carriers, enabling users to map out the best and most cost-efficient routes.</p>\r\n            <p>Here are 5 reasons why you should use scheduling data and how it can save you time and money.</p>\r\n            <h6>1. Time is money in the shipping business.</h6>\r\n            <p>Do you remember when Expedia and TripAdvisor first came out? You could finally search for the cheapest flights and most affordable hotels on your own. The power was finally in your hands.</p>\r\n            <p>Now, think about it in shipping terms. With IT scheduling solutions, you’re in the driver’s seat when it comes to finding the optimal routes and schedules to save you time and money. Plus, you receive all of that data neatly packaged and delivered direct to your inbox.</p>\r\n            <h6>2. \"Shipping by water is cheaper than by rail, which is cheaper than by truck.\" - <i>Rick Scott - Governor of Florida</i></h6>\r\n            <p>This is usually true -- unless your shipment is delayed, damaged or lost. That’s where a powerful search engine comes in handy, giving you access to a solution that filters data by port, carrier and vessel.</p>\r\n            <h6>3. Sell, Ship, Win Worldwide</h6>\r\n            <p>E-commerce sales and growth is on the rise. Sales will reach nearly $500 billion in 2018, according to trends and data by <a href=\"https://www.internetretailer.com/trends/sales/us-e-commerce-sales-2013-2017/\" target=\"_blank\">Internet Retailer</a>. This presents tremendous opportunity for businesses, but also challenges that cannot be underestimated. Small and large businesses alike can track liner shipping schedules to deliver products on time and foster customer loyalty. Everyone wins! </p>\r\n            <h6>4. Support the growing global economy</h6>\r\n            <p>This year’s theme for the <a href=\"http://www.imo.org/en/About/Events/WorldMaritimeDay/Pages/WMD-2017.aspx\" target=\"_blank\">2017 World Maritime Day</a> is “Connecting Ships, Ports and People,” celebrating the maritime sector as a wealth creator on both land and sea. IT solutions such as <a [routerLink]=\"['']\">Linescape’s</a> scheduling and data mining tools help you maximize the efficiency of ocean container shipping and contribute to a sustainable world economy.</p>\r\n            <h6>5. Make data feeds part of your shipping strategy</h6>\r\n            <p>There is no budget too small or too big that wouldn’t benefit from automating the process of gathering, checking and consolidating carrier schedule data. That’s where Linescape’s data feeds plays a vital role. Just prioritize your data needs and build your own schedule by origin and destination, vessel name or IMO, port arrivals and departures. Customize three to five feeds and your next shipment is just one click away!</p>\r\n            <p>Your Opinion:  We want to hear how you use ocean container shipping schedules as part of your logistics strategy? Please share your thoughts in the comment section below.</p>\r\n            <p><b>Sources:</b> <i><a href=\"http://www.ics-shipping.org/\" target=\"_blank\">International Chamber of Shipping</a></i></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(749));


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(30);
var SampleNewsComponent = (function (_super) {
    __extends(SampleNewsComponent, _super);
    function SampleNewsComponent(route, app, seo) {
        return _super.call(this, route, app, seo) || this;
    }
    SampleNewsComponent = __decorate([
        core_1.Component({
            selector: 'sample-news',
            template: __webpack_require__(750),
            styles: [__webpack_require__(27), __webpack_require__(751)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], SampleNewsComponent);
    return SampleNewsComponent;
}(blog_page_1.BlogPage));
exports.SampleNewsComponent = SampleNewsComponent;


/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Sample Title</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Dec 16th, 2016</h6>\r\n            <p>Launched in May 2009, Linescape was the first independent website to present a comprehensive and impartial overview of the routes and schedules of all the world's containership lines, thus giving shippers and forwarders the freedom and ease to choose the carrier and vessel best suited to any particular shipment.</p>\r\n            <p>Relaunched in October 2016, the new Linescape website is more powerful and versatile. You can now search schedules from any view: by port pairs, by vessel name, by port of call or by carrier. Our data comprises routes and schedules from over 100 carriers, all of which is regularly updated, allowing shippers and forwarders to quickly and easily find alternatives.</p>\r\n            <h6>Saving Time</h6>\r\n            <p>We believe that the process of finding a carrier should be a simple one. Our aim is to help achieve this by presenting routing and scheduling information in a clear and easy to understand format, in order to save you time.</p>\r\n            <p>Linescape is dedicated to listening to our users. Our new website was developed based on your feedback, and we have incorporated premium and professional subscriptions for more data, and new ways of searching and downloading data, as well as offering subscribers “mini data feeds”.</p>\r\n            <p>We hope you enjoy the new Linescape website and we look forward to your feedback.</p>\r\n            <h6>Linescape - Finding Alternatives. Saving Time. . . F A S T</h6>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <div *ngIf=\"app.accountType === ''\">\r\n                <div class=\"sidebar-section\">\r\n                    <h6>Follow us</h6>\r\n                    <div class=\"social-links\">\r\n                        <ul>\r\n                            <li><a href=\"http://www.facebook.com/pages/Linescape/127633963941865\" target=\"_blank\"><img src=\"../img/facebook-logotype-button.png\"></a></li>\r\n                            <li><a href=\"http://www.linkedin.com/company/linescape\" target=\"_blank\"><img src=\"../img/linkedin-logotype-button.png\"></a></li>\r\n                            <li><a href=\"http://twitter.com/Linescape\" target=\"_blank\"><img src=\"../img/twitter-logo.png\"></a></li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n                <div class=\"sidebar-section\">\r\n                    <h6>Register for Extra Features</h6>\r\n                    <p>Registering is quick and easy, in order to take advantage of these useful features:</p>\r\n                    <ul>\r\n                        <li>Save routes for easy searching again.</li>\r\n                        <li>Email schedules for immediate action.</li>\r\n                        <li>Print schedules for your files.</li>\r\n                        <li>Save carrier info for quick access.</li>\r\n                    </ul>\r\n                    <p class=\"text-center\"><a [routerLink]=\"['/register']\" class=\"btn text-center\">Try Now</a></p>\r\n                </div>\r\n            </div>\r\n            <div *ngIf=\"app.accountType !== '' && (app.accountType !== 'Professional' || app.accountType !== 'Enterprise')\">\r\n                <div class=\"sidebar-section\">\r\n                    <h6>Follow us</h6>\r\n                    <div class=\"social-links\">\r\n                        <ul>\r\n                            <li><a href=\"http://www.facebook.com/pages/Linescape/127633963941865\" target=\"_blank\"><img src=\"../img/facebook-logotype-button.png\"></a></li>\r\n                            <li><a href=\"http://www.linkedin.com/company/linescape\" target=\"_blank\"><img src=\"../img/linkedin-logotype-button.png\"></a></li>\r\n                            <li><a href=\"http://twitter.com/Linescape\" target=\"_blank\"><img src=\"../img/twitter-logo.png\"></a></li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n                <div class=\"sidebar-section\">\r\n                    <h6>Upgrade for Extra Features</h6>\r\n                    <p>Upgrade in order to take advantage of these useful features:</p>\r\n                    <ul>\r\n                        <li>Local carrier contact information.</li>\r\n                        <li>Information on trip transhipments</li>\r\n                        <li>Vessel Management Data</li>\r\n                    </ul>\r\n                    <p class=\"text-center\"><a  [routerLink]=\"['../../account/information']\" class=\"btn text-center\">Try Now</a></p>\r\n                </div>\r\n            </div>\r\n            <div *ngIf=\"app.accountType === 'Professional' || app.accountType === 'Enterprise'\" class=\"sidebar-section\">\r\n                <div class=\"plans-sidebar plans-sidebar-1\">\r\n                    <div class=\"plans-sidebar-section\">\r\n                    <img src=\"../img/datafeed.svg\" onerror=\"this.onerror=null; this.src='../img/datafeed.png'\">\r\n                    <h5>Data Feeds</h5>\r\n                    <p class=\"small-text\">Integrate schedule data directly into your system.</p>\r\n                    <p>Reduce Errors</p>\r\n                    <p>Save time</p>\r\n                    <p>Cut Costs</p>\r\n                    <p class=\"small-text\">Choose either API or FTP delivery.</p>\r\n                    </div>\r\n                    <div class=\"plans-sidebar-section\">\r\n                    <img class=\"small-image\" src=\"../img/api.svg\" onerror=\"this.onerror=null; this.src='../img/api.png'\">\r\n                    <h6>Live Data by API</h6>\r\n                    <p>Real Time Data</p>\r\n                    <p>No Hosting</p>\r\n                    <p>On Demand</p>\r\n                    </div>\r\n                    <div>\r\n                    <img class=\"small-image\" src=\"../img/ftp.svg\" onerror=\"this.onerror=null; this.src='../img/ftp.png'\">\r\n                    <h6>Bulk Data by FTP</h6>\r\n                    <p>Regular Updates</p>\r\n                    <p>Hosted Locally</p>\r\n                    <p>Tailor-Made</p>\r\n                    <a [routerLink]=\"['../bulk-data-feeds']\" class=\"btn\">Get a Quote</a><br>\r\n                    <a [routerLink]=\"['../bulk-data-feeds']\" class=\"link\">Learn More</a>\r\n                    </div>\r\n                </div>\r\n                <div class=\"plans-sidebar plans-sidebar-2\">\r\n                    <div class=\"plans-sidebar-section\">\r\n                        <img class=\"small-image\" src=\"../img/api.svg\" onerror=\"this.onerror=null; this.src='../img/api.png'\">\r\n                        <h6>Live Data by API</h6>\r\n                        <p>Real Time Data</p>\r\n                        <p>No Hosting</p>\r\n                        <p>On Demand</p>\r\n                    </div>\r\n                    <div class=\"plans-sidebar-section hide980\">\r\n                        <img src=\"../img/datafeed.svg\" onerror=\"this.onerror=null; this.src='../img/datafeed.png'\">\r\n                        <h6>Data Feeds</h6>\r\n                        <p class=\"small-text\">Integrate schedule data directly into your system.</p>\r\n                        <p>Reduce Errors</p>\r\n                        <p>Save time</p>\r\n                        <p>Cut Costs</p>\r\n                        <p class=\"small-text\">Choose either API or FTP delivery.</p>\r\n                    </div>\r\n                    <div class=\"plans-sidebar-section\">\r\n                        <img class=\"small-image\" src=\"../img/ftp.svg\" onerror=\"this.onerror=null; this.src='../img/ftp.png'\">\r\n                        <h6>Bulk Data by FTP</h6>\r\n                        <p>Regular Updates</p>\r\n                        <p>Hosted Locally</p>\r\n                        <p>Tailor-Made</p>\r\n                    </div>\r\n                    <div class=\"mt10\">\r\n                        <a class=\"btn\">Get a Quote</a>\r\n                        <a [routerLink]=\"['../../bulk-data-feeds']\" class=\"link\">Learn More</a>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(753));


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var BlogRollComponent = (function () {
    function BlogRollComponent(route, seo) {
        this.route = route;
        this.seo = seo;
        this.title = 'Ocean Container Shipping Search Engine Blog - Linescape';
        this.description = 'Get the latest news from Linescape, the first independent liner shipping search engine dedicated to ocean container sailing schedules.';
        // Do stuff
    }
    BlogRollComponent.prototype.ngOnInit = function () {
        this.seo.set(this.title, this.description);
    };
    BlogRollComponent.prototype.ngAfterViewInit = function () {
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    BlogRollComponent = __decorate([
        core_1.Component({
            selector: 'blog-roll',
            template: __webpack_require__(754),
            styles: [__webpack_require__(27), __webpack_require__(755)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.SeoService])
    ], BlogRollComponent);
    return BlogRollComponent;
}());
exports.BlogRollComponent = BlogRollComponent;


/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n        <h2>Blog</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <h3 class=\"blog-mobile-title\">Blog Posts</h3>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2018-3-5-analytics-answer-your-questions', {scroll:true}]\">How Big Data is a Game-Changer in Ocean-Container Shipping</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Mar 5th, 2018</p>\r\n          <p>What is the most important question for your business today? Reducing costs? Increasing revenue? Optimizing transit times?</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2017-8-21-five-outcomes-of-super-sizing-shipping-industry', {scroll:true}]\">5 Outcomes of Super-Sizing the Shipping Industry</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Aug 21st, 2017</p>\r\n          <p>The gradual recovery of global trade has boosted demand for container shipping by 6% this year, said Soren Skou, chief executive officer at A.P. Moller-Maersk (Maersk), in a recent interview with Bloomberg.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2017-3-16-glass-half-full-in-shippings-murky-waters', {scroll:true}]\">Seeing the Glass Half Full in Shipping's Murky Waters</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Mar 16th, 2017</p>\r\n          <p>You would think new investment in America’s infrastructure would mean a rosier outlook for the shipping industry. But many are unsure whether to see the glass half full or half empty.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2017-2-6-five-reasons-to-use-scheduling-data', {scroll:true}]\">5 Reasons to Use Scheduling Data </a></h6>\r\n          <p class=\"blog-entry-sub-head\">Feb 6th, 2017</p>\r\n          <p>With over 50,000 merchant ships transporting 90% of the world’s trade by sea, how do you plan to navigate around that traffic jam?</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2017-1-30-five-trends-shaping-thee-global-maritime-industry', {scroll:true}]\">5 Trends Shaping the Global Maritime Industry </a></h6>\r\n          <p class=\"blog-entry-sub-head\">Jan 30th, 2017</p>\r\n          <p>As much as the global economy relies on international shipping to keep vital commodities moving safely and efficiently, the maritime industry relies on the world’s economies to keep driving the demand for shipping.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2017-1-23-walmart-amazon-take-retail-shipping-wars-to-sea', {scroll:true}]\">Walmart, Amazon Take Retail Shipping Wars to Sea</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Jan 23rd, 2017</p>\r\n          <p>It’s official – the battle between the world’s largest retailers has taken to sea. Retailers are scrambling to claim their share of the global e-commerce market and ocean container shipping is a key piece of the puzzle.</p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = ".page-content {\n  padding-top: 40px; }\n  .page-content p, .page-content li, .page-content div, .page-content label {\n    font-size: 16px;\n    line-height: 24px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 50%;\n    padding-right: 40px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-right {\n    display: inline-block;\n    width: 50%;\n    padding-left: 40px;\n    vertical-align: top;\n    border-left: 1px solid #d4d4d4; }\n    .page-content .page-content-right p, .page-content .page-content-right li, .page-content .page-content-right div, .page-content .page-content-right label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .blog-entry {\n    margin-bottom: 30px; }\n    .page-content .blog-entry h6 {\n      margin-bottom: 0;\n      margin-top: 0; }\n  .page-content .news-entry {\n    margin-bottom: 20px; }\n    .page-content .news-entry h6 {\n      margin-bottom: 0; }\n  .page-content .blog-mobile-title,\n  .page-content .news-mobile-title {\n    display: none;\n    border-bottom: 1px solid #d4d4d4; }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-left: 0; }\n  .page-content .page-content-right {\n    width: 100%;\n    display: inline-block;\n    padding-right: 0;\n    padding-left: 0;\n    border-left: none; }\n  .page-content .news-entry {\n    margin-bottom: 20px; }\n  .page-content .blog-mobile-title,\n  .page-content .news-mobile-title {\n    display: block; }\n  .page-content .news-entry-snippet {\n    display: none; } }\n"

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(757));


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(30);
var FiveTrendsShapingComponent = (function (_super) {
    __extends(FiveTrendsShapingComponent, _super);
    function FiveTrendsShapingComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = '5 Trends Shaping the Global Maritime Industry - Linescape';
        _this.description = 'As much as the global economy relies on international shipping to keep vital commodities moving safely and efficiently, the maritime industry relies on the world’s economies to keep driving the demand for shipping.';
        return _this;
    }
    FiveTrendsShapingComponent = __decorate([
        core_1.Component({
            selector: 'five-trends-shaping',
            template: __webpack_require__(758),
            styles: [__webpack_require__(27), __webpack_require__(759)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], FiveTrendsShapingComponent);
    return FiveTrendsShapingComponent;
}(blog_page_1.BlogPage));
exports.FiveTrendsShapingComponent = FiveTrendsShapingComponent;


/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>5 Trends Shaping the Global Maritime Industry</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <img class=\"featured-image\" src=\"../../../img/five-trends-shaping-image.png\">\r\n            <h6 class=\"author-sub-head\">Jan 30th, 2017</h6>\r\n            <p>As much as the global economy relies on international shipping to keep vital commodities moving safely and efficiently, the maritime industry relies on the world’s economies to keep driving the demand for shipping.</p>\r\n            <p>But with everything from a slowdown in developing countries to a drop in China’s GDP to Iran’s re-entry into the oil export market shaking up ocean freight rates, it’s hard to know if shipping demand will ramp up or wane? How can any business accurately budget shipping costs with this kind of volatility?</p>\r\n            <p>You can try hedging the rates by following the ocean freight indices that set rate levels, including the <a href=\"http://en.sse.net.cn/\" target=\"_blank\">Shanghai Containerized Freight Index</a>, <a href=\"http://www.worldcontainerindex.com/\" target=\"_blank\">World Container Index</a> of <a href=\"http://www.drewry.co.uk/\" target=\"_blank\">Drewry Shipping Consultants Ltd.</a> and <a href=\"http://en.wikipedia.org/wiki/Baltic_Dry_Index\" target=\"_blank\">Baltic Dry Index</a>. However, the practice of hedging freight rates has yet to be widely embraced by shippers and carriers alike.</p>\r\n            <p>Your next best bet is to make an educated guess and look to industry trends as an indicator. A great resource is the <a href=\"http://www.ihs.com/industry/maritime.html\" target=\"_blank\">IHS Maritime and Trade</a>, where experts forecast key market drivers and global trends that will shape the maritime industry for the upcoming year. To make it easy, we created a list of the most influential trends that could impact the ocean container shipping industry -- rates, schedules and all.</p>\r\n            <h6>Trend #1: Commodity supercycle loses momentum</h6>\r\n            <p>The 15-year commodity supercycle has come to an end. IHS forecasts a lasting weakness in commodity prices over the next decade. Prices for coal, iron ore and crude oil remain depressed for the next few years. This slow growth will affect shippers with ailing shipping rates, particularly dry bulk shipping. Tanker shipping is the exception, which is expected to stay strong in the short term.</p>\r\n            <h6>Trend #2: China's slowdown slows shipping</h6>\r\n            <p>China’s GDP is expected to rebound slowly in 2017 after a drop to 6.3% in 2016. Its recent economic slowdown is affecting many domestic industries, with implications for the global maritime economy. Dry bulk shipping has been hurt by the shrinking of China’s demand for commodities. Another difficulty for shipping is the decline in imports of thermal coal to China. One bright spot in Chinese shipping is expected growth in container trade.</p>\r\n            <h6>Trend #3: Lifting of Iranian sanctions: Boon to shipping</h6>\r\n            <p>Iran’s sanctions lifting were supposed to add half a million barrels of oil a day to the global supply by the end of 2016. Compared to Saudi Arabia and United States, which produce 10 million barrels a day, that’s sounds like a drop in the bucket. Still, extra barrels will add a few extra tons to the global shipping market.</p>\r\n            <h6>Trend #4: Big Data, less drama</h6>\r\n            <p>Knowledge is power! Shippers will benefit from increased availability of shipping data and advances in big data analytics, gaining insights into market and pricing trends. Automated Identification Systems (AIS) that track ships at sea provide information on ship operations at sea and ports. Experts believe that data analytics will help mitigate risk and transform challenges into opportunities.</p>\r\n            <h6>Trend #5: Long-term demographics shifts</h6>\r\n            <p>Emerging economies are at the forefront of demographics shifts. Parts of Asia, Africa and Latin America are experiencing middle class growth, and the subsequent an increase in spending on imported goods. India’s economy is expected to grow by 8% in 2017. The main economic driver is consumer spending, which accounts for 60% of the economy. A rise in consumer spending means opportunities for container ships. IHS indicates that more container ships will need to invest in ports, infrastructure and technology to keep up with demand.</p>\r\n            <p>Read the full report <a href=\"https://www.ihs.com/pdf/Global-Trends-Impacting-the-Maritime-Industry_235788110915583632.pdf\" target=\"_blank\">here</a></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(761));


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(30);
var WalmartAmazonTakeComponent = (function (_super) {
    __extends(WalmartAmazonTakeComponent, _super);
    function WalmartAmazonTakeComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = 'Walmart, Amazon Take Retail Shipping Wars to Sea - Linescape';
        _this.description = 'Retailers are scrambling to claim their share of the global e-commerce market and ocean container shipping is a key piece of the puzzle.';
        return _this;
    }
    WalmartAmazonTakeComponent = __decorate([
        core_1.Component({
            selector: 'walmart-amazon-take',
            template: __webpack_require__(762),
            styles: [__webpack_require__(27), __webpack_require__(763)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], WalmartAmazonTakeComponent);
    return WalmartAmazonTakeComponent;
}(blog_page_1.BlogPage));
exports.WalmartAmazonTakeComponent = WalmartAmazonTakeComponent;


/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Walmart, Amazon Take Retail Shipping Wars to Sea</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <img class=\"featured-image\" src=\"../../../img/walmart-amazon-take-image.png\">\r\n            <h6 class=\"author-sub-head\">Jan 23rd, 2017</h6>\r\n            <p>It’s official – the battle between the world’s largest retailers has taken to sea.</p>\r\n            <p>Retailers are scrambling to claim their share of the global e-commerce market and ocean container shipping is a key piece of the puzzle.</p>\r\n            <p>Amazon, Walmart and Alibaba are among the large retailers that are scaling their online business through low-cost shipping incentives, and to control costs they need to take ownership of shipping logistics.</p>\r\n            <p>As a result, transportation and logistics could be the next billion dollar opportunity for e-commerce companies, according to <a href=\"https://www.businessinsider.com/intelligence/research-store?IR=T&utm_source=businessinsider&utm_medium=content_marketing&utm_term=content_marketing_store_text_link_walmart-introduces-new-shipping-policy-to-compete-with-amazon-2017-2&utm_content=report_store_content_marketing_text_link&utm_campaign=content_marketing_store_link&vertical=ecommerce#%21/The-Future-of-Shipping-Report/p/68220326/\" target=\"_blank\">The Future of Shipping Report</a>. In fact, the global shipping market, including ocean, air, and truck freight, is a $2.1 trillion market, report the World Bank, Boeing and Golden Valley Co.</p>\r\n            <p>After U.S. subscribers to Amazon Prime, a $99 annual subscription that gets you free two-day shipping, grew to over 60 million in 2016, up from 10 million in 2013, the Seattle-based retailer began managing logistics for carriers, shipping products from Chinese merchant partners to its U.S. warehouses via ocean freighters. Their strategy is to control costs while growing Amazon Prime.</p>\r\n            <p>But not so fast Amazon. Walmart is moving full steam ahead with plans to overhaul ShippingPass, its $50-per-year shipping service for all online purchases. Now it offers free two-day shipping with minimum purchase of $35 – with no membership required. By offering the best fast and “free” shipping deal, Walmart aims to undercut Amazon’s Prime business. Similarly, Walmart has begun leasing shipping containers to transport manufactured goods from China in an effort to control its shipping costs.</p>\r\n            <p>But Amazon and Walmart are not the only game in town – don’t forget about Chinese e-commerce behemoth Alibaba. Like its competitors, Alibaba began leasing containers on ships, providing first-mile shipping for third-party merchants, reports <a href=\"http://www.businessinsider.com/walmart-introduces-new-shipping-policy-to-compete-with-amazon-2017-2\" target=\"_blank\">BI Intelligence</a>.</p>\r\n            <p>With Amazon, Alibaba and Walmart owning shipping logistics, the big retailers are well positioned to go to battle – and disrupt the global shipping industry while they’re at it.</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(765));


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(30);
var GlassHalfFullComponent = (function (_super) {
    __extends(GlassHalfFullComponent, _super);
    function GlassHalfFullComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Seeing the Glass Half Full in Shipping's Murky Waters - Linescape";
        _this.description = "You would think new investment in America’s infrastructure would mean a rosier outlook for the shipping industry. But many are unsure whether to see the glass half full or half empty.";
        return _this;
    }
    GlassHalfFullComponent = __decorate([
        core_1.Component({
            selector: 'glass-half-full',
            template: __webpack_require__(766),
            styles: [__webpack_require__(27), __webpack_require__(767)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], GlassHalfFullComponent);
    return GlassHalfFullComponent;
}(blog_page_1.BlogPage));
exports.GlassHalfFullComponent = GlassHalfFullComponent;


/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Seeing the Glass Half Full in Shipping's Murky Waters</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Mar 16th, 2017</h6>\r\n            <p>You would think new investment in America's infrastructure would mean a rosier outlook for the shipping industry. But many are unsure whether to see the glass half full or half empty.</p>\r\n            <p>It's not surprising when policy proposals seem to be at odds with each other.</p>\r\n            <p>On the one hand, President Trump has promised to invest in American infrastructure. In fact, Wilbur L. Ross Jr., the 39th United States Secretary of Commerce, pointed out that “infrastructure is going to be a cornerstone of his presidency,” as a way to build up demand for many products.</p>\r\n            <p>On the other hand, we are hearing Trump’s tough talk on global trade agreements, proposing protectionist policies against countries that apply tariffs to American goods. This may help lower the $500 billion deficit the U.S. has with the rest of the world, but how will this fair for an industry so heavily reliant on goods being shipped to the U.S.?</p>\r\n            <p>Then there’s the uncertainty surrounding China’s industrial output. This month, China’s National People Congress implemented a 50% cut in sintering production for the first half of the month designed to improve local air quality. This temporary slowdown has already driven down shipping freight rates linked to steel-making commodities.</p>\r\n            <p>While the waters appear murky, it may just depend on your point of view. Leaders like the Hong Kong Shipowners Association Chairwoman, Sabrina Chao Sih-ming, see the glass half full. According to Chao, investment in new infrastructure projects in the U.S. is an opportunity to drive raw materials and special equipment shipments that will have to be imported in order for Trump’s infrastructure plans to be fulfilled.</p>\r\n            <p>So what is the outlook for the shipping industry under a new U.S. administration? Well, all certainty aside, the only thing that is clear is that where there are threats there is always an opportunity.</p>\r\n            <br>\r\n            <p><b>Sources:</b><br><p>\r\n            <p><i>1. Trump will be good for shipping, investor says.  Workboat. November 15, 2016.<br><a href=\"https://www.workboat.com/blogs/maritime-matters/trump-will-good-shipping-investor-says/\" target=\"_blank\">https://www.workboat.com/blogs/maritime-matters/trump-will-good-shipping-investor-says/</a></i></p>\r\n            <p><i>2. Donald Trump and shipping: what to expect next. Splash247. Jan. 20. 2017.<br><a href=\"http://splash247.com/donald-trump-shipping-expect/\" target=\"_blank\">http://splash247.com/donald-trump-shipping-expect/</a></i></p>\r\n            <p><i>3. Dry bulk market report: The China factor. Seatrade-Maritime. March 3, 2017.<br><a href=\" http://www.seatrade-maritime.com/news/asia/dry-bulk-market-report-the-china-factor.html\" target=\"_blank\"> http://www.seatrade-maritime.com/news/asia/dry-bulk-market-report-the-china-factor.html</a></i></p>\r\n            <p><i>4. Hong Kong’s maritime industry sees opportunities in Trump era. South China Morning Post. Feb. 4, 2017. <br><a href=\"http://www.scmp.com/news/hong-kong/economy/article/2068125/hong-kongs-maritime-industry-sees-opportunities-trump-era\" target=\"_blank\"> http://www.scmp.com/news/hong-kong/economy/article/2068125/hong-kongs-maritime-industry-sees-opportunities-trump-era</a></i></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(769));


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(30);
var SuperSizedShippingComponent = (function (_super) {
    __extends(SuperSizedShippingComponent, _super);
    function SuperSizedShippingComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "5 Outcomes of Super-Sizing the Shipping Industry - Linescape";
        _this.description = "The global container shipping sector has consolidated to the point that today the five biggest ocean-container lines control about 60% of the global shipping market.";
        return _this;
    }
    SuperSizedShippingComponent = __decorate([
        core_1.Component({
            selector: 'super-sized-shipping',
            template: __webpack_require__(770),
            styles: [__webpack_require__(27), __webpack_require__(771)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], SuperSizedShippingComponent);
    return SuperSizedShippingComponent;
}(blog_page_1.BlogPage));
exports.SuperSizedShippingComponent = SuperSizedShippingComponent;


/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>5 Outcomes of Super-Sizing the Shipping Industry</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Aug. 21, 2017</h6>\r\n            <p>The gradual recovery of global trade has boosted demand for container shipping by 6% this year, said Soren Skou, chief executive officer at A.P. Moller-Maersk (Maersk), in a recent interview with Bloomberg.</p>\r\n            <p>Maersk reported 8.4% revenue growth year-on-year in Q2 2017, contributing to an underlying profit of $327 million. That’s great news for the leading ocean-container carriers, but will the resurgence in demand trickle-down to the rest of the industry?</p>\r\n            <p>Hand-in-hand with the recovery is some major reshuffling of the big players.</p>\r\n            <ul>\r\n                <li>South Korea’s Hanjin Shipping Company declared bankruptcy.</li>\r\n                <li>China’s <a href=\"https://www.bloomberg.com/quote/1919:HK\">Cosco Shipping Holdings Co.</a> is buying its rival <a href=\"https://www.bloomberg.com/quote/316:HK\">Orient Overseas International Ltd.</a> for $6 billion – and getting the world’s biggest vessel along with it.</li>\r\n                <li>Maersk is buying a German competitor that has its own fleet of mega ships.</li>\r\n            </ul>\r\n            <p>The sector has consolidated to the point that today the five biggest ocean-container lines control about 60% of the global shipping market.</p>\r\n            <p>Consolidation has not only super-sized the leaders, but the top dogs are super-sizing their ships.  These larger companies are dispatching massive vessels to transport more goods in fewer shipments. There are now about 58 huge carriers worldwide that can transport more than 18,000 containers, and the number is expected to double in two years. Experts say 50% of the ships will be owned by the five largest shipping companies. This has afforded them “greater economies of scale from a cost and service perspective,” said Skou.</p>\r\n            <p>So now the big players wield much more pricing power when it comes to negotiating freight rates with mega-manufacturers and retailers like Wal-Mart Stores Inc. and Target Corp. “Demand has been outgrowing supply since the third quarter last year, which is driving up prices, with freight rates surging 22% compared to a year ago,” Skou told reporters.</p>\r\n            <p>As the saying goes, \"a rising tide lifts all boats.\" But in this latest version of shipping economics, high tides might mean that only super-sized ships rise. </p>\r\n            <br>\r\n            <img src=\"../img/super-sized-shipping.png\">\r\n            <br>\r\n\r\n            <p>Image: <i>Five ocean-container shipping companies control 60% of the $500 billion global shipping sector. Bloomberg Markets: European Open.</i></p>\r\n            <h6>5 Outcomes of Super-Sizing the Shipping Industry</h6>\r\n            \r\n                <p>1.  <b>Consolidation:</b> Five of the biggest container lines controlling about 60% of the global shipping market means the big players just keep getting bigger.</p>\r\n                <p>2.  <b>Super-Sized Ships:</b> The massive vessels ship more goods per shipment.</p>\r\n                <p>3.  <b>Increased Demand:</b> Demand continues to outgrow supply.</p>\r\n                <p>4.  <b>Negotiating Power:</b> The big box stores and manufacturers have less leverage in negotiating freight rates.</p>\r\n                <p>5.  <b>Profits:</b> The container-shipping industry is expected to become more profitable through economies of scale – in particular for the largest companies.</p>\r\n            \r\n            <p><i>*As a result of post-tax impairments of $732 million related to Maersk Tankers and APM Terminals, A.P. Moller-Maersk reported a loss of $264 million.</i></p>\r\n            <br>\r\n            <p><b>Sources:</b><br><p>\r\n            <p><i>1. 'Bloomberg Markets: European Open.'<br><a href=\"https://www.bloomberg.com/news/articles/2017-08-15/global-shipping-industry-bounces-back-from-its-lehman-moment\" target=\"_blank\">https://www.bloomberg.com/news/articles/2017-08-15/global-shipping-industry-bounces-back-from-its-lehman-moment</a></i></p>\r\n            <p><i>2. 2. A.P. Moller - Maersk improves underlying profit and grows revenue in first half of the year.<br><a href=\"http://www.maersk.com/en/the-maersk-group/press-room/press-release-archive/2017/8/a-p-moller-maersk-interim-report-q2-2017\" target=\"_blank\">http://www.maersk.com/en/the-maersk-group/press-room/press-release-archive/2017/8/a-p-moller-maersk-interim-report-q2-2017</a> Maersk.com. Press Release. August 16, 2017.</i></p>\r\n          \r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(773));


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(30);
var AnalyticsAnswerYourBusinessQuestions = (function (_super) {
    __extends(AnalyticsAnswerYourBusinessQuestions, _super);
    function AnalyticsAnswerYourBusinessQuestions(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = 'How Big Data is a Game-Changer in Ocean-Container Shipping - Linescape';
        _this.description = 'What is the most important question for your business today? Reducing costs? Increasing revenue? Optimizing transit times?';
        _super.prototype.ngOnInit.call(_this);
        return _this;
    }
    AnalyticsAnswerYourBusinessQuestions = __decorate([
        core_1.Component({
            selector: 'analytics-answer-your-business-questions',
            template: __webpack_require__(774),
            styles: [__webpack_require__(27), __webpack_require__(775)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], AnalyticsAnswerYourBusinessQuestions);
    return AnalyticsAnswerYourBusinessQuestions;
}(blog_page_1.BlogPage));
exports.AnalyticsAnswerYourBusinessQuestions = AnalyticsAnswerYourBusinessQuestions;


/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>How Big Data is a Game-Changer in Ocean-Container Shipping</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <img class=\"featured-image\" src=\"../../../img/amazon-container-ship.jpg\">\r\n            <h6 class=\"author-sub-head\">Feb 6th, 2017</h6>\r\n            <p>What is the most important question for your business today? Reducing costs? Increasing revenue? Optimizing transit times?</p>\r\n            <p>Perhaps all three questions are critical to meeting your business objectives. This is where Big Data can answer questions that have a big impact on your business.</p>\r\n            <p>Big data is “more than just ‘look-back information', of say how many TEUs you shipped in May from Shanghai to Rotterdam, but rather pulling the data necessary to ship them cheaper, faster or to achieve whatever metric you need addressed.” <sup>1</sup></p>\r\n            <p>That’s why leaders in the ocean liner shipping industry are leveraging data analytics to identify trends and gain key insights into shipping performance that will guide them in making better decisions.</p>\r\n            <p>In fact, some of the heaviest of hitters in global supply chain management are making a play for ‘smart shipping’ with <a href=\"https://www.supplychain247.com/article/maersk_alibaba_roll_out_ocean_cargo_booking_partnership/yusen_logistics\" target=\"_blank\">Alibaba's shipping platform, One Touch, partnering with Maersk</a> and <a href=\"https://www.supplychain247.com/article/amazon_enters_trillion_dollar_ocean_freight_business/yusen_logistics\" target=\"_blank\">Amazon China entering the trillion dollar ocean container industry with a new venture as a freight forwarder</a>. <sup>2</sup></p>\r\n            <p>Traditionally, shippers and freighters referenced fuel costs, transit times, wages, insurance, revenue per TEU and TEU rates. Now you can leverage time sensitive factors, such as weather and traffic delays, port strikes, changes in scheduling, unexpected repairs, and even cultural influences like holidays that can be taken into consideration as variables contributing to timeliness.</p>\r\n            <p>Analytics have become as important to the shipper as to the vendor sending the goods and the buyer receiving product on the other end. That’s why Linescape is crunching the numbers for you, offering new Analytics Reporting that provides critical insights into:</p>\r\n            <ul>\r\n                <li>On-Time Arrival Accuracy</li>\r\n                <li>Competitive Transit Times Benchmarks</li>\r\n                <li>Route Reliability Options</li>\r\n                <li>Alerts on Events that may affect scheduling changes</li>\r\n            </ul>\r\n            <p>Now you can leverage these valuable insights to make the best call when scheduling your shipments.</p>\r\n            <p>Take a hint from industry leaders like Alibaba and Amazon, Maersk and others who are staying ahead of the curve – because they have realized that Big Data is more than just a buzzword – it’s a game changer.</p>\r\n            <p><b>Sources:</b><br><p>\r\n            <p><i>1. Sorbo T. Why Big Data In Shipping And Freight Is Important. May 15, 2017. Xeneta.<br><a href=\"https://www.xeneta.com/blog/big-data-shipping-analysis\" target=\"_blank\">https://www.xeneta.com/blog/big-data-shipping-analysis</a></i></p>\r\n            <p><i>2. Changing the Ocean Shipping Game, Amazon, Alibaba, Maersk, and CMA CGM Leading the Way. Supply Chain 247.<br><a href=\"https://www.supplychain247.com/article/changing_the_ocean_shipping_game_amazon_alibaba_maersk_and_cma_cgm\" target=\"_blank\">https://www.supplychain247.com/article/changing_the_ocean_shipping_game_amazon_alibaba_maersk_and_cma_cgm</a></i></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var _1 = __webpack_require__(250);
var blogRoutes = [
    {
        path: '',
        component: _1.BlogRollComponent
    },
    {
        path: '',
        children: [
            { path: '2017-2-6-five-reasons-to-use-scheduling-data', component: _1.FiveReasonsToComponent },
            { path: 'sample-news', component: _1.SampleNewsComponent },
            { path: '2017-1-30-five-trends-shaping-thee-global-maritime-industry', component: _1.FiveTrendsShapingComponent },
            { path: '2017-1-23-walmart-amazon-take-retail-shipping-wars-to-sea', component: _1.WalmartAmazonTakeComponent },
            { path: '2017-3-16-glass-half-full-in-shippings-murky-waters', component: _1.GlassHalfFullComponent },
            { path: '2017-8-21-five-outcomes-of-super-sizing-shipping-industry', component: _1.SuperSizedShippingComponent },
            { path: '2018-3-5-analytics-answer-your-questions', component: _1.AnalyticsAnswerYourBusinessQuestions }
        ]
    }
];
var BlogRoutingModule = (function () {
    function BlogRoutingModule() {
    }
    BlogRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(blogRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        })
    ], BlogRoutingModule);
    return BlogRoutingModule;
}());
exports.BlogRoutingModule = BlogRoutingModule;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(778));


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var PressRollComponent = (function () {
    function PressRollComponent(router, route, seo) {
        this.router = router;
        this.route = route;
        this.seo = seo;
        this.title = 'Ocean Container Shipping Search Engine Press - Linescape';
        this.description = 'Get the latest news from Linescape, the first independent liner shipping search engine dedicated to ocean container sailing schedules.';
        // Do stuff
    }
    PressRollComponent.prototype.ngOnInit = function () {
        this.seo.set(this.title, this.description);
    };
    PressRollComponent.prototype.ngAfterViewInit = function () {
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    PressRollComponent = __decorate([
        core_1.Component({
            selector: 'press-roll',
            template: __webpack_require__(779),
            styles: [__webpack_require__(7), __webpack_require__(780)]
        }),
        __metadata("design:paramtypes", [router_1.Router, router_1.ActivatedRoute, shared_1.SeoService])
    ], PressRollComponent);
    return PressRollComponent;
}());
exports.PressRollComponent = PressRollComponent;


/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n        <h2>PRESS</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <h3 class=\"press-mobile-title\">Press Releases</h3>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2022-02-15-linescape-enhances-sailing-schedules-with-actual-tracking-data', {scroll:true}]\">Linescape Enhances Sailing Schedules with Actual Tracking Data</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – February 15, 2022</p>\r\n          <p>Updating schedules with actual departure and arrival times provides subscribers with greater visibility over their shipments</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2020-09-29-linescape-ceo-to-speak-at-global-liner-shipping-conference', {scroll:true}]\">Linescape CEO to Speak at Global Liner Shipping Conference</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – September 29, 2020</p>\r\n          <p>Linescape CEO, David Tarizzo, will give a speech entitled, “The Troubles with Sailing Schedules”, at the Global Liner Shipping Virtual Conference to be held on November 2-4, 2020</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2020-09-14-linescape-journal-of-commerce-technology', {scroll:true}]\">Linescape Featured in Journal of Commerce Technology Supplement</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – September 14, 2020</p>\r\n          <p>Sailing Schedule Data Improves Visibility and Efficiency</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2019-08-27-linescape-website-new-look', {scroll:true}]\">Linescape website gets a new look and more features</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – August 27, 2019</p>\r\n          <p>Leading Sailing Schedule data provider refreshes its website for easier use and more targeted information.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2019-05-10-linescape-celebrates-10th-anniversary', {scroll:true}]\">Linescape celebrates 10th Anniversary by adding Port Terminal Names to Port Calls</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – May 10, 2019</p>\r\n          <p>Leading Sailing Schedule data provider enhances port calls with berth or terminal names.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2018-12-7-cogoport-adds-linescape-schedules', {scroll:true}]\">Cogoport adds Linescape Sailing Schedules to live Freight Rates</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – December 7, 2018</p>\r\n          <p>Indian digital platform integrates Linescape's schedule data with real-time freight rates for instant online bookings.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2018-8-7-cogoport-adds-linescape-schedules', {scroll:true}]\">Logit One chooses Linescape as Sailing Schedule Provider</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – August 7, 2018</p>\r\n          <p>Linescape  was chosen by Logit One, Belgium, to provide consolidated sailing schedules to the Logit One platform for collaborative transport coordination, intermediation and visibility.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2018-2-27-kotahi-selects-linescape-sailing-schedules-api', {scroll:true}]\">Kotahi selects Linescape’s Sailing Schedules API</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – February 27, 2018</p>\r\n          <p>Linescape was selected by Kotahi Logistics, New Zealand, to provide consolidated sailing schedules to the Kotahi through Linescape’s API for their supply chain collaboration with customers.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2017-11-2-linescape-launches-sailing-schedule', {scroll:true}]\">Linescape Launches Sailing Schedule API for Data-on-Demand</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – November 2, 2017</p>\r\n          <p>Leading Sailing Schedule data provider launches its first API as an exciting new alternative solution to its traditional bulk data feeds.</p>\r\n        </div>  \r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2017-09-14-suzhou-yun-logistics-technology-selects-linescape', {scroll:true}]\">Suzhou Yun Logistics Technology selects Linescape Sailing Schedule Data</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – September 14, 2017</p>\r\n          <p>Leading Chinese logistics platform adds Linescape's schedules to enhance freight rate data and vessel tracking.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2017-3-20-linescape-upgrades-search-engine', {scroll:true}]\">Linescape Upgrades Sailing Schedule Search Engine to Reach a Wider Audience in the Shipping Community</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, California - March 20, 2017</p>\r\n          <p>Cutting-edge technology coupled with a new search interface provides more ways to search containership schedules, appealing to a larger shipping community.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2016-5-6-tech-stack-anniversary', {scroll:true}]\">Linescape celebrates 7th Anniversary with new Tech Stack</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – May 6, 2016</p>\r\n          <p>Leading Sailing Schedules provider migrates systems and components to new equipment and to the cloud.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2016-1-25-jf-hillebrand-to-integrate-linescape-into-tms', {scroll:true}]\">JF Hillebrand to integrate Linescape’s Sailing Schedules into TMS</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – January 25, 2016</p>\r\n          <p>JF Hillebrand, a Netherlands-based provider of high quality door to door service for shipping wines, has integrated Linescape’s Sailing Schedules into their TMS in order to improve customer experience.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2015-1-23-haven-ocean-freight-marketplace-linescape', {scroll:true}]\">Haven streamlines Ocean Freight Marketplace with Linescape Sailing Schedules</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – January 23, 2015</p>\r\n          <p>San Francisco technology company integrates Linescape's Schedule Data into their online marketplace.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2014-10-8-xeneta-adds-linescape', {scroll:true}]\">Xeneta adds Linescape Sailing Schedules to Freight Rates</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – October 8, 2014</p>\r\n          <p>Norwegian Start-up Integrates Linescape's Schedule Data into Freight Rate Transparency Platform.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2014-6-4-ef3-integrates-linescape-data', {scroll:true}]\">eF3 Systems integrates Linescape Sailing Schedule Data</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – June 4, 2014</p>\r\n          <p>Las Vegas technology company combines Linescape's Schedule Data with their logistics and supply chain management software.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2013-6-26-mercurygate-adds-linescape-to-tms', {scroll:true}]\">MercuryGate adds Linescape’s Sailing Schedules to TMS </a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – June 26, 2013</p>\r\n          <p>MercuryGate, the best-of-breed transportation management platform, has integrated Linescape’s Sailing Schedule Data into their award-winning Transport Management System (TMS).</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2013-5-1-Linescape-4th-anniversary-transhipment-voyage', {scroll:true}]\">Linescape celebrates 4th Anniversary with Transhipment Voyage Schedules</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – May 1, 2013</p>\r\n          <p>Leading Sailing Schedules provider expands data offering with pre-searched transhipment schedules as a data feed.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2013-1-8-dbh-integrates-linescape-schedules', {scroll:true}]\">dbh integrates Linescape Sailing Schedules</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – January 8, 2013</p>\r\n          <p>Bremen ports Ship Information System (SIS) extended by worldwide sailing lists.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2012-11-5-dachser-selects-linescapes-sailing-schedules', {scroll:true}]\">Dachser selects Linescape's Sailing Schedules</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – November 5, 2012</p>\r\n          <p>Global Logistics Provider Integrates Data Feeds From the World's Leading Schedule Information Provider.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2012-7-13-linescape-ci-award-finalist', {scroll:true}]\">Linescape selected as Finalist for CI Award</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – July 13, 2012</p>\r\n          <p>Containerisation International are pleased to announce the finalists for the CI Awards 2012.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2012-6-14-dakosy-to-distribute-linescape', {scroll:true}]\">DAKOSY to distribute Linescape’s Sailing Schedules</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – June 14, 2012</p>\r\n          <p>Hamburg Port Community to provide its members with access to the global sailing schedules and vessel data from the world’s leading data provider.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2012-5-3-linescape-more-data-anniversary', {scroll:true}]\">Linescape celebrates 3rd Anniversary with \"More Data\"</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – May 3, 2012</p>\r\n          <p>Sailing Schedules Website Expands Depth and Breadth of Data Offering.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2011-10-24-linescape-exhibit-intermodal-europe', {scroll:true}]\">Linescape to exhibit at Intermodal Europe in Hamburg</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – October 24, 2011</p>\r\n          <p>Search Engine to showcase Data Solutions at Intermodal, Nov. 29 - 30, 2011</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2011-5-13-linescape-vessel-information-anniversary', {scroll:true}]\">Linescape celebrates 2nd Anniversary with Vessel Information</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – May 13, 2011</p>\r\n          <p>Sailing Schedules Website Expands Results to Display Vessel Register Data.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2010-10-25-linescape-exhibit-intermodal-europe-amsterdam', {scroll:true}]\">Linescape to exhibit at Intermodal Europe in Amsterdam</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – October 25, 2010</p>\r\n          <p>Search Engine to unveil new developments at Intermodal, Nov. 30 - Dec. 2, 2010.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2010-8-26-transworld-expedition-ship-truck', {scroll:true}]\">Transworld Expedition uses Linescape to Ship Truck around the World</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – August 26, 2010</p>\r\n          <p>Linescape is a great tool to find container ships, when they leave, how long and what company.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2010-5-4-linescape-carrier-profiles-anniversary', {scroll:true}]\">Linescape celebrates 1st Anniversary with Carrier Profiles</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – May 4, 2010</p>\r\n          <p>Sailing Schedules Website Adds Carrier Profile and Fleet Information.</p>\r\n        </div>\r\n        <div class=\"blog-entry\">\r\n          <h6><a [routerLink]=\"['2009-5-4-linescape-launches-ocean-container-search', {scroll:true}]\">Linescape launches Ocean Container Schedule Search Engine</a></h6>\r\n          <p class=\"blog-entry-sub-head\">Burlingame, CA – May 4, 2009</p>\r\n          <p>Innovative, Powerful Tool Reveals Optimum Container Shipping Schedules Using Advanced Features and Industry’s Broadest Database.</p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = ".page-content {\n  padding-top: 40px; }\n  .page-content p, .page-content li, .page-content div, .page-content label {\n    font-size: 16px;\n    line-height: 24px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 50%;\n    padding-right: 40px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-right {\n    display: inline-block;\n    width: 50%;\n    padding-left: 40px;\n    vertical-align: top;\n    border-left: 1px solid #d4d4d4; }\n    .page-content .page-content-right p, .page-content .page-content-right li, .page-content .page-content-right div, .page-content .page-content-right label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .press-entry {\n    margin-bottom: 30px; }\n    .page-content .press-entry h6 {\n      margin-bottom: 0;\n      margin-top: 0; }\n  .page-content .news-entry {\n    margin-bottom: 20px; }\n    .page-content .news-entry h6 {\n      margin-bottom: 0; }\n  .page-content .press-mobile-title,\n  .page-content .news-mobile-title {\n    display: none;\n    border-bottom: 1px solid #d4d4d4; }\n\n.page-banner-inner {\n  text-transform: none; }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-left: 0; }\n  .page-content .page-content-right {\n    width: 100%;\n    display: inline-block;\n    padding-right: 0;\n    padding-left: 0;\n    border-left: none; }\n  .page-content .news-entry {\n    margin-bottom: 20px; }\n  .page-content .press-mobile-title,\n  .page-content .news-mobile-title {\n    display: block; }\n  .page-content .news-entry-snippet {\n    display: none; } }\n"

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(782));


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeUpgradesSearchEngineComponent = (function (_super) {
    __extends(LinescapeUpgradesSearchEngineComponent, _super);
    function LinescapeUpgradesSearchEngineComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape Upgrades Search Engine - Linescape";
        _this.description = "Cutting-edge technology coupled with a new search interface provides more ways to search containership schedules, appealing to a larger shipping community.";
        return _this;
    }
    LinescapeUpgradesSearchEngineComponent = __decorate([
        core_1.Component({
            selector: 'linescape-upgrades-search-engine',
            template: __webpack_require__(784),
            styles: [__webpack_require__(7), __webpack_require__(785)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeUpgradesSearchEngineComponent);
    return LinescapeUpgradesSearchEngineComponent;
}(blog_page_1.BlogPage));
exports.LinescapeUpgradesSearchEngineComponent = LinescapeUpgradesSearchEngineComponent;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BlogPage = (function () {
    function BlogPage(route, app, seo) {
        this.route = route;
        this.app = app;
        this.seo = seo;
        this.title = 'Linescape Blog Page';
        this.description = 'Linescape';
    }
    BlogPage.prototype.ngOnInit = function () {
        this.seo.set(this.title, this.description);
    };
    BlogPage.prototype.ngAfterViewInit = function () {
        this.route.params.subscribe(function (params) {
            if (params['scroll'] != null && params['scroll'] === 'true') {
                window.scrollTo(0, 0);
            }
        });
    };
    return BlogPage;
}());
exports.BlogPage = BlogPage;


/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape Upgrades Sailing Schedule Search Engine to Reach a Wider Audience in the Shipping Community</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, California - March 20, 2017</h6>\r\n            <p><b>Cutting-edge technology coupled with a new search interface provides more ways to search containership schedules, appealing to more sectors of the shipping industry</b></p>\r\n            <p>Linescape, the leading provider of sailing schedule data solutions, now offers three new ways to search schedules -- by vessel, by port and by carrier. Linescape is adding the new search interfaces to reach a wider audience beyond its regular users who search only by port pairs.</p>\r\n            <p>The standard way to search sailing schedules was always by origin and destination, appealing most to shippers and forwarders planning their shipments, but now Linescape's new interface offers the most versatile search tool in the industry. The new search by vessel is useful for users who wish to track vessels through all planned ports of call. The new search by port is useful for users in port communities who need to know vessel arrivals and departures at a port on any given day in the future. The new search by carrier is useful for users who want to follow a carrier's entire fleet of vessels. Furthermore, the search by origin and destination has been optimized to quickly return all schedules, either direct sailings or with up to 1 or 2 transhipments.</p>\r\n            <p>When asked about the motivation for the new search interfaces, David Tarizzo explains, <i>\"From our user feedback we learned that the shipping community needed to search schedule data in more ways than just by port pairs. The new interface now allows them to follow a vessel, to follow port arrivals and departures, or to follow a carrier's fleet of vessels, equally responsive by computer or by mobile device. There is now literally something for everyone in the shipping industry, whether in the office or on the road.\"</i></p>\r\n            <p>Another innovation of the new website is the option to receive the results from any search as a CSV file either by direct download or by scheduled delivery of email attachments. Users can set up their own mini datafeeds to deliver automatically to their email address and to receive repeating updates on the days and intervals of their choosing. This \"Data by Email\" can be set up in three different formats: by origin and destination, by vessel name or IMO, and by port arrivals or departures.</p>\r\n            <p>When asked about the inspiration behind the strategic initiative to support all companies with these mini datafeeds, Dimitrios Sogas explains,  <i>\"Our new 'Data by Email' feature allows us to serve a wider range of customers. For years, we have had to turn away datafeed customers who needed rather small data sets because the cost of setting up and maintaining them was out of reach for so many users with smaller budgets. Now, with this new feature, we can help many more users around the world get the data they have been asking for, at a very reasonable cost.\"</i></p>\r\n            <p>As before, only basic data is available to users free of charge, but for advanced data and special features Linescape has added two subscription plans to meet the budgets and needs of companies large and small. Beyond these, for more sophisticated needs, Linescape continues to offer its business-to-business datafeeds which are ideal for integrating into a customer's transport management system.</p>\r\n            <p>Designed for faster and more versatile navigation either by computer or by mobile device, Linescape's new search engine allows users to map out almost any view of ocean schedules for shipping containers worldwide. The new subscription plans offer a broader range of schedule, vessel and carrier data, as well as more useful features and local carrier contacts. The powerful search engine allows users to view routes and schedules from over 100 container lines, with some 12 million voyages by deep-sea, short-sea and feeder-lines, and through more than 200,000 port pairs.</p>\r\n            <p>Learn more about how Linescape's advanced search capabilities and datafeeds can help you find alternatives and save time at www.linescape.com.</p>\r\n            <br>\r\n            <p><b>About Linescape</b><br>Linescape is the first independent website to present a comprehensive and impartial overview of the routes and schedules of the world's containership lines. The newly redesigned website gives shippers and forwarders the freedom to search schedules by origin and destination, by vessel, by port or by carrier. The company is headquartered in Burlingame, California. It's not affiliated with any carrier, acting independently from all shipping lines, shippers and forwarders.</p>\r\n            <br>\r\n            <p><b>Contact:</b></p>\r\n            <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n            <p><b>Marketing &amp; PR</b><br><a href=\"mailto:media@linescape.com\">media@linescape.com</a></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(787));


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var TechStackAnniversaryComponent = (function (_super) {
    __extends(TechStackAnniversaryComponent, _super);
    function TechStackAnniversaryComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape Anniversary with new Tech Stack - Linescape";
        _this.description = "Leading Sailing Schedules provider migrates systems and components to new equipment and to the cloud.";
        return _this;
    }
    TechStackAnniversaryComponent = __decorate([
        core_1.Component({
            selector: 'tech-stack-anniversary',
            template: __webpack_require__(788),
            styles: [__webpack_require__(7), __webpack_require__(789)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], TechStackAnniversaryComponent);
    return TechStackAnniversaryComponent;
}(blog_page_1.BlogPage));
exports.TechStackAnniversaryComponent = TechStackAnniversaryComponent;


/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape celebrates 7th Anniversary with new Tech Stack</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – May 6, 2016</h6>\r\n            <p><b>Leading Sailing Schedules provider migrates systems and components to new equipment and to the cloud.</b></p>\r\n            <p>Linescape, the leading global sailing schedules search engine and data feed provider, has moved all of it back-end systems and components, some to new hardware and some to the cloud. The move will greatly enhance performance and ensure maximum security and uptime.</p>\r\n            <p>Linescape, celebrating its seventh anniversary, provides sailing schedules from over 100 container shipping lines with more than 9 million voyages, including data on 13,000 vessels sailing through 3,000 ports. In addition to it's online search engine, Linescape provides customers with sailing schedule data feeds, of both direct and transhipment voyages. All of its technology was originally built and hosted on just one server, but the growing complexities and higher operational demands have necessitated a move to new technology, as well as to the cloud.</p>\r\n            <p>In preparing for the move, Linescape enlisted the services of the London-based IT support firm, LShift, to analyse and recommend a new architecture, as well as to consult and assist in its implementation.</p>\r\n            <p>“We used to call our system the bowl of spaghetti, because everything was mixed together”, said president and co-founder, David Tarizzo. “This presented various operational and security risks, so we have been working for well over a year with LShift in planning and executing a migration and separation of the various components onto new and separate but interconnected hardware or cloud services. The result, I am very please to say, greatly enhances security and performance and provides us with a fantastic foundation for our next big development”.</p>\r\n            <p><u>About LShift</u></p>\r\n            <p>LShift is an independent software development company with offices in London and Berlin. It was founded in 2000 in Shoreditch, London, long before Silicon Roundabout or Tech City had even been imagined, by developers and designed to provide the ideal conditions in which the best levels of technical services can be offered to clients. Our model has proven successful again and again in the many long-standing relationships we have developed with our clients. (<a href=\"http://www.lshift.net\" target=\"_blank\">www.lshift.net</a>)</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(791));


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var HavenOceanFreightMarketplaceLinescapeComponent = (function (_super) {
    __extends(HavenOceanFreightMarketplaceLinescapeComponent, _super);
    function HavenOceanFreightMarketplaceLinescapeComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape Streamlines Ocean Freight Marketplace - Linescape";
        _this.description = "San Francisco technology company integrates Linescape's Schedule Data into their online marketplace";
        return _this;
    }
    HavenOceanFreightMarketplaceLinescapeComponent = __decorate([
        core_1.Component({
            selector: 'haven-ocean-freight-marketplace-linescape',
            template: __webpack_require__(792),
            styles: [__webpack_require__(7), __webpack_require__(793)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], HavenOceanFreightMarketplaceLinescapeComponent);
    return HavenOceanFreightMarketplaceLinescapeComponent;
}(blog_page_1.BlogPage));
exports.HavenOceanFreightMarketplaceLinescapeComponent = HavenOceanFreightMarketplaceLinescapeComponent;


/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Haven streamlines Ocean Freight Marketplace with Linescape Sailing Schedules</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – January 23, 2015</h6>\r\n            <p><b>San Francisco technology company integrates Linescape's Schedule Data into their online marketplace</b></p>\r\n            <p>Linescape, the leading provider of global sailing schedule, vessel and carrier data for containerships, has started delivering sailing schedule data feeds to Haven of San Francisco, a private marketplace where shippers can compare and purchase shipment capacity from supply partners. Linescape and Haven have cooperated to integrate Linescape's data into Haven's newly developed shipment capacity marketplace.</p>\r\n            <p>\"Linescape's sailing schedule data feed enhances Haven's marketplace,\" according to Renee DiResta, Founder and Director of Marketing. \"Haven currently offers 600,000 sailings (or shipment schedules) from 1,500 ports, and receives regularly updated rates and schedules from half of its top 20 carrier, and Linescape has been instrumental in providing schedule data.\"</p>\r\n            <p>Linescape hosts the container sailing schedules from over 120 shipping lines, including deep-sea, short-sea and feeders, with some 8 million voyages through 3,000 ports by more than 12,500 cargo and container vessels. Data includes a wide variety of in-depth information including: sailing schedules, vessel register data, carrier profiles and local carrier contacts. Linescape pioneered data feeds in 2010 and is now the leading schedule data supplier to shippers, forwarders, logistic providers, port communities and logistics websites.</p>\r\n            <p><u>About Haven</u></p>\r\n            <p>Haven is the automated trade technology platform for quoting, booking, and end-to-end shipment management with the world's leading providers. Haven is a privately held company and is head-quartered in San Francisco, California. (<a href=\"http://www.haveninc.com\" target=\"_blank\">www.haveninc.com</a>)</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(795));


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var XenetaAddsLinescapeComponent = (function (_super) {
    __extends(XenetaAddsLinescapeComponent, _super);
    function XenetaAddsLinescapeComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Xeneta Adds Linescape Sailing Schedules - Linescape";
        _this.description = "Norwegian Start-up Integrates Linescape's Schedule Data into Freight Rate Transparency Platform";
        return _this;
    }
    XenetaAddsLinescapeComponent = __decorate([
        core_1.Component({
            selector: 'xeneta-adds-linescape',
            template: __webpack_require__(796),
            styles: [__webpack_require__(7), __webpack_require__(797)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], XenetaAddsLinescapeComponent);
    return XenetaAddsLinescapeComponent;
}(blog_page_1.BlogPage));
exports.XenetaAddsLinescapeComponent = XenetaAddsLinescapeComponent;


/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Xeneta adds Linescape Sailing Schedules to Freight Rates</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – October 8, 2014</h6>\r\n            <p><b>Norwegian Start-up Integrates Linescape's Schedule Data into Freight Rate Transparency Platform.</b></p>\r\n            <p>Linescape, the leading provider of global sailing schedule, vessel and carrier data for containerships, is now supplying sailing schedule data feeds to Xeneta of Oslo, Norway, a freight rate transparency platform. Linescape and Xeneta have worked together to integrate Linescape's data into Xeneta's newly developed freight rate transparency platform.</p>\r\n            <p>\"The Linescape data feed enhances Xeneta's solution to our subscribers,\" according to Thomas Sørbø, COO & Co-Founder Xeneta. \"Our subscribers get full transparency into their ocean freight rates and sailing schedules which changes the way they procure container freight with actionable data and intelligence.\"</p>\r\n            <p>Linescape hosts the container sailing schedules from over 120 shipping lines, including deep-sea, short-sea and feeders, with some 8 million voyages through 3,000 ports by more than 10,500 cargo and container vessels. Data includes a wide variety of in-depth information including: sailing schedules, vessel register data, carrier profiles and local carrier contacts. Linescape pioneered data feeds in 2010 and is now the leading schedule data supplier to shippers, forwarders, logistic providers, port communities and logistics websites.</p>\r\n            <p><u>About Xeneta</u></p>\r\n            <p>Xeneta is the leading ocean freight price comparison and shipping market watch index transforming the shipping and logistics industry. Xeneta's easy-to-use yet powerful reporting and analytics platform provides shippers and freight forwarders the software data they need to compare their shipping prices against the world's largest database of contracted rates - reporting live on market average and low/high movements. Xeneta's shipping indexes cover over 60,000 global trade routes enabling informed decisions with actionable intelligence optimizing companies' logistics procurement. Xeneta is a privately held company and is headquartered in Oslo, Norway. (<a href=\"http://www.xeneta.com\" target=\"_blank\">www.xeneta.com</a>)</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(799));


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var Ef3IntegratesLinescapeDataComponent = (function (_super) {
    __extends(Ef3IntegratesLinescapeDataComponent, _super);
    function Ef3IntegratesLinescapeDataComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "eF3 Systems Integrates Linescape Data - Linescape";
        _this.description = "Las Vegas technology company combines Linescape's Schedule Data with their logistics and supply chain management software";
        return _this;
    }
    Ef3IntegratesLinescapeDataComponent = __decorate([
        core_1.Component({
            selector: 'ef3-integrates-linescape-data',
            template: __webpack_require__(800),
            styles: [__webpack_require__(7), __webpack_require__(801)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], Ef3IntegratesLinescapeDataComponent);
    return Ef3IntegratesLinescapeDataComponent;
}(blog_page_1.BlogPage));
exports.Ef3IntegratesLinescapeDataComponent = Ef3IntegratesLinescapeDataComponent;


/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>eF3 Systems integrates Linescape Sailing Schedule Data</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – June 4, 2014</h6>\r\n            <p><b>Las Vegas technology company combines Linescape's Schedule Data with their logistics and supply chain management software.</b></p>\r\n            <p>Linescape, the leading provider of global sailing schedule, vessel and carrier data for containerships, is now delivering sailing schedule data through eF3 System's logistics and supply chain management software. Linescape and eF3 Systems have cooperated closely to integrate Linescape's sailing schedule data into eF3 System's supply chain management software.</p>\r\n            <p>\"Linescape's sailing schedule data is a brilliant compliment to the software we provide to our logistics customers,\" according to Tony Tyler, CEO of eF3 Systems. \"Customers of our supply chain technology suite, specifically developed for the Asia-Pacific region, will benefit enormously by now being able to access Linescape's sailing schedules directly from within our software.\"</p>\r\n            <p>Linescape hosts the container sailing schedules from over 100 shipping lines, including deep-sea, short-sea and feeders, with some 9 million voyages through 3,000 ports by more than 12,000 cargo and container vessels. Data includes a wide variety of in-depth information including: sailing schedules, vessel register data, carrier profiles, local carrier contacts, and CO2 emissions. Linescape pioneered data feeds in 2010 and is now the leading schedule data supplier to shippers, forwarders, logistic providers, port communities and logistics websites.</p>\r\n            <p>VP and co-founder of Linescape, Dimitrios Sogas, confirms the value of their cooperation: \"eF3 Systems had some very challenging requirements, so we worked extensively with Tony's team to deliver a vast amount of data to their exacting specifications, and our flexible data systems allowed us to quickly satisfy all of eF3 System's requirements.\"</p>\r\n            <p><u>About eF3 Systems</u></p>\r\n            <p>eF3 Systems has an integrated technology portfolio featuring highly flexible, cloud-based WMS, TMS, document to data integration and conversion, real-time ocean data, and other unique supply chain management tools for the logistics enterprise. eF3 Systems is a privately held company and is headquartered in Las Vegas, Nevada. (<a href=\"http://www.ef3systems.com\" target=\"_blank\">www.ef3systems.com</a>)</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(803));


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var Linescape4AniversaryTranshipmentVoyageComponent = (function (_super) {
    __extends(Linescape4AniversaryTranshipmentVoyageComponent, _super);
    function Linescape4AniversaryTranshipmentVoyageComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape 4th Anniversary with Transhipment Voyage - Linescape";
        _this.description = "Leading Sailing Schedules provider expands data offering with pre-searched transhipment schedules as a data feed.";
        return _this;
    }
    Linescape4AniversaryTranshipmentVoyageComponent = __decorate([
        core_1.Component({
            selector: 'linescape-4-anniversary-transhipment-voyage',
            template: __webpack_require__(804),
            styles: [__webpack_require__(7), __webpack_require__(805)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], Linescape4AniversaryTranshipmentVoyageComponent);
    return Linescape4AniversaryTranshipmentVoyageComponent;
}(blog_page_1.BlogPage));
exports.Linescape4AniversaryTranshipmentVoyageComponent = Linescape4AniversaryTranshipmentVoyageComponent;


/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape celebrates 4th Anniversary with Transhipment Voyage Schedules</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – May 1, 2013</h6>\r\n            <p><b>Leading Sailing Schedules provider expands data offering with pre-searched transhipment schedules as a data feed.</b></p>\r\n            <p>Linescape, the leading global sailing schedules search engine and data feed provider, has now launched transhipment schedules by data feed.</p>\r\n            <p>Linescape, celebrating its fourth anniversary, provides sailing schedules from over 110 container shipping lines with more than 8 million voyages, including data on 10,000 vessels sailing through 3,000 ports. In addition to it's online search engine, Linescape has also been providing customers with sailing schedule data feeds. Until recently, only direct voyages were available, but the team at Linescape has worked closely with a key customer to produce schedules for voyages with up to 2 transhipments, and thereby vastly expanding the number of possible origins and destinations.</p>\r\n            <p>“Transhipment schedules have been a long time in the making”, said president and co-founder, David Tarizzo. “We worked closely with a large logistics software provider to develop the technology necessary to produce voyage schedules of up to 3 vessels with 2 transhipments. This new transhipment data feed helped us to secure the supply agreement with that customer and it greatly expands our product offering to the industry”.</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(807));


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var DbhIntegratesLinescapeComponent = (function (_super) {
    __extends(DbhIntegratesLinescapeComponent, _super);
    function DbhIntegratesLinescapeComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "dbh Integrates Linescape Sailing Schedules - Linescape";
        _this.description = "Bremen ports Ship Information System (SIS) extended by worldwide sailing lists";
        return _this;
    }
    DbhIntegratesLinescapeComponent = __decorate([
        core_1.Component({
            selector: 'dbh-integrates-linescape-schedules',
            template: __webpack_require__(808),
            styles: [__webpack_require__(7), __webpack_require__(809)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], DbhIntegratesLinescapeComponent);
    return DbhIntegratesLinescapeComponent;
}(blog_page_1.BlogPage));
exports.DbhIntegratesLinescapeComponent = DbhIntegratesLinescapeComponent;


/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>dbh integrates Linescape Sailing Schedules</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – January 8, 2013</h6>\r\n            <p><b>Bremen ports Ship Information System (SIS) extended by worldwide sailing lists</b></p>\r\n            <p>Linescape, the California-based provider of containership sailing schedules, is supplying daily updated data feeds comprising over 120 carriers, more than 10,000 ships and 3,000 ports to freight forwarders all over the world. This data will now be available via “SIS”, the Bremen ports Ship Information System.</p>\r\n            <p>This is possible thanks to the cooperation between Linescape and the SIS provider, dbh logistics IT AG. The integration of Linescape data into the Bremen system was achieved by jointly adopting the EDI interfaces. In this way, a solution was created with little effort, that represents a significant added value for SIS users.</p>\r\n            <p>\"With the integration of Linescape's sailing schedules, we are pleased to offer to our customers an additional benefit,\" said Bernd Huckschlag, Head Port Solutions at dbh. \"Terminals, freight forwarders and other companies involved in import-export can save a lot of time and money. Since access to the data can be achieved without any technical adaptations, users benefit directly from this integration\".</p>\r\n            <p>SIS users can make use of the extension immediately. The Linescape data will be available in the same format as the ships data from SIS and can be read into any software used by customers. No interface adjustments are needed. All data will be updated regularly to insure that users are accessing always the most recent dataset.</p>\r\n            <p>Customers who may have any questions about this service are requested to contact directly dbh Sales at +49 421 30902-700 or <a href=\"mailto:sales@dbh.de?Subject=Linescape Saling Schedules\">sales@dbh.de</a>.</p>\r\n            <p><u>About dbh</u></p>\r\n            <p><b>dbh Logistics IT AG</b> is one of the leading service providers for support and software in the logistics sector. The company develops business solutions for industry and trade, forwarding and logistics, as well as shipping and ports within the spectrum of customs and foreign trade, transport management, compliance and port operation. The portfolio consists of a whole host of services, from consultation, conception and implementation, through to hosting and support. In its data centre in Bremen, dbh operates both individual applications as well as complex IT infrastructures and SAP systems. Founded in 1973, dbh employs 140 members of staff all over Germany. In addition to its head office in Bremen, the company operates in other locations in Germany - Dortmund, Dresden, Hamburg, Wilhelmshaven and Würzburg. (<a href=\"http://www.dbh.de\" target=\"_blank\">www.dbh.de</a>)</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(811));


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var DachserSelectsLinescapeSchedulesComponent = (function (_super) {
    __extends(DachserSelectsLinescapeSchedulesComponent, _super);
    function DachserSelectsLinescapeSchedulesComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Dachser selects Linescape's Sailing Schedules - Linescape";
        _this.description = "Global Logistics Provider Integrates Data Feeds From the World's Leading Schedule Information Provider.";
        return _this;
    }
    DachserSelectsLinescapeSchedulesComponent = __decorate([
        core_1.Component({
            selector: 'dachser-selects-linescape-schedules',
            template: __webpack_require__(812),
            styles: [__webpack_require__(7), __webpack_require__(813)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], DachserSelectsLinescapeSchedulesComponent);
    return DachserSelectsLinescapeSchedulesComponent;
}(blog_page_1.BlogPage));
exports.DachserSelectsLinescapeSchedulesComponent = DachserSelectsLinescapeSchedulesComponent;


/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Dachser selects Linescape's Sailing Schedules</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – November 5, 2012</h6>\r\n            <p><b>Global Logistics Provider Integrates Data Feeds From the World's Leading Schedule Information Provider.</b></p>\r\n            <p>Linescape, the leading provider of global sailing schedule, vessel and carrier data for containerships, and Dachser GmbH & Co. KG, of Kempten, Germany, one of the world's largest global logistics providers, have announced the extent of their cooperation which began over one year ago. Linescape has been supplying Dachser with a broad base of containership data including: sailing schedules, vessel register data, carrier profiles, local carrier contacts and carbon footprint data.</p>\r\n            <p>Linescape and Dachser have worked closely over the last year to integrate Linescape's database into Dachser's newly developed Transport Management System (TMS) for the business area of Dachser Air & Sea Logistics which started to be rolled-out last year. Upon completion, over 3000 employees in 140 profit centers will benefit from the integration of Linescape's data, instantly and directly accessible through Dachser's TMS.</p>\r\n            <p>\"The Linescape data feeds bring us a multitude of benefits,\" confirmed Björn Diederich, Business Analyst Sea of Dachser. \"Our operators previously had to research schedule, vessel and carrier information from a variety of sources, which wasted much time and risked introducing errors. Now, we save thousands of hours in transport planning by finding these data inside our TMS, and allowing direct integration into our order processing. The increase in workflow speed and data quality allows us to serve our customers much more quickly and effectively.\"</p>\r\n            <p>Linescape hosts the container sailing schedules from over 120 shipping lines, including deep-sea, short-sea and feeders, with some 8 million voyages through 3,000 ports by more than 10,500 cargo and container vessels. Data includes a wide variety of in-depth information including: sailing schedules, vessel register data, carrier profiles, local carrier contacts, and CO2 emissions. Linescape pioneered data feeds in 2010 and is now the leading schedule data supplier to shippers, forwarders, logistic providers, port communities and logistics websites.</p>\r\n            <p>The CEO and co-founder of Linescape, David Tarizzo, confirms the mutual benefits of their cooperation: \"Dachser presented us with many challenges to fulfil, to deliver a vast array of data, some of which was not readily available at the time. Our mission to provide the highest level of service to our customers, and our advanced database architecture allowed us to quickly respond to their needs and satisfy all of Dachser's requirements ahead of schedule.\"</p>\r\n            <p><u>About Dachser</u></p>\r\n            <p>Dachser is an international logistics services provider headquartered in Kempten, Germany, where the company was founded in 1930 by Thomas Dachser. The company's aim is to improve the logistics processes of its customers. In 2011, Dachser generated total revenue of EUR 4.3 billion. 21,000 staff working in 315 profit centres worldwide handled 49.3 million consignments weighing a total of 37.1 million tons. (<a href=\"http://www.dachser.com\" target=\"_blank\">www.dachser.com</a>)</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(815));


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeCIAwardFinalistComponent = (function (_super) {
    __extends(LinescapeCIAwardFinalistComponent, _super);
    function LinescapeCIAwardFinalistComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape Selected as Finalist for CI Award - Linescape";
        _this.description = "Containerisation International are pleased to announce the finalists for the CI Awards 2012.";
        return _this;
    }
    LinescapeCIAwardFinalistComponent = __decorate([
        core_1.Component({
            selector: 'linescape-ci-award-finalist',
            template: __webpack_require__(816),
            styles: [__webpack_require__(7), __webpack_require__(817)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeCIAwardFinalistComponent);
    return LinescapeCIAwardFinalistComponent;
}(blog_page_1.BlogPage));
exports.LinescapeCIAwardFinalistComponent = LinescapeCIAwardFinalistComponent;


/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape selected as Finalist for CI Award</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – July 13, 2012</h6>\r\n            <p><b>Containerisation International are pleased to announce the finalists for the CI Awards 2012.</b></p>\r\n            <p>Linescape, the leading provider of global sailing schedules, has been selected by trade journal, Containerisation International, as one of the six Finalists announced for an Award in the category of Innovation IT of the Year. The winner will be chosen on October 18, 2012. <a href=\"http://www.ci-awards.com/award-finalists/\" target=\"_blank\">www.ci-awards.com/award-finalists/</a></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(819));


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var DakosyToDistributeLinescapeComponent = (function (_super) {
    __extends(DakosyToDistributeLinescapeComponent, _super);
    function DakosyToDistributeLinescapeComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "DAKOSY to Distribute Linescape’s Sailing Schedules - Linescape";
        _this.description = "Hamburg Port Community to provide its members with access to the global sailing schedules and vessel data from the world’s leading data provider.";
        return _this;
    }
    DakosyToDistributeLinescapeComponent = __decorate([
        core_1.Component({
            selector: 'dakosy-to-distribute-linescape',
            template: __webpack_require__(820),
            styles: [__webpack_require__(7), __webpack_require__(821)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], DakosyToDistributeLinescapeComponent);
    return DakosyToDistributeLinescapeComponent;
}(blog_page_1.BlogPage));
exports.DakosyToDistributeLinescapeComponent = DakosyToDistributeLinescapeComponent;


/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>DAKOSY to distribute Linescape’s Sailing Schedules</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – June 14, 2012</h6>\r\n            <p><b>Hamburg Port Community to provide its members with access to the global sailing schedules and vessel data from the world’s leading data provider.</b></p>\r\n            <p>Linescape, the leading provider of global sailing schedules and vessel data for containerships, and DAKOSY AG, the port community system for the Port of Hamburg, have announced a cooperation whereby DAKOSY will provide its members with access to Linescape’s vast database of sailing schedules.</p>\r\n            <p>In addition to the existing “Hamburg ship departure list” DAKOSY can now also offer all interested customers current and up-to-date sailing schedules of 8 million voyages from over 120 container carriers, with more than 9,000 ships and through 3,000 ports worldwide. This offer is based on a new initiative between DAKOSY and Linescape, announced today at the “transfairlog” exhibition in Hamburg, Germany.</p>\r\n            <p>\"Our cooperation with Linescape brings many advantages to our customers\", confirmed Dieter Spark, Member of the Board of DAKOSY. \"Customers can save much time and effort in transport planning when they have a comprehensive overview of ship schedules directly integrated into order processing. This avoids searching by external tools, where data must be collected manually, and thereby avoids data entry errors.” Also, the CEO and founder of Linescape, David Tarizzo, sees great benefits through their cooperation: \"With DAKOSY, the port community system for the port of Hamburg, we have found a strong partner in Germany who can integrate our solution quickly and easily into the local and international freight forwarding market.\"</p>\r\n            <p><u>About DAKOSY</u></p>\r\n            <p><b>DAKOSY Data Communication Systems AG</b>, as one of the leading data managers for the transport and logistics industry, serving commerce and industry, has been offering pioneering solutions for over 30 years, in particular for international freight forwarding and customs clearance, as well as for dangerous goods and transport mode processing. State-of-the-art data centres provide business communications for more than 2,000 companies in Germany, in Europe and around the world. As the port community system for the port of Hamburg, DAKOSY’s comprehensive communications and software services supports export, import and transit management. All documents necessary for carrying out transport (e.g. schedules, transfer orders, customs applications, dangerous goods declarations, port jobs, bills of lading, manifests, shipping notifications) are transmitted with internationally standardized message formats between business partners via the DAKOSY computer centre. (<a target=\"_blank\" href=\"http://www.dakosy.com\">www.dakosy.com</a>)</p>\r\n            <p><b>Meet Linescape at transfairlog</b></p>\r\n            <p>From 12 to 14 June, 2012, Hamburg, Germany. For an appointment <a [routerLink]=\"['contact', { scroll: true }]\">click here</a>.</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(823));


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeMoreDataAnniversaryComponent = (function (_super) {
    __extends(LinescapeMoreDataAnniversaryComponent, _super);
    function LinescapeMoreDataAnniversaryComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = 'Linescape celebrates 3rd Anniversary with "More Data" - Linescape';
        _this.description = "Sailing Schedules Website Expands Depth and Breadth of Data Offering.";
        return _this;
    }
    LinescapeMoreDataAnniversaryComponent = __decorate([
        core_1.Component({
            selector: 'linescape-more-data-anniversary',
            template: __webpack_require__(824),
            styles: [__webpack_require__(7), __webpack_require__(825)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeMoreDataAnniversaryComponent);
    return LinescapeMoreDataAnniversaryComponent;
}(blog_page_1.BlogPage));
exports.LinescapeMoreDataAnniversaryComponent = LinescapeMoreDataAnniversaryComponent;


/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape celebrates 3rd Anniversary with \"More Data\"</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – May 3, 2012</h6>\r\n            <p><b>Sailing Schedules Website Expands Depth and Breadth of Data Offering.</b></p>\r\n            <p>Linescape, the leading global sailing schedules search engine, which provides the fastest way to search multiple carrier schedules and vessel details, has further expanded the types and quantity of data available.</p>\r\n            <p>Linescape, celebrating the third anniversary of its launch, provides thousands of daily users with sailing schedule data from over 130 container shipping lines with more than 8 million voyages, including ships register data on 9,500 cargo and container vessels sailing through 3,000 ports, and with profiles, fleet information and local contacts for 380 carriers.</p>\r\n            <p>“Not all of our data is available on the Linescape website. Though sailng schedules, basic vessel register details and carrier profiles plus fleet information can be searched on the website, new supplimentary data is only available by data feeds”, said co-founder Dimitios Sogas. “With a data feed, our customers can access everthing found on the website plus important additional data, such as carbon footprint data for all vessels on all voyages, over 50 data fields of ships register details, and local carrier contacts for 380 shipping lines”.</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(827));


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeExhibitIntermodalEuropeComponent = (function (_super) {
    __extends(LinescapeExhibitIntermodalEuropeComponent, _super);
    function LinescapeExhibitIntermodalEuropeComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape Exhibits at Intermodal Europe - Linescape";
        _this.description = "Search Engine to showcase Data Solutions at Intermodal, Nov. 29 - 30, 2011";
        return _this;
    }
    LinescapeExhibitIntermodalEuropeComponent = __decorate([
        core_1.Component({
            selector: 'linescape-exhibit-intermodal-europe',
            template: __webpack_require__(828),
            styles: [__webpack_require__(7), __webpack_require__(829)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeExhibitIntermodalEuropeComponent);
    return LinescapeExhibitIntermodalEuropeComponent;
}(blog_page_1.BlogPage));
exports.LinescapeExhibitIntermodalEuropeComponent = LinescapeExhibitIntermodalEuropeComponent;


/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape to exhibit at Intermodal Europe in Hamburg</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – October 24, 2011</h6>\r\n            <p><b>Search Engine to showcase Data Solutions at Intermodal, Nov. 29 - 30, 2011.</b></p>\r\n            <p>Linescape will exhibit at the Intermodal Exhibition taking place at Hamburg Messe from November 29 to 30. Visitors are invited to stand C-7 to view demonstrations of Linescape's Data Solutions. (<a href=\"http://www.intermodal-events.com\" target=\"_blank\">www.intermodal-events.com</a>)</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(831));


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeVesselInformationAnniversaryComponent = (function (_super) {
    __extends(LinescapeVesselInformationAnniversaryComponent, _super);
    function LinescapeVesselInformationAnniversaryComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape celebrates 2nd Anniversary with Vessel Information - Linescape";
        _this.description = "Sailing Schedules Website Expands Results to Display Vessel Register Data.";
        return _this;
    }
    LinescapeVesselInformationAnniversaryComponent = __decorate([
        core_1.Component({
            selector: 'linescape-vessel-information-anniversary',
            template: __webpack_require__(832),
            styles: [__webpack_require__(7), __webpack_require__(833)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeVesselInformationAnniversaryComponent);
    return LinescapeVesselInformationAnniversaryComponent;
}(blog_page_1.BlogPage));
exports.LinescapeVesselInformationAnniversaryComponent = LinescapeVesselInformationAnniversaryComponent;


/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape celebrates 2nd Anniversary with Vessel Information</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – May 13, 2011</h6>\r\n            <p><b>Sailing Schedules Website Expands Results to Display Vessel Register Data.</b></p>\r\n            <p>Linescape, the leading global sailing schedules search engine, which provides the quickest and most intuitive way to search multiple carrier schedules, now includes key vessel profile information within search results as users browse vessel voyage schedules.</p>\r\n            <p>Linescape, celebrating the second anniversary of its launch, allows thousands of daily users to search and view schedule data from over 120 container shipping lines with more than 8 million voyages searchable all at once, including data on 5,000 vessels sailing through 3,000 ports. Linescape offers free hosting of sailing schedules from any VOCC carrier, and encourages any NVOCC carrier to host theirs as ‘sponsored schedules’ which are specially highlighted to promote their business and services.</p>\r\n            <p>“Detailed vessel data is now just a click away, including: Vessel Name, IMO Number, Ship Type, Year Built, Country of Registry, DWT, Operator and TEU capacity”, said co-founder David Tarizzo. “We continue to respond to the demands of our users for a one-stop data service, and to the needs of the logistics industry to make their work more efficient and highly effective by expanding available data, and the ease of access.”.</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(835));


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeExhibitIntermodalEuropeAmsterdamComponent = (function (_super) {
    __extends(LinescapeExhibitIntermodalEuropeAmsterdamComponent, _super);
    function LinescapeExhibitIntermodalEuropeAmsterdamComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape to exhibit at Intermodal Europe in Amsterdam - Linescape";
        _this.description = "Search Engine to unveil new developments at Intermodal, Nov. 30 - Dec. 2, 2010.";
        return _this;
    }
    LinescapeExhibitIntermodalEuropeAmsterdamComponent = __decorate([
        core_1.Component({
            selector: 'linescape-exhibit-intermodal-europe-amsterdam',
            template: __webpack_require__(836),
            styles: [__webpack_require__(7), __webpack_require__(837)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeExhibitIntermodalEuropeAmsterdamComponent);
    return LinescapeExhibitIntermodalEuropeAmsterdamComponent;
}(blog_page_1.BlogPage));
exports.LinescapeExhibitIntermodalEuropeAmsterdamComponent = LinescapeExhibitIntermodalEuropeAmsterdamComponent;


/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape to exhibit at Intermodal Europe in Amsterdam</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – October 25, 2010</h6>\r\n            <p><b>Search Engine to unveil new developments at Intermodal, Nov. 30 - Dec. 2, 2010.</b></p>\r\n            <p>Linescape will exhibit at the Intermodal Exhibition taking place at Amsterdam RAI from November 30 to December 2. Visitors are invited to stand B-88 to view demonstrations of Linescape's products and services. (<a href=\"http://www.intermodal-events.com\" target=\"_blank\">www.intermodal-events.com</a>)</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(839));


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var TransworldExpeditionShipTruckComponent = (function (_super) {
    __extends(TransworldExpeditionShipTruckComponent, _super);
    function TransworldExpeditionShipTruckComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Transworld Expedition uses Linescape to Ship Truck around the World - Linescape";
        _this.description = "Linescape is a great tool to find container ships, when they leave, how long and what company.";
        return _this;
    }
    TransworldExpeditionShipTruckComponent = __decorate([
        core_1.Component({
            selector: 'transworld-expedition-ship-truck',
            template: __webpack_require__(840),
            styles: [__webpack_require__(7), __webpack_require__(841)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], TransworldExpeditionShipTruckComponent);
    return TransworldExpeditionShipTruckComponent;
}(blog_page_1.BlogPage));
exports.TransworldExpeditionShipTruckComponent = TransworldExpeditionShipTruckComponent;


/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Transworld Expedition uses Linescape to Ship Truck around the World</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – August 26, 2010</h6>\r\n            <p><b>Linescape is a great tool to find container ships, when they leave, how long and what company.</b></p>\r\n            <p>In the summer of 2009, Nicolas Rapp decided to take a break from his Art Director job at The Associated Press to attempt a one-year overland travel around the world in a 1996 Toyota Land Cruiser.</p>\r\n            <p>During the expedition, he used Linescape to ship his truck a half-dozen times: from Argentina to South Africa, from Djibouti to Yemen, from Dubai to Iran, from Iran to Mumbai, from Bangladesh to Malaysia, from South East Asia to the United States.</p>\r\n            <p>\"Linescape is a great tool to find container ships, when they leave, how long and what company; I used it a lot to ship the truck\", said Nicolas Rapp. (<a href=\"http://www.transworldexpedition.com\" target=\"_blank\">www.transworldexpedition.com</a>)</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(843));


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeCarrierProfilesAnniversaryComponent = (function (_super) {
    __extends(LinescapeCarrierProfilesAnniversaryComponent, _super);
    function LinescapeCarrierProfilesAnniversaryComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape celebrates 1st Anniversary with Carrier Profiles - Linescape";
        _this.description = "Sailing Schedules Website Adds Carrier Profile and Fleet Information.";
        return _this;
    }
    LinescapeCarrierProfilesAnniversaryComponent = __decorate([
        core_1.Component({
            selector: 'linescape-carrier-profiles-anniversary',
            template: __webpack_require__(844),
            styles: [__webpack_require__(7), __webpack_require__(845)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeCarrierProfilesAnniversaryComponent);
    return LinescapeCarrierProfilesAnniversaryComponent;
}(blog_page_1.BlogPage));
exports.LinescapeCarrierProfilesAnniversaryComponent = LinescapeCarrierProfilesAnniversaryComponent;


/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape celebrates 1st Anniversary with Carrier Profiles</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – May 4, 2010</h6>\r\n            <p><b>Sailing Schedules Website Adds Carrier Profile and Fleet Information.</b></p>\r\n            <p>Linescape, the leading global sailing schedules search engine, which provides the quickest and most intuitive way to search multiple carrier schedules, now includes key carrier profile and fleet information linked to schedule search results.</p>\r\n            <p>Linescape, celebrating the first anniversary of its launch, allows thousands of daily users to search and view schedule data from over 110 container shipping lines with more than 7 million voyages searchable all at once, including data on 5,000 vessels sailing through 3,000 ports. Linescape offers free hosting of sailing schedules from any VOCC carrier, and encourages any NVOCC carrier to host theirs as ‘sponsored schedules’ which are specially highlighted to promote their business and services.</p>\r\n            <p>“Expanded carrier information is now just a click away, including: BIC/SCAC code, Company Name, Address, Telephone, Telefax, Website, Parent Company, Regions Served, Fleet Size (Ships) and Fleet Capacity (TEU)”, said co-founder David Tarizzo. “We continue to respond to the demands of our users for a one-stop data service, and to the needs of the logistics industry to make their work more efficient and highly effective by expanding available data, and the ease of access.”.</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(847));


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeLaunchesOceanContainerSearchComponent = (function (_super) {
    __extends(LinescapeLaunchesOceanContainerSearchComponent, _super);
    function LinescapeLaunchesOceanContainerSearchComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape launches Ocean Container Schedule Search Engine - Linescape";
        _this.description = "Innovative, Powerful Tool Reveals Optimum Container Shipping Schedules Using Advanced Features and Industry’s Broadest Database.";
        return _this;
    }
    LinescapeLaunchesOceanContainerSearchComponent = __decorate([
        core_1.Component({
            selector: 'linescape-launches-ocean-container-search',
            template: __webpack_require__(848),
            styles: [__webpack_require__(7), __webpack_require__(849)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeLaunchesOceanContainerSearchComponent);
    return LinescapeLaunchesOceanContainerSearchComponent;
}(blog_page_1.BlogPage));
exports.LinescapeLaunchesOceanContainerSearchComponent = LinescapeLaunchesOceanContainerSearchComponent;


/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape launches Ocean Container Schedule Search Engine</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – May 4, 2009</h6>\r\n            <p><b>Innovative, Powerful Tool Reveals Optimum Container Shipping Schedules Using Advanced Features and Industry’s Broadest Database.</b></p>\r\n            <p>Linescape announced today the launch of its free, independent search engine for finding and comparing routes and schedules for shipping ocean containers. Linescape brings to users the only comprehensive and impartial overview of the routes and schedules of the world's carriers, of all sizes, thus giving shippers and forwarders the freedom and ease to find the carrier with the lowest cost or the best schedule for any particular shipment. Linescape’s powerful search engine leverages Web 2.0 technology to simplify sorting through 6 million voyages to 3,000 ports on over 100 shipping lines, and with more added each week. In today’s economic climate, optimized logistics and supply chain functionality is critical for success. It is crucial that shippers and forwarders know all of the options they have in order to get the best price and delivery times for shipping goods to their customers. Equally, shipping lines need a place to bring their offerings to the attention of shippers and forwarders. Linescape provides the perfect market place for buyers and sellers to meet: www.linescape.com.</p>\r\n            <p>“We studied the container shipping market and discovered that freight rates can vary by 50% and transit times by 75% on the same route. Choosing the wrong carrier will waste time or waste money or both,” said co-founder Dimitrios Sogas. “The biggest problem has always been the difficulty in finding which carriers sail on which routes; many shippers and forwarders do not even know whom to call. They usually contact only familiar carriers for quotations and therefore often miss out on better options that they do not even know exist, because they can’t find them”.</p>\r\n            <p>“Linescape is the answer to the fundamental question, ‘Whom should I call for a quotation?’” according to co-founder David Tarizzo. “Linescape finds you alternatives and saves you time, like an Expedia for the container shipping industry, which in the end will save time and money for shippers and forwarders everywhere.”</p>\r\n            <p>Linescape has introduced several advanced features unique to its search engine, including an innovative “Route Planner” that presents users with a matrix of all the possible port combinations between two geographical areas and which carriers serve those routes. This very powerful and easy to use feature will simplify one of the most difficult tasks of a user – trying to choose the best possible origin and destination ports. A unique aspect of the website is the visibility of the number of transhipments in a journey, allowing a user to balance journey times with numbers of tranships to keep risks of delay to a minimum. Another advanced feature is the innovative “Multiple Lines” feature, whereby users are able to automatically build routes via transhipments, even between two unrelated shipping lines. (<a [routerLink]=\"['/about']\">www.linescape.com/about</a>)</p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(851));


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeLaunchesSailingScheduleComponent = (function (_super) {
    __extends(LinescapeLaunchesSailingScheduleComponent, _super);
    function LinescapeLaunchesSailingScheduleComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape Launches Sailing Schedule API for Data-on-Demand - Linescape";
        _this.description = "Leading Sailing Schedule data provider launches its first API as an exciting new alternative solution to its traditional bulk data feeds.";
        return _this;
    }
    LinescapeLaunchesSailingScheduleComponent = __decorate([
        core_1.Component({
            selector: 'linescape-launches-sailing-schedule',
            template: __webpack_require__(852),
            styles: [__webpack_require__(7), __webpack_require__(853)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeLaunchesSailingScheduleComponent);
    return LinescapeLaunchesSailingScheduleComponent;
}(blog_page_1.BlogPage));
exports.LinescapeLaunchesSailingScheduleComponent = LinescapeLaunchesSailingScheduleComponent;


/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape Launches Sailing Schedule API for Data-on-Demand</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – November 2, 2017</h6>\r\n            <p><b>Leading Sailing Schedule data provider launches its first API as an exciting new alternative solution to its traditional bulk data feeds.</b></p>\r\n            <p>Linescape was one of the first providers of aggregated sailing schedules, initially delivered only by data feeds, as CSV files by FTP download. But now, Linescape has unveiled its API which allows users to make requests and receive responses as and when needed, and at lower cost.</p>\r\n            <p>“Data feeds are great, but only for those wanting to host and maintain the database on their IT system, whereas with the API we host the database and our users simply make calls to it as and when necessary”, said vice-president and co-founder, Dimitrios Sogas. “The API can provide a more cost-effect way to integrate sailing schedules, and we even offer low-cost plans for light usage, thereby appealing to an even wider audience.”</p>\r\n            <p>Linescape offers customers a variety of monthly fixed-priced API plans, based on the number of monthly calls, so there is a plan for every level of usage.</p>\r\n            <br>\r\n            <p><b>Contact:</b></p>\r\n            <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n            <p><b>Marketing &amp; PR</b><br><a href=\"mailto:media@linescape.com\">media@linescape.com</a></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(855));


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var CogoportAddsLinescapeSchedulesComponent = (function (_super) {
    __extends(CogoportAddsLinescapeSchedulesComponent, _super);
    function CogoportAddsLinescapeSchedulesComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Cogoport adds Linescape Sailing Schedules to live Freight Rates - Linescape";
        _this.description = "Indian digital platform integrates Linescape's schedule data with real-time freight rates for instant online bookings.";
        return _this;
    }
    CogoportAddsLinescapeSchedulesComponent = __decorate([
        core_1.Component({
            selector: 'cogoport-adds-linescape-schedules',
            template: __webpack_require__(856),
            styles: [__webpack_require__(7), __webpack_require__(857)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], CogoportAddsLinescapeSchedulesComponent);
    return CogoportAddsLinescapeSchedulesComponent;
}(blog_page_1.BlogPage));
exports.CogoportAddsLinescapeSchedulesComponent = CogoportAddsLinescapeSchedulesComponent;


/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Cogoport adds Linescape Sailing Schedules to live Freight Rates</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – December 7, 2018</h6>\r\n            <p><b>Indian digital platform integrates Linescape's schedule data with real-time freight rates for instant online bookings.</b></p>\r\n            <p>Linescape, the leading provider of sailing schedule data solutions, was selected by Cogoport, India, to provide consolidated sailing schedules to their freight rate and shipping platform, which is a leading online platform in India.</p>\r\n            <p>“Linescape’s sailing schedules enhance the data available on our platform, giving our users all the information they need to plan their shipping,” said Nishant Dalmia, co-founder and CTO. “With Linescape data, we can leverage technology, algorithms and analytics to make international shipments easy, affordable and hassle free.”</p>\r\n            <p>Linescape hosts the container sailing schedules from over 120 shipping lines, including deep-sea, short-sea and feeders, with some 8 million schedules through 250,000 port pairs by more than 4000 cargo and container vessels. Data includes a wide variety of in-depth information including: sailing schedules, vessel register data, carrier profiles and local carrier contacts. Linescape pioneered data feeds in 2010 and is now the leading schedule data supplier to shippers, forwarders, logistic providers, port communities and logistics websites.</p>\r\n            <p><u><b>About Cogoport</b></u></p>\r\n            <p>Cogoport is the fastest way to ship containers, where shippers can discover freight rates in real time on 70+ carriers and book instantly. No hidden charges. Cogoport is a rapidly expanding group of young and driven tech savvy entrepreneurs, engineers, designers, innovators and thinkers and who are working to bring the trillion dollar freight industry online. Cogoport is a privately held company and is head-quartered in Mumbai, India. (www.cogoport.com)</p>\r\n            <br>\r\n            <p><b>Contact:</b></p>\r\n            <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n            <p><b>Marketing &amp; PR</b><br><a href=\"mailto:media@linescape.com\">media@linescape.com</a></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(859));


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeCelebrates10thAnniversaryComponent = (function (_super) {
    __extends(LinescapeCelebrates10thAnniversaryComponent, _super);
    function LinescapeCelebrates10thAnniversaryComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape celebrates 10th Anniversary by adding Port Terminal Names to Port Calls - Linescape";
        _this.description = "Leading Sailing Schedule data provider enhances port calls with berth or terminal names.";
        return _this;
    }
    LinescapeCelebrates10thAnniversaryComponent = __decorate([
        core_1.Component({
            selector: 'linescape-celebrates-10th-anniversary',
            template: __webpack_require__(860),
            styles: [__webpack_require__(7), __webpack_require__(861)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeCelebrates10thAnniversaryComponent);
    return LinescapeCelebrates10thAnniversaryComponent;
}(blog_page_1.BlogPage));
exports.LinescapeCelebrates10thAnniversaryComponent = LinescapeCelebrates10thAnniversaryComponent;


/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape celebrates 10th Anniversary by adding Port Terminal Names to Port Calls</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – May 10, 2019</h6>\r\n            <p><b>Leading Sailing Schedule data provider enhances port calls with berth or terminal names.</b></p>\r\n            <p>Linescape, the leading provider of global sailing schedules, has enhanced port call information by adding berth or terminal names, to more accurately display a vessel’s arrival and departure location within a port.</p>\r\n            <p>“We added berth and terminal names to port calls in our data feeds and API as a direct response to customer requests for more details which help to streamline their operations”, said president and co-founder, David Tarizzo. “One of the main benefits to Linescape customers is our willingness to listen to our customers and work closely with them to make additions and enhancements to meet their requirements. We are always very flexible.”</p>\r\n            <p>Linescape, celebrating its 10th anniversary as a provider of sailing schedules to the shipping and transportation industry, now provides data from 120 carriers with 3000 services, sailing 4000 vessels through 900 ports. Over any 3-month period, this represents 60,000 voyages with 260,000 port pairs comprising 8 million schedules. Customers integrate schedules into their IT systems to lower costs and increase process efficiencies.</p>\r\n            <br>\r\n            <p><b>Contact:</b></p>\r\n            <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n            <p><b>Marketing &amp; PR</b><br><a href=\"mailto:media@linescape.com\">media@linescape.com</a></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(863));


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeWebsiteNewLookComponent = (function (_super) {
    __extends(LinescapeWebsiteNewLookComponent, _super);
    function LinescapeWebsiteNewLookComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape website gets a new look and more features - Linescape";
        _this.description = "Leading Sailing Schedule data provider refreshes its website for easier use and more targeted information.";
        return _this;
    }
    LinescapeWebsiteNewLookComponent = __decorate([
        core_1.Component({
            selector: 'linescape-website-new-look',
            template: __webpack_require__(864),
            styles: [__webpack_require__(7), __webpack_require__(865)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeWebsiteNewLookComponent);
    return LinescapeWebsiteNewLookComponent;
}(blog_page_1.BlogPage));
exports.LinescapeWebsiteNewLookComponent = LinescapeWebsiteNewLookComponent;


/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape website gets a new look and more features</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – August 27, 2019</h6>\r\n            <p><b>Leading Sailing Schedule data provider refreshes its website for easier use and more targeted information.</b></p>\r\n            <p>Linescape, the foremost provider of sailing schedule data solutions, has re-launched its industry-leading search engine with a new look and more features.</p>\r\n            <p>“After our last major upgrade two years ago, we have listened to our users requests and have launched a new version of the website to provide users with an even easier way to search sailing schedules”, stated vice-president and co-founder, Dimitrios Sogas. “The search interface is now accessible from any page, and we’ve add more details about our data feeds, API and carrier list, as well as more information about what we do and how we do it.”</p>\r\n            <p>Linescape is the leading provider of sailing schedule data solutions for the container shipping industry. With data from 120 carriers through 3,000 services, sailing 4,000 vessels through 900 ports, over any 3-month period, this represents 65,000 voyages reaching 270,000 port pairs comprising 8 million schedules. Whether for planning container bookings or analyzing vessel movements, Linescape has the most comprehensive database. Complete, accurate and updated continuously, Linescape’s sailing schedule data is available to logistics professionals - anytime, anywhere.</p>\r\n            <br>\r\n            <p><b>Contact:</b></p>\r\n            <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n            <p><b>Marketing &amp; PR</b><br><a href=\"mailto:media@linescape.com\">media@linescape.com</a></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(867));


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var SuzhouYunLogisticsTechnologySelectsLinescape = (function (_super) {
    __extends(SuzhouYunLogisticsTechnologySelectsLinescape, _super);
    function SuzhouYunLogisticsTechnologySelectsLinescape(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Suzhou Yun Logistics Technology chooses Linescape Sailing Schedule Data";
        _this.description = "Leading Chinese logistics platform adds Linescape's schedules to enhance freight rate data and vessel tracking.";
        return _this;
    }
    SuzhouYunLogisticsTechnologySelectsLinescape = __decorate([
        core_1.Component({
            selector: 'suzhou-yun-logistics-technology-selects-linescape',
            template: __webpack_require__(868),
            styles: [__webpack_require__(7), __webpack_require__(869)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], SuzhouYunLogisticsTechnologySelectsLinescape);
    return SuzhouYunLogisticsTechnologySelectsLinescape;
}(blog_page_1.BlogPage));
exports.SuzhouYunLogisticsTechnologySelectsLinescape = SuzhouYunLogisticsTechnologySelectsLinescape;


/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-banner-inner\">\r\n        <h2>Suzhou Yun Logistics Technology chooses Linescape Sailing Schedule Data</h2>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"main-content\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"col-holder page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n          <div class=\"col-holder\">\r\n            <div class=\"page-content-left\">\r\n              <h6 class=\"author-sub-head\">Burlingame, CA – September 14, 2017</h6>\r\n              <p><b>Leading Chinese logistics platform adds Linescape's schedules to enhance freight rate data and vessel tracking.</b></p>\r\n              <p>Linescape, the leading provider of global sailing schedule, vessel and carrier data for containerships, is now supplying sailing schedule data feeds to Suzhou Yun Logistics Technology, the first online platform to provide a comprehensive international tracking service from inland factories in China to overseas ports. Linescape and Suzhou Yun have worked together to integrate Linescape's data into Suzhou Yun’s newly developed platform.</p>\r\n              <p>\"The Linescape data feed enhances Suzhou Yun’s solution for all of our users,\" according to Frank Xu, vice-president of Suzhou Yun Logistics Technology. \"Suzhou Yun is an international web-based service provider, specializing in online supply chain operations management. We combine Linescape’s sailing schedules with shipping prices for our customers to easily select.\"</p>\r\n              <p>Linescape is the first independent website to present a comprehensive and impartial overview of the routes and schedules of the world's containership lines. Linescape gives shippers and forwarders the ability to search sailing schedules from over 3,000 services offered by 120 carriers, comprising 240,000 port pairs. The company is headquartered in Burlingame, California. It's not affiliated with any carrier, acting independently from all shipping lines, shippers and forwarders.</p>\r\n              <p><u>About Suzhou Yun</u></p>\r\n              <p>Suzhou Yun Logistics Technology Co. Ltd. was founded in Suzhou, China, in 2015. The head offices are located in Creative Industrial Park, in close proximity to neighboring Shanghai, where many operations are currently focused. Suzhou Yun is leading the way in China as the first online platform to provide a comprehensive international tracking service from inland factories to overseas ports. Specializing in delivering up to date global logistical information to micro, small and medium sized foreign trade enterprises, Suzhou Yun also liaises with logistics providers around the world to better understand local and national markets. (www.yunlsp.com)</p>\r\n              <br>\r\n              <p><b>Contact:</b></p>\r\n              <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n              <p><b>Marketing &amp; PR</b><br><a href=\"mailto:media@linescape.com\">media@linescape.com</a></p>\r\n            </div>\r\n            <div class=\"page-content-sidebar-right\">\r\n              <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>"

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(871));


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeJournalOfCommerceComponent = (function (_super) {
    __extends(LinescapeJournalOfCommerceComponent, _super);
    function LinescapeJournalOfCommerceComponent(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Sailing Schedule Data Improves Visibility and Efficiency - Linescape";
        _this.description = "Leading Sailing Schedule data provider refreshes its website for easier use and more targeted information.";
        return _this;
    }
    LinescapeJournalOfCommerceComponent = __decorate([
        core_1.Component({
            selector: 'linescape-journal-of-commerce-technology',
            template: __webpack_require__(872),
            styles: [__webpack_require__(7), __webpack_require__(873)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeJournalOfCommerceComponent);
    return LinescapeJournalOfCommerceComponent;
}(blog_page_1.BlogPage));
exports.LinescapeJournalOfCommerceComponent = LinescapeJournalOfCommerceComponent;


/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape Featured in Journal of Commerce Editorial Supplement</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – September 14, 2020</h6>\r\n            <p><b>Sailing Schedule Data Improves Visibility and Efficiency</b></p>\r\n            <p>Linescape, the leading provider of sailing schedule data solutions, was featured in the September Technology supplement of the Journal of Commerce. An interview with co-founder, David Tarizzo, can be viewed on page 72 <a target=\"_blank\" href=\"https://jocdigital.uberflip.com/i/1285094-september-14-2020/69?\">here</a>.</p>\r\n            <p>Accurate shipment planning demands accurate data.  As the transport industry rapidly moves to deep automation, and the capability to process huge amounts of data becomes routine, the depth and quality of that data directly impacts the quality of the results.</p>\r\n            <p>Linescape is the leading independent source for ocean container shipping routes and schedules. Our aggregated, clarified, structured data supplies a wide variety of industry needs.  Everything needed for researching and understanding the schedules of ship movements is at the industry’s fingertips: data to feed route planning, predicative studies, performance benchmarks or many other logistics tools to satisfy the growing needs to provide higher levels of service to the industry.</p>\r\n            <p>The best business decisions start with data-driven insights. Linescape combines up-to-date schedule data with cutting-edge technology that helps our users make the most informed decisions possible – for today or for future planning.   Our data comprises routes and schedules from over 120 carriers (deep sea, short sea and feeders), all of which is continuously updated to ensure the most current data is available.</p>\r\n            <p>Our technology provides the best fit access to users to match their internal needs.  From a massive daily bulk delivery to API on-demand data down to individual website searches; we have a delivery solution optimized for every use case.</p>\r\n            <p>Linescape’s variety of applications lets logistics professionals search schedules from any view: by port pairs, by vessel name, by port call or by ocean carrier. We offer a variety of data service levels to support the small freight forwarder to the Fortune 100 global manufacturing companies.</p>\r\n            <p>Whether you’re planning container bookings or analyzing vessel movements, Linescape has the most comprehensive sailing schedule database. Complete, accurate and updated continuously, our schedule data is available to logistics professionals – anytime, anywhere.</p>\r\n            <p><b>About Linescape</b></p>\r\n            <p>Linescape hosts the container sailing schedules from over 120 shipping lines, with some 8 million schedules through 270,000 port pairs by more than 4000 vessels on 3,000 services. Data includes a wide variety of in-depth information including: sailing schedules, vessel register data, carrier profiles and local carrier contacts. Linescape pioneered data feeds in 2010 and is now the leading schedule data supplier to shippers, forwarders, logistic providers, port communities and logistics websites.</p>\r\n            <p><b>About Journal of Commerce</b></p>\r\n            <p>The Journal of Commerce (JOC) is a biweekly magazine published in the United States that focuses on global trade topics. First published in 1827 in New York, it has a circulation of approximately 15,000. It provides editorial content to manage day-to-day international logistics and shipping need, covering the areas of cargo and freight transportation, export and import, global transport logistics and trade, international supply chain management and US Customs regulations.</p>\r\n            <br>\r\n            <p><b>Contact:</b></p>\r\n            <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n            <p><b>Marketing &amp; PR</b><br><a href=\"mailto:media@linescape.com\">media@linescape.com</a></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(875));


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeCeoToSpeakAtGlobalLinerShippingConference = (function (_super) {
    __extends(LinescapeCeoToSpeakAtGlobalLinerShippingConference, _super);
    function LinescapeCeoToSpeakAtGlobalLinerShippingConference(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape CEO to Speak at Global Liner Shipping Conference";
        _this.description = "Linescape CEO, David Tarizzo, will give a speech entitled, “The Troubles with Sailing Schedules”, at the Global Liner Shipping Virtual Conference to be held on November 2-4, 2020.";
        return _this;
    }
    LinescapeCeoToSpeakAtGlobalLinerShippingConference = __decorate([
        core_1.Component({
            selector: 'linescape-ceo-to-speak-at-global-liner-shipping-conference',
            template: __webpack_require__(876),
            styles: [__webpack_require__(7), __webpack_require__(877)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeCeoToSpeakAtGlobalLinerShippingConference);
    return LinescapeCeoToSpeakAtGlobalLinerShippingConference;
}(blog_page_1.BlogPage));
exports.LinescapeCeoToSpeakAtGlobalLinerShippingConference = LinescapeCeoToSpeakAtGlobalLinerShippingConference;


/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape CEO to Speak at Global Liner Shipping Conference</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA – September 29, 2020</h6>\r\n            <p><b>Linescape CEO, David Tarizzo, will give a speech entitled, “The Troubles with Sailing Schedules”, at the Global Liner Shipping Virtual Conference to be held on November 2-4, 2020.</b></p>\r\n            <p>Linescape is the leading provider of sailing schedule data solutions, and its CEO, David Tarizzo, will present a first-of-its-kind assessment of the “The Troubles with Sailing Schedules” at the Global Liner Shipping Virtual Conference on November 3, 2020 at 3:50pm, Central European Time.</p>\r\n            <p>The main topics of his speech will focus on the following issues:</p>\r\n            <p style=\"margin-left: 30px; margin-bottom: -8px;\">•\tSailing Schedules</p>\r\n            <p style=\"margin-left: 30px; margin-bottom: -8px;\">•\tSchedule Updates</p>\r\n            <p style=\"margin-left: 30px; margin-bottom: -8px;\">•\tPerformance & Reliability</p>\r\n            <p style=\"margin-left: 30px; margin-bottom: -8px;\">•\tPort Location Codes</p>\r\n            <p style=\"margin-left: 30px; margin-bottom: -8px;\">•\tTerminal Operator Codes</p>\r\n            <p style=\"margin-left: 30px;\">•\tCarrier Identity Codes</p>\r\n            <p>As co-founder and CEO of Linescape, David Tarizzo, has been working with sailing schedules for more than 10 years, and is in the unique position to understand the issues behind sailing schedules to all sectors of the industry.</p>\r\n            <p>Prior to joining Linescape, David was a shipper who exported containers all around the world and from this experience he developed direct insight into the difficulties with sailing schedules and opportunities for standardization.</p>\r\n            <p>With two decades of experience in transportation and logistics, David has established relationships with industry stakeholders and a thorough understanding of the drivers related to sailing schedules.</p>\r\n            <p>David has an MBA from the University of Michigan, including a semester at Erasmus University in Rotterdam.</p>\r\n            <br />\r\n            <p><b>Contact:</b></p>\r\n            <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n            <p><b>Marketing &amp; PR</b><br><a href=\"mailto:media@linescape.com\">media@linescape.com</a></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(879));


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LinescapeEnhancesSailingScheduleswithActualTrackingData = (function (_super) {
    __extends(LinescapeEnhancesSailingScheduleswithActualTrackingData, _super);
    function LinescapeEnhancesSailingScheduleswithActualTrackingData(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Linescape Enhances Sailing Schedules with Actual Tracking Data";
        _this.description = "Updating schedules with actual departure and arrival times provides subscribers with greater visibility over their shipments.";
        return _this;
    }
    LinescapeEnhancesSailingScheduleswithActualTrackingData = __decorate([
        core_1.Component({
            selector: 'linescape-enhances-sailing-schedules-with-actual-tracking-data',
            template: __webpack_require__(880),
            styles: [__webpack_require__(7), __webpack_require__(881)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LinescapeEnhancesSailingScheduleswithActualTrackingData);
    return LinescapeEnhancesSailingScheduleswithActualTrackingData;
}(blog_page_1.BlogPage));
exports.LinescapeEnhancesSailingScheduleswithActualTrackingData = LinescapeEnhancesSailingScheduleswithActualTrackingData;


/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Linescape Enhances Sailing Schedules with Actual Tracking Data</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"col-holder page-content-wrapper\">\r\n      <div class=\"page-content\">\r\n        <div class=\"col-holder\">\r\n          <div class=\"page-content-left\">\r\n            <h6 class=\"author-sub-head\">Burlingame, CA - February 15, 2022</h6>\r\n            <p><b>Updating schedules with actual departure and arrival times provides subscribers with greater visibility over their shipments.</b></p>\r\n            \r\n            <p>Linescape, the leading provider of ocean container schedules, is now offering their subscribers access to actual voyage tracking in addition to their unparalleled database of future sailing schedules, allowing their customers the ability to get a continuously updated view of a voyage as it traverses the oceans. The juxtaposition of a vessel's future path, with its actual path is invaluable to the logistics industry, particularly during these times of global uncertainty.\r\n            </p>\r\n\r\n            <p style=\"font-style: italic;\">\"The entire logistics industry is running, not walking, to provide some visibility and clarity to their customers,\" co-founder Dimitrios Sogas explains, \"Now, with the inclusion of actuals with our planned schedule data, our users have the ability to make more refined transit plans and risk assessments. Our new solutions will be on display at our booth at the TPM Conference in Long Beach, February 28th to March 2nd.\"</p>\r\n\r\n            <p>Linescape's customizable subscriptions can be configured to suit almost any ocean shipping needs. Linescape's powerful and intuitive API allows users to dynamically gather the relevant information for their cargo transit.</p>\r\n\r\n            <p>According to David Tarizzo, president and co-founder, \"The depth and breadth of our data continues to grow and, coupled with our proprietary error checking and routing heuristics, allows us to serve the widest range of customers in the industry. We offer a broad spectrum of solutions that can fit almost any budget and scale of service - from the small local operation to the large global operator.\"</p>\r\n\r\n            <p>The powerful data service allows users to obtain the routes and schedules from 120 container lines, as well as scan 12 million voyages by deep-sea, short-sea and feeder-lines. What's more, they can find direct and trans-ship schedules through 300,000 port pairs and access the profiles and local contacts of hundreds of shipping lines.</p>\r\n\r\n            <p>A selection of data plans that meet any budget, large or small, puts the power of data in any shippers' hands. Learn more about how Linescape's advanced search engine capabilities can help you save time and money at <a href=\"https://www.linescape.com/\">www.linescape.com</a>.</p>\r\n\r\n            <p><b>About Linescape.com</b></p>\r\n\r\n            <p>Linescape is the first independent website to present a comprehensive and impartial overview of the routes and schedules of all the world's containership lines. The newly redesigned website gives shippers and forwarders the freedom to search schedules by port pairs, vessel name, port of call or carrier. The company is headquartered in Burlingame, California. It's not affiliated with any carrier, acting independently from all shipping lines, shippers and forwarders.</p>\r\n\r\n            <br />\r\n            <p><b>Contact:</b></p>\r\n            <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n          </div>\r\n          <div class=\"page-content-sidebar-right\">\r\n            <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(883));


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var LogitOneChoosesLinescapeAsSaillingScheduleProvider = (function (_super) {
    __extends(LogitOneChoosesLinescapeAsSaillingScheduleProvider, _super);
    function LogitOneChoosesLinescapeAsSaillingScheduleProvider(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Logit One chooses Linescape as Sailing Schedule Provider";
        _this.description = "Linescape  was chosen by Logit One, Belgium, to provide consolidated sailing schedules to the Logit One platform for collaborative transport coordination, intermediation and visibility.";
        return _this;
    }
    LogitOneChoosesLinescapeAsSaillingScheduleProvider = __decorate([
        core_1.Component({
            selector: 'logit-one-chooses-linescape-as-sailling-schedule-provider',
            template: __webpack_require__(884),
            styles: [__webpack_require__(7), __webpack_require__(885)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], LogitOneChoosesLinescapeAsSaillingScheduleProvider);
    return LogitOneChoosesLinescapeAsSaillingScheduleProvider;
}(blog_page_1.BlogPage));
exports.LogitOneChoosesLinescapeAsSaillingScheduleProvider = LogitOneChoosesLinescapeAsSaillingScheduleProvider;


/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-banner-inner\">\r\n        <h2>Logit One chooses Linescape as Sailing Schedule Provider</h2>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"main-content\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"col-holder page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n          <div class=\"col-holder\">\r\n            <div class=\"page-content-left\">\r\n              <h6 class=\"author-sub-head\">Burlingame, CA – August 7, 2018</h6>\r\n              <p><b>Linescape  was chosen by Logit One, Belgium, to provide consolidated sailing schedules to the Logit One platform for collaborative transport coordination, intermediation and visibility.</b></p>\r\n              <p>“We reviewed 3 potential suppliers of sailing schedules and chose Linescape because Linescape has the most complete and extensive database, and we particularly prefer Linescape’s data format and structure which we find to be the most intuitive”, said Mark Scheerlinck, Business development Manager at Logit One. “The people at Linescape are a great bunch, readily available and eager to work with us. They are willing to quickly tailor solutions to our needs, in contrast to their competitors who offer only a take-it-or-leave-it service.</p>\r\n              <p>Linescape hosts the container sailing schedules from over 120 shipping lines, including deep-sea, short-sea and feeders, with some 8 million schedules through 250,000 unique port pairs by more than 4,000 cargo and container vessels. Data includes a wide variety of in-depth information including: sailing schedules, vessel register data, carrier profiles and local carrier contacts. Linescape pioneered data feeds in 2010 and is now the leading schedule data supplier to shippers, forwarders, logistic providers, port communities and digital logistics platforms and supply chain visibility providers.</p>\r\n              <p><u>About Logit One</u></p>\r\n              <p>Logit One developed solutions for door-to-door transport chain management and operational fleet management. Logit One’s mission is to translate data into real-time insights for decision makers while still enabling and supporting basic operations. We boost efficiency and improve customer experiences across the supply chain. By capturing the value of innovative technologies, we contribute to their bottom line and enhance their sustainability targets.</p>\r\n              <br>\r\n              <p><b>Contact:</b></p>\r\n              <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n              <p><b>Marketing &amp; PR</b><br><a href=\"mailto:media@linescape.com\">media@linescape.com</a></p>\r\n            </div>\r\n            <div class=\"page-content-sidebar-right\">\r\n              <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>"

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(887));


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var KotachiSelectsLinescapeSailingSchedulesApi = (function (_super) {
    __extends(KotachiSelectsLinescapeSailingSchedulesApi, _super);
    function KotachiSelectsLinescapeSailingSchedulesApi(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "Kotahi selects Linescape’s Sailing Schedules API";
        _this.description = "Linescape was selected by Kotahi Logistics, New Zealand, to provide consolidated sailing schedules to the Kotahi through Linescape’s API for their supply chain collaboration with customers.";
        return _this;
    }
    KotachiSelectsLinescapeSailingSchedulesApi = __decorate([
        core_1.Component({
            selector: 'kotahi-selects-linescape-sailing-schedules-api',
            template: __webpack_require__(888),
            styles: [__webpack_require__(7), __webpack_require__(889)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], KotachiSelectsLinescapeSailingSchedulesApi);
    return KotachiSelectsLinescapeSailingSchedulesApi;
}(blog_page_1.BlogPage));
exports.KotachiSelectsLinescapeSailingSchedulesApi = KotachiSelectsLinescapeSailingSchedulesApi;


/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-banner-inner\">\r\n        <h2>Kotahi selects Linescape’s Sailing Schedules API</h2>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"main-content\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"col-holder page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n          <div class=\"col-holder\">\r\n            <div class=\"page-content-left\">\r\n              <h6 class=\"author-sub-head\">Burlingame, CA – February 27, 2018</h6>\r\n              <p>“The data is very useful for moving New Zealand’s products around the world”, said Joshua Taylor, Head of Data at Kotahi Logistics. “And, the pricing is very reasonable to us, as well.</p>\r\n              <p>Linescape hosts the container sailing schedules from over 120 shipping lines, including deep-sea, short-sea and feeders, with some 8 million schedules through 250,000 unique port pairs by more than 4,000 cargo and container vessels. Data includes a wide variety of in-depth information including: sailing schedules, vessel register data, carrier profiles and local carrier contacts. Linescape pioneered data feeds in 2010 and is now the leading schedule data supplier to shippers, forwarders, logistic providers, port communities and digital logistics platforms and supply chain visibility providers.</p>\r\n              <p><u>About Kotahi</u></p>\r\n              <p>Kotahi means “standing together as one”. Kotahi was founded by exporters who realized that ocean freight challenges would only be overcome by working together. Kotahi’s collaboration with over 40 exporters, importers and industry partners ensures New Zealand maintains a sustainable, secure supply chain and remains competitive on the world stage.</p>\r\n              <br>\r\n              <p><b>Contact:</b></p>\r\n              <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n              <p><b>Marketing &amp; PR</b><br><a href=\"mailto:media@linescape.com\">media@linescape.com</a></p>\r\n            </div>\r\n            <div class=\"page-content-sidebar-right\">\r\n              <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>"

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(891));


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var JfHillebrandToIntegrateLinescapeIntoTms = (function (_super) {
    __extends(JfHillebrandToIntegrateLinescapeIntoTms, _super);
    function JfHillebrandToIntegrateLinescapeIntoTms(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "JF Hillebrand to integrate Linescape’s Sailing Schedules into TMS";
        _this.description = "JF Hillebrand, a Netherlands-based provider of high quality door to door service for shipping wines, has integrated Linescape’s Sailing Schedules into their TMS in order to improve customer experience.";
        return _this;
    }
    JfHillebrandToIntegrateLinescapeIntoTms = __decorate([
        core_1.Component({
            selector: 'jf-hillebrand-to-integrate-linescape-into-tms',
            template: __webpack_require__(892),
            styles: [__webpack_require__(7), __webpack_require__(893)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], JfHillebrandToIntegrateLinescapeIntoTms);
    return JfHillebrandToIntegrateLinescapeIntoTms;
}(blog_page_1.BlogPage));
exports.JfHillebrandToIntegrateLinescapeIntoTms = JfHillebrandToIntegrateLinescapeIntoTms;


/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-banner-inner\">\r\n        <h2>JF Hillebrand to integrate Linescape’s Sailing Schedules into TMS</h2>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"main-content\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"col-holder page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n          <div class=\"col-holder\">\r\n            <div class=\"page-content-left\">\r\n              <h6 class=\"author-sub-head\">Burlingame, CA – January 25, 2016</h6>\r\n              <p><b>JF Hillebrand, a Netherlands-based provider of high quality door to door service for shipping wines, has integrated Linescape’s Sailing Schedules into their TMS in order to improve customer experience.</b></p>\r\n              <p>“We’ve looked at several providers of sailing schedules and chose Linescape for the depth and breadth of their global sailing schedules”, said Marco Stigter, Manager of Software Development at JF Hillebrand. “We plan to show this information in our Transportation Management System, to make it available to our customers”.</p>\r\n              <p>Linescape hosts the container sailing schedules from over 120 shipping lines, including deep-sea, short-sea and feeders, with some 8 million schedules through 250,000 unique port pairs by more than 4,000 cargo and container vessels. Data includes a wide variety of in-depth information including: sailing schedules, vessel register data, carrier profiles and local carrier contacts. Linescape pioneered data feeds in 2010 and is now the leading schedule data supplier to shippers, forwarders, logistic providers, port communities and digital logistics platforms and supply chain visibility providers.</p>\r\n              <p><u>About JF Hillebrand</u></p>\r\n              <p>JF Hillebrand, based in the Netherlands, is the world leading forwarding, transport and logistics provider to the alcoholic beverage industry. Its mission is to deliver customers’ products in a reliable way, with ultimate care and the shortest possible transit times. JF Hillebrand manages logistics and transport for any quantity from a single bottle to bulk, from all origins to all destinations, for all modalities, making logistics simple for all customers.</p>\r\n              <br>\r\n              <p><b>Contact:</b></p>\r\n              <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n              <p><b>Marketing &amp; PR</b><br><a href=\"mailto:media@linescape.com\">media@linescape.com</a></p>\r\n            </div>\r\n            <div class=\"page-content-sidebar-right\">\r\n              <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>"

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(895));


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var blog_page_1 = __webpack_require__(8);
var MercurygateAddsLinescapeToTme = (function (_super) {
    __extends(MercurygateAddsLinescapeToTme, _super);
    function MercurygateAddsLinescapeToTme(route, app, seo) {
        var _this = _super.call(this, route, app, seo) || this;
        _this.title = "MercuryGate adds Linescape’s Sailing Schedules to TMS ";
        _this.description = "MercuryGate, the best-of-breed transportation management platform, has integrated Linescape’s Sailing Schedule Data into their award-winning Transport Management System (TMS).";
        return _this;
    }
    MercurygateAddsLinescapeToTme = __decorate([
        core_1.Component({
            selector: 'mercurygate-adds-linescape-to-tms',
            template: __webpack_require__(896),
            styles: [__webpack_require__(7), __webpack_require__(897)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute, shared_1.AppContext, shared_1.SeoService])
    ], MercurygateAddsLinescapeToTme);
    return MercurygateAddsLinescapeToTme;
}(blog_page_1.BlogPage));
exports.MercurygateAddsLinescapeToTme = MercurygateAddsLinescapeToTme;


/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"page-banner-inner\">\r\n        <h2>MercuryGate adds Linescape’s Sailing Schedules to TMS </h2>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"main-content\">\r\n    <div class=\"wrapper main-wrapper\">\r\n      <div class=\"col-holder page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n          <div class=\"col-holder\">\r\n            <div class=\"page-content-left\">\r\n              <h6 class=\"author-sub-head\">Burlingame, CA – June 26, 2013</h6>\r\n              <p><b>MercuryGate, the best-of-breed transportation management platform, has integrated Linescape’s Sailing Schedule Data into their award-winning Transport Management System (TMS).</b></p>\r\n              <p>“We’ve been working with the team at Linescape over the last 6 months to develop enhancements to improve our Freight Forwarding application”, said Doug Surrett, VP Global Logistics at MercuryGate. “We’ve completed the design and development to offer sailing schedules in our TMS. Our customers previously went to several different websites for schedule lookups, including the Linescape website, but now they can get all schedule information fully integrated within the TMS, saving time and operating more efficiently”.</p>\r\n              <p>Linescape hosts the container sailing schedules from over 120 shipping lines, including deep-sea, short-sea and feeders, with some 8 million voyages through 3,000 ports by more than 10,500 cargo and container vessels. Data includes a wide variety of in-depth information including: sailing schedules, vessel register data, carrier profiles, local carrier contacts, and CO2 emissions. Linescape pioneered data feeds in 2010 and is now the leading schedule data supplier to shippers, forwarders, logistic providers, port communities and logistics websites.</p>\r\n              <p><u>About MercuryGate</u></p>\r\n              <p>MercuryGate is the only full power, feature-rich transportation management system (TMS) that is singularly focused on strategic freight transportation management automation and has been for over a decade. The result is the best-of-breed transportation management platform that enables logistics experts to execute efficiencies previously unattainable and empowers relative newcomers to perform at expert levels they could not otherwise achieve.</p>\r\n              <br>\r\n              <p><b>Contact:</b></p>\r\n              <p><b>David Tarizzo or Dimitrios Sogas</b><br><a href=\"mailto:management@linescape.com\">management@linescape.com</a></p>\r\n              <p><b>Marketing &amp; PR</b><br><a href=\"mailto:media@linescape.com\">media@linescape.com</a></p>\r\n            </div>\r\n            <div class=\"page-content-sidebar-right\">\r\n              <plans-side-bar [type]=\"app.getPlanSideBarType()\">loading...</plans-side-bar>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>"

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var _1 = __webpack_require__(252);
var pressRoutes = [
    {
        path: '',
        component: _1.PressRollComponent
    },
    {
        path: '',
        children: [
            { path: '2022-02-15-linescape-enhances-sailing-schedules-with-actual-tracking-data', component: _1.LinescapeEnhancesSailingScheduleswithActualTrackingData },
            { path: '2020-09-29-linescape-ceo-to-speak-at-global-liner-shipping-conference', component: _1.LinescapeCeoToSpeakAtGlobalLinerShippingConference },
            { path: '2020-09-14-linescape-journal-of-commerce-technology', component: _1.LinescapeJournalOfCommerceComponent },
            { path: '2019-08-27-linescape-website-new-look', component: _1.LinescapeWebsiteNewLookComponent },
            { path: '2019-05-10-linescape-celebrates-10th-anniversary', component: _1.LinescapeCelebrates10thAnniversaryComponent },
            { path: '2018-12-7-cogoport-adds-linescape-schedules', component: _1.CogoportAddsLinescapeSchedulesComponent },
            { path: '2018-8-7-cogoport-adds-linescape-schedules', component: _1.LogitOneChoosesLinescapeAsSaillingScheduleProvider },
            { path: '2018-2-27-kotahi-selects-linescape-sailing-schedules-api', component: _1.KotachiSelectsLinescapeSailingSchedulesApi },
            { path: '2017-11-2-linescape-launches-sailing-schedule', component: _1.LinescapeLaunchesSailingScheduleComponent },
            { path: '2017-09-14-suzhou-yun-logistics-technology-selects-linescape', component: _1.SuzhouYunLogisticsTechnologySelectsLinescape },
            { path: '2017-3-20-linescape-upgrades-search-engine', component: _1.LinescapeUpgradesSearchEngineComponent },
            { path: '2016-5-6-tech-stack-anniversary', component: _1.TechStackAnniversaryComponent },
            { path: '2016-1-25-jf-hillebrand-to-integrate-linescape-into-tms', component: _1.JfHillebrandToIntegrateLinescapeIntoTms },
            { path: '2015-1-23-haven-ocean-freight-marketplace-linescape', component: _1.HavenOceanFreightMarketplaceLinescapeComponent },
            { path: '2014-10-8-xeneta-adds-linescape', component: _1.XenetaAddsLinescapeComponent },
            { path: '2014-6-4-ef3-integrates-linescape-data', component: _1.Ef3IntegratesLinescapeDataComponent },
            { path: '2013-6-26-mercurygate-adds-linescape-to-tms', component: _1.MercurygateAddsLinescapeToTme },
            { path: '2013-5-1-Linescape-4th-anniversary-transhipment-voyage', component: _1.Linescape4AniversaryTranshipmentVoyageComponent },
            { path: '2013-1-8-dbh-integrates-linescape-schedules', component: _1.DbhIntegratesLinescapeComponent },
            { path: '2012-11-5-dachser-selects-linescapes-sailing-schedules', component: _1.DachserSelectsLinescapeSchedulesComponent },
            { path: '2012-7-13-linescape-ci-award-finalist', component: _1.LinescapeCIAwardFinalistComponent },
            { path: '2012-6-14-dakosy-to-distribute-linescape', component: _1.DakosyToDistributeLinescapeComponent },
            { path: '2012-5-3-linescape-more-data-anniversary', component: _1.LinescapeMoreDataAnniversaryComponent },
            { path: '2011-10-24-linescape-exhibit-intermodal-europe', component: _1.LinescapeExhibitIntermodalEuropeComponent },
            { path: '2011-5-13-linescape-vessel-information-anniversary', component: _1.LinescapeVesselInformationAnniversaryComponent },
            { path: '2010-10-25-linescape-exhibit-intermodal-europe-amsterdam', component: _1.LinescapeExhibitIntermodalEuropeAmsterdamComponent },
            { path: '2010-8-26-transworld-expedition-ship-truck', component: _1.TransworldExpeditionShipTruckComponent },
            { path: '2010-5-4-linescape-carrier-profiles-anniversary', component: _1.LinescapeCarrierProfilesAnniversaryComponent },
            { path: '2009-5-4-linescape-launches-ocean-container-search', component: _1.LinescapeLaunchesOceanContainerSearchComponent },
        ]
    }
];
var PressRoutingModule = (function () {
    function PressRoutingModule() {
    }
    PressRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forChild(pressRoutes)
            ],
            exports: [
                router_1.RouterModule
            ]
        })
    ], PressRoutingModule);
    return PressRoutingModule;
}());
exports.PressRoutingModule = PressRoutingModule;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var RegisterService = (function () {
    function RegisterService(apiService, authService, userService, logger, billing) {
        this.apiService = apiService;
        this.authService = authService;
        this.userService = userService;
        this.logger = logger;
        this.billing = billing;
        this.holderName = '';
        this.card = '';
        this.expiration = '';
        this.month = -1;
        this.year = -1;
        this.cvc = '';
        this.postalCode = '';
        this.holderNameError = '';
        this.postalCodeError = '';
        this.coupon = '';
        this.freeAccount = false;
        this.costMultiplier = 1;
        this.accountType = 'Basic';
        this.billingPeriod = 'Monthly';
        this.cost = '';
        this.plan = 'Basic';
        this.couponValid = false;
        this.couponError = '';
        this.stripeStatus = 0;
        this.stripeResponse = null;
        this.errors = {
            holderName: '',
            card: '',
            expiration: '',
            cvc: '',
            postalCode: '',
            register: '',
            cardRegister: '',
            emailRegister: ''
        };
        this.plans = new Array();
        this.displayThanks = false;
        this.displayAccountDetails = true;
        this.loaderOn = false;
        this.getPlans();
    }
    RegisterService.prototype.getPlans = function () {
        var _this = this;
        this.billing.getPlans().then(function (plans) {
            _this.plans = plans;
        });
    };
    RegisterService.prototype.updateCost = function () {
        var cost = '';
        if (this.accountType === 'Premium') {
            if (this.billingPeriod === 'Monthly') {
                cost = "You will be charged $" + (49 * this.costMultiplier).toFixed(2) + " in 14 days";
                this.plan = 'monthly-premium';
            }
            else {
                cost = "You will be charged $" + (488 * this.costMultiplier).toFixed(2) + " in 14 days";
                this.plan = 'yearly-premium';
            }
        }
        else if (this.accountType === 'Professional') {
            if (this.billingPeriod === 'Monthly') {
                cost = "You will be charged $" + (99 * this.costMultiplier).toFixed(2) + " in 14 days";
                this.plan = 'monthly-professional';
            }
            else {
                cost = "You will be charged $" + (988 * this.costMultiplier).toFixed(2) + " in 14 days";
                this.plan = 'yearly-professional';
            }
        }
        else if (this.accountType === 'Enterprise6') {
            if (this.billingPeriod === 'Monthly') {
                cost = "You will be charged $" + (149 * this.costMultiplier).toFixed(2);
                this.plan = 'price_1HUDlXBI16lWsbHUpazF2axJ';
            }
            else {
                cost = "You will be charged $" + (1488 * this.costMultiplier).toFixed(2);
                this.plan = 'price_1HrW7lBI16lWsbHUsNT327Sp';
            }
        }
        else if (this.accountType === 'Enterprise12') {
            if (this.billingPeriod === 'Monthly') {
                cost = "You will be charged $" + (199 * this.costMultiplier).toFixed(2);
                this.plan = 'price_1HUDrpBI16lWsbHUEcy8QqRp';
            }
            else {
                cost = "You will be charged $" + (1988 * this.costMultiplier).toFixed(2);
                this.plan = 'price_1HtzNJBI16lWsbHUF6DRNf0X';
            }
        }
        else if (this.accountType === 'Enterprise18') {
            if (this.billingPeriod === 'Monthly') {
                cost = "You will be charged $" + (249 * this.costMultiplier).toFixed(2);
                this.plan = 'price_1HUDwiBI16lWsbHUJUXFNMp2';
            }
            else {
                cost = "You will be charged $" + (2488 * this.costMultiplier).toFixed(2);
                this.plan = 'price_1HtzKUBI16lWsbHU4gyZlwmJ';
            }
        }
        else if (this.accountType === 'API500') {
            this.billingPeriod = 'Monthly';
            cost = "You will be charged $" + (330 * this.costMultiplier).toFixed(2);
            this.plan = 'price_1KDzaGCAIBqfWZikF50UOobO';
        }
        else if (this.accountType === 'API1500') {
            this.billingPeriod = 'Monthly';
            cost = "You will be charged $" + (550 * this.costMultiplier).toFixed(2);
            this.plan = 'price_1KDzdlCAIBqfWZikTr54Oj54';
        }
        else if (this.accountType === 'API4000') {
            this.billingPeriod = 'Monthly';
            cost = "You will be charged $" + (1000 * this.costMultiplier).toFixed(2);
            this.plan = 'price_1KDzh3CAIBqfWZikkmKsljAm';
        }
        else if (this.accountType === 'API15000') {
            this.billingPeriod = 'Monthly';
            cost = "You will be charged $" + (1990 * this.costMultiplier).toFixed(2);
            this.plan = 'price_1KDzicCAIBqfWZikm7knIDYs';
        }
        else if (this.accountType === 'API50000') {
            this.billingPeriod = 'Monthly';
            cost = "You will be charged $" + (3600 * this.costMultiplier).toFixed(2);
            this.plan = 'price_1KDzlWCAIBqfWZikOzC01OKm';
        }
        else if (this.accountType === 'API150000') {
            this.billingPeriod = 'Monthly';
            cost = "You will be charged $" + (4900 * this.costMultiplier).toFixed(2);
            this.plan = 'price_1KDzoOCAIBqfWZik4wgvO1ZZ';
        }
        this.cost = this.freeAccount ? 'FREE ACCOUNT' : cost;
    };
    RegisterService.prototype.checkCoupon = function () {
        this.couponValid = false;
        this.couponError = '';
        if (this.validateCoupon()) {
            this.logger.log('register.service', 'checkCoupon', 'before call');
            this.callCheckCoupon();
        }
    };
    RegisterService.prototype.getToken = function () {
        this.expirationMasking();
        this.stripeStatus = 0;
        if (this.validateCard() && this.validateExpiration() && this.validateCVC()) {
            this.logger.log('register.service', 'getToken', 'before call');
            this.callGetToken();
        }
    };
    // **** 
    RegisterService.prototype.getTokenForCheckCard = function () {
        var model = {
            name: this.holderName.trim(),
            number: +this.card,
            exp_month: this.month,
            exp_year: this.year,
            cvc: +this.cvc,
            address_zip: this.postalCode.trim()
        };
        return this.billing.createToken(model);
    };
    RegisterService.prototype.tokenResponse = function (status, response) {
        this.stripeStatus = status;
        this.stripeResponse = response;
        if (this.stripeStatus === 200) {
            //this.cardOkay = true;
        }
        else {
            this.stripeError(response.error);
            //this.cardOkay = false;
        }
    };
    RegisterService.prototype.stripeError = function (error) {
        try {
            if (error.param === 'number') {
                this.errors.card = error.message;
            }
            else if (error.param === 'exp_year' || error.param === 'exp_month') {
                this.errors.expiration = error.message;
            }
            else if (error.param === 'name') {
                this.errors.holderName = error.message;
            }
            else if (error.param === 'address_zip') {
                this.errors.holderName = error.message;
            }
        }
        catch (ex) {
            this.errors.register = 'Card Invalid';
        }
    };
    // ****
    RegisterService.prototype.validateCoupon = function () {
        if (this.coupon.length === 0 || this.coupon.length > 256) {
            return false;
        }
        // this.errors.coupon = '';
        return true;
    };
    RegisterService.prototype.validateCard = function () {
        this.stripeStatus = 0;
        if (this.card.length !== 13 && this.card.length !== 14 && this.card.length !== 15 && this.card.length !== 16 && this.card.length !== 17 && this.card.length !== 18 && this.card.length !== 19) {
            return false;
        }
        this.errors.card = '';
        return true;
    };
    RegisterService.prototype.validateExpiration = function () {
        this.stripeStatus = 0;
        try {
            var exp = this.expiration.split('/');
            this.month = +exp[0];
            this.year = +exp[1];
            if (this.month <= 0 || this.month >= 13) {
                return false;
            }
            if (this.year <= 0 || this.year >= 100) {
                return false;
            }
        }
        catch (ex) {
            return false;
        }
        this.errors.expiration = '';
        return true;
    };
    RegisterService.prototype.validateCVC = function () {
        this.stripeStatus = 0;
        if (this.cvc.length !== 3 && this.cvc.length !== 4) {
            return false;
        }
        this.errors.cvc = '';
        return true;
    };
    RegisterService.prototype.validateHolderName = function () {
        var name = this.holderName.trim();
        if (name.length === 0 || name.length > 256) {
            this.holderNameError = 'Invalid Card Holder Name';
            return false;
        }
        else {
            this.holderNameError = '';
            return true;
        }
    };
    RegisterService.prototype.validatePostalCode = function () {
        var code = this.postalCode.trim();
        if (code.length === 0 || code.length > 256) {
            this.postalCodeError = 'Invalid Postal Code';
            return false;
        }
        else {
            this.postalCodeError = '';
            return true;
        }
    };
    RegisterService.prototype.callCheckCoupon = function () {
        var _this = this;
        this.billing.checkCoupon(this.coupon).then(function (coupon) {
            if (coupon.percentOff == 100) {
                // free account
                _this.cost = 'FREE ACCOUNT';
                _this.freeAccount = true;
                _this.couponValid = true;
            }
            else if (coupon.percentOff !== 0 && coupon.percentOff) {
                _this.costMultiplier = 1 - (coupon.percentOff / 100);
                _this.couponValid = true;
            }
            else {
                _this.couponError = 'Invalid Coupon';
                _this.couponValid = false;
            }
        }).catch(function (err) {
            // make stuff happen
            _this.couponError = 'Invalid Coupon';
            _this.couponValid = false;
        });
    };
    RegisterService.prototype.callGetToken = function () {
        var _this = this;
        var model = {
            number: +this.card,
            exp_month: this.month,
            exp_year: this.year,
            cvc: +this.cvc
        };
        this.billing.createToken(model).then(function (response) {
            _this.stripeResponseHandler(200, response);
        }).catch(function (err) {
            _this.stripeResponseHandler(400, err);
        });
    };
    RegisterService.prototype.stripeResponseHandler = function (status, response) {
        this.stripeStatus = status;
        this.stripeResponse = response;
    };
    RegisterService.prototype.registerProcess = function (model) {
        var _this = this;
        this.errors.register = '';
        this.loaderOn = true;
        this.getToken();
        this.getTokenForCheckCard()
            .then(function (response) {
            //this.tokenResponse(200, response);
            _this.billing.createCustomer(model.email, response.id) // ** stripeResponse.id
                .then(function (customer) {
                _this.registerWithCognito(model);
                _this.loaderOn = false;
            }).catch(function (err) {
                _this.cardUpdateFailure(err);
                _this.loaderOn = false;
            });
        })
            .catch(function (err) {
            _this.tokenResponse(400, err);
            _this.errors.register = err.message;
            _this.loaderOn = false;
        });
    };
    RegisterService.prototype.registerWithCognito = function (model) {
        var _this = this;
        this.logger.log('register.service', 'register before auth', model);
        this.errors.register = '';
        this.authService.register(model)
            .then(function (result) { return _this.handleRegistration(model, result); })
            .catch(function (err) { return _this.handleRegistrationError(err); });
    };
    RegisterService.prototype.handleRegistration = function (model, result) {
        this.logger.log('register.service', 'handleRegistration result', result);
        var cognitoUser = result.user;
        this.displayAccountDetails = false;
        this.displayThanks = true;
        // localStorage.setItem('email', email);
        // localStorage.setItem('password', password);
        this.registerCustomer(model, this.plan, this.coupon);
    };
    // ****
    RegisterService.prototype.updateCard = function (model) {
        var _this = this;
        this.expirationMasking();
        this.errors.register = '';
        //this.errors.cardRegister = '';
        //this.loaderOn = true;
        return new Promise(function (resolve, reject) {
            var result = 4;
            if (_this.validateHolderName() && _this.validateCard() && _this.validateExpiration() && _this.validateCVC() && _this.validatePostalCode()) {
                _this.logger.log('update-card.service', 'getToken', 'before call');
                _this.getTokenForCheckCard().then(function (response) {
                    _this.tokenResponse(200, response);
                    _this.callUpdateCard(model);
                    result = 3;
                    resolve(result);
                }).catch(function (err) {
                    //this.loaderOn = false;
                    _this.tokenResponse(400, err);
                    _this.errors.register = err.message;
                    result = 4;
                    reject(result);
                });
                //this.updateCardAttempted = true;
            }
            else {
                // card is not validated, do not create token
                //this.cardOkay = false;
                //this.loaderOn = false;
                _this.errors.register = "Invalid card";
                //this.updateCardAttempted = true;
                result = 4;
                reject(result);
            }
        });
    };
    RegisterService.prototype.callUpdateCard = function (model) {
        var _this = this;
        this.billing.createCustomer(model.email, this.stripeResponse.id)
            .then(function (customer) {
            _this.cardUpdateSuccess(customer);
            //this.loaderOn = false;
        }).catch(function (err) {
            _this.cardUpdateFailure(err);
            //this.loaderOn = false;
        });
    };
    RegisterService.prototype.cardUpdateSuccess = function (customer) {
        //this.app.setIsCustomer('stripeId'); // just to set it to true
        //this.app.setCustomer(customer);
        this.getCustomer();
        this.errors.register = 'Success';
        //this.showEditCard = false;
    };
    RegisterService.prototype.cardUpdateFailure = function (error) {
        this.logger.log('update-card.service', 'cardUpdateFailure', error);
        try {
            this.errors.register = error.data.details.message;
        }
        catch (ex) {
            this.errors.register = 'Something went wrong';
        }
    };
    RegisterService.prototype.getCustomer = function () {
        var _this = this;
        this.billing.getCustomer().then(function (customer) {
            _this.logger.log('update-card.service', 'getCustomer customer', customer);
            try {
                //this.lastFour = customer.sources[0].lastFour;
                //this.exp = `${customer.sources[0].expMonth}/${customer.sources[0].expYear}`;
            }
            catch (ex) {
                //this.lastFour = '';
                //this.exp = '';
            }
        }).catch(function (err) {
            _this.logger.log('update-card.service', 'getCustomer error', err);
        });
    };
    //****
    RegisterService.prototype.registerCustomer = function (model, planId, coupon) {
        var _this = this;
        var stripeId = '';
        var couponId = '';
        if (this.stripeStatus === 200 && this.stripeResponse !== null) {
            stripeId = this.stripeResponse.id;
        }
        if (this.couponError === '' && this.couponValid) {
            couponId = coupon; // only use the coupon if it is valid
        }
        model.token = stripeId;
        model.planId = planId;
        model.coupon = couponId;
        this.userService.createUser(model).then(function (result) {
            _this.logger.log('register.service', 'registerCustomer result', result);
            _this.apiService.destroy();
        }).catch(function (err) {
            _this.logger.log('register.service', 'registerCustomer error', err);
        });
    };
    RegisterService.prototype.handleRegistrationError = function (error) {
        this.logger.log('register.service', 'handleRegistrationError', error);
        if (error = 'Error: User already exists') {
            this.errors.register = 'Email already in use';
        }
        else {
            this.errors.register = error;
        }
        // ****
        //this.errors.register = 'handleRegistrationError';
    };
    RegisterService.prototype.expirationMasking = function () {
        if (this.expiration.match(/^\d{2}$/) !== null) {
            this.expiration = this.expiration + '/';
        }
    };
    RegisterService.prototype.numeralInputMasking = function (event) {
        var e = event || window.event;
        var key = event.keyCode || e.which;
        if ((key < 48 || key > 57) && key !== 37 && key !== 38 && key !== 39 && key !== 40 && key !== 46 && key !== 8 && key !== 35) {
            e.preventDefault();
        }
    };
    RegisterService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AuthService, shared_1.UserService, shared_1.LogService, shared_1.BillingService])
    ], RegisterService);
    return RegisterService;
}());
exports.RegisterService = RegisterService;


/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Sign Up</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n            <div *ngIf=\"service.displayAccountDetails\">\r\n                <div class=\"col-holder register-cols\">\r\n                    <div class=\"col1of2\">\r\n                        <select autofocus=\"on\" [(ngModel)]=\"service.accountType\" (ngModelChange)=\"service.updateCost()\">\r\n                            <option [ngValue]=\"basicPlan\" [attr.selected]=\"service.accountType === 'Basic' ? 'selected' : null\">\r\n                                Basic\r\n                            </option>\r\n                            <option [ngValue]=\"premiumPlan\" [attr.selected]=\"service.accountType === 'Premium' ? 'selected' : null\">\r\n                                Premium\r\n                            </option>\r\n                            <option [ngValue]=\"professionalPlan\" [attr.selected]=\"service.accountType === 'Professional' ? 'selected' : null\">\r\n                                Professional\r\n                            </option>\r\n                            <option [ngValue]=\"enterprise6Plan\" [attr.selected]=\"service.accountType === 'Enterprise6' ? 'selected' : null\">\r\n                                Enterprise 2-6 users\r\n                            </option>\r\n                            <option [ngValue]=\"enterprise12Plan\" [attr.selected]=\"service.accountType === 'Enterprise12' ? 'selected' : null\">\r\n                                Enterprise 7-12 users\r\n                            </option>\r\n                            <option [ngValue]=\"enterprise18Plan\" [attr.selected]=\"service.accountType === 'Enterprise18' ? 'selected' : null\">\r\n                                Enterprise 13-18 users\r\n                            </option>\r\n                        </select>\r\n                        <div *ngIf=\"service.accountType !== 'Basic'\">\r\n                            <select [(ngModel)]=\"service.billingPeriod\" (ngModelChange)=\"service.updateCost()\">\r\n                                <option [ngValue]=\"monthlyPlan\" [attr.selected]=\"service.billingPeriod === 'Monthly' ? 'selected' : null\">\r\n                                    Monthly\r\n                                </option>\r\n                                <option *ngIf=\"service.accountType !== 'API500' && service.accountType !== 'API1000' && service.accountType !== 'API4000' && service.accountType !== 'API15000' && service.accountType !== 'API50000' && service.accountType !== 'API150000'\" [ngValue]=\"yearlyPlan\" [attr.selected]=\"service.billingPeriod === 'Yearly' ? 'selected' : null\">\r\n                                    Yearly\r\n                                </option>\r\n                            </select>\r\n                            <div class=\"col-holder\">\r\n                                <input class=\"coupon-input\" (blur)=\"service.checkCoupon()\" [class.passed]=\"service.couponValid\" [(ngModel)]=\"service.coupon\" placeholder=\"Coupon Code\" type=\"text\" />\r\n                                <div class=\"coupon-plus-holder\"><a class=\"coupon-plus\" (click)=\"service.checkCoupon()\">+</a></div>\r\n                                <span *ngIf=\"couponError !== ''\" style=\"font-size: 18px;\" class=\"error\">{{ service.couponError }}</span>\r\n                            </div>\r\n                            <p *ngIf=\"service.cost\">{{ service.cost }}</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"service.accountType !== 'Basic' && !service.freeAccount\" class=\"line-tag\">Billing Information</div>\r\n                <div *ngIf=\"service.accountType !== 'Basic' && !service.freeAccount\" class=\"line-grey mb15\"></div>\r\n                <div class=\"col-holder register-cols\">\r\n                    <div *ngIf=\"service.accountType !== 'Basic'\" class=\"col1of2\">\r\n                        <div *ngIf=\"!service.freeAccount\">\r\n                            <div>\r\n                                <span [class.error-input-outer]=\"service.holderNameError\"><input [(ngModel)]=\"service.holderName\" (blur)=\"service.validateHolderName()\"  placeholder=\"Card Holder Name\" type=\"text\" /></span>\r\n                                <span *ngIf=\"service.holderNameError\"  class=\"error\">{{ service.holderNameError }}</span>\r\n                            </div>\r\n                            <span [class.stripe-passed]=\"service.stripeStatus === 200\"><input [class.error-input]=\"service.errors.card\" [(ngModel)]=\"service.card\" (ngModelChange)=\"service.getToken()\" (blur)=\"validateCC()\" (keypress)=\"service.numeralInputMasking($event)\" id=\"card\" #card=\"ngModel\" class=\"form-control\" placeholder=\"Credit Card Number\" type=text required pattern=\"[0-9]{13,16}\"/></span>\r\n                            <div *ngIf=\"service.errors.card\" class=\"alert alert-danger\">\r\n                                <span class=\"error\">{{ service.errors.card }}</span>\r\n                            </div>\r\n                            <div class=\"col-holder\">\r\n                                <input [class.error-input]=\"service.errors.expiration\" class=\"small-input\" style=\"margin-right: 5px;\" [(ngModel)]=\"service.expiration\" (blur)=\"validateExp()\" (ngModelChange)=\"service.getToken()\" (keypress)=\"service.numeralInputMasking($event)\" placeholder=\"Expiration (MM/YY)\" type=\"text\" pattern=\"(0[1-9]|1[0-2])\\/\\d{2}\" minlength=\"4\" maxlength=\"5\"/>\r\n                                <input [class.error-input]=\"service.errors.cvc\" class=\"small-input\" style=\"margin-left: 5px;\" [(ngModel)]=\"service.cvc\" (blur)=\"validateCVC()\" (ngModelChange)=\"service.getToken()\" (keypress)=\"service.numeralInputMasking($event)\" placeholder=\"CVC\" type=\"text\" pattern=\"[0-9]{3,4}\" minlength=\"3\" maxlength=\"4\"/>\r\n                            </div>\r\n                            <div class=\"col-holder\">\r\n                                <div *ngIf=\"service.errors.expiration\" style=\"margin-right: 5px; width: calc(50% - 5px); float: left;\" class=\"col1of2 alert alert-danger\">\r\n                                    <span class=\"error\">{{ service.errors.expiration }}</span>\r\n                                </div>\r\n                                <div *ngIf=\"service.errors.cvc\" style=\"margin-left: 5px; width: calc(50% - 5px); float: right;\" class=\"col1of2 alert alert-danger\">\r\n                                    <span class=\"error\">{{ service.errors.cvc }}</span>\r\n                                </div>\r\n                                <div class=\"clear\"></div>\r\n                            </div>\r\n                            <div>\r\n                                <span [class.error-input-outer]=\"service.postalCodeError\"><input [(ngModel)]=\"service.postalCode\" (blur)=\"service.validatePostalCode()\"  placeholder=\"Postal Code\" type=\"text\" /></span>\r\n                                <span *ngIf=\"service.postalCodeError\"  class=\"error\">{{service.postalCodeError}}</span>\r\n                            </div>\r\n                        </div>  \r\n                    </div>\r\n                </div>\r\n                <div class=\"line-tag\">Customer Account</div>\r\n                <div class=\"line-grey mb15\"></div>\r\n                <div class=\"col-holder mt15 register-cols\">\r\n                    <div class=\"col1of2\">\r\n                        <div style=\"margin-right: 5px; width: calc(50% - 5px); float: left;\">\r\n                            <span [class.error-input-outer]=\"firstNameError\"><input [(ngModel)]=\"model.firstName\" (blur)=\"validateFirstName()\"  placeholder=\"First Name\" type=\"text\" /></span>\r\n                            <span *ngIf=\"firstNameError\"  class=\"error\">{{firstNameError}}</span>\r\n                        </div>\r\n                        <div style=\"margin-left: 5px; width: calc(50% - 5px); float: right;\">\r\n                            <span [class.error-input-outer]=\"lastNameError\"><input [(ngModel)]=\"model.lastName\" (blur)=\"validateLastName()\"  placeholder=\"Last Name\" type=\"text\" /></span>\r\n                            <span *ngIf=\"lastNameError\"  class=\"error\">{{lastNameError}}</span>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col1of2\">\r\n                        <div>\r\n                            <span [class.error-input-outer]=\"emailError\"><input [class.error-input]=\"service.errors.register === 'Email already in use'\" [(ngModel)]=\"model.email\" (blur)=\"validateEmail()\"  placeholder=\"Email\" type=\"text\" /></span>\r\n                            <span *ngIf=\"emailError\"  class=\"error\">{{emailError}}</span>\r\n                            <span *ngIf=\"service.errors.register === 'Email already in use'\" class=\"error\">{{ service.errors.register }}</span>\r\n                            <span><input [class.error-input]=\"confirmEmailError\" (blur)=\"validateConfirmEmail()\" (keyup.enter)=\"register()\" [(ngModel)]=\"model.confirmEmail\" placeholder=\"Confirm Email\" type=\"text\"></span>\r\n                            <span *ngIf=\"confirmEmailError\" class=\"error\">{{confirmEmailError}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <input [class.error-input]=\"passwordError\" (blur)=\"validatePassword()\" title='Passwords must be at least 8 characters and contain one uppercase letter, one lowercase letter, one numeral, and one special character' [(ngModel)]=\"model.password\" placeholder=\"Password\" type=\"password\" />\r\n                            <span *ngIf=\"passwordError\" class=\"error\">{{passwordError}}</span>\r\n                            <p *ngIf=\"passwordError\" class=\"error-explanation\"><em>Passwords must be at least 8 characters and contain one uppercase letter, one lowercase letter, one numeral, and one special character.</em></p>\r\n                            <input [class.error-input]=\"confirmPasswordError\" (blur)=\"validateConfirmPassword()\" (keyup.enter)=\"register()\" [(ngModel)]=\"model.confirmPassword\" placeholder=\"Confirm Password\" type=\"password\" />\r\n                            <span *ngIf=\"confirmPasswordError\" class=\"error\">{{confirmPasswordError}}</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"line-grey mb15\"></div>\r\n                <span>By clicking <em>Register</em>, you agree to our <a [routerLink]=\"['/terms-of-use', {scroll: true}]\">Terms of Use</a> and <a [routerLink]=\"['/privacy-policy', {scroll: true}]\">Privacy Policy</a>.</span>\r\n                <div class=\"col-holder register-cols\">\r\n                    <div class=\"col1of2\">\r\n                        <button (click)=\"register()\" class=\"btn mt10 text-center\">Register</button>\r\n                    </div>\r\n                    <div *ngIf=\"service.loaderOn\">\r\n                        <p *ngIf=\"service.loaderOn\">Loading <span class=\"sending-loader\"><span class=\"ellipse-1\">. </span><span class=\"ellipse-2\">. </span><span class=\"ellipse-3\"> .</span></span></p>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div *ngIf=\"service.displayThanks\">\r\n                <h5>Thank you for signing up!</h5>\r\n                <div class=\"line\"></div>\r\n                <p>We have sent you a confirmation email. Please click on the \"Verify Account\" button in the email to activate your account.</p>\r\n                <p *ngIf=\"service.accountType !== 'Basic' && service.accountType !== 'API500' && service.accountType !== 'API1500' && service.accountType !== 'API4000'\">Your account will be in a free trial for 14 days<span>, and your credit card will be charged automatically after the trial period ends</span>. You may cancel your account at any time.</p>\r\n            </div>\r\n            <div *ngIf=\"service.errors.register\">\r\n                <span *ngIf=\"service.errors.register !== 'Email already in use'\" class=\"error mt5\">{{ service.errors.register }}</span>\r\n            </div>\r\n            <div *ngIf=\"service.errors.cardRegister\">\r\n                <span *ngIf=\"service.errors.cardRegister !== ''\" class=\"error mt5\">{{ service.errors.cardRegister }}</span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = ".line-tag {\n  font-size: medium;\n  color: grey;\n  font-weight: bold;\n  margin-top: 30px;\n  margin-bottom: -20px; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 457px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 200px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\np {\n  text-align: left; }\n\nh3 {\n  text-align: left; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput,\n.btn {\n  width: 100%; }\n\ninput.small-input {\n  width: calc(50% - 5px);\n  min-width: 0; }\n\n#card.ng-untouched {\n  outline: none;\n  box-shadow: none; }\n\n.coupon-input.passed,\n.stripe-passed input {\n  background-image: url(../../img/greencheck.png);\n  background-repeat: no-repeat;\n  background-size: 20px;\n  background-position: 98% 50%; }\n\n.error-input {\n  background-image: none; }\n\nselect {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  font-size: 16px;\n  text-align: left;\n  margin-top: 10px; }\n\n.close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  line-height: 7px;\n  font-size: 24px;\n  color: #353535;\n  cursor: pointer; }\n  .close:hover {\n    color: #1c1c1c; }\n\n.coupon-input {\n  width: calc(100% - 40px);\n  min-width: 160px; }\n\n.coupon-plus-holder {\n  vertical-align: top;\n  display: inline-block;\n  width: 40px;\n  margin-top: 5px;\n  height: 37px; }\n  .coupon-plus-holder .coupon-plus {\n    font-size: 30px;\n    margin-left: 5px; }\n\n.register-cols .col1of2 {\n  padding-right: 15px; }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; } }\n\n@media only screen and (max-width: 599px) {\n  .team-section .col-holder.mobile-team {\n    display: block; }\n    .team-section .col-holder.mobile-team .col1of3 {\n      width: calc(100% - 20px); } }\n\n@media only screen and (max-width: 499px) {\n  .register-cols > .col1of2 {\n    padding: 10px 0; }\n  .page-content {\n    padding-left: 20px;\n    padding-right: 20px; } }\n\n@media only screen and (max-width: 399px) {\n  .page-content {\n    padding-left: 5px;\n    padding-right: 5px; }\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(43);
var router_1 = __webpack_require__(3);
var shared_1 = __webpack_require__(2);
var login_service_1 = __webpack_require__(903);
var LoginComponent = (function () {
    function LoginComponent(service, app, api, authService, userService, formBuilder, router) {
        this.service = service;
        this.app = app;
        this.api = api;
        this.authService = authService;
        this.userService = userService;
        this.formBuilder = formBuilder;
        this.router = router;
        this.displayLogin = true;
        this.displayVerificationInput = false;
        this.displayResult = false;
        this.displayForgotPassword = false;
        this.forgotError = '';
        this.displayForgotPasswordMessage = false;
        this.verificationStatus = '';
        this.verificationCode = '';
        this.submitted = false;
        this.loginForm = new forms_1.FormGroup({
            email: new forms_1.FormControl(),
            password: new forms_1.FormControl()
        });
        this.forgotForm = new forms_1.FormGroup({
            email: new forms_1.FormControl()
        });
        this.confirmForm = new forms_1.FormGroup({
            code: new forms_1.FormControl(),
            password: new forms_1.FormControl()
        });
        this.header = 'Login';
        // Do stuff
    }
    LoginComponent.prototype.ngOnInit = function () {
        this.submitted = false;
        this.loginForm = this.formBuilder.group({
            email: ['', this.service.validateEmail],
            password: ['', forms_1.Validators.compose([this.service.validatePassword, forms_1.Validators.minLength(1)])]
        });
        this.forgotForm = this.formBuilder.group({
            email: ['', this.service.validateEmail]
        });
        this.confirmForm = this.formBuilder.group({
            code: '',
            password: ['', forms_1.Validators.compose([this.service.validatePassword, forms_1.Validators.minLength(8)])]
        });
        // changed password length from 8 for migration process
    };
    LoginComponent.prototype.login = function () {
        var _this = this;
        if (this.loginForm.valid) {
            this.service.login(this.loginForm.controls['email'].value, this.loginForm.controls['password'].value)
                .then(function (result) {
                _this.close();
                var url = _this.router.url;
                _this.router.navigate(['/']).then(function (navigateResult) { return _this.router.navigateByUrl(url); });
            })
                .catch(function (err) { return _this.handleError(err); });
        }
        this.submitted = true;
        this.app.closeSearch();
        // ****
        //window.location.reload()
        var appStatus = this.app;
        if (this.app.accountType == 'Professional') {
            sessionStorage.setItem('schedules-week', '8');
            sessionStorage.setItem('schedules-origin-nearby', 'ture');
            sessionStorage.setItem('schedules-destination-nearby', 'true');
        }
        else if (this.app.accountType == 'Premium') {
            sessionStorage.setItem('schedules-week', '6');
            sessionStorage.setItem('schedules-origin-nearby', 'ture');
            sessionStorage.setItem('schedules-destination-nearby', 'true');
        }
        else if (this.app.accountType == 'Basic') {
            sessionStorage.setItem('schedules-week', '4');
            sessionStorage.setItem('schedules-origin-nearby', 'false');
            sessionStorage.setItem('schedules-destination-nearby', 'false');
        }
        // ****
    };
    LoginComponent.prototype.resend = function () {
        var _this = this;
        this.displayResult = false;
        this.service.resendLoaderOn = true;
        this.service.resendVerificationCode(this.loginForm.controls['email'].value).then(function (result) {
            _this.verificationEmailResent(result);
        }).catch(function (err) {
            _this.errorMessage = err;
            _this.service.resendLoaderOn = false;
        });
    };
    LoginComponent.prototype.verificationEmailResent = function (result) {
        this.displayVerificationInput = false;
        this.displayResult = true;
        this.service.resendLoaderOn = false;
        this.verificationStatus = result ? 'Your verification email has been resent. Please click the link in the email to confirm.' : 'There was a problem when we tried to send you a new email. Please try again';
    };
    LoginComponent.prototype.openForgot = function () {
        if (this.forgotForm.controls['email'].value === '') {
            this.forgotForm.setValue({ email: this.loginForm.controls['email'].value });
        }
        this.displayForgotPassword = true;
        this.displayLogin = false;
        this.header = 'Forgot Password';
        this.displayVerificationInput = false;
    };
    LoginComponent.prototype.closeForgot = function () {
        this.displayForgotPassword = false;
        this.displayLogin = true;
        this.header = 'Login';
    };
    LoginComponent.prototype.forgot = function () {
        var _this = this;
        var email = this.forgotForm.controls['email'].value;
        this.service.forgotPassword(email).then(function (result) {
            _this.app.setEmail(email);
            _this.displayForgotPassword = false;
            _this.displayForgotPasswordMessage = true;
        }).catch(function (err) {
            if (err.message === 'Username/client id combination not found.') {
                // this.forgotError = 'Unrecognized Email';
                // pretend the email was sent out
                _this.displayForgotPassword = false;
                _this.displayForgotPasswordMessage = true;
            }
            else if (err.message == 'Attempt limit exceeded, please try after some time.') {
                _this.forgotError = 'Too many attempts. Please Try Again Later';
            }
            else if (err.Message = 'Cannot reset password for the user as there is no registered/verified email or phone_number') {
                _this.forgotError = 'You must confirm your account first. Please check your email for a confirmation link. (It may take several minutes to reach your inbox.)';
                _this.authService.resendVerificationEmail(email);
                //this.resend();
            }
            else {
                _this.forgotError = 'Please Try Again Later';
            }
        });
    };
    LoginComponent.prototype.handleError = function (error) {
        if (error === 'User is not confirmed.') {
            this.displayLogin = false;
            this.displayVerificationInput = true;
        }
        else if (error === 'User does not exist.') {
            error = 'Incorrect username or password.';
        }
        this.errorMessage = error;
    };
    LoginComponent.prototype.close = function () {
        this.app.login = false;
        this.header = 'Login';
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], LoginComponent.prototype, "cognitoUser", void 0);
    LoginComponent = __decorate([
        core_1.Component({
            selector: 'login',
            template: __webpack_require__(904),
            styles: [__webpack_require__(905)],
            providers: [login_service_1.LoginService]
        }),
        __metadata("design:paramtypes", [login_service_1.LoginService, shared_1.AppContext, shared_1.ApiService, shared_1.AuthService, shared_1.UserService, forms_1.FormBuilder, router_1.Router])
    ], LoginComponent);
    return LoginComponent;
}());
exports.LoginComponent = LoginComponent;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var LoginService = (function () {
    function LoginService(api, auth, user, app) {
        this.api = api;
        this.auth = auth;
        this.user = user;
        this.app = app;
        this.resendLoaderOn = false;
    }
    LoginService.prototype.validateEmail = function (control) {
        //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*|\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        //let EMAIL_REGEXP = this.app.EMAIL_REGEXP;
        var EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*|\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        if (!EMAIL_REGEXP.test(control.value)) {
            return { invalidEmail: true };
        }
    };
    LoginService.prototype.validatePassword = function (control) {
        // let PASSWORD_REGEXP = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).*$/;
        // if (!PASSWORD_REGEXP.test(control.value)) {
        //   return {invalidPassword: true};
        // }
        // disabled for the migration process
        var PASSWORD_REGEXP = /^(?![\s\S])/;
        if (PASSWORD_REGEXP.test(control.value)) {
            return { invalidPassword: true };
        }
    };
    LoginService.prototype.login = function (email, password) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.auth.login(email, password).then(function (result) {
                resolve(result);
            }).catch(function (err) {
                _this.handleError(err, email, password).then(function (message) {
                    reject(message);
                });
                // reject(this.handleError(err, email, password));
            });
        });
    };
    LoginService.prototype.handleError = function (error, email, password) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var message = error.message.trim();
                if (message === 'User is not confirmed.') {
                    // localStorage.setItem('email', email);
                    // localStorage.setItem('password', password);
                    resolve(message);
                }
                else if (message === 'Password reset required for the user') {
                    // localStorage.setItem('email', email);
                    _this.user.checkIfUser(email).then(function (checkResult) {
                        // is a user
                        // don't do anything
                        resolve('Password reset required');
                    }).catch(function (err) {
                        // is not a user
                        _this.api.destroy();
                        _this.user.confirmUser(email).then(function (confirmResult) {
                            _this.auth.forgotPassword(email).then(function (result) {
                                _this.showMigrationMessage();
                                resolve('');
                            });
                        }).catch(function (confirmError) {
                            resolve('please try again');
                        });
                    });
                }
                else {
                    resolve(message);
                }
            }
            catch (ex) {
                resolve(error === 'object' ? error.message : '');
            }
        });
    };
    LoginService.prototype.showMigrationMessage = function () {
        this.app.login = false;
        this.app.showMessage('Welcome to the new Linescape!', 'We have migrated your account, but you will need to create a new password. Please check your email for a link to set your password.');
    };
    LoginService.prototype.resendVerificationCode = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.auth.resendVerificationEmail(email).then(function (result) {
                resolve(result === 'SUCCESS');
            }).catch(function (err) { return reject(err); });
        });
    };
    LoginService.prototype.forgotPassword = function (email) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.auth.forgotPassword(email).then(function (forgotResult) {
                // check if user
                _this.user.checkIfUser(email).then(function (checkResult) {
                    // is a user
                    resolve(forgotResult);
                }).catch(function (err) {
                    // is not a user
                    _this.api.destroy();
                    _this.user.confirmUser(email).then(function (confirmResult) {
                        _this.showMigrationMessage();
                        resolve(forgotResult);
                    }).catch(function (confirmError) {
                    });
                    // what should be done for the catch of confirmUser
                });
            }).catch(function (err) {
                reject(err);
            });
        });
    };
    LoginService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AuthService, shared_1.UserService, shared_1.AppContext])
    ], LoginService);
    return LoginService;
}());
exports.LoginService = LoginService;


/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-container\">\r\n    <div class=\"popup\">\r\n        <a class=\"close\" (click)=\"close()\">&times;</a>\r\n        <h5 class=\"text-center\">{{ header }}</h5>\r\n        <div class=\"popup-line-div\"></div>\r\n        <div *ngIf=\"displayLogin\">\r\n            <form [formGroup]=\"loginForm\" (submit)=\"login()\">\r\n                <input [class.error-input]=\"loginForm.controls.email.errors && submitted\" formControlName=\"email\" placeholder=\"Email\" type=\"text\" />\r\n                <span class=\"error\" *ngIf=\"loginForm.controls.email.errors && submitted\">Please enter a valid email.</span>\r\n                <input [class.error-input]=\"loginForm.controls.password.errors && submitted\" title='Passwords must be at least 8 characters and contain one uppercase letter, one lowercase letter, one numeral, and one special character' formControlName=\"password\" placeholder=\"Password\" type=\"password\" />\r\n                <span class=\"error\" *ngIf=\"loginForm.controls.password.errors && submitted\">Password Invalid</span>\r\n                <!--<button class=\"btn\" (click)=\"login()\">Login</button>-->\r\n                <input class=\"btn\" type=\"submit\" value=\"Login\"/>\r\n                <span *ngIf=\"errorMessage\" class=\"error\">{{ errorMessage }}</span>\r\n            </form>\r\n            <p><a (click)=\"openForgot()\">Forgot Password?</a><a (click)=\"close()\" style=\"float: right;\" [routerLink]=\"['/register']\">Register</a></p>\r\n        </div>\r\n        <div *ngIf=\"displayVerificationInput\">\r\n            <p class=\"login-code-message\">Please click the link included in your verification email.</p>\r\n            <label>\r\n                <button (click)=\"resend()\" class=\"btn text-center\">Re-send Verification Code</button>\r\n            </label>\r\n            <p *ngIf=\"service.resendLoaderOn\" class=\"sending-loader\">Sending<span class=\"ellipse-1\"> .</span><span class=\"ellipse-2\"> .</span><span class=\"ellipse-3\"> .</span></p>\r\n        </div>\r\n        <div *ngIf=\"displayResult\">\r\n            <p class=\"login-code-message\"><img class=\"success-check\" *ngIf=\"verificationStatus\" src=\"../img/check-sign.svg\" onerror=\"this.onerror=null; this.src='../img/check-sign.png'\">{{ verificationStatus }}</p>\r\n        </div>\r\n        <div *ngIf=\"displayForgotPassword\">\r\n            <p><a (click)=\"closeForgot()\">back</a></p>\r\n            <form [formGroup]=\"forgotForm\" (submit)=\"forgot()\">\r\n                <p>Enter the email associated with your account.</p>\r\n                <input [class.error-input]=\"forgotForm.controls.email.errors && submitted\" formControlName=\"email\" placeholder=\"Email\" type=\"text\" />\r\n                <span class=\"error\" *ngIf=\"forgotForm.controls.email.errors && submitted\">Please enter a valid email.</span>\r\n                <input class=\"btn\" type=\"submit\" value=\"Confirm\"/>\r\n                <span *ngIf=\"forgotError\" class=\"error\">{{ forgotError }}</span>\r\n            </form>\r\n        </div>\r\n        <div *ngIf=\"displayForgotPasswordMessage\">\r\n            <p>We have emailed you a link to reset your password.</p>\r\n        </div>\r\n    </div>\r\n    <div class=\"popup-wrapper\" (click)=\"close()\"></div>\r\n</div>"

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = "/*:host {\r\n  background-color: #575757;\r\n\tposition: absolute;\r\n\ttop: 250px;\r\n\tleft: calc(50% - 160px);\r\n\twidth: 320px;\r\n\tpadding: 20px;\r\n\ttext-align: center;\r\n\tz-index: 2;\r\n\tborder-radius: 3px;\r\n  -webkit-box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.43);\r\n  -moz-box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.43);\r\n  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.43);\r\n}*/\n.popup {\n  width: 320px;\n  max-width: 100%; }\n\n.login-code-message {\n  text-align: left; }\n\np {\n  color: #353535;\n  text-align: left;\n  line-height: 24px; }\n\nh5 {\n  color: #353535;\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput:focus,\ninput {\n  font-size: 18px; }\n\ninput,\n.btn {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  font-size: 16px;\n  text-align: left;\n  margin-top: 10px; }\n\n.error-message {\n  margin-top: 0;\n  line-height: 18px;\n  color: #ff3333;\n  text-align: left; }\n\n.sending-loader .ellipse-1 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseOne 2s linear infinite;\n  -webkit-animation: ellipseOne 2s linear infinite; }\n\n.sending-loader .ellipse-2 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseTwo 2s linear infinite;\n  -webkit-animation: ellipseTwo 2s linear infinite; }\n\n.sending-loader .ellipse-3 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseThree 2s linear infinite;\n  -webkit-animation: ellipseThree 2s linear infinite; }\n\n@keyframes ellipseOne {\n  0% {\n    opacity: 0; }\n  24% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseTwo {\n  0% {\n    opacity: 0; }\n  49% {\n    opacity: 0; }\n  50% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseThree {\n  0% {\n    opacity: 0; }\n  74% {\n    opacity: 0; }\n  75% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n"

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(907));
__export(__webpack_require__(910));
__export(__webpack_require__(914));
__export(__webpack_require__(918));
__export(__webpack_require__(922));


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var MessageComponent = (function () {
    function MessageComponent(app) {
        this.app = app;
        // Do stuff
    }
    MessageComponent.prototype.close = function () {
        this.app.hideMessage();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MessageComponent.prototype, "title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MessageComponent.prototype, "content", void 0);
    MessageComponent = __decorate([
        core_1.Component({
            selector: 'message',
            template: __webpack_require__(908),
            styles: [__webpack_require__(909)]
        }),
        __metadata("design:paramtypes", [shared_1.AppContext])
    ], MessageComponent);
    return MessageComponent;
}());
exports.MessageComponent = MessageComponent;


/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-container\">\r\n  <div class=\"popup-wrapper\" (click)=\"close()\"></div>\r\n  <div class=\"popup\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5>{{ title }}</h5>\r\n    <div class=\"popup-line-div\"></div>\r\n    <p>{{ content }}</p>\r\n    <div *ngIf=\"content === 'Sorry, you have exceeded your search limit. Please try again later or register for free.'\" class=\"col-holder\">\r\n      <a class=\"btn mt15\" style=\"margin-right: 3px;\" [routerLink]=\"['/register']\" (click)=\"close()\">Register</a>\r\n      <a class=\"btn btn-blue mt15\" style=\"margin-left: 3px;\" (click)=\"openLogin()\">Login</a>\r\n    </div>\r\n    <a *ngIf=\"content === 'Sorry, you have exceeded your search limit. Please try again later or upgrade your plan.'\" [routerLink]=\"['/subscribe']\" class=\"btn text-center\">View Plans</a>\r\n  </div>\r\n</div>"

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = ".popup {\n  width: 320px;\n  max-width: 100%; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput,\n.btn {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  margin-top: 10px; }\n\n.route-label {\n  cursor: pointer; }\n\n.route-label * {\n  cursor: pointer; }\n"

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(911));


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var RegisterMessageComponent = (function () {
    function RegisterMessageComponent(app) {
        this.app = app;
        // Do stuff
    }
    RegisterMessageComponent.prototype.ngOnInit = function () {
        if (this.content === '') {
            this.content = 'This feature requires a Linescape account. Please register or login now.';
        }
    };
    RegisterMessageComponent.prototype.openLogin = function () {
        this.app.toggleLogin();
        this.app.hideRegister();
    };
    RegisterMessageComponent.prototype.close = function () {
        this.app.hideRegister();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], RegisterMessageComponent.prototype, "title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], RegisterMessageComponent.prototype, "content", void 0);
    RegisterMessageComponent = __decorate([
        core_1.Component({
            selector: 'register-message',
            template: __webpack_require__(912),
            styles: [__webpack_require__(913)]
        }),
        __metadata("design:paramtypes", [shared_1.AppContext])
    ], RegisterMessageComponent);
    return RegisterMessageComponent;
}());
exports.RegisterMessageComponent = RegisterMessageComponent;


/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-container\">\r\n  <div class=\"popup-wrapper\" (click)=\"close()\"></div>\r\n  <div class=\"popup\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5>{{ title }}</h5>\r\n    <div class=\"popup-line-div\"></div>\r\n    <p>This feature requires a Linescape account. Please register or login now.</p>\r\n    <div class=\"col-holder\">\r\n      <a class=\"btn mt15\" style=\"margin-right: 3px;\" [routerLink]=\"['/register']\" (click)=\"close()\">Register</a>\r\n      <a class=\"btn btn-blue mt15\" style=\"margin-left: 3px;\" (click)=\"openLogin()\">Login</a>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports = ".popup {\n  width: 320px;\n  max-width: 100%;\n  text-align: center; }\n\np,\nlabel {\n  line-height: 24px; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput,\n.btn {\n  width: 100%; }\n\n.btn {\n  width: calc(50% - 3px);\n  padding-left: 0;\n  padding-right: 0; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  margin-top: 10px; }\n\n.route-label {\n  cursor: pointer; }\n\n.route-label * {\n  cursor: pointer; }\n"

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(915));


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var UpgradeMessageComponent = (function () {
    function UpgradeMessageComponent(app) {
        this.app = app;
        // Do stuff
    }
    UpgradeMessageComponent.prototype.close = function () {
        this.app.hideUpgrade();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], UpgradeMessageComponent.prototype, "title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], UpgradeMessageComponent.prototype, "content", void 0);
    UpgradeMessageComponent = __decorate([
        core_1.Component({
            selector: 'upgrade-message',
            template: __webpack_require__(916),
            styles: [__webpack_require__(917)]
        }),
        __metadata("design:paramtypes", [shared_1.AppContext])
    ], UpgradeMessageComponent);
    return UpgradeMessageComponent;
}());
exports.UpgradeMessageComponent = UpgradeMessageComponent;


/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-container\">\r\n  <div class=\"popup-wrapper\" (click)=\"close()\"></div>\r\n  <div class=\"popup\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5>{{ title }}</h5>\r\n    <div class=\"popup-line-div\"></div>\r\n    <p>{{ content }}</p>\r\n    <a class=\"btn-blue mt15\" [routerLink]=\"['/subscribe']\" (click)=\"close()\">View Plans and Pricing</a>\r\n  </div>\r\n</div>"

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports = ".popup {\n  width: 320px;\n  max-width: 100%;\n  text-align: center; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput,\n.btn {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  margin-top: 10px;\n  line-height: 24px; }\n\n.route-label {\n  cursor: pointer; }\n\n.route-label * {\n  cursor: pointer; }\n"

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(919));


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var ArrivalMessageComponent = (function () {
    function ArrivalMessageComponent(app) {
        this.app = app;
        // Do stuff
    }
    ArrivalMessageComponent.prototype.close = function () {
        this.app.hideArrivalMessage();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ArrivalMessageComponent.prototype, "title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ArrivalMessageComponent.prototype, "content", void 0);
    ArrivalMessageComponent = __decorate([
        core_1.Component({
            selector: 'arrival-message',
            template: __webpack_require__(920),
            styles: [__webpack_require__(921)]
        }),
        __metadata("design:paramtypes", [shared_1.AppContext])
    ], ArrivalMessageComponent);
    return ArrivalMessageComponent;
}());
exports.ArrivalMessageComponent = ArrivalMessageComponent;


/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-container\">\r\n  <div class=\"popup-wrapper\" (click)=\"close()\"></div>\r\n  <div class=\"popup\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5>Welcome to the new Linescape!</h5>\r\n    <p>Please contact us with your thoughts and feedback.</p>\r\n    <div class=\"col-holder\">\r\n      <a class=\"btn mt15\" style=\"margin-right: 3px;\" [routerLink]=\"['/contact']\" (click)=\"close()\">Submit Feedback</a>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports = ".popup {\n  /*background-color: #2798d8;*/\n  background-image: url(img/linescape-pop-up-background.jpg);\n  width: 400px;\n  max-width: 100%; }\n\np,\nlabel {\n  color: #ffffff;\n  line-height: 24px; }\n\nh5 {\n  color: #ffffff;\n  font-weight: 500;\n  margin-bottom: 10px; }\n\n.btn {\n  width: initial;\n  padding-left: 20px;\n  padding-right: 20px; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  margin-top: 10px; }\n\n.route-label {\n  cursor: pointer; }\n\n.route-label * {\n  cursor: pointer; }\n"

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(923));


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var ProfilePopupComponent = (function () {
    function ProfilePopupComponent(app) {
        this.app = app;
        this.showClose = false;
    }
    ProfilePopupComponent.prototype.close = function () {
        this.app.showPersonalInformation = false;
    };
    ProfilePopupComponent.prototype.onSave = function () {
        this.showClose = true;
    };
    ProfilePopupComponent = __decorate([
        core_1.Component({
            selector: 'profile-popup',
            template: __webpack_require__(924),
            styles: [__webpack_require__(925)],
        }),
        __metadata("design:paramtypes", [shared_1.AppContext])
    ], ProfilePopupComponent);
    return ProfilePopupComponent;
}());
exports.ProfilePopupComponent = ProfilePopupComponent;


/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports = "<div class=\"popup-container\">\r\n  <div class=\"popup-wrapper\" (click)=\"close()\"></div>\r\n  <div class=\"popup\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5>Personal Information</h5>\r\n    <div class=\"popup-line-div\"></div>\r\n    <personal-information (onSave)=\"onSave()\">loading...</personal-information>\r\n    <button *ngIf=\"showClose\" class=\"btn text-center\" (click)=\"close()\">Close</button>\r\n  </div>\r\n</div>"

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports = ".popup {\n  width: 320px;\n  max-width: 100%;\n  text-align: center; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput, select,\n.btn {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  margin-top: 10px; }\n\n.route-label {\n  cursor: pointer; }\n\n.route-label * {\n  cursor: pointer; }\n"

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var save_route_service_1 = __webpack_require__(927);
var SaveRouteComponent = (function () {
    function SaveRouteComponent(service) {
        this.service = service;
        this.onClose = new core_1.EventEmitter();
    }
    Object.defineProperty(SaveRouteComponent.prototype, "display", {
        set: function (toDisplay) {
            this.service.show = toDisplay;
            this.service.checkIfLoggedIn();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SaveRouteComponent.prototype, "origins", {
        set: function (originIds) {
            this.service.origins = originIds;
            this.service.updateRoutes();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SaveRouteComponent.prototype, "destinations", {
        set: function (destinationIds) {
            this.service.destinations = destinationIds;
            this.service.updateRoutes();
        },
        enumerable: true,
        configurable: true
    });
    SaveRouteComponent.prototype.close = function () {
        this.onClose.emit();
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], SaveRouteComponent.prototype, "onClose", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], SaveRouteComponent.prototype, "display", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], SaveRouteComponent.prototype, "origins", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], SaveRouteComponent.prototype, "destinations", null);
    SaveRouteComponent = __decorate([
        core_1.Component({
            selector: 'save-route',
            template: __webpack_require__(928),
            styles: [__webpack_require__(929)],
            providers: [save_route_service_1.SaveRouteService],
        }),
        __metadata("design:paramtypes", [save_route_service_1.SaveRouteService])
    ], SaveRouteComponent);
    return SaveRouteComponent;
}());
exports.SaveRouteComponent = SaveRouteComponent;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var SaveRouteService = (function () {
    function SaveRouteService(api, logger, app) {
        this.api = api;
        this.logger = logger;
        this.app = app;
        this.show = false;
        this.origins = Array();
        this.destinations = Array();
        this.routes = Array();
        this.message = '';
        this.apiService = null;
        this.appContext = null;
        this.routesList = new Array();
        this.apiService = api;
        this.appContext = app;
        this.routesList = app.routes;
    }
    SaveRouteService.prototype.save = function (route) {
        this.message = ''; // clear previous message
        if (!route.selected) {
            this.message = 'saving';
            this.saveRoute(route);
        }
        else {
            this.message = 'deleting';
            this.deleteRoute(route);
        }
    };
    SaveRouteService.prototype.checkIfLoggedIn = function () {
        if (!this.app.isLoggedIn && this.show) {
            this.app.showMessage('Sign in Required', 'You must sign in to use this feature');
            return;
        }
    };
    SaveRouteService.prototype.updateRoutes = function () {
        this.routes = [];
        if (this.origins.length === 0 || this.destinations.length === 0) {
            return;
        }
        for (var currentOrigin = 0; currentOrigin < this.origins.length; currentOrigin++) {
            for (var currentDestination = 0; currentDestination < this.destinations.length; currentDestination++) {
                var formatted = {
                    origin: this.origins[currentOrigin],
                    destination: this.destinations[currentDestination]
                };
                this.formatRoute(formatted);
                this.routes.push(formatted);
            }
        }
        this.logger.log('save-route.service', 'updateRoutes', this.routes);
    };
    SaveRouteService.prototype.formatRoute = function (route) {
        route.selected = false;
        if (this.app.routes === null || this.app.routes === undefined) {
            return;
        }
        for (var current = 0; current < this.app.routes.length; current++) {
            if (this.app.routes[current].originId === route.origin.port.id && this.app.routes[current].destinationId === route.destination.port.id) {
                this.logger.log('save-route.service', 'formatRoute', route);
                route.selected = true;
            }
        }
    };
    SaveRouteService.prototype.saveRoute = function (route) {
        var _this = this;
        var formatted = {
            origin_id: route.origin.port.id,
            origin_name: route.origin.port.title,
            destination_id: route.destination.port.id,
            destination_name: route.destination.port.title
        };
        var alreadySaved = false;
        for (var current = 0; current < this.app.routes.length; current++) {
            if (this.app.routes[current].originId == route.origin.port.id && this.app.routes[current].destinationId == route.destination.port.id) {
                alreadySaved = true;
                break;
            }
        }
        if (!alreadySaved) {
            this.api.getApiClient().then(function (client) { return _this.callSave(client, route, formatted); });
        }
    };
    SaveRouteService.prototype.deleteRoute = function (route) {
        var _this = this;
        var cognitoIdentityId = this.apiService.getCognitoId();
        var formatted = {
            cognitoId: cognitoIdentityId,
            originId: route.origin.port.id,
            destinationId: route.destination.port.id
        };
        this.api.getApiClient().then(function (client) { return _this.callDelete(client, route, formatted); });
    };
    SaveRouteService.prototype.callSave = function (apigClient, route, formatted) {
        var _this = this;
        this.logger.log('save-route.service', 'callSave', formatted);
        var params = {};
        var body = formatted;
        var additionalParams = {
            headers: { 'Content-Type': 'application/json' },
            queryParams: {}
        };
        try {
            apigClient.routesFavoritePost(params, body, additionalParams)
                .then(function (result) {
                _this.logger.log('save-route.service', 'resolve', result);
                route.selected = true;
                _this.message = 'Route Saved';
                if (_this.app.routes === null || _this.app.routes === undefined) {
                    _this.app.routes = new Array();
                }
                // ****
                var newFavoriteRoute = {
                    originId: route.origin.port.id,
                    originName: route.origin.port.title,
                    destinationId: route.destination.port.id,
                    destinationName: route.destination.port.title
                };
                var favoriteRoutes = _this.app.routes;
                favoriteRoutes.push(newFavoriteRoute);
                _this.app.routes = favoriteRoutes;
                localStorage.setItem('favoriteRoutes', JSON.stringify(favoriteRoutes));
                // ****
                // this.app.routes.push({
                //   originId: formatted.origin_id,
                //   originName: formatted.origin_name,
                //   destinationId: formatted.destination_id,
                //   destinationName: formatted.destination_name
                // });
            }).catch(function (err) {
                _this.message = 'an error occurred';
                _this.api.handleError(err);
            });
        }
        catch (ex) {
            this.message = 'an error occurred';
            this.logger.log('save-route.service', 'catch', ex);
        }
    };
    SaveRouteService.prototype.callDelete = function (apigClient, route, formatted) {
        var _this = this;
        this.logger.log('save-route.service', 'callDelete', route);
        var params = {
            originId: formatted.originId,
            destinationId: formatted.destinationId
        };
        var body = formatted;
        var additionalParams = {
            headers: { 'Content-Type': 'application/json' },
            queryParams: {}
        };
        try {
            apigClient.v2RoutesFavoriteDelete(params, body, additionalParams)
                .then(function (result) {
                _this.logger.log('save-route.service', 'resolve', result);
                // ****
                var resultRouteList = _this.app.routes;
                for (var current = 0; current < _this.routes.length; current++) {
                    if (resultRouteList[current].originId == route.origin.port.id && resultRouteList[current].destinationId == route.destination.port.id) {
                        resultRouteList.splice(current, 1);
                        break;
                    }
                }
                _this.app.routes = resultRouteList;
                localStorage.setItem('favoriteRoutes', JSON.stringify(_this.routesList));
                if (result.data.body != undefined) {
                    try {
                        var resultRoutes = JSON.parse(result.data.body);
                        if (Array.isArray(resultRoutes)) {
                            localStorage.setItem('favoriteRoutes', JSON.stringify(resultRoutes));
                        }
                    }
                    catch (ex) {
                        console.log(ex);
                    }
                }
                _this.app.routes = JSON.parse(localStorage.getItem('favoriteRoutes'));
                // ****
                route.selected = false;
                _this.message = 'Route Deleted';
            }).catch(function (err) {
                _this.message = 'an error occurred';
                _this.api.handleError(err);
            });
        }
        catch (ex) {
            this.message = 'an error occurred';
            this.logger.log('save-route.service', 'catch', ex);
        }
    };
    SaveRouteService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.LogService, shared_1.AppContext])
    ], SaveRouteService);
    return SaveRouteService;
}());
exports.SaveRouteService = SaveRouteService;


/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"service.show\" class=\"popup-container\">\r\n  <div class=\"popup-wrapper\" (click)=\"close()\"></div>\r\n  <div class=\"popup\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5>Save Route?</h5>\r\n    <div class=\"popup-line-div\"></div>\r\n    <div>\r\n      <div *ngFor=\"let route of service.routes; let last = last\">\r\n        <div class=\"route-label\" (click)=\"service.save(route)\">\r\n          <div [class.selected]=\"route.selected\" class=\"check-box-div\">\r\n            <span>&#x2714;</span>\r\n          </div>\r\n          <label>{{ route.origin.port.title }} &#8594; {{ route.destination.port.title }}</label>\r\n        </div>\r\n        <div *ngIf=\"!last\" class=\"saved-routes-line\"></div>\r\n      </div>\r\n    </div>\r\n    <span *ngIf=\"service.message !== 'deleting'\"><p class=\"message\" *ngIf=\"service.message !== 'saving'\" [class.success]=\"service.message === 'Route Saved'\"><img class=\"success-check\" *ngIf=\"service.message === 'Route Saved'\" src=\"../img/check-sign.svg\" onerror=\"this.onerror=null; this.src='../img/check-sign.png'\">{{ service.message }}</p></span>\r\n    <p class=\"message\" *ngIf=\"service.message === 'saving'\"><span class=\"sending-loader\">Saving<span class=\"ellipse-1\">. </span><span class=\"ellipse-2\">. </span><span class=\"ellipse-3\"> .</span></span></p>\r\n    <p class=\"message\" *ngIf=\"service.message === 'deleting'\"><span class=\"sending-loader\">Deleting<span class=\"ellipse-1\">. </span><span class=\"ellipse-2\">. </span><span class=\"ellipse-3\"> .</span></span></p>\r\n  </div>\r\n</div>"

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports = ".popup {\n  width: 650px;\n  max-width: 100%;\n  text-align: center; }\n  .popup .popup-line-div {\n    margin-bottom: 5px; }\n\n.overflow-div {\n  max-height: calc(100vh - 370px);\n  overflow-y: auto;\n  width: calc(100% + 20px); }\n\n.check-box-div {\n  border: 1px solid #c4c4c4;\n  margin-right: 5px; }\n\np,\n.message {\n  text-align: left; }\n\n.message.success {\n  /*animation: savedAnimation 1.75s linear forwards 1;*/ }\n\n.sending-loader .ellipse-1 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseOne 2s linear infinite;\n  -webkit-animation: ellipseOne 2s linear infinite; }\n\n.sending-loader .ellipse-2 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseTwo 2s linear infinite;\n  -webkit-animation: ellipseTwo 2s linear infinite; }\n\n.sending-loader .ellipse-3 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseThree 2s linear infinite;\n  -webkit-animation: ellipseThree 2s linear infinite; }\n\n@keyframes ellipseOne {\n  0% {\n    opacity: 0; }\n  24% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseTwo {\n  0% {\n    opacity: 0; }\n  49% {\n    opacity: 0; }\n  50% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseThree {\n  0% {\n    opacity: 0; }\n  74% {\n    opacity: 0; }\n  75% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes savedAnimation {\n  from {\n    background: forestgreen;\n    border-color: #117310;\n    color: #353535;\n    visibility: visible; }\n  to {\n    background: transparent;\n    border-color: transparent;\n    color: transparent;\n    visibility: transparent; } }\n\n.saved-routes-line {\n  display: block;\n  height: 1px;\n  width: 50%;\n  margin: auto;\n  margin-top: 4px;\n  margin-bottom: 4px;\n  background: #d4d4d4; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput,\n.btn {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  font-size: 16px;\n  text-align: right;\n  margin-top: 10px; }\n\n.route-label {\n  cursor: pointer;\n  text-align: left; }\n\n.route-label * {\n  cursor: pointer; }\n\n@media only screen and (max-width: 399px) {\n  .overflow-div {\n    max-height: calc(100vh - 170px);\n    overflow-y: auto; } }\n"

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var Subject_1 = __webpack_require__(10);
var carriers_search_service_1 = __webpack_require__(931);
var shared_1 = __webpack_require__(2);
var CarriersSearchComponent = (function () {
    function CarriersSearchComponent(logger, router, service) {
        this.logger = logger;
        this.router = router;
        this.service = service;
        this.close = new core_1.EventEmitter();
        this.searchTermStream = new Subject_1.Subject();
        this.searchTerm = '';
        this.item = null;
        this.items = Array();
        // Do stuff
    }
    CarriersSearchComponent.prototype.ngOnInit = function () {
        this.logger.log('carriers-search.component', 'ngOnInit', 'Hello Carriers Search');
        this.initSearchBox();
        this.loadCache();
    };
    CarriersSearchComponent.prototype.initSearchBox = function () {
        var _this = this;
        this.itemsSub = this.searchTermStream
            .debounceTime(100)
            .distinctUntilChanged()
            .switchMap(function (term) { return _this.service.getCarriers(term); }).subscribe(function (carriers) {
            _this.items = carriers;
        });
    };
    CarriersSearchComponent.prototype.loadCache = function () {
        if (sessionStorage.getItem('carries-search-term')) {
            this.searchTerm = sessionStorage.getItem('carries-search-term');
        }
    };
    CarriersSearchComponent.prototype.onClick = function ($event) {
        if ($event.target.id === 'searchbox' && !this.service.autoOn) {
            this.auto();
        }
        else if ($event.target.id !== 'searchbox' && this.service.autoOn) {
            this.service.autoOn = false;
        }
    };
    CarriersSearchComponent.prototype.search = function () {
        if (this.item !== null) {
            this.close.emit({ event: event, searchType: '', location: 'header' });
            this.router.navigate(['/carriers', this.item.id]);
        }
        else if (sessionStorage.getItem('carries-search-item-id')) {
            var carrierId = +sessionStorage.getItem('carries-search-item-id');
            this.close.emit({ event: event, searchType: '', location: 'header' });
            this.router.navigate(['/carriers', carrierId]);
        }
        sessionStorage.setItem('carries-search-term', this.searchTerm);
        sessionStorage.setItem('carries-search-item-id', this.item.id.toString());
    };
    CarriersSearchComponent.prototype.set = function (item) {
        this.service.autoOn = false;
        this.logger.log('carriers-search', 'set', item);
        this.searchTerm = item.name;
        this.item = item;
    };
    CarriersSearchComponent.prototype.auto = function (event) {
        if (event === void 0) { event = null; }
        this.logger.log('carriers-search', 'auto', this.service.noResult);
        if (event != null) {
            this.capture(event.keyCode);
        }
        if (this.searchTerm.length < 3) {
            if (this.service.app.carriers.length === 0) {
                this.service.autoOn = false;
            }
            else {
                this.service.autoOn = true;
            }
        }
        else {
            if (this.service.autoOn === false) {
                this.service.startSearch();
            }
            this.searchTermStream.next(this.searchTerm);
            this.logger.log('carriers-search', 'auto else', this.service.autoOn);
        }
    };
    CarriersSearchComponent.prototype.selectText = function ($event) {
        $event.target.select();
    };
    CarriersSearchComponent.prototype.capture = function (keyCode) {
        switch (keyCode) {
            case 9:
                this.autocomplete();
                break;
            case 13:
                this.autocomplete();
                this.search();
                break;
            case 35:
                this.highlight('up');
                break;
            case 40:
                this.highlight('down');
                break;
        }
    };
    CarriersSearchComponent.prototype.autocomplete = function () {
        try {
            if (this.items != null && this.items.length != 0) {
                this.set(this.items[0]);
            }
        }
        catch (ex) {
            this.logger.log('ports-search', 'autocomplete ex', ex);
        }
    };
    CarriersSearchComponent.prototype.highlight = function (direction) {
        if (direction === void 0) { direction = 'down'; }
        if (this.items == null || this.items.length == 0) {
            return;
        }
        // expand to highlight items in the list
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], CarriersSearchComponent.prototype, "close", void 0);
    CarriersSearchComponent = __decorate([
        core_1.Component({
            selector: 'carriers-search',
            template: __webpack_require__(932),
            styles: [__webpack_require__(933)],
            providers: [carriers_search_service_1.CarriersSearchService],
            host: {
                '(document:click)': 'onClick($event)'
            }
        }),
        __metadata("design:paramtypes", [shared_1.LogService, router_1.Router, carriers_search_service_1.CarriersSearchService])
    ], CarriersSearchComponent);
    return CarriersSearchComponent;
}());
exports.CarriersSearchComponent = CarriersSearchComponent;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
__webpack_require__(23);
var shared_1 = __webpack_require__(2);
var CarriersSearchService = (function () {
    function CarriersSearchService(logger, api, cache, app) {
        this.logger = logger;
        this.api = api;
        this.cache = cache;
        this.app = app;
        this.autoOn = false;
        this.loaderOn = false;
        this.noResult = false;
    }
    CarriersSearchService.prototype.startSearch = function () {
        this.autoOn = true;
        this.loaderOn = true;
        this.noResult = false;
    };
    CarriersSearchService.prototype.getCarriers = function (term) {
        var _this = this;
        this.logger.log('carriers-search.service', 'getCarriers', term);
        this.startSearch();
        // let cache = this.cache.get('carriers' + term);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetCarriers(client, term); });
        var server = Observable_1.Observable.fromPromise(promise);
        this.carriers = server;
        // this.carriers = Observable.concat(cache, server);
        // this.cache.updateCache('carriers' + term, this.carriers);
        return this.carriers;
    };
    CarriersSearchService.prototype.callGetCarriers = function (apigClient, term) {
        var _this = this;
        this.logger.log('carriers-search.service', 'callGetCarriers', term);
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: { search: term }
            };
            try {
                apigClient.carriersGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('carriers-search.service', 'resolve', result);
                    var formatted = _this.endSearch(result.data);
                    resolve(formatted);
                }).catch(function (err) {
                    _this.endSearch(null);
                    _this.autoOn = false;
                    _this.api.handleError(err);
                });
            }
            catch (ex) {
                _this.logger.log('carriers-search.service', 'catch', ex);
                return reject(ex);
            }
        });
    };
    CarriersSearchService.prototype.endSearch = function (data) {
        this.loaderOn = false;
        try {
            var formatted = new Array();
            for (var current = 0; current < data.items.length; current++) {
                formatted.push(new shared_1.Carrier(data.items[current]));
            }
            return formatted;
        }
        catch (ex) {
            this.noResult = true;
            return null;
        }
    };
    CarriersSearchService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.LogService, shared_1.ApiService, shared_1.CacheService, shared_1.AppContext])
    ], CarriersSearchService);
    return CarriersSearchService;
}());
exports.CarriersSearchService = CarriersSearchService;


/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-holder\">\r\n  <div class=\"col1of1 inputContainer\">\r\n    <h5>Carrier</h5>\r\n    <input id='searchbox' class=\"text\" autocomplete=\"false\" placeholder=\"name, code, or keyword\" [(ngModel)]=\"searchTerm\" (keydown)=\"auto($event)\" (click)=\"auto()\" (click)=\"selectText($event)\">\r\n    <div *ngIf=\"service.autoOn\" class=\"auto-complete\">\r\n      <div [class.visible]=\"service.loaderOn\" class=\"little-loader\"></div>\r\n      <ul *ngIf=\"searchTerm === ''\"> \r\n        <li *ngFor=\"let item of service.app.carriers\" (click)=\"set(item)\">\r\n          <span class=\"favorite-star\"><img *ngIf=\"item.userData.favorited\" src=\"../img/star-filled.svg\"></span>\r\n          {{ item.name }} - \r\n          {{ item.company }}\r\n        </li>\r\n      </ul>\r\n      <ul *ngIf=\"searchTerm !== ''\">\r\n        <ul *ngIf=\"service.noResult\"><li>No Results</li></ul>\r\n        <li *ngFor=\"let item of items\" (click)=\"set(item)\">\r\n          {{ item.name }} - \r\n          {{ item.company }}\r\n        </li>\r\n      </ul>\r\n    </div>\r\n    <!--\r\n    <p><i>name, code, or keyword</i></p>\r\n    -->\r\n  </div>\r\n  <div class=\"col-holder text-center\">\r\n    <div class=\"col4of5\">\r\n      <a class=\"btn\" (click)=\"search()\">Search Carriers</a>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports = ".col-holder {\n  padding: 20px;\n  box-shadow: 0px 9px 20px -10px rgba(0, 0, 0, 0.75); }\n\n.col-holder.text-center {\n  box-shadow: none; }\n\nh5 {\n  font-size: 20px;\n  color: #247cbd;\n  font-weight: bold; }\n\ninput.text {\n  width: 100%; }\n\n.inputContainer {\n  margin-bottom: 20px; }\n\n@media only screen and (max-width: 979px) {\n  .col-holder {\n    box-shadow: none; } }\n\n/*\r\n.btn {\r\n  float: right;\r\n}\r\n\r\n.btn {\r\n\twidth: 100%;\r\n\ttext-align: center;\r\n\tmargin-top: 15px;\r\n\ttext-transform: uppercase;\r\n\tfont-weight: bold;\r\n\tpadding: 12px 20px;\r\n}\r\n\r\n.auto-complete {\r\n  margin-top: -9px;\r\n}\r\n\r\n.little-loader {\r\n  float: right;\r\n}\r\n\r\n@media only screen and (max-width: 599px) {\r\n    .btn {\r\n      float: none;\r\n      margin-top: 10px;\r\n    }\r\n}\r\n*/\n"

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var Subject_1 = __webpack_require__(10);
var ports_search_service_1 = __webpack_require__(935);
var shared_1 = __webpack_require__(2);
var PortsSearchComponent = (function () {
    function PortsSearchComponent(logger, router, service) {
        this.logger = logger;
        this.router = router;
        this.service = service;
        this.close = new core_1.EventEmitter();
        this.searchTermStream = new Subject_1.Subject();
        this.searchTerm = '';
        this.item = null;
        this.items = Array();
        // Do stuff
    }
    PortsSearchComponent.prototype.ngOnInit = function () {
        this.logger.log('ports-search.component', 'ngOnInit', 'Hello Ports Search');
        this.initSearchBox();
        this.loadCache();
    };
    PortsSearchComponent.prototype.initSearchBox = function () {
        var _this = this;
        this.itemsSub = this.searchTermStream
            .debounceTime(100)
            .distinctUntilChanged()
            .switchMap(function (term) { return _this.service.getPorts(term); }).subscribe(function (ports) {
            _this.items = ports;
        });
    };
    PortsSearchComponent.prototype.loadCache = function () {
        if (sessionStorage.getItem('ports-search-term')) {
            this.searchTerm = sessionStorage.getItem('ports-search-term');
        }
        if (sessionStorage.getItem('ports-search-date')) {
            this.date = sessionStorage.getItem('ports-search-date');
        }
    };
    PortsSearchComponent.prototype.onClick = function ($event) {
        if ($event.target.id === 'searchbox' && !this.service.autoOn) {
            this.auto();
        }
        else if ($event.target.id !== 'searchbox' && this.service.autoOn) {
            this.service.autoOn = false;
        }
    };
    PortsSearchComponent.prototype.search = function () {
        var date = moment(this.date, 'YYYY-MM-DD').format('YYYY-MM-DD');
        if (this.item !== null) {
            this.close.emit({ event: event, searchType: '', location: 'header' });
            this.router.navigate(['/ports', this.item.id, { date: encodeURIComponent(this.date) }]);
        }
        else if (sessionStorage.getItem('ports-search-item-id')) {
            var portId = +sessionStorage.getItem('ports-search-item-id');
            this.close.emit({ event: event, searchType: '', location: 'header' });
            this.router.navigate(['/ports', portId, { date: encodeURIComponent(this.date) }]);
        }
        sessionStorage.setItem('ports-search-term', this.searchTerm);
        sessionStorage.setItem('ports-search-date', this.date);
        sessionStorage.setItem('ports-search-item-id', this.item.id.toString());
    };
    PortsSearchComponent.prototype.set = function (item) {
        this.service.autoOn = false;
        this.logger.log('ports-search', 'set', item);
        this.searchTerm = item.title;
        this.item = item;
    };
    PortsSearchComponent.prototype.auto = function (event) {
        if (event === void 0) { event = null; }
        this.logger.log('ports-search', 'auto', this.service.noResult);
        if (event != null) {
            this.capture(event.keyCode);
        }
        if (this.searchTerm.length < 3) {
            if (this.service.app.carriers.length === 0) {
                this.service.autoOn = false;
            }
            else {
                this.service.autoOn = true;
            }
        }
        else {
            if (this.service.autoOn === false) {
                this.service.startSearch();
            }
            this.searchTermStream.next(this.searchTerm);
            this.logger.log('ports-search', 'auto else', this.service.autoOn);
        }
    };
    PortsSearchComponent.prototype.selectText = function ($event) {
        $event.target.select();
    };
    PortsSearchComponent.prototype.capture = function (keyCode) {
        switch (keyCode) {
            case 9:
                this.autocomplete();
                break;
            case 13:
                this.autocomplete();
                this.search();
                break;
            case 35:
                this.highlight('up');
                break;
            case 40:
                this.highlight('down');
                break;
        }
    };
    PortsSearchComponent.prototype.autocomplete = function () {
        try {
            if (this.items != null && this.items.length != 0) {
                this.set(this.items[0]);
                this.service.autoOn = false;
            }
        }
        catch (ex) {
            this.logger.log('ports-search', 'autocomplete ex', ex);
        }
    };
    PortsSearchComponent.prototype.highlight = function (direction) {
        if (direction === void 0) { direction = 'down'; }
        if (this.items == null || this.items.length == 0) {
            return;
        }
        // expand to highlight items in the list
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], PortsSearchComponent.prototype, "close", void 0);
    PortsSearchComponent = __decorate([
        core_1.Component({
            selector: 'ports-search',
            template: __webpack_require__(936),
            styles: [__webpack_require__(937)],
            providers: [ports_search_service_1.PortsSearchService],
            host: {
                '(document:click)': 'onClick($event)'
            }
        }),
        __metadata("design:paramtypes", [shared_1.LogService, router_1.Router, ports_search_service_1.PortsSearchService])
    ], PortsSearchComponent);
    return PortsSearchComponent;
}());
exports.PortsSearchComponent = PortsSearchComponent;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
__webpack_require__(23);
var shared_1 = __webpack_require__(2);
var PortsSearchService = (function () {
    function PortsSearchService(logger, api, cache, app) {
        this.logger = logger;
        this.api = api;
        this.cache = cache;
        this.app = app;
        this.autoOn = false;
        this.loaderOn = false;
        this.noResult = false;
        this.logger.log('ports-search.service', 'constructor', this.app);
    }
    PortsSearchService.prototype.startSearch = function () {
        this.autoOn = true;
        this.loaderOn = true;
        this.noResult = false;
    };
    PortsSearchService.prototype.getPorts = function (term) {
        var _this = this;
        this.logger.log('ports-search.service', 'getPorts', term);
        this.startSearch();
        // let cache = this.cache.get('ports' + term);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetPorts(client, term); });
        var server = Observable_1.Observable.fromPromise(promise);
        this.ports = server;
        // this.ports = Observable.concat(cache, server);
        // this.cache.updateCache('ports' + term, this.ports);
        return this.ports;
    };
    PortsSearchService.prototype.callGetPorts = function (apigClient, term) {
        var _this = this;
        this.logger.log('ports-search.service', 'callGetPorts', term);
        return new Promise(function (resolve, reject) {
            var params = {};
            var body = {};
            var additionalParams = {
                headers: {
                    'Content-Type': 'application/json'
                },
                queryParams: {
                    search: term
                }
            };
            try {
                apigClient.portsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('ports-search.service', 'resolve', result);
                    var formatted = _this.endSearch(result.data);
                    resolve(formatted);
                }).catch(function (err) {
                    _this.autoOn = false;
                    _this.api.handleError(err);
                });
            }
            catch (ex) {
                _this.logger.log('ports-search.service', 'catch', ex);
                return reject(ex);
            }
        });
    };
    PortsSearchService.prototype.endSearch = function (data) {
        this.loaderOn = false;
        try {
            var formatted = new Array();
            for (var current = 0; current < data.items.length; current++) {
                formatted.push(new shared_1.Port(data.items[current]));
            }
            return formatted;
        }
        catch (ex) {
            this.noResult = true;
            return null;
        }
    };
    PortsSearchService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.LogService, shared_1.ApiService, shared_1.CacheService, shared_1.AppContext])
    ], PortsSearchService);
    return PortsSearchService;
}());
exports.PortsSearchService = PortsSearchService;


/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports = "<div class=\"search-holder\">  \r\n  <div class=\"col-holder\">\r\n    <div class=\"inputContainer\">\r\n      <h5>Port</h5>\r\n      <input id='searchbox' class=\"text\" placeholder=\"name, locode, region, country\" [(ngModel)]=\"searchTerm\" (keydown)=\"auto($event)\" (click)=\"auto()\" (click)=\"selectText($event)\">\r\n      <div *ngIf=\"service.autoOn\" class=\"auto-complete\">\r\n        <div [class.visible]=\"service.loaderOn\" class=\"little-loader\"></div>\r\n        <ul *ngIf=\"service.noResult\"><li>No Results</li></ul>\r\n        <ul *ngIf=\"searchTerm === ''\">\r\n          <li *ngFor=\"let item of service.app.ports\" (click)=\"set(item)\">\r\n          <span class=\"favorite-star\"><img *ngIf=\"item.userData.favorited\" src=\"../img/star-filled.svg\"></span>\r\n            {{ item.display }}\r\n          </li>\r\n        </ul>\r\n        <ul *ngIf=\"searchTerm !== ''\">\r\n          <li *ngFor=\"let item of items\" (click)=\"set(item)\">\r\n            {{ item.display }}\r\n          </li>\r\n        </ul>\r\n      </div>\r\n      <!--\r\n      <p><i>name, locode, region, country</i></p>\r\n      -->\r\n    </div>\r\n    <div class=\"inputContainer\">\r\n      <h5>Date</h5>\r\n      <datepicker [(ngModel)]=\"date\" [init-date]=\"date\" view-format=\"YYYY-MM-DD\" model-format=\"YYYY-MM-DD\"></datepicker>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-holder text-center\">\r\n    <div class=\"col4of5\">\r\n      <a class=\"btn\" (click)=\"search()\">Search Ports</a>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports = ".search-holder {\n  padding: 20px;\n  box-shadow: 0px 9px 20px -10px rgba(0, 0, 0, 0.75); }\n\n.col-holder.text-center {\n  box-shadow: none; }\n\nh5 {\n  font-size: 20px;\n  color: #247cbd;\n  font-weight: bold; }\n\ninput.text {\n  width: 100%; }\n\ninput.ng-datepicker-input {\n  width: 100%; }\n\n.inputContainer {\n  margin-bottom: 20px; }\n\n@media only screen and (max-width: 979px) {\n  .search-holder {\n    box-shadow: none; } }\n\n/*\r\n.btn {\r\n  float: right;\r\n}\r\n\r\n.btn {\r\n\twidth: 100%;\r\n\ttext-align: center;\r\n\tmargin-top: 15px;\r\n\ttext-transform: uppercase;\r\n\tfont-weight: bold;\r\n\tpadding: 12px 20px;\r\n}\r\n\r\n.little-loader {\r\n  float: right;\r\n}\r\n\r\n@media only screen and (max-width: 599px) {\r\n    .btn {\r\n      float: none;\r\n      margin-top: 10px;\r\n    }\r\n}\r\n*/\n"

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var Subject_1 = __webpack_require__(10);
var schedules_search_service_1 = __webpack_require__(939);
var shared_1 = __webpack_require__(2);
var SchedulesSearchComponent = (function () {
    function SchedulesSearchComponent(router, logger, service, ref, app) {
        this.router = router;
        this.logger = logger;
        this.service = service;
        this.ref = ref;
        this.app = app;
        this.close = new core_1.EventEmitter();
        this.originTermStream = new Subject_1.Subject();
        this.originTerm = '';
        this.origin = null;
        this.originPorts = Array();
        this.originLocations = Array();
        this.originNoResult = false;
        this.originNearPorts = true;
        this.destinationTermStream = new Subject_1.Subject();
        this.destinationTerm = '';
        this.destination = null;
        this.destinationPorts = Array();
        this.destinationLocations = Array();
        this.destinationNoResult = false;
        this.destinationNearPorts = true;
        this.arrival = false;
        this.week = 2;
        this.da = 'depart';
        this.showRoutes = false;
        // Do stuff
    }
    SchedulesSearchComponent.prototype.ngOnInit = function () {
        this.loadCache();
        this.initOrigin();
        this.initDestination();
        this.initNearBy();
        this.initDepartArrive();
        var appStatus = this.app;
        if (sessionStorage.getItem('need-update-search-setting') !== 'false') {
            if (this.app.accountType === "Professional") {
                this.week = 8;
                this.destinationNearPorts = true;
                this.originNearPorts = true;
                sessionStorage.setItem('schedules-week', '8');
                sessionStorage.setItem('schedules-origin-nearby', 'ture');
                sessionStorage.setItem('schedules-destination-nearby', 'true');
                sessionStorage.setItem('need-update-search-setting', 'false');
            }
            if (this.app.accountType === "Premium") {
                console.log('Premium User');
                this.week = 6;
                // if box checked originNearPorts/destinationNearPorts = true if not originNearPorts = false
                this.destinationNearPorts = true;
                this.originNearPorts = true;
                sessionStorage.setItem('schedules-week', '6');
                sessionStorage.setItem('schedules-origin-nearby', 'ture');
                sessionStorage.setItem('schedules-destination-nearby', 'true');
                sessionStorage.setItem('need-update-search-setting', 'false');
            }
            if (this.app.accountType === "Basic") {
                this.week = 4;
                this.destinationNearPorts = false;
                this.originNearPorts = false;
                sessionStorage.setItem('schedules-week', '4');
                sessionStorage.setItem('schedules-origin-nearby', 'false');
                sessionStorage.setItem('schedules-destination-nearby', 'false');
                sessionStorage.setItem('need-update-search-setting', 'false');
            }
            // if(this.app.accountType === "") {
            //   this.week = 2;
            //   this.destinationNearPorts = false;
            //   this.originNearPorts = false;
            //   sessionStorage.setItem('need-update-search-setting', 'true');
            // }
        }
        if (this.app.accountType === "") {
            this.week = 2;
            this.destinationNearPorts = false;
            this.originNearPorts = false;
            sessionStorage.setItem('need-update-search-setting', 'true');
            sessionStorage.setItem('schedules-week', '2');
            sessionStorage.setItem('schedules-origin-nearby', 'false');
            sessionStorage.setItem('schedules-destination-nearby', 'false');
        }
    };
    SchedulesSearchComponent.prototype.accountValueChange = function () {
        if (this.app.accountType === 'Premium') {
            this.week = 6;
            console.log('Premium User ngModel');
        }
    };
    SchedulesSearchComponent.prototype.loadCache = function () {
        this.originTerm = sessionStorage.getItem('schedules-origin-title');
        this.origin = JSON.parse(sessionStorage.getItem('schedules-origin'));
        this.destinationTerm = sessionStorage.getItem('schedules-destination-title');
        this.destination = JSON.parse(sessionStorage.getItem('schedules-destination'));
        this.originNearPorts = sessionStorage.getItem('schedules-origin-nearby') == 'true';
        this.destinationNearPorts = sessionStorage.getItem('schedules-destination-nearby') == 'true';
        if (sessionStorage.getItem('schedules-date')) {
            this.date = sessionStorage.getItem('schedules-date');
        }
        this.da = sessionStorage.getItem('schedules-depart-arrive');
        if (this.da !== 'arrive') {
            this.da = 'depart';
        }
        var lastWeek = +sessionStorage.getItem('schedules-week');
        if (lastWeek == 1 || lastWeek == 2 || lastWeek == 3 || lastWeek == 4 ||
            lastWeek == 5 || lastWeek == 6 || lastWeek == 7 || lastWeek == 8) {
            this.week = lastWeek;
        }
        // if(this.app.accountType === "") {
        //   this.week = 2;
        //   this.destinationNearPorts = false;
        //   this.originNearPorts = false;
        //   sessionStorage.setItem('schedules-week', this.week.toString());
        //   sessionStorage.setItem('schedules-origin-nearby', this.originNearPorts.toString());
        //   sessionStorage.setItem('schedules-destination-nearby', this.destinationNearPorts.toString());
        //   sessionStorage.setItem('need-update-search-setting', 'true');
        // } else {
        //   if (sessionStorage.getItem('need-update-search-setting') === 'true') {
        //     sessionStorage.setItem('need-update-search-setting', 'false');
        //     if(this.app.accountType === "Professional") {
        //       this.week = 8;
        //       sessionStorage.setItem('schedules-week', '8');
        //     }
        //     if(this.app.accountType === "Premium") {
        //       console.log('Premium User')
        //       this.week = 6;
        //       sessionStorage.setItem('schedules-week', '6');
        //     }
        //     if(this.app.accountType === "Basic") {
        //       this.week = 4;
        //       sessionStorage.setItem('schedules-week', '4');
        //     }
        //   }
        // }
    };
    SchedulesSearchComponent.prototype.initOrigin = function () {
        var _this = this;
        this.originResults = this.ref.nativeElement.querySelector('originResults');
        this.originPortSub = this.originTermStream
            .debounceTime(100)
            .distinctUntilChanged()
            .switchMap(function (term) { return _this.service.getPorts('origin', term); }).subscribe(function (ports) {
            _this.originPorts = ports;
            _this.originNoResult = (_this.service.originPortNoResult && _this.service.originLocationNoResult
                && !_this.service.originLoaderOn) ? true : false;
        });
        this.originLocationSub = this.originTermStream
            .debounceTime(100)
            .distinctUntilChanged()
            .switchMap(function (term) { return _this.service.getLocations('origin', term); }).subscribe(function (locations) {
            _this.originLocations = locations;
            _this.originNoResult = (_this.service.originPortNoResult && _this.service.originLocationNoResult
                && !_this.service.originLoaderOn) ? true : false;
        });
    };
    SchedulesSearchComponent.prototype.initDestination = function () {
        var _this = this;
        this.destinationResults = this.ref.nativeElement.querySelector('destinationResults');
        this.destinationPortSub = this.destinationTermStream
            .debounceTime(100)
            .distinctUntilChanged()
            .switchMap(function (term) { return _this.service.getPorts('destination', term); }).subscribe(function (ports) {
            _this.destinationPorts = ports;
            _this.destinationNoResult = (_this.service.destinationPortNoResult && _this.service.destinationLocationNoResult
                && !_this.service.destinationLoaderOn) ? true : false;
        });
        this.destinationLocationSub = this.destinationTermStream
            .debounceTime(100)
            .distinctUntilChanged()
            .switchMap(function (term) { return _this.service.getLocations('destination', term); }).subscribe(function (locations) {
            _this.destinationLocations = locations;
            _this.destinationNoResult = (_this.service.destinationPortNoResult && _this.service.destinationLocationNoResult
                && !_this.service.destinationLoaderOn) ? true : false;
        });
    };
    SchedulesSearchComponent.prototype.initNearBy = function () {
        var originCheck = document.getElementById("origin-ports-selection");
        originCheck.checked = this.originNearPorts;
        var destinationCheck = document.getElementById("destination-ports-selection");
        destinationCheck.checked = this.destinationNearPorts;
    };
    SchedulesSearchComponent.prototype.initDepartArrive = function () {
        var departRadio = document.getElementById("depart-radio");
        var arriveRadio = document.getElementById("arrive-radio");
        if (this.da === 'depart') {
            departRadio.checked = true;
            arriveRadio.checked = false;
        }
        else {
            departRadio.checked = false;
            arriveRadio.checked = true;
        }
    };
    SchedulesSearchComponent.prototype.originClick = function ($event) {
        this.originAuto();
        this.service.originAutoOn = true;
        $event.target.select();
    };
    SchedulesSearchComponent.prototype.destinationClick = function ($event) {
        this.destinationAuto();
        this.service.destinationAutoOn = true;
        $event.target.select();
    };
    SchedulesSearchComponent.prototype.onClick = function ($event) {
        if ($event.target.id === 'origin' && !this.service.originAutoOn) {
            // this.service.originAutoOn = true;
            this.originAuto();
        }
        else if (($event.target.id !== 'origin' && this.service.originAutoOn)) {
            this.service.originAutoOn = false;
        }
        if ($event.target.id === 'destination' && !this.service.destinationAutoOn) {
            // this.service.destinationAutoOn = true;
            this.destinationAuto();
        }
        else if (($event.target.id !== 'destination' && this.service.destinationAutoOn)) {
            this.service.destinationAutoOn = false;
        }
        // if (($event.target.id !== 'destination' && $event.target.contains(this.destinationResults)) && this.service.destinationAutoOn) {
    };
    SchedulesSearchComponent.prototype.search = function () {
        var _this = this;
        if (this.origin == null || this.destination == null) {
            return;
        }
        sessionStorage.setItem('schedules-origin-title', this.originTerm);
        sessionStorage.setItem('schedules-origin', JSON.stringify(this.origin));
        sessionStorage.setItem('schedules-destination-title', this.destinationTerm);
        sessionStorage.setItem('schedules-destination', JSON.stringify(this.destination));
        sessionStorage.setItem('schedules-origin-nearby', this.originNearPorts.toString());
        sessionStorage.setItem('schedules-destination-nearby', this.destinationNearPorts.toString());
        sessionStorage.setItem('schedules-date', this.date);
        sessionStorage.setItem('schedules-depart-arrive', this.da);
        sessionStorage.setItem('schedules-week', this.week.toString());
        var params = this.setRouteParams();
        this.close.emit({ event: event, searchType: '' });
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(function () {
            return _this.router.navigate(['/schedules', params]);
        });
    };
    SchedulesSearchComponent.prototype.setRouteParams = function () {
        var params = {
            origin_search: this.originTerm,
            destination_search: this.destinationTerm,
        };
        this.setRouteDate(params);
        this.setOriginAndDestination(params);
        return params;
    };
    SchedulesSearchComponent.prototype.setRouteDate = function (params) {
        // let date = moment(this.date).format('YYYY-MM-DD');
        var endDate = moment(this.date, 'YYYY-MM-DD').add(this.week, 'week').format('YYYY-MM-DD');
        var startDate = encodeURIComponent(this.date);
        endDate = encodeURIComponent(endDate);
        if (this.da === 'depart') {
            params['start_date_gte'] = startDate;
            params['start_date_lte'] = endDate;
        }
        else {
            params['end_date_gte'] = startDate;
            params['end_date_lte'] = endDate;
        }
    };
    SchedulesSearchComponent.prototype.setOriginAndDestination = function (params) {
        params['origin_id'] = this.origin.id;
        //params['with_nearby_origins'] = this.originNearPorts;
        if (this.originNearPorts === true) {
            params['with_nearby_origins'] = 'true';
        }
        else {
            params['with_nearby_origins'] = 'false';
        }
        try {
            params['origin_type'] = this.origin.type || 'port';
        }
        catch (ex) {
            params['origin_type'] = 'port';
        }
        params['destination_id'] = this.destination.id;
        //params['with_nearby_destinations'] = 'false';this.destinationNearPorts;
        if (this.destinationNearPorts === true) {
            params['with_nearby_destinations'] = 'true';
        }
        else {
            params['with_nearby_destinations'] = 'false';
        }
        try {
            params['destination_type'] = this.destination.type || 'port';
        }
        catch (ex) {
            params['destination_type'] = 'port';
        }
    };
    SchedulesSearchComponent.prototype.setOriginPort = function (item) {
        this.service.originAutoOn = false;
        this.originTerm = item.title;
        this.origin = item;
    };
    SchedulesSearchComponent.prototype.setOriginLocation = function (item) {
        this.service.originAutoOn = false;
        this.originTerm = item.value.name;
        this.origin = item;
        // this.service.getPortsForLocation(item).then((result) => {
        //   this.origin = result;
        // });
    };
    SchedulesSearchComponent.prototype.setDestinationPort = function (item) {
        this.service.destinationAutoOn = false;
        this.destinationTerm = item.title;
        this.destination = item;
    };
    SchedulesSearchComponent.prototype.setDestinationLocation = function (item) {
        this.service.destinationAutoOn = false;
        this.destinationTerm = item.value.name;
        // this.service.getPortsForLocation(item).then((result) => {
        //   this.destination = result;
        // });
        this.destination = item;
    };
    SchedulesSearchComponent.prototype.originAuto = function (event) {
        if (event === void 0) { event = null; }
        if (event != null) {
            this.capture('origin', event.keyCode);
        }
        if (this.originTerm != null && this.originTerm.length < 3) {
            // clear results
            this.service.endPortSearch(true, 'origin');
            this.service.endLocationSearch(true, 'origin');
            if (this.service.app.ports.length === 0) {
                this.service.originAutoOn = false;
            }
            else {
                this.service.originAutoOn = true;
                this.service.destinationAutoOn = false;
            }
        }
        else if (this.originTerm != null) {
            this.originTermStream.next(this.originTerm);
            if (!this.service.originLoaderOn && this.service.originPortNoResult && this.service.originLocationNoResult) {
                this.service.originAutoOn = false;
            }
        }
    };
    SchedulesSearchComponent.prototype.destinationAuto = function (event) {
        if (event === void 0) { event = null; }
        if (event != null) {
            this.capture('destination', event.keyCode);
        }
        if (this.destinationTerm != null && this.destinationTerm.length < 3) {
            // clear results
            this.service.endPortSearch(true, 'destination');
            this.service.endLocationSearch(true, 'destination');
            if (this.service.app.ports.length === 0) {
                this.service.destinationAutoOn = false;
            }
            else {
                this.service.destinationAutoOn = true;
                this.service.originAutoOn = false;
            }
        }
        else if (this.destinationTerm != null) {
            this.destinationTermStream.next(this.destinationTerm);
            if (!this.service.destinationLoaderOn && this.service.destinationPortNoResult && this.service.destinationLocationNoResult) {
                this.service.destinationAutoOn = false;
            }
        }
    };
    SchedulesSearchComponent.prototype.capture = function (input, keyCode) {
        switch (keyCode) {
            case 9:
                this.autocomplete(input);
                break;
            case 13:
                this.autocomplete(input);
                if (input == 'destination') {
                    this.search();
                }
                break;
            case 35:
                this.highlight('up');
                break;
            case 40:
                this.highlight('down');
                break;
        }
    };
    SchedulesSearchComponent.prototype.autocomplete = function (inbox) {
        try {
            if (inbox == 'destination') {
                if (this.destinationPorts != null && this.destinationPorts.length > 0) {
                    this.setDestinationPort(this.destinationPorts[0]);
                }
                else {
                    this.setDestinationLocation(this.destinationLocations[0]);
                }
                this.service.destinationAutoOn = false;
            }
            else if (inbox == 'origin') {
                if (this.originPorts != null && this.originPorts.length > 0) {
                    this.setOriginPort(this.originPorts[0]);
                }
                else {
                    this.setOriginLocation(this.originLocations[0]);
                }
                this.service.originAutoOn = false;
            }
            else {
                this.logger.log('schedules-search', 'autocomplete unknown inbox:', inbox);
            }
        }
        catch (ex) {
            this.logger.log('schedules-search', 'autocomplete ex', ex);
        }
    };
    SchedulesSearchComponent.prototype.highlight = function (direction) {
        if (direction === void 0) { direction = 'down'; }
        // expand to highlight items in the list
    };
    SchedulesSearchComponent.prototype.when = function (checked) {
        this.da = checked;
    };
    SchedulesSearchComponent.prototype.toggleRoutes = function () {
        if (this.service.app.accountType === '') {
            this.service.app.showRegister();
        }
        else if (this.service.app.routes.length !== 0) {
            this.showRoutes = !this.showRoutes;
        }
        else {
            this.showRoutes = false;
            this.service.app.showSavedRoutesExplanation();
        }
    };
    SchedulesSearchComponent.prototype.toggleNearbyPorts = function () {
        if (this.service.app.accountType === '') {
            // const inputField = document.getElementById("test")
            var element = document.getElementById("destination-ports-selection");
            var originCheck = document.getElementById("origin-ports-selection");
            element.checked = false;
            originCheck.checked = false;
            this.service.app.showRegister();
        }
        if (this.service.app.accountType === 'Basic') {
            var element = document.getElementById("destination-ports-selection");
            var originCheck = document.getElementById("origin-ports-selection");
            element.checked = false;
            originCheck.checked = false;
            this.service.app.showUpgrade();
        }
    };
    SchedulesSearchComponent.prototype.populateRoute = function (route) {
        this.showRoutes = false;
        var originName = route.originName;
        originName = originName.substr(0, originName.indexOf('['));
        var routeOrigin = {
            id: route.originId,
            title: originName
        };
        this.setOriginPort(routeOrigin);
        var destinationName = route.destinationName;
        destinationName = destinationName.substr(0, destinationName.indexOf('['));
        var routeDestination = {
            id: route.destinationId,
            title: destinationName
        };
        this.setDestinationPort(routeDestination);
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SchedulesSearchComponent.prototype, "close", void 0);
    SchedulesSearchComponent = __decorate([
        core_1.Component({
            selector: 'schedules-search',
            template: __webpack_require__(940),
            styles: [__webpack_require__(941)],
            providers: [schedules_search_service_1.SchedulesSearchService],
            host: {
                '(document:click)': 'onClick($event)'
            }
        }),
        __metadata("design:paramtypes", [router_1.Router, shared_1.LogService, schedules_search_service_1.SchedulesSearchService, core_1.ElementRef, shared_1.AppContext])
    ], SchedulesSearchComponent);
    return SchedulesSearchComponent;
}());
exports.SchedulesSearchComponent = SchedulesSearchComponent;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
__webpack_require__(23);
var shared_1 = __webpack_require__(2);
var SchedulesSearchService = (function () {
    function SchedulesSearchService(logger, api, cache, app) {
        this.logger = logger;
        this.api = api;
        this.cache = cache;
        this.app = app;
        this.originAutoOn = false;
        this.originLoaderOn = false;
        this.originPortLoader = false;
        this.originLocationLoader = false;
        this.originPortNoResult = true;
        this.originLocationNoResult = true;
        this.destinationAutoOn = false;
        this.destinationLoaderOn = false;
        this.destinationPortLoader = false;
        this.destinationLocationLoader = false;
        this.destinationLocationNoResult = true;
        this.destinationPortNoResult = true;
    }
    SchedulesSearchService.prototype.startPortSearch = function (input) {
        if (input === 'origin') {
            this.originAutoOn = true;
            this.originLoaderOn = true;
            this.originPortLoader = true;
            this.originPortNoResult = true;
        }
        else {
            this.destinationAutoOn = true;
            this.destinationLoaderOn = true;
            this.destinationPortLoader = true;
            this.destinationPortNoResult = true;
        }
    };
    SchedulesSearchService.prototype.getPorts = function (input, term) {
        var _this = this;
        this.startPortSearch(input);
        // let cache = this.cache.get('ports' + term);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetPorts(client, term, input); });
        var server = Observable_1.Observable.fromPromise(promise);
        this.ports = server;
        // this.ports = Observable.concat(cache, server);
        // this.cache.updateCache('ports' + term, this.ports);
        return this.ports;
    };
    SchedulesSearchService.prototype.callGetPorts = function (apigClient, term, input) {
        var _this = this;
        this.logger.log('schedules-search.service', 'callGetPorts', term);
        return new Promise(function (resolve, reject) {
            if (term.trim().length === 0) {
                resolve(null);
                return;
            }
            var params = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {
                    search: term,
                    in_schedules: 1
                }
            };
            try {
                apigClient.portsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('schedules-search.service', 'ports resolve', result);
                    var formatted = _this.formatPorts(result.data, input);
                    resolve(formatted);
                }).catch(function (err) {
                    _this.api.handleError(err);
                    _this.endPortSearch(true, input);
                });
            }
            catch (ex) {
                _this.logger.log('schedules-search.service', 'catch', ex);
                return reject(ex);
            }
        });
    };
    SchedulesSearchService.prototype.endPortSearch = function (isNull, input) {
        if (input === 'origin') {
            this.originPortLoader = false;
            if (!this.originPortLoader && !this.originLocationLoader) {
                this.originLoaderOn = false;
            }
            if (isNull) {
                this.originPortNoResult = true;
            }
            else {
                this.originPortNoResult = false;
            }
        }
        else {
            this.destinationPortLoader = false;
            if (!this.destinationPortLoader && !this.destinationLocationLoader) {
                this.destinationLoaderOn = false;
            }
            if (isNull) {
                this.destinationPortNoResult = true;
            }
            else {
                this.destinationPortNoResult = false;
            }
        }
    };
    SchedulesSearchService.prototype.formatPorts = function (data, input) {
        this.logger.log('schedules-search.service', 'formatPorts', input);
        try {
            this.endPortSearch(false, input);
            var formatted = new Array();
            for (var current = 0; current < data.items.length; current++) {
                formatted.push(new shared_1.Port(data.items[current]));
            }
            return formatted;
        }
        catch (ex) {
            this.endPortSearch(true, input);
            return null;
        }
    };
    SchedulesSearchService.prototype.startLocationSearch = function (input) {
        if (input === 'origin') {
            this.originAutoOn = true;
            this.originLoaderOn = true;
            this.originLocationLoader = true;
            this.originLocationNoResult = true;
        }
        else {
            this.destinationAutoOn = true;
            this.destinationLoaderOn = true;
            this.destinationLocationLoader = true;
            this.destinationLocationNoResult = true;
        }
    };
    SchedulesSearchService.prototype.getLocations = function (input, term) {
        var _this = this;
        this.startLocationSearch(input);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetLocations(client, term, input); });
        var server = Observable_1.Observable.fromPromise(promise);
        this.locations = server;
        return this.locations;
    };
    SchedulesSearchService.prototype.callGetLocations = function (apigClient, term, input) {
        var _this = this;
        this.logger.log('schedules-search.service', 'callGetLocations', term);
        return new Promise(function (resolve, reject) {
            if (term.trim().length === 0) {
                resolve(null);
                return;
            }
            var params = {};
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {
                    search: term
                }
            };
            try {
                apigClient.locationsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('schedules-search.service', 'locations resolve', result);
                    var formatted = _this.formatLocations(result.data, input);
                    resolve(formatted);
                }).catch(function (err) {
                    _this.api.handleError(err);
                    _this.endLocationSearch(true, input);
                });
            }
            catch (ex) {
                _this.logger.log('schedules-search.service', 'catch', ex);
                return reject(ex);
            }
        });
    };
    SchedulesSearchService.prototype.formatLocations = function (data, input) {
        this.logger.log('schedules-search.service', 'formatLocations', input);
        try {
            this.endLocationSearch(false, input);
            var formatted = data.items;
            for (var current = 0; current < formatted.length; current++) {
                this.formatLocation(formatted[current]);
            }
            return formatted;
        }
        catch (ex) {
            this.endLocationSearch(true, input);
            return null;
        }
    };
    SchedulesSearchService.prototype.formatLocation = function (item) {
        if (item.type === 'country') {
            item.image = '../img/flags/' + item.id + '.svg';
        }
        else if (item.type === 'region') {
            item.image = '../img/flags/' + item.value.country.id + '.svg';
        }
        else {
            item.image = '';
        }
    };
    SchedulesSearchService.prototype.endLocationSearch = function (isNull, input) {
        if (input === 'origin') {
            this.originLocationLoader = false;
            if (!this.originPortLoader && !this.originLocationLoader) {
                this.originLoaderOn = false;
            }
            this.originLocationNoResult = isNull;
        }
        else {
            this.destinationLocationLoader = false;
            if (!this.destinationPortLoader && !this.destinationLocationLoader) {
                this.destinationLoaderOn = false;
            }
            this.destinationLocationNoResult = isNull;
        }
    };
    SchedulesSearchService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.LogService, shared_1.ApiService, shared_1.CacheService, shared_1.AppContext])
    ], SchedulesSearchService);
    return SchedulesSearchService;
}());
exports.SchedulesSearchService = SchedulesSearchService;


/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports = "<div class=\"search-holder-big\">\r\n  <div class=\"searchInputsContainer clearfix\">\r\n    <div class=\"locationsContainer clearfix\">\r\n      <div class=\"originContainer inputContainer\" style=\"padding-bottom: 20px\">\r\n        <h5>Origin</h5>\r\n        <input id=\"origin\" class=\"text saved-routes-next location-input\" autocomplete=\"false\"\r\n          placeholder=\"name, locode, region, country\" [(ngModel)]=\"originTerm\" (keydown)=\"originAuto($event)\"\r\n          (click)=\"originClick($event)\">\r\n        <div id=\"originResults\" *ngIf=\"service.originAutoOn\" class=\"auto-complete\">\r\n          <div [class.visible]=\"service.originLoaderOn\" class=\"little-loader\"></div>\r\n          <ul *ngIf=\"originTerm === '' || originTerm == null\">\r\n            <li *ngFor=\"let item of service.app.ports\" (click)=\"setOriginPort(item)\">\r\n              <span class=\"favorite-star\"><img *ngIf=\"item.userData.favorited\" src=\"../img/star-filled.svg\"></span>\r\n              {{item.display}}\r\n            </li>\r\n          </ul>\r\n          <div *ngIf=\"originTerm !== ''\">\r\n            <ul *ngIf=\"originNoResult\">\r\n              <li>No Results</li>\r\n            </ul>\r\n            <div *ngIf=\"!service.originPortNoResult\">\r\n              <p>Port</p>\r\n              <ul>\r\n                <li *ngFor=\"let item of originPorts\" (click)=\"setOriginPort(item)\">\r\n                  {{item.display}}\r\n                </li>\r\n              </ul>\r\n            </div>\r\n            <div *ngIf=\"!service.originLocationNoResult\">\r\n              <p>Country, state, or region</p>\r\n              <ul>\r\n                <li *ngFor=\"let item of originLocations\" (click)=\"setOriginLocation(item)\">\r\n                  <img class=\"company-logo\" src=\"{{ item.image }}\">\r\n                  {{item.value.name}}\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!--\r\n        <p class=\"input-explanation\"><i>name, locode, region, country</i></p>\r\n        -->\r\n      </div>\r\n      <div class=\"saved-schedule-btn-container search-button-container\">\r\n        <div>\r\n          <input type=\"checkbox\" id=\"origin-ports-selection\" name=\"origin-ports-selection\" (click)=\"toggleNearbyPorts()\"\r\n            [(ngModel)]=\"originNearPorts\" [checked]=\"originNearPorts\">\r\n            <label for=\"origin-ports-selection\" class=\"origin-desination-label\">and nearby ports</label>\r\n        </div>\r\n        <div class=\"dashes\"></div>\r\n        <a href=\"javascript:;\" class=\"saved-schedule-btn\" (click)=\"toggleRoutes()\" style=\"top: 20px;\" ><img class=\"saved-schedule-btn-image\"\r\n            title=\"Saved Routes\" src=\"../img/icons/png/btn-saved-schedule.png\" /></a>\r\n      </div>\r\n      <!--\r\n      <p class=\"btn-no-fill saved-schedule-btn\" (click)=\"toggleRoutes()\"><img class=\"saved-schedule-btn-image\" title=\"Saved Routes\" src=\"../img/icons/png/btn-saved-schedule.png\" /></p>\r\n      -->\r\n      <div class=\"destinationContainer inputContainer\">\r\n        <h5>Destination</h5>\r\n        <input id=\"destination\" class=\"text saved-routes-next location-input\" autocomplete=\"false\"\r\n          placeholder=\"name, locode, region, country\" [(ngModel)]=\"destinationTerm\" (keydown)=\"destinationAuto($event)\"\r\n          (click)=\"destinationClick($event)\">\r\n        <div id=\"destinationResults\" *ngIf=\"service.destinationAutoOn\" class=\"auto-complete\">\r\n          <div [class.visible]=\"service.destinationLoaderOn\" class=\"little-loader\"></div>\r\n          <ul *ngIf=\"destinationTerm === '' || destinationTerm == null\">\r\n            <li *ngFor=\"let item of service.app.ports\" (click)=\"setDestinationPort(item)\">\r\n              <span class=\"favorite-star\"><img *ngIf=\"item.userData.favorited\" src=\"../img/star-filled.svg\"\r\n                  onerror=\"this.onerror=null; this.src='../img/star-filled1x.png'\"></span>\r\n              {{item.display}}\r\n            </li>\r\n          </ul>\r\n          <div *ngIf=\"destinationTerm !== ''\">\r\n            <ul *ngIf=\"destinationNoResult\">\r\n              <li>No Results</li>\r\n            </ul>\r\n            <div *ngIf=\"!service.destinationPortNoResult\">\r\n              <p>Port</p>\r\n              <ul>\r\n                <li *ngFor=\"let item of destinationPorts\" (click)=\"setDestinationPort(item)\">\r\n                  {{item.display}}\r\n                </li>\r\n              </ul>\r\n            </div>\r\n            <div *ngIf=\"!service.destinationLocationNoResult\">\r\n              <p>Country, state, or region</p>\r\n              <ul>\r\n                <li *ngFor=\"let item of destinationLocations\" (click)=\"setDestinationLocation(item)\" (onclick)=\"retr\">\r\n                  <img class=\"company-logo\" src=\"{{ item.image }}\">\r\n                  {{item.value.name}}\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"search-button-container search-button-container\">\r\n          <input type=\"checkbox\" id=\"destination-ports-selection\" name=\"destination-ports-selection\" [(ngModel)]=\"destinationNearPorts\" (click)=\"toggleNearbyPorts()\" [checked]=\"destinationNearPorts\">\r\n          <label for=\"destination-ports-selection\" class=\"origin-desination-label\">and nearby ports</label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"dateRangeContainer clearfix\">\r\n      <div class=\"dateContainer inputContainer\">\r\n        <h5>Date</h5>\r\n        <datepicker id=\"schedules-datepicker\" [(ngModel)]=\"date\" [init-date]=\"date\" view-format=\"YYYY-MM-DD\" model-format=\"YYYY-MM-DD\"></datepicker>\r\n        <div>\r\n          <input class=\"radio-hide\" type=\"radio\" id=\"depart-radio\" value=\"depart\" name=\"depart/arrive\"\r\n            (click)=\"when('depart')\"><label for=\"depart-radio\" class=\"radio-label\"><span></span></label><label\r\n            class=\"pointer\" for=\"depart-radio\">Depart by</label>\r\n          <input class=\"radio-hide\" type=\"radio\" id=\"arrive-radio\" value=\"arrive\" name=\"depart/arrive\" \r\n            (click)=\"when('arrive')\"><label for=\"arrive-radio\" class=\"radio-label\"><span></span></label><label\r\n            class=\"pointer\" for=\"arrive-radio\">Arrive by</label>\r\n        </div>\r\n      </div>\r\n      <div class=\"rangeContainer inputContainer\">\r\n        <h5>Range</h5>\r\n    <!-- <select class=\"select-big\" [(ngModel)]=\"week\" (ngModelChange)=\"accountValueChange($event)\">\r\n          <option *ngIf=\"app.accountType !==''\" [selected]=\"app.accountType === 'Premium'\" value=\"6\">6 weeks</option>\r\n          <option value=\"1\">1 week</option>\r\n          <option [selected]=\"app.accountType === ''\" value=\"2\">2 weeks</option>\r\n          <option value=\"3\">3 weeks</option>\r\n          <option [selected]=\"app.accountType === 'Basic'\" value=\"4\">4 weeks</option>\r\n          <option *ngIf=\"app.accountType !== ''\" value=\"5\">5 weeks</option>\r\n          <option *ngIf=\"app.accountType !== '' && app.accountType !== 'Basic'\" value=\"7\">7 weeks</option>\r\n          <option [selected]=\"app.accountType === 'Professional'\"\r\n            *ngIf=\"app.accountType !== '' && app.accountType !== 'Basic'\" value=\"8\">8 weeks</option>\r\n      </select> -->\r\n\r\n<!-- dropdowns for each user login account below-->\r\n      <select class=\"select-big\" *ngIf=\"app.accountType === ''\" style=\"color: #247cbd\" [(ngModel)]=\"week\">\r\n          <option value=\"1\">1 week</option>\r\n          <option value=\"2\" selected>2 weeks</option>\r\n          <option disabled value=\"3\">3 weeks <div>- Register to Basic</div></option>\r\n          <option disabled value=\"4\">4 weeks <span>- Register to Basic</span></option>\r\n          <option disabled value=\"5\">5 weeks <span>- Subscribe to Premium</span></option>\r\n          <option disabled value=\"6\" >6 weeks <span>- Subscribe to Premium</span></option>\r\n          <option disabled value=\"7\">7 weeks <span>- Subscribe to Professional</span></option>\r\n          <option disabled value=\"8\">8 weeks <span>- Subscribe to Professional</span></option>\r\n      </select>\r\n      <select class=\"select-big\" *ngIf=\"app.accountType === 'Basic'\" style=\"color: #247cbd\" [(ngModel)]=\"week\">\r\n          <option value=\"1\">1 week</option>\r\n          <option value=\"2\">2 weeks</option>\r\n          <option value=\"3\">3 weeks</option>\r\n          <option value=\"4\" selected>4 weeks</option>\r\n          <option disabled value=\"5\">5 weeks <span>- Subscribe to Premium</span></option>\r\n          <option disabled value=\"6\">6 weeks <span>- Subscribe to Premium</span></option>\r\n          <option disabled value=\"7\">7 weeks <span>- Subscribe to Professional</span></option>\r\n          <option disabled value=\"8\">8 weeks <span>- Subscribe to Professional</span></option>\r\n      </select>\r\n      <select class=\"select-big\" *ngIf=\"app.accountType === 'Premium'\" style=\"color: #247cbd\" [(ngModel)]=\"week\">\r\n          <option value=\"1\">1 week</option>\r\n          <option value=\"2\">2 weeks</option>\r\n          <option value=\"3\">3 weeks</option>\r\n          <option value=\"4\">4 weeks</option>\r\n          <option value=\"5\">5 weeks</option>\r\n          <option value=\"6\" selected>6 weeks</option>\r\n          <option disabled value=\"7\">7 weeks <span>- Subscribe to Professional</span></option>\r\n          <option disabled value=\"8\">8 weeks <span>- Subscribe to Professional</span></option>\r\n      </select>\r\n      <select class=\"select-big\" *ngIf=\"app.accountType === 'Professional'\" style=\"color: #247cbd\" [(ngModel)]=\"week\">\r\n          <option value=\"1\">1 week</option>\r\n          <option value=\"2\">2 weeks</option>\r\n          <option value=\"3\">3 weeks</option>\r\n          <option value=\"4\">4 weeks</option>\r\n          <option value=\"5\">5 weeks</option>\r\n          <option value=\"6\" >6 weeks</option>\r\n          <option value=\"7\">7 weeks</option>\r\n          <option value=\"8\" selected>8 weeks</option>\r\n      </select>\r\n<!-- dropdowns for each user login account above-->\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-holder text-center\">\r\n    <div class=\"col4of5\">\r\n      <a class=\"btn\" (click)=\"search()\">Search Schedules</a>\r\n    </div>\r\n  </div>\r\n  <div class=\"text-center register-text\" *ngIf=\"!service.app.isLoggedIn\">\r\n    Register or <a [routerLink]=\"['/subscribe']\">subscribe</a> for extra features and more data\r\n  </div>\r\n</div>\r\n\r\n<!-- Does this go after origin? -->\r\n<div *ngIf=\"showRoutes\" class=\"auto-complete saved-schedule-autocomplete\">\r\n  <ul class=\"saved-route-ul\" *ngFor=\"let route of service.app.routes; let last = last\">\r\n    <li (click)=\"populateRoute(route)\">\r\n      {{ route.originName }} &#8594; {{ route.destinationName }}\r\n    </li>\r\n    <div *ngIf=\"!last\" class=\"saved-routes-line\"></div>\r\n  </ul>\r\n</div>"

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports = ".search-holder-big {\n  padding: 20px;\n  box-shadow: 0px 9px 20px -10px rgba(0, 0, 0, 0.75); }\n\n.col-holder.text-center {\n  box-shadow: none; }\n\n.origin-desination-label {\n  font-size: 14px; }\n\n.search-button-container {\n  font-size: 14px;\n  color: #247cbd;\n  padding-top: 4px !important; }\n\n@media only screen and (max-width: 979px) {\n  .search-holder-big {\n    box-shadow: none; } }\n\nh5 {\n  font-size: 20px;\n  color: #247cbd;\n  font-weight: bold; }\n\ninput.text {\n  width: 100%; }\n\ninput.ng-datepicker-input {\n  width: 100%; }\n\nselect {\n  width: 100%; }\n\nlabel.pointer {\n  font-size: 14px;\n  color: #247cbd;\n  margin-right: 30px; }\n\n.register-text {\n  font-size: 16px; }\n\n.inputContainer {\n  margin-bottom: 20px; }\n\n.register-text {\n  margin-top: 20px; }\n\n.originContainer {\n  margin-bottom: 30px; }\n\n.saved-schedule-btn-container {\n  position: absolute;\n  top: 88px;\n  left: 0;\n  width: 100%;\n  padding: 0 20px;\n  height: 67px; }\n  .saved-schedule-btn-container .dashes {\n    position: absolute;\n    left: 50%;\n    top: 10px;\n    height: 100%;\n    width: calc(50% - 20px);\n    background: url(\"/img/icons/png/saved-schedule-btn-dashes.png\");\n    background-repeat: no-repeat;\n    background-position: left 50%;\n    background-size: 100% 100%; }\n  .saved-schedule-btn-container .saved-schedule-btn {\n    position: absolute;\n    top: 10px;\n    right: 20px; }\n\n/*\r\n@media only screen and (max-width: 979px) {\r\n\t.saved-schedule-btn-container {\r\n\t\theight: 0;\r\n\t\t&.open {\r\n\t\t\t\theight: 67px;\r\n\t\t}\r\n\t}\r\n\t.open .saved-schedule-btn-container {\r\n\t\theight: 67px;\r\n\t}\r\n}\r\n*/\n/*\r\n.locationsContainer {\r\n\twidth: 60%;\r\n\tfloat: left;\r\n}\r\n.dateRangeContainer {\r\n\twidth: 40%;\r\n\tfloat: left;\r\n}\r\n.originContainer {\r\n\twidth: calc(50% - 35px);\r\n\tfloat: left;\r\n\tposition: relative;\r\n}\r\n.destinationContainer {\r\n\twidth: calc(50% + 35px);\r\n\tfloat: left;\r\n\tposition: relative;\r\n\t.btn {\r\n\t\twidth: 50px;\r\n\t}\r\n}\r\n.dateRangeContainer {\r\n\tinput {\r\n\t\twidth: calc(50% - 7px);\r\n\t\t&:first-of-type {\r\n\t\t\tmargin-right: 10px;\r\n\t\t}\r\n\t}\r\n}\r\n.dateContainer {\r\n\twidth: 50%;\r\n\tfloat: left;\r\n}\r\n.rangeContainer {\r\n\twidth: 50%;\r\n\tfloat: left;\r\n}\r\n\r\n// Layout of the innards\r\n.originContainer  {\r\n\tinput, .auto-complete {\r\n\t\twidth: calc(100% - 15px);\r\n\t\tmin-width: 0;\r\n\t}\r\n}\r\n.destinationContainer {\r\n\tinput, .auto-complete {\r\n\t\twidth: calc(100% - 80px);\r\n\t\tmargin-right: 10px;\r\n\t\tmin-width: 0;\r\n\t}\r\n}\r\n// Styles for the datepicker are in app.scss (.search-holder-big .ng-datepicker-input)\r\n\r\n// Media Queries for containers and innards\r\n@media only screen and (max-width: 980px) {\r\n\t.locationsContainer {\r\n\t\twidth: 100%;\r\n\t}\r\n\t.dateRangeContainer {\r\n\t\twidth: 100%;\r\n\t}\r\n\t.destinationContainer input {\r\n\t\twidth: calc(100% - 70px);\r\n\t}\r\n}\r\n@media only screen and (max-width: 599px) {\r\n\t.originContainer, .destinationContainer, .dateContainer, .rangeContainer {\r\n\t\twidth: 100%;\r\n\t}\r\n\t.originContainer input {\r\n\t\twidth: 100%;\r\n\t}\r\n}\r\n\r\n\r\n// Original Styles\r\n.btn {\r\n\twidth: 100%;\r\n\ttext-align: center;\r\n\tmargin-top: 15px;\r\n\ttext-transform: uppercase;\r\n\tfont-weight: bold;\r\n\tpadding: 12px 20px;\r\n}\r\n\r\n.saved-schedule-btn {\r\n\tline-height: 28px;\r\n\tfont-size: 30px;\r\n\theight: 34px;\r\n\twidth: 34px;\r\n\tpadding: 0;\r\n\ttext-align: center;\r\n\tvertical-align: middle;\r\n\tborder: none;\r\n\tborder-radius: 3px;\r\n\tmargin-top: -5px;\r\n\timg {\r\n\t\theight: 34px;\r\n\t}\r\n}\r\n\r\n.saved-routes-line {\r\n\tdisplay: block;\r\n\theight: 1px;\r\n\twidth: 50%;\r\n\tmargin: auto;\r\n\tmargin-top: 4px;\r\n\tmargin-bottom: 4px;\r\n\tbackground: #d4d4d4;\r\n}\r\n\r\n.input-explanation {\r\n   position: relative;\r\n   max-width: 300px;\r\n}\r\n\r\n.select-big {\r\n\twidth: 100%;\r\n\tmin-width: 100%;\r\n}\r\n\r\n.col1of3 {\r\n\twidth: 25%;\r\n\t&:nth-of-type(2) {\r\n\t\twidth: 35%;\r\n\t}\r\n\t&:last-of-type {\r\n\t\twidth: 40%;\r\n\t\t.col1of2 {\r\n\t\t\t&:first-of-type {\r\n\t\t\t\tpadding-right: 10px;\r\n\t\t\t}\r\n\t\t\t&:last-of-type {\r\n\t\t\t\tpadding-left: 30px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\tselect {\r\n\t\t\tmargin-top: 31px; \r\n\t\t}\r\n}\r\n\r\n.little-loader {\r\n\tposition: absolute;\r\n\tright: 3px;\r\n}\r\n*/\n/*\r\n@media only screen and (max-width: 1200px) {\r\n\t.saved-schedule-btn {\r\n\t\tright: calc(50% - 132px);\r\n\t}\r\n}\r\n\r\n@media only screen and (max-width: 1125px) {\r\n\t.saved-schedule-btn {\r\n\t\tright: 23px;\r\n\t}\r\n\t.saved-routes-next {\r\n\t\twidth: calc(100% - 60px);\r\n\t\tmin-width: calc(100% - 60px);\r\n\t}\r\n}\r\n\r\n@media only screen and (max-width: 1050px) {\r\n\t.saved-routes-next {\r\n\t\twidth: calc(100% - 60px);\r\n\t\tmin-width: calc(100% - 60px);\r\n\t}\r\n}\r\n\r\n@media only screen and (max-width: 980px) {\r\n\t.saved-schedule-btn {\r\n\t\tright: calc(50% - 134px);\r\n\t}\r\n\tselect,\r\n\t.saved-routes-next {\r\n\t\twidth: 250px;\r\n\t\tmin-width: 250px;\r\n\t}\r\n\t.col1of3 {\r\n\t\twidth: 50%;\r\n\t\t&:last-of-type {\r\n\t\t\tmargin-top: 30px;\r\n\t\t\twidth: 100%;\r\n\t\t\t.col1of2 {\r\n\t\t\t\tselect,\r\n\t\t\t\tinput {\r\n\t\t\t\t\twidth: 250px !important;\r\n\t\t\t\t\tmin-width: 250px !important;\r\n\t\t\t\t}\r\n\t\t\t\t&:first-of-type {\r\n\t\t\t\t\tpadding-right: 0;\r\n\t\t\t\t}\r\n\t\t\t\t&:last-of-type {\r\n\t\t\t\t\tpadding-left: 0;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n@media only screen and (max-width: 767px) {\r\n\t.col1of3 {\r\n\t\t&:last-of-type {\r\n\t\t\t.col1of2 {\r\n\t\t\t\twidth: 50%;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media only screen and (max-width: 699px) {\r\n\t.col1of3 {\r\n\t\twidth: 100%;\r\n\t\t&:last-of-type {\r\n\t\t\tmargin-top: 0;\r\n\t\t\t.col1of2 {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\t\tselect {\r\n\t\t\tmargin-top: 8px; \r\n\t\t}\r\n\t}\r\n\t.saved-schedule-btn {\r\n\t\tright: inherit;\r\n\t\tmargin-left: 2px;\r\n\t}\r\n}\r\n\r\n\r\n@media only screen and (max-width: 599px) {\r\n    .btn {\r\n      float: none;\r\n      margin-top: 10px;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 350px) {\r\n    .saved-routes-next {\r\n\t\tmin-width: 225px;\r\n\t\twidth: 225px;\r\n\t}\r\n}\r\n*/\n"

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var Subject_1 = __webpack_require__(10);
var vessels_search_service_1 = __webpack_require__(943);
var shared_1 = __webpack_require__(2);
var VesselsSearchComponent = (function () {
    function VesselsSearchComponent(logger, router, service) {
        this.logger = logger;
        this.router = router;
        this.service = service;
        this.close = new core_1.EventEmitter();
        this.searchTermStream = new Subject_1.Subject();
        this.searchTerm = '';
        this.item = null;
        this.items = Array();
        // Do stuff
    }
    VesselsSearchComponent.prototype.ngOnInit = function () {
        this.logger.log('vessels-search.component', 'ngOnInit', 'Hello Vessels Search');
        this.initSearchBox();
        this.loadCache();
    };
    VesselsSearchComponent.prototype.initSearchBox = function () {
        var _this = this;
        this.itemsSub = this.searchTermStream
            .debounceTime(100)
            .distinctUntilChanged()
            .switchMap(function (term) { return _this.service.getVessels(term); }).subscribe(function (vessels) {
            _this.items = vessels;
        });
    };
    VesselsSearchComponent.prototype.loadCache = function () {
        if (sessionStorage.getItem('vessels-search-term')) {
            this.searchTerm = sessionStorage.getItem('vessels-search-term');
        }
    };
    VesselsSearchComponent.prototype.onClick = function ($event) {
        if ($event.target.id === 'searchbox' && !this.service.autoOn) {
            this.auto();
        }
        else if ($event.target.id !== 'searchbox' && this.service.autoOn) {
            this.service.autoOn = false;
        }
    };
    VesselsSearchComponent.prototype.search = function () {
        if (this.item !== null) {
            this.close.emit({ event: event, searchType: '', location: 'header' });
            this.router.navigate(['/vessels', this.item.id]);
        }
        else if (sessionStorage.getItem('vessels-search-item-id')) {
            var vesselsId = sessionStorage.getItem('vessels-search-item-id');
            this.close.emit({ event: event, searchType: '', location: 'header' });
            this.router.navigate(['/vessels', vesselsId]);
        }
        sessionStorage.setItem('vessels-search-term', this.searchTerm);
        sessionStorage.setItem('vessels-search-item-id', this.item.id.toString());
    };
    VesselsSearchComponent.prototype.set = function (item) {
        this.service.autoOn = false;
        this.logger.log('vessels-search', 'set', item);
        this.searchTerm = item.name;
        this.item = item;
    };
    VesselsSearchComponent.prototype.auto = function (event) {
        if (event === void 0) { event = null; }
        this.logger.log('vessels-search', 'auto', this.service.noResult);
        if (event != null) {
            this.capture(event.keyCode);
        }
        if (this.searchTerm.length < 3) {
            if (this.service.app.vessels.length === 0) {
                this.service.autoOn = false;
            }
            else {
                this.service.autoOn = true;
            }
        }
        else {
            if (this.service.autoOn === false) {
                this.service.startSearch();
            }
            this.searchTermStream.next(this.searchTerm);
            this.logger.log('vessels-search', 'auto else', this.service.autoOn);
        }
    };
    VesselsSearchComponent.prototype.selectText = function ($event) {
        $event.target.select();
    };
    VesselsSearchComponent.prototype.capture = function (keyCode) {
        switch (keyCode) {
            case 9:
                this.autocomplete();
                break;
            case 13:
                this.autocomplete();
                this.search();
                break;
            case 35:
                this.highlight('up');
                break;
            case 40:
                this.highlight('down');
                break;
        }
    };
    VesselsSearchComponent.prototype.autocomplete = function () {
        try {
            if (this.items != null && this.items.length != 0) {
                this.set(this.items[0]);
            }
        }
        catch (ex) {
            this.logger.log('ports-search', 'autocomplete ex', ex);
        }
    };
    VesselsSearchComponent.prototype.highlight = function (direction) {
        if (direction === void 0) { direction = 'down'; }
        if (this.items == null || this.items.length == 0) {
            return;
        }
        // expand to highlight items in the list
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], VesselsSearchComponent.prototype, "close", void 0);
    VesselsSearchComponent = __decorate([
        core_1.Component({
            selector: 'vessels-search',
            template: __webpack_require__(944),
            styles: [__webpack_require__(945)],
            providers: [vessels_search_service_1.VesselsSearchService],
            host: {
                '(document:click)': 'onClick($event)'
            }
        }),
        __metadata("design:paramtypes", [shared_1.LogService, router_1.Router, vessels_search_service_1.VesselsSearchService])
    ], VesselsSearchComponent);
    return VesselsSearchComponent;
}());
exports.VesselsSearchComponent = VesselsSearchComponent;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__(1);
__webpack_require__(23);
var shared_1 = __webpack_require__(2);
var VesselsSearchService = (function () {
    function VesselsSearchService(logger, api, cache, app) {
        this.logger = logger;
        this.api = api;
        this.cache = cache;
        this.app = app;
        this.autoOn = false;
        this.loaderOn = false;
        this.noResult = false;
    }
    VesselsSearchService.prototype.startSearch = function () {
        this.autoOn = true;
        this.loaderOn = true;
        this.noResult = false;
    };
    VesselsSearchService.prototype.getVessels = function (term) {
        var _this = this;
        this.logger.log('vessel-search.service', 'getVessels', term);
        this.startSearch();
        // let cache = this.cache.get('vessels' + term);
        var promise = this.api.getApiClient().then(function (client) { return _this.callGetVessels(client, term); });
        var server = Observable_1.Observable.fromPromise(promise);
        this.vessels = server;
        // this.vessels = Observable.concat(cache, server);
        // this.cache.updateCache('vessels' + term, this.vessels);
        return this.vessels;
    };
    VesselsSearchService.prototype.callGetVessels = function (apigClient, term) {
        var _this = this;
        this.logger.log('vessels-search.service', 'callGetVessels', term);
        return new Promise(function (resolve, reject) {
            var params = {};
            var additionalParams = {
                headers: {
                    'Content-Type': 'application/json'
                },
                queryParams: {
                    search: term
                }
            };
            try {
                apigClient.vesselsGet(params, '', additionalParams)
                    .then(function (result) {
                    _this.logger.log('vessels-search.service', 'resolve', result);
                    var formatted = _this.endSearch(result.data);
                    resolve(formatted);
                }).catch(function (err) {
                    _this.endSearch(null);
                    _this.autoOn = false;
                    _this.api.handleError(err);
                });
            }
            catch (ex) {
                _this.logger.log('vessels-search.service', 'catch', ex);
                return reject(ex);
            }
        });
    };
    VesselsSearchService.prototype.endSearch = function (data) {
        this.loaderOn = false;
        try {
            var formatted = new Array();
            for (var current = 0; current < data.items.length; current++) {
                formatted.push(new shared_1.Vessel(data.items[current]));
            }
            return formatted;
        }
        catch (ex) {
            this.noResult = true;
            return null;
        }
    };
    VesselsSearchService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.LogService, shared_1.ApiService, shared_1.CacheService, shared_1.AppContext])
    ], VesselsSearchService);
    return VesselsSearchService;
}());
exports.VesselsSearchService = VesselsSearchService;


/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-holder\">\r\n  <div class=\"col1of1 inputContainer\">\r\n    <h5>Vessel</h5>\r\n    <input id='searchbox' class=\"text\" placeholder=\"vessel name or IMO number\" [(ngModel)]=\"searchTerm\" (keydown)=\"auto($event)\" (click)=\"auto()\" (click)=\"selectText($event)\">\r\n    <div *ngIf=\"service.autoOn\" class=\"auto-complete\">\r\n      <div [class.visible]=\"service.loaderOn\" style=\"float: right;\" class=\"little-loader\"></div>\r\n      <ul *ngIf=\"searchTerm === ''\">\r\n        <li *ngFor=\"let item of service.app.vessels\" (click)=\"set(item)\">\r\n          <span class=\"favorite-star\"><img *ngIf=\"item.userData.favorited\" src=\"../img/star-filled.svg\"></span>\r\n          {{ item.name }}\r\n        </li>\r\n      </ul>\r\n      <ul *ngIf=\"searchTerm !== ''\">\r\n        <ul *ngIf=\"service.noResult\"><li>No Results</li></ul>\r\n        <li *ngFor=\"let item of items\" (click)=\"set(item)\">\r\n          {{ item.name }}\r\n        </li>\r\n      </ul>\r\n    </div>\r\n    <!--\r\n    <p><i>vessel name or IMO number</i></p>\r\n    -->\r\n  </div>\r\n  <div class=\"col-holder text-center\">\r\n    <div class=\"col4of5\">\r\n    <a class=\"btn\" (click)=\"search()\">Search Vessels</a>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports = ".col-holder {\n  padding: 20px;\n  box-shadow: 0px 9px 20px -10px rgba(0, 0, 0, 0.75); }\n\n.col-holder.text-center {\n  box-shadow: none; }\n\nh5 {\n  font-size: 20px;\n  color: #247cbd;\n  font-weight: bold; }\n\ninput.text {\n  width: 100%; }\n\n.inputContainer {\n  margin-bottom: 20px; }\n\n@media only screen and (max-width: 979px) {\n  .col-holder {\n    box-shadow: none; } }\n\n/*\r\n.btn {\r\n  float: right;\r\n}\r\n\r\n.btn {\r\n\twidth: 100%;\r\n\ttext-align: center;\r\n\tmargin-top: 15px;\r\n\ttext-transform: uppercase;\r\n\tfont-weight: bold;\r\n\tpadding: 12px 20px;\r\n}\r\n\r\n.auto-complete {\r\n  margin-top: -9px;\r\n}\r\n\r\n@media only screen and (max-width: 599px) {\r\n    .btn {\r\n      float: none;\r\n      margin-top: 10px;\r\n    }\r\n}\r\n*/\n"

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var share_results_service_1 = __webpack_require__(947);
var trips_1 = __webpack_require__(60);
var ShareResultsComponent = (function () {
    function ShareResultsComponent(service) {
        this.service = service;
        this.onClose = new core_1.EventEmitter();
    }
    Object.defineProperty(ShareResultsComponent.prototype, "display", {
        set: function (toDisplay) {
            this.service.show = toDisplay;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShareResultsComponent.prototype, "id", {
        set: function (id) {
            this.service.searchId = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShareResultsComponent.prototype, "schedules", {
        set: function (schedules) {
            this.service.emailBody = schedules.message;
            this.service.emailSubject = schedules.subject;
        },
        enumerable: true,
        configurable: true
    });
    ShareResultsComponent.prototype.close = function () {
        this.onClose.emit();
    };
    ShareResultsComponent.prototype.share = function () {
        var _this = this;
        try {
            this.service.share().then(function () {
                setTimeout(function () {
                    _this.service.message = '';
                    _this.service.success = false;
                    _this.onClose.emit();
                }, 4000);
            }).catch(function (err) {
                _this.service.message = 'Something went wrong. Please try again later.';
            });
        }
        catch (ex) {
        }
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], ShareResultsComponent.prototype, "onClose", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], ShareResultsComponent.prototype, "display", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ShareResultsComponent.prototype, "id", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", trips_1.Trips),
        __metadata("design:paramtypes", [trips_1.Trips])
    ], ShareResultsComponent.prototype, "schedules", null);
    ShareResultsComponent = __decorate([
        core_1.Component({
            selector: 'share-results',
            template: __webpack_require__(948),
            styles: [__webpack_require__(949)],
            providers: [share_results_service_1.ShareResultsService]
        }),
        __metadata("design:paramtypes", [share_results_service_1.ShareResultsService])
    ], ShareResultsComponent);
    return ShareResultsComponent;
}());
exports.ShareResultsComponent = ShareResultsComponent;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var ShareResultsService = (function () {
    function ShareResultsService(api, app, logger) {
        this.api = api;
        this.app = app;
        this.logger = logger;
        this.showEmail = false;
        this.message = '';
        this.show = false;
        this.searchId = '';
        this.emails = '';
        this.emailSubject = '';
        this.emailBody = '';
        this.success = false;
        this.loaderOn = false;
        if (!this.app.isLoggedIn) {
            this.display('others');
        }
    }
    ShareResultsService.prototype.display = function (who) {
        if (who === 'others') {
            this.showEmail = true;
        }
        else {
            this.showEmail = false;
        }
    };
    ShareResultsService.prototype.share = function () {
        var _this = this;
        this.logger.log('share-results', 'share', this.emails);
        this.message = '';
        if (this.showEmail && this.emails.trim().length === 0) {
            this.message = 'Please specify an email';
            return;
        }
        if (this.emailBody.length > 1024) {
            this.message = 'Messages must be less than 1024 characters';
            return;
        }
        var params = {
            fromAddress: this.app.email,
            toAddress: this.app.email,
            subject: this.emailSubject,
            message: this.emailBody
        };
        if (this.showEmail) {
            params.toAddress = this.emails;
        }
        return this.api.getApiClient().then(function (client) { return _this.callShare(client, params); });
    };
    ShareResultsService.prototype.callShare = function (apigClient, query) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.loaderOn = true;
            _this.success = false;
            _this.logger.log('share.service', 'callShare', query);
            var params = {
                searchId: _this.searchId
            };
            var body = query;
            var additionalParams = {
                headers: { 'Content-Type': 'application/json' },
                queryParams: {}
            };
            try {
                apigClient.searchesSearchIdSharePost(params, body, additionalParams)
                    .then(function (result) {
                    _this.logger.log('share.service', 'resolve', result);
                    _this.success = true;
                    _this.loaderOn = false;
                    resolve();
                }).catch(function (err) {
                    _this.api.handleError(err);
                    _this.loaderOn = false;
                    reject();
                });
            }
            catch (ex) {
                _this.logger.log('share.service', 'catch', ex);
                _this.loaderOn = false;
                reject();
            }
        });
    };
    ShareResultsService.prototype.updateEmails = function (emails) {
        this.message = '';
        this.emails = emails.join(',');
    };
    ShareResultsService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AppContext, shared_1.LogService])
    ], ShareResultsService);
    return ShareResultsService;
}());
exports.ShareResultsService = ShareResultsService;


/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = "  <div *ngIf=\"service.show\" class=\"share-box\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5 class=\"text-center\">Email Results</h5>\r\n    <div class=\"popup-line-div\"></div>\r\n    <div *ngIf=\"service.app.isLoggedIn\">\r\n      <input class=\"radio-hide\" type=\"radio\" id=\"yourself\" value=\"yourself\" name=\"shareToWhom\" checked (click)=\"service.display('yourself')\"><label for=\"yourself\" class=\"radio-label text-center\"><span></span></label><label for=\"yourself\">Email yourself</label>\r\n    </div>\r\n    <div>\r\n      <input [checked]=\"service.showEmail\" class=\"radio-hide\" type=\"radio\" id=\"others\" value=\"others\" name=\"shareToWhom\" (click)=\"service.display('others')\"><label for=\"others\" class=\"radio-label text-center\"><span></span></label><label for=\"others\">Enter email addresses</label>\r\n    </div>\r\n    <div *ngIf=\"service.showEmail\">\r\n      <p>Email Address</p>\r\n      <div class=\"popup-line-div\"></div>\r\n      <span [class.error-input-outer]=\"service.message === 'Please specify an email'\">\r\n          <email-box [initial]=\"service.email\" (emailsUpdated)=\"service.updateEmails($event)\"></email-box>\r\n      </span>\r\n    </div>\r\n    <textarea [class.error-input]=\"service.message === 'Your message is too long'\" [(ngModel)]=\"service.emailBody\" placeholder=\"Message Body to Send\"></textarea>\r\n    <a (click)=\"share()\" class=\"btn send-share-result-event text-center\">Share</a>\r\n    <p *ngIf=\"service.loaderOn\" class=\"sending-loader\">Sending<span class=\"ellipse-1\"> .</span><span class=\"ellipse-2\"> .</span><span class=\"ellipse-3\"> .</span></p>\r\n    <p *ngIf=\"service.success\"><img class=\"success-check\" src=\"../img/check-sign.svg\" onerror=\"this.onerror=null; this.src='../img/check-sign.png'\">Schedules sent.</p>\r\n    <span class=\"error mt5\">{{ service.message }}</span>\r\n  </div>\r\n<div *ngIf=\"service.show\" (click)=\"close()\" class=\"share-behind\"></div>"

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports = "/*\r\n.share-box {\r\n  background-color: #575757;\r\n\tposition: absolute;\r\n\ttop: 250px;\r\n\tleft: calc(50% - 160px);\r\n\twidth: 320px;\r\n\tpadding: 20px;\r\n\ttext-align: center;\r\n\tz-index: 40;\r\n\tborder-radius: 3px;\r\n  -webkit-box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.43);\r\n  -moz-box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.43);\r\n  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.43);\r\n}\r\n\r\n.share-behind {\r\n    position: fixed;\r\n\tz-index: 30;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100vh;\r\n\tbackground: rgba(250, 250, 250, 0.5);\r\n}\r\n*/\n.share-behind {\n  position: fixed;\n  z-index: 30;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.3); }\n\n.share-box {\n  background-color: #fafafa;\n  position: fixed;\n  top: 250px;\n  left: calc(50% - 160px);\n  width: 325px;\n  padding: 20px;\n  text-align: left;\n  z-index: 40;\n  border-radius: 3px;\n  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.43);\n  border: 1px solid #c4c4c4;\n  top: 200px;\n  max-height: calc(100vh - 220px);\n  overflow-y: auto; }\n\ninput[type=\"radio\"]:checked + label.radio-label span {\n  margin-left: 0; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput {\n  width: 15px; }\n\ninput[type=\"email\"] {\n  width: 100%; }\n\ntextarea {\n  width: 100%;\n  min-height: 100px; }\n\n.btn {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  margin-top: 10px; }\n\nlabel {\n  cursor: pointer; }\n\n.close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  line-height: 7px;\n  font-size: 24px;\n  color: #353535; }\n  .close:hover {\n    color: #1c1c1c; }\n\n.sending-loader .ellipse-1 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseOne 2s linear infinite;\n  -webkit-animation: ellipseOne 2s linear infinite; }\n\n.sending-loader .ellipse-2 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseTwo 2s linear infinite;\n  -webkit-animation: ellipseTwo 2s linear infinite; }\n\n.sending-loader .ellipse-3 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseThree 2s linear infinite;\n  -webkit-animation: ellipseThree 2s linear infinite; }\n\n@keyframes ellipseOne {\n  0% {\n    opacity: 0; }\n  24% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseTwo {\n  0% {\n    opacity: 0; }\n  49% {\n    opacity: 0; }\n  50% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseThree {\n  0% {\n    opacity: 0; }\n  74% {\n    opacity: 0; }\n  75% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@media only screen and (max-width: 399px) {\n  .share-box {\n    left: calc(50% - 150px);\n    width: 300px;\n    top: 20%; } }\n"

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n    <div class=\"wrapper main-wrapper\">\r\n        <div class=\"page-banner-inner\">\r\n            <h2>404 - Page Not Found</h2>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"main-content\">\r\n        <div class=\"wrapper main-wrapper\">\r\n          <div class=\"page-content-wrapper\">\r\n            <div class=\"page-content\">\r\n                <p>Please click any link above or go to the <a href=\"\">Homepage</a></p>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n                  "

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports = ".error-message-spacing {\n  font-size: 27px;\n  padding: 30px; }\n\n.page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"/img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 456px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 50px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-full {\n    vertical-align: top; }\n    .page-content .page-content-full p, .page-content .page-content-full li, .page-content .page-content-full div, .page-content .page-content-full label {\n      font-size: 18px;\n      line-height: 32px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n  .page-content .header-black {\n    color: black; }\n"

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var contact_carrier_service_1 = __webpack_require__(953);
var ContactCarrierComponent = (function () {
    function ContactCarrierComponent(service) {
        this.service = service;
        this.onClose = new core_1.EventEmitter();
    }
    Object.defineProperty(ContactCarrierComponent.prototype, "display", {
        set: function (toDisplay) {
            this.service.show = toDisplay;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactCarrierComponent.prototype, "schedule", {
        set: function (item) {
            this.service.schedule = item;
            if (item != null) {
                this.service.getWebsite();
            }
        },
        enumerable: true,
        configurable: true
    });
    ContactCarrierComponent.prototype.close = function () {
        this.onClose.emit(true);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], ContactCarrierComponent.prototype, "display", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], ContactCarrierComponent.prototype, "schedule", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], ContactCarrierComponent.prototype, "onClose", void 0);
    ContactCarrierComponent = __decorate([
        core_1.Component({
            selector: 'contact-carrier',
            template: __webpack_require__(954),
            styles: [__webpack_require__(955)],
            providers: [contact_carrier_service_1.ContactCarrierService],
        }),
        __metadata("design:paramtypes", [contact_carrier_service_1.ContactCarrierService])
    ], ContactCarrierComponent);
    return ContactCarrierComponent;
}());
exports.ContactCarrierComponent = ContactCarrierComponent;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var ContactCarrierService = (function () {
    function ContactCarrierService(api, logger, app) {
        this.api = api;
        this.logger = logger;
        this.app = app;
        this.show = false;
        this.route = '';
        this.company = '';
        this.website = '';
    }
    ContactCarrierService.prototype.getWebsite = function () {
        var _this = this;
        // clear if re-opening for a different carrier
        this.company = '';
        this.website = '';
        try {
            var origin = this.formatPort(this.schedule.departurePort);
            var start = moment(this.schedule.departure).format('MMM Do YYYY');
            var destination = this.formatPort(this.schedule.arrivalPort);
            var end = moment(this.schedule.arrival).format('MMM Do YYYY');
            this.route = origin + ' ' + start + ' to ' + end + ' ' + destination;
        }
        catch (ex) {
            this.route = 'the desired route';
        }
        this.api.getApiClient().then(function (client) { return _this.callGetCarrier(client, _this.schedule.carrier.id); });
    };
    ContactCarrierService.prototype.formatPort = function (item) {
        var display = '';
        try {
            display = item.name + ' [' + item.code + '], ' + item.region.name + ', ' + item.country.name;
        }
        catch (ex) {
            if (item.region === null && item.country !== null) {
                display = item.name + ' [' + item.code + '], ' + item.county.name;
            }
            else {
                display = item.name + ' [' + item.code + ']';
            }
        }
        return display;
    };
    ContactCarrierService.prototype.callGetCarrier = function (apigClient, carrierId) {
        var _this = this;
        this.logger.log('contact-carrier.service', 'callGetCarrier', this.schedule);
        var params = {};
        var additionalParams = {
            headers: { 'Content-Type': 'application/json' },
            queryParams: {
                id: carrierId
            }
        };
        try {
            apigClient.carriersGet(params, '', additionalParams)
                .then(function (result) {
                _this.logger.log('contact-carrier.service', 'carrier result', result);
                var carrier = new shared_1.Carrier(result.data.items[0], _this.app.accountType);
                _this.company = carrier.company;
                _this.website = carrier.website;
            }).catch(function (err) { return _this.api.handleError(err); });
        }
        catch (ex) {
            this.app.showMessage('Error', 'We were unable to retrieve the website for the carrier. Please try again');
        }
    };
    ContactCarrierService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.LogService, shared_1.AppContext])
    ], ContactCarrierService);
    return ContactCarrierService;
}());
exports.ContactCarrierService = ContactCarrierService;


/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"service.show\" class=\"popup-container\">\r\n  <div (click)=\"close()\" class=\"popup-wrapper\"></div>\r\n  <div class=\"popup\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5>Contact Carrier</h5>\r\n    <div class=\"popup-line-div\"></div>\r\n    <p><strong>Company:</strong> {{ service.company }}</p>\r\n    <p><strong>Website:</strong> {{ service.website }}</p>\r\n    <a (click)=\"close()\" class=\"btn text-center\" href=\"http://{{ service.website }}\" target=\"_blank\">Visit Website</a>\r\n  </div>\r\n</div>"

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports = ".popup {\n  width: 400px;\n  max-width: 100%; }\n\np {\n  text-align: left; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput,\n.btn {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  font-size: 16px;\n  text-align: left;\n  margin-top: 10px; }\n"

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var contact_form_service_1 = __webpack_require__(957);
var ContactFormComponent = (function () {
    function ContactFormComponent(service) {
        this.service = service;
    }
    Object.defineProperty(ContactFormComponent.prototype, "type", {
        set: function (emailType) {
            this.service.setType(emailType);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ContactFormComponent.prototype, "type", null);
    ContactFormComponent = __decorate([
        core_1.Component({
            selector: 'contact-form',
            template: __webpack_require__(958),
            styles: [__webpack_require__(959)],
            providers: [contact_form_service_1.ContactFormService]
        }),
        __metadata("design:paramtypes", [contact_form_service_1.ContactFormService])
    ], ContactFormComponent);
    return ContactFormComponent;
}());
exports.ContactFormComponent = ContactFormComponent;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var ContactFormService = (function () {
    function ContactFormService(api, app, logger) {
        this.api = api;
        this.app = app;
        this.logger = logger;
        this.status = '';
        // fields
        this.name = '';
        this.email = '';
        // ****
        this.domain = '';
        // ****
        this.company = '';
        this.position = '';
        this.telephone = '';
        this.country = '';
        this.message = '';
        this.frontError = false;
        this.emailError = false;
        this.emailErrorMessage = '';
        this.messageError = false;
        this.messageErrorMessage = '';
        this.nameErrorMessage = '';
        this.nameError = false;
        this.companyErrorMessage = '';
        this.companyError = false;
        this.positionErrorMessage = '';
        this.positionError = false;
        this.countryErrorMessage = '';
        this.countryError = false;
        this.telephoneErrorMessage = '';
        this.telephoneError = false;
        this.type = 'Contact';
    }
    ContactFormService.prototype.setType = function (type) {
        if (type === void 0) { type = 'Contact'; }
        this.type = type;
    };
    ContactFormService.prototype.contact = function () {
        var _this = this;
        this.frontError = false;
        var toSend = {
            from: this.name,
            email: this.email,
            domain: this.domain,
            type: this.type,
            company: this.company,
            position: this.position,
            telephone: this.telephone,
            country: this.country,
            message: this.message
        };
        this.validateEmail();
        this.validateMessage();
        this.validateName();
        this.validateCompany();
        this.validatePosition();
        this.validateTelephone();
        this.validateCountry();
        if (this.status !== 'sending' && this.frontError === false) {
            this.status = 'sending';
            this.api.getApiClient().then(function (client) { return _this.callContact(client, toSend); });
        }
    };
    ContactFormService.prototype.validateEmail = function () {
        //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        var EMAIL_REGEXP = this.app.EMAIL_REGEXP;
        if (EMAIL_REGEXP.test(this.email)) {
            this.emailErrorMessage = '';
            this.emailError = false;
            this.domain = "www." + this.email.split("@")[1];
        }
        else if (this.email === '') {
            this.frontError = true;
            this.emailErrorMessage = 'Email required';
            this.emailError = true;
        }
        else {
            this.frontError = true;
            this.emailErrorMessage = 'Invalid email';
            this.emailError = true;
        }
    };
    ContactFormService.prototype.validateMessage = function () {
        if (this.message !== '') {
            this.messageErrorMessage = '';
            this.messageError = false;
        }
        else {
            this.frontError = true;
            this.messageErrorMessage = 'Please include a message';
            this.messageError = true;
        }
    };
    ContactFormService.prototype.validateName = function () {
        if (this.name !== '') {
            this.nameErrorMessage = '';
            this.nameError = false;
        }
        else {
            this.frontError = true;
            this.nameErrorMessage = 'Name required';
            this.nameError = true;
        }
    };
    ContactFormService.prototype.validateCompany = function () {
        if (this.company !== '') {
            this.companyErrorMessage = '';
            this.companyError = false;
        }
        else {
            this.frontError = true;
            this.companyErrorMessage = 'Company required';
            this.companyError = true;
        }
    };
    ContactFormService.prototype.validatePosition = function () {
        if (this.position !== '') {
            this.positionErrorMessage = '';
            this.positionError = false;
        }
        else {
            this.frontError = true;
            this.positionErrorMessage = 'Position required';
            this.positionError = true;
        }
    };
    ContactFormService.prototype.validateTelephone = function () {
        if (this.telephone !== '') {
            this.telephoneErrorMessage = '';
            this.telephoneError = false;
        }
        else {
            this.frontError = true;
            this.telephoneErrorMessage = 'Telephone number required';
            this.telephoneError = true;
        }
    };
    ContactFormService.prototype.validateCountry = function () {
        if (this.country !== '') {
            this.countryErrorMessage = '';
            this.countryError = false;
        }
        else {
            this.frontError = true;
            this.countryErrorMessage = 'Country required';
            this.countryError = true;
        }
    };
    ContactFormService.prototype.numeralInputMasking = function (event) {
        var e = event || window.event;
        var key = event.keyCode || e.which;
        if ((key < 48 || key > 57) && key !== 37 && key !== 38
            && key !== 39 && key !== 40 && key !== 46
            && key !== 8 && key !== 35 && key !== 101 && key !== 120 && key !== 116) {
            e.preventDefault();
        }
    };
    ContactFormService.prototype.callContact = function (apigClient, toSend) {
        var _this = this;
        this.logger.log('contact.service', 'callContact', toSend);
        var params = {};
        var body = toSend;
        var additionalParams = {
            headers: { 'Content-Type': 'application/json' },
            queryParams: {}
        };
        try {
            apigClient.userContactPost(params, body, additionalParams)
                .then(function (result) {
                _this.logger.log('contact.service', 'resovlve', result);
                _this.status = 'Success';
            }).catch(function (err) {
                _this.status = 'Unable to connect to the server. Your message is important to us. Please try again later.';
                _this.api.handleError(err);
            });
        }
        catch (ex) {
            this.status = 'Unable to connect to the server. Your message is important to us. Please try again later.';
        }
    };
    ContactFormService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AppContext, shared_1.LogService])
    ], ContactFormService);
    return ContactFormService;
}());
exports.ContactFormService = ContactFormService;


/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"service.status !== 'Success'\" class=\"mt15\">\r\n  <div class=\"col-holder\">\r\n    <div class=\"col1of2\">\r\n      <label>From</label>\r\n      <input [class.error-input]=\"service.nameError === true\" (blur)=\"service.validateName()\" [(ngModel)]=\"service.name\" type=\"text\">\r\n      <span *ngIf=\"service.nameError\" class=\"error\">{{ service.nameErrorMessage }}</span>\r\n    </div>\r\n    <div class=\"col1of2\">\r\n      <label>E-mail</label>\r\n      <input [class.error-input]=\"service.emailError === true\" (blur)=\"service.validateEmail()\" [(ngModel)]=\"service.email\" type=\"email\">\r\n      <span *ngIf=\"service.emailError\" class=\"error\">{{ service.emailErrorMessage }}</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-holder\">\r\n    <div class=\"col1of2\">\r\n      <label>Company</label>\r\n      <input [class.error-input]=\"service.companyError === true\" (blur)=\"service.validateCompany()\" [(ngModel)]=\"service.company\" type=\"text\">\r\n      <span *ngIf=\"service.companyError\" class=\"error\">{{ service.companyErrorMessage }}</span>\r\n    </div>\r\n    <div class=\"col1of2\">\r\n      <label>Position</label>\r\n      <input [class.error-input]=\"service.positionError === true\" (blur)=\"service.validatePosition()\" [(ngModel)]=\"service.position\" type=\"text\">\r\n      <span *ngIf=\"service.positionError\" class=\"error\">{{ service.positionErrorMessage }}</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-holder\">\r\n    <div class=\"col1of2\">\r\n      <label>Telephone</label>\r\n      <input (keypress)=\"service.numeralInputMasking($event)\" [class.error-input]=\"service.telephoneError === true\" (blur)=\"service.validateTelephone()\" pattern=\"[0-9]\" [(ngModel)]=\"service.telephone\" type=\"text\">\r\n      <span *ngIf=\"service.telephoneError\" class=\"error\">{{ service.telephoneErrorMessage }}</span>\r\n    </div>\r\n    <div class=\"col1of2\">\r\n      <label>Country</label>\r\n      <input [class.error-input]=\"service.countryError === true\" (blur)=\"service.validateCountry()\" [(ngModel)]=\"service.country\" type=\"text\">\r\n      <span *ngIf=\"service.countryError\" class=\"error\">{{ service.countryErrorMessage }}</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"textarea-holder\">\r\n    <label>Message</label>\r\n    <textarea [class.error-input]=\"service.messageError === true\" (blur)=\"service.validateMessage()\" [(ngModel)]=\"service.message\"></textarea>\r\n    <span *ngIf=\"service.messageError\" style=\"margin-top: -10px;\" class=\"error mb10\">{{ service.messageErrorMessage }}</span>\r\n  </div>\r\n  <input (click)=\"service.contact()\" class=\"btn\" type=\"submit\">\r\n</div>\r\n<p *ngIf=\"service.status === 'sending'\" class=\"sending-loader\">Sending<span class=\"ellipse-1\"> .</span><span class=\"ellipse-2\"> .</span><span class=\"ellipse-3\"> .</span></p>\r\n<span *ngIf=\"service.status !== 'sending'\"><p class=\"mt10\" *ngIf=\"service.status !== 'Success'\">{{ service.status }}</p></span>\r\n<p class=\"mt10\" *ngIf=\"service.status === 'Success'\"><img class=\"success-check\" src=\"../img/check-sign.svg\" onerror=\"this.onerror=null; this.src='../img/check-sign.png'\">Message sent.</p>"

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports = ".page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 200px; }\n  .page-content p + p {\n    margin-top: 10px; }\n\nlabel {\n  line-height: 26px;\n  margin-top: 5px; }\n\n.textarea-holder,\n.col1of2 {\n  margin-top: 10px;\n  padding-right: 60px; }\n\ninput[type=\"text\"],\ninput[type=\"email\"] {\n  max-width: 100%;\n  width: 100%; }\n\ninput[type=\"text\"],\ninput[type=\"email\"],\ntextarea {\n  margin-top: 0; }\n\ntextarea {\n  width: 100%;\n  min-height: 100px; }\n\n.sending-loader .ellipse-1 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseOne 2s linear infinite;\n  -webkit-animation: ellipseOne 2s linear infinite; }\n\n.sending-loader .ellipse-2 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseTwo 2s linear infinite;\n  -webkit-animation: ellipseTwo 2s linear infinite; }\n\n.sending-loader .ellipse-3 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseThree 2s linear infinite;\n  -webkit-animation: ellipseThree 2s linear infinite; }\n\n@keyframes ellipseOne {\n  0% {\n    opacity: 0; }\n  24% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseTwo {\n  0% {\n    opacity: 0; }\n  49% {\n    opacity: 0; }\n  50% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseThree {\n  0% {\n    opacity: 0; }\n  74% {\n    opacity: 0; }\n  75% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%;\n    border-top: 1px solid #e3e3e3;\n    margin-top: 25px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; } }\n\n@media only screen and (max-width: 767px) {\n  .textarea-holder {\n    padding-right: 0; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n    .page-content .page-top-content {\n      padding-top: 0; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var appt_form_service_1 = __webpack_require__(961);
var ApptFormComponent = (function () {
    function ApptFormComponent(service) {
        this.service = service;
    }
    Object.defineProperty(ApptFormComponent.prototype, "type", {
        set: function (emailType) {
            this.service.setType(emailType);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ApptFormComponent.prototype, "type", null);
    ApptFormComponent = __decorate([
        core_1.Component({
            selector: 'appt-form',
            template: __webpack_require__(962),
            styles: [__webpack_require__(963)],
            providers: [appt_form_service_1.ApptFormService]
        }),
        __metadata("design:paramtypes", [appt_form_service_1.ApptFormService])
    ], ApptFormComponent);
    return ApptFormComponent;
}());
exports.ApptFormComponent = ApptFormComponent;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var ApptFormService = (function () {
    function ApptFormService(api, app, logger) {
        this.api = api;
        this.app = app;
        this.logger = logger;
        this.status = '';
        // fields
        this.name = '';
        this.email = '';
        // ****
        this.domain = '';
        // ****
        this.company = '';
        this.position = '';
        this.telephone = '';
        this.country = '';
        this.message = '';
        this.frontError = false;
        this.emailError = false;
        this.emailErrorMessage = '';
        this.messageError = false;
        this.messageErrorMessage = '';
        this.nameErrorMessage = '';
        this.nameError = false;
        this.companyErrorMessage = '';
        this.companyError = false;
        this.positionErrorMessage = '';
        this.positionError = false;
        this.countryErrorMessage = '';
        this.countryError = false;
        this.telephoneErrorMessage = '';
        this.telephoneError = false;
        this.type = 'Contact';
    }
    ApptFormService.prototype.setType = function (type) {
        if (type === void 0) { type = 'Appointment'; }
        this.type = type;
    };
    ApptFormService.prototype.contact = function () {
        var _this = this;
        this.frontError = false;
        var toSend = {
            from: this.name,
            email: this.email,
            domain: this.domain,
            type: this.type,
            company: this.company,
            position: this.position,
            telephone: this.telephone,
            country: this.country,
            message: this.message
        };
        this.validateEmail();
        this.validateMessage();
        this.validateName();
        this.validateCompany();
        this.validatePosition();
        this.validateTelephone();
        this.validateCountry();
        if (this.status !== 'sending' && this.frontError === false) {
            this.status = 'sending';
            this.api.getApiClient().then(function (client) { return _this.callContact(client, toSend); });
        }
    };
    ApptFormService.prototype.validateEmail = function () {
        //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        var EMAIL_REGEXP = this.app.EMAIL_REGEXP;
        if (EMAIL_REGEXP.test(this.email)) {
            this.emailErrorMessage = '';
            this.emailError = false;
            this.domain = "www." + this.email.split("@")[1];
        }
        else if (this.email === '') {
            this.frontError = true;
            this.emailErrorMessage = 'Email required';
            this.emailError = true;
        }
        else {
            this.frontError = true;
            this.emailErrorMessage = 'Invalid email';
            this.emailError = true;
        }
    };
    ApptFormService.prototype.validateMessage = function () {
        if (this.message !== '') {
            this.messageErrorMessage = '';
            this.messageError = false;
        }
        else {
            this.frontError = true;
            this.messageErrorMessage = 'Please include a message';
            this.messageError = true;
        }
    };
    ApptFormService.prototype.validateName = function () {
        if (this.name !== '') {
            this.nameErrorMessage = '';
            this.nameError = false;
        }
        else {
            this.frontError = true;
            this.nameErrorMessage = 'Name required';
            this.nameError = true;
        }
    };
    ApptFormService.prototype.validateCompany = function () {
        if (this.company !== '') {
            this.companyErrorMessage = '';
            this.companyError = false;
        }
        else {
            this.frontError = true;
            this.companyErrorMessage = 'Company required';
            this.companyError = true;
        }
    };
    ApptFormService.prototype.validatePosition = function () {
        if (this.position !== '') {
            this.positionErrorMessage = '';
            this.positionError = false;
        }
        else {
            this.frontError = true;
            this.positionErrorMessage = 'Position required';
            this.positionError = true;
        }
    };
    ApptFormService.prototype.validateTelephone = function () {
        if (this.telephone !== '') {
            this.telephoneErrorMessage = '';
            this.telephoneError = false;
        }
        else {
            this.frontError = true;
            this.telephoneErrorMessage = 'Telephone number required';
            this.telephoneError = true;
        }
    };
    ApptFormService.prototype.validateCountry = function () {
        if (this.country !== '') {
            this.countryErrorMessage = '';
            this.countryError = false;
        }
        else {
            this.frontError = true;
            this.countryErrorMessage = 'Country required';
            this.countryError = true;
        }
    };
    ApptFormService.prototype.numeralInputMasking = function (event) {
        var e = event || window.event;
        var key = event.keyCode || e.which;
        if ((key < 48 || key > 57) && key !== 37 && key !== 38
            && key !== 39 && key !== 40 && key !== 46
            && key !== 8 && key !== 35 && key !== 101 && key !== 120 && key !== 116) {
            e.preventDefault();
        }
    };
    ApptFormService.prototype.callContact = function (apigClient, toSend) {
        var _this = this;
        this.logger.log('contact.service', 'callContact', toSend);
        var params = {};
        var body = toSend;
        var additionalParams = {
            headers: { 'Content-Type': 'application/json' },
            queryParams: {}
        };
        try {
            apigClient.userContactPost(params, body, additionalParams)
                .then(function (result) {
                _this.logger.log('contact.service', 'resovlve', result);
                _this.status = 'Success';
            }).catch(function (err) {
                _this.status = 'Unable to connect to the server. Your message is important to us. Please try again later.';
                _this.api.handleError(err);
            });
        }
        catch (ex) {
            this.status = 'Unable to connect to the server. Your message is important to us. Please try again later.';
        }
    };
    ApptFormService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.ApiService, shared_1.AppContext, shared_1.LogService])
    ], ApptFormService);
    return ApptFormService;
}());
exports.ApptFormService = ApptFormService;


/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"service.status !== 'Success'\" class=\"mt15\">\r\n  <div class=\"col-holder\">\r\n    <div class=\"col1of2\">\r\n      <label>From</label>\r\n      <input [class.error-input]=\"service.nameError === true\" (blur)=\"service.validateName()\" [(ngModel)]=\"service.name\" type=\"text\">\r\n      <span *ngIf=\"service.nameError\" class=\"error\">{{ service.nameErrorMessage }}</span>\r\n    </div>\r\n    <div class=\"col1of2\">\r\n      <label>E-mail</label>\r\n      <input [class.error-input]=\"service.emailError === true\" (blur)=\"service.validateEmail()\" [(ngModel)]=\"service.email\" type=\"email\">\r\n      <span *ngIf=\"service.emailError\" class=\"error\">{{ service.emailErrorMessage }}</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-holder\">\r\n    <div class=\"col1of2\">\r\n      <label>Company</label>\r\n      <input [class.error-input]=\"service.companyError === true\" (blur)=\"service.validateCompany()\" [(ngModel)]=\"service.company\" type=\"text\">\r\n      <span *ngIf=\"service.companyError\" class=\"error\">{{ service.companyErrorMessage }}</span>\r\n    </div>\r\n    <div class=\"col1of2\">\r\n      <label>Position</label>\r\n      <input [class.error-input]=\"service.positionError === true\" (blur)=\"service.validatePosition()\" [(ngModel)]=\"service.position\" type=\"text\">\r\n      <span *ngIf=\"service.positionError\" class=\"error\">{{ service.positionErrorMessage }}</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-holder\">\r\n    <div class=\"col1of2\">\r\n      <label>Telephone</label>\r\n      <input (keypress)=\"service.numeralInputMasking($event)\" [class.error-input]=\"service.telephoneError === true\" (blur)=\"service.validateTelephone()\" pattern=\"[0-9]\" [(ngModel)]=\"service.telephone\" type=\"text\">\r\n      <span *ngIf=\"service.telephoneError\" class=\"error\">{{ service.telephoneErrorMessage }}</span>\r\n    </div>\r\n    <div class=\"col1of2\">\r\n      <label>Country</label>\r\n      <input [class.error-input]=\"service.countryError === true\" (blur)=\"service.validateCountry()\" [(ngModel)]=\"service.country\" type=\"text\">\r\n      <span *ngIf=\"service.countryError\" class=\"error\">{{ service.countryErrorMessage }}</span>\r\n    </div>\r\n  </div>\r\n  <div class=\"textarea-holder\">\r\n    <label>Message</label>\r\n    <textarea [class.error-input]=\"service.messageError === true\" (blur)=\"service.validateMessage()\" [(ngModel)]=\"service.message\"></textarea>\r\n    <span *ngIf=\"service.messageError\" style=\"margin-top: -10px;\" class=\"error mb10\">{{ service.messageErrorMessage }}</span>\r\n  </div>\r\n  <input (click)=\"service.contact()\" class=\"btn\" type=\"submit\" value=\"Book Appointment\">\r\n</div>\r\n<p *ngIf=\"service.status === 'sending'\" class=\"sending-loader\">Sending<span class=\"ellipse-1\"> .</span><span class=\"ellipse-2\"> .</span><span class=\"ellipse-3\"> .</span></p>\r\n<span *ngIf=\"service.status !== 'sending'\"><p class=\"mt10\" *ngIf=\"service.status !== 'Success'\">{{ service.status }}</p></span>\r\n<p class=\"mt10\" *ngIf=\"service.status === 'Success'\"><img class=\"success-check\" src=\"../img/check-sign.svg\" onerror=\"this.onerror=null; this.src='../img/check-sign.png'\">Message sent.</p>"

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports = ".page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 200px; }\n  .page-content p + p {\n    margin-top: 10px; }\n\nlabel {\n  line-height: 26px;\n  margin-top: 5px; }\n\n.textarea-holder,\n.col1of2 {\n  margin-top: 10px;\n  padding-right: 60px; }\n\ninput[type=\"text\"],\ninput[type=\"email\"] {\n  max-width: 100%;\n  width: 100%; }\n\ninput[type=\"text\"],\ninput[type=\"email\"],\ntextarea {\n  margin-top: 0; }\n\ntextarea {\n  width: 100%;\n  min-height: 100px; }\n\n.sending-loader .ellipse-1 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseOne 2s linear infinite;\n  -webkit-animation: ellipseOne 2s linear infinite; }\n\n.sending-loader .ellipse-2 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseTwo 2s linear infinite;\n  -webkit-animation: ellipseTwo 2s linear infinite; }\n\n.sending-loader .ellipse-3 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseThree 2s linear infinite;\n  -webkit-animation: ellipseThree 2s linear infinite; }\n\n@keyframes ellipseOne {\n  0% {\n    opacity: 0; }\n  24% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseTwo {\n  0% {\n    opacity: 0; }\n  49% {\n    opacity: 0; }\n  50% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseThree {\n  0% {\n    opacity: 0; }\n  74% {\n    opacity: 0; }\n  75% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%;\n    border-top: 1px solid #e3e3e3;\n    margin-top: 25px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; } }\n\n@media only screen and (max-width: 767px) {\n  .textarea-holder {\n    padding-right: 0; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n    .page-content .page-top-content {\n      padding-top: 0; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(43);
var DatePicker = (function () {
    function DatePicker(cd, viewContainer) {
        this.changed = new core_1.EventEmitter();
        this.ninetydays = moment().add(90, 'days');
        this.minusthirtydays = moment().subtract(29, 'days');
        this.today = moment().add(1, 'days');
        this.currentDay = moment();
        cd.valueAccessor = this;
        this.cd = cd;
        this.viewContainer = viewContainer;
        this.el = viewContainer.element.nativeElement;
        this.init();
    }
    DatePicker.prototype.ngAfterViewInit = function () {
        this.initValue();
    };
    DatePicker.prototype.ngOnInit = function () {
        if (this.initDate) {
            var dateParts = this.initDate.split("-");
            this.date = moment(dateParts[2] + '.' + dateParts[1] + '.' + dateParts[0], 'DD.MM.YYYY');
        }
        else {
            this.date = moment();
        }
        this.generateCalendar(this.date);
    };
    DatePicker.prototype.openDatepicker = function () {
        this.isOpened = true;
    };
    DatePicker.prototype.closeDatepicker = function () {
        this.isOpened = false;
    };
    DatePicker.prototype.prevYear = function () {
        this.date.subtract(1, 'Y');
        this.generateCalendar(this.date);
    };
    DatePicker.prototype.prevMonth = function () {
        this.date.subtract(1, 'M');
        this.generateCalendar(this.date);
    };
    DatePicker.prototype.nextYear = function () {
        this.date.add(1, 'Y');
        this.generateCalendar(this.date);
    };
    DatePicker.prototype.nextMonth = function () {
        this.date.add(1, 'M');
        this.generateCalendar(this.date);
    };
    DatePicker.prototype.selectDate = function (e, date) {
        e.preventDefault();
        if (this.isSelected(date))
            return;
        var dateMoment = moment(date);
        var selectedDate = moment(date.day + '.' + date.month + '.' + date.year, 'DD.MM.YYYY');
        this.setValue(selectedDate);
        this.closeDatepicker();
        this.changed.emit(selectedDate.toDate());
    };
    DatePicker.prototype.generateCalendar = function (date) {
        var lastDayOfMonth = date.endOf('month').date();
        var month = date.month();
        var year = date.year();
        var n = 1;
        var firstWeekDay = null;
        var dateMoment = moment(date);
        this.dateValue = date.format('MMMM YYYY');
        this.days = [];
        if (this.firstWeekDaySunday === true) {
            firstWeekDay = date.date(2).day();
        }
        else {
            firstWeekDay = date.date(1).day();
        }
        if (firstWeekDay !== 1) {
            n -= (firstWeekDay + 6) % 7;
        }
        for (var i = n; i <= lastDayOfMonth; i += 1) {
            this.currentDay = moment(date).add(i, 'days');
            if (i > 0 && !this.currentDay.isAfter(this.ninetydays) && !this.currentDay.isBefore(this.today)) {
                this.days.push({ day: i, month: month + 1, year: year, enabled: true });
            }
            else if (i > 0 && (this.currentDay.isAfter(this.ninetydays) || this.currentDay.isBefore(this.today))) {
                this.days.push({ day: i, month: month + 1, year: year, enabled: false });
            }
            else {
                this.days.push({ day: null, month: null, year: null, enabled: false });
            }
        }
    };
    DatePicker.prototype.isSelected = function (date) {
        var selectedDate = moment(date.day + '.' + date.month + '.' + date.year, 'DD.MM.YYYY');
        return selectedDate.toDate().getTime() === this.cannonical;
    };
    DatePicker.prototype.generateDayNames = function () {
        this.dayNames = [];
        var date = this.firstWeekDaySunday === true ? moment('2015-06-07') : moment('2015-06-01');
        for (var i = 0; i < 7; i += 1) {
            this.dayNames.push(date.format('ddd'));
            date.add('1', 'd');
        }
    };
    DatePicker.prototype.initMouseEvents = function () {
        var _this = this;
        var body = document.getElementsByTagName('body')[0];
        body.addEventListener('click', function (e) {
            if (!_this.isOpened || !e.target)
                return;
            if (_this.el !== e.target && !_this.el.contains(e.target)) {
                _this.closeDatepicker();
            }
        }, false);
    };
    DatePicker.prototype.setValue = function (value) {
        var val = moment(value, this.modelFormat || 'YYYY-MM-DD');
        this.viewValue = val.format(this.viewFormat || 'Do MMMM YYYY');
        this.cd.viewToModelUpdate(val.format(this.modelFormat || 'YYYY-MM-DD'));
        this.cannonical = val.toDate().getTime();
    };
    DatePicker.prototype.initValue = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.initDate) {
                _this.setValue(moment().format(_this.modelFormat || 'YYYY-MM-DD'));
            }
            else {
                _this.setValue(moment(_this.initDate, _this.modelFormat || 'YYYY-MM-DD'));
            }
        });
    };
    DatePicker.prototype.writeValue = function (value) {
        if (!value)
            return;
        this.setValue(value);
    };
    DatePicker.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    DatePicker.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    DatePicker.prototype.init = function () {
        this.isOpened = false;
        this.firstWeekDaySunday = false;
        this.generateDayNames();
        this.initMouseEvents();
    };
    __decorate([
        core_1.Input('model-format'),
        __metadata("design:type", String)
    ], DatePicker.prototype, "modelFormat", void 0);
    __decorate([
        core_1.Input('view-format'),
        __metadata("design:type", String)
    ], DatePicker.prototype, "viewFormat", void 0);
    __decorate([
        core_1.Input('init-date'),
        __metadata("design:type", String)
    ], DatePicker.prototype, "initDate", void 0);
    __decorate([
        core_1.Input('first-week-day-sunday'),
        __metadata("design:type", Boolean)
    ], DatePicker.prototype, "firstWeekDaySunday", void 0);
    __decorate([
        core_1.Input('static'),
        __metadata("design:type", Boolean)
    ], DatePicker.prototype, "isStatic", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DatePicker.prototype, "changed", void 0);
    DatePicker = __decorate([
        core_1.Component({
            selector: 'datepicker',
            template: __webpack_require__(965),
            styles: [__webpack_require__(966)]
        }),
        __metadata("design:paramtypes", [forms_1.NgModel, core_1.ViewContainerRef])
    ], DatePicker);
    return DatePicker;
}());
exports.DatePicker = DatePicker;
/*
The MIT License (MIT)

Copyright (c) 2015 Jan Kuri

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the 'Software'), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/


/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports = "<input type=\"text\"\r\n  class=\"ng-datepicker-input\"\r\n  (focus)=\"openDatepicker()\"\r\n  [value]=\"viewValue\"\r\n  [hidden]=\"isStatic\"\r\n  readonly>\r\n\r\n<div class=\"ng-datepicker\" *ngIf=\"isStatic || isOpened\" [ngClass]=\"{ static: isStatic }\">\r\n  <div class=\"controls\">\r\n    <div class=\"left\">\r\n      <i class=\"ion-arrow-left-b prev-year-btn\" (click)=\"prevYear()\">&#9664;</i>\r\n      <i class=\"ion-arrow-left-a prev-month-btn\" (click)=\"prevMonth()\">&#9664;</i>\r\n    </div>\r\n    <span class=\"date\">\r\n      {{ dateValue }}\r\n    </span>\r\n    <div class=\"right\">\r\n      <i class=\"ion-arrow-right-a next-month-btn\" (click)=\"nextMonth()\">&#9654;</i>\r\n      <i class=\"ion-arrow-right-b next-year-btn\" (click)=\"nextYear()\">&#9654;</i>\r\n    </div>\r\n  </div>\r\n  <div class=\"day-names\">\r\n    <span *ngFor=\"let dn of dayNames\">\r\n      <span>{{ dn }}</span>\r\n    </span>\r\n  </div>\r\n  <div class=\"calendar\">\r\n    <span *ngFor=\"let d of days; let i = index\">\r\n      <span [class.disabled]=\"!d.enabled\" class=\"day day-{{d.day}}\" [ngClass]=\"{'disabled': !d.enabled, 'selected': isSelected(d)}\" (click)=\"selectDate($event, d)\">\r\n        {{ d.day }}\r\n      </span>\r\n    </span>\r\n  </div>\r\n</div>"

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports = "div {\n  font-size: 15px;\n  line-height: 19px; }\n\n.ng-datepicker-input {\n  display: block;\n  position: relative;\n  cursor: pointer;\n  background: url(../../img/calendar-icon.png), linear-gradient(to right, #ffffff, #ffffff);\n  background-repeat: NO-REPEAT;\n  background-position: 6px 50%, 100% 100%;\n  border: 1px solid #c4c4c4;\n  padding: 8px;\n  padding-left: 35px;\n  margin-bottom: 5px;\n  margin-top: 5px;\n  max-width: 100%;\n  min-width: 251px;\n  width: 100%; }\n\n.ng-datepicker {\n  border-radius: 3px;\n  position: absolute;\n  z-index: 99;\n  width: 251px;\n  background: #fff;\n  font-size: 12px;\n  color: #565a5c;\n  display: inline-block;\n  border: 1px solid #c4c4c4;\n  margin: 0;\n  padding: 0;\n  overflow: hidden; }\n\n.ng-datepicker > .controls {\n  width: 251px;\n  display: inline-block;\n  padding: 5px 0 0 0; }\n\n.ng-datepicker > .controls i {\n  font-size: 25px;\n  cursor: pointer; }\n\n.ng-datepicker > .controls > .left {\n  width: 40px;\n  display: inline-block;\n  float: left;\n  margin: 5px 0 0 3px; }\n\n.ng-datepicker > .controls > .left > i.prev-year-btn {\n  float: left;\n  display: none;\n  font-size: 14px;\n  opacity: 0.4;\n  margin: -2px 0 0 2px; }\n\n.ng-datepicker > .controls > .left > i.prev-month-btn {\n  float: left;\n  margin: -7px 0 0 5px;\n  font-style: inherit;\n  font-size: 19px;\n  color: #03A9F4; }\n\n.ng-datepicker > .controls > span.date {\n  width: 160px;\n  text-align: center;\n  font-size: 17px;\n  color: #565a5c;\n  font-weight: bold;\n  float: left;\n  padding: 0px 0 0 0; }\n\n.ng-datepicker > .controls > .right {\n  width: 40px;\n  display: inline-block;\n  float: right;\n  margin: 5px 0 0 0; }\n\n.ng-datepicker > .controls > .right > i.next-year-btn {\n  content: '>';\n  float: left;\n  display: none;\n  font-size: 14px;\n  opacity: 0.4;\n  margin: -2px 2px 0 0; }\n\n.ng-datepicker > .controls > .right > i.next-month-btn {\n  float: right;\n  font-style: inherit;\n  margin: -7px 5px 0 0;\n  font-size: 19px;\n  color: #03A9F4; }\n\n.ng-datepicker > .day-names {\n  width: 251px;\n  border-bottom: 1px solid #c4c4c4;\n  display: inline-block; }\n\n.ng-datepicker > .day-names > span {\n  width: calc(251px / 7);\n  text-align: center;\n  color: #82888a;\n  float: left;\n  display: block; }\n\n.ng-datepicker > .calendar {\n  width: 251px;\n  display: inline-block;\n  margin: -5px 0 -6px -1px;\n  padding: 0; }\n\n.ng-datepicker > .calendar > span > span.day {\n  width: calc(251px / 7);\n  height: 35px;\n  border-left: 1px solid #c4c4c4;\n  border-bottom: 1px solid #c4c4c4;\n  float: left;\n  display: block;\n  color: #565a5c;\n  text-align: center;\n  font-weight: bold;\n  line-height: 35px;\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n  cursor: pointer;\n  background: #ffffff; }\n\n.ng-datepicker > .calendar > span:last-child > span.day {\n  border-right: 1px solid #c4c4c4; }\n\n.ng-datepicker > .calendar > span:nth-child(7n) > span.day {\n  border-right: none; }\n\n.ng-datepicker > .calendar > span > span.day.disabled {\n  cursor: default;\n  pointer-events: none;\n  color: #cccccc; }\n\n.ng-datepicker > .calendar > span > span.day:hover {\n  background: #03A9F4;\n  /* rgba(0, 0, 0, 0.4);*/\n  color: #fff; }\n\n.ng-datepicker > .calendar > span > span.day.selected {\n  background: #0286c2;\n  /*rgba(0, 0, 0, 0.8);*/\n  cursor: default;\n  pointer-events: none;\n  color: #fff; }\n\n.ng-datepicker.static {\n  position: relative;\n  width: 100%;\n  box-sizing: border-box; }\n\n.ng-datepicker.static > .controls {\n  width: 100%;\n  text-align: center;\n  background-color: #eee;\n  padding: 5px 0; }\n\n.ng-datepicker.static > .controls > .left > i.prev-month-btn {\n  margin-top: -6px; }\n\n.ng-datepicker.static > .controls > span.date {\n  width: auto;\n  float: none;\n  display: inline-block;\n  padding-top: 4px; }\n\n.ng-datepicker.static > .day-names {\n  width: 100%;\n  background-color: #f9f9f9; }\n\n.ng-datepicker.static > .day-names > span {\n  width: calc(100%/7); }\n\n.ng-datepicker.static > .calendar {\n  width: 100%; }\n\n.ng-datepicker.static > .calendar > span > span.day {\n  width: calc(100%/7 - 1px);\n  height: 50px;\n  line-height: 50px; }\n"

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(2);
var ConfirmService = (function () {
    function ConfirmService(app, api, auth, user, logger, billing) {
        this.app = app;
        this.api = api;
        this.auth = auth;
        this.user = user;
        this.logger = logger;
        this.billing = billing;
        this.noEmail = false;
        this.email = '';
        this.emailError = '';
        this.password = localStorage.getItem('password') || '';
        this.passwordError = '';
        this.frontError = false;
        this.message = '';
        this.thanksAmount = '';
        this.thanksDate = '';
        this.status = '';
        this.type = '';
        this.init();
    }
    ConfirmService.prototype.init = function () {
        this.app.clear();
        if (this.app.email.trim() === '') {
            this.type = 'no-email';
        }
        else {
            this.email = this.app.email;
            this.checkIfUser(this.app.email);
        }
    };
    ConfirmService.prototype.validateEmail = function () {
        //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        //let EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*|\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
        var EMAIL_REGEXP = this.app.EMAIL_REGEXP;
        if (EMAIL_REGEXP.test(this.email)) {
            this.emailError = '';
        }
        else {
            this.frontError = true;
            this.emailError = 'Invalid Email';
        }
    };
    ConfirmService.prototype.validatePassword = function () {
        var PASSWORD_REGEXP = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).*$/;
        if (PASSWORD_REGEXP.test(this.password) && this.password.length >= 8) {
            this.passwordError = '';
        }
        else if (!PASSWORD_REGEXP.test(this.password) && this.password.length >= 8) {
            this.frontError = true;
            this.passwordError = 'Invalid Password';
        }
        else if (PASSWORD_REGEXP.test(this.password) && this.password.length < 8) {
            this.frontError = true;
            this.passwordError = 'Invalid Password';
        }
        else {
            this.frontError = true;
            this.passwordError = 'Invalid Password';
        }
    };
    ConfirmService.prototype.checkIfUser = function (email) {
        var _this = this;
        this.logger.log('confirm.service', 'checkIfUser', email);
        if (this.status !== 'confirming') {
            this.status = 'confirming';
            this.user.checkIfUser(email).then(function (result) {
                // is a user, resetting password
                _this.status = '';
                _this.type = 'forgot-password';
            }).catch(function (err) {
                // not a user, must be confirming a registration
                _this.status = '';
                _this.type = 'register';
            });
        }
    };
    ConfirmService.prototype.reset = function (email, code, password) {
        var _this = this;
        this.logger.log('confirm.service', 'reset code', code);
        if (this.status !== 'resetting') {
            this.status = 'resetting';
            this.auth.confirmPassword(email, code, password).then(function (result) {
                _this.logger.log('confirm.service', 'reset result', result);
                _this.status = 'reset';
                _this.auth.login(email, password).then(function (loginResult) {
                    _this.user.confirmUser(email).then(function (confirmResult) {
                        _this.user.getProfile();
                    });
                });
            }).catch(function (err) {
                _this.logger.log('confirm.service', 'reset error', err);
                _this.onError(err);
            });
        }
    };
    ConfirmService.prototype.confirm = function (model) {
        var _this = this;
        this.logger.log('confirm.service', 'confirm code', model.code);
        if (this.status !== 'confirming') {
            this.status = 'confirming';
            this.user.checkIfUser(model.email).then(function (result) {
                // is a user, resetting password
                _this.status = '';
                _this.type = 'forgot-password';
            }).catch(function (err) {
                // not a user, confirming a registration
                _this.auth.confirmEmail(model.code, model.email).then(function (result) {
                    // success, ask user to login
                    _this.logger.log('confirm.service', 'confirm result', result);
                    _this.status = 'confirmed';
                }).catch(function (err) {
                    // fail, prompt user to resend
                    _this.type = 'register';
                    _this.email = model.email;
                    _this.logger.log('confirm.service', 'confirm error', err);
                    _this.onError(err);
                });
            });
        }
    };
    ConfirmService.prototype.onError = function (error) {
        this.status = 'error';
        try {
            if (error.message === 'Invalid verification code provided, please try again.'
                || error.message === 'Invalid code provided, please request a code again.') {
                this.status = 'invalid';
                this.message = 'Invalid verification code provided. Please note that you must use the link in your most recent Linescape verification email. Verification codes from older emails are not valid. If you can\'t find the email, check your spam folder or re-send the code by clicking the button below.';
            }
            else if (error === 'There was a problem when we tried to send you a new email. Please try again') {
                this.status = 'invalid';
                this.message = 'There was a problem when we tried to send you a new email. Please try again';
            }
            else {
                this.status = 'invalid';
                this.message = "There was an error : " + error;
            }
        }
        catch (ex) {
            this.status = 'invalid';
            this.message = 'Invalid username and code combination provided, please request a code again.';
        }
    };
    ConfirmService.prototype.resend = function () {
        var _this = this;
        this.status = 'resending';
        this.message = '';
        this.resendVerificationCode(this.email).then(function (result) {
            _this.verificationEmailResent(result);
        }).catch(function (err) {
            _this.logger.log('confirm.service', 'resend error', err);
            _this.onError(err);
        });
    };
    ConfirmService.prototype.verificationEmailResent = function (result) {
        this.status = 'resent';
        if (!result) {
            this.onError('There was a problem when we tried to send you a new email. Please try again');
        }
        else {
            this.message = 'We sent you a new verification email.';
        }
    };
    ConfirmService.prototype.resendVerificationCode = function (email) {
        var _this = this;
        if (this.type === 'register') {
            return new Promise(function (resolve, reject) {
                _this.auth.resendVerificationEmail(email).then(function (result) {
                    resolve(result === 'SUCCESS');
                }).catch(function (err) { return reject(err); });
            });
        }
        else {
            return new Promise(function (resolve, reject) {
                _this.auth.forgotPassword(email).then(function (result) {
                    resolve(true);
                }).catch(function (err) { return reject(err); });
            });
        }
    };
    ConfirmService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [shared_1.AppContext, shared_1.ApiService, shared_1.AuthService, shared_1.UserService, shared_1.LogService,
            shared_1.BillingService])
    ], ConfirmService);
    return ConfirmService;
}());
exports.ConfirmService = ConfirmService;


/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-banner\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-banner-inner\">\r\n      <h2>Confirm Account</h2>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"main-content\">\r\n  <div class=\"wrapper main-wrapper\">\r\n    <div class=\"page-content-wrapper\">\r\n        <div class=\"page-content\">\r\n            <div class=\"col-holder\">\r\n                <div class=\"col1of2\">\r\n                    <div *ngIf=\"service.status === '' || service.status === 'error' || service.status === 'confirming'\">\r\n                        <div *ngIf=\"service.type === 'no-email'\">\r\n                            <h5>Confirm Email</h5>\r\n                            <div class=\"line-grey\"></div>\r\n                            <p>Please verify your email.</p>\r\n                            <span [class.error-input-outer]=\"service.emailError\"><input [(ngModel)]=\"service.email\" (blur)=\"service.validateEmail()\" (keyup.enter)=\"confirmEmail()\" placeholder=\"Email\" type=\"text\" /></span>\r\n                            <span *ngIf=\"service.emailError\" class=\"error\">{{ service.emailError }}</span>\r\n                            <button class=\"btn text-center\" (click)=\"confirmEmail()\">Confirm</button>\r\n                        </div>\r\n                        <div *ngIf=\"service.type === 'forgot-password'\">\r\n                            <h5>Reset Password</h5>\r\n                            <div class=\"line-grey\"></div>\r\n                            <p>Please change your password.</p>\r\n                            <input [(ngModel)]=\"service.password\" [class.error-input]=\"service.passwordError\" (blur)=\"service.validatePassword()\" (keyup.enter)=\"reset()\" title='Passwords must be at least 8 characters and contain one uppercase letter, one lowercase letter, one numeral, and one special character' placeholder=\"Password\" type=\"password\" />\r\n                            <span *ngIf=\"service.passwordError\" class=\"error\">{{ service.passwordError }}</span>\r\n                            <p *ngIf=\"service.passwordError\" class=\"error-explanation\"><em>Passwords must be at least 8 characters and contain one uppercase letter, one lowercase letter, one numeral, and one special character.</em></p>\r\n                            <button class=\"btn text-center\" (click)=\"reset()\">Reset</button>\r\n                        </div>\r\n                    </div>\r\n                    <div *ngIf=\"service.status === 'confirming'\">\r\n                        <p class=\"loader\">Confirming<span class=\"ellipse-1\"> .</span><span class=\"ellipse-2\"> .</span><span class=\"ellipse-3\"> .</span></p>\r\n                    </div>\r\n                    <div *ngIf=\"service.status === 'reset'\">\r\n                        <h5>Your Password Has Been Reset</h5>\r\n                        <div class=\"popup-line-div\"></div>\r\n                        <button (click)=\"close()\" class=\"btn text-center\">Home</button>\r\n                    </div>\r\n                    <div *ngIf=\"service.status === 'confirmed'\">\r\n                        <h5>Thank you for confirming your account!</h5>\r\n                        <div class=\"line-grey\"></div>\r\n                        <p>Please login to start enjoying your account.</p>\r\n                        <button (click)=\"login()\" class=\"btn text-center\">Login</button>\r\n                    </div>\r\n                    <div *ngIf=\"service.status === 'error' || service.status === 'invalid'\">\r\n                        <h5>Error</h5>\r\n                        <div class=\"line-grey\"></div>\r\n                        <span class=\"error\">{{ service.message }}</span>\r\n                    </div>\r\n                    <div *ngIf=\"service.status === 'invalid'\">\r\n                        <button (click)=\"service.resend()\" class=\"btn text-center\">Re-send Verification Code</button>\r\n                    </div>\r\n                    <div *ngIf=\"service.status === 'resending'\">\r\n                        <p class=\"loader\">Resending<span class=\"ellipse-1\"> .</span><span class=\"ellipse-2\"> .</span><span class=\"ellipse-3\"> .</span></p>\r\n                    </div>\r\n                    <div *ngIf=\"service.status === 'resent'\">\r\n                        <p>Your verification email has been resent. Please click the link in the email to try again.</p>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports = ".page-banner {\n  padding-top: 200px !important;\n  color: #ffffff;\n  background: url(\"../../img/background-home.jpg\");\n  background-repeat: no-repeat;\n  background-size: 100%;\n  background-position: 81% 57%; }\n  .page-banner .page-banner-inner {\n    background: #247cbd;\n    padding: 20px 60px; }\n    .page-banner .page-banner-inner h2 {\n      line-height: 40px;\n      text-transform: uppercase; }\n\n.page-content-wrapper {\n  position: relative;\n  min-height: 457px;\n  /*min-height: 2000px;*/\n  background: #ffffff;\n  overflow-x: hidden; }\n\n.page-content {\n  vertical-align: top;\n  display: inline-block;\n  padding: 20px 60px;\n  width: 100%;\n  padding-bottom: 200px; }\n  .page-content p + p {\n    margin-top: 10px; }\n  .page-content h1 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h2 {\n    margin-top: 30px;\n    margin-bottom: 20px; }\n  .page-content h3 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h4 {\n    margin-top: 25px;\n    margin-bottom: 15px; }\n  .page-content h5 {\n    margin-top: 20px;\n    margin-bottom: 15px; }\n  .page-content h6 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n  .page-content h6, .page-content h5, .page-content h4, .page-content h3, .page-content h2, .page-content h1 {\n    color: #7f56db; }\n  .page-content .page-top-content {\n    padding-top: 20px;\n    font-size: 20px;\n    border-bottom: 1px solid #e9e9e9;\n    padding-bottom: 30px;\n    margin-bottom: 30px; }\n  .page-content .page-content-left {\n    display: inline-block;\n    width: calc(100% - 270px);\n    padding-right: 50px;\n    vertical-align: top; }\n    .page-content .page-content-left p, .page-content .page-content-left li, .page-content .page-content-left div, .page-content .page-content-left label {\n      font-size: 16px;\n      line-height: 24px; }\n  .page-content .page-content-sidebar-right {\n    display: inline-block;\n    width: 270px;\n    vertical-align: top; }\n    .page-content .page-content-sidebar-right p, .page-content .page-content-sidebar-right li, .page-content .page-content-sidebar-right div, .page-content .page-content-sidebar-right .btn, .page-content .page-content-sidebar-right label {\n      font-size: 16px;\n      line-height: 24px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 70px; }\n    .page-content .page-content-sidebar-right .sidebar-section:first-of-type {\n      margin-top: 0; }\n\np {\n  text-align: left;\n  line-height: 24px; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput,\n.btn {\n  width: 100%; }\n\nselect {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  font-size: 16px;\n  text-align: left;\n  margin-top: 10px; }\n\n.loader .ellipse-1 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseOne 2s linear infinite;\n  -webkit-animation: ellipseOne 2s linear infinite; }\n\n.loader .ellipse-2 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseTwo 2s linear infinite;\n  -webkit-animation: ellipseTwo 2s linear infinite; }\n\n.loader .ellipse-3 {\n  opacity: 0;\n  transition: opacity .1s linear;\n  animation: ellipseThree 2s linear infinite;\n  -webkit-animation: ellipseThree 2s linear infinite; }\n\n@keyframes ellipseOne {\n  0% {\n    opacity: 0; }\n  24% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseTwo {\n  0% {\n    opacity: 0; }\n  49% {\n    opacity: 0; }\n  50% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes ellipseThree {\n  0% {\n    opacity: 0; }\n  74% {\n    opacity: 0; }\n  75% {\n    opacity: 1; }\n  99% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@media only screen and (max-width: 980px) {\n  .page-content .page-content-left {\n    display: inline-block;\n    width: 100%;\n    padding-right: 0; }\n  .page-content .page-content-sidebar-right {\n    width: 100%;\n    border-top: 1px solid #e3e3e3;\n    margin-top: 25px; }\n    .page-content .page-content-sidebar-right .sidebar-section {\n      margin-top: 0; } }\n\n@media only screen and (max-width: 699px) {\n  .page-content {\n    padding-left: 15px;\n    padding-right: 15px; }\n    .page-content .page-top-content {\n      padding-top: 0; }\n  .page-banner .page-banner-inner {\n    padding: 15px 15px 15px 15px; } }\n\n@media only screen and (max-width: 399px) {\n  .main-wrapper {\n    padding-left: 0;\n    padding-right: 0; } }\n"

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ng5SliderModule", function() { return Ng5SliderModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangeContext", function() { return ChangeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PointerType", function() { return PointerType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LabelType", function() { return LabelType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Options", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵo", function() { return JqLiteWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi", function() { return CeilLabDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵl", function() { return CmbLabDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵh", function() { return FlrLabDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function() { return FullBarDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function() { return LeftOutSelDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵg", function() { return MaxHDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵk", function() { return MaxLabDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf", function() { return MinHDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵj", function() { return MinLabDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return RightOutSelDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function() { return SelBarDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵn", function() { return SliderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return SliderElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵm", function() { return TicksDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵp", function() { return TooltipWrapperComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(17);




var LabelType = {
    Low: 0,
    High: 1,
    Floor: 2,
    Ceil: 3,
    TickValue: 4,
};
LabelType[LabelType.Low] = "Low";
LabelType[LabelType.High] = "High";
LabelType[LabelType.Floor] = "Floor";
LabelType[LabelType.Ceil] = "Ceil";
LabelType[LabelType.TickValue] = "TickValue";
var Options = (function () {
    function Options() {
        this.floor = 0;
        this.ceil = null;
        this.step = 1;
        this.minRange = null;
        this.maxRange = null;
        this.pushRange = false;
        this.minLimit = null;
        this.maxLimit = null;
        this.translate = null;
        this.combineLabels = null;
        this.getLegend = null;
        this.stepsArray = null;
        this.bindIndexForStepsArray = false;
        this.draggableRange = false;
        this.draggableRangeOnly = false;
        this.showSelectionBar = false;
        this.showSelectionBarEnd = false;
        this.showSelectionBarFromValue = null;
        this.showOuterSelectionBars = false;
        this.hidePointerLabels = false;
        this.hideLimitLabels = false;
        this.autoHideLimitLabels = true;
        this.readOnly = false;
        this.disabled = false;
        this.interval = 350;
        this.showTicks = false;
        this.showTicksValues = false;
        this.tickStep = null;
        this.tickValueStep = 1;
        this.ticksArray = null;
        this.ticksTooltip = null;
        this.ticksValuesTooltip = null;
        this.vertical = false;
        this.getSelectionBarColor = null;
        this.getTickColor = null;
        this.getPointerColor = null;
        this.keyboardSupport = true;
        this.scale = 1;
        this.enforceStep = true;
        this.enforceRange = false;
        this.noSwitching = false;
        this.onlyBindHandles = false;
        this.rightToLeft = false;
        this.reversedControls = false;
        this.boundPointerLabels = true;
        this.logScale = false;
        this.customValueToPosition = null;
        this.customPositionToValue = null;
        this.precisionLimit = 12;
        this.selectionBarGradient = null;
        this.ariaLabel = null;
        this.ariaLabelledBy = null;
        this.ariaLabelHigh = null;
        this.ariaLabelledByHigh = null;
    }
    return Options;
}());
var PointerType = {
    Min: 0,
    Max: 1,
};
PointerType[PointerType.Min] = "Min";
PointerType[PointerType.Max] = "Max";
var ChangeContext = (function () {
    function ChangeContext() {
    }
    return ChangeContext;
}());
var ValueHelper = (function () {
    function ValueHelper() {
    }
    ValueHelper.linearValueToPosition = function (val, minVal, maxVal) {
        var range = maxVal - minVal;
        return (val - minVal) / range;
    };
    ValueHelper.logValueToPosition = function (val, minVal, maxVal) {
        val = Math.log(val);
        minVal = Math.log(minVal);
        maxVal = Math.log(maxVal);
        var range = maxVal - minVal;
        return (val - minVal) / range;
    };
    ValueHelper.linearPositionToValue = function (percent, minVal, maxVal) {
        return percent * (maxVal - minVal) + minVal;
    };
    ValueHelper.logPositionToValue = function (percent, minVal, maxVal) {
        minVal = Math.log(minVal);
        maxVal = Math.log(maxVal);
        var value = percent * (maxVal - minVal) + minVal;
        return Math.exp(value);
    };
    ValueHelper.findStepIndex = function (modelValue, stepsArray) {
        var differences = stepsArray.map(function (step) { return Math.abs(modelValue - step.value); });
        var minDifferenceIndex = 0;
        for (var index = 0; index < stepsArray.length; index++) {
            if (differences[index] !== differences[minDifferenceIndex] && differences[index] < differences[minDifferenceIndex]) {
                minDifferenceIndex = index;
            }
        }
        return minDifferenceIndex;
    };
    return ValueHelper;
}());
var JqLiteWrapper = (function () {
    function JqLiteWrapper(elemRef, renderer) {
        this.elemRef = elemRef;
        this.renderer = renderer;
        this.eventListeners = {};
    }
    JqLiteWrapper.prototype.addClass = function (clazz) {
        this.renderer.addClass(this.elemRef.nativeElement, clazz);
    };
    JqLiteWrapper.prototype.removeClass = function (clazz) {
        this.renderer.removeClass(this.elemRef.nativeElement, clazz);
    };
    JqLiteWrapper.prototype.hasClass = function (clazz) {
        return this.elemRef.nativeElement.classList.contains(clazz);
    };
    JqLiteWrapper.prototype.html = function (html) {
        this.elemRef.nativeElement.innerHTML = html;
    };
    JqLiteWrapper.prototype.css = function (style, value) {
        if (value !== '') {
            this.renderer.setStyle(this.elemRef.nativeElement, style, value);
        }
        else {
            this.renderer.removeStyle(this.elemRef.nativeElement, style);
        }
    };
    JqLiteWrapper.prototype.attr = function (attr, value) {
        if (value !== null) {
            this.renderer.setAttribute(this.elemRef.nativeElement, attr, value);
        }
        else {
            this.renderer.removeAttribute(this.elemRef.nativeElement, attr);
        }
    };
    JqLiteWrapper.prototype.getBoundingClientRect = function () {
        return this.elemRef.nativeElement.getBoundingClientRect();
    };
    JqLiteWrapper.prototype.focus = function () {
        this.elemRef.nativeElement.focus();
    };
    JqLiteWrapper.prototype.on = function (eventName, callback) {
        if (!this.eventListeners.hasOwnProperty(eventName)) {
            this.eventListeners[eventName] = ([]);
        }
        var unsubscribe = this.renderer.listen(this.elemRef.nativeElement, eventName, callback);
        this.eventListeners[eventName].push(unsubscribe);
    };
    JqLiteWrapper.prototype.off = function (eventName) {
        if (eventName) {
            if (this.eventListeners.hasOwnProperty(eventName)) {
                try {
                    for (var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __values */])(this.eventListeners[eventName]), _b = _a.next(); !_b.done; _b = _a.next()) {
                        var unsubscribe = _b.value;
                        unsubscribe();
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                delete this.eventListeners[eventName];
            }
        }
        else {
            try {
                for (var _d = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __values */])(Object.keys(this.eventListeners)), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var eName = _e.value;
                    this.off(eName);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_f = _d.return)) _f.call(_d);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        var e_1, _c, e_2, _f;
    };
    return JqLiteWrapper;
}());
var ThrottledFunc = (function () {
    function ThrottledFunc(func, wait) {
        this.previous = 0;
        this.timeout = null;
        this.func = func;
        this.wait = wait;
    }
    ThrottledFunc.prototype.call = function () {
        var _this = this;
        var now = this.getTime();
        var remaining = this.wait - (now - this.previous);
        if (remaining <= 0) {
            clearTimeout(this.timeout);
            this.timeout = null;
            this.previous = now;
            this.func();
        }
        else if (this.timeout === null) {
            this.timeout = setTimeout(function () { return _this.callLater(); }, remaining);
        }
    };
    ThrottledFunc.prototype.getTime = function () {
        return Date.now();
    };
    ThrottledFunc.prototype.callLater = function () {
        this.previous = this.getTime();
        this.timeout = null;
        this.func();
    };
    return ThrottledFunc;
}());
var CompatibilityHelper = (function () {
    function CompatibilityHelper() {
    }
    CompatibilityHelper.isTouchEvent = function (event) {
        if (((window)).TouchEvent !== undefined) {
            return event instanceof TouchEvent;
        }
        return event.touches !== undefined;
    };
    return CompatibilityHelper;
}());
var MathHelper = (function () {
    function MathHelper() {
    }
    MathHelper.roundToPrecisionLimit = function (value, precisionLimit) {
        return +(value.toPrecision(precisionLimit));
    };
    return MathHelper;
}());
var Tick = (function () {
    function Tick() {
    }
    return Tick;
}());
var Dragging = (function () {
    function Dragging() {
        this.active = false;
        this.value = 0;
        this.difference = 0;
        this.position = 0;
        this.lowLimit = 0;
        this.highLimit = 0;
    }
    return Dragging;
}());
var HandleType = {
    Low: 0,
    High: 1,
};
HandleType[HandleType.Low] = "Low";
HandleType[HandleType.High] = "High";
var HandleLabelType = {
    Min: 0,
    Max: 1,
};
HandleLabelType[HandleLabelType.Min] = "Min";
HandleLabelType[HandleLabelType.Max] = "Max";
var SliderElement = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(SliderElement, _super);
    function SliderElement(elemRef, renderer) {
        var _this = _super.call(this, elemRef, renderer) || this;
        _this.position = 0;
        _this.alwaysHide = false;
        return _this;
    }
    return SliderElement;
}(JqLiteWrapper));
var RightOutSelDirective = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(RightOutSelDirective, _super);
    function RightOutSelDirective(elemRef, renderer) {
        return _super.call(this, elemRef, renderer) || this;
    }
    return RightOutSelDirective;
}(SliderElement));
RightOutSelDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ng5SliderRightOutSelElem]' },] },
];
RightOutSelDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
]; };
var LeftOutSelDirective = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(LeftOutSelDirective, _super);
    function LeftOutSelDirective(elemRef, renderer) {
        return _super.call(this, elemRef, renderer) || this;
    }
    return LeftOutSelDirective;
}(SliderElement));
LeftOutSelDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ng5SliderLeftOutSelElem]' },] },
];
LeftOutSelDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
]; };
var FullBarDirective = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FullBarDirective, _super);
    function FullBarDirective(elemRef, renderer) {
        return _super.call(this, elemRef, renderer) || this;
    }
    return FullBarDirective;
}(SliderElement));
FullBarDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ng5SliderFullBarElem]' },] },
];
FullBarDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
]; };
var SelBarDirective = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(SelBarDirective, _super);
    function SelBarDirective(elemRef, renderer) {
        return _super.call(this, elemRef, renderer) || this;
    }
    return SelBarDirective;
}(SliderElement));
SelBarDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ng5SliderSelBarElem]' },] },
];
SelBarDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
]; };
var MinHDirective = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MinHDirective, _super);
    function MinHDirective(elemRef, renderer) {
        return _super.call(this, elemRef, renderer) || this;
    }
    return MinHDirective;
}(SliderElement));
MinHDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ng5SliderMinHElem]' },] },
];
MinHDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
]; };
var MaxHDirective = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MaxHDirective, _super);
    function MaxHDirective(elemRef, renderer) {
        return _super.call(this, elemRef, renderer) || this;
    }
    return MaxHDirective;
}(SliderElement));
MaxHDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ng5SliderMaxHElem]' },] },
];
MaxHDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
]; };
var FlrLabDirective = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FlrLabDirective, _super);
    function FlrLabDirective(elemRef, renderer) {
        return _super.call(this, elemRef, renderer) || this;
    }
    return FlrLabDirective;
}(SliderElement));
FlrLabDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ng5SliderFlrLabElem]' },] },
];
FlrLabDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
]; };
var CeilLabDirective = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CeilLabDirective, _super);
    function CeilLabDirective(elemRef, renderer) {
        return _super.call(this, elemRef, renderer) || this;
    }
    return CeilLabDirective;
}(SliderElement));
CeilLabDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ng5SliderCeilLabElem]' },] },
];
CeilLabDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
]; };
var MinLabDirective = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MinLabDirective, _super);
    function MinLabDirective(elemRef, renderer) {
        return _super.call(this, elemRef, renderer) || this;
    }
    return MinLabDirective;
}(SliderElement));
MinLabDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ng5SliderMinLabElem]' },] },
];
MinLabDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
]; };
var MaxLabDirective = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MaxLabDirective, _super);
    function MaxLabDirective(elemRef, renderer) {
        return _super.call(this, elemRef, renderer) || this;
    }
    return MaxLabDirective;
}(SliderElement));
MaxLabDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ng5SliderMaxLabElem]' },] },
];
MaxLabDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
]; };
var CmbLabDirective = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CmbLabDirective, _super);
    function CmbLabDirective(elemRef, renderer) {
        return _super.call(this, elemRef, renderer) || this;
    }
    return CmbLabDirective;
}(SliderElement));
CmbLabDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ng5SliderCmbLabElem]' },] },
];
CmbLabDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
]; };
var TicksDirective = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(TicksDirective, _super);
    function TicksDirective(elemRef, renderer) {
        return _super.call(this, elemRef, renderer) || this;
    }
    return TicksDirective;
}(SliderElement));
TicksDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: '[ng5SliderTicksElem]' },] },
];
TicksDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
]; };
var SliderComponent = (function () {
    function SliderComponent(renderer, elementRef, changeDetectionRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.changeDetectionRef = changeDetectionRef;
        this.valueChange = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.highValueChange = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.userChangeStart = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.userChange = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.userChangeEnd = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this._options = new Options();
        this.viewOptions = new Options();
        this.barStyle = {};
        this.minPointerStyle = {};
        this.maxPointerStyle = {};
        this.showTicks = false;
        this.ticks = [];
        this.sliderElementVerticalClass = false;
        this.sliderElementDisabledAttr = null;
        this.sliderElementPosition = 0;
        this.dragging = new Dragging();
        this.handleHalfDim = 0;
        this.maxPos = 0;
        this.precisionLimit = 12;
        this.step = 1;
        this.tracking = null;
        this.minValue = 0;
        this.maxValue = 0;
        this.valueRange = 0;
        this.intermediateTicks = false;
        this.initHasRun = false;
        this.firstKeyDown = false;
        this.internalChange = false;
        this.cmbLabelShown = false;
        this.currentFocusElement = null;
        this.onMoveUnsubscribe = null;
        this.onEndUnsubscribe = null;
    }
    Object.defineProperty(SliderComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (newValue) {
            var oldValue = this._value;
            this._value = newValue;
            this.onChangeValue(oldValue, newValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "highValue", {
        get: function () {
            return this._highValue;
        },
        set: function (newHighValue) {
            var oldHighValue = this._highValue;
            this._highValue = newHighValue;
            this.onChangeHighValue(oldHighValue, newHighValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "options", {
        get: function () {
            return this._options;
        },
        set: function (newOptions) {
            var oldOptions = this._options;
            this._options = newOptions;
            this.onChangeOptions(oldOptions, newOptions);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "manualRefresh", {
        set: function (manualRefresh) {
            var _this = this;
            this.unsubscribeManualRefresh();
            this.manualRefreshSubscription = manualRefresh.subscribe(function () {
                setTimeout(function () { return _this.calcViewDimensions(); });
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "range", {
        get: function () {
            return this.value !== undefined && this.highValue !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    SliderComponent.prototype.ngOnInit = function () {
        this.viewOptions = new Options();
        Object.assign(this.viewOptions, this.options);
        this.setDisabledState();
        this.setVerticalClass();
    };
    SliderComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.thrOnLowHandleChange = new ThrottledFunc(function () { _this.onLowHandleChange(); }, this.viewOptions.interval);
        this.thrOnHighHandleChange = new ThrottledFunc(function () { _this.onHighHandleChange(); }, this.viewOptions.interval);
        this.applyOptions();
        this.syncLowValue();
        if (this.range) {
            this.syncHighValue();
        }
        this.manageElementsStyle();
        this.setDisabledState();
        this.calcViewDimensions();
        this.setMinAndMax();
        this.addAccessibility();
        this.updateCeilLab();
        this.updateFloorLab();
        this.initHandles();
        this.manageEventsBindings();
        this.initHasRun = true;
        if (this.value !== this.viewLowValue || (this.range && this.highValue !== this.viewHighValue)) {
            setTimeout(function () { return _this.applyModel(false); });
        }
        this.changeDetectionRef.detectChanges();
    };
    SliderComponent.prototype.onChangeOptions = function (oldValue, newValue) {
        if (!this.initHasRun || newValue === oldValue) {
            return;
        }
        this.applyOptions();
        this.syncLowValue();
        if (this.range) {
            this.syncHighValue();
        }
        this.resetSlider();
    };
    SliderComponent.prototype.onChangeValue = function (oldValue, newValue) {
        if (!this.initHasRun || this.internalChange || newValue === oldValue) {
            return;
        }
        this.thrOnLowHandleChange.call();
    };
    SliderComponent.prototype.onChangeHighValue = function (oldValue, newValue) {
        if (!this.initHasRun || this.internalChange || newValue === oldValue) {
            return;
        }
        if (newValue != null) {
            this.thrOnHighHandleChange.call();
        }
        if ((this.range && newValue == null) ||
            (!this.range && newValue != null)) {
            this.applyOptions();
            this.resetSlider();
        }
    };
    SliderComponent.prototype.onResize = function (event) {
        this.calcViewDimensions();
    };
    SliderComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeManualRefresh();
        this.unbindEvents();
        this.currentFocusElement = null;
    };
    SliderComponent.prototype.unsubscribeManualRefresh = function () {
        if (this.manualRefreshSubscription) {
            this.manualRefreshSubscription.unsubscribe();
            this.manualRefreshSubscription = null;
        }
    };
    SliderComponent.prototype.getCurrentTrackingValue = function () {
        if (this.tracking === null) {
            return null;
        }
        return this.tracking === HandleType.Low ? this.viewLowValue : this.viewHighValue;
    };
    SliderComponent.prototype.syncLowValue = function () {
        if (this.viewOptions.stepsArray) {
            if (!this.viewOptions.bindIndexForStepsArray) {
                this.viewLowValue = ValueHelper.findStepIndex(this.value, this.viewOptions.stepsArray);
            }
            else {
                this.viewLowValue = this.value;
            }
        }
        else {
            this.viewLowValue = this.value;
        }
    };
    SliderComponent.prototype.syncHighValue = function () {
        if (this.viewOptions.stepsArray) {
            if (!this.viewOptions.bindIndexForStepsArray) {
                this.viewHighValue = ValueHelper.findStepIndex(this.highValue, this.viewOptions.stepsArray);
            }
            else {
                this.viewHighValue = this.highValue;
            }
        }
        else {
            this.viewHighValue = this.highValue;
        }
    };
    SliderComponent.prototype.getStepValue = function (sliderValue) {
        var step = this.viewOptions.stepsArray[sliderValue];
        return step.value;
    };
    SliderComponent.prototype.applyLowValue = function () {
        this.internalChange = true;
        if (this.viewOptions.stepsArray) {
            if (!this.viewOptions.bindIndexForStepsArray) {
                this.value = this.getStepValue(this.viewLowValue);
            }
            else {
                this.value = this.viewLowValue;
            }
        }
        else {
            this.value = this.viewLowValue;
        }
        this.internalChange = false;
    };
    SliderComponent.prototype.applyHighValue = function () {
        this.internalChange = true;
        if (this.viewOptions.stepsArray) {
            if (!this.viewOptions.bindIndexForStepsArray) {
                this.highValue = this.getStepValue(this.viewHighValue);
            }
            else {
                this.highValue = this.viewHighValue;
            }
        }
        else {
            this.highValue = this.viewHighValue;
        }
        this.internalChange = false;
    };
    SliderComponent.prototype.onLowHandleChange = function () {
        this.syncLowValue();
        if (this.range) {
            this.syncHighValue();
        }
        this.setMinAndMax();
        this.updateLowHandle(this.valueToPosition(this.viewLowValue));
        this.updateSelectionBar();
        this.updateTicksScale();
        this.updateAriaAttributes();
        if (this.range) {
            this.updateCmbLabel();
        }
    };
    SliderComponent.prototype.onHighHandleChange = function () {
        this.syncLowValue();
        this.syncHighValue();
        this.setMinAndMax();
        this.updateHighHandle(this.valueToPosition(this.viewHighValue));
        this.updateSelectionBar();
        this.updateTicksScale();
        this.updateCmbLabel();
        this.updateAriaAttributes();
    };
    SliderComponent.prototype.applyOptions = function () {
        this.viewOptions = new Options();
        Object.assign(this.viewOptions, this.options);
        if (this.viewOptions.precisionLimit) {
            this.precisionLimit = this.viewOptions.precisionLimit;
        }
        if (this.viewOptions.step <= 0) {
            this.viewOptions.step = 1;
        }
        this.viewOptions.draggableRange = this.range && this.viewOptions.draggableRange;
        this.viewOptions.draggableRangeOnly = this.range && this.viewOptions.draggableRangeOnly;
        if (this.viewOptions.draggableRangeOnly) {
            this.viewOptions.draggableRange = true;
        }
        this.viewOptions.showTicks = this.viewOptions.showTicks ||
            this.viewOptions.showTicksValues ||
            !!this.viewOptions.ticksArray;
        if (this.viewOptions.showTicks && (this.viewOptions.tickStep !== null || this.viewOptions.ticksArray)) {
            this.intermediateTicks = true;
        }
        this.showTicks = this.viewOptions.showTicks;
        this.viewOptions.showSelectionBar = this.viewOptions.showSelectionBar ||
            this.viewOptions.showSelectionBarEnd ||
            this.viewOptions.showSelectionBarFromValue !== null;
        if (this.viewOptions.stepsArray) {
            this.parseStepsArray();
        }
        else {
            if (this.viewOptions.translate) {
                this.translate = this.viewOptions.translate;
            }
            else {
                this.translate = function (value) { return String(value); };
            }
            this.getLegend = this.viewOptions.getLegend;
        }
        if (this.viewOptions.combineLabels) {
            this.combineLabels = this.viewOptions.combineLabels;
        }
        else {
            this.combineLabels = function (minValue, maxValue) {
                return minValue + ' - ' + maxValue;
            };
        }
    };
    SliderComponent.prototype.parseStepsArray = function () {
        var _this = this;
        this.viewOptions.floor = 0;
        this.viewOptions.ceil = this.viewOptions.stepsArray.length - 1;
        this.viewOptions.step = 1;
        if (this.viewOptions.translate) {
            this.translate = this.viewOptions.translate;
        }
        else {
            this.translate = function (modelValue) {
                if (_this.viewOptions.bindIndexForStepsArray) {
                    return String(_this.getStepValue(modelValue));
                }
                return String(modelValue);
            };
        }
        this.getLegend = function (index) {
            var step = _this.viewOptions.stepsArray[index];
            return step.legend;
        };
    };
    SliderComponent.prototype.resetSlider = function () {
        this.manageElementsStyle();
        this.addAccessibility();
        this.setMinAndMax();
        this.updateCeilLab();
        this.updateFloorLab();
        this.unbindEvents();
        this.manageEventsBindings();
        this.setDisabledState();
        this.calcViewDimensions();
        this.refocusPointerIfNeeded();
    };
    SliderComponent.prototype.refocusPointerIfNeeded = function () {
        if (this.currentFocusElement) {
            this.onPointerFocus(this.currentFocusElement.pointer, this.currentFocusElement.ref);
            this.focusElement(this.currentFocusElement.pointer);
        }
    };
    SliderComponent.prototype.manageElementsStyle = function () {
        var _this = this;
        if (!this.range) {
            this.maxHElem.css('display', 'none');
        }
        else {
            this.maxHElem.css('display', '');
        }
        this.alwaysHide(this.flrLabElem, this.viewOptions.showTicksValues || this.viewOptions.hideLimitLabels);
        this.alwaysHide(this.ceilLabElem, this.viewOptions.showTicksValues || this.viewOptions.hideLimitLabels);
        var hideLabelsForTicks = this.viewOptions.showTicksValues && !this.intermediateTicks;
        this.alwaysHide(this.minLabElem, hideLabelsForTicks || this.viewOptions.hidePointerLabels);
        this.alwaysHide(this.maxLabElem, hideLabelsForTicks || !this.range || this.viewOptions.hidePointerLabels);
        this.alwaysHide(this.cmbLabElem, hideLabelsForTicks || !this.range || this.viewOptions.hidePointerLabels);
        this.alwaysHide(this.selBarElem, !this.range && !this.viewOptions.showSelectionBar);
        this.alwaysHide(this.leftOutSelBar, !this.range || !this.viewOptions.showOuterSelectionBars);
        this.alwaysHide(this.rightOutSelBar, !this.range || !this.viewOptions.showOuterSelectionBars);
        if (this.range && this.viewOptions.showOuterSelectionBars) {
            this.fullBarElem.addClass('ng5-slider-transparent');
        }
        if (this.sliderElementVerticalClass !== this.viewOptions.vertical) {
            this.setVerticalClass();
            setTimeout(function () { _this.resetSlider(); });
        }
        if (this.viewOptions.draggableRange) {
            this.selBarElem.addClass('ng5-slider-draggable');
        }
        else {
            this.selBarElem.removeClass('ng5-slider-draggable');
        }
        if (this.intermediateTicks && this.options.showTicksValues) {
            this.ticksElem.addClass('ng5-slider-ticks-values-under');
        }
    };
    SliderComponent.prototype.alwaysHide = function (el, hide) {
        el.alwaysHide = hide;
        if (hide) {
            this.hideEl(el);
        }
        else {
            this.showEl(el);
        }
    };
    SliderComponent.prototype.manageEventsBindings = function () {
        if (this.viewOptions.disabled || this.viewOptions.readOnly) {
            this.unbindEvents();
        }
        else {
            this.bindEvents();
        }
    };
    SliderComponent.prototype.setDisabledState = function () {
        this.sliderElementDisabledAttr = this.viewOptions.disabled ? 'disabled' : null;
    };
    SliderComponent.prototype.setVerticalClass = function () {
        this.sliderElementVerticalClass = this.viewOptions.vertical;
    };
    SliderComponent.prototype.resetLabelsValue = function () {
        this.minLabElem.value = undefined;
        this.maxLabElem.value = undefined;
    };
    SliderComponent.prototype.initHandles = function () {
        this.updateLowHandle(this.valueToPosition(this.viewLowValue));
        if (this.range) {
            this.updateHighHandle(this.valueToPosition(this.viewHighValue));
        }
        this.updateSelectionBar();
        if (this.range) {
            this.updateCmbLabel();
        }
        this.updateTicksScale();
    };
    SliderComponent.prototype.setLabelValue = function (value, label) {
        var recalculateDimension = false;
        var noLabelInjection = label.hasClass('no-label-injection');
        if (label.value === undefined ||
            label.value.length !== value.length ||
            (label.value.length > 0 && label.dimension === 0)) {
            recalculateDimension = true;
            label.value = value;
        }
        if (!noLabelInjection) {
            label.html(value);
        }
        if (recalculateDimension) {
            this.calculateElementDimension(label);
        }
    };
    SliderComponent.prototype.setMinAndMax = function () {
        this.step = +this.viewOptions.step;
        this.minValue = this.viewOptions.floor;
        if (this.viewOptions.logScale && this.minValue === 0) {
            throw Error('Can\'t use floor=0 with logarithmic scale');
        }
        if (this.viewOptions.enforceStep) {
            this.viewLowValue = this.roundStep(this.viewLowValue);
            if (this.range) {
                this.viewHighValue = this.roundStep(this.viewHighValue);
            }
        }
        if (this.viewOptions.ceil != null) {
            this.maxValue = this.viewOptions.ceil;
        }
        else {
            this.maxValue = this.viewOptions.ceil = this.range ? this.viewHighValue : this.viewLowValue;
        }
        if (this.viewOptions.enforceRange) {
            this.viewLowValue = this.sanitizeValue(this.viewLowValue);
            if (this.range) {
                this.viewHighValue = this.sanitizeValue(this.viewHighValue);
            }
        }
        this.applyLowValue();
        if (this.range) {
            this.applyHighValue();
        }
        this.valueRange = this.maxValue - this.minValue;
    };
    SliderComponent.prototype.addAccessibility = function () {
        this.updateAriaAttributes();
        this.minHElem.attr('role', 'slider');
        if (this.viewOptions.keyboardSupport &&
            !(this.viewOptions.readOnly || this.viewOptions.disabled)) {
            this.minHElem.attr('tabindex', '0');
        }
        else {
            this.minHElem.attr('tabindex', '');
        }
        if (this.viewOptions.vertical) {
            this.minHElem.attr('aria-orientation', 'vertical');
        }
        if (this.viewOptions.ariaLabel) {
            this.minHElem.attr('aria-label', this.viewOptions.ariaLabel);
        }
        else if (this.viewOptions.ariaLabelledBy) {
            this.minHElem.attr('aria-labelledby', this.viewOptions.ariaLabelledBy);
        }
        if (this.range) {
            this.maxHElem.attr('role', 'slider');
            if (this.viewOptions.keyboardSupport &&
                !(this.viewOptions.readOnly || this.viewOptions.disabled)) {
                this.maxHElem.attr('tabindex', '0');
            }
            else {
                this.maxHElem.attr('tabindex', '');
            }
            if (this.viewOptions.vertical) {
                this.maxHElem.attr('aria-orientation', 'vertical');
            }
            if (this.viewOptions.ariaLabelHigh) {
                this.maxHElem.attr('aria-label', this.viewOptions.ariaLabelHigh);
            }
            else if (this.viewOptions.ariaLabelledByHigh) {
                this.maxHElem.attr('aria-labelledby', this.viewOptions.ariaLabelledByHigh);
            }
        }
    };
    SliderComponent.prototype.updateAriaAttributes = function () {
        this.minHElem.attr('aria-valuenow', this.value.toString());
        this.minHElem.attr('aria-valuetext', this.translate(this.value, LabelType.Low));
        this.minHElem.attr('aria-valuemin', this.minValue.toString());
        this.minHElem.attr('aria-valuemax', this.maxValue.toString());
        if (this.range) {
            this.maxHElem.attr('aria-valuenow', this.highValue.toString());
            this.maxHElem.attr('aria-valuetext', this.translate(this.highValue, LabelType.High));
            this.maxHElem.attr('aria-valuemin', this.minValue.toString());
            this.maxHElem.attr('aria-valuemax', this.maxValue.toString());
        }
    };
    SliderComponent.prototype.calcViewDimensions = function () {
        this.calculateElementDimension(this.minHElem);
        var handleWidth = this.minHElem.dimension;
        this.handleHalfDim = handleWidth / 2;
        this.calculateElementDimension(this.fullBarElem);
        this.barDimension = this.fullBarElem.dimension;
        this.maxPos = this.barDimension - handleWidth;
        var sliderElementBoundingRect = this.elementRef.nativeElement.getBoundingClientRect();
        this.sliderElementPosition = this.viewOptions.vertical ?
            sliderElementBoundingRect.bottom : sliderElementBoundingRect.left;
        if (this.initHasRun) {
            this.updateFloorLab();
            this.updateCeilLab();
            this.initHandles();
        }
    };
    SliderComponent.prototype.updateTicksScale = function () {
        var _this = this;
        if (!this.viewOptions.showTicks) {
            return;
        }
        var ticksArray = this.viewOptions.ticksArray || this.getTicksArray();
        var translate = this.viewOptions.vertical ? 'translateY' : 'translateX';
        if (this.viewOptions.rightToLeft) {
            ticksArray.reverse();
        }
        this.ticks = ticksArray.map(function (value) {
            var position = _this.valueToPosition(value);
            if (_this.viewOptions.vertical) {
                position = _this.maxPos - position;
            }
            var translation = translate + '(' + Math.round(position) + 'px)';
            var tick = new Tick();
            tick.selected = _this.isTickSelected(value);
            tick.style = {
                '-webkit-transform': translation,
                '-moz-transform': translation,
                '-o-transform': translation,
                '-ms-transform': translation,
                transform: translation,
            };
            if (tick.selected && _this.viewOptions.getSelectionBarColor) {
                tick.style['background-color'] = _this.getSelectionBarColor();
            }
            if (!tick.selected && _this.viewOptions.getTickColor) {
                tick.style['background-color'] = _this.getTickColor(value);
            }
            if (_this.viewOptions.ticksTooltip) {
                tick.tooltip = _this.viewOptions.ticksTooltip(value);
                tick.tooltipPlacement = _this.viewOptions.vertical ? 'right' : 'top';
            }
            if (_this.viewOptions.showTicksValues && (value % _this.viewOptions.tickValueStep === 0)) {
                tick.value = _this.getDisplayValue(value, LabelType.TickValue);
                if (_this.viewOptions.ticksValuesTooltip) {
                    tick.valueTooltip = _this.viewOptions.ticksValuesTooltip(value);
                    tick.valueTooltipPlacement = _this.viewOptions.vertical
                        ? 'right'
                        : 'top';
                }
            }
            if (_this.getLegend) {
                var legend = _this.getLegend(value);
                if (legend) {
                    tick.legend = legend;
                }
            }
            return tick;
        });
    };
    SliderComponent.prototype.getTicksArray = function () {
        var step = (this.viewOptions.tickStep !== null) ? this.viewOptions.tickStep : this.step;
        var ticksArray = [];
        for (var value = this.minValue; value <= this.maxValue; value += step) {
            ticksArray.push(value);
        }
        return ticksArray;
    };
    SliderComponent.prototype.isTickSelected = function (value) {
        if (!this.range) {
            if (this.viewOptions.showSelectionBarFromValue !== null) {
                var center = this.viewOptions.showSelectionBarFromValue;
                if (this.viewLowValue > center &&
                    value >= center &&
                    value <= this.viewLowValue) {
                    return true;
                }
                else if (this.viewLowValue < center &&
                    value <= center &&
                    value >= this.viewLowValue) {
                    return true;
                }
            }
            else if (this.viewOptions.showSelectionBarEnd) {
                if (value >= this.viewLowValue) {
                    return true;
                }
            }
            else if (this.viewOptions.showSelectionBar && value <= this.viewLowValue) {
                return true;
            }
        }
        if (this.range && value >= this.viewLowValue && value <= this.viewHighValue) {
            return true;
        }
        return false;
    };
    SliderComponent.prototype.updateFloorLab = function () {
        this.setLabelValue(this.getDisplayValue(this.minValue, LabelType.Floor), this.flrLabElem);
        this.calculateElementDimension(this.flrLabElem);
        var position = this.viewOptions.rightToLeft
            ? this.barDimension - this.flrLabElem.dimension
            : 0;
        this.setPosition(this.flrLabElem, position);
    };
    SliderComponent.prototype.updateCeilLab = function () {
        this.setLabelValue(this.getDisplayValue(this.maxValue, LabelType.Ceil), this.ceilLabElem);
        this.calculateElementDimension(this.ceilLabElem);
        var position = this.viewOptions.rightToLeft
            ? 0
            : this.barDimension - this.ceilLabElem.dimension;
        this.setPosition(this.ceilLabElem, position);
    };
    SliderComponent.prototype.updateHandles = function (which, newPos) {
        if (which === HandleType.Low) {
            this.updateLowHandle(newPos);
        }
        else {
            this.updateHighHandle(newPos);
        }
        this.updateSelectionBar();
        this.updateTicksScale();
        if (this.range) {
            this.updateCmbLabel();
        }
    };
    SliderComponent.prototype.getHandleLabelPos = function (labelType, newPos) {
        var labelDimension = labelType === HandleLabelType.Min ? this.minLabElem.dimension : this.maxLabElem.dimension;
        var nearHandlePos = newPos - labelDimension / 2 + this.handleHalfDim;
        var endOfBarPos = this.barDimension - labelDimension;
        if (!this.viewOptions.boundPointerLabels) {
            return nearHandlePos;
        }
        if ((this.viewOptions.rightToLeft && labelType === HandleLabelType.Min) ||
            (!this.viewOptions.rightToLeft && labelType === HandleLabelType.Max)) {
            return Math.min(nearHandlePos, endOfBarPos);
        }
        else {
            return Math.min(Math.max(nearHandlePos, 0), endOfBarPos);
        }
    };
    SliderComponent.prototype.updateLowHandle = function (newPos) {
        this.setPosition(this.minHElem, newPos);
        this.setLabelValue(this.getDisplayValue(this.viewLowValue, LabelType.Low), this.minLabElem);
        this.setPosition(this.minLabElem, this.getHandleLabelPos(HandleLabelType.Min, newPos));
        if (this.viewOptions.getPointerColor) {
            var pointercolor = this.getPointerColor(PointerType.Min);
            this.minPointerStyle = {
                backgroundColor: pointercolor,
            };
        }
        if (this.viewOptions.autoHideLimitLabels) {
            this.shFloorCeil();
        }
    };
    SliderComponent.prototype.updateHighHandle = function (newPos) {
        this.setPosition(this.maxHElem, newPos);
        this.setLabelValue(this.getDisplayValue(this.viewHighValue, LabelType.High), this.maxLabElem);
        this.setPosition(this.maxLabElem, this.getHandleLabelPos(HandleLabelType.Max, newPos));
        if (this.viewOptions.getPointerColor) {
            var pointercolor = this.getPointerColor(PointerType.Max);
            this.maxPointerStyle = {
                backgroundColor: pointercolor,
            };
        }
        if (this.viewOptions.autoHideLimitLabels) {
            this.shFloorCeil();
        }
    };
    SliderComponent.prototype.shFloorCeil = function () {
        if (this.viewOptions.hidePointerLabels) {
            return;
        }
        var flHidden = false;
        var clHidden = false;
        var isMinLabAtFloor = this.isLabelBelowFloorLab(this.minLabElem);
        var isMinLabAtCeil = this.isLabelAboveCeilLab(this.minLabElem);
        var isMaxLabAtCeil = this.isLabelAboveCeilLab(this.maxLabElem);
        var isCmbLabAtFloor = this.isLabelBelowFloorLab(this.cmbLabElem);
        var isCmbLabAtCeil = this.isLabelAboveCeilLab(this.cmbLabElem);
        if (isMinLabAtFloor) {
            flHidden = true;
            this.hideEl(this.flrLabElem);
        }
        else {
            flHidden = false;
            this.showEl(this.flrLabElem);
        }
        if (isMinLabAtCeil) {
            clHidden = true;
            this.hideEl(this.ceilLabElem);
        }
        else {
            clHidden = false;
            this.showEl(this.ceilLabElem);
        }
        if (this.range) {
            var hideCeil = this.cmbLabelShown ? isCmbLabAtCeil : isMaxLabAtCeil;
            var hideFloor = this.cmbLabelShown
                ? isCmbLabAtFloor
                : isMinLabAtFloor;
            if (hideCeil) {
                this.hideEl(this.ceilLabElem);
            }
            else if (!clHidden) {
                this.showEl(this.ceilLabElem);
            }
            if (hideFloor) {
                this.hideEl(this.flrLabElem);
            }
            else if (!flHidden) {
                this.showEl(this.flrLabElem);
            }
        }
    };
    SliderComponent.prototype.isLabelBelowFloorLab = function (label) {
        var isRTL = this.viewOptions.rightToLeft;
        var pos = label.position;
        var dim = label.dimension;
        var floorPos = this.flrLabElem.position;
        var floorDim = this.flrLabElem.dimension;
        return isRTL
            ? pos + dim >= floorPos - 2
            : pos <= floorPos + floorDim + 2;
    };
    SliderComponent.prototype.isLabelAboveCeilLab = function (label) {
        var isRTL = this.viewOptions.rightToLeft;
        var pos = label.position;
        var dim = label.dimension;
        var ceilPos = this.ceilLabElem.position;
        var ceilDim = this.ceilLabElem.dimension;
        return isRTL ? pos <= ceilPos + ceilDim + 2 : pos + dim >= ceilPos - 2;
    };
    SliderComponent.prototype.updateSelectionBar = function () {
        var position = 0;
        var dimension = 0;
        var isSelectionBarFromRight = this.viewOptions.rightToLeft
            ? !this.viewOptions.showSelectionBarEnd
            : this.viewOptions.showSelectionBarEnd;
        var positionForRange = this.viewOptions.rightToLeft
            ? this.maxHElem.position + this.handleHalfDim
            : this.minHElem.position + this.handleHalfDim;
        if (this.range) {
            dimension = Math.abs(this.maxHElem.position - this.minHElem.position);
            position = positionForRange;
        }
        else {
            if (this.viewOptions.showSelectionBarFromValue !== null) {
                var center = this.viewOptions.showSelectionBarFromValue;
                var centerPosition = this.valueToPosition(center);
                var isModelGreaterThanCenter = this.viewOptions.rightToLeft
                    ? this.viewLowValue <= center
                    : this.viewLowValue > center;
                if (isModelGreaterThanCenter) {
                    dimension = this.minHElem.position - centerPosition;
                    position = centerPosition + this.handleHalfDim;
                }
                else {
                    dimension = centerPosition - this.minHElem.position;
                    position = this.minHElem.position + this.handleHalfDim;
                }
            }
            else if (isSelectionBarFromRight) {
                dimension = Math.ceil(Math.abs(this.maxPos - this.minHElem.position) + this.handleHalfDim);
                position = Math.floor(this.minHElem.position + this.handleHalfDim);
            }
            else {
                dimension = this.minHElem.position + this.handleHalfDim;
                position = 0;
            }
        }
        this.setDimension(this.selBarElem, dimension);
        this.setPosition(this.selBarElem, position);
        if (this.range && this.viewOptions.showOuterSelectionBars) {
            if (this.viewOptions.rightToLeft) {
                this.setDimension(this.rightOutSelBar, position);
                this.setPosition(this.rightOutSelBar, 0);
                this.calculateElementDimension(this.fullBarElem);
                this.setDimension(this.leftOutSelBar, this.fullBarElem.dimension - (position + dimension));
                this.setPosition(this.leftOutSelBar, position + dimension);
            }
            else {
                this.setDimension(this.leftOutSelBar, position);
                this.setPosition(this.leftOutSelBar, 0);
                this.calculateElementDimension(this.fullBarElem);
                this.setDimension(this.rightOutSelBar, this.fullBarElem.dimension - (position + dimension));
                this.setPosition(this.rightOutSelBar, position + dimension);
            }
        }
        if (this.viewOptions.getSelectionBarColor) {
            var color = this.getSelectionBarColor();
            this.barStyle = {
                backgroundColor: color,
            };
        }
        else if (this.viewOptions.selectionBarGradient) {
            var offset = this.viewOptions.showSelectionBarFromValue !== null
                ? this.valueToPosition(this.viewOptions.showSelectionBarFromValue)
                : 0;
            var reversed = (offset - position > 0 && !isSelectionBarFromRight) || (offset - position <= 0 && isSelectionBarFromRight);
            var direction = this.viewOptions.vertical
                ? reversed ? 'bottom' : 'top'
                : reversed ? 'left' : 'right';
            this.barStyle = {
                backgroundImage: 'linear-gradient(to ' +
                    direction +
                    ', ' +
                    this.viewOptions.selectionBarGradient.from +
                    ' 0%,' +
                    this.viewOptions.selectionBarGradient.to +
                    ' 100%)',
            };
            if (this.viewOptions.vertical) {
                this.barStyle.backgroundPosition =
                    'center ' +
                        (offset +
                            dimension +
                            position +
                            (reversed ? -this.handleHalfDim : 0)) +
                        'px';
                this.barStyle.backgroundSize =
                    '100% ' + (this.barDimension - this.handleHalfDim) + 'px';
            }
            else {
                this.barStyle.backgroundPosition =
                    offset -
                        position +
                        (reversed ? this.handleHalfDim : 0) +
                        'px center';
                this.barStyle.backgroundSize =
                    this.barDimension - this.handleHalfDim + 'px 100%';
            }
        }
    };
    SliderComponent.prototype.getSelectionBarColor = function () {
        if (this.range) {
            return this.viewOptions.getSelectionBarColor(this.value, this.highValue);
        }
        return this.viewOptions.getSelectionBarColor(this.value);
    };
    SliderComponent.prototype.getPointerColor = function (pointerType) {
        if (pointerType === PointerType.Max) {
            return this.viewOptions.getPointerColor(this.highValue, pointerType);
        }
        return this.viewOptions.getPointerColor(this.value, pointerType);
    };
    SliderComponent.prototype.getTickColor = function (value) {
        return this.viewOptions.getTickColor(value);
    };
    SliderComponent.prototype.updateCmbLabel = function () {
        var isLabelOverlap = null;
        if (this.viewOptions.rightToLeft) {
            isLabelOverlap =
                this.minLabElem.position - this.minLabElem.dimension - 10 <= this.maxLabElem.position;
        }
        else {
            isLabelOverlap =
                this.minLabElem.position + this.minLabElem.dimension + 10 >= this.maxLabElem.position;
        }
        if (isLabelOverlap) {
            var lowTr = this.getDisplayValue(this.viewLowValue, LabelType.Low);
            var highTr = this.getDisplayValue(this.viewHighValue, LabelType.High);
            var labelVal = this.viewOptions.rightToLeft
                ? this.combineLabels(highTr, lowTr)
                : this.combineLabels(lowTr, highTr);
            this.setLabelValue(labelVal, this.cmbLabElem);
            var pos = this.viewOptions.boundPointerLabels
                ? Math.min(Math.max(this.selBarElem.position +
                    this.selBarElem.dimension / 2 -
                    this.cmbLabElem.dimension / 2, 0), this.barDimension - this.cmbLabElem.dimension)
                : this.selBarElem.position + this.selBarElem.dimension / 2 - this.cmbLabElem.dimension / 2;
            this.setPosition(this.cmbLabElem, pos);
            this.cmbLabelShown = true;
            this.hideEl(this.minLabElem);
            this.hideEl(this.maxLabElem);
            this.showEl(this.cmbLabElem);
        }
        else {
            this.cmbLabelShown = false;
            this.updateHighHandle(this.valueToPosition(this.viewHighValue));
            this.updateLowHandle(this.valueToPosition(this.viewLowValue));
            this.showEl(this.maxLabElem);
            this.showEl(this.minLabElem);
            this.hideEl(this.cmbLabElem);
        }
        if (this.viewOptions.autoHideLimitLabels) {
            this.shFloorCeil();
        }
    };
    SliderComponent.prototype.getDisplayValue = function (value, which) {
        if (this.viewOptions.stepsArray && !this.viewOptions.bindIndexForStepsArray) {
            value = this.getStepValue(value);
        }
        return this.translate(value, which);
    };
    SliderComponent.prototype.roundStep = function (value, customStep) {
        var step = customStep ? customStep : this.step;
        var steppedDifference = MathHelper.roundToPrecisionLimit((value - this.minValue) / step, this.precisionLimit);
        steppedDifference = Math.round(steppedDifference) * step;
        return MathHelper.roundToPrecisionLimit(this.minValue + steppedDifference, this.precisionLimit);
    };
    SliderComponent.prototype.hideEl = function (element) {
        element.css('visibility', 'hidden');
    };
    SliderComponent.prototype.showEl = function (element) {
        if (!!element.alwaysHide) {
            return;
        }
        element.css('visibility', 'visible');
    };
    SliderComponent.prototype.setPosition = function (elem, pos) {
        elem.position = pos;
        if (this.viewOptions.vertical) {
            elem.css('bottom', Math.round(pos) + 'px');
        }
        else {
            elem.css('left', Math.round(pos) + 'px');
        }
    };
    SliderComponent.prototype.calculateElementDimension = function (elem) {
        var val = elem.getBoundingClientRect();
        if (this.viewOptions.vertical) {
            elem.dimension = (val.bottom - val.top) * this.viewOptions.scale;
        }
        else {
            elem.dimension = (val.right - val.left) * this.viewOptions.scale;
        }
    };
    SliderComponent.prototype.setDimension = function (elem, dim) {
        elem.dimension = dim;
        if (this.viewOptions.vertical) {
            elem.css('height', Math.round(dim) + 'px');
        }
        else {
            elem.css('width', Math.round(dim) + 'px');
        }
        return dim;
    };
    SliderComponent.prototype.sanitizeValue = function (val) {
        return Math.min(Math.max(val, this.minValue), this.maxValue);
    };
    SliderComponent.prototype.valueToPosition = function (val) {
        var fn = ValueHelper.linearValueToPosition;
        if (this.viewOptions.customValueToPosition) {
            fn = this.viewOptions.customValueToPosition;
        }
        else if (this.viewOptions.logScale) {
            fn = ValueHelper.logValueToPosition;
        }
        val = this.sanitizeValue(val);
        var percent = fn(val, this.minValue, this.maxValue) || 0;
        if (this.viewOptions.rightToLeft) {
            percent = 1 - percent;
        }
        return percent * this.maxPos;
    };
    SliderComponent.prototype.positionToValue = function (position) {
        var percent = position / this.maxPos;
        if (this.viewOptions.rightToLeft) {
            percent = 1 - percent;
        }
        var fn = ValueHelper.linearPositionToValue;
        if (this.viewOptions.customPositionToValue) {
            fn = this.viewOptions.customPositionToValue;
        }
        else if (this.viewOptions.logScale) {
            fn = ValueHelper.logPositionToValue;
        }
        return fn(percent, this.minValue, this.maxValue) || 0;
    };
    SliderComponent.prototype.getEventXY = function (event, targetTouchId) {
        if (event instanceof MouseEvent) {
            return this.viewOptions.vertical ? event.clientY : event.clientX;
        }
        var touchIndex = 0;
        var touches = event.touches;
        if (targetTouchId !== undefined) {
            for (var i = 0; i < touches.length; i++) {
                if (touches[i].identifier === targetTouchId) {
                    touchIndex = i;
                    break;
                }
            }
        }
        return this.viewOptions.vertical ? touches[touchIndex].clientY : touches[touchIndex].clientX;
    };
    SliderComponent.prototype.getEventPosition = function (event, targetTouchId) {
        var sliderPos = this.sliderElementPosition;
        var eventPos = 0;
        if (this.viewOptions.vertical) {
            eventPos = -this.getEventXY(event, targetTouchId) + sliderPos;
        }
        else {
            eventPos = this.getEventXY(event, targetTouchId) - sliderPos;
        }
        return eventPos * this.viewOptions.scale - this.handleHalfDim;
    };
    SliderComponent.prototype.getNearestHandle = function (event) {
        if (!this.range) {
            return this.minHElem;
        }
        var position = this.getEventPosition(event);
        var distanceMin = Math.abs(position - this.minHElem.position);
        var distanceMax = Math.abs(position - this.maxHElem.position);
        if (distanceMin < distanceMax) {
            return this.minHElem;
        }
        else if (distanceMin > distanceMax) {
            return this.maxHElem;
        }
        else if (!this.viewOptions.rightToLeft) {
            return position < this.minHElem.position ? this.minHElem : this.maxHElem;
        }
        else {
            return position > this.minHElem.position ? this.minHElem : this.maxHElem;
        }
    };
    SliderComponent.prototype.focusElement = function (el) {
        el.focus();
    };
    SliderComponent.prototype.bindEvents = function () {
        var _this = this;
        var draggableRange = this.viewOptions.draggableRange;
        if (!this.viewOptions.onlyBindHandles) {
            this.selBarElem.on('mousedown', function (event) { return _this.onBarStart(draggableRange, null, event, true, true, true); });
        }
        if (this.viewOptions.draggableRangeOnly) {
            this.minHElem.on('mousedown', function (event) { return _this.onBarStart(draggableRange, null, event, true, true); });
            this.maxHElem.on('mousedown', function (event) { return _this.onBarStart(draggableRange, null, event, true, true); });
        }
        else {
            this.minHElem.on('mousedown', function (event) { return _this.onStart(_this.minHElem, HandleType.Low, event, true, true); });
            if (this.range) {
                this.maxHElem.on('mousedown', function (event) { return _this.onStart(_this.maxHElem, HandleType.High, event, true, true); });
            }
            if (!this.viewOptions.onlyBindHandles) {
                this.fullBarElem.on('mousedown', function (event) { return _this.onStart(null, null, event, true, true, true); });
                this.ticksElem.on('mousedown', function (event) { return _this.onStart(null, null, event, true, true); });
            }
        }
        if (!this.viewOptions.onlyBindHandles) {
            this.selBarElem.on('touchstart', function (event) { return _this.onBarStart(draggableRange, null, event, true, true); });
        }
        if (this.viewOptions.draggableRangeOnly) {
            this.minHElem.on('touchstart', function (event) { return _this.onBarStart(draggableRange, null, event, true, true); });
            this.maxHElem.on('touchstart', function (event) { return _this.onBarStart(draggableRange, null, event, true, true); });
        }
        else {
            this.minHElem.on('touchstart', function (event) { return _this.onStart(_this.minHElem, HandleType.Low, event, true, true); });
            if (this.range) {
                this.maxHElem.on('touchstart', function (event) { return _this.onStart(_this.maxHElem, HandleType.High, event, true, true); });
            }
            if (!this.viewOptions.onlyBindHandles) {
                this.fullBarElem.on('touchstart', function (event) { return _this.onStart(null, null, event, true, true, true); });
                this.ticksElem.on('touchstart', function (event) { return _this.onStart(null, null, event, false, false, true, true); });
            }
        }
        if (this.viewOptions.keyboardSupport) {
            this.minHElem.on('focus', function () { return _this.onPointerFocus(_this.minHElem, HandleType.Low); });
            if (this.range) {
                this.maxHElem.on('focus', function () { return _this.onPointerFocus(_this.maxHElem, HandleType.High); });
            }
        }
    };
    SliderComponent.prototype.unbindEvents = function () {
        this.minHElem.off();
        this.maxHElem.off();
        this.fullBarElem.off();
        this.selBarElem.off();
        this.ticksElem.off();
    };
    SliderComponent.prototype.onBarStart = function (draggableRange, pointer, event, bindMove, bindEnd, simulateImmediateMove, simulateImmediateEnd) {
        if (draggableRange) {
            this.onDragStart(pointer, HandleType.High, event, bindMove, bindEnd, simulateImmediateMove, simulateImmediateEnd);
        }
        else {
            this.onStart(pointer, HandleType.Low, event, bindMove, bindEnd, simulateImmediateMove, simulateImmediateEnd);
        }
    };
    SliderComponent.prototype.onStart = function (pointer, ref, event, bindMove, bindEnd, simulateImmediateMove, simulateImmediateEnd) {
        var _this = this;
        var moveEvent = '';
        var endEvent = '';
        if (CompatibilityHelper.isTouchEvent(event)) {
            moveEvent = 'touchmove';
            endEvent = 'touchend';
        }
        else {
            moveEvent = 'mousemove';
            endEvent = 'mouseup';
        }
        event.stopPropagation();
        event.preventDefault();
        this.calcViewDimensions();
        if (pointer) {
            this.tracking = ref;
        }
        else {
            pointer = this.getNearestHandle(event);
            this.tracking = pointer === this.minHElem ? HandleType.Low : HandleType.High;
        }
        pointer.addClass('ng5-slider-active');
        if (this.viewOptions.keyboardSupport) {
            this.focusElement(pointer);
        }
        if (bindMove) {
            var ehMove = function (e) { return _this.dragging.active ? _this.onDragMove(pointer, e) : _this.onMove(pointer, e); };
            if (this.onMoveUnsubscribe !== null) {
                this.onMoveUnsubscribe();
            }
            this.onMoveUnsubscribe = this.renderer.listen('document', moveEvent, ehMove);
        }
        if (bindEnd) {
            var ehEnd = function (e) { return _this.onEnd(e); };
            if (this.onEndUnsubscribe !== null) {
                this.onEndUnsubscribe();
            }
            this.onEndUnsubscribe = this.renderer.listen('document', endEvent, ehEnd);
        }
        this.userChangeStart.emit(this.getChangeContext());
        if (CompatibilityHelper.isTouchEvent(event) && ((event)).changedTouches) {
            if (!this.touchId) {
                this.isDragging = true;
                this.touchId = ((event)).changedTouches[0].identifier;
            }
        }
        if (simulateImmediateMove && CompatibilityHelper.isTouchEvent(event)) {
            this.onMove(pointer, event, true);
        }
        if (simulateImmediateEnd && CompatibilityHelper.isTouchEvent(event)) {
            this.onEnd(event);
        }
    };
    SliderComponent.prototype.onMove = function (pointer, event, fromTick) {
        var touchForThisSlider;
        if (CompatibilityHelper.isTouchEvent(event)) {
            var changedTouches = ((event)).changedTouches;
            for (var i = 0; i < changedTouches.length; i++) {
                if (changedTouches[i].identifier === this.touchId) {
                    touchForThisSlider = changedTouches[i];
                    break;
                }
            }
            if (!touchForThisSlider) {
                return;
            }
        }
        var newPos = this.getEventPosition(event, touchForThisSlider ? touchForThisSlider.identifier : undefined);
        var newValue;
        var ceilValue = this.viewOptions.rightToLeft
            ? this.minValue
            : this.maxValue;
        var flrValue = this.viewOptions.rightToLeft ? this.maxValue : this.minValue;
        if (newPos <= 0) {
            newValue = flrValue;
        }
        else if (newPos >= this.maxPos) {
            newValue = ceilValue;
        }
        else {
            newValue = this.positionToValue(newPos);
            if (fromTick && this.viewOptions.tickStep !== null) {
                newValue = this.roundStep(newValue, this.viewOptions.tickStep);
            }
            else {
                newValue = this.roundStep(newValue);
            }
        }
        this.positionTrackingHandle(newValue);
    };
    SliderComponent.prototype.onEnd = function (event) {
        if (CompatibilityHelper.isTouchEvent(event)) {
            var changedTouches = ((event)).changedTouches;
            if (changedTouches[0].identifier !== this.touchId) {
                return;
            }
        }
        this.isDragging = false;
        this.touchId = null;
        if (!this.viewOptions.keyboardSupport) {
            this.minHElem.removeClass('ng5-slider-active');
            this.maxHElem.removeClass('ng5-slider-active');
            this.tracking = null;
        }
        this.dragging.active = false;
        if (this.onMoveUnsubscribe !== null) {
            this.onMoveUnsubscribe();
        }
        if (this.onEndUnsubscribe !== null) {
            this.onEndUnsubscribe();
        }
        this.userChangeEnd.emit(this.getChangeContext());
    };
    SliderComponent.prototype.onPointerFocus = function (pointer, ref) {
        var _this = this;
        this.tracking = ref;
        pointer.on('blur', function () { return _this.onPointerBlur(pointer); });
        pointer.on('keydown', function (event) { return _this.onKeyboardEvent(event); });
        pointer.on('keyup', function () { return _this.onKeyUp(); });
        this.firstKeyDown = true;
        pointer.addClass('ng5-slider-active');
        this.currentFocusElement = {
            pointer: pointer,
            ref: ref,
        };
    };
    SliderComponent.prototype.onKeyUp = function () {
        this.firstKeyDown = true;
        this.userChangeEnd.emit(this.getChangeContext());
    };
    SliderComponent.prototype.onPointerBlur = function (pointer) {
        pointer.off('blur');
        pointer.off('keydown');
        pointer.off('keyup');
        pointer.removeClass('ng5-slider-active');
        if (!this.isDragging) {
            this.tracking = null;
            this.currentFocusElement = null;
        }
    };
    SliderComponent.prototype.getKeyActions = function (currentValue) {
        var increaseStep = currentValue + this.step;
        var decreaseStep = currentValue - this.step;
        var increasePage = currentValue + this.valueRange / 10;
        var decreasePage = currentValue - this.valueRange / 10;
        if (this.viewOptions.reversedControls) {
            increaseStep = currentValue - this.step;
            decreaseStep = currentValue + this.step;
            increasePage = currentValue - this.valueRange / 10;
            decreasePage = currentValue + this.valueRange / 10;
        }
        var actions = {
            UP: increaseStep,
            DOWN: decreaseStep,
            LEFT: decreaseStep,
            RIGHT: increaseStep,
            PAGEUP: increasePage,
            PAGEDOWN: decreasePage,
            HOME: this.viewOptions.reversedControls ? this.maxValue : this.minValue,
            END: this.viewOptions.reversedControls ? this.minValue : this.maxValue,
        };
        if (this.viewOptions.rightToLeft) {
            actions["LEFT"] = increaseStep;
            actions["RIGHT"] = decreaseStep;
            if (this.viewOptions.vertical) {
                actions["UP"] = decreaseStep;
                actions["DOWN"] = increaseStep;
            }
        }
        return actions;
    };
    SliderComponent.prototype.onKeyboardEvent = function (event) {
        var currentValue = this.getCurrentTrackingValue();
        var keyCode = event.keyCode || event.which;
        var keys = {
            38: 'UP',
            40: 'DOWN',
            37: 'LEFT',
            39: 'RIGHT',
            33: 'PAGEUP',
            34: 'PAGEDOWN',
            36: 'HOME',
            35: 'END',
        };
        var actions = this.getKeyActions(currentValue);
        var key = keys[keyCode];
        var action = actions[key];
        if (action == null || this.tracking === null) {
            return;
        }
        event.preventDefault();
        if (this.firstKeyDown) {
            this.firstKeyDown = false;
            this.userChangeStart.emit(this.getChangeContext());
        }
        var newValue = this.roundStep(this.sanitizeValue(action));
        if (!this.viewOptions.draggableRangeOnly) {
            this.positionTrackingHandle(newValue);
        }
        else {
            var difference = this.viewHighValue - this.viewLowValue;
            var newMinValue = void 0;
            var newMaxValue = void 0;
            if (this.tracking === HandleType.Low) {
                newMinValue = newValue;
                newMaxValue = newValue + difference;
                if (newMaxValue > this.maxValue) {
                    newMaxValue = this.maxValue;
                    newMinValue = newMaxValue - difference;
                }
            }
            else {
                newMaxValue = newValue;
                newMinValue = newValue - difference;
                if (newMinValue < this.minValue) {
                    newMinValue = this.minValue;
                    newMaxValue = newMinValue + difference;
                }
            }
            this.positionTrackingBar(newMinValue, newMaxValue);
        }
    };
    SliderComponent.prototype.onDragStart = function (pointer, ref, event, bindMove, bindEnd, simulateImmediateMove, simulateImmediateEnd) {
        var position = this.getEventPosition(event);
        this.dragging = new Dragging();
        this.dragging.active = true;
        this.dragging.value = this.positionToValue(position);
        this.dragging.difference = this.viewHighValue - this.viewLowValue;
        this.dragging.lowLimit = this.viewOptions.rightToLeft
            ? this.minHElem.position - position
            : position - this.minHElem.position;
        this.dragging.highLimit = this.viewOptions.rightToLeft
            ? position - this.maxHElem.position
            : this.maxHElem.position - position;
        this.onStart(pointer, ref, event, bindMove, bindEnd, simulateImmediateMove, simulateImmediateEnd);
    };
    SliderComponent.prototype.getMinValue = function (newPos, outOfBounds, isAbove) {
        var isRTL = this.viewOptions.rightToLeft;
        var value = null;
        if (outOfBounds) {
            if (isAbove) {
                value = isRTL
                    ? this.minValue
                    : this.maxValue - this.dragging.difference;
            }
            else {
                value = isRTL
                    ? this.maxValue - this.dragging.difference
                    : this.minValue;
            }
        }
        else {
            value = isRTL
                ? this.positionToValue(newPos + this.dragging.lowLimit)
                : this.positionToValue(newPos - this.dragging.lowLimit);
        }
        return this.roundStep(value);
    };
    SliderComponent.prototype.getMaxValue = function (newPos, outOfBounds, isAbove) {
        var isRTL = this.viewOptions.rightToLeft;
        var value = null;
        if (outOfBounds) {
            if (isAbove) {
                value = isRTL
                    ? this.minValue + this.dragging.difference
                    : this.maxValue;
            }
            else {
                value = isRTL
                    ? this.maxValue
                    : this.minValue + this.dragging.difference;
            }
        }
        else {
            if (isRTL) {
                value =
                    this.positionToValue(newPos + this.dragging.lowLimit) +
                        this.dragging.difference;
            }
            else {
                value =
                    this.positionToValue(newPos - this.dragging.lowLimit) +
                        this.dragging.difference;
            }
        }
        return this.roundStep(value);
    };
    SliderComponent.prototype.onDragMove = function (pointer, event) {
        var newPos = this.getEventPosition(event);
        var ceilLimit, flrLimit, flrHElem, ceilHElem;
        if (this.viewOptions.rightToLeft) {
            ceilLimit = this.dragging.lowLimit;
            flrLimit = this.dragging.highLimit;
            flrHElem = this.maxHElem;
            ceilHElem = this.minHElem;
        }
        else {
            ceilLimit = this.dragging.highLimit;
            flrLimit = this.dragging.lowLimit;
            flrHElem = this.minHElem;
            ceilHElem = this.maxHElem;
        }
        var isUnderFlrLimit = newPos <= flrLimit;
        var isOverCeilLimit = newPos >= this.maxPos - ceilLimit;
        var newMinValue;
        var newMaxValue;
        if (isUnderFlrLimit) {
            if (flrHElem.position === 0) {
                return;
            }
            newMinValue = this.getMinValue(newPos, true, false);
            newMaxValue = this.getMaxValue(newPos, true, false);
        }
        else if (isOverCeilLimit) {
            if (ceilHElem.position === this.maxPos) {
                return;
            }
            newMaxValue = this.getMaxValue(newPos, true, true);
            newMinValue = this.getMinValue(newPos, true, true);
        }
        else {
            newMinValue = this.getMinValue(newPos, false, false);
            newMaxValue = this.getMaxValue(newPos, false, false);
        }
        this.positionTrackingBar(newMinValue, newMaxValue);
    };
    SliderComponent.prototype.positionTrackingBar = function (newMinValue, newMaxValue) {
        if (this.viewOptions.minLimit != null &&
            newMinValue < this.viewOptions.minLimit) {
            newMinValue = this.viewOptions.minLimit;
            newMaxValue = MathHelper.roundToPrecisionLimit(newMinValue + this.dragging.difference, this.precisionLimit);
        }
        if (this.viewOptions.maxLimit != null &&
            newMaxValue > this.viewOptions.maxLimit) {
            newMaxValue = this.viewOptions.maxLimit;
            newMinValue = MathHelper.roundToPrecisionLimit(newMaxValue - this.dragging.difference, this.precisionLimit);
        }
        this.viewLowValue = newMinValue;
        this.viewHighValue = newMaxValue;
        this.applyLowValue();
        if (this.range) {
            this.applyHighValue();
        }
        this.applyModel(true);
        this.updateHandles(HandleType.Low, this.valueToPosition(newMinValue));
        this.updateHandles(HandleType.High, this.valueToPosition(newMaxValue));
    };
    SliderComponent.prototype.positionTrackingHandle = function (newValue) {
        var valueChanged = false;
        newValue = this.applyMinMaxLimit(newValue);
        if (this.range) {
            if (this.viewOptions.pushRange) {
                newValue = this.applyPushRange(newValue);
                valueChanged = true;
            }
            else {
                if (this.viewOptions.noSwitching) {
                    if (this.tracking === HandleType.Low && newValue > this.viewHighValue) {
                        newValue = this.applyMinMaxRange(this.viewHighValue);
                    }
                    else if (this.tracking === HandleType.High &&
                        newValue < this.viewLowValue) {
                        newValue = this.applyMinMaxRange(this.viewLowValue);
                    }
                }
                newValue = this.applyMinMaxRange(newValue);
                if (this.tracking === HandleType.Low && newValue > this.viewHighValue) {
                    this.viewLowValue = this.viewHighValue;
                    this.applyLowValue();
                    this.applyModel(false);
                    this.updateHandles(HandleType.Low, this.maxHElem.position);
                    this.updateAriaAttributes();
                    this.tracking = HandleType.High;
                    this.minHElem.removeClass('ng5-slider-active');
                    this.maxHElem.addClass('ng5-slider-active');
                    if (this.viewOptions.keyboardSupport) {
                        this.focusElement(this.maxHElem);
                    }
                    valueChanged = true;
                }
                else if (this.tracking === HandleType.High &&
                    newValue < this.viewLowValue) {
                    this.viewHighValue = this.viewLowValue;
                    this.applyHighValue();
                    this.applyModel(false);
                    this.updateHandles(HandleType.High, this.minHElem.position);
                    this.updateAriaAttributes();
                    this.tracking = HandleType.Low;
                    this.maxHElem.removeClass('ng5-slider-active');
                    this.minHElem.addClass('ng5-slider-active');
                    if (this.viewOptions.keyboardSupport) {
                        this.focusElement(this.minHElem);
                    }
                    valueChanged = true;
                }
            }
        }
        if (this.getCurrentTrackingValue() !== newValue) {
            if (this.tracking === HandleType.Low) {
                this.viewLowValue = newValue;
                this.applyLowValue();
            }
            else {
                this.viewHighValue = newValue;
                this.applyHighValue();
            }
            this.applyModel(false);
            this.updateHandles(this.tracking, this.valueToPosition(newValue));
            this.updateAriaAttributes();
            valueChanged = true;
        }
        if (valueChanged) {
            this.applyModel(true);
        }
    };
    SliderComponent.prototype.applyMinMaxLimit = function (newValue) {
        if (this.viewOptions.minLimit != null && newValue < this.viewOptions.minLimit) {
            return this.viewOptions.minLimit;
        }
        if (this.viewOptions.maxLimit != null && newValue > this.viewOptions.maxLimit) {
            return this.viewOptions.maxLimit;
        }
        return newValue;
    };
    SliderComponent.prototype.applyMinMaxRange = function (newValue) {
        var oppositeValue = this.tracking === HandleType.Low ? this.viewHighValue : this.viewLowValue;
        var difference = Math.abs(newValue - oppositeValue);
        if (this.viewOptions.minRange != null) {
            if (difference < this.viewOptions.minRange) {
                if (this.tracking === HandleType.Low) {
                    return MathHelper.roundToPrecisionLimit(this.viewHighValue - this.viewOptions.minRange, this.precisionLimit);
                }
                else {
                    return MathHelper.roundToPrecisionLimit(this.viewLowValue + this.viewOptions.minRange, this.precisionLimit);
                }
            }
        }
        if (this.viewOptions.maxRange != null) {
            if (difference > this.viewOptions.maxRange) {
                if (this.tracking === HandleType.Low) {
                    return MathHelper.roundToPrecisionLimit(this.viewHighValue - this.viewOptions.maxRange, this.precisionLimit);
                }
                else {
                    return MathHelper.roundToPrecisionLimit(this.viewLowValue + this.viewOptions.maxRange, this.precisionLimit);
                }
            }
        }
        return newValue;
    };
    SliderComponent.prototype.applyPushRange = function (newValue) {
        var difference = this.tracking === HandleType.Low
            ? this.viewHighValue - newValue
            : newValue - this.viewLowValue;
        var minRange = this.viewOptions.minRange !== null
            ? this.viewOptions.minRange
            : this.viewOptions.step;
        var maxRange = this.viewOptions.maxRange;
        if (difference < minRange) {
            if (this.tracking === HandleType.Low) {
                this.viewHighValue = MathHelper.roundToPrecisionLimit(Math.min(newValue + minRange, this.maxValue), this.precisionLimit);
                newValue = MathHelper.roundToPrecisionLimit(this.viewHighValue - minRange, this.precisionLimit);
                this.applyHighValue();
                this.updateHandles(HandleType.High, this.valueToPosition(this.viewHighValue));
            }
            else {
                this.viewLowValue = MathHelper.roundToPrecisionLimit(Math.max(newValue - minRange, this.minValue), this.precisionLimit);
                newValue = MathHelper.roundToPrecisionLimit(this.viewLowValue + minRange, this.precisionLimit);
                this.applyLowValue();
                this.updateHandles(HandleType.Low, this.valueToPosition(this.viewLowValue));
            }
            this.updateAriaAttributes();
        }
        else if (maxRange !== null && difference > maxRange) {
            if (this.tracking === HandleType.Low) {
                this.viewHighValue = MathHelper.roundToPrecisionLimit(newValue + maxRange, this.precisionLimit);
                this.applyHighValue();
                this.updateHandles(HandleType.High, this.valueToPosition(this.viewHighValue));
            }
            else {
                this.viewLowValue = MathHelper.roundToPrecisionLimit(newValue - maxRange, this.precisionLimit);
                this.applyLowValue();
                this.updateHandles(HandleType.Low, this.valueToPosition(this.viewLowValue));
            }
            this.updateAriaAttributes();
        }
        return newValue;
    };
    SliderComponent.prototype.applyModel = function (callUserChange) {
        this.internalChange = true;
        this.valueChange.emit(this.value);
        this.highValueChange.emit(this.highValue);
        if (callUserChange) {
            this.userChange.emit(this.getChangeContext());
        }
        this.internalChange = false;
    };
    SliderComponent.prototype.getChangeContext = function () {
        var changeContext = new ChangeContext();
        changeContext.pointerType = this.tracking === HandleType.Low ? PointerType.Min : PointerType.Max;
        changeContext.value = this.value;
        changeContext.highValue = this.highValue;
        return changeContext;
    };
    return SliderComponent;
}());
SliderComponent.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"], args: [{
                selector: 'ng5-slider',
                template: "<!-- // 0 (left) Highlight outside two handles -->\n<span ng5SliderLeftOutSelElem class=\"ng5-slider-span ng5-slider-bar-wrapper ng5-slider-left-out-selection\">\n  <span class=\"ng5-slider-span ng5-slider-bar\"></span>\n</span>\n<!-- // 1 (right) Highlight outside two handles -->\n<span ng5SliderRightOutSelElem class=\"ng5-slider-span ng5-slider-bar-wrapper ng5-slider-right-out-selection\">\n  <span class=\"ng5-slider-span ng5-slider-bar\"></span>\n</span>\n<!-- // 2 The slider bar -->\n<span ng5SliderFullBarElem class=\"ng5-slider-span ng5-slider-bar-wrapper\">\n  <span class=\"ng5-slider-span ng5-slider-bar\"></span>\n</span>\n<!-- // 3 Highlight between two handles -->\n<span ng5SliderSelBarElem class=\"ng5-slider-span ng5-slider-bar-wrapper\">\n  <span class=\"ng5-slider-span ng5-slider-bar ng5-slider-selection\" [ngStyle]=\"barStyle\"></span>\n</span>\n<!-- // 4 Left slider handle -->\n<span ng5SliderMinHElem class=\"ng5-slider-span ng5-slider-pointer ng5-slider-pointer-min\" [ngStyle]=minPointerStyle></span>\n<!-- // 5 Right slider handle -->\n<span ng5SliderMaxHElem class=\"ng5-slider-span ng5-slider-pointer ng5-slider-pointer-max\" [ngStyle]=maxPointerStyle></span>\n<!-- // 6 Floor label -->\n<span ng5SliderFlrLabElem class=\"ng5-slider-span ng5-slider-bubble ng5-slider-limit ng5-slider-floor\"></span>\n<!-- // 7 Ceiling label -->\n<span ng5SliderCeilLabElem class=\"ng5-slider-span ng5-slider-bubble ng5-slider-limit ng5-slider-ceil\"></span>\n<!-- // 8 Label above left slider handle -->\n<span ng5SliderMinLabElem class=\"ng5-slider-span ng5-slider-bubble ng5-slider-model-value\"></span>\n<!-- // 9 Label above right slider handle -->\n<span ng5SliderMaxLabElem class=\"ng5-slider-span ng5-slider-bubble ng5-slider-model-high\"></span>\n<!-- // 10 Range label when the slider handles are close ex. 15 - 17 -->\n<span ng5SliderCmbLabElem class=\"ng5-slider-span ng5-slider-bubble\"></span>\n<!-- // 11 The ticks -->\n<span ng5SliderTicksElem [hidden]=\"!showTicks\" class=\"ng5-slider-ticks\">\n  <span *ngFor=\"let t of ticks\" class=\"ng5-slider-tick\" [ngClass]=\"{'ng5-slider-selected': t.selected}\" [ngStyle]=\"t.style\">\n    <ng5-slider-tooltip-wrapper [template]=\"tooltipTemplate\" [tooltip]=\"t.tooltip\" [placement]=\"t.tooltipPlacement\"></ng5-slider-tooltip-wrapper>\n    <ng5-slider-tooltip-wrapper *ngIf=\"t.value != null\" class=\"ng5-slider-span ng5-slider-tick-value\"\n        [template]=\"tooltipTemplate\" [tooltip]=\"t.valueTooltip\" [placement]=\"t.valueTooltipPlacement\" [content]=\"t.value\"></ng5-slider-tooltip-wrapper>\n    <span *ngIf=\"t.legend != null\" class=\"ng5-slider-span ng5-slider-tick-legend\">{{ t.legend }}</span>\n  </span>\n</span>",
                styles: ["::ng-deep .ng5-slider{display:inline-block;position:relative;height:4px;width:100%;margin:35px 0 15px;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}::ng-deep .ng5-slider.with-legend{margin-bottom:40px}::ng-deep .ng5-slider[disabled]{cursor:not-allowed}::ng-deep .ng5-slider[disabled] .ng5-slider-pointer{cursor:not-allowed;background-color:#d8e0f3}::ng-deep .ng5-slider[disabled] .ng5-slider-draggable{cursor:not-allowed}::ng-deep .ng5-slider[disabled] .ng5-slider-selection{background:#8b91a2}::ng-deep .ng5-slider[disabled] .ng5-slider-tick{cursor:not-allowed}::ng-deep .ng5-slider[disabled] .ng5-slider-tick.ng5-slider-selected{background:#8b91a2}::ng-deep .ng5-slider .ng5-slider-span{white-space:nowrap;position:absolute;display:inline-block}::ng-deep .ng5-slider .ng5-slider-base{width:100%;height:100%;padding:0}::ng-deep .ng5-slider .ng5-slider-bar-wrapper{left:0;-webkit-box-sizing:border-box;box-sizing:border-box;margin-top:-16px;padding-top:16px;width:100%;height:32px;z-index:1}::ng-deep .ng5-slider .ng5-slider-draggable{cursor:move}::ng-deep .ng5-slider .ng5-slider-bar{left:0;width:100%;height:4px;z-index:1;background:#d8e0f3;border-radius:2px}::ng-deep .ng5-slider .ng5-slider-bar-wrapper.ng5-slider-transparent .ng5-slider-bar{background:0 0}::ng-deep .ng5-slider .ng5-slider-bar-wrapper.ng5-slider-left-out-selection .ng5-slider-bar{background:#df002d}::ng-deep .ng5-slider .ng5-slider-bar-wrapper.ng5-slider-right-out-selection .ng5-slider-bar{background:#03a688}::ng-deep .ng5-slider .ng5-slider-selection{z-index:2;background:#0db9f0;border-radius:2px}::ng-deep .ng5-slider .ng5-slider-pointer{cursor:pointer;width:32px;height:32px;top:-14px;background-color:#0db9f0;z-index:3;border-radius:16px}::ng-deep .ng5-slider .ng5-slider-pointer:after{content:'';width:8px;height:8px;position:absolute;top:12px;left:12px;border-radius:4px;background:#fff}::ng-deep .ng5-slider .ng5-slider-pointer:hover:after{background-color:#fff}::ng-deep .ng5-slider .ng5-slider-pointer.ng5-slider-active{z-index:4}::ng-deep .ng5-slider .ng5-slider-pointer.ng5-slider-active:after{background-color:#451aff}::ng-deep .ng5-slider .ng5-slider-bubble{cursor:default;bottom:16px;padding:1px 3px;color:#55637d;font-size:16px}::ng-deep .ng5-slider .ng5-slider-bubble.ng5-slider-limit{color:#55637d}::ng-deep .ng5-slider .ng5-slider-ticks{-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;height:0;position:absolute;left:0;top:-3px;margin:0;z-index:1;list-style:none}::ng-deep .ng5-slider .ng5-slider-ticks-values-under .ng5-slider-tick-value{top:auto;bottom:-36px}::ng-deep .ng5-slider .ng5-slider-tick{text-align:center;cursor:pointer;width:10px;height:10px;background:#d8e0f3;border-radius:50%;position:absolute;top:0;left:0;margin-left:11px}::ng-deep .ng5-slider .ng5-slider-tick.ng5-slider-selected{background:#0db9f0}::ng-deep .ng5-slider .ng5-slider-tick-value{position:absolute;top:-34px;-webkit-transform:translate(-50%,0);transform:translate(-50%,0)}::ng-deep .ng5-slider .ng5-slider-tick-legend{position:absolute;top:24px;-webkit-transform:translate(-50%,0);transform:translate(-50%,0);max-width:50px;white-space:normal}::ng-deep .ng5-slider.ng5-slider-vertical{position:relative;width:4px;height:100%;margin:0 20px;padding:0;vertical-align:baseline}::ng-deep .ng5-slider.ng5-slider-vertical .ng5-slider-base{width:100%;height:100%;padding:0}::ng-deep .ng5-slider.ng5-slider-vertical .ng5-slider-bar-wrapper{top:auto;left:0;margin:0 0 0 -16px;padding:0 0 0 16px;height:100%;width:32px}::ng-deep .ng5-slider.ng5-slider-vertical .ng5-slider-bar{bottom:0;left:auto;width:4px;height:100%}::ng-deep .ng5-slider.ng5-slider-vertical .ng5-slider-pointer{left:-14px!important;top:auto;bottom:0}::ng-deep .ng5-slider.ng5-slider-vertical .ng5-slider-bubble{left:16px!important;bottom:0}::ng-deep .ng5-slider.ng5-slider-vertical .ng5-slider-ticks{height:100%;width:0;left:-3px;top:0;z-index:1}::ng-deep .ng5-slider.ng5-slider-vertical .ng5-slider-tick{vertical-align:middle;margin-left:auto;margin-top:11px}::ng-deep .ng5-slider.ng5-slider-vertical .ng5-slider-tick-value{left:24px;top:auto;-webkit-transform:translate(0,-28%);transform:translate(0,-28%)}::ng-deep .ng5-slider.ng5-slider-vertical .ng5-slider-tick-legend{top:auto;right:24px;-webkit-transform:translate(0,-28%);transform:translate(0,-28%);max-width:none;white-space:nowrap}::ng-deep .ng5-slider.ng5-slider-vertical .ng5-slider-ticks-values-under .ng5-slider-tick-value{bottom:auto;left:auto;right:24px}"],
                host: { class: 'ng5-slider' }
            },] },
];
SliderComponent.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"], },
]; };
SliderComponent.propDecorators = {
    "value": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    "valueChange": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"] },],
    "highValue": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    "highValueChange": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"] },],
    "userChangeStart": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"] },],
    "userChange": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"] },],
    "userChangeEnd": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"] },],
    "options": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    "manualRefresh": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    "leftOutSelBar": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"], args: [LeftOutSelDirective,] },],
    "rightOutSelBar": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"], args: [RightOutSelDirective,] },],
    "fullBarElem": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"], args: [FullBarDirective,] },],
    "selBarElem": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"], args: [SelBarDirective,] },],
    "minHElem": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"], args: [MinHDirective,] },],
    "maxHElem": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"], args: [MaxHDirective,] },],
    "flrLabElem": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"], args: [FlrLabDirective,] },],
    "ceilLabElem": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"], args: [CeilLabDirective,] },],
    "minLabElem": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"], args: [MinLabDirective,] },],
    "maxLabElem": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"], args: [MaxLabDirective,] },],
    "cmbLabElem": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"], args: [CmbLabDirective,] },],
    "ticksElem": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewChild"], args: [TicksDirective,] },],
    "tooltipTemplate": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ContentChild"], args: ['tooltipTemplate',] },],
    "sliderElementVerticalClass": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostBinding"], args: ['class.ng5-slider-vertical',] },],
    "sliderElementDisabledAttr": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostBinding"], args: ['attr.disabled',] },],
    "onResize": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"], args: ['window:resize', ['$event'],] },],
};
var TooltipWrapperComponent = (function () {
    function TooltipWrapperComponent() {
    }
    return TooltipWrapperComponent;
}());
TooltipWrapperComponent.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Component"], args: [{
                selector: 'ng5-slider-tooltip-wrapper',
                template: "<ng-container *ngIf=\"template\">\n  <ng-template *ngTemplateOutlet=\"template; context: {tooltip: tooltip, placement: placement, content: content}\"></ng-template>\n</ng-container>\n\n<ng-container *ngIf=\"!template\">\n  <div class=\"ng5-slider-inner-tooltip\" [attr.title]=\"tooltip\" [attr.data-tooltip-placement]=\"placement\">\n    {{content}}\n  </div>\n</ng-container>",
                styles: [".ng5-slider-inner-tooltip{height:100%}"]
            },] },
];
TooltipWrapperComponent.ctorParameters = function () { return []; };
TooltipWrapperComponent.propDecorators = {
    "template": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    "tooltip": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    "placement": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    "content": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
};
var Ng5SliderModule = (function () {
    function Ng5SliderModule() {
    }
    return Ng5SliderModule;
}());
Ng5SliderModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                imports: [
                    __WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"]
                ],
                declarations: [
                    SliderComponent,
                    RightOutSelDirective,
                    LeftOutSelDirective,
                    FullBarDirective,
                    SelBarDirective,
                    MinHDirective,
                    MaxHDirective,
                    FlrLabDirective,
                    CeilLabDirective,
                    MinLabDirective,
                    MaxLabDirective,
                    CmbLabDirective,
                    TicksDirective,
                    TooltipWrapperComponent
                ],
                exports: [
                    SliderComponent
                ]
            },] },
];
Ng5SliderModule.ctorParameters = function () { return []; };


//# sourceMappingURL=ng5-slider.js.map


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(3);
var home_1 = __webpack_require__(972);
var api_docs_1 = __webpack_require__(233);
var test_connection_1 = __webpack_require__(234);
var schedules_1 = __webpack_require__(973);
var ports_1 = __webpack_require__(974);
var carriers_1 = __webpack_require__(975);
var vessels_1 = __webpack_require__(976);
var web_search_1 = __webpack_require__(977);
var plans_1 = __webpack_require__(978);
var page_not_found_component_1 = __webpack_require__(254);
var register_1 = __webpack_require__(979);
var confirm_1 = __webpack_require__(980);
var static_1 = __webpack_require__(243);
var routes = [
    { path: '', component: home_1.HomeComponent },
    { path: 'api-docs', component: api_docs_1.ApiDocsComponent },
    { path: 'test-connection', component: test_connection_1.TestConnectionComponent },
    { path: 'schedules', component: schedules_1.SchedulesComponent },
    { path: 'ports/:id', component: ports_1.PortsComponent },
    { path: 'carriers/:id', component: carriers_1.CarriersComponent },
    { path: 'vessels/:id', component: vessels_1.VesselsComponent },
    { path: 'plans', component: plans_1.PlansComponent },
    { path: 'register', component: register_1.RegisterComponent },
    { path: 'confirm', component: confirm_1.ConfirmComponent },
    { path: 'bulk-data-feeds', component: static_1.DataFeedsComponent },
    { path: 'blog', loadChildren: function () { return new Promise(function (resolve, reject) { new Promise(function(resolve) { resolve(); }).then((function (require) { resolve(__webpack_require__(249)['BlogModule']); }).bind(null, __webpack_require__)).catch(function (e) { reject({ loadChunkError: true, details: e }); }); }); } },
    { path: 'press', loadChildren: function () { return new Promise(function (resolve, reject) { new Promise(function(resolve) { resolve(); }).then((function (require) { resolve(__webpack_require__(251)['PressModule']); }).bind(null, __webpack_require__)).catch(function (e) { reject({ loadChunkError: true, details: e }); }); }); } },
    { path: 'who-we-are', component: static_1.AboutComponent },
    { path: 'api-data-on-demand', component: static_1.ApiComponent },
    { path: 'analytics-reporting', component: static_1.AnalyticsComponent },
    { path: 'contact', component: static_1.ContactComponent },
    { path: 'privacy-policy', component: static_1.PrivacyPolicyComponent },
    { path: 'terms-of-use', component: static_1.TermsOfUseComponent },
    { path: 'help', component: static_1.HelpComponent },
    { path: 'account', loadChildren: function () { return new Promise(function (resolve, reject) { new Promise(function(resolve) { resolve(); }).then((function (require) { resolve(__webpack_require__(245)['AccountModule']); }).bind(null, __webpack_require__)).catch(function (e) { reject({ loadChunkError: true, details: e }); }); }); } },
    { path: 'solutions', component: static_1.SolutionsComponent },
    { path: 'application', component: static_1.ApplicationComponent },
    { path: 'subscribe', component: web_search_1.WebSearchComponent },
    { path: 'what-we-do', component: static_1.WhatWeDoComponent },
    { path: 'online-search', component: static_1.OnlineSearchComponent },
    { path: 'api-overview', component: static_1.ApiOverviewComponent },
    { path: 'carrier-list', component: static_1.CarrierNetworkComponent },
    { path: 'data-consolidation', component: static_1.DataConsolidationComponent },
    { path: 'bulk-data-formats', component: static_1.DataFormatsComponent },
    { path: 'about', component: static_1.AboutLandingComponent },
    { path: 'upcoming-events', component: static_1.UpcomingEventsComponent },
    { path: '**', component: page_not_found_component_1.PageNotFoundComponent }
];
// lazy loaded children must have a route readable by webpack
var AppRoutingModule = (function () {
    function AppRoutingModule() {
    }
    AppRoutingModule = __decorate([
        core_1.NgModule({
            imports: [router_1.RouterModule.forRoot(routes)],
            exports: [router_1.RouterModule]
        })
    ], AppRoutingModule);
    return AppRoutingModule;
}());
exports.AppRoutingModule = AppRoutingModule;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(232));


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(235));


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(236));


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(237));


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(240));


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(241));


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(242));


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(253));


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(255));


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
// Hot Module Replacement
__export(__webpack_require__(982));
//# sourceMappingURL=index.js.map

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Hot Module Replacement
function bootloader(main) {
    if (document.readyState === 'complete') {
        main();
    }
    else {
        document.addEventListener('DOMContentLoaded', main);
    }
}
exports.bootloader = bootloader;
// create new elements
function createNewHosts(cmps) {
    var components = cmps.map(function (componentNode) {
        var newNode = document.createElement(componentNode.tagName);
        // display none
        var currentDisplay = newNode.style.display;
        newNode.style.display = 'none';
        var parentNode = componentNode.parentNode;
        parentNode.insertBefore(newNode, componentNode);
        return { currentDisplay: currentDisplay, newNode: newNode };
    });
    return function () {
        components.forEach(function (cmp) {
            cmp.newNode.style.display = cmp.currentDisplay;
            cmp.newNode = null;
            cmp.currentDisplay = null;
        });
    };
}
exports.createNewHosts = createNewHosts;
// remove old styles
function removeNgStyles() {
    Array.prototype.slice.call(document.head.querySelectorAll('style'), 0)
        .filter(function (style) { return style.innerText.indexOf('_ng') !== -1; })
        .map(function (el) { return el.remove(); });
}
exports.removeNgStyles = removeNgStyles;
// get input values
function getInputValues() {
    var inputs = document.querySelectorAll('input');
    return Array.prototype.slice.call(inputs).map(function (input) { return input.value; });
}
exports.getInputValues = getInputValues;
// set input values
function setInputValues($inputs) {
    var inputs = document.querySelectorAll('input');
    if ($inputs && inputs.length === $inputs.length) {
        $inputs.forEach(function (value, i) {
            var el = inputs[i];
            el.value = value;
            el.dispatchEvent(new CustomEvent('input', { detail: el.value }));
        });
    }
}
exports.setInputValues = setInputValues;
// get/set input values
function createInputTransfer() {
    var $inputs = getInputValues();
    return function restoreInputValues() {
        setInputValues($inputs);
    };
}
exports.createInputTransfer = createInputTransfer;
//# sourceMappingURL=helpers.js.map

/***/ })
],[538]);


// WEBPACK FOOTER //
// js/app.6b4f809880981c1d06e7.js